(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea7a1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea7a1"] = parcelRequire;
}
parcelRequire.register("1XyTv", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $16d65e61ad75fba0$export$bdfd709ae4826697; }, function (v) { return $16d65e61ad75fba0$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $16d65e61ad75fba0$export$5a759dc7a1cfb72a; }, function (v) { return $16d65e61ad75fba0$export$5a759dc7a1cfb72a = v; });
var $16d65e61ad75fba0$export$bdfd709ae4826697;
var $16d65e61ad75fba0$export$c9e73fbda7da57b6;
var $16d65e61ad75fba0$export$5a759dc7a1cfb72a;
"use strict";
var $16d65e61ad75fba0$var$bundleURL = {};
function $16d65e61ad75fba0$var$getBundleURLCached(id) {
    var value = $16d65e61ad75fba0$var$bundleURL[id];
    if (!value) {
        value = $16d65e61ad75fba0$var$getBundleURL();
        $16d65e61ad75fba0$var$bundleURL[id] = value;
    }
    return value;
}
function $16d65e61ad75fba0$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $16d65e61ad75fba0$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $16d65e61ad75fba0$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $16d65e61ad75fba0$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$16d65e61ad75fba0$export$bdfd709ae4826697 = $16d65e61ad75fba0$var$getBundleURLCached;
$16d65e61ad75fba0$export$c9e73fbda7da57b6 = $16d65e61ad75fba0$var$getBaseURL;
$16d65e61ad75fba0$export$5a759dc7a1cfb72a = $16d65e61ad75fba0$var$getOrigin;

});

parcelRequire.register("gG43b", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.33
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.33", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /yabrowser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                // Ordered by popularity
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    "Mac OS"
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    "Chromium OS"
                ],
                VERSION
            ],
            [
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _ua = ua || (typeof window1 !== UNDEF_TYPE && window1.navigator && window1.navigator.userAgent ? window1.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});


const $a7bbb4392bc1ea56$export$b782dad1d219cf26 = [
    "DEFAULT",
    "CAMERA_PERMISSIONS",
    "NO_CONTROLLER_DETECTED",
    "CONTROLLER_DETECTED",
    "VR_WARNING",
    "PLACE_YOUR_HEADSET",
    "WEBGL",
    "WEBGL__GAMEPAD",
    "WEBGL__FREELOOK"
];


var $e97a97f0b0cf48c9$exports = {};

$parcel$export($e97a97f0b0cf48c9$exports, "REVISION", function () { return $e97a97f0b0cf48c9$export$3545e07a80636437; });
$parcel$export($e97a97f0b0cf48c9$exports, "MOUSE", function () { return $e97a97f0b0cf48c9$export$7177b3e430c2d7ca; });
$parcel$export($e97a97f0b0cf48c9$exports, "TOUCH", function () { return $e97a97f0b0cf48c9$export$d46bd3ead7cc759b; });
$parcel$export($e97a97f0b0cf48c9$exports, "CullFaceNone", function () { return $e97a97f0b0cf48c9$export$3237e1f2c1ea1f44; });
$parcel$export($e97a97f0b0cf48c9$exports, "CullFaceBack", function () { return $e97a97f0b0cf48c9$export$b9a7b4fc5cb15f9b; });
$parcel$export($e97a97f0b0cf48c9$exports, "CullFaceFront", function () { return $e97a97f0b0cf48c9$export$b8058bcc7037d3f3; });
$parcel$export($e97a97f0b0cf48c9$exports, "CullFaceFrontBack", function () { return $e97a97f0b0cf48c9$export$f24be24dcddeac0d; });
$parcel$export($e97a97f0b0cf48c9$exports, "BasicShadowMap", function () { return $e97a97f0b0cf48c9$export$346307dbae2b7447; });
$parcel$export($e97a97f0b0cf48c9$exports, "PCFShadowMap", function () { return $e97a97f0b0cf48c9$export$5813f879eee7cd88; });
$parcel$export($e97a97f0b0cf48c9$exports, "PCFSoftShadowMap", function () { return $e97a97f0b0cf48c9$export$a47c4b43a1be34f0; });
$parcel$export($e97a97f0b0cf48c9$exports, "VSMShadowMap", function () { return $e97a97f0b0cf48c9$export$896ae1ade6c829c4; });
$parcel$export($e97a97f0b0cf48c9$exports, "FrontSide", function () { return $e97a97f0b0cf48c9$export$2ede184fc2998901; });
$parcel$export($e97a97f0b0cf48c9$exports, "BackSide", function () { return $e97a97f0b0cf48c9$export$d9f0486e75b5ace; });
$parcel$export($e97a97f0b0cf48c9$exports, "DoubleSide", function () { return $e97a97f0b0cf48c9$export$3b296b6f144d5b03; });
$parcel$export($e97a97f0b0cf48c9$exports, "FlatShading", function () { return $e97a97f0b0cf48c9$export$a62047d29c96d8ff; });
$parcel$export($e97a97f0b0cf48c9$exports, "SmoothShading", function () { return $e97a97f0b0cf48c9$export$fadb74c06a7f490; });
$parcel$export($e97a97f0b0cf48c9$exports, "NoBlending", function () { return $e97a97f0b0cf48c9$export$63b8d6b580fc65ba; });
$parcel$export($e97a97f0b0cf48c9$exports, "NormalBlending", function () { return $e97a97f0b0cf48c9$export$5b29a26d96ee6af0; });
$parcel$export($e97a97f0b0cf48c9$exports, "AdditiveBlending", function () { return $e97a97f0b0cf48c9$export$777d8f9551c2216b; });
$parcel$export($e97a97f0b0cf48c9$exports, "SubtractiveBlending", function () { return $e97a97f0b0cf48c9$export$cdfa06f868e2e467; });
$parcel$export($e97a97f0b0cf48c9$exports, "MultiplyBlending", function () { return $e97a97f0b0cf48c9$export$4138e1c684b46a20; });
$parcel$export($e97a97f0b0cf48c9$exports, "CustomBlending", function () { return $e97a97f0b0cf48c9$export$eda4864c68df1fa2; });
$parcel$export($e97a97f0b0cf48c9$exports, "AddEquation", function () { return $e97a97f0b0cf48c9$export$20183a0484ce21a0; });
$parcel$export($e97a97f0b0cf48c9$exports, "SubtractEquation", function () { return $e97a97f0b0cf48c9$export$73e0df5177988548; });
$parcel$export($e97a97f0b0cf48c9$exports, "ReverseSubtractEquation", function () { return $e97a97f0b0cf48c9$export$28e582859cbec660; });
$parcel$export($e97a97f0b0cf48c9$exports, "MinEquation", function () { return $e97a97f0b0cf48c9$export$c8c1508da8d0600c; });
$parcel$export($e97a97f0b0cf48c9$exports, "MaxEquation", function () { return $e97a97f0b0cf48c9$export$99948c02fb51055f; });
$parcel$export($e97a97f0b0cf48c9$exports, "ZeroFactor", function () { return $e97a97f0b0cf48c9$export$2110f05edf778d3d; });
$parcel$export($e97a97f0b0cf48c9$exports, "OneFactor", function () { return $e97a97f0b0cf48c9$export$8805bad65e24940e; });
$parcel$export($e97a97f0b0cf48c9$exports, "SrcColorFactor", function () { return $e97a97f0b0cf48c9$export$7fbe15b28d28cf52; });
$parcel$export($e97a97f0b0cf48c9$exports, "OneMinusSrcColorFactor", function () { return $e97a97f0b0cf48c9$export$947829af9f2c17f6; });
$parcel$export($e97a97f0b0cf48c9$exports, "SrcAlphaFactor", function () { return $e97a97f0b0cf48c9$export$d5773124e86cf28c; });
$parcel$export($e97a97f0b0cf48c9$exports, "OneMinusSrcAlphaFactor", function () { return $e97a97f0b0cf48c9$export$11d468cc7f19e971; });
$parcel$export($e97a97f0b0cf48c9$exports, "DstAlphaFactor", function () { return $e97a97f0b0cf48c9$export$a78aed1ca2a87192; });
$parcel$export($e97a97f0b0cf48c9$exports, "OneMinusDstAlphaFactor", function () { return $e97a97f0b0cf48c9$export$5d0fe17fd8773bac; });
$parcel$export($e97a97f0b0cf48c9$exports, "DstColorFactor", function () { return $e97a97f0b0cf48c9$export$ef5f2dd8ffac5574; });
$parcel$export($e97a97f0b0cf48c9$exports, "OneMinusDstColorFactor", function () { return $e97a97f0b0cf48c9$export$56b85b2686ab16; });
$parcel$export($e97a97f0b0cf48c9$exports, "SrcAlphaSaturateFactor", function () { return $e97a97f0b0cf48c9$export$c05e2a1fc8609506; });
$parcel$export($e97a97f0b0cf48c9$exports, "NeverDepth", function () { return $e97a97f0b0cf48c9$export$69025ce147cee220; });
$parcel$export($e97a97f0b0cf48c9$exports, "AlwaysDepth", function () { return $e97a97f0b0cf48c9$export$7182eb52ea3b3f04; });
$parcel$export($e97a97f0b0cf48c9$exports, "LessDepth", function () { return $e97a97f0b0cf48c9$export$eedccec66ab7ebe; });
$parcel$export($e97a97f0b0cf48c9$exports, "LessEqualDepth", function () { return $e97a97f0b0cf48c9$export$296f78a0b892f81a; });
$parcel$export($e97a97f0b0cf48c9$exports, "EqualDepth", function () { return $e97a97f0b0cf48c9$export$a60d398fc7b7590e; });
$parcel$export($e97a97f0b0cf48c9$exports, "GreaterEqualDepth", function () { return $e97a97f0b0cf48c9$export$7d7234c1240a1fc4; });
$parcel$export($e97a97f0b0cf48c9$exports, "GreaterDepth", function () { return $e97a97f0b0cf48c9$export$c5e2c52991f30937; });
$parcel$export($e97a97f0b0cf48c9$exports, "NotEqualDepth", function () { return $e97a97f0b0cf48c9$export$2f843afa843d8916; });
$parcel$export($e97a97f0b0cf48c9$exports, "MultiplyOperation", function () { return $e97a97f0b0cf48c9$export$e50ac29801f1774d; });
$parcel$export($e97a97f0b0cf48c9$exports, "MixOperation", function () { return $e97a97f0b0cf48c9$export$9f9d94f963c85479; });
$parcel$export($e97a97f0b0cf48c9$exports, "AddOperation", function () { return $e97a97f0b0cf48c9$export$e641dc52bc3494aa; });
$parcel$export($e97a97f0b0cf48c9$exports, "NoToneMapping", function () { return $e97a97f0b0cf48c9$export$9fcb6b4294603b2; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinearToneMapping", function () { return $e97a97f0b0cf48c9$export$98f52c2a46c598ca; });
$parcel$export($e97a97f0b0cf48c9$exports, "ReinhardToneMapping", function () { return $e97a97f0b0cf48c9$export$74b25e54b3bcd548; });
$parcel$export($e97a97f0b0cf48c9$exports, "CineonToneMapping", function () { return $e97a97f0b0cf48c9$export$932b3dd283d4a366; });
$parcel$export($e97a97f0b0cf48c9$exports, "ACESFilmicToneMapping", function () { return $e97a97f0b0cf48c9$export$a0d98fe6d7e4af64; });
$parcel$export($e97a97f0b0cf48c9$exports, "CustomToneMapping", function () { return $e97a97f0b0cf48c9$export$2c7b09c1e9abfb5e; });
$parcel$export($e97a97f0b0cf48c9$exports, "UVMapping", function () { return $e97a97f0b0cf48c9$export$1beec6768cbb3d2d; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubeReflectionMapping", function () { return $e97a97f0b0cf48c9$export$8759762a6477f2c4; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubeRefractionMapping", function () { return $e97a97f0b0cf48c9$export$dc59f8aed047f61d; });
$parcel$export($e97a97f0b0cf48c9$exports, "EquirectangularReflectionMapping", function () { return $e97a97f0b0cf48c9$export$d64030b316d3b087; });
$parcel$export($e97a97f0b0cf48c9$exports, "EquirectangularRefractionMapping", function () { return $e97a97f0b0cf48c9$export$ee99d97d46898098; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubeUVReflectionMapping", function () { return $e97a97f0b0cf48c9$export$dbf3e70ff37af79; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubeUVRefractionMapping", function () { return $e97a97f0b0cf48c9$export$76a9f4355364345c; });
$parcel$export($e97a97f0b0cf48c9$exports, "RepeatWrapping", function () { return $e97a97f0b0cf48c9$export$533346c8e8dac0f5; });
$parcel$export($e97a97f0b0cf48c9$exports, "ClampToEdgeWrapping", function () { return $e97a97f0b0cf48c9$export$9d9334239a5a5e06; });
$parcel$export($e97a97f0b0cf48c9$exports, "MirroredRepeatWrapping", function () { return $e97a97f0b0cf48c9$export$c7e7c00b14f51a4f; });
$parcel$export($e97a97f0b0cf48c9$exports, "NearestFilter", function () { return $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0; });
$parcel$export($e97a97f0b0cf48c9$exports, "NearestMipmapNearestFilter", function () { return $e97a97f0b0cf48c9$export$d129e38cf6feaa8c; });
$parcel$export($e97a97f0b0cf48c9$exports, "NearestMipMapNearestFilter", function () { return $e97a97f0b0cf48c9$export$14a4936464a36496; });
$parcel$export($e97a97f0b0cf48c9$exports, "NearestMipmapLinearFilter", function () { return $e97a97f0b0cf48c9$export$d2327c1afe5bfdf2; });
$parcel$export($e97a97f0b0cf48c9$exports, "NearestMipMapLinearFilter", function () { return $e97a97f0b0cf48c9$export$cbc5b7f5647595d8; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinearFilter", function () { return $e97a97f0b0cf48c9$export$8a72f490b25c56c8; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinearMipmapNearestFilter", function () { return $e97a97f0b0cf48c9$export$19a719f377145a13; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinearMipMapNearestFilter", function () { return $e97a97f0b0cf48c9$export$dbe96bee3fe9dbf0; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinearMipmapLinearFilter", function () { return $e97a97f0b0cf48c9$export$5d8599b6a933fb1b; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinearMipMapLinearFilter", function () { return $e97a97f0b0cf48c9$export$90d80f1e3506775f; });
$parcel$export($e97a97f0b0cf48c9$exports, "UnsignedByteType", function () { return $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10; });
$parcel$export($e97a97f0b0cf48c9$exports, "ByteType", function () { return $e97a97f0b0cf48c9$export$545fce0311a9796a; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShortType", function () { return $e97a97f0b0cf48c9$export$88572337f312435f; });
$parcel$export($e97a97f0b0cf48c9$exports, "UnsignedShortType", function () { return $e97a97f0b0cf48c9$export$c63dc51868b06a9d; });
$parcel$export($e97a97f0b0cf48c9$exports, "IntType", function () { return $e97a97f0b0cf48c9$export$5c612977753abe2; });
$parcel$export($e97a97f0b0cf48c9$exports, "UnsignedIntType", function () { return $e97a97f0b0cf48c9$export$c3c7fc4518ebba96; });
$parcel$export($e97a97f0b0cf48c9$exports, "FloatType", function () { return $e97a97f0b0cf48c9$export$f6d331659b644596; });
$parcel$export($e97a97f0b0cf48c9$exports, "HalfFloatType", function () { return $e97a97f0b0cf48c9$export$2697304443f382bc; });
$parcel$export($e97a97f0b0cf48c9$exports, "UnsignedShort4444Type", function () { return $e97a97f0b0cf48c9$export$b3969b01faf587f2; });
$parcel$export($e97a97f0b0cf48c9$exports, "UnsignedShort5551Type", function () { return $e97a97f0b0cf48c9$export$18886f8ae33e90de; });
$parcel$export($e97a97f0b0cf48c9$exports, "UnsignedInt248Type", function () { return $e97a97f0b0cf48c9$export$6c8ea339bfab1301; });
$parcel$export($e97a97f0b0cf48c9$exports, "AlphaFormat", function () { return $e97a97f0b0cf48c9$export$988473390501ed4b; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBFormat", function () { return $e97a97f0b0cf48c9$export$7c67423a5ee6f5eb; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBAFormat", function () { return $e97a97f0b0cf48c9$export$3f8bb04b555a363c; });
$parcel$export($e97a97f0b0cf48c9$exports, "LuminanceFormat", function () { return $e97a97f0b0cf48c9$export$cc09ccbf6d1ed449; });
$parcel$export($e97a97f0b0cf48c9$exports, "LuminanceAlphaFormat", function () { return $e97a97f0b0cf48c9$export$9053a81c4a69c289; });
$parcel$export($e97a97f0b0cf48c9$exports, "DepthFormat", function () { return $e97a97f0b0cf48c9$export$c1b6b5136be58045; });
$parcel$export($e97a97f0b0cf48c9$exports, "DepthStencilFormat", function () { return $e97a97f0b0cf48c9$export$1e113ac2d0905829; });
$parcel$export($e97a97f0b0cf48c9$exports, "RedFormat", function () { return $e97a97f0b0cf48c9$export$4e041a7967d15c4b; });
$parcel$export($e97a97f0b0cf48c9$exports, "RedIntegerFormat", function () { return $e97a97f0b0cf48c9$export$aa92e870a709d190; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGFormat", function () { return $e97a97f0b0cf48c9$export$6cdf0b461c7ce8a0; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGIntegerFormat", function () { return $e97a97f0b0cf48c9$export$1ba1c45f9f77d4d7; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBAIntegerFormat", function () { return $e97a97f0b0cf48c9$export$c200e7d26f592f21; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGB_S3TC_DXT1_Format", function () { return $e97a97f0b0cf48c9$export$21d1799c6d552fc0; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_S3TC_DXT1_Format", function () { return $e97a97f0b0cf48c9$export$afa304c3e981b668; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_S3TC_DXT3_Format", function () { return $e97a97f0b0cf48c9$export$d2a1a68024a3e56c; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_S3TC_DXT5_Format", function () { return $e97a97f0b0cf48c9$export$9a79c424327dacf9; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGB_PVRTC_4BPPV1_Format", function () { return $e97a97f0b0cf48c9$export$19ada9bbb1af3573; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGB_PVRTC_2BPPV1_Format", function () { return $e97a97f0b0cf48c9$export$d0f0355bb3d948e4; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_PVRTC_4BPPV1_Format", function () { return $e97a97f0b0cf48c9$export$b82296714358084c; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_PVRTC_2BPPV1_Format", function () { return $e97a97f0b0cf48c9$export$b71692456c47b6c3; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGB_ETC1_Format", function () { return $e97a97f0b0cf48c9$export$6ab91af2d757aee7; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGB_ETC2_Format", function () { return $e97a97f0b0cf48c9$export$7800993ef8106a6a; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ETC2_EAC_Format", function () { return $e97a97f0b0cf48c9$export$23ed8300a860e7d8; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_4x4_Format", function () { return $e97a97f0b0cf48c9$export$dc5570b4a2b92d48; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_5x4_Format", function () { return $e97a97f0b0cf48c9$export$68880cd325f8b2fb; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_5x5_Format", function () { return $e97a97f0b0cf48c9$export$7d2c0be323373d95; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_6x5_Format", function () { return $e97a97f0b0cf48c9$export$22b52da301fc3a3e; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_6x6_Format", function () { return $e97a97f0b0cf48c9$export$c009e2cb4a66485e; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_8x5_Format", function () { return $e97a97f0b0cf48c9$export$118fff5afa255b63; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_8x6_Format", function () { return $e97a97f0b0cf48c9$export$120713c829ae0667; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_8x8_Format", function () { return $e97a97f0b0cf48c9$export$c79eeabbf53313e9; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_10x5_Format", function () { return $e97a97f0b0cf48c9$export$443cf6567cdd6424; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_10x6_Format", function () { return $e97a97f0b0cf48c9$export$6573984fc9840780; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_10x8_Format", function () { return $e97a97f0b0cf48c9$export$e7aee563f30091de; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_10x10_Format", function () { return $e97a97f0b0cf48c9$export$2eb8634622ddeab7; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_12x10_Format", function () { return $e97a97f0b0cf48c9$export$202b1ce7b5d25742; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_ASTC_12x12_Format", function () { return $e97a97f0b0cf48c9$export$18ab77abd087e467; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBA_BPTC_Format", function () { return $e97a97f0b0cf48c9$export$ce40b115e188bc81; });
$parcel$export($e97a97f0b0cf48c9$exports, "LoopOnce", function () { return $e97a97f0b0cf48c9$export$d62fdc9d1b1cccad; });
$parcel$export($e97a97f0b0cf48c9$exports, "LoopRepeat", function () { return $e97a97f0b0cf48c9$export$dfaf4422ce096e29; });
$parcel$export($e97a97f0b0cf48c9$exports, "LoopPingPong", function () { return $e97a97f0b0cf48c9$export$f8f6f2041b78e210; });
$parcel$export($e97a97f0b0cf48c9$exports, "InterpolateDiscrete", function () { return $e97a97f0b0cf48c9$export$995b32462a65e855; });
$parcel$export($e97a97f0b0cf48c9$exports, "InterpolateLinear", function () { return $e97a97f0b0cf48c9$export$30fac1aace31cf4d; });
$parcel$export($e97a97f0b0cf48c9$exports, "InterpolateSmooth", function () { return $e97a97f0b0cf48c9$export$198b11ff4c72bb30; });
$parcel$export($e97a97f0b0cf48c9$exports, "ZeroCurvatureEnding", function () { return $e97a97f0b0cf48c9$export$7f795934b84ab523; });
$parcel$export($e97a97f0b0cf48c9$exports, "ZeroSlopeEnding", function () { return $e97a97f0b0cf48c9$export$24a4ccb5099273b5; });
$parcel$export($e97a97f0b0cf48c9$exports, "WrapAroundEnding", function () { return $e97a97f0b0cf48c9$export$8e8c3ecdcd8e1fee; });
$parcel$export($e97a97f0b0cf48c9$exports, "NormalAnimationBlendMode", function () { return $e97a97f0b0cf48c9$export$bcfbbdcf8de7f8cd; });
$parcel$export($e97a97f0b0cf48c9$exports, "AdditiveAnimationBlendMode", function () { return $e97a97f0b0cf48c9$export$d875e029ef558d3; });
$parcel$export($e97a97f0b0cf48c9$exports, "TrianglesDrawMode", function () { return $e97a97f0b0cf48c9$export$4c28c87c2dc84758; });
$parcel$export($e97a97f0b0cf48c9$exports, "TriangleStripDrawMode", function () { return $e97a97f0b0cf48c9$export$b23a071aa286eb29; });
$parcel$export($e97a97f0b0cf48c9$exports, "TriangleFanDrawMode", function () { return $e97a97f0b0cf48c9$export$f0d8293634f88842; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinearEncoding", function () { return $e97a97f0b0cf48c9$export$7207336e4151a112; });
$parcel$export($e97a97f0b0cf48c9$exports, "sRGBEncoding", function () { return $e97a97f0b0cf48c9$export$f32388edbb32674; });
$parcel$export($e97a97f0b0cf48c9$exports, "BasicDepthPacking", function () { return $e97a97f0b0cf48c9$export$deeb383078690b50; });
$parcel$export($e97a97f0b0cf48c9$exports, "RGBADepthPacking", function () { return $e97a97f0b0cf48c9$export$8f910f4c4f73df11; });
$parcel$export($e97a97f0b0cf48c9$exports, "TangentSpaceNormalMap", function () { return $e97a97f0b0cf48c9$export$2852a58ebdac27b8; });
$parcel$export($e97a97f0b0cf48c9$exports, "ObjectSpaceNormalMap", function () { return $e97a97f0b0cf48c9$export$9990ad26f9db5b2c; });
$parcel$export($e97a97f0b0cf48c9$exports, "ZeroStencilOp", function () { return $e97a97f0b0cf48c9$export$69433f11f42d5527; });
$parcel$export($e97a97f0b0cf48c9$exports, "KeepStencilOp", function () { return $e97a97f0b0cf48c9$export$9f542ae4b5baca34; });
$parcel$export($e97a97f0b0cf48c9$exports, "ReplaceStencilOp", function () { return $e97a97f0b0cf48c9$export$8a4f28336ef203d3; });
$parcel$export($e97a97f0b0cf48c9$exports, "IncrementStencilOp", function () { return $e97a97f0b0cf48c9$export$2928c0231297c036; });
$parcel$export($e97a97f0b0cf48c9$exports, "DecrementStencilOp", function () { return $e97a97f0b0cf48c9$export$c0e9611c8a15f9a8; });
$parcel$export($e97a97f0b0cf48c9$exports, "IncrementWrapStencilOp", function () { return $e97a97f0b0cf48c9$export$9c2c08927385dcc4; });
$parcel$export($e97a97f0b0cf48c9$exports, "DecrementWrapStencilOp", function () { return $e97a97f0b0cf48c9$export$7c74ea00fa1315e6; });
$parcel$export($e97a97f0b0cf48c9$exports, "InvertStencilOp", function () { return $e97a97f0b0cf48c9$export$22e2e5726612443; });
$parcel$export($e97a97f0b0cf48c9$exports, "NeverStencilFunc", function () { return $e97a97f0b0cf48c9$export$1343870698229224; });
$parcel$export($e97a97f0b0cf48c9$exports, "LessStencilFunc", function () { return $e97a97f0b0cf48c9$export$8e1d8ed281997fa6; });
$parcel$export($e97a97f0b0cf48c9$exports, "EqualStencilFunc", function () { return $e97a97f0b0cf48c9$export$55648a1cde8329a7; });
$parcel$export($e97a97f0b0cf48c9$exports, "LessEqualStencilFunc", function () { return $e97a97f0b0cf48c9$export$2dff107857e6aca2; });
$parcel$export($e97a97f0b0cf48c9$exports, "GreaterStencilFunc", function () { return $e97a97f0b0cf48c9$export$6f93765ab2f451a2; });
$parcel$export($e97a97f0b0cf48c9$exports, "NotEqualStencilFunc", function () { return $e97a97f0b0cf48c9$export$6f3fb2d2440f2b76; });
$parcel$export($e97a97f0b0cf48c9$exports, "GreaterEqualStencilFunc", function () { return $e97a97f0b0cf48c9$export$4119cf7b4c98fd5a; });
$parcel$export($e97a97f0b0cf48c9$exports, "AlwaysStencilFunc", function () { return $e97a97f0b0cf48c9$export$14cf96713ddd97a8; });
$parcel$export($e97a97f0b0cf48c9$exports, "StaticDrawUsage", function () { return $e97a97f0b0cf48c9$export$763e8360f4d7f77d; });
$parcel$export($e97a97f0b0cf48c9$exports, "DynamicDrawUsage", function () { return $e97a97f0b0cf48c9$export$8505d14ac8546ca; });
$parcel$export($e97a97f0b0cf48c9$exports, "StreamDrawUsage", function () { return $e97a97f0b0cf48c9$export$721e63549e51d81e; });
$parcel$export($e97a97f0b0cf48c9$exports, "StaticReadUsage", function () { return $e97a97f0b0cf48c9$export$415731dc4f48e299; });
$parcel$export($e97a97f0b0cf48c9$exports, "DynamicReadUsage", function () { return $e97a97f0b0cf48c9$export$9e809946455f13bc; });
$parcel$export($e97a97f0b0cf48c9$exports, "StreamReadUsage", function () { return $e97a97f0b0cf48c9$export$2ed9499a35b5f832; });
$parcel$export($e97a97f0b0cf48c9$exports, "StaticCopyUsage", function () { return $e97a97f0b0cf48c9$export$32ab2503ea19469a; });
$parcel$export($e97a97f0b0cf48c9$exports, "DynamicCopyUsage", function () { return $e97a97f0b0cf48c9$export$ab4022c2c3f86315; });
$parcel$export($e97a97f0b0cf48c9$exports, "StreamCopyUsage", function () { return $e97a97f0b0cf48c9$export$ba7f1db36a76a970; });
$parcel$export($e97a97f0b0cf48c9$exports, "GLSL1", function () { return $e97a97f0b0cf48c9$export$43600cc67fabd9f; });
$parcel$export($e97a97f0b0cf48c9$exports, "GLSL3", function () { return $e97a97f0b0cf48c9$export$f63012db5506e7dd; });
$parcel$export($e97a97f0b0cf48c9$exports, "_SRGBAFormat", function () { return $e97a97f0b0cf48c9$export$ca1dce8b5e1de74d; });
$parcel$export($e97a97f0b0cf48c9$exports, "EventDispatcher", function () { return $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a; });
$parcel$export($e97a97f0b0cf48c9$exports, "Math", function () { return $e97a97f0b0cf48c9$export$380958644dbbc22b; });
$parcel$export($e97a97f0b0cf48c9$exports, "Vector2", function () { return $e97a97f0b0cf48c9$export$c977b3e384af9ae1; });
$parcel$export($e97a97f0b0cf48c9$exports, "Matrix3", function () { return $e97a97f0b0cf48c9$export$8ff26dafa08918; });
$parcel$export($e97a97f0b0cf48c9$exports, "Color", function () { return $e97a97f0b0cf48c9$export$892596cec99bc70e; });
$parcel$export($e97a97f0b0cf48c9$exports, "ImageUtils", function () { return $e97a97f0b0cf48c9$export$698882cf06df44aa; });
$parcel$export($e97a97f0b0cf48c9$exports, "Texture", function () { return $e97a97f0b0cf48c9$export$5431306cf43de24a; });
$parcel$export($e97a97f0b0cf48c9$exports, "Vector4", function () { return $e97a97f0b0cf48c9$export$fa7daccca11cdbe3; });
$parcel$export($e97a97f0b0cf48c9$exports, "WebGLRenderTarget", function () { return $e97a97f0b0cf48c9$export$3c052beb2e51e23f; });
$parcel$export($e97a97f0b0cf48c9$exports, "WebGLMultipleRenderTargets", function () { return $e97a97f0b0cf48c9$export$bd934554fb721730; });
$parcel$export($e97a97f0b0cf48c9$exports, "WebGLMultisampleRenderTarget", function () { return $e97a97f0b0cf48c9$export$cb2022643d3c928d; });
$parcel$export($e97a97f0b0cf48c9$exports, "Quaternion", function () { return $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3; });
$parcel$export($e97a97f0b0cf48c9$exports, "Vector3", function () { return $e97a97f0b0cf48c9$export$64b5c384219d3699; });
$parcel$export($e97a97f0b0cf48c9$exports, "Box3", function () { return $e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3; });
$parcel$export($e97a97f0b0cf48c9$exports, "Sphere", function () { return $e97a97f0b0cf48c9$export$805e8b72413ccaba; });
$parcel$export($e97a97f0b0cf48c9$exports, "Ray", function () { return $e97a97f0b0cf48c9$export$a186db52eed6d40e; });
$parcel$export($e97a97f0b0cf48c9$exports, "Matrix4", function () { return $e97a97f0b0cf48c9$export$2ae72fc923e5eb5; });
$parcel$export($e97a97f0b0cf48c9$exports, "Euler", function () { return $e97a97f0b0cf48c9$export$d93cc409a0768c5f; });
$parcel$export($e97a97f0b0cf48c9$exports, "Layers", function () { return $e97a97f0b0cf48c9$export$89312ce47c0ca777; });
$parcel$export($e97a97f0b0cf48c9$exports, "Object3D", function () { return $e97a97f0b0cf48c9$export$e4dd07dff30cc924; });
$parcel$export($e97a97f0b0cf48c9$exports, "Triangle", function () { return $e97a97f0b0cf48c9$export$5a465592bfe74b48; });
$parcel$export($e97a97f0b0cf48c9$exports, "Material", function () { return $e97a97f0b0cf48c9$export$a2d8b23205c25948; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshBasicMaterial", function () { return $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5; });
$parcel$export($e97a97f0b0cf48c9$exports, "BufferAttribute", function () { return $e97a97f0b0cf48c9$export$8dea267bd6bde117; });
$parcel$export($e97a97f0b0cf48c9$exports, "Int8BufferAttribute", function () { return $e97a97f0b0cf48c9$export$f9ff2d6a20248cbf; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uint8BufferAttribute", function () { return $e97a97f0b0cf48c9$export$cacc90cf35d11cdd; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uint8ClampedBufferAttribute", function () { return $e97a97f0b0cf48c9$export$baaa85a1a812c157; });
$parcel$export($e97a97f0b0cf48c9$exports, "Int16BufferAttribute", function () { return $e97a97f0b0cf48c9$export$2b755a102ccdcefe; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uint16BufferAttribute", function () { return $e97a97f0b0cf48c9$export$640a853f68025f2e; });
$parcel$export($e97a97f0b0cf48c9$exports, "Int32BufferAttribute", function () { return $e97a97f0b0cf48c9$export$46b369aed2968a0a; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uint32BufferAttribute", function () { return $e97a97f0b0cf48c9$export$7eb8c9fa25cd5bd6; });
$parcel$export($e97a97f0b0cf48c9$exports, "Float16BufferAttribute", function () { return $e97a97f0b0cf48c9$export$dbd3698c64958d69; });
$parcel$export($e97a97f0b0cf48c9$exports, "Float32BufferAttribute", function () { return $e97a97f0b0cf48c9$export$cbe7a62641830ebd; });
$parcel$export($e97a97f0b0cf48c9$exports, "Float64BufferAttribute", function () { return $e97a97f0b0cf48c9$export$9e0ade74842adbb8; });
$parcel$export($e97a97f0b0cf48c9$exports, "BufferGeometry", function () { return $e97a97f0b0cf48c9$export$b7be63a67df8959; });
$parcel$export($e97a97f0b0cf48c9$exports, "Mesh", function () { return $e97a97f0b0cf48c9$export$e176487c05830cc5; });
$parcel$export($e97a97f0b0cf48c9$exports, "BoxBufferGeometry", function () { return $e97a97f0b0cf48c9$export$ab3456a079aa7d80; });
$parcel$export($e97a97f0b0cf48c9$exports, "UniformsUtils", function () { return $e97a97f0b0cf48c9$export$d8ecdf8615bfea69; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShaderMaterial", function () { return $e97a97f0b0cf48c9$export$83c7d75d550a8b0d; });
$parcel$export($e97a97f0b0cf48c9$exports, "Camera", function () { return $e97a97f0b0cf48c9$export$79f141de891a5fed; });
$parcel$export($e97a97f0b0cf48c9$exports, "PerspectiveCamera", function () { return $e97a97f0b0cf48c9$export$74e4ae24825f68d7; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubeCamera", function () { return $e97a97f0b0cf48c9$export$d0cdd0bd804995de; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubeTexture", function () { return $e97a97f0b0cf48c9$export$ee2e5a18258a4049; });
$parcel$export($e97a97f0b0cf48c9$exports, "WebGLCubeRenderTarget", function () { return $e97a97f0b0cf48c9$export$ac386671d651941e; });
$parcel$export($e97a97f0b0cf48c9$exports, "Plane", function () { return $e97a97f0b0cf48c9$export$7ff5ac152ef991b0; });
$parcel$export($e97a97f0b0cf48c9$exports, "Frustum", function () { return $e97a97f0b0cf48c9$export$35efe6f4c85463d2; });
$parcel$export($e97a97f0b0cf48c9$exports, "PlaneBufferGeometry", function () { return $e97a97f0b0cf48c9$export$e789a11a194ca4e0; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShaderChunk", function () { return $e97a97f0b0cf48c9$export$955f9f2e84c43c8b; });
$parcel$export($e97a97f0b0cf48c9$exports, "UniformsLib", function () { return $e97a97f0b0cf48c9$export$6643083551874bf5; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShaderLib", function () { return $e97a97f0b0cf48c9$export$bee4a7d47f8f5014; });
$parcel$export($e97a97f0b0cf48c9$exports, "OrthographicCamera", function () { return $e97a97f0b0cf48c9$export$9ebf355ee4ed261b; });
$parcel$export($e97a97f0b0cf48c9$exports, "RawShaderMaterial", function () { return $e97a97f0b0cf48c9$export$21c421a2e1df9d22; });
$parcel$export($e97a97f0b0cf48c9$exports, "PMREMGenerator", function () { return $e97a97f0b0cf48c9$export$6add42717753e221; });
$parcel$export($e97a97f0b0cf48c9$exports, "DataTexture2DArray", function () { return $e97a97f0b0cf48c9$export$e38bf4541665bbbd; });
$parcel$export($e97a97f0b0cf48c9$exports, "DataTexture3D", function () { return $e97a97f0b0cf48c9$export$ef03cdc98340bab4; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshDepthMaterial", function () { return $e97a97f0b0cf48c9$export$2698c22ec13825db; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshDistanceMaterial", function () { return $e97a97f0b0cf48c9$export$33e187ed002f2a19; });
$parcel$export($e97a97f0b0cf48c9$exports, "WebGLUtils", function () { return $e97a97f0b0cf48c9$export$ddaebcad857649a8; });
$parcel$export($e97a97f0b0cf48c9$exports, "ArrayCamera", function () { return $e97a97f0b0cf48c9$export$56b937d9e5581166; });
$parcel$export($e97a97f0b0cf48c9$exports, "Group", function () { return $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4; });
$parcel$export($e97a97f0b0cf48c9$exports, "DepthTexture", function () { return $e97a97f0b0cf48c9$export$fc830aa069cc8c2f; });
$parcel$export($e97a97f0b0cf48c9$exports, "WebGLRenderer", function () { return $e97a97f0b0cf48c9$export$f6cc00ef28d7cf97; });
$parcel$export($e97a97f0b0cf48c9$exports, "WebGL1Renderer", function () { return $e97a97f0b0cf48c9$export$a2f65229194348f9; });
$parcel$export($e97a97f0b0cf48c9$exports, "FogExp2", function () { return $e97a97f0b0cf48c9$export$6f1519f023b8d0f6; });
$parcel$export($e97a97f0b0cf48c9$exports, "Fog", function () { return $e97a97f0b0cf48c9$export$3c890837b09508d4; });
$parcel$export($e97a97f0b0cf48c9$exports, "Scene", function () { return $e97a97f0b0cf48c9$export$38af1803e3442a7f; });
$parcel$export($e97a97f0b0cf48c9$exports, "InterleavedBuffer", function () { return $e97a97f0b0cf48c9$export$3d5cd879f108f53f; });
$parcel$export($e97a97f0b0cf48c9$exports, "InterleavedBufferAttribute", function () { return $e97a97f0b0cf48c9$export$920b6d07334599c7; });
$parcel$export($e97a97f0b0cf48c9$exports, "SpriteMaterial", function () { return $e97a97f0b0cf48c9$export$5ec7dd1c6994bf8e; });
$parcel$export($e97a97f0b0cf48c9$exports, "Sprite", function () { return $e97a97f0b0cf48c9$export$3075603db8e6204c; });
$parcel$export($e97a97f0b0cf48c9$exports, "LOD", function () { return $e97a97f0b0cf48c9$export$112e7237be0c5f30; });
$parcel$export($e97a97f0b0cf48c9$exports, "SkinnedMesh", function () { return $e97a97f0b0cf48c9$export$b303577035157ecf; });
$parcel$export($e97a97f0b0cf48c9$exports, "Bone", function () { return $e97a97f0b0cf48c9$export$b127726e56765aa4; });
$parcel$export($e97a97f0b0cf48c9$exports, "DataTexture", function () { return $e97a97f0b0cf48c9$export$b691f601014eabe1; });
$parcel$export($e97a97f0b0cf48c9$exports, "Skeleton", function () { return $e97a97f0b0cf48c9$export$8f31e4c4a37b8e9c; });
$parcel$export($e97a97f0b0cf48c9$exports, "InstancedBufferAttribute", function () { return $e97a97f0b0cf48c9$export$32ea87a8b54d744a; });
$parcel$export($e97a97f0b0cf48c9$exports, "InstancedMesh", function () { return $e97a97f0b0cf48c9$export$f3c979c331175ad7; });
$parcel$export($e97a97f0b0cf48c9$exports, "LineBasicMaterial", function () { return $e97a97f0b0cf48c9$export$fbaaa33907730a0c; });
$parcel$export($e97a97f0b0cf48c9$exports, "Line", function () { return $e97a97f0b0cf48c9$export$17d680238e50603e; });
$parcel$export($e97a97f0b0cf48c9$exports, "LineSegments", function () { return $e97a97f0b0cf48c9$export$ff1ed10fedfdd604; });
$parcel$export($e97a97f0b0cf48c9$exports, "LineLoop", function () { return $e97a97f0b0cf48c9$export$f85a24d745e4f17d; });
$parcel$export($e97a97f0b0cf48c9$exports, "PointsMaterial", function () { return $e97a97f0b0cf48c9$export$a178c45366ce5d6b; });
$parcel$export($e97a97f0b0cf48c9$exports, "Points", function () { return $e97a97f0b0cf48c9$export$1c787534cb11aa3e; });
$parcel$export($e97a97f0b0cf48c9$exports, "VideoTexture", function () { return $e97a97f0b0cf48c9$export$6e09d1edf8d5a25c; });
$parcel$export($e97a97f0b0cf48c9$exports, "FramebufferTexture", function () { return $e97a97f0b0cf48c9$export$9270d786f73ce6fe; });
$parcel$export($e97a97f0b0cf48c9$exports, "CompressedTexture", function () { return $e97a97f0b0cf48c9$export$3466bac9141a5cc4; });
$parcel$export($e97a97f0b0cf48c9$exports, "CanvasTexture", function () { return $e97a97f0b0cf48c9$export$f7189e49152d1c13; });
$parcel$export($e97a97f0b0cf48c9$exports, "CircleBufferGeometry", function () { return $e97a97f0b0cf48c9$export$3f74fe60decf7462; });
$parcel$export($e97a97f0b0cf48c9$exports, "CylinderBufferGeometry", function () { return $e97a97f0b0cf48c9$export$d4345c83207d7c68; });
$parcel$export($e97a97f0b0cf48c9$exports, "ConeBufferGeometry", function () { return $e97a97f0b0cf48c9$export$59d971120dc8b6e7; });
$parcel$export($e97a97f0b0cf48c9$exports, "PolyhedronBufferGeometry", function () { return $e97a97f0b0cf48c9$export$38789b531813345c; });
$parcel$export($e97a97f0b0cf48c9$exports, "DodecahedronBufferGeometry", function () { return $e97a97f0b0cf48c9$export$37cd4e52cce48c4c; });
$parcel$export($e97a97f0b0cf48c9$exports, "EdgesGeometry", function () { return $e97a97f0b0cf48c9$export$4730b1542707547f; });
$parcel$export($e97a97f0b0cf48c9$exports, "Curve", function () { return $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1; });
$parcel$export($e97a97f0b0cf48c9$exports, "EllipseCurve", function () { return $e97a97f0b0cf48c9$export$3f87a931616cde04; });
$parcel$export($e97a97f0b0cf48c9$exports, "ArcCurve", function () { return $e97a97f0b0cf48c9$export$b1eedc9aab6300e8; });
$parcel$export($e97a97f0b0cf48c9$exports, "CatmullRomCurve3", function () { return $e97a97f0b0cf48c9$export$b9146b27c24b744c; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubicBezierCurve", function () { return $e97a97f0b0cf48c9$export$e36650d36468bb39; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubicBezierCurve3", function () { return $e97a97f0b0cf48c9$export$13d5f1c9525f246c; });
$parcel$export($e97a97f0b0cf48c9$exports, "LineCurve", function () { return $e97a97f0b0cf48c9$export$ab2e07e76531a47e; });
$parcel$export($e97a97f0b0cf48c9$exports, "LineCurve3", function () { return $e97a97f0b0cf48c9$export$1fdfd9d9cf487600; });
$parcel$export($e97a97f0b0cf48c9$exports, "QuadraticBezierCurve", function () { return $e97a97f0b0cf48c9$export$5938c4ee491a43ad; });
$parcel$export($e97a97f0b0cf48c9$exports, "QuadraticBezierCurve3", function () { return $e97a97f0b0cf48c9$export$bf3f4c7e459f90fc; });
$parcel$export($e97a97f0b0cf48c9$exports, "SplineCurve", function () { return $e97a97f0b0cf48c9$export$d3bdd77da77afc1b; });
$parcel$export($e97a97f0b0cf48c9$exports, "CurvePath", function () { return $e97a97f0b0cf48c9$export$4aaf9b66af1bbf2c; });
$parcel$export($e97a97f0b0cf48c9$exports, "Path", function () { return $e97a97f0b0cf48c9$export$4b2950bdac9b6ee9; });
$parcel$export($e97a97f0b0cf48c9$exports, "Shape", function () { return $e97a97f0b0cf48c9$export$6428a7f2611ef1fa; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShapeUtils", function () { return $e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8; });
$parcel$export($e97a97f0b0cf48c9$exports, "ExtrudeBufferGeometry", function () { return $e97a97f0b0cf48c9$export$91836d01b9f75a58; });
$parcel$export($e97a97f0b0cf48c9$exports, "IcosahedronBufferGeometry", function () { return $e97a97f0b0cf48c9$export$731fd4feef063ea2; });
$parcel$export($e97a97f0b0cf48c9$exports, "LatheBufferGeometry", function () { return $e97a97f0b0cf48c9$export$dc3e1273c1dd9240; });
$parcel$export($e97a97f0b0cf48c9$exports, "OctahedronBufferGeometry", function () { return $e97a97f0b0cf48c9$export$8e05fc91596f4752; });
$parcel$export($e97a97f0b0cf48c9$exports, "RingBufferGeometry", function () { return $e97a97f0b0cf48c9$export$ee8b85b34b7d9cad; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShapeBufferGeometry", function () { return $e97a97f0b0cf48c9$export$233afc324766bed8; });
$parcel$export($e97a97f0b0cf48c9$exports, "SphereBufferGeometry", function () { return $e97a97f0b0cf48c9$export$d5d06a966fec4192; });
$parcel$export($e97a97f0b0cf48c9$exports, "TetrahedronBufferGeometry", function () { return $e97a97f0b0cf48c9$export$369e08f62a796c65; });
$parcel$export($e97a97f0b0cf48c9$exports, "TorusBufferGeometry", function () { return $e97a97f0b0cf48c9$export$19d55f905fa4f2cb; });
$parcel$export($e97a97f0b0cf48c9$exports, "TorusKnotBufferGeometry", function () { return $e97a97f0b0cf48c9$export$2b32466f4274fe5c; });
$parcel$export($e97a97f0b0cf48c9$exports, "TubeBufferGeometry", function () { return $e97a97f0b0cf48c9$export$d97a193ce44e691b; });
$parcel$export($e97a97f0b0cf48c9$exports, "WireframeGeometry", function () { return $e97a97f0b0cf48c9$export$4b739da06d24892b; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShadowMaterial", function () { return $e97a97f0b0cf48c9$export$e8564da406055a3; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshStandardMaterial", function () { return $e97a97f0b0cf48c9$export$f2980790215acccd; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshPhysicalMaterial", function () { return $e97a97f0b0cf48c9$export$28d04986c4269c9f; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshPhongMaterial", function () { return $e97a97f0b0cf48c9$export$24c72f71cbaf0678; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshToonMaterial", function () { return $e97a97f0b0cf48c9$export$df893cf97e765622; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshNormalMaterial", function () { return $e97a97f0b0cf48c9$export$bfe8c0a091f41ae7; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshLambertMaterial", function () { return $e97a97f0b0cf48c9$export$5023a9a8114806b8; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshMatcapMaterial", function () { return $e97a97f0b0cf48c9$export$6f5fef6235ec12ee; });
$parcel$export($e97a97f0b0cf48c9$exports, "LineDashedMaterial", function () { return $e97a97f0b0cf48c9$export$327886a3efaeaebe; });
$parcel$export($e97a97f0b0cf48c9$exports, "AnimationUtils", function () { return $e97a97f0b0cf48c9$export$7ee8caa573e71ad1; });
$parcel$export($e97a97f0b0cf48c9$exports, "Interpolant", function () { return $e97a97f0b0cf48c9$export$b558baee9c0f72d3; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubicInterpolant", function () { return $e97a97f0b0cf48c9$export$3646682e7a3959; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinearInterpolant", function () { return $e97a97f0b0cf48c9$export$a8e6009059f51e1a; });
$parcel$export($e97a97f0b0cf48c9$exports, "DiscreteInterpolant", function () { return $e97a97f0b0cf48c9$export$fb9758ef7ef8d5cc; });
$parcel$export($e97a97f0b0cf48c9$exports, "KeyframeTrack", function () { return $e97a97f0b0cf48c9$export$b0e479f45b7006d6; });
$parcel$export($e97a97f0b0cf48c9$exports, "BooleanKeyframeTrack", function () { return $e97a97f0b0cf48c9$export$d3a344b98cf0b775; });
$parcel$export($e97a97f0b0cf48c9$exports, "ColorKeyframeTrack", function () { return $e97a97f0b0cf48c9$export$83444c5d885347d8; });
$parcel$export($e97a97f0b0cf48c9$exports, "NumberKeyframeTrack", function () { return $e97a97f0b0cf48c9$export$d45f0d1a4d9a9314; });
$parcel$export($e97a97f0b0cf48c9$exports, "QuaternionLinearInterpolant", function () { return $e97a97f0b0cf48c9$export$2db1cfb7923d931e; });
$parcel$export($e97a97f0b0cf48c9$exports, "QuaternionKeyframeTrack", function () { return $e97a97f0b0cf48c9$export$b8043f12b5aafbd7; });
$parcel$export($e97a97f0b0cf48c9$exports, "StringKeyframeTrack", function () { return $e97a97f0b0cf48c9$export$6ce41d4f3a8df9cd; });
$parcel$export($e97a97f0b0cf48c9$exports, "VectorKeyframeTrack", function () { return $e97a97f0b0cf48c9$export$5ce2dcb4cc9f2bff; });
$parcel$export($e97a97f0b0cf48c9$exports, "AnimationClip", function () { return $e97a97f0b0cf48c9$export$d942c706bf23829c; });
$parcel$export($e97a97f0b0cf48c9$exports, "Cache", function () { return $e97a97f0b0cf48c9$export$94affb487e701bf2; });
$parcel$export($e97a97f0b0cf48c9$exports, "LoadingManager", function () { return $e97a97f0b0cf48c9$export$99cc795e99919eed; });
$parcel$export($e97a97f0b0cf48c9$exports, "DefaultLoadingManager", function () { return $e97a97f0b0cf48c9$export$b033c3f9a95c6a16; });
$parcel$export($e97a97f0b0cf48c9$exports, "Loader", function () { return $e97a97f0b0cf48c9$export$3b0d6d7590275603; });
$parcel$export($e97a97f0b0cf48c9$exports, "FileLoader", function () { return $e97a97f0b0cf48c9$export$98435a25b5cf7b2b; });
$parcel$export($e97a97f0b0cf48c9$exports, "AnimationLoader", function () { return $e97a97f0b0cf48c9$export$29711c7e14f61db; });
$parcel$export($e97a97f0b0cf48c9$exports, "CompressedTextureLoader", function () { return $e97a97f0b0cf48c9$export$bd73ce947a280350; });
$parcel$export($e97a97f0b0cf48c9$exports, "ImageLoader", function () { return $e97a97f0b0cf48c9$export$8905ce1c7a2464a1; });
$parcel$export($e97a97f0b0cf48c9$exports, "CubeTextureLoader", function () { return $e97a97f0b0cf48c9$export$2ec114afc2cf6308; });
$parcel$export($e97a97f0b0cf48c9$exports, "DataTextureLoader", function () { return $e97a97f0b0cf48c9$export$792d8a18f2c55855; });
$parcel$export($e97a97f0b0cf48c9$exports, "TextureLoader", function () { return $e97a97f0b0cf48c9$export$fd1bfc71f64c538c; });
$parcel$export($e97a97f0b0cf48c9$exports, "Light", function () { return $e97a97f0b0cf48c9$export$6ecadb6ed240d696; });
$parcel$export($e97a97f0b0cf48c9$exports, "HemisphereLight", function () { return $e97a97f0b0cf48c9$export$8d474f55edbb9624; });
$parcel$export($e97a97f0b0cf48c9$exports, "SpotLight", function () { return $e97a97f0b0cf48c9$export$81495cbb73897362; });
$parcel$export($e97a97f0b0cf48c9$exports, "PointLight", function () { return $e97a97f0b0cf48c9$export$4c9c1cb3f0b6f455; });
$parcel$export($e97a97f0b0cf48c9$exports, "DirectionalLight", function () { return $e97a97f0b0cf48c9$export$3fea33cc9972c868; });
$parcel$export($e97a97f0b0cf48c9$exports, "AmbientLight", function () { return $e97a97f0b0cf48c9$export$af279bfef9ec2c96; });
$parcel$export($e97a97f0b0cf48c9$exports, "RectAreaLight", function () { return $e97a97f0b0cf48c9$export$61db2d908bbd2429; });
$parcel$export($e97a97f0b0cf48c9$exports, "SphericalHarmonics3", function () { return $e97a97f0b0cf48c9$export$ba61ce607e1f405a; });
$parcel$export($e97a97f0b0cf48c9$exports, "LightProbe", function () { return $e97a97f0b0cf48c9$export$e7ef036e309b38d2; });
$parcel$export($e97a97f0b0cf48c9$exports, "MaterialLoader", function () { return $e97a97f0b0cf48c9$export$3bd6d323353dcf96; });
$parcel$export($e97a97f0b0cf48c9$exports, "LoaderUtils", function () { return $e97a97f0b0cf48c9$export$b5d2dc08d867e41a; });
$parcel$export($e97a97f0b0cf48c9$exports, "InstancedBufferGeometry", function () { return $e97a97f0b0cf48c9$export$231f009cbe414146; });
$parcel$export($e97a97f0b0cf48c9$exports, "BufferGeometryLoader", function () { return $e97a97f0b0cf48c9$export$dc275bb96327833a; });
$parcel$export($e97a97f0b0cf48c9$exports, "ObjectLoader", function () { return $e97a97f0b0cf48c9$export$40110c8505c5ad19; });
$parcel$export($e97a97f0b0cf48c9$exports, "ImageBitmapLoader", function () { return $e97a97f0b0cf48c9$export$52286b55c4a9b51f; });
$parcel$export($e97a97f0b0cf48c9$exports, "AudioContext", function () { return $e97a97f0b0cf48c9$export$fcbc63750ec2a81f; });
$parcel$export($e97a97f0b0cf48c9$exports, "AudioLoader", function () { return $e97a97f0b0cf48c9$export$d8d5fccfbf47714e; });
$parcel$export($e97a97f0b0cf48c9$exports, "HemisphereLightProbe", function () { return $e97a97f0b0cf48c9$export$2f22dadc8bc42820; });
$parcel$export($e97a97f0b0cf48c9$exports, "AmbientLightProbe", function () { return $e97a97f0b0cf48c9$export$afe310a21c86023d; });
$parcel$export($e97a97f0b0cf48c9$exports, "StereoCamera", function () { return $e97a97f0b0cf48c9$export$bc7f73a1065bee0c; });
$parcel$export($e97a97f0b0cf48c9$exports, "Clock", function () { return $e97a97f0b0cf48c9$export$9735c82c4bae3302; });
$parcel$export($e97a97f0b0cf48c9$exports, "AudioListener", function () { return $e97a97f0b0cf48c9$export$8a1b810c6fde8951; });
$parcel$export($e97a97f0b0cf48c9$exports, "Audio", function () { return $e97a97f0b0cf48c9$export$153755f98d9861de; });
$parcel$export($e97a97f0b0cf48c9$exports, "PositionalAudio", function () { return $e97a97f0b0cf48c9$export$4b3e397ef1832507; });
$parcel$export($e97a97f0b0cf48c9$exports, "AudioAnalyser", function () { return $e97a97f0b0cf48c9$export$d47da1ef3d382827; });
$parcel$export($e97a97f0b0cf48c9$exports, "PropertyMixer", function () { return $e97a97f0b0cf48c9$export$dfe0af1ca1acb78a; });
$parcel$export($e97a97f0b0cf48c9$exports, "PropertyBinding", function () { return $e97a97f0b0cf48c9$export$7bf70fcf9f891893; });
$parcel$export($e97a97f0b0cf48c9$exports, "AnimationObjectGroup", function () { return $e97a97f0b0cf48c9$export$30619c2afd3f34db; });
$parcel$export($e97a97f0b0cf48c9$exports, "AnimationMixer", function () { return $e97a97f0b0cf48c9$export$fbd77e5aefaa0102; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uniform", function () { return $e97a97f0b0cf48c9$export$2947cebfe91c02f8; });
$parcel$export($e97a97f0b0cf48c9$exports, "InstancedInterleavedBuffer", function () { return $e97a97f0b0cf48c9$export$25ec0e1af1389358; });
$parcel$export($e97a97f0b0cf48c9$exports, "GLBufferAttribute", function () { return $e97a97f0b0cf48c9$export$6b7339ae8dbddf73; });
$parcel$export($e97a97f0b0cf48c9$exports, "Raycaster", function () { return $e97a97f0b0cf48c9$export$8b7aaceff00bd2f; });
$parcel$export($e97a97f0b0cf48c9$exports, "Spherical", function () { return $e97a97f0b0cf48c9$export$d712cd887b4a00f7; });
$parcel$export($e97a97f0b0cf48c9$exports, "Cylindrical", function () { return $e97a97f0b0cf48c9$export$287165bb2177f4fd; });
$parcel$export($e97a97f0b0cf48c9$exports, "Box2", function () { return $e97a97f0b0cf48c9$export$60f553fa130f08b0; });
$parcel$export($e97a97f0b0cf48c9$exports, "Line3", function () { return $e97a97f0b0cf48c9$export$e0ba6359f1954fd3; });
$parcel$export($e97a97f0b0cf48c9$exports, "SpotLightHelper", function () { return $e97a97f0b0cf48c9$export$4b14638ffdd81e68; });
$parcel$export($e97a97f0b0cf48c9$exports, "SkeletonHelper", function () { return $e97a97f0b0cf48c9$export$5277df3c9e732259; });
$parcel$export($e97a97f0b0cf48c9$exports, "PointLightHelper", function () { return $e97a97f0b0cf48c9$export$9a9291685b9e4023; });
$parcel$export($e97a97f0b0cf48c9$exports, "HemisphereLightHelper", function () { return $e97a97f0b0cf48c9$export$8dca15f13f4f8172; });
$parcel$export($e97a97f0b0cf48c9$exports, "GridHelper", function () { return $e97a97f0b0cf48c9$export$3875d39926561055; });
$parcel$export($e97a97f0b0cf48c9$exports, "PolarGridHelper", function () { return $e97a97f0b0cf48c9$export$361430a10f533cd3; });
$parcel$export($e97a97f0b0cf48c9$exports, "DirectionalLightHelper", function () { return $e97a97f0b0cf48c9$export$f8e434dc14203e7d; });
$parcel$export($e97a97f0b0cf48c9$exports, "CameraHelper", function () { return $e97a97f0b0cf48c9$export$ed8e93f853cd795; });
$parcel$export($e97a97f0b0cf48c9$exports, "BoxHelper", function () { return $e97a97f0b0cf48c9$export$38a664cc862a6a9d; });
$parcel$export($e97a97f0b0cf48c9$exports, "Box3Helper", function () { return $e97a97f0b0cf48c9$export$ce39f4bb96c9a290; });
$parcel$export($e97a97f0b0cf48c9$exports, "PlaneHelper", function () { return $e97a97f0b0cf48c9$export$a34fe8156c66e5d7; });
$parcel$export($e97a97f0b0cf48c9$exports, "ArrowHelper", function () { return $e97a97f0b0cf48c9$export$a3008e7bd8d2cbe7; });
$parcel$export($e97a97f0b0cf48c9$exports, "AxesHelper", function () { return $e97a97f0b0cf48c9$export$6c8303f35b8578fd; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShapePath", function () { return $e97a97f0b0cf48c9$export$148534a3c727230b; });
$parcel$export($e97a97f0b0cf48c9$exports, "DataUtils", function () { return $e97a97f0b0cf48c9$export$11ce8b759162cc80; });
$parcel$export($e97a97f0b0cf48c9$exports, "LineStrip", function () { return $e97a97f0b0cf48c9$export$195910b613d3dbcb; });
$parcel$export($e97a97f0b0cf48c9$exports, "LinePieces", function () { return $e97a97f0b0cf48c9$export$c8a71586e494fb81; });
$parcel$export($e97a97f0b0cf48c9$exports, "NoColors", function () { return $e97a97f0b0cf48c9$export$1a5c46edbdc9a5b7; });
$parcel$export($e97a97f0b0cf48c9$exports, "FaceColors", function () { return $e97a97f0b0cf48c9$export$617e978cc3201d85; });
$parcel$export($e97a97f0b0cf48c9$exports, "VertexColors", function () { return $e97a97f0b0cf48c9$export$969ede3d37172881; });
$parcel$export($e97a97f0b0cf48c9$exports, "MeshFaceMaterial", function () { return $e97a97f0b0cf48c9$export$8f0d8c869214e38a; });
$parcel$export($e97a97f0b0cf48c9$exports, "MultiMaterial", function () { return $e97a97f0b0cf48c9$export$4f1842f7cdf61f78; });
$parcel$export($e97a97f0b0cf48c9$exports, "PointCloud", function () { return $e97a97f0b0cf48c9$export$5c812f854e08d33d; });
$parcel$export($e97a97f0b0cf48c9$exports, "Particle", function () { return $e97a97f0b0cf48c9$export$c36c68baa13912a5; });
$parcel$export($e97a97f0b0cf48c9$exports, "ParticleSystem", function () { return $e97a97f0b0cf48c9$export$f219b6a0e4bb0b6d; });
$parcel$export($e97a97f0b0cf48c9$exports, "PointCloudMaterial", function () { return $e97a97f0b0cf48c9$export$29121d9ccd2f757a; });
$parcel$export($e97a97f0b0cf48c9$exports, "ParticleBasicMaterial", function () { return $e97a97f0b0cf48c9$export$ffa02580217a1c8; });
$parcel$export($e97a97f0b0cf48c9$exports, "ParticleSystemMaterial", function () { return $e97a97f0b0cf48c9$export$cb1306c614c86e6b; });
$parcel$export($e97a97f0b0cf48c9$exports, "Vertex", function () { return $e97a97f0b0cf48c9$export$3e8a3cc8713efbec; });
$parcel$export($e97a97f0b0cf48c9$exports, "DynamicBufferAttribute", function () { return $e97a97f0b0cf48c9$export$189ab5ea9d161e81; });
$parcel$export($e97a97f0b0cf48c9$exports, "Int8Attribute", function () { return $e97a97f0b0cf48c9$export$e0ae4f0a1804ea11; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uint8Attribute", function () { return $e97a97f0b0cf48c9$export$a0d192e03a5b32f5; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uint8ClampedAttribute", function () { return $e97a97f0b0cf48c9$export$8ca743ab36552bfa; });
$parcel$export($e97a97f0b0cf48c9$exports, "Int16Attribute", function () { return $e97a97f0b0cf48c9$export$5d9757676aad9dab; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uint16Attribute", function () { return $e97a97f0b0cf48c9$export$ed102ffd14092320; });
$parcel$export($e97a97f0b0cf48c9$exports, "Int32Attribute", function () { return $e97a97f0b0cf48c9$export$6acc479034658f15; });
$parcel$export($e97a97f0b0cf48c9$exports, "Uint32Attribute", function () { return $e97a97f0b0cf48c9$export$53474877d6e539b9; });
$parcel$export($e97a97f0b0cf48c9$exports, "Float32Attribute", function () { return $e97a97f0b0cf48c9$export$377af6eadc8006c3; });
$parcel$export($e97a97f0b0cf48c9$exports, "Float64Attribute", function () { return $e97a97f0b0cf48c9$export$b9212d1a67b6f081; });
$parcel$export($e97a97f0b0cf48c9$exports, "AxisHelper", function () { return $e97a97f0b0cf48c9$export$46c1eaab6b8d1e23; });
$parcel$export($e97a97f0b0cf48c9$exports, "BoundingBoxHelper", function () { return $e97a97f0b0cf48c9$export$3c24c67720a2146c; });
$parcel$export($e97a97f0b0cf48c9$exports, "EdgesHelper", function () { return $e97a97f0b0cf48c9$export$e341a90264c62d4c; });
$parcel$export($e97a97f0b0cf48c9$exports, "WireframeHelper", function () { return $e97a97f0b0cf48c9$export$72d033539c529f13; });
$parcel$export($e97a97f0b0cf48c9$exports, "XHRLoader", function () { return $e97a97f0b0cf48c9$export$c8b77178c5db4e0d; });
$parcel$export($e97a97f0b0cf48c9$exports, "BinaryTextureLoader", function () { return $e97a97f0b0cf48c9$export$58c7c1107fc658f9; });
$parcel$export($e97a97f0b0cf48c9$exports, "WebGLRenderTargetCube", function () { return $e97a97f0b0cf48c9$export$689069929abfa262; });
$parcel$export($e97a97f0b0cf48c9$exports, "CanvasRenderer", function () { return $e97a97f0b0cf48c9$export$7adc20298958481a; });
$parcel$export($e97a97f0b0cf48c9$exports, "JSONLoader", function () { return $e97a97f0b0cf48c9$export$8e85bca5826c4696; });
$parcel$export($e97a97f0b0cf48c9$exports, "SceneUtils", function () { return $e97a97f0b0cf48c9$export$a8351e0de8b3fd78; });
$parcel$export($e97a97f0b0cf48c9$exports, "LensFlare", function () { return $e97a97f0b0cf48c9$export$3f909fba4d49fe3d; });
$parcel$export($e97a97f0b0cf48c9$exports, "ParametricGeometry", function () { return $e97a97f0b0cf48c9$export$8f6f2b4b16d33f; });
$parcel$export($e97a97f0b0cf48c9$exports, "TextGeometry", function () { return $e97a97f0b0cf48c9$export$684b774b4473ba5f; });
$parcel$export($e97a97f0b0cf48c9$exports, "FontLoader", function () { return $e97a97f0b0cf48c9$export$812303d6cad736b3; });
$parcel$export($e97a97f0b0cf48c9$exports, "Font", function () { return $e97a97f0b0cf48c9$export$89abf52a030e56ee; });
$parcel$export($e97a97f0b0cf48c9$exports, "ImmediateRenderObject", function () { return $e97a97f0b0cf48c9$export$960665a8431ecff6; });
$parcel$export($e97a97f0b0cf48c9$exports, "BoxGeometry", function () { return $e97a97f0b0cf48c9$export$ab3456a079aa7d80; });
$parcel$export($e97a97f0b0cf48c9$exports, "CircleGeometry", function () { return $e97a97f0b0cf48c9$export$3f74fe60decf7462; });
$parcel$export($e97a97f0b0cf48c9$exports, "ConeGeometry", function () { return $e97a97f0b0cf48c9$export$59d971120dc8b6e7; });
$parcel$export($e97a97f0b0cf48c9$exports, "CylinderGeometry", function () { return $e97a97f0b0cf48c9$export$d4345c83207d7c68; });
$parcel$export($e97a97f0b0cf48c9$exports, "DodecahedronGeometry", function () { return $e97a97f0b0cf48c9$export$37cd4e52cce48c4c; });
$parcel$export($e97a97f0b0cf48c9$exports, "ExtrudeGeometry", function () { return $e97a97f0b0cf48c9$export$91836d01b9f75a58; });
$parcel$export($e97a97f0b0cf48c9$exports, "IcosahedronGeometry", function () { return $e97a97f0b0cf48c9$export$731fd4feef063ea2; });
$parcel$export($e97a97f0b0cf48c9$exports, "LatheGeometry", function () { return $e97a97f0b0cf48c9$export$dc3e1273c1dd9240; });
$parcel$export($e97a97f0b0cf48c9$exports, "MathUtils", function () { return $e97a97f0b0cf48c9$export$380958644dbbc22b; });
$parcel$export($e97a97f0b0cf48c9$exports, "OctahedronGeometry", function () { return $e97a97f0b0cf48c9$export$8e05fc91596f4752; });
$parcel$export($e97a97f0b0cf48c9$exports, "PlaneGeometry", function () { return $e97a97f0b0cf48c9$export$e789a11a194ca4e0; });
$parcel$export($e97a97f0b0cf48c9$exports, "PolyhedronGeometry", function () { return $e97a97f0b0cf48c9$export$38789b531813345c; });
$parcel$export($e97a97f0b0cf48c9$exports, "RingGeometry", function () { return $e97a97f0b0cf48c9$export$ee8b85b34b7d9cad; });
$parcel$export($e97a97f0b0cf48c9$exports, "ShapeGeometry", function () { return $e97a97f0b0cf48c9$export$233afc324766bed8; });
$parcel$export($e97a97f0b0cf48c9$exports, "SphereGeometry", function () { return $e97a97f0b0cf48c9$export$d5d06a966fec4192; });
$parcel$export($e97a97f0b0cf48c9$exports, "TetrahedronGeometry", function () { return $e97a97f0b0cf48c9$export$369e08f62a796c65; });
$parcel$export($e97a97f0b0cf48c9$exports, "TorusGeometry", function () { return $e97a97f0b0cf48c9$export$19d55f905fa4f2cb; });
$parcel$export($e97a97f0b0cf48c9$exports, "TorusKnotGeometry", function () { return $e97a97f0b0cf48c9$export$2b32466f4274fe5c; });
$parcel$export($e97a97f0b0cf48c9$exports, "TubeGeometry", function () { return $e97a97f0b0cf48c9$export$d97a193ce44e691b; });
/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $e97a97f0b0cf48c9$export$3545e07a80636437 = "137";
const $e97a97f0b0cf48c9$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $e97a97f0b0cf48c9$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $e97a97f0b0cf48c9$export$3237e1f2c1ea1f44 = 0;
const $e97a97f0b0cf48c9$export$b9a7b4fc5cb15f9b = 1;
const $e97a97f0b0cf48c9$export$b8058bcc7037d3f3 = 2;
const $e97a97f0b0cf48c9$export$f24be24dcddeac0d = 3;
const $e97a97f0b0cf48c9$export$346307dbae2b7447 = 0;
const $e97a97f0b0cf48c9$export$5813f879eee7cd88 = 1;
const $e97a97f0b0cf48c9$export$a47c4b43a1be34f0 = 2;
const $e97a97f0b0cf48c9$export$896ae1ade6c829c4 = 3;
const $e97a97f0b0cf48c9$export$2ede184fc2998901 = 0;
const $e97a97f0b0cf48c9$export$d9f0486e75b5ace = 1;
const $e97a97f0b0cf48c9$export$3b296b6f144d5b03 = 2;
const $e97a97f0b0cf48c9$export$a62047d29c96d8ff = 1;
const $e97a97f0b0cf48c9$export$fadb74c06a7f490 = 2;
const $e97a97f0b0cf48c9$export$63b8d6b580fc65ba = 0;
const $e97a97f0b0cf48c9$export$5b29a26d96ee6af0 = 1;
const $e97a97f0b0cf48c9$export$777d8f9551c2216b = 2;
const $e97a97f0b0cf48c9$export$cdfa06f868e2e467 = 3;
const $e97a97f0b0cf48c9$export$4138e1c684b46a20 = 4;
const $e97a97f0b0cf48c9$export$eda4864c68df1fa2 = 5;
const $e97a97f0b0cf48c9$export$20183a0484ce21a0 = 100;
const $e97a97f0b0cf48c9$export$73e0df5177988548 = 101;
const $e97a97f0b0cf48c9$export$28e582859cbec660 = 102;
const $e97a97f0b0cf48c9$export$c8c1508da8d0600c = 103;
const $e97a97f0b0cf48c9$export$99948c02fb51055f = 104;
const $e97a97f0b0cf48c9$export$2110f05edf778d3d = 200;
const $e97a97f0b0cf48c9$export$8805bad65e24940e = 201;
const $e97a97f0b0cf48c9$export$7fbe15b28d28cf52 = 202;
const $e97a97f0b0cf48c9$export$947829af9f2c17f6 = 203;
const $e97a97f0b0cf48c9$export$d5773124e86cf28c = 204;
const $e97a97f0b0cf48c9$export$11d468cc7f19e971 = 205;
const $e97a97f0b0cf48c9$export$a78aed1ca2a87192 = 206;
const $e97a97f0b0cf48c9$export$5d0fe17fd8773bac = 207;
const $e97a97f0b0cf48c9$export$ef5f2dd8ffac5574 = 208;
const $e97a97f0b0cf48c9$export$56b85b2686ab16 = 209;
const $e97a97f0b0cf48c9$export$c05e2a1fc8609506 = 210;
const $e97a97f0b0cf48c9$export$69025ce147cee220 = 0;
const $e97a97f0b0cf48c9$export$7182eb52ea3b3f04 = 1;
const $e97a97f0b0cf48c9$export$eedccec66ab7ebe = 2;
const $e97a97f0b0cf48c9$export$296f78a0b892f81a = 3;
const $e97a97f0b0cf48c9$export$a60d398fc7b7590e = 4;
const $e97a97f0b0cf48c9$export$7d7234c1240a1fc4 = 5;
const $e97a97f0b0cf48c9$export$c5e2c52991f30937 = 6;
const $e97a97f0b0cf48c9$export$2f843afa843d8916 = 7;
const $e97a97f0b0cf48c9$export$e50ac29801f1774d = 0;
const $e97a97f0b0cf48c9$export$9f9d94f963c85479 = 1;
const $e97a97f0b0cf48c9$export$e641dc52bc3494aa = 2;
const $e97a97f0b0cf48c9$export$9fcb6b4294603b2 = 0;
const $e97a97f0b0cf48c9$export$98f52c2a46c598ca = 1;
const $e97a97f0b0cf48c9$export$74b25e54b3bcd548 = 2;
const $e97a97f0b0cf48c9$export$932b3dd283d4a366 = 3;
const $e97a97f0b0cf48c9$export$a0d98fe6d7e4af64 = 4;
const $e97a97f0b0cf48c9$export$2c7b09c1e9abfb5e = 5;
const $e97a97f0b0cf48c9$export$1beec6768cbb3d2d = 300;
const $e97a97f0b0cf48c9$export$8759762a6477f2c4 = 301;
const $e97a97f0b0cf48c9$export$dc59f8aed047f61d = 302;
const $e97a97f0b0cf48c9$export$d64030b316d3b087 = 303;
const $e97a97f0b0cf48c9$export$ee99d97d46898098 = 304;
const $e97a97f0b0cf48c9$export$dbf3e70ff37af79 = 306;
const $e97a97f0b0cf48c9$export$76a9f4355364345c = 307;
const $e97a97f0b0cf48c9$export$533346c8e8dac0f5 = 1000;
const $e97a97f0b0cf48c9$export$9d9334239a5a5e06 = 1001;
const $e97a97f0b0cf48c9$export$c7e7c00b14f51a4f = 1002;
const $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0 = 1003;
const $e97a97f0b0cf48c9$export$d129e38cf6feaa8c = 1004;
const $e97a97f0b0cf48c9$export$14a4936464a36496 = 1004;
const $e97a97f0b0cf48c9$export$d2327c1afe5bfdf2 = 1005;
const $e97a97f0b0cf48c9$export$cbc5b7f5647595d8 = 1005;
const $e97a97f0b0cf48c9$export$8a72f490b25c56c8 = 1006;
const $e97a97f0b0cf48c9$export$19a719f377145a13 = 1007;
const $e97a97f0b0cf48c9$export$dbe96bee3fe9dbf0 = 1007;
const $e97a97f0b0cf48c9$export$5d8599b6a933fb1b = 1008;
const $e97a97f0b0cf48c9$export$90d80f1e3506775f = 1008;
const $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10 = 1009;
const $e97a97f0b0cf48c9$export$545fce0311a9796a = 1010;
const $e97a97f0b0cf48c9$export$88572337f312435f = 1011;
const $e97a97f0b0cf48c9$export$c63dc51868b06a9d = 1012;
const $e97a97f0b0cf48c9$export$5c612977753abe2 = 1013;
const $e97a97f0b0cf48c9$export$c3c7fc4518ebba96 = 1014;
const $e97a97f0b0cf48c9$export$f6d331659b644596 = 1015;
const $e97a97f0b0cf48c9$export$2697304443f382bc = 1016;
const $e97a97f0b0cf48c9$export$b3969b01faf587f2 = 1017;
const $e97a97f0b0cf48c9$export$18886f8ae33e90de = 1018;
const $e97a97f0b0cf48c9$export$6c8ea339bfab1301 = 1020;
const $e97a97f0b0cf48c9$export$988473390501ed4b = 1021;
const $e97a97f0b0cf48c9$export$7c67423a5ee6f5eb = 1022;
const $e97a97f0b0cf48c9$export$3f8bb04b555a363c = 1023;
const $e97a97f0b0cf48c9$export$cc09ccbf6d1ed449 = 1024;
const $e97a97f0b0cf48c9$export$9053a81c4a69c289 = 1025;
const $e97a97f0b0cf48c9$export$c1b6b5136be58045 = 1026;
const $e97a97f0b0cf48c9$export$1e113ac2d0905829 = 1027;
const $e97a97f0b0cf48c9$export$4e041a7967d15c4b = 1028;
const $e97a97f0b0cf48c9$export$aa92e870a709d190 = 1029;
const $e97a97f0b0cf48c9$export$6cdf0b461c7ce8a0 = 1030;
const $e97a97f0b0cf48c9$export$1ba1c45f9f77d4d7 = 1031;
const $e97a97f0b0cf48c9$export$c200e7d26f592f21 = 1033;
const $e97a97f0b0cf48c9$export$21d1799c6d552fc0 = 33776;
const $e97a97f0b0cf48c9$export$afa304c3e981b668 = 33777;
const $e97a97f0b0cf48c9$export$d2a1a68024a3e56c = 33778;
const $e97a97f0b0cf48c9$export$9a79c424327dacf9 = 33779;
const $e97a97f0b0cf48c9$export$19ada9bbb1af3573 = 35840;
const $e97a97f0b0cf48c9$export$d0f0355bb3d948e4 = 35841;
const $e97a97f0b0cf48c9$export$b82296714358084c = 35842;
const $e97a97f0b0cf48c9$export$b71692456c47b6c3 = 35843;
const $e97a97f0b0cf48c9$export$6ab91af2d757aee7 = 36196;
const $e97a97f0b0cf48c9$export$7800993ef8106a6a = 37492;
const $e97a97f0b0cf48c9$export$23ed8300a860e7d8 = 37496;
const $e97a97f0b0cf48c9$export$dc5570b4a2b92d48 = 37808;
const $e97a97f0b0cf48c9$export$68880cd325f8b2fb = 37809;
const $e97a97f0b0cf48c9$export$7d2c0be323373d95 = 37810;
const $e97a97f0b0cf48c9$export$22b52da301fc3a3e = 37811;
const $e97a97f0b0cf48c9$export$c009e2cb4a66485e = 37812;
const $e97a97f0b0cf48c9$export$118fff5afa255b63 = 37813;
const $e97a97f0b0cf48c9$export$120713c829ae0667 = 37814;
const $e97a97f0b0cf48c9$export$c79eeabbf53313e9 = 37815;
const $e97a97f0b0cf48c9$export$443cf6567cdd6424 = 37816;
const $e97a97f0b0cf48c9$export$6573984fc9840780 = 37817;
const $e97a97f0b0cf48c9$export$e7aee563f30091de = 37818;
const $e97a97f0b0cf48c9$export$2eb8634622ddeab7 = 37819;
const $e97a97f0b0cf48c9$export$202b1ce7b5d25742 = 37820;
const $e97a97f0b0cf48c9$export$18ab77abd087e467 = 37821;
const $e97a97f0b0cf48c9$export$ce40b115e188bc81 = 36492;
const $e97a97f0b0cf48c9$export$d62fdc9d1b1cccad = 2200;
const $e97a97f0b0cf48c9$export$dfaf4422ce096e29 = 2201;
const $e97a97f0b0cf48c9$export$f8f6f2041b78e210 = 2202;
const $e97a97f0b0cf48c9$export$995b32462a65e855 = 2300;
const $e97a97f0b0cf48c9$export$30fac1aace31cf4d = 2301;
const $e97a97f0b0cf48c9$export$198b11ff4c72bb30 = 2302;
const $e97a97f0b0cf48c9$export$7f795934b84ab523 = 2400;
const $e97a97f0b0cf48c9$export$24a4ccb5099273b5 = 2401;
const $e97a97f0b0cf48c9$export$8e8c3ecdcd8e1fee = 2402;
const $e97a97f0b0cf48c9$export$bcfbbdcf8de7f8cd = 2500;
const $e97a97f0b0cf48c9$export$d875e029ef558d3 = 2501;
const $e97a97f0b0cf48c9$export$4c28c87c2dc84758 = 0;
const $e97a97f0b0cf48c9$export$b23a071aa286eb29 = 1;
const $e97a97f0b0cf48c9$export$f0d8293634f88842 = 2;
const $e97a97f0b0cf48c9$export$7207336e4151a112 = 3000;
const $e97a97f0b0cf48c9$export$f32388edbb32674 = 3001;
const $e97a97f0b0cf48c9$export$deeb383078690b50 = 3200;
const $e97a97f0b0cf48c9$export$8f910f4c4f73df11 = 3201;
const $e97a97f0b0cf48c9$export$2852a58ebdac27b8 = 0;
const $e97a97f0b0cf48c9$export$9990ad26f9db5b2c = 1;
const $e97a97f0b0cf48c9$export$69433f11f42d5527 = 0;
const $e97a97f0b0cf48c9$export$9f542ae4b5baca34 = 7680;
const $e97a97f0b0cf48c9$export$8a4f28336ef203d3 = 7681;
const $e97a97f0b0cf48c9$export$2928c0231297c036 = 7682;
const $e97a97f0b0cf48c9$export$c0e9611c8a15f9a8 = 7683;
const $e97a97f0b0cf48c9$export$9c2c08927385dcc4 = 34055;
const $e97a97f0b0cf48c9$export$7c74ea00fa1315e6 = 34056;
const $e97a97f0b0cf48c9$export$22e2e5726612443 = 5386;
const $e97a97f0b0cf48c9$export$1343870698229224 = 512;
const $e97a97f0b0cf48c9$export$8e1d8ed281997fa6 = 513;
const $e97a97f0b0cf48c9$export$55648a1cde8329a7 = 514;
const $e97a97f0b0cf48c9$export$2dff107857e6aca2 = 515;
const $e97a97f0b0cf48c9$export$6f93765ab2f451a2 = 516;
const $e97a97f0b0cf48c9$export$6f3fb2d2440f2b76 = 517;
const $e97a97f0b0cf48c9$export$4119cf7b4c98fd5a = 518;
const $e97a97f0b0cf48c9$export$14cf96713ddd97a8 = 519;
const $e97a97f0b0cf48c9$export$763e8360f4d7f77d = 35044;
const $e97a97f0b0cf48c9$export$8505d14ac8546ca = 35048;
const $e97a97f0b0cf48c9$export$721e63549e51d81e = 35040;
const $e97a97f0b0cf48c9$export$415731dc4f48e299 = 35045;
const $e97a97f0b0cf48c9$export$9e809946455f13bc = 35049;
const $e97a97f0b0cf48c9$export$2ed9499a35b5f832 = 35041;
const $e97a97f0b0cf48c9$export$32ab2503ea19469a = 35046;
const $e97a97f0b0cf48c9$export$ab4022c2c3f86315 = 35050;
const $e97a97f0b0cf48c9$export$ba7f1db36a76a970 = 35042;
const $e97a97f0b0cf48c9$export$43600cc67fabd9f = "100";
const $e97a97f0b0cf48c9$export$f63012db5506e7dd = "300 es";
const $e97a97f0b0cf48c9$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $e97a97f0b0cf48c9$var$_lut = [];
for(let i = 0; i < 256; i++)$e97a97f0b0cf48c9$var$_lut[i] = (i < 16 ? "0" : "") + i.toString(16);
let $e97a97f0b0cf48c9$var$_seed = 1234567;
const $e97a97f0b0cf48c9$var$DEG2RAD = Math.PI / 180;
const $e97a97f0b0cf48c9$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $e97a97f0b0cf48c9$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $e97a97f0b0cf48c9$var$_lut[d0 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d0 >> 8 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d0 >> 16 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d0 >> 24 & 0xff] + "-" + $e97a97f0b0cf48c9$var$_lut[d1 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d1 >> 8 & 0xff] + "-" + $e97a97f0b0cf48c9$var$_lut[d1 >> 16 & 0x0f | 0x40] + $e97a97f0b0cf48c9$var$_lut[d1 >> 24 & 0xff] + "-" + $e97a97f0b0cf48c9$var$_lut[d2 & 0x3f | 0x80] + $e97a97f0b0cf48c9$var$_lut[d2 >> 8 & 0xff] + "-" + $e97a97f0b0cf48c9$var$_lut[d2 >> 16 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d2 >> 24 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d3 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d3 >> 8 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d3 >> 16 & 0xff] + $e97a97f0b0cf48c9$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
function $e97a97f0b0cf48c9$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidian modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $e97a97f0b0cf48c9$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $e97a97f0b0cf48c9$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $e97a97f0b0cf48c9$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $e97a97f0b0cf48c9$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $e97a97f0b0cf48c9$var$damp(x, y, lambda, dt) {
    return $e97a97f0b0cf48c9$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $e97a97f0b0cf48c9$var$pingpong(x, length = 1) {
    return length - Math.abs($e97a97f0b0cf48c9$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $e97a97f0b0cf48c9$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $e97a97f0b0cf48c9$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $e97a97f0b0cf48c9$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $e97a97f0b0cf48c9$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $e97a97f0b0cf48c9$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $e97a97f0b0cf48c9$var$seededRandom(s) {
    if (s !== undefined) $e97a97f0b0cf48c9$var$_seed = s % 2147483647;
    // Park-Miller algorithm
    $e97a97f0b0cf48c9$var$_seed = $e97a97f0b0cf48c9$var$_seed * 16807 % 2147483647;
    return ($e97a97f0b0cf48c9$var$_seed - 1) / 2147483646;
}
function $e97a97f0b0cf48c9$var$degToRad(degrees) {
    return degrees * $e97a97f0b0cf48c9$var$DEG2RAD;
}
function $e97a97f0b0cf48c9$var$radToDeg(radians) {
    return radians * $e97a97f0b0cf48c9$var$RAD2DEG;
}
function $e97a97f0b0cf48c9$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $e97a97f0b0cf48c9$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $e97a97f0b0cf48c9$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $e97a97f0b0cf48c9$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
var $e97a97f0b0cf48c9$export$380958644dbbc22b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $e97a97f0b0cf48c9$var$DEG2RAD,
    RAD2DEG: $e97a97f0b0cf48c9$var$RAD2DEG,
    generateUUID: $e97a97f0b0cf48c9$var$generateUUID,
    clamp: $e97a97f0b0cf48c9$var$clamp,
    euclideanModulo: $e97a97f0b0cf48c9$var$euclideanModulo,
    mapLinear: $e97a97f0b0cf48c9$var$mapLinear,
    inverseLerp: $e97a97f0b0cf48c9$var$inverseLerp,
    lerp: $e97a97f0b0cf48c9$var$lerp,
    damp: $e97a97f0b0cf48c9$var$damp,
    pingpong: $e97a97f0b0cf48c9$var$pingpong,
    smoothstep: $e97a97f0b0cf48c9$var$smoothstep,
    smootherstep: $e97a97f0b0cf48c9$var$smootherstep,
    randInt: $e97a97f0b0cf48c9$var$randInt,
    randFloat: $e97a97f0b0cf48c9$var$randFloat,
    randFloatSpread: $e97a97f0b0cf48c9$var$randFloatSpread,
    seededRandom: $e97a97f0b0cf48c9$var$seededRandom,
    degToRad: $e97a97f0b0cf48c9$var$degToRad,
    radToDeg: $e97a97f0b0cf48c9$var$radToDeg,
    isPowerOfTwo: $e97a97f0b0cf48c9$var$isPowerOfTwo,
    ceilPowerOfTwo: $e97a97f0b0cf48c9$var$ceilPowerOfTwo,
    floorPowerOfTwo: $e97a97f0b0cf48c9$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $e97a97f0b0cf48c9$var$setQuaternionFromProperEuler
});
class $e97a97f0b0cf48c9$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
$e97a97f0b0cf48c9$export$c977b3e384af9ae1.prototype.isVector2 = true;
class $e97a97f0b0cf48c9$export$8ff26dafa08918 {
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
$e97a97f0b0cf48c9$export$8ff26dafa08918.prototype.isMatrix3 = true;
function $e97a97f0b0cf48c9$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] > 65535) return true;
    }
    return false;
}
const $e97a97f0b0cf48c9$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $e97a97f0b0cf48c9$var$getTypedArray(type, buffer) {
    return new $e97a97f0b0cf48c9$var$TYPED_ARRAYS[type](buffer);
}
function $e97a97f0b0cf48c9$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
const $e97a97f0b0cf48c9$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $e97a97f0b0cf48c9$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $e97a97f0b0cf48c9$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $e97a97f0b0cf48c9$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $e97a97f0b0cf48c9$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $e97a97f0b0cf48c9$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
class $e97a97f0b0cf48c9$export$892596cec99bc70e {
    constructor(r, g, b){
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === "number") this.setHex(value);
        else if (typeof value === "string") this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        return this;
    }
    setRGB(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
        return this;
    }
    setHSL(h, s, l) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $e97a97f0b0cf48c9$var$euclideanModulo(h, 1);
        s = $e97a97f0b0cf48c9$var$clamp(s, 0, 1);
        l = $e97a97f0b0cf48c9$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $e97a97f0b0cf48c9$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $e97a97f0b0cf48c9$var$hue2rgb(q, p, h);
            this.b = $e97a97f0b0cf48c9$var$hue2rgb(q, p, h - 1 / 3);
        }
        return this;
    }
    setStyle(style) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseInt(color[2], 10) / 100;
                        const l = parseInt(color[3], 10) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style);
        return this;
    }
    setColorName(style) {
        // color keywords
        const hex = $e97a97f0b0cf48c9$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $e97a97f0b0cf48c9$var$SRGBToLinear(color.r);
        this.g = $e97a97f0b0cf48c9$var$SRGBToLinear(color.g);
        this.b = $e97a97f0b0cf48c9$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $e97a97f0b0cf48c9$var$LinearToSRGB(color.r);
        this.g = $e97a97f0b0cf48c9$var$LinearToSRGB(color.g);
        this.b = $e97a97f0b0cf48c9$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex() {
        return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
    }
    getHexString() {
        return ("000000" + this.getHex().toString(16)).slice(-6);
    }
    getHSL(target) {
        // h,s,l ranges are in 0.0 - 1.0
        const r = this.r, g = this.g, b = this.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getStyle() {
        return "rgb(" + (this.r * 255 | 0) + "," + (this.g * 255 | 0) + "," + (this.b * 255 | 0) + ")";
    }
    offsetHSL(h, s, l) {
        this.getHSL($e97a97f0b0cf48c9$var$_hslA);
        $e97a97f0b0cf48c9$var$_hslA.h += h;
        $e97a97f0b0cf48c9$var$_hslA.s += s;
        $e97a97f0b0cf48c9$var$_hslA.l += l;
        this.setHSL($e97a97f0b0cf48c9$var$_hslA.h, $e97a97f0b0cf48c9$var$_hslA.s, $e97a97f0b0cf48c9$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($e97a97f0b0cf48c9$var$_hslA);
        color.getHSL($e97a97f0b0cf48c9$var$_hslB);
        const h = $e97a97f0b0cf48c9$var$lerp($e97a97f0b0cf48c9$var$_hslA.h, $e97a97f0b0cf48c9$var$_hslB.h, alpha);
        const s = $e97a97f0b0cf48c9$var$lerp($e97a97f0b0cf48c9$var$_hslA.s, $e97a97f0b0cf48c9$var$_hslB.s, alpha);
        const l = $e97a97f0b0cf48c9$var$lerp($e97a97f0b0cf48c9$var$_hslA.l, $e97a97f0b0cf48c9$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        if (attribute.normalized === true) {
            // assuming Uint8Array
            this.r /= 255;
            this.g /= 255;
            this.b /= 255;
        }
        return this;
    }
    toJSON() {
        return this.getHex();
    }
}
$e97a97f0b0cf48c9$export$892596cec99bc70e.NAMES = $e97a97f0b0cf48c9$var$_colorKeywords;
$e97a97f0b0cf48c9$export$892596cec99bc70e.prototype.isColor = true;
$e97a97f0b0cf48c9$export$892596cec99bc70e.prototype.r = 1;
$e97a97f0b0cf48c9$export$892596cec99bc70e.prototype.g = 1;
$e97a97f0b0cf48c9$export$892596cec99bc70e.prototype.b = 1;
let $e97a97f0b0cf48c9$var$_canvas;
class $e97a97f0b0cf48c9$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($e97a97f0b0cf48c9$var$_canvas === undefined) $e97a97f0b0cf48c9$var$_canvas = $e97a97f0b0cf48c9$var$createElementNS("canvas");
            $e97a97f0b0cf48c9$var$_canvas.width = image.width;
            $e97a97f0b0cf48c9$var$_canvas.height = image.height;
            const context = $e97a97f0b0cf48c9$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $e97a97f0b0cf48c9$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $e97a97f0b0cf48c9$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $e97a97f0b0cf48c9$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($e97a97f0b0cf48c9$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $e97a97f0b0cf48c9$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
let $e97a97f0b0cf48c9$var$textureId = 0;
class $e97a97f0b0cf48c9$export$5431306cf43de24a extends $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a {
    constructor(image = $e97a97f0b0cf48c9$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $e97a97f0b0cf48c9$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $e97a97f0b0cf48c9$export$9d9334239a5a5e06, wrapT = $e97a97f0b0cf48c9$export$9d9334239a5a5e06, magFilter = $e97a97f0b0cf48c9$export$8a72f490b25c56c8, minFilter = $e97a97f0b0cf48c9$export$5d8599b6a933fb1b, format = $e97a97f0b0cf48c9$export$3f8bb04b555a363c, type = $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10, anisotropy = 1, encoding = $e97a97f0b0cf48c9$export$7207336e4151a112){
        super();
        Object.defineProperty(this, "id", {
            value: $e97a97f0b0cf48c9$var$textureId++
        });
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
        this.name = "";
        this.image = image;
        this.mipmaps = [];
        this.mapping = mapping;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
        this.center = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $e97a97f0b0cf48c9$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        this.encoding = encoding;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.image = source.image;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (this.image !== undefined) {
            // TODO: Move to THREE.Image
            const image = this.image;
            if (image.uuid === undefined) image.uuid = $e97a97f0b0cf48c9$var$generateUUID(); // UGH
            if (!isRootObject && meta.images[image.uuid] === undefined) {
                let url;
                if (Array.isArray(image)) {
                    // process array of images e.g. CubeTexture
                    url = [];
                    for(let i = 0, l = image.length; i < l; i++)// check cube texture with data textures
                    if (image[i].isDataTexture) url.push($e97a97f0b0cf48c9$var$serializeImage(image[i].image));
                    else url.push($e97a97f0b0cf48c9$var$serializeImage(image[i]));
                } else // process single image
                url = $e97a97f0b0cf48c9$var$serializeImage(image);
                meta.images[image.uuid] = {
                    uuid: image.uuid,
                    url: url
                };
            }
            output.image = image.uuid;
        }
        if (JSON.stringify(this.userData) !== "{}") output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $e97a97f0b0cf48c9$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $e97a97f0b0cf48c9$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $e97a97f0b0cf48c9$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $e97a97f0b0cf48c9$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $e97a97f0b0cf48c9$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $e97a97f0b0cf48c9$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $e97a97f0b0cf48c9$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
$e97a97f0b0cf48c9$export$5431306cf43de24a.DEFAULT_IMAGE = undefined;
$e97a97f0b0cf48c9$export$5431306cf43de24a.DEFAULT_MAPPING = $e97a97f0b0cf48c9$export$1beec6768cbb3d2d;
$e97a97f0b0cf48c9$export$5431306cf43de24a.prototype.isTexture = true;
function $e97a97f0b0cf48c9$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $e97a97f0b0cf48c9$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.prototype.slice.call(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
class $e97a97f0b0cf48c9$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
$e97a97f0b0cf48c9$export$fa7daccca11cdbe3.prototype.isVector4 = true;
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $e97a97f0b0cf48c9$export$3c052beb2e51e23f extends $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a {
    constructor(width, height, options = {}){
        super();
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(0, 0, width, height);
        this.texture = new $e97a97f0b0cf48c9$export$5431306cf43de24a(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.isRenderTargetTexture = true;
        this.texture.image = {
            width: width,
            height: height,
            depth: 1
        };
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
    }
    setTexture(texture) {
        texture.image = {
            width: this.width,
            height: this.height,
            depth: this.depth
        };
        this.texture = texture;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        // ensure image object is not shared, see #20328
        this.texture.image = Object.assign({}, source.texture.image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$e97a97f0b0cf48c9$export$3c052beb2e51e23f.prototype.isWebGLRenderTarget = true;
class $e97a97f0b0cf48c9$export$bd934554fb721730 extends $e97a97f0b0cf48c9$export$3c052beb2e51e23f {
    constructor(width, height, count){
        super(width, height);
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++)this.texture[i] = texture.clone();
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.set(0, 0, this.width, this.height);
        this.scissor.set(0, 0, this.width, this.height);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++)this.texture[i] = source.texture[i].clone();
        return this;
    }
}
$e97a97f0b0cf48c9$export$bd934554fb721730.prototype.isWebGLMultipleRenderTargets = true;
class $e97a97f0b0cf48c9$export$cb2022643d3c928d extends $e97a97f0b0cf48c9$export$3c052beb2e51e23f {
    constructor(width, height, options = {}){
        super(width, height, options);
        this.samples = 4;
        this.ignoreDepthForMultisampleCopy = options.ignoreDepth !== undefined ? options.ignoreDepth : true;
        this.useRenderToTexture = options.useRenderToTexture !== undefined ? options.useRenderToTexture : false;
        this.useRenderbuffer = this.useRenderToTexture === false;
    }
    copy(source) {
        super.copy.call(this, source);
        this.samples = source.samples;
        this.useRenderToTexture = source.useRenderToTexture;
        this.useRenderbuffer = source.useRenderbuffer;
        return this;
    }
}
$e97a97f0b0cf48c9$export$cb2022643d3c928d.prototype.isWebGLMultisampleRenderTarget = true;
class $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerp(qa, qb, qm, t) {
        console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.");
        return qm.slerpQuaternions(qa, qb, t);
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($e97a97f0b0cf48c9$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q, p) {
        if (p !== undefined) {
            console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.");
            return this.multiplyQuaternions(q, p);
        }
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
$e97a97f0b0cf48c9$export$23d6a54f0bbc85a3.prototype.isQuaternion = true;
class $e97a97f0b0cf48c9$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.");
            return this.multiplyVectors(v, w);
        }
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
        return this.applyQuaternion($e97a97f0b0cf48c9$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($e97a97f0b0cf48c9$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.");
            return this.crossVectors(v, w);
        }
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $e97a97f0b0cf48c9$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($e97a97f0b0cf48c9$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($e97a97f0b0cf48c9$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($e97a97f0b0cf48c9$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.isVector3 = true;
const $e97a97f0b0cf48c9$var$_vector$c = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_quaternion$4 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3();
class $e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3 {
    constructor(min = new $e97a97f0b0cf48c9$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $e97a97f0b0cf48c9$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $e97a97f0b0cf48c9$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (precise && geometry.attributes != undefined && geometry.attributes.position !== undefined) {
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count; i < l; i++){
                    $e97a97f0b0cf48c9$var$_vector$b.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                    this.expandByPoint($e97a97f0b0cf48c9$var$_vector$b);
                }
            } else {
                if (geometry.boundingBox === null) geometry.computeBoundingBox();
                $e97a97f0b0cf48c9$var$_box$3.copy(geometry.boundingBox);
                $e97a97f0b0cf48c9$var$_box$3.applyMatrix4(object.matrixWorld);
                this.union($e97a97f0b0cf48c9$var$_box$3);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $e97a97f0b0cf48c9$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $e97a97f0b0cf48c9$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($e97a97f0b0cf48c9$var$_center);
        $e97a97f0b0cf48c9$var$_extents.subVectors(this.max, $e97a97f0b0cf48c9$var$_center);
        // translate triangle to aabb origin
        $e97a97f0b0cf48c9$var$_v0$2.subVectors(triangle.a, $e97a97f0b0cf48c9$var$_center);
        $e97a97f0b0cf48c9$var$_v1$7.subVectors(triangle.b, $e97a97f0b0cf48c9$var$_center);
        $e97a97f0b0cf48c9$var$_v2$3.subVectors(triangle.c, $e97a97f0b0cf48c9$var$_center);
        // compute edge vectors for triangle
        $e97a97f0b0cf48c9$var$_f0.subVectors($e97a97f0b0cf48c9$var$_v1$7, $e97a97f0b0cf48c9$var$_v0$2);
        $e97a97f0b0cf48c9$var$_f1.subVectors($e97a97f0b0cf48c9$var$_v2$3, $e97a97f0b0cf48c9$var$_v1$7);
        $e97a97f0b0cf48c9$var$_f2.subVectors($e97a97f0b0cf48c9$var$_v0$2, $e97a97f0b0cf48c9$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$e97a97f0b0cf48c9$var$_f0.z,
            $e97a97f0b0cf48c9$var$_f0.y,
            0,
            -$e97a97f0b0cf48c9$var$_f1.z,
            $e97a97f0b0cf48c9$var$_f1.y,
            0,
            -$e97a97f0b0cf48c9$var$_f2.z,
            $e97a97f0b0cf48c9$var$_f2.y,
            $e97a97f0b0cf48c9$var$_f0.z,
            0,
            -$e97a97f0b0cf48c9$var$_f0.x,
            $e97a97f0b0cf48c9$var$_f1.z,
            0,
            -$e97a97f0b0cf48c9$var$_f1.x,
            $e97a97f0b0cf48c9$var$_f2.z,
            0,
            -$e97a97f0b0cf48c9$var$_f2.x,
            -$e97a97f0b0cf48c9$var$_f0.y,
            $e97a97f0b0cf48c9$var$_f0.x,
            0,
            -$e97a97f0b0cf48c9$var$_f1.y,
            $e97a97f0b0cf48c9$var$_f1.x,
            0,
            -$e97a97f0b0cf48c9$var$_f2.y,
            $e97a97f0b0cf48c9$var$_f2.x,
            0
        ];
        if (!$e97a97f0b0cf48c9$var$satForAxes(axes, $e97a97f0b0cf48c9$var$_v0$2, $e97a97f0b0cf48c9$var$_v1$7, $e97a97f0b0cf48c9$var$_v2$3, $e97a97f0b0cf48c9$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$e97a97f0b0cf48c9$var$satForAxes(axes, $e97a97f0b0cf48c9$var$_v0$2, $e97a97f0b0cf48c9$var$_v1$7, $e97a97f0b0cf48c9$var$_v2$3, $e97a97f0b0cf48c9$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $e97a97f0b0cf48c9$var$_triangleNormal.crossVectors($e97a97f0b0cf48c9$var$_f0, $e97a97f0b0cf48c9$var$_f1);
        axes = [
            $e97a97f0b0cf48c9$var$_triangleNormal.x,
            $e97a97f0b0cf48c9$var$_triangleNormal.y,
            $e97a97f0b0cf48c9$var$_triangleNormal.z
        ];
        return $e97a97f0b0cf48c9$var$satForAxes(axes, $e97a97f0b0cf48c9$var$_v0$2, $e97a97f0b0cf48c9$var$_v1$7, $e97a97f0b0cf48c9$var$_v2$3, $e97a97f0b0cf48c9$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $e97a97f0b0cf48c9$var$_vector$b.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        this.getCenter(target.center);
        target.radius = this.getSize($e97a97f0b0cf48c9$var$_vector$b).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $e97a97f0b0cf48c9$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $e97a97f0b0cf48c9$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $e97a97f0b0cf48c9$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $e97a97f0b0cf48c9$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $e97a97f0b0cf48c9$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $e97a97f0b0cf48c9$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $e97a97f0b0cf48c9$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $e97a97f0b0cf48c9$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($e97a97f0b0cf48c9$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
$e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3.prototype.isBox3 = true;
const $e97a97f0b0cf48c9$var$_points = [
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699()
];
const $e97a97f0b0cf48c9$var$_vector$b = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_box$3 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $e97a97f0b0cf48c9$var$_v0$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v1$7 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v2$3 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
// triangle edge vectors
const $e97a97f0b0cf48c9$var$_f0 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_f1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_f2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_center = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_extents = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_triangleNormal = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_testAxis = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
function $e97a97f0b0cf48c9$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $e97a97f0b0cf48c9$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the seperating axis
        const r = extents.x * Math.abs($e97a97f0b0cf48c9$var$_testAxis.x) + extents.y * Math.abs($e97a97f0b0cf48c9$var$_testAxis.y) + extents.z * Math.abs($e97a97f0b0cf48c9$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the seperating axis
        const p0 = v0.dot($e97a97f0b0cf48c9$var$_testAxis);
        const p1 = v1.dot($e97a97f0b0cf48c9$var$_testAxis);
        const p2 = v2.dot($e97a97f0b0cf48c9$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is seperating and we can exit
        return false;
    }
    return true;
}
const $e97a97f0b0cf48c9$var$_box$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3();
const $e97a97f0b0cf48c9$var$_v1$6 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_toFarthestPoint = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_toPoint = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$805e8b72413ccaba {
    constructor(center = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $e97a97f0b0cf48c9$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
        $e97a97f0b0cf48c9$var$_toPoint.subVectors(point, this.center);
        const lengthSq = $e97a97f0b0cf48c9$var$_toPoint.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            const length = Math.sqrt(lengthSq);
            const missingRadiusHalf = (length - this.radius) * 0.5;
            // Nudge this sphere towards the target point. Add half the missing distance to radius,
            // and the other half to position. This gives a tighter enclosure, instead of if
            // the whole missing distance were just added to radius.
            this.center.add($e97a97f0b0cf48c9$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
            this.radius += missingRadiusHalf;
        }
        return this;
    }
    union(sphere) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
        // To enclose another sphere into this sphere, we only need to enclose two points:
        // 1) Enclose the farthest point on the other sphere into this sphere.
        // 2) Enclose the opposite point of the farthest point into this sphere.
        if (this.center.equals(sphere.center) === true) $e97a97f0b0cf48c9$var$_toFarthestPoint.set(0, 0, 1).multiplyScalar(sphere.radius);
        else $e97a97f0b0cf48c9$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
        this.expandByPoint($e97a97f0b0cf48c9$var$_v1$6.copy(sphere.center).add($e97a97f0b0cf48c9$var$_toFarthestPoint));
        this.expandByPoint($e97a97f0b0cf48c9$var$_v1$6.copy(sphere.center).sub($e97a97f0b0cf48c9$var$_toFarthestPoint));
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $e97a97f0b0cf48c9$var$_vector$a = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_segCenter = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_segDir = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_diff = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_edge1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_edge2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_normal$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$a186db52eed6d40e {
    constructor(origin = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), direction = new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $e97a97f0b0cf48c9$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $e97a97f0b0cf48c9$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $e97a97f0b0cf48c9$var$_vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return $e97a97f0b0cf48c9$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $e97a97f0b0cf48c9$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $e97a97f0b0cf48c9$var$_segDir.copy(v1).sub(v0).normalize();
        $e97a97f0b0cf48c9$var$_diff.copy(this.origin).sub($e97a97f0b0cf48c9$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($e97a97f0b0cf48c9$var$_segDir);
        const b0 = $e97a97f0b0cf48c9$var$_diff.dot(this.direction);
        const b1 = -$e97a97f0b0cf48c9$var$_diff.dot($e97a97f0b0cf48c9$var$_segDir);
        const c = $e97a97f0b0cf48c9$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($e97a97f0b0cf48c9$var$_segDir).multiplyScalar(s1).add($e97a97f0b0cf48c9$var$_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $e97a97f0b0cf48c9$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $e97a97f0b0cf48c9$var$_vector$a.dot(this.direction);
        const d2 = $e97a97f0b0cf48c9$var$_vector$a.dot($e97a97f0b0cf48c9$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $e97a97f0b0cf48c9$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $e97a97f0b0cf48c9$var$_edge1.subVectors(b, a);
        $e97a97f0b0cf48c9$var$_edge2.subVectors(c, a);
        $e97a97f0b0cf48c9$var$_normal$1.crossVectors($e97a97f0b0cf48c9$var$_edge1, $e97a97f0b0cf48c9$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($e97a97f0b0cf48c9$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $e97a97f0b0cf48c9$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($e97a97f0b0cf48c9$var$_edge2.crossVectors($e97a97f0b0cf48c9$var$_diff, $e97a97f0b0cf48c9$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($e97a97f0b0cf48c9$var$_edge1.cross($e97a97f0b0cf48c9$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $e97a97f0b0cf48c9$var$_diff.dot($e97a97f0b0cf48c9$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $e97a97f0b0cf48c9$export$2ae72fc923e5eb5 {
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $e97a97f0b0cf48c9$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $e97a97f0b0cf48c9$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $e97a97f0b0cf48c9$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($e97a97f0b0cf48c9$var$_zero, q, $e97a97f0b0cf48c9$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $e97a97f0b0cf48c9$var$_z.subVectors(eye, target);
        if ($e97a97f0b0cf48c9$var$_z.lengthSq() === 0) // eye and target are in the same position
        $e97a97f0b0cf48c9$var$_z.z = 1;
        $e97a97f0b0cf48c9$var$_z.normalize();
        $e97a97f0b0cf48c9$var$_x.crossVectors(up, $e97a97f0b0cf48c9$var$_z);
        if ($e97a97f0b0cf48c9$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $e97a97f0b0cf48c9$var$_z.x += 0.0001;
            else $e97a97f0b0cf48c9$var$_z.z += 0.0001;
            $e97a97f0b0cf48c9$var$_z.normalize();
            $e97a97f0b0cf48c9$var$_x.crossVectors(up, $e97a97f0b0cf48c9$var$_z);
        }
        $e97a97f0b0cf48c9$var$_x.normalize();
        $e97a97f0b0cf48c9$var$_y.crossVectors($e97a97f0b0cf48c9$var$_z, $e97a97f0b0cf48c9$var$_x);
        te[0] = $e97a97f0b0cf48c9$var$_x.x;
        te[4] = $e97a97f0b0cf48c9$var$_y.x;
        te[8] = $e97a97f0b0cf48c9$var$_z.x;
        te[1] = $e97a97f0b0cf48c9$var$_x.y;
        te[5] = $e97a97f0b0cf48c9$var$_y.y;
        te[9] = $e97a97f0b0cf48c9$var$_z.y;
        te[2] = $e97a97f0b0cf48c9$var$_x.z;
        te[6] = $e97a97f0b0cf48c9$var$_y.z;
        te[10] = $e97a97f0b0cf48c9$var$_z.z;
        return this;
    }
    multiply(m, n) {
        if (n !== undefined) {
            console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.");
            return this.multiplyMatrices(m, n);
        }
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $e97a97f0b0cf48c9$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $e97a97f0b0cf48c9$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $e97a97f0b0cf48c9$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $e97a97f0b0cf48c9$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $e97a97f0b0cf48c9$var$_m1$2.elements[0] *= invSX;
        $e97a97f0b0cf48c9$var$_m1$2.elements[1] *= invSX;
        $e97a97f0b0cf48c9$var$_m1$2.elements[2] *= invSX;
        $e97a97f0b0cf48c9$var$_m1$2.elements[4] *= invSY;
        $e97a97f0b0cf48c9$var$_m1$2.elements[5] *= invSY;
        $e97a97f0b0cf48c9$var$_m1$2.elements[6] *= invSY;
        $e97a97f0b0cf48c9$var$_m1$2.elements[8] *= invSZ;
        $e97a97f0b0cf48c9$var$_m1$2.elements[9] *= invSZ;
        $e97a97f0b0cf48c9$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($e97a97f0b0cf48c9$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        if (far === undefined) console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
const $e97a97f0b0cf48c9$var$_v1$5 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_m1$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_zero = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, 0);
const $e97a97f0b0cf48c9$var$_one = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 1, 1);
const $e97a97f0b0cf48c9$var$_x = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_y = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_z = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_matrix$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_quaternion$3 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3();
class $e97a97f0b0cf48c9$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $e97a97f0b0cf48c9$export$d93cc409a0768c5f.DefaultOrder){
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($e97a97f0b0cf48c9$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$e97a97f0b0cf48c9$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($e97a97f0b0cf48c9$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$e97a97f0b0cf48c9$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($e97a97f0b0cf48c9$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$e97a97f0b0cf48c9$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $e97a97f0b0cf48c9$var$_matrix$1.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($e97a97f0b0cf48c9$var$_matrix$1, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $e97a97f0b0cf48c9$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($e97a97f0b0cf48c9$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    toVector3(optionalResult) {
        if (optionalResult) return optionalResult.set(this._x, this._y, this._z);
        else return new $e97a97f0b0cf48c9$export$64b5c384219d3699(this._x, this._y, this._z);
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
$e97a97f0b0cf48c9$export$d93cc409a0768c5f.prototype.isEuler = true;
$e97a97f0b0cf48c9$export$d93cc409a0768c5f.DefaultOrder = "XYZ";
$e97a97f0b0cf48c9$export$d93cc409a0768c5f.RotationOrders = [
    "XYZ",
    "YZX",
    "ZXY",
    "XZY",
    "YXZ",
    "ZYX"
];
class $e97a97f0b0cf48c9$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $e97a97f0b0cf48c9$var$_object3DId = 0;
const $e97a97f0b0cf48c9$var$_v1$4 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_q1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3();
const $e97a97f0b0cf48c9$var$_m1$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_target = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_position$3 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_scale$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_quaternion$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3();
const $e97a97f0b0cf48c9$var$_xAxis = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 0, 0);
const $e97a97f0b0cf48c9$var$_yAxis = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0);
const $e97a97f0b0cf48c9$var$_zAxis = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, 1);
const $e97a97f0b0cf48c9$var$_addedEvent = {
    type: "added"
};
const $e97a97f0b0cf48c9$var$_removedEvent = {
    type: "removed"
};
class $e97a97f0b0cf48c9$export$e4dd07dff30cc924 extends $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $e97a97f0b0cf48c9$var$_object3DId++
        });
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $e97a97f0b0cf48c9$export$e4dd07dff30cc924.DefaultUp.clone();
        const position = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const rotation = new $e97a97f0b0cf48c9$export$d93cc409a0768c5f();
        const quaternion = new $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3();
        const scale = new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
            }
        });
        this.matrix = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
        this.matrixWorld = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $e97a97f0b0cf48c9$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate;
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $e97a97f0b0cf48c9$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $e97a97f0b0cf48c9$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($e97a97f0b0cf48c9$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $e97a97f0b0cf48c9$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($e97a97f0b0cf48c9$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($e97a97f0b0cf48c9$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($e97a97f0b0cf48c9$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($e97a97f0b0cf48c9$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $e97a97f0b0cf48c9$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($e97a97f0b0cf48c9$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($e97a97f0b0cf48c9$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($e97a97f0b0cf48c9$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($e97a97f0b0cf48c9$var$_zAxis, distance);
    }
    localToWorld(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        return vector.applyMatrix4($e97a97f0b0cf48c9$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $e97a97f0b0cf48c9$var$_target.copy(x);
        else $e97a97f0b0cf48c9$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $e97a97f0b0cf48c9$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $e97a97f0b0cf48c9$var$_m1$1.lookAt($e97a97f0b0cf48c9$var$_position$3, $e97a97f0b0cf48c9$var$_target, this.up);
        else $e97a97f0b0cf48c9$var$_m1$1.lookAt($e97a97f0b0cf48c9$var$_target, $e97a97f0b0cf48c9$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($e97a97f0b0cf48c9$var$_m1$1);
        if (parent) {
            $e97a97f0b0cf48c9$var$_m1$1.extractRotation(parent.matrixWorld);
            $e97a97f0b0cf48c9$var$_q1.setFromRotationMatrix($e97a97f0b0cf48c9$var$_m1$1);
            this.quaternion.premultiply($e97a97f0b0cf48c9$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($e97a97f0b0cf48c9$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($e97a97f0b0cf48c9$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($e97a97f0b0cf48c9$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $e97a97f0b0cf48c9$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $e97a97f0b0cf48c9$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($e97a97f0b0cf48c9$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($e97a97f0b0cf48c9$var$_position$3, target, $e97a97f0b0cf48c9$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($e97a97f0b0cf48c9$var$_position$3, $e97a97f0b0cf48c9$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {}
            };
            output.metadata = {
                version: 4.5,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== "{}") object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$e97a97f0b0cf48c9$export$e4dd07dff30cc924.DefaultUp = new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0);
$e97a97f0b0cf48c9$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate = true;
$e97a97f0b0cf48c9$export$e4dd07dff30cc924.prototype.isObject3D = true;
const $e97a97f0b0cf48c9$var$_v0$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v1$3 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v2$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v3$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vab = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vac = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vbc = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vap = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vbp = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vcp = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$5a465592bfe74b48 {
    constructor(a = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), b = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), c = new $e97a97f0b0cf48c9$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $e97a97f0b0cf48c9$var$_v0$1.subVectors(a, b);
        target.cross($e97a97f0b0cf48c9$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $e97a97f0b0cf48c9$var$_v0$1.subVectors(c, a);
        $e97a97f0b0cf48c9$var$_v1$3.subVectors(b, a);
        $e97a97f0b0cf48c9$var$_v2$2.subVectors(point, a);
        const dot00 = $e97a97f0b0cf48c9$var$_v0$1.dot($e97a97f0b0cf48c9$var$_v0$1);
        const dot01 = $e97a97f0b0cf48c9$var$_v0$1.dot($e97a97f0b0cf48c9$var$_v1$3);
        const dot02 = $e97a97f0b0cf48c9$var$_v0$1.dot($e97a97f0b0cf48c9$var$_v2$2);
        const dot11 = $e97a97f0b0cf48c9$var$_v1$3.dot($e97a97f0b0cf48c9$var$_v1$3);
        const dot12 = $e97a97f0b0cf48c9$var$_v1$3.dot($e97a97f0b0cf48c9$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $e97a97f0b0cf48c9$var$_v3$1);
        return $e97a97f0b0cf48c9$var$_v3$1.x >= 0 && $e97a97f0b0cf48c9$var$_v3$1.y >= 0 && $e97a97f0b0cf48c9$var$_v3$1.x + $e97a97f0b0cf48c9$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, $e97a97f0b0cf48c9$var$_v3$1);
        target.set(0, 0);
        target.addScaledVector(uv1, $e97a97f0b0cf48c9$var$_v3$1.x);
        target.addScaledVector(uv2, $e97a97f0b0cf48c9$var$_v3$1.y);
        target.addScaledVector(uv3, $e97a97f0b0cf48c9$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $e97a97f0b0cf48c9$var$_v0$1.subVectors(c, b);
        $e97a97f0b0cf48c9$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $e97a97f0b0cf48c9$var$_v0$1.cross($e97a97f0b0cf48c9$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $e97a97f0b0cf48c9$var$_v0$1.subVectors(this.c, this.b);
        $e97a97f0b0cf48c9$var$_v1$3.subVectors(this.a, this.b);
        return $e97a97f0b0cf48c9$var$_v0$1.cross($e97a97f0b0cf48c9$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $e97a97f0b0cf48c9$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $e97a97f0b0cf48c9$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return $e97a97f0b0cf48c9$export$5a465592bfe74b48.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return $e97a97f0b0cf48c9$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $e97a97f0b0cf48c9$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $e97a97f0b0cf48c9$var$_vab.subVectors(b, a);
        $e97a97f0b0cf48c9$var$_vac.subVectors(c, a);
        $e97a97f0b0cf48c9$var$_vap.subVectors(p, a);
        const d1 = $e97a97f0b0cf48c9$var$_vab.dot($e97a97f0b0cf48c9$var$_vap);
        const d2 = $e97a97f0b0cf48c9$var$_vac.dot($e97a97f0b0cf48c9$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $e97a97f0b0cf48c9$var$_vbp.subVectors(p, b);
        const d3 = $e97a97f0b0cf48c9$var$_vab.dot($e97a97f0b0cf48c9$var$_vbp);
        const d4 = $e97a97f0b0cf48c9$var$_vac.dot($e97a97f0b0cf48c9$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($e97a97f0b0cf48c9$var$_vab, v);
        }
        $e97a97f0b0cf48c9$var$_vcp.subVectors(p, c);
        const d5 = $e97a97f0b0cf48c9$var$_vab.dot($e97a97f0b0cf48c9$var$_vcp);
        const d6 = $e97a97f0b0cf48c9$var$_vac.dot($e97a97f0b0cf48c9$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($e97a97f0b0cf48c9$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $e97a97f0b0cf48c9$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($e97a97f0b0cf48c9$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($e97a97f0b0cf48c9$var$_vab, v).addScaledVector($e97a97f0b0cf48c9$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $e97a97f0b0cf48c9$var$materialId = 0;
class $e97a97f0b0cf48c9$export$a2d8b23205c25948 extends $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $e97a97f0b0cf48c9$var$materialId++
        });
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.fog = true;
        this.blending = $e97a97f0b0cf48c9$export$5b29a26d96ee6af0;
        this.side = $e97a97f0b0cf48c9$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $e97a97f0b0cf48c9$export$d5773124e86cf28c;
        this.blendDst = $e97a97f0b0cf48c9$export$11d468cc7f19e971;
        this.blendEquation = $e97a97f0b0cf48c9$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $e97a97f0b0cf48c9$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $e97a97f0b0cf48c9$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $e97a97f0b0cf48c9$export$9f542ae4b5baca34;
        this.stencilZFail = $e97a97f0b0cf48c9$export$9f542ae4b5baca34;
        this.stencilZPass = $e97a97f0b0cf48c9$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn("THREE.Material: '" + key + "' parameter is undefined.");
                continue;
            }
            // for backward compatability if shading is set in the constructor
            if (key === "shading") {
                console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
                this.flatShading = newValue === $e97a97f0b0cf48c9$export$a62047d29c96d8ff ? true : false;
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn("THREE." + this.type + ": '" + key + "' is not a property of this material.");
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRoot = meta === undefined || typeof meta === "string";
        if (isRoot) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $e97a97f0b0cf48c9$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $e97a97f0b0cf48c9$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (JSON.stringify(this.userData) !== "{}") data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.fog = source.fog;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
$e97a97f0b0cf48c9$export$a2d8b23205c25948.prototype.isMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 * }
 */ class $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5 extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshBasicMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $e97a97f0b0cf48c9$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        return this;
    }
}
$e97a97f0b0cf48c9$export$55cbcc9b622fe1f5.prototype.isMeshBasicMaterial = true;
const $e97a97f0b0cf48c9$var$_vector$9 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vector2$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
class $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized === true;
        this.usage = $e97a97f0b0cf48c9$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    copyColorsArray(colors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = colors.length; i < l; i++){
            let color = colors[i];
            if (color === undefined) {
                console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", i);
                color = new $e97a97f0b0cf48c9$export$892596cec99bc70e();
            }
            array[offset++] = color.r;
            array[offset++] = color.g;
            array[offset++] = color.b;
        }
        return this;
    }
    copyVector2sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", i);
                vector = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
        }
        return this;
    }
    copyVector3sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", i);
                vector = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
        }
        return this;
    }
    copyVector4sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", i);
                vector = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
            array[offset++] = vector.w;
        }
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $e97a97f0b0cf48c9$var$_vector2$1.fromBufferAttribute(this, i);
            $e97a97f0b0cf48c9$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $e97a97f0b0cf48c9$var$_vector2$1.x, $e97a97f0b0cf48c9$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $e97a97f0b0cf48c9$var$_vector$9.fromBufferAttribute(this, i);
            $e97a97f0b0cf48c9$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $e97a97f0b0cf48c9$var$_vector$9.x, $e97a97f0b0cf48c9$var$_vector$9.y, $e97a97f0b0cf48c9$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e97a97f0b0cf48c9$var$_vector$9.x = this.getX(i);
            $e97a97f0b0cf48c9$var$_vector$9.y = this.getY(i);
            $e97a97f0b0cf48c9$var$_vector$9.z = this.getZ(i);
            $e97a97f0b0cf48c9$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $e97a97f0b0cf48c9$var$_vector$9.x, $e97a97f0b0cf48c9$var$_vector$9.y, $e97a97f0b0cf48c9$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e97a97f0b0cf48c9$var$_vector$9.x = this.getX(i);
            $e97a97f0b0cf48c9$var$_vector$9.y = this.getY(i);
            $e97a97f0b0cf48c9$var$_vector$9.z = this.getZ(i);
            $e97a97f0b0cf48c9$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $e97a97f0b0cf48c9$var$_vector$9.x, $e97a97f0b0cf48c9$var$_vector$9.y, $e97a97f0b0cf48c9$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e97a97f0b0cf48c9$var$_vector$9.x = this.getX(i);
            $e97a97f0b0cf48c9$var$_vector$9.y = this.getY(i);
            $e97a97f0b0cf48c9$var$_vector$9.z = this.getZ(i);
            $e97a97f0b0cf48c9$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $e97a97f0b0cf48c9$var$_vector$9.x, $e97a97f0b0cf48c9$var$_vector$9.y, $e97a97f0b0cf48c9$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        return this.array[index * this.itemSize];
    }
    setX(index, x) {
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        return this.array[index * this.itemSize + 1];
    }
    setY(index, y) {
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        return this.array[index * this.itemSize + 2];
    }
    setZ(index, z) {
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        return this.array[index * this.itemSize + 3];
    }
    setW(index, w) {
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.prototype.slice.call(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $e97a97f0b0cf48c9$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
$e97a97f0b0cf48c9$export$8dea267bd6bde117.prototype.isBufferAttribute = true;
//
class $e97a97f0b0cf48c9$export$f9ff2d6a20248cbf extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $e97a97f0b0cf48c9$export$cacc90cf35d11cdd extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $e97a97f0b0cf48c9$export$baaa85a1a812c157 extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $e97a97f0b0cf48c9$export$2b755a102ccdcefe extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $e97a97f0b0cf48c9$export$640a853f68025f2e extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $e97a97f0b0cf48c9$export$46b369aed2968a0a extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $e97a97f0b0cf48c9$export$7eb8c9fa25cd5bd6 extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $e97a97f0b0cf48c9$export$dbd3698c64958d69 extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
$e97a97f0b0cf48c9$export$dbd3698c64958d69.prototype.isFloat16BufferAttribute = true;
class $e97a97f0b0cf48c9$export$cbe7a62641830ebd extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $e97a97f0b0cf48c9$export$9e0ade74842adbb8 extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $e97a97f0b0cf48c9$var$_id$1 = 0;
const $e97a97f0b0cf48c9$var$_m1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_obj = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$e4dd07dff30cc924();
const $e97a97f0b0cf48c9$var$_offset = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_box$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3();
const $e97a97f0b0cf48c9$var$_boxMorphTargets = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3();
const $e97a97f0b0cf48c9$var$_vector$8 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$b7be63a67df8959 extends $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        Object.defineProperty(this, "id", {
            value: $e97a97f0b0cf48c9$var$_id$1++
        });
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($e97a97f0b0cf48c9$var$arrayNeedsUint32(index) ? $e97a97f0b0cf48c9$export$7eb8c9fa25cd5bd6 : $e97a97f0b0cf48c9$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $e97a97f0b0cf48c9$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $e97a97f0b0cf48c9$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($e97a97f0b0cf48c9$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $e97a97f0b0cf48c9$var$_m1.makeRotationX(angle);
        this.applyMatrix4($e97a97f0b0cf48c9$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $e97a97f0b0cf48c9$var$_m1.makeRotationY(angle);
        this.applyMatrix4($e97a97f0b0cf48c9$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $e97a97f0b0cf48c9$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($e97a97f0b0cf48c9$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $e97a97f0b0cf48c9$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($e97a97f0b0cf48c9$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $e97a97f0b0cf48c9$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($e97a97f0b0cf48c9$var$_m1);
        return this;
    }
    lookAt(vector) {
        $e97a97f0b0cf48c9$var$_obj.lookAt(vector);
        $e97a97f0b0cf48c9$var$_obj.updateMatrix();
        this.applyMatrix4($e97a97f0b0cf48c9$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($e97a97f0b0cf48c9$var$_offset).negate();
        this.translate($e97a97f0b0cf48c9$var$_offset.x, $e97a97f0b0cf48c9$var$_offset.y, $e97a97f0b0cf48c9$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $e97a97f0b0cf48c9$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $e97a97f0b0cf48c9$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $e97a97f0b0cf48c9$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $e97a97f0b0cf48c9$var$_vector$8.addVectors(this.boundingBox.min, $e97a97f0b0cf48c9$var$_box$1.min);
                    this.boundingBox.expandByPoint($e97a97f0b0cf48c9$var$_vector$8);
                    $e97a97f0b0cf48c9$var$_vector$8.addVectors(this.boundingBox.max, $e97a97f0b0cf48c9$var$_box$1.max);
                    this.boundingBox.expandByPoint($e97a97f0b0cf48c9$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($e97a97f0b0cf48c9$var$_box$1.min);
                    this.boundingBox.expandByPoint($e97a97f0b0cf48c9$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $e97a97f0b0cf48c9$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $e97a97f0b0cf48c9$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $e97a97f0b0cf48c9$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $e97a97f0b0cf48c9$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $e97a97f0b0cf48c9$var$_vector$8.addVectors($e97a97f0b0cf48c9$var$_box$1.min, $e97a97f0b0cf48c9$var$_boxMorphTargets.min);
                    $e97a97f0b0cf48c9$var$_box$1.expandByPoint($e97a97f0b0cf48c9$var$_vector$8);
                    $e97a97f0b0cf48c9$var$_vector$8.addVectors($e97a97f0b0cf48c9$var$_box$1.max, $e97a97f0b0cf48c9$var$_boxMorphTargets.max);
                    $e97a97f0b0cf48c9$var$_box$1.expandByPoint($e97a97f0b0cf48c9$var$_vector$8);
                } else {
                    $e97a97f0b0cf48c9$var$_box$1.expandByPoint($e97a97f0b0cf48c9$var$_boxMorphTargets.min);
                    $e97a97f0b0cf48c9$var$_box$1.expandByPoint($e97a97f0b0cf48c9$var$_boxMorphTargets.max);
                }
            }
            $e97a97f0b0cf48c9$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $e97a97f0b0cf48c9$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($e97a97f0b0cf48c9$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $e97a97f0b0cf48c9$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $e97a97f0b0cf48c9$var$_offset.fromBufferAttribute(position, j);
                        $e97a97f0b0cf48c9$var$_vector$8.add($e97a97f0b0cf48c9$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($e97a97f0b0cf48c9$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (attributes.tangent === undefined) this.setAttribute("tangent", new $e97a97f0b0cf48c9$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = attributes.tangent.array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            tan2[i] = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        }
        const vA = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), vB = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), vC = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), uvA = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), uvB = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), uvC = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), sdir = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), tdir = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), tmp2 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const n = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), n2 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $e97a97f0b0cf48c9$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), pB = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), pC = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const nA = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), nB = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), nC = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const cb = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), ab = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge(geometry, offset) {
        if (!(geometry && geometry.isBufferGeometry)) {
            console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", geometry);
            return;
        }
        if (offset === undefined) {
            offset = 0;
            console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
        }
        const attributes = this.attributes;
        for(const key in attributes){
            if (geometry.attributes[key] === undefined) continue;
            const attribute1 = attributes[key];
            const attributeArray1 = attribute1.array;
            const attribute2 = geometry.attributes[key];
            const attributeArray2 = attribute2.array;
            const attributeOffset = attribute2.itemSize * offset;
            const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
            for(let i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
        }
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $e97a97f0b0cf48c9$var$_vector$8.fromBufferAttribute(normals, i);
            $e97a97f0b0cf48c9$var$_vector$8.normalize();
            normals.setXYZ(i, $e97a97f0b0cf48c9$var$_vector$8.x, $e97a97f0b0cf48c9$var$_vector$8.y, $e97a97f0b0cf48c9$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $e97a97f0b0cf48c9$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        // geometry generator parameters
        if (source.parameters !== undefined) this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$e97a97f0b0cf48c9$export$b7be63a67df8959.prototype.isBufferGeometry = true;
const $e97a97f0b0cf48c9$var$_inverseMatrix$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_ray$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$a186db52eed6d40e();
const $e97a97f0b0cf48c9$var$_sphere$3 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$805e8b72413ccaba();
const $e97a97f0b0cf48c9$var$_vA$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vB$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vC$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_tempA = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_tempB = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_tempC = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_morphA = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_morphB = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_morphC = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_uvA$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
const $e97a97f0b0cf48c9$var$_uvB$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
const $e97a97f0b0cf48c9$var$_uvC$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
const $e97a97f0b0cf48c9$var$_intersectionPoint = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_intersectionPointWorld = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$e176487c05830cc5 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959(), material = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5()){
        super();
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $e97a97f0b0cf48c9$var$_sphere$3.copy(geometry.boundingSphere);
        $e97a97f0b0cf48c9$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($e97a97f0b0cf48c9$var$_sphere$3) === false) return;
        //
        $e97a97f0b0cf48c9$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $e97a97f0b0cf48c9$var$_ray$2.copy(raycaster.ray).applyMatrix4($e97a97f0b0cf48c9$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($e97a97f0b0cf48c9$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const position = geometry.attributes.position;
            const morphPosition = geometry.morphAttributes.position;
            const morphTargetsRelative = geometry.morphTargetsRelative;
            const uv = geometry.attributes.uv;
            const uv2 = geometry.attributes.uv2;
            const groups = geometry.groups;
            const drawRange = geometry.drawRange;
            if (index !== null) {
                // indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = index.getX(j);
                        const b = index.getX(j + 1);
                        const c = index.getX(j + 2);
                        intersection = $e97a97f0b0cf48c9$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $e97a97f0b0cf48c9$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = index.getX(i);
                        const b = index.getX(i + 1);
                        const c = index.getX(i + 2);
                        intersection = $e97a97f0b0cf48c9$var$checkBufferGeometryIntersection(this, material, raycaster, $e97a97f0b0cf48c9$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            } else if (position !== undefined) {
                // non-indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = j;
                        const b = j + 1;
                        const c = j + 2;
                        intersection = $e97a97f0b0cf48c9$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $e97a97f0b0cf48c9$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(position.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = i;
                        const b = i + 1;
                        const c = i + 2;
                        intersection = $e97a97f0b0cf48c9$var$checkBufferGeometryIntersection(this, material, raycaster, $e97a97f0b0cf48c9$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            }
        } else if (geometry.isGeometry) console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
}
$e97a97f0b0cf48c9$export$e176487c05830cc5.prototype.isMesh = true;
function $e97a97f0b0cf48c9$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== $e97a97f0b0cf48c9$export$3b296b6f144d5b03, point);
    if (intersect === null) return null;
    $e97a97f0b0cf48c9$var$_intersectionPointWorld.copy(point);
    $e97a97f0b0cf48c9$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($e97a97f0b0cf48c9$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $e97a97f0b0cf48c9$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $e97a97f0b0cf48c9$var$checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    $e97a97f0b0cf48c9$var$_vA$1.fromBufferAttribute(position, a);
    $e97a97f0b0cf48c9$var$_vB$1.fromBufferAttribute(position, b);
    $e97a97f0b0cf48c9$var$_vC$1.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (morphPosition && morphInfluences) {
        $e97a97f0b0cf48c9$var$_morphA.set(0, 0, 0);
        $e97a97f0b0cf48c9$var$_morphB.set(0, 0, 0);
        $e97a97f0b0cf48c9$var$_morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            $e97a97f0b0cf48c9$var$_tempA.fromBufferAttribute(morphAttribute, a);
            $e97a97f0b0cf48c9$var$_tempB.fromBufferAttribute(morphAttribute, b);
            $e97a97f0b0cf48c9$var$_tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                $e97a97f0b0cf48c9$var$_morphA.addScaledVector($e97a97f0b0cf48c9$var$_tempA, influence);
                $e97a97f0b0cf48c9$var$_morphB.addScaledVector($e97a97f0b0cf48c9$var$_tempB, influence);
                $e97a97f0b0cf48c9$var$_morphC.addScaledVector($e97a97f0b0cf48c9$var$_tempC, influence);
            } else {
                $e97a97f0b0cf48c9$var$_morphA.addScaledVector($e97a97f0b0cf48c9$var$_tempA.sub($e97a97f0b0cf48c9$var$_vA$1), influence);
                $e97a97f0b0cf48c9$var$_morphB.addScaledVector($e97a97f0b0cf48c9$var$_tempB.sub($e97a97f0b0cf48c9$var$_vB$1), influence);
                $e97a97f0b0cf48c9$var$_morphC.addScaledVector($e97a97f0b0cf48c9$var$_tempC.sub($e97a97f0b0cf48c9$var$_vC$1), influence);
            }
        }
        $e97a97f0b0cf48c9$var$_vA$1.add($e97a97f0b0cf48c9$var$_morphA);
        $e97a97f0b0cf48c9$var$_vB$1.add($e97a97f0b0cf48c9$var$_morphB);
        $e97a97f0b0cf48c9$var$_vC$1.add($e97a97f0b0cf48c9$var$_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, $e97a97f0b0cf48c9$var$_vA$1);
        object.boneTransform(b, $e97a97f0b0cf48c9$var$_vB$1);
        object.boneTransform(c, $e97a97f0b0cf48c9$var$_vC$1);
    }
    const intersection = $e97a97f0b0cf48c9$var$checkIntersection(object, material, raycaster, ray, $e97a97f0b0cf48c9$var$_vA$1, $e97a97f0b0cf48c9$var$_vB$1, $e97a97f0b0cf48c9$var$_vC$1, $e97a97f0b0cf48c9$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $e97a97f0b0cf48c9$var$_uvA$1.fromBufferAttribute(uv, a);
            $e97a97f0b0cf48c9$var$_uvB$1.fromBufferAttribute(uv, b);
            $e97a97f0b0cf48c9$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $e97a97f0b0cf48c9$export$5a465592bfe74b48.getUV($e97a97f0b0cf48c9$var$_intersectionPoint, $e97a97f0b0cf48c9$var$_vA$1, $e97a97f0b0cf48c9$var$_vB$1, $e97a97f0b0cf48c9$var$_vC$1, $e97a97f0b0cf48c9$var$_uvA$1, $e97a97f0b0cf48c9$var$_uvB$1, $e97a97f0b0cf48c9$var$_uvC$1, new $e97a97f0b0cf48c9$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $e97a97f0b0cf48c9$var$_uvA$1.fromBufferAttribute(uv2, a);
            $e97a97f0b0cf48c9$var$_uvB$1.fromBufferAttribute(uv2, b);
            $e97a97f0b0cf48c9$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $e97a97f0b0cf48c9$export$5a465592bfe74b48.getUV($e97a97f0b0cf48c9$var$_intersectionPoint, $e97a97f0b0cf48c9$var$_vA$1, $e97a97f0b0cf48c9$var$_vB$1, $e97a97f0b0cf48c9$var$_vC$1, $e97a97f0b0cf48c9$var$_uvA$1, $e97a97f0b0cf48c9$var$_uvB$1, $e97a97f0b0cf48c9$var$_uvC$1, new $e97a97f0b0cf48c9$export$c977b3e384af9ae1());
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $e97a97f0b0cf48c9$export$5a465592bfe74b48.getNormal($e97a97f0b0cf48c9$var$_vA$1, $e97a97f0b0cf48c9$var$_vB$1, $e97a97f0b0cf48c9$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $e97a97f0b0cf48c9$export$ab3456a079aa7d80 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$ab3456a079aa7d80(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $e97a97f0b0cf48c9$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $e97a97f0b0cf48c9$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $e97a97f0b0cf48c9$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
// Legacy
const $e97a97f0b0cf48c9$export$d8ecdf8615bfea69 = {
    clone: $e97a97f0b0cf48c9$var$cloneUniforms,
    merge: $e97a97f0b0cf48c9$var$mergeUniforms
};
var $e97a97f0b0cf48c9$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $e97a97f0b0cf48c9$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>
 * }
 */ class $e97a97f0b0cf48c9$export$83c7d75d550a8b0d extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.vertexShader = $e97a97f0b0cf48c9$var$default_vertex;
        this.fragmentShader = $e97a97f0b0cf48c9$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv2": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) {
            if (parameters.attributes !== undefined) console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.");
            this.setValues(parameters);
        }
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $e97a97f0b0cf48c9$var$cloneUniforms(source.uniforms);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
$e97a97f0b0cf48c9$export$83c7d75d550a8b0d.prototype.isShaderMaterial = true;
class $e97a97f0b0cf48c9$export$79f141de891a5fed extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Camera";
        this.matrixWorldInverse = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
$e97a97f0b0cf48c9$export$79f141de891a5fed.prototype.isCamera = true;
class $e97a97f0b0cf48c9$export$74e4ae24825f68d7 extends $e97a97f0b0cf48c9$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $e97a97f0b0cf48c9$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($e97a97f0b0cf48c9$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $e97a97f0b0cf48c9$var$RAD2DEG * 2 * Math.atan(Math.tan($e97a97f0b0cf48c9$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($e97a97f0b0cf48c9$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
$e97a97f0b0cf48c9$export$74e4ae24825f68d7.prototype.isPerspectiveCamera = true;
const $e97a97f0b0cf48c9$var$fov = 90, $e97a97f0b0cf48c9$var$aspect = 1;
class $e97a97f0b0cf48c9$export$d0cdd0bd804995de extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        if (renderTarget.isWebGLCubeRenderTarget !== true) {
            console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
            return;
        }
        this.renderTarget = renderTarget;
        const cameraPX = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7($e97a97f0b0cf48c9$var$fov, $e97a97f0b0cf48c9$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 0, 0));
        this.add(cameraPX);
        const cameraNX = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7($e97a97f0b0cf48c9$var$fov, $e97a97f0b0cf48c9$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(new $e97a97f0b0cf48c9$export$64b5c384219d3699(-1, 0, 0));
        this.add(cameraNX);
        const cameraPY = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7($e97a97f0b0cf48c9$var$fov, $e97a97f0b0cf48c9$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0));
        this.add(cameraPY);
        const cameraNY = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7($e97a97f0b0cf48c9$var$fov, $e97a97f0b0cf48c9$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, -1, 0));
        this.add(cameraNY);
        const cameraPZ = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7($e97a97f0b0cf48c9$var$fov, $e97a97f0b0cf48c9$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, 1));
        this.add(cameraPZ);
        const cameraNZ = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7($e97a97f0b0cf48c9$var$fov, $e97a97f0b0cf48c9$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, -1));
        this.add(cameraNZ);
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentXrEnabled = renderer.xr.enabled;
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $e97a97f0b0cf48c9$export$ee2e5a18258a4049 extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $e97a97f0b0cf48c9$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
$e97a97f0b0cf48c9$export$ee2e5a18258a4049.prototype.isCubeTexture = true;
class $e97a97f0b0cf48c9$export$ac386671d651941e extends $e97a97f0b0cf48c9$export$3c052beb2e51e23f {
    constructor(size, options, dummy){
        if (Number.isInteger(options)) {
            console.warn("THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )");
            options = dummy;
        }
        super(size, size, options);
        options = options || {};
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture = new $e97a97f0b0cf48c9$export$ee2e5a18258a4049(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.format = $e97a97f0b0cf48c9$export$3f8bb04b555a363c; // see #18859
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $e97a97f0b0cf48c9$export$ab3456a079aa7d80(5, 5, 5);
        const material = new $e97a97f0b0cf48c9$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $e97a97f0b0cf48c9$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $e97a97f0b0cf48c9$export$d9f0486e75b5ace,
            blending: $e97a97f0b0cf48c9$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $e97a97f0b0cf48c9$export$5d8599b6a933fb1b) texture.minFilter = $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
        const camera = new $e97a97f0b0cf48c9$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
$e97a97f0b0cf48c9$export$ac386671d651941e.prototype.isWebGLCubeRenderTarget = true;
const $e97a97f0b0cf48c9$var$_vector1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vector2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_normalMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$8ff26dafa08918();
class $e97a97f0b0cf48c9$export$7ff5ac152ef991b0 {
    constructor(normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 0, 0), constant = 0){
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $e97a97f0b0cf48c9$var$_vector1.subVectors(c, b).cross($e97a97f0b0cf48c9$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        const direction = line.delta($e97a97f0b0cf48c9$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $e97a97f0b0cf48c9$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($e97a97f0b0cf48c9$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
$e97a97f0b0cf48c9$export$7ff5ac152ef991b0.prototype.isPlane = true;
const $e97a97f0b0cf48c9$var$_sphere$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$805e8b72413ccaba();
const $e97a97f0b0cf48c9$var$_vector$7 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$35efe6f4c85463d2 {
    constructor(p0 = new $e97a97f0b0cf48c9$export$7ff5ac152ef991b0(), p1 = new $e97a97f0b0cf48c9$export$7ff5ac152ef991b0(), p2 = new $e97a97f0b0cf48c9$export$7ff5ac152ef991b0(), p3 = new $e97a97f0b0cf48c9$export$7ff5ac152ef991b0(), p4 = new $e97a97f0b0cf48c9$export$7ff5ac152ef991b0(), p5 = new $e97a97f0b0cf48c9$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $e97a97f0b0cf48c9$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere($e97a97f0b0cf48c9$var$_sphere$2);
    }
    intersectsSprite(sprite) {
        $e97a97f0b0cf48c9$var$_sphere$2.center.set(0, 0, 0);
        $e97a97f0b0cf48c9$var$_sphere$2.radius = 0.7071067811865476;
        $e97a97f0b0cf48c9$var$_sphere$2.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($e97a97f0b0cf48c9$var$_sphere$2);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $e97a97f0b0cf48c9$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $e97a97f0b0cf48c9$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $e97a97f0b0cf48c9$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($e97a97f0b0cf48c9$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $e97a97f0b0cf48c9$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $e97a97f0b0cf48c9$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type = 5126;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Float64Array) console.warn("THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.");
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else console.warn("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $e97a97f0b0cf48c9$export$e789a11a194ca4e0 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$e789a11a194ca4e0(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $e97a97f0b0cf48c9$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var $e97a97f0b0cf48c9$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $e97a97f0b0cf48c9$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $e97a97f0b0cf48c9$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $e97a97f0b0cf48c9$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $e97a97f0b0cf48c9$var$begin_vertex = "vec3 transformed = vec3( position );";
var $e97a97f0b0cf48c9$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $e97a97f0b0cf48c9$var$bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif";
var $e97a97f0b0cf48c9$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vUv );\n		vec2 dSTdy = dFdy( vUv );\n		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n		vec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $e97a97f0b0cf48c9$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $e97a97f0b0cf48c9$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $e97a97f0b0cf48c9$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $e97a97f0b0cf48c9$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $e97a97f0b0cf48c9$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $e97a97f0b0cf48c9$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $e97a97f0b0cf48c9$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $e97a97f0b0cf48c9$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n	vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n	return dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}";
var $e97a97f0b0cf48c9$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_maxMipLevel 8.0\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_maxTileSize 256.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		float texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n		vec2 uv = getUV( direction, face ) * ( faceSize - 1.0 ) + 0.5;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		if ( mipInt < cubeUV_maxMipLevel ) {\n			uv.y += 2.0 * cubeUV_maxTileSize;\n		}\n		uv.y += filterInt * 2.0 * cubeUV_minTileSize;\n		uv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n		uv *= texelSize;\n		return texture2D( envMap, uv ).rgb;\n	}\n	#define r0 1.0\n	#define v0 0.339\n	#define m0 - 2.0\n	#define r1 0.8\n	#define v1 0.276\n	#define m1 - 1.0\n	#define r4 0.4\n	#define v4 0.046\n	#define m4 2.0\n	#define r5 0.305\n	#define v5 0.016\n	#define m5 3.0\n	#define r6 0.21\n	#define v6 0.0038\n	#define m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= r1 ) {\n			mip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n		} else if ( roughness >= r4 ) {\n			mip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n		} else if ( roughness >= r5 ) {\n			mip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n		} else if ( roughness >= r6 ) {\n			mip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $e97a97f0b0cf48c9$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $e97a97f0b0cf48c9$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var $e97a97f0b0cf48c9$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $e97a97f0b0cf48c9$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $e97a97f0b0cf48c9$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $e97a97f0b0cf48c9$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $e97a97f0b0cf48c9$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $e97a97f0b0cf48c9$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $e97a97f0b0cf48c9$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $e97a97f0b0cf48c9$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $e97a97f0b0cf48c9$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		return ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n	#endif\n}";
var $e97a97f0b0cf48c9$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		lightMapIrradiance *= PI;\n	#endif\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $e97a97f0b0cf48c9$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $e97a97f0b0cf48c9$var$lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n	vLightBack = vec3( 0.0 );\n	vIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n	vIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n	vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		getPointLightInfo( pointLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		getSpotLightInfo( spotLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n		vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		#ifdef DOUBLE_SIDED\n			vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif";
var $e97a97f0b0cf48c9$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#else\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $e97a97f0b0cf48c9$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	#ifdef ENVMAP_MODE_REFRACTION\n		uniform float refractionRatio;\n	#endif\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 reflectVec;\n			#ifdef ENVMAP_MODE_REFLECTION\n				reflectVec = reflect( - viewDir, normal );\n				reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			#else\n				reflectVec = refract( - viewDir, normal, refractionRatio );\n			#endif\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n#endif";
var $e97a97f0b0cf48c9$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $e97a97f0b0cf48c9$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )	(0)";
var $e97a97f0b0cf48c9$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $e97a97f0b0cf48c9$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )	(0)";
var $e97a97f0b0cf48c9$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	#ifdef SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULARINTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n		#endif\n		#ifdef USE_SPECULARCOLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEENCOLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEENROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	vec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	vec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $e97a97f0b0cf48c9$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $e97a97f0b0cf48c9$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			lightMapIrradiance *= PI;\n		#endif\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $e97a97f0b0cf48c9$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $e97a97f0b0cf48c9$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $e97a97f0b0cf48c9$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var $e97a97f0b0cf48c9$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $e97a97f0b0cf48c9$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $e97a97f0b0cf48c9$var$map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	uniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $e97a97f0b0cf48c9$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $e97a97f0b0cf48c9$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $e97a97f0b0cf48c9$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1, 2 ) * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform vec2 morphTargetsTextureSize;\n		vec3 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset, const in int stride ) {\n			float texelIndex = float( vertexIndex * stride + offset );\n			float y = floor( texelIndex / morphTargetsTextureSize.x );\n			float x = texelIndex - y * morphTargetsTextureSize.x;\n			vec3 morphUV = vec3( ( x + 0.5 ) / morphTargetsTextureSize.x, y / morphTargetsTextureSize.y, morphTargetIndex );\n			return texture( morphTargetsTexture, morphUV ).xyz;\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			#ifndef USE_MORPHNORMALS\n				if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0, 1 ) * morphTargetInfluences[ i ];\n			#else\n				if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0, 2 ) * morphTargetInfluences[ i ];\n			#endif\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n	vec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	#ifdef USE_TANGENT\n		vec3 tangent = normalize( vTangent );\n		vec3 bitangent = normalize( vBitangent );\n		#ifdef DOUBLE_SIDED\n			tangent = tangent * faceDirection;\n			bitangent = bitangent * faceDirection;\n		#endif\n		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n			mat3 vTBN = mat3( tangent, bitangent, normal );\n		#endif\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $e97a97f0b0cf48c9$var$normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	#ifdef USE_TANGENT\n		normal = normalize( vTBN * mapN );\n	#else\n		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n	#endif\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $e97a97f0b0cf48c9$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n		vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n		vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n		vec2 st0 = dFdx( vUv.st );\n		vec2 st1 = dFdy( vUv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n	}\n#endif";
var $e97a97f0b0cf48c9$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $e97a97f0b0cf48c9$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	#ifdef USE_TANGENT\n		clearcoatNormal = normalize( vTBN * clearcoatMapN );\n	#else\n		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif";
var $e97a97f0b0cf48c9$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $e97a97f0b0cf48c9$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n	return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var $e97a97f0b0cf48c9$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $e97a97f0b0cf48c9$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $e97a97f0b0cf48c9$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $e97a97f0b0cf48c9$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $e97a97f0b0cf48c9$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $e97a97f0b0cf48c9$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $e97a97f0b0cf48c9$var$shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n		bool inFrustum = all( inFrustumVec );\n		bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n		bool frustumTest = all( frustumTestVec );\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $e97a97f0b0cf48c9$var$shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$shadowmap_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		vec4 shadowWorldPosition;\n	#endif\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n		vSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $e97a97f0b0cf48c9$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $e97a97f0b0cf48c9$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	#ifdef BONE_TEXTURE\n		uniform highp sampler2D boneTexture;\n		uniform int boneTextureSize;\n		mat4 getBoneMatrix( const in float i ) {\n			float j = i * 4.0;\n			float x = mod( j, float( boneTextureSize ) );\n			float y = floor( j / float( boneTextureSize ) );\n			float dx = 1.0 / float( boneTextureSize );\n			float dy = 1.0 / float( boneTextureSize );\n			y = dy * ( y + 0.5 );\n			vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n			vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n			vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n			vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n			mat4 bone = mat4( v1, v2, v3, v4 );\n			return bone;\n		}\n	#else\n		uniform mat4 boneMatrices[ MAX_BONES ];\n		mat4 getBoneMatrix( const in float i ) {\n			mat4 bone = boneMatrices[ int(i) ];\n			return bone;\n		}\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $e97a97f0b0cf48c9$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $e97a97f0b0cf48c9$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $e97a97f0b0cf48c9$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $e97a97f0b0cf48c9$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $e97a97f0b0cf48c9$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $e97a97f0b0cf48c9$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	float transmissionAlpha = 1.0;\n	float transmissionFactor = transmission;\n	float thicknessFactor = thickness;\n	#ifdef USE_TRANSMISSIONMAP\n		transmissionFactor *= texture2D( transmissionMap, vUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		thicknessFactor *= texture2D( thicknessMap, vUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmission = getIBLVolumeRefraction(\n		n, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n		attenuationColor, attenuationDistance );\n	totalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n	transmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif";
var $e97a97f0b0cf48c9$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		#ifdef TEXTURE_LOD_EXT\n			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#else\n			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#endif\n	}\n	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( attenuationDistance == 0.0 ) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n	}\n#endif";
var $e97a97f0b0cf48c9$var$uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n	varying vec2 vUv;\n#endif";
var $e97a97f0b0cf48c9$var$uv_pars_vertex = "#ifdef USE_UV\n	#ifdef UVS_VERTEX_ONLY\n		vec2 vUv;\n	#else\n		varying vec2 vUv;\n	#endif\n	uniform mat3 uvTransform;\n#endif";
var $e97a97f0b0cf48c9$var$uv_vertex = "#ifdef USE_UV\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var $e97a97f0b0cf48c9$var$uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	varying vec2 vUv2;\n#endif";
var $e97a97f0b0cf48c9$var$uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	attribute vec2 uv2;\n	varying vec2 vUv2;\n	uniform mat3 uv2Transform;\n#endif";
var $e97a97f0b0cf48c9$var$uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var $e97a97f0b0cf48c9$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $e97a97f0b0cf48c9$var$vertex$g = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $e97a97f0b0cf48c9$var$fragment$g = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n	gl_FragColor = texture2D( t2D, vUv );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $e97a97f0b0cf48c9$var$fragment$f = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	vec3 vReflect = vWorldDirection;\n	#include <envmap_fragment>\n	gl_FragColor = envColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $e97a97f0b0cf48c9$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $e97a97f0b0cf48c9$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $e97a97f0b0cf48c9$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $e97a97f0b0cf48c9$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$9 = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <lights_lambert_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$9 = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <emissivemap_fragment>\n	#ifdef DOUBLE_SIDED\n		reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n	#else\n		reflectedLight.indirectDiffuse += vIndirectFront;\n	#endif\n	#include <lightmap_fragment>\n	reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n	#ifdef DOUBLE_SIDED\n		reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n	#else\n		reflectedLight.directDiffuse = vLightFront;\n	#endif\n	reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $e97a97f0b0cf48c9$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $e97a97f0b0cf48c9$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $e97a97f0b0cf48c9$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $e97a97f0b0cf48c9$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULARINTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n	#ifdef USE_SPECULARCOLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEENCOLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEENROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $e97a97f0b0cf48c9$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $e97a97f0b0cf48c9$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $e97a97f0b0cf48c9$export$955f9f2e84c43c8b = {
    alphamap_fragment: $e97a97f0b0cf48c9$var$alphamap_fragment,
    alphamap_pars_fragment: $e97a97f0b0cf48c9$var$alphamap_pars_fragment,
    alphatest_fragment: $e97a97f0b0cf48c9$var$alphatest_fragment,
    alphatest_pars_fragment: $e97a97f0b0cf48c9$var$alphatest_pars_fragment,
    aomap_fragment: $e97a97f0b0cf48c9$var$aomap_fragment,
    aomap_pars_fragment: $e97a97f0b0cf48c9$var$aomap_pars_fragment,
    begin_vertex: $e97a97f0b0cf48c9$var$begin_vertex,
    beginnormal_vertex: $e97a97f0b0cf48c9$var$beginnormal_vertex,
    bsdfs: $e97a97f0b0cf48c9$var$bsdfs,
    bumpmap_pars_fragment: $e97a97f0b0cf48c9$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $e97a97f0b0cf48c9$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $e97a97f0b0cf48c9$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $e97a97f0b0cf48c9$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $e97a97f0b0cf48c9$var$clipping_planes_vertex,
    color_fragment: $e97a97f0b0cf48c9$var$color_fragment,
    color_pars_fragment: $e97a97f0b0cf48c9$var$color_pars_fragment,
    color_pars_vertex: $e97a97f0b0cf48c9$var$color_pars_vertex,
    color_vertex: $e97a97f0b0cf48c9$var$color_vertex,
    common: $e97a97f0b0cf48c9$var$common,
    cube_uv_reflection_fragment: $e97a97f0b0cf48c9$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $e97a97f0b0cf48c9$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $e97a97f0b0cf48c9$var$displacementmap_pars_vertex,
    displacementmap_vertex: $e97a97f0b0cf48c9$var$displacementmap_vertex,
    emissivemap_fragment: $e97a97f0b0cf48c9$var$emissivemap_fragment,
    emissivemap_pars_fragment: $e97a97f0b0cf48c9$var$emissivemap_pars_fragment,
    encodings_fragment: $e97a97f0b0cf48c9$var$encodings_fragment,
    encodings_pars_fragment: $e97a97f0b0cf48c9$var$encodings_pars_fragment,
    envmap_fragment: $e97a97f0b0cf48c9$var$envmap_fragment,
    envmap_common_pars_fragment: $e97a97f0b0cf48c9$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $e97a97f0b0cf48c9$var$envmap_pars_fragment,
    envmap_pars_vertex: $e97a97f0b0cf48c9$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $e97a97f0b0cf48c9$var$envmap_physical_pars_fragment,
    envmap_vertex: $e97a97f0b0cf48c9$var$envmap_vertex,
    fog_vertex: $e97a97f0b0cf48c9$var$fog_vertex,
    fog_pars_vertex: $e97a97f0b0cf48c9$var$fog_pars_vertex,
    fog_fragment: $e97a97f0b0cf48c9$var$fog_fragment,
    fog_pars_fragment: $e97a97f0b0cf48c9$var$fog_pars_fragment,
    gradientmap_pars_fragment: $e97a97f0b0cf48c9$var$gradientmap_pars_fragment,
    lightmap_fragment: $e97a97f0b0cf48c9$var$lightmap_fragment,
    lightmap_pars_fragment: $e97a97f0b0cf48c9$var$lightmap_pars_fragment,
    lights_lambert_vertex: $e97a97f0b0cf48c9$var$lights_lambert_vertex,
    lights_pars_begin: $e97a97f0b0cf48c9$var$lights_pars_begin,
    lights_toon_fragment: $e97a97f0b0cf48c9$var$lights_toon_fragment,
    lights_toon_pars_fragment: $e97a97f0b0cf48c9$var$lights_toon_pars_fragment,
    lights_phong_fragment: $e97a97f0b0cf48c9$var$lights_phong_fragment,
    lights_phong_pars_fragment: $e97a97f0b0cf48c9$var$lights_phong_pars_fragment,
    lights_physical_fragment: $e97a97f0b0cf48c9$var$lights_physical_fragment,
    lights_physical_pars_fragment: $e97a97f0b0cf48c9$var$lights_physical_pars_fragment,
    lights_fragment_begin: $e97a97f0b0cf48c9$var$lights_fragment_begin,
    lights_fragment_maps: $e97a97f0b0cf48c9$var$lights_fragment_maps,
    lights_fragment_end: $e97a97f0b0cf48c9$var$lights_fragment_end,
    logdepthbuf_fragment: $e97a97f0b0cf48c9$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $e97a97f0b0cf48c9$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $e97a97f0b0cf48c9$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $e97a97f0b0cf48c9$var$logdepthbuf_vertex,
    map_fragment: $e97a97f0b0cf48c9$var$map_fragment,
    map_pars_fragment: $e97a97f0b0cf48c9$var$map_pars_fragment,
    map_particle_fragment: $e97a97f0b0cf48c9$var$map_particle_fragment,
    map_particle_pars_fragment: $e97a97f0b0cf48c9$var$map_particle_pars_fragment,
    metalnessmap_fragment: $e97a97f0b0cf48c9$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $e97a97f0b0cf48c9$var$metalnessmap_pars_fragment,
    morphnormal_vertex: $e97a97f0b0cf48c9$var$morphnormal_vertex,
    morphtarget_pars_vertex: $e97a97f0b0cf48c9$var$morphtarget_pars_vertex,
    morphtarget_vertex: $e97a97f0b0cf48c9$var$morphtarget_vertex,
    normal_fragment_begin: $e97a97f0b0cf48c9$var$normal_fragment_begin,
    normal_fragment_maps: $e97a97f0b0cf48c9$var$normal_fragment_maps,
    normal_pars_fragment: $e97a97f0b0cf48c9$var$normal_pars_fragment,
    normal_pars_vertex: $e97a97f0b0cf48c9$var$normal_pars_vertex,
    normal_vertex: $e97a97f0b0cf48c9$var$normal_vertex,
    normalmap_pars_fragment: $e97a97f0b0cf48c9$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $e97a97f0b0cf48c9$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $e97a97f0b0cf48c9$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $e97a97f0b0cf48c9$var$clearcoat_pars_fragment,
    output_fragment: $e97a97f0b0cf48c9$var$output_fragment,
    packing: $e97a97f0b0cf48c9$var$packing,
    premultiplied_alpha_fragment: $e97a97f0b0cf48c9$var$premultiplied_alpha_fragment,
    project_vertex: $e97a97f0b0cf48c9$var$project_vertex,
    dithering_fragment: $e97a97f0b0cf48c9$var$dithering_fragment,
    dithering_pars_fragment: $e97a97f0b0cf48c9$var$dithering_pars_fragment,
    roughnessmap_fragment: $e97a97f0b0cf48c9$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $e97a97f0b0cf48c9$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $e97a97f0b0cf48c9$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $e97a97f0b0cf48c9$var$shadowmap_pars_vertex,
    shadowmap_vertex: $e97a97f0b0cf48c9$var$shadowmap_vertex,
    shadowmask_pars_fragment: $e97a97f0b0cf48c9$var$shadowmask_pars_fragment,
    skinbase_vertex: $e97a97f0b0cf48c9$var$skinbase_vertex,
    skinning_pars_vertex: $e97a97f0b0cf48c9$var$skinning_pars_vertex,
    skinning_vertex: $e97a97f0b0cf48c9$var$skinning_vertex,
    skinnormal_vertex: $e97a97f0b0cf48c9$var$skinnormal_vertex,
    specularmap_fragment: $e97a97f0b0cf48c9$var$specularmap_fragment,
    specularmap_pars_fragment: $e97a97f0b0cf48c9$var$specularmap_pars_fragment,
    tonemapping_fragment: $e97a97f0b0cf48c9$var$tonemapping_fragment,
    tonemapping_pars_fragment: $e97a97f0b0cf48c9$var$tonemapping_pars_fragment,
    transmission_fragment: $e97a97f0b0cf48c9$var$transmission_fragment,
    transmission_pars_fragment: $e97a97f0b0cf48c9$var$transmission_pars_fragment,
    uv_pars_fragment: $e97a97f0b0cf48c9$var$uv_pars_fragment,
    uv_pars_vertex: $e97a97f0b0cf48c9$var$uv_pars_vertex,
    uv_vertex: $e97a97f0b0cf48c9$var$uv_vertex,
    uv2_pars_fragment: $e97a97f0b0cf48c9$var$uv2_pars_fragment,
    uv2_pars_vertex: $e97a97f0b0cf48c9$var$uv2_pars_vertex,
    uv2_vertex: $e97a97f0b0cf48c9$var$uv2_vertex,
    worldpos_vertex: $e97a97f0b0cf48c9$var$worldpos_vertex,
    background_vert: $e97a97f0b0cf48c9$var$vertex$g,
    background_frag: $e97a97f0b0cf48c9$var$fragment$g,
    cube_vert: $e97a97f0b0cf48c9$var$vertex$f,
    cube_frag: $e97a97f0b0cf48c9$var$fragment$f,
    depth_vert: $e97a97f0b0cf48c9$var$vertex$e,
    depth_frag: $e97a97f0b0cf48c9$var$fragment$e,
    distanceRGBA_vert: $e97a97f0b0cf48c9$var$vertex$d,
    distanceRGBA_frag: $e97a97f0b0cf48c9$var$fragment$d,
    equirect_vert: $e97a97f0b0cf48c9$var$vertex$c,
    equirect_frag: $e97a97f0b0cf48c9$var$fragment$c,
    linedashed_vert: $e97a97f0b0cf48c9$var$vertex$b,
    linedashed_frag: $e97a97f0b0cf48c9$var$fragment$b,
    meshbasic_vert: $e97a97f0b0cf48c9$var$vertex$a,
    meshbasic_frag: $e97a97f0b0cf48c9$var$fragment$a,
    meshlambert_vert: $e97a97f0b0cf48c9$var$vertex$9,
    meshlambert_frag: $e97a97f0b0cf48c9$var$fragment$9,
    meshmatcap_vert: $e97a97f0b0cf48c9$var$vertex$8,
    meshmatcap_frag: $e97a97f0b0cf48c9$var$fragment$8,
    meshnormal_vert: $e97a97f0b0cf48c9$var$vertex$7,
    meshnormal_frag: $e97a97f0b0cf48c9$var$fragment$7,
    meshphong_vert: $e97a97f0b0cf48c9$var$vertex$6,
    meshphong_frag: $e97a97f0b0cf48c9$var$fragment$6,
    meshphysical_vert: $e97a97f0b0cf48c9$var$vertex$5,
    meshphysical_frag: $e97a97f0b0cf48c9$var$fragment$5,
    meshtoon_vert: $e97a97f0b0cf48c9$var$vertex$4,
    meshtoon_frag: $e97a97f0b0cf48c9$var$fragment$4,
    points_vert: $e97a97f0b0cf48c9$var$vertex$3,
    points_frag: $e97a97f0b0cf48c9$var$fragment$3,
    shadow_vert: $e97a97f0b0cf48c9$var$vertex$2,
    shadow_frag: $e97a97f0b0cf48c9$var$fragment$2,
    sprite_vert: $e97a97f0b0cf48c9$var$vertex$1,
    sprite_frag: $e97a97f0b0cf48c9$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $e97a97f0b0cf48c9$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
        },
        uv2Transform: {
            value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
        }
    }
};
const $e97a97f0b0cf48c9$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.specularmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.envmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.aomap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lightmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.specularmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.envmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.aomap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lightmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.emissivemap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.specularmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.envmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.aomap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lightmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.emissivemap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.bumpmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.normalmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.displacementmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.envmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.aomap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lightmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.emissivemap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.bumpmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.normalmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.displacementmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.roughnessmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.metalnessmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.aomap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lightmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.emissivemap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.bumpmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.normalmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.displacementmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.gradientmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog,
            $e97a97f0b0cf48c9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.bumpmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.normalmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.displacementmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.points,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.bumpmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.normalmap,
            $e97a97f0b0cf48c9$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.sprite,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.background_frag
    },
    /* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */ cube: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.common,
            $e97a97f0b0cf48c9$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: new $e97a97f0b0cf48c9$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
            $e97a97f0b0cf48c9$export$6643083551874bf5.lights,
            $e97a97f0b0cf48c9$export$6643083551874bf5.fog,
            {
                color: {
                    value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.shadow_frag
    }
};
$e97a97f0b0cf48c9$export$bee4a7d47f8f5014.physical = {
    uniforms: $e97a97f0b0cf48c9$var$mergeUniforms([
        $e97a97f0b0cf48c9$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: new $e97a97f0b0cf48c9$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $e97a97f0b0cf48c9$export$955f9f2e84c43c8b.meshphysical_frag
};
function $e97a97f0b0cf48c9$var$WebGLBackground(renderer, cubemaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === "additive") background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $e97a97f0b0cf48c9$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5(new $e97a97f0b0cf48c9$export$ab3456a079aa7d80(1, 1, 1), new $e97a97f0b0cf48c9$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $e97a97f0b0cf48c9$var$cloneUniforms($e97a97f0b0cf48c9$export$bee4a7d47f8f5014.cube.uniforms),
                    vertexShader: $e97a97f0b0cf48c9$export$bee4a7d47f8f5014.cube.vertexShader,
                    fragmentShader: $e97a97f0b0cf48c9$export$bee4a7d47f8f5014.cube.fragmentShader,
                    side: $e97a97f0b0cf48c9$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5(new $e97a97f0b0cf48c9$export$e789a11a194ca4e0(2, 2), new $e97a97f0b0cf48c9$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $e97a97f0b0cf48c9$var$cloneUniforms($e97a97f0b0cf48c9$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $e97a97f0b0cf48c9$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $e97a97f0b0cf48c9$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $e97a97f0b0cf48c9$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $e97a97f0b0cf48c9$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(geometry, index);
            if (updateBuffers) saveCache(geometry, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (object.isInstancedMesh === true) updateBuffers = true;
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers) {
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(geometry, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in geometryAttributes){
            const cachedAttribute = cachedAttributes[key];
            const geometryAttribute = geometryAttributes[key];
            if (cachedAttribute === undefined) return true;
            if (cachedAttribute.attribute !== geometryAttribute) return true;
            if (cachedAttribute.data !== geometryAttribute.data) return true;
            attributesNum++;
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(geometry, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in attributes){
            const attribute = attributes[key];
            const data = {};
            data.attribute = attribute;
            if (attribute.data) data.data = attribute.data;
            cache[key] = data;
            attributesNum++;
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data && data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatilibity
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $e97a97f0b0cf48c9$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $e97a97f0b0cf48c9$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== "undefined" && gl instanceof WebGL2ComputeRenderingContext;
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $e97a97f0b0cf48c9$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $e97a97f0b0cf48c9$export$7ff5ac152ef991b0(), viewNormalMatrix = new $e97a97f0b0cf48c9$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $e97a97f0b0cf48c9$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $e97a97f0b0cf48c9$export$d64030b316d3b087) texture.mapping = $e97a97f0b0cf48c9$export$8759762a6477f2c4;
        else if (mapping === $e97a97f0b0cf48c9$export$ee99d97d46898098) texture.mapping = $e97a97f0b0cf48c9$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $e97a97f0b0cf48c9$export$d64030b316d3b087 || mapping === $e97a97f0b0cf48c9$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $e97a97f0b0cf48c9$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $e97a97f0b0cf48c9$export$9ebf355ee4ed261b extends $e97a97f0b0cf48c9$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
$e97a97f0b0cf48c9$export$9ebf355ee4ed261b.prototype.isOrthographicCamera = true;
class $e97a97f0b0cf48c9$export$21c421a2e1df9d22 extends $e97a97f0b0cf48c9$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.type = "RawShaderMaterial";
    }
}
$e97a97f0b0cf48c9$export$21c421a2e1df9d22.prototype.isRawShaderMaterial = true;
const $e97a97f0b0cf48c9$var$LOD_MIN = 4;
const $e97a97f0b0cf48c9$var$LOD_MAX = 8;
const $e97a97f0b0cf48c9$var$SIZE_MAX = Math.pow(2, $e97a97f0b0cf48c9$var$LOD_MAX);
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $e97a97f0b0cf48c9$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
const $e97a97f0b0cf48c9$var$TOTAL_LODS = $e97a97f0b0cf48c9$var$LOD_MAX - $e97a97f0b0cf48c9$var$LOD_MIN + 1 + $e97a97f0b0cf48c9$var$EXTRA_LOD_SIGMA.length;
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $e97a97f0b0cf48c9$var$MAX_SAMPLES = 20;
const $e97a97f0b0cf48c9$var$_flatCamera = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$9ebf355ee4ed261b();
const { _lodPlanes: $e97a97f0b0cf48c9$var$_lodPlanes, _sizeLods: $e97a97f0b0cf48c9$var$_sizeLods, _sigmas: $e97a97f0b0cf48c9$var$_sigmas } = /*@__PURE__*/ $e97a97f0b0cf48c9$var$_createPlanes();
const $e97a97f0b0cf48c9$var$_clearColor = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$892596cec99bc70e();
let $e97a97f0b0cf48c9$var$_oldTarget = null;
// Golden Ratio
const $e97a97f0b0cf48c9$var$PHI = (1 + Math.sqrt(5)) / 2;
const $e97a97f0b0cf48c9$var$INV_PHI = 1 / $e97a97f0b0cf48c9$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $e97a97f0b0cf48c9$var$_axisDirections = [
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, $e97a97f0b0cf48c9$var$PHI, $e97a97f0b0cf48c9$var$INV_PHI),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, $e97a97f0b0cf48c9$var$PHI, -$e97a97f0b0cf48c9$var$INV_PHI),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699($e97a97f0b0cf48c9$var$INV_PHI, 0, $e97a97f0b0cf48c9$var$PHI),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(-$e97a97f0b0cf48c9$var$INV_PHI, 0, $e97a97f0b0cf48c9$var$PHI),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699($e97a97f0b0cf48c9$var$PHI, $e97a97f0b0cf48c9$var$INV_PHI, 0),
    /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699(-$e97a97f0b0cf48c9$var$PHI, $e97a97f0b0cf48c9$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $e97a97f0b0cf48c9$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._blurMaterial = $e97a97f0b0cf48c9$var$_getBlurShader($e97a97f0b0cf48c9$var$MAX_SAMPLES);
        this._equirectShader = null;
        this._cubemapShader = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $e97a97f0b0cf48c9$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets();
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapShader === null) {
            this._cubemapShader = $e97a97f0b0cf48c9$var$_getCubemapShader();
            this._compileMaterial(this._cubemapShader);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectShader === null) {
            this._equirectShader = $e97a97f0b0cf48c9$var$_getEquirectShader();
            this._compileMaterial(this._equirectShader);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        if (this._cubemapShader !== null) this._cubemapShader.dispose();
        if (this._equirectShader !== null) this._equirectShader.dispose();
        for(let i = 0; i < $e97a97f0b0cf48c9$var$_lodPlanes.length; i++)$e97a97f0b0cf48c9$var$_lodPlanes[i].dispose();
    }
    // private interface
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($e97a97f0b0cf48c9$var$_oldTarget);
        outputTarget.scissorTest = false;
        $e97a97f0b0cf48c9$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        $e97a97f0b0cf48c9$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets(texture);
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets(texture) {
        const params = {
            magFilter: $e97a97f0b0cf48c9$export$8a72f490b25c56c8,
            minFilter: $e97a97f0b0cf48c9$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $e97a97f0b0cf48c9$export$2697304443f382bc,
            format: $e97a97f0b0cf48c9$export$3f8bb04b555a363c,
            encoding: $e97a97f0b0cf48c9$export$7207336e4151a112,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $e97a97f0b0cf48c9$var$_createRenderTarget(params);
        cubeUVRenderTarget.depthBuffer = texture ? false : true;
        if (this._pingPongRenderTarget === null) this._pingPongRenderTarget = $e97a97f0b0cf48c9$var$_createRenderTarget(params);
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5($e97a97f0b0cf48c9$var$_lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $e97a97f0b0cf48c9$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($e97a97f0b0cf48c9$var$_clearColor);
        renderer.toneMapping = $e97a97f0b0cf48c9$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $e97a97f0b0cf48c9$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $e97a97f0b0cf48c9$export$e176487c05830cc5(new $e97a97f0b0cf48c9$export$ab3456a079aa7d80(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($e97a97f0b0cf48c9$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            $e97a97f0b0cf48c9$var$_setViewport(cubeUVRenderTarget, col * $e97a97f0b0cf48c9$var$SIZE_MAX, i > 2 ? $e97a97f0b0cf48c9$var$SIZE_MAX : 0, $e97a97f0b0cf48c9$var$SIZE_MAX, $e97a97f0b0cf48c9$var$SIZE_MAX);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $e97a97f0b0cf48c9$export$8759762a6477f2c4 || texture.mapping === $e97a97f0b0cf48c9$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapShader === null) this._cubemapShader = $e97a97f0b0cf48c9$var$_getCubemapShader();
            this._cubemapShader.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectShader === null) this._equirectShader = $e97a97f0b0cf48c9$var$_getEquirectShader();
        const material = isCubeTexture ? this._cubemapShader : this._equirectShader;
        const mesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5($e97a97f0b0cf48c9$var$_lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        if (!isCubeTexture) uniforms["texelSize"].value.set(1.0 / texture.image.width, 1.0 / texture.image.height);
        $e97a97f0b0cf48c9$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * $e97a97f0b0cf48c9$var$SIZE_MAX, 2 * $e97a97f0b0cf48c9$var$SIZE_MAX);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $e97a97f0b0cf48c9$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < $e97a97f0b0cf48c9$var$TOTAL_LODS; i++){
            const sigma = Math.sqrt($e97a97f0b0cf48c9$var$_sigmas[i] * $e97a97f0b0cf48c9$var$_sigmas[i] - $e97a97f0b0cf48c9$var$_sigmas[i - 1] * $e97a97f0b0cf48c9$var$_sigmas[i - 1]);
            const poleAxis = $e97a97f0b0cf48c9$var$_axisDirections[(i - 1) % $e97a97f0b0cf48c9$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5($e97a97f0b0cf48c9$var$_lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = $e97a97f0b0cf48c9$var$_sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $e97a97f0b0cf48c9$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $e97a97f0b0cf48c9$var$MAX_SAMPLES;
        if (samples > $e97a97f0b0cf48c9$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$e97a97f0b0cf48c9$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $e97a97f0b0cf48c9$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = $e97a97f0b0cf48c9$var$LOD_MAX - lodIn;
        const outputSize = $e97a97f0b0cf48c9$var$_sizeLods[lodOut];
        const x = 3 * Math.max(0, $e97a97f0b0cf48c9$var$SIZE_MAX - 2 * outputSize);
        const y = (lodOut === 0 ? 0 : 2 * $e97a97f0b0cf48c9$var$SIZE_MAX) + 2 * outputSize * (lodOut > $e97a97f0b0cf48c9$var$LOD_MAX - $e97a97f0b0cf48c9$var$LOD_MIN ? lodOut - $e97a97f0b0cf48c9$var$LOD_MAX + $e97a97f0b0cf48c9$var$LOD_MIN : 0);
        $e97a97f0b0cf48c9$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $e97a97f0b0cf48c9$var$_flatCamera);
    }
}
function $e97a97f0b0cf48c9$var$_createPlanes() {
    const _lodPlanes = [];
    const _sizeLods = [];
    const _sigmas = [];
    let lod = $e97a97f0b0cf48c9$var$LOD_MAX;
    for(let i = 0; i < $e97a97f0b0cf48c9$var$TOTAL_LODS; i++){
        const sizeLod = Math.pow(2, lod);
        _sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > $e97a97f0b0cf48c9$var$LOD_MAX - $e97a97f0b0cf48c9$var$LOD_MIN) sigma = $e97a97f0b0cf48c9$var$EXTRA_LOD_SIGMA[i - $e97a97f0b0cf48c9$var$LOD_MAX + $e97a97f0b0cf48c9$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        _sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 1);
        const min = -texelSize / 2;
        const max = 1 + texelSize / 2;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        planes.setAttribute("position", new $e97a97f0b0cf48c9$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $e97a97f0b0cf48c9$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $e97a97f0b0cf48c9$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        _lodPlanes.push(planes);
        if (lod > $e97a97f0b0cf48c9$var$LOD_MIN) lod--;
    }
    return {
        _lodPlanes: _lodPlanes,
        _sizeLods: _sizeLods,
        _sigmas: _sigmas
    };
}
function $e97a97f0b0cf48c9$var$_createRenderTarget(params) {
    const cubeUVRenderTarget = new $e97a97f0b0cf48c9$export$3c052beb2e51e23f(3 * $e97a97f0b0cf48c9$var$SIZE_MAX, 3 * $e97a97f0b0cf48c9$var$SIZE_MAX, params);
    cubeUVRenderTarget.texture.mapping = $e97a97f0b0cf48c9$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $e97a97f0b0cf48c9$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $e97a97f0b0cf48c9$var$_getBlurShader(maxSamples) {
    const weights = new Float32Array(maxSamples);
    const poleAxis = new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $e97a97f0b0cf48c9$export$21c421a2e1df9d22({
        name: "SphericalGaussianBlur",
        defines: {
            "n": maxSamples
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $e97a97f0b0cf48c9$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $e97a97f0b0cf48c9$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $e97a97f0b0cf48c9$var$_getEquirectShader() {
    const texelSize = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
    const shaderMaterial = new $e97a97f0b0cf48c9$export$21c421a2e1df9d22({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "texelSize": {
                value: texelSize
            }
        },
        vertexShader: $e97a97f0b0cf48c9$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform vec2 texelSize;

			#include <common>

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				vec2 f = fract( uv / texelSize - 0.5 );
				uv -= f * texelSize;
				vec3 tl = texture2D ( envMap, uv ).rgb;
				uv.x += texelSize.x;
				vec3 tr = texture2D ( envMap, uv ).rgb;
				uv.y += texelSize.y;
				vec3 br = texture2D ( envMap, uv ).rgb;
				uv.x -= texelSize.x;
				vec3 bl = texture2D ( envMap, uv ).rgb;

				vec3 tm = mix( tl, tr, f.x );
				vec3 bm = mix( bl, br, f.x );
				gl_FragColor.rgb = mix( tm, bm, f.y );

			}
		`,
        blending: $e97a97f0b0cf48c9$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $e97a97f0b0cf48c9$var$_getCubemapShader() {
    const shaderMaterial = new $e97a97f0b0cf48c9$export$21c421a2e1df9d22({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $e97a97f0b0cf48c9$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $e97a97f0b0cf48c9$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $e97a97f0b0cf48c9$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute vec3 position;
		attribute vec2 uv;
		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $e97a97f0b0cf48c9$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $e97a97f0b0cf48c9$export$d64030b316d3b087 || mapping === $e97a97f0b0cf48c9$export$ee99d97d46898098;
            const isCubeMap = mapping === $e97a97f0b0cf48c9$export$8759762a6477f2c4 || mapping === $e97a97f0b0cf48c9$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $e97a97f0b0cf48c9$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $e97a97f0b0cf48c9$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $e97a97f0b0cf48c9$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $e97a97f0b0cf48c9$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($e97a97f0b0cf48c9$var$arrayNeedsUint32(indices) ? $e97a97f0b0cf48c9$export$7eb8c9fa25cd5bd6 : $e97a97f0b0cf48c9$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $e97a97f0b0cf48c9$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $e97a97f0b0cf48c9$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
class $e97a97f0b0cf48c9$export$e38bf4541665bbbd extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0;
        this.minFilter = $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0;
        this.wrapR = $e97a97f0b0cf48c9$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
$e97a97f0b0cf48c9$export$e38bf4541665bbbd.prototype.isDataTexture2DArray = true;
function $e97a97f0b0cf48c9$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $e97a97f0b0cf48c9$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $e97a97f0b0cf48c9$var$denormalize(morph, attribute) {
    let denominator = 1;
    const array = attribute.isInterleavedBufferAttribute ? attribute.data.array : attribute.array;
    if (array instanceof Int8Array) denominator = 127;
    else if (array instanceof Int16Array) denominator = 32767;
    else if (array instanceof Int32Array) denominator = 2147483647;
    else console.error("THREE.WebGLMorphtargets: Unsupported morph attribute data type: ", array);
    morph.divideScalar(denominator);
}
function $e97a97f0b0cf48c9$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const numberOfMorphTargets = geometry.morphAttributes.position.length;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== numberOfMorphTargets) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const morphTargets = geometry.morphAttributes.position;
                const morphNormals = geometry.morphAttributes.normal || [];
                const numberOfVertices = geometry.attributes.position.count;
                const numberOfVertexData = hasMorphNormals === true ? 2 : 1; // (v,n) vs. (v)
                let width = numberOfVertices * numberOfVertexData;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * numberOfMorphTargets);
                const texture = new $e97a97f0b0cf48c9$export$e38bf4541665bbbd(buffer, width, height, numberOfMorphTargets);
                texture.format = $e97a97f0b0cf48c9$export$3f8bb04b555a363c; // using RGBA since RGB might be emulated (and is thus slower)
                texture.type = $e97a97f0b0cf48c9$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = numberOfVertexData * 4;
                for(let i = 0; i < numberOfMorphTargets; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        morph.fromBufferAttribute(morphTarget, j);
                        if (morphTarget.normalized === true) $e97a97f0b0cf48c9$var$denormalize(morph, morphTarget);
                        const stride = j * vertexDataStride;
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            if (morphNormal.normalized === true) $e97a97f0b0cf48c9$var$denormalize(morph, morphNormal);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                    }
                }
                entry = {
                    count: numberOfMorphTargets,
                    texture: texture,
                    size: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($e97a97f0b0cf48c9$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($e97a97f0b0cf48c9$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $e97a97f0b0cf48c9$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
class $e97a97f0b0cf48c9$export$ef03cdc98340bab4 extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0;
        this.minFilter = $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0;
        this.wrapR = $e97a97f0b0cf48c9$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
$e97a97f0b0cf48c9$export$ef03cdc98340bab4.prototype.isDataTexture3D = true;
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $e97a97f0b0cf48c9$var$emptyTexture = new $e97a97f0b0cf48c9$export$5431306cf43de24a();
const $e97a97f0b0cf48c9$var$emptyTexture2dArray = new $e97a97f0b0cf48c9$export$e38bf4541665bbbd();
const $e97a97f0b0cf48c9$var$emptyTexture3d = new $e97a97f0b0cf48c9$export$ef03cdc98340bab4();
const $e97a97f0b0cf48c9$var$emptyCubeTexture = new $e97a97f0b0cf48c9$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $e97a97f0b0cf48c9$var$arrayCacheF32 = [];
const $e97a97f0b0cf48c9$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $e97a97f0b0cf48c9$var$mat4array = new Float32Array(16);
const $e97a97f0b0cf48c9$var$mat3array = new Float32Array(9);
const $e97a97f0b0cf48c9$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $e97a97f0b0cf48c9$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $e97a97f0b0cf48c9$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $e97a97f0b0cf48c9$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $e97a97f0b0cf48c9$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $e97a97f0b0cf48c9$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $e97a97f0b0cf48c9$var$allocTexUnits(textures, n) {
    let r = $e97a97f0b0cf48c9$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $e97a97f0b0cf48c9$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $e97a97f0b0cf48c9$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $e97a97f0b0cf48c9$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $e97a97f0b0cf48c9$var$copyArray(cache, v);
    }
}
function $e97a97f0b0cf48c9$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $e97a97f0b0cf48c9$var$copyArray(cache, v);
    }
}
function $e97a97f0b0cf48c9$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $e97a97f0b0cf48c9$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $e97a97f0b0cf48c9$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $e97a97f0b0cf48c9$var$copyArray(cache, v);
    } else {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, elements)) return;
        $e97a97f0b0cf48c9$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $e97a97f0b0cf48c9$var$mat2array);
        $e97a97f0b0cf48c9$var$copyArray(cache, elements);
    }
}
function $e97a97f0b0cf48c9$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $e97a97f0b0cf48c9$var$copyArray(cache, v);
    } else {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, elements)) return;
        $e97a97f0b0cf48c9$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $e97a97f0b0cf48c9$var$mat3array);
        $e97a97f0b0cf48c9$var$copyArray(cache, elements);
    }
}
function $e97a97f0b0cf48c9$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $e97a97f0b0cf48c9$var$copyArray(cache, v);
    } else {
        if ($e97a97f0b0cf48c9$var$arraysEqual(cache, elements)) return;
        $e97a97f0b0cf48c9$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $e97a97f0b0cf48c9$var$mat4array);
        $e97a97f0b0cf48c9$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $e97a97f0b0cf48c9$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array)
function $e97a97f0b0cf48c9$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    $e97a97f0b0cf48c9$var$copyArray(cache, v);
}
function $e97a97f0b0cf48c9$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    $e97a97f0b0cf48c9$var$copyArray(cache, v);
}
function $e97a97f0b0cf48c9$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    $e97a97f0b0cf48c9$var$copyArray(cache, v);
}
// Single unsigned integer
function $e97a97f0b0cf48c9$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array)
function $e97a97f0b0cf48c9$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    $e97a97f0b0cf48c9$var$copyArray(cache, v);
}
function $e97a97f0b0cf48c9$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    $e97a97f0b0cf48c9$var$copyArray(cache, v);
}
function $e97a97f0b0cf48c9$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if ($e97a97f0b0cf48c9$var$arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    $e97a97f0b0cf48c9$var$copyArray(cache, v);
}
// Single texture (2D / Cube)
function $e97a97f0b0cf48c9$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTexture2D(v || $e97a97f0b0cf48c9$var$emptyTexture, unit);
}
function $e97a97f0b0cf48c9$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $e97a97f0b0cf48c9$var$emptyTexture3d, unit);
}
function $e97a97f0b0cf48c9$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTextureCube(v || $e97a97f0b0cf48c9$var$emptyCubeTexture, unit);
}
function $e97a97f0b0cf48c9$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $e97a97f0b0cf48c9$var$emptyTexture2dArray, unit);
}
// Helper to pick the right setter for the singular case
function $e97a97f0b0cf48c9$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $e97a97f0b0cf48c9$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $e97a97f0b0cf48c9$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $e97a97f0b0cf48c9$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $e97a97f0b0cf48c9$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $e97a97f0b0cf48c9$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $e97a97f0b0cf48c9$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $e97a97f0b0cf48c9$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $e97a97f0b0cf48c9$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $e97a97f0b0cf48c9$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $e97a97f0b0cf48c9$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $e97a97f0b0cf48c9$var$setValueV4i; // _VEC4
        case 0x1405:
            return $e97a97f0b0cf48c9$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $e97a97f0b0cf48c9$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $e97a97f0b0cf48c9$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $e97a97f0b0cf48c9$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $e97a97f0b0cf48c9$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $e97a97f0b0cf48c9$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $e97a97f0b0cf48c9$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $e97a97f0b0cf48c9$var$setValueT2DArray1;
    }
}
// Array of scalars
function $e97a97f0b0cf48c9$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $e97a97f0b0cf48c9$var$setValueV2fArray(gl, v) {
    const data = $e97a97f0b0cf48c9$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $e97a97f0b0cf48c9$var$setValueV3fArray(gl, v) {
    const data = $e97a97f0b0cf48c9$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $e97a97f0b0cf48c9$var$setValueV4fArray(gl, v) {
    const data = $e97a97f0b0cf48c9$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $e97a97f0b0cf48c9$var$setValueM2Array(gl, v) {
    const data = $e97a97f0b0cf48c9$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $e97a97f0b0cf48c9$var$setValueM3Array(gl, v) {
    const data = $e97a97f0b0cf48c9$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $e97a97f0b0cf48c9$var$setValueM4Array(gl, v) {
    const data = $e97a97f0b0cf48c9$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $e97a97f0b0cf48c9$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $e97a97f0b0cf48c9$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $e97a97f0b0cf48c9$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $e97a97f0b0cf48c9$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $e97a97f0b0cf48c9$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $e97a97f0b0cf48c9$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $e97a97f0b0cf48c9$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $e97a97f0b0cf48c9$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $e97a97f0b0cf48c9$var$setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = $e97a97f0b0cf48c9$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTexture2D(v[i] || $e97a97f0b0cf48c9$var$emptyTexture, units[i]);
}
function $e97a97f0b0cf48c9$var$setValueT3DArray(gl, v, textures) {
    const n = v.length;
    const units = $e97a97f0b0cf48c9$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $e97a97f0b0cf48c9$var$emptyTexture3d, units[i]);
}
function $e97a97f0b0cf48c9$var$setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = $e97a97f0b0cf48c9$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTextureCube(v[i] || $e97a97f0b0cf48c9$var$emptyCubeTexture, units[i]);
}
function $e97a97f0b0cf48c9$var$setValueT2DArrayArray(gl, v, textures) {
    const n = v.length;
    const units = $e97a97f0b0cf48c9$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $e97a97f0b0cf48c9$var$emptyTexture2dArray, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $e97a97f0b0cf48c9$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $e97a97f0b0cf48c9$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $e97a97f0b0cf48c9$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $e97a97f0b0cf48c9$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $e97a97f0b0cf48c9$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $e97a97f0b0cf48c9$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $e97a97f0b0cf48c9$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $e97a97f0b0cf48c9$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $e97a97f0b0cf48c9$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $e97a97f0b0cf48c9$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $e97a97f0b0cf48c9$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $e97a97f0b0cf48c9$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $e97a97f0b0cf48c9$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $e97a97f0b0cf48c9$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $e97a97f0b0cf48c9$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $e97a97f0b0cf48c9$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $e97a97f0b0cf48c9$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $e97a97f0b0cf48c9$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $e97a97f0b0cf48c9$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $e97a97f0b0cf48c9$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
function $e97a97f0b0cf48c9$var$SingleUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.setValue = $e97a97f0b0cf48c9$var$getSingularSetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
function $e97a97f0b0cf48c9$var$PureArrayUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.size = activeInfo.size;
    this.setValue = $e97a97f0b0cf48c9$var$getPureArraySetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
$e97a97f0b0cf48c9$var$PureArrayUniform.prototype.updateCache = function(data) {
    const cache = this.cache;
    if (data instanceof Float32Array && cache.length !== data.length) this.cache = new Float32Array(data.length);
    $e97a97f0b0cf48c9$var$copyArray(cache, data);
};
function $e97a97f0b0cf48c9$var$StructuredUniform(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
}
$e97a97f0b0cf48c9$var$StructuredUniform.prototype.setValue = function(gl, value, textures) {
    const seq = this.seq;
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        u.setValue(gl, value[u.id], textures);
    }
};
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $e97a97f0b0cf48c9$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $e97a97f0b0cf48c9$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $e97a97f0b0cf48c9$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $e97a97f0b0cf48c9$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $e97a97f0b0cf48c9$var$RePathPart.exec(path), matchEnd = $e97a97f0b0cf48c9$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $e97a97f0b0cf48c9$var$addUniform(container, subscript === undefined ? new $e97a97f0b0cf48c9$var$SingleUniform(id, activeInfo, addr) : new $e97a97f0b0cf48c9$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $e97a97f0b0cf48c9$var$StructuredUniform(id);
                $e97a97f0b0cf48c9$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
function $e97a97f0b0cf48c9$var$WebGLUniforms(gl, program) {
    this.seq = [];
    this.map = {};
    const n = gl.getProgramParameter(program, 35718);
    for(let i = 0; i < n; ++i){
        const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
        $e97a97f0b0cf48c9$var$parseUniform(info, addr, this);
    }
}
$e97a97f0b0cf48c9$var$WebGLUniforms.prototype.setValue = function(gl, name, value, textures) {
    const u = this.map[name];
    if (u !== undefined) u.setValue(gl, value, textures);
};
$e97a97f0b0cf48c9$var$WebGLUniforms.prototype.setOptional = function(gl, object, name) {
    const v = object[name];
    if (v !== undefined) this.setValue(gl, name, v);
};
// Static interface
$e97a97f0b0cf48c9$var$WebGLUniforms.upload = function(gl, seq, values, textures) {
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i], v = values[u.id];
        if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
        u.setValue(gl, v.value, textures);
    }
};
$e97a97f0b0cf48c9$var$WebGLUniforms.seqWithValue = function(seq, values) {
    const r = [];
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        if (u.id in values) r.push(u);
    }
    return r;
};
function $e97a97f0b0cf48c9$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $e97a97f0b0cf48c9$var$programIdCount = 0;
function $e97a97f0b0cf48c9$var$addLineNumbers(string) {
    const lines = string.split("\n");
    for(let i = 0; i < lines.length; i++)lines[i] = i + 1 + ": " + lines[i];
    return lines.join("\n");
}
function $e97a97f0b0cf48c9$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $e97a97f0b0cf48c9$export$7207336e4151a112:
            return [
                "Linear",
                "( value )"
            ];
        case $e97a97f0b0cf48c9$export$f32388edbb32674:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported encoding:", encoding);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $e97a97f0b0cf48c9$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    // --enable-privileged-webgl-extension
    // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
    return type.toUpperCase() + "\n\n" + errors + "\n\n" + $e97a97f0b0cf48c9$var$addLineNumbers(gl.getShaderSource(shader));
}
function $e97a97f0b0cf48c9$var$getTexelEncodingFunction(functionName, encoding) {
    const components = $e97a97f0b0cf48c9$var$getEncodingComponents(encoding);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $e97a97f0b0cf48c9$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $e97a97f0b0cf48c9$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $e97a97f0b0cf48c9$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $e97a97f0b0cf48c9$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $e97a97f0b0cf48c9$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $e97a97f0b0cf48c9$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $e97a97f0b0cf48c9$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($e97a97f0b0cf48c9$var$filterEmptyLine).join("\n");
}
function $e97a97f0b0cf48c9$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $e97a97f0b0cf48c9$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === 35674) locationSize = 2;
        if (info.type === 35675) locationSize = 3;
        if (info.type === 35676) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $e97a97f0b0cf48c9$var$filterEmptyLine(string) {
    return string !== "";
}
function $e97a97f0b0cf48c9$var$replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $e97a97f0b0cf48c9$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $e97a97f0b0cf48c9$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $e97a97f0b0cf48c9$var$resolveIncludes(string) {
    return string.replace($e97a97f0b0cf48c9$var$includePattern, $e97a97f0b0cf48c9$var$includeReplacer);
}
function $e97a97f0b0cf48c9$var$includeReplacer(match, include) {
    const string = $e97a97f0b0cf48c9$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error("Can not resolve #include <" + include + ">");
    return $e97a97f0b0cf48c9$var$resolveIncludes(string);
}
// Unroll Loops
const $e97a97f0b0cf48c9$var$deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const $e97a97f0b0cf48c9$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $e97a97f0b0cf48c9$var$unrollLoops(string) {
    return string.replace($e97a97f0b0cf48c9$var$unrollLoopPattern, $e97a97f0b0cf48c9$var$loopReplacer).replace($e97a97f0b0cf48c9$var$deprecatedUnrollLoopPattern, $e97a97f0b0cf48c9$var$deprecatedLoopReplacer);
}
function $e97a97f0b0cf48c9$var$deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.");
    return $e97a97f0b0cf48c9$var$loopReplacer(match, start, end, snippet);
}
function $e97a97f0b0cf48c9$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $e97a97f0b0cf48c9$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $e97a97f0b0cf48c9$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $e97a97f0b0cf48c9$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $e97a97f0b0cf48c9$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $e97a97f0b0cf48c9$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $e97a97f0b0cf48c9$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $e97a97f0b0cf48c9$export$8759762a6477f2c4:
        case $e97a97f0b0cf48c9$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $e97a97f0b0cf48c9$export$dbf3e70ff37af79:
        case $e97a97f0b0cf48c9$export$76a9f4355364345c:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $e97a97f0b0cf48c9$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $e97a97f0b0cf48c9$export$dc59f8aed047f61d:
        case $e97a97f0b0cf48c9$export$76a9f4355364345c:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $e97a97f0b0cf48c9$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $e97a97f0b0cf48c9$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $e97a97f0b0cf48c9$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $e97a97f0b0cf48c9$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $e97a97f0b0cf48c9$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $e97a97f0b0cf48c9$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $e97a97f0b0cf48c9$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $e97a97f0b0cf48c9$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $e97a97f0b0cf48c9$var$generateEnvMapBlendingDefine(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $e97a97f0b0cf48c9$var$generateExtensions(parameters);
    const customDefines = $e97a97f0b0cf48c9$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($e97a97f0b0cf48c9$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($e97a97f0b0cf48c9$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $e97a97f0b0cf48c9$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
            "#define MAX_BONES " + parameters.maxBones,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
            parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.displacementMap && parameters.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs ? "#define USE_UV" : "",
            parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.useVertexTexture ? "#define BONE_TEXTURE" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphTargets && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargets && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($e97a97f0b0cf48c9$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $e97a97f0b0cf48c9$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
            parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUvs ? "#define USE_UV" : "",
            parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? "#define TEXTURE_LOD_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $e97a97f0b0cf48c9$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $e97a97f0b0cf48c9$export$9fcb6b4294603b2 ? $e97a97f0b0cf48c9$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $e97a97f0b0cf48c9$export$9fcb6b4294603b2 ? $e97a97f0b0cf48c9$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.transparent ? "" : "#define OPAQUE",
            $e97a97f0b0cf48c9$export$955f9f2e84c43c8b["encodings_pars_fragment"],
            $e97a97f0b0cf48c9$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputEncoding),
            parameters.depthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($e97a97f0b0cf48c9$var$filterEmptyLine).join("\n");
    }
    vertexShader = $e97a97f0b0cf48c9$var$resolveIncludes(vertexShader);
    vertexShader = $e97a97f0b0cf48c9$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $e97a97f0b0cf48c9$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $e97a97f0b0cf48c9$var$resolveIncludes(fragmentShader);
    fragmentShader = $e97a97f0b0cf48c9$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $e97a97f0b0cf48c9$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $e97a97f0b0cf48c9$var$unrollLoops(vertexShader);
    fragmentShader = $e97a97f0b0cf48c9$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $e97a97f0b0cf48c9$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $e97a97f0b0cf48c9$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $e97a97f0b0cf48c9$var$WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = $e97a97f0b0cf48c9$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = $e97a97f0b0cf48c9$var$getShaderErrors(gl, glVertexShader, "vertex");
            const fragmentErrors = $e97a97f0b0cf48c9$var$getShaderErrors(gl, glFragmentShader, "fragment");
            console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, 35715) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $e97a97f0b0cf48c9$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $e97a97f0b0cf48c9$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $e97a97f0b0cf48c9$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $e97a97f0b0cf48c9$var$_id = 0;
class $e97a97f0b0cf48c9$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        if (cache.has(material) === false) cache.set(material, new Set());
        return cache.get(material);
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        if (cache.has(code) === false) {
            const stage = new $e97a97f0b0cf48c9$var$WebGLShaderStage();
            cache.set(code, stage);
        }
        return cache.get(code);
    }
}
class $e97a97f0b0cf48c9$var$WebGLShaderStage {
    constructor(){
        this.id = $e97a97f0b0cf48c9$var$_id++;
        this.usedTimes = 0;
    }
}
function $e97a97f0b0cf48c9$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $e97a97f0b0cf48c9$export$89312ce47c0ca777();
    const _customShaders = new $e97a97f0b0cf48c9$var$WebGLShaderCache();
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const floatVertexTextures = capabilities.floatVertexTextures;
    const maxVertexUniforms = capabilities.maxVertexUniforms;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getMaxBones(object) {
        const skeleton = object.skeleton;
        const bones = skeleton.bones;
        if (floatVertexTextures) return 1024;
        else {
            // default for when object is not specified
            // ( for example when prebuilding shader to be used with multiple objects )
            //
            //  - leave some extra space for other uniforms
            //  - limit here is ANGLE's 254 max uniform vectors
            //    (up to 54 should be safe)
            const nVertexUniforms = maxVertexUniforms;
            const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
            const maxBones = Math.min(nVertexMatrices, bones.length);
            if (maxBones < bones.length) {
                console.warn("THREE.WebGLRenderer: Skeleton has " + bones.length + " bones. This GPU supports " + maxBones + ".");
                return 0;
            }
            return maxBones;
        }
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        const maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $e97a97f0b0cf48c9$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const useAlphaTest = material.alphaTest > 0;
        const useClearcoat = material.clearcoat > 0;
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : $e97a97f0b0cf48c9$export$7207336e4151a112,
            map: !!material.map,
            matcap: !!material.matcap,
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapCubeUV: !!envMap && (envMap.mapping === $e97a97f0b0cf48c9$export$dbf3e70ff37af79 || envMap.mapping === $e97a97f0b0cf48c9$export$76a9f4355364345c),
            lightMap: !!material.lightMap,
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === $e97a97f0b0cf48c9$export$9990ad26f9db5b2c,
            tangentSpaceNormalMap: material.normalMapType === $e97a97f0b0cf48c9$export$2852a58ebdac27b8,
            decodeVideoTexture: !!material.map && material.map.isVideoTexture === true && material.map.encoding === $e97a97f0b0cf48c9$export$f32388edbb32674,
            clearcoat: useClearcoat,
            clearcoatMap: useClearcoat && !!material.clearcoatMap,
            clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            specularIntensityMap: !!material.specularIntensityMap,
            specularColorMap: !!material.specularColorMap,
            transparent: material.transparent,
            alphaMap: !!material.alphaMap,
            alphaTest: useAlphaTest,
            gradientMap: !!material.gradientMap,
            sheen: material.sheen > 0,
            sheenColorMap: !!material.sheenColorMap,
            sheenRoughnessMap: !!material.sheenRoughnessMap,
            transmission: material.transmission > 0,
            transmissionMap: !!material.transmissionMap,
            thicknessMap: !!material.thicknessMap,
            combine: material.combine,
            vertexTangents: !!material.normalMap && !!object.geometry && !!object.geometry.attributes.tangent,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!object.geometry && !!object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || !!material.sheenColorMap || !!material.sheenRoughnessMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || material.sheen > 0 || !!material.sheenColorMap || !!material.sheenRoughnessMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog,
            fogExp2: fog && fog.isFogExp2,
            flatShading: !!material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true && maxBones > 0,
            maxBones: maxBones,
            useVertexTexture: floatVertexTextures,
            morphTargets: !!object.geometry && !!object.geometry.morphAttributes.position,
            morphNormals: !!object.geometry && !!object.geometry.morphAttributes.normal,
            morphTargetsCount: !!object.geometry && !!object.geometry.morphAttributes.position ? object.geometry.morphAttributes.position.length : 0,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $e97a97f0b0cf48c9$export$9fcb6b4294603b2,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $e97a97f0b0cf48c9$export$3b296b6f144d5b03,
            flipSided: material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace,
            depthPacking: material.depthPacking !== undefined ? material.depthPacking : false,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputEncoding);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputEncoding);
        array.push(parameters.envMapMode);
        array.push(parameters.combine);
        array.push(parameters.vertexUvs);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.maxBones);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.map) _programLayers.enable(4);
        if (parameters.matcap) _programLayers.enable(5);
        if (parameters.envMap) _programLayers.enable(6);
        if (parameters.envMapCubeUV) _programLayers.enable(7);
        if (parameters.lightMap) _programLayers.enable(8);
        if (parameters.aoMap) _programLayers.enable(9);
        if (parameters.emissiveMap) _programLayers.enable(10);
        if (parameters.bumpMap) _programLayers.enable(11);
        if (parameters.normalMap) _programLayers.enable(12);
        if (parameters.objectSpaceNormalMap) _programLayers.enable(13);
        if (parameters.tangentSpaceNormalMap) _programLayers.enable(14);
        if (parameters.clearcoat) _programLayers.enable(15);
        if (parameters.clearcoatMap) _programLayers.enable(16);
        if (parameters.clearcoatRoughnessMap) _programLayers.enable(17);
        if (parameters.clearcoatNormalMap) _programLayers.enable(18);
        if (parameters.displacementMap) _programLayers.enable(19);
        if (parameters.specularMap) _programLayers.enable(20);
        if (parameters.roughnessMap) _programLayers.enable(21);
        if (parameters.metalnessMap) _programLayers.enable(22);
        if (parameters.gradientMap) _programLayers.enable(23);
        if (parameters.alphaMap) _programLayers.enable(24);
        if (parameters.alphaTest) _programLayers.enable(25);
        if (parameters.vertexColors) _programLayers.enable(26);
        if (parameters.vertexAlphas) _programLayers.enable(27);
        if (parameters.vertexUvs) _programLayers.enable(28);
        if (parameters.vertexTangents) _programLayers.enable(29);
        if (parameters.uvsVertexOnly) _programLayers.enable(30);
        if (parameters.fog) _programLayers.enable(31);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.useFog) _programLayers.enable(0);
        if (parameters.flatShading) _programLayers.enable(1);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(2);
        if (parameters.skinning) _programLayers.enable(3);
        if (parameters.useVertexTexture) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.premultipliedAlpha) _programLayers.enable(7);
        if (parameters.shadowMapEnabled) _programLayers.enable(8);
        if (parameters.physicallyCorrectLights) _programLayers.enable(9);
        if (parameters.doubleSided) _programLayers.enable(10);
        if (parameters.flipSided) _programLayers.enable(11);
        if (parameters.depthPacking) _programLayers.enable(12);
        if (parameters.dithering) _programLayers.enable(13);
        if (parameters.specularIntensityMap) _programLayers.enable(14);
        if (parameters.specularColorMap) _programLayers.enable(15);
        if (parameters.transmission) _programLayers.enable(16);
        if (parameters.transmissionMap) _programLayers.enable(17);
        if (parameters.thicknessMap) _programLayers.enable(18);
        if (parameters.sheen) _programLayers.enable(19);
        if (parameters.sheenColorMap) _programLayers.enable(20);
        if (parameters.sheenRoughnessMap) _programLayers.enable(21);
        if (parameters.decodeVideoTexture) _programLayers.enable(22);
        if (parameters.transparent) _programLayers.enable(23);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $e97a97f0b0cf48c9$export$bee4a7d47f8f5014[shaderID];
            uniforms = $e97a97f0b0cf48c9$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $e97a97f0b0cf48c9$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $e97a97f0b0cf48c9$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $e97a97f0b0cf48c9$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $e97a97f0b0cf48c9$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $e97a97f0b0cf48c9$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $e97a97f0b0cf48c9$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $e97a97f0b0cf48c9$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $e97a97f0b0cf48c9$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $e97a97f0b0cf48c9$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        let list;
        if (lists.has(scene) === false) {
            list = new $e97a97f0b0cf48c9$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= lists.get(scene).length) {
            list = new $e97a97f0b0cf48c9$var$WebGLRenderList();
            lists.get(scene).push(list);
        } else list = lists.get(scene)[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $e97a97f0b0cf48c9$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
                        color: new $e97a97f0b0cf48c9$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
                        direction: new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
                        color: new $e97a97f0b0cf48c9$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
                        color: new $e97a97f0b0cf48c9$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
                        skyColor: new $e97a97f0b0cf48c9$export$892596cec99bc70e(),
                        groundColor: new $e97a97f0b0cf48c9$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $e97a97f0b0cf48c9$export$892596cec99bc70e(),
                        position: new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
                        halfWidth: new $e97a97f0b0cf48c9$export$64b5c384219d3699(),
                        halfHeight: new $e97a97f0b0cf48c9$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $e97a97f0b0cf48c9$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $e97a97f0b0cf48c9$var$nextVersion = 0;
function $e97a97f0b0cf48c9$var$shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function $e97a97f0b0cf48c9$var$WebGLLights(extensions, capabilities) {
    const cache = new $e97a97f0b0cf48c9$var$UniformsCache();
    const shadowCache = $e97a97f0b0cf48c9$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $e97a97f0b0cf48c9$export$64b5c384219d3699());
    const vector3 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
    const matrix4 = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
    const matrix42 = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
    function setup(lights, physicallyCorrectLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        lights.sort($e97a97f0b0cf48c9$var$shadowCastingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms;
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $e97a97f0b0cf48c9$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $e97a97f0b0cf48c9$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $e97a97f0b0cf48c9$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $e97a97f0b0cf48c9$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $e97a97f0b0cf48c9$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $e97a97f0b0cf48c9$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = $e97a97f0b0cf48c9$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                uniforms.direction.normalize();
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $e97a97f0b0cf48c9$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $e97a97f0b0cf48c9$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(physicallyCorrectLights) {
        lights.setup(lightsArray, physicallyCorrectLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $e97a97f0b0cf48c9$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        let renderState;
        if (renderStates.has(scene) === false) {
            renderState = new $e97a97f0b0cf48c9$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new $e97a97f0b0cf48c9$var$WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
/**
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */ class $e97a97f0b0cf48c9$export$2698c22ec13825db extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshDepthMaterial";
        this.depthPacking = $e97a97f0b0cf48c9$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
$e97a97f0b0cf48c9$export$2698c22ec13825db.prototype.isMeshDepthMaterial = true;
/**
 * parameters = {
 *
 *  referencePosition: <float>,
 *  nearDistance: <float>,
 *  farDistance: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>
 *
 * }
 */ class $e97a97f0b0cf48c9$export$33e187ed002f2a19 extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshDistanceMaterial";
        this.referencePosition = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        this.nearDistance = 1;
        this.farDistance = 1000;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.fog = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.referencePosition.copy(source.referencePosition);
        this.nearDistance = source.nearDistance;
        this.farDistance = source.farDistance;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
$e97a97f0b0cf48c9$export$33e187ed002f2a19.prototype.isMeshDistanceMaterial = true;
const $e97a97f0b0cf48c9$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $e97a97f0b0cf48c9$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $e97a97f0b0cf48c9$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $e97a97f0b0cf48c9$export$35efe6f4c85463d2();
    const _shadowMapSize = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), _viewportSize = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), _viewport = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(), _depthMaterial = new $e97a97f0b0cf48c9$export$2698c22ec13825db({
        depthPacking: $e97a97f0b0cf48c9$export$8f910f4c4f73df11
    }), _distanceMaterial = new $e97a97f0b0cf48c9$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        0: $e97a97f0b0cf48c9$export$d9f0486e75b5ace,
        1: $e97a97f0b0cf48c9$export$2ede184fc2998901,
        2: $e97a97f0b0cf48c9$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $e97a97f0b0cf48c9$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $e97a97f0b0cf48c9$var$vertex,
        fragmentShader: $e97a97f0b0cf48c9$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $e97a97f0b0cf48c9$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $e97a97f0b0cf48c9$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($e97a97f0b0cf48c9$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null && !shadow.isPointLightShadow && this.type === $e97a97f0b0cf48c9$export$896ae1ade6c829c4) {
                const pars = {
                    minFilter: $e97a97f0b0cf48c9$export$8a72f490b25c56c8,
                    magFilter: $e97a97f0b0cf48c9$export$8a72f490b25c56c8,
                    format: $e97a97f0b0cf48c9$export$3f8bb04b555a363c
                };
                shadow.map = new $e97a97f0b0cf48c9$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.mapPass = new $e97a97f0b0cf48c9$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.camera.updateProjectionMatrix();
            }
            if (shadow.map === null) {
                const pars = {
                    minFilter: $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0,
                    magFilter: $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0,
                    format: $e97a97f0b0cf48c9$export$3f8bb04b555a363c
                };
                shadow.map = new $e97a97f0b0cf48c9$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (!shadow.isPointLightShadow && this.type === $e97a97f0b0cf48c9$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $e97a97f0b0cf48c9$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $e97a97f0b0cf48c9$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $e97a97f0b0cf48c9$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case $e97a97f0b0cf48c9$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $e97a97f0b0cf48c9$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $e97a97f0b0cf48c9$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $e97a97f0b0cf48c9$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $e97a97f0b0cf48c9$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $e97a97f0b0cf48c9$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $e97a97f0b0cf48c9$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $e97a97f0b0cf48c9$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(3088);
    const viewportParam = gl.getParameter(2978);
    const currentScissor = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($e97a97f0b0cf48c9$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($e97a97f0b0cf48c9$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($e97a97f0b0cf48c9$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = 36064 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== 36064) {
                drawBuffers[0] = 36064;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== 1029) {
            drawBuffers[0] = 1029;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$e97a97f0b0cf48c9$export$20183a0484ce21a0]: 32774,
        [$e97a97f0b0cf48c9$export$73e0df5177988548]: 32778,
        [$e97a97f0b0cf48c9$export$28e582859cbec660]: 32779
    };
    if (isWebGL2) {
        equationToGL[$e97a97f0b0cf48c9$export$c8c1508da8d0600c] = 32775;
        equationToGL[$e97a97f0b0cf48c9$export$99948c02fb51055f] = 32776;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$e97a97f0b0cf48c9$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$e97a97f0b0cf48c9$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$e97a97f0b0cf48c9$export$2110f05edf778d3d]: 0,
        [$e97a97f0b0cf48c9$export$8805bad65e24940e]: 1,
        [$e97a97f0b0cf48c9$export$7fbe15b28d28cf52]: 768,
        [$e97a97f0b0cf48c9$export$d5773124e86cf28c]: 770,
        [$e97a97f0b0cf48c9$export$c05e2a1fc8609506]: 776,
        [$e97a97f0b0cf48c9$export$ef5f2dd8ffac5574]: 774,
        [$e97a97f0b0cf48c9$export$a78aed1ca2a87192]: 772,
        [$e97a97f0b0cf48c9$export$947829af9f2c17f6]: 769,
        [$e97a97f0b0cf48c9$export$11d468cc7f19e971]: 771,
        [$e97a97f0b0cf48c9$export$56b85b2686ab16]: 775,
        [$e97a97f0b0cf48c9$export$5d0fe17fd8773bac]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $e97a97f0b0cf48c9$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $e97a97f0b0cf48c9$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $e97a97f0b0cf48c9$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $e97a97f0b0cf48c9$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $e97a97f0b0cf48c9$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $e97a97f0b0cf48c9$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $e97a97f0b0cf48c9$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $e97a97f0b0cf48c9$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $e97a97f0b0cf48c9$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $e97a97f0b0cf48c9$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $e97a97f0b0cf48c9$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $e97a97f0b0cf48c9$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $e97a97f0b0cf48c9$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $e97a97f0b0cf48c9$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $e97a97f0b0cf48c9$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        let flipSided = material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $e97a97f0b0cf48c9$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($e97a97f0b0cf48c9$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $e97a97f0b0cf48c9$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $e97a97f0b0cf48c9$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $e97a97f0b0cf48c9$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $e97a97f0b0cf48c9$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const hasMultisampledRenderToTexture = extensions.has("WEBGL_multisampled_render_to_texture");
    const MultisampledRenderToTextureExtension = hasMultisampledRenderToTexture ? extensions.get("WEBGL_multisampled_render_to_texture") : undefined;
    const _videoTextures = new WeakMap();
    let _canvas;
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : $e97a97f0b0cf48c9$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $e97a97f0b0cf48c9$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $e97a97f0b0cf48c9$var$isPowerOfTwo(image.width) && $e97a97f0b0cf48c9$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $e97a97f0b0cf48c9$export$9d9334239a5a5e06 || texture.wrapT !== $e97a97f0b0cf48c9$export$9d9334239a5a5e06 || texture.minFilter !== $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0 && texture.minFilter !== $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0 && texture.minFilter !== $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, encoding, isVideoTexture = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 33319) {
            if (glType === 5126) internalFormat = 33328;
            if (glType === 5131) internalFormat = 33327;
            if (glType === 5121) internalFormat = 33323;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 && isVideoTexture === false ? 35907 : 32856;
            if (glType === 32819) internalFormat = 32854;
            if (glType === 32820) internalFormat = 32855;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0 && texture.minFilter !== $e97a97f0b0cf48c9$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0 || f === $e97a97f0b0cf48c9$export$d129e38cf6feaa8c || f === $e97a97f0b0cf48c9$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
        info.memory.textures--;
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        _gl.deleteTexture(textureProperties.__webglTexture);
        properties.remove(texture);
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (!renderTarget) return;
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === undefined) console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [$e97a97f0b0cf48c9$export$533346c8e8dac0f5]: 10497,
        [$e97a97f0b0cf48c9$export$9d9334239a5a5e06]: 33071,
        [$e97a97f0b0cf48c9$export$c7e7c00b14f51a4f]: 33648
    };
    const filterToGL = {
        [$e97a97f0b0cf48c9$export$727aa5ec3fe39bf0]: 9728,
        [$e97a97f0b0cf48c9$export$d129e38cf6feaa8c]: 9984,
        [$e97a97f0b0cf48c9$export$d2327c1afe5bfdf2]: 9986,
        [$e97a97f0b0cf48c9$export$8a72f490b25c56c8]: 9729,
        [$e97a97f0b0cf48c9$export$19a719f377145a13]: 9985,
        [$e97a97f0b0cf48c9$export$5d8599b6a933fb1b]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $e97a97f0b0cf48c9$export$9d9334239a5a5e06 || texture.wrapT !== $e97a97f0b0cf48c9$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0 && texture.minFilter !== $e97a97f0b0cf48c9$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.type === $e97a97f0b0cf48c9$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $e97a97f0b0cf48c9$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
            textureProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataTexture2DArray) textureType = 35866;
        if (texture.isDataTexture3D) textureType = 32879;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
        let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
        image = verifyColorSpace(texture, image);
        const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding);
        let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
        setTextureParameters(textureType, texture, supportsMips);
        let mipmap;
        const mipmaps = texture.mipmaps;
        const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
        const allocateMemory = textureProperties.__version === undefined;
        const levels = getMipLevels(texture, image, supportsMips);
        if (texture.isDepthTexture) {
            // populate depth texture with dummy data
            glInternalFormat = 6402;
            if (isWebGL2) {
                if (texture.type === $e97a97f0b0cf48c9$export$f6d331659b644596) glInternalFormat = 36012;
                else if (texture.type === $e97a97f0b0cf48c9$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                else if (texture.type === $e97a97f0b0cf48c9$export$6c8ea339bfab1301) glInternalFormat = 35056;
                else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
            } else if (texture.type === $e97a97f0b0cf48c9$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
            // validation checks for WebGL 1
            if (texture.format === $e97a97f0b0cf48c9$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
            // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
            // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
            {
                if (texture.type !== $e97a97f0b0cf48c9$export$c63dc51868b06a9d && texture.type !== $e97a97f0b0cf48c9$export$c3c7fc4518ebba96) {
                    console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                    texture.type = $e97a97f0b0cf48c9$export$c63dc51868b06a9d;
                    glType = utils.convert(texture.type);
                }
            }
            if (texture.format === $e97a97f0b0cf48c9$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                // Depth stencil textures need the DEPTH_STENCIL internal format
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                glInternalFormat = 34041;
                // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                if (texture.type !== $e97a97f0b0cf48c9$export$6c8ea339bfab1301) {
                    console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                    texture.type = $e97a97f0b0cf48c9$export$6c8ea339bfab1301;
                    glType = utils.convert(texture.type);
                }
            }
            //
            if (useTexStorage && allocateMemory) state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
            else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else if (texture.isDataTexture) {
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    if (useTexStorage) state.texSubImage2D(3553, 0, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                    else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
                texture.generateMipmaps = false;
            } else if (useTexStorage) {
                if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
            } else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
        } else if (texture.isCompressedTexture) {
            if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                if (texture.format !== $e97a97f0b0cf48c9$export$3f8bb04b555a363c) {
                    if (glFormat !== null) {
                        if (useTexStorage) state.compressedTexSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                        else state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                    } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                } else if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
        } else if (texture.isDataTexture2DArray) {
            if (useTexStorage) {
                if (allocateMemory) state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
                state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
            } else state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        } else if (texture.isDataTexture3D) {
            if (useTexStorage) {
                if (allocateMemory) state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
                state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
            } else state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        } else if (texture.isFramebufferTexture) {
            if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
            else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else {
            // regular Texture (image, video, canvas)
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, glFormat, glType, mipmap);
                    else state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
                }
                texture.generateMipmaps = false;
            } else if (useTexStorage) {
                if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
            } else state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        const isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
        const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
        const cubeImage = [];
        for(let i = 0; i < 6; i++){
            if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
            else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
            cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
        }
        const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
        const allocateMemory = textureProperties.__version === undefined;
        let levels = getMipLevels(texture, image, supportsMips);
        setTextureParameters(34067, texture, supportsMips);
        let mipmaps;
        if (isCompressed) {
            if (useTexStorage && allocateMemory) state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
            for(let i = 0; i < 6; i++){
                mipmaps = cubeImage[i].mipmaps;
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    if (texture.format !== $e97a97f0b0cf48c9$export$3f8bb04b555a363c) {
                        if (glFormat !== null) {
                            if (useTexStorage) state.compressedTexSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                            else state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                    } else if (useTexStorage) state.texSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                    else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            }
        } else {
            mipmaps = texture.mipmaps;
            if (useTexStorage && allocateMemory) {
                // TODO: Uniformly handle mipmap definitions
                // Normal textures and compressed cube textures define base level + mips with their mipmap array
                // Uncompressed cube textures use their mipmap array only for mips (no base level)
                if (mipmaps.length > 0) levels++;
                state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
            }
            for(let i = 0; i < 6; i++)if (isDataTexture) {
                if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                else state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    const mipmapImage = mipmap.image[i].image;
                    if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                    else state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                }
            } else {
                if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                else state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                    else state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                }
            }
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
        generateMipmap(34067);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.encoding);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(36160, framebuffer);
        if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample || renderTarget.useRenderToTexture) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $e97a97f0b0cf48c9$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $e97a97f0b0cf48c9$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && renderTarget.useRenderbuffer) _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.renderbufferStorageMultisampleEXT(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            // Use the first texture for MRT so far
            const texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
            const glFormat = utils.convert(texture.format, texture.encoding);
            const glType = utils.convert(texture.type);
            const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && renderTarget.useRenderbuffer) _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $e97a97f0b0cf48c9$export$c1b6b5136be58045) {
            if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $e97a97f0b0cf48c9$export$1e113ac2d0905829) {
            if (renderTarget.useRenderToTexture) MultisampledRenderToTextureExtension.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const isRenderTarget3D = texture.isDataTexture3D || texture.isDataTexture2DArray;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            } else if (renderTarget.useRenderbuffer) {
                if (isWebGL2) {
                    renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                    renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
                    const glFormat = utils.convert(texture.format, texture.encoding);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
                    _gl.bindRenderbuffer(36161, null);
                    if (renderTarget.depthBuffer) {
                        renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                        setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                    }
                    state.bindFramebuffer(36160, null);
                } else console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553);
            }
            state.unbindTexture();
        } else {
            let glTextureType = 3553;
            if (isRenderTarget3D) {
                // Render targets containing layers, i.e: Texture 3D and 2d arrays
                if (isWebGL2) {
                    const isTexture3D = texture.isDataTexture3D;
                    glTextureType = isTexture3D ? 32879 : 35866;
                } else console.warn("THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.useRenderbuffer) {
            if (isWebGL2) {
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = 16384;
                const invalidationArray = [
                    36064
                ];
                const depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                if (!renderTarget.ignoreDepthForMultisampleCopy) {
                    if (renderTarget.depthBuffer) mask |= 256;
                    if (renderTarget.stencilBuffer) mask |= 1024;
                }
                const renderTargetProperties = properties.get(renderTarget);
                state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
                if (renderTarget.ignoreDepthForMultisampleCopy) {
                    _gl.invalidateFramebuffer(36008, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(36009, [
                        depthStyle
                    ]);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                _gl.invalidateFramebuffer(36008, invalidationArray);
                state.bindFramebuffer(36008, null);
                state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
            } else console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return isWebGL2 && (renderTarget.useRenderbuffer || renderTarget.useRenderToTexture) ? Math.min(maxSamples, renderTarget.samples) : 0;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const encoding = texture.encoding;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $e97a97f0b0cf48c9$export$ca1dce8b5e1de74d) return image;
        if (encoding !== $e97a97f0b0cf48c9$export$7207336e4151a112) {
            // sRGB
            if (encoding === $e97a97f0b0cf48c9$export$f32388edbb32674) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $e97a97f0b0cf48c9$export$3f8bb04b555a363c) {
                        texture.format = $e97a97f0b0cf48c9$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $e97a97f0b0cf48c9$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $e97a97f0b0cf48c9$export$3f8bb04b555a363c || type !== $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture encoding:", encoding);
        }
        return image;
    }
    // backwards compatibility
    let warnedTexture2D = false;
    let warnedTextureCube = false;
    function safeSetTexture2D(texture, slot) {
        if (texture && texture.isWebGLRenderTarget) {
            if (warnedTexture2D === false) {
                console.warn("THREE.WebGLTextures.safeSetTexture2D: don't use render targets as textures. Use their .texture property instead.");
                warnedTexture2D = true;
            }
            texture = texture.texture;
        }
        setTexture2D(texture, slot);
    }
    function safeSetTextureCube(texture, slot) {
        if (texture && texture.isWebGLCubeRenderTarget) {
            if (warnedTextureCube === false) {
                console.warn("THREE.WebGLTextures.safeSetTextureCube: don't use cube render targets as textures. Use their .texture property instead.");
                warnedTextureCube = true;
            }
            texture = texture.texture;
        }
        setTextureCube(texture, slot);
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.safeSetTexture2D = safeSetTexture2D;
    this.safeSetTextureCube = safeSetTextureCube;
}
function $e97a97f0b0cf48c9$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, encoding = null) {
        let extension;
        if (p === $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $e97a97f0b0cf48c9$export$b3969b01faf587f2) return 32819;
        if (p === $e97a97f0b0cf48c9$export$18886f8ae33e90de) return 32820;
        if (p === $e97a97f0b0cf48c9$export$545fce0311a9796a) return 5120;
        if (p === $e97a97f0b0cf48c9$export$88572337f312435f) return 5122;
        if (p === $e97a97f0b0cf48c9$export$c63dc51868b06a9d) return 5123;
        if (p === $e97a97f0b0cf48c9$export$5c612977753abe2) return 5124;
        if (p === $e97a97f0b0cf48c9$export$c3c7fc4518ebba96) return 5125;
        if (p === $e97a97f0b0cf48c9$export$f6d331659b644596) return 5126;
        if (p === $e97a97f0b0cf48c9$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $e97a97f0b0cf48c9$export$988473390501ed4b) return 6406;
        if (p === $e97a97f0b0cf48c9$export$3f8bb04b555a363c) return 6408;
        if (p === $e97a97f0b0cf48c9$export$cc09ccbf6d1ed449) return 6409;
        if (p === $e97a97f0b0cf48c9$export$9053a81c4a69c289) return 6410;
        if (p === $e97a97f0b0cf48c9$export$c1b6b5136be58045) return 6402;
        if (p === $e97a97f0b0cf48c9$export$1e113ac2d0905829) return 34041;
        if (p === $e97a97f0b0cf48c9$export$4e041a7967d15c4b) return 6403;
        if (p === $e97a97f0b0cf48c9$export$7c67423a5ee6f5eb) {
            console.warn("THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228");
            return 6408;
        }
        // WebGL 1 sRGB fallback
        if (p === $e97a97f0b0cf48c9$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $e97a97f0b0cf48c9$export$aa92e870a709d190) return 36244;
        if (p === $e97a97f0b0cf48c9$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $e97a97f0b0cf48c9$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $e97a97f0b0cf48c9$export$c200e7d26f592f21) return 36249;
        // S3TC
        if (p === $e97a97f0b0cf48c9$export$21d1799c6d552fc0 || p === $e97a97f0b0cf48c9$export$afa304c3e981b668 || p === $e97a97f0b0cf48c9$export$d2a1a68024a3e56c || p === $e97a97f0b0cf48c9$export$9a79c424327dacf9) {
            if (encoding === $e97a97f0b0cf48c9$export$f32388edbb32674) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $e97a97f0b0cf48c9$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $e97a97f0b0cf48c9$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $e97a97f0b0cf48c9$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $e97a97f0b0cf48c9$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $e97a97f0b0cf48c9$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $e97a97f0b0cf48c9$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $e97a97f0b0cf48c9$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $e97a97f0b0cf48c9$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $e97a97f0b0cf48c9$export$19ada9bbb1af3573 || p === $e97a97f0b0cf48c9$export$d0f0355bb3d948e4 || p === $e97a97f0b0cf48c9$export$b82296714358084c || p === $e97a97f0b0cf48c9$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $e97a97f0b0cf48c9$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $e97a97f0b0cf48c9$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $e97a97f0b0cf48c9$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $e97a97f0b0cf48c9$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $e97a97f0b0cf48c9$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $e97a97f0b0cf48c9$export$7800993ef8106a6a || p === $e97a97f0b0cf48c9$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $e97a97f0b0cf48c9$export$7800993ef8106a6a) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $e97a97f0b0cf48c9$export$23ed8300a860e7d8) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $e97a97f0b0cf48c9$export$dc5570b4a2b92d48 || p === $e97a97f0b0cf48c9$export$68880cd325f8b2fb || p === $e97a97f0b0cf48c9$export$7d2c0be323373d95 || p === $e97a97f0b0cf48c9$export$22b52da301fc3a3e || p === $e97a97f0b0cf48c9$export$c009e2cb4a66485e || p === $e97a97f0b0cf48c9$export$118fff5afa255b63 || p === $e97a97f0b0cf48c9$export$120713c829ae0667 || p === $e97a97f0b0cf48c9$export$c79eeabbf53313e9 || p === $e97a97f0b0cf48c9$export$443cf6567cdd6424 || p === $e97a97f0b0cf48c9$export$6573984fc9840780 || p === $e97a97f0b0cf48c9$export$e7aee563f30091de || p === $e97a97f0b0cf48c9$export$2eb8634622ddeab7 || p === $e97a97f0b0cf48c9$export$202b1ce7b5d25742 || p === $e97a97f0b0cf48c9$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $e97a97f0b0cf48c9$export$dc5570b4a2b92d48) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $e97a97f0b0cf48c9$export$68880cd325f8b2fb) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $e97a97f0b0cf48c9$export$7d2c0be323373d95) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $e97a97f0b0cf48c9$export$22b52da301fc3a3e) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $e97a97f0b0cf48c9$export$c009e2cb4a66485e) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $e97a97f0b0cf48c9$export$118fff5afa255b63) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $e97a97f0b0cf48c9$export$120713c829ae0667) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $e97a97f0b0cf48c9$export$c79eeabbf53313e9) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $e97a97f0b0cf48c9$export$443cf6567cdd6424) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $e97a97f0b0cf48c9$export$6573984fc9840780) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $e97a97f0b0cf48c9$export$e7aee563f30091de) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $e97a97f0b0cf48c9$export$2eb8634622ddeab7) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $e97a97f0b0cf48c9$export$202b1ce7b5d25742) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $e97a97f0b0cf48c9$export$18ab77abd087e467) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $e97a97f0b0cf48c9$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $e97a97f0b0cf48c9$export$ce40b115e188bc81) return encoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        //
        if (p === $e97a97f0b0cf48c9$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
    }
    return {
        convert: convert
    };
}
class $e97a97f0b0cf48c9$export$56b937d9e5581166 extends $e97a97f0b0cf48c9$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.cameras = array;
    }
}
$e97a97f0b0cf48c9$export$56b937d9e5581166.prototype.isArrayCamera = true;
class $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Group";
    }
}
$e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4.prototype.isGroup = true;
const $e97a97f0b0cf48c9$var$_moveEvent = {
    type: "move"
};
class $e97a97f0b0cf48c9$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($e97a97f0b0cf48c9$var$_moveEvent);
                }
            }
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    if (hand.joints[inputjoint.jointName] === undefined) {
                        // The transform of this joint will be updated with the joint pose on each frame
                        const joint = new $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4();
                        joint.matrixAutoUpdate = false;
                        joint.visible = false;
                        hand.joints[inputjoint.jointName] = joint;
                        // ??
                        hand.add(joint);
                    }
                    const joint = hand.joints[inputjoint.jointName];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
}
class $e97a97f0b0cf48c9$export$fc830aa069cc8c2f extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $e97a97f0b0cf48c9$export$c1b6b5136be58045;
        if (format !== $e97a97f0b0cf48c9$export$c1b6b5136be58045 && format !== $e97a97f0b0cf48c9$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $e97a97f0b0cf48c9$export$c1b6b5136be58045) type = $e97a97f0b0cf48c9$export$c63dc51868b06a9d;
        if (type === undefined && format === $e97a97f0b0cf48c9$export$1e113ac2d0905829) type = $e97a97f0b0cf48c9$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
$e97a97f0b0cf48c9$export$fc830aa069cc8c2f.prototype.isDepthTexture = true;
class $e97a97f0b0cf48c9$var$WebXRManager extends $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        const hasMultisampledRenderToTexture = renderer.extensions.has("WEBGL_multisampled_render_to_texture");
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let isMultisample = false;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const inputSourcesMap = new Map();
        //
        const cameraL = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
        const cameraR = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $e97a97f0b0cf48c9$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $e97a97f0b0cf48c9$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $e97a97f0b0cf48c9$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $e97a97f0b0cf48c9$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controller = inputSourcesMap.get(event.inputSource);
            if (controller) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        }
        function onSessionEnd() {
            inputSourcesMap.forEach(function(controller, inputSource) {
                controller.disconnect(inputSource);
            });
            inputSourcesMap.clear();
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return referenceSpace;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: attributes.alpha,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $e97a97f0b0cf48c9$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $e97a97f0b0cf48c9$export$3f8bb04b555a363c,
                        type: $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10,
                        encoding: renderer.outputEncoding
                    });
                } else {
                    isMultisample = attributes.antialias;
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? 35056 : 33190;
                        depthFormat = attributes.stencil ? $e97a97f0b0cf48c9$export$1e113ac2d0905829 : $e97a97f0b0cf48c9$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $e97a97f0b0cf48c9$export$6c8ea339bfab1301 : $e97a97f0b0cf48c9$export$c63dc51868b06a9d;
                    }
                    const projectionlayerInit = {
                        colorFormat: renderer.outputEncoding === $e97a97f0b0cf48c9$export$f32388edbb32674 ? 35907 : 32856,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    if (isMultisample) newRenderTarget = new $e97a97f0b0cf48c9$export$cb2022643d3c928d(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $e97a97f0b0cf48c9$export$3f8bb04b555a363c,
                        type: $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10,
                        depthTexture: new $e97a97f0b0cf48c9$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        ignoreDepth: glProjLayer.ignoreDepthValues,
                        useRenderToTexture: hasMultisampledRenderToTexture,
                        encoding: renderer.outputEncoding
                    });
                    else newRenderTarget = new $e97a97f0b0cf48c9$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $e97a97f0b0cf48c9$export$3f8bb04b555a363c,
                        type: $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10,
                        depthTexture: new $e97a97f0b0cf48c9$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        ignoreDepth: glProjLayer.ignoreDepthValues,
                        encoding: renderer.outputEncoding
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                // Set foveation to maximum.
                this.setFoveation(1.0);
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function onInputSourcesChange(event) {
            const inputSources = session.inputSources;
            // Assign inputSources to available controllers
            for(let i = 0; i < controllers.length; i++)inputSourcesMap.set(inputSources[i], controllers[i]);
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const controller = inputSourcesMap.get(inputSource);
                if (controller) {
                    controller.dispatchEvent({
                        type: "disconnected",
                        data: inputSource
                    });
                    inputSourcesMap.delete(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                const controller = inputSourcesMap.get(inputSource);
                if (controller) controller.dispatchEvent({
                    type: "connected",
                    data: inputSource
                });
            }
        }
        //
        const cameraLPos = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const cameraRPos = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
            // update user camera and its children
            camera.position.copy(cameraVR.position);
            camera.quaternion.copy(cameraVR.quaternion);
            camera.scale.copy(cameraVR.scale);
            camera.matrix.copy(cameraVR.matrix);
            camera.matrixWorld.copy(cameraVR.matrixWorld);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        };
        this.getCamera = function() {
            return cameraVR;
        };
        this.getFoveation = function() {
            if (glProjLayer !== null) return glProjLayer.fixedFoveation;
            if (glBaseLayer !== null) return glBaseLayer.fixedFoveation;
            return undefined;
        };
        this.setFoveation = function(foveation) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            if (glProjLayer !== null) glProjLayer.fixedFoveation = foveation;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = foveation;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    const camera = cameras[i];
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) cameraVR.matrix.copy(camera.matrix);
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            const inputSources = session.inputSources;
            for(let i = 0; i < controllers.length; i++){
                const controller = controllers[i];
                const inputSource = inputSources[i];
                controller.update(inputSource, frame, referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            xrFrame = null;
        }
        const animation = new $e97a97f0b0cf48c9$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $e97a97f0b0cf48c9$var$WebGLMaterials(properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsLambert(uniforms, material);
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
            else refreshUniformsStandard(uniforms, material);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDepth(uniforms, material);
        } else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsNormal(uniforms, material);
        } else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        // 13. specular intensity map
        // 14. specular tint map
        // 15. transmission map
        // 16. thickness map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        else if (material.specularIntensityMap) uvScaleMap = material.specularIntensityMap;
        else if (material.specularColorMap) uvScaleMap = material.specularColorMap;
        else if (material.transmissionMap) uvScaleMap = material.transmissionMap;
        else if (material.thicknessMap) uvScaleMap = material.thicknessMap;
        else if (material.sheenColorMap) uvScaleMap = material.sheenColorMap;
        else if (material.sheenRoughnessMap) uvScaleMap = material.sheenRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsLambert(uniforms, material) {
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        refreshUniformsStandard(uniforms, material);
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) uniforms.sheenColorMap.value = material.sheenColorMap;
            if (material.sheenRoughnessMap) uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
            if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) uniforms.thicknessMap.value = material.thicknessMap;
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularIntensityMap) uniforms.specularIntensityMap.value = material.specularIntensityMap;
        if (material.specularColorMap) uniforms.specularColorMap.value = material.specularColorMap;
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDepth(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDistance(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    function refreshUniformsNormal(uniforms, material) {
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $e97a97f0b0cf48c9$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $e97a97f0b0cf48c9$var$createCanvasElement() {
    const canvas = $e97a97f0b0cf48c9$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
function $e97a97f0b0cf48c9$export$f6cc00ef28d7cf97(parameters = {}) {
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : $e97a97f0b0cf48c9$var$createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _alpha = parameters.alpha !== undefined ? parameters.alpha : false, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : "default", _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its list and state isolated from the parent render call.
    const renderListStack = [];
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.outputEncoding = $e97a97f0b0cf48c9$export$7207336e4151a112;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = $e97a97f0b0cf48c9$export$9fcb6b4294603b2;
    this.toneMappingExposure = 1.0;
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
    const _currentScissor = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(0, 0, _width, _height);
    const _scissor = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(0, 0, _width, _height);
    let _scissorTest = false;
    // frustum
    const _frustum = new $e97a97f0b0cf48c9$export$35efe6f4c85463d2();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // transmission
    let _transmissionRenderTarget = null;
    // camera matrices cache
    const _projScreenMatrix = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
    const _vector3 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: true,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // OffscreenCanvas does not have setAttribute, see #22811
        if ("setAttribute" in _canvas) _canvas.setAttribute("data-engine", `three.js r${$e97a97f0b0cf48c9$export$3545e07a80636437}`);
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener("webglcontextlost", onContextLost, false);
        _canvas.addEventListener("webglcontextrestored", onContextRestore, false);
        if (_gl === null) {
            const contextNames = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                else throw new Error("Error creating WebGL context.");
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                "rangeMin": 1,
                "rangeMax": 1,
                "precision": 1
            };
        };
    } catch (error) {
        console.error("THREE.WebGLRenderer: " + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates;
    function initGLContext() {
        extensions = new $e97a97f0b0cf48c9$var$WebGLExtensions(_gl);
        capabilities = new $e97a97f0b0cf48c9$var$WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new $e97a97f0b0cf48c9$export$ddaebcad857649a8(_gl, extensions, capabilities);
        state = new $e97a97f0b0cf48c9$var$WebGLState(_gl, extensions, capabilities);
        info = new $e97a97f0b0cf48c9$var$WebGLInfo(_gl);
        properties = new $e97a97f0b0cf48c9$var$WebGLProperties();
        textures = new $e97a97f0b0cf48c9$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new $e97a97f0b0cf48c9$var$WebGLCubeMaps(_this);
        cubeuvmaps = new $e97a97f0b0cf48c9$var$WebGLCubeUVMaps(_this);
        attributes = new $e97a97f0b0cf48c9$var$WebGLAttributes(_gl, capabilities);
        bindingStates = new $e97a97f0b0cf48c9$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new $e97a97f0b0cf48c9$var$WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new $e97a97f0b0cf48c9$var$WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new $e97a97f0b0cf48c9$var$WebGLMorphtargets(_gl, capabilities, textures);
        clipping = new $e97a97f0b0cf48c9$var$WebGLClipping(properties);
        programCache = new $e97a97f0b0cf48c9$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
        materials = new $e97a97f0b0cf48c9$var$WebGLMaterials(properties);
        renderLists = new $e97a97f0b0cf48c9$var$WebGLRenderLists();
        renderStates = new $e97a97f0b0cf48c9$var$WebGLRenderStates(extensions, capabilities);
        background = new $e97a97f0b0cf48c9$var$WebGLBackground(_this, cubemaps, state, objects, _alpha, _premultipliedAlpha);
        shadowMap = new $e97a97f0b0cf48c9$var$WebGLShadowMap(_this, objects, capabilities);
        bufferRenderer = new $e97a97f0b0cf48c9$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new $e97a97f0b0cf48c9$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new $e97a97f0b0cf48c9$var$WebXRManager(_this, _gl);
    this.xr = xr;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + "px";
            _canvas.style.height = height + "px";
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color, depth, stencil) {
        let bits = 0;
        if (color === undefined || color) bits |= 16384;
        if (depth === undefined || depth) bits |= 256;
        if (stencil === undefined || stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener("webglcontextlost", onContextLost, false);
        _canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        cubeuvmaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        programCache.dispose();
        xr.dispose();
        xr.removeEventListener("sessionstart", onXRSessionStart);
        xr.removeEventListener("sessionend", onXRSessionEnd);
        if (_transmissionRenderTarget) {
            _transmissionRenderTarget.dispose();
            _transmissionRenderTarget = null;
        }
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log("THREE.WebGLRenderer: Context Lost.");
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log("THREE.WebGLRenderer: Context Restored.");
        _isContextLost = false;
        const infoAutoReset = info.autoReset;
        const shadowMapEnabled = shadowMap.enabled;
        const shadowMapAutoUpdate = shadowMap.autoUpdate;
        const shadowMapNeedsUpdate = shadowMap.needsUpdate;
        const shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener("dispose", onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
        const programs = properties.get(material).programs;
        if (programs !== undefined) {
            programs.forEach(function(program) {
                programCache.releaseProgram(program);
            });
            if (material.isShaderMaterial) programCache.releaseShaderCache(material);
        }
    }
    // Buffer rendering
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, geometry, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    getProgram(material2, scene, object);
                }
                else getProgram(material, scene, object);
            }
        });
        renderStateStack.pop();
        currentRenderState = null;
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
        animation.stop();
    }
    function onXRSessionEnd() {
        animation.start();
    }
    const animation = new $e97a97f0b0cf48c9$var$WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof window !== "undefined") animation.setContext(window);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener("sessionstart", onXRSessionStart);
    xr.addEventListener("sessionend", onXRSessionEnd);
    // Rendering
    this.render = function(scene, camera) {
        if (camera !== undefined && camera.isCamera !== true) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
        }
        if (_isContextLost === true) return;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        //
        background.render(currentRenderList, scene);
        // render scene
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        if (camera.isArrayCamera) {
            const cameras = camera.cameras;
            for(let i = 0, l = cameras.length; i < l; i++){
                const camera2 = cameras[i];
                renderScene(currentRenderList, scene, camera2, camera2.viewport);
            }
        } else renderScene(currentRenderList, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
        }
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
        // _gl.finish();
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        renderListStack.pop();
        if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
        else currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderScene(currentRenderList, scene, camera, viewport) {
        const opaqueObjects = currentRenderList.opaque;
        const transmissiveObjects = currentRenderList.transmissive;
        const transparentObjects = currentRenderList.transparent;
        currentRenderState.setupLightsView(camera);
        if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, scene, camera);
        if (viewport) state.viewport(_currentViewport.copy(viewport));
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
    }
    function renderTransmissionPass(opaqueObjects, scene, camera) {
        if (_transmissionRenderTarget === null) {
            const needsAntialias = _antialias === true && capabilities.isWebGL2 === true;
            const renderTargetType = needsAntialias ? $e97a97f0b0cf48c9$export$cb2022643d3c928d : $e97a97f0b0cf48c9$export$3c052beb2e51e23f;
            _transmissionRenderTarget = new renderTargetType(1024, 1024, {
                generateMipmaps: true,
                type: utils.convert($e97a97f0b0cf48c9$export$2697304443f382bc) !== null ? $e97a97f0b0cf48c9$export$2697304443f382bc : $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10,
                minFilter: $e97a97f0b0cf48c9$export$5d8599b6a933fb1b,
                magFilter: $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0,
                wrapS: $e97a97f0b0cf48c9$export$9d9334239a5a5e06,
                wrapT: $e97a97f0b0cf48c9$export$9d9334239a5a5e06,
                useRenderToTexture: extensions.has("WEBGL_multisampled_render_to_texture")
            });
        }
        const currentRenderTarget = _this.getRenderTarget();
        _this.setRenderTarget(_transmissionRenderTarget);
        _this.clear();
        // Turn off the features which can affect the frag color for opaque objects pass.
        // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
        const currentToneMapping = _this.toneMapping;
        _this.toneMapping = $e97a97f0b0cf48c9$export$9fcb6b4294603b2;
        renderObjects(opaqueObjects, scene, camera);
        _this.toneMapping = currentToneMapping;
        textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
        textures.updateRenderTargetMipmap(_transmissionRenderTarget);
        _this.setRenderTarget(currentRenderTarget);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        material.onBeforeRender(_this, scene, camera, geometry, object, group);
        if (material.transparent === true && material.side === $e97a97f0b0cf48c9$export$3b296b6f144d5b03) {
            material.side = $e97a97f0b0cf48c9$export$d9f0486e75b5ace;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $e97a97f0b0cf48c9$export$2ede184fc2998901;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $e97a97f0b0cf48c9$export$3b296b6f144d5b03;
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let programs = materialProperties.programs;
        // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
        if (programs === undefined) {
            // new material
            material.addEventListener("dispose", onMaterialDispose);
            programs = new Map();
            materialProperties.programs = programs;
        }
        let program = programs.get(programCacheKey);
        if (program !== undefined) // early out if program and light state is identical
        {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                updateCommonMaterialProperties(material, parameters);
                return program;
            }
        } else {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBuild(object, parameters, _this);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters.uniforms;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
        updateCommonMaterialProperties(material, parameters);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = program.getUniforms();
        const uniformsList = $e97a97f0b0cf48c9$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = uniformsList;
        return program;
    }
    function updateCommonMaterialProperties(material, parameters) {
        const materialProperties = properties.get(material);
        materialProperties.outputEncoding = parameters.outputEncoding;
        materialProperties.instancing = parameters.instancing;
        materialProperties.skinning = parameters.skinning;
        materialProperties.morphTargets = parameters.morphTargets;
        materialProperties.morphNormals = parameters.morphNormals;
        materialProperties.morphTargetsCount = parameters.morphTargetsCount;
        materialProperties.numClippingPlanes = parameters.numClippingPlanes;
        materialProperties.numIntersection = parameters.numClipIntersection;
        materialProperties.vertexAlphas = parameters.vertexAlphas;
        materialProperties.vertexTangents = parameters.vertexTangents;
        materialProperties.toneMapping = parameters.toneMapping;
    }
    function setProgram(camera, scene, geometry, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : $e97a97f0b0cf48c9$export$7207336e4151a112;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
        const vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
        const morphTargets = !!geometry.morphAttributes.position;
        const morphNormals = !!geometry.morphAttributes.normal;
        const morphTargetsCount = !!geometry.morphAttributes.position ? geometry.morphAttributes.position.length : 0;
        const toneMapping = material.toneMapped ? _this.toneMapping : $e97a97f0b0cf48c9$export$9fcb6b4294603b2;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        //
        let needsProgramChange = false;
        if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
            else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
            else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
            else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
            else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
            else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
            else if (materialProperties.envMap !== envMap) needsProgramChange = true;
            else if (material.fog && materialProperties.fog !== fog) needsProgramChange = true;
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
            else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
            else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
            else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
            else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
            else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
            else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
        } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
        }
        //
        let program = materialProperties.currentProgram;
        if (needsProgramChange === true) program = getProgram(material, scene, object);
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
        }
        // skinning and morph target uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone and morph texture must go before other textures
        // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
        if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, "bindMatrix");
            p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
            const skeleton = object.skeleton;
            if (skeleton) {
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                } else p_uniforms.setOptional(_gl, skeleton, "boneMatrices");
            }
        }
        if (!!geometry && (geometry.morphAttributes.position !== undefined || geometry.morphAttributes.normal !== undefined)) morphtargets.update(object, geometry, material, program);
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
            $e97a97f0b0cf48c9$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            $e97a97f0b0cf48c9$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
        // common matrices
        p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
        p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
        p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
        properties.get(renderTarget.texture).__webglTexture = colorTexture;
        properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__hasExternalTextures = true;
        if (renderTargetProperties.__hasExternalTextures) {
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (renderTarget.useRenderToTexture) {
                    console.warn("render-to-texture extension was disabled because an external texture was provided");
                    renderTarget.useRenderToTexture = false;
                    renderTarget.useRenderbuffer = true;
                }
            }
        }
    };
    this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
        renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        let useDefaultFramebuffer = true;
        if (renderTarget) {
            const renderTargetProperties = properties.get(renderTarget);
            if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                // We need to make sure to rebind the framebuffer.
                state.bindFramebuffer(36160, null);
                useDefaultFramebuffer = false;
            } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
            else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
            textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
        }
        let framebuffer = null;
        let isCube = false;
        let isRenderTarget3D = false;
        if (renderTarget) {
            const texture = renderTarget.texture;
            if (texture.isDataTexture3D || texture.isDataTexture2DArray) isRenderTarget3D = true;
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (renderTarget.useRenderbuffer) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        const framebufferBound = state.bindFramebuffer(36160, framebuffer);
        if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
            const textureProperties = properties.get(renderTarget.texture);
            const layer = activeCubeFace || 0;
            _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
        }
        _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            state.bindFramebuffer(36160, framebuffer);
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== $e97a97f0b0cf48c9$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    return;
                }
                const halfFloatSupportedByExt = textureType === $e97a97f0b0cf48c9$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                if (textureType !== $e97a97f0b0cf48c9$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                !(textureType === $e97a97f0b0cf48c9$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    return;
                }
                if (_gl.checkFramebufferStatus(36160) === 36053) // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                {
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } else console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
            } finally{
                // restore framebuffer of current render target if necessary
                const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                state.bindFramebuffer(36160, framebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        if (texture.isFramebufferTexture !== true) {
            console.error("THREE.WebGLRenderer: copyFramebufferToTexture() can only be used with FramebufferTexture.");
            return;
        }
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        textures.setTexture2D(texture, 0);
        _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
        if (_this.isWebGL1Renderer) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
            return;
        }
        const width = sourceBox.max.x - sourceBox.min.x + 1;
        const height = sourceBox.max.y - sourceBox.min.y + 1;
        const depth = sourceBox.max.z - sourceBox.min.z + 1;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        let glTarget;
        if (dstTexture.isDataTexture3D) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = 32879;
        } else if (dstTexture.isDataTexture2DArray) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = 35866;
        } else {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            return;
        }
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        const unpackRowLen = _gl.getParameter(3314);
        const unpackImageHeight = _gl.getParameter(32878);
        const unpackSkipPixels = _gl.getParameter(3316);
        const unpackSkipRows = _gl.getParameter(3315);
        const unpackSkipImages = _gl.getParameter(32877);
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
        _gl.pixelStorei(3314, image.width);
        _gl.pixelStorei(32878, image.height);
        _gl.pixelStorei(3316, sourceBox.min.x);
        _gl.pixelStorei(3315, sourceBox.min.y);
        _gl.pixelStorei(32877, sourceBox.min.z);
        if (srcTexture.isDataTexture || srcTexture.isDataTexture3D) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
        else if (srcTexture.isCompressedTexture) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
            _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
        } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
        _gl.pixelStorei(3314, unpackRowLen);
        _gl.pixelStorei(32878, unpackImageHeight);
        _gl.pixelStorei(3316, unpackSkipPixels);
        _gl.pixelStorei(3315, unpackSkipRows);
        _gl.pixelStorei(32877, unpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    }));
}
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.isWebGLRenderer = true;
class $e97a97f0b0cf48c9$export$a2f65229194348f9 extends $e97a97f0b0cf48c9$export$f6cc00ef28d7cf97 {
}
$e97a97f0b0cf48c9$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $e97a97f0b0cf48c9$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.name = "";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $e97a97f0b0cf48c9$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
$e97a97f0b0cf48c9$export$6f1519f023b8d0f6.prototype.isFogExp2 = true;
class $e97a97f0b0cf48c9$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.name = "";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $e97a97f0b0cf48c9$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
$e97a97f0b0cf48c9$export$3c890837b09508d4.prototype.isFog = true;
class $e97a97f0b0cf48c9$export$38af1803e3442a7f extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.autoUpdate = source.autoUpdate;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
}
$e97a97f0b0cf48c9$export$38af1803e3442a7f.prototype.isScene = true;
class $e97a97f0b0cf48c9$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $e97a97f0b0cf48c9$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $e97a97f0b0cf48c9$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $e97a97f0b0cf48c9$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
$e97a97f0b0cf48c9$export$3d5cd879f108f53f.prototype.isInterleavedBuffer = true;
const $e97a97f0b0cf48c9$var$_vector$6 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized === true;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $e97a97f0b0cf48c9$var$_vector$6.x = this.getX(i);
            $e97a97f0b0cf48c9$var$_vector$6.y = this.getY(i);
            $e97a97f0b0cf48c9$var$_vector$6.z = this.getZ(i);
            $e97a97f0b0cf48c9$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $e97a97f0b0cf48c9$var$_vector$6.x, $e97a97f0b0cf48c9$var$_vector$6.y, $e97a97f0b0cf48c9$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e97a97f0b0cf48c9$var$_vector$6.x = this.getX(i);
            $e97a97f0b0cf48c9$var$_vector$6.y = this.getY(i);
            $e97a97f0b0cf48c9$var$_vector$6.z = this.getZ(i);
            $e97a97f0b0cf48c9$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $e97a97f0b0cf48c9$var$_vector$6.x, $e97a97f0b0cf48c9$var$_vector$6.y, $e97a97f0b0cf48c9$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $e97a97f0b0cf48c9$var$_vector$6.x = this.getX(i);
            $e97a97f0b0cf48c9$var$_vector$6.y = this.getY(i);
            $e97a97f0b0cf48c9$var$_vector$6.z = this.getZ(i);
            $e97a97f0b0cf48c9$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $e97a97f0b0cf48c9$var$_vector$6.x, $e97a97f0b0cf48c9$var$_vector$6.y, $e97a97f0b0cf48c9$var$_vector$6.z);
        }
        return this;
    }
    setX(index, x) {
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        return this.data.array[index * this.data.stride + this.offset];
    }
    getY(index) {
        return this.data.array[index * this.data.stride + this.offset + 1];
    }
    getZ(index) {
        return this.data.array[index * this.data.stride + this.offset + 2];
    }
    getW(index) {
        return this.data.array[index * this.data.stride + this.offset + 3];
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $e97a97f0b0cf48c9$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $e97a97f0b0cf48c9$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interlaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
$e97a97f0b0cf48c9$export$920b6d07334599c7.prototype.isInterleavedBufferAttribute = true;
/**
 * parameters = {
 *  color: <hex>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *  rotation: <float>,
 *  sizeAttenuation: <bool>
 * }
 */ class $e97a97f0b0cf48c9$export$5ec7dd1c6994bf8e extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "SpriteMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        return this;
    }
}
$e97a97f0b0cf48c9$export$5ec7dd1c6994bf8e.prototype.isSpriteMaterial = true;
let $e97a97f0b0cf48c9$var$_geometry;
const $e97a97f0b0cf48c9$var$_intersectPoint = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_worldScale = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_mvPosition = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_alignedPosition = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
const $e97a97f0b0cf48c9$var$_rotatedPosition = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
const $e97a97f0b0cf48c9$var$_viewWorldMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_vA = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vB = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_vC = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_uvA = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
const $e97a97f0b0cf48c9$var$_uvB = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
const $e97a97f0b0cf48c9$var$_uvC = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
class $e97a97f0b0cf48c9$export$3075603db8e6204c extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.type = "Sprite";
        if ($e97a97f0b0cf48c9$var$_geometry === undefined) {
            $e97a97f0b0cf48c9$var$_geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $e97a97f0b0cf48c9$export$3d5cd879f108f53f(float32Array, 5);
            $e97a97f0b0cf48c9$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $e97a97f0b0cf48c9$var$_geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $e97a97f0b0cf48c9$var$_geometry.setAttribute("uv", new $e97a97f0b0cf48c9$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $e97a97f0b0cf48c9$var$_geometry;
        this.material = material !== undefined ? material : new $e97a97f0b0cf48c9$export$5ec7dd1c6994bf8e();
        this.center = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $e97a97f0b0cf48c9$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $e97a97f0b0cf48c9$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $e97a97f0b0cf48c9$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $e97a97f0b0cf48c9$var$_worldScale.multiplyScalar(-$e97a97f0b0cf48c9$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $e97a97f0b0cf48c9$var$transformVertex($e97a97f0b0cf48c9$var$_vA.set(-0.5, -0.5, 0), $e97a97f0b0cf48c9$var$_mvPosition, center, $e97a97f0b0cf48c9$var$_worldScale, sin, cos);
        $e97a97f0b0cf48c9$var$transformVertex($e97a97f0b0cf48c9$var$_vB.set(0.5, -0.5, 0), $e97a97f0b0cf48c9$var$_mvPosition, center, $e97a97f0b0cf48c9$var$_worldScale, sin, cos);
        $e97a97f0b0cf48c9$var$transformVertex($e97a97f0b0cf48c9$var$_vC.set(0.5, 0.5, 0), $e97a97f0b0cf48c9$var$_mvPosition, center, $e97a97f0b0cf48c9$var$_worldScale, sin, cos);
        $e97a97f0b0cf48c9$var$_uvA.set(0, 0);
        $e97a97f0b0cf48c9$var$_uvB.set(1, 0);
        $e97a97f0b0cf48c9$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($e97a97f0b0cf48c9$var$_vA, $e97a97f0b0cf48c9$var$_vB, $e97a97f0b0cf48c9$var$_vC, false, $e97a97f0b0cf48c9$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $e97a97f0b0cf48c9$var$transformVertex($e97a97f0b0cf48c9$var$_vB.set(-0.5, 0.5, 0), $e97a97f0b0cf48c9$var$_mvPosition, center, $e97a97f0b0cf48c9$var$_worldScale, sin, cos);
            $e97a97f0b0cf48c9$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($e97a97f0b0cf48c9$var$_vA, $e97a97f0b0cf48c9$var$_vC, $e97a97f0b0cf48c9$var$_vB, false, $e97a97f0b0cf48c9$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($e97a97f0b0cf48c9$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $e97a97f0b0cf48c9$var$_intersectPoint.clone(),
            uv: $e97a97f0b0cf48c9$export$5a465592bfe74b48.getUV($e97a97f0b0cf48c9$var$_intersectPoint, $e97a97f0b0cf48c9$var$_vA, $e97a97f0b0cf48c9$var$_vB, $e97a97f0b0cf48c9$var$_vC, $e97a97f0b0cf48c9$var$_uvA, $e97a97f0b0cf48c9$var$_uvB, $e97a97f0b0cf48c9$var$_uvC, new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source) {
        super.copy(source);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
$e97a97f0b0cf48c9$export$3075603db8e6204c.prototype.isSprite = true;
function $e97a97f0b0cf48c9$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $e97a97f0b0cf48c9$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $e97a97f0b0cf48c9$var$_rotatedPosition.x = cos * $e97a97f0b0cf48c9$var$_alignedPosition.x - sin * $e97a97f0b0cf48c9$var$_alignedPosition.y;
        $e97a97f0b0cf48c9$var$_rotatedPosition.y = sin * $e97a97f0b0cf48c9$var$_alignedPosition.x + cos * $e97a97f0b0cf48c9$var$_alignedPosition.y;
    } else $e97a97f0b0cf48c9$var$_rotatedPosition.copy($e97a97f0b0cf48c9$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $e97a97f0b0cf48c9$var$_rotatedPosition.x;
    vertexPosition.y += $e97a97f0b0cf48c9$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($e97a97f0b0cf48c9$var$_viewWorldMatrix);
}
const $e97a97f0b0cf48c9$var$_v1$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v2$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$112e7237be0c5f30 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $e97a97f0b0cf48c9$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($e97a97f0b0cf48c9$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $e97a97f0b0cf48c9$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $e97a97f0b0cf48c9$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $e97a97f0b0cf48c9$var$_v1$2.distanceTo($e97a97f0b0cf48c9$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
}
const $e97a97f0b0cf48c9$var$_basePosition = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_skinIndex = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
const $e97a97f0b0cf48c9$var$_skinWeight = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
const $e97a97f0b0cf48c9$var$_vector$5 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_matrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
class $e97a97f0b0cf48c9$export$b303577035157ecf extends $e97a97f0b0cf48c9$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
    }
    copy(source) {
        super.copy(source);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.x = skinWeight.getX(i);
            vector.y = skinWeight.getY(i);
            vector.z = skinWeight.getZ(i);
            vector.w = skinWeight.getW(i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    boneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $e97a97f0b0cf48c9$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $e97a97f0b0cf48c9$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $e97a97f0b0cf48c9$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $e97a97f0b0cf48c9$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $e97a97f0b0cf48c9$var$_skinIndex.getComponent(i);
                $e97a97f0b0cf48c9$var$_matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($e97a97f0b0cf48c9$var$_vector$5.copy($e97a97f0b0cf48c9$var$_basePosition).applyMatrix4($e97a97f0b0cf48c9$var$_matrix), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
$e97a97f0b0cf48c9$export$b303577035157ecf.prototype.isSkinnedMesh = true;
class $e97a97f0b0cf48c9$export$b127726e56765aa4 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "Bone";
    }
}
$e97a97f0b0cf48c9$export$b127726e56765aa4.prototype.isBone = true;
class $e97a97f0b0cf48c9$export$b691f601014eabe1 extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0, minFilter = $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
$e97a97f0b0cf48c9$export$b691f601014eabe1.prototype.isDataTexture = true;
const $e97a97f0b0cf48c9$var$_offsetMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_identityMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
class $e97a97f0b0cf48c9$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $e97a97f0b0cf48c9$var$_identityMatrix;
            $e97a97f0b0cf48c9$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $e97a97f0b0cf48c9$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $e97a97f0b0cf48c9$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $e97a97f0b0cf48c9$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $e97a97f0b0cf48c9$export$b691f601014eabe1(boneMatrices, size, size, $e97a97f0b0cf48c9$export$3f8bb04b555a363c, $e97a97f0b0cf48c9$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $e97a97f0b0cf48c9$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $e97a97f0b0cf48c9$export$32ea87a8b54d744a extends $e97a97f0b0cf48c9$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        if (typeof normalized === "number") {
            meshPerAttribute = normalized;
            normalized = false;
            console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.");
        }
        super(array, itemSize, normalized);
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
$e97a97f0b0cf48c9$export$32ea87a8b54d744a.prototype.isInstancedBufferAttribute = true;
const $e97a97f0b0cf48c9$var$_instanceLocalMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_instanceWorldMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_instanceIntersects = [];
const $e97a97f0b0cf48c9$var$_mesh = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$e176487c05830cc5();
class $e97a97f0b0cf48c9$export$f3c979c331175ad7 extends $e97a97f0b0cf48c9$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.instanceMatrix = new $e97a97f0b0cf48c9$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.frustumCulled = false;
    }
    copy(source) {
        super.copy(source);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $e97a97f0b0cf48c9$var$_mesh.geometry = this.geometry;
        $e97a97f0b0cf48c9$var$_mesh.material = this.material;
        if ($e97a97f0b0cf48c9$var$_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $e97a97f0b0cf48c9$var$_instanceLocalMatrix);
            $e97a97f0b0cf48c9$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $e97a97f0b0cf48c9$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $e97a97f0b0cf48c9$var$_mesh.matrixWorld = $e97a97f0b0cf48c9$var$_instanceWorldMatrix;
            $e97a97f0b0cf48c9$var$_mesh.raycast(raycaster, $e97a97f0b0cf48c9$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $e97a97f0b0cf48c9$var$_instanceIntersects.length; i < l; i++){
                const intersect = $e97a97f0b0cf48c9$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $e97a97f0b0cf48c9$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $e97a97f0b0cf48c9$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
$e97a97f0b0cf48c9$export$f3c979c331175ad7.prototype.isInstancedMesh = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */ class $e97a97f0b0cf48c9$export$fbaaa33907730a0c extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "LineBasicMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff);
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        return this;
    }
}
$e97a97f0b0cf48c9$export$fbaaa33907730a0c.prototype.isLineBasicMaterial = true;
const $e97a97f0b0cf48c9$var$_start$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_end$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_inverseMatrix$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_ray$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$a186db52eed6d40e();
const $e97a97f0b0cf48c9$var$_sphere$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$805e8b72413ccaba();
class $e97a97f0b0cf48c9$export$17d680238e50603e extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959(), material = new $e97a97f0b0cf48c9$export$fbaaa33907730a0c()){
        super();
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [
                    0
                ];
                for(let i = 1, l = positionAttribute.count; i < l; i++){
                    $e97a97f0b0cf48c9$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                    $e97a97f0b0cf48c9$var$_end$1.fromBufferAttribute(positionAttribute, i);
                    lineDistances[i] = lineDistances[i - 1];
                    lineDistances[i] += $e97a97f0b0cf48c9$var$_start$1.distanceTo($e97a97f0b0cf48c9$var$_end$1);
                }
                geometry.setAttribute("lineDistance", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(lineDistances, 1));
            } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else if (geometry.isGeometry) console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $e97a97f0b0cf48c9$var$_sphere$1.copy(geometry.boundingSphere);
        $e97a97f0b0cf48c9$var$_sphere$1.applyMatrix4(matrixWorld);
        $e97a97f0b0cf48c9$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($e97a97f0b0cf48c9$var$_sphere$1) === false) return;
        //
        $e97a97f0b0cf48c9$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $e97a97f0b0cf48c9$var$_ray$1.copy(raycaster.ray).applyMatrix4($e97a97f0b0cf48c9$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const vEnd = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const interSegment = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const interRay = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, l = end - 1; i < l; i += step){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    vStart.fromBufferAttribute(positionAttribute, a);
                    vEnd.fromBufferAttribute(positionAttribute, b);
                    const distSq = $e97a97f0b0cf48c9$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            } else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for(let i = start, l = end - 1; i < l; i += step){
                    vStart.fromBufferAttribute(positionAttribute, i);
                    vEnd.fromBufferAttribute(positionAttribute, i + 1);
                    const distSq = $e97a97f0b0cf48c9$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
        } else if (geometry.isGeometry) console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
}
$e97a97f0b0cf48c9$export$17d680238e50603e.prototype.isLine = true;
const $e97a97f0b0cf48c9$var$_start = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_end = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$ff1ed10fedfdd604 extends $e97a97f0b0cf48c9$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [];
                for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                    $e97a97f0b0cf48c9$var$_start.fromBufferAttribute(positionAttribute, i);
                    $e97a97f0b0cf48c9$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                    lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                    lineDistances[i + 1] = lineDistances[i] + $e97a97f0b0cf48c9$var$_start.distanceTo($e97a97f0b0cf48c9$var$_end);
                }
                geometry.setAttribute("lineDistance", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(lineDistances, 1));
            } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else if (geometry.isGeometry) console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
    }
}
$e97a97f0b0cf48c9$export$ff1ed10fedfdd604.prototype.isLineSegments = true;
class $e97a97f0b0cf48c9$export$f85a24d745e4f17d extends $e97a97f0b0cf48c9$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.type = "LineLoop";
    }
}
$e97a97f0b0cf48c9$export$f85a24d745e4f17d.prototype.isLineLoop = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 *
 * }
 */ class $e97a97f0b0cf48c9$export$a178c45366ce5d6b extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "PointsMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        return this;
    }
}
$e97a97f0b0cf48c9$export$a178c45366ce5d6b.prototype.isPointsMaterial = true;
const $e97a97f0b0cf48c9$var$_inverseMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_ray = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$a186db52eed6d40e();
const $e97a97f0b0cf48c9$var$_sphere = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$805e8b72413ccaba();
const $e97a97f0b0cf48c9$var$_position$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$1c787534cb11aa3e extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959(), material = new $e97a97f0b0cf48c9$export$a178c45366ce5d6b()){
        super();
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source) {
        super.copy(source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $e97a97f0b0cf48c9$var$_sphere.copy(geometry.boundingSphere);
        $e97a97f0b0cf48c9$var$_sphere.applyMatrix4(matrixWorld);
        $e97a97f0b0cf48c9$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($e97a97f0b0cf48c9$var$_sphere) === false) return;
        //
        $e97a97f0b0cf48c9$var$_inverseMatrix.copy(matrixWorld).invert();
        $e97a97f0b0cf48c9$var$_ray.copy(raycaster.ray).applyMatrix4($e97a97f0b0cf48c9$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i++){
                    const a = index.getX(i);
                    $e97a97f0b0cf48c9$var$_position$2.fromBufferAttribute(positionAttribute, a);
                    $e97a97f0b0cf48c9$var$testPoint($e97a97f0b0cf48c9$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            } else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for(let i = start, l = end; i < l; i++){
                    $e97a97f0b0cf48c9$var$_position$2.fromBufferAttribute(positionAttribute, i);
                    $e97a97f0b0cf48c9$var$testPoint($e97a97f0b0cf48c9$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            }
        } else console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
    }
}
$e97a97f0b0cf48c9$export$1c787534cb11aa3e.prototype.isPoints = true;
function $e97a97f0b0cf48c9$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $e97a97f0b0cf48c9$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        $e97a97f0b0cf48c9$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $e97a97f0b0cf48c9$export$6e09d1edf8d5a25c extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.minFilter = minFilter !== undefined ? minFilter : $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
$e97a97f0b0cf48c9$export$6e09d1edf8d5a25c.prototype.isVideoTexture = true;
class $e97a97f0b0cf48c9$export$9270d786f73ce6fe extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(width, height, format){
        super({
            width: width,
            height: height
        });
        this.format = format;
        this.magFilter = $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0;
        this.minFilter = $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
$e97a97f0b0cf48c9$export$9270d786f73ce6fe.prototype.isFramebufferTexture = true;
class $e97a97f0b0cf48c9$export$3466bac9141a5cc4 extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
$e97a97f0b0cf48c9$export$3466bac9141a5cc4.prototype.isCompressedTexture = true;
class $e97a97f0b0cf48c9$export$f7189e49152d1c13 extends $e97a97f0b0cf48c9$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.needsUpdate = true;
    }
}
$e97a97f0b0cf48c9$export$f7189e49152d1c13.prototype.isCanvasTexture = true;
class $e97a97f0b0cf48c9$export$3f74fe60decf7462 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const uv = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$3f74fe60decf7462(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $e97a97f0b0cf48c9$export$d4345c83207d7c68 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
            const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$d4345c83207d7c68(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $e97a97f0b0cf48c9$export$59d971120dc8b6e7 extends $e97a97f0b0cf48c9$export$d4345c83207d7c68 {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$59d971120dc8b6e7(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $e97a97f0b0cf48c9$export$38789b531813345c extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const b = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const c = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const b = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const c = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const centroid = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const uvA = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
            const uvB = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
            const uvC = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$38789b531813345c(data.vertices, data.indices, data.radius, data.details);
    }
}
class $e97a97f0b0cf48c9$export$37cd4e52cce48c4c extends $e97a97f0b0cf48c9$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$37cd4e52cce48c4c(data.radius, data.detail);
    }
}
const $e97a97f0b0cf48c9$var$_v0 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v1$1 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_triangle = new $e97a97f0b0cf48c9$export$5a465592bfe74b48();
class $e97a97f0b0cf48c9$export$4730b1542707547f extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($e97a97f0b0cf48c9$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $e97a97f0b0cf48c9$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $e97a97f0b0cf48c9$var$_triangle.getNormal($e97a97f0b0cf48c9$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $e97a97f0b0cf48c9$var$_triangle[vertKeys[j]];
                    const v1 = $e97a97f0b0cf48c9$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($e97a97f0b0cf48c9$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $e97a97f0b0cf48c9$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $e97a97f0b0cf48c9$var$_v0.fromBufferAttribute(positionAttr, index0);
                $e97a97f0b0cf48c9$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($e97a97f0b0cf48c9$var$_v0.x, $e97a97f0b0cf48c9$var$_v0.y, $e97a97f0b0cf48c9$var$_v0.z);
                vertices.push($e97a97f0b0cf48c9$var$_v1$1.x, $e97a97f0b0cf48c9$var$_v1$1.y, $e97a97f0b0cf48c9$var$_v1$1.z);
            }
            this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $e97a97f0b0cf48c9$export$c977b3e384af9ae1() : new $e97a97f0b0cf48c9$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const mat = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $e97a97f0b0cf48c9$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        binormals[0] = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($e97a97f0b0cf48c9$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($e97a97f0b0cf48c9$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $e97a97f0b0cf48c9$export$3f87a931616cde04 extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
$e97a97f0b0cf48c9$export$3f87a931616cde04.prototype.isEllipseCurve = true;
class $e97a97f0b0cf48c9$export$b1eedc9aab6300e8 extends $e97a97f0b0cf48c9$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.type = "ArcCurve";
    }
}
$e97a97f0b0cf48c9$export$b1eedc9aab6300e8.prototype.isArcCurve = true;
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $e97a97f0b0cf48c9$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $e97a97f0b0cf48c9$var$tmp = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$px = new $e97a97f0b0cf48c9$var$CubicPoly(), $e97a97f0b0cf48c9$var$py = new $e97a97f0b0cf48c9$var$CubicPoly(), $e97a97f0b0cf48c9$var$pz = new $e97a97f0b0cf48c9$var$CubicPoly();
class $e97a97f0b0cf48c9$export$b9146b27c24b744c extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $e97a97f0b0cf48c9$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $e97a97f0b0cf48c9$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $e97a97f0b0cf48c9$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $e97a97f0b0cf48c9$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $e97a97f0b0cf48c9$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $e97a97f0b0cf48c9$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $e97a97f0b0cf48c9$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $e97a97f0b0cf48c9$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $e97a97f0b0cf48c9$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $e97a97f0b0cf48c9$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $e97a97f0b0cf48c9$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($e97a97f0b0cf48c9$var$px.calc(weight), $e97a97f0b0cf48c9$var$py.calc(weight), $e97a97f0b0cf48c9$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $e97a97f0b0cf48c9$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
$e97a97f0b0cf48c9$export$b9146b27c24b744c.prototype.isCatmullRomCurve3 = true;
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $e97a97f0b0cf48c9$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $e97a97f0b0cf48c9$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $e97a97f0b0cf48c9$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $e97a97f0b0cf48c9$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $e97a97f0b0cf48c9$var$QuadraticBezier(t, p0, p1, p2) {
    return $e97a97f0b0cf48c9$var$QuadraticBezierP0(t, p0) + $e97a97f0b0cf48c9$var$QuadraticBezierP1(t, p1) + $e97a97f0b0cf48c9$var$QuadraticBezierP2(t, p2);
}
//
function $e97a97f0b0cf48c9$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $e97a97f0b0cf48c9$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $e97a97f0b0cf48c9$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $e97a97f0b0cf48c9$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $e97a97f0b0cf48c9$var$CubicBezier(t, p0, p1, p2, p3) {
    return $e97a97f0b0cf48c9$var$CubicBezierP0(t, p0) + $e97a97f0b0cf48c9$var$CubicBezierP1(t, p1) + $e97a97f0b0cf48c9$var$CubicBezierP2(t, p2) + $e97a97f0b0cf48c9$var$CubicBezierP3(t, p3);
}
class $e97a97f0b0cf48c9$export$e36650d36468bb39 extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), v1 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), v2 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), v3 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()){
        super();
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($e97a97f0b0cf48c9$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $e97a97f0b0cf48c9$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
$e97a97f0b0cf48c9$export$e36650d36468bb39.prototype.isCubicBezierCurve = true;
class $e97a97f0b0cf48c9$export$13d5f1c9525f246c extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), v1 = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), v2 = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), v3 = new $e97a97f0b0cf48c9$export$64b5c384219d3699()){
        super();
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $e97a97f0b0cf48c9$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($e97a97f0b0cf48c9$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $e97a97f0b0cf48c9$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $e97a97f0b0cf48c9$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
$e97a97f0b0cf48c9$export$13d5f1c9525f246c.prototype.isCubicBezierCurve3 = true;
class $e97a97f0b0cf48c9$export$ab2e07e76531a47e extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), v2 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()){
        super();
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget) {
        const tangent = optionalTarget || new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
        tangent.copy(this.v2).sub(this.v1).normalize();
        return tangent;
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$e97a97f0b0cf48c9$export$ab2e07e76531a47e.prototype.isLineCurve = true;
class $e97a97f0b0cf48c9$export$1fdfd9d9cf487600 extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), v2 = new $e97a97f0b0cf48c9$export$64b5c384219d3699()){
        super();
        this.type = "LineCurve3";
        this.isLineCurve3 = true;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $e97a97f0b0cf48c9$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $e97a97f0b0cf48c9$export$5938c4ee491a43ad extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), v1 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(), v2 = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()){
        super();
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($e97a97f0b0cf48c9$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $e97a97f0b0cf48c9$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$e97a97f0b0cf48c9$export$5938c4ee491a43ad.prototype.isQuadraticBezierCurve = true;
class $e97a97f0b0cf48c9$export$bf3f4c7e459f90fc extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), v1 = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), v2 = new $e97a97f0b0cf48c9$export$64b5c384219d3699()){
        super();
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $e97a97f0b0cf48c9$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($e97a97f0b0cf48c9$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $e97a97f0b0cf48c9$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $e97a97f0b0cf48c9$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
$e97a97f0b0cf48c9$export$bf3f4c7e459f90fc.prototype.isQuadraticBezierCurve3 = true;
class $e97a97f0b0cf48c9$export$d3bdd77da77afc1b extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($e97a97f0b0cf48c9$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $e97a97f0b0cf48c9$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
$e97a97f0b0cf48c9$export$d3bdd77da77afc1b.prototype.isSplineCurve = true;
var $e97a97f0b0cf48c9$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $e97a97f0b0cf48c9$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $e97a97f0b0cf48c9$export$b9146b27c24b744c,
    CubicBezierCurve: $e97a97f0b0cf48c9$export$e36650d36468bb39,
    CubicBezierCurve3: $e97a97f0b0cf48c9$export$13d5f1c9525f246c,
    EllipseCurve: $e97a97f0b0cf48c9$export$3f87a931616cde04,
    LineCurve: $e97a97f0b0cf48c9$export$ab2e07e76531a47e,
    LineCurve3: $e97a97f0b0cf48c9$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $e97a97f0b0cf48c9$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $e97a97f0b0cf48c9$export$bf3f4c7e459f90fc,
    SplineCurve: $e97a97f0b0cf48c9$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $e97a97f0b0cf48c9$export$4aaf9b66af1bbf2c extends $e97a97f0b0cf48c9$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $e97a97f0b0cf48c9$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $e97a97f0b0cf48c9$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $e97a97f0b0cf48c9$export$4b2950bdac9b6ee9 extends $e97a97f0b0cf48c9$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $e97a97f0b0cf48c9$export$ab2e07e76531a47e(this.currentPoint.clone(), new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $e97a97f0b0cf48c9$export$5938c4ee491a43ad(this.currentPoint.clone(), new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(aCPx, aCPy), new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $e97a97f0b0cf48c9$export$e36650d36468bb39(this.currentPoint.clone(), new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(aCP1x, aCP1y), new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(aCP2x, aCP2y), new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $e97a97f0b0cf48c9$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $e97a97f0b0cf48c9$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $e97a97f0b0cf48c9$export$6428a7f2611ef1fa extends $e97a97f0b0cf48c9$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $e97a97f0b0cf48c9$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const $e97a97f0b0cf48c9$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $e97a97f0b0cf48c9$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $e97a97f0b0cf48c9$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        $e97a97f0b0cf48c9$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $e97a97f0b0cf48c9$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $e97a97f0b0cf48c9$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $e97a97f0b0cf48c9$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $e97a97f0b0cf48c9$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $e97a97f0b0cf48c9$var$equals(last, last.next)) {
        $e97a97f0b0cf48c9$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $e97a97f0b0cf48c9$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($e97a97f0b0cf48c9$var$equals(p, p.next) || $e97a97f0b0cf48c9$var$area(p.prev, p, p.next) === 0)) {
            $e97a97f0b0cf48c9$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $e97a97f0b0cf48c9$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $e97a97f0b0cf48c9$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $e97a97f0b0cf48c9$var$isEarHashed(ear, minX, minY, invSize) : $e97a97f0b0cf48c9$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $e97a97f0b0cf48c9$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $e97a97f0b0cf48c9$var$earcutLinked($e97a97f0b0cf48c9$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $e97a97f0b0cf48c9$var$cureLocalIntersections($e97a97f0b0cf48c9$var$filterPoints(ear), triangles, dim);
                $e97a97f0b0cf48c9$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $e97a97f0b0cf48c9$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $e97a97f0b0cf48c9$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($e97a97f0b0cf48c9$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if ($e97a97f0b0cf48c9$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $e97a97f0b0cf48c9$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $e97a97f0b0cf48c9$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($e97a97f0b0cf48c9$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = $e97a97f0b0cf48c9$var$zOrder(minTX, minTY, minX, minY, invSize), maxZ = $e97a97f0b0cf48c9$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $e97a97f0b0cf48c9$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $e97a97f0b0cf48c9$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $e97a97f0b0cf48c9$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $e97a97f0b0cf48c9$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $e97a97f0b0cf48c9$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $e97a97f0b0cf48c9$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $e97a97f0b0cf48c9$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $e97a97f0b0cf48c9$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $e97a97f0b0cf48c9$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$e97a97f0b0cf48c9$var$equals(a, b) && $e97a97f0b0cf48c9$var$intersects(a, p, p.next, b) && $e97a97f0b0cf48c9$var$locallyInside(a, b) && $e97a97f0b0cf48c9$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            $e97a97f0b0cf48c9$var$removeNode(p);
            $e97a97f0b0cf48c9$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $e97a97f0b0cf48c9$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $e97a97f0b0cf48c9$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $e97a97f0b0cf48c9$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $e97a97f0b0cf48c9$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $e97a97f0b0cf48c9$var$filterPoints(a, a.next);
                c = $e97a97f0b0cf48c9$var$filterPoints(c, c.next);
                // run earcut on each half
                $e97a97f0b0cf48c9$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $e97a97f0b0cf48c9$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $e97a97f0b0cf48c9$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $e97a97f0b0cf48c9$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($e97a97f0b0cf48c9$var$getLeftmost(list));
    }
    queue.sort($e97a97f0b0cf48c9$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $e97a97f0b0cf48c9$var$eliminateHole(queue[i], outerNode);
        outerNode = $e97a97f0b0cf48c9$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $e97a97f0b0cf48c9$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $e97a97f0b0cf48c9$var$eliminateHole(hole, outerNode) {
    outerNode = $e97a97f0b0cf48c9$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = $e97a97f0b0cf48c9$var$splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        $e97a97f0b0cf48c9$var$filterPoints(outerNode, outerNode.next);
        $e97a97f0b0cf48c9$var$filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $e97a97f0b0cf48c9$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $e97a97f0b0cf48c9$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($e97a97f0b0cf48c9$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $e97a97f0b0cf48c9$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $e97a97f0b0cf48c9$var$sectorContainsSector(m, p) {
    return $e97a97f0b0cf48c9$var$area(m.prev, m, p.prev) < 0 && $e97a97f0b0cf48c9$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $e97a97f0b0cf48c9$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = $e97a97f0b0cf48c9$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $e97a97f0b0cf48c9$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $e97a97f0b0cf48c9$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $e97a97f0b0cf48c9$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $e97a97f0b0cf48c9$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $e97a97f0b0cf48c9$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $e97a97f0b0cf48c9$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$e97a97f0b0cf48c9$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($e97a97f0b0cf48c9$var$locallyInside(a, b) && $e97a97f0b0cf48c9$var$locallyInside(b, a) && $e97a97f0b0cf48c9$var$middleInside(a, b) && // locally visible
    ($e97a97f0b0cf48c9$var$area(a.prev, a, b.prev) || $e97a97f0b0cf48c9$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $e97a97f0b0cf48c9$var$equals(a, b) && $e97a97f0b0cf48c9$var$area(a.prev, a, a.next) > 0 && $e97a97f0b0cf48c9$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $e97a97f0b0cf48c9$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $e97a97f0b0cf48c9$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $e97a97f0b0cf48c9$var$intersects(p1, q1, p2, q2) {
    const o1 = $e97a97f0b0cf48c9$var$sign($e97a97f0b0cf48c9$var$area(p1, q1, p2));
    const o2 = $e97a97f0b0cf48c9$var$sign($e97a97f0b0cf48c9$var$area(p1, q1, q2));
    const o3 = $e97a97f0b0cf48c9$var$sign($e97a97f0b0cf48c9$var$area(p2, q2, p1));
    const o4 = $e97a97f0b0cf48c9$var$sign($e97a97f0b0cf48c9$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $e97a97f0b0cf48c9$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $e97a97f0b0cf48c9$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $e97a97f0b0cf48c9$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $e97a97f0b0cf48c9$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $e97a97f0b0cf48c9$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $e97a97f0b0cf48c9$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $e97a97f0b0cf48c9$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $e97a97f0b0cf48c9$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $e97a97f0b0cf48c9$var$locallyInside(a, b) {
    return $e97a97f0b0cf48c9$var$area(a.prev, a, a.next) < 0 ? $e97a97f0b0cf48c9$var$area(a, b, a.next) >= 0 && $e97a97f0b0cf48c9$var$area(a, a.prev, b) >= 0 : $e97a97f0b0cf48c9$var$area(a, b, a.prev) < 0 || $e97a97f0b0cf48c9$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $e97a97f0b0cf48c9$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $e97a97f0b0cf48c9$var$splitPolygon(a, b) {
    const a2 = new $e97a97f0b0cf48c9$var$Node(a.i, a.x, a.y), b2 = new $e97a97f0b0cf48c9$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $e97a97f0b0cf48c9$var$insertNode(i, x, y, last) {
    const p = new $e97a97f0b0cf48c9$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $e97a97f0b0cf48c9$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $e97a97f0b0cf48c9$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $e97a97f0b0cf48c9$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $e97a97f0b0cf48c9$var$removeDupEndPts(contour);
        $e97a97f0b0cf48c9$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($e97a97f0b0cf48c9$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $e97a97f0b0cf48c9$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $e97a97f0b0cf48c9$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $e97a97f0b0cf48c9$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $e97a97f0b0cf48c9$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $e97a97f0b0cf48c9$export$91836d01b9f75a58 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(shapes = new $e97a97f0b0cf48c9$export$6428a7f2611ef1fa([
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0.5, 0.5),
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(-0.5, 0.5),
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(-0.5, -0.5),
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            let depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $e97a97f0b0cf48c9$var$WorldUVGenerator;
            // deprecated options
            if (options.amount !== undefined) {
                console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth.");
                depth = options.amount;
            }
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
                normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
                position2 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $e97a97f0b0cf48c9$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $e97a97f0b0cf48c9$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $e97a97f0b0cf48c9$export$91836d01b9f75a58(geometryShapes, data.options);
    }
}
const $e97a97f0b0cf48c9$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(a_x, a_y),
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(b_x, b_y),
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $e97a97f0b0cf48c9$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $e97a97f0b0cf48c9$export$731fd4feef063ea2 extends $e97a97f0b0cf48c9$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$731fd4feef063ea2(data.radius, data.detail);
    }
}
class $e97a97f0b0cf48c9$export$dc3e1273c1dd9240 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(points = [
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, 0.5),
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0.5, 0),
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, -0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $e97a97f0b0cf48c9$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const uv = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
        const normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const curNormal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const prevNormal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$dc3e1273c1dd9240(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $e97a97f0b0cf48c9$export$8e05fc91596f4752 extends $e97a97f0b0cf48c9$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$8e05fc91596f4752(data.radius, data.detail);
    }
}
class $e97a97f0b0cf48c9$export$ee8b85b34b7d9cad extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const uv = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$ee8b85b34b7d9cad(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $e97a97f0b0cf48c9$export$233afc324766bed8 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(shapes = new $e97a97f0b0cf48c9$export$6428a7f2611ef1fa([
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, 0.5),
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(-0.5, -0.5),
        new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $e97a97f0b0cf48c9$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $e97a97f0b0cf48c9$export$233afc324766bed8(geometryShapes, data.curveSegments);
    }
}
function $e97a97f0b0cf48c9$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $e97a97f0b0cf48c9$export$d5d06a966fec4192 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$d5d06a966fec4192(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $e97a97f0b0cf48c9$export$369e08f62a796c65 extends $e97a97f0b0cf48c9$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$369e08f62a796c65(data.radius, data.detail);
    }
}
class $e97a97f0b0cf48c9$export$19d55f905fa4f2cb extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$19d55f905fa4f2cb(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $e97a97f0b0cf48c9$export$2b32466f4274fe5c extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const P1 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const P2 = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const B = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const T = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const N = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segement
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    static fromJSON(data) {
        return new $e97a97f0b0cf48c9$export$2b32466f4274fe5c(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $e97a97f0b0cf48c9$export$d97a193ce44e691b extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(path = new $e97a97f0b0cf48c9$export$bf3f4c7e459f90fc(new $e97a97f0b0cf48c9$export$64b5c384219d3699(-1, -1, 0), new $e97a97f0b0cf48c9$export$64b5c384219d3699(-1, 1, 0), new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const normal = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        const uv = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
        let P = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $e97a97f0b0cf48c9$export$d97a193ce44e691b(new $e97a97f0b0cf48c9$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $e97a97f0b0cf48c9$export$4b739da06d24892b extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            const end = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all eges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($e97a97f0b0cf48c9$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($e97a97f0b0cf48c9$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
function $e97a97f0b0cf48c9$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1, hash2);
        return true;
    }
}
var $e97a97f0b0cf48c9$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $e97a97f0b0cf48c9$export$ab3456a079aa7d80,
    BoxBufferGeometry: $e97a97f0b0cf48c9$export$ab3456a079aa7d80,
    CircleGeometry: $e97a97f0b0cf48c9$export$3f74fe60decf7462,
    CircleBufferGeometry: $e97a97f0b0cf48c9$export$3f74fe60decf7462,
    ConeGeometry: $e97a97f0b0cf48c9$export$59d971120dc8b6e7,
    ConeBufferGeometry: $e97a97f0b0cf48c9$export$59d971120dc8b6e7,
    CylinderGeometry: $e97a97f0b0cf48c9$export$d4345c83207d7c68,
    CylinderBufferGeometry: $e97a97f0b0cf48c9$export$d4345c83207d7c68,
    DodecahedronGeometry: $e97a97f0b0cf48c9$export$37cd4e52cce48c4c,
    DodecahedronBufferGeometry: $e97a97f0b0cf48c9$export$37cd4e52cce48c4c,
    EdgesGeometry: $e97a97f0b0cf48c9$export$4730b1542707547f,
    ExtrudeGeometry: $e97a97f0b0cf48c9$export$91836d01b9f75a58,
    ExtrudeBufferGeometry: $e97a97f0b0cf48c9$export$91836d01b9f75a58,
    IcosahedronGeometry: $e97a97f0b0cf48c9$export$731fd4feef063ea2,
    IcosahedronBufferGeometry: $e97a97f0b0cf48c9$export$731fd4feef063ea2,
    LatheGeometry: $e97a97f0b0cf48c9$export$dc3e1273c1dd9240,
    LatheBufferGeometry: $e97a97f0b0cf48c9$export$dc3e1273c1dd9240,
    OctahedronGeometry: $e97a97f0b0cf48c9$export$8e05fc91596f4752,
    OctahedronBufferGeometry: $e97a97f0b0cf48c9$export$8e05fc91596f4752,
    PlaneGeometry: $e97a97f0b0cf48c9$export$e789a11a194ca4e0,
    PlaneBufferGeometry: $e97a97f0b0cf48c9$export$e789a11a194ca4e0,
    PolyhedronGeometry: $e97a97f0b0cf48c9$export$38789b531813345c,
    PolyhedronBufferGeometry: $e97a97f0b0cf48c9$export$38789b531813345c,
    RingGeometry: $e97a97f0b0cf48c9$export$ee8b85b34b7d9cad,
    RingBufferGeometry: $e97a97f0b0cf48c9$export$ee8b85b34b7d9cad,
    ShapeGeometry: $e97a97f0b0cf48c9$export$233afc324766bed8,
    ShapeBufferGeometry: $e97a97f0b0cf48c9$export$233afc324766bed8,
    SphereGeometry: $e97a97f0b0cf48c9$export$d5d06a966fec4192,
    SphereBufferGeometry: $e97a97f0b0cf48c9$export$d5d06a966fec4192,
    TetrahedronGeometry: $e97a97f0b0cf48c9$export$369e08f62a796c65,
    TetrahedronBufferGeometry: $e97a97f0b0cf48c9$export$369e08f62a796c65,
    TorusGeometry: $e97a97f0b0cf48c9$export$19d55f905fa4f2cb,
    TorusBufferGeometry: $e97a97f0b0cf48c9$export$19d55f905fa4f2cb,
    TorusKnotGeometry: $e97a97f0b0cf48c9$export$2b32466f4274fe5c,
    TorusKnotBufferGeometry: $e97a97f0b0cf48c9$export$2b32466f4274fe5c,
    TubeGeometry: $e97a97f0b0cf48c9$export$d97a193ce44e691b,
    TubeBufferGeometry: $e97a97f0b0cf48c9$export$d97a193ce44e691b,
    WireframeGeometry: $e97a97f0b0cf48c9$export$4b739da06d24892b
});
/**
 * parameters = {
 *  color: <THREE.Color>
 * }
 */ class $e97a97f0b0cf48c9$export$e8564da406055a3 extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "ShadowMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        return this;
    }
}
$e97a97f0b0cf48c9$export$e8564da406055a3.prototype.isShadowMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  flatShading: <bool>
 * }
 */ class $e97a97f0b0cf48c9$export$f2980790215acccd extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e97a97f0b0cf48c9$export$2852a58ebdac27b8;
        this.normalScale = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        return this;
    }
}
$e97a97f0b0cf48c9$export$f2980790215acccd.prototype.isMeshStandardMaterial = true;
/**
 * parameters = {
 *  clearcoat: <float>,
 *  clearcoatMap: new THREE.Texture( <Image> ),
 *  clearcoatRoughness: <float>,
 *  clearcoatRoughnessMap: new THREE.Texture( <Image> ),
 *  clearcoatNormalScale: <Vector2>,
 *  clearcoatNormalMap: new THREE.Texture( <Image> ),
 *
 *  ior: <float>,
 *  reflectivity: <float>,
 *
 *  sheen: <float>,
 *  sheenColor: <Color>,
 *  sheenColorMap: new THREE.Texture( <Image> ),
 *  sheenRoughness: <float>,
 *  sheenRoughnessMap: new THREE.Texture( <Image> ),
 *
 *  transmission: <float>,
 *  transmissionMap: new THREE.Texture( <Image> ),
 *
 *  thickness: <float>,
 *  thicknessMap: new THREE.Texture( <Image> ),
 *  attenuationDistance: <float>,
 *  attenuationColor: <Color>,
 *
 *  specularIntensity: <float>,
 *  specularIntensityMap: new THREE.Texture( <Image> ),
 *  specularColor: <Color>,
 *  specularColorMap: new THREE.Texture( <Image> )
 * }
 */ class $e97a97f0b0cf48c9$export$28d04986c4269c9f extends $e97a97f0b0cf48c9$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $e97a97f0b0cf48c9$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.sheenColor = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = 0.0;
        this.attenuationColor = new $e97a97f0b0cf48c9$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $e97a97f0b0cf48c9$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._sheen = 0.0;
        this._clearcoat = 0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
$e97a97f0b0cf48c9$export$28d04986c4269c9f.prototype.isMeshPhysicalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.MultiplyOperation,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  flatShading: <bool>
 * }
 */ class $e97a97f0b0cf48c9$export$24c72f71cbaf0678 extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshPhongMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e97a97f0b0cf48c9$export$2852a58ebdac27b8;
        this.normalScale = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $e97a97f0b0cf48c9$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        return this;
    }
}
$e97a97f0b0cf48c9$export$24c72f71cbaf0678.prototype.isMeshPhongMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *
 *  map: new THREE.Texture( <Image> ),
 *  gradientMap: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 * }
 */ class $e97a97f0b0cf48c9$export$df893cf97e765622 extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e97a97f0b0cf48c9$export$2852a58ebdac27b8;
        this.normalScale = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        return this;
    }
}
$e97a97f0b0cf48c9$export$df893cf97e765622.prototype.isMeshToonMaterial = true;
/**
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  flatShading: <bool>
 * }
 */ class $e97a97f0b0cf48c9$export$bfe8c0a091f41ae7 extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e97a97f0b0cf48c9$export$2852a58ebdac27b8;
        this.normalScale = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
$e97a97f0b0cf48c9$export$bfe8c0a091f41ae7.prototype.isMeshNormalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 * }
 */ class $e97a97f0b0cf48c9$export$5023a9a8114806b8 extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.type = "MeshLambertMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $e97a97f0b0cf48c9$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        return this;
    }
}
$e97a97f0b0cf48c9$export$5023a9a8114806b8.prototype.isMeshLambertMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  matcap: new THREE.Texture( <Image> ),
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  flatShading: <bool>
 * }
 */ class $e97a97f0b0cf48c9$export$6f5fef6235ec12ee extends $e97a97f0b0cf48c9$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $e97a97f0b0cf48c9$export$2852a58ebdac27b8;
        this.normalScale = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        return this;
    }
}
$e97a97f0b0cf48c9$export$6f5fef6235ec12ee.prototype.isMeshMatcapMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */ class $e97a97f0b0cf48c9$export$327886a3efaeaebe extends $e97a97f0b0cf48c9$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
$e97a97f0b0cf48c9$export$327886a3efaeaebe.prototype.isLineDashedMaterial = true;
var $e97a97f0b0cf48c9$var$Materials = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ShadowMaterial: $e97a97f0b0cf48c9$export$e8564da406055a3,
    SpriteMaterial: $e97a97f0b0cf48c9$export$5ec7dd1c6994bf8e,
    RawShaderMaterial: $e97a97f0b0cf48c9$export$21c421a2e1df9d22,
    ShaderMaterial: $e97a97f0b0cf48c9$export$83c7d75d550a8b0d,
    PointsMaterial: $e97a97f0b0cf48c9$export$a178c45366ce5d6b,
    MeshPhysicalMaterial: $e97a97f0b0cf48c9$export$28d04986c4269c9f,
    MeshStandardMaterial: $e97a97f0b0cf48c9$export$f2980790215acccd,
    MeshPhongMaterial: $e97a97f0b0cf48c9$export$24c72f71cbaf0678,
    MeshToonMaterial: $e97a97f0b0cf48c9$export$df893cf97e765622,
    MeshNormalMaterial: $e97a97f0b0cf48c9$export$bfe8c0a091f41ae7,
    MeshLambertMaterial: $e97a97f0b0cf48c9$export$5023a9a8114806b8,
    MeshDepthMaterial: $e97a97f0b0cf48c9$export$2698c22ec13825db,
    MeshDistanceMaterial: $e97a97f0b0cf48c9$export$33e187ed002f2a19,
    MeshBasicMaterial: $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5,
    MeshMatcapMaterial: $e97a97f0b0cf48c9$export$6f5fef6235ec12ee,
    LineDashedMaterial: $e97a97f0b0cf48c9$export$327886a3efaeaebe,
    LineBasicMaterial: $e97a97f0b0cf48c9$export$fbaaa33907730a0c,
    Material: $e97a97f0b0cf48c9$export$a2d8b23205c25948
});
const $e97a97f0b0cf48c9$export$7ee8caa573e71ad1 = {
    // same as Array.prototype.slice, but also works on typed arrays
    arraySlice: function(array, from, to) {
        if ($e97a97f0b0cf48c9$export$7ee8caa573e71ad1.isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
        // but array.subarray(from) or array.subarray(from, len) is correct
        return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
        return array.slice(from, to);
    },
    // converts an array to a specific type
    convertArray: function(array, type, forceClone) {
        if (!array || // let 'undefined' and 'null' pass
        !forceClone && array.constructor === type) return array;
        if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
        return Array.prototype.slice.call(array); // create Array
    },
    isTypedArray: function(object) {
        return ArrayBuffer.isView(object) && !(object instanceof DataView);
    },
    // returns an array by which times and values can be sorted
    getKeyframeOrder: function(times) {
        function compareTime(i, j) {
            return times[i] - times[j];
        }
        const n = times.length;
        const result = new Array(n);
        for(let i = 0; i !== n; ++i)result[i] = i;
        result.sort(compareTime);
        return result;
    },
    // uses the array previously returned by 'getKeyframeOrder' to sort data
    sortedArray: function(values, stride, order) {
        const nValues = values.length;
        const result = new values.constructor(nValues);
        for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
            const srcOffset = order[i] * stride;
            for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
        }
        return result;
    },
    // function for parsing AOS keyframe formats
    flattenJSON: function(jsonKeys, times, values, valuePropertyName) {
        let i = 1, key = jsonKeys[0];
        while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
        if (key === undefined) return; // no data
        let value = key[valuePropertyName];
        if (value === undefined) return; // no data
        if (Array.isArray(value)) do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push.apply(values, value); // push all elements
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else if (value.toArray !== undefined) // ...assume THREE.Math-ish
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                value.toArray(values, values.length);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else // otherwise push as-is
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push(value);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
    },
    subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
        const clip = sourceClip.clone();
        clip.name = name;
        const tracks = [];
        for(let i = 0; i < clip.tracks.length; ++i){
            const track = clip.tracks[i];
            const valueSize = track.getValueSize();
            const times = [];
            const values = [];
            for(let j = 0; j < track.times.length; ++j){
                const frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
            }
            if (times.length === 0) continue;
            track.times = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.convertArray(times, track.times.constructor);
            track.values = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.convertArray(values, track.values.constructor);
            tracks.push(track);
        }
        clip.tracks = tracks;
        // find minimum .times value across all tracks in the trimmed clip
        let minStartTime = Infinity;
        for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
        // shift all tracks such that clip begins at t=0
        for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
        clip.resetDuration();
        return clip;
    },
    makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        if (fps <= 0) fps = 30;
        const numTracks = referenceClip.tracks.length;
        const referenceTime = referenceFrame / fps;
        // Make each track's values relative to the values at the reference frame
        for(let i = 0; i < numTracks; ++i){
            const referenceTrack = referenceClip.tracks[i];
            const referenceTrackType = referenceTrack.ValueTypeName;
            // Skip this track if it's non-numeric
            if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
            // Find the track in the target clip whose name and type matches the reference track
            const targetTrack = targetClip.tracks.find(function(track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
            });
            if (targetTrack === undefined) continue;
            let referenceOffset = 0;
            const referenceValueSize = referenceTrack.getValueSize();
            if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
            let targetOffset = 0;
            const targetValueSize = targetTrack.getValueSize();
            if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
            const lastIndex = referenceTrack.times.length - 1;
            let referenceValue;
            // Find the value to subtract out of the track
            if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                referenceValue = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                const startIndex = lastIndex * referenceValueSize + referenceOffset;
                const endIndex = startIndex + referenceValueSize - referenceOffset;
                referenceValue = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else {
                // Interpolate to the reference value
                const interpolant = referenceTrack.createInterpolant();
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
            }
            // Conjugate the quaternion
            if (referenceTrackType === "quaternion") {
                const referenceQuat = new $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
            }
            // Subtract the reference value from all of the track values
            const numTimes = targetTrack.times.length;
            for(let j = 0; j < numTimes; ++j){
                const valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
                $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                else {
                    const valueEnd = targetValueSize - targetOffset * 2;
                    // Subtract each value for all other numeric track types
                    for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
                }
            }
        }
        targetClip.blendMode = $e97a97f0b0cf48c9$export$d875e029ef558d3;
        return targetClip;
    }
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $e97a97f0b0cf48c9$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.afterEnd_(i1 - 1, t, t0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.beforeStart_(0, t, t1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.beforeStart_(0, t, t1);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.afterEnd_(i1 - 1, t0, t);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
// ALIAS DEFINITIONS
$e97a97f0b0cf48c9$export$b558baee9c0f72d3.prototype.beforeStart_ = $e97a97f0b0cf48c9$export$b558baee9c0f72d3.prototype.copySampleValue_;
$e97a97f0b0cf48c9$export$b558baee9c0f72d3.prototype.afterEnd_ = $e97a97f0b0cf48c9$export$b558baee9c0f72d3.prototype.copySampleValue_;
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $e97a97f0b0cf48c9$export$3646682e7a3959 extends $e97a97f0b0cf48c9$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $e97a97f0b0cf48c9$export$7f795934b84ab523,
            endingEnd: $e97a97f0b0cf48c9$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $e97a97f0b0cf48c9$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $e97a97f0b0cf48c9$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $e97a97f0b0cf48c9$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $e97a97f0b0cf48c9$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $e97a97f0b0cf48c9$export$a8e6009059f51e1a extends $e97a97f0b0cf48c9$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 */ class $e97a97f0b0cf48c9$export$fb9758ef7ef8d5cc extends $e97a97f0b0cf48c9$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $e97a97f0b0cf48c9$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.convertArray(times, this.TimeBufferType);
        this.values = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.convertArray(track.times, Array),
                "values": $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $e97a97f0b0cf48c9$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $e97a97f0b0cf48c9$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $e97a97f0b0cf48c9$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $e97a97f0b0cf48c9$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $e97a97f0b0cf48c9$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $e97a97f0b0cf48c9$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $e97a97f0b0cf48c9$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $e97a97f0b0cf48c9$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $e97a97f0b0cf48c9$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(times, from, to);
            this.values = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($e97a97f0b0cf48c9$export$7ee8caa573e71ad1.isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(this.times), values = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $e97a97f0b0cf48c9$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(times, 0, writeIndex);
            this.values = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(this.times, 0);
        const values = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$e97a97f0b0cf48c9$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$e97a97f0b0cf48c9$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$e97a97f0b0cf48c9$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $e97a97f0b0cf48c9$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $e97a97f0b0cf48c9$export$d3a344b98cf0b775 extends $e97a97f0b0cf48c9$export$b0e479f45b7006d6 {
}
$e97a97f0b0cf48c9$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$e97a97f0b0cf48c9$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$e97a97f0b0cf48c9$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $e97a97f0b0cf48c9$export$995b32462a65e855;
$e97a97f0b0cf48c9$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$e97a97f0b0cf48c9$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $e97a97f0b0cf48c9$export$83444c5d885347d8 extends $e97a97f0b0cf48c9$export$b0e479f45b7006d6 {
}
$e97a97f0b0cf48c9$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $e97a97f0b0cf48c9$export$d45f0d1a4d9a9314 extends $e97a97f0b0cf48c9$export$b0e479f45b7006d6 {
}
$e97a97f0b0cf48c9$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $e97a97f0b0cf48c9$export$2db1cfb7923d931e extends $e97a97f0b0cf48c9$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$e97a97f0b0cf48c9$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $e97a97f0b0cf48c9$export$b8043f12b5aafbd7 extends $e97a97f0b0cf48c9$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $e97a97f0b0cf48c9$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$e97a97f0b0cf48c9$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$e97a97f0b0cf48c9$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $e97a97f0b0cf48c9$export$30fac1aace31cf4d;
$e97a97f0b0cf48c9$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $e97a97f0b0cf48c9$export$6ce41d4f3a8df9cd extends $e97a97f0b0cf48c9$export$b0e479f45b7006d6 {
}
$e97a97f0b0cf48c9$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$e97a97f0b0cf48c9$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$e97a97f0b0cf48c9$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $e97a97f0b0cf48c9$export$995b32462a65e855;
$e97a97f0b0cf48c9$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$e97a97f0b0cf48c9$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $e97a97f0b0cf48c9$export$5ce2dcb4cc9f2bff extends $e97a97f0b0cf48c9$export$b0e479f45b7006d6 {
}
$e97a97f0b0cf48c9$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $e97a97f0b0cf48c9$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $e97a97f0b0cf48c9$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($e97a97f0b0cf48c9$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($e97a97f0b0cf48c9$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.getKeyframeOrder(times);
            times = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.sortedArray(times, 1, order);
            values = $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $e97a97f0b0cf48c9$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $e97a97f0b0cf48c9$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * (fps || 1.0);
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($e97a97f0b0cf48c9$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($e97a97f0b0cf48c9$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($e97a97f0b0cf48c9$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $e97a97f0b0cf48c9$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $e97a97f0b0cf48c9$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $e97a97f0b0cf48c9$export$5ce2dcb4cc9f2bff;
        case "color":
            return $e97a97f0b0cf48c9$export$83444c5d885347d8;
        case "quaternion":
            return $e97a97f0b0cf48c9$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $e97a97f0b0cf48c9$export$d3a344b98cf0b775;
        case "string":
            return $e97a97f0b0cf48c9$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $e97a97f0b0cf48c9$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $e97a97f0b0cf48c9$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $e97a97f0b0cf48c9$export$7ee8caa573e71ad1.flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $e97a97f0b0cf48c9$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $e97a97f0b0cf48c9$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $e97a97f0b0cf48c9$export$b033c3f9a95c6a16 = new $e97a97f0b0cf48c9$export$99cc795e99919eed();
class $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $e97a97f0b0cf48c9$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $e97a97f0b0cf48c9$var$loading = {};
class $e97a97f0b0cf48c9$export$98435a25b5cf7b2b extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $e97a97f0b0cf48c9$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($e97a97f0b0cf48c9$var$loading[url] !== undefined) {
            $e97a97f0b0cf48c9$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $e97a97f0b0cf48c9$var$loading[url] = [];
        $e97a97f0b0cf48c9$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                if (typeof ReadableStream === "undefined" || response.body.getReader === undefined) return response;
                const callbacks = $e97a97f0b0cf48c9$var$loading[url];
                const reader = response.body.getReader();
                const contentLength = response.headers.get("Content-Length");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw Error(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $e97a97f0b0cf48c9$export$94affb487e701bf2.add(url, data);
            const callbacks = $e97a97f0b0cf48c9$var$loading[url];
            delete $e97a97f0b0cf48c9$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $e97a97f0b0cf48c9$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $e97a97f0b0cf48c9$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $e97a97f0b0cf48c9$export$29711c7e14f61db extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $e97a97f0b0cf48c9$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $e97a97f0b0cf48c9$export$bd73ce947a280350 extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $e97a97f0b0cf48c9$export$3466bac9141a5cc4();
        const loader = new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $e97a97f0b0cf48c9$export$8905ce1c7a2464a1 extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $e97a97f0b0cf48c9$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $e97a97f0b0cf48c9$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $e97a97f0b0cf48c9$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.substr(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $e97a97f0b0cf48c9$export$2ec114afc2cf6308 extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $e97a97f0b0cf48c9$export$ee2e5a18258a4049();
        const loader = new $e97a97f0b0cf48c9$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $e97a97f0b0cf48c9$export$792d8a18f2c55855 extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $e97a97f0b0cf48c9$export$b691f601014eabe1();
        const loader = new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $e97a97f0b0cf48c9$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $e97a97f0b0cf48c9$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $e97a97f0b0cf48c9$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $e97a97f0b0cf48c9$export$fd1bfc71f64c538c extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $e97a97f0b0cf48c9$export$5431306cf43de24a();
        const loader = new $e97a97f0b0cf48c9$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $e97a97f0b0cf48c9$export$6ecadb6ed240d696 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.type = "Light";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
$e97a97f0b0cf48c9$export$6ecadb6ed240d696.prototype.isLight = true;
class $e97a97f0b0cf48c9$export$8d474f55edbb9624 extends $e97a97f0b0cf48c9$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.type = "HemisphereLight";
        this.position.copy($e97a97f0b0cf48c9$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.groundColor = new $e97a97f0b0cf48c9$export$892596cec99bc70e(groundColor);
    }
    copy(source) {
        $e97a97f0b0cf48c9$export$6ecadb6ed240d696.prototype.copy.call(this, source);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
$e97a97f0b0cf48c9$export$8d474f55edbb9624.prototype.isHemisphereLight = true;
const $e97a97f0b0cf48c9$var$_projScreenMatrix$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_lightPositionWorld$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_lookTarget$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $e97a97f0b0cf48c9$export$35efe6f4c85463d2();
        this._frameExtents = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $e97a97f0b0cf48c9$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($e97a97f0b0cf48c9$var$_lightPositionWorld$1);
        $e97a97f0b0cf48c9$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($e97a97f0b0cf48c9$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $e97a97f0b0cf48c9$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($e97a97f0b0cf48c9$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $e97a97f0b0cf48c9$var$SpotLightShadow extends $e97a97f0b0cf48c9$var$LightShadow {
    constructor(){
        super(new $e97a97f0b0cf48c9$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $e97a97f0b0cf48c9$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
$e97a97f0b0cf48c9$var$SpotLightShadow.prototype.isSpotLightShadow = true;
class $e97a97f0b0cf48c9$export$81495cbb73897362 extends $e97a97f0b0cf48c9$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 1){
        super(color, intensity);
        this.type = "SpotLight";
        this.position.copy($e97a97f0b0cf48c9$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $e97a97f0b0cf48c9$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $e97a97f0b0cf48c9$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
$e97a97f0b0cf48c9$export$81495cbb73897362.prototype.isSpotLight = true;
const $e97a97f0b0cf48c9$var$_projScreenMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_lightPositionWorld = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_lookTarget = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$var$PointLightShadow extends $e97a97f0b0cf48c9$var$LightShadow {
    constructor(){
        super(new $e97a97f0b0cf48c9$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this._frameExtents = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(1, 0, 0),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(-1, 0, 0),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, 1),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, -1),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 1, 0),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, 1),
            new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $e97a97f0b0cf48c9$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($e97a97f0b0cf48c9$var$_lightPositionWorld);
        $e97a97f0b0cf48c9$var$_lookTarget.copy(camera.position);
        $e97a97f0b0cf48c9$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($e97a97f0b0cf48c9$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$e97a97f0b0cf48c9$var$_lightPositionWorld.x, -$e97a97f0b0cf48c9$var$_lightPositionWorld.y, -$e97a97f0b0cf48c9$var$_lightPositionWorld.z);
        $e97a97f0b0cf48c9$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($e97a97f0b0cf48c9$var$_projScreenMatrix);
    }
}
$e97a97f0b0cf48c9$var$PointLightShadow.prototype.isPointLightShadow = true;
class $e97a97f0b0cf48c9$export$4c9c1cb3f0b6f455 extends $e97a97f0b0cf48c9$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 1){
        super(color, intensity);
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $e97a97f0b0cf48c9$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
$e97a97f0b0cf48c9$export$4c9c1cb3f0b6f455.prototype.isPointLight = true;
class $e97a97f0b0cf48c9$var$DirectionalLightShadow extends $e97a97f0b0cf48c9$var$LightShadow {
    constructor(){
        super(new $e97a97f0b0cf48c9$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
    }
}
$e97a97f0b0cf48c9$var$DirectionalLightShadow.prototype.isDirectionalLightShadow = true;
class $e97a97f0b0cf48c9$export$3fea33cc9972c868 extends $e97a97f0b0cf48c9$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.type = "DirectionalLight";
        this.position.copy($e97a97f0b0cf48c9$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $e97a97f0b0cf48c9$export$e4dd07dff30cc924();
        this.shadow = new $e97a97f0b0cf48c9$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
$e97a97f0b0cf48c9$export$3fea33cc9972c868.prototype.isDirectionalLight = true;
class $e97a97f0b0cf48c9$export$af279bfef9ec2c96 extends $e97a97f0b0cf48c9$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.type = "AmbientLight";
    }
}
$e97a97f0b0cf48c9$export$af279bfef9ec2c96.prototype.isAmbientLight = true;
class $e97a97f0b0cf48c9$export$61db2d908bbd2429 extends $e97a97f0b0cf48c9$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
$e97a97f0b0cf48c9$export$61db2d908bbd2429.prototype.isRectAreaLight = true;
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $e97a97f0b0cf48c9$export$ba61ce607e1f405a {
    constructor(){
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $e97a97f0b0cf48c9$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
$e97a97f0b0cf48c9$export$ba61ce607e1f405a.prototype.isSphericalHarmonics3 = true;
class $e97a97f0b0cf48c9$export$e7ef036e309b38d2 extends $e97a97f0b0cf48c9$export$6ecadb6ed240d696 {
    constructor(sh = new $e97a97f0b0cf48c9$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
$e97a97f0b0cf48c9$export$e7ef036e309b38d2.prototype.isLightProbe = true;
class $e97a97f0b0cf48c9$export$3bd6d323353dcf96 extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = new $e97a97f0b0cf48c9$var$Materials[json.type]();
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $e97a97f0b0cf48c9$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $e97a97f0b0cf48c9$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $e97a97f0b0cf48c9$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $e97a97f0b0cf48c9$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $e97a97f0b0cf48c9$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // Deprecated
        if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
}
class $e97a97f0b0cf48c9$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.substr(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $e97a97f0b0cf48c9$export$231f009cbe414146 extends $e97a97f0b0cf48c9$export$b7be63a67df8959 {
    constructor(){
        super();
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const data = super.toJSON(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
$e97a97f0b0cf48c9$export$231f009cbe414146.prototype.isInstancedBufferGeometry = true;
class $e97a97f0b0cf48c9$export$dc275bb96327833a extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $e97a97f0b0cf48c9$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $e97a97f0b0cf48c9$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $e97a97f0b0cf48c9$export$231f009cbe414146() : new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $e97a97f0b0cf48c9$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $e97a97f0b0cf48c9$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $e97a97f0b0cf48c9$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $e97a97f0b0cf48c9$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $e97a97f0b0cf48c9$export$32ea87a8b54d744a : $e97a97f0b0cf48c9$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $e97a97f0b0cf48c9$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $e97a97f0b0cf48c9$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $e97a97f0b0cf48c9$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $e97a97f0b0cf48c9$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $e97a97f0b0cf48c9$export$40110c8505c5ad19 extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $e97a97f0b0cf48c9$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $e97a97f0b0cf48c9$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid] instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $e97a97f0b0cf48c9$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $e97a97f0b0cf48c9$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $e97a97f0b0cf48c9$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    case "Geometry":
                        console.error("THREE.ObjectLoader: The legacy Geometry type is no longer supported.");
                        break;
                    default:
                        if (data.type in $e97a97f0b0cf48c9$var$Geometries) geometry = $e97a97f0b0cf48c9$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $e97a97f0b0cf48c9$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (data.type === "MultiMaterial") {
                    // Deprecated
                    const array = [];
                    for(let j = 0; j < data.materials.length; j++){
                        const material = data.materials[j];
                        if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                        array.push(cache[material.uuid]);
                    }
                    materials[data.uuid] = array;
                } else {
                    if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                    materials[data.uuid] = cache[data.uuid];
                }
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $e97a97f0b0cf48c9$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $e97a97f0b0cf48c9$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $e97a97f0b0cf48c9$export$99cc795e99919eed(onLoad);
            loader = new $e97a97f0b0cf48c9$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new $e97a97f0b0cf48c9$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $e97a97f0b0cf48c9$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $e97a97f0b0cf48c9$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new $e97a97f0b0cf48c9$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            let texture;
            const image = images[data.image];
            if (Array.isArray(image)) {
                texture = new $e97a97f0b0cf48c9$export$ee2e5a18258a4049(image);
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $e97a97f0b0cf48c9$export$b691f601014eabe1(image.data, image.width, image.height);
                else texture = new $e97a97f0b0cf48c9$export$5431306cf43de24a(image);
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $e97a97f0b0cf48c9$var$TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $e97a97f0b0cf48c9$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $e97a97f0b0cf48c9$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $e97a97f0b0cf48c9$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $e97a97f0b0cf48c9$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $e97a97f0b0cf48c9$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $e97a97f0b0cf48c9$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $e97a97f0b0cf48c9$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $e97a97f0b0cf48c9$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                break;
            case "PerspectiveCamera":
                object = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $e97a97f0b0cf48c9$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $e97a97f0b0cf48c9$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $e97a97f0b0cf48c9$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $e97a97f0b0cf48c9$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $e97a97f0b0cf48c9$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $e97a97f0b0cf48c9$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $e97a97f0b0cf48c9$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $e97a97f0b0cf48c9$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $e97a97f0b0cf48c9$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $e97a97f0b0cf48c9$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $e97a97f0b0cf48c9$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $e97a97f0b0cf48c9$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $e97a97f0b0cf48c9$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $e97a97f0b0cf48c9$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $e97a97f0b0cf48c9$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $e97a97f0b0cf48c9$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $e97a97f0b0cf48c9$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $e97a97f0b0cf48c9$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $e97a97f0b0cf48c9$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $e97a97f0b0cf48c9$export$b127726e56765aa4();
                break;
            default:
                object = new $e97a97f0b0cf48c9$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    /* DEPRECATED */ setTexturePath(value) {
        console.warn("THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().");
        return this.setResourcePath(value);
    }
}
const $e97a97f0b0cf48c9$var$TEXTURE_MAPPING = {
    UVMapping: $e97a97f0b0cf48c9$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $e97a97f0b0cf48c9$export$8759762a6477f2c4,
    CubeRefractionMapping: $e97a97f0b0cf48c9$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $e97a97f0b0cf48c9$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $e97a97f0b0cf48c9$export$ee99d97d46898098,
    CubeUVReflectionMapping: $e97a97f0b0cf48c9$export$dbf3e70ff37af79,
    CubeUVRefractionMapping: $e97a97f0b0cf48c9$export$76a9f4355364345c
};
const $e97a97f0b0cf48c9$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $e97a97f0b0cf48c9$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $e97a97f0b0cf48c9$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $e97a97f0b0cf48c9$export$c7e7c00b14f51a4f
};
const $e97a97f0b0cf48c9$var$TEXTURE_FILTER = {
    NearestFilter: $e97a97f0b0cf48c9$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $e97a97f0b0cf48c9$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $e97a97f0b0cf48c9$export$d2327c1afe5bfdf2,
    LinearFilter: $e97a97f0b0cf48c9$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $e97a97f0b0cf48c9$export$19a719f377145a13,
    LinearMipmapLinearFilter: $e97a97f0b0cf48c9$export$5d8599b6a933fb1b
};
class $e97a97f0b0cf48c9$export$52286b55c4a9b51f extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $e97a97f0b0cf48c9$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $e97a97f0b0cf48c9$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
$e97a97f0b0cf48c9$export$52286b55c4a9b51f.prototype.isImageBitmapLoader = true;
let $e97a97f0b0cf48c9$var$_context;
const $e97a97f0b0cf48c9$export$fcbc63750ec2a81f = {
    getContext: function() {
        if ($e97a97f0b0cf48c9$var$_context === undefined) $e97a97f0b0cf48c9$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $e97a97f0b0cf48c9$var$_context;
    },
    setContext: function(value) {
        $e97a97f0b0cf48c9$var$_context = value;
    }
};
class $e97a97f0b0cf48c9$export$d8d5fccfbf47714e extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $e97a97f0b0cf48c9$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
}
class $e97a97f0b0cf48c9$export$2f22dadc8bc42820 extends $e97a97f0b0cf48c9$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        const color1 = new $e97a97f0b0cf48c9$export$892596cec99bc70e().set(skyColor);
        const color2 = new $e97a97f0b0cf48c9$export$892596cec99bc70e().set(groundColor);
        const sky = new $e97a97f0b0cf48c9$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $e97a97f0b0cf48c9$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
$e97a97f0b0cf48c9$export$2f22dadc8bc42820.prototype.isHemisphereLightProbe = true;
class $e97a97f0b0cf48c9$export$afe310a21c86023d extends $e97a97f0b0cf48c9$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        const color1 = new $e97a97f0b0cf48c9$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
$e97a97f0b0cf48c9$export$afe310a21c86023d.prototype.isAmbientLightProbe = true;
const $e97a97f0b0cf48c9$var$_eyeRight = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_eyeLeft = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_projectionMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
class $e97a97f0b0cf48c9$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $e97a97f0b0cf48c9$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($e97a97f0b0cf48c9$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $e97a97f0b0cf48c9$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $e97a97f0b0cf48c9$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $e97a97f0b0cf48c9$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $e97a97f0b0cf48c9$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($e97a97f0b0cf48c9$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $e97a97f0b0cf48c9$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $e97a97f0b0cf48c9$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($e97a97f0b0cf48c9$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($e97a97f0b0cf48c9$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($e97a97f0b0cf48c9$var$_eyeRight);
    }
}
class $e97a97f0b0cf48c9$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $e97a97f0b0cf48c9$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $e97a97f0b0cf48c9$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $e97a97f0b0cf48c9$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $e97a97f0b0cf48c9$var$_position$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_quaternion$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3();
const $e97a97f0b0cf48c9$var$_scale$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_orientation$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$8a1b810c6fde8951 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $e97a97f0b0cf48c9$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $e97a97f0b0cf48c9$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($e97a97f0b0cf48c9$var$_position$1, $e97a97f0b0cf48c9$var$_quaternion$1, $e97a97f0b0cf48c9$var$_scale$1);
        $e97a97f0b0cf48c9$var$_orientation$1.set(0, 0, -1).applyQuaternion($e97a97f0b0cf48c9$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($e97a97f0b0cf48c9$var$_position$1.x, $e97a97f0b0cf48c9$var$_position$1.y, $e97a97f0b0cf48c9$var$_position$1.z);
            listener.setOrientation($e97a97f0b0cf48c9$var$_orientation$1.x, $e97a97f0b0cf48c9$var$_orientation$1.y, $e97a97f0b0cf48c9$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $e97a97f0b0cf48c9$export$153755f98d9861de extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $e97a97f0b0cf48c9$var$_position = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_quaternion = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3();
const $e97a97f0b0cf48c9$var$_scale = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_orientation = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$4b3e397ef1832507 extends $e97a97f0b0cf48c9$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($e97a97f0b0cf48c9$var$_position, $e97a97f0b0cf48c9$var$_quaternion, $e97a97f0b0cf48c9$var$_scale);
        $e97a97f0b0cf48c9$var$_orientation.set(0, 0, 1).applyQuaternion($e97a97f0b0cf48c9$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($e97a97f0b0cf48c9$var$_orientation.z, endTime);
        } else {
            panner.setPosition($e97a97f0b0cf48c9$var$_position.x, $e97a97f0b0cf48c9$var$_position.y, $e97a97f0b0cf48c9$var$_position.z);
            panner.setOrientation($e97a97f0b0cf48c9$var$_orientation.x, $e97a97f0b0cf48c9$var$_orientation.y, $e97a97f0b0cf48c9$var$_orientation.z);
        }
    }
}
class $e97a97f0b0cf48c9$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $e97a97f0b0cf48c9$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $e97a97f0b0cf48c9$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $e97a97f0b0cf48c9$var$_reservedRe = new RegExp("[" + $e97a97f0b0cf48c9$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $e97a97f0b0cf48c9$var$_wordChar = "[^" + $e97a97f0b0cf48c9$var$_RESERVED_CHARS_RE + "]";
const $e97a97f0b0cf48c9$var$_wordCharOrDot = "[^" + $e97a97f0b0cf48c9$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $e97a97f0b0cf48c9$var$_directoryRe = /((?:WC+[\/:])*)/.source.replace("WC", $e97a97f0b0cf48c9$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $e97a97f0b0cf48c9$var$_nodeRe = /(WCOD+)?/.source.replace("WCOD", $e97a97f0b0cf48c9$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $e97a97f0b0cf48c9$var$_objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $e97a97f0b0cf48c9$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $e97a97f0b0cf48c9$var$_propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $e97a97f0b0cf48c9$var$_wordChar);
const $e97a97f0b0cf48c9$var$_trackRe = new RegExp("^" + $e97a97f0b0cf48c9$var$_directoryRe + $e97a97f0b0cf48c9$var$_nodeRe + $e97a97f0b0cf48c9$var$_objectRe + $e97a97f0b0cf48c9$var$_propertyRe + "$");
const $e97a97f0b0cf48c9$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones"
];
class $e97a97f0b0cf48c9$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $e97a97f0b0cf48c9$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $e97a97f0b0cf48c9$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $e97a97f0b0cf48c9$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $e97a97f0b0cf48c9$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $e97a97f0b0cf48c9$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $e97a97f0b0cf48c9$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($e97a97f0b0cf48c9$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $e97a97f0b0cf48c9$var$_trackRe.exec(trackName);
        if (!matches) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($e97a97f0b0cf48c9$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (!nodeName || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $e97a97f0b0cf48c9$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (targetObject.geometry.isBufferGeometry) {
                    if (!targetObject.geometry.morphAttributes) {
                        console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        return;
                    }
                    if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                } else {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
                    return;
                }
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$e97a97f0b0cf48c9$export$7bf70fcf9f891893.Composite = $e97a97f0b0cf48c9$var$Composite;
$e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._getValue_direct,
    $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._getValue_array,
    $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_direct,
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_array,
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $e97a97f0b0cf48c9$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $e97a97f0b0cf48c9$export$30619c2afd3f34db {
    constructor(){
        this.uuid = $e97a97f0b0cf48c9$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $e97a97f0b0cf48c9$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $e97a97f0b0cf48c9$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $e97a97f0b0cf48c9$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
$e97a97f0b0cf48c9$export$30619c2afd3f34db.prototype.isAnimationObjectGroup = true;
class $e97a97f0b0cf48c9$var$AnimationAction {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $e97a97f0b0cf48c9$export$7f795934b84ab523,
            endingEnd: $e97a97f0b0cf48c9$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $e97a97f0b0cf48c9$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
            // start
            this._startTime = null; // unschedule
            deltaTime = timeDirection * timeRunning;
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $e97a97f0b0cf48c9$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $e97a97f0b0cf48c9$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $e97a97f0b0cf48c9$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $e97a97f0b0cf48c9$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $e97a97f0b0cf48c9$export$24a4ccb5099273b5;
            settings.endingEnd = $e97a97f0b0cf48c9$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $e97a97f0b0cf48c9$export$24a4ccb5099273b5 : $e97a97f0b0cf48c9$export$7f795934b84ab523;
            else settings.endingStart = $e97a97f0b0cf48c9$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $e97a97f0b0cf48c9$export$24a4ccb5099273b5 : $e97a97f0b0cf48c9$export$7f795934b84ab523;
            else settings.endingEnd = $e97a97f0b0cf48c9$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
class $e97a97f0b0cf48c9$export$fbd77e5aefaa0102 extends $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $e97a97f0b0cf48c9$export$dfe0af1ca1acb78a($e97a97f0b0cf48c9$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $e97a97f0b0cf48c9$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $e97a97f0b0cf48c9$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $e97a97f0b0cf48c9$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $e97a97f0b0cf48c9$var$AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $e97a97f0b0cf48c9$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
$e97a97f0b0cf48c9$export$fbd77e5aefaa0102.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
class $e97a97f0b0cf48c9$export$2947cebfe91c02f8 {
    constructor(value){
        if (typeof value === "string") {
            console.warn("THREE.Uniform: Type parameter is no longer needed.");
            value = arguments[1];
        }
        this.value = value;
    }
    clone() {
        return new $e97a97f0b0cf48c9$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
class $e97a97f0b0cf48c9$export$25ec0e1af1389358 extends $e97a97f0b0cf48c9$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
$e97a97f0b0cf48c9$export$25ec0e1af1389358.prototype.isInstancedInterleavedBuffer = true;
class $e97a97f0b0cf48c9$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
$e97a97f0b0cf48c9$export$6b7339ae8dbddf73.prototype.isGLBufferAttribute = true;
class $e97a97f0b0cf48c9$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $e97a97f0b0cf48c9$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $e97a97f0b0cf48c9$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera && camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera && camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $e97a97f0b0cf48c9$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($e97a97f0b0cf48c9$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$e97a97f0b0cf48c9$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($e97a97f0b0cf48c9$var$ascSort);
        return intersects;
    }
}
function $e97a97f0b0cf48c9$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $e97a97f0b0cf48c9$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$e97a97f0b0cf48c9$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $e97a97f0b0cf48c9$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be betwee EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($e97a97f0b0cf48c9$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $e97a97f0b0cf48c9$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $e97a97f0b0cf48c9$var$_vector$4 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
class $e97a97f0b0cf48c9$export$60f553fa130f08b0 {
    constructor(min = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(Infinity, Infinity), max = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $e97a97f0b0cf48c9$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $e97a97f0b0cf48c9$var$_vector$4.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
$e97a97f0b0cf48c9$export$60f553fa130f08b0.prototype.isBox2 = true;
const $e97a97f0b0cf48c9$var$_startP = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_startEnd = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$e0ba6359f1954fd3 {
    constructor(start = new $e97a97f0b0cf48c9$export$64b5c384219d3699(), end = new $e97a97f0b0cf48c9$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $e97a97f0b0cf48c9$var$_startP.subVectors(point, this.start);
        $e97a97f0b0cf48c9$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $e97a97f0b0cf48c9$var$_startEnd.dot($e97a97f0b0cf48c9$var$_startEnd);
        const startEnd_startP = $e97a97f0b0cf48c9$var$_startEnd.dot($e97a97f0b0cf48c9$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $e97a97f0b0cf48c9$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $e97a97f0b0cf48c9$var$_vector$3 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$4b14638ffdd81e68 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(positions, 3));
        const material = new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $e97a97f0b0cf48c9$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $e97a97f0b0cf48c9$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($e97a97f0b0cf48c9$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $e97a97f0b0cf48c9$var$_vector$2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_boneMatrix = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
const $e97a97f0b0cf48c9$var$_matrixWorldInv = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
class $e97a97f0b0cf48c9$export$5277df3c9e732259 extends $e97a97f0b0cf48c9$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $e97a97f0b0cf48c9$var$getBoneList(object);
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(colors, 3));
        const material = new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.type = "SkeletonHelper";
        this.isSkeletonHelper = true;
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $e97a97f0b0cf48c9$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $e97a97f0b0cf48c9$var$_boneMatrix.multiplyMatrices($e97a97f0b0cf48c9$var$_matrixWorldInv, bone.matrixWorld);
                $e97a97f0b0cf48c9$var$_vector$2.setFromMatrixPosition($e97a97f0b0cf48c9$var$_boneMatrix);
                position.setXYZ(j, $e97a97f0b0cf48c9$var$_vector$2.x, $e97a97f0b0cf48c9$var$_vector$2.y, $e97a97f0b0cf48c9$var$_vector$2.z);
                $e97a97f0b0cf48c9$var$_boneMatrix.multiplyMatrices($e97a97f0b0cf48c9$var$_matrixWorldInv, bone.parent.matrixWorld);
                $e97a97f0b0cf48c9$var$_vector$2.setFromMatrixPosition($e97a97f0b0cf48c9$var$_boneMatrix);
                position.setXYZ(j + 1, $e97a97f0b0cf48c9$var$_vector$2.x, $e97a97f0b0cf48c9$var$_vector$2.y, $e97a97f0b0cf48c9$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
}
function $e97a97f0b0cf48c9$var$getBoneList(object) {
    const boneList = [];
    if (object && object.isBone) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $e97a97f0b0cf48c9$var$getBoneList(object.children[i]));
    return boneList;
}
class $e97a97f0b0cf48c9$export$9a9291685b9e4023 extends $e97a97f0b0cf48c9$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $e97a97f0b0cf48c9$export$d5d06a966fec4192(sphereSize, 4, 2);
        const material = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronBufferGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $e97a97f0b0cf48c9$var$_vector$1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_color1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$892596cec99bc70e();
const $e97a97f0b0cf48c9$var$_color2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$892596cec99bc70e();
class $e97a97f0b0cf48c9$export$8dca15f13f4f8172 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $e97a97f0b0cf48c9$export$8e05fc91596f4752(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $e97a97f0b0cf48c9$export$8dea267bd6bde117(colors, 3));
        this.add(new $e97a97f0b0cf48c9$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $e97a97f0b0cf48c9$var$_color1.copy(this.light.color);
            $e97a97f0b0cf48c9$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $e97a97f0b0cf48c9$var$_color1 : $e97a97f0b0cf48c9$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt($e97a97f0b0cf48c9$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $e97a97f0b0cf48c9$export$3875d39926561055 extends $e97a97f0b0cf48c9$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $e97a97f0b0cf48c9$export$892596cec99bc70e(color1);
        color2 = new $e97a97f0b0cf48c9$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(colors, 3));
        const material = new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
}
class $e97a97f0b0cf48c9$export$361430a10f533cd3 extends $e97a97f0b0cf48c9$export$ff1ed10fedfdd604 {
    constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $e97a97f0b0cf48c9$export$892596cec99bc70e(color1);
        color2 = new $e97a97f0b0cf48c9$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the radials
        for(let i = 0; i <= radials; i++){
            const v = i / radials * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(let i = 0; i <= circles; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / circles * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(colors, 3));
        const material = new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
}
const $e97a97f0b0cf48c9$var$_v1 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v2 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_v3 = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
class $e97a97f0b0cf48c9$export$f8e434dc14203e7d extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $e97a97f0b0cf48c9$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $e97a97f0b0cf48c9$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        $e97a97f0b0cf48c9$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $e97a97f0b0cf48c9$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $e97a97f0b0cf48c9$var$_v3.subVectors($e97a97f0b0cf48c9$var$_v2, $e97a97f0b0cf48c9$var$_v1);
        this.lightPlane.lookAt($e97a97f0b0cf48c9$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($e97a97f0b0cf48c9$var$_v2);
        this.targetLine.scale.z = $e97a97f0b0cf48c9$var$_v3.length();
    }
}
const $e97a97f0b0cf48c9$var$_vector = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
const $e97a97f0b0cf48c9$var$_camera = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $e97a97f0b0cf48c9$export$ed8e93f853cd795 extends $e97a97f0b0cf48c9$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        const material = new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // colors
        const colorFrustum = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xff0000);
        const colorUp = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0xffffff);
        const colorCross = new $e97a97f0b0cf48c9$export$892596cec99bc70e(0x333333);
        // near
        addLine("n1", "n2", colorFrustum);
        addLine("n2", "n4", colorFrustum);
        addLine("n4", "n3", colorFrustum);
        addLine("n3", "n1", colorFrustum);
        // far
        addLine("f1", "f2", colorFrustum);
        addLine("f2", "f4", colorFrustum);
        addLine("f4", "f3", colorFrustum);
        addLine("f3", "f1", colorFrustum);
        // sides
        addLine("n1", "f1", colorFrustum);
        addLine("n2", "f2", colorFrustum);
        addLine("n3", "f3", colorFrustum);
        addLine("n4", "f4", colorFrustum);
        // cone
        addLine("p", "n1", colorCone);
        addLine("p", "n2", colorCone);
        addLine("p", "n3", colorCone);
        addLine("p", "n4", colorCone);
        // up
        addLine("u1", "u2", colorUp);
        addLine("u2", "u3", colorUp);
        addLine("u3", "u1", colorUp);
        // target
        addLine("c", "t", colorTarget);
        addLine("p", "c", colorCross);
        // cross
        addLine("cn1", "cn2", colorCross);
        addLine("cn3", "cn4", colorCross);
        addLine("cf1", "cf2", colorCross);
        addLine("cf3", "cf4", colorCross);
        function addLine(a, b, color) {
            addPoint(a, color);
            addPoint(b, color);
        }
        function addPoint(id, color) {
            vertices.push(0, 0, 0);
            colors.push(color.r, color.g, color.b);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $e97a97f0b0cf48c9$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $e97a97f0b0cf48c9$var$setPoint("c", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, 0, 0, -1);
        $e97a97f0b0cf48c9$var$setPoint("t", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, 0, 0, 1);
        // near
        $e97a97f0b0cf48c9$var$setPoint("n1", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, -w, -h, -1);
        $e97a97f0b0cf48c9$var$setPoint("n2", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, w, -h, -1);
        $e97a97f0b0cf48c9$var$setPoint("n3", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, -w, h, -1);
        $e97a97f0b0cf48c9$var$setPoint("n4", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, w, h, -1);
        // far
        $e97a97f0b0cf48c9$var$setPoint("f1", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, -w, -h, 1);
        $e97a97f0b0cf48c9$var$setPoint("f2", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, w, -h, 1);
        $e97a97f0b0cf48c9$var$setPoint("f3", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, -w, h, 1);
        $e97a97f0b0cf48c9$var$setPoint("f4", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, w, h, 1);
        // up
        $e97a97f0b0cf48c9$var$setPoint("u1", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, w * 0.7, h * 1.1, -1);
        $e97a97f0b0cf48c9$var$setPoint("u2", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, -w * 0.7, h * 1.1, -1);
        $e97a97f0b0cf48c9$var$setPoint("u3", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, 0, h * 2, -1);
        // cross
        $e97a97f0b0cf48c9$var$setPoint("cf1", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, -w, 0, 1);
        $e97a97f0b0cf48c9$var$setPoint("cf2", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, w, 0, 1);
        $e97a97f0b0cf48c9$var$setPoint("cf3", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, 0, -h, 1);
        $e97a97f0b0cf48c9$var$setPoint("cf4", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, 0, h, 1);
        $e97a97f0b0cf48c9$var$setPoint("cn1", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, -w, 0, -1);
        $e97a97f0b0cf48c9$var$setPoint("cn2", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, w, 0, -1);
        $e97a97f0b0cf48c9$var$setPoint("cn3", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, 0, -h, -1);
        $e97a97f0b0cf48c9$var$setPoint("cn4", pointMap, geometry, $e97a97f0b0cf48c9$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $e97a97f0b0cf48c9$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $e97a97f0b0cf48c9$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $e97a97f0b0cf48c9$var$_vector.x, $e97a97f0b0cf48c9$var$_vector.y, $e97a97f0b0cf48c9$var$_vector.z);
    }
}
const $e97a97f0b0cf48c9$var$_box = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3();
class $e97a97f0b0cf48c9$export$38a664cc862a6a9d extends $e97a97f0b0cf48c9$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry.setIndex(new $e97a97f0b0cf48c9$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $e97a97f0b0cf48c9$var$_box.setFromObject(this.object);
        if ($e97a97f0b0cf48c9$var$_box.isEmpty()) return;
        const min = $e97a97f0b0cf48c9$var$_box.min;
        const max = $e97a97f0b0cf48c9$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source) {
        $e97a97f0b0cf48c9$export$ff1ed10fedfdd604.prototype.copy.call(this, source);
        this.object = source.object;
        return this;
    }
}
class $e97a97f0b0cf48c9$export$ce39f4bb96c9a290 extends $e97a97f0b0cf48c9$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry.setIndex(new $e97a97f0b0cf48c9$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
}
class $e97a97f0b0cf48c9$export$a34fe8156c66e5d7 extends $e97a97f0b0cf48c9$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0
        ];
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1
        ];
        const geometry2 = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $e97a97f0b0cf48c9$export$e176487c05830cc5(geometry2, new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        let scale = -this.plane.constant;
        if (Math.abs(scale) < 1e-8) scale = 1e-8; // sign does not matter
        this.scale.set(0.5 * this.size, 0.5 * this.size, scale);
        this.children[0].material.side = scale < 0 ? $e97a97f0b0cf48c9$export$d9f0486e75b5ace : $e97a97f0b0cf48c9$export$2ede184fc2998901; // renderer flips side when determinant < 0; flipping not wanted here
        this.lookAt(this.plane.normal);
        super.updateMatrixWorld(force);
    }
}
const $e97a97f0b0cf48c9$var$_axis = /*@__PURE__*/ new $e97a97f0b0cf48c9$export$64b5c384219d3699();
let $e97a97f0b0cf48c9$var$_lineGeometry, $e97a97f0b0cf48c9$var$_coneGeometry;
class $e97a97f0b0cf48c9$export$a3008e7bd8d2cbe7 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, 1), origin = new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($e97a97f0b0cf48c9$var$_lineGeometry === undefined) {
            $e97a97f0b0cf48c9$var$_lineGeometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
            $e97a97f0b0cf48c9$var$_lineGeometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $e97a97f0b0cf48c9$var$_coneGeometry = new $e97a97f0b0cf48c9$export$d4345c83207d7c68(0, 0.5, 1, 5, 1);
            $e97a97f0b0cf48c9$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $e97a97f0b0cf48c9$export$17d680238e50603e($e97a97f0b0cf48c9$var$_lineGeometry, new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $e97a97f0b0cf48c9$export$e176487c05830cc5($e97a97f0b0cf48c9$var$_coneGeometry, new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $e97a97f0b0cf48c9$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($e97a97f0b0cf48c9$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
}
class $e97a97f0b0cf48c9$export$6c8303f35b8578fd extends $e97a97f0b0cf48c9$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $e97a97f0b0cf48c9$export$b7be63a67df8959();
        geometry.setAttribute("position", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(colors, 3));
        const material = new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $e97a97f0b0cf48c9$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $e97a97f0b0cf48c9$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $e97a97f0b0cf48c9$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $e97a97f0b0cf48c9$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW, noHoles) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $e97a97f0b0cf48c9$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $e97a97f0b0cf48c9$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        if (noHoles === true) return toShapesNoHoles(subPaths);
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $e97a97f0b0cf48c9$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $e97a97f0b0cf48c9$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            const toChange = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange.push({
                            froms: sIdx,
                            tos: s2Idx,
                            hole: hIdx
                        });
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            // console.log("ambiguous: ", ambiguous);
            if (toChange.length > 0) // console.log("to change: ", toChange);
            {
                if (!ambiguous) newShapeHoles = betterShapeHoles;
            }
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
const $e97a97f0b0cf48c9$var$_floatView = new Float32Array(1);
const $e97a97f0b0cf48c9$var$_int32View = new Int32Array($e97a97f0b0cf48c9$var$_floatView.buffer);
class $e97a97f0b0cf48c9$export$11ce8b759162cc80 {
    // Converts float32 to float16 (stored as uint16 value).
    static toHalfFloat(val) {
        if (val > 65504) {
            console.warn("THREE.DataUtils.toHalfFloat(): value exceeds 65504.");
            val = 65504; // maximum representable value in float16
        }
        // Source: http://gamedev.stackexchange.com/questions/17326/conversion-of-a-number-from-single-precision-floating-point-representation-to-a/17410#17410
        /* This method is faster than the OpenEXR implementation (very often
		* used, eg. in Ogre), with the additional benefit of rounding, inspired
		* by James Tursa?s half-precision code. */ $e97a97f0b0cf48c9$var$_floatView[0] = val;
        const x = $e97a97f0b0cf48c9$var$_int32View[0];
        let bits = x >> 16 & 0x8000; /* Get the sign */ 
        let m = x >> 12 & 0x07ff; /* Keep one extra bit for rounding */ 
        const e = x >> 23 & 0xff; /* Using int is faster here */ 
        /* If zero, or denormal, or exponent underflows too much for a denormal
			* half, return signed zero. */ if (e < 103) return bits;
        /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */ if (e > 142) {
            bits |= 0x7c00;
            /* If exponent was 0xff and one mantissa bit was set, it means NaN,
						* not Inf, so make sure we set one mantissa bit too. */ bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
            return bits;
        }
        /* If exponent underflows but not too much, return a denormal */ if (e < 113) {
            m |= 0x0800;
            /* Extra rounding may overflow and set mantissa to 0 and exponent
				* to 1, which is OK. */ bits |= (m >> 114 - e) + (m >> 113 - e & 1);
            return bits;
        }
        bits |= e - 112 << 10 | m >> 1;
        /* Extra rounding. An overflow will set mantissa to 0 and increment
			* the exponent, which is OK. */ bits += m & 1;
        return bits;
    }
}
const $e97a97f0b0cf48c9$export$195910b613d3dbcb = 0;
const $e97a97f0b0cf48c9$export$c8a71586e494fb81 = 1;
const $e97a97f0b0cf48c9$export$1a5c46edbdc9a5b7 = 0;
const $e97a97f0b0cf48c9$export$617e978cc3201d85 = 1;
const $e97a97f0b0cf48c9$export$969ede3d37172881 = 2;
function $e97a97f0b0cf48c9$export$8f0d8c869214e38a(materials) {
    console.warn("THREE.MeshFaceMaterial has been removed. Use an Array instead.");
    return materials;
}
function $e97a97f0b0cf48c9$export$4f1842f7cdf61f78(materials = []) {
    console.warn("THREE.MultiMaterial has been removed. Use an Array instead.");
    materials.isMultiMaterial = true;
    materials.materials = materials;
    materials.clone = function() {
        return materials.slice();
    };
    return materials;
}
function $e97a97f0b0cf48c9$export$5c812f854e08d33d(geometry, material) {
    console.warn("THREE.PointCloud has been renamed to THREE.Points.");
    return new $e97a97f0b0cf48c9$export$1c787534cb11aa3e(geometry, material);
}
function $e97a97f0b0cf48c9$export$c36c68baa13912a5(material) {
    console.warn("THREE.Particle has been renamed to THREE.Sprite.");
    return new $e97a97f0b0cf48c9$export$3075603db8e6204c(material);
}
function $e97a97f0b0cf48c9$export$f219b6a0e4bb0b6d(geometry, material) {
    console.warn("THREE.ParticleSystem has been renamed to THREE.Points.");
    return new $e97a97f0b0cf48c9$export$1c787534cb11aa3e(geometry, material);
}
function $e97a97f0b0cf48c9$export$29121d9ccd2f757a(parameters) {
    console.warn("THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.");
    return new $e97a97f0b0cf48c9$export$a178c45366ce5d6b(parameters);
}
function $e97a97f0b0cf48c9$export$ffa02580217a1c8(parameters) {
    console.warn("THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.");
    return new $e97a97f0b0cf48c9$export$a178c45366ce5d6b(parameters);
}
function $e97a97f0b0cf48c9$export$cb1306c614c86e6b(parameters) {
    console.warn("THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.");
    return new $e97a97f0b0cf48c9$export$a178c45366ce5d6b(parameters);
}
function $e97a97f0b0cf48c9$export$3e8a3cc8713efbec(x, y, z) {
    console.warn("THREE.Vertex has been removed. Use THREE.Vector3 instead.");
    return new $e97a97f0b0cf48c9$export$64b5c384219d3699(x, y, z);
}
//
function $e97a97f0b0cf48c9$export$189ab5ea9d161e81(array, itemSize) {
    console.warn("THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead.");
    return new $e97a97f0b0cf48c9$export$8dea267bd6bde117(array, itemSize).setUsage($e97a97f0b0cf48c9$export$8505d14ac8546ca);
}
function $e97a97f0b0cf48c9$export$e0ae4f0a1804ea11(array, itemSize) {
    console.warn("THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$f9ff2d6a20248cbf(array, itemSize);
}
function $e97a97f0b0cf48c9$export$a0d192e03a5b32f5(array, itemSize) {
    console.warn("THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$cacc90cf35d11cdd(array, itemSize);
}
function $e97a97f0b0cf48c9$export$8ca743ab36552bfa(array, itemSize) {
    console.warn("THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$baaa85a1a812c157(array, itemSize);
}
function $e97a97f0b0cf48c9$export$5d9757676aad9dab(array, itemSize) {
    console.warn("THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$2b755a102ccdcefe(array, itemSize);
}
function $e97a97f0b0cf48c9$export$ed102ffd14092320(array, itemSize) {
    console.warn("THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$640a853f68025f2e(array, itemSize);
}
function $e97a97f0b0cf48c9$export$6acc479034658f15(array, itemSize) {
    console.warn("THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$46b369aed2968a0a(array, itemSize);
}
function $e97a97f0b0cf48c9$export$53474877d6e539b9(array, itemSize) {
    console.warn("THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$7eb8c9fa25cd5bd6(array, itemSize);
}
function $e97a97f0b0cf48c9$export$377af6eadc8006c3(array, itemSize) {
    console.warn("THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$cbe7a62641830ebd(array, itemSize);
}
function $e97a97f0b0cf48c9$export$b9212d1a67b6f081(array, itemSize) {
    console.warn("THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.");
    return new $e97a97f0b0cf48c9$export$9e0ade74842adbb8(array, itemSize);
}
//
$e97a97f0b0cf48c9$export$b0e83c3ef8d2db1.create = function(construct, getPoint) {
    console.log("THREE.Curve.create() has been deprecated");
    construct.prototype = Object.create($e97a97f0b0cf48c9$export$b0e83c3ef8d2db1.prototype);
    construct.prototype.constructor = construct;
    construct.prototype.getPoint = getPoint;
    return construct;
};
//
$e97a97f0b0cf48c9$export$4b2950bdac9b6ee9.prototype.fromPoints = function(points) {
    console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints().");
    return this.setFromPoints(points);
};
//
function $e97a97f0b0cf48c9$export$46c1eaab6b8d1e23(size) {
    console.warn("THREE.AxisHelper has been renamed to THREE.AxesHelper.");
    return new $e97a97f0b0cf48c9$export$6c8303f35b8578fd(size);
}
function $e97a97f0b0cf48c9$export$3c24c67720a2146c(object, color) {
    console.warn("THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.");
    return new $e97a97f0b0cf48c9$export$38a664cc862a6a9d(object, color);
}
function $e97a97f0b0cf48c9$export$e341a90264c62d4c(object, hex) {
    console.warn("THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.");
    return new $e97a97f0b0cf48c9$export$ff1ed10fedfdd604(new $e97a97f0b0cf48c9$export$4730b1542707547f(object.geometry), new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
$e97a97f0b0cf48c9$export$3875d39926561055.prototype.setColors = function() {
    console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
};
$e97a97f0b0cf48c9$export$5277df3c9e732259.prototype.update = function() {
    console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
};
function $e97a97f0b0cf48c9$export$72d033539c529f13(object, hex) {
    console.warn("THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.");
    return new $e97a97f0b0cf48c9$export$ff1ed10fedfdd604(new $e97a97f0b0cf48c9$export$4b739da06d24892b(object.geometry), new $e97a97f0b0cf48c9$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
//
$e97a97f0b0cf48c9$export$3b0d6d7590275603.prototype.extractUrlBase = function(url) {
    console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.");
    return $e97a97f0b0cf48c9$export$b5d2dc08d867e41a.extractUrlBase(url);
};
$e97a97f0b0cf48c9$export$3b0d6d7590275603.Handlers = {
    add: function() {
        console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
    },
    get: function() {
        console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
    }
};
function $e97a97f0b0cf48c9$export$c8b77178c5db4e0d(manager) {
    console.warn("THREE.XHRLoader has been renamed to THREE.FileLoader.");
    return new $e97a97f0b0cf48c9$export$98435a25b5cf7b2b(manager);
}
function $e97a97f0b0cf48c9$export$58c7c1107fc658f9(manager) {
    console.warn("THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.");
    return new $e97a97f0b0cf48c9$export$792d8a18f2c55855(manager);
}
//
$e97a97f0b0cf48c9$export$60f553fa130f08b0.prototype.center = function(optionalTarget) {
    console.warn("THREE.Box2: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
$e97a97f0b0cf48c9$export$60f553fa130f08b0.prototype.empty = function() {
    console.warn("THREE.Box2: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
$e97a97f0b0cf48c9$export$60f553fa130f08b0.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$e97a97f0b0cf48c9$export$60f553fa130f08b0.prototype.size = function(optionalTarget) {
    console.warn("THREE.Box2: .size() has been renamed to .getSize().");
    return this.getSize(optionalTarget);
};
//
$e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3.prototype.center = function(optionalTarget) {
    console.warn("THREE.Box3: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
$e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3.prototype.empty = function() {
    console.warn("THREE.Box3: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
$e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3.prototype.isIntersectionSphere = function(sphere) {
    console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().");
    return this.intersectsSphere(sphere);
};
$e97a97f0b0cf48c9$export$6f7d5a9418ab2aa3.prototype.size = function(optionalTarget) {
    console.warn("THREE.Box3: .size() has been renamed to .getSize().");
    return this.getSize(optionalTarget);
};
//
$e97a97f0b0cf48c9$export$805e8b72413ccaba.prototype.empty = function() {
    console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty().");
    return this.isEmpty();
};
//
$e97a97f0b0cf48c9$export$35efe6f4c85463d2.prototype.setFromMatrix = function(m) {
    console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().");
    return this.setFromProjectionMatrix(m);
};
//
$e97a97f0b0cf48c9$export$e0ba6359f1954fd3.prototype.center = function(optionalTarget) {
    console.warn("THREE.Line3: .center() has been renamed to .getCenter().");
    return this.getCenter(optionalTarget);
};
//
$e97a97f0b0cf48c9$export$8ff26dafa08918.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
    return this.toArray(array, offset);
};
$e97a97f0b0cf48c9$export$8ff26dafa08918.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.");
    return vector.applyMatrix3(this);
};
$e97a97f0b0cf48c9$export$8ff26dafa08918.prototype.multiplyVector3Array = function() {
    console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
};
$e97a97f0b0cf48c9$export$8ff26dafa08918.prototype.applyToBufferAttribute = function(attribute) {
    console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.");
    return attribute.applyMatrix3(this);
};
$e97a97f0b0cf48c9$export$8ff26dafa08918.prototype.applyToVector3Array = function() {
    console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
};
$e97a97f0b0cf48c9$export$8ff26dafa08918.prototype.getInverse = function(matrix) {
    console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
    return this.copy(matrix).invert();
};
//
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.extractPosition = function(m) {
    console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().");
    return this.copyPosition(m);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
    return this.toArray(array, offset);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.getPosition = function() {
    console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.");
    return new $e97a97f0b0cf48c9$export$64b5c384219d3699().setFromMatrixColumn(this, 3);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.setRotationFromQuaternion = function(q) {
    console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().");
    return this.makeRotationFromQuaternion(q);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.multiplyToArray = function() {
    console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.multiplyVector4 = function(vector) {
    console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.multiplyVector3Array = function() {
    console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.rotateAxis = function(v) {
    console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.");
    v.transformDirection(this);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.crossVector = function(vector) {
    console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.");
    return vector.applyMatrix4(this);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.translate = function() {
    console.error("THREE.Matrix4: .translate() has been removed.");
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.rotateX = function() {
    console.error("THREE.Matrix4: .rotateX() has been removed.");
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.rotateY = function() {
    console.error("THREE.Matrix4: .rotateY() has been removed.");
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.rotateZ = function() {
    console.error("THREE.Matrix4: .rotateZ() has been removed.");
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.rotateByAxis = function() {
    console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.applyToBufferAttribute = function(attribute) {
    console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.");
    return attribute.applyMatrix4(this);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.applyToVector3Array = function() {
    console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.makeFrustum = function(left, right, bottom, top, near, far) {
    console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.");
    return this.makePerspective(left, right, top, bottom, near, far);
};
$e97a97f0b0cf48c9$export$2ae72fc923e5eb5.prototype.getInverse = function(matrix) {
    console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
    return this.copy(matrix).invert();
};
//
$e97a97f0b0cf48c9$export$7ff5ac152ef991b0.prototype.isIntersectionLine = function(line) {
    console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().");
    return this.intersectsLine(line);
};
//
$e97a97f0b0cf48c9$export$23d6a54f0bbc85a3.prototype.multiplyVector3 = function(vector) {
    console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.");
    return vector.applyQuaternion(this);
};
$e97a97f0b0cf48c9$export$23d6a54f0bbc85a3.prototype.inverse = function() {
    console.warn("THREE.Quaternion: .inverse() has been renamed to invert().");
    return this.invert();
};
//
$e97a97f0b0cf48c9$export$a186db52eed6d40e.prototype.isIntersectionBox = function(box) {
    console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().");
    return this.intersectsBox(box);
};
$e97a97f0b0cf48c9$export$a186db52eed6d40e.prototype.isIntersectionPlane = function(plane) {
    console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().");
    return this.intersectsPlane(plane);
};
$e97a97f0b0cf48c9$export$a186db52eed6d40e.prototype.isIntersectionSphere = function(sphere) {
    console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().");
    return this.intersectsSphere(sphere);
};
//
$e97a97f0b0cf48c9$export$5a465592bfe74b48.prototype.area = function() {
    console.warn("THREE.Triangle: .area() has been renamed to .getArea().");
    return this.getArea();
};
$e97a97f0b0cf48c9$export$5a465592bfe74b48.prototype.barycoordFromPoint = function(point, target) {
    console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
    return this.getBarycoord(point, target);
};
$e97a97f0b0cf48c9$export$5a465592bfe74b48.prototype.midpoint = function(target) {
    console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint().");
    return this.getMidpoint(target);
};
$e97a97f0b0cf48c9$export$5a465592bfe74b48.prototypenormal = function(target) {
    console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
    return this.getNormal(target);
};
$e97a97f0b0cf48c9$export$5a465592bfe74b48.prototype.plane = function(target) {
    console.warn("THREE.Triangle: .plane() has been renamed to .getPlane().");
    return this.getPlane(target);
};
$e97a97f0b0cf48c9$export$5a465592bfe74b48.barycoordFromPoint = function(point, a, b, c, target) {
    console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
    return $e97a97f0b0cf48c9$export$5a465592bfe74b48.getBarycoord(point, a, b, c, target);
};
$e97a97f0b0cf48c9$export$5a465592bfe74b48.normal = function(a, b, c, target) {
    console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
    return $e97a97f0b0cf48c9$export$5a465592bfe74b48.getNormal(a, b, c, target);
};
//
$e97a97f0b0cf48c9$export$6428a7f2611ef1fa.prototype.extractAllPoints = function(divisions) {
    console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.");
    return this.extractPoints(divisions);
};
$e97a97f0b0cf48c9$export$6428a7f2611ef1fa.prototype.extrude = function(options) {
    console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.");
    return new $e97a97f0b0cf48c9$export$91836d01b9f75a58(this, options);
};
$e97a97f0b0cf48c9$export$6428a7f2611ef1fa.prototype.makeGeometry = function(options) {
    console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.");
    return new $e97a97f0b0cf48c9$export$233afc324766bed8(this, options);
};
//
$e97a97f0b0cf48c9$export$c977b3e384af9ae1.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$e97a97f0b0cf48c9$export$c977b3e384af9ae1.prototype.distanceToManhattan = function(v) {
    console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
    return this.manhattanDistanceTo(v);
};
$e97a97f0b0cf48c9$export$c977b3e384af9ae1.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.setEulerFromRotationMatrix = function() {
    console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
};
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.setEulerFromQuaternion = function() {
    console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
};
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.getPositionFromMatrix = function(m) {
    console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().");
    return this.setFromMatrixPosition(m);
};
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.getScaleFromMatrix = function(m) {
    console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().");
    return this.setFromMatrixScale(m);
};
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.getColumnFromMatrix = function(index, matrix) {
    console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().");
    return this.setFromMatrixColumn(matrix, index);
};
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.applyProjection = function(m) {
    console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.");
    return this.applyMatrix4(m);
};
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.distanceToManhattan = function(v) {
    console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
    return this.manhattanDistanceTo(v);
};
$e97a97f0b0cf48c9$export$64b5c384219d3699.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$e97a97f0b0cf48c9$export$fa7daccca11cdbe3.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().");
    return this.fromBufferAttribute(attribute, index, offset);
};
$e97a97f0b0cf48c9$export$fa7daccca11cdbe3.prototype.lengthManhattan = function() {
    console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().");
    return this.manhattanLength();
};
//
$e97a97f0b0cf48c9$export$e4dd07dff30cc924.prototype.getChildByName = function(name) {
    console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().");
    return this.getObjectByName(name);
};
$e97a97f0b0cf48c9$export$e4dd07dff30cc924.prototype.renderDepth = function() {
    console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
};
$e97a97f0b0cf48c9$export$e4dd07dff30cc924.prototype.translate = function(distance, axis) {
    console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.");
    return this.translateOnAxis(axis, distance);
};
$e97a97f0b0cf48c9$export$e4dd07dff30cc924.prototype.getWorldRotation = function() {
    console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
};
$e97a97f0b0cf48c9$export$e4dd07dff30cc924.prototype.applyMatrix = function(matrix) {
    console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().");
    return this.applyMatrix4(matrix);
};
Object.defineProperties($e97a97f0b0cf48c9$export$e4dd07dff30cc924.prototype, {
    eulerOrder: {
        get: function() {
            console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
            return this.rotation.order;
        },
        set: function(value) {
            console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
            this.rotation.order = value;
        }
    },
    useQuaternion: {
        get: function() {
            console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        },
        set: function() {
            console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        }
    }
});
$e97a97f0b0cf48c9$export$e176487c05830cc5.prototype.setDrawMode = function() {
    console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
};
Object.defineProperties($e97a97f0b0cf48c9$export$e176487c05830cc5.prototype, {
    drawMode: {
        get: function() {
            console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.");
            return $e97a97f0b0cf48c9$export$4c28c87c2dc84758;
        },
        set: function() {
            console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
        }
    }
});
$e97a97f0b0cf48c9$export$b303577035157ecf.prototype.initBones = function() {
    console.error("THREE.SkinnedMesh: initBones() has been removed.");
};
//
$e97a97f0b0cf48c9$export$74e4ae24825f68d7.prototype.setLens = function(focalLength, filmGauge) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
    if (filmGauge !== undefined) this.filmGauge = filmGauge;
    this.setFocalLength(focalLength);
};
//
Object.defineProperties($e97a97f0b0cf48c9$export$6ecadb6ed240d696.prototype, {
    onlyShadow: {
        set: function() {
            console.warn("THREE.Light: .onlyShadow has been removed.");
        }
    },
    shadowCameraFov: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov.");
            this.shadow.camera.fov = value;
        }
    },
    shadowCameraLeft: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left.");
            this.shadow.camera.left = value;
        }
    },
    shadowCameraRight: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right.");
            this.shadow.camera.right = value;
        }
    },
    shadowCameraTop: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top.");
            this.shadow.camera.top = value;
        }
    },
    shadowCameraBottom: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.");
            this.shadow.camera.bottom = value;
        }
    },
    shadowCameraNear: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near.");
            this.shadow.camera.near = value;
        }
    },
    shadowCameraFar: {
        set: function(value) {
            console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far.");
            this.shadow.camera.far = value;
        }
    },
    shadowCameraVisible: {
        set: function() {
            console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
        }
    },
    shadowBias: {
        set: function(value) {
            console.warn("THREE.Light: .shadowBias is now .shadow.bias.");
            this.shadow.bias = value;
        }
    },
    shadowDarkness: {
        set: function() {
            console.warn("THREE.Light: .shadowDarkness has been removed.");
        }
    },
    shadowMapWidth: {
        set: function(value) {
            console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.");
            this.shadow.mapSize.width = value;
        }
    },
    shadowMapHeight: {
        set: function(value) {
            console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.");
            this.shadow.mapSize.height = value;
        }
    }
});
//
Object.defineProperties($e97a97f0b0cf48c9$export$8dea267bd6bde117.prototype, {
    length: {
        get: function() {
            console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead.");
            return this.array.length;
        }
    },
    dynamic: {
        get: function() {
            console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
            return this.usage === $e97a97f0b0cf48c9$export$8505d14ac8546ca;
        },
        set: function() {
            console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
            this.setUsage($e97a97f0b0cf48c9$export$8505d14ac8546ca);
        }
    }
});
$e97a97f0b0cf48c9$export$8dea267bd6bde117.prototype.setDynamic = function(value) {
    console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.");
    this.setUsage(value === true ? $e97a97f0b0cf48c9$export$8505d14ac8546ca : $e97a97f0b0cf48c9$export$763e8360f4d7f77d);
    return this;
};
$e97a97f0b0cf48c9$export$8dea267bd6bde117.prototype.copyIndicesArray = function() {
    console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, $e97a97f0b0cf48c9$export$8dea267bd6bde117.prototype.setArray = function() {
    console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
//
$e97a97f0b0cf48c9$export$b7be63a67df8959.prototype.addIndex = function(index) {
    console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().");
    this.setIndex(index);
};
$e97a97f0b0cf48c9$export$b7be63a67df8959.prototype.addAttribute = function(name, attribute) {
    console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().");
    if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
        console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).");
        return this.setAttribute(name, new $e97a97f0b0cf48c9$export$8dea267bd6bde117(arguments[1], arguments[2]));
    }
    if (name === "index") {
        console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.");
        this.setIndex(attribute);
        return this;
    }
    return this.setAttribute(name, attribute);
};
$e97a97f0b0cf48c9$export$b7be63a67df8959.prototype.addDrawCall = function(start, count, indexOffset) {
    if (indexOffset !== undefined) console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.");
    console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup().");
    this.addGroup(start, count);
};
$e97a97f0b0cf48c9$export$b7be63a67df8959.prototype.clearDrawCalls = function() {
    console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().");
    this.clearGroups();
};
$e97a97f0b0cf48c9$export$b7be63a67df8959.prototype.computeOffsets = function() {
    console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
};
$e97a97f0b0cf48c9$export$b7be63a67df8959.prototype.removeAttribute = function(name) {
    console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().");
    return this.deleteAttribute(name);
};
$e97a97f0b0cf48c9$export$b7be63a67df8959.prototype.applyMatrix = function(matrix) {
    console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().");
    return this.applyMatrix4(matrix);
};
Object.defineProperties($e97a97f0b0cf48c9$export$b7be63a67df8959.prototype, {
    drawcalls: {
        get: function() {
            console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups.");
            return this.groups;
        }
    },
    offsets: {
        get: function() {
            console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups.");
            return this.groups;
        }
    }
});
$e97a97f0b0cf48c9$export$3d5cd879f108f53f.prototype.setDynamic = function(value) {
    console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.");
    this.setUsage(value === true ? $e97a97f0b0cf48c9$export$8505d14ac8546ca : $e97a97f0b0cf48c9$export$763e8360f4d7f77d);
    return this;
};
$e97a97f0b0cf48c9$export$3d5cd879f108f53f.prototype.setArray = function() {
    console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
//
$e97a97f0b0cf48c9$export$91836d01b9f75a58.prototype.getArrays = function() {
    console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
};
$e97a97f0b0cf48c9$export$91836d01b9f75a58.prototype.addShapeList = function() {
    console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
};
$e97a97f0b0cf48c9$export$91836d01b9f75a58.prototype.addShape = function() {
    console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
};
//
$e97a97f0b0cf48c9$export$38af1803e3442a7f.prototype.dispose = function() {
    console.error("THREE.Scene: .dispose() has been removed.");
};
//
$e97a97f0b0cf48c9$export$2947cebfe91c02f8.prototype.onUpdate = function() {
    console.warn("THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.");
    return this;
};
//
Object.defineProperties($e97a97f0b0cf48c9$export$a2d8b23205c25948.prototype, {
    wrapAround: {
        get: function() {
            console.warn("THREE.Material: .wrapAround has been removed.");
        },
        set: function() {
            console.warn("THREE.Material: .wrapAround has been removed.");
        }
    },
    overdraw: {
        get: function() {
            console.warn("THREE.Material: .overdraw has been removed.");
        },
        set: function() {
            console.warn("THREE.Material: .overdraw has been removed.");
        }
    },
    wrapRGB: {
        get: function() {
            console.warn("THREE.Material: .wrapRGB has been removed.");
            return new $e97a97f0b0cf48c9$export$892596cec99bc70e();
        }
    },
    shading: {
        get: function() {
            console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
        },
        set: function(value) {
            console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
            this.flatShading = value === $e97a97f0b0cf48c9$export$a62047d29c96d8ff;
        }
    },
    stencilMask: {
        get: function() {
            console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
            return this.stencilFuncMask;
        },
        set: function(value) {
            console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
            this.stencilFuncMask = value;
        }
    },
    vertexTangents: {
        get: function() {
            console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
        },
        set: function() {
            console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
        }
    }
});
Object.defineProperties($e97a97f0b0cf48c9$export$83c7d75d550a8b0d.prototype, {
    derivatives: {
        get: function() {
            console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
            return this.extensions.derivatives;
        },
        set: function(value) {
            console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
            this.extensions.derivatives = value;
        }
    }
});
//
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.clearTarget = function(renderTarget, color, depth, stencil) {
    console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.");
    this.setRenderTarget(renderTarget);
    this.clear(color, depth, stencil);
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.animate = function(callback) {
    console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop().");
    this.setAnimationLoop(callback);
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.getCurrentRenderTarget = function() {
    console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().");
    return this.getRenderTarget();
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.getMaxAnisotropy = function() {
    console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().");
    return this.capabilities.getMaxAnisotropy();
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.getPrecision = function() {
    console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.");
    return this.capabilities.precision;
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.resetGLState = function() {
    console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset().");
    return this.state.reset();
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.supportsFloatTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' ).");
    return this.extensions.get("OES_texture_float");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.supportsHalfFloatTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' ).");
    return this.extensions.get("OES_texture_half_float");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.supportsStandardDerivatives = function() {
    console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' ).");
    return this.extensions.get("OES_standard_derivatives");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.supportsCompressedTextureS3TC = function() {
    console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' ).");
    return this.extensions.get("WEBGL_compressed_texture_s3tc");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.supportsCompressedTexturePVRTC = function() {
    console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' ).");
    return this.extensions.get("WEBGL_compressed_texture_pvrtc");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.supportsBlendMinMax = function() {
    console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' ).");
    return this.extensions.get("EXT_blend_minmax");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.supportsVertexTextures = function() {
    console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.");
    return this.capabilities.vertexTextures;
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.supportsInstancedArrays = function() {
    console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' ).");
    return this.extensions.get("ANGLE_instanced_arrays");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.enableScissorTest = function(boolean) {
    console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().");
    this.setScissorTest(boolean);
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.initMaterial = function() {
    console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.addPrePlugin = function() {
    console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.addPostPlugin = function() {
    console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.updateShadowMap = function() {
    console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.setFaceCulling = function() {
    console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.allocTextureUnit = function() {
    console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.setTexture = function() {
    console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.setTexture2D = function() {
    console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.setTextureCube = function() {
    console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
};
$e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype.getActiveMipMapLevel = function() {
    console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().");
    return this.getActiveMipmapLevel();
};
Object.defineProperties($e97a97f0b0cf48c9$export$f6cc00ef28d7cf97.prototype, {
    shadowMapEnabled: {
        get: function() {
            return this.shadowMap.enabled;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.");
            this.shadowMap.enabled = value;
        }
    },
    shadowMapType: {
        get: function() {
            return this.shadowMap.type;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.");
            this.shadowMap.type = value;
        }
    },
    shadowMapCullFace: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
        }
    },
    context: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.");
            return this.getContext();
        }
    },
    vr: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr");
            return this.xr;
        }
    },
    gammaInput: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
            return false;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
        }
    },
    gammaOutput: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
            return false;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
            this.outputEncoding = value === true ? $e97a97f0b0cf48c9$export$f32388edbb32674 : $e97a97f0b0cf48c9$export$7207336e4151a112;
        }
    },
    toneMappingWhitePoint: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
            return 1.0;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
        }
    },
    gammaFactor: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
            return 2;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
        }
    }
});
Object.defineProperties($e97a97f0b0cf48c9$var$WebGLShadowMap.prototype, {
    cullFace: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
        }
    },
    renderReverseSided: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
        }
    },
    renderSingleSided: {
        get: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
            return undefined;
        },
        set: function() {
            console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
        }
    }
});
function $e97a97f0b0cf48c9$export$689069929abfa262(width, height, options) {
    console.warn("THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options ).");
    return new $e97a97f0b0cf48c9$export$ac386671d651941e(width, options);
}
//
Object.defineProperties($e97a97f0b0cf48c9$export$3c052beb2e51e23f.prototype, {
    wrapS: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
            return this.texture.wrapS;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
            this.texture.wrapS = value;
        }
    },
    wrapT: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
            return this.texture.wrapT;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
            this.texture.wrapT = value;
        }
    },
    magFilter: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
            return this.texture.magFilter;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
            this.texture.magFilter = value;
        }
    },
    minFilter: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
            return this.texture.minFilter;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
            this.texture.minFilter = value;
        }
    },
    anisotropy: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
            return this.texture.anisotropy;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
            this.texture.anisotropy = value;
        }
    },
    offset: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
            return this.texture.offset;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
            this.texture.offset = value;
        }
    },
    repeat: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
            return this.texture.repeat;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
            this.texture.repeat = value;
        }
    },
    format: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
            return this.texture.format;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
            this.texture.format = value;
        }
    },
    type: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
            return this.texture.type;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
            this.texture.type = value;
        }
    },
    generateMipmaps: {
        get: function() {
            console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
            return this.texture.generateMipmaps;
        },
        set: function(value) {
            console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
            this.texture.generateMipmaps = value;
        }
    }
});
//
$e97a97f0b0cf48c9$export$153755f98d9861de.prototype.load = function(file) {
    console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
    const scope = this;
    const audioLoader = new $e97a97f0b0cf48c9$export$d8d5fccfbf47714e();
    audioLoader.load(file, function(buffer) {
        scope.setBuffer(buffer);
    });
    return this;
};
$e97a97f0b0cf48c9$export$d47da1ef3d382827.prototype.getData = function() {
    console.warn("THREE.AudioAnalyser: .getData() is now .getFrequencyData().");
    return this.getFrequencyData();
};
//
$e97a97f0b0cf48c9$export$d0cdd0bd804995de.prototype.updateCubeMap = function(renderer, scene) {
    console.warn("THREE.CubeCamera: .updateCubeMap() is now .update().");
    return this.update(renderer, scene);
};
$e97a97f0b0cf48c9$export$d0cdd0bd804995de.prototype.clear = function(renderer, color, depth, stencil) {
    console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear().");
    return this.renderTarget.clear(renderer, color, depth, stencil);
};
$e97a97f0b0cf48c9$export$698882cf06df44aa.crossOrigin = undefined;
$e97a97f0b0cf48c9$export$698882cf06df44aa.loadTexture = function(url, mapping, onLoad, onError) {
    console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
    const loader = new $e97a97f0b0cf48c9$export$fd1bfc71f64c538c();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(url, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$e97a97f0b0cf48c9$export$698882cf06df44aa.loadTextureCube = function(urls, mapping, onLoad, onError) {
    console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
    const loader = new $e97a97f0b0cf48c9$export$2ec114afc2cf6308();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(urls, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$e97a97f0b0cf48c9$export$698882cf06df44aa.loadCompressedTexture = function() {
    console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
};
$e97a97f0b0cf48c9$export$698882cf06df44aa.loadCompressedTextureCube = function() {
    console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
};
//
function $e97a97f0b0cf48c9$export$7adc20298958481a() {
    console.error("THREE.CanvasRenderer has been removed");
}
//
function $e97a97f0b0cf48c9$export$8e85bca5826c4696() {
    console.error("THREE.JSONLoader has been removed.");
}
//
const $e97a97f0b0cf48c9$export$a8351e0de8b3fd78 = {
    createMultiMaterialObject: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    },
    detach: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    },
    attach: function() {
        console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    }
};
//
function $e97a97f0b0cf48c9$export$3f909fba4d49fe3d() {
    console.error("THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js");
}
//
function $e97a97f0b0cf48c9$export$8f6f2b4b16d33f() {
    console.error("THREE.ParametricGeometry has been moved to /examples/jsm/geometries/ParametricGeometry.js");
    return new $e97a97f0b0cf48c9$export$b7be63a67df8959();
}
function $e97a97f0b0cf48c9$export$684b774b4473ba5f() {
    console.error("THREE.TextGeometry has been moved to /examples/jsm/geometries/TextGeometry.js");
    return new $e97a97f0b0cf48c9$export$b7be63a67df8959();
}
function $e97a97f0b0cf48c9$export$812303d6cad736b3() {
    console.error("THREE.FontLoader has been moved to /examples/jsm/loaders/FontLoader.js");
}
function $e97a97f0b0cf48c9$export$89abf52a030e56ee() {
    console.error("THREE.Font has been moved to /examples/jsm/loaders/FontLoader.js");
}
function $e97a97f0b0cf48c9$export$960665a8431ecff6() {
    console.error("THREE.ImmediateRenderObject has been removed.");
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $e97a97f0b0cf48c9$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $e97a97f0b0cf48c9$export$3545e07a80636437;
}


var $bb352d88731e6f32$exports = {};
// stats.js - http://github.com/mrdoob/stats.js
(function(f, e) {
    $bb352d88731e6f32$exports = e();
})($bb352d88731e6f32$exports, function() {
    var f = function() {
        function e(a) {
            c.appendChild(a.dom);
            return a;
        }
        function u(a) {
            for(var d = 0; d < c.children.length; d++)c.children[d].style.display = d === a ? "block" : "none";
            l = a;
        }
        var l = 0, c = document.createElement("div");
        c.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";
        c.addEventListener("click", function(a) {
            a.preventDefault();
            u(++l % c.children.length);
        }, !1);
        var k = (performance || Date).now(), g = k, a = 0, r = e(new f.Panel("FPS", "#0ff", "#002")), h = e(new f.Panel("MS", "#0f0", "#020"));
        if (self.performance && self.performance.memory) var t = e(new f.Panel("MB", "#f08", "#201"));
        u(0);
        return {
            REVISION: 16,
            dom: c,
            addPanel: e,
            showPanel: u,
            begin: function() {
                k = (performance || Date).now();
            },
            end: function() {
                a++;
                var c = (performance || Date).now();
                h.update(c - k, 200);
                if (c > g + 1E3 && (r.update(1E3 * a / (c - g), 100), g = c, a = 0, t)) {
                    var d = performance.memory;
                    t.update(d.usedJSHeapSize / 1048576, d.jsHeapSizeLimit / 1048576);
                }
                return c;
            },
            update: function() {
                k = this.end();
            },
            domElement: c,
            setMode: u
        };
    };
    f.Panel = function(e, f, l) {
        var c = Infinity, k = 0, g = Math.round, a = g(window.devicePixelRatio || 1), r = 80 * a, h = 48 * a, t = 3 * a, v = 2 * a, d = 3 * a, m = 15 * a, n = 74 * a, p = 30 * a, q = document.createElement("canvas");
        q.width = r;
        q.height = h;
        q.style.cssText = "width:80px;height:48px";
        var b = q.getContext("2d");
        b.font = "bold " + 9 * a + "px Helvetica,Arial,sans-serif";
        b.textBaseline = "top";
        b.fillStyle = l;
        b.fillRect(0, 0, r, h);
        b.fillStyle = f;
        b.fillText(e, t, v);
        b.fillRect(d, m, n, p);
        b.fillStyle = l;
        b.globalAlpha = .9;
        b.fillRect(d, m, n, p);
        return {
            dom: q,
            update: function(h, w) {
                c = Math.min(c, h);
                k = Math.max(k, h);
                b.fillStyle = l;
                b.globalAlpha = 1;
                b.fillRect(0, 0, r, m);
                b.fillStyle = f;
                b.fillText(g(h) + " " + e + " (" + g(c) + "-" + g(k) + ")", t, v);
                b.drawImage(q, d + a, m, n - a, p, d, m, n - a, p);
                b.fillRect(d + n - a, m, a, p);
                b.fillStyle = l;
                b.globalAlpha = .9;
                b.fillRect(d + n - a, m, a, g((1 - h / w) * p));
            }
        };
    };
    return f;
});



const $746a181503264f5a$var$_euler = new (0, $e97a97f0b0cf48c9$export$d93cc409a0768c5f)(0, 0, 0, "YXZ");
const $746a181503264f5a$var$_vector = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)();
const $746a181503264f5a$var$_changeEvent = {
    type: "change"
};
const $746a181503264f5a$var$_lockEvent = {
    type: "lock"
};
const $746a181503264f5a$var$_unlockEvent = {
    type: "unlock"
};
const $746a181503264f5a$var$_PI_2 = Math.PI / 2;
class $746a181503264f5a$export$e08ee79bd6cc99de extends (0, $e97a97f0b0cf48c9$export$ec8b666c5fe2c75a) {
    constructor(camera, domElement){
        super();
        if (domElement === undefined) {
            console.warn('THREE.PointerLockControls: The second parameter "domElement" is now mandatory.');
            domElement = document.body;
        }
        this.domElement = domElement;
        this.isLocked = false;
        // Set to constrain the pitch of the camera
        // Range is 0 to Math.PI radians
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        const scope = this;
        function onMouseMove(event) {
            if (scope.isLocked === false) return;
            const movementX = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
            const movementY = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
            $746a181503264f5a$var$_euler.setFromQuaternion(camera.quaternion);
            $746a181503264f5a$var$_euler.y -= movementX * 0.002;
            $746a181503264f5a$var$_euler.x -= movementY * 0.002;
            $746a181503264f5a$var$_euler.x = Math.max($746a181503264f5a$var$_PI_2 - scope.maxPolarAngle, Math.min($746a181503264f5a$var$_PI_2 - scope.minPolarAngle, $746a181503264f5a$var$_euler.x));
            camera.quaternion.setFromEuler($746a181503264f5a$var$_euler);
            scope.dispatchEvent($746a181503264f5a$var$_changeEvent);
        }
        function onPointerlockChange() {
            if (scope.domElement.ownerDocument.pointerLockElement === scope.domElement) {
                scope.dispatchEvent($746a181503264f5a$var$_lockEvent);
                scope.isLocked = true;
            } else {
                scope.dispatchEvent($746a181503264f5a$var$_unlockEvent);
                scope.isLocked = false;
            }
        }
        function onPointerlockError() {
            console.error("THREE.PointerLockControls: Unable to use Pointer Lock API");
        }
        this.connect = function() {
            scope.domElement.ownerDocument.addEventListener("mousemove", onMouseMove);
            scope.domElement.ownerDocument.addEventListener("pointerlockchange", onPointerlockChange);
            scope.domElement.ownerDocument.addEventListener("pointerlockerror", onPointerlockError);
        };
        this.disconnect = function() {
            scope.domElement.ownerDocument.removeEventListener("mousemove", onMouseMove);
            scope.domElement.ownerDocument.removeEventListener("pointerlockchange", onPointerlockChange);
            scope.domElement.ownerDocument.removeEventListener("pointerlockerror", onPointerlockError);
        };
        this.dispose = function() {
            this.disconnect();
        };
        this.getObject = function() {
            return camera;
        };
        this.getDirection = function() {
            const direction = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)(0, 0, -1);
            return function(v) {
                return v.copy(direction).applyQuaternion(camera.quaternion);
            };
        }();
        this.moveForward = function(distance) {
            // move forward parallel to the xz-plane
            // assumes camera.up is y-up
            $746a181503264f5a$var$_vector.setFromMatrixColumn(camera.matrix, 0);
            $746a181503264f5a$var$_vector.crossVectors(camera.up, $746a181503264f5a$var$_vector);
            camera.position.addScaledVector($746a181503264f5a$var$_vector, distance);
        };
        this.moveRight = function(distance) {
            $746a181503264f5a$var$_vector.setFromMatrixColumn(camera.matrix, 0);
            camera.position.addScaledVector($746a181503264f5a$var$_vector, distance);
        };
        this.lock = function() {
            this.domElement.requestPointerLock();
        };
        this.unlock = function() {
            scope.domElement.ownerDocument.exitPointerLock();
        };
        this.connect();
    }
}



class $5a73931fb849d1b7$var$DeviceOrientationControls {
    camera;
    deviceOrientation;
    enabled = true;
    isAndroid;
    hasPlaced = false;
    screenOrientation = 0;
    orientationChangeEventName = "ondeviceorientationabsolute" in window ? "deviceorientationabsolute" : "deviceorientation";
    defaultData = {
        position: new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)(),
        quaternion: new (0, $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3)(),
        rotation: new (0, $e97a97f0b0cf48c9$export$d93cc409a0768c5f)()
    };
    constructor({ camera: camera, isAndroid: isAndroid }){
        this.camera = camera;
        this.camera.rotation.reorder("YXZ");
        this.defaultData.position.copy(camera.position);
        this.defaultData.quaternion.copy(camera.quaternion);
        this.defaultData.rotation.copy(camera.rotation);
        this.isAndroid = isAndroid;
        this.bind();
    }
    bind() {
        this.updateHasPlaced = this.updateHasPlaced.bind(this);
        this.onScreenOrientationChangeEvent = this.onScreenOrientationChangeEvent.bind(this);
        this.onDeviceOrientationChangeEvent = this.onDeviceOrientationChangeEvent.bind(this);
    }
    updateHasPlaced(value) {
        this.hasPlaced = value;
    }
    connect = ()=>{
        this.onScreenOrientationChangeEvent(); // run once on load
        window.addEventListener("orientationchange", this.onScreenOrientationChangeEvent, true);
        // @ts-ignore
        window.addEventListener(this.orientationChangeEventName, this.onDeviceOrientationChangeEvent, true);
        this.enabled = true;
    };
    /**
   * GYRO FUNCTIONS
   */ onDeviceOrientationChangeEvent = (event)=>{
        this.deviceOrientation = event;
    };
    onScreenOrientationChangeEvent = ()=>{
        this.screenOrientation = Number(window.orientation) || 0;
    };
    cameraReset() {
        if (this.camera.quaternion !== this.defaultData.quaternion) {
            this.camera.position.copy(this.defaultData.position);
            this.camera.quaternion.copy(this.defaultData.quaternion);
            this.camera.rotation.copy(this.defaultData.rotation);
        }
    }
    setObjectQuaternion = (()=>{
        const zee = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)(0, 0, 1);
        const euler = new (0, $e97a97f0b0cf48c9$export$d93cc409a0768c5f)();
        const q0 = new (0, $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3)();
        const q1 = new (0, $e97a97f0b0cf48c9$export$23d6a54f0bbc85a3)(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5)); // - PI/2 around the x-axis
        return (quaternion, alpha, beta, gamma, orient)=>{
            euler.set(beta, alpha, -gamma, "YXZ"); // 'ZXY' for the device, but 'YXZ' for us
            quaternion.setFromEuler(euler); // orient the device
            quaternion.multiply(q1); // camera looks out the back of the device, not the top
            quaternion.multiply(q0.setFromAxisAngle(zee, -orient)); // adjust for screen orientation
        };
    })();
    updateSensorValues = ()=>{
        if (this.deviceOrientation) {
            //We'er doing a check here for iOS or android
            let alpha = this.deviceOrientation.alpha ? (0, $e97a97f0b0cf48c9$export$380958644dbbc22b).degToRad(this.deviceOrientation.alpha) : 0; // Z; Alpha offset needs to be subtracted
            alpha = this.isAndroid ? alpha + (0, $e97a97f0b0cf48c9$export$380958644dbbc22b).degToRad(90) : alpha;
            const beta = this.deviceOrientation?.beta ? (0, $e97a97f0b0cf48c9$export$380958644dbbc22b).degToRad(this.deviceOrientation.beta) : 0; // X'
            const gamma = this.deviceOrientation?.gamma ? (0, $e97a97f0b0cf48c9$export$380958644dbbc22b).degToRad(this.deviceOrientation.gamma) : 0; // Y''
            const orient = this.screenOrientation ? (0, $e97a97f0b0cf48c9$export$380958644dbbc22b).degToRad(this.screenOrientation) : 0; // O
            if (this.hasPlaced) this.cameraReset();
            else this.setObjectQuaternion(this.camera.quaternion, alpha, beta, gamma, orient);
        }
    };
    /**
   * FRAME LOOP
   */ update = ()=>{
        if (this.enabled === false) return;
        this.updateSensorValues();
    };
    /**
   * DISPOSE
   */ dispose = ()=>{
        this.disconnect();
    };
    disconnect = ()=>{
        console.log("disconnect GYRO");
        window.removeEventListener("orientationchange", this.onScreenOrientationChangeEvent, false);
        //@ts-ignore
        window.removeEventListener(this.orientationChangeEventName, this.onDeviceOrientationChangeEvent, false);
        this.enabled = false;
    };
}
var $5a73931fb849d1b7$export$2e2bcd8739ae039 = $5a73931fb849d1b7$var$DeviceOrientationControls;


/**
 * SDK version.
 */ const $02df7e5d1f394832$export$a4ad2735b021c132 = "2.1.2";


var $20ed77af6adf4d0f$exports = {};

$parcel$export($20ed77af6adf4d0f$exports, "ImageTracker", function () { return $20ed77af6adf4d0f$export$333222788f3dd075; });
/**
 * A type-safe event handling class that multiple functions to be registered to be called when events are emitted.
 */ class $bd0785a1f078b628$export$d61e24a684f9e51 {
    constructor(){
        this._funcs = [];
    }
    /**
     * Bind new handler function.
     * @param f - The callback function to be bound.
     */ bind(f) {
        this._funcs.push(f);
    }
    /**
     * Unbind an existing handler function.
     * @param f - The callback function to be unbound.
     */ unbind(f) {
        const indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    /**
     * Emit an event, calling the bound handler functions.
     */ emit() {
        for(let i = 0, total = this._funcs.length; i < total; i++)this._funcs[i]();
    }
}
class $bd0785a1f078b628$export$3371bf92c01fb88b {
    constructor(){
        this._funcs = [];
    }
    /**
     * Bind new handler function.
     * @param f - The callback function to be bound.
    */ bind(f) {
        this._funcs.push(f);
    }
    /**
     * Unbind an existing function.
     * @param f - The callback function to be unbound.
     */ unbind(f) {
        const indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    /**
     * Emit an event.
     *
     * @param a - The argument to pass to handler functions.
     */ emit(a) {
        for(let i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a);
    }
}


var $16ba0ad9af69b2e5$exports = {};

$parcel$export($16ba0ad9af69b2e5$exports, "z", function () { return $16ba0ad9af69b2e5$export$df995fae86a55f06; });
$parcel$export($16ba0ad9af69b2e5$exports, "cameraDefaultDeviceID", function () { return $16ba0ad9af69b2e5$export$5e22cf87be86f6fa; });
$parcel$export($16ba0ad9af69b2e5$exports, "projectionMatrixFromCameraModel", function () { return $16ba0ad9af69b2e5$export$790b3b94a8142dee; });
$parcel$export($16ba0ad9af69b2e5$exports, "loadedPromise", function () { return $16ba0ad9af69b2e5$export$6b6393bedfd195a0; });
var $8a638ecfa585148b$exports = {};

$parcel$export($8a638ecfa585148b$exports, "initialize", function () { return $8a638ecfa585148b$export$2a47f398eeff8b01; });
var $c937c8c7cc26bb65$export$53baafd5596ae7a8;
(function(barcode_format_t) {
    barcode_format_t[barcode_format_t["UNKNOWN"] = 131072] = "UNKNOWN";
    barcode_format_t[barcode_format_t["AZTEC"] = 1] = "AZTEC";
    barcode_format_t[barcode_format_t["CODABAR"] = 2] = "CODABAR";
    barcode_format_t[barcode_format_t["CODE_39"] = 4] = "CODE_39";
    barcode_format_t[barcode_format_t["CODE_93"] = 8] = "CODE_93";
    barcode_format_t[barcode_format_t["CODE_128"] = 16] = "CODE_128";
    barcode_format_t[barcode_format_t["DATA_MATRIX"] = 32] = "DATA_MATRIX";
    barcode_format_t[barcode_format_t["EAN_8"] = 64] = "EAN_8";
    barcode_format_t[barcode_format_t["EAN_13"] = 128] = "EAN_13";
    barcode_format_t[barcode_format_t["ITF"] = 256] = "ITF";
    barcode_format_t[barcode_format_t["MAXICODE"] = 512] = "MAXICODE";
    barcode_format_t[barcode_format_t["PDF_417"] = 1024] = "PDF_417";
    barcode_format_t[barcode_format_t["QR_CODE"] = 2048] = "QR_CODE";
    barcode_format_t[barcode_format_t["RSS_14"] = 4096] = "RSS_14";
    barcode_format_t[barcode_format_t["RSS_EXPANDED"] = 8192] = "RSS_EXPANDED";
    barcode_format_t[barcode_format_t["UPC_A"] = 16384] = "UPC_A";
    barcode_format_t[barcode_format_t["UPC_E"] = 32768] = "UPC_E";
    barcode_format_t[barcode_format_t["UPC_EAN_EXTENSION"] = 65536] = "UPC_EAN_EXTENSION";
    barcode_format_t[barcode_format_t["ALL"] = 131071] = "ALL";
})($c937c8c7cc26bb65$export$53baafd5596ae7a8 || ($c937c8c7cc26bb65$export$53baafd5596ae7a8 = {}));
var $c937c8c7cc26bb65$export$1f0a57b556284af4;
(function(face_landmark_name_t) {
    face_landmark_name_t[face_landmark_name_t["EYE_LEFT"] = 0] = "EYE_LEFT";
    face_landmark_name_t[face_landmark_name_t["EYE_RIGHT"] = 1] = "EYE_RIGHT";
    face_landmark_name_t[face_landmark_name_t["EAR_LEFT"] = 2] = "EAR_LEFT";
    face_landmark_name_t[face_landmark_name_t["EAR_RIGHT"] = 3] = "EAR_RIGHT";
    face_landmark_name_t[face_landmark_name_t["NOSE_BRIDGE"] = 4] = "NOSE_BRIDGE";
    face_landmark_name_t[face_landmark_name_t["NOSE_TIP"] = 5] = "NOSE_TIP";
    face_landmark_name_t[face_landmark_name_t["NOSE_BASE"] = 6] = "NOSE_BASE";
    face_landmark_name_t[face_landmark_name_t["LIP_TOP"] = 7] = "LIP_TOP";
    face_landmark_name_t[face_landmark_name_t["LIP_BOTTOM"] = 8] = "LIP_BOTTOM";
    face_landmark_name_t[face_landmark_name_t["MOUTH_CENTER"] = 9] = "MOUTH_CENTER";
    face_landmark_name_t[face_landmark_name_t["CHIN"] = 10] = "CHIN";
    face_landmark_name_t[face_landmark_name_t["EYEBROW_LEFT"] = 11] = "EYEBROW_LEFT";
    face_landmark_name_t[face_landmark_name_t["EYEBROW_RIGHT"] = 12] = "EYEBROW_RIGHT";
})($c937c8c7cc26bb65$export$1f0a57b556284af4 || ($c937c8c7cc26bb65$export$1f0a57b556284af4 = {}));
var $c937c8c7cc26bb65$export$51221aec55e6c7e6;
(function(instant_world_tracker_transform_orientation_t) {
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["WORLD"] = 3] = "WORLD";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["MINUS_Z_AWAY_FROM_USER"] = 4] = "MINUS_Z_AWAY_FROM_USER";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["MINUS_Z_HEADING"] = 5] = "MINUS_Z_HEADING";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["UNCHANGED"] = 6] = "UNCHANGED";
})($c937c8c7cc26bb65$export$51221aec55e6c7e6 || ($c937c8c7cc26bb65$export$51221aec55e6c7e6 = {}));
var $c937c8c7cc26bb65$export$3c7fce2c49a05698;
(function(log_level_t) {
    log_level_t[log_level_t["LOG_LEVEL_NONE"] = 0] = "LOG_LEVEL_NONE";
    log_level_t[log_level_t["LOG_LEVEL_ERROR"] = 1] = "LOG_LEVEL_ERROR";
    log_level_t[log_level_t["LOG_LEVEL_WARNING"] = 2] = "LOG_LEVEL_WARNING";
    log_level_t[log_level_t["LOG_LEVEL_VERBOSE"] = 3] = "LOG_LEVEL_VERBOSE";
})($c937c8c7cc26bb65$export$3c7fce2c49a05698 || ($c937c8c7cc26bb65$export$3c7fce2c49a05698 = {}));
var $c937c8c7cc26bb65$export$75bacc79ae92a32d;
(function(frame_pixel_format_t) {
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I420"] = 0] = "FRAME_PIXEL_FORMAT_I420";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I420A"] = 1] = "FRAME_PIXEL_FORMAT_I420A";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I422"] = 2] = "FRAME_PIXEL_FORMAT_I422";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I444"] = 3] = "FRAME_PIXEL_FORMAT_I444";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_NV12"] = 4] = "FRAME_PIXEL_FORMAT_NV12";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_RGBA"] = 5] = "FRAME_PIXEL_FORMAT_RGBA";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_BGRA"] = 6] = "FRAME_PIXEL_FORMAT_BGRA";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_Y"] = 7] = "FRAME_PIXEL_FORMAT_Y";
})($c937c8c7cc26bb65$export$75bacc79ae92a32d || ($c937c8c7cc26bb65$export$75bacc79ae92a32d = {}));
var $c937c8c7cc26bb65$export$7f44ab26face7b78;
(function(image_target_type_t) {
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_PLANAR"] = 0] = "IMAGE_TRACKER_TYPE_PLANAR";
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_CYLINDRICAL"] = 1] = "IMAGE_TRACKER_TYPE_CYLINDRICAL";
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_CONICAL"] = 2] = "IMAGE_TRACKER_TYPE_CONICAL";
})($c937c8c7cc26bb65$export$7f44ab26face7b78 || ($c937c8c7cc26bb65$export$7f44ab26face7b78 = {}));




class $79a3753793ef6bc2$export$74925a4979a99f62 {
    constructor(_messageSender){
        this._messageSender = _messageSender;
        this._freeBufferPool = [];
        this._buffer = new ArrayBuffer(16);
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 1;
        this._startOffset = -1;
        this._timeoutSet = false;
        this._appender = {
            int: (i)=>this.int(i),
            bool: (i)=>this.int(i ? 1 : 0),
            float: (i)=>this.float(i),
            string: (i)=>this.string(i),
            dataWithLength: (i)=>this.arrayBuffer(i),
            type: (i)=>this.int(i),
            matrix4x4: (i)=>this.float32ArrayBuffer(i),
            matrix3x3: (i)=>this.float32ArrayBuffer(i),
            identityCoefficients: (i)=>this.float32ArrayBuffer(i),
            expressionCoefficients: (i)=>this.float32ArrayBuffer(i),
            cameraModel: (i)=>this.float32ArrayBuffer(i),
            timestamp: (i)=>this.double(i),
            barcodeFormat: (i)=>this.int(i),
            faceLandmarkName: (i)=>this.int(i),
            instantTrackerTransformOrientation: (i)=>this.int(i),
            logLevel: (i)=>this.int(i)
        };
        this._freeBufferPool.push(new ArrayBuffer(16));
        this._freeBufferPool.push(new ArrayBuffer(16));
    }
    bufferReturn(ab) {
        this._freeBufferPool.push(ab);
    }
    // public copySerializedData(): ArrayBuffer {
    //     let data = this._buffer.slice(0, this._offset * Int32Array.BYTES_PER_ELEMENT);
    //     this._offset = 0;
    //     this._startOffset = -1;
    //     return data;
    // }
    _ensureArrayBuffer(incremental) {
        let requirement = (this._offset + incremental + 8) * 4;
        if (this._buffer && this._buffer.byteLength >= requirement) return;
        let newBuffer = undefined;
        // for (let i = 0; i < this._freeBufferPool.length; i++) {
        //     if (this._freeBufferPool[i].byteLength > requirement) {
        //         newBuffer = this._freeBufferPool[i];
        //         this._freeBufferPool.splice(i, 1);
        //         break;
        //     }
        // }
        if (!newBuffer) {
            let nextPow2 = requirement;
            nextPow2--;
            nextPow2 |= nextPow2 >> 1;
            nextPow2 |= nextPow2 >> 2;
            nextPow2 |= nextPow2 >> 4;
            nextPow2 |= nextPow2 >> 8;
            nextPow2 |= nextPow2 >> 16;
            nextPow2++;
            newBuffer = new ArrayBuffer(nextPow2);
        }
        let oldView = this._buffer ? this._i32View : undefined;
        this._buffer = newBuffer;
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        if (oldView) this._i32View.set(oldView.subarray(0, this._offset));
    // this._offset = 1; // First int is whole length
    // this._startOffset = -1;
    }
    sendMessage(messageId, cb) {
        this._ensureArrayBuffer(4);
        this._startOffset = this._offset;
        this._i32View[this._offset + 1] = messageId;
        this._offset += 2;
        cb(this._appender);
        this._i32View[this._startOffset] = this._offset - this._startOffset;
        this._startOffset = -1;
        this._sendOneTime();
    }
    _sendOneTime() {
        if (this._timeoutSet === false) {
            this._timeoutSet = true;
            setTimeout(()=>{
                this._timeoutSet = false;
                this._send();
            }, 0);
        }
    }
    _send() {
        // Continue filling the current buffer unless have a new buffer to fill
        if (this._freeBufferPool.length === 0) {
            this._sendOneTime();
            return;
        }
        this._i32View[0] = this._offset;
        this._messageSender(this._buffer);
        this._buffer = undefined;
        this._buffer = this._freeBufferPool.pop();
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 1;
        this._startOffset = -1;
    }
    int(arg) {
        this._ensureArrayBuffer(1);
        this._i32View[this._offset] = arg;
        this._offset++;
    }
    double(arg) {
        this._ensureArrayBuffer(2);
        if (this._offset % 2 === 1) this._offset++;
        this._f64View[this._offset / 2] = arg;
        this._offset += 2;
    }
    float(arg) {
        this._ensureArrayBuffer(1);
        this._f32View[this._offset] = arg;
        this._offset++;
    }
    int32Array(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._i32View[this._offset + i] = args[i];
        this._offset += args.length;
    }
    float32Array(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._f32View[this._offset + i] = args[i];
        this._offset += args.length;
    }
    booleanArray(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._i32View[this._offset + i] = args[i] ? 1 : 0;
        this._offset += args.length;
    }
    uint8ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.byteLength;
        this._offset++;
        this._u8View.set(data, this._offset * 4);
        // Update the int32 offset
        this._offset += data.byteLength >> 2;
        if ((data.byteLength & 3) !== 0) this._offset++;
    }
    arrayBuffer(data) {
        let view = new Uint8Array(data);
        this.uint8ArrayBuffer(view);
    }
    uint8ClampedArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.byteLength;
        this._offset++;
        this._u8cView.set(data, this._offset * 4);
        // Update the int32 offset
        this._offset += data.byteLength >> 2;
        if ((data.byteLength & 3) !== 0) this._offset++;
    }
    float32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._f32View.set(data, this._offset);
        this._offset += data.length;
    }
    uint16ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        let u16Offset = this._offset * 2;
        this._u16View.set(data, u16Offset);
        // Update the int32 offset
        this._offset += data.length >> 1;
        if ((data.length & 1) !== 0) this._offset++;
    }
    int32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._i32View.set(data, this._offset);
        this._offset += data.length;
    }
    uint32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._u32View.set(data, this._offset);
        this._offset += data.length;
    }
    string(data) {
        let encoder = new TextEncoder();
        let res = encoder.encode(data);
        this._ensureArrayBuffer(res.byteLength / 4);
        this._i32View[this._offset] = res.byteLength;
        this._offset++;
        this._u8View.set(res, this._offset * 4);
        // Update the int32 offset
        this._offset += res.byteLength >> 2;
        if ((res.byteLength & 3) !== 0) this._offset++;
    }
}


class $058c18e13a5d6d8e$export$16c5ab9fb870b6bb {
    constructor(){
        this._buffer = new ArrayBuffer(0);
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 0;
        this._length = 0;
        this._startOffset = -1;
        this._processor = {
            int: ()=>this._i32View[this._startOffset++],
            bool: ()=>this._i32View[this._startOffset++] === 1,
            type: ()=>this._i32View[this._startOffset++],
            float: ()=>this._f32View[this._startOffset++],
            timestamp: ()=>{
                if (this._startOffset % 2 === 1) this._startOffset++;
                let ret = this._f64View[this._startOffset / 2];
                this._startOffset += 2;
                return ret;
            },
            string: ()=>{
                let len = this._i32View[this._startOffset++];
                let decoder = new TextDecoder();
                let res = decoder.decode(new Uint8Array(this._buffer, this._startOffset * 4, len));
                this._startOffset += len >> 2;
                if ((len & 3) !== 0) this._startOffset++;
                return res;
            },
            dataWithLength: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Uint8Array(len);
                ret.set(this._u8View.subarray(this._startOffset * 4, this._startOffset * 4 + len));
                this._startOffset += ret.byteLength >> 2;
                if ((ret.byteLength & 3) !== 0) this._startOffset++;
                return ret.buffer;
            },
            matrix4x4: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 16));
                this._startOffset += len;
                return ret;
            },
            matrix3x3: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 9));
                this._startOffset += len;
                return ret;
            },
            identityCoefficients: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 50));
                this._startOffset += len;
                return ret;
            },
            expressionCoefficients: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 29));
                this._startOffset += len;
                return ret;
            },
            cameraModel: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 6));
                this._startOffset += len;
                return ret;
            },
            barcodeFormat: ()=>this._i32View[this._startOffset++],
            faceLandmarkName: ()=>this._i32View[this._startOffset++],
            instantTrackerTransformOrientation: ()=>this._i32View[this._startOffset++],
            logLevel: ()=>this._i32View[this._startOffset++]
        };
    }
    setData(data) {
        this._buffer = data;
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 0;
        this._length = 0;
        if (data.byteLength >= 4) {
            this._offset = 1;
            this._length = this._i32View[0];
        }
        this._startOffset = -1;
    }
    hasMessage() {
        return this._offset + 1 < this._length;
    }
    forMessages(cb) {
        while(this.hasMessage()){
            let len = this._i32View[this._offset];
            let messageId = this._i32View[this._offset + 1];
            this._startOffset = this._offset + 2;
            this._offset += len;
            cb(messageId, this._processor);
        }
    }
}


class $7ef3c563cf4c51a2$export$ada9decabe1e7aa7 {
    constructor(_messageSender){
        this._messageSender = _messageSender;
        this._globalState = {
            log_level: 1
        };
        this.serializer = new (0, $79a3753793ef6bc2$export$74925a4979a99f62)((ab)=>{
            this._messageSender(ab);
        });
        this.deserializer = new (0, $058c18e13a5d6d8e$export$16c5ab9fb870b6bb)();
        this._latestId = 1;
        this._pipeline_state_by_instance = new Map();
        this._camera_source_state_by_instance = new Map();
        this._sequence_source_state_by_instance = new Map();
        this._image_tracker_state_by_instance = new Map();
        this._face_tracker_state_by_instance = new Map();
        this._face_mesh_state_by_instance = new Map();
        this._face_landmark_state_by_instance = new Map();
        this._barcode_finder_state_by_instance = new Map();
        this._instant_world_tracker_state_by_instance = new Map();
        this.impl = {
            log_level: ()=>{
                return this._globalState.log_level;
            },
            log_level_set: (level)=>{
                this.serializer.sendMessage(34, (m)=>{
                    m.logLevel(level);
                });
            },
            analytics_project_id_set: (id)=>{
                this.serializer.sendMessage(31, (m)=>{
                    m.string(id);
                });
            },
            // #### pipeline ####
            pipeline_create: ()=>{
                let newId = this._latestId++;
                let s = {
                    current_frame_user_data: 0,
                    camera_model: new Float32Array([
                        300,
                        300,
                        160,
                        120,
                        0,
                        0
                    ]),
                    camera_pose: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    camera_frame_camera_attitude: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    camera_frame_device_attitude: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    frame_number: 0
                };
                this._pipeline_state_by_instance.set(newId, s);
                this.serializer.sendMessage(27, (m)=>{
                    m.type(newId);
                });
                return newId;
            },
            pipeline_destroy: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._pipeline_state_by_instance.delete(o);
                this.serializer.sendMessage(28, (m)=>{
                    m.type(o);
                });
            },
            pipeline_frame_update: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(9, (m)=>{
                    m.type(o);
                });
            },
            pipeline_frame_number: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.frame_number;
            },
            pipeline_camera_model: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_model;
            },
            pipeline_camera_frame_user_data: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.current_frame_user_data;
            },
            pipeline_camera_frame_submit: (o, data, width, height, user_data, camera_to_device_transform, camera_model, user_facing)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(8, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                    m.int(width);
                    m.int(height);
                    m.int(user_data);
                    m.matrix4x4(camera_to_device_transform);
                    m.cameraModel(camera_model);
                    m.bool(user_facing);
                });
            },
            pipeline_camera_frame_submit_raw_pointer: (o, data, dataLength, format, width, height, user_data, camera_to_device_transform, rotation, camera_model, user_facing)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
            },
            pipeline_camera_frame_camera_attitude: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_frame_camera_attitude;
            },
            pipeline_camera_frame_device_attitude: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_frame_device_attitude;
            },
            pipeline_motion_accelerometer_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(10, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_rotation_rate_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(11, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_attitude_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(12, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_attitude_matrix_submit: (o, mat)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(13, (m)=>{
                    m.type(o);
                    m.matrix4x4(mat);
                });
            },
            // #### camera_source ####
            camera_source_create: (pipeline, device_id)=>{
                let newId = this._latestId++;
                let s = {};
                this._camera_source_state_by_instance.set(newId, s);
                this.serializer.sendMessage(29, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                    m.string(device_id);
                });
                return newId;
            },
            camera_source_destroy: (o)=>{
                let s = this._camera_source_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._camera_source_state_by_instance.delete(o);
                this.serializer.sendMessage(30, (m)=>{
                    m.type(o);
                });
            },
            // #### sequence_source ####
            sequence_source_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {};
                this._sequence_source_state_by_instance.set(newId, s);
                this.serializer.sendMessage(35, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            sequence_source_destroy: (o)=>{
                let s = this._sequence_source_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._sequence_source_state_by_instance.delete(o);
                this.serializer.sendMessage(36, (m)=>{
                    m.type(o);
                });
            },
            // #### image_tracker ####
            image_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    target_loaded_version: -1,
                    anchor_count: 0,
                    anchor_id: [],
                    anchor_pose: []
                };
                this._image_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(2, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            image_tracker_destroy: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._image_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(14, (m)=>{
                    m.type(o);
                });
            },
            image_tracker_target_load_from_memory: (o, data)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(4, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                });
            },
            image_tracker_target_loaded_version: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.target_loaded_version;
            },
            image_tracker_enabled: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            image_tracker_enabled_set: (o, enabled)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(3, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            image_tracker_anchor_count: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_count;
            },
            image_tracker_anchor_id: (o, indx)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_id[indx];
            },
            image_tracker_anchor_pose_raw: (o, indx)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_pose[indx];
            },
            // #### face_tracker ####
            face_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    model_loaded: -1,
                    max_faces: 1,
                    anchor_count: 0,
                    anchor_id: [],
                    anchor_pose: [],
                    anchor_identity_coefficients: [],
                    anchor_expression_coefficients: []
                };
                this._face_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(20, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            face_tracker_destroy: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(21, (m)=>{
                    m.type(o);
                });
            },
            face_tracker_model_load_from_memory: (o, data)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(22, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                });
            },
            face_tracker_model_loaded_version: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.model_loaded;
            },
            face_tracker_enabled_set: (o, enabled)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(23, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            face_tracker_enabled: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            face_tracker_max_faces_set: (o, num)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(24, (m)=>{
                    m.type(o);
                    m.int(num);
                });
            },
            face_tracker_max_faces: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.max_faces;
            },
            face_tracker_anchor_count: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_count;
            },
            face_tracker_anchor_id: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_id[indx];
            },
            face_tracker_anchor_pose_raw: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_pose[indx];
            },
            face_tracker_anchor_identity_coefficients: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_identity_coefficients[indx];
            },
            face_tracker_anchor_expression_coefficients: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_expression_coefficients[indx];
            },
            // #### face_mesh ####
            face_mesh_create: ()=>{
                let newId = this._latestId++;
                let s = {};
                this._face_mesh_state_by_instance.set(newId, s);
                this.serializer.sendMessage(25, (m)=>{
                    m.type(newId);
                });
                return newId;
            },
            face_mesh_destroy: (o)=>{
                let s = this._face_mesh_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_mesh_state_by_instance.delete(o);
                this.serializer.sendMessage(26, (m)=>{
                    m.type(o);
                });
            },
            // #### face_landmark ####
            face_landmark_create: (landmark)=>{
                let newId = this._latestId++;
                let s = {};
                this._face_landmark_state_by_instance.set(newId, s);
                this.serializer.sendMessage(32, (m)=>{
                    m.type(newId);
                    m.faceLandmarkName(landmark);
                });
                return newId;
            },
            face_landmark_destroy: (o)=>{
                let s = this._face_landmark_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_landmark_state_by_instance.delete(o);
                this.serializer.sendMessage(33, (m)=>{
                    m.type(o);
                });
            },
            // #### barcode_finder ####
            barcode_finder_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    number_found: 0,
                    found_text: [],
                    found_format: [],
                    formats: 131071
                };
                this._barcode_finder_state_by_instance.set(newId, s);
                this.serializer.sendMessage(16, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            barcode_finder_destroy: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._barcode_finder_state_by_instance.delete(o);
                this.serializer.sendMessage(17, (m)=>{
                    m.type(o);
                });
            },
            barcode_finder_enabled_set: (o, enabled)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(18, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            barcode_finder_enabled: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            barcode_finder_found_number: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.number_found;
            },
            barcode_finder_found_text: (o, indx)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.found_text[indx];
            },
            barcode_finder_found_format: (o, indx)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.found_format[indx];
            },
            barcode_finder_formats: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.formats;
            },
            barcode_finder_formats_set: (o, f)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(19, (m)=>{
                    m.type(o);
                    m.barcodeFormat(f);
                });
            },
            // #### instant_world_tracker ####
            instant_world_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    pose: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ])
                };
                this._instant_world_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(5, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            instant_world_tracker_destroy: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._instant_world_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(15, (m)=>{
                    m.type(o);
                });
            },
            instant_world_tracker_enabled_set: (o, enabled)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(6, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            instant_world_tracker_enabled: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            instant_world_tracker_anchor_pose_raw: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.pose;
            },
            instant_world_tracker_anchor_pose_set_from_camera_offset_raw: (o, x, y, z, orientation)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(7, (m)=>{
                    m.type(o);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                    m.instantTrackerTransformOrientation(orientation);
                });
            }
        };
    }
    processMessages(a) {
        this.deserializer.setData(a);
        this.deserializer.forMessages((messageId, msg)=>{
            switch(messageId){
                case 7:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.frame_number = msg.int();
                        break;
                    }
                case 6:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_model = msg.cameraModel();
                        break;
                    }
                case 5:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.current_frame_user_data = msg.int();
                        break;
                    }
                case 11:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_frame_camera_attitude = msg.matrix4x4();
                        break;
                    }
                case 12:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_frame_device_attitude = msg.matrix4x4();
                        break;
                    }
                case 19:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.target_loaded_version = msg.int();
                        break;
                    }
                case 1:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.anchor_count = msg.int();
                        break;
                    }
                case 2:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_id[indx] = msg.string();
                        break;
                    }
                case 3:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_pose[indx] = msg.matrix4x4();
                        break;
                    }
                case 18:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.model_loaded = msg.int();
                        break;
                    }
                case 13:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.anchor_count = msg.int();
                        break;
                    }
                case 14:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_id[indx] = msg.string();
                        break;
                    }
                case 15:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_pose[indx] = msg.matrix4x4();
                        break;
                    }
                case 16:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_identity_coefficients[indx] = msg.identityCoefficients();
                        break;
                    }
                case 17:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_expression_coefficients[indx] = msg.expressionCoefficients();
                        break;
                    }
                case 8:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.number_found = msg.int();
                        break;
                    }
                case 9:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.found_text[indx] = msg.string();
                        break;
                    }
                case 10:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.found_format[indx] = msg.barcodeFormat();
                        break;
                    }
                case 4:
                    {
                        let handle = msg.type();
                        let inst = this._instant_world_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.pose = msg.matrix4x4();
                        break;
                    }
            }
        });
    }
}


function $7333038afa66965a$export$9b5304f4eb007cf0(gl, type, src) {
    let ret = gl.createShader(type);
    if (!ret) throw new Error("Unable to create shader");
    gl.shaderSource(ret, src);
    gl.compileShader(ret);
    let msg = gl.getShaderInfoLog(ret);
    if (msg && msg.trim().length > 0) throw new Error("Shader compile error: " + msg);
    return ret;
}
function $7333038afa66965a$export$d879afae78b531a5(gl, prog) {
    gl.linkProgram(prog);
    let msg = gl.getProgramInfoLog(prog);
    if (msg && msg.trim().length > 0) throw new Error("Unable to link: " + msg);
}


let $90357911555bd622$var$shader;
let $90357911555bd622$var$vbo;
let $90357911555bd622$var$uvbo;
let $90357911555bd622$var$texturesByUrl = {};
function $90357911555bd622$export$5998daa18e8ce5b0() {
    $90357911555bd622$var$shader = undefined;
    $90357911555bd622$var$vbo = undefined;
    $90357911555bd622$var$uvbo = undefined;
    $90357911555bd622$var$texturesByUrl = {};
}
function $90357911555bd622$var$generate(gl) {
    if ($90357911555bd622$var$vbo) return $90357911555bd622$var$vbo;
    $90357911555bd622$var$vbo = gl.createBuffer();
    if (!$90357911555bd622$var$vbo) throw new Error("Unable to create buffer object");
    let coords = [
        -0.5,
        0.125,
        0,
        -0.5,
        -0.125,
        0,
        0.5,
        0.125,
        0,
        0.5,
        -0.125,
        0
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, $90357911555bd622$var$vbo);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(coords), gl.STATIC_DRAW);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return $90357911555bd622$var$vbo;
}
function $90357911555bd622$var$generateUVBO(gl) {
    if ($90357911555bd622$var$uvbo) return $90357911555bd622$var$uvbo;
    $90357911555bd622$var$uvbo = gl.createBuffer();
    if (!$90357911555bd622$var$uvbo) throw new Error("Unable to create buffer object");
    let coords = [
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        0
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, $90357911555bd622$var$uvbo);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(coords), gl.STATIC_DRAW);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return $90357911555bd622$var$uvbo;
}
function $90357911555bd622$export$4807f772bfdbc71f(gl, projectionMatrix, cameraMatrix, targetMatrix, textureUrl) {
    let shader = $90357911555bd622$var$getShader(gl);
    let v = $90357911555bd622$var$generate(gl);
    let uvbo = $90357911555bd622$var$generateUVBO(gl);
    gl.disable(gl.DEPTH_TEST);
    gl.useProgram(shader.prog);
    gl.uniformMatrix4fv(shader.unif_proj, false, projectionMatrix);
    gl.uniformMatrix4fv(shader.unif_camera, false, cameraMatrix);
    gl.uniformMatrix4fv(shader.unif_matrix, false, targetMatrix);
    gl.bindBuffer(gl.ARRAY_BUFFER, v);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, $90357911555bd622$var$loadTexture(gl, textureUrl));
    gl.uniform1i(shader.unif_skinSampler, 0);
    gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
    gl.enableVertexAttribArray(shader.attr_position);
    gl.bindBuffer(gl.ARRAY_BUFFER, uvbo);
    gl.vertexAttribPointer(shader.attr_textureCoord, 2, gl.FLOAT, false, 8, 0);
    gl.enableVertexAttribArray(shader.attr_textureCoord);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    gl.disableVertexAttribArray(shader.attr_position);
    gl.disableVertexAttribArray(shader.attr_textureCoord);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
}
function $90357911555bd622$var$generateLocalMatrix() {
    let position = [
        0,
        0,
        -5
    ];
    return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        position[0],
        position[1],
        position[2],
        1
    ]);
}
let $90357911555bd622$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 projMatrix;
uniform mat4 cameraMatrix;
uniform mat4 modelViewMatrix;
attribute vec4 position;
attribute vec2 textureCoord;

varying highp vec2 vTextureCoord;

void main()
{
    gl_Position = projMatrix * cameraMatrix * modelViewMatrix * position;
    vTextureCoord = textureCoord;
}`;
let $90357911555bd622$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
uniform sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2D(skinSampler, vTextureCoord);
}`;
function $90357911555bd622$var$getShader(gl) {
    if ($90357911555bd622$var$shader) return $90357911555bd622$var$shader;
    let prog = gl.createProgram();
    if (!prog) throw new Error("Unable to create program");
    let vertexShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $90357911555bd622$var$vertexShaderSrc);
    let fragmentShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $90357911555bd622$var$fragmentShaderSrc);
    gl.attachShader(prog, vertexShader);
    gl.attachShader(prog, fragmentShader);
    (0, $7333038afa66965a$export$d879afae78b531a5)(gl, prog);
    let unif_proj = gl.getUniformLocation(prog, "projMatrix");
    if (!unif_proj) throw new Error("Unable to get uniform location projMatrix");
    let unif_matrix = gl.getUniformLocation(prog, "modelViewMatrix");
    if (!unif_matrix) throw new Error("Unable to get uniform location modelViewMatrix");
    let unif_camera = gl.getUniformLocation(prog, "cameraMatrix");
    if (!unif_camera) throw new Error("Unable to get uniform location cameraMatrix");
    let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
    if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
    $90357911555bd622$var$shader = {
        prog: prog,
        unif_matrix: unif_matrix,
        unif_proj: unif_proj,
        unif_camera: unif_camera,
        unif_skinSampler: unif_skinSampler,
        attr_position: gl.getAttribLocation(prog, "position"),
        attr_textureCoord: gl.getAttribLocation(prog, "textureCoord")
    };
    return $90357911555bd622$var$shader;
}
function $90357911555bd622$var$loadTexture(gl, url) {
    if ($90357911555bd622$var$texturesByUrl[url]) return $90357911555bd622$var$texturesByUrl[url];
    let texture = gl.createTexture();
    if (!texture) throw new Error("Unable to create texture");
    $90357911555bd622$var$texturesByUrl[url] = texture;
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // Because images have to be download over the internet
    // they might take a moment until they are ready.
    // Until then put a single pixel in the texture so we can
    // use it immediately. When the image has finished downloading
    // we'll update the texture with the contents of the image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 1;
    const height = 1;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const pixel = new Uint8Array([
        0,
        0,
        255,
        255
    ]); // opaque blue
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);
    const image = new Image();
    image.onload = function() {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    };
    image.src = url;
    return texture;
}


var $2edf3b5f20103352$exports = {};

$parcel$export($2edf3b5f20103352$exports, "create", function () { return $2edf3b5f20103352$export$185802fd694ee1f5; });
$parcel$export($2edf3b5f20103352$exports, "clone", function () { return $2edf3b5f20103352$export$9cd59f9826255e47; });
$parcel$export($2edf3b5f20103352$exports, "copy", function () { return $2edf3b5f20103352$export$784d13d8ee351f07; });
$parcel$export($2edf3b5f20103352$exports, "fromValues", function () { return $2edf3b5f20103352$export$a82be99ed2a44a7d; });
$parcel$export($2edf3b5f20103352$exports, "set", function () { return $2edf3b5f20103352$export$adaa4cf7ef1b65be; });
$parcel$export($2edf3b5f20103352$exports, "identity", function () { return $2edf3b5f20103352$export$f0954fd7d5368655; });
$parcel$export($2edf3b5f20103352$exports, "transpose", function () { return $2edf3b5f20103352$export$9cb09a71b7d66923; });
$parcel$export($2edf3b5f20103352$exports, "invert", function () { return $2edf3b5f20103352$export$6897c284b6f9f4dc; });
$parcel$export($2edf3b5f20103352$exports, "adjoint", function () { return $2edf3b5f20103352$export$33f3c024b4ae00a1; });
$parcel$export($2edf3b5f20103352$exports, "determinant", function () { return $2edf3b5f20103352$export$a04698f914c55ed9; });
$parcel$export($2edf3b5f20103352$exports, "multiply", function () { return $2edf3b5f20103352$export$2060d2db72cce88f; });
$parcel$export($2edf3b5f20103352$exports, "translate", function () { return $2edf3b5f20103352$export$d73ee8ef04f5226a; });
$parcel$export($2edf3b5f20103352$exports, "scale", function () { return $2edf3b5f20103352$export$dcdf75081b88279d; });
$parcel$export($2edf3b5f20103352$exports, "rotate", function () { return $2edf3b5f20103352$export$bb628a54ab399bc9; });
$parcel$export($2edf3b5f20103352$exports, "rotateX", function () { return $2edf3b5f20103352$export$a59c8716592e09af; });
$parcel$export($2edf3b5f20103352$exports, "rotateY", function () { return $2edf3b5f20103352$export$cf71e4d4ca4d1cfd; });
$parcel$export($2edf3b5f20103352$exports, "rotateZ", function () { return $2edf3b5f20103352$export$ea6eae3365de5b9c; });
$parcel$export($2edf3b5f20103352$exports, "fromTranslation", function () { return $2edf3b5f20103352$export$bc9e79e74e9fddf6; });
$parcel$export($2edf3b5f20103352$exports, "fromScaling", function () { return $2edf3b5f20103352$export$832ca188ffb1955d; });
$parcel$export($2edf3b5f20103352$exports, "fromRotation", function () { return $2edf3b5f20103352$export$926fc125ff3c666c; });
$parcel$export($2edf3b5f20103352$exports, "fromXRotation", function () { return $2edf3b5f20103352$export$dd47cc2f828c32ef; });
$parcel$export($2edf3b5f20103352$exports, "fromYRotation", function () { return $2edf3b5f20103352$export$7dc997d67d2b7f33; });
$parcel$export($2edf3b5f20103352$exports, "fromZRotation", function () { return $2edf3b5f20103352$export$ad5ddaedc8f405df; });
$parcel$export($2edf3b5f20103352$exports, "fromRotationTranslation", function () { return $2edf3b5f20103352$export$9545ac307f2a256b; });
$parcel$export($2edf3b5f20103352$exports, "fromQuat2", function () { return $2edf3b5f20103352$export$ff497f2be31cc6a; });
$parcel$export($2edf3b5f20103352$exports, "getTranslation", function () { return $2edf3b5f20103352$export$202e99f82f7f0395; });
$parcel$export($2edf3b5f20103352$exports, "getScaling", function () { return $2edf3b5f20103352$export$71dc54d92bd04b57; });
$parcel$export($2edf3b5f20103352$exports, "getRotation", function () { return $2edf3b5f20103352$export$df3937d3b537df0a; });
$parcel$export($2edf3b5f20103352$exports, "fromRotationTranslationScale", function () { return $2edf3b5f20103352$export$ddf9c55c9f2be172; });
$parcel$export($2edf3b5f20103352$exports, "fromRotationTranslationScaleOrigin", function () { return $2edf3b5f20103352$export$1def1f860edc4b1f; });
$parcel$export($2edf3b5f20103352$exports, "fromQuat", function () { return $2edf3b5f20103352$export$2ff2bbe382249af7; });
$parcel$export($2edf3b5f20103352$exports, "frustum", function () { return $2edf3b5f20103352$export$89b5708c387cac6c; });
$parcel$export($2edf3b5f20103352$exports, "perspectiveNO", function () { return $2edf3b5f20103352$export$4cf19729ec9a96b8; });
$parcel$export($2edf3b5f20103352$exports, "perspective", function () { return $2edf3b5f20103352$export$541149539f3a4684; });
$parcel$export($2edf3b5f20103352$exports, "perspectiveZO", function () { return $2edf3b5f20103352$export$294bba99a6af0c0c; });
$parcel$export($2edf3b5f20103352$exports, "perspectiveFromFieldOfView", function () { return $2edf3b5f20103352$export$58ae211c788e338f; });
$parcel$export($2edf3b5f20103352$exports, "orthoNO", function () { return $2edf3b5f20103352$export$c5f65ef3eb668f27; });
$parcel$export($2edf3b5f20103352$exports, "ortho", function () { return $2edf3b5f20103352$export$4f2167e613cfc87b; });
$parcel$export($2edf3b5f20103352$exports, "orthoZO", function () { return $2edf3b5f20103352$export$b1d31ea7b4d854e; });
$parcel$export($2edf3b5f20103352$exports, "lookAt", function () { return $2edf3b5f20103352$export$d924e14fd6d9aa66; });
$parcel$export($2edf3b5f20103352$exports, "targetTo", function () { return $2edf3b5f20103352$export$aa67782f4dc9e52c; });
$parcel$export($2edf3b5f20103352$exports, "str", function () { return $2edf3b5f20103352$export$42d51816ce590c93; });
$parcel$export($2edf3b5f20103352$exports, "frob", function () { return $2edf3b5f20103352$export$326827e8268e9cdb; });
$parcel$export($2edf3b5f20103352$exports, "add", function () { return $2edf3b5f20103352$export$e16d8520af44a096; });
$parcel$export($2edf3b5f20103352$exports, "subtract", function () { return $2edf3b5f20103352$export$4e2d2ead65e5f7e3; });
$parcel$export($2edf3b5f20103352$exports, "multiplyScalar", function () { return $2edf3b5f20103352$export$c697bed75648cdb7; });
$parcel$export($2edf3b5f20103352$exports, "multiplyScalarAndAdd", function () { return $2edf3b5f20103352$export$553579f63bdd7137; });
$parcel$export($2edf3b5f20103352$exports, "exactEquals", function () { return $2edf3b5f20103352$export$f2599a5cf1109d8; });
$parcel$export($2edf3b5f20103352$exports, "equals", function () { return $2edf3b5f20103352$export$e9bab7fafb253603; });
$parcel$export($2edf3b5f20103352$exports, "mul", function () { return $2edf3b5f20103352$export$6e3a27864ab166fe; });
$parcel$export($2edf3b5f20103352$exports, "sub", function () { return $2edf3b5f20103352$export$f93b5905241a7cca; });
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $ff5897571e714368$export$fd293b15f47e270 = 0.000001;
var $ff5897571e714368$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $ff5897571e714368$export$5ada478c8a628231 = Math.random;
function $ff5897571e714368$export$cb2c0eb57f5e532c(type) {
    $ff5897571e714368$export$b67359430d3b1b2 = type;
}
var $ff5897571e714368$var$degree = Math.PI / 180;
function $ff5897571e714368$export$408b8ee5959eefd5(a) {
    return a * $ff5897571e714368$var$degree;
}
function $ff5897571e714368$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};


function $2edf3b5f20103352$export$185802fd694ee1f5() {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(16);
    if ($ff5897571e714368$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$9cd59f9826255e47(a) {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2edf3b5f20103352$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2edf3b5f20103352$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $2edf3b5f20103352$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $2edf3b5f20103352$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $2edf3b5f20103352$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $2edf3b5f20103352$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $2edf3b5f20103352$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $2edf3b5f20103352$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $2edf3b5f20103352$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $2edf3b5f20103352$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2edf3b5f20103352$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $ff5897571e714368$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $2edf3b5f20103352$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $2edf3b5f20103352$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $2edf3b5f20103352$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $2edf3b5f20103352$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $ff5897571e714368$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$ff497f2be31cc6a(out, a) {
    var translation = new $ff5897571e714368$export$b67359430d3b1b2(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $2edf3b5f20103352$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $2edf3b5f20103352$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $2edf3b5f20103352$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $2edf3b5f20103352$export$df3937d3b537df0a(out, mat) {
    var scaling = new $ff5897571e714368$export$b67359430d3b1b2(3);
    $2edf3b5f20103352$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $2edf3b5f20103352$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $2edf3b5f20103352$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $2edf3b5f20103352$export$541149539f3a4684 = $2edf3b5f20103352$export$4cf19729ec9a96b8;
function $2edf3b5f20103352$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $2edf3b5f20103352$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $2edf3b5f20103352$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $2edf3b5f20103352$export$4f2167e613cfc87b = $2edf3b5f20103352$export$c5f65ef3eb668f27;
function $2edf3b5f20103352$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $ff5897571e714368$export$fd293b15f47e270 && Math.abs(eyey - centery) < $ff5897571e714368$export$fd293b15f47e270 && Math.abs(eyez - centerz) < $ff5897571e714368$export$fd293b15f47e270) return $2edf3b5f20103352$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $2edf3b5f20103352$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $2edf3b5f20103352$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $2edf3b5f20103352$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $2edf3b5f20103352$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $2edf3b5f20103352$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $2edf3b5f20103352$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $2edf3b5f20103352$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $2edf3b5f20103352$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $2edf3b5f20103352$export$6e3a27864ab166fe = $2edf3b5f20103352$export$2060d2db72cce88f;
var $2edf3b5f20103352$export$f93b5905241a7cca = $2edf3b5f20103352$export$4e2d2ead65e5f7e3;

var $7aaf532207b60e73$exports = {};

$parcel$export($7aaf532207b60e73$exports, "create", function () { return $7aaf532207b60e73$export$185802fd694ee1f5; });
$parcel$export($7aaf532207b60e73$exports, "clone", function () { return $7aaf532207b60e73$export$9cd59f9826255e47; });
$parcel$export($7aaf532207b60e73$exports, "length", function () { return $7aaf532207b60e73$export$f24224f1c91d8156; });
$parcel$export($7aaf532207b60e73$exports, "fromValues", function () { return $7aaf532207b60e73$export$a82be99ed2a44a7d; });
$parcel$export($7aaf532207b60e73$exports, "copy", function () { return $7aaf532207b60e73$export$784d13d8ee351f07; });
$parcel$export($7aaf532207b60e73$exports, "set", function () { return $7aaf532207b60e73$export$adaa4cf7ef1b65be; });
$parcel$export($7aaf532207b60e73$exports, "add", function () { return $7aaf532207b60e73$export$e16d8520af44a096; });
$parcel$export($7aaf532207b60e73$exports, "subtract", function () { return $7aaf532207b60e73$export$4e2d2ead65e5f7e3; });
$parcel$export($7aaf532207b60e73$exports, "multiply", function () { return $7aaf532207b60e73$export$2060d2db72cce88f; });
$parcel$export($7aaf532207b60e73$exports, "divide", function () { return $7aaf532207b60e73$export$cd007d971a5a2143; });
$parcel$export($7aaf532207b60e73$exports, "ceil", function () { return $7aaf532207b60e73$export$803ce6b71a0a94b2; });
$parcel$export($7aaf532207b60e73$exports, "floor", function () { return $7aaf532207b60e73$export$a3fe094919f356fd; });
$parcel$export($7aaf532207b60e73$exports, "min", function () { return $7aaf532207b60e73$export$96ec731ed4dcb222; });
$parcel$export($7aaf532207b60e73$exports, "max", function () { return $7aaf532207b60e73$export$8960430cfd85939f; });
$parcel$export($7aaf532207b60e73$exports, "round", function () { return $7aaf532207b60e73$export$2077e0241d6afd3c; });
$parcel$export($7aaf532207b60e73$exports, "scale", function () { return $7aaf532207b60e73$export$dcdf75081b88279d; });
$parcel$export($7aaf532207b60e73$exports, "scaleAndAdd", function () { return $7aaf532207b60e73$export$19cedf1da84ba854; });
$parcel$export($7aaf532207b60e73$exports, "distance", function () { return $7aaf532207b60e73$export$9f17032d917177de; });
$parcel$export($7aaf532207b60e73$exports, "squaredDistance", function () { return $7aaf532207b60e73$export$88e6ebb4fe54f538; });
$parcel$export($7aaf532207b60e73$exports, "squaredLength", function () { return $7aaf532207b60e73$export$ab44e1323ffc8376; });
$parcel$export($7aaf532207b60e73$exports, "negate", function () { return $7aaf532207b60e73$export$aef51622e549b8b0; });
$parcel$export($7aaf532207b60e73$exports, "inverse", function () { return $7aaf532207b60e73$export$70ae2c07e401031b; });
$parcel$export($7aaf532207b60e73$exports, "normalize", function () { return $7aaf532207b60e73$export$a3295358bff77e; });
$parcel$export($7aaf532207b60e73$exports, "dot", function () { return $7aaf532207b60e73$export$94132a0e348806d4; });
$parcel$export($7aaf532207b60e73$exports, "cross", function () { return $7aaf532207b60e73$export$bb646b20bb93d339; });
$parcel$export($7aaf532207b60e73$exports, "lerp", function () { return $7aaf532207b60e73$export$3a89f8d6f6bf6c9f; });
$parcel$export($7aaf532207b60e73$exports, "hermite", function () { return $7aaf532207b60e73$export$ae8865616f30561c; });
$parcel$export($7aaf532207b60e73$exports, "bezier", function () { return $7aaf532207b60e73$export$b9c5f84610baddaf; });
$parcel$export($7aaf532207b60e73$exports, "random", function () { return $7aaf532207b60e73$export$4385e60b38654f68; });
$parcel$export($7aaf532207b60e73$exports, "transformMat4", function () { return $7aaf532207b60e73$export$5ffbd13800309d59; });
$parcel$export($7aaf532207b60e73$exports, "transformMat3", function () { return $7aaf532207b60e73$export$f0bfa0a0024626ee; });
$parcel$export($7aaf532207b60e73$exports, "transformQuat", function () { return $7aaf532207b60e73$export$c32adef9e939ce85; });
$parcel$export($7aaf532207b60e73$exports, "rotateX", function () { return $7aaf532207b60e73$export$a59c8716592e09af; });
$parcel$export($7aaf532207b60e73$exports, "rotateY", function () { return $7aaf532207b60e73$export$cf71e4d4ca4d1cfd; });
$parcel$export($7aaf532207b60e73$exports, "rotateZ", function () { return $7aaf532207b60e73$export$ea6eae3365de5b9c; });
$parcel$export($7aaf532207b60e73$exports, "angle", function () { return $7aaf532207b60e73$export$944b09d2ad10b378; });
$parcel$export($7aaf532207b60e73$exports, "zero", function () { return $7aaf532207b60e73$export$7f9972325ebfd559; });
$parcel$export($7aaf532207b60e73$exports, "str", function () { return $7aaf532207b60e73$export$42d51816ce590c93; });
$parcel$export($7aaf532207b60e73$exports, "exactEquals", function () { return $7aaf532207b60e73$export$f2599a5cf1109d8; });
$parcel$export($7aaf532207b60e73$exports, "equals", function () { return $7aaf532207b60e73$export$e9bab7fafb253603; });
$parcel$export($7aaf532207b60e73$exports, "sub", function () { return $7aaf532207b60e73$export$f93b5905241a7cca; });
$parcel$export($7aaf532207b60e73$exports, "mul", function () { return $7aaf532207b60e73$export$6e3a27864ab166fe; });
$parcel$export($7aaf532207b60e73$exports, "div", function () { return $7aaf532207b60e73$export$159d9494db57879b; });
$parcel$export($7aaf532207b60e73$exports, "dist", function () { return $7aaf532207b60e73$export$6c4a311cc157c764; });
$parcel$export($7aaf532207b60e73$exports, "sqrDist", function () { return $7aaf532207b60e73$export$2422cd6c492a8b3a; });
$parcel$export($7aaf532207b60e73$exports, "len", function () { return $7aaf532207b60e73$export$fc1400facf92c78; });
$parcel$export($7aaf532207b60e73$exports, "sqrLen", function () { return $7aaf532207b60e73$export$99d8dd3f32a3435; });
$parcel$export($7aaf532207b60e73$exports, "forEach", function () { return $7aaf532207b60e73$export$4b80e395e36b5a56; });

function $7aaf532207b60e73$export$185802fd694ee1f5() {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(3);
    if ($ff5897571e714368$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $7aaf532207b60e73$export$9cd59f9826255e47(a) {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $7aaf532207b60e73$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $7aaf532207b60e73$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $7aaf532207b60e73$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $7aaf532207b60e73$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $7aaf532207b60e73$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $7aaf532207b60e73$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $7aaf532207b60e73$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $7aaf532207b60e73$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $7aaf532207b60e73$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $7aaf532207b60e73$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $7aaf532207b60e73$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $7aaf532207b60e73$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $7aaf532207b60e73$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $7aaf532207b60e73$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $7aaf532207b60e73$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $7aaf532207b60e73$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $7aaf532207b60e73$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $7aaf532207b60e73$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $7aaf532207b60e73$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $7aaf532207b60e73$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $7aaf532207b60e73$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $7aaf532207b60e73$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $7aaf532207b60e73$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $7aaf532207b60e73$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $7aaf532207b60e73$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $7aaf532207b60e73$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $7aaf532207b60e73$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $ff5897571e714368$export$5ada478c8a628231() * 2.0 * Math.PI;
    var z = $ff5897571e714368$export$5ada478c8a628231() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $7aaf532207b60e73$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $7aaf532207b60e73$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $7aaf532207b60e73$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $7aaf532207b60e73$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $7aaf532207b60e73$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $7aaf532207b60e73$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $7aaf532207b60e73$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $7aaf532207b60e73$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $7aaf532207b60e73$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $7aaf532207b60e73$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $7aaf532207b60e73$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $7aaf532207b60e73$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $7aaf532207b60e73$export$f93b5905241a7cca = $7aaf532207b60e73$export$4e2d2ead65e5f7e3;
var $7aaf532207b60e73$export$6e3a27864ab166fe = $7aaf532207b60e73$export$2060d2db72cce88f;
var $7aaf532207b60e73$export$159d9494db57879b = $7aaf532207b60e73$export$cd007d971a5a2143;
var $7aaf532207b60e73$export$6c4a311cc157c764 = $7aaf532207b60e73$export$9f17032d917177de;
var $7aaf532207b60e73$export$2422cd6c492a8b3a = $7aaf532207b60e73$export$88e6ebb4fe54f538;
var $7aaf532207b60e73$export$fc1400facf92c78 = $7aaf532207b60e73$export$f24224f1c91d8156;
var $7aaf532207b60e73$export$99d8dd3f32a3435 = $7aaf532207b60e73$export$ab44e1323ffc8376;
var $7aaf532207b60e73$export$4b80e395e36b5a56 = function() {
    var vec = $7aaf532207b60e73$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();


function $0a666de0430682ad$export$ca7f1c5c0280e0bf(params, screenWidth, screenHeight, near = 0.01, far = 100.0) {
    let cam_x = params[2] * 2;
    let cam_y = params[3] * 2;
    let projection = (0, $2edf3b5f20103352$exports).create();
    (0, $2edf3b5f20103352$exports).frustum(projection, near * (-0.5 - params[2]) / params[0], near * (cam_x - 0.5 - params[2]) / params[0], near * (cam_y - 0.5 - params[3]) / params[1], near * (-0.5 - params[3]) / params[1], near, far);
    // Flip camera y axis (before any other transformations) - converts from
    // the y axis downwards of the  tracking camera models to the y axis upwards
    // of rendering coordinate systems
    projection[4] *= -1;
    projection[5] *= -1;
    projection[6] *= -1;
    projection[7] *= -1;
    let mult = (0, $2edf3b5f20103352$exports).create();
    (0, $2edf3b5f20103352$exports).fromScaling(mult, [
        0.5 * cam_x,
        0.5 * cam_y,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, mult, projection);
    // If it's user facing or not doesn't matter here as long as we apply the same-but-opposite
    // rotation at the end of the function
    (0, $2edf3b5f20103352$exports).fromRotation(mult, $0a666de0430682ad$export$83fad53f837eba8e(false) * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, mult, projection);
    let vec = (0, $7aaf532207b60e73$exports).create();
    vec[0] = cam_x;
    vec[1] = cam_y;
    vec[2] = 0;
    (0, $7aaf532207b60e73$exports).transformMat4(vec, vec, mult);
    let absWidth = Math.abs(vec[0]);
    let absHeight = Math.abs(vec[1]);
    let scaleFactor = 1;
    if (absWidth / screenWidth > absHeight / screenHeight) scaleFactor = screenHeight / absHeight;
    else scaleFactor = screenWidth / absWidth;
    (0, $2edf3b5f20103352$exports).fromScaling(mult, [
        scaleFactor,
        scaleFactor,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, mult, projection);
    (0, $2edf3b5f20103352$exports).fromScaling(mult, [
        2 / screenWidth,
        2 / screenHeight,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, mult, projection);
    (0, $2edf3b5f20103352$exports).fromRotation(mult, $0a666de0430682ad$export$83fad53f837eba8e(false) * Math.PI / -180, [
        0,
        0,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, projection, mult);
    return projection;
}
function $0a666de0430682ad$export$83fad53f837eba8e(isUserFacing) {
    if (window.screen.orientation) switch(window.screen.orientation.type){
        case "portrait-primary":
            return isUserFacing ? 90 : 270;
        case "landscape-secondary":
            return 180;
        case "portrait-secondary":
            return isUserFacing ? 270 : 90;
        default:
            return 0;
    }
    else if (window.orientation !== undefined) switch(window.orientation){
        case 0:
            return isUserFacing ? 90 : 270;
        case 90:
            return 0;
        case 180:
            return isUserFacing ? 270 : 90;
        case -90:
            return 180;
    }
    return 0;
}



var $4f6a2a885f909fd4$exports = {};

$parcel$export($4f6a2a885f909fd4$exports, "messageManager", function () { return $4f6a2a885f909fd4$export$40ec70640330196f; });
$parcel$export($4f6a2a885f909fd4$exports, "launchWorker", function () { return $4f6a2a885f909fd4$export$11afba88bcfa2040; });
class $e9bc282abf4ce8a0$export$d61e24a684f9e51 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit() {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i]();
    }
}
class $e9bc282abf4ce8a0$export$3371bf92c01fb88b {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a);
    }
}
class $e9bc282abf4ce8a0$export$2432f79a777b511d {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b);
    }
}
class $e9bc282abf4ce8a0$export$82c217a001e88885 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b, c) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b, c);
    }
}
class $e9bc282abf4ce8a0$export$88bac6eca2b85ca9 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b, c, d, e) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b, c, d, e);
    }
}


class $a93c9e2e7a4327b2$export$7401c2b3ceaa2a5d {
    constructor(){
        this.onOutgoingMessage = new (0, $e9bc282abf4ce8a0$export$d61e24a684f9e51)();
        this.onIncomingMessage = new (0, $e9bc282abf4ce8a0$export$3371bf92c01fb88b)();
        this._outgoingMessages = [];
    }
    postIncomingMessage(msg) {
        this.onIncomingMessage.emit(msg);
    }
    postOutgoingMessage(msg, trans) {
        this._outgoingMessages.push({
            msg: msg,
            transferables: trans
        });
        this.onOutgoingMessage.emit();
    }
    getOutgoingMessages() {
        let ret = this._outgoingMessages;
        this._outgoingMessages = [];
        return ret;
    }
}


var $4f6a2a885f909fd4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $4f6a2a885f909fd4$export$40ec70640330196f = new (0, $a93c9e2e7a4327b2$export$7401c2b3ceaa2a5d)();
var $c3a66be3635d568a$exports = {};
var $e7768240e195dd6f$exports = {};
"use strict";
$e7768240e195dd6f$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



var $1XyTv = parcelRequire("1XyTv");

let $c3a66be3635d568a$var$url = $1XyTv.getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("f1VEZ");
$c3a66be3635d568a$exports = $e7768240e195dd6f$exports($c3a66be3635d568a$var$url, $1XyTv.getOrigin($c3a66be3635d568a$var$url), false);


var $f699b8f26f5df05a$exports = {};


$f699b8f26f5df05a$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("eNhid");


function $4f6a2a885f909fd4$export$11afba88bcfa2040(worker) {
    return $4f6a2a885f909fd4$var$__awaiter(this, void 0, void 0, function*() {
        if (!worker) worker = new Worker($c3a66be3635d568a$exports);
        worker.postMessage({
            t: "wasm",
            url: new URL($f699b8f26f5df05a$exports).toString()
        });
        yield $4f6a2a885f909fd4$var$waitForLoad(worker);
        function sendOutgoing() {
            let msgs = $4f6a2a885f909fd4$export$40ec70640330196f.getOutgoingMessages();
            for (let msg of msgs)worker.postMessage(msg.msg, msg.transferables);
        }
        $4f6a2a885f909fd4$export$40ec70640330196f.onOutgoingMessage.bind(sendOutgoing);
        sendOutgoing();
        worker.addEventListener("message", (evt)=>{
            $4f6a2a885f909fd4$export$40ec70640330196f.postIncomingMessage(evt.data);
        });
    });
}
function $4f6a2a885f909fd4$var$waitForLoad(w) {
    return new Promise((resolve)=>{
        let listener = (msg)=>{
            if (msg.data === "loaded") {
                w.removeEventListener("message", listener);
                resolve();
            }
        };
        w.addEventListener("message", listener);
    });
}


var $bbd51e21c47e24e9$exports = {};

$parcel$export($bbd51e21c47e24e9$exports, "permissionGrantedCamera", function () { return $bbd51e21c47e24e9$export$4bb09993846e9acf; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionGrantedMotion", function () { return $bbd51e21c47e24e9$export$8ef5e97655361f65; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionDeniedCamera", function () { return $bbd51e21c47e24e9$export$5867d9a17b50afa0; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionDeniedMotion", function () { return $bbd51e21c47e24e9$export$fb47f4fbe41dd949; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionDeniedAny", function () { return $bbd51e21c47e24e9$export$79205252f7c81bd7; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionGrantedAll", function () { return $bbd51e21c47e24e9$export$672567c1c7f186ec; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionRequestAll", function () { return $bbd51e21c47e24e9$export$4366b797ee910129; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionRequestMotion", function () { return $bbd51e21c47e24e9$export$b90d6478d97704f1; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionRequestCamera", function () { return $bbd51e21c47e24e9$export$5115e68f403cb5d9; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionRequestUI", function () { return $bbd51e21c47e24e9$export$447cf121adb7b558; });
$parcel$export($bbd51e21c47e24e9$exports, "permissionDeniedUI", function () { return $bbd51e21c47e24e9$export$2e339b4d51173824; });

var $gG43b = parcelRequire("gG43b");
var $209e359f7bc32132$export$caa3e053e76e6c08;
(function(STRINGS) {
    STRINGS[STRINGS["PermissionTitle"] = 0] = "PermissionTitle";
    STRINGS[STRINGS["PermissionDescription"] = 1] = "PermissionDescription";
    STRINGS[STRINGS["PermissionButton"] = 2] = "PermissionButton";
})($209e359f7bc32132$export$caa3e053e76e6c08 || ($209e359f7bc32132$export$caa3e053e76e6c08 = {}));
function $209e359f7bc32132$var$parseLanguage(inp) {
    const [lang, locale] = inp.toLowerCase().split("-");
    return [
        lang,
        locale || ""
    ];
}
const [$209e359f7bc32132$var$lang, $209e359f7bc32132$var$locale] = $209e359f7bc32132$var$parseLanguage(navigator.language);
function $209e359f7bc32132$export$72451b88a72ad9c2(str) {
    switch($209e359f7bc32132$var$lang){
        case "es":
            switch(str){
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionTitle:
                    return "Ya casi...";
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionDescription:
                    return "Para brindar esta experiencia de realidad aumentada, necesitamos acceso a la c\xe1mara y los sensores de movimiento de su dispositivo.";
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionButton:
                    return "Permitir acceso";
            }
            break;
        case "de":
            switch(str){
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionTitle:
                    return "Fast am Ziel..";
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionDescription:
                    return "Um dir dieses Augmented Reality Erlebnis zu liefern, brauchen wir Zugriff auf die Kamera und Bewegungssensoren deines Ger\xe4tes.";
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionButton:
                    return "Gew\xe4hre Zugriff";
            }
            break;
        case "pt":
            switch(str){
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionTitle:
                    return "Est\xe1 quase!";
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionDescription:
                    return "Esta experi\xeancia de realidade aumentada precisa de acesso \xe0 c\xe2mera e aos sensores de movimento deste dispositivo.";
                case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionButton:
                    return "Permitir acesso";
            }
            break;
    }
    switch(str){
        case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionTitle:
            return "Almost there...";
        case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionDescription:
            return "In order to provide this augmented reality experience, we need access to your device's camera and motion sensors.";
        case $209e359f7bc32132$export$caa3e053e76e6c08.PermissionButton:
            return "Grant Access";
    }
    return "";
}


var $bbd51e21c47e24e9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $bbd51e21c47e24e9$var$parser = new (0, $gG43b.UAParser)();
let $bbd51e21c47e24e9$var$_permissionGrantedCamera = false;
let $bbd51e21c47e24e9$var$_permissionGrantedMotion = false;
let $bbd51e21c47e24e9$var$_permissionDeniedCamera = false;
let $bbd51e21c47e24e9$var$_permissionDeniedMotion = false;
if (!window.DeviceOrientationEvent || !window.DeviceOrientationEvent.requestPermission) $bbd51e21c47e24e9$var$_permissionGrantedMotion = true;
function $bbd51e21c47e24e9$var$checkForCameraPermission() {
    return $bbd51e21c47e24e9$var$__awaiter(this, void 0, void 0, function*() {
        if (navigator.permissions && navigator.permissions.query) try {
            let res = yield navigator.permissions.query({
                name: "camera"
            });
            $bbd51e21c47e24e9$var$_permissionDeniedCamera = res.state === "denied";
            $bbd51e21c47e24e9$var$_permissionGrantedCamera = res.state === "granted";
        } catch (ex) {}
    });
}
$bbd51e21c47e24e9$var$checkForCameraPermission();
function $bbd51e21c47e24e9$export$4bb09993846e9acf() {
    return $bbd51e21c47e24e9$var$_permissionGrantedCamera;
}
function $bbd51e21c47e24e9$export$8ef5e97655361f65() {
    return $bbd51e21c47e24e9$var$_permissionGrantedMotion;
}
function $bbd51e21c47e24e9$export$5867d9a17b50afa0() {
    return $bbd51e21c47e24e9$var$_permissionDeniedCamera;
}
function $bbd51e21c47e24e9$export$fb47f4fbe41dd949() {
    return $bbd51e21c47e24e9$var$_permissionDeniedMotion;
}
function $bbd51e21c47e24e9$export$79205252f7c81bd7() {
    return $bbd51e21c47e24e9$var$_permissionDeniedCamera || $bbd51e21c47e24e9$var$_permissionDeniedMotion;
}
function $bbd51e21c47e24e9$export$672567c1c7f186ec() {
    return $bbd51e21c47e24e9$var$_permissionGrantedCamera && $bbd51e21c47e24e9$var$_permissionGrantedMotion;
}
function $bbd51e21c47e24e9$export$4366b797ee910129() {
    return $bbd51e21c47e24e9$var$__awaiter(this, void 0, void 0, function*() {
        yield $bbd51e21c47e24e9$export$b90d6478d97704f1();
        yield $bbd51e21c47e24e9$export$5115e68f403cb5d9();
    });
}
function $bbd51e21c47e24e9$export$5115e68f403cb5d9() {
    return $bbd51e21c47e24e9$var$__awaiter(this, void 0, void 0, function*() {
        try {
            let res = yield navigator.mediaDevices.getUserMedia({
                video: true
            });
            let tracks = res.getTracks();
            tracks.forEach((t)=>t.stop());
            $bbd51e21c47e24e9$var$_permissionGrantedCamera = true;
            $bbd51e21c47e24e9$var$_permissionDeniedCamera = false;
        } catch (err) {
            $bbd51e21c47e24e9$var$_permissionGrantedCamera = false;
            $bbd51e21c47e24e9$var$_permissionDeniedCamera = true;
        }
    });
}
function $bbd51e21c47e24e9$export$b90d6478d97704f1() {
    return $bbd51e21c47e24e9$var$__awaiter(this, void 0, void 0, function*() {
        if (window.DeviceOrientationEvent && window.DeviceOrientationEvent.requestPermission) {
            let permissionResult = yield window.DeviceOrientationEvent.requestPermission();
            if (permissionResult !== "granted") {
                $bbd51e21c47e24e9$var$_permissionGrantedMotion = false;
                $bbd51e21c47e24e9$var$_permissionDeniedMotion = true;
                return false;
            }
        }
        // No motion permissions or granted
        $bbd51e21c47e24e9$var$_permissionGrantedMotion = true;
        $bbd51e21c47e24e9$var$_permissionDeniedMotion = false;
    });
}
function $bbd51e21c47e24e9$export$447cf121adb7b558() {
    return $bbd51e21c47e24e9$var$__awaiter(this, void 0, void 0, function*() {
        yield $bbd51e21c47e24e9$var$checkForCameraPermission();
        if ($bbd51e21c47e24e9$export$672567c1c7f186ec()) return true;
        let div = document.createElement("div");
        div.classList.add("zappar-permission-request");
        div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            max-width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">${(0, $209e359f7bc32132$export$72451b88a72ad9c2)((0, $209e359f7bc32132$export$caa3e053e76e6c08).PermissionTitle)}</div>
        <div class="zappar-text">${(0, $209e359f7bc32132$export$72451b88a72ad9c2)((0, $209e359f7bc32132$export$caa3e053e76e6c08).PermissionDescription)}</div>
        <button id="zappar-permission-request-button">${(0, $209e359f7bc32132$export$72451b88a72ad9c2)((0, $209e359f7bc32132$export$caa3e053e76e6c08).PermissionButton)}</button>
    </div>
`;
        document.body.append(div);
        let button = div.querySelector("#zappar-permission-request-button");
        return yield new Promise((resolve)=>{
            button === null || button === void 0 || button.addEventListener("click", ()=>$bbd51e21c47e24e9$var$__awaiter(this, void 0, void 0, function*() {
                    yield $bbd51e21c47e24e9$export$4366b797ee910129();
                    div.remove();
                    while(true){
                        yield $bbd51e21c47e24e9$var$nextFrame();
                        if ($bbd51e21c47e24e9$export$79205252f7c81bd7()) {
                            resolve(false);
                            return;
                        }
                        if ($bbd51e21c47e24e9$export$672567c1c7f186ec()) {
                            resolve(true);
                            return;
                        }
                    }
                }));
        });
    });
}
function $bbd51e21c47e24e9$var$nextFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}
function $bbd51e21c47e24e9$export$2e339b4d51173824() {
    switch($bbd51e21c47e24e9$var$parser.getBrowser().name){
        case "Chrome":
            $bbd51e21c47e24e9$var$permissionDeniedUIChrome();
            break;
        default:
            $bbd51e21c47e24e9$var$permissionDeniedUIIOS();
            break;
    }
}
function $bbd51e21c47e24e9$var$permissionDeniedUIIOS() {
    let div = document.createElement("div");
    div.classList.add("zappar-permission-request");
    div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            max-width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">Permission is Needed</div>
        <div class="zappar-text">Permission to access your device's camera and motion sensors is necessary for this experience. Please reload the page to try again.</div>
        <button id="zappar-permission-reload-button">Reload</button>
    </div>
`;
    document.body.append(div);
    let button = div.querySelector("#zappar-permission-reload-button");
    button === null || button === void 0 || button.addEventListener("click", ()=>window.location.reload());
}
function $bbd51e21c47e24e9$var$permissionDeniedUIChrome() {
    let div = document.createElement("div");
    div.classList.add("zappar-permission-request");
    div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">Permission is Needed</div>
        <div class="zappar-text">Permission to access your device's camera and motion sensors is necessary for this experience.<br/><br/>To grant access, please tap the ! button in the address bar of your browser, then "Site settings", and finally "Clear and reset". You can then reload the page to try again.</div>
        <button id="zappar-permission-reload-button">Reload</button>
    </div>
`;
    document.body.append(div);
    let button = div.querySelector("#zappar-permission-reload-button");
    button === null || button === void 0 || button.addEventListener("click", ()=>window.location.reload());
}




let $7e50675ff5e3df75$var$logLevel = (0, $c937c8c7cc26bb65$export$3c7fce2c49a05698).LOG_LEVEL_ERROR;
function $7e50675ff5e3df75$export$c622e99c0ce7b1c9(l) {
    $7e50675ff5e3df75$var$logLevel = l;
}
function $7e50675ff5e3df75$export$454156e929b28fe7(...args) {
    if ($7e50675ff5e3df75$var$logLevel >= (0, $c937c8c7cc26bb65$export$3c7fce2c49a05698).LOG_LEVEL_VERBOSE) console.log("[Zappar] INFO", ...args);
}
function $7e50675ff5e3df75$export$497c45d0bfe56de1(...args) {
    if ($7e50675ff5e3df75$var$logLevel >= (0, $c937c8c7cc26bb65$export$3c7fce2c49a05698).LOG_LEVEL_ERROR) console.error("[Zappar] ERROR", ...args);
}
function $7e50675ff5e3df75$export$79a36c979e81230e(...args) {
    if ($7e50675ff5e3df75$var$logLevel >= (0, $c937c8c7cc26bb65$export$3c7fce2c49a05698).LOG_LEVEL_VERBOSE) console.log("[Zappar] WARN", ...args);
}


let $f197f040e648db59$var$latestFaceMesh = 1;
let $f197f040e648db59$var$faceMeshById = new Map();
function $f197f040e648db59$export$3a09cf4ac8b68494() {
    let ret = $f197f040e648db59$var$latestFaceMesh++;
    $f197f040e648db59$var$faceMeshById.set(ret, new $f197f040e648db59$export$1238420da3a0b20c());
    (0, $7e50675ff5e3df75$export$454156e929b28fe7)("face_mesh_t initialized");
    return ret;
}
function $f197f040e648db59$export$eed3c787ca5a1447(m) {
    $f197f040e648db59$var$faceMeshById.delete(m);
}
function $f197f040e648db59$export$139ac0d2bb1e45ec(m) {
    return $f197f040e648db59$var$faceMeshById.get(m);
}
class $f197f040e648db59$export$1238420da3a0b20c {
    constructor(){
        this.render_mean_ = new Float32Array();
        this.render_identity_ = new Float32Array(50);
        this.render_expression_ = new Float32Array(29);
        this.render_uvs_ = new Float32Array();
        this.render_indices_ = new Uint16Array();
        this.vertices_ = new Float32Array();
        this.normals_ = new Float32Array();
        this.normalsCalculated_ = false;
        this.modelVersion_ = -1;
        this.mirrored_ = false;
    }
    loadFromMemory(ab, fillMouth, fillEyeL, fillEyeR, fillNeck) {
        let offset = 0;
        let uint16View = new Uint16Array(ab);
        let intView = new Int32Array(ab);
        let floatView = new Float32Array(ab);
        let readMatrix = ()=>{
            let nr = intView[offset++];
            let nc = intView[offset++];
            let size = nr * nc;
            let ret = floatView.subarray(offset, offset + size);
            offset += size;
            return ret;
        };
        let readShortVector = ()=>{
            let size = intView[offset++];
            let ret = uint16View.subarray(offset * 2, offset * 2 + size);
            offset += size / 2;
            return ret;
        };
        this.render_mean_ = readMatrix();
        this.render_identity_ = readMatrix();
        this.render_expression_ = readMatrix();
        this.render_uvs_ = readMatrix();
        let baseIndices = readShortVector();
        let mouthIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let leftEyeIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let rightEyeIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let neckIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        if (!fillMouth && !fillEyeL && !fillEyeR && !fillNeck) this.render_indices_ = baseIndices;
        else {
            let sizeRequired = baseIndices.length;
            if (fillMouth) sizeRequired += mouthIndices.length;
            if (fillEyeL) sizeRequired += leftEyeIndices.length;
            if (fillEyeR) sizeRequired += rightEyeIndices.length;
            if (fillNeck) sizeRequired += neckIndices.length;
            this.render_indices_ = new Uint16Array(sizeRequired);
            this.render_indices_.set(baseIndices, 0);
            let indx = baseIndices.length;
            if (fillMouth) {
                this.render_indices_.set(mouthIndices, indx);
                indx += mouthIndices.length;
            }
            if (fillEyeL) {
                this.render_indices_.set(leftEyeIndices, indx);
                indx += leftEyeIndices.length;
            }
            if (fillEyeR) {
                this.render_indices_.set(rightEyeIndices, indx);
                indx += rightEyeIndices.length;
            }
            if (fillNeck) {
                this.render_indices_.set(neckIndices, indx);
                indx += neckIndices.length;
            }
        }
        this.vertices_ = new Float32Array(this.render_mean_);
        this.normals_ = new Float32Array(this.vertices_.length);
        this.modelVersion_++;
    }
    getVertices() {
        return this.vertices_;
    }
    getUVs() {
        return this.render_uvs_;
    }
    getIndices() {
        if (this.mirrored_) {
            if (!this.render_indices_reversed) {
                this.render_indices_reversed = new Uint16Array(this.render_indices_.length);
                for(let i = 0; i < this.render_indices_.length; i += 3){
                    this.render_indices_reversed[i] = this.render_indices_[i + 2];
                    this.render_indices_reversed[i + 1] = this.render_indices_[i + 1];
                    this.render_indices_reversed[i + 2] = this.render_indices_[i];
                }
            }
            return this.render_indices_reversed;
        }
        return this.render_indices_;
    }
    getNormals() {
        if (!this.normalsCalculated_) this.calculateNormals();
        return this.normals_;
    }
    getModelVersion() {
        return this.modelVersion_;
    }
    getLandmarkDataForVertex(v) {
        let mean = [
            this.render_mean_[v * 3],
            this.render_mean_[v * 3 + 1],
            this.render_mean_[v * 3 + 2]
        ];
        let identity = [];
        for(let i = 0; i < 50; i++)identity.push(this.render_identity_[v * 150 + i]), identity.push(this.render_identity_[(v * 3 + 1) * 50 + i]), identity.push(this.render_identity_[(v * 3 + 2) * 50 + i]);
        let expression = [];
        for(let i = 0; i < 29; i++)expression.push(this.render_expression_[v * 87 + i]), expression.push(this.render_expression_[(v * 3 + 1) * 29 + i]), expression.push(this.render_expression_[(v * 3 + 2) * 29 + i]);
        return {
            mean: mean,
            identity: identity,
            expression: expression
        };
    }
    update(identity, expression, mirrored) {
        if (this.render_mean_.length === 0) return;
        if (this.render_identity_.length === 0) return;
        if (this.render_expression_.length === 0) return;
        this.mirrored_ = mirrored;
        this.vertices_.set(this.render_mean_);
        for(let i = 0; i < identity.length; i++)for(let j = 0; j < this.vertices_.length; j++)this.vertices_[j] += identity[i] * this.render_identity_[j * identity.length + i];
        for(let i = 0; i < expression.length; i++)for(let j = 0; j < this.vertices_.length; j++)this.vertices_[j] += expression[i] * this.render_expression_[j * expression.length + i];
        if (mirrored) for(let j = 0; j < this.vertices_.length; j += 3)this.vertices_[j] *= -1;
        this.normalsCalculated_ = false;
    }
    calculateNormals() {
        let indices = this.getIndices();
        let vertices = this.vertices_;
        let faceNormals = new Float32Array(indices.length);
        if (!vertices) return;
        let size = indices.length;
        let normals = this.normals_;
        let v = new Float32Array([
            0,
            0,
            0
        ]);
        let w = new Float32Array([
            0,
            0,
            0
        ]);
        let out = new Float32Array([
            0,
            0,
            0
        ]);
        for(let i = 0; i < size; i += 3){
            let vertexStart0 = indices[i] * 3;
            let vertexStart1 = indices[i + 1] * 3;
            let vertexStart2 = indices[i + 2] * 3;
            v[0] = vertices[vertexStart1] - vertices[vertexStart0];
            v[1] = vertices[vertexStart1 + 1] - vertices[vertexStart0 + 1];
            v[2] = vertices[vertexStart1 + 2] - vertices[vertexStart0 + 2];
            w[0] = vertices[vertexStart2] - vertices[vertexStart0];
            w[1] = vertices[vertexStart2 + 1] - vertices[vertexStart0 + 1];
            w[2] = vertices[vertexStart2 + 2] - vertices[vertexStart0 + 2];
            (0, $7aaf532207b60e73$exports).cross(out, v, w);
            let length = (0, $7aaf532207b60e73$exports).length(out);
            faceNormals[i] = out[0] / length;
            faceNormals[i + 1] = out[1] / length;
            faceNormals[i + 2] = out[2] / length;
        }
        normals.fill(0);
        for(let i = 0; i < size; i += 3){
            let vertexStart0 = indices[i] * 3;
            let vertexStart1 = indices[i + 1] * 3;
            let vertexStart2 = indices[i + 2] * 3;
            normals[vertexStart0] += faceNormals[i];
            normals[vertexStart0 + 1] += faceNormals[i + 1];
            normals[vertexStart0 + 2] += faceNormals[i + 2];
            normals[vertexStart1] += faceNormals[i];
            normals[vertexStart1 + 1] += faceNormals[i + 1];
            normals[vertexStart1 + 2] += faceNormals[i + 2];
            normals[vertexStart2] += faceNormals[i];
            normals[vertexStart2 + 1] += faceNormals[i + 1];
            normals[vertexStart2 + 2] += faceNormals[i + 2];
        }
        let numberNormals = normals.length / 3;
        for(let i = 0; i < numberNormals; i++){
            let indx = i * 3;
            v[0] = normals[indx];
            v[1] = normals[indx + 1];
            v[2] = normals[indx + 2];
            (0, $7aaf532207b60e73$exports).normalize(w, v);
            normals[indx] = w[0];
            normals[indx + 1] = w[1];
            normals[indx + 2] = w[2];
        }
        this.normalsCalculated_ = true;
    }
}




let $3caa8b08e875393d$var$identity = (0, $2edf3b5f20103352$exports).create();
class $3caa8b08e875393d$export$65ee3277a9a1612d {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        this._vbo = undefined;
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._shader = undefined;
    }
    _generate(gl, i) {
        if (this._vbo) return this._vbo;
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        let vboData = new Float32Array([
            -1,
            -1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            1,
            1,
            -1,
            0,
            1,
            0,
            1,
            -1,
            0,
            1,
            0,
            -1,
            1,
            0,
            0,
            1,
            1,
            1,
            0,
            1,
            1
        ]);
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vboData), gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    drawCameraFrame(screenWidth, screenHeight, i, mirror) {
        if (!i.texture) return;
        let gl = this._gl;
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.BLEND);
        let shader = this._getCameraShader(gl);
        let vbo = this._generate(gl, i);
        gl.activeTexture(gl.TEXTURE0);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_skinTexTransform, false, $3caa8b08e875393d$export$3da067886124f338(i.dataWidth, i.dataHeight, screenWidth, screenHeight, i.uvTransform || $3caa8b08e875393d$var$identity, mirror));
        gl.uniform1i(shader.unif_skinSampler, 0);
        gl.bindTexture(gl.TEXTURE_2D, i.texture);
        gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 20, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.vertexAttribPointer(shader.attr_texCoord, 2, gl.FLOAT, false, 20, 12);
        gl.enableVertexAttribArray(shader.attr_texCoord);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_texCoord);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.useProgram(null);
    }
    _getCameraShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $3caa8b08e875393d$var$vertexShaderSrc);
        let fragmentShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $3caa8b08e875393d$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $7333038afa66965a$export$d879afae78b531a5)(gl, prog);
        let unif_skinTexTransform = gl.getUniformLocation(prog, "skinTexTransform");
        if (!unif_skinTexTransform) throw new Error("Unable to get uniform location skinTexTransform");
        let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
        if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
        this._shader = {
            prog: prog,
            unif_skinTexTransform: unif_skinTexTransform,
            unif_skinSampler: unif_skinSampler,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_texCoord: gl.getAttribLocation(prog, "texCoord")
        };
        return this._shader;
    }
}
let $3caa8b08e875393d$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

attribute vec4 position;
attribute vec4 texCoord;
varying vec4 skinTexVarying;
uniform mat4 skinTexTransform;

void main()
{
    gl_Position = position;
    skinTexVarying = skinTexTransform * texCoord;
}`;
let $3caa8b08e875393d$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying vec4 skinTexVarying;
uniform lowp sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2DProj(skinSampler, skinTexVarying);
}`;
function $3caa8b08e875393d$var$cameraRotationForScreenOrientation() {
    if (window.screen.orientation) switch(window.screen.orientation.type){
        case "portrait-primary":
            return 270;
        case "landscape-secondary":
            return 180;
        case "portrait-secondary":
            return 90;
        default:
            return 0;
    }
    else if (window.orientation !== undefined) switch(window.orientation){
        case 0:
            return 270;
        case 90:
            return 0;
        case 180:
            return 90;
        case -90:
            return 180;
    }
    return 0;
}
function $3caa8b08e875393d$export$3da067886124f338(frameWidth, frameHeight, screenWidth, screenHeight, uvMatrix, mirror) {
    let ret = (0, $2edf3b5f20103352$exports).create();
    let trans = (0, $2edf3b5f20103352$exports).create();
    // Translate to centre UV coords
    (0, $2edf3b5f20103352$exports).fromTranslation(trans, [
        -0.5,
        -0.5,
        0
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    if (mirror) {
        (0, $2edf3b5f20103352$exports).fromScaling(trans, [
            -1,
            1,
            1
        ]);
        (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    }
    // Apply rotation back into ZCV's landscape space
    (0, $2edf3b5f20103352$exports).fromRotation(trans, -1 * $3caa8b08e875393d$var$cameraRotationForScreenOrientation() * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    // Get our screenWidth and screenHeight into that same space
    let vec = (0, $7aaf532207b60e73$exports).create();
    vec[0] = screenWidth;
    vec[1] = screenHeight;
    vec[2] = 0;
    (0, $7aaf532207b60e73$exports).transformMat4(vec, vec, trans);
    let absScreenX = Math.abs(vec[0]);
    let absScreenY = Math.abs(vec[1]);
    // Apply a flip since the texture is upside-down
    (0, $2edf3b5f20103352$exports).fromScaling(trans, [
        1,
        -1,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    // Apply cropping
    let screenAspect = absScreenX / absScreenY;
    let frameAspect = frameWidth / frameHeight;
    if (screenAspect > frameAspect) (0, $2edf3b5f20103352$exports).fromScaling(trans, [
        1,
        frameAspect / screenAspect,
        1
    ]);
    else (0, $2edf3b5f20103352$exports).fromScaling(trans, [
        screenAspect / frameAspect,
        1,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    // Translate back to UV coords
    (0, $2edf3b5f20103352$exports).fromTranslation(trans, [
        0.5,
        0.5,
        0
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    // Apply the camera frame's UV matrix
    (0, $2edf3b5f20103352$exports).multiply(ret, uvMatrix, ret);
    return ret;
}





class $b8531391f3339736$export$884fb66b30975d12 {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._normalbo) this._gl.deleteBuffer(this._normalbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._normalbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateNormalBO(face, gl) {
        if (!this._normalbo) this._normalbo = gl.createBuffer();
        if (!this._normalbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._normalbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._normalbo;
    }
    drawFace(matrix, o) {
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(o.getVertices(), gl);
        let n = this._generateNormalBO(o.getNormals(), gl);
        let i = this._generateIBO(o.getIndices(), gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, n);
        gl.vertexAttribPointer(shader.attr_normal, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_normal);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, o.getIndices().length, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_normal);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $b8531391f3339736$var$vertexShaderSrc);
        let fragmentShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $b8531391f3339736$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $7333038afa66965a$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location mattrix");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_normal: gl.getAttribLocation(prog, "normal")
        };
        return this._shader;
    }
}
let $b8531391f3339736$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
attribute vec4 position;
attribute vec3 normal;
varying highp vec3 vnormal;

void main()
{
    gl_Position = matrix * position;
    vnormal = normal;
}`;
let $b8531391f3339736$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying vec4 skinTexVarying;
varying highp vec3 vnormal;
uniform lowp sampler2D skinSampler;

void main()
{
    vec3 normal2 = 0.5 * vnormal + 0.5;
    gl_FragColor = vec4(normal2.x , normal2.y, normal2.z, 1.0);
}`;



class $ba0b3e1b08f31345$export$626d5c7c1d8c587c {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._uvbo) this._gl.deleteBuffer(this._uvbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._uvbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateUVBO(face, gl) {
        if (!this._uvbo) this._uvbo = gl.createBuffer();
        if (!this._uvbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._uvbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._uvbo;
    }
    drawFace(matrix, vertices, uvMatrix, uvs, indices, texture) {
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(vertices, gl);
        let u = this._generateUVBO(uvs, gl);
        let i = this._generateIBO(indices, gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        // gl.enable(gl.BLEND);
        // gl.blendFunc(gl.ONE, gl.ONE);
        // gl.blendEquation(gl.FUNC_SUBTRACT);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.uniformMatrix4fv(shader.unif_uvmatrix, false, uvMatrix);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.uniform1i(shader.unif_sampler, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, u);
        gl.vertexAttribPointer(shader.attr_uv, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_uv);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, 6912, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_uv);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $ba0b3e1b08f31345$var$vertexShaderSrc);
        let fragmentShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $ba0b3e1b08f31345$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $7333038afa66965a$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location matrix");
        let unif_uvmatrix = gl.getUniformLocation(prog, "uvmatrix");
        if (!unif_uvmatrix) throw new Error("Unable to get uniform location matrix");
        let unif_sampler = gl.getUniformLocation(prog, "uSampler");
        if (!unif_sampler) throw new Error("Unable to get uniform location sampler");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            unif_sampler: unif_sampler,
            unif_uvmatrix: unif_uvmatrix,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_uv: gl.getAttribLocation(prog, "uv"),
            attr_texturecoord: gl.getAttribLocation(prog, "aTextureCoord")
        };
        return this._shader;
    }
}
let $ba0b3e1b08f31345$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
uniform mat4 uvmatrix;
attribute vec4 position;
attribute vec3 normal;
attribute vec3 uv;

// varying highp vec3 vnormal;

varying highp vec2 vTextureCoord;
varying highp float vAlpha;

void main()
{
    gl_Position = matrix * position;
    vec4 ret = uvmatrix * vec4(uv.x, uv.y, uv.z, 1.0);
    ret.x /= ret.w * 2.0;
    ret.y /= ret.w * 2.0;
    ret.x += 0.5;
    ret.y += 0.0;
    vAlpha = 1.0;
    vTextureCoord = ret.xy;
}`;
let $ba0b3e1b08f31345$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
varying highp vec3 vnormal;
varying highp float vAlpha;
uniform lowp sampler2D uSampler;

void main()
{
    // vec3 normal2 = 0.5 * vnormal + 0.5;
    vec4 p = texture2D(uSampler, vTextureCoord);
    p.a = vAlpha;
    gl_FragColor = p; // vec4(normal2.x , normal2.y, normal2.z, 1.0);
}`;






var $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b;
(function(SequenceRecorderPacketType) {
    SequenceRecorderPacketType[SequenceRecorderPacketType["CAMERA_FRAME"] = 0] = "CAMERA_FRAME";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ACCELEROMETER"] = 1] = "ACCELEROMETER";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ROTATION_RATE"] = 2] = "ROTATION_RATE";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ATTITUDE"] = 3] = "ATTITUDE";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ATTITUDE_MATRIX"] = 4] = "ATTITUDE_MATRIX";
})($8daf7012fef9fdbd$export$b970cf2e1a7b7c7b || ($8daf7012fef9fdbd$export$b970cf2e1a7b7c7b = {}));
class $8daf7012fef9fdbd$export$a9d7f366c6e802ee {
    constructor(estimatedFrames){
        this._insertionByte = 0;
        this._numberPackets = 0;
        this._started = false;
        this._hasLoggedUnsuppored = false;
        this._data = new ArrayBuffer(this._estimatedSize(estimatedFrames, 320, 240));
        this._dataView = new DataView(this._data);
        this._dataUint8 = new Uint8Array(this._data);
        this._dataFloat32 = new Float32Array(this._data);
    }
    _estimatedSize(frames, cameraFrameWidth, cameraFrameHeight) {
        return $8daf7012fef9fdbd$export$a9d7f366c6e802ee.headerSizeBytes + ($8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType + $8daf7012fef9fdbd$export$a9d7f366c6e802ee.cameraPacketSizeBytes + cameraFrameWidth * cameraFrameHeight) * frames;
    }
    start() {
        this._started = true;
        this._insertionByte = 0;
        this._numberPackets = 0;
        this._growArrayBuffer($8daf7012fef9fdbd$export$a9d7f366c6e802ee.headerSizeBytes);
        let enc = new TextEncoder();
        let headerData = enc.encode("UAR1");
        this._dataUint8.set(headerData);
        this._dataView.setUint32(4, 0, true);
        this._insertionByte += 8;
    }
    stop() {
        this._started = false;
        let trimmed = this._data.slice(0, this._insertionByte);
        this._data = trimmed;
        this._dataUint8 = new Uint8Array(this._data);
        this._dataFloat32 = new Float32Array(this._data);
        this._dataView = new DataView(this._data);
    }
    data() {
        return this._dataUint8;
    }
    appendCameraFrame(c) {
        if (!this._started) return;
        if (!c.data) {
            if (this._hasLoggedUnsuppored) return;
            this._hasLoggedUnsuppored = true;
            (0, $7e50675ff5e3df75$export$497c45d0bfe56de1)("Unable to record frames from this camera source");
            return;
        }
        if (c.data.byteLength !== c.dataWidth * c.dataHeight) {
            (0, $7e50675ff5e3df75$export$497c45d0bfe56de1)("Unable to record frame to sequence: greyscale array doesn't match dimensions");
            return;
        }
        let increment = $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType + $8daf7012fef9fdbd$export$a9d7f366c6e802ee.cameraPacketSizeBytes + c.dataWidth * c.dataHeight;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.CAMERA_FRAME, true);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType;
        this._dataView.setUint32(this._insertionByte, c.dataWidth, true);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraFrameWidth;
        this._dataView.setUint32(this._insertionByte, c.dataHeight, true);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraFrameHeight;
        this._dataFloat32.set(c.cameraToDevice, this._insertionByte / 4);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraToDeviceTransform;
        this._dataFloat32.set(c.cameraModel, this._insertionByte / 4);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraModel;
        this._dataView.setUint32(this._insertionByte, c.userFacing ? 1 : 0, true);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbFlags;
        this._dataUint8.set(new Uint8Array(c.data), this._insertionByte);
        this._insertionByte += c.data.byteLength;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    appendAccelerometer(t, x, y, z) {
        this._appendTimestampedVec3($8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ACCELEROMETER, t, x, y, z);
    }
    appendRotationRate(t, x, y, z) {
        this._appendTimestampedVec3($8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ROTATION_RATE, t, x, y, z);
    }
    appendAttitude(t, x, y, z) {
        this._appendTimestampedVec3($8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ATTITUDE, t, x, y, z);
    }
    _appendTimestampedVec3(type, t, x, y, z) {
        if (!this._started) return;
        let increment = $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType + $8daf7012fef9fdbd$export$a9d7f366c6e802ee.accelerometerPacketSizeBytes;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, type, true);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType;
        this._dataView.setUint32(this._insertionByte, t, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, x, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, y, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, z, true);
        this._insertionByte += 4;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    appendAttitudeMatrix(m) {
        if (!this._started) return;
        let increment = $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType + $8daf7012fef9fdbd$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX, true);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType;
        this._dataFloat32.set(m, this._insertionByte / 4);
        this._insertionByte += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    _growArrayBuffer(requiredIncrement) {
        while(this._insertionByte + requiredIncrement > this._data.byteLength){
            let newSize = Math.max(this._data.byteLength * 2, this._estimatedSize(50, 320, 240));
            let newData = new ArrayBuffer(newSize);
            let newDataUint8 = new Uint8Array(newData);
            newDataUint8.set(this._dataUint8);
            this._data = newData;
            this._dataUint8 = newDataUint8;
            this._dataFloat32 = new Float32Array(this._data);
            this._dataView = new DataView(this._data);
        }
    }
}
// Header (8 bytes): "UAR1" + number of frames (uint32)
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.headerSizeBytes = 8;
// Per-frame packet byte sizes
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType = 4;
// Camera frames
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraFrameWidth = 4;
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraFrameHeight = 4;
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbFlags = 4;
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraToDeviceTransform = 64;
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraModel = 24;
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.cameraPacketSizeBytes = $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraFrameWidth + $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraFrameHeight + $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraToDeviceTransform + $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraModel + $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbFlags;
// Accelerometer
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.accelerometerPacketSizeBytes = 16; // t, x, y, z
// Rotation rate
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.rotationRatePacketSizeBytes = 16; // t, x, y, z
// Attitude
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.attitudePacketSizeBytes = 16; // t, x, y, z
// Attitude matrix
$8daf7012fef9fdbd$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes = 64;
class $8daf7012fef9fdbd$export$20801e67610bf5d8 {
    constructor(_data){
        this._data = _data;
        this.dataByPacket = new Map();
        this.dataByCameraFrame = new Map();
        this.numberPackets = 0;
        this.numberCameraFrames = 0;
        this.numberAccelerometerPackets = 0;
        this.numberRotationRatePackets = 0;
        this.numberAttitudePackets = 0;
        this.numberAttitudeMatrixPackets = 0;
        let dec = new TextDecoder();
        let txt = "";
        try {
            txt = dec.decode(this._data.slice(0, 4));
        } catch (err) {
            throw new Error("Unable to decode header - perhaps this isn't a sequence file?");
        }
        if (txt !== "UAR1") throw new Error(`Invalid - perhaps this isn't a sequence file: ${txt}`);
        let readPoint = 0;
        let dataView = new DataView(this._data);
        this.numberPackets = dataView.getUint32(4, true);
        readPoint += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.headerSizeBytes;
        for(let i = 0; i < this.numberPackets; i++){
            let type = dataView.getUint32(readPoint, true);
            readPoint += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbPacketType;
            switch(type){
                case $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.CAMERA_FRAME:
                    {
                        let width = dataView.getUint32(readPoint, true);
                        readPoint += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraFrameWidth;
                        let height = dataView.getUint32(readPoint, true);
                        readPoint += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraFrameHeight;
                        let cameraToDevice = new Float32Array(this._data, readPoint, $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraToDeviceTransform / 4);
                        readPoint += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraToDeviceTransform;
                        let cameraModel = new Float32Array(this._data, readPoint, $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraModel / 4);
                        readPoint += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbCameraModel;
                        let flags = dataView.getUint32(readPoint, true);
                        readPoint += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.psbFlags;
                        let userFacing = flags === 1;
                        let greyscale = new Uint8Array(this._data, readPoint, width * height);
                        readPoint += width * height;
                        let d = {
                            type: $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.CAMERA_FRAME,
                            width: width,
                            height: height,
                            cameraToDevice: cameraToDevice,
                            cameraModel: cameraModel,
                            userFacing: userFacing,
                            greyscale: greyscale
                        };
                        this.dataByPacket.set(i, d);
                        this.dataByCameraFrame.set(this.numberCameraFrames, d);
                        this.numberCameraFrames++;
                        break;
                    }
                case $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ACCELEROMETER:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ACCELEROMETER,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberAccelerometerPackets++;
                        break;
                    }
                case $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ROTATION_RATE:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ROTATION_RATE,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberRotationRatePackets++;
                        break;
                    }
                case $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ATTITUDE:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ATTITUDE,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberAttitudePackets++;
                        break;
                    }
                case $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX:
                    {
                        let attitude = new Float32Array(this._data, readPoint, $8daf7012fef9fdbd$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes / 4);
                        readPoint += $8daf7012fef9fdbd$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
                        this.dataByPacket.set(i, {
                            type: $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX,
                            attitude: attitude
                        });
                        this.numberAttitudeMatrixPackets++;
                        break;
                    }
            }
        }
    }
}


var $f2ea8a8055b5cf7a$exports = {};

$parcel$export($f2ea8a8055b5cf7a$exports, "CameraSource", function () { return $f2ea8a8055b5cf7a$export$9a93ce53f488cb2e; });

class $6b0cfaf8deebc493$export$1d2df86270c81ecb {
}



var $gG43b = parcelRequire("gG43b");
var $e926f8f1245f24de$export$59a354bcfe78fe8;
(function(EmbeddedVideoImplementation) {
    EmbeddedVideoImplementation[EmbeddedVideoImplementation["OBJECT_URL"] = 0] = "OBJECT_URL";
    EmbeddedVideoImplementation[EmbeddedVideoImplementation["SRC_OBJECT"] = 1] = "SRC_OBJECT";
})($e926f8f1245f24de$export$59a354bcfe78fe8 || ($e926f8f1245f24de$export$59a354bcfe78fe8 = {}));
let $e926f8f1245f24de$export$4882ae973e0491e = {
    deviceMotionMutliplier: -1,
    blacklisted: false,
    showGyroPermissionsWarningIfNecessary: false,
    showSafariPermissionsResetIfNecessary: false,
    requestHighFrameRate: false,
    videoWidth: 640,
    videoHeight: 480,
    dataWidth: 320,
    dataHeight: 240,
    videoElementInDOM: false,
    preferMediaStreamTrackProcessorCamera: false,
    preferImageBitmapCamera: false,
    ios164CameraSelection: false
};
if (typeof window !== "undefined") {
    window["zeeProfile"] = $e926f8f1245f24de$export$4882ae973e0491e;
    if (window.location.href.indexOf("_mstppipeline") >= 0) {
        console.log("Configuring for MSTP camera pipeline (if supported)");
        $e926f8f1245f24de$export$4882ae973e0491e.preferMediaStreamTrackProcessorCamera = true;
    }
    if (window.location.href.indexOf("_imagebitmappipeline") >= 0) {
        console.log("Configuring for ImageBitmap camera pipeline (if supported)");
        $e926f8f1245f24de$export$4882ae973e0491e.preferImageBitmapCamera = true;
    }
}
let $e926f8f1245f24de$var$agent = new $gG43b.UAParser();
let $e926f8f1245f24de$var$os = ($e926f8f1245f24de$var$agent.getOS().name || "unknown").toLowerCase();
let $e926f8f1245f24de$var$engine = ($e926f8f1245f24de$var$agent.getEngine().name || "unknown").toLowerCase();
if ($e926f8f1245f24de$var$engine === "webkit" && $e926f8f1245f24de$var$os !== "ios") {
    $e926f8f1245f24de$export$4882ae973e0491e.deviceMotionMutliplier = 1.0;
    if (typeof window !== "undefined" && window.orientation !== undefined) // iPad
    $e926f8f1245f24de$var$iDevice("15.0");
}
if ($e926f8f1245f24de$var$engine === "webkit" && $e926f8f1245f24de$var$os === "ios") {
    $e926f8f1245f24de$export$4882ae973e0491e.deviceMotionMutliplier = 1.0;
    const version = $e926f8f1245f24de$var$agent.getOS().version || "15.0";
    $e926f8f1245f24de$var$iDevice(version);
}
function $e926f8f1245f24de$var$iDevice(version) {
    let versionParts = version.split(".");
    if (versionParts.length >= 2) {
        const majorVersion = parseInt(versionParts[0]);
        const minorVersion = parseInt(versionParts[1]);
        if (majorVersion < 11 || majorVersion === 11 && minorVersion < 3) $e926f8f1245f24de$export$4882ae973e0491e.blacklisted = true;
        if (majorVersion < 12 || majorVersion === 12 && minorVersion < 2) $e926f8f1245f24de$export$4882ae973e0491e.videoElementInDOM = true;
        if (majorVersion === 12 && minorVersion >= 2 || majorVersion >= 13) $e926f8f1245f24de$export$4882ae973e0491e.showGyroPermissionsWarningIfNecessary = true;
        if (majorVersion >= 13) $e926f8f1245f24de$export$4882ae973e0491e.showSafariPermissionsResetIfNecessary = true;
        if ((majorVersion >= 12 && minorVersion > 1 || majorVersion >= 13) && navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().frameRate) {
            $e926f8f1245f24de$export$4882ae973e0491e.requestHighFrameRate = true;
            if (majorVersion < 14) {
                // Avoid bug where iOS letterboxes 16:9 into 4:3 for high fps
                // Doesn't seem needed with newer versions of iOS, tested on 14.8.1 and 15.2
                $e926f8f1245f24de$export$4882ae973e0491e.videoHeight = 360;
                $e926f8f1245f24de$export$4882ae973e0491e.dataHeight = 180;
            }
        }
        if (majorVersion === 16 && minorVersion >= 4 || majorVersion > 16) $e926f8f1245f24de$export$4882ae973e0491e.ios164CameraSelection = true;
    }
}





const $ad507bd8cfd62de0$var$managers = new Map();
class $ad507bd8cfd62de0$export$6d8a7545b2cb2a7e {
    constructor(_gl){
        this._gl = _gl;
        this._viewports = [];
        this._underlyingViewport = this._gl.viewport;
        this._viewports.push(this._gl.getParameter(this._gl.VIEWPORT));
        this._gl.viewport = (x, y, width, height)=>{
            this._viewports[this._viewports.length - 1] = [
                x,
                y,
                width,
                height
            ];
            this._underlyingViewport.call(this._gl, x, y, width, height);
        };
    }
    static get(gl) {
        let existing = $ad507bd8cfd62de0$var$managers.get(gl);
        if (!existing) {
            existing = new $ad507bd8cfd62de0$export$6d8a7545b2cb2a7e(gl);
            $ad507bd8cfd62de0$var$managers.set(gl, existing);
        }
        return existing;
    }
    push() {
        this._viewports.push(this._viewports[this._viewports.length - 1]);
    }
    pop() {
        const current = this._viewports.pop();
        const prev = this._viewports[this._viewports.length - 1];
        if (!current || current[0] !== prev[0] || current[1] !== prev[1] || current[2] !== prev[2] || current[3] !== prev[3]) this._underlyingViewport.call(this._gl, prev[0], prev[1], prev[2], prev[3]);
    }
}




class $8b884d4e06424e82$export$f9b0f8dc7af3bf20 {
    constructor(_gl){
        this._gl = _gl;
        this._isPaused = true;
        this._hadFrames = false;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._isUploadFrame = true;
        this._computedTransformRotation = -1;
        this._computedFrontCameraRotation = false;
        this._cameraUvTransform = (0, $2edf3b5f20103352$exports).create();
        this._framebufferWidth = 0;
        this._framebufferHeight = 0;
        this._framebufferId = null;
        this._renderTexture = null;
        this._isWebGL2 = false;
        this._isWebGL2 = _gl.getParameter(_gl.VERSION).indexOf("WebGL 2") >= 0;
        if (!this._isWebGL2) this._instancedArraysExtension = this._gl.getExtension("ANGLE_instanced_arrays");
    }
    resetGLContext() {
        this._framebufferId = null;
        this._renderTexture = null;
        this._vertexBuffer = undefined;
        this._indexBuffer = undefined;
        this._greyscaleShader = undefined;
    }
    destroy() {
        this.resetGLContext();
    }
    uploadFrame(texture, img, rotation, fc) {
        let gl = this._gl;
        const glStateManager = (0, $ad507bd8cfd62de0$export$6d8a7545b2cb2a7e).get(gl);
        glStateManager.push();
        const reenableScissorTest = gl.isEnabled(gl.SCISSOR_TEST);
        const reenableDepthTest = gl.isEnabled(gl.DEPTH_TEST);
        const reenableBlend = gl.isEnabled(gl.BLEND);
        const reenableCullFace = gl.isEnabled(gl.CULL_FACE);
        const reenableStencilTest = gl.isEnabled(gl.STENCIL_TEST);
        const previousActiveTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
        const previousUnpackFlip = gl.getParameter(gl.UNPACK_FLIP_Y_WEBGL);
        const previousProgram = gl.getParameter(gl.CURRENT_PROGRAM);
        gl.activeTexture(gl.TEXTURE0);
        const previousBoundTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
        const previousBoundFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
        const previousBoundArrayBuffer = gl.getParameter(gl.ARRAY_BUFFER_BINDING);
        const previousBoundElementArrayBuffer = gl.getParameter(gl.ELEMENT_ARRAY_BUFFER_BINDING);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.STENCIL_TEST);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const level = 0;
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, img);
        let videoWidth = 0;
        let videoHeight = 0;
        if (typeof HTMLVideoElement !== "undefined" && img instanceof HTMLVideoElement) {
            videoWidth = img.videoWidth;
            videoHeight = img.videoHeight;
        } else {
            videoWidth = img.width;
            videoHeight = img.height;
        }
        if (videoHeight > videoWidth) videoHeight = [
            videoWidth,
            videoWidth = videoHeight
        ][0];
        this._updateTransforms(rotation, fc);
        let framebuffer = this._getFramebuffer(gl, (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth / 4, (0, $e926f8f1245f24de$export$4882ae973e0491e).dataHeight);
        let vbo = this._getVertexBuffer(gl);
        let ibo = this._getIndexBuffer(gl);
        let shader = this._getGreyscaleShader(gl);
        const previousVertexAttribSize = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_SIZE);
        const previousVertexAttribType = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_TYPE);
        const previousVertexAttribNormalized = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_NORMALIZED);
        const previousVertexAttribStride = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_STRIDE);
        const previousVertexAttribOffset = gl.getVertexAttribOffset(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_POINTER);
        const previousVertexAttribEnabled = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
        const previousVertexAttribBufferBinding = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING);
        const previousTextureAttribSize = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_SIZE);
        const previousTextureAttribType = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_TYPE);
        const previousTextureAttribNormalized = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_NORMALIZED);
        const previousTextureAttribStride = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_STRIDE);
        const previousTextureAttribOffset = gl.getVertexAttribOffset(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_POINTER);
        const previousTextureAttribBufferBinding = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING);
        const previousTextureAttribEnabled = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
        let previousVertexAttribDivisor = 0;
        let previousTextureAttribDivisor = 0;
        if (this._isWebGL2) {
            previousVertexAttribDivisor = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_DIVISOR);
            previousTextureAttribDivisor = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_DIVISOR);
            gl.vertexAttribDivisor(shader.aVertexPositionLoc, 0);
            gl.vertexAttribDivisor(shader.aTextureCoordLoc, 0);
        } else if (this._instancedArraysExtension) {
            previousVertexAttribDivisor = gl.getVertexAttrib(shader.aVertexPositionLoc, this._instancedArraysExtension.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
            previousTextureAttribDivisor = gl.getVertexAttrib(shader.aTextureCoordLoc, this._instancedArraysExtension.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aVertexPositionLoc, 0);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aTextureCoordLoc, 0);
        }
        // Rendering to the greyscale conversion buffer - bind the framebuffer
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.viewport(0, 0, this._framebufferWidth, this._framebufferHeight);
        // We'll be replacing all the content - clear is a good hint for this on mobile
        gl.clear(gl.COLOR_BUFFER_BIT);
        // Set up bindings for vertex attributes
        gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
        gl.vertexAttribPointer(shader.aVertexPositionLoc, 2, gl.FLOAT, false, 16, 0);
        gl.enableVertexAttribArray(shader.aVertexPositionLoc);
        gl.vertexAttribPointer(shader.aTextureCoordLoc, 2, gl.FLOAT, false, 16, 8);
        gl.enableVertexAttribArray(shader.aTextureCoordLoc);
        // Bind the index buffer
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ibo);
        // Tell WebGL to use our program when drawing
        gl.useProgram(shader.program);
        // Specify greyscale width for the correct offsets, and the uv transform
        gl.uniform1f(shader.uTexWidthLoc, (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth);
        gl.uniformMatrix4fv(shader.uUvTransformLoc, false, this._cameraUvTransform);
        gl.activeTexture(gl.TEXTURE0);
        // Bind the texture to texture unit 0
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // Tell the shader we bound the texture to texture unit 0
        gl.uniform1i(shader.uSamplerLoc, 0);
        // Do the drawing...
        gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousVertexAttribBufferBinding);
        gl.vertexAttribPointer(shader.aVertexPositionLoc, previousVertexAttribSize, previousVertexAttribType, previousVertexAttribNormalized, previousVertexAttribStride, previousVertexAttribOffset);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousTextureAttribBufferBinding);
        gl.vertexAttribPointer(shader.aTextureCoordLoc, previousTextureAttribSize, previousTextureAttribType, previousTextureAttribNormalized, previousTextureAttribStride, previousTextureAttribOffset);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousBoundArrayBuffer);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, previousBoundElementArrayBuffer);
        if (!previousVertexAttribEnabled) gl.disableVertexAttribArray(shader.aVertexPositionLoc);
        if (!previousTextureAttribEnabled) gl.disableVertexAttribArray(shader.aTextureCoordLoc);
        if (this._isWebGL2) {
            gl.vertexAttribDivisor(shader.aVertexPositionLoc, previousVertexAttribDivisor);
            gl.vertexAttribDivisor(shader.aTextureCoordLoc, previousTextureAttribDivisor);
        } else if (this._instancedArraysExtension) {
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aVertexPositionLoc, previousVertexAttribDivisor);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aTextureCoordLoc, previousTextureAttribDivisor);
        }
        gl.bindFramebuffer(gl.FRAMEBUFFER, previousBoundFramebuffer);
        gl.useProgram(previousProgram);
        gl.bindTexture(gl.TEXTURE_2D, previousBoundTexture);
        gl.activeTexture(previousActiveTexture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, previousUnpackFlip);
        glStateManager.pop();
        if (reenableBlend) gl.enable(gl.BLEND);
        if (reenableCullFace) gl.enable(gl.CULL_FACE);
        if (reenableDepthTest) gl.enable(gl.DEPTH_TEST);
        if (reenableScissorTest) gl.enable(gl.SCISSOR_TEST);
        if (reenableStencilTest) gl.enable(gl.STENCIL_TEST);
    }
    readFrame(texture, pixels) {
        let gl = this._gl;
        let pixelsView = new Uint8Array(pixels);
        const previousBoundFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
        let framebuffer = this._getFramebuffer(gl, (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth / 4, (0, $e926f8f1245f24de$export$4882ae973e0491e).dataHeight);
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.readPixels(0, 0, this._framebufferWidth, this._framebufferHeight, gl.RGBA, gl.UNSIGNED_BYTE, pixelsView);
        gl.bindFramebuffer(gl.FRAMEBUFFER, previousBoundFramebuffer);
        return {
            uvTransform: this._cameraUvTransform,
            data: pixels,
            texture: texture,
            dataWidth: (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth,
            dataHeight: (0, $e926f8f1245f24de$export$4882ae973e0491e).dataHeight,
            userFacing: this._computedFrontCameraRotation
        };
    }
    _updateTransforms(rot, fc) {
        if (rot == this._computedTransformRotation && fc == this._computedFrontCameraRotation) return;
        this._computedTransformRotation = rot;
        this._computedFrontCameraRotation = fc;
        this._cameraUvTransform = this._getCameraUvTransform();
    }
    _getCameraUvTransform() {
        switch(this._computedTransformRotation){
            case 270:
                return new Float32Array([
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    1
                ]);
            case 180:
                return new Float32Array([
                    -1,
                    0,
                    0,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1
                ]);
            case 90:
                return new Float32Array([
                    0,
                    -1,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    1,
                    0,
                    1
                ]);
        }
        return new Float32Array([
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    _getFramebuffer(gl, fbWidth, fbHeight) {
        if (this._framebufferWidth === fbWidth && this._framebufferHeight === fbHeight && this._framebufferId) return this._framebufferId;
        if (this._framebufferId) {
            gl.deleteFramebuffer(this._framebufferId);
            this._framebufferId = null;
        }
        if (this._renderTexture) {
            gl.deleteTexture(this._renderTexture);
            this._renderTexture = null;
        }
        this._framebufferId = gl.createFramebuffer();
        if (!this._framebufferId) throw new Error("Unable to create framebuffer");
        gl.bindFramebuffer(gl.FRAMEBUFFER, this._framebufferId);
        this._renderTexture = gl.createTexture();
        if (!this._renderTexture) throw new Error("Unable to create render texture");
        gl.activeTexture(gl.TEXTURE0);
        const previousBoundTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
        gl.bindTexture(gl.TEXTURE_2D, this._renderTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, fbWidth, fbHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this._renderTexture, 0);
        let fbStatus = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
        if (fbStatus !== gl.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer not complete: " + fbStatus.toString());
        this._framebufferWidth = fbWidth;
        this._framebufferHeight = fbHeight;
        gl.bindTexture(gl.TEXTURE_2D, previousBoundTexture);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        return this._framebufferId;
    }
    _getVertexBuffer(gl) {
        if (this._vertexBuffer) return this._vertexBuffer;
        this._vertexBuffer = gl.createBuffer();
        if (!this._vertexBuffer) throw new Error("Unable to create vertex buffer");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vertexBuffer);
        let buffer = new Float32Array([
            -1,
            -1,
            0.0,
            0.0,
            -1,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            -1,
            1.0,
            0.0
        ]);
        gl.bufferData(gl.ARRAY_BUFFER, buffer, gl.STATIC_DRAW);
        return this._vertexBuffer;
    }
    _getIndexBuffer(gl) {
        if (this._indexBuffer) return this._indexBuffer;
        this._indexBuffer = gl.createBuffer();
        if (!this._indexBuffer) throw new Error("Unable to create index buffer");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._indexBuffer);
        let buffer = new Uint16Array([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, buffer, gl.STATIC_DRAW);
        return this._indexBuffer;
    }
    _getGreyscaleShader(gl) {
        if (this._greyscaleShader) return this._greyscaleShader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $8b884d4e06424e82$var$greyscaleVsSource);
        let fragmentShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $8b884d4e06424e82$var$greyscaleFsSource);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $7333038afa66965a$export$d879afae78b531a5)(gl, prog);
        let uTexWidthLoc = gl.getUniformLocation(prog, "uTexWidth");
        if (!uTexWidthLoc) throw new Error("Unable to get uniform location uTexWidth");
        let uUvTransformLoc = gl.getUniformLocation(prog, "uUvTransform");
        if (!uUvTransformLoc) throw new Error("Unable to get uniform location uUvTransform");
        let uSamplerLoc = gl.getUniformLocation(prog, "uSampler");
        if (!uSamplerLoc) throw new Error("Unable to get uniform location uSampler");
        this._greyscaleShader = {
            program: prog,
            aVertexPositionLoc: gl.getAttribLocation(prog, "aVertexPosition"),
            aTextureCoordLoc: gl.getAttribLocation(prog, "aTextureCoord"),
            uTexWidthLoc: uTexWidthLoc,
            uUvTransformLoc: uUvTransformLoc,
            uSamplerLoc: uSamplerLoc
        };
        return this._greyscaleShader;
    }
}
let $8b884d4e06424e82$var$greyscaleVsSource = `
    attribute vec4 aVertexPosition;
    attribute vec2 aTextureCoord;

    varying highp vec2 vTextureCoord1;
    varying highp vec2 vTextureCoord2;
    varying highp vec2 vTextureCoord3;
    varying highp vec2 vTextureCoord4;

    uniform float uTexWidth;
	uniform mat4 uUvTransform;

    void main(void) {
      highp vec2 offset1 = vec2(1.5 / uTexWidth, 0);
      highp vec2 offset2 = vec2(0.5 / uTexWidth, 0);

      gl_Position = aVertexPosition;
      vTextureCoord1 = (uUvTransform * vec4(aTextureCoord - offset1, 0, 1)).xy;
      vTextureCoord2 = (uUvTransform * vec4(aTextureCoord - offset2, 0, 1)).xy;
      vTextureCoord3 = (uUvTransform * vec4(aTextureCoord + offset2, 0, 1)).xy;
      vTextureCoord4 = (uUvTransform * vec4(aTextureCoord + offset1, 0, 1)).xy;
    }
`;
// Fragment shader program
let $8b884d4e06424e82$var$greyscaleFsSource = `
  varying highp vec2 vTextureCoord1;
  varying highp vec2 vTextureCoord2;
  varying highp vec2 vTextureCoord3;
  varying highp vec2 vTextureCoord4;

  uniform sampler2D uSampler;

  const lowp vec3 colorWeights = vec3(77.0 / 256.0, 150.0 / 256.0, 29.0 / 256.0);

  void main(void) {
    lowp vec4 outpx;

    outpx.r = dot(colorWeights, texture2D(uSampler, vTextureCoord1).xyz);
    outpx.g = dot(colorWeights, texture2D(uSampler, vTextureCoord2).xyz);
    outpx.b = dot(colorWeights, texture2D(uSampler, vTextureCoord3).xyz);
    outpx.a = dot(colorWeights, texture2D(uSampler, vTextureCoord4).xyz);

    gl_FragColor = outpx;
  }
`;


let $23fd8c5744e6b817$var$latest = 1;
let $23fd8c5744e6b817$var$byId = new Map();
class $23fd8c5744e6b817$export$bbfb48c500076b66 extends (0, $6b0cfaf8deebc493$export$1d2df86270c81ecb) {
    constructor(_video, _pipeline){
        super();
        this._video = _video;
        this._pipeline = _pipeline;
        this._isPaused = true;
        this._hadFrames = false;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._isUploadFrame = true;
        this._cameraToDeviceTransform = (0, $2edf3b5f20103352$exports).create();
        this._cameraToDeviceTransformUserFacing = (0, $2edf3b5f20103352$exports).create();
        this._cameraModel = new Float32Array([
            300,
            300,
            160,
            120,
            0,
            0
        ]);
        (0, $2edf3b5f20103352$exports).fromScaling(this._cameraToDeviceTransformUserFacing, [
            -1,
            1,
            -1
        ]);
        let video = this._video;
        if (this._video instanceof HTMLVideoElement) video.addEventListener("loadedmetadata", ()=>{
            this._hadFrames = true;
        });
        else this._hadFrames = true;
        this._resetGLContext = this._resetGLContext.bind(this);
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p) p.onGLContextReset.bind(this._resetGLContext);
    }
    static createVideoElementSource(p, element) {
        let ret = $23fd8c5744e6b817$var$latest++;
        $23fd8c5744e6b817$var$byId.set(ret, new $23fd8c5744e6b817$export$bbfb48c500076b66(element, p));
        (0, $7e50675ff5e3df75$export$454156e929b28fe7)("html_element_source_t initialized");
        return ret;
    }
    static getVideoElementSource(m) {
        return $23fd8c5744e6b817$var$byId.get(m);
    }
    _resetGLContext() {
        var _a, _b;
        this._currentVideoTexture = undefined;
        (_b = (_a = this._imageProcessor) === null || _a === void 0 ? void 0 : _a.resetGLContext) === null || _b === void 0 || _b.call(_a);
    }
    destroy() {
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p) p.onGLContextReset.unbind(this._resetGLContext);
        this.pause();
        this._resetGLContext();
    }
    pause() {
        this._isPaused = true;
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
    }
    start() {
        var _a;
        if (this._isPaused) {
            this._isUploadFrame = true;
            if (this._video instanceof HTMLVideoElement) this._hadFrames = false;
        }
        this._isPaused = false;
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
    }
    getFrame(currentlyProcessing) {
        let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let gl = pipeline.glContext;
        if (!gl) return;
        if (this._isPaused) return;
        if (!this._hadFrames) return;
        try {
            let info = this._processFrame(gl, this._cameraToScreenRotation, currentlyProcessing);
            if (info) {
                let token = pipeline.registerToken(info);
                pipeline.sendDataToWorker(info.data || new ArrayBuffer(0), token, info.dataWidth, info.dataHeight, info.userFacing, info.cameraToDevice, info.cameraModel);
            }
        } catch (ex) {
            console.log("Unable to process frame");
        }
        return;
    }
    _processFrame(gl, rotation, currentlyProcessing) {
        let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return undefined;
        if (!this._imageProcessor) this._imageProcessor = new (0, $8b884d4e06424e82$export$f9b0f8dc7af3bf20)(gl);
        if (this._isUploadFrame) {
            if (!this._currentVideoTexture) this._currentVideoTexture = pipeline.getVideoTexture();
            if (!this._currentVideoTexture) return undefined;
            this._imageProcessor.uploadFrame(this._currentVideoTexture, this._video, rotation, this._isUserFacing);
            this._isUploadFrame = !this._isUploadFrame;
            return undefined;
        }
        if (currentlyProcessing || !this._currentVideoTexture) return undefined;
        this._isUploadFrame = !this._isUploadFrame;
        let greySize = (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth * (0, $e926f8f1245f24de$export$4882ae973e0491e).dataHeight;
        let pixels = pipeline.cameraPixelArrays.pop();
        while(pixels){
            if (pixels.byteLength === greySize) break;
            pixels = pipeline.cameraPixelArrays.pop();
        }
        if (!pixels) pixels = new ArrayBuffer(greySize);
        let tex = this._currentVideoTexture;
        this._currentVideoTexture = undefined;
        let focalLength = 300.0 * (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth / 320.0;
        this._cameraModel[0] = focalLength;
        this._cameraModel[1] = focalLength;
        this._cameraModel[2] = (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth * 0.5;
        this._cameraModel[3] = (0, $e926f8f1245f24de$export$4882ae973e0491e).dataHeight * 0.5;
        return Object.assign(Object.assign({}, this._imageProcessor.readFrame(tex, pixels)), {
            cameraModel: this._cameraModel,
            cameraSource: this,
            cameraToDevice: this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform
        });
    }
    uploadGL() {
    // No-op as already uploaded
    }
}







var $f2ea8a8055b5cf7a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $f2ea8a8055b5cf7a$var$_videoSingleton = document.createElement("video");
$f2ea8a8055b5cf7a$var$_videoSingleton.setAttribute("playsinline", "");
$f2ea8a8055b5cf7a$var$_videoSingleton.setAttribute("webkit-playsinline", "");
if ((0, $e926f8f1245f24de$export$4882ae973e0491e).videoElementInDOM) {
    $f2ea8a8055b5cf7a$var$_videoSingleton.style.width = "0px";
    $f2ea8a8055b5cf7a$var$_videoSingleton.style.height = "0px";
    document.body.appendChild($f2ea8a8055b5cf7a$var$_videoSingleton);
}
class $f2ea8a8055b5cf7a$export$9a93ce53f488cb2e extends (0, $23fd8c5744e6b817$export$bbfb48c500076b66) {
    constructor(_impl, pipeline, _deviceId){
        super($f2ea8a8055b5cf7a$var$_videoSingleton, pipeline);
        this._impl = _impl;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
    }
    destroy() {
        (0, $3f7c6300f8a4fe70$export$55d101622faac174)(this._impl);
        super.destroy();
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        super.pause();
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        super.start();
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $f2ea8a8055b5cf7a$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $f2ea8a8055b5cf7a$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID && this._deviceId !== $f2ea8a8055b5cf7a$export$9a93ce53f488cb2e.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else {
                facingMode = this._deviceId === $f2ea8a8055b5cf7a$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID ? "environment" : "user";
                if ((0, $e926f8f1245f24de$export$4882ae973e0491e).ios164CameraSelection) {
                    if (!this._explicitEnvironmentCameraId || !this._explicitUserCameraId) {
                        const stream = yield navigator.mediaDevices.getUserMedia({
                            audio: false,
                            video: {
                                facingMode: facingMode
                            }
                        });
                        let tracks = stream.getTracks();
                        tracks.forEach((t)=>t.stop());
                        let devices = yield navigator.mediaDevices.enumerateDevices();
                        devices = devices.filter((val)=>val.kind === "videoinput");
                        if (devices.length >= 2) {
                            this._explicitUserCameraId = devices[0].deviceId;
                            this._explicitEnvironmentCameraId = devices[1].deviceId;
                        }
                    }
                    deviceId = facingMode === "environment" ? this._explicitEnvironmentCameraId : this._explicitUserCameraId;
                }
            }
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $e926f8f1245f24de$export$4882ae973e0491e).videoWidth,
                    height: (0, $e926f8f1245f24de$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $e926f8f1245f24de$export$4882ae973e0491e).requestHighFrameRate ? 60 : undefined,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $7e50675ff5e3df75$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(allowRead) {
        this._cameraToScreenRotation = (0, $0a666de0430682ad$export$83fad53f837eba8e)(false);
        super.getFrame(allowRead);
    }
    _getUserMedia() {
        return $f2ea8a8055b5cf7a$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $f2ea8a8055b5cf7a$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                }
                if (!(this._video instanceof HTMLVideoElement)) return;
                this._video.src = "";
                this._video.loop = false;
                this._video.muted = true;
                this._video.srcObject = this._currentStream;
                this._video.play();
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        this._deviceOrientationListener = (ev)=>{
            let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        };
        window.addEventListener("deviceorientation", this._deviceOrientationListener);
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
        if (this._deviceOrientationListener) window.removeEventListener("deviceorientation", this._deviceOrientationListener);
    }
}
$f2ea8a8055b5cf7a$export$9a93ce53f488cb2e.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$f2ea8a8055b5cf7a$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";


var $04ee798a268f0e8c$exports = {};

$parcel$export($04ee798a268f0e8c$exports, "ImageBitmapCameraSource", function () { return $04ee798a268f0e8c$export$26291a750254acd7; });







var $04ee798a268f0e8c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $04ee798a268f0e8c$export$26291a750254acd7 extends (0, $6b0cfaf8deebc493$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline, _deviceId){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._isPaused = true;
        this._isUserFacing = false;
        this._hadFrames = false;
        this._canvas = new OffscreenCanvas(640, 480);
        this._context = this._canvas.getContext("2d");
        this._lastFrameTime = -1;
        this._video = document.createElement("video");
        this._cameraToDeviceTransform = (0, $2edf3b5f20103352$exports).create();
        this._cameraToDeviceTransformUserFacing = (0, $2edf3b5f20103352$exports).create();
        this._cameraModel = new Float32Array([
            300,
            300,
            160,
            120,
            0,
            0
        ]);
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
        (0, $7e50675ff5e3df75$export$454156e929b28fe7)("Using ImageBitmap camera source");
        (0, $2edf3b5f20103352$exports).fromScaling(this._cameraToDeviceTransformUserFacing, [
            -1,
            1,
            -1
        ]);
        this._video.muted = true;
        this._video.setAttribute("playsinline", "");
        this._video.setAttribute("webkit-playsinline", "");
        if ((0, $e926f8f1245f24de$export$4882ae973e0491e).videoElementInDOM) {
            this._video.style.width = "0px";
            this._video.style.height = "0px";
            document.body.appendChild(this._video);
        }
        this._video.addEventListener("loadedmetadata", ()=>{
            this._hadFrames = true;
        });
    }
    destroy() {
        this.pause();
        (0, $3f7c6300f8a4fe70$export$55d101622faac174)(this._impl);
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        this._isPaused = true;
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        var _a;
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
        this._isPaused = false;
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $04ee798a268f0e8c$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $04ee798a268f0e8c$export$26291a750254acd7.DEFAULT_DEVICE_ID && this._deviceId !== $04ee798a268f0e8c$export$26291a750254acd7.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else facingMode = this._deviceId === $04ee798a268f0e8c$export$26291a750254acd7.DEFAULT_DEVICE_ID ? "environment" : "user";
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $e926f8f1245f24de$export$4882ae973e0491e).videoWidth,
                    height: (0, $e926f8f1245f24de$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $e926f8f1245f24de$export$4882ae973e0491e).requestHighFrameRate ? 60 : undefined,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $7e50675ff5e3df75$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(currentlyProcessing) {
        var _a, _b;
        if (!this._context) return;
        if (!this._hadFrames) return;
        if (currentlyProcessing) return;
        let currentTime = performance.now();
        if (currentTime < this._lastFrameTime + 25) return;
        this._lastFrameTime = currentTime;
        if (this._canvas.width !== this._video.videoWidth) this._canvas.width = this._video.videoWidth;
        if (this._canvas.height !== this._video.videoHeight) this._canvas.height = this._video.videoHeight;
        this._context.drawImage(this._video, 0, 0);
        const imageBitmap = this._canvas.transferToImageBitmap();
        let rotation = (0, $0a666de0430682ad$export$83fad53f837eba8e)(false);
        let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let focalLength = 300.0 * (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth / 320.0;
        this._cameraModel[0] = focalLength;
        this._cameraModel[1] = focalLength;
        this._cameraModel[2] = (0, $e926f8f1245f24de$export$4882ae973e0491e).dataWidth * 0.5;
        this._cameraModel[3] = (0, $e926f8f1245f24de$export$4882ae973e0491e).dataHeight * 0.5;
        let token = pipeline.registerToken({
            dataWidth: this._canvas.width,
            dataHeight: this._canvas.height,
            texture: undefined,
            userFacing: this._isUserFacing,
            cameraSource: this,
            cameraModel: this._cameraModel.slice(),
            cameraToDevice: this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform
        });
        (_b = (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline)) === null || _a === void 0 ? void 0 : _a.sendImageBitmapToWorker) === null || _b === void 0 || _b.call(_a, imageBitmap, rotation, this._isUserFacing, token, this._cameraModel, this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform);
        return;
    }
    _getUserMedia() {
        return $04ee798a268f0e8c$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $04ee798a268f0e8c$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                }
                this._video.src = "";
                this._video.loop = false;
                this._video.muted = true;
                this._video.srcObject = this._currentStream;
                this._video.play();
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        window.addEventListener("deviceorientation", (ev)=>{
            let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        });
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
    }
    uploadGL(info) {
        const pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        const gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!info || info.texture || !info.frame || !pipeline || !gl) return;
        let texture = pipeline.getVideoTexture();
        if (!texture) return;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, info.frame);
        gl.bindTexture(gl.TEXTURE_2D, null);
        info.texture = texture;
        info.frame.close();
        delete info.frame;
    }
}
$04ee798a268f0e8c$export$26291a750254acd7.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$04ee798a268f0e8c$export$26291a750254acd7.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";



var $14b8b13107cd351a$exports = {};

$parcel$export($14b8b13107cd351a$exports, "MSTPCameraSource", function () { return $14b8b13107cd351a$export$e29bc47e63d4ca88; });






var $14b8b13107cd351a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $14b8b13107cd351a$export$e29bc47e63d4ca88 extends (0, $6b0cfaf8deebc493$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline, _deviceId){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._isPaused = true;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $e926f8f1245f24de$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
        (0, $7e50675ff5e3df75$export$454156e929b28fe7)("Using MSTP camera source");
    }
    destroy() {
        this.pause();
        (0, $3f7c6300f8a4fe70$export$55d101622faac174)(this._impl);
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        this._isPaused = true;
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        var _a;
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
        this._isPaused = false;
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $14b8b13107cd351a$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $14b8b13107cd351a$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID && this._deviceId !== $14b8b13107cd351a$export$e29bc47e63d4ca88.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else facingMode = this._deviceId === $14b8b13107cd351a$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID ? "environment" : "user";
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $e926f8f1245f24de$export$4882ae973e0491e).videoWidth,
                    height: (0, $e926f8f1245f24de$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $e926f8f1245f24de$export$4882ae973e0491e).requestHighFrameRate ? 60 : 30,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $7e50675ff5e3df75$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(allowRead) {
        var _a, _b;
        let rotation = (0, $0a666de0430682ad$export$83fad53f837eba8e)(false);
        if (rotation != this._cameraToScreenRotation) {
            (_b = (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline)) === null || _a === void 0 ? void 0 : _a.sendCameraToScreenRotationToWorker) === null || _b === void 0 || _b.call(_a, rotation);
            this._cameraToScreenRotation = rotation;
        }
        return;
    }
    _getUserMedia() {
        return $14b8b13107cd351a$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $14b8b13107cd351a$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) {
                        this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                        let processor = new MediaStreamTrackProcessor({
                            track: videoTracks[0]
                        });
                        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
                        if (p) p.sendCameraStreamToWorker(this._impl, processor.readable, this._isUserFacing);
                    }
                }
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        window.addEventListener("deviceorientation", (ev)=>{
            let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        });
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
    }
    uploadGL(info) {
        const pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        const gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!info || info.texture || !info.frame || !pipeline || !gl) return;
        let texture = pipeline.getVideoTexture();
        if (!texture) return;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, info.frame);
        gl.bindTexture(gl.TEXTURE_2D, null);
        info.texture = texture;
        info.frame.close();
        delete info.frame;
    }
}
$14b8b13107cd351a$export$e29bc47e63d4ca88.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$14b8b13107cd351a$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";



let $3f7c6300f8a4fe70$var$latest = 1;
let $3f7c6300f8a4fe70$var$byId = new Map();
function $3f7c6300f8a4fe70$export$1c7b58c7f8b1da4() {
    return $3f7c6300f8a4fe70$var$latest++;
}
function $3f7c6300f8a4fe70$export$9c2853b8b7906172(id, c) {
    $3f7c6300f8a4fe70$var$byId.set(id, c);
}
function $3f7c6300f8a4fe70$export$cf42922f9ae76ed1(id) {
    return $3f7c6300f8a4fe70$var$byId.get(id);
}
function $3f7c6300f8a4fe70$export$55d101622faac174(id) {
    $3f7c6300f8a4fe70$var$byId.delete(id);
}
function $3f7c6300f8a4fe70$export$3612a413b5e57058(p, deviceId) {
    let ret = $3f7c6300f8a4fe70$export$1c7b58c7f8b1da4();
    if ((0, $e926f8f1245f24de$export$4882ae973e0491e).preferMediaStreamTrackProcessorCamera && "MediaStreamTrackProcessor" in window && "MediaStreamTrackGenerator" in window) $3f7c6300f8a4fe70$export$9c2853b8b7906172(ret, new (0, $14b8b13107cd351a$exports.MSTPCameraSource)(ret, p, deviceId));
    else if ((0, $e926f8f1245f24de$export$4882ae973e0491e).preferImageBitmapCamera && typeof OffscreenCanvas !== "undefined") $3f7c6300f8a4fe70$export$9c2853b8b7906172(ret, new (0, $04ee798a268f0e8c$exports.ImageBitmapCameraSource)(ret, p, deviceId));
    else $3f7c6300f8a4fe70$export$9c2853b8b7906172(ret, new (0, $f2ea8a8055b5cf7a$exports.CameraSource)(ret, p, deviceId));
    (0, $7e50675ff5e3df75$export$454156e929b28fe7)("camera_source_t initialized");
    return ret;
}



class $c64d17b0a80fec7f$export$2a06d804567c3ad8 {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._uvbo) this._gl.deleteBuffer(this._uvbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._uvbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateUVBO(face, gl) {
        if (!this._uvbo) this._uvbo = gl.createBuffer();
        if (!this._uvbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._uvbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._uvbo;
    }
    draw(matrix, tracker, indx) {
        var _a;
        const o = tracker.getPreviewMesh(indx);
        const image = (_a = tracker.getTargetInfo(indx).preview) === null || _a === void 0 ? void 0 : _a.image;
        if (!o || !image) return;
        if (!image.complete) return;
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(o.vertices, gl);
        let n = this._generateUVBO(o.uvs, gl);
        let i = this._generateIBO(o.indices, gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, $c64d17b0a80fec7f$var$loadTexture(gl, image));
        gl.uniform1i(shader.unif_skinSampler, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, n);
        gl.vertexAttribPointer(shader.attr_textureCoord, 2, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(shader.attr_textureCoord);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, o.indices.length, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_textureCoord);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $c64d17b0a80fec7f$var$vertexShaderSrc);
        let fragmentShader = (0, $7333038afa66965a$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $c64d17b0a80fec7f$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $7333038afa66965a$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location mattrix");
        let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
        if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            unif_skinSampler: unif_skinSampler,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_textureCoord: gl.getAttribLocation(prog, "textureCoord")
        };
        return this._shader;
    }
}
const $c64d17b0a80fec7f$var$texturesByElement = new Map();
function $c64d17b0a80fec7f$var$loadTexture(gl, elm) {
    let existing = $c64d17b0a80fec7f$var$texturesByElement.get(elm);
    if (existing) return existing;
    existing = gl.createTexture() || undefined;
    if (!existing) throw new Error("Unable to create texture");
    $c64d17b0a80fec7f$var$texturesByElement.set(elm, existing);
    gl.bindTexture(gl.TEXTURE_2D, existing);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    // Because images have to be download over the internet
    // they might take a moment until they are ready.
    // Until then put a single pixel in the texture so we can
    // use it immediately. When the image has finished downloading
    // we'll update the texture with the contents of the image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, elm);
    elm.addEventListener("load", ()=>{
        if (!existing) return;
        gl.bindTexture(gl.TEXTURE_2D, existing);
        const level = 0;
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, elm);
    });
    return existing;
}
let $c64d17b0a80fec7f$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
attribute vec4 position;
attribute vec2 textureCoord;

varying highp vec2 vTextureCoord;

void main()
{
    gl_Position = matrix * position;
    vTextureCoord = textureCoord;
}`;
let $c64d17b0a80fec7f$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
uniform sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2D(skinSampler, vTextureCoord);
}`;


let $8115c34601272f2c$var$byId = new Map();
let $8115c34601272f2c$var$identity = (0, $2edf3b5f20103352$exports).create();
class $8115c34601272f2c$export$abd47b564b6c9ce2 {
    constructor(_client, _impl, _mgr){
        this._client = _client;
        this._impl = _impl;
        this._mgr = _mgr;
        this.pendingMessages = [];
        this.cameraTokens = new Map();
        this.nextCameraToken = 1;
        this.tokensInFlight = 0;
        this.videoTextures = [];
        this.cameraPixelArrays = [];
        this._sequenceRecordDeviceAttitudeMatrices = true;
        this._sequenceRecorderFirstCameraToken = 0;
        this.onGLContextReset = new (0, $e9bc282abf4ce8a0$export$d61e24a684f9e51)();
    }
    static create(client, mgr) {
        let ret = client.pipeline_create();
        $8115c34601272f2c$var$byId.set(ret, new $8115c34601272f2c$export$abd47b564b6c9ce2(client, ret, mgr));
        return ret;
    }
    static get(p) {
        return $8115c34601272f2c$var$byId.get(p);
    }
    frameUpdate(client) {
        for (let msg of this.pendingMessages){
            client.processMessages(msg);
            this._mgr.postOutgoingMessage({
                t: "buf",
                p: this._impl,
                d: msg
            }, [
                msg
            ]);
        }
        this.pendingMessages = [];
        this.cleanOldFrames();
    }
    cleanOldFrames() {
        var _a, _b;
        let currentToken = this._client.pipeline_camera_frame_user_data(this._impl);
        if (!currentToken) return;
        for (let t of this.cameraTokens)if (t[0] < currentToken) {
            if (t[1].texture) this.videoTextures.push(t[1].texture);
            (_b = (_a = t[1].frame) === null || _a === void 0 ? void 0 : _a.close) === null || _b === void 0 || _b.call(_a);
            this.cameraTokens.delete(t[0]);
        }
    }
    cameraTokenReturn(msg) {
        if (this._sequenceRecorder && this._sequenceRecordDeviceAttitudeMatrices && msg.token >= this._sequenceRecorderFirstCameraToken) {
            let info = this.cameraTokens.get(msg.token);
            if (info) {
                if (msg.att) this._sequenceRecorder.appendAttitudeMatrix(msg.att);
                info.data = msg.d;
                this._sequenceRecorder.appendCameraFrame(info);
            }
        }
        this.cameraPixelArrays.push(msg.d);
        this.tokensInFlight--;
    }
    sequenceRecordStart(expectedFrames) {
        if (!this._sequenceRecorder) this._sequenceRecorder = new (0, $8daf7012fef9fdbd$export$a9d7f366c6e802ee)(expectedFrames);
        this._sequenceRecorder.start();
        this._sequenceRecorderFirstCameraToken = this.nextCameraToken;
    }
    sequenceRecordStop() {
        var _a;
        (_a = this._sequenceRecorder) === null || _a === void 0 || _a.stop();
    }
    sequenceRecordData() {
        var _a;
        return ((_a = this._sequenceRecorder) === null || _a === void 0 ? void 0 : _a.data()) || new Uint8Array(0);
    }
    sequenceRecordClear() {
        delete this._sequenceRecorder;
    }
    sequenceRecordDeviceAttitudeMatrices(v) {
        this._sequenceRecordDeviceAttitudeMatrices = v;
    }
    getVideoTexture() {
        return this.videoTextures.pop();
    }
    destroy() {
        this._client.pipeline_destroy(this._impl);
        $8115c34601272f2c$var$byId.delete(this._impl);
    }
    getCurrentCameraInfo() {
        let currentToken = this._client.pipeline_camera_frame_user_data(this._impl);
        if (!currentToken) return undefined;
        return this.cameraTokens.get(currentToken);
    }
    cameraFrameDrawGL(screenWidth, screenHeight, mirror) {
        if (!this.glContext) return;
        let token = this.getCurrentCameraInfo();
        if (!token) return;
        if (!this._cameraDraw) this._cameraDraw = new (0, $3caa8b08e875393d$export$65ee3277a9a1612d)(this.glContext);
        this._cameraDraw.drawCameraFrame(screenWidth, screenHeight, token, mirror === true);
    }
    glContextLost() {
        if (this._cameraDraw) this._cameraDraw.dispose();
        if (this._faceDraw) this._faceDraw.dispose();
        if (this._imageTargetPreviewDraw) this._imageTargetPreviewDraw.dispose();
        if (this._faceProjectDraw) this._faceProjectDraw.dispose();
        delete this._cameraDraw;
        delete this._faceDraw;
        delete this._imageTargetPreviewDraw;
        delete this._faceProjectDraw;
        (0, $90357911555bd622$export$5998daa18e8ce5b0)();
        this.onGLContextReset.emit();
        for (let tex of this.videoTextures)if (this.glContext) this.glContext.deleteTexture(tex);
        this.videoTextures = [];
        for (let info of this.cameraTokens){
            if (this.glContext && info[1].texture) this.glContext.deleteTexture(info[1].texture);
            info[1].texture = undefined;
        }
        this.glContext = undefined;
    }
    glContextSet(gl, texturePool) {
        this.glContextLost();
        this.glContext = gl;
        texturePool = texturePool || [];
        for(let i = 0; i < 4; i++){
            let tex = texturePool[i] || gl.createTexture();
            if (tex) {
                gl.bindTexture(gl.TEXTURE_2D, tex);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                this.videoTextures.push(tex);
            }
        }
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    drawFace(projectionMatrix, cameraMatrix, targetMatrix, o) {
        if (!this.glContext) return;
        if (!this._faceDraw) this._faceDraw = new (0, $b8531391f3339736$export$884fb66b30975d12)(this.glContext);
        let mat = (0, $2edf3b5f20103352$exports).create();
        (0, $2edf3b5f20103352$exports).multiply(mat, projectionMatrix, cameraMatrix);
        (0, $2edf3b5f20103352$exports).multiply(mat, mat, targetMatrix);
        this._faceDraw.drawFace(mat, o);
    }
    drawImageTargetPreview(projectionMatrix, cameraMatrix, targetMatrix, indx, o) {
        if (!this.glContext) return;
        if (!this._imageTargetPreviewDraw) this._imageTargetPreviewDraw = new (0, $c64d17b0a80fec7f$export$2a06d804567c3ad8)(this.glContext);
        let mat = (0, $2edf3b5f20103352$exports).create();
        (0, $2edf3b5f20103352$exports).multiply(mat, projectionMatrix, cameraMatrix);
        (0, $2edf3b5f20103352$exports).multiply(mat, mat, targetMatrix);
        this._imageTargetPreviewDraw.draw(mat, o, indx);
    }
    drawFaceProject(matrix, vertices, uvMatrix, uvs, indices, texture) {
        if (!this.glContext) return;
        if (!this._faceProjectDraw) this._faceProjectDraw = new (0, $ba0b3e1b08f31345$export$626d5c7c1d8c587c)(this.glContext);
        this._faceProjectDraw.drawFace(matrix, vertices, uvMatrix, uvs, indices, texture);
    }
    cameraFrameTexture() {
        var _a;
        return (_a = this.getCurrentCameraInfo()) === null || _a === void 0 ? void 0 : _a.texture;
    }
    cameraFrameTextureMatrix(sw, sh, mirror) {
        let info = this.getCurrentCameraInfo();
        if (!info) return (0, $2edf3b5f20103352$exports).create();
        return (0, $3caa8b08e875393d$export$3da067886124f338)(info.dataWidth, info.dataHeight, sw, sh, info.uvTransform || $8115c34601272f2c$var$identity, mirror);
    }
    cameraFrameUserFacing() {
        var _a;
        return ((_a = this.getCurrentCameraInfo()) === null || _a === void 0 ? void 0 : _a.userFacing) || false;
    }
    cameraPoseWithAttitude(mirror) {
        let res = $8115c34601272f2c$export$9e7b3df2d144a412(this.getCurrentCameraInfo(), this._client.pipeline_camera_frame_camera_attitude(this._impl));
        if (mirror) {
            let scale = (0, $2edf3b5f20103352$exports).create();
            (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                -1,
                1,
                1
            ]);
            (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
            (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
        }
        (0, $2edf3b5f20103352$exports).invert(res, res);
        return res;
    }
    videoFrameFromWorker(msg) {
        let tokenId = this.nextCameraToken++;
        const cameraSource = (0, $3f7c6300f8a4fe70$export$cf42922f9ae76ed1)(msg.source);
        if (!cameraSource) return;
        this.cameraTokens.set(tokenId, {
            dataWidth: msg.w,
            dataHeight: msg.h,
            texture: undefined,
            frame: msg.d,
            userFacing: msg.userFacing,
            uvTransform: msg.uvTransform,
            cameraModel: msg.cameraModel,
            cameraToDevice: msg.cameraToDevice,
            cameraSource: cameraSource
        });
        this.cleanOldFrames();
    }
    imageBitmapFromWorker(msg) {
        let data = this.cameraTokens.get(msg.tokenId);
        if (!data) return;
        data.dataWidth = msg.dataWidth;
        data.dataHeight = msg.dataHeight;
        data.frame = msg.frame;
        data.userFacing = msg.userFacing;
        data.uvTransform = msg.uvTransform;
        this.tokensInFlight--;
        this.cleanOldFrames();
    }
    uploadGL() {
        var _a, _b;
        let info = this.getCurrentCameraInfo();
        (_b = (_a = info === null || info === void 0 ? void 0 : info.cameraSource) === null || _a === void 0 ? void 0 : _a.uploadGL) === null || _b === void 0 || _b.call(_a, info);
    }
    registerToken(info) {
        let tokenId = this.nextCameraToken++;
        this.cameraTokens.set(tokenId, info);
        this.tokensInFlight++;
        return tokenId;
    }
    processGL() {
        if (!this.glContext) {
            (0, $7e50675ff5e3df75$export$497c45d0bfe56de1)("no GL context for camera frames - please call pipeline_gl_context_set");
            return;
        }
        if (!this.currentCameraSource) return;
        if (this.tokensInFlight > 0) {
            this.currentCameraSource.getFrame(true);
            return;
        }
        this.currentCameraSource.getFrame(false);
    }
    motionAccelerometerSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendAccelerometer(timestamp, x, y, z);
        this._client.pipeline_motion_accelerometer_submit(this._impl, timestamp, x, y, z);
    }
    motionRotationRateSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendRotationRate(timestamp, x, y, z);
        this._client.pipeline_motion_rotation_rate_submit(this._impl, timestamp, x, y, z);
    }
    motionAttitudeSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendAttitude(timestamp, x, y, z);
        this._client.pipeline_motion_attitude_submit(this._impl, timestamp, x, y, z);
    }
    motionAttitudeMatrix(m) {
        // This doesn't need to be added to the sequence since that's done on frame update instead
        this._client.pipeline_motion_attitude_matrix_submit(this._impl, m);
    }
    sendCameraStreamToWorker(source, stream, userFacing) {
        let msg = {
            t: "streamC2S",
            p: this._impl,
            s: stream,
            userFacing: userFacing,
            source: source
        };
        this._mgr.postOutgoingMessage(msg, [
            msg.s
        ]);
    }
    sendCameraToScreenRotationToWorker(rot) {
        let msg = {
            p: this._impl,
            t: "cameraToScreenC2S",
            r: rot
        };
        this._mgr.postOutgoingMessage(msg, []);
    }
    sendImageBitmapToWorker(img, rot, userFacing, tokenId, cameraModel, cameraToDevice) {
        let msg = {
            p: this._impl,
            t: "imageBitmapC2S",
            i: img,
            r: rot,
            tokenId: tokenId,
            userFacing: userFacing,
            cameraModel: cameraModel,
            cameraToDevice: cameraToDevice
        };
        this._mgr.postOutgoingMessage(msg, [
            img
        ]);
    }
    sendDataToWorker(data, token, width, height, userFacing, cameraToDevice, cameraModel) {
        let msg = {
            d: data,
            p: this._impl,
            width: width,
            height: height,
            token: token,
            userFacing: userFacing,
            c2d: cameraToDevice,
            cm: cameraModel,
            t: "cameraFrameC2S"
        };
        this._mgr.postOutgoingMessage(msg, [
            data
        ]);
    }
}
function $8115c34601272f2c$export$9e7b3df2d144a412(info, inp) {
    let userFacing = false;
    userFacing = info ? info.userFacing : false;
    let mult = (0, $2edf3b5f20103352$exports).create();
    (0, $2edf3b5f20103352$exports).fromRotation(mult, (0, $0a666de0430682ad$export$83fad53f837eba8e)(userFacing) * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(mult, mult, inp);
    return mult;
}





const $cd4affe11a7fe13b$export$bc05bfbdf8a2824 = {
    0: [
        {
            mean: [
                0.235,
                0.2344,
                0.7305
            ],
            identity: [
                0.008,
                0.0087,
                0.0024,
                -0.0026,
                0.0006,
                -0.0022,
                0.0005,
                0.0033,
                0.0026,
                0.0017,
                -0.0055,
                -0.0008,
                0.0011,
                0.0059,
                0,
                0.0002,
                0.001,
                -0.001,
                -0.0044,
                -0.0011,
                -0.0001,
                0.0024,
                0.0019,
                -0.0009,
                0.0004,
                -0.0015,
                0,
                0.0038,
                0.0013,
                0.0003,
                0.002,
                -0.0021,
                0.0018,
                0.0023,
                0.0011,
                0.0012,
                -0.0011,
                -0.0017,
                0.0009,
                -0.0012,
                -0.0008,
                0.0007,
                -0.0017,
                0.0029,
                -0.0029,
                0.0008,
                -0.0027,
                0.0008,
                -0.0017,
                0.0004,
                0.0009,
                -0.001,
                -0.0003,
                0.0008,
                -0.0016,
                -0.0003,
                -0.0007,
                0.0016,
                -0.0009,
                0.0021,
                -0.0005,
                0.0011,
                -0.0024,
                -0.0001,
                0.0006,
                0.0001,
                -0.0026,
                -0.0004,
                -0.0003,
                -0.0009,
                0.0005,
                0.0003,
                -0.0008,
                -0.001,
                -0.0004,
                -0.0008,
                0.0022,
                -0.0014,
                -0.0001,
                -0.0023,
                0,
                -0.0018,
                0.0007,
                -0.0036,
                0.0017,
                0.0017,
                -0.0018,
                -0.0002,
                -0.0004,
                -0.0009,
                -0.0008,
                0.0003,
                0.0012,
                0.0009,
                -0.0004,
                -0.0016,
                0.0005,
                -0.0013,
                0.0011,
                0.0023,
                0.0029,
                0.0024,
                0.0017,
                -0.0027,
                -0.0004,
                -0.001,
                -0.0018,
                -0.0015,
                -0.001,
                0.001,
                -0.0013,
                -0.0001,
                -0.0002,
                0.0007,
                0.0003,
                0.0003,
                -0.0016,
                0.0009,
                -0.0021,
                0.0004,
                0.0014,
                0.002,
                -0.0007,
                -0.0004,
                0.0002,
                -0.0004,
                -0.0006,
                -0.0009,
                0.0015,
                0.0004,
                -0.0004,
                0.0005,
                -0.0015,
                0.0009,
                0.0003,
                0.0003,
                -0.0002,
                -0.0008,
                -0.0009,
                0.0023,
                0.0004,
                0.0001,
                -0.0004,
                -0.0001,
                0.0007,
                0.0002,
                0.001,
                0.0001,
                -0.0029,
                -0.0005
            ],
            expression: [
                0,
                0.0003,
                0.0052,
                -0.0007,
                -0.0051,
                -0.0103,
                0,
                0.0019,
                0.0027,
                -0.0054,
                0.0135,
                0.035,
                -0.0005,
                -0.0006,
                0.0025,
                -0.0045,
                -0.0557,
                -0.003,
                -0.0191,
                -0.1199,
                0.0548,
                -0.0036,
                -0.0682,
                -0.0167,
                0.0002,
                -0.0085,
                -0.0085,
                0.0044,
                0.0041,
                -0.0568,
                0.0044,
                0.179,
                0.0065,
                -0.0017,
                -0.1006,
                0.0036,
                -0.0267,
                -0.3279,
                0.0301,
                -0.0011,
                -0.0173,
                -0.001,
                0.0046,
                0.2808,
                0.0207,
                0.0162,
                0.238,
                -0.0225,
                0.0017,
                0.1041,
                0.0203,
                0.0005,
                0.0161,
                0.0031,
                -0.0436,
                0.6504,
                0.0873,
                -0.0099,
                0.1039,
                0.0048,
                -0.0254,
                0.2534,
                -0.0042,
                0.003,
                -0.0106,
                -0.0153,
                -0.0118,
                0.0252,
                0.0009,
                -0.0071,
                0.0099,
                0.007,
                -0.0724,
                0.0461,
                -0.0235,
                0.0833,
                0.004,
                0.0141,
                -0.0219,
                0.0132,
                -0.0042,
                -0.0179,
                0.0045,
                -0.0215,
                0.3638,
                0.0054,
                -0.0445
            ]
        },
        {
            mean: [
                0.2358,
                0.1466,
                0.7183
            ],
            identity: [
                0.0077,
                0.0093,
                0.0001,
                -0.0022,
                0,
                -0.0041,
                0.0005,
                0.0022,
                0.0028,
                0.0018,
                -0.0038,
                -0.0013,
                0.001,
                0.0044,
                -0.0002,
                0,
                0.0017,
                -0.0016,
                -0.0043,
                -0.0002,
                -0.0001,
                0.0023,
                0.0009,
                0.0005,
                -0.0007,
                -0.0004,
                -0.0017,
                0.003,
                0.0007,
                0.0006,
                0.0011,
                -0.0018,
                0.0005,
                0.0018,
                -0.0008,
                0.0004,
                -0.0023,
                -0.0006,
                -0.0003,
                -0.0015,
                -0.0014,
                -0.0001,
                -0.0018,
                0.0027,
                -0.0026,
                0.0003,
                -0.0031,
                0.0011,
                -0.0026,
                -0.0011,
                0.0012,
                -0.0013,
                -0.0002,
                0.0007,
                -0.0021,
                0.0021,
                0.0004,
                0.0012,
                -0.001,
                0.002,
                -0.0003,
                0.0002,
                -0.0026,
                -0.0003,
                0.001,
                0.0001,
                -0.0018,
                -0.001,
                0.0009,
                -0.0011,
                0.001,
                0.0004,
                -0.0008,
                -0.0007,
                -0.001,
                -0.0003,
                0.0007,
                -0.0005,
                -0.0006,
                -0.0019,
                -0.0005,
                -0.002,
                0.0007,
                -0.0027,
                0.0014,
                0.0013,
                0.0006,
                -0.0005,
                -0.0003,
                -0.0003,
                -0.001,
                0,
                0.0019,
                0.0001,
                0.0006,
                -0.0012,
                0.0004,
                -0.0009,
                0.0004,
                0.0025,
                0.0003,
                0.0024,
                0.0017,
                -0.0009,
                -0.0015,
                -0.0015,
                -0.001,
                -0.0023,
                -0.001,
                -0.0005,
                -0.0004,
                0.0008,
                0.0009,
                0.0007,
                0.0002,
                0.0007,
                -0.0009,
                0.0009,
                -0.0013,
                0.0001,
                0.0009,
                0.0002,
                0.0006,
                -0.0006,
                -0.0008,
                -0.0004,
                -0.0007,
                0.0008,
                0.0019,
                0.0003,
                0.0015,
                0.0002,
                -0.0015,
                -0.0003,
                0,
                0.0006,
                0.0003,
                0.0006,
                -0.0006,
                0.0002,
                0.0005,
                -0.0004,
                0.0012,
                -0.0004,
                0.0002,
                -0.0008,
                0.0006,
                -0.0004,
                0.0002,
                -0.0021
            ],
            expression: [
                -0.0034,
                0.0054,
                0.0069,
                0.004,
                0.0006,
                -0.0104,
                -0.0003,
                0.0036,
                0.0025,
                0.0065,
                0.0296,
                0.0208,
                -0.0009,
                0.0154,
                0.0029,
                -0.0167,
                0.0124,
                0.004,
                -0.0102,
                0.0351,
                0.028,
                -0.019,
                0.0146,
                -0.0035,
                -0.0023,
                -0.0069,
                -0.0051,
                -0.01,
                0.0262,
                -0.028,
                0.0112,
                0.082,
                0.023,
                -0.0019,
                -0.066,
                -0.0104,
                -0.0408,
                0.0164,
                0.0075,
                -0.0074,
                0.0367,
                0.0041,
                0.0517,
                -0.0207,
                0.0045,
                0.0291,
                -0.0672,
                -0.0129,
                0.0345,
                -0.1558,
                -0.0106,
                0.0037,
                -0.0437,
                -0.0021,
                0.0854,
                -0.1121,
                0.0187,
                0.0041,
                0.0072,
                0.0011,
                0.0193,
                -0.0143,
                -0.0119,
                0.005,
                -0.02,
                -0.0122,
                -0.008,
                0.0527,
                0.0036,
                -0.006,
                0.0222,
                0.007,
                -0.0429,
                0.046,
                -0.0046,
                0.0226,
                -0.0059,
                0.0202,
                -0.0173,
                0.0087,
                0,
                -0.0067,
                -0.0095,
                -0.0153,
                0.1506,
                -0.0017,
                0.0021
            ]
        }
    ],
    1: [
        {
            mean: [
                -0.2271,
                0.2323,
                0.7319
            ],
            identity: [
                -0.0084,
                0.0097,
                0.0018,
                0.0041,
                0.0002,
                -0.002,
                -0.0012,
                0.0036,
                0.0019,
                -0.0009,
                -0.0063,
                -0.001,
                -0.0003,
                0.0053,
                0.0006,
                0.0001,
                0.0005,
                -0.0015,
                0.0044,
                -0.0025,
                -0.0015,
                -0.002,
                0.0016,
                -0.0006,
                0.0002,
                -0.0013,
                0,
                -0.0022,
                0.0002,
                0.0002,
                -0.0025,
                -0.0014,
                0.0015,
                0.0008,
                0.0002,
                0.0012,
                0.0006,
                -0.0006,
                0.0017,
                0,
                0.0003,
                -0.0001,
                0.0024,
                0.0025,
                -0.0029,
                -0.0015,
                -0.0015,
                0.0001,
                0.0031,
                -0.0016,
                0.0007,
                0.0019,
                0.0006,
                0.002,
                0.0009,
                0.001,
                -0.0014,
                -0.002,
                -0.0015,
                0.0029,
                0.0001,
                0.0005,
                -0.0023,
                0.0008,
                -0.0011,
                0.0019,
                0.0017,
                -0.0003,
                -0.0011,
                -0.0003,
                0.0011,
                -0.0008,
                0.0019,
                -0.0022,
                0.0001,
                0.0015,
                0.0017,
                -0.0008,
                -0.0011,
                -0.0022,
                0.0003,
                0.0022,
                0.0006,
                -0.003,
                -0.0002,
                0,
                -0.0017,
                -0.0002,
                0,
                0.0001,
                0.0004,
                0.0012,
                0.0019,
                -0.0014,
                0.0004,
                -0.0017,
                -0.0012,
                -0.0011,
                0.0021,
                -0.0029,
                0.0026,
                0.0018,
                -0.0023,
                -0.0029,
                0.0001,
                0.0014,
                -0.0019,
                -0.0004,
                -0.0004,
                0.0023,
                -0.0016,
                0,
                -0.0009,
                0.0014,
                -0.0015,
                0.0015,
                -0.0016,
                -0.0011,
                -0.0022,
                0.0001,
                -0.0018,
                0.0027,
                -0.0013,
                0.0004,
                -0.0001,
                -0.0005,
                0.0011,
                -0.0002,
                0.0015,
                0.0005,
                -0.0009,
                -0.0001,
                0.0029,
                0.0006,
                0,
                -0.0003,
                0.0007,
                -0.0008,
                -0.0005,
                0.0025,
                0.0003,
                0.0002,
                -0.0008,
                -0.0001,
                0.0003,
                0,
                0.0014,
                0.0002,
                -0.0024,
                0.0001
            ],
            expression: [
                -0.0025,
                -0.0009,
                0.006,
                0.004,
                -0.0027,
                -0.0113,
                -0.0008,
                0.001,
                0.0031,
                -0.0016,
                0.0144,
                0.0382,
                -0.0003,
                -0.0005,
                0.0035,
                -0.0044,
                -0.0511,
                -0.0014,
                -0.0007,
                -0.1007,
                0.0582,
                -0.0006,
                -0.0606,
                -0.0165,
                0.0005,
                -0.0087,
                -0.0093,
                0.0036,
                0.0057,
                -0.0576,
                -0.0039,
                0.1488,
                0.0127,
                0.0016,
                -0.0666,
                -0.0009,
                -0.0153,
                0.3162,
                -0.0445,
                -0.0021,
                0.0023,
                0.0043,
                -0.0033,
                0.2382,
                0.0063,
                -0.0217,
                0.167,
                -0.039,
                0.0097,
                -0.1144,
                -0.0189,
                -0.0145,
                0.6831,
                0.0632,
                -0.0012,
                -0.1959,
                -0.0133,
                0.0004,
                0.1108,
                -0.0003,
                0.0062,
                0.2593,
                -0.0161,
                -0.0018,
                -0.0051,
                -0.012,
                0.0162,
                0.016,
                -0.0022,
                -0.0052,
                -0.0201,
                0.0101,
                0.0115,
                0.0365,
                -0.024,
                -0.0059,
                0.0188,
                -0.0336,
                0.0352,
                0.0224,
                -0.0229,
                0.0146,
                0.0086,
                -0.0273,
                -0.0032,
                0.0103,
                -0.0112
            ]
        },
        {
            mean: [
                -0.2288,
                0.1541,
                0.7202
            ],
            identity: [
                -0.0082,
                0.0101,
                0.0002,
                0.0036,
                -0.0007,
                -0.0037,
                -0.0008,
                0.0024,
                0.0022,
                -0.0013,
                -0.0045,
                -0.0013,
                -0.0006,
                0.0045,
                -0.0004,
                0.0004,
                0.0012,
                -0.0014,
                0.0042,
                -0.001,
                -0.0007,
                -0.0019,
                0.0003,
                -0.0002,
                0.0012,
                -0.0004,
                -0.0012,
                -0.0018,
                -0.0004,
                -0.0001,
                -0.0014,
                -0.0012,
                0.0001,
                0.0001,
                -0.0017,
                0.001,
                0.0015,
                -0.0001,
                0.0006,
                0.0001,
                0,
                -0.0006,
                0.0028,
                0.0021,
                -0.0025,
                -0.002,
                -0.0015,
                0.0007,
                0.0028,
                -0.0023,
                0.0009,
                0.0013,
                0.0001,
                0.0016,
                0.0012,
                0.0032,
                -0.0006,
                -0.0013,
                -0.0011,
                0.0021,
                0.0003,
                -0.0005,
                -0.0024,
                0.0004,
                -0.0004,
                0.0014,
                0.0015,
                -0.0008,
                -0.0003,
                0.0003,
                0.0017,
                -0.0006,
                0.002,
                -0.0018,
                -0.0003,
                0.0009,
                0.0001,
                0.0002,
                -0.0006,
                -0.0015,
                -0.0004,
                0.0022,
                0.0007,
                -0.0023,
                0,
                -0.0002,
                -0.0002,
                -0.0003,
                -0.0001,
                0.0006,
                -0.0002,
                0.0006,
                0.0022,
                -0.0003,
                0.0013,
                -0.0014,
                -0.0005,
                -0.0003,
                0.0013,
                -0.0027,
                0.0006,
                0.0025,
                -0.0023,
                -0.0008,
                -0.0013,
                0.0017,
                -0.0009,
                -0.0019,
                0.0001,
                0.0008,
                -0.0007,
                -0.0004,
                0,
                0.001,
                -0.001,
                0.0019,
                -0.0008,
                -0.0015,
                -0.0006,
                -0.0002,
                -0.0011,
                0.0008,
                0.0001,
                0.0009,
                -0.0008,
                -0.0004,
                0.0006,
                0.0007,
                0.0021,
                -0.0004,
                0.0007,
                -0.0005,
                0.0021,
                -0.0007,
                -0.0004,
                -0.0009,
                0.0008,
                0.0003,
                0.0001,
                0.0003,
                0.0001,
                0.0009,
                0.001,
                -0.0005,
                0.0005,
                -0.001,
                0.001,
                0.0004,
                -0.0005,
                -0.0012
            ],
            expression: [
                0.0008,
                0.0037,
                0.0078,
                -0.0004,
                0.0005,
                -0.012,
                -0.0002,
                -0.0046,
                0.0033,
                -0.0089,
                0.0295,
                0.0221,
                -0.0024,
                -0.0084,
                0.0013,
                0.0057,
                0.0125,
                0.0049,
                -0.0036,
                0.0373,
                0.0285,
                0.0115,
                0.0135,
                -0.0035,
                0.0048,
                0.0108,
                -0.0033,
                0.0106,
                0.0281,
                -0.0301,
                -0.0082,
                0.0803,
                0.0244,
                -0.0007,
                -0.0725,
                -0.0105,
                -0.0247,
                -0.0036,
                -0.0143,
                -0.0045,
                -0.029,
                0.0002,
                -0.0303,
                0.0093,
                -0.0021,
                -0.0196,
                -0.0754,
                -0.0211,
                0.0326,
                0.1246,
                0.006,
                -0.0804,
                -0.1499,
                0.0109,
                0.0182,
                -0.0029,
                -0.0014,
                -0.0035,
                0.0072,
                -0.0008,
                -0.0152,
                -0.0108,
                -0.0166,
                -0.0073,
                -0.0144,
                -0.0095,
                0.0101,
                0.047,
                -0.0018,
                -0.004,
                -0.0189,
                0.0027,
                0.0104,
                0.0298,
                -0.0042,
                -0.0096,
                0.0191,
                -0.0217,
                0.0228,
                0.0226,
                -0.0105,
                0.0047,
                -0.0048,
                -0.0172,
                0.0061,
                -0.0043,
                -0.0016
            ]
        }
    ],
    2: {
        mean: [
            0.5396,
            0.2028,
            0.2496
        ],
        identity: [
            0.0204,
            0.0146,
            -0.0182,
            -0.0052,
            0.0158,
            -0.0038,
            -0.0025,
            -0.0108,
            -0.006,
            0.0085,
            -0.0044,
            0.0029,
            0.0042,
            0.001,
            0.0095,
            0.0015,
            -0.0034,
            -0.0064,
            -0.0057,
            0.0007,
            0.0026,
            0.0007,
            0.0037,
            -0.0006,
            0.0037,
            0.0026,
            0.0024,
            0.0005,
            -0.0019,
            -0.0013,
            0.003,
            -0.0028,
            0.0018,
            -0.0009,
            0.002,
            -0.0047,
            0.004,
            -0.003,
            0.0031,
            -0.0027,
            -0.0026,
            -0.0017,
            0.0016,
            0.0014,
            -0.0004,
            0.0021,
            -0.002,
            0,
            0.0017,
            0.0007,
            -0.0004,
            -0.0007,
            -0.0018,
            -0.0009,
            0.0002,
            -0.0012,
            0.0001,
            -0.0005,
            -0.0011,
            0.0004,
            0.0002,
            0.0011,
            0.0001,
            0.0008,
            0.0017,
            -0.0013,
            0.0025,
            0.0017,
            0.001,
            0.0002,
            0.0003,
            0.0005,
            -0.0004,
            -0.0001,
            -0.0005,
            0.0007,
            -0.0022,
            -0.0029,
            0.0006,
            -0.0008,
            -0.0006,
            0.0006,
            -0.0005,
            0.0005,
            0.0013,
            0.0003,
            -0.0005,
            -0.003,
            0.0007,
            0.0002,
            0.0016,
            -0.0004,
            0,
            0,
            0.0004,
            0.0001,
            0.0014,
            0.0012,
            0.0001,
            0.0004,
            -0.0001,
            0.0008,
            0.0009,
            0.0004,
            -0.0004,
            0.0009,
            -0.0002,
            0.001,
            0.0009,
            0.0004,
            0.0001,
            0.0007,
            0.0007,
            0.001,
            -0.0017,
            -0.0008,
            0.0002,
            0.0017,
            -0.0003,
            -0.0001,
            0.0004,
            0.0005,
            0.0007,
            0.0005,
            -0.0001,
            -0.0006,
            -0.0001,
            0.0001,
            -0.0003,
            -0.0007,
            -0.0002,
            -0.0005,
            0,
            -0.0003,
            0.0003,
            0.0008,
            -0.0002,
            -0.0003,
            0.0005,
            0.0001,
            -0.0007,
            -0.001,
            -0.0002,
            0.0003,
            0.0004,
            -0.0001,
            0.0007,
            0,
            0.0004,
            0.0004
        ],
        expression: [
            0.0001,
            -0.0004,
            0.0001,
            0,
            0.0005,
            0.0002,
            0,
            0,
            0.0003,
            -0.0002,
            0.0003,
            0.0005,
            -0.0001,
            0.0002,
            0.0008,
            0.0001,
            -0.0002,
            -0.0005,
            -0.0003,
            0.0006,
            0.0005,
            0,
            0.0001,
            0.0002,
            0.0001,
            -0.0001,
            -0.0006,
            -0.0002,
            0.0005,
            0,
            -0.0004,
            0.0004,
            0.0016,
            0.0004,
            -0.0004,
            -0.0015,
            0,
            0.0001,
            0.0001,
            -0.0003,
            0.0003,
            0.0019,
            -0.0002,
            0.0007,
            0.0004,
            0.0004,
            -0.0008,
            -0.0015,
            0.0013,
            -0.0016,
            -0.0069,
            0.0004,
            -0.0006,
            -0.0019,
            0,
            -0.0001,
            0.0005,
            -0.0003,
            0.0002,
            0.0014,
            -0.0003,
            0.0006,
            0.0011,
            0.0004,
            -0.0003,
            -0.0032,
            -0.0006,
            0.0008,
            0.0025,
            -0.0003,
            0.0003,
            0.0015,
            -0.0001,
            0.0001,
            0.0003,
            -0.0001,
            0,
            0,
            -0.0003,
            0.0004,
            0.0019,
            0.0001,
            0,
            -0.0008,
            -0.0001,
            0.0001,
            0.0005
        ]
    },
    3: {
        mean: [
            -0.5464,
            0.2141,
            0.26
        ],
        identity: [
            -0.0207,
            0.0172,
            -0.0176,
            0.0068,
            0.0148,
            -0.0051,
            0.0042,
            -0.0101,
            -0.0058,
            -0.0087,
            -0.0059,
            0.0045,
            -0.0056,
            0.0017,
            0.0097,
            -0.0048,
            -0.004,
            -0.0044,
            0.0019,
            0.0002,
            0.0041,
            -0.0052,
            0.0041,
            0.0002,
            -0.0027,
            0.0006,
            0.002,
            -0.0027,
            -0.0033,
            -0.0006,
            -0.004,
            0.0009,
            -0.0012,
            -0.0001,
            -0.0026,
            0.0021,
            -0.003,
            -0.0025,
            0.0052,
            0.0025,
            0.0022,
            -0.0001,
            -0.0008,
            0.0013,
            0.001,
            0.0004,
            0.0018,
            0.0014,
            0.0006,
            -0.0005,
            -0.0015,
            -0.0039,
            0.0014,
            -0.0001,
            0.0008,
            -0.0002,
            0.0006,
            -0.0005,
            -0.0038,
            -0.0012,
            -0.0018,
            -0.0003,
            0.001,
            0.0009,
            0.0012,
            0.0024,
            -0.0024,
            -0.0007,
            -0.0016,
            -0.0016,
            0.0003,
            -0.001,
            -0.0014,
            -0.0014,
            0.001,
            -0.0003,
            -0.0007,
            -0.0012,
            0.0003,
            0.0006,
            0.0003,
            -0.0005,
            0.0003,
            0.0012,
            0.0006,
            -0.0008,
            0.0004,
            0.0004,
            0.0008,
            -0.0002,
            -0.0014,
            0.0003,
            0,
            0.0023,
            -0.0003,
            -0.0012,
            -0.0013,
            0.0011,
            -0.0002,
            -0.0014,
            -0.0001,
            0.0014,
            0,
            0.0003,
            0.0003,
            -0.0008,
            -0.0005,
            -0.0007,
            -0.0007,
            -0.0002,
            0.0003,
            0.0005,
            0.0002,
            -0.0001,
            0.0011,
            -0.0014,
            0.0001,
            -0.0015,
            -0.0001,
            -0.0003,
            0,
            -0.001,
            -0.0001,
            -0.0008,
            0.0008,
            -0.0008,
            -0.0002,
            -0.0011,
            -0.0003,
            -0.0004,
            0.0001,
            -0.0002,
            0.0003,
            -0.0007,
            0,
            0.0003,
            0.0001,
            -0.0008,
            0.0005,
            0.0001,
            0.0004,
            0.0014,
            -0.0006,
            -0.001,
            -0.0003,
            -0.0002,
            0.0001,
            -0.0001,
            -0.0001,
            0.0007
        ],
        expression: [
            -0.0003,
            -0.0001,
            0.0006,
            0.0004,
            0,
            -0.0007,
            0,
            -0.0003,
            -0.0002,
            -0.0004,
            0.0012,
            0.0008,
            0.0001,
            -0.0005,
            -0.0007,
            -0.0004,
            0,
            0.0001,
            -0.0004,
            0.0017,
            0.0007,
            0,
            0.0001,
            0.0003,
            0,
            0.0004,
            0.0004,
            0.0005,
            0.0001,
            -0.001,
            -0.0007,
            0.0022,
            0.0026,
            0.0005,
            -0.0024,
            -0.0023,
            0,
            0.0001,
            0.0003,
            0,
            -0.0013,
            -0.0015,
            0.0006,
            0.0014,
            0.0008,
            -0.0002,
            -0.0025,
            -0.0023,
            -0.0003,
            0.0049,
            0.006,
            -0.0002,
            -0.0007,
            -0.0002,
            0,
            -0.0019,
            -0.0018,
            -0.0002,
            0.0017,
            0.0017,
            0.0003,
            0.0015,
            0.0007,
            0.0001,
            -0.0023,
            -0.0036,
            0.0002,
            0.0023,
            0.0017,
            0,
            -0.0005,
            -0.0003,
            -0.0003,
            0.0004,
            0.0002,
            -0.0001,
            -0.0003,
            -0.0005,
            0.0001,
            0.0018,
            0.0025,
            0.0001,
            -0.0006,
            -0.0011,
            0,
            0.0001,
            0.0001
        ]
    },
    4: {
        mean: [
            0.0018,
            0.1864,
            0.853
        ],
        identity: [
            -0.0011,
            0.0134,
            0.0085,
            0.0009,
            -0.0025,
            -0.0007,
            -0.0003,
            0.0033,
            0.0004,
            -0.0005,
            -0.0047,
            -0.002,
            0.0007,
            0.0026,
            -0.0069,
            -0.0001,
            0.0036,
            0.0072,
            0.0005,
            -0.0008,
            -0.0047,
            0.0004,
            -0.0008,
            -0.001,
            0,
            0.0002,
            -0.0036,
            -0.0002,
            -0.001,
            -0.0048,
            -0.0001,
            0.0018,
            0.0044,
            -0.0007,
            -0.0002,
            0.0043,
            0.0003,
            0.002,
            -0.0031,
            0,
            -0.0007,
            0.0013,
            0,
            0.0037,
            0.0033,
            -0.0016,
            -0.0012,
            0.002,
            -0.0001,
            -0.0027,
            0.0051,
            0.0005,
            0.0008,
            0.0007,
            -0.0017,
            0.0054,
            0.0023,
            -0.0003,
            0.0032,
            0.0001,
            0,
            0.0007,
            -0.0005,
            -0.0011,
            0.0002,
            0.0008,
            0,
            -0.0033,
            -0.0008,
            -0.0007,
            0.0007,
            0.0033,
            0.0005,
            -0.0003,
            0.0029,
            -0.0001,
            -0.0024,
            -0.0011,
            -0.002,
            -0.0015,
            -0.0019,
            0.0002,
            0.0007,
            0.0031,
            0.0006,
            0.0012,
            0,
            0,
            -0.0021,
            0,
            -0.0009,
            -0.0011,
            -0.0011,
            -0.0002,
            0.0015,
            0.001,
            0.0013,
            0.0008,
            0.001,
            -0.0003,
            0.0009,
            0.0027,
            -0.0002,
            -0.0011,
            -0.0011,
            0.0006,
            0.0007,
            0.0002,
            0.0001,
            -0.0005,
            -0.0022,
            0.0011,
            -0.0014,
            0.0009,
            0.0003,
            0.0002,
            0,
            -0.0006,
            -0.0004,
            -0.0011,
            -0.0007,
            0.001,
            -0.0012,
            0.0006,
            -0.0012,
            -0.0015,
            0.0003,
            -0.0009,
            -0.0013,
            -0.0013,
            0.0007,
            0.001,
            -0.0011,
            -0.0013,
            0.0015,
            0.0004,
            0.0001,
            0.0004,
            -0.0001,
            -0.0016,
            -0.0016,
            0.0009,
            -0.0007,
            -0.0024,
            0.0005,
            -0.0001,
            -0.0017,
            -0.0002,
            0.0003,
            -0.0009
        ],
        expression: [
            -0.0017,
            0.0019,
            0.0097,
            0.003,
            -0.0103,
            -0.0093,
            0.0009,
            0.0006,
            0.0023,
            -0.0017,
            -0.0204,
            0.0376,
            0.0033,
            -0.0034,
            0.0033,
            -0.0026,
            -0.0322,
            0.0396,
            -0.0032,
            -0.0947,
            0.0942,
            -0.0007,
            -0.0175,
            0.0266,
            -0.001,
            -0.0006,
            0.0016,
            0.0025,
            0.0157,
            -0.0142,
            -0.0022,
            0.037,
            0.015,
            0.0021,
            -0.0102,
            -0.0107,
            0.0036,
            0.0055,
            -0.0051,
            0.0021,
            0.0003,
            -0.0003,
            0.0004,
            -0.0177,
            0.0074,
            -0.0006,
            -0.0357,
            0.0149,
            -0.0066,
            0.0009,
            0.0013,
            -0.0031,
            0.0016,
            0.0095,
            0.002,
            0.0052,
            0.0035,
            -0.0003,
            0.0053,
            -0.0082,
            0.002,
            0.0022,
            -0.0071,
            -0.0011,
            0.0005,
            0.0055,
            0.0011,
            0.0003,
            -0.0126,
            -0.0004,
            0.0003,
            -0.0023,
            -0.0015,
            0.0059,
            0.0063,
            -0.0042,
            -0.0023,
            0.0055,
            0.0019,
            0.0017,
            -0.0075,
            0.0006,
            -0.0008,
            0.0018,
            0.0012,
            0.0012,
            -0.0005
        ]
    },
    5: {
        mean: [
            -0.002,
            -0.0469,
            1.0039
        ],
        identity: [
            -0.0017,
            0.0018,
            0.0156,
            0.0006,
            -0.0038,
            0.0005,
            0.0004,
            0.0013,
            0.002,
            -0.0004,
            -0.0015,
            -0.0051,
            0.0005,
            -0.0007,
            -0.0055,
            -0.0001,
            -0.0009,
            0.008,
            -0.0002,
            0.0036,
            -0.0053,
            0.0004,
            -0.0026,
            -0.0016,
            0.0007,
            0.0009,
            -0.009,
            -0.0003,
            0.0007,
            -0.0084,
            0.0015,
            0.0021,
            0.0032,
            -0.0015,
            0.0018,
            0.0046,
            -0.0003,
            -0.0004,
            -0.0001,
            0.0008,
            -0.0044,
            -0.0007,
            -0.0008,
            0.0007,
            0.0048,
            -0.0024,
            -0.0003,
            0.0024,
            0.0002,
            -0.0051,
            0.0058,
            -0.0006,
            0.0028,
            0.0018,
            -0.0021,
            0.0035,
            0.0057,
            0.0011,
            0.0065,
            0,
            -0.0002,
            0.0011,
            0.003,
            -0.0027,
            0.0008,
            0.0007,
            0.0003,
            -0.0039,
            -0.002,
            -0.0002,
            -0.0015,
            0.0034,
            0.0012,
            -0.0025,
            0.0024,
            -0.0002,
            0.0004,
            -0.0042,
            -0.0024,
            -0.001,
            -0.0023,
            0.0016,
            -0.0007,
            0.0039,
            0.0001,
            -0.0005,
            0.0018,
            0.0003,
            -0.0002,
            -0.0009,
            -0.0015,
            0.0003,
            -0.0007,
            -0.0001,
            -0.0002,
            0.0023,
            0.0032,
            0.002,
            -0.0013,
            0.0013,
            -0.0038,
            0.0045,
            0.0001,
            -0.0031,
            0.0001,
            0.0019,
            -0.0001,
            0.0016,
            0.0013,
            0,
            -0.002,
            0.0023,
            0.0002,
            0.0011,
            0.0018,
            -0.0024,
            0.0006,
            -0.0017,
            0.002,
            -0.0008,
            -0.0021,
            0.0007,
            0.0011,
            0.0008,
            0.0004,
            -0.001,
            0.0012,
            0.0002,
            -0.0006,
            -0.0027,
            -0.0005,
            0.001,
            -0.0009,
            0.0001,
            -0.0001,
            0.0008,
            -0.0011,
            0.0022,
            -0.001,
            -0.0005,
            -0.0011,
            0.0016,
            -0.0015,
            0.0008,
            -0.0003,
            0.0009,
            0.0013,
            -0.0007,
            -0.0007,
            -0.0002
        ],
        expression: [
            -0.0018,
            -0.0168,
            0.0088,
            0.0389,
            0.1026,
            0.0414,
            0.2201,
            -0.0262,
            -0.0016,
            -0.0017,
            0.0612,
            -0.0298,
            -0.0323,
            0.0093,
            0.0013,
            -0.005,
            0.2207,
            0.1315,
            -0.0004,
            0.0858,
            -0.0303,
            -0.0133,
            0.015,
            -0.008,
            0.1454,
            0.0114,
            0.0177,
            -0.0077,
            0.1022,
            0.0356,
            -0.0023,
            0.1088,
            0.0232,
            0.003,
            -0.0706,
            0.0347,
            -0.0001,
            0.004,
            -0.0011,
            0.0397,
            -0.0096,
            -0.0033,
            0.0029,
            -0.01,
            -0.0083,
            -0.0006,
            -0.0135,
            0.0016,
            -0.0087,
            -0.0019,
            0.0022,
            -0.004,
            -0.0087,
            0.0105,
            0.0008,
            -0.005,
            0.0069,
            0.0028,
            0.0409,
            -0.0391,
            0.003,
            0.0103,
            0.0051,
            0.0026,
            0.0776,
            -0.0083,
            -0.0062,
            -0.0567,
            0.0268,
            0.0175,
            0.0017,
            0.0156,
            -0.0043,
            0.0299,
            -0.0395,
            -0.0015,
            0.0051,
            -0.0148,
            0.0125,
            0.0035,
            0.0603,
            0.0109,
            -0.0645,
            -0.0257,
            0.002,
            0.0006,
            -0.0008
        ]
    },
    6: {
        mean: [
            -0.0006,
            -0.1542,
            0.8789
        ],
        identity: [
            -0.0007,
            -0.0032,
            0.01,
            0,
            -0.0027,
            0.0031,
            0.0006,
            0.0005,
            -0.0006,
            -0.0003,
            0.0013,
            -0.0049,
            -0.0002,
            -0.002,
            -0.0046,
            0.0008,
            -0.0011,
            0.0054,
            0.0002,
            0.0043,
            -0.0027,
            0.0003,
            -0.0022,
            -0.0019,
            0.0008,
            0.0032,
            -0.0069,
            0,
            0.0004,
            -0.0071,
            0.0016,
            0.0027,
            0.0039,
            -0.0017,
            0.0009,
            0.0031,
            -0.0001,
            -0.0005,
            -0.0004,
            0.0007,
            -0.0026,
            -0.0012,
            -0.0005,
            0.0006,
            0.0002,
            -0.0014,
            -0.0013,
            0.0019,
            -0.0002,
            -0.0053,
            0.0031,
            -0.0006,
            0.0016,
            0.0023,
            -0.0013,
            0.0021,
            0.0029,
            0.0008,
            0.0052,
            0,
            0.0004,
            0,
            0.0037,
            -0.0026,
            0.0003,
            0.002,
            -0.0002,
            -0.0024,
            0.0004,
            -0.0004,
            -0.0012,
            0.0008,
            0.0007,
            -0.0023,
            0.0005,
            0,
            0.0014,
            -0.0022,
            -0.0016,
            0,
            -0.0012,
            0.0008,
            -0.0007,
            0.0014,
            -0.0006,
            -0.0012,
            -0.0003,
            0.0002,
            0.0012,
            -0.0003,
            -0.002,
            -0.0001,
            0.0001,
            -0.0002,
            -0.0016,
            0.0009,
            0.002,
            0.0019,
            0,
            0.0006,
            -0.0022,
            0.0016,
            0.0001,
            -0.0017,
            -0.0013,
            0.001,
            0.0009,
            -0.0001,
            0.0011,
            0.0003,
            -0.0007,
            0.0014,
            0.0008,
            0.0013,
            0.0011,
            -0.002,
            0,
            -0.0015,
            0.0014,
            0.001,
            -0.0015,
            0.0007,
            0.0003,
            0.001,
            -0.0001,
            0.0012,
            0.0007,
            0.0006,
            -0.0004,
            -0.0013,
            -0.0012,
            -0.0009,
            -0.0011,
            0.0002,
            -0.0005,
            0.0005,
            0.0004,
            0.0002,
            0.0001,
            0,
            0.0005,
            0.0005,
            -0.0014,
            0.0015,
            -0.0009,
            0.0005,
            0.0014,
            -0.0008,
            -0.0008,
            0.0012
        ],
        expression: [
            0.0008,
            0.0481,
            0.1653,
            0.0784,
            0.1008,
            -0.3992,
            0.5088,
            -0.02,
            0.0542,
            0.001,
            0.3723,
            -0.0151,
            -0.0986,
            0.0283,
            -0.0033,
            -0.0121,
            0.2634,
            0.1202,
            0.0036,
            -0.0529,
            -0.0245,
            -0.0297,
            -0.1085,
            0.0495,
            0.3264,
            0.0083,
            0.0004,
            -0.0314,
            0.1459,
            -0.1142,
            -0.003,
            0.0001,
            0.1154,
            -0.0035,
            -0.0285,
            -0.0184,
            -0.0001,
            0.0012,
            0.0035,
            0.079,
            -0.0103,
            0.0043,
            0.011,
            -0.004,
            -0.0774,
            -0.0047,
            -0.023,
            0.0284,
            -0.0048,
            -0.001,
            0.0149,
            -0.0039,
            0.0046,
            0.0528,
            -0.0006,
            0.0063,
            0.0376,
            0.0096,
            0.0558,
            -0.0295,
            0,
            -0.0311,
            -0.0634,
            0.0062,
            0.0176,
            -0.0154,
            -0.0109,
            -0.1149,
            0.0192,
            0.0326,
            0.0121,
            0.0237,
            0.0034,
            0.0262,
            -0.0778,
            0.0014,
            -0.0045,
            -0.0203,
            0.0077,
            0.0588,
            0.0575,
            0.008,
            -0.0557,
            -0.0095,
            0.0032,
            0.0054,
            -0.0042
        ]
    },
    7: {
        mean: [
            0.0038,
            -0.2927,
            0.833
        ],
        identity: [
            0.0006,
            -0.0109,
            0.0073,
            -0.0006,
            -0.0044,
            0.0017,
            -0.0001,
            -0.0022,
            -0.0006,
            -0.0003,
            0.0065,
            -0.0014,
            -0.0006,
            -0.0051,
            -0.0046,
            0.0003,
            -0.0029,
            0.003,
            0.0002,
            0.0038,
            -0.0006,
            0,
            -0.0012,
            0.0006,
            -0.0004,
            0.0053,
            -0.0075,
            -0.0002,
            -0.0007,
            -0.0063,
            0.0014,
            0.0026,
            0.0019,
            -0.0022,
            0.0018,
            0.0028,
            -0.0001,
            -0.0012,
            0.0011,
            0.0009,
            0.0019,
            -0.0019,
            -0.0001,
            0.0012,
            -0.0022,
            -0.0003,
            -0.0012,
            0.0004,
            -0.0008,
            0.0003,
            -0.0003,
            0,
            0.0017,
            0.0021,
            -0.0004,
            0.0012,
            0.0022,
            -0.0003,
            0.0026,
            -0.0003,
            0.0004,
            -0.0026,
            0.0032,
            -0.0019,
            0.0003,
            0.0015,
            0.0001,
            -0.0015,
            0.0013,
            -0.0001,
            0.0001,
            -0.0029,
            0,
            -0.0002,
            -0.0028,
            -0.0007,
            0.0019,
            -0.0003,
            -0.0002,
            0.0012,
            0.0009,
            0.0004,
            -0.001,
            -0.002,
            -0.0016,
            0.0011,
            -0.0001,
            0.0003,
            0.0021,
            0.0002,
            -0.0014,
            -0.0009,
            -0.0001,
            0,
            -0.0002,
            -0.001,
            0.0015,
            0.0018,
            0.0001,
            0.0007,
            0.0008,
            0.0017,
            0.001,
            -0.0009,
            0.0001,
            0.0004,
            0.0023,
            -0.0001,
            0.0012,
            0.0001,
            -0.0008,
            0.0002,
            0.0018,
            0.0006,
            0.0003,
            0.0001,
            0.0012,
            -0.0003,
            0.002,
            -0.0006,
            0,
            -0.0001,
            -0.0022,
            0.0004,
            0.0005,
            0.0011,
            0.0002,
            -0.0013,
            -0.0023,
            0.0006,
            0.0006,
            -0.0005,
            -0.0005,
            0.0009,
            0.0002,
            0.0002,
            0.0011,
            -0.0003,
            0.0011,
            0.0015,
            0.0011,
            0.0003,
            0.0002,
            0.0008,
            -0.0004,
            -0.0008,
            0.0003,
            0,
            0.0012,
            -0.0001
        ],
        expression: [
            0.026,
            0.1107,
            0.3257,
            0.1917,
            0.3206,
            -1.1348,
            1.0791,
            -0.035,
            0.1549,
            -0.0103,
            0.6953,
            0.0001,
            -0.3262,
            0.068,
            0.0219,
            -0.0044,
            0.3643,
            0.2178,
            0.0168,
            -0.2478,
            -0.1321,
            -0.0414,
            -0.3782,
            -0.0617,
            0.5088,
            -0.0031,
            -0.0311,
            -0.0497,
            0.0948,
            -0.385,
            0.0148,
            -0.2224,
            -0.1415,
            -0.0074,
            0.0863,
            -0.203,
            0.0003,
            -0.0081,
            0.0057,
            0.1164,
            -0.0039,
            0.0015,
            -0.0024,
            0.0505,
            0.1532,
            0.0039,
            -0.0148,
            -0.0753,
            0.0163,
            0.0058,
            -0.0339,
            0.0036,
            0.0252,
            -0.0569,
            -0.0041,
            0.0163,
            -0.0361,
            0.0035,
            -0.018,
            0.1266,
            0,
            -0.0163,
            -0.0046,
            0.0133,
            -0.1656,
            0.2134,
            0.0191,
            0.0057,
            0.0734,
            0.0681,
            0.0039,
            -0.0144,
            0.029,
            -0.074,
            -0.046,
            0.0122,
            0.0072,
            -0.0162,
            -0.0349,
            -0.1234,
            0.0212,
            -0.0355,
            0.0535,
            0.1218,
            0.0043,
            -0.024,
            0.0016
        ]
    },
    8: {
        mean: [
            -0.0018,
            -0.3037,
            0.8491
        ],
        identity: [
            0.0002,
            -0.0112,
            0.0077,
            -0.0004,
            -0.0044,
            0.0024,
            0.0001,
            -0.0021,
            -0.0004,
            -0.0004,
            0.0066,
            -0.002,
            -0.0004,
            -0.0052,
            -0.0044,
            0.0003,
            -0.0032,
            0.0039,
            0.0004,
            0.0042,
            -0.0003,
            0.0002,
            -0.0012,
            -0.0002,
            -0.0002,
            0.0052,
            -0.0083,
            -0.0001,
            -0.0008,
            -0.0056,
            0.0017,
            0.0024,
            0.0019,
            -0.0023,
            0.002,
            0.0027,
            -0.0002,
            -0.0013,
            0.002,
            0.0009,
            0.0017,
            -0.0028,
            -0.0002,
            0.0012,
            -0.0026,
            0,
            -0.0016,
            0.0002,
            -0.0005,
            0.0003,
            -0.001,
            -0.0001,
            0.0016,
            0.0016,
            -0.0003,
            0.0012,
            0.0012,
            -0.0003,
            0.0027,
            -0.0003,
            0.0003,
            -0.0026,
            0.0037,
            -0.0017,
            0.0001,
            0.0016,
            0.0001,
            -0.0015,
            0.0024,
            0.0001,
            0.0002,
            -0.0039,
            0,
            -0.0003,
            -0.0033,
            -0.0006,
            0.0017,
            -0.0004,
            -0.0004,
            0.0012,
            0.0018,
            0.0002,
            -0.0012,
            -0.002,
            -0.0017,
            0.0013,
            -0.001,
            0.0003,
            0.0021,
            0.0004,
            -0.0012,
            -0.0006,
            -0.0002,
            0,
            -0.0004,
            -0.0009,
            0.0016,
            0.0017,
            0.0004,
            0.0007,
            0.0007,
            0.001,
            0.0009,
            -0.0008,
            0.0005,
            0.0005,
            0.0023,
            0.001,
            0.0013,
            0.0002,
            -0.0004,
            0.0002,
            0.0017,
            0.0008,
            0.0003,
            -0.0001,
            0.0009,
            -0.0004,
            0.0019,
            -0.0005,
            0.0003,
            0,
            -0.0025,
            0.0003,
            0.0003,
            0.0011,
            0.0001,
            -0.0015,
            -0.001,
            0.0007,
            0.0007,
            -0.0007,
            -0.0007,
            0.0008,
            0,
            0.0001,
            0.0013,
            -0.0004,
            0.0012,
            0.0014,
            0.0017,
            0.0004,
            0.0002,
            0.0003,
            -0.0003,
            -0.0009,
            0.0001,
            0,
            0.001,
            -0.0004
        ],
        expression: [
            -0.0092,
            2.8809,
            1.416,
            0.2018,
            1.1982,
            -0.9351,
            1.4492,
            -0.1902,
            0.1749,
            0.0305,
            -0.167,
            -0.1572,
            -0.7354,
            -0.0492,
            0.0115,
            0.0608,
            0.2971,
            0.1179,
            0.0046,
            -0.0997,
            -0.0041,
            -0.0104,
            0.3379,
            -0.1854,
            0.009,
            0.0366,
            -0.0583,
            0.0269,
            -0.0029,
            -0.4175,
            -0.0008,
            0.1794,
            0.0752,
            -0.0135,
            0.1158,
            0.1234,
            0.0005,
            0.003,
            -0.0032,
            0.1034,
            -0.0504,
            -0.0055,
            -0.0076,
            -0.0772,
            0.224,
            0.0047,
            0.0229,
            -0.1044,
            0.0162,
            -0.0161,
            -0.0241,
            -0.0083,
            -0.1388,
            -0.0434,
            -0.0125,
            -0.0997,
            -0.0327,
            -0.0111,
            0.1576,
            -0.3911,
            0.0199,
            0.2522,
            0.142,
            0.0059,
            -0.0721,
            -0.0045,
            0.031,
            -0.1136,
            -0.1685,
            0.0641,
            0.0142,
            0.0312,
            0.0426,
            -0.1366,
            0.1011,
            0.0101,
            -0.0157,
            0.0018,
            -0.0103,
            -0.0344,
            0.0907,
            0.0016,
            0.1168,
            -0.0806,
            0.0104,
            -0.0057,
            0.0111
        ]
    },
    9: [
        {
            mean: [
                0.0038,
                -0.2927,
                0.833
            ],
            identity: [
                0.0006,
                -0.0109,
                0.0073,
                -0.0006,
                -0.0044,
                0.0017,
                -0.0001,
                -0.0022,
                -0.0006,
                -0.0003,
                0.0065,
                -0.0014,
                -0.0006,
                -0.0051,
                -0.0046,
                0.0003,
                -0.0029,
                0.003,
                0.0002,
                0.0038,
                -0.0006,
                0,
                -0.0012,
                0.0006,
                -0.0004,
                0.0053,
                -0.0075,
                -0.0002,
                -0.0007,
                -0.0063,
                0.0014,
                0.0026,
                0.0019,
                -0.0022,
                0.0018,
                0.0028,
                -0.0001,
                -0.0012,
                0.0011,
                0.0009,
                0.0019,
                -0.0019,
                -0.0001,
                0.0012,
                -0.0022,
                -0.0003,
                -0.0012,
                0.0004,
                -0.0008,
                0.0003,
                -0.0003,
                0,
                0.0017,
                0.0021,
                -0.0004,
                0.0012,
                0.0022,
                -0.0003,
                0.0026,
                -0.0003,
                0.0004,
                -0.0026,
                0.0032,
                -0.0019,
                0.0003,
                0.0015,
                0.0001,
                -0.0015,
                0.0013,
                -0.0001,
                0.0001,
                -0.0029,
                0,
                -0.0002,
                -0.0028,
                -0.0007,
                0.0019,
                -0.0003,
                -0.0002,
                0.0012,
                0.0009,
                0.0004,
                -0.001,
                -0.002,
                -0.0016,
                0.0011,
                -0.0001,
                0.0003,
                0.0021,
                0.0002,
                -0.0014,
                -0.0009,
                -0.0001,
                0,
                -0.0002,
                -0.001,
                0.0015,
                0.0018,
                0.0001,
                0.0007,
                0.0008,
                0.0017,
                0.001,
                -0.0009,
                0.0001,
                0.0004,
                0.0023,
                -0.0001,
                0.0012,
                0.0001,
                -0.0008,
                0.0002,
                0.0018,
                0.0006,
                0.0003,
                0.0001,
                0.0012,
                -0.0003,
                0.002,
                -0.0006,
                0,
                -0.0001,
                -0.0022,
                0.0004,
                0.0005,
                0.0011,
                0.0002,
                -0.0013,
                -0.0023,
                0.0006,
                0.0006,
                -0.0005,
                -0.0005,
                0.0009,
                0.0002,
                0.0002,
                0.0011,
                -0.0003,
                0.0011,
                0.0015,
                0.0011,
                0.0003,
                0.0002,
                0.0008,
                -0.0004,
                -0.0008,
                0.0003,
                0,
                0.0012,
                -0.0001
            ],
            expression: [
                0.026,
                0.1107,
                0.3257,
                0.1917,
                0.3206,
                -1.1348,
                1.0791,
                -0.035,
                0.1549,
                -0.0103,
                0.6953,
                0.0001,
                -0.3262,
                0.068,
                0.0219,
                -0.0044,
                0.3643,
                0.2178,
                0.0168,
                -0.2478,
                -0.1321,
                -0.0414,
                -0.3782,
                -0.0617,
                0.5088,
                -0.0031,
                -0.0311,
                -0.0497,
                0.0948,
                -0.385,
                0.0148,
                -0.2224,
                -0.1415,
                -0.0074,
                0.0863,
                -0.203,
                0.0003,
                -0.0081,
                0.0057,
                0.1164,
                -0.0039,
                0.0015,
                -0.0024,
                0.0505,
                0.1532,
                0.0039,
                -0.0148,
                -0.0753,
                0.0163,
                0.0058,
                -0.0339,
                0.0036,
                0.0252,
                -0.0569,
                -0.0041,
                0.0163,
                -0.0361,
                0.0035,
                -0.018,
                0.1266,
                0,
                -0.0163,
                -0.0046,
                0.0133,
                -0.1656,
                0.2134,
                0.0191,
                0.0057,
                0.0734,
                0.0681,
                0.0039,
                -0.0144,
                0.029,
                -0.074,
                -0.046,
                0.0122,
                0.0072,
                -0.0162,
                -0.0349,
                -0.1234,
                0.0212,
                -0.0355,
                0.0535,
                0.1218,
                0.0043,
                -0.024,
                0.0016
            ]
        },
        {
            mean: [
                -0.0018,
                -0.3037,
                0.8491
            ],
            identity: [
                0.0002,
                -0.0112,
                0.0077,
                -0.0004,
                -0.0044,
                0.0024,
                0.0001,
                -0.0021,
                -0.0004,
                -0.0004,
                0.0066,
                -0.002,
                -0.0004,
                -0.0052,
                -0.0044,
                0.0003,
                -0.0032,
                0.0039,
                0.0004,
                0.0042,
                -0.0003,
                0.0002,
                -0.0012,
                -0.0002,
                -0.0002,
                0.0052,
                -0.0083,
                -0.0001,
                -0.0008,
                -0.0056,
                0.0017,
                0.0024,
                0.0019,
                -0.0023,
                0.002,
                0.0027,
                -0.0002,
                -0.0013,
                0.002,
                0.0009,
                0.0017,
                -0.0028,
                -0.0002,
                0.0012,
                -0.0026,
                0,
                -0.0016,
                0.0002,
                -0.0005,
                0.0003,
                -0.001,
                -0.0001,
                0.0016,
                0.0016,
                -0.0003,
                0.0012,
                0.0012,
                -0.0003,
                0.0027,
                -0.0003,
                0.0003,
                -0.0026,
                0.0037,
                -0.0017,
                0.0001,
                0.0016,
                0.0001,
                -0.0015,
                0.0024,
                0.0001,
                0.0002,
                -0.0039,
                0,
                -0.0003,
                -0.0033,
                -0.0006,
                0.0017,
                -0.0004,
                -0.0004,
                0.0012,
                0.0018,
                0.0002,
                -0.0012,
                -0.002,
                -0.0017,
                0.0013,
                -0.001,
                0.0003,
                0.0021,
                0.0004,
                -0.0012,
                -0.0006,
                -0.0002,
                0,
                -0.0004,
                -0.0009,
                0.0016,
                0.0017,
                0.0004,
                0.0007,
                0.0007,
                0.001,
                0.0009,
                -0.0008,
                0.0005,
                0.0005,
                0.0023,
                0.001,
                0.0013,
                0.0002,
                -0.0004,
                0.0002,
                0.0017,
                0.0008,
                0.0003,
                -0.0001,
                0.0009,
                -0.0004,
                0.0019,
                -0.0005,
                0.0003,
                0,
                -0.0025,
                0.0003,
                0.0003,
                0.0011,
                0.0001,
                -0.0015,
                -0.001,
                0.0007,
                0.0007,
                -0.0007,
                -0.0007,
                0.0008,
                0,
                0.0001,
                0.0013,
                -0.0004,
                0.0012,
                0.0014,
                0.0017,
                0.0004,
                0.0002,
                0.0003,
                -0.0003,
                -0.0009,
                0.0001,
                0,
                0.001,
                -0.0004
            ],
            expression: [
                -0.0092,
                2.8809,
                1.416,
                0.2018,
                1.1982,
                -0.9351,
                1.4492,
                -0.1902,
                0.1749,
                0.0305,
                -0.167,
                -0.1572,
                -0.7354,
                -0.0492,
                0.0115,
                0.0608,
                0.2971,
                0.1179,
                0.0046,
                -0.0997,
                -0.0041,
                -0.0104,
                0.3379,
                -0.1854,
                0.009,
                0.0366,
                -0.0583,
                0.0269,
                -0.0029,
                -0.4175,
                -0.0008,
                0.1794,
                0.0752,
                -0.0135,
                0.1158,
                0.1234,
                0.0005,
                0.003,
                -0.0032,
                0.1034,
                -0.0504,
                -0.0055,
                -0.0076,
                -0.0772,
                0.224,
                0.0047,
                0.0229,
                -0.1044,
                0.0162,
                -0.0161,
                -0.0241,
                -0.0083,
                -0.1388,
                -0.0434,
                -0.0125,
                -0.0997,
                -0.0327,
                -0.0111,
                0.1576,
                -0.3911,
                0.0199,
                0.2522,
                0.142,
                0.0059,
                -0.0721,
                -0.0045,
                0.031,
                -0.1136,
                -0.1685,
                0.0641,
                0.0142,
                0.0312,
                0.0426,
                -0.1366,
                0.1011,
                0.0101,
                -0.0157,
                0.0018,
                -0.0103,
                -0.0344,
                0.0907,
                0.0016,
                0.1168,
                -0.0806,
                0.0104,
                -0.0057,
                0.0111
            ]
        }
    ],
    10: {
        mean: [
            -0.007,
            -0.6338,
            0.7695
        ],
        identity: [
            0.0001,
            -0.0296,
            0.0089,
            -0.0006,
            -0.0073,
            -0.0065,
            -0.0001,
            -0.0029,
            -0.0031,
            -0.0002,
            0.0128,
            0.0065,
            0,
            -0.0116,
            -0.014,
            -0.0001,
            -0.0037,
            -0.0052,
            -0.0005,
            0.0028,
            0.003,
            -0.0004,
            0.0041,
            0.0015,
            0.0006,
            0.0088,
            -0.0076,
            -0.0011,
            -0.0015,
            -0.0073,
            0.0007,
            -0.0011,
            0.0019,
            -0.0011,
            -0.0005,
            0.0031,
            -0.0001,
            -0.0018,
            0.0009,
            0.0018,
            0.0038,
            0.0068,
            -0.0004,
            -0.0001,
            0.0061,
            0.0024,
            0.0024,
            -0.0066,
            -0.0006,
            0.0051,
            0.0014,
            0.002,
            0.005,
            -0.0035,
            0.0001,
            -0.0034,
            -0.004,
            -0.0007,
            0.001,
            -0.0008,
            0.0001,
            -0.0005,
            -0.0021,
            0.0002,
            0.0045,
            -0.0043,
            -0.0012,
            -0.0024,
            -0.0014,
            0.0006,
            0.0034,
            0.0027,
            -0.0008,
            -0.0053,
            0.0014,
            0.0001,
            0.0013,
            -0.0018,
            0.0006,
            -0.0015,
            0.0029,
            -0.0002,
            -0.0035,
            0.0001,
            -0.002,
            0.0012,
            0.0048,
            0.0011,
            0.0001,
            -0.0002,
            -0.0003,
            -0.0012,
            0.0033,
            0.0006,
            0.002,
            -0.0033,
            0.0004,
            0.0028,
            0.0002,
            0.0008,
            -0.0001,
            -0.0018,
            0.0008,
            0.0017,
            0.0001,
            0.0009,
            0.0008,
            0.0003,
            0.0019,
            -0.001,
            0.001,
            -0.0007,
            -0.0013,
            0,
            0.0001,
            0.0032,
            -0.0001,
            0.0001,
            0.0011,
            -0.0004,
            0.0005,
            -0.0007,
            0.0018,
            -0.0003,
            0.0002,
            0.0007,
            0.0008,
            -0.0014,
            0.0007,
            0.0015,
            -0.0006,
            -0.0001,
            -0.0004,
            0.0019,
            -0.0009,
            -0.0006,
            -0.0006,
            -0.0012,
            0.0002,
            -0.0012,
            -0.0008,
            0.0004,
            0.0006,
            -0.0011,
            0.0003,
            0.0009,
            -0.0004,
            0.0006,
            -0.0007,
            -0.0004
        ],
        expression: [
            -0.0603,
            2.0527,
            1.9014,
            0.1025,
            0.6143,
            0.3804,
            0.7881,
            -0.1023,
            -0.0764,
            0.0454,
            -0.2487,
            -0.5073,
            -0.6704,
            -0.031,
            -0.0181,
            0.0466,
            0.0651,
            -0.0726,
            -0.0033,
            -0.0022,
            0.2944,
            0.0101,
            0.1669,
            -0.5225,
            -0.4685,
            0.0236,
            0.0079,
            0.011,
            0.2173,
            0.4529,
            0.0121,
            -0.2104,
            -0.0673,
            0.0225,
            -0.4023,
            0.0317,
            -0.0009,
            0.0076,
            -0.0032,
            0.0333,
            0.0523,
            0.0129,
            -0.001,
            -0.0319,
            -0.0139,
            0.0015,
            -0.0044,
            0.0247,
            -0.0005,
            0.0161,
            0.0061,
            0.0074,
            0.0776,
            -0.0176,
            0.007,
            0.055,
            -0.017,
            0.0052,
            -0.1819,
            0.0294,
            -0.0161,
            -0.0337,
            0.0226,
            -0.008,
            -0.0297,
            0.1967,
            -0.0095,
            0.0383,
            0.2039,
            0.0434,
            0.0271,
            -0.0064,
            -0.0037,
            -0.0294,
            -0.024,
            0.0024,
            -0.0137,
            -0.0209,
            -0.0031,
            0.0628,
            0.1003,
            -0.0126,
            -0.056,
            -0.0097,
            -0.0012,
            -0.0041,
            0.0162
        ]
    },
    11: {
        mean: [
            0.2505,
            0.3833,
            0.7793
        ],
        identity: [
            0.0098,
            0.012,
            0.0077,
            -0.0006,
            -0.0003,
            0,
            0.0001,
            0.0082,
            -0.0007,
            0.0019,
            -0.0036,
            -0.0012,
            0.0002,
            0.0119,
            -0.0039,
            0.001,
            0.0001,
            0.0031,
            -0.0036,
            -0.0059,
            -0.0007,
            0.0026,
            0.0028,
            -0.0011,
            0.0009,
            -0.0032,
            0.0008,
            0.0029,
            0.0043,
            0.0003,
            0.0025,
            -0.0009,
            0.0047,
            0.0016,
            0.0022,
            0.0018,
            -0.001,
            0.0025,
            -0.003,
            -0.001,
            0.0033,
            0.0034,
            0.0004,
            -0.0052,
            0.0024,
            -0.0002,
            0.001,
            -0.0014,
            -0.0006,
            0.0038,
            -0.0015,
            -0.0006,
            -0.001,
            -0.0011,
            -0.0004,
            -0.001,
            0.0004,
            -0.0007,
            0.0036,
            -0.0008,
            -0.0002,
            -0.0019,
            0.0005,
            0.0003,
            -0.0006,
            -0.0024,
            -0.0017,
            -0.0014,
            0.0006,
            -0.0004,
            -0.0031,
            -0.0013,
            -0.0006,
            0.0042,
            0.0002,
            -0.0002,
            -0.002,
            -0.0003,
            0.0008,
            0.0018,
            -0.0005,
            -0.0006,
            -0.0002,
            -0.0006,
            0.0025,
            0.0019,
            0.001,
            0.0008,
            -0.0015,
            -0.0012,
            -0.0001,
            -0.0006,
            -0.0004,
            0.0023,
            -0.001,
            0.0006,
            -0.0002,
            -0.001,
            0,
            -0.0009,
            -0.002,
            -0.0011,
            0.0001,
            0,
            -0.0001,
            0.0005,
            0.0006,
            0.0009,
            -0.0006,
            0.0005,
            0.0008,
            -0.0001,
            -0.0002,
            -0.0017,
            -0.0006,
            -0.0004,
            0.0004,
            -0.0006,
            0.0012,
            0.0004,
            0.0003,
            -0.0007,
            0.0003,
            -0.0002,
            0.0006,
            0.0001,
            0.0005,
            -0.0019,
            -0.0006,
            0.0004,
            0.0007,
            -0.0001,
            0.0001,
            0.0005,
            0.001,
            -0.0006,
            -0.002,
            -0.0007,
            -0.0005,
            0.0005,
            0.0003,
            0.0007,
            0.0014,
            0,
            0.0005,
            -0.0005,
            -0.0002,
            0.0003,
            -0.0006,
            -0.0001
        ],
        expression: [
            -0.0009,
            -0.0003,
            0.0032,
            -0.003,
            -0.0034,
            -0.0031,
            0.0014,
            0,
            0.0004,
            -0.0139,
            -0.0764,
            0.0275,
            -0.002,
            -0.0089,
            0.0031,
            -0.0503,
            -0.0771,
            0.038,
            -0.1323,
            -0.3523,
            0.1368,
            -0.0474,
            -0.0564,
            0.0296,
            -0.0045,
            0.007,
            -0.0013,
            0.0153,
            0.1259,
            -0.0464,
            0.0866,
            0.2175,
            -0.0786,
            -0.0413,
            -0.1248,
            0.0448,
            -0.1777,
            -0.4607,
            0.1782,
            -0.0005,
            -0.005,
            0.0016,
            0.0629,
            0.1506,
            -0.0624,
            0.0545,
            0.2576,
            -0.0864,
            -0.0231,
            -0.0552,
            0.0244,
            -0.0136,
            -0.0359,
            0.0169,
            -0.1158,
            -0.2996,
            0.1214,
            -0.0235,
            -0.0354,
            0.0165,
            -0.0745,
            -0.1079,
            0.0475,
            -0.0116,
            -0.0039,
            0.0012,
            0.0013,
            -0.0108,
            -0.0008,
            0.0044,
            -0.0027,
            -0.0001,
            -0.0694,
            0.0363,
            0.0071,
            0.1462,
            -0.136,
            0.0047,
            0.009,
            -0.0177,
            0.0038,
            -0.0271,
            0.0118,
            0.0011,
            -0.0399,
            -0.0111,
            0.0123
        ]
    },
    12: {
        mean: [
            -0.2981,
            0.3828,
            0.7563
        ],
        identity: [
            -0.0116,
            0.014,
            0.0054,
            0.0018,
            0.0005,
            0,
            -0.0004,
            0.0068,
            -0.0013,
            -0.0019,
            -0.0048,
            -0.0005,
            0.0005,
            0.0108,
            -0.0036,
            -0.0029,
            -0.0018,
            0.0029,
            0.0043,
            -0.0077,
            0.0006,
            -0.0017,
            0.002,
            -0.0011,
            -0.0014,
            -0.0035,
            0.0015,
            -0.0024,
            0.0011,
            0.0004,
            -0.0048,
            0.0002,
            0.0029,
            -0.0001,
            -0.0001,
            0.003,
            0.0019,
            0.0035,
            -0.0016,
            -0.0004,
            0.0039,
            0.0019,
            0.0001,
            -0.0064,
            0.004,
            0.0003,
            0.002,
            -0.0021,
            0.0017,
            0.0011,
            -0.001,
            0.0026,
            0.0025,
            -0.0005,
            0.0002,
            -0.0003,
            -0.0005,
            -0.0007,
            0.0009,
            -0.0004,
            -0.001,
            -0.0022,
            0.001,
            0.0009,
            -0.0014,
            0.0007,
            0.0011,
            -0.001,
            -0.0005,
            -0.0008,
            -0.0017,
            -0.0021,
            0.0009,
            0.0036,
            0.0005,
            0.0004,
            -0.0031,
            0.0006,
            -0.0015,
            0.0027,
            0.0002,
            0.0001,
            -0.0011,
            0.0002,
            -0.0011,
            -0.0018,
            0.0004,
            -0.0013,
            -0.0002,
            0.0007,
            0.0009,
            -0.0003,
            0.001,
            -0.0021,
            0.0008,
            0.0006,
            -0.0009,
            0.0004,
            -0.0007,
            0.0008,
            -0.002,
            -0.0013,
            0,
            0.0007,
            -0.0012,
            -0.0001,
            0.0014,
            0.0014,
            -0.0001,
            0.0013,
            0.0006,
            0.0006,
            -0.0014,
            -0.0015,
            -0.0009,
            0.0001,
            0.0001,
            0.0009,
            0.0007,
            0,
            0.0001,
            -0.001,
            -0.0004,
            0,
            -0.0005,
            0.0001,
            -0.0003,
            0.0004,
            -0.0005,
            -0.0001,
            -0.0011,
            0.0002,
            0,
            0.0001,
            0.0008,
            0.0008,
            0,
            -0.0007,
            -0.0008,
            0,
            0.0002,
            -0.0001,
            0.001,
            0.0003,
            0.0004,
            -0.0002,
            0,
            0.0005,
            0.0018,
            -0.0001
        ],
        expression: [
            0,
            -0.0004,
            0.0028,
            0.0036,
            -0.0008,
            -0.0026,
            -0.0015,
            -0.0008,
            0.0003,
            0.0075,
            -0.0608,
            0.025,
            0.0019,
            -0.0076,
            0.0033,
            0.0379,
            -0.0437,
            0.0335,
            0.0964,
            -0.2452,
            0.1233,
            0.0368,
            -0.0251,
            0.0253,
            0.0033,
            0.0097,
            -0.0021,
            -0.0095,
            0.1171,
            -0.0475,
            -0.064,
            0.1548,
            -0.0718,
            0.0228,
            -0.0831,
            0.0343,
            -0.1924,
            0.6206,
            -0.2771,
            0.0021,
            -0.0143,
            0.0056,
            -0.0705,
            0.2522,
            -0.1116,
            -0.0692,
            0.4229,
            -0.1592,
            -0.0093,
            0.05,
            -0.0185,
            0.0948,
            -0.3196,
            0.1437,
            -0.0184,
            0.0194,
            -0.0131,
            0.0205,
            -0.0353,
            0.0201,
            0.0676,
            -0.135,
            0.0672,
            0.0137,
            -0.0311,
            0.0118,
            0.0003,
            -0.0077,
            -0.0002,
            -0.0151,
            0.0004,
            -0.0058,
            0.029,
            -0.0139,
            0.0163,
            0.1324,
            0.1819,
            -0.0039,
            0.0406,
            0.0501,
            0.0017,
            0.0331,
            0.0161,
            0.0062,
            -0.0235,
            -0.0446,
            0.0047
        ]
    }
};



let $b4178198a2f8dfd2$var$latestFaceLandmark = 1;
let $b4178198a2f8dfd2$var$faceLandmarkById = new Map();
function $b4178198a2f8dfd2$export$36e720c0ee0eafff(n) {
    let ret = $b4178198a2f8dfd2$var$latestFaceLandmark++;
    $b4178198a2f8dfd2$var$faceLandmarkById.set(ret, new $b4178198a2f8dfd2$export$8da7a4c55ed49539(n));
    (0, $7e50675ff5e3df75$export$454156e929b28fe7)("face_landmark_t initialized");
    return ret;
}
function $b4178198a2f8dfd2$export$4a91c83b2945af9c(m) {
    $b4178198a2f8dfd2$var$faceLandmarkById.delete(m);
}
function $b4178198a2f8dfd2$export$2cdf232f18b0ea25(m) {
    return $b4178198a2f8dfd2$var$faceLandmarkById.get(m);
}
class $b4178198a2f8dfd2$export$8da7a4c55ed49539 {
    constructor(_name){
        this._name = _name;
        this.anchor_pose = (0, $2edf3b5f20103352$exports).create();
    }
    _getVertex(identity, expression, data) {
        let vert = data.mean.slice();
        for(let i = 0; i < 50; i++){
            vert[0] += identity[i] * data.identity[i * 3 + 0];
            vert[1] += identity[i] * data.identity[i * 3 + 1];
            vert[2] += identity[i] * data.identity[i * 3 + 2];
        }
        for(let i = 0; i < 29; i++){
            vert[0] += expression[i] * data.expression[i * 3 + 0];
            vert[1] += expression[i] * data.expression[i * 3 + 1];
            vert[2] += expression[i] * data.expression[i * 3 + 2];
        }
        return vert;
    }
    update(identity, expression, mirrored) {
        let vert;
        let data = (0, $cd4affe11a7fe13b$export$bc05bfbdf8a2824)[this._name.toString()];
        if (!data) return;
        if (Array.isArray(data)) {
            vert = this._getVertex(identity, expression, data[0]);
            let b = this._getVertex(identity, expression, data[1]);
            vert[0] = 0.5 * (vert[0] + b[0]);
            vert[1] = 0.5 * (vert[1] + b[1]);
            vert[2] = 0.5 * (vert[2] + b[2]);
        } else vert = this._getVertex(identity, expression, data);
        if (mirrored) vert[0] *= -1;
        (0, $2edf3b5f20103352$exports).fromTranslation(this.anchor_pose, vert);
    }
}


function $76dc112703edaa32$var$getUnsupportedMessage() {
    let ret = document.createElement("div");
    let idealBrowser = "a recent web browser";
    if (navigator.userAgent.match(/Android/i)) {
        idealBrowser = "Chrome for Android";
        window.location.href = "googlechrome://navigate?url=" + encodeURI(window.location.href);
        setTimeout(()=>{
            window.location.href = "samsunginternet://open?url=" + encodeURI(window.location.href);
        }, 2000);
    } else if (navigator.userAgent.match(/iPhone|iPod|iPad/i)) {
        idealBrowser = "Safari";
        ret.classList.add("zee-launcher-browser-safari");
    }
    ret.classList.add("zee-launcher-unsupported");
    ret.innerHTML = `
            <style>.zee-launcher-unsupported {
               display: flex;
               flex-direction: column;
               height: 100%;
               justify-content: center;
               position: absolute;
               width: 100%;
               height: 100%;
               top: 0;
               left: 0;
               align-items: center;
               }
               .zee-launcher-browser-logo {
               background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 210 211' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(-82 -146)' fill-rule='nonzero' stroke='%23ffffff' stroke-width='2'%3E%3Cg transform='translate(83 146.5)'%3E%3Cpath d='m55.146 88.785l-32.039-49.472c19.962-24.947 49.904-38.684 80.517-38.81 17.739-0.12642 35.855 4.4246 52.336 13.99 18.2 10.619 32.039 25.874 40.846 43.404l-86.095-4.5511c-24.365-1.4327-47.556 12.347-55.565 35.439zm13.797 16.224c0 19.468 15.684 35.229 35.059 35.229 19.374 0 35.059-15.76 35.059-35.229 0-19.468-15.684-35.229-35.059-35.229-19.374 0-35.059 15.718-35.059 35.229zm132.06-37.588l-58.585 3.034c15.894 18.668 16.145 45.595 2.7678 66.243l-47.01 72.648c19.5 1.0535 39.588-3.2447 57.788-13.864 45.039-26.126 63.282-80.908 45.039-128.06zm-144.93 57.647l-39.126-77.326c-10.694 16.434-16.942 36.156-16.942 57.267 0 52.253 38.078 95.53 87.856 103.2l26.713-52.59c-24.155 4.5511-47.472-8.765-58.501-30.551z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
               width: 211px;
               height: 211px;
               margin-bottom: 25%;
               margin-top: -60px;
               background-repeat: no-repeat;
               }
               .zee-launcher-browser-safari .zee-launcher-browser-logo {
               background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 211 211' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(-82 -146)' fill-rule='nonzero' stroke='%23ffffff' stroke-width='2'%3E%3Cpath d='m180 251.86c0-4.0385 2.9377-7.855 7.2552-7.855 3.9614 0 7.7448 2.8402 7.7448 7.145 0 4.0385-2.8487 7.855-7.1662 7.855-4.0059 0-7.8338-2.9734-7.8338-7.145zm112-0.35503c0 57.728-46.772 104.5-104.5 104.5s-104.5-46.772-104.5-104.5 46.772-104.5 104.5-104.5 104.5 46.772 104.5 104.5zm-12-1c0-51.649-41.851-93.5-93.5-93.5s-93.5 41.851-93.5 93.5 41.851 93.5 93.5 93.5 93.5-41.851 93.5-93.5zm-30.624 40.983c0 1.5095 5.4495 4.2768 6.8328 5.1154-11.486 17.401-29.26 29.938-49.423 34.928l-1.8444-7.757c-0.12576-1.0482-0.79646-1.174-1.7606-1.174-0.79646 0-1.2576 1.174-1.1737 1.7611l1.8444 7.8828c-5.5753 1.174-11.234 1.7611-16.935 1.7611-15.217 0-30.182-4.2768-43.177-12.202 0.71263-1.174 5.1141-7.5474 5.1141-8.4698 0-0.79666-0.71263-1.5095-1.5091-1.5095-1.6348 0-5.1141 6.9603-6.1621 8.344-17.522-11.615-30.182-29.602-35.044-50.148l8.0066-1.761c0.92222-0.25158 1.1737-0.92246 1.1737-1.7611 0-0.79667-1.1737-1.2579-1.8444-1.174l-7.8389 1.803c-1.048-5.3251-1.6348-10.692-1.6348-16.143 0-15.556 4.4015-30.86 12.66-43.984 1.1737 0.71281 6.749 4.5284 7.6712 4.5284 0.79646 0 1.5091-0.58702 1.5091-1.3837 0-1.6353-6.1621-4.7381-7.5455-5.7024 11.821-17.275 29.805-29.728 50.219-34.34l1.7606 7.757c0.25152 0.92246 0.92222 1.174 1.7606 1.174 0.83838 0 1.2576-1.174 1.1737-1.8449l-1.7606-7.6732c5.1141-0.92246 10.312-1.5095 15.552-1.5095 15.552 0 30.727 4.4026 43.973 12.663-0.79646 1.174-4.5273 6.6249-4.5273 7.5474 0 0.79667 0.58687 1.5095 1.3833 1.5095 1.6348 0 4.7369-6.0379 5.5753-7.4216 17.187 11.615 29.469 29.351 34.248 49.561l-6.4975 1.3837c-1.048 0.25158-1.1737 0.92246-1.1737 1.8449 0 0.79667 1.1737 1.2579 1.7606 1.174l6.6232-1.5095c1.048 5.3251 1.6348 10.776 1.6348 16.227 0 15.221-4.1919 30.189-12.073 43.062-1.1737-0.58702-6.0364-4.0672-6.9586-4.0672-0.8803 0-1.5929 0.71281-1.5929 1.5095zm-14.876-98.483c-5.2178 4.88-53.863 49.48-55.228 51.8l-38.772 64.2c5.0974-4.76 53.863-49.6 55.108-51.72l38.892-64.28z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
               }
               .zee-launcher-unsupported-message {
               text-align: center;
               width: 250px;
               font-family: sans-serif;
               color: #ffffff;
               }
               .zee-launcher-unsupported-message-copy {
               border: 1px solid #ffffff;
               border-radius: 5px;
               margin-top: 10px;
               }
               #zee-launcher-unsupported-message-input {
               border: none;
               padding: 10px;
               border-radius: 0px;
               border-right: 1px solid #344B60;
               height: 40px;
               color: #ffffff;
               background-color: black;
               box-sizing: border-box;
               width: calc(100% - 65px);
               margin-left: 5px;
               }
               #zee-launcher-unsupported-message-button {
               background: none;
               border: none;
               outline: none;
               text-transform: uppercase;
               color: #ffffff;
               height: 40px;
               display: inline-block;
               width: 59px;
               }
               .zee-launcher-unsupported-message-before-copy {
               height: 100px;
               display: flex;
               flex-direction: column;
               justify-content: center;
               margin-top: 20px;
               }
               .zee-launcher-unsupported-message-copied .zee-launcher-unsupported-message-before-copy {
               display: none;
               }
               .zee-launcher-unsupported-message-after-copy {
               display: none;
               }
               .zee-launcher-unsupported-message-copied .zee-launcher-unsupported-message-after-copy {
               height: 100px;
               display: flex;
               flex-direction: column;
               justify-content: center;
               margin-top: 20px;
               }
            </style>
            <div class="zee-launcher-browser-logo"></div>
            <div class="zee-launcher-unsupported-message">Open with ${idealBrowser} to access this content.</div>
            <div class="zee-launcher-unsupported-message-before-copy">
               <div class="zee-launcher-unsupported-message ">Tap below to copy the address for easy pasting into ${idealBrowser}.</div>
               <div class="zee-launcher-unsupported-message-copy"><input id="zee-launcher-unsupported-message-input" type="text/"><button id="zee-launcher-unsupported-message-button">Copy</button></div>
            </div>
            <div class="zee-launcher-unsupported-message zee-launcher-unsupported-message-after-copy">COPIED! Now paste into ${idealBrowser}'s address bar to experience the content.</div>
    `;
    let inpElm = ret.querySelector("#zee-launcher-unsupported-message-input") || document.createElement("input");
    inpElm.value = window.location.href;
    let btnElm = ret.querySelector("#zee-launcher-unsupported-message-button") || document.createElement("button");
    let onCopyPressed = ()=>{
        if (navigator.userAgent.match(/iPhone|iPod|iPad/i)) {
            let r = document.createRange();
            r.selectNodeContents(inpElm);
            let sel = window.getSelection();
            if (!sel) return;
            sel.removeAllRanges();
            sel.addRange(r);
            inpElm.setSelectionRange(0, 999999999);
        } else inpElm.select();
        document.execCommand("copy");
        inpElm.blur();
        ret.classList.toggle("zee-launcher-unsupported-message-copied", true);
    };
    btnElm.addEventListener("click", onCopyPressed);
    inpElm.addEventListener("click", onCopyPressed);
    return ret;
}
const $76dc112703edaa32$var$incompatibleUI = ()=>{
    const zapparCompatibility = document.createElement("div");
    zapparCompatibility.append($76dc112703edaa32$var$getUnsupportedMessage());
    Object.assign(zapparCompatibility.style, {
        position: "fixed",
        width: "100%",
        height: "100%",
        top: "0px",
        left: "0px",
        zIndex: 1001,
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        fontFamily: "sans-serif",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    });
    zapparCompatibility.classList.add("zee_launcher_compatibility");
    document.body.append(zapparCompatibility);
};
function $76dc112703edaa32$var$isSupportedBrowser() {
    if (typeof Promise !== "function") return false;
    if (typeof WebAssembly !== "object") return false;
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices || !navigator.mediaDevices.getUserMedia) return false;
    return true;
}
var $76dc112703edaa32$export$2e2bcd8739ae039 = {
    incompatible: ()=>!$76dc112703edaa32$var$isSupportedBrowser(),
    incompatible_ui: $76dc112703edaa32$var$incompatibleUI
};








let $45c5dd3ebc146df0$var$latest = 1;
let $45c5dd3ebc146df0$var$byId = new Map();
class $45c5dd3ebc146df0$export$9035336025e5be06 extends (0, $6b0cfaf8deebc493$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._packetNumber = 0;
        this._motionUpdatesQueued = 0;
        this._motionUpdatesSent = 0;
        this._minFrameGapMs = 0;
        this._lastUpdateTime = 0;
    }
    static create(p) {
        let ret = $45c5dd3ebc146df0$var$latest++;
        $45c5dd3ebc146df0$var$byId.set(ret, new $45c5dd3ebc146df0$export$9035336025e5be06(ret, p));
        (0, $7e50675ff5e3df75$export$454156e929b28fe7)("sequence_source_source_t initialized");
        return ret;
    }
    static get(m) {
        return $45c5dd3ebc146df0$var$byId.get(m);
    }
    loadFromMemory(data) {
        try {
            this._decoder = new (0, $8daf7012fef9fdbd$export$20801e67610bf5d8)(data);
            this._packetNumber = 0;
            this._lastUpdateTime = 0;
        } catch (err) {
            (0, $7e50675ff5e3df75$export$497c45d0bfe56de1)("Unable to decode sequence:", err);
        }
    }
    maxPlaybackFpsSet(fps) {
        if (fps <= 0) {
            this._minFrameGapMs = 0;
            return;
        }
        this._minFrameGapMs = 1000.0 / fps;
    }
    setTime(t) {
        if (t < 0) delete this._time;
        else this._time = t;
    }
    getFrame(currentlyProcessing) {
        var _a;
        let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        if (!this._decoder) return;
        this._submitMotionUpdates(pipeline);
        if (this._motionUpdatesQueued > this._motionUpdatesSent) return;
        if (currentlyProcessing) return;
        let curTime = (_a = this._time) !== null && _a !== void 0 ? _a : performance.now();
        if (curTime < this._lastUpdateTime + this._minFrameGapMs) return;
        if (this._packetNumber >= this._decoder.numberPackets) return;
        let packet = this._decoder.dataByPacket.get(this._packetNumber);
        if (packet.type != (0, $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b).CAMERA_FRAME) return;
        this._packetNumber++;
        let pixels = pipeline.cameraPixelArrays.pop();
        while(pixels){
            if (pixels.byteLength === packet.greyscale.byteLength) break;
            pixels = pipeline.cameraPixelArrays.pop();
        }
        if (!pixels) pixels = new ArrayBuffer(packet.greyscale.byteLength);
        new Uint8Array(pixels).set(packet.greyscale);
        this._lastUpdateTime = curTime;
        let info = {
            data: pixels,
            cameraSourceData: packet.greyscale,
            cameraModel: packet.cameraModel,
            cameraToDevice: packet.cameraToDevice,
            dataWidth: packet.width,
            dataHeight: packet.height,
            texture: undefined,
            userFacing: packet.userFacing,
            uvTransform: (0, $2edf3b5f20103352$exports).create(),
            cameraSource: this
        };
        // We can queue the motion updates for the follwing frame immediately
        // as this camera frame will be sent immediately, but the next motion
        // updates will be one frame later
        this._submitMotionUpdates(pipeline);
        const token = pipeline.registerToken(info);
        pipeline.sendDataToWorker(info.data || new ArrayBuffer(0), token, info.dataWidth, info.dataHeight, info.userFacing, info.cameraToDevice, info.cameraModel);
    }
    destroy() {
        $45c5dd3ebc146df0$var$byId.delete(this._impl);
        this.pause();
    }
    start() {
        var _a;
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
    }
    pause() {
        let p = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
    }
    uploadGL(info) {
        let pipeline = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!gl) return;
        if (!info.texture) info.texture = pipeline.getVideoTexture();
        if (!info.texture) return;
        if (!info.cameraSourceData) return;
        gl.bindTexture(gl.TEXTURE_2D, info.texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, info.dataWidth, info.dataHeight, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, new Uint8Array(info.cameraSourceData));
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    _submitMotionUpdates(pipeline) {
        let pendingMotionUpdate = false;
        while(this._packetNumber < this._decoder.numberPackets){
            let packet = this._decoder.dataByPacket.get(this._packetNumber);
            if (packet.type == (0, $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b).CAMERA_FRAME) break;
            switch(packet.type){
                case (0, $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b).ACCELEROMETER:
                    pipeline.motionAccelerometerSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b).ROTATION_RATE:
                    pipeline.motionRotationRateSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b).ATTITUDE:
                    pipeline.motionAttitudeSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $8daf7012fef9fdbd$export$b970cf2e1a7b7c7b).ATTITUDE_MATRIX:
                    pipeline.motionAttitudeMatrix(packet.attitude);
                    pendingMotionUpdate = true;
                    break;
            }
            this._packetNumber++;
        }
        // If we've submitted motion updates, add a setTimeout to reflect when
        // the message serializer will actually have sent them over to the worker
        if (pendingMotionUpdate) {
            this._motionUpdatesQueued++;
            setTimeout(()=>{
                this._motionUpdatesSent++;
            }, 0);
        }
        return;
    }
}



const $86d6871336d56abd$export$4cf8838f9102a661 = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="250" height="80.408" viewBox="0 0 250 80.408"><defs><filter id="a" x="0" y="1.182" width="250" height="79.226" filterUnits="userSpaceOnUse"><feOffset dy="3" input="SourceAlpha"/><feGaussianBlur stdDeviation="3" result="b"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="c" x="6.929" y="0" width="111.975" height="40.988" filterUnits="userSpaceOnUse"><feOffset dy="3" input="SourceAlpha"/><feGaussianBlur stdDeviation="3" result="d"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-26.873 -414.029)"><g transform="translate(44 423.332)"><g transform="translate(0 0.635)" style="isolation:isolate"><g transform="translate(0 0)"><g transform="matrix(1, 0, 0, 1, -17.13, -9.94)" filter="url(#a)"><path d="M55.766,44.97V11.8h8.272v2.6h.089a8.258,8.258,0,0,1,7.046-3.357,11.4,11.4,0,0,1,8.5,3.686,12.667,12.667,0,0,1,3.278,8.622,12.509,12.509,0,0,1-3.25,8.57,11.353,11.353,0,0,1-8.429,3.6,9.533,9.533,0,0,1-7.229-2.95V43.378l-8.269,1.594h0Zm8-21.671a4.958,4.958,0,0,0,5.319,5.15A4.957,4.957,0,0,0,74.4,23.3a5.321,5.321,0,0,0-10.638,0ZM16.105,18.412H2.752V11.038H30.9L14.887,37.16H38.22L0,44.534ZM131.469,38.45a.761.761,0,0,1-.484-.166.582.582,0,0,1-.228-.419l-.553-3.586a12.243,12.243,0,0,1-1.782-.721l-2.789,2.084a.718.718,0,0,1-.5.176.688.688,0,0,1-.495-.214,25.864,25.864,0,0,1-3.264-3.274.754.754,0,0,1,.018-.9c.2-.277.543-.713,1.01-1.3.483-.6.832-1.05,1.068-1.374a9.614,9.614,0,0,1-.811-1.929l-3.62-.527a.631.631,0,0,1-.416-.243.728.728,0,0,1-.159-.458V21.283a.743.743,0,0,1,.159-.448.6.6,0,0,1,.376-.253l3.68-.546a9.511,9.511,0,0,1,.772-1.792c-.523-.733-1.235-1.638-2.117-2.69a.731.731,0,0,1-.2-.467.82.82,0,0,1,.178-.449,19.577,19.577,0,0,1,1.949-2.095c.953-.924,1.582-1.393,1.87-1.393a.861.861,0,0,1,.515.195l2.729,2.084a11.551,11.551,0,0,1,1.8-.741,31.446,31.446,0,0,1,.573-3.623.666.666,0,0,1,.712-.546h4.392a.757.757,0,0,1,.485.166.58.58,0,0,1,.228.419l.553,3.584a12.576,12.576,0,0,1,1.782.722l2.809-2.085a.641.641,0,0,1,.475-.176.776.776,0,0,1,.5.195,27.035,27.035,0,0,1,3.264,3.313.625.625,0,0,1,.139.429.742.742,0,0,1-.159.447c-.2.271-.525.7-1.008,1.3-.467.581-.827,1.043-1.069,1.373a11.8,11.8,0,0,1,.812,1.91l3.62.545a.626.626,0,0,1,.416.244.736.736,0,0,1,.158.457v4.325a.755.755,0,0,1-.158.449.6.6,0,0,1-.4.253l-3.66.545a12.692,12.692,0,0,1-.772,1.774c.465.653,1.177,1.559,2.117,2.688a.751.751,0,0,1,.2.488.648.648,0,0,1-.178.448,19.638,19.638,0,0,1-1.958,2.1c-.947.918-1.573,1.384-1.861,1.384a.976.976,0,0,1-.515-.176l-2.731-2.1a11.361,11.361,0,0,1-1.8.741,31.849,31.849,0,0,1-.573,3.625.668.668,0,0,1-.713.546Zm-1.385-18.491a4.935,4.935,0,0,0,0,7.053,5.12,5.12,0,0,0,7.163,0,4.931,4.931,0,0,0,0-7.053,5.117,5.117,0,0,0-7.163,0Zm69.969,14.868a18.523,18.523,0,0,1-4.932-2.073l1.705-6.1A13.441,13.441,0,0,0,200.779,29a12.14,12.14,0,0,0,4.344.818,4.644,4.644,0,0,0,2.351-.482,1.538,1.538,0,0,0,.806-1.4q0-1.5-3.25-2.242-1.061-.246-1.705-.425a12.335,12.335,0,0,1-5.358-2.589,5.5,5.5,0,0,1-1.671-4.157,6.323,6.323,0,0,1,2.547-5.267,10.993,10.993,0,0,1,6.9-1.972,21.351,21.351,0,0,1,4.552.5,25.439,25.439,0,0,1,4.736,1.557l-1.705,5.491a14.244,14.244,0,0,0-3.319-1.636,10.6,10.6,0,0,0-3.364-.561,4.227,4.227,0,0,0-2.121.426,1.357,1.357,0,0,0-.714,1.232q0,1.211,3.227,2.04.737.2,1.106.291,4.264,1.187,5.935,2.79a5.728,5.728,0,0,1,1.67,4.337A6.781,6.781,0,0,1,213,33.37a11.48,11.48,0,0,1-7.259,2.14A22.577,22.577,0,0,1,200.053,34.827ZM30.568,31.834a12.566,12.566,0,0,1-3.292-8.59,12.567,12.567,0,0,1,3.247-8.568,11.3,11.3,0,0,1,8.423-3.638,9.519,9.519,0,0,1,7.217,3V11.8h8.264V34.735H46.163V32.186h-.09c-1.32,2.071-3.951,3.308-7.038,3.308A11.412,11.412,0,0,1,30.568,31.834Zm5.245-8.545a4.95,4.95,0,0,0,5.312,5.141,4.95,4.95,0,0,0,5.312-5.141A5.023,5.023,0,0,0,41.125,18.1,5.023,5.023,0,0,0,35.813,23.289Zm69.2,11.554-3.527-10.452q-.282-.892-.505-1.8t-.412-1.8a30.821,30.821,0,0,1-.917,3.454l-.047.16L96.1,34.842H90.176l-9.925-23.1h8.632l3.552,10.223q.4,1.12.634,1.955t.377,1.635a23.558,23.558,0,0,1,.917-3.179q.093-.274.141-.411l3.528-10.223h5.056l3.5,10.2.07.183a20.724,20.724,0,0,1,.988,3.43q.141-.732.364-1.532t.647-2.058l3.574-10.223h8.678l-9.971,23.1Zm80.154-.092-8.587-9.841v9.841h-7.888V1.5L176.583,0V22.28l8.272-9.665h9.96L184.584,23.266l11.156,11.485Zm-35.09,0V11.782h8.272v3.761h.091a8.131,8.131,0,0,1,7.546-4.074h1.593V19.3a6.8,6.8,0,0,0-3.5-.761c-4.593,0-5.728,3-5.728,6.941v9.268Z" transform="translate(17.13 15.31)"/></g><g transform="matrix(1, 0, 0, 1, -17.13, -9.94)" filter="url(#c)"><path d="M3.576-12.852v-4.3H6.628a2.867,2.867,0,0,1,1.945.55A2.034,2.034,0,0,1,9.188-15a2.06,2.06,0,0,1-.615,1.608,2.784,2.784,0,0,1-1.945.542ZM2.017-18.464V-6.748H3.576v-4.792H7.153a3.569,3.569,0,0,0,2.683-.9A3.478,3.478,0,0,0,10.747-15a3.45,3.45,0,0,0-.911-2.552,3.638,3.638,0,0,0-2.683-.911Zm11.421,7.483a4.221,4.221,0,0,1,.205-1.37,2.957,2.957,0,0,1,.566-1.009,2.411,2.411,0,0,1,.845-.624A2.515,2.515,0,0,1,16.08-14.2a2.515,2.515,0,0,1,1.026.213,2.411,2.411,0,0,1,.845.624,2.957,2.957,0,0,1,.566,1.009,4.221,4.221,0,0,1,.205,1.37,4.221,4.221,0,0,1-.205,1.37,2.867,2.867,0,0,1-.566,1,2.457,2.457,0,0,1-.845.615,2.515,2.515,0,0,1-1.026.213,2.515,2.515,0,0,1-1.026-.213,2.457,2.457,0,0,1-.845-.615,2.867,2.867,0,0,1-.566-1A4.221,4.221,0,0,1,13.438-10.981Zm-1.477,0a5.573,5.573,0,0,0,.263,1.739,3.97,3.97,0,0,0,.788,1.4,3.623,3.623,0,0,0,1.3.935,4.4,4.4,0,0,0,1.772.336A4.381,4.381,0,0,0,17.86-6.9a3.641,3.641,0,0,0,1.288-.935,3.97,3.97,0,0,0,.788-1.4,5.573,5.573,0,0,0,.263-1.739,5.65,5.65,0,0,0-.263-1.748,3.96,3.96,0,0,0-.788-1.411,3.729,3.729,0,0,0-1.288-.944,4.29,4.29,0,0,0-1.78-.345,4.3,4.3,0,0,0-1.772.345,3.71,3.71,0,0,0-1.3.944,3.96,3.96,0,0,0-.788,1.411A5.65,5.65,0,0,0,11.961-10.981Zm18.28,4.234,2.708-8.484H31.5L29.6-8.29h-.033L27.8-15.231H26.27L24.564-8.29h-.033l-1.92-6.941H21.068l2.724,8.484H25.3l1.707-6.744h.033l1.723,6.744ZM40.169-11.8H35.3a2.905,2.905,0,0,1,.213-.927A2.473,2.473,0,0,1,36-13.492a2.255,2.255,0,0,1,.747-.517,2.429,2.429,0,0,1,.976-.189,2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,40.169-11.8Zm1.346,2.363H40.136a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.105,5.105,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,41.515-9.439Zm1.526-5.793v8.484h1.395v-3.774a5.8,5.8,0,0,1,.164-1.452,2.784,2.784,0,0,1,.525-1.075,2.251,2.251,0,0,1,.952-.673,3.945,3.945,0,0,1,1.428-.23v-1.477a3.135,3.135,0,0,0-1.871.459,3.779,3.779,0,0,0-1.247,1.526h-.033v-1.789ZM54.15-11.8H49.276a2.905,2.905,0,0,1,.213-.927,2.473,2.473,0,0,1,.492-.763,2.255,2.255,0,0,1,.747-.517A2.429,2.429,0,0,1,51.7-14.2a2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,54.15-11.8ZM55.5-9.439H54.117a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.1,5.1,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,55.5-9.439Zm2.593-1.477a5.581,5.581,0,0,1,.131-1.214,3.212,3.212,0,0,1,.427-1.05,2.221,2.221,0,0,1,.788-.738,2.4,2.4,0,0,1,1.2-.279,2.589,2.589,0,0,1,1.231.271,2.389,2.389,0,0,1,.829.714,2.985,2.985,0,0,1,.468,1.026,4.889,4.889,0,0,1,.148,1.206,4.919,4.919,0,0,1-.139,1.165,3.053,3.053,0,0,1-.451,1.026,2.4,2.4,0,0,1-.8.73,2.4,2.4,0,0,1-1.2.279,2.491,2.491,0,0,1-1.173-.263,2.332,2.332,0,0,1-.82-.706,3.122,3.122,0,0,1-.476-1.009A4.338,4.338,0,0,1,58.088-10.916Zm6.564,4.168V-18.464H63.257V-14.1h-.033a2.247,2.247,0,0,0-.566-.632,3.216,3.216,0,0,0-.714-.41,3.583,3.583,0,0,0-.755-.222,4.132,4.132,0,0,0-.706-.066,3.861,3.861,0,0,0-1.7.353,3.487,3.487,0,0,0-1.214.952,4.018,4.018,0,0,0-.722,1.4,5.985,5.985,0,0,0-.238,1.707,5.8,5.8,0,0,0,.246,1.707,4.218,4.218,0,0,0,.73,1.411,3.529,3.529,0,0,0,1.214.968,3.827,3.827,0,0,0,1.715.361,4.135,4.135,0,0,0,1.625-.312A2.053,2.053,0,0,0,63.224-7.9h.033v1.149Zm6.761-11.716V-6.748h1.395V-7.88h.033a2.247,2.247,0,0,0,.566.632,2.982,2.982,0,0,0,.714.4,3.874,3.874,0,0,0,.763.213,4.193,4.193,0,0,0,.7.066,3.94,3.94,0,0,0,1.7-.345,3.4,3.4,0,0,0,1.214-.944,4.018,4.018,0,0,0,.722-1.4,5.985,5.985,0,0,0,.238-1.707,5.8,5.8,0,0,0-.246-1.707,4.312,4.312,0,0,0-.73-1.419,3.488,3.488,0,0,0-1.214-.976,3.827,3.827,0,0,0-1.715-.361,4.043,4.043,0,0,0-1.625.32,2.088,2.088,0,0,0-1.083,1.026h-.033v-4.381Zm6.564,7.4a5.581,5.581,0,0,1-.131,1.214,3.212,3.212,0,0,1-.427,1.05,2.243,2.243,0,0,1-.779.738,2.385,2.385,0,0,1-1.206.279A2.589,2.589,0,0,1,74.2-8.052a2.389,2.389,0,0,1-.829-.714,2.985,2.985,0,0,1-.468-1.026A4.889,4.889,0,0,1,72.758-11a4.919,4.919,0,0,1,.139-1.165,3.053,3.053,0,0,1,.451-1.026,2.4,2.4,0,0,1,.8-.73,2.4,2.4,0,0,1,1.2-.279,2.491,2.491,0,0,1,1.173.263,2.332,2.332,0,0,1,.82.706,3.122,3.122,0,0,1,.476,1.009A4.338,4.338,0,0,1,77.976-11.063Zm6.449,5.448a8.871,8.871,0,0,1-.484,1.05,2.871,2.871,0,0,1-.525.7,1.782,1.782,0,0,1-.64.394,2.462,2.462,0,0,1-.812.123,3.721,3.721,0,0,1-.492-.033A2.324,2.324,0,0,1,81-3.5v-1.28a2.342,2.342,0,0,0,.418.139,1.765,1.765,0,0,0,.4.057,1.2,1.2,0,0,0,.714-.205,1.255,1.255,0,0,0,.435-.583L83.539-6.8l-3.364-8.434h1.575L84.228-8.29h.033l2.379-6.941h1.477Z" transform="translate(17.85 28.4)"/></g></g></g><g transform="translate(0 0)"><g transform="translate(0 5.371)"><path d="M11.76,24.456A11.41,11.41,0,0,1,3.292,20.8,12.564,12.564,0,0,1,0,12.206,12.569,12.569,0,0,1,3.246,3.638,11.307,11.307,0,0,1,11.67,0a9.519,9.519,0,0,1,7.217,3V.759h8.264V23.7H18.887V21.148H18.8C17.478,23.219,14.846,24.456,11.76,24.456ZM13.849,7.064A5.023,5.023,0,0,0,8.537,12.25a4.95,4.95,0,0,0,5.312,5.141A4.95,4.95,0,0,0,19.16,12.25,5.023,5.023,0,0,0,13.849,7.064Z" transform="translate(27.277 11.038)" fill="#fff"/><path d="M0,33.931V.758H8.271v2.6H8.36A8.258,8.258,0,0,1,15.406,0,11.4,11.4,0,0,1,23.9,3.686a12.665,12.665,0,0,1,3.278,8.622,12.508,12.508,0,0,1-3.25,8.57,11.351,11.351,0,0,1-8.429,3.6,9.535,9.535,0,0,1-7.229-2.95V32.337L0,33.931ZM13.317,7.07A5.028,5.028,0,0,0,8,12.259a4.957,4.957,0,0,0,5.319,5.15,4.957,4.957,0,0,0,5.319-5.15A5.028,5.028,0,0,0,13.317,7.07Z" transform="translate(55.766 11.041)" fill="#fff"/><path d="M22.836,0l3.5,10.2.07.183a20.748,20.748,0,0,1,.988,3.43q.141-.731.364-1.532t.647-2.058L31.985,0h8.678L30.691,23.1H24.764L21.237,12.647q-.282-.891-.505-1.8t-.412-1.8A30.927,30.927,0,0,1,19.4,12.51l-.047.16L15.851,23.1H9.925L0,0H8.631l3.552,10.223q.4,1.121.635,1.955t.377,1.635a23.522,23.522,0,0,1,.917-3.179q.093-.274.141-.411L17.78,0h5.056" transform="translate(80.251 11.743)" fill="#fff"/><path d="M0,34.75V1.5L7.888,0V22.28l8.272-9.665H26.12L15.889,23.266,27.045,34.75H16.475L7.888,24.91v9.84H0" transform="translate(168.695 0)" fill="#fff"/><path d="M0,21.47l1.705-6.1a13.453,13.453,0,0,0,3.952,2.342A12.145,12.145,0,0,0,10,18.534a4.643,4.643,0,0,0,2.351-.482,1.539,1.539,0,0,0,.807-1.4q0-1.5-3.25-2.241-1.06-.246-1.705-.426A12.325,12.325,0,0,1,2.846,11.4,5.5,5.5,0,0,1,1.176,7.239,6.324,6.324,0,0,1,3.722,1.972,11,11,0,0,1,10.624,0a21.365,21.365,0,0,1,4.551.5,25.45,25.45,0,0,1,4.736,1.558l-1.706,5.49a14.24,14.24,0,0,0-3.319-1.636,10.6,10.6,0,0,0-3.364-.56A4.22,4.22,0,0,0,9.4,5.782a1.356,1.356,0,0,0-.714,1.233q0,1.211,3.227,2.04.737.2,1.106.291,4.264,1.188,5.935,2.79a5.728,5.728,0,0,1,1.671,4.337,6.782,6.782,0,0,1-2.743,5.614,11.478,11.478,0,0,1-7.259,2.14,22.565,22.565,0,0,1-5.693-.683A18.517,18.517,0,0,1,0,21.47" transform="translate(195.121 11.284)" fill="#fff"/><path d="M8.273,4.075h.091A8.13,8.13,0,0,1,15.909,0H17.5V7.834A6.8,6.8,0,0,0,14,7.074c-4.593,0-5.728,3-5.728,6.941v9.268H0V.313H8.273V4.075" transform="translate(150.08 11.469)" fill="#fff"/><path d="M17.392,29.929H13a.76.76,0,0,1-.485-.166.579.579,0,0,1-.227-.419l-.553-3.586a12.3,12.3,0,0,1-1.781-.721L7.163,27.123a.719.719,0,0,1-.495.176.687.687,0,0,1-.495-.214A25.873,25.873,0,0,1,2.91,23.81a.753.753,0,0,1,.019-.9c.2-.277.542-.713,1.009-1.3.483-.6.832-1.05,1.068-1.374a9.591,9.591,0,0,1-.811-1.929l-3.62-.526a.63.63,0,0,1-.416-.243A.729.729,0,0,1,0,17.089V12.762a.746.746,0,0,1,.159-.448.6.6,0,0,1,.376-.253l3.68-.546a9.5,9.5,0,0,1,.772-1.792C4.464,8.991,3.752,8.085,2.87,7.034a.732.732,0,0,1-.2-.468.82.82,0,0,1,.179-.449A19.622,19.622,0,0,1,4.8,4.023C5.751,3.1,6.38,2.631,6.668,2.631a.859.859,0,0,1,.515.194L9.913,4.91a11.536,11.536,0,0,1,1.8-.741A31.372,31.372,0,0,1,12.287.546.665.665,0,0,1,13,0h4.392a.755.755,0,0,1,.485.166.581.581,0,0,1,.229.419l.553,3.584a12.543,12.543,0,0,1,1.781.722L23.25,2.807a.641.641,0,0,1,.475-.176.775.775,0,0,1,.495.194,27.092,27.092,0,0,1,3.264,3.313.625.625,0,0,1,.139.429.745.745,0,0,1-.159.448c-.2.271-.525.695-1.008,1.3-.467.581-.827,1.043-1.069,1.373a11.784,11.784,0,0,1,.812,1.91l3.62.545a.625.625,0,0,1,.416.244.736.736,0,0,1,.157.458v4.325a.754.754,0,0,1-.157.449.606.606,0,0,1-.4.253l-3.66.545a12.628,12.628,0,0,1-.772,1.774c.465.654,1.177,1.559,2.117,2.688a.752.752,0,0,1,.2.488.648.648,0,0,1-.177.448,19.641,19.641,0,0,1-1.959,2.1c-.947.918-1.573,1.384-1.86,1.384a.978.978,0,0,1-.515-.176l-2.731-2.1a11.429,11.429,0,0,1-1.8.741,32.016,32.016,0,0,1-.573,3.624A.668.668,0,0,1,17.392,29.929ZM15.2,9.976a4.938,4.938,0,0,0-3.582,1.463,4.935,4.935,0,0,0,0,7.053,5.12,5.12,0,0,0,7.163,0,4.932,4.932,0,0,0,0-7.053A4.938,4.938,0,0,0,15.2,9.976Z" transform="translate(118.47 8.521)" fill="#fff"/><path d="M0,33.5,16.106,7.374H2.752V0H30.9L14.887,26.122H38.22L0,33.5" transform="translate(0 11.038)" fill="#fff"/></g><path d="M3.576-12.852v-4.3H6.628a2.867,2.867,0,0,1,1.945.55A2.034,2.034,0,0,1,9.188-15a2.06,2.06,0,0,1-.615,1.608,2.784,2.784,0,0,1-1.945.542ZM2.017-18.464V-6.748H3.576v-4.792H7.153a3.569,3.569,0,0,0,2.683-.9A3.478,3.478,0,0,0,10.747-15a3.45,3.45,0,0,0-.911-2.552,3.638,3.638,0,0,0-2.683-.911Zm11.421,7.483a4.221,4.221,0,0,1,.205-1.37,2.957,2.957,0,0,1,.566-1.009,2.411,2.411,0,0,1,.845-.624A2.515,2.515,0,0,1,16.08-14.2a2.515,2.515,0,0,1,1.026.213,2.411,2.411,0,0,1,.845.624,2.957,2.957,0,0,1,.566,1.009,4.221,4.221,0,0,1,.205,1.37,4.221,4.221,0,0,1-.205,1.37,2.867,2.867,0,0,1-.566,1,2.457,2.457,0,0,1-.845.615,2.515,2.515,0,0,1-1.026.213,2.515,2.515,0,0,1-1.026-.213,2.457,2.457,0,0,1-.845-.615,2.867,2.867,0,0,1-.566-1A4.221,4.221,0,0,1,13.438-10.981Zm-1.477,0a5.573,5.573,0,0,0,.263,1.739,3.97,3.97,0,0,0,.788,1.4,3.623,3.623,0,0,0,1.3.935,4.4,4.4,0,0,0,1.772.336A4.381,4.381,0,0,0,17.86-6.9a3.641,3.641,0,0,0,1.288-.935,3.97,3.97,0,0,0,.788-1.4,5.573,5.573,0,0,0,.263-1.739,5.65,5.65,0,0,0-.263-1.748,3.96,3.96,0,0,0-.788-1.411,3.729,3.729,0,0,0-1.288-.944,4.29,4.29,0,0,0-1.78-.345,4.3,4.3,0,0,0-1.772.345,3.71,3.71,0,0,0-1.3.944,3.96,3.96,0,0,0-.788,1.411A5.65,5.65,0,0,0,11.961-10.981Zm18.28,4.234,2.708-8.484H31.5L29.6-8.29h-.033L27.8-15.231H26.27L24.564-8.29h-.033l-1.92-6.941H21.068l2.724,8.484H25.3l1.707-6.744h.033l1.723,6.744ZM40.169-11.8H35.3a2.905,2.905,0,0,1,.213-.927A2.473,2.473,0,0,1,36-13.492a2.255,2.255,0,0,1,.747-.517,2.429,2.429,0,0,1,.976-.189,2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,40.169-11.8Zm1.346,2.363H40.136a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.105,5.105,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,41.515-9.439Zm1.526-5.793v8.484h1.395v-3.774a5.8,5.8,0,0,1,.164-1.452,2.784,2.784,0,0,1,.525-1.075,2.251,2.251,0,0,1,.952-.673,3.945,3.945,0,0,1,1.428-.23v-1.477a3.135,3.135,0,0,0-1.871.459,3.779,3.779,0,0,0-1.247,1.526h-.033v-1.789ZM54.15-11.8H49.276a2.905,2.905,0,0,1,.213-.927,2.473,2.473,0,0,1,.492-.763,2.255,2.255,0,0,1,.747-.517A2.429,2.429,0,0,1,51.7-14.2a2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,54.15-11.8ZM55.5-9.439H54.117a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.1,5.1,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,55.5-9.439Zm2.593-1.477a5.581,5.581,0,0,1,.131-1.214,3.212,3.212,0,0,1,.427-1.05,2.221,2.221,0,0,1,.788-.738,2.4,2.4,0,0,1,1.2-.279,2.589,2.589,0,0,1,1.231.271,2.389,2.389,0,0,1,.829.714,2.985,2.985,0,0,1,.468,1.026,4.889,4.889,0,0,1,.148,1.206,4.919,4.919,0,0,1-.139,1.165,3.053,3.053,0,0,1-.451,1.026,2.4,2.4,0,0,1-.8.73,2.4,2.4,0,0,1-1.2.279,2.491,2.491,0,0,1-1.173-.263,2.332,2.332,0,0,1-.82-.706,3.122,3.122,0,0,1-.476-1.009A4.338,4.338,0,0,1,58.088-10.916Zm6.564,4.168V-18.464H63.257V-14.1h-.033a2.247,2.247,0,0,0-.566-.632,3.216,3.216,0,0,0-.714-.41,3.583,3.583,0,0,0-.755-.222,4.132,4.132,0,0,0-.706-.066,3.861,3.861,0,0,0-1.7.353,3.487,3.487,0,0,0-1.214.952,4.018,4.018,0,0,0-.722,1.4,5.985,5.985,0,0,0-.238,1.707,5.8,5.8,0,0,0,.246,1.707,4.218,4.218,0,0,0,.73,1.411,3.529,3.529,0,0,0,1.214.968,3.827,3.827,0,0,0,1.715.361,4.135,4.135,0,0,0,1.625-.312A2.053,2.053,0,0,0,63.224-7.9h.033v1.149Zm6.761-11.716V-6.748h1.395V-7.88h.033a2.247,2.247,0,0,0,.566.632,2.982,2.982,0,0,0,.714.4,3.874,3.874,0,0,0,.763.213,4.193,4.193,0,0,0,.7.066,3.94,3.94,0,0,0,1.7-.345,3.4,3.4,0,0,0,1.214-.944,4.018,4.018,0,0,0,.722-1.4,5.985,5.985,0,0,0,.238-1.707,5.8,5.8,0,0,0-.246-1.707,4.312,4.312,0,0,0-.73-1.419,3.488,3.488,0,0,0-1.214-.976,3.827,3.827,0,0,0-1.715-.361,4.043,4.043,0,0,0-1.625.32,2.088,2.088,0,0,0-1.083,1.026h-.033v-4.381Zm6.564,7.4a5.581,5.581,0,0,1-.131,1.214,3.212,3.212,0,0,1-.427,1.05,2.243,2.243,0,0,1-.779.738,2.385,2.385,0,0,1-1.206.279A2.589,2.589,0,0,1,74.2-8.052a2.389,2.389,0,0,1-.829-.714,2.985,2.985,0,0,1-.468-1.026A4.889,4.889,0,0,1,72.758-11a4.919,4.919,0,0,1,.139-1.165,3.053,3.053,0,0,1,.451-1.026,2.4,2.4,0,0,1,.8-.73,2.4,2.4,0,0,1,1.2-.279,2.491,2.491,0,0,1,1.173.263,2.332,2.332,0,0,1,.82.706,3.122,3.122,0,0,1,.476,1.009A4.338,4.338,0,0,1,77.976-11.063Zm6.449,5.448a8.871,8.871,0,0,1-.484,1.05,2.871,2.871,0,0,1-.525.7,1.782,1.782,0,0,1-.64.394,2.462,2.462,0,0,1-.812.123,3.721,3.721,0,0,1-.492-.033A2.324,2.324,0,0,1,81-3.5v-1.28a2.342,2.342,0,0,0,.418.139,1.765,1.765,0,0,0,.4.057,1.2,1.2,0,0,0,.714-.205,1.255,1.255,0,0,0,.435-.583L83.539-6.8l-3.364-8.434h1.575L84.228-8.29h.033l2.379-6.941h1.477Z" transform="translate(0.722 18.464)" fill="#fff"/></g></g></g></svg>`;



var $15341bfe28675a89$exports = {};

$parcel$export($15341bfe28675a89$exports, "create", function () { return $15341bfe28675a89$export$185802fd694ee1f5; });
$parcel$export($15341bfe28675a89$exports, "clone", function () { return $15341bfe28675a89$export$9cd59f9826255e47; });
$parcel$export($15341bfe28675a89$exports, "fromValues", function () { return $15341bfe28675a89$export$a82be99ed2a44a7d; });
$parcel$export($15341bfe28675a89$exports, "copy", function () { return $15341bfe28675a89$export$784d13d8ee351f07; });
$parcel$export($15341bfe28675a89$exports, "set", function () { return $15341bfe28675a89$export$adaa4cf7ef1b65be; });
$parcel$export($15341bfe28675a89$exports, "add", function () { return $15341bfe28675a89$export$e16d8520af44a096; });
$parcel$export($15341bfe28675a89$exports, "subtract", function () { return $15341bfe28675a89$export$4e2d2ead65e5f7e3; });
$parcel$export($15341bfe28675a89$exports, "multiply", function () { return $15341bfe28675a89$export$2060d2db72cce88f; });
$parcel$export($15341bfe28675a89$exports, "divide", function () { return $15341bfe28675a89$export$cd007d971a5a2143; });
$parcel$export($15341bfe28675a89$exports, "ceil", function () { return $15341bfe28675a89$export$803ce6b71a0a94b2; });
$parcel$export($15341bfe28675a89$exports, "floor", function () { return $15341bfe28675a89$export$a3fe094919f356fd; });
$parcel$export($15341bfe28675a89$exports, "min", function () { return $15341bfe28675a89$export$96ec731ed4dcb222; });
$parcel$export($15341bfe28675a89$exports, "max", function () { return $15341bfe28675a89$export$8960430cfd85939f; });
$parcel$export($15341bfe28675a89$exports, "round", function () { return $15341bfe28675a89$export$2077e0241d6afd3c; });
$parcel$export($15341bfe28675a89$exports, "scale", function () { return $15341bfe28675a89$export$dcdf75081b88279d; });
$parcel$export($15341bfe28675a89$exports, "scaleAndAdd", function () { return $15341bfe28675a89$export$19cedf1da84ba854; });
$parcel$export($15341bfe28675a89$exports, "distance", function () { return $15341bfe28675a89$export$9f17032d917177de; });
$parcel$export($15341bfe28675a89$exports, "squaredDistance", function () { return $15341bfe28675a89$export$88e6ebb4fe54f538; });
$parcel$export($15341bfe28675a89$exports, "length", function () { return $15341bfe28675a89$export$f24224f1c91d8156; });
$parcel$export($15341bfe28675a89$exports, "squaredLength", function () { return $15341bfe28675a89$export$ab44e1323ffc8376; });
$parcel$export($15341bfe28675a89$exports, "negate", function () { return $15341bfe28675a89$export$aef51622e549b8b0; });
$parcel$export($15341bfe28675a89$exports, "inverse", function () { return $15341bfe28675a89$export$70ae2c07e401031b; });
$parcel$export($15341bfe28675a89$exports, "normalize", function () { return $15341bfe28675a89$export$a3295358bff77e; });
$parcel$export($15341bfe28675a89$exports, "dot", function () { return $15341bfe28675a89$export$94132a0e348806d4; });
$parcel$export($15341bfe28675a89$exports, "cross", function () { return $15341bfe28675a89$export$bb646b20bb93d339; });
$parcel$export($15341bfe28675a89$exports, "lerp", function () { return $15341bfe28675a89$export$3a89f8d6f6bf6c9f; });
$parcel$export($15341bfe28675a89$exports, "random", function () { return $15341bfe28675a89$export$4385e60b38654f68; });
$parcel$export($15341bfe28675a89$exports, "transformMat2", function () { return $15341bfe28675a89$export$b732428d73874bfc; });
$parcel$export($15341bfe28675a89$exports, "transformMat2d", function () { return $15341bfe28675a89$export$3e55bc4b3707dfd3; });
$parcel$export($15341bfe28675a89$exports, "transformMat3", function () { return $15341bfe28675a89$export$f0bfa0a0024626ee; });
$parcel$export($15341bfe28675a89$exports, "transformMat4", function () { return $15341bfe28675a89$export$5ffbd13800309d59; });
$parcel$export($15341bfe28675a89$exports, "rotate", function () { return $15341bfe28675a89$export$bb628a54ab399bc9; });
$parcel$export($15341bfe28675a89$exports, "angle", function () { return $15341bfe28675a89$export$944b09d2ad10b378; });
$parcel$export($15341bfe28675a89$exports, "zero", function () { return $15341bfe28675a89$export$7f9972325ebfd559; });
$parcel$export($15341bfe28675a89$exports, "str", function () { return $15341bfe28675a89$export$42d51816ce590c93; });
$parcel$export($15341bfe28675a89$exports, "exactEquals", function () { return $15341bfe28675a89$export$f2599a5cf1109d8; });
$parcel$export($15341bfe28675a89$exports, "equals", function () { return $15341bfe28675a89$export$e9bab7fafb253603; });
$parcel$export($15341bfe28675a89$exports, "len", function () { return $15341bfe28675a89$export$fc1400facf92c78; });
$parcel$export($15341bfe28675a89$exports, "sub", function () { return $15341bfe28675a89$export$f93b5905241a7cca; });
$parcel$export($15341bfe28675a89$exports, "mul", function () { return $15341bfe28675a89$export$6e3a27864ab166fe; });
$parcel$export($15341bfe28675a89$exports, "div", function () { return $15341bfe28675a89$export$159d9494db57879b; });
$parcel$export($15341bfe28675a89$exports, "dist", function () { return $15341bfe28675a89$export$6c4a311cc157c764; });
$parcel$export($15341bfe28675a89$exports, "sqrDist", function () { return $15341bfe28675a89$export$2422cd6c492a8b3a; });
$parcel$export($15341bfe28675a89$exports, "sqrLen", function () { return $15341bfe28675a89$export$99d8dd3f32a3435; });
$parcel$export($15341bfe28675a89$exports, "forEach", function () { return $15341bfe28675a89$export$4b80e395e36b5a56; });

function $15341bfe28675a89$export$185802fd694ee1f5() {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(2);
    if ($ff5897571e714368$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $15341bfe28675a89$export$9cd59f9826255e47(a) {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $15341bfe28675a89$export$a82be99ed2a44a7d(x, y) {
    var out = new $ff5897571e714368$export$b67359430d3b1b2(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $15341bfe28675a89$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $15341bfe28675a89$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $15341bfe28675a89$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $15341bfe28675a89$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $15341bfe28675a89$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $15341bfe28675a89$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $15341bfe28675a89$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $15341bfe28675a89$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $15341bfe28675a89$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $15341bfe28675a89$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $15341bfe28675a89$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $15341bfe28675a89$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $15341bfe28675a89$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $15341bfe28675a89$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $15341bfe28675a89$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $15341bfe28675a89$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $15341bfe28675a89$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $15341bfe28675a89$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $15341bfe28675a89$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $15341bfe28675a89$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $15341bfe28675a89$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $15341bfe28675a89$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $15341bfe28675a89$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $15341bfe28675a89$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $ff5897571e714368$export$5ada478c8a628231() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $15341bfe28675a89$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $15341bfe28675a89$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $15341bfe28675a89$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $15341bfe28675a89$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $15341bfe28675a89$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $15341bfe28675a89$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $15341bfe28675a89$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $15341bfe28675a89$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $15341bfe28675a89$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $15341bfe28675a89$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $ff5897571e714368$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $15341bfe28675a89$export$fc1400facf92c78 = $15341bfe28675a89$export$f24224f1c91d8156;
var $15341bfe28675a89$export$f93b5905241a7cca = $15341bfe28675a89$export$4e2d2ead65e5f7e3;
var $15341bfe28675a89$export$6e3a27864ab166fe = $15341bfe28675a89$export$2060d2db72cce88f;
var $15341bfe28675a89$export$159d9494db57879b = $15341bfe28675a89$export$cd007d971a5a2143;
var $15341bfe28675a89$export$6c4a311cc157c764 = $15341bfe28675a89$export$9f17032d917177de;
var $15341bfe28675a89$export$2422cd6c492a8b3a = $15341bfe28675a89$export$88e6ebb4fe54f538;
var $15341bfe28675a89$export$99d8dd3f32a3435 = $15341bfe28675a89$export$ab44e1323ffc8376;
var $15341bfe28675a89$export$4b80e395e36b5a56 = function() {
    var vec = $15341bfe28675a89$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();



function $a1d0afa1b14d7ed2$export$ccd5084c909b35f5(info) {
    switch(info.type){
        case (0, $c937c8c7cc26bb65$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR:
            return $a1d0afa1b14d7ed2$var$planar(info);
        case (0, $c937c8c7cc26bb65$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CYLINDRICAL:
            return $a1d0afa1b14d7ed2$var$cylindrical(info);
        case (0, $c937c8c7cc26bb65$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CONICAL:
            return $a1d0afa1b14d7ed2$var$conical(info);
    }
    return $a1d0afa1b14d7ed2$var$defaultMesh();
}
function $a1d0afa1b14d7ed2$var$planar(info) {
    const aspectRatio = info.trainedWidth / info.trainedHeight;
    if (isNaN(aspectRatio)) return $a1d0afa1b14d7ed2$var$defaultMesh();
    const scaling = info.physicalScaleFactor > 0 ? info.physicalScaleFactor : 1;
    const vertices = new Float32Array([
        -1 * aspectRatio * scaling,
        -1 * scaling,
        0,
        -1 * aspectRatio * scaling,
        scaling,
        0,
        aspectRatio * scaling,
        scaling,
        0,
        aspectRatio * scaling,
        -1 * scaling,
        0
    ]);
    const indices = new Uint16Array([
        0,
        2,
        1,
        0,
        3,
        2
    ]);
    const uvs = new Float32Array([
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0
    ]);
    const normals = new Float32Array([
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1
    ]);
    return {
        vertices: vertices,
        indices: indices,
        uvs: uvs,
        normals: normals
    };
}
function $a1d0afa1b14d7ed2$var$defaultMesh() {
    return {
        indices: new Uint16Array(0),
        vertices: new Float32Array(0),
        normals: new Float32Array(0),
        uvs: new Float32Array(0)
    };
}
function $a1d0afa1b14d7ed2$var$cylindrical(info) {
    const wrap_amount = 2 * info.trainedWidth / (info.trainedHeight * info.topRadius);
    return $a1d0afa1b14d7ed2$var$generalConical(info, 2, false, 0, 0, 0, (0, $15341bfe28675a89$exports).create(), info.trainedWidth / info.trainedHeight, wrap_amount, info.physicalScaleFactor);
}
function $a1d0afa1b14d7ed2$var$conical(info) {
    const radius_diff = info.topRadius - info.bottomRadius;
    // Prevents divide by zero errors.
    if (radius_diff === 0) {
        console.warn("Conical target has matching radii, using cylindrical preview mesh with a defined image size instead.");
        return $a1d0afa1b14d7ed2$var$cylindrical(info);
    }
    const height_3d = Math.sqrt(info.sideLength * info.sideLength - radius_diff * radius_diff);
    const flip = info.bottomRadius > info.topRadius;
    let aspect_ratio = info.trainedWidth / info.trainedHeight;
    if (isNaN(aspect_ratio)) aspect_ratio = 1;
    const cone = !(info.bottomRadius > 0) || !(info.topRadius > 0);
    const wide = info.sideLength < 2 * Math.abs(info.topRadius - info.bottomRadius);
    const top_corner = (0, $15341bfe28675a89$exports).create();
    const bottom_corner = (0, $15341bfe28675a89$exports).create();
    const rotation_center = (0, $15341bfe28675a89$exports).create();
    if (cone) {
        if (wide) {
            if (flip) {
                rotation_center[1] = aspect_ratio - 1;
                const omega = Math.acos((2 - aspect_ratio) / aspect_ratio);
                top_corner[0] = aspect_ratio * Math.sin(omega);
                top_corner[1] = aspect_ratio - 1 + aspect_ratio * Math.cos(omega);
                (0, $15341bfe28675a89$exports).copy(bottom_corner, rotation_center);
            } else {
                rotation_center[1] = 1.0 - aspect_ratio;
                const omega = Math.PI + Math.acos((2 - aspect_ratio) / aspect_ratio);
                top_corner[0] = aspect_ratio * Math.sin(omega);
                top_corner[1] = 1 - aspect_ratio + aspect_ratio * Math.cos(omega);
                (0, $15341bfe28675a89$exports).copy(bottom_corner, rotation_center);
            }
        } else if (flip) {
            rotation_center[1] = 1;
            (0, $15341bfe28675a89$exports).copy(bottom_corner, rotation_center);
            top_corner[0] = aspect_ratio;
            top_corner[1] = 1 - Math.sqrt(4 - Math.pow(aspect_ratio, 2));
        } else {
            rotation_center[1] = -1;
            (0, $15341bfe28675a89$exports).copy(bottom_corner, rotation_center);
            top_corner[0] = -aspect_ratio;
            top_corner[1] = Math.sqrt(4 - Math.pow(aspect_ratio, 2)) - 1;
        }
    } else if (wide) {
        if (flip) {
            rotation_center[1] = aspect_ratio - 1;
            const omega = Math.acos((2 - aspect_ratio) / aspect_ratio);
            top_corner[0] = aspect_ratio * Math.sin(omega);
            top_corner[1] = aspect_ratio - 1 + aspect_ratio * Math.cos(omega);
            bottom_corner[0] = (aspect_ratio - info.sideLength) * Math.sin(omega);
            bottom_corner[1] = aspect_ratio - 1 + (aspect_ratio - info.sideLength) * Math.cos(omega);
        } else {
            rotation_center[1] = 1.0 - aspect_ratio;
            const omega = Math.PI + Math.acos((2 - aspect_ratio) / aspect_ratio);
            top_corner[0] = aspect_ratio * Math.sin(omega);
            top_corner[1] = 1 - aspect_ratio + aspect_ratio * Math.cos(omega);
            bottom_corner[0] = (aspect_ratio - info.sideLength) * Math.sin(omega);
            bottom_corner[1] = 1 - aspect_ratio + (aspect_ratio - info.sideLength) * Math.cos(omega);
        }
    } else {
        const radius_ratio = flip ? info.topRadius / info.bottomRadius : info.bottomRadius / info.topRadius;
        if (flip) {
            bottom_corner[0] = radius_ratio * aspect_ratio;
            bottom_corner[1] = 1;
            top_corner[0] = aspect_ratio;
            top_corner[1] = 1 - Math.sqrt(info.sideLength * info.sideLength - (bottom_corner[0] - top_corner[0]) * (bottom_corner[0] - top_corner[0]));
            rotation_center[1] = top_corner[1] + top_corner[0] / (top_corner[0] - bottom_corner[0]) * (bottom_corner[1] - top_corner[1]);
        } else {
            bottom_corner[0] = -radius_ratio * aspect_ratio;
            bottom_corner[1] = -1;
            top_corner[0] = -aspect_ratio;
            top_corner[1] = Math.sqrt(info.sideLength * info.sideLength - (bottom_corner[0] - top_corner[0]) * (bottom_corner[0] - top_corner[0])) - 1;
            rotation_center[1] = top_corner[1] - -top_corner[0] / (bottom_corner[0] - top_corner[0]) * (top_corner[1] - bottom_corner[1]);
        }
    }
    const top_from_center = (0, $15341bfe28675a89$exports).create();
    (0, $15341bfe28675a89$exports).subtract(top_from_center, top_corner, rotation_center);
    const bottom_from_center = (0, $15341bfe28675a89$exports).create();
    (0, $15341bfe28675a89$exports).subtract(bottom_from_center, bottom_corner, rotation_center);
    const top_2d_radius = (0, $15341bfe28675a89$exports).length(top_from_center);
    const bottom_2d_radius = (0, $15341bfe28675a89$exports).length(bottom_from_center);
    let max_angle = 2 * Math.abs(Math.atan(top_from_center[0] / top_from_center[1]));
    if (wide) max_angle = 2 * Math.PI - max_angle;
    let theta_3d = top_2d_radius * max_angle / info.topRadius;
    let theta = Math.abs(Math.atan(top_from_center[0] / top_from_center[1]));
    if (wide) theta = Math.PI - theta;
    return $a1d0afa1b14d7ed2$var$generalConical(info, height_3d, flip, theta, bottom_2d_radius, top_2d_radius, rotation_center, aspect_ratio, theta_3d, info.physicalScaleFactor);
}
function $a1d0afa1b14d7ed2$var$generalConical(info, height_3d, flip, theta, bottom_2d_radius, top_2d_radius, rotation_center, aspect_ratio, wrap_amount, psf) {
    if (isNaN(aspect_ratio)) aspect_ratio = 1;
    const vertices = [];
    const uvs = [];
    const physical_scale = psf > 0 ? psf : 1;
    const scale_factor = physical_scale * 2.0 / height_3d;
    const subdivisons = 64;
    for(let s = 0; s <= subdivisons; ++s){
        const angle = s * wrap_amount / subdivisons + (2 * Math.PI - wrap_amount) / 2;
        const bx = info.bottomRadius * Math.sin(angle) * scale_factor;
        const bz = info.bottomRadius * Math.cos(angle) * scale_factor;
        const tx = info.topRadius * Math.sin(angle) * scale_factor;
        const tz = info.topRadius * Math.cos(angle) * scale_factor;
        const btm = -1 * physical_scale;
        const top = physical_scale;
        if (flip) {
            vertices.push(bx, btm, bz);
            vertices.push(tx, top, tz);
        } else {
            vertices.push(tx, top, -tz);
            vertices.push(bx, btm, -bz);
        }
    }
    for(let s = 0; s <= subdivisons; ++s)if (info.type == (0, $c937c8c7cc26bb65$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CYLINDRICAL) {
        const offset = 1 - s / subdivisons;
        uvs.push(offset, 1);
        uvs.push(offset, 0);
    } else {
        let angle_2d = -(s / subdivisons - 0.5) * 2 * theta;
        if (flip) {
            angle_2d = -angle_2d + theta;
            if (angle_2d > theta) angle_2d = -theta + (angle_2d - theta);
        }
        const direction = (0, $15341bfe28675a89$exports).create();
        direction[0] = Math.sin(angle_2d);
        direction[1] = Math.cos(angle_2d);
        if (flip) direction[1] *= -1;
        const bottom_px = (0, $15341bfe28675a89$exports).create();
        (0, $15341bfe28675a89$exports).copy(bottom_px, direction);
        (0, $15341bfe28675a89$exports).scale(bottom_px, bottom_px, bottom_2d_radius);
        (0, $15341bfe28675a89$exports).add(bottom_px, rotation_center, bottom_px);
        const top_px = (0, $15341bfe28675a89$exports).create();
        (0, $15341bfe28675a89$exports).copy(top_px, direction);
        (0, $15341bfe28675a89$exports).scale(top_px, top_px, top_2d_radius);
        (0, $15341bfe28675a89$exports).add(top_px, rotation_center, top_px);
        uvs.push((top_px[0] + aspect_ratio) / (2 * aspect_ratio), 1 - (-top_px[1] + 1) / 2);
        uvs.push((bottom_px[0] + aspect_ratio) / (2 * aspect_ratio), 1 - (-bottom_px[1] + 1) / 2);
    }
    const indices = [];
    for(let i = 0; i < subdivisons; ++i){
        const bi = i * 2;
        indices.push(bi + 1, bi + 2, bi + 3);
        indices.push(bi + 0, bi + 2, bi + 1);
    }
    return {
        vertices: new Float32Array(vertices),
        indices: new Uint16Array(indices),
        normals: new Float32Array(0),
        uvs: new Float32Array(uvs)
    };
}


const $72140d0e3d48f6ff$var$decoder = new TextDecoder();
class $72140d0e3d48f6ff$export$55f75071f06461bb {
    constructor(_data, _paddingBytes = false){
        this._data = _data;
        this._paddingBytes = _paddingBytes;
        this.truncatedChunks = false;
        this._view = new DataView(this._data);
        this.root = this._parse();
    }
    _parse() {
        const header = $72140d0e3d48f6ff$var$decoder.decode(this._data.slice(0, 4));
        if (header !== "RIFF") throw new Error("Not a valid ZPT file");
        return this._parseChunk(0);
    }
    _parseChunk(offset) {
        const ident = $72140d0e3d48f6ff$var$decoder.decode(this._data.slice(offset, offset + 4));
        const length = this._view.getUint32(offset + 4, true);
        const data = new Uint8Array(this._data, offset + 8, length);
        if (data.byteLength !== length) this.truncatedChunks = true;
        let subchunks;
        let subident;
        if (ident === "RIFF" || ident === "LIST") {
            subident = $72140d0e3d48f6ff$var$decoder.decode(this._data.slice(offset + 8, offset + 12));
            subchunks = [];
            let currentOffset = 4;
            while(currentOffset < data.byteLength - 1){
                const subchunk = this._parseChunk(offset + 8 + currentOffset);
                subchunks.push(subchunk);
                currentOffset += subchunk.data.byteLength + 8;
                if (this._paddingBytes && subchunk.data.byteLength & 0x1) currentOffset++;
            }
        }
        return {
            ident: ident,
            data: data,
            subident: subident,
            subchunks: subchunks
        };
    }
    find(str, inChunk = this.root) {
        if (inChunk.ident === str) return inChunk;
        if (!inChunk.subchunks) return;
        for (let c of inChunk.subchunks){
            const found = this.find(str, c);
            if (found) return found;
        }
    }
    has(str) {
        return this.find(str) !== undefined;
    }
}


let $fee20207659b267f$var$byId = new Map();
const $fee20207659b267f$var$decoder = new TextDecoder();
class $fee20207659b267f$export$333222788f3dd075 {
    constructor(_client, _impl){
        this._client = _client;
        this._impl = _impl;
        this._targets = [];
    }
    static create(pipeline, client) {
        let ret = client.image_tracker_create(pipeline);
        $fee20207659b267f$var$byId.set(ret, new $fee20207659b267f$export$333222788f3dd075(client, ret));
        return ret;
    }
    static get(p) {
        return $fee20207659b267f$var$byId.get(p);
    }
    destroy() {
        this._client.image_tracker_destroy(this._impl);
        $fee20207659b267f$var$byId.delete(this._impl);
    }
    loadFromMemory(data) {
        this._targets.push({
            data: data
        });
        this._client.image_tracker_target_load_from_memory(this._impl, data);
    }
    targetCount() {
        return this._targets.length;
    }
    getTargetInfo(i) {
        let current = this._targets[i];
        if (current && current.info) return current.info;
        current.info = {
            topRadius: -1,
            bottomRadius: -1,
            sideLength: -1,
            physicalScaleFactor: -1,
            trainedWidth: 0,
            trainedHeight: 0,
            type: (0, $c937c8c7cc26bb65$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR
        };
        try {
            const reader = new (0, $72140d0e3d48f6ff$export$55f75071f06461bb)(current.data, false);
            const imgChunk = reader.find("IMG ");
            if (imgChunk) {
                let mimeType = "image/png";
                const mimeTypeChunk = reader.find("IMGM");
                if (mimeTypeChunk) mimeType = $fee20207659b267f$var$decoder.decode(mimeTypeChunk.data);
                current.info.preview = {
                    mimeType: mimeType,
                    compressed: imgChunk.data
                };
            }
            const odleChunk = reader.find("ODLE");
            if (odleChunk) {
                const odle = $fee20207659b267f$var$decoder.decode(odleChunk.data);
                this._parseOdle(odle, current.info);
            }
        } catch (err) {}
        return current.info;
    }
    _parseOdle(data, info) {
        let currentOffset = 0;
        let version = "0";
        [version, currentOffset] = $fee20207659b267f$var$readLine(currentOffset, data);
        if (version === "1") return this._parseOdleV1(data, currentOffset, info);
        else if (version === "3") return this._parseOdleV3(data, currentOffset, info);
    }
    _parseOdleV1(data, currentOffset, info) {
        let treeOrFlat = "0";
        [treeOrFlat, currentOffset] = $fee20207659b267f$var$readLine(currentOffset, data);
        if (treeOrFlat !== "0" && treeOrFlat !== "1") return;
        let emptyLine = "";
        [emptyLine, currentOffset] = $fee20207659b267f$var$readLine(currentOffset, data);
        if (emptyLine.length !== 0) return;
        let infoLine = "";
        [infoLine, currentOffset] = $fee20207659b267f$var$readLine(currentOffset, data);
        const infoLineParts = infoLine.split(" ");
        if (infoLineParts.length < 5) return;
        info.trainedWidth = parseInt(infoLineParts[3].replace("[", ""));
        info.trainedHeight = parseInt(infoLineParts[4].replace("]", ""));
    }
    _parseOdleV3(data, currentOffset, info) {
        let treeOrFlat = "0";
        [treeOrFlat, currentOffset] = $fee20207659b267f$var$readLine(currentOffset, data);
        if (treeOrFlat !== "0" && treeOrFlat !== "1") return;
        let numberTargets = "0";
        [numberTargets, currentOffset] = $fee20207659b267f$var$readLine(currentOffset, data);
        const parsedTargets = parseInt(numberTargets);
        if (isNaN(parsedTargets) || parsedTargets < 1) return;
        let emptyLine = "";
        [emptyLine, currentOffset] = $fee20207659b267f$var$readLine(currentOffset, data);
        if (emptyLine.length !== 0) return;
        let infoLine = "";
        [infoLine, currentOffset] = $fee20207659b267f$var$readLine(currentOffset, data);
        const infoLineParts = infoLine.split(" ");
        if (infoLineParts.length < 6) return;
        const targetType = parseInt(infoLineParts[0]);
        if (targetType === 0 || targetType === 1 || targetType === 2) info.type = targetType;
        info.trainedWidth = parseInt(infoLineParts[4].replace("[", ""));
        info.trainedHeight = parseInt(infoLineParts[5].replace("]", ""));
        if (infoLineParts.length >= 7) {
            info.physicalScaleFactor = parseFloat(infoLineParts[6]);
            if (isNaN(info.physicalScaleFactor)) info.physicalScaleFactor = -1;
        }
        if (infoLineParts.length >= 8) {
            info.topRadius = parseFloat(infoLineParts[7]);
            if (isNaN(info.topRadius)) info.topRadius = -1;
            info.bottomRadius = info.topRadius;
        }
        if (infoLineParts.length >= 9) {
            info.bottomRadius = parseFloat(infoLineParts[8]);
            if (isNaN(info.bottomRadius)) info.bottomRadius = -1;
        }
        if (infoLineParts.length >= 10) {
            info.sideLength = parseFloat(infoLineParts[9]);
            if (isNaN(info.sideLength)) info.sideLength = -1;
        }
    }
    getDecodedPreview(i) {
        const info = this.getTargetInfo(i);
        if (!info.preview) return undefined;
        if (!info.preview.image) {
            const blob = new Blob([
                info.preview.compressed
            ], {
                type: info.preview.mimeType
            });
            info.preview.image = new Image();
            info.preview.image.src = URL.createObjectURL(blob);
        }
        return info.preview.image;
    }
    getPreviewMesh(i) {
        const info = this.getTargetInfo(i);
        if (!info.previewMesh) info.previewMesh = (0, $a1d0afa1b14d7ed2$export$ccd5084c909b35f5)(info);
        return info.previewMesh;
    }
}
function $fee20207659b267f$var$readLine(offset, str) {
    let indx = str.indexOf("\n", offset);
    return [
        str.substring(offset, indx >= 0 ? indx : undefined).replace("\r", ""),
        indx + 1
    ];
}


var $8a638ecfa585148b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $8a638ecfa585148b$var$client;
var $648c055168c14a7b$exports = {};


$648c055168c14a7b$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("bDGgf");



var $511896ee96a3f24d$exports = {};


$511896ee96a3f24d$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("kdalY");


function $8a638ecfa585148b$export$2a47f398eeff8b01(opts) {
    if ($8a638ecfa585148b$var$client) return $8a638ecfa585148b$var$client;
    let loaded = false;
    (0, $4f6a2a885f909fd4$exports.launchWorker)(opts === null || opts === void 0 ? void 0 : opts.worker).then(()=>{
        (0, $7e50675ff5e3df75$export$454156e929b28fe7)("Fully loaded");
        loaded = true;
    });
    let c = new (0, $7ef3c563cf4c51a2$export$ada9decabe1e7aa7)((ab)=>{
        (0, $4f6a2a885f909fd4$exports.messageManager).postOutgoingMessage({
            t: "zappar",
            d: ab
        }, [
            ab
        ]);
    });
    if (window.location.hostname.toLowerCase().indexOf(".zappar.io") > 0 || window.location.hostname.toLowerCase().indexOf(".webar.run") > 0) {
        let pathParts = window.location.pathname.split("/");
        if (pathParts.length > 1 && pathParts[1].length > 0) c.impl.analytics_project_id_set(".wiz" + pathParts[1]);
    }
    (0, $4f6a2a885f909fd4$exports.messageManager).onIncomingMessage.bind((msg)=>{
        var _a, _b, _c, _d, _e, _f, _g;
        switch(msg.t){
            case "zappar":
                (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(msg.p)) === null || _a === void 0 || _a.pendingMessages.push(msg.d);
                break;
            case "buf":
                c.serializer.bufferReturn(msg.d);
                break;
            case "cameraFrameRecycleS2C":
                {
                    let msgt = msg;
                    (_c = (_b = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(msgt.p)) === null || _b === void 0 ? void 0 : _b.cameraTokenReturn) === null || _c === void 0 || _c.call(_b, msg);
                    break;
                }
            case "videoFrameS2C":
                {
                    let msgt = msg;
                    (_e = (_d = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(msgt.p)) === null || _d === void 0 ? void 0 : _d.videoFrameFromWorker) === null || _e === void 0 || _e.call(_d, msgt);
                    break;
                }
            case "imageBitmapS2C":
                {
                    let msgt = msg;
                    (_g = (_f = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(msgt.p)) === null || _f === void 0 ? void 0 : _f.imageBitmapFromWorker) === null || _g === void 0 || _g.call(_f, msgt);
                    break;
                }
            case "licerr":
                {
                    let div = document.createElement("div");
                    div.innerHTML = "Visit <a href='https://docs.zap.works/universal-ar/licensing/' style='color: white;'>our licensing page</a> to find out about hosting on your own domain.";
                    div.style.position = "absolute";
                    div.style.bottom = "20px";
                    div.style.width = "80%";
                    div.style.backgroundColor = "black";
                    div.style.color = "white";
                    div.style.borderRadius = "10px";
                    div.style.padding = "10px";
                    div.style.fontFamily = "sans-serif";
                    div.style.textAlign = "center";
                    div.style.left = "10%";
                    div.style.zIndex = Number.MAX_SAFE_INTEGER.toString();
                    let span = document.createElement("span");
                    span.innerText = " (30)";
                    div.append(span);
                    let indx = 30;
                    setInterval(function() {
                        indx--;
                        if (indx >= 0) span.innerText = " (" + indx.toString() + ")";
                    }, 1000);
                    document.body.append(div);
                }
            case "gfx":
                {
                    let div = document.createElement("div");
                    div.innerHTML = (0, $86d6871336d56abd$export$4cf8838f9102a661);
                    div.style.position = "absolute";
                    div.style.bottom = "20px";
                    div.style.width = "250px";
                    div.style.left = "50%";
                    div.style.marginLeft = "-125px";
                    div.style.zIndex = Number.MAX_SAFE_INTEGER.toString();
                    div.style.opacity = "0";
                    div.style.transition = "opacity 0.5s";
                    document.body.append(div);
                    setTimeout(function() {
                        div.style.opacity = "1";
                    }, 500);
                    setTimeout(function() {
                        div.style.opacity = "0";
                    }, 3000);
                    setTimeout(function() {
                        div.remove();
                    }, 4000);
                }
        }
    });
    $8a638ecfa585148b$var$client = Object.assign(Object.assign({}, c.impl), {
        loaded: ()=>loaded,
        camera_default_device_id: (userFacing)=>userFacing ? (0, $f2ea8a8055b5cf7a$exports.CameraSource).USER_DEFAULT_DEVICE_ID : (0, $f2ea8a8055b5cf7a$exports.CameraSource).DEFAULT_DEVICE_ID,
        camera_source_create: (p, deviceId)=>(0, $3f7c6300f8a4fe70$export$3612a413b5e57058)(p, deviceId),
        camera_source_destroy: (cam)=>{
            var _a;
            return (_a = (0, $3f7c6300f8a4fe70$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        camera_source_pause: (cam)=>{
            var _a;
            return (_a = (0, $3f7c6300f8a4fe70$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        camera_source_start: (cam)=>{
            var _a;
            return (_a = (0, $3f7c6300f8a4fe70$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.start();
        },
        camera_count: ()=>2,
        camera_id: (indx)=>indx === 0 ? (0, $f2ea8a8055b5cf7a$exports.CameraSource).DEFAULT_DEVICE_ID : (0, $f2ea8a8055b5cf7a$exports.CameraSource).USER_DEFAULT_DEVICE_ID,
        camera_name: (indx)=>indx === 0 ? "Rear-facing Camera" : "User-facing Camera",
        camera_user_facing: (indx)=>indx !== 0,
        pipeline_create: ()=>(0, $8115c34601272f2c$export$abd47b564b6c9ce2).create(c.impl, (0, $4f6a2a885f909fd4$exports.messageManager)),
        pipeline_frame_update: (p)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.frameUpdate(c);
        },
        pipeline_camera_frame_draw_gl: (pipeline, screenWidth, screenHeight, mirror)=>{
            var _a;
            (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(pipeline)) === null || _a === void 0 || _a.cameraFrameDrawGL(screenWidth, screenHeight, mirror);
        },
        draw_plane: (gl, projectionMatrix, cameraMatrix, targetMatrix, texture)=>{
            (0, $90357911555bd622$export$4807f772bfdbc71f)(gl, projectionMatrix, cameraMatrix, targetMatrix, texture);
        },
        pipeline_draw_face: (p, projectionMatrix, cameraMatrix, targetMatrix, o)=>{
            var _a;
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call draw_face on a destroyed zappar_face_mesh_t");
                return new Uint16Array();
            }
            (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawFace(projectionMatrix, cameraMatrix, targetMatrix, obj);
        },
        pipeline_draw_face_project: (p, matrix, vertices, uvMatrix, uvs, indices, texture)=>{
            var _a;
            (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawFaceProject(matrix, vertices, uvMatrix, uvs, indices, texture);
        },
        pipeline_draw_image_target_preview: (p, projectionMatrix, cameraMatrix, targetMatrix, o, indx)=>{
            var _a;
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("image tracker not found");
                return;
            }
            (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawImageTargetPreview(projectionMatrix, cameraMatrix, targetMatrix, indx, obj);
        },
        projection_matrix_from_camera_model: (0, $0a666de0430682ad$export$ca7f1c5c0280e0bf),
        projection_matrix_from_camera_model_ext: (0, $0a666de0430682ad$export$ca7f1c5c0280e0bf),
        pipeline_process_gl: (p)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.processGL();
        },
        pipeline_gl_context_set: (p, gl, texturePool)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.glContextSet(gl, texturePool);
        },
        pipeline_gl_context_lost: (p)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.glContextLost();
        },
        pipeline_camera_frame_upload_gl: (p)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.uploadGL();
        },
        pipeline_camera_frame_texture_gl: (p)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameTexture();
        },
        pipeline_camera_frame_texture_matrix: (p, sw, sh, mirror)=>{
            var _a;
            return ((_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameTextureMatrix(sw, sh, mirror)) || (0, $2edf3b5f20103352$exports).create();
        },
        pipeline_camera_frame_user_facing: (p)=>{
            var _a;
            return ((_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameUserFacing()) || false;
        },
        pipeline_camera_pose_default: ()=>(0, $2edf3b5f20103352$exports).create(),
        pipeline_camera_pose_with_attitude: (p, mirror)=>{
            var _a;
            return ((_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraPoseWithAttitude(mirror)) || (0, $2edf3b5f20103352$exports).create();
        },
        pipeline_camera_pose_with_origin: (p, o)=>{
            let res = (0, $2edf3b5f20103352$exports).create();
            (0, $2edf3b5f20103352$exports).invert(res, o);
            return res;
        },
        pipeline_sequence_record_clear: (p)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordClear();
        },
        pipeline_sequence_record_start: (p, expectedFrames)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordStart(expectedFrames);
        },
        pipeline_sequence_record_stop: (p)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordStop();
        },
        pipeline_sequence_record_device_attitude_matrices_set: (p, v)=>{
            var _a;
            return (_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordDeviceAttitudeMatrices(v);
        },
        pipeline_sequence_record_data: (p)=>{
            var _a;
            return ((_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordData()) || new Uint8Array(0);
        },
        pipeline_sequence_record_data_size: (p)=>{
            var _a;
            return ((_a = (0, $8115c34601272f2c$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordData().byteLength) || 0;
        },
        instant_world_tracker_anchor_pose_camera_relative: (o, mirror)=>{
            let res = (0, $8115c34601272f2c$export$9e7b3df2d144a412)(undefined, c.impl.instant_world_tracker_anchor_pose_raw(o));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            return res;
        },
        instant_world_tracker_anchor_pose: (o, cameraPose, mirror)=>{
            let res = (0, $8115c34601272f2c$export$9e7b3df2d144a412)(undefined, c.impl.instant_world_tracker_anchor_pose_raw(o));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            (0, $2edf3b5f20103352$exports).multiply(res, cameraPose, res);
            return res;
        },
        instant_world_tracker_anchor_pose_set_from_camera_offset: (o, x, y, z, orientation)=>{
            // TODO - add an _ext function if we need to support mirrored cameras with an extra param
            // if(mirror) {
            //     x *= -1;
            // }
            // TODO - can we access the appropriate pipeline here to call pipeline_camera_frame_user_facing(p)?
            let userFacing = false;
            let rotation = (0, $0a666de0430682ad$export$83fad53f837eba8e)(userFacing) * Math.PI / 180.0;
            let rotationMat = (0, $2edf3b5f20103352$exports).create();
            (0, $2edf3b5f20103352$exports).fromRotation(rotationMat, -rotation, [
                0,
                0,
                1
            ]);
            let rawVec = (0, $7aaf532207b60e73$exports).create();
            (0, $7aaf532207b60e73$exports).transformMat4(rawVec, [
                x,
                y,
                z
            ], rotationMat);
            c.impl.instant_world_tracker_anchor_pose_set_from_camera_offset_raw(o, rawVec[0], rawVec[1], rawVec[2], orientation);
        },
        image_tracker_create: (pipeline)=>(0, $fee20207659b267f$export$333222788f3dd075).create(pipeline, c.impl),
        image_tracker_destroy: (t)=>{
            var _a;
            return (_a = (0, $fee20207659b267f$export$333222788f3dd075).get(t)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        image_tracker_target_type: (t, i)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_type on a destroyed zappar_image_tracker_t");
                return (0, $c937c8c7cc26bb65$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR;
            }
            return obj.getTargetInfo(i).type;
        },
        image_tracker_target_count: (t)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_count on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.targetCount();
        },
        image_tracker_target_load_from_memory: (t, data)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_load_from_memory on a destroyed zappar_image_tracker_t");
                return 0;
            }
            obj.loadFromMemory(data);
        },
        image_tracker_target_preview_compressed: (t, i)=>{
            var _a;
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed on a destroyed zappar_image_tracker_t");
                return new Uint8Array(0);
            }
            return ((_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.compressed) || new Uint8Array(0);
        },
        image_tracker_target_preview_compressed_mimetype: (t, i)=>{
            var _a;
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed_mimetype on a destroyed zappar_image_tracker_t");
                return "";
            }
            return ((_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.mimeType) || "";
        },
        image_tracker_target_preview_compressed_size: (t, i)=>{
            var _a, _b;
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return ((_b = (_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.compressed) === null || _b === void 0 ? void 0 : _b.byteLength) || 0;
        },
        image_tracker_target_physical_scale_factor: (t, i)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_physical_scale_factor on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).physicalScaleFactor;
        },
        image_tracker_target_radius_top: (t, i)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_radius_top on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).topRadius;
        },
        image_tracker_target_radius_bottom: (t, i)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_radius_bottom on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).bottomRadius;
        },
        image_tracker_target_side_length: (t, i)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_side_length on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).sideLength;
        },
        image_tracker_target_image: (t, i)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_image on a destroyed zappar_image_tracker_t");
                return new Image();
            }
            return obj.getDecodedPreview(i);
        },
        image_tracker_anchor_pose_camera_relative: (o, indx, mirror)=>{
            let res = (0, $8115c34601272f2c$export$9e7b3df2d144a412)(undefined, c.impl.image_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            return res;
        },
        image_tracker_anchor_pose: (o, indx, cameraPose, mirror)=>{
            let res = (0, $8115c34601272f2c$export$9e7b3df2d144a412)(undefined, c.impl.image_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            (0, $2edf3b5f20103352$exports).multiply(res, cameraPose, res);
            return res;
        },
        image_tracker_target_preview_mesh_indices: (o, indx)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_indices on a destroyed zappar_image_tracker_t");
                return new Uint16Array();
            }
            return obj.getPreviewMesh(indx).indices;
        },
        image_tracker_target_preview_mesh_vertices: (o, indx)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_vertices on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).vertices;
        },
        image_tracker_target_preview_mesh_uvs: (o, indx)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_uvs on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).uvs;
        },
        image_tracker_target_preview_mesh_normals: (o, indx)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_normals on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).normals;
        },
        image_tracker_target_preview_mesh_indices_size: (o, indx)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_indices_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).indices.length;
        },
        image_tracker_target_preview_mesh_vertices_size: (o, indx)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_vertices_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).vertices.length;
        },
        image_tracker_target_preview_mesh_uvs_size: (o, indx)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_uvs_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).uvs.length;
        },
        image_tracker_target_preview_mesh_normals_size: (o, indx)=>{
            let obj = (0, $fee20207659b267f$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_normals_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).normals.length;
        },
        face_tracker_anchor_pose_camera_relative: (o, indx, mirror)=>{
            let res = (0, $8115c34601272f2c$export$9e7b3df2d144a412)(undefined, c.impl.face_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            return res;
        },
        face_tracker_anchor_pose: (o, indx, cameraPose, mirror)=>{
            let res = (0, $8115c34601272f2c$export$9e7b3df2d144a412)(undefined, c.impl.face_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            (0, $2edf3b5f20103352$exports).multiply(res, cameraPose, res);
            return res;
        },
        face_tracker_model_load_default: (o)=>$8a638ecfa585148b$var$__awaiter(this, void 0, void 0, function*() {
                yield $8a638ecfa585148b$var$loadDefaultFaceModel(o);
            }),
        face_mesh_create: ()=>{
            return (0, $f197f040e648db59$export$3a09cf4ac8b68494)();
        },
        face_mesh_destroy: (m)=>{
            (0, $f197f040e648db59$export$eed3c787ca5a1447)(m);
        },
        face_mesh_indices: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_indices on a destroyed zappar_face_mesh_t");
                return new Uint16Array();
            }
            return obj.getIndices();
        },
        face_mesh_indices_size: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_indices_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getIndices().length;
        },
        face_mesh_uvs: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_uvs on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getUVs();
        },
        face_mesh_uvs_size: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_uvs_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getUVs().length;
        },
        face_mesh_vertices: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_vertices on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getVertices();
        },
        face_mesh_vertices_size: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_vertices_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getVertices().length;
        },
        face_mesh_normals: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_normals on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getNormals();
        },
        face_mesh_normals_size: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_normals_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getNormals().length;
        },
        face_mesh_load_from_memory: (m, ab, fillMouth, fillEyeL, fillEyeR, fillNeck)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_load_from_memory on a destroyed zappar_face_mesh_t");
                return;
            }
            obj.loadFromMemory(ab, fillMouth, fillEyeL, fillEyeR, fillNeck);
        },
        face_mesh_update: (m, identity, expression, mirrored)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_update on a destroyed zappar_face_mesh_t");
                return;
            }
            obj.update(identity, expression, mirrored);
        },
        face_mesh_load_default: (m)=>$8a638ecfa585148b$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_load_default on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($648c055168c14a7b$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), false, false, false, false);
            }),
        face_mesh_load_default_face: (m, fillMouth, fillEyeL, fillEyeR)=>$8a638ecfa585148b$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_load_default_face on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($648c055168c14a7b$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), fillMouth, fillEyeL, fillEyeR, false);
            }),
        face_mesh_load_default_full_head_simplified: (m, fillMouth, fillEyeL, fillEyeR, fillNeck)=>$8a638ecfa585148b$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_load_default_full_head_simplified on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($511896ee96a3f24d$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), fillMouth, fillEyeL, fillEyeR, fillNeck);
            }),
        face_mesh_loaded_version: (m)=>{
            let obj = (0, $f197f040e648db59$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_mesh_load_default on a destroyed zappar_face_mesh_t");
                return -1;
            }
            return obj.getModelVersion();
        },
        face_landmark_create: (n)=>{
            return (0, $b4178198a2f8dfd2$export$36e720c0ee0eafff)(n);
        },
        face_landmark_destroy: (m)=>{
            (0, $b4178198a2f8dfd2$export$4a91c83b2945af9c)(m);
        },
        face_landmark_update: (m, identity, expression, mirrored)=>{
            let obj = (0, $b4178198a2f8dfd2$export$2cdf232f18b0ea25)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_landmark_update on a destroyed zappar_face_landmark_t");
                return;
            }
            obj.update(identity, expression, mirrored);
        },
        face_landmark_anchor_pose: (m)=>{
            let obj = (0, $b4178198a2f8dfd2$export$2cdf232f18b0ea25)(m);
            if (!obj) {
                (0, $7e50675ff5e3df75$export$79a36c979e81230e)("attempting to call face_landmark_anchor_pose on a destroyed zappar_face_landmark_t");
                return (0, $2edf3b5f20103352$exports).create();
            }
            return obj.anchor_pose;
        },
        html_element_source_create: (pipeline, elm)=>(0, $23fd8c5744e6b817$export$bbfb48c500076b66).createVideoElementSource(pipeline, elm),
        html_element_source_start: (o)=>{
            var _a;
            return (_a = (0, $23fd8c5744e6b817$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.start();
        },
        html_element_source_pause: (o)=>{
            var _a;
            return (_a = (0, $23fd8c5744e6b817$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        html_element_source_destroy: (o)=>{
            var _a;
            return (_a = (0, $23fd8c5744e6b817$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        sequence_source_create: (p)=>(0, $45c5dd3ebc146df0$export$9035336025e5be06).create(p),
        sequence_source_load_from_memory: (o, data)=>{
            var _a;
            return (_a = (0, $45c5dd3ebc146df0$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.loadFromMemory(data);
        },
        sequence_source_pause: (o)=>{
            var _a;
            return (_a = (0, $45c5dd3ebc146df0$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        sequence_source_start: (o)=>{
            var _a;
            return (_a = (0, $45c5dd3ebc146df0$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.start();
        },
        sequence_source_max_playback_fps_set: (o, fps)=>{
            var _a;
            return (_a = (0, $45c5dd3ebc146df0$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.maxPlaybackFpsSet(fps);
        },
        sequence_source_time_set: (o, t)=>{
            var _a;
            return (_a = (0, $45c5dd3ebc146df0$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.setTime(t);
        },
        sequence_source_destroy: (o)=>{
            var _a;
            return (_a = (0, $45c5dd3ebc146df0$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        permission_granted_all: (0, $bbd51e21c47e24e9$exports.permissionGrantedAll),
        permission_granted_camera: (0, $bbd51e21c47e24e9$exports.permissionGrantedCamera),
        permission_granted_motion: (0, $bbd51e21c47e24e9$exports.permissionGrantedMotion),
        permission_denied_any: (0, $bbd51e21c47e24e9$exports.permissionDeniedAny),
        permission_denied_camera: (0, $bbd51e21c47e24e9$exports.permissionDeniedCamera),
        permission_denied_motion: (0, $bbd51e21c47e24e9$exports.permissionDeniedMotion),
        permission_request_motion: (0, $bbd51e21c47e24e9$exports.permissionRequestMotion),
        permission_request_camera: (0, $bbd51e21c47e24e9$exports.permissionRequestCamera),
        permission_request_all: (0, $bbd51e21c47e24e9$exports.permissionRequestAll),
        permission_request_ui: (0, $bbd51e21c47e24e9$exports.permissionRequestUI),
        permission_request_ui_promise: (0, $bbd51e21c47e24e9$exports.permissionRequestUI),
        permission_denied_ui: (0, $bbd51e21c47e24e9$exports.permissionDeniedUI),
        browser_incompatible: (0, $76dc112703edaa32$export$2e2bcd8739ae039).incompatible,
        browser_incompatible_ui: (0, $76dc112703edaa32$export$2e2bcd8739ae039).incompatible_ui,
        log_level_set: (l)=>{
            (0, $7e50675ff5e3df75$export$c622e99c0ce7b1c9)(l);
            c.impl.log_level_set(l);
        }
    });
    return $8a638ecfa585148b$var$client;
}
var $3554574ee2576322$exports = {};


$3554574ee2576322$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("iM80n");


function $8a638ecfa585148b$var$loadDefaultFaceModel(o) {
    return $8a638ecfa585148b$var$__awaiter(this, void 0, void 0, function*() {
        let url = new URL($3554574ee2576322$exports);
        let data = yield fetch(url.toString());
        let ab = yield data.arrayBuffer();
        $8a638ecfa585148b$var$client === null || $8a638ecfa585148b$var$client === void 0 || $8a638ecfa585148b$var$client.face_tracker_model_load_from_memory(o, ab);
    });
}


const $f841e4643766f46b$export$a4ad2735b021c132 = "2.0.1";



function $379ae1301d43b448$export$2a47f398eeff8b01(opts) {
    console.log(`Zappar CV v${(0, $f841e4643766f46b$export$a4ad2735b021c132)}`);
    return (0, $8a638ecfa585148b$exports.initialize)(opts);
}



/**
  * SDK version.
*/ const $c9b8f6edfec5e45e$export$a4ad2735b021c132 = "2.1.1";


var $16ba0ad9af69b2e5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $16ba0ad9af69b2e5$var$_z;
let $16ba0ad9af69b2e5$var$_options;
function $16ba0ad9af69b2e5$export$add91eafeaeab287(opts) {
    if ($16ba0ad9af69b2e5$var$_z) console.warn("setOptions called after Zappar JS initialization");
    $16ba0ad9af69b2e5$var$_options = opts;
}
function $16ba0ad9af69b2e5$export$df995fae86a55f06() {
    if (!$16ba0ad9af69b2e5$var$_z) {
        console.log(`Zappar JS v${(0, $c9b8f6edfec5e45e$export$a4ad2735b021c132)}`);
        $16ba0ad9af69b2e5$var$_z = (0, $379ae1301d43b448$export$2a47f398eeff8b01)($16ba0ad9af69b2e5$var$_options);
    }
    return $16ba0ad9af69b2e5$var$_z;
}
function $16ba0ad9af69b2e5$export$5e22cf87be86f6fa(userFacing) {
    return $16ba0ad9af69b2e5$export$df995fae86a55f06().camera_default_device_id(userFacing || false);
}
function $16ba0ad9af69b2e5$export$6897c284b6f9f4dc(m) {
    const ret = (0, $2edf3b5f20103352$exports).create();
    (0, $2edf3b5f20103352$exports).invert(ret, m);
    return ret;
}
function $16ba0ad9af69b2e5$export$790b3b94a8142dee(model, renderWidth, renderHeight, zNear = 0.1, zFar = 100) {
    return $16ba0ad9af69b2e5$export$df995fae86a55f06().projection_matrix_from_camera_model_ext(model, renderWidth, renderHeight, zNear, zFar);
}
function $16ba0ad9af69b2e5$export$4807f772bfdbc71f(gl, projectionMatrix, cameraMatrix, targetMatrix, texture) {
    $16ba0ad9af69b2e5$export$df995fae86a55f06().draw_plane(gl, projectionMatrix, cameraMatrix, targetMatrix, texture);
}
function $16ba0ad9af69b2e5$export$45d46abc43ff1aac() {
    return $16ba0ad9af69b2e5$export$df995fae86a55f06().browser_incompatible();
}
function $16ba0ad9af69b2e5$export$5485d7c8ccfb3ed0() {
    $16ba0ad9af69b2e5$export$df995fae86a55f06().browser_incompatible_ui();
}
function $16ba0ad9af69b2e5$export$b40fc69c4a2927a1() {
    return $16ba0ad9af69b2e5$export$df995fae86a55f06().loaded();
}
function $16ba0ad9af69b2e5$export$6b6393bedfd195a0() {
    return $16ba0ad9af69b2e5$var$__awaiter(this, void 0, void 0, function*() {
        while(true){
            if ($16ba0ad9af69b2e5$export$b40fc69c4a2927a1()) return;
            yield $16ba0ad9af69b2e5$var$delay(50);
        }
    });
}
function $16ba0ad9af69b2e5$var$delay(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


var $20ed77af6adf4d0f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $20ed77af6adf4d0f$export$333222788f3dd075 {
    /**
     * Constructs a new ImageTracker
     * @param _pipeline - The pipeline that this tracker will operate within.
     * @param targetFile - The .zpt target file from the source image you'd like to track.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
    */ constructor(_pipeline, targetFile){
        this._pipeline = _pipeline;
        /**
        * Emitted when an anchor becomes visible in a camera frame.
        */ this.onVisible = new (0, $bd0785a1f078b628$export$3371bf92c01fb88b)();
        /**
        * Emitted when an anchor goes from being visible in the previous camera frame, to not being visible in the current frame.
        */ this.onNotVisible = new (0, $bd0785a1f078b628$export$3371bf92c01fb88b)();
        /**
        * Emitted when a new anchor is created by the tracker.
        */ this.onNewAnchor = new (0, $bd0785a1f078b628$export$3371bf92c01fb88b)();
        /**
        * The set of currently visible anchors.
        */ this.visible = new Set();
        /**
        * A map of the available image anchors by their respective IDs.
        */ this.anchors = new Map();
        this._visibleLastFrame = new Set();
        this._frameUpdate = ()=>{
            const newAnchors = new Set();
            // Swap the visible and visibleLastFrame so we can avoid a set allocation
            const swap = this.visible;
            this.visible = this._visibleLastFrame;
            this._visibleLastFrame = swap;
            this.visible.clear();
            const num = this._z.image_tracker_anchor_count(this._impl);
            for(let i = 0; i < num; i++){
                const id = this._z.image_tracker_anchor_id(this._impl, i);
                let anchor = this.anchors.get(id);
                let isNew = false; // TODO: declared but never used?
                if (!anchor) {
                    anchor = {
                        onVisible: new (0, $bd0785a1f078b628$export$d61e24a684f9e51)(),
                        onNotVisible: new (0, $bd0785a1f078b628$export$d61e24a684f9e51)(),
                        id: id,
                        poseCameraRelative: (mirror)=>this._z.image_tracker_anchor_pose_camera_relative(this._impl, i, mirror === true),
                        pose: (cameraPose, mirror)=>this._z.image_tracker_anchor_pose(this._impl, i, cameraPose, mirror === true),
                        visible: true
                    };
                    isNew = true;
                    this.anchors.set(id, anchor);
                    newAnchors.add(anchor);
                }
                anchor.visible = true;
                this.visible.add(anchor);
            }
            // Events
            for (const anchor of newAnchors)this.onNewAnchor.emit(anchor);
            for (const anchor of this.visible)if (!this._visibleLastFrame.has(anchor)) {
                this.onVisible.emit(anchor);
                anchor.onVisible.emit();
            } else this._visibleLastFrame.delete(anchor);
            for (const anchor of this._visibleLastFrame){
                this.onNotVisible.emit(anchor);
                anchor.onNotVisible.emit();
            }
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.image_tracker_create(this._pipeline._getImpl());
        if (targetFile) this.loadTarget(targetFile);
    }
    /**
     * Destroys the image tracker.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this.anchors.clear();
        this.visible.clear();
        this._z.image_tracker_destroy(this._impl);
    }
    /**
     * Loads a target file.
     * @param src - A URL to, or an ArrayBuffer of, the target file from the source image you'd like to track.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
     * @returns A promise that's resolved once the file is downloaded. It may still take a few frames for the tracker to fully initialize and detect images.
    */ loadTarget(src) {
        return $20ed77af6adf4d0f$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._targets = undefined;
            this._z.image_tracker_target_load_from_memory(this._impl, src);
        });
    }
    /**
     * Gets/sets the enabled state of the image tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.image_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.image_tracker_enabled_set(this._impl, e);
    }
    /**
     * An array of information for each of the target images loaded by this tracker.
     */ get targets() {
        if (!this._targets) {
            this._targets = [];
            const count = this._z.image_tracker_target_count(this._impl);
            for(let i = 0; i < count; i++)this._targets.push(new $20ed77af6adf4d0f$export$90139717fc3176c2(this._z, this._impl, i));
        }
        return this._targets;
    }
}
class $20ed77af6adf4d0f$export$90139717fc3176c2 {
    constructor(_z, _impl, _indx){
        this._z = _z;
        this._impl = _impl;
        this._indx = _indx;
        this.physicalScaleFactor = this._z.image_tracker_target_physical_scale_factor(this._impl, this._indx);
        if (this.physicalScaleFactor < 0) this.physicalScaleFactor = undefined;
        this.topRadius = this._z.image_tracker_target_radius_top(this._impl, this._indx);
        if (this.topRadius < 0) this.topRadius = undefined;
        this.bottomRadius = this._z.image_tracker_target_radius_bottom(this._impl, this._indx);
        if (this.bottomRadius < 0) this.bottomRadius = undefined;
        this.sideLength = this._z.image_tracker_target_side_length(this._impl, this._indx);
        if (this.sideLength < 0) this.sideLength = undefined;
    }
    /**
     * An <img> element containing the embedded preview image, or `undefined` if the target file does not contain one.
     */ get image() {
        if (this._image === undefined) this._image = this._z.image_tracker_target_image(this._impl, this._indx) || null;
        return this._image || undefined;
    }
    /**
     * An object containing a mesh that represents this image target.
     */ get preview() {
        if (this._preview === undefined) this._preview = new $20ed77af6adf4d0f$export$ae476155e1d7e629(this._z, this._impl, this._indx);
        return this._preview;
    }
}
class $20ed77af6adf4d0f$export$ae476155e1d7e629 {
    constructor(_z, _impl, _indx){
        this._z = _z;
        this._impl = _impl;
        this._indx = _indx;
        this.vertices = this._z.image_tracker_target_preview_mesh_vertices(this._impl, this._indx);
        this.indices = this._z.image_tracker_target_preview_mesh_indices(this._impl, this._indx);
        this.uvs = this._z.image_tracker_target_preview_mesh_uvs(this._impl, this._indx);
    }
}




class $ae336885894939c7$export$230d52b81bfab97f {
    /**
     * Constructs a new InstantWorldTracker.
     * @param _pipeline - The pipeline that this tracker will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * The instant world tracking anchor.
        */ this.anchor = {
            poseCameraRelative: (mirror)=>this._anchorPoseCameraRelative(mirror),
            pose: (cameraPose, mirror)=>this._anchorPose(cameraPose, mirror)
        };
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.instant_world_tracker_create(this._pipeline._getImpl());
    }
    /**
     * Destroys the instant tracker.
     */ destroy() {
        this._z.instant_world_tracker_destroy(this._impl);
    }
    _anchorPoseCameraRelative(mirror) {
        return this._z.instant_world_tracker_anchor_pose_camera_relative(this._impl, mirror === true);
    }
    _anchorPose(cameraPose, mirror) {
        return this._z.instant_world_tracker_anchor_pose(this._impl, cameraPose, mirror === true);
    }
    /**
     * Gets/sets the enabled state of the instant world tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.instant_world_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.instant_world_tracker_enabled_set(this._impl, e);
    }
    /**
     * Sets the point in the user's environment that the anchor tracks from.
     *
     * The parameters passed in to this function correspond to the X, Y and Z coordinates (in camera space) of the point to track. Choosing a position with X and Y coordinates of zero, and a negative Z coordinate, will select a point on a surface directly in front of the center of the screen.
     *
     * @param orientation -  The orientation of the point in space.
     */ setAnchorPoseFromCameraOffset(x, y, z, orientation) {
        this._z.instant_world_tracker_anchor_pose_set_from_camera_offset(this._impl, x, y, z, orientation || (0, $c937c8c7cc26bb65$export$51221aec55e6c7e6).MINUS_Z_AWAY_FROM_USER);
    }
}





class $dd31c4de20a19f0a$export$441c3cbad541da1b {
    /**
     * Constructs a new BarcodeFinder.
     * @param _pipeline - The pipeline that this BarcodeFinder will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * Emitted when a barcode becomes visible in a camera frame.
        */ this.onDetection = new (0, $bd0785a1f078b628$export$3371bf92c01fb88b)();
        this._lastDetected = [];
        this._found = [];
        this._formats = [];
        this._frameUpdate = ()=>{
            this._found = [];
            const num = this._z.barcode_finder_found_number(this._impl);
            for(let i = 0; i < num; i++)this._found.push({
                text: this._z.barcode_finder_found_text(this._impl, i),
                format: this._z.barcode_finder_found_format(this._impl, i)
            });
            if (this._found.length === 0) return;
            outerloop: for (const entry of this._found){
                for (const previous of this._lastDetected){
                    if (previous.text === entry.text) continue outerloop;
                }
                this.onDetection.emit(entry);
            }
            this._lastDetected = this._found;
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.barcode_finder_create(this._pipeline._getImpl());
        this._formats.push.apply(this._formats, [
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).AZTEC,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).CODABAR,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).CODE_39,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).CODE_93,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).CODE_128,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).DATA_MATRIX,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).EAN_8,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).EAN_13,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).ITF,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).MAXICODE,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).PDF_417,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).QR_CODE,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).RSS_14,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).RSS_EXPANDED,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).UPC_A,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).UPC_E,
            (0, $c937c8c7cc26bb65$export$53baafd5596ae7a8).UPC_EAN_EXTENSION
        ]);
    }
    /**
     * Destroys the barcode finder.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this._found = [];
        this._lastDetected = [];
        this._z.barcode_finder_destroy(this._impl);
    }
    /**
      * Returns an array of discovered barcodes
      */ get found() {
        return this._found;
    }
    /**
     * Gets/sets the enabled state of the barcode finder.
     * Disable when not in use to save computational resources during frame processing.
    */ get enabled() {
        return this._z.barcode_finder_enabled(this._impl);
    }
    set enabled(e) {
        this._z.barcode_finder_enabled_set(this._impl, e);
    }
    /**
      * Gets/sets the barcode formats to scan for.
      */ get formats() {
        return this._formats;
    }
    set formats(f) {
        this._formats = f.slice();
        let underlying = 0;
        for (const format of this._formats)underlying |= format;
        this._z.barcode_finder_formats_set(this._impl, underlying);
    }
}


var $b93e1b8491784d92$exports = {};

$parcel$export($b93e1b8491784d92$exports, "FaceTracker", function () { return $b93e1b8491784d92$export$bb2337bd021e3bce; });


var $b93e1b8491784d92$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $b93e1b8491784d92$export$bb2337bd021e3bce {
    /**
     * Constructs a new FaceTracker
     * @param _pipeline - The pipeline that this tracker will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * Emitted when an anchor becomes visible in a camera frame.
        */ this.onVisible = new (0, $bd0785a1f078b628$export$3371bf92c01fb88b)();
        /**
        * Emitted when an anchor goes from being visible in the previous camera frame, to not being visible in the current frame.
        */ this.onNotVisible = new (0, $bd0785a1f078b628$export$3371bf92c01fb88b)();
        /**
        * Emitted when a new anchor is created by the tracker.
        */ this.onNewAnchor = new (0, $bd0785a1f078b628$export$3371bf92c01fb88b)();
        /**
         * The set of currently visible anchors.
         */ this.visible = new Set();
        /**
        * A map of the available anchors by their respective IDs.
        */ this.anchors = new Map();
        this._visibleLastFrame = new Set();
        this._frameUpdate = ()=>{
            const newAnchors = new Set();
            // Swap the visible and visibleLastFrame so we can avoid a set allocation
            const swap = this.visible;
            this.visible = this._visibleLastFrame;
            this._visibleLastFrame = swap;
            this.visible.clear();
            const num = this._z.face_tracker_anchor_count(this._impl);
            for(let i = 0; i < num; i++){
                const id = this._z.face_tracker_anchor_id(this._impl, i);
                let anchor = this.anchors.get(id);
                let isNew = false;
                if (!anchor) {
                    anchor = {
                        onVisible: new (0, $bd0785a1f078b628$export$d61e24a684f9e51)(),
                        onNotVisible: new (0, $bd0785a1f078b628$export$d61e24a684f9e51)(),
                        indx: 0,
                        id: id,
                        poseCameraRelative: (mirror)=>this._z.face_tracker_anchor_pose_camera_relative(this._impl, anchor.indx, mirror === true),
                        pose: (cameraPose, mirror)=>this._z.face_tracker_anchor_pose(this._impl, anchor.indx, cameraPose, mirror === true),
                        identity: new Float32Array(50),
                        expression: new Float32Array(29),
                        visible: true
                    };
                    isNew = true;
                    this.anchors.set(id, anchor);
                    newAnchors.add(anchor);
                }
                anchor.indx = i;
                anchor.visible = true;
                anchor.identity = this._z.face_tracker_anchor_identity_coefficients(this._impl, i);
                anchor.expression = this._z.face_tracker_anchor_expression_coefficients(this._impl, i);
                this.visible.add(anchor);
            }
            // Events
            for (const anchor of newAnchors)this.onNewAnchor.emit(anchor);
            for (const anchor of this.visible)if (!this._visibleLastFrame.has(anchor)) {
                this.onVisible.emit(anchor);
                anchor.onVisible.emit();
            } else this._visibleLastFrame.delete(anchor);
            for (const anchor of this._visibleLastFrame){
                this.onNotVisible.emit(anchor);
                anchor.onNotVisible.emit();
            }
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.face_tracker_create(this._pipeline._getImpl());
    }
    /**
      * Destroys the face tracker.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this.anchors.clear();
        this.visible.clear();
        this._z.face_tracker_destroy(this._impl);
    }
    /**
     * Loads face tracking model data.
     * @param src - A URL to, or ArrayBuffer of, model data.
     * @returns A promise that's resolved once the model is loaded. It may still take a few frames for the tracker to fully initialize and detect faces.
    */ loadModel(src) {
        return $b93e1b8491784d92$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.face_tracker_model_load_from_memory(this._impl, src);
        });
    }
    /**
     * Loads the default face tracking model.
     * @returns A promise that's resolved once the model is loaded. It may still take a few frames for the tracker to fully initialize and detect faces.
    */ loadDefaultModel() {
        return $b93e1b8491784d92$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_tracker_model_load_default(this._impl);
        });
    }
    /**
     * Gets/sets the enabled state of the face tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.face_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.face_tracker_enabled_set(this._impl, e);
    }
    /**
     * Gets/sets the maximum number of faces to track.
     *
     * By default only one face is tracked in any given frame. Increasing this number may reduce runtime performance.
     */ get maxFaces() {
        return this._z.face_tracker_max_faces(this._impl);
    }
    set maxFaces(m) {
        this._z.face_tracker_max_faces_set(this._impl, m);
    }
}


var $5b535c031aa0f632$exports = {};

$parcel$export($5b535c031aa0f632$exports, "FaceMesh", function () { return $5b535c031aa0f632$export$1238420da3a0b20c; });

var $5b535c031aa0f632$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $5b535c031aa0f632$export$1238420da3a0b20c {
    /**
     * Constructs a new FaceMesh.
     * @see https://docs.zap.works/universal-ar/javascript/face-tracking/
    */ constructor(){
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.face_mesh_create();
    }
    /**
     * Destroys the face mesh.
     */ destroy() {
        this._z.face_mesh_destroy(this._impl);
    }
    /**
     * Loads the data for a face mesh.
     * @param src - A URL or ArrayBuffer of the source mesh data.
     * @param fillMouth - If true, fills this face feature with polygons.
     * @param fillEyeLeft - If true, fills this face feature with polygons.
     * @param fillEyeRight - If true, fills this face feature with polygons.
     * @param fillNeck - If true, fills this face feature with polygons.
     * @returns A promise that's resolved once the data is loaded.
     */ load(src, fillMouth, fillEyeLeft, fillEyeRight, fillNeck) {
        return $5b535c031aa0f632$var$__awaiter(this, void 0, void 0, function*() {
            if (!src) {
                this.loadDefault();
                return;
            } else if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.face_mesh_load_from_memory(this._impl, src, fillMouth || false, fillEyeLeft || false, fillEyeRight || false, fillNeck || false);
        });
    }
    /**
      * Loads the default face mesh data.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefault() {
        return $5b535c031aa0f632$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default(this._impl);
        });
    }
    /**
      * Loads the default face mesh.
      * @param fillMouth - If true, fills this face feature with polygons.
      * @param fillEyeLeft - If true, fills this face feature with polygons.
      * @param fillEyeRight - If true, fills this face feature with polygons.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefaultFace(fillMouth, fillEyeLeft, fillEyeRight) {
        return $5b535c031aa0f632$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default_face(this._impl, fillMouth || false, fillEyeLeft || false, fillEyeRight || false);
        });
    }
    /**
      * The full head simplified mesh covers the whole of the user's head, including some neck.
      * It's ideal for drawing into the depth buffer in order to mask out the back of 3D models placed on the user's head.
      * @param fillMouth - If true, fills this face feature with polygons.
      * @param fillEyeLeft - If true, fills this face feature with polygons.
      * @param fillEyeRight - If true, fills this face feature with polygons.
      * @param fillNeck - If true, fills this face feature with polygons.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefaultFullHeadSimplified(fillMouth, fillEyeLeft, fillEyeRight, fillNeck) {
        return $5b535c031aa0f632$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default_full_head_simplified(this._impl, fillMouth || false, fillEyeLeft || false, fillEyeRight || false, fillNeck || false);
        });
    }
    /**
      * Update the face mesh directly from a [[FaceAnchor]].
      * @param f - The face anchor.
      * @param mirror - Pass `true` to mirror the location in the X-axis.
      */ updateFromFaceAnchor(f, mirror) {
        this._z.face_mesh_update(this._impl, f.identity, f.expression, mirror || false);
    }
    /**
      * Updates the face mesh directly from a identity and expression coefficients.
      * @param identity - The identity coefficients.
      * @param expression - The expression coefficients.
      * @param mirror - Pass `true` to mirror the location in the X-axis.
     */ updateFromIdentityExpression(identity, expression, mirror) {
        this._z.face_mesh_update(this._impl, identity, expression, mirror || false);
    }
    /**
     *
     * @returns The vertices of the mesh.
     */ get vertices() {
        return this._z.face_mesh_vertices(this._impl);
    }
    /**
     * @returns The indices of the mesh.
     */ get indices() {
        return this._z.face_mesh_indices(this._impl);
    }
    /**
     * @returns The UVs of the mesh.
     */ get uvs() {
        return this._z.face_mesh_uvs(this._impl);
    }
    /**
     * @returns The normals of the mesh.
     */ get normals() {
        return this._z.face_mesh_normals(this._impl);
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
}



class $331f49974e73e77e$export$9a93ce53f488cb2e {
    /**
     * Constructs a new CameraSource.
     * @param _pipeline - The pipeline that this tracker will operate within.
     * @param deviceId - The camera device ID which will be used as the source.
     * @see https://docs.zap.works/universal-ar/javascript/pipelines-and-camera-processing/
    */ constructor(pipeline, deviceId){
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.camera_source_create(pipeline._getImpl(), deviceId);
    }
    /**
    * Destroys the camera source.
    */ destroy() {
        this._z.camera_source_destroy(this._impl);
    }
    /**
    * Starts the camera source.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.camera_source_start(this._impl);
    }
    /**
    * Pauses the camera source.
    */ pause() {
        this._z.camera_source_pause(this._impl);
    }
}



class $6c9834203f6acbdf$export$bbfb48c500076b66 {
    /**
     * Constructs a new HTMLElementSource.
     * @param pipeline - The pipeline that this tracker will operate within.
     * @param element -  The HTML source element.
    */ constructor(pipeline, element){
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.html_element_source_create(pipeline._getImpl(), element);
    }
    /**
    * Destroys the source.
    */ destroy() {
        this._z.html_element_source_destroy(this._impl);
    }
    /**
    * Starts the source sending frames into the pipeline.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.html_element_source_start(this._impl);
    }
    /**
    * Pauses the source.
    */ pause() {
        this._z.html_element_source_pause(this._impl);
    }
}


var $395ef46d41825e9c$exports = {};

var $395ef46d41825e9c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $395ef46d41825e9c$export$9035336025e5be06 {
    /**
     * Constructs a new SequenceSource.
     * @param _pipeline - The pipeline that this source will operate within.
    */ constructor(pipeline){
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.sequence_source_create(pipeline._getImpl());
    }
    /**
    * Destroys the sequence source.
    */ destroy() {
        this._z.sequence_source_destroy(this._impl);
    }
    /**
    * Starts the sequence source.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.sequence_source_start(this._impl);
    }
    /**
    * Pauses the sequence source.
    */ pause() {
        this._z.sequence_source_pause(this._impl);
    }
    /**
     * Loads sequence data.
     * @param src - A URL to, or an ArrayBuffer of, the sequence data you'd like to play back.
     * @returns A promise that's resolved once the data is downloaded.
    */ load(src) {
        return $395ef46d41825e9c$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.sequence_source_load_from_memory(this._impl, src);
        });
    }
    /**
     * Manually set the current time for the sequence.
     * @param t The time in ms, or `undefined` to use the system time.
     */ setTime(t) {
        this._z.sequence_source_time_set(this._impl, t !== null && t !== void 0 ? t : -1);
    }
}




class $3aa97644b1167104$export$abd47b564b6c9ce2 {
    /**
     * Constructs a new Pipeline.
    */ constructor(){
        /**
         * Emitted when the frame is updated.
        */ this.onFrameUpdate = new (0, $bd0785a1f078b628$export$d61e24a684f9e51)();
        /**
         * @ignore
        */ this._onFrameUpdateInternal = new (0, $bd0785a1f078b628$export$d61e24a684f9e51)();
        this._lastFrameNumber = -1;
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.pipeline_create();
    }
    /**
     * Destroys the pipeline.
     */ destroy() {
        this._z.pipeline_destroy(this._impl);
    }
    /**
     * Updates the pipeline and trackers to expose tracking data from the most recently processed camera frame.
     */ frameUpdate() {
        this._z.pipeline_frame_update(this._impl);
        const frameNumber = this._z.pipeline_frame_number(this._impl);
        if (frameNumber !== this._lastFrameNumber) {
            this._lastFrameNumber = frameNumber;
            this._onFrameUpdateInternal.emit();
            this.onFrameUpdate.emit();
        }
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
    /**
     * Sets the WebGL context used for the processing and upload of camera textures.
     * @param gl - The WebGL context.
    */ glContextSet(gl) {
        this._z.pipeline_gl_context_set(this._impl, gl);
    }
    /**
     * Informs the pipeline that the GL context is lost and should not be used.
    */ glContextLost() {
        this._z.pipeline_gl_context_lost(this._impl);
    }
    /**
     * Returns the most recent camera frame texture.
    */ cameraFrameTextureGL() {
        return this._z.pipeline_camera_frame_texture_gl(this._impl);
    }
    /**
     * Returns a matrix that you can use to transform the UV coordinates of the following full-screen quad in order to render the camera texture:
     *
     * Vertex 0: `-1, -1, 0`
     *
     * UV 0: `0, 0`
     *
     * Vertex 1: `-1, 1, 0`
     *
     * UV 1: `0, 1`
     *
     * Vertex 2: `1, -1, 0`
     *
     * UV 1: `1, 0`
     *
     * Vertex 3: `1, 1, 0`
     *
     * UV 1: `1, 1`
     *
     * @param renderWidth - The width of the canvas.
     * @param renderHeight - The height of the canvas.
     * @param mirror - Pass `true` to mirror the camera image in the X-axis.
     * @returns A 4x4 column-major transformation matrix.
    */ cameraFrameTextureMatrix(renderWidth, renderHeight, mirror) {
        return this._z.pipeline_camera_frame_texture_matrix(this._impl, renderWidth, renderHeight, mirror === true);
    }
    /**
    * Draw the camera to the screen as a full screen quad.
    *
    * Please note this function modifies some GL state during its operation so you may need to reset the following GL state if you use it:
    * - The currently bound texture 2D is set to `null` (e.g. `gl.bindTexture(gl.TEXTURE_2D, null)`)
    * - The currently bound array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ARRAY_BUFFER, null);`)
    * - The currently bound program is set to `null` (e.g. `gl.useProgram(null)`)
    * - The currently active texture is set to `gl.TEXTURE0` (e.g. `gl.activeTexture(gl.TEXTURE0)`)
    * - These features are disabled: `gl.SCISSOR_TEST`, `gl.DEPTH_TEST`, `gl.BLEND`, `gl.CULL_FACE`
    * @param renderWidth - The width of the canvas.
    * @param renderHeight - The height of the canvas.
    * @param mirror - Pass `true` to mirror the camera image in the X-axis.
   */ cameraFrameDrawGL(renderWidth, renderHeight, mirror) {
        this._z.pipeline_camera_frame_draw_gl(this._impl, renderWidth, renderHeight, mirror);
    }
    /**
     * Uploads the current camera frame to a WebGL texture.
    */ cameraFrameUploadGL() {
        this._z.pipeline_camera_frame_upload_gl(this._impl);
    }
    /**
     * Prepares camera frames for processing.
     *
     * Call this function on your pipeline once an animation frame (e.g. during your `requestAnimationFrame` function) in order to process incoming camera frames.
     *
     * Please note this function modifies some GL state during its operation so you may need to reset the following GL state if you use it:
     * - The currently bound framebuffer is set to `null` (e.g. `gl.bindFramebuffer(gl.FRAMEBUFFER, null)`)
     * - The currently bound texture 2D is set to `null` (e.g. `gl.bindTexture(gl.TEXTURE_2D, null)`)
     * - The currently bound array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ARRAY_BUFFER, null);`)
     * - The currently bound element array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null)`)
     * - The currently bound program is set to `null` (e.g. `gl.useProgram(null)`)
     * - The currently active texture is set to `gl.TEXTURE0` (e.g. `gl.activeTexture(gl.TEXTURE0)`)
     * - These features are disabled: `gl.SCISSOR_TEST`, `gl.DEPTH_TEST`, `gl.BLEND`, `gl.CULL_FACE`
     * - The pixel store flip-Y mode is disabled (e.g. `gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false)`)
     * - The viewport is changed (e.g. `gl.viewport(...)`)
     * - The clear color is changed (e.g. `gl.clearColor(...)`)
    */ processGL() {
        this._z.pipeline_process_gl(this._impl);
    }
    /**
     * Returns the camera model (i.e. the intrinsic camera parameters) for the current frame.
    */ cameraModel() {
        return this._z.pipeline_camera_model(this._impl);
    }
    /**
     * Returns a transformation where the camera sits, stationary, at the origin of world space, and points down the negative Z axis.
     *
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     *
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseDefault() {
        return this._z.pipeline_camera_pose_default(this._impl);
    }
    /**
     * Returns a transformation where the camera sits at the origin of world space, but rotates as the user rotates the physical device.
     *
     * When the Zappar library initializes, the negative Z axis of world space points forward in front of the user.
     *
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     *
     * @param mirror -  Pass `true` to mirror the location in the X-axis.
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseWithAttitude(mirror) {
        return this._z.pipeline_camera_pose_with_attitude(this._impl, mirror || false);
    }
    /**
     * Returns a transformation with the (camera-relative) origin specified by the supplied parameter.
     *
     * This is used with the `poseCameraRelative(...) : Float32Array` functions provided by the various anchor types to allow a given anchor (e.g. a tracked image or face) to be the origin of world space.
     *
     * In this case the camera moves and rotates in world space around the anchor at the origin.
     *
     * @param o - The origin matrix.
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseWithOrigin(o) {
        return this._z.pipeline_camera_pose_with_origin(this._impl, o);
    }
    /**
      * Returns true if the current camera frame came from a user-facing camera
     */ cameraFrameUserFacing() {
        return this._z.pipeline_camera_frame_user_facing(this._impl);
    }
    /**
      * @ignore
     */ drawFace(projectionMatrix, cameraMatrix, targetMatrix, m) {
        this._z.pipeline_draw_face(this._impl, projectionMatrix, cameraMatrix, targetMatrix, m._getImpl());
    }
    /**
      * Returns the number of the current frame.
     */ frameNumber() {
        return this._z.pipeline_frame_number(this._impl);
    }
    /**
     * Start recording camera and motion data into memory. This data can then used with SequenceSource to replay the sequence.
     *
     * @param expectedFrames - The number of camera frames you expect to capture. If supplied, memory will be pre-allocated to improve performance
     */ sequenceRecordStart(expectedFrames) {
        if (expectedFrames === undefined) expectedFrames = 150; // 5 second default
        this._z.pipeline_sequence_record_start(this._impl, expectedFrames);
    }
    /**
     * Stop recording camera and motion data.
     */ sequenceRecordStop() {
        this._z.pipeline_sequence_record_stop(this._impl);
    }
    /**
     * Remove any camera and motion data currently stored in memory.
     */ sequenceRecordClear() {
        this._z.pipeline_sequence_record_clear(this._impl);
    }
    /**
     * Get the data captured by sequence recording.
     *
     * @returns A Uint8Array of packed camera and motion data
     */ sequenceRecordData() {
        return this._z.pipeline_sequence_record_data(this._impl);
    }
}





class $df6c913b1bef7e5c$export$8da7a4c55ed49539 {
    /**
     * Constructs a new FaceLanmdmark.
     * @param _name - The name of the landmark to track.
     * @see https://docs.zap.works/universal-ar/javascript/face-tracking/
    */ constructor(_name){
        this._name = _name;
        /**
         * The most recent pose of this landmark, relative to the [[FaceAnchor]] used to update it.
         * A 4x4 column-major transformation matrix.
         */ this.pose = (0, $2edf3b5f20103352$exports).create();
        this._z = (0, $16ba0ad9af69b2e5$exports.z)();
        this._impl = this._z.face_landmark_create(this._name);
    }
    /**
     * Destroys the face landmark.
     */ destroy() {
        this._z.face_landmark_destroy(this._impl);
    }
    /**
     * Updates pose directly from the expression and identity in a [[FaceAnchor]].
     * @param f - The anchor to derive the expression and identity from.
     * @param mirror - Pass `true` to mirror the location in the X-axis.
    */ updateFromFaceAnchor(f, mirror) {
        this._z.face_landmark_update(this._impl, f.identity, f.expression, mirror || false);
        this.pose = this._z.face_landmark_anchor_pose(this._impl);
    }
    /**
     * Updates pose directly from identity and expression coefficients.
     * @param identity  - The identity coefficients.
     * @param expression - The expression coefficients.
     * @param mirror - Pass `true` to mirror the location in the X-axis.
    */ updateFromIdentityExpression(identity, expression, mirror) {
        this._z.face_landmark_update(this._impl, identity, expression, mirror || false);
        this.pose = this._z.face_landmark_anchor_pose(this._impl);
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
}


var $1865e185f0ff5554$exports = {};

$parcel$export($1865e185f0ff5554$exports, "permissionGranted", function () { return $1865e185f0ff5554$export$f568f2f64377aed0; });

var $1865e185f0ff5554$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1865e185f0ff5554$export$a461eaf23bef603e;
(function(Permission) {
    /**
    * Permission to access camera images.
    */ Permission[Permission["CAMERA"] = 0] = "CAMERA";
    /**
     * Permission to access device motion data (e.g. accelerometer and gyro). Some tracking algorithms require this data to operate.
     */ Permission[Permission["MOTION"] = 1] = "MOTION";
})($1865e185f0ff5554$export$a461eaf23bef603e || ($1865e185f0ff5554$export$a461eaf23bef603e = {}));
function $1865e185f0ff5554$export$f568f2f64377aed0(onlyPermsission) {
    switch(onlyPermsission){
        case $1865e185f0ff5554$export$a461eaf23bef603e.CAMERA:
            return (0, $16ba0ad9af69b2e5$exports.z)().permission_granted_camera();
        case $1865e185f0ff5554$export$a461eaf23bef603e.MOTION:
            return (0, $16ba0ad9af69b2e5$exports.z)().permission_granted_motion();
        default:
            return (0, $16ba0ad9af69b2e5$exports.z)().permission_granted_all();
    }
}
function $1865e185f0ff5554$export$a188bf2e0d7eb5c7(onlyPermission) {
    switch(onlyPermission){
        case $1865e185f0ff5554$export$a461eaf23bef603e.CAMERA:
            return (0, $16ba0ad9af69b2e5$exports.z)().permission_denied_camera();
        case $1865e185f0ff5554$export$a461eaf23bef603e.MOTION:
            return (0, $16ba0ad9af69b2e5$exports.z)().permission_denied_motion();
        default:
            return (0, $16ba0ad9af69b2e5$exports.z)().permission_denied_any();
    }
}
function $1865e185f0ff5554$export$d303ff031c4d4b58(onlyPermission) {
    switch(onlyPermission){
        case $1865e185f0ff5554$export$a461eaf23bef603e.CAMERA:
            (0, $16ba0ad9af69b2e5$exports.z)().permission_request_camera();
            break;
        case $1865e185f0ff5554$export$a461eaf23bef603e.MOTION:
            (0, $16ba0ad9af69b2e5$exports.z)().permission_request_motion();
            break;
        default:
            (0, $16ba0ad9af69b2e5$exports.z)().permission_request_all();
            break;
    }
    // eslint-disable-next-line no-async-promise-executor
    return new Promise((resolve)=>$1865e185f0ff5554$var$__awaiter(this, void 0, void 0, function*() {
            // eslint-disable-next-line no-constant-condition
            while(true){
                yield $1865e185f0ff5554$var$_nextFrame();
                switch(onlyPermission){
                    case $1865e185f0ff5554$export$a461eaf23bef603e.CAMERA:
                        if ((0, $16ba0ad9af69b2e5$exports.z)().permission_granted_camera()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $16ba0ad9af69b2e5$exports.z)().permission_denied_camera()) {
                            resolve(false);
                            return;
                        }
                        break;
                    case $1865e185f0ff5554$export$a461eaf23bef603e.MOTION:
                        if ((0, $16ba0ad9af69b2e5$exports.z)().permission_granted_motion()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $16ba0ad9af69b2e5$exports.z)().permission_denied_motion()) {
                            resolve(false);
                            return;
                        }
                        break;
                    default:
                        if ((0, $16ba0ad9af69b2e5$exports.z)().permission_granted_camera() && (0, $16ba0ad9af69b2e5$exports.z)().permission_granted_motion()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $16ba0ad9af69b2e5$exports.z)().permission_denied_camera() || (0, $16ba0ad9af69b2e5$exports.z)().permission_denied_motion()) {
                            resolve(false);
                            return;
                        }
                        break;
                }
            }
        }));
}
function $1865e185f0ff5554$export$447cf121adb7b558() {
    return $1865e185f0ff5554$var$__awaiter(this, void 0, void 0, function*() {
        return yield (0, $16ba0ad9af69b2e5$exports.z)().permission_request_ui_promise();
    });
}
function $1865e185f0ff5554$export$2e339b4d51173824() {
    return (0, $16ba0ad9af69b2e5$exports.z)().permission_denied_ui();
}
function $1865e185f0ff5554$var$_nextFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}




function $6bb3f59178deb876$export$b564441c22aac826() {
    return (0, $16ba0ad9af69b2e5$exports.z)().log_level();
}
function $6bb3f59178deb876$export$c622e99c0ce7b1c9(l) {
    (0, $16ba0ad9af69b2e5$exports.z)().log_level_set(l);
}






/* eslint-disable tsdoc/syntax */ // eslint-disable-next-line no-restricted-imports

const $ef9360c70215a050$export$80ed8c37bba391f3 = $e97a97f0b0cf48c9$exports;




let $e9c3a419a4122d1f$var$defaultPipeline;
const $e9c3a419a4122d1f$export$129b224e7efc1ade = new (0, $bd0785a1f078b628$export$d61e24a684f9e51)();
function $e9c3a419a4122d1f$export$aaa5f5f072ab70d() {
    if (!$e9c3a419a4122d1f$var$defaultPipeline) {
        $e9c3a419a4122d1f$var$defaultPipeline = new $3aa97644b1167104$export$abd47b564b6c9ce2();
        $e9c3a419a4122d1f$var$defaultPipeline.onFrameUpdate.bind(()=>$e9c3a419a4122d1f$export$129b224e7efc1ade.emit());
    }
    return $e9c3a419a4122d1f$var$defaultPipeline;
}
class $e9c3a419a4122d1f$export$333222788f3dd075 extends $20ed77af6adf4d0f$exports.ImageTracker {
    /**
     * Constructs a new ImageTracker.
     * @param targetFile - The .zpt target file from the source image you'd like to track.
     * @param pipeline - The pipeline that this tracker will operate within.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
     */ constructor(targetFile, pipeline){
        super(pipeline || $e9c3a419a4122d1f$export$aaa5f5f072ab70d(), targetFile);
    }
}
class $e9c3a419a4122d1f$export$441c3cbad541da1b extends $dd31c4de20a19f0a$export$441c3cbad541da1b {
    /**
     * Constructs a new BarcodeFinder.
     * @param pipeline - The pipeline that this tracker will operate within.
     */ constructor(pipeline){
        super(pipeline || $e9c3a419a4122d1f$export$aaa5f5f072ab70d());
    }
}
class $e9c3a419a4122d1f$export$bb2337bd021e3bce extends $b93e1b8491784d92$exports.FaceTracker {
    /**
     * Constructs a new FaceTracker.
     * @param _pipeline - The pipeline that this tracker will operate within.
     */ constructor(pipeline){
        super(pipeline || $e9c3a419a4122d1f$export$aaa5f5f072ab70d());
    }
}
class $e9c3a419a4122d1f$export$230d52b81bfab97f extends $ae336885894939c7$export$230d52b81bfab97f {
    /**
     * Constructs a new InstantWorldTracker.
     * @param _pipeline - The pipeline that this tracker will operate within.
     */ constructor(pipeline){
        super(pipeline || $e9c3a419a4122d1f$export$aaa5f5f072ab70d());
    }
}
class $e9c3a419a4122d1f$export$9a93ce53f488cb2e extends $331f49974e73e77e$export$9a93ce53f488cb2e {
    /**
     * Constructs a new CameraSource.
     * @param _pipeline - The pipeline that this source will operate within.
     * @param deviceId - The camera device ID which will be used as the source.
     * @see https://docs.zap.works/universal-ar/javascript/pipelines-and-camera-processing/
     */ constructor(deviceId, pipeline){
        super(pipeline || $e9c3a419a4122d1f$export$aaa5f5f072ab70d(), deviceId);
    }
}
class $e9c3a419a4122d1f$export$bbfb48c500076b66 extends $6c9834203f6acbdf$export$bbfb48c500076b66 {
    /**
     * Constructs a new HTMLElementSource.
     * @param element -  The HTML source element.
     * @param pipeline - The pipeline that this tracker will operate within.
     */ constructor(element, pipeline){
        super(pipeline || $e9c3a419a4122d1f$export$aaa5f5f072ab70d(), element);
    }
}
function $e9c3a419a4122d1f$export$efb561eaedf42055(gl) {
    $e9c3a419a4122d1f$export$aaa5f5f072ab70d().glContextSet(gl);
}
function $e9c3a419a4122d1f$export$3ca78aa2d472f506() {
    $e9c3a419a4122d1f$export$aaa5f5f072ab70d().glContextLost();
}




class $cd14ecab9f038da0$export$6516fe1fcd178d63 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Texture {
    constructor(){
        super(...arguments);
        this.MirrorMode = (0, $1ec2e62baebbadc2$export$974403070558317).None;
        this.isVideoTexture = true;
    }
    /**
     * Override three.js update function since we update the camera texture ourselves.
     */ update() {}
    /**
     * Processes camera frames and updates the texture.
     * @param renderer - The Three.js WebGL renderer.
     * @param pipeline - A ZapparThree Pipeline.
     */ updateFromPipeline(renderer, pipeline) {
        this.encoding = renderer.outputEncoding;
        pipeline.cameraFrameUploadGL();
        const texture = pipeline.cameraFrameTextureGL();
        if (!texture) return;
        // Update the underlying WebGL texture of the ThreeJS texture object
        // to the one provided by the Zappar library
        const properties = renderer.properties.get(this);
        // eslint-disable-next-line no-underscore-dangle
        properties.__webglTexture = texture;
        // eslint-disable-next-line no-underscore-dangle
        properties.__webglInit = true;
        // The Zappar library provides a 4x4 UV matrix to display the camera
        // texture on a fullscreen quad with 0,0 -> 1,1 UV coordinates
        const view = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Matrix4();
        view.fromArray(pipeline.cameraFrameTextureMatrix(renderer.domElement.width, renderer.domElement.height, this.MirrorMode === (0, $1ec2e62baebbadc2$export$974403070558317).Poses));
        // ThreeJS's Texture object uses a 3x3 matrix, so convert from our 4x4 matrix
        const textureMatrix3 = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Matrix3();
        textureMatrix3.setFromMatrix4(view);
        // eslint-disable-next-line prefer-destructuring
        textureMatrix3.elements[6] = view.elements[12];
        // eslint-disable-next-line prefer-destructuring
        textureMatrix3.elements[7] = view.elements[13];
        textureMatrix3.elements[8] = 1;
        // The typings for ThreeJS's Texture object does not include the matrix properties
        // so we have a custom type here
        this.matrixAutoUpdate = false;
        this.matrix = textureMatrix3;
    }
}


var $1ec2e62baebbadc2$export$3a3d770f890a3a97;
(function(CameraPoseMode) {
    /**
     * The camera sits, stationary, at the origin of world space, and points down the negative Z axis.
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     */ CameraPoseMode[CameraPoseMode["Default"] = 0] = "Default";
    /**
     * The camera sits at the origin of world space, but rotates as the user rotates the physical device.
     *
     * When the Zappar library initializes, the negative Z axis of world space points forward in front of the user.
     *
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     */ CameraPoseMode[CameraPoseMode["Attitude"] = 1] = "Attitude";
    /**
     * In this case the camera moves and rotates in world space around the anchor at the origin.
     */ CameraPoseMode[CameraPoseMode["AnchorOrigin"] = 2] = "AnchorOrigin";
})($1ec2e62baebbadc2$export$3a3d770f890a3a97 || ($1ec2e62baebbadc2$export$3a3d770f890a3a97 = {}));
var $1ec2e62baebbadc2$export$974403070558317;
(function(CameraMirrorMode) {
    /**
     * No mirroring.
     */ CameraMirrorMode[CameraMirrorMode["None"] = 0] = "None";
    /**
     * This mode mirrors the background camera texture and ensures content still appears correctly tracked.
     * In this mode your content itself isn't flipped, so any text in your tracked content doesn't appear mirrored.
     * This is the default mode for the user-facing camera.
     */ CameraMirrorMode[CameraMirrorMode["Poses"] = 1] = "Poses";
    /**
     * In this mode, the Zappar camera applies a scaleX(-1) CSS transform to your whole canvas.
     * This way both the camera and your content appear mirrored.
     */ CameraMirrorMode[CameraMirrorMode["CSS"] = 2] = "CSS";
})($1ec2e62baebbadc2$export$974403070558317 || ($1ec2e62baebbadc2$export$974403070558317 = {}));
/**
 * The directions that the camera can face.
 */ var $1ec2e62baebbadc2$var$CameraDirection;
(function(CameraDirection) {
    /** The camera is not running.
     * This is the default mode for the camera.
     */ CameraDirection[CameraDirection["None"] = 0] = "None";
    /** In this mode, the camera is always facing the user. */ CameraDirection[CameraDirection["User"] = 1] = "User";
    /** In this mode, the camera is always facing away from the user. */ CameraDirection[CameraDirection["Rear"] = 2] = "Rear";
})($1ec2e62baebbadc2$var$CameraDirection || ($1ec2e62baebbadc2$var$CameraDirection = {}));
class $1ec2e62baebbadc2$export$79f141de891a5fed extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Camera {
    /**
     * Constructs a new Camera.
     * @param pipeline - The pipeline that this tracker will operate within.
     * @property pipeline - The pipeline that this tracker will operate within.
     * @property zNear - The near clipping plane.
     * @property zFar - The far clipping plane.
     * @property rearCameraSource? - The camera source which will be used for the rear camera.
     * @property userCameraSource? - The camera source which will be used for the user camera.
     */ constructor(opts){
        super();
        /**
         * The pose mode that determines how the camera moves in the scene.
         */ this.poseMode = $1ec2e62baebbadc2$export$3a3d770f890a3a97.Default;
        /**
         * The mirror mode that is used for the rear camera.
         */ this.rearCameraMirrorMode = $1ec2e62baebbadc2$export$974403070558317.None;
        /**
         * The mirror mode that is used for the user camera.
         */ this.userCameraMirrorMode = $1ec2e62baebbadc2$export$974403070558317.Poses;
        this._currentMirrorMode = $1ec2e62baebbadc2$export$974403070558317.None;
        /**
         * @ignore
         * Needed for raycasters to work.
         */ this.isPerspectiveCamera = true;
        this.cameraDirection = $1ec2e62baebbadc2$var$CameraDirection.None;
        this.hasSetCSSScaleX = false;
        this.renderWidth = 0;
        this.renderHeight = 0;
        this.pipeline = opts instanceof $3aa97644b1167104$export$abd47b564b6c9ce2 ? opts : (opts === null || opts === void 0 ? void 0 : opts.pipeline) || (0, $e9c3a419a4122d1f$export$aaa5f5f072ab70d)();
        this.rawPose = this.pipeline.cameraPoseDefault();
        if (opts && !(opts instanceof $3aa97644b1167104$export$abd47b564b6c9ce2)) {
            this.zNear = opts.zNear ? opts.zNear : 0.1;
            this.zFar = opts.zFar ? opts.zFar : 100;
            this.rearCameraSource = this.cameraSourceFromOpts(opts.rearCameraSource);
            this.userCameraSource = this.cameraSourceFromOpts(opts.userCameraSource, true);
            this.backgroundTexture = opts.backgroundTexture ? opts.backgroundTexture : new (0, $cd14ecab9f038da0$export$6516fe1fcd178d63)();
        } else {
            this.rearCameraSource = new (0, $e9c3a419a4122d1f$export$9a93ce53f488cb2e)($16ba0ad9af69b2e5$exports.cameraDefaultDeviceID(), this.pipeline);
            this.userCameraSource = new (0, $e9c3a419a4122d1f$export$9a93ce53f488cb2e)($16ba0ad9af69b2e5$exports.cameraDefaultDeviceID(true), this.pipeline);
            this.backgroundTexture = new (0, $cd14ecab9f038da0$export$6516fe1fcd178d63)();
        }
        this.matrixAutoUpdate = false;
        document.addEventListener("visibilitychange", ()=>{
            document.visibilityState === "visible" ? this.resume() : this.pause();
        });
    }
    /**
     * Constructs a new CameraSource or HTMLElementSource based on parameters passed in.
     * @param cameraSource - HTML element or camera device ID which will be used as a source
     * @returns CameraSource if cameraSource param is undefined or string, otherwise HTMLElementSource.
     */ cameraSourceFromOpts(cameraSource, frontFacing = false) {
        return cameraSource instanceof Element ? new $6c9834203f6acbdf$export$bbfb48c500076b66(this.pipeline, cameraSource) : new (0, $e9c3a419a4122d1f$export$9a93ce53f488cb2e)(cameraSource || $16ba0ad9af69b2e5$exports.cameraDefaultDeviceID(frontFacing), this.pipeline);
    }
    /**
     * Pauses the camera source.
     */ pause() {
        this.userCameraSource.pause();
        this.rearCameraSource.pause();
    }
    /**
     * Starts the camera source.
     *
     * Starting a given source pauses any other sources within the same pipeline.
     */ resume() {
        switch(this.cameraDirection){
            case $1ec2e62baebbadc2$var$CameraDirection.User:
                this.userCameraSource.start();
                break;
            case $1ec2e62baebbadc2$var$CameraDirection.Rear:
                this.rearCameraSource.start();
                break;
            default:
                break;
        }
    }
    /**
     * Starts the camera source.
     * @param userFacing - If true, starts the user facing camera. (i.e selfie).
     */ start(userFacing) {
        this.cameraDirection = userFacing ? $1ec2e62baebbadc2$var$CameraDirection.User : $1ec2e62baebbadc2$var$CameraDirection.Rear;
        this.resume();
    }
    /**
     * Stops the camera source.
     */ stop() {
        this.cameraDirection = $1ec2e62baebbadc2$var$CameraDirection.None;
        this.pause();
    }
    /**
     * Sets the pose mode to 'Anchor Origin'.
     *
     * In this case the camera moves and rotates in world space around the anchor at the origin.
     * @param anchor - The anchor that defines the origin.
     */ setPoseModeAnchorOrigin(anchor) {
        this.poseAnchorOrigin = anchor;
        this.poseMode = $1ec2e62baebbadc2$export$3a3d770f890a3a97.AnchorOrigin;
    }
    /**
     * Gets the current mirror mode.
     */ get currentMirrorMode() {
        // eslint-disable-next-line no-underscore-dangle
        return this._currentMirrorMode;
    }
    /**
     * Processes camera frames and updates `backgroundTexture`.
     * Call this function on your pipeline once an animation frame (e.g. during your `requestAnimationFrame` function).
     * @param renderer - The Three.js WebGL renderer.
     */ updateFrame(renderer) {
        this.pipeline.processGL();
        // Update to using the latest tracking frame data
        this.pipeline.frameUpdate();
        // eslint-disable-next-line no-underscore-dangle
        this._currentMirrorMode = this.pipeline.cameraFrameUserFacing() ? this.userCameraMirrorMode : this.rearCameraMirrorMode;
        const { domElement: domElement } = renderer;
        if (this.currentMirrorMode !== $1ec2e62baebbadc2$export$974403070558317.CSS && this.hasSetCSSScaleX) {
            domElement.style.transform = "";
            this.hasSetCSSScaleX = false;
        } else if (this.currentMirrorMode === $1ec2e62baebbadc2$export$974403070558317.CSS && !this.hasSetCSSScaleX) {
            domElement.style.transform = "scaleX(-1)";
            this.hasSetCSSScaleX = true;
        }
        this.renderWidth = renderer.domElement.width;
        this.renderHeight = renderer.domElement.height;
        // eslint-disable-next-line no-underscore-dangle
        this._updateProjectionMatrix();
        // Get the pose of the camera from the Zappar library
        switch(this.poseMode){
            case $1ec2e62baebbadc2$export$3a3d770f890a3a97.Default:
                this.rawPose = this.pipeline.cameraPoseDefault();
                break;
            case $1ec2e62baebbadc2$export$3a3d770f890a3a97.Attitude:
                this.rawPose = this.pipeline.cameraPoseWithAttitude(this.currentMirrorMode === $1ec2e62baebbadc2$export$974403070558317.Poses);
                break;
            case $1ec2e62baebbadc2$export$3a3d770f890a3a97.AnchorOrigin:
                this.rawPose = this.poseAnchorOrigin ? this.getOriginPose() : this.pipeline.cameraPoseDefault();
                break;
            default:
                this.rawPose = this.pipeline.cameraPoseDefault();
                break;
        }
        this.matrixWorldNeedsUpdate = true;
        this.backgroundTexture.MirrorMode = this.currentMirrorMode;
        this.backgroundTexture.updateFromPipeline(renderer, this.pipeline);
    }
    // eslint-disable-next-line no-underscore-dangle
    _updateProjectionMatrix() {
        // Get the projection matrix for the camera from the Zappar library
        const model = this.pipeline.cameraModel();
        const projection = $16ba0ad9af69b2e5$exports.projectionMatrixFromCameraModel(model, this.renderWidth, this.renderHeight, this.zNear, this.zFar);
        this.projectionMatrix.fromArray(projection);
        if (typeof this.projectionMatrixInverse.invert === "function") this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
        else this.projectionMatrixInverse.getInverse(this.projectionMatrix);
    }
    updateMatrixWorld(force) {
        this.matrix.fromArray(this.rawPose);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
        super.updateMatrixWorld(force);
    }
    getOriginPose() {
        if (!this.poseAnchorOrigin) return this.pipeline.cameraPoseDefault();
        return this.pipeline.cameraPoseWithOrigin(this.poseAnchorOrigin.poseCameraRelative(this.currentMirrorMode === $1ec2e62baebbadc2$export$974403070558317.Poses));
    }
    /**
     * Destroys the camera sources.
     */ dispose() {
        this.rearCameraSource.destroy();
        this.userCameraSource.destroy();
    }
}




class $177c8c5806e97245$export$b3062829607710c9 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Group {
    /**
     * Constructs a new ImageAnchorGroup.
     * @param camera - A ZapparThree.Camera.
     * @param imageTracker - The image tracker which will be used.
     * @param anchorId - Specify this to limit the group to tracking an anchor with the provided ID.
     */ constructor(camera, imageTracker, anchorId){
        super();
        this.camera = camera;
        this.imageTracker = imageTracker;
        this.anchorId = anchorId;
        /**
         * @ignore
         */ this.isReady = false;
        // We'll be updating this Group's matrix ourselves from the Zappar library
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        if (!this.currentAnchor || !this.imageTracker.visible.has(this.currentAnchor)) {
            // No current anchor, or current anchor isn't visible
            if (this.anchorId) this.currentAnchor = this.imageTracker.anchors.get(this.anchorId);
            else this.currentAnchor = this.imageTracker.visible.values().next().value;
        }
        if (this.currentAnchor) {
            this.matrix.fromArray(this.currentAnchor.pose(this.camera.rawPose, this.camera.currentMirrorMode === (0, $1ec2e62baebbadc2$export$974403070558317).Poses));
            this.matrix.decompose(this.position, this.quaternion, this.scale);
        }
        super.updateMatrixWorld(force);
    }
}


/* eslint-disable class-methods-use-this */ 

class $e45f47998eef9c1c$export$476589aa8292412e extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Loader {
    /**
     * Loads an image tracker.
     * @param zpt - A URL to, or ArrayBuffer of, an image target file.
     * @param onLoad - Callback which returns the imageTracker once it's loaded.
     * @param onError - Callback which is called if there's an error loading the target file.
     * @returns The ImageTracker.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
     */ load(zpt, onLoad, onProgress, onError) {
        const trk = new (0, $e9c3a419a4122d1f$export$333222788f3dd075)();
        trk.loadTarget(zpt).then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(zpt);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(zpt);
            this.manager.itemEnd(zpt);
        });
        return trk;
    }
    /**
     * @ignore
     */ parse() {}
}




class $0f9fcc9ccf2c8e5b$export$d205f0b92721f194 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Group {
    /**
     * Constructs a new InstantWorldAnchorGroup.
     * @param camera - A ZapparThree.Camera.
     * @param instantTracker - The instant world tracker which will be used.
     */ constructor(camera, instantTracker){
        super();
        this.camera = camera;
        this.instantTracker = instantTracker;
        // We'll be updating this Group's matrix ourselves from the Zappar library
        this.matrixAutoUpdate = false;
    }
    /**
     * Sets the point in the user's environment that the anchor tracks from.
     *
     * The parameters passed in to this function correspond to the X, Y and Z coordinates (in camera space) of the point to track.
     * Choosing a position with X and Y coordinates of zero, and a negative Z coordinate,
     * will select a point on a surface directly in front of the center of the screen.
     *
     * @param orientation -  The orientation of the point in space.
     */ setAnchorPoseFromCameraOffset(x, y, z, orientation) {
        this.instantTracker.setAnchorPoseFromCameraOffset(x, y, z, orientation);
    }
    updateMatrixWorld(force) {
        this.matrix.fromArray(this.instantTracker.anchor.pose(this.camera.rawPose, this.camera.currentMirrorMode === (0, $1ec2e62baebbadc2$export$974403070558317).Poses));
        this.matrix.decompose(this.position, this.quaternion, this.scale);
        super.updateMatrixWorld(force);
    }
}




class $1c22ab919cfd08b0$export$c7a2c06edb4f910d extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Group {
    /**
     * Constructs a new FaceAnchorGroup.
     * @param camera - A ZapparThree.Camera.
     * @param faceTracker - The face tracker which will be used.
     * @param anchorId - Specify this to limit the group to tracking an anchor with the provided ID.
     */ constructor(camera, faceTracker, anchorId){
        super();
        this.camera = camera;
        this.faceTracker = faceTracker;
        this.anchorId = anchorId;
        /**
         * @ignore
         */ this.isReady = false;
        // We'll be updating this Group's matrix ourselves from the Zappar library
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        if (!this.currentAnchor || !this.faceTracker.visible.has(this.currentAnchor)) {
            // No current anchor, or current anchor isn't visible
            if (this.anchorId) this.currentAnchor = this.faceTracker.anchors.get(this.anchorId);
            else this.currentAnchor = this.faceTracker.visible.values().next().value;
        }
        if (this.currentAnchor) {
            this.matrix.fromArray(this.currentAnchor.pose(this.camera.rawPose, this.camera.currentMirrorMode === (0, $1ec2e62baebbadc2$export$974403070558317).Poses));
            this.matrix.decompose(this.position, this.quaternion, this.scale);
        }
        super.updateMatrixWorld(force);
    }
}






class $a4691b6c2888a809$export$2b6da85a49cb7391 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Group {
    /**
     * Constructs a new FaceLandmarkGroup.
     * @param camera - A ZapparThree.Camera.
     * @param faceTracker - The face tracker which will be used.
     * @param landmark - The landmark to which the group will be anchored.
     */ constructor(camera, faceTracker, landmark){
        super();
        this.camera = camera;
        this.faceTracker = faceTracker;
        this.pose = (0, $2edf3b5f20103352$exports).create();
        this.landmark = new (0, $df6c913b1bef7e5c$export$8da7a4c55ed49539)(landmark);
        // We'll be updating this Group's matrix ourselves from the Zappar library
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        if (!this.currentAnchor || !this.faceTracker.visible.has(this.currentAnchor)) // No current anchor, or current anchor isn't visible
        this.currentAnchor = this.faceTracker.visible.values().next().value;
        if (this.currentAnchor) {
            this.landmark.updateFromFaceAnchor(this.currentAnchor, this.camera.currentMirrorMode === (0, $1ec2e62baebbadc2$export$974403070558317).Poses);
            (0, $2edf3b5f20103352$exports).multiply(this.pose, this.currentAnchor.pose(this.camera.rawPose, this.camera.currentMirrorMode === (0, $1ec2e62baebbadc2$export$974403070558317).Poses), this.landmark.pose);
            this.matrix.fromArray(this.pose);
            this.matrix.decompose(this.position, this.quaternion, this.scale);
        }
        super.updateMatrixWorld(force);
    }
    /**
     * Destroys the face landmark.
     */ dispose() {
        this.landmark.destroy();
    }
}


/* eslint-disable class-methods-use-this */ 

class $fdb3cf10ce6c67af$export$6477c3a8ab843fd9 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Loader {
    /**
     * Loads face tracking model data.
     * @param customModel - A URL to, or ArrayBuffer of, model data.
     * @param options - A URL or ArrayBuffer of the source mesh data or defines if some face features should be filled with polygons.
     * @param onLoad - Callback which returns the FaceMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The FaceTracker.
     */ load(customModel, onLoad, onProgress, onError) {
        const trk = new (0, $e9c3a419a4122d1f$export$bb2337bd021e3bce)();
        const p = customModel ? trk.loadModel(customModel) : trk.loadDefaultModel();
        const itemFilename = typeof customModel === "string" ? customModel : "__zappar_threejs_face_tracker_default";
        p.then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(itemFilename);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(itemFilename);
            this.manager.itemEnd(itemFilename);
        });
        return trk;
    }
    /**
     * @ignore
     */ parse() {}
}



/* eslint-disable class-methods-use-this */ 

class $20a2a009ad144235$export$866c7932b77a7aa1 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Loader {
    /**
     * Loads the data for a face mesh.
     * @param options - A URL or ArrayBuffer of the source mesh data or defines if some face features should be filled with polygons.
     * @param onLoad - Callback which returns the FaceMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The FaceMesh.
     */ load(options, onLoad, onProgress, onError) {
        const trk = new (0, $5b535c031aa0f632$exports.FaceMesh)();
        let p;
        const itemFilename = `__zappar_threejs_face_mesh_${JSON.stringify(options || "default")}`;
        this.manager.itemStart(itemFilename);
        if (options) {
            if (typeof options === "string") p = trk.load(options);
            else if (options.customModel) p = trk.load(options.customModel, options.fillMouth, options.fillEyeLeft, options.fillEyeRight, options.fillNeck);
            else p = trk.loadDefaultFace(options.fillMouth, options.fillEyeLeft, options.fillEyeRight);
        } else p = trk.loadDefaultFace();
        p.then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(itemFilename);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(itemFilename);
            this.manager.itemEnd(itemFilename);
        });
        return trk;
    }
    /**
     * Loads the default face mesh.
     * @param options - Defines if some face features should be filled with polygons.
     * @param onLoad - Callback which returns the FaceMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The FaceMesh.
     */ loadFace(options, onLoad, onProgress, onError) {
        const trk = new (0, $5b535c031aa0f632$exports.FaceMesh)();
        let p;
        const itemFilename = `__zappar_threejs_face_mesh_face_${JSON.stringify(options || "default")}`;
        if (options) {
            if (options.customModel) p = trk.load(options.customModel, options.fillMouth, options.fillEyeLeft, options.fillEyeRight, options.fillNeck);
            else p = trk.loadDefaultFace(options.fillMouth, options.fillEyeLeft, options.fillEyeRight);
        } else p = trk.loadDefaultFace();
        p.then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(itemFilename);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(itemFilename);
            this.manager.itemEnd(itemFilename);
        });
        return trk;
    }
    /**
     * Loads the full head simplified mesh which covers the whole of the user's head, including some neck.
     * It's ideal for drawing into the depth buffer in order to mask out the back of 3D models placed on the user's head.
     * @param options - Defines if some face features should be filled with polygons.
     * @param onLoad - Callback which returns the FaceMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The FaceMesh.
     */ loadFullHeadSimplified(options, onLoad, onProgress, onError) {
        const trk = new (0, $5b535c031aa0f632$exports.FaceMesh)();
        let p;
        const itemFilename = `__zappar_threejs_face_mesh_full_head_${JSON.stringify(options || "default")}`;
        if (options) {
            if (options.customModel) p = trk.load(options.customModel, options.fillMouth, options.fillEyeLeft, options.fillEyeRight, options.fillNeck);
            else p = trk.loadDefaultFullHeadSimplified(options.fillMouth, options.fillEyeLeft, options.fillEyeRight, options.fillNeck);
        } else p = trk.loadDefaultFullHeadSimplified();
        p.then(()=>{
            onLoad === null || onLoad === void 0 || onLoad(trk);
            this.manager.itemEnd(itemFilename);
        }).catch((_)=>{
            onError === null || onError === void 0 || onError(_);
            this.manager.itemError(itemFilename);
            this.manager.itemEnd(itemFilename);
        });
        return trk;
    }
    /**
     * @ignore
     */ parse() {}
}


let $9e350a13cf80f8f9$var$faceMeshSingleton;
class $9e350a13cf80f8f9$export$ba2edb9dcb012875 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).BufferGeometry {
    /**
     * Constructs a new FaceBufferGeometry.
     * @param faceMesh - The face mesh which will be used. If not specified, the default face mesh will be loaded.
     */ constructor(faceMesh){
        super();
        this.hasSetIndices = false;
        this.hasSetUVs = false;
        this.recalculateNormals = true;
        this.setIndex([]);
        this.setAttribute("position", new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Float32BufferAttribute([], 3));
        this.setAttribute("normal", new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Float32BufferAttribute([], 3));
        this.setAttribute("uv", new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Float32BufferAttribute([], 2));
        if (!faceMesh) {
            if (!$9e350a13cf80f8f9$var$faceMeshSingleton) $9e350a13cf80f8f9$var$faceMeshSingleton = new (0, $20a2a009ad144235$export$866c7932b77a7aa1)().load();
            // eslint-disable-next-line no-param-reassign
            faceMesh = $9e350a13cf80f8f9$var$faceMeshSingleton;
        }
        this._faceMesh = faceMesh;
    }
    _updateIndices() {
        if (this.hasSetIndices) return;
        if (this._faceMesh.indices.length === 0) return;
        this.setIndex(new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Uint16BufferAttribute(this._faceMesh.indices, 1));
        this.hasSetIndices = true;
    }
    _updateUVs() {
        if (this.hasSetUVs) return;
        if (this._faceMesh.uvs.length === 0) return;
        this.setAttribute("uv", new (0, $ef9360c70215a050$export$80ed8c37bba391f3).BufferAttribute(this._faceMesh.uvs, 2));
        this.hasSetUVs = true;
    }
    /**
     * @ignore
     */ get calculateNormals() {
        return this.recalculateNormals;
    }
    /**
     * @ignore
     */ set calculateNormals(b) {
        this.recalculateNormals = b;
        if (!this.recalculateNormals) {
            if (typeof this.removeAttribute === "function") this.removeAttribute("normal");
            delete this.normals;
        }
    }
    /**
     * Updates the geometry to the most recent identity and expression output from a face anchor group.
     * @param f - The face anchor group which will be used to update the geometry.
     */ updateFromFaceAnchorGroup(f) {
        if (this._faceMesh.vertices.length === 0) return;
        if (!f.currentAnchor) return;
        this.updateFromFaceAnchor(f.currentAnchor);
    }
    /**
     * Updates the geometry to the most recent identity and expression output from a face anchor.
     * @param f - The face anchor which will be used to update the geometry.
     */ updateFromFaceAnchor(f) {
        this.updateFromIdentityExpression(f.identity, f.expression);
    }
    /**
     * Updates the geometry to the provided identity and expression coefficients.
     * @param identity  - The identity coefficients.
     * @param expression - The expression coefficients.
     */ updateFromIdentityExpression(identity, expression) {
        if (this._faceMesh.vertices.length === 0) return;
        this._updateIndices();
        this._updateUVs();
        this._faceMesh.updateFromIdentityExpression(identity, expression);
        if (!this.vertices) {
            this.vertices = new Float32Array(this._faceMesh.vertices.length);
            this.verticesAttribute = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).BufferAttribute(this.vertices, 3);
            this.setAttribute("position", this.verticesAttribute);
        }
        this.vertices.set(this._faceMesh.vertices);
        if (this.verticesAttribute) this.verticesAttribute.needsUpdate = true;
        this.computeBoundingSphere();
        if (!this.calculateNormals) return;
        if (!this.normals) {
            this.normals = new Float32Array(this._faceMesh.normals.length);
            this.normalsAttribute = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).BufferAttribute(this.normals, 3);
            this.setAttribute("normal", this.normalsAttribute);
        }
        this.normals.set(this._faceMesh.normals);
        if (this.normalsAttribute) this.normalsAttribute.needsUpdate = true;
    }
}






class $084d035d2786ed3d$export$a961155be7c87c3 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Mesh {
    /**
     * Constructs a new head mask mesh.
     * @param onLoad - Callback function which runs when the mesh is loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     */ constructor(onLoad, onError){
        super();
        this.onLoad = onLoad;
        this.onError = onError;
        this.faceMesh = new $5b535c031aa0f632$exports.FaceMesh();
        this.faceBufferGeometry = new (0, $9e350a13cf80f8f9$export$ba2edb9dcb012875)(this.faceMesh);
        this.geometry = this.faceBufferGeometry;
        this.material = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).MeshBasicMaterial({
            colorWrite: false
        });
        this.faceMesh.loadDefaultFullHeadSimplified(true, true, true, true).then(()=>{
            var _a;
            return (_a = this.onLoad) === null || _a === void 0 ? void 0 : _a.call(this);
        }).catch(()=>{
            var _a;
            return (_a = this.onError) === null || _a === void 0 ? void 0 : _a.call(this);
        });
        this.renderOrder = Number.MIN_SAFE_INTEGER;
    }
    /**
     * Updates pose directly from the [[FaceAnchorGroup]] anchor.
     * @param f - The anchor to derive the expression and identity from.
     */ updateFromFaceAnchorGroup(f) {
        this.faceBufferGeometry.updateFromFaceAnchorGroup(f);
    }
    /**
     * Updates pose directly from the expression and identity in a [[FaceAnchor]].
     * @param f - The anchor to derive the expression and identity from.
     */ updateFromFaceAnchor(f) {
        this.faceBufferGeometry.updateFromFaceAnchor(f);
    }
    /**
     * Updates pose directly from identity and expression coefficients.
     * @param identity  - The identity coefficients.
     * @param expression - The expression coefficients.
     */ updateFromIdentityExpression(identity, expression) {
        this.faceBufferGeometry.updateFromIdentityExpression(identity, expression);
    }
    /**
     * Destroys the face mesh and disposes of resources.
     */ dispose() {
        this.faceMesh.destroy();
        this.faceBufferGeometry.dispose();
    }
}


/* eslint-disable class-methods-use-this */ 

const $6f218b3ee8a73ace$var$itemFilename = "__zappar_threejs_head_mask_mesh";
class $6f218b3ee8a73ace$export$78438eeac3ca8f03 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Loader {
    /**
     * Loads a HeadMaskMesh.
     * @param onLoad - Callback which returns the HeadMaskMesh once it's loaded.
     * @param onError - Callback which is called if there's an error loading the mesh.
     * @returns The HeadMaskMesh.
     */ load(onLoad, onProgress, onError) {
        this.manager.itemStart($6f218b3ee8a73ace$var$itemFilename);
        return new (0, $084d035d2786ed3d$export$a961155be7c87c3)(()=>{
            onLoad === null || onLoad === void 0 || onLoad();
            this.manager.itemEnd($6f218b3ee8a73ace$var$itemFilename);
        }, ()=>{
            onError === null || onError === void 0 || onError();
            this.manager.itemError($6f218b3ee8a73ace$var$itemFilename);
            this.manager.itemEnd($6f218b3ee8a73ace$var$itemFilename);
        });
    }
    /**
     * @ignore
     */ parse() {}
}


/* eslint-disable class-methods-use-this */ 

const $d905b547e85f1a39$var$itemFilename = "__zappar_threejs_library";
class $d905b547e85f1a39$export$6ed2c5ca64bd5225 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Loader {
    /**
     * Resolves once the library is loaded and ready to process data.
     * @param onLoad - Callback which runs once the library is fully loaded.
     * @param onError - Callback which is called if there's an error loading library.
     */ load(onLoad, onProgress, onError) {
        this.manager.itemStart($d905b547e85f1a39$var$itemFilename);
        (0, $16ba0ad9af69b2e5$exports.loadedPromise)().then(()=>{
            onLoad === null || onLoad === void 0 || onLoad();
            this.manager.itemEnd($d905b547e85f1a39$var$itemFilename);
        }).catch((err)=>{
            onError === null || onError === void 0 || onError();
            this.manager.itemError($d905b547e85f1a39$var$itemFilename);
            this.manager.itemEnd($d905b547e85f1a39$var$itemFilename);
        });
    }
    /**
     * @ignore
     */ parse() {}
}


/* eslint-disable guard-for-in */ 

class $9ff49558819875be$var$UI {
    constructor(style){
        this.lastLoadPercentage = 0;
        this.divs = {
            inner: document.createElement("div"),
            title: document.createElement("div"),
            progress: document.createElement("div"),
            progressValue: document.createElement("div")
        };
        this.css = {
            container: {
                position: "fixed",
                width: "100%",
                height: "100%",
                top: "0px",
                left: "0px",
                zIndex: "10000",
                backgroundColor: "rgba(0,0,0,0.8)",
                fontFamily: "sans-serif",
                color: "rgba(255,255,255,1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "opacity 500ms"
            },
            inner: {
                maxWidth: "400px",
                textAlign: "center"
            },
            title: {
                fontSize: "20px"
            },
            progress: {
                background: "rgba(255,255,255, 0.1)",
                justifyContent: "flex-start",
                borderRadius: "100px",
                alignItems: "center",
                position: "relative",
                padding: "0 5px",
                display: "flex",
                height: "15px",
                width: "250px",
                margin: "15px"
            },
            progressValue: {
                boxShadow: "0 10px 40px -10px #fff",
                borderTopLeftRadius: "100px",
                borderBottomLeftRadius: "100px",
                background: "rgba(255,255,255,1)",
                height: "10px",
                width: "0",
                transition: "width 500ms"
            }
        };
        // update loading bar based on % = (n-loaded / n-total * 100)
        this.updateLoader = (loadPercentage)=>{
            if (loadPercentage < this.lastLoadPercentage) return;
            this.lastLoadPercentage = loadPercentage;
            const elem = document.getElementById("zappar-loader-progressValue");
            elem.style.width = `${loadPercentage}%`;
            elem.style.borderTopRightRadius = `${loadPercentage}px`;
            elem.style.borderBottomRightRadius = `${loadPercentage}px`;
            elem.addEventListener("transitionend", ()=>{
                if (loadPercentage === 100) {
                    this.containerDiv.style.opacity = "0";
                    this.containerDiv.addEventListener("transitionend", (ev)=>{
                        if (ev.propertyName === "opacity") this.dispose();
                    });
                }
            });
        };
        this.dispose = ()=>{
            this.containerDiv.remove();
        };
        this.customStyle = style;
        this.containerDiv = document.createElement("div");
    }
    initialize() {
        // eslint-disable-next-line no-restricted-syntax
        for(const key in this.divs)// eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.divs[key].id = `zappar-loader-${key}`;
        this.refreshStyle();
        this.divs.inner.appendChild(this.divs.title);
        this.divs.inner.appendChild(this.divs.progress);
        this.divs.progress.appendChild(this.divs.progressValue);
        this.containerDiv.appendChild(this.divs.inner);
        this.divs.title.innerHTML = "Loading...";
        document.body.append(this.containerDiv);
    }
    refreshStyle() {
        var _a, _b, _c, _d, _e;
        Object.assign(this.css.container, (_a = this.customStyle) === null || _a === void 0 ? void 0 : _a.container);
        Object.assign(this.css.inner, (_b = this.customStyle) === null || _b === void 0 ? void 0 : _b.inner);
        Object.assign(this.css.title, (_c = this.customStyle) === null || _c === void 0 ? void 0 : _c.title);
        Object.assign(this.css.progress, (_d = this.customStyle) === null || _d === void 0 ? void 0 : _d.progress);
        Object.assign(this.css.progressValue, (_e = this.customStyle) === null || _e === void 0 ? void 0 : _e.progressValue);
        Object.assign(this.containerDiv.style, this.css.container);
        Object.assign(this.divs.inner.style, this.css.inner);
        Object.assign(this.divs.title.style, this.css.title);
        Object.assign(this.divs.progress.style, this.css.progress);
        Object.assign(this.divs.progressValue.style, this.css.progressValue);
    }
}
class $9ff49558819875be$export$da96ffd6d2c5ddec extends $9ff49558819875be$var$UI {
    /**
     * Constructs a new DefaultLoaderUI.
     * @param options - The styling of the UI.
     * @param onload - The callback function to be called when assets are loaded.
     */ constructor(options){
        super(options === null || options === void 0 ? void 0 : options.style);
        (0, $ef9360c70215a050$export$80ed8c37bba391f3).DefaultLoadingManager.onStart = ()=>{
            this.initialize();
        };
        (0, $ef9360c70215a050$export$80ed8c37bba391f3).DefaultLoadingManager.onLoad = ()=>{
            var _a;
            (_a = options === null || options === void 0 ? void 0 : options.onLoad) === null || _a === void 0 || _a.call(options);
        };
        (0, $ef9360c70215a050$export$80ed8c37bba391f3).DefaultLoadingManager.onProgress = (_url, itemsLoaded, itemsTotal)=>{
            this.updateLoader(itemsLoaded / itemsTotal * 100);
        };
    }
}
class $9ff49558819875be$export$99cc795e99919eed extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).LoadingManager {
    /**
     * Constructs a new LoadingManager.
     * @param options - Styling may be defined here, as well as any event callbacks.
     */ constructor(options){
        super(()=>{
            var _a;
            return (_a = options === null || options === void 0 ? void 0 : options.onLoad) === null || _a === void 0 ? void 0 : _a.call(options);
        }, (url, loaded, total)=>{
            var _a;
            this.ui.customStyle = options === null || options === void 0 ? void 0 : options.style;
            this.ui.refreshStyle();
            (_a = options === null || options === void 0 ? void 0 : options.onProgress) === null || _a === void 0 || _a.call(options, url, loaded, total);
            this.ui.updateLoader(loaded / total * 100);
        }, options === null || options === void 0 ? void 0 : options.onError);
        this.ui = new $9ff49558819875be$var$UI(); // no multiple inheritance (╯°□°)╯︵ ┻━┻
        this.onStartCallback = undefined;
        /**
         * @ignore
         */ this.onStart = ()=>{
            this.ui.initialize();
            if (this.onStartCallback) this.onStartCallback();
        };
        /**
         * Calls provided function when loading begins.
         * @param callback - Function that is called when loading starts.
         */ this._onStart = (callback)=>{
            this.onStartCallback = callback;
        };
        /**
         * Destroys the UI.
         */ this.dispose = ()=>{
            this.ui.dispose();
        };
        new (0, $d905b547e85f1a39$export$6ed2c5ca64bd5225)(this).load();
    }
}



class $b63e077d701f9df0$export$770c0a160afa3ffb {
    /**
     * Constructs a new Camera Environment Map.
     */ constructor(){
        this.cubeMapScene = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Scene();
        this.renderTarget = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).WebGLCubeRenderTarget(256, {
            format: (0, $ef9360c70215a050$export$80ed8c37bba391f3).RGBAFormat,
            generateMipmaps: true,
            minFilter: (0, $ef9360c70215a050$export$80ed8c37bba391f3).LinearMipmapLinearFilter
        });
        this.cubeCamera = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).CubeCamera(0.1, 1000, this.renderTarget);
        this.sphereMaterial = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).MeshBasicMaterial({
            side: (0, $ef9360c70215a050$export$80ed8c37bba391f3).DoubleSide
        });
        this.sphereGroup = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Group();
        /**
         * The resulting map texture. Set this as your `scene.environment` or as a material's `envMap`.
         */ this.environmentMap = this.renderTarget.texture;
        this.cubeMapScene.add(this.cubeCamera);
        const sphere = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Mesh(new (0, $ef9360c70215a050$export$80ed8c37bba391f3).SphereGeometry(10, 16, 12), this.sphereMaterial);
        sphere.rotation.set(0, -0.5 * Math.PI, 0);
        this.sphereGroup.add(sphere);
        this.cubeMapScene.add(this.sphereGroup);
    }
    /**
     * Destroy the resources held by this object.
     */ dispose() {
        this.renderTarget.dispose();
        this.sphereMaterial.dispose();
    }
    /**
     * Update the contents of the environment map with the latest texture from the camera.
     *
     * Call this each frame after you call `update` on your Zappar camera, but before you render the scene.
     * @param renderer - Your renderer object
     * @param zapparCamera - The Zappar camera you're using to render your scene
     */ update(renderer, zapparCamera) {
        this.environmentMap.encoding = renderer.outputEncoding;
        this.sphereMaterial.map = zapparCamera.backgroundTexture;
        this.sphereGroup.quaternion.copy(zapparCamera.quaternion);
        this.cubeCamera.update(renderer, this.cubeMapScene);
    }
}



class $de5c3929a64d071b$export$8162c4b53657ac03 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).BufferGeometry {
    /**
     * Constructs a new TargetImagePreviewBufferGeometry.
     * @param imageTarget - The image target which will be used.
     */ constructor(imageTarget){
        var _a;
        super();
        this.imageTarget = imageTarget;
        this.hasSetIndices = false;
        this.hasSetUVs = false;
        this.recalculateNormals = true;
        this.setIndex([]);
        this.setAttribute("position", new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Float32BufferAttribute([], 3));
        this.setAttribute("normal", new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Float32BufferAttribute([], 3));
        this.setAttribute("uv", new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Float32BufferAttribute([], 2));
        if (this.imageTarget.preview.vertices.length === 0) throw new Error("No vertices found in the image target.");
        this._updateIndices();
        this._updateUVs();
        if (!this.vertices) {
            this.vertices = new Float32Array((_a = this.imageTarget) === null || _a === void 0 ? void 0 : _a.preview.vertices.length);
            this.verticesAttribute = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).BufferAttribute(this.vertices, 3);
            this.setAttribute("position", this.verticesAttribute);
        }
        this.vertices.set(this.imageTarget.preview.vertices);
        if (this.verticesAttribute) this.verticesAttribute.needsUpdate = true;
        this.computeBoundingSphere();
    }
    /**
     * @ignore
     */ _updateIndices() {
        var _a;
        if (this.hasSetIndices) return;
        if (((_a = this.imageTarget) === null || _a === void 0 ? void 0 : _a.preview.indices.length) === 0) return;
        this.setIndex(new (0, $ef9360c70215a050$export$80ed8c37bba391f3).Uint16BufferAttribute(this.imageTarget.preview.indices, 1));
        this.hasSetIndices = true;
    }
    /**
     * @ignore
     */ _updateUVs() {
        if (this.hasSetUVs) return;
        if (this.imageTarget.preview.uvs.length === 0) return;
        this.setAttribute("uv", new (0, $ef9360c70215a050$export$80ed8c37bba391f3).BufferAttribute(this.imageTarget.preview.uvs, 2));
        this.hasSetUVs = true;
    }
    /**
     * @ignore
     */ get calculateNormals() {
        return this.recalculateNormals;
    }
}




class $d1e740899a49da4b$export$bde4320e74a4f4c8 extends (0, $ef9360c70215a050$export$80ed8c37bba391f3).Mesh {
    constructor(target, material = new (0, $ef9360c70215a050$export$80ed8c37bba391f3).MeshBasicMaterial({
        map: new (0, $ef9360c70215a050$export$80ed8c37bba391f3).TextureLoader().load(target.image.src)
    })){
        super(new (0, $de5c3929a64d071b$export$8162c4b53657ac03)(target), material);
    }
}




console.log(`Zappar for ThreeJS v${(0, $02df7e5d1f394832$export$a4ad2735b021c132)}`);




const $85a5f587c2a7b3b2$export$2c10387ab05da0ac = new Event("rnib:focuson", {
    bubbles: true,
    cancelable: true
});
const $85a5f587c2a7b3b2$export$e6bc4b45455ea7e7 = new Event("rnib:focusout", {
    bubbles: true,
    cancelable: true
});
const $85a5f587c2a7b3b2$export$957026111206bdf8 = new Event("rnib:click", {
    bubbles: true,
    cancelable: true
});
const $85a5f587c2a7b3b2$export$9a8f25c467234dda = new Event("rnib:refocus", {
    bubbles: true,
    cancelable: true
});
const $85a5f587c2a7b3b2$export$68d5264cfe134b94 = ()=>{
    const event = new Event("rnib:end-task", {
        bubbles: true,
        cancelable: true
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$9e72f2b7858f2dd7 = ()=>{
    const event = new Event("rnib:reset-task", {
        bubbles: true,
        cancelable: true
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$c0498f458a5d334d = ()=>{
    const event = new Event("rnib:continue-task", {
        bubbles: true,
        cancelable: true
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$b1c1607a32cb819b = ()=>{
    const event = new Event("rnib:continue-task2", {
        bubbles: true,
        cancelable: true
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$5102595c4507afe8 = (meshes)=>{
    const event = new CustomEvent("rnib:switch", {
        detail: {
            meshes: meshes
        }
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$187686429c539d6 = (state)=>{
    const event = new CustomEvent("rnib:360-video", {
        detail: {
            state: state
        }
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$c5c93d23325f795e = (eyeCondition, severityLevel)=>{
    const event = new CustomEvent("rnib:condition", {
        detail: {
            condition: eyeCondition,
            severity: severityLevel
        }
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$549798acdf125a64 = (task, state)=>{
    const event = new CustomEvent("rnib:task-mode", {
        detail: {
            task: task,
            state: state
        }
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$3fe8048cbcec8a76 = ()=>{
    const event = new CustomEvent("rnib:task-mode", {
        detail: {
            state: false
        }
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$997607796c4801b3 = (eyeSep)=>{
    const event = new CustomEvent("rnib:eye-sep", {
        detail: {
            eyeSep: eyeSep
        }
    });
    document?.dispatchEvent(event);
};
const $85a5f587c2a7b3b2$export$cfd85ebbb456058b = ()=>{
    console.log("bug test updateUIEvent");
    const event = new Event("rnib:update-ui", {
        bubbles: true,
        cancelable: true
    });
    document?.dispatchEvent(event);
};


let $67eb3f7e442cf16e$export$281ad3752a540efe = {
    bendDepth: 4,
    eyeSep: 0,
    headsetBreakpoint: 500,
    focusTime: 3000,
    focusDelay: 1500,
    fadeOutTime: 3000,
    lerpAlpha: 0.1
};
function $67eb3f7e442cf16e$export$cf0eb8a51048902b(voicoverActive) {
    $67eb3f7e442cf16e$export$281ad3752a540efe.focusTime = voicoverActive ? 6000 : 3000;
}




const $0656ff799c64aac2$var$isIOS = ()=>{
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
};
const $0656ff799c64aac2$export$5c7363e8472f2e24 = (css)=>{
    return css.match(/[0-9.]+/gi);
};
const $0656ff799c64aac2$var$isAndroid = ()=>{
    return /android/i.test(navigator.userAgent);
};
const $0656ff799c64aac2$export$f395e2d3d05d3c6a = ()=>{
    if ($0656ff799c64aac2$var$isAndroid()) return "Android";
    else if ($0656ff799c64aac2$var$isIOS()) return "iOS";
    return "Other";
};
const $0656ff799c64aac2$export$66313c302b2ea154 = (errorMessage)=>{
    throw new Error(errorMessage);
};
const $0656ff799c64aac2$export$6a645c07cf2dc9cc = (val, min, max)=>min <= val && max >= val;
const $0656ff799c64aac2$export$952b2e72a89c71b5 = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)(0, 1, 0);
const $0656ff799c64aac2$export$ce98074e4218dbec = ()=>{};
window.addEventListener("VoiceoverInfo", (e)=>{
    console.log("VoiceoverInfo, e: ", e);
    console.log("VoiceoverInfo, e.detail.info: ", e.detail.info);
    let voiceoverActive = e.detail.info == "true" ? true : false;
    (0, $67eb3f7e442cf16e$export$cf0eb8a51048902b)(voiceoverActive);
});
$0656ff799c64aac2$var$callback();
function $0656ff799c64aac2$var$callback() {
    try {
        window.webkit.messageHandlers.callbackRnib.postMessage("{}");
        console.log("vo callback successful");
    } catch  {
        (0, $67eb3f7e442cf16e$export$cf0eb8a51048902b)(false);
        console.log("vo failed callback");
    }
}


const $3c5424715410c340$export$9302a2cd748aaf61 = (elemName, elemToQuery)=>{
    elemToQuery || (elemToQuery = document);
    let result;
    if ((result = elemToQuery.querySelector(elemName)) === null) throw Error("Queried DOM element that doesn't exist: " + elemName);
    return result;
};
const $3c5424715410c340$export$2333ffce05e999c1 = ()=>{
    if (window.innerHeight > window.innerWidth) return "portrait";
    else return "landscape";
};
const $3c5424715410c340$export$d2de3aaeafa91619 = (func)=>{
    let result;
    let done = false;
    return (...args)=>{
        if (done) return result;
        else {
            result = func(...args);
            done = true;
            return result;
        }
    };
};


var $58346b94217c2348$exports = {};
// shim for using process in browser
var $58346b94217c2348$var$process = $58346b94217c2348$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $58346b94217c2348$var$cachedSetTimeout;
var $58346b94217c2348$var$cachedClearTimeout;
function $58346b94217c2348$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $58346b94217c2348$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $58346b94217c2348$var$cachedSetTimeout = setTimeout;
        else $58346b94217c2348$var$cachedSetTimeout = $58346b94217c2348$var$defaultSetTimout;
    } catch (e) {
        $58346b94217c2348$var$cachedSetTimeout = $58346b94217c2348$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $58346b94217c2348$var$cachedClearTimeout = clearTimeout;
        else $58346b94217c2348$var$cachedClearTimeout = $58346b94217c2348$var$defaultClearTimeout;
    } catch (e) {
        $58346b94217c2348$var$cachedClearTimeout = $58346b94217c2348$var$defaultClearTimeout;
    }
})();
function $58346b94217c2348$var$runTimeout(fun) {
    if ($58346b94217c2348$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($58346b94217c2348$var$cachedSetTimeout === $58346b94217c2348$var$defaultSetTimout || !$58346b94217c2348$var$cachedSetTimeout) && setTimeout) {
        $58346b94217c2348$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $58346b94217c2348$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $58346b94217c2348$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $58346b94217c2348$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $58346b94217c2348$var$runClearTimeout(marker) {
    if ($58346b94217c2348$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($58346b94217c2348$var$cachedClearTimeout === $58346b94217c2348$var$defaultClearTimeout || !$58346b94217c2348$var$cachedClearTimeout) && clearTimeout) {
        $58346b94217c2348$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $58346b94217c2348$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $58346b94217c2348$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $58346b94217c2348$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $58346b94217c2348$var$queue = [];
var $58346b94217c2348$var$draining = false;
var $58346b94217c2348$var$currentQueue;
var $58346b94217c2348$var$queueIndex = -1;
function $58346b94217c2348$var$cleanUpNextTick() {
    if (!$58346b94217c2348$var$draining || !$58346b94217c2348$var$currentQueue) return;
    $58346b94217c2348$var$draining = false;
    if ($58346b94217c2348$var$currentQueue.length) $58346b94217c2348$var$queue = $58346b94217c2348$var$currentQueue.concat($58346b94217c2348$var$queue);
    else $58346b94217c2348$var$queueIndex = -1;
    if ($58346b94217c2348$var$queue.length) $58346b94217c2348$var$drainQueue();
}
function $58346b94217c2348$var$drainQueue() {
    if ($58346b94217c2348$var$draining) return;
    var timeout = $58346b94217c2348$var$runTimeout($58346b94217c2348$var$cleanUpNextTick);
    $58346b94217c2348$var$draining = true;
    var len = $58346b94217c2348$var$queue.length;
    while(len){
        $58346b94217c2348$var$currentQueue = $58346b94217c2348$var$queue;
        $58346b94217c2348$var$queue = [];
        while(++$58346b94217c2348$var$queueIndex < len)if ($58346b94217c2348$var$currentQueue) $58346b94217c2348$var$currentQueue[$58346b94217c2348$var$queueIndex].run();
        $58346b94217c2348$var$queueIndex = -1;
        len = $58346b94217c2348$var$queue.length;
    }
    $58346b94217c2348$var$currentQueue = null;
    $58346b94217c2348$var$draining = false;
    $58346b94217c2348$var$runClearTimeout(timeout);
}
$58346b94217c2348$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $58346b94217c2348$var$queue.push(new $58346b94217c2348$var$Item(fun, args));
    if ($58346b94217c2348$var$queue.length === 1 && !$58346b94217c2348$var$draining) $58346b94217c2348$var$runTimeout($58346b94217c2348$var$drainQueue);
};
// v8 likes predictible objects
function $58346b94217c2348$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$58346b94217c2348$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$58346b94217c2348$var$process.title = "browser";
$58346b94217c2348$var$process.browser = true;
$58346b94217c2348$var$process.env = {};
$58346b94217c2348$var$process.argv = [];
$58346b94217c2348$var$process.version = ""; // empty string to avoid regexp issues
$58346b94217c2348$var$process.versions = {};
function $58346b94217c2348$var$noop() {}
$58346b94217c2348$var$process.on = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.addListener = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.once = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.off = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.removeListener = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.removeAllListeners = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.emit = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.prependListener = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.prependOnceListener = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.listeners = function(name) {
    return [];
};
$58346b94217c2348$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$58346b94217c2348$var$process.cwd = function() {
    return "/";
};
$58346b94217c2348$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$58346b94217c2348$var$process.umask = function() {
    return 0;
};


function $5c575c3b305e6fcd$export$f85c16a6d62f7d63(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement("base");
    const a = doc.createElement("a");
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const $5c575c3b305e6fcd$export$31b40729666a4ae0 = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function $5c575c3b305e6fcd$export$1391212d75b2ee65(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function $5c575c3b305e6fcd$export$45b10814cc054894(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
function $5c575c3b305e6fcd$var$px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace("px", "")) : 0;
}
function $5c575c3b305e6fcd$var$getNodeWidth(node) {
    const leftBorder = $5c575c3b305e6fcd$var$px(node, "border-left-width");
    const rightBorder = $5c575c3b305e6fcd$var$px(node, "border-right-width");
    return node.clientWidth + leftBorder + rightBorder;
}
function $5c575c3b305e6fcd$var$getNodeHeight(node) {
    const topBorder = $5c575c3b305e6fcd$var$px(node, "border-top-width");
    const bottomBorder = $5c575c3b305e6fcd$var$px(node, "border-bottom-width");
    return node.clientHeight + topBorder + bottomBorder;
}
function $5c575c3b305e6fcd$export$ada5537b2c061996(targetNode, options = {}) {
    const width = options.width || $5c575c3b305e6fcd$var$getNodeWidth(targetNode);
    const height = options.height || $5c575c3b305e6fcd$var$getNodeHeight(targetNode);
    return {
        width: width,
        height: height
    };
}
function $5c575c3b305e6fcd$export$d39ce20a37bba061() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = $58346b94217c2348$exports;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const $5c575c3b305e6fcd$var$canvasDimensionLimit = 16384;
function $5c575c3b305e6fcd$export$c2c809a2fe6b0f1a(canvas) {
    if (canvas.width > $5c575c3b305e6fcd$var$canvasDimensionLimit || canvas.height > $5c575c3b305e6fcd$var$canvasDimensionLimit) {
        if (canvas.width > $5c575c3b305e6fcd$var$canvasDimensionLimit && canvas.height > $5c575c3b305e6fcd$var$canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= $5c575c3b305e6fcd$var$canvasDimensionLimit / canvas.width;
                canvas.width = $5c575c3b305e6fcd$var$canvasDimensionLimit;
            } else {
                canvas.width *= $5c575c3b305e6fcd$var$canvasDimensionLimit / canvas.height;
                canvas.height = $5c575c3b305e6fcd$var$canvasDimensionLimit;
            }
        } else if (canvas.width > $5c575c3b305e6fcd$var$canvasDimensionLimit) {
            canvas.height *= $5c575c3b305e6fcd$var$canvasDimensionLimit / canvas.width;
            canvas.width = $5c575c3b305e6fcd$var$canvasDimensionLimit;
        } else {
            canvas.width *= $5c575c3b305e6fcd$var$canvasDimensionLimit / canvas.height;
            canvas.height = $5c575c3b305e6fcd$var$canvasDimensionLimit;
        }
    }
}
function $5c575c3b305e6fcd$export$403d539f215df596(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : "image/png", options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(",")[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : "image/png"
        }));
    });
}
function $5c575c3b305e6fcd$export$ec664d7487540b(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.decode = ()=>resolve(img);
        img.onload = ()=>resolve(img);
        img.onerror = reject;
        img.crossOrigin = "anonymous";
        img.decoding = "async";
        img.src = url;
    });
}
async function $5c575c3b305e6fcd$export$fe77aa9c02de4599(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function $5c575c3b305e6fcd$export$b62810fb8ca515fa(node, width, height) {
    const xmlns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(xmlns, "svg");
    const foreignObject = document.createElementNS(xmlns, "foreignObject");
    svg.setAttribute("width", `${width}`);
    svg.setAttribute("height", `${height}`);
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    foreignObject.setAttribute("width", "100%");
    foreignObject.setAttribute("height", "100%");
    foreignObject.setAttribute("x", "0");
    foreignObject.setAttribute("y", "0");
    foreignObject.setAttribute("externalResourcesRequired", "true");
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return $5c575c3b305e6fcd$export$fe77aa9c02de4599(svg);
}
const $5c575c3b305e6fcd$export$3a92fc9ec83ef360 = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || $5c575c3b305e6fcd$export$3a92fc9ec83ef360(nodePrototype, instance);
};


function $9df578c83a326071$var$formatCSSText(style) {
    const content = style.getPropertyValue("content");
    return `${style.cssText} content: '${content.replace(/'|"/g, "")}';`;
}
function $9df578c83a326071$var$formatCSSProperties(style) {
    return (0, $5c575c3b305e6fcd$export$45b10814cc054894)(style).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? " !important" : ""};`;
    }).join(" ");
}
function $9df578c83a326071$var$getPseudoElementStyle(className, pseudo, style) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? $9df578c83a326071$var$formatCSSText(style) : $9df578c83a326071$var$formatCSSProperties(style);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function $9df578c83a326071$var$clonePseudoElement(nativeNode, clonedNode, pseudo) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue("content");
    if (content === "" || content === "none") return;
    const className = (0, $5c575c3b305e6fcd$export$31b40729666a4ae0)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement("style");
    styleElement.appendChild($9df578c83a326071$var$getPseudoElementStyle(className, pseudo, style));
    clonedNode.appendChild(styleElement);
}
function $9df578c83a326071$export$8df63687a708ed2e(nativeNode, clonedNode) {
    $9df578c83a326071$var$clonePseudoElement(nativeNode, clonedNode, ":before");
    $9df578c83a326071$var$clonePseudoElement(nativeNode, clonedNode, ":after");
}



const $efa7da66dc28142b$var$WOFF = "application/font-woff";
const $efa7da66dc28142b$var$JPEG = "image/jpeg";
const $efa7da66dc28142b$var$mimes = {
    woff: $efa7da66dc28142b$var$WOFF,
    woff2: $efa7da66dc28142b$var$WOFF,
    ttf: "application/font-truetype",
    eot: "application/vnd.ms-fontobject",
    png: "image/png",
    jpg: $efa7da66dc28142b$var$JPEG,
    jpeg: $efa7da66dc28142b$var$JPEG,
    gif: "image/gif",
    tiff: "image/tiff",
    svg: "image/svg+xml",
    webp: "image/webp"
};
function $efa7da66dc28142b$var$getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : "";
}
function $efa7da66dc28142b$export$200548c990602f61(url) {
    const extension = $efa7da66dc28142b$var$getExtension(url).toLowerCase();
    return $efa7da66dc28142b$var$mimes[extension] || "";
}


function $3516909bc18d8651$var$getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function $3516909bc18d8651$export$f8a05efa20ffd5a(url) {
    return url.search(/^(data:)/) !== -1;
}
function $3516909bc18d8651$export$68336ea1617fa80a(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function $3516909bc18d8651$export$c20a8b76c95b0d41(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res: res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const $3516909bc18d8651$var$cache = {};
function $3516909bc18d8651$var$getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, "");
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, "");
    return contentType ? `[${contentType}]${key}` : key;
}
async function $3516909bc18d8651$export$bdf0422c029b202a(resourceUrl, contentType, options) {
    const cacheKey = $3516909bc18d8651$var$getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if ($3516909bc18d8651$var$cache[cacheKey] != null) return $3516909bc18d8651$var$cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? "&" : "?") + new Date().getTime();
    let dataURL;
    try {
        const content = await $3516909bc18d8651$export$c20a8b76c95b0d41(resourceUrl, options.fetchRequestInit, ({ res: res, result: result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get("Content-Type") || "";
            return $3516909bc18d8651$var$getContentFromDataUrl(result);
        });
        dataURL = $3516909bc18d8651$export$68336ea1617fa80a(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || "";
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === "string" ? error : error.message;
        if (msg) console.warn(msg);
    }
    $3516909bc18d8651$var$cache[cacheKey] = dataURL;
    return dataURL;
}


async function $90a895fc1d4badaa$var$cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === "data:,") return canvas.cloneNode(false);
    return (0, $5c575c3b305e6fcd$export$ec664d7487540b)(dataURL);
}
async function $90a895fc1d4badaa$var$cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, $5c575c3b305e6fcd$export$ec664d7487540b)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, $efa7da66dc28142b$export$200548c990602f61)(poster);
    const dataURL = await (0, $3516909bc18d8651$export$bdf0422c029b202a)(poster, contentType, options);
    return (0, $5c575c3b305e6fcd$export$ec664d7487540b)(dataURL);
}
async function $90a895fc1d4badaa$var$cloneIFrameElement(iframe) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await $90a895fc1d4badaa$export$ae8e35ea29ddac22(iframe.contentDocument.body, {}, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function $90a895fc1d4badaa$var$cloneSingleNode(node, options) {
    if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(node, HTMLCanvasElement)) return $90a895fc1d4badaa$var$cloneCanvasElement(node);
    if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(node, HTMLVideoElement)) return $90a895fc1d4badaa$var$cloneVideoElement(node, options);
    if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(node, HTMLIFrameElement)) return $90a895fc1d4badaa$var$cloneIFrameElement(node);
    return node.cloneNode(false);
}
const $90a895fc1d4badaa$var$isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === "SLOT";
async function $90a895fc1d4badaa$var$cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    let children = [];
    if ($90a895fc1d4badaa$var$isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, $5c575c3b305e6fcd$export$45b10814cc054894)(nativeNode.assignedNodes());
    else if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, $5c575c3b305e6fcd$export$45b10814cc054894)(nativeNode.contentDocument.body.childNodes);
    else children = (0, $5c575c3b305e6fcd$export$45b10814cc054894)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>$90a895fc1d4badaa$export$ae8e35ea29ddac22(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function $90a895fc1d4badaa$var$cloneCSSStyle(nativeNode, clonedNode) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, $5c575c3b305e6fcd$export$45b10814cc054894)(sourceStyle).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === "font-size" && value.endsWith("px")) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && name === "display" && value === "inline") value = "block";
        if (name === "d" && clonedNode.getAttribute("d")) value = `path(${clonedNode.getAttribute("d")})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function $90a895fc1d4badaa$var$cloneInputValue(nativeNode, clonedNode) {
    if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(nativeNode, HTMLInputElement)) clonedNode.setAttribute("value", nativeNode.value);
}
function $90a895fc1d4badaa$var$cloneSelectValue(nativeNode, clonedNode) {
    if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute("value"));
        if (selectedOption) selectedOption.setAttribute("selected", "");
    }
}
function $90a895fc1d4badaa$var$decorate(nativeNode, clonedNode) {
    if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        $90a895fc1d4badaa$var$cloneCSSStyle(nativeNode, clonedNode);
        (0, $9df578c83a326071$export$8df63687a708ed2e)(nativeNode, clonedNode);
        $90a895fc1d4badaa$var$cloneInputValue(nativeNode, clonedNode);
        $90a895fc1d4badaa$var$cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function $90a895fc1d4badaa$var$ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll("use") : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute("xlink:href");
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await $90a895fc1d4badaa$export$ae8e35ea29ddac22(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = "http://www.w3.org/1999/xhtml";
        const svg = document.createElementNS(ns, "svg");
        svg.setAttribute("xmlns", ns);
        svg.style.position = "absolute";
        svg.style.width = "0";
        svg.style.height = "0";
        svg.style.overflow = "hidden";
        svg.style.display = "none";
        const defs = document.createElementNS(ns, "defs");
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function $90a895fc1d4badaa$export$ae8e35ea29ddac22(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>$90a895fc1d4badaa$var$cloneSingleNode(clonedNode, options)).then((clonedNode)=>$90a895fc1d4badaa$var$cloneChildren(node, clonedNode, options)).then((clonedNode)=>$90a895fc1d4badaa$var$decorate(node, clonedNode)).then((clonedNode)=>$90a895fc1d4badaa$var$ensureSVGSymbols(clonedNode, options));
}





const $5c4ecfff4425d9e9$var$URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const $5c4ecfff4425d9e9$var$URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $5c4ecfff4425d9e9$var$FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $5c4ecfff4425d9e9$var$toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, "g");
}
function $5c4ecfff4425d9e9$export$d04549d631b8762d(cssText) {
    const urls = [];
    cssText.replace($5c4ecfff4425d9e9$var$URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, $3516909bc18d8651$export$f8a05efa20ffd5a)(url));
}
async function $5c4ecfff4425d9e9$export$2be46bb7e96db87f(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, $5c575c3b305e6fcd$export$f85c16a6d62f7d63)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, $efa7da66dc28142b$export$200548c990602f61)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, $3516909bc18d8651$export$68336ea1617fa80a)(content, contentType);
        } else dataURL = await (0, $3516909bc18d8651$export$bdf0422c029b202a)(resolvedURL, contentType, options);
        return cssText.replace($5c4ecfff4425d9e9$var$toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function $5c4ecfff4425d9e9$var$filterPreferredFontFormat(str, { preferredFontFormat: preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace($5c4ecfff4425d9e9$var$FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = $5c4ecfff4425d9e9$var$URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return "";
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function $5c4ecfff4425d9e9$export$7b668369e5eab853(url) {
    return url.search($5c4ecfff4425d9e9$var$URL_REGEX) !== -1;
}
async function $5c4ecfff4425d9e9$export$3d88803585cbbc21(cssText, baseUrl, options) {
    if (!$5c4ecfff4425d9e9$export$7b668369e5eab853(cssText)) return cssText;
    const filteredCSSText = $5c4ecfff4425d9e9$var$filterPreferredFontFormat(cssText, options);
    const urls = $5c4ecfff4425d9e9$export$d04549d631b8762d(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>$5c4ecfff4425d9e9$export$2be46bb7e96db87f(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}





async function $674c3960bcaa0dd2$var$embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, $5c4ecfff4425d9e9$export$3d88803585cbbc21)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function $674c3960bcaa0dd2$var$embedBackground(clonedNode, options) {
    if (!await $674c3960bcaa0dd2$var$embedProp("background", clonedNode, options)) await $674c3960bcaa0dd2$var$embedProp("background-image", clonedNode, options);
    if (!await $674c3960bcaa0dd2$var$embedProp("mask", clonedNode, options)) await $674c3960bcaa0dd2$var$embedProp("mask-image", clonedNode, options);
}
async function $674c3960bcaa0dd2$var$embedImageNode(clonedNode, options) {
    const isImageElement = (0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, $3516909bc18d8651$export$f8a05efa20ffd5a)(clonedNode.src)) && !((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(clonedNode, SVGImageElement) && !(0, $3516909bc18d8651$export$f8a05efa20ffd5a)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, $3516909bc18d8651$export$bdf0422c029b202a)(url, (0, $efa7da66dc28142b$export$200548c990602f61)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === "lazy") image.loading = "eager";
        if (isImageElement) {
            clonedNode.srcset = "";
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function $674c3960bcaa0dd2$var$embedChildren(clonedNode, options) {
    const children = (0, $5c575c3b305e6fcd$export$45b10814cc054894)(clonedNode.childNodes);
    const deferreds = children.map((child)=>$674c3960bcaa0dd2$export$6660fa8dd20e53aa(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function $674c3960bcaa0dd2$export$6660fa8dd20e53aa(clonedNode, options) {
    if ((0, $5c575c3b305e6fcd$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        await $674c3960bcaa0dd2$var$embedBackground(clonedNode, options);
        await $674c3960bcaa0dd2$var$embedImageNode(clonedNode, options);
        await $674c3960bcaa0dd2$var$embedChildren(clonedNode, options);
    }
}


function $87e6e1001dec4b08$export$d63a6b7859608045(node, options) {
    const { style: style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}





const $e3c96e31a3fa3e88$var$cssFetchCache = {};
async function $e3c96e31a3fa3e88$var$fetchCSS(url) {
    let cache = $e3c96e31a3fa3e88$var$cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url: url,
        cssText: cssText
    };
    $e3c96e31a3fa3e88$var$cssFetchCache[url] = cache;
    return cache;
}
async function $e3c96e31a3fa3e88$var$embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, "$1");
        if (!url.startsWith("https://")) url = new URL(url, data.url).href;
        return (0, $3516909bc18d8651$export$c20a8b76c95b0d41)(url, options.fetchRequestInit, ({ result: result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function $e3c96e31a3fa3e88$var$parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, "");
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})", "gi");
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, "");
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, "gi");
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function $e3c96e31a3fa3e88$var$getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ("cssRules" in sheet) try {
            (0, $5c575c3b305e6fcd$export$45b10814cc054894)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = $e3c96e31a3fa3e88$var$fetchCSS(url).then((metadata)=>$e3c96e31a3fa3e88$var$embedFonts(metadata, options)).then((cssText)=>$e3c96e31a3fa3e88$var$parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith("@import") ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error("Error inserting rule from remote css", {
                                    rule: rule,
                                    error: error
                                });
                            }
                        })).catch((e)=>{
                        console.error("Error loading remote css", e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push($e3c96e31a3fa3e88$var$fetchCSS(sheet.href).then((metadata)=>$e3c96e31a3fa3e88$var$embedFonts(metadata, options)).then((cssText)=>$e3c96e31a3fa3e88$var$parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, sheet.cssRules.length);
                })).catch((err)=>{
                console.error("Error loading remote stylesheet", err);
            }));
            console.error("Error inlining remote css file", e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ("cssRules" in sheet) try {
                (0, $5c575c3b305e6fcd$export$45b10814cc054894)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function $e3c96e31a3fa3e88$var$getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, $5c4ecfff4425d9e9$export$7b668369e5eab853)(rule.style.getPropertyValue("src")));
}
async function $e3c96e31a3fa3e88$var$parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error("Provided element is not within a Document");
    const styleSheets = (0, $5c575c3b305e6fcd$export$45b10814cc054894)(node.ownerDocument.styleSheets);
    const cssRules = await $e3c96e31a3fa3e88$var$getCSSRules(styleSheets, options);
    return $e3c96e31a3fa3e88$var$getWebFontRules(cssRules);
}
async function $e3c96e31a3fa3e88$export$253c9aa3d83a57b6(node, options) {
    const rules = await $e3c96e31a3fa3e88$var$parseWebFontRules(node, options);
    const cssTexts = await Promise.all(rules.map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, $5c4ecfff4425d9e9$export$3d88803585cbbc21)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join("\n");
}
async function $e3c96e31a3fa3e88$export$2c2c83b77c8cb421(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await $e3c96e31a3fa3e88$export$253c9aa3d83a57b6(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement("style");
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}



async function $c2080fe3a5dc99a4$export$20d300cb2d558b7(node, options = {}) {
    const { width: width, height: height } = (0, $5c575c3b305e6fcd$export$ada5537b2c061996)(node, options);
    const clonedNode = await (0, $90a895fc1d4badaa$export$ae8e35ea29ddac22)(node, options, true);
    await (0, $e3c96e31a3fa3e88$export$2c2c83b77c8cb421)(clonedNode, options);
    await (0, $674c3960bcaa0dd2$export$6660fa8dd20e53aa)(clonedNode, options);
    (0, $87e6e1001dec4b08$export$d63a6b7859608045)(clonedNode, options);
    const datauri = await (0, $5c575c3b305e6fcd$export$b62810fb8ca515fa)(clonedNode, width, height);
    return datauri;
}
async function $c2080fe3a5dc99a4$export$f87f6982d1fd4f81(node, options = {}) {
    const { width: width, height: height } = (0, $5c575c3b305e6fcd$export$ada5537b2c061996)(node, options);
    const svg = await $c2080fe3a5dc99a4$export$20d300cb2d558b7(node, options);
    const img = await (0, $5c575c3b305e6fcd$export$ec664d7487540b)(svg);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const ratio = options.pixelRatio || (0, $5c575c3b305e6fcd$export$d39ce20a37bba061)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, $5c575c3b305e6fcd$export$c2c809a2fe6b0f1a)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function $c2080fe3a5dc99a4$export$6f9e32581c0cde11(node, options = {}) {
    const { width: width, height: height } = (0, $5c575c3b305e6fcd$export$ada5537b2c061996)(node, options);
    const canvas = await $c2080fe3a5dc99a4$export$f87f6982d1fd4f81(node, options);
    const ctx = canvas.getContext("2d");
    return ctx.getImageData(0, 0, width, height).data;
}
async function $c2080fe3a5dc99a4$export$aba256f33615c92e(node, options = {}) {
    const canvas = await $c2080fe3a5dc99a4$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL();
}
async function $c2080fe3a5dc99a4$export$ed218bd2440d33a5(node, options = {}) {
    const canvas = await $c2080fe3a5dc99a4$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL("image/jpeg", options.quality || 1);
}
async function $c2080fe3a5dc99a4$export$b20f4ee19ffa0668(node, options = {}) {
    const canvas = await $c2080fe3a5dc99a4$export$f87f6982d1fd4f81(node, options);
    const blob = await (0, $5c575c3b305e6fcd$export$403d539f215df596)(canvas);
    return blob;
}
async function $c2080fe3a5dc99a4$export$92678bad7eef403b(node, options = {}) {
    return (0, $e3c96e31a3fa3e88$export$253c9aa3d83a57b6)(node, options);
}


const $96577971ed9db16c$var$showDebug = false;
const $96577971ed9db16c$var$debugInfo = $96577971ed9db16c$var$showDebug ? new WeakMap() : null;
const $96577971ed9db16c$var$getDebugInfo = (key, create)=>{
    let info = $96577971ed9db16c$var$debugInfo.get(key);
    if (!info) {
        info = create(key);
        $96577971ed9db16c$var$debugInfo.set(key, info);
    }
    return info;
};
async function $96577971ed9db16c$export$5473b3d3a2a90179(node, ctx) {
    const t0 = performance.now();
    const svg = await (0, $c2080fe3a5dc99a4$export$20d300cb2d558b7)(node, {});
    const img = await $96577971ed9db16c$var$createImage(svg);
    const { width: width, height: height } = ctx.canvas;
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(img, 0, 0, width, height);
    const elapsed = performance.now() - t0;
    if ($96577971ed9db16c$var$showDebug) {
        // draw outline, update count & render time for debug
        const info = $96577971ed9db16c$var$getDebugInfo(node, ()=>({
                count: 0
            }));
        info.count += 1;
        const name = node.id;
        const text = `${name}  ${info.count}  (${Math.round(elapsed)} ms)`;
        ctx.save();
        {
            ctx.font = "20px sans-serif";
            const { width: tw } = ctx.measureText(text);
            ctx.fillStyle = "rgba(0 0 0 / .5)";
            ctx.fillRect(0, 0, tw + 8, 26);
            ctx.fillStyle = "orange";
            ctx.fillText(text, 5, 20);
        }
        ctx.lineWidth = 3;
        ctx.strokeStyle = "orange";
        ctx.strokeRect(0, 0, width, height);
        ctx.restore();
    }
}
function $96577971ed9db16c$var$createImage(url) {
    return new Promise((resolve, reject)=>{
        const image = new Image();
        Object.assign(image, {
            decode: ()=>resolve(image),
            onload: ()=>resolve(image),
            onerror: reject,
            crossOrigin: "anonymous",
            decoding: "async",
            src: url
        });
    });
}


class $2c672c48f22f9ffc$export$2e2bcd8739ae039 extends $e97a97f0b0cf48c9$export$e176487c05830cc5 {
    curveAxisY = false;
    HTMLElement;
    buttonCoordinates = [];
    currentButtonId = null;
    backgroundUpdated = false;
    buttonSelected = false;
    updateCanvasTimeout;
    loadingTimeout;
    lerpVector;
    originalPosition;
    lerpOutVector = new $e97a97f0b0cf48c9$export$64b5c384219d3699();
    isControllerEnabled;
    constructor(id, xSegments, ySegments, position, // _curveAxisY?: boolean | undefined,
    isControllerEnabled = false){
        super();
        this.HTMLElement = (0, $3c5424715410c340$export$9302a2cd748aaf61)(`#${id}`);
        this.HTMLElement.classList.add("active");
        this.material = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            transparent: true,
            blending: $e97a97f0b0cf48c9$export$5b29a26d96ee6af0
        });
        this.geometry = new $e97a97f0b0cf48c9$export$e789a11a194ca4e0(1, 1, xSegments, ySegments);
        this.originalPosition = position;
        this.position.copy(position);
        this.name = this.HTMLElement.id;
        this.isControllerEnabled = isControllerEnabled;
        // MeshUI is invisible by default
        this.visible = false;
    }
    planeCurve(customBendDepth) {
        if (!this.curveAxisY) {
            // this.bendDepth = customBendDepth;
            let z = (0, $67eb3f7e442cf16e$export$281ad3752a540efe).bendDepth;
            if (customBendDepth) z = customBendDepth;
            let p = this.geometry.parameters;
            let hw = p.width * 0.5;
            let a = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(-hw, 0);
            let b = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, z);
            let c = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(hw, 0);
            let ab = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().subVectors(a, b);
            let bc = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().subVectors(b, c);
            let ac = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().subVectors(a, c);
            let r = ab.length() * bc.length() * ac.length() / (2 * Math.abs(ab.cross(ac)));
            let center = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, z - r);
            let baseV = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().subVectors(a, center);
            let baseAngle = baseV.angle() - Math.PI * 0.5;
            let arc = baseAngle * 2;
            let uv = this.geometry.attributes.uv;
            let pos = this.geometry.attributes.position;
            let mainV = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
            for(let i = 0; i < uv.count; i++){
                let uvRatio = 1 - uv.getX(i);
                let y = pos.getY(i);
                mainV.copy(c).rotateAround(center, arc * uvRatio);
                pos.setXYZ(i, mainV.x, y, -mainV.y);
            }
            pos.needsUpdate = true;
        } else {
            let z = (0, $67eb3f7e442cf16e$export$281ad3752a540efe).bendDepth;
            if (customBendDepth) z = customBendDepth;
            let p = this.geometry.parameters;
            let vh = p.height * 0.5;
            let a = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(-vh, 0);
            let b = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, z);
            let c = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(vh, 0);
            let ab = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().subVectors(a, b);
            let bc = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().subVectors(b, c);
            let ac = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().subVectors(a, c);
            let r = ab.length() * bc.length() * ac.length() / (2 * Math.abs(ab.cross(ac)));
            let center = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1(0, z - r);
            let baseV = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1().subVectors(a, center);
            let baseAngle = baseV.angle() - Math.PI * 0.5;
            let arc = baseAngle * 2;
            let uv = this.geometry.attributes.uv;
            let pos = this.geometry.attributes.position;
            let mainV = new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
            for(let i = 0; i < uv.count; i++){
                let uvRatio = 1 - uv.getY(i);
                let y = pos.getX(i);
                mainV.copy(c).rotateAround(center, arc * uvRatio);
                pos.setXYZ(i, y, mainV.x, -mainV.y);
            }
            pos.needsUpdate = true;
        }
    }
    getLerpOutVector = ()=>this.lerpOutVector.set(this.originalPosition.x, this.originalPosition.y + 5, this.originalPosition.z - 2);
    switchEvent() {
        if (this.name === "gui") return; // ReCentre AR doesn't transition, it's always on
        document.addEventListener("rnib:switch", (e)=>{
            const meshes = e.detail.meshes;
            let meshIsActive = false;
            meshes.forEach((mesh)=>{
                if (mesh === this.name) meshIsActive = true;
            });
            if (meshIsActive && !this.visible) this.updateTextureFromCanvas().then((message)=>{
                if (message === "updated") {
                    this.material.opacity = 0;
                    this.lerpVector = this.originalPosition;
                    this.visible = true;
                    this.getUICoordinates();
                    setTimeout(()=>{
                        this.material.opacity = 1;
                        this.lerpVector = undefined;
                    }, (0, $67eb3f7e442cf16e$export$281ad3752a540efe).fadeOutTime);
                }
            });
            else if (this.visible && !meshIsActive) {
                this.lerpVector = this.getLerpOutVector();
                setTimeout(()=>{
                    this.visible = false;
                    this.lerpVector = undefined;
                }, (0, $67eb3f7e442cf16e$export$281ad3752a540efe).fadeOutTime);
            }
        });
    }
    init() {
        this.updateTextureFromCanvas();
        document.addEventListener("rnib:click", (e)=>{
            const target = e.target;
            const element = target.closest(".active");
            if (this.visible && element === this.HTMLElement) {
                this.updateTextureFromCanvas();
                this.getUICoordinates();
            }
        });
        document.addEventListener("rnib:update-ui", ()=>{
            this.updateTextureFromCanvas();
            this.getUICoordinates();
        });
        this.switchEvent();
        Array.from(this.HTMLElement.querySelectorAll("button")).forEach(this.setupButtonsFromIndividualElement);
    }
    setupButtonsFromIndividualElement = (currentButton)=>{
        this.getUICoordinates();
        currentButton.addEventListener("focusin", ()=>{
            //console.log("[FOCUS TRIGGERED]", "isControllerEnabled: ", this.isControllerEnabled);
            clearTimeout(this.updateCanvasTimeout);
            currentButton.dispatchEvent((0, $85a5f587c2a7b3b2$export$2c10387ab05da0ac));
            if (currentButton.classList.contains("button") && !currentButton.classList.contains("button-recenter") || currentButton.classList.contains("navigation--arrow")) //currentButton.style.backgroundColor = "white";
            //currentButton.style.color = "black";
            currentButton.style.filter = "invert(1)";
            else {
                currentButton.style.backgroundColor = "black";
                if (currentButton.style.color == "") currentButton.style.color = "#FFFFFF";
            }
            this.updateCanvasTimeout = setTimeout(()=>{
                this.updateTextureFromCanvas();
            }, 20);
            if (!this.isControllerEnabled) this.loadingTimeout = setTimeout(()=>{
                currentButton.click();
                currentButton.dispatchEvent((0, $85a5f587c2a7b3b2$export$957026111206bdf8));
                currentButton.blur();
            }, (0, $67eb3f7e442cf16e$export$281ad3752a540efe).focusTime + (0, $67eb3f7e442cf16e$export$281ad3752a540efe).focusDelay);
        });
        currentButton.addEventListener("focusout", ()=>{
            currentButton.blur();
            currentButton.removeAttribute("style");
            clearTimeout(this.loadingTimeout);
            this.updateTextureFromCanvas();
        });
    };
    getUICoordinates = ()=>{
        this.buttonsElements = Array.from(this?.HTMLElement?.querySelectorAll("button"));
        this.currentButtonId = null;
        if (!this.buttonsElements) return;
        this.buttonCoordinates = [];
        const { x: x, y: y } = this.HTMLElement.getBoundingClientRect();
        this.buttonsElements.forEach((element, index)=>{
            if (element.classList.contains("hidden") || element.classList.contains("unclickable")) return;
            element.tabIndex = 0;
            const rect = element.getBoundingClientRect();
            this.buttonCoordinates.push({
                index: index,
                x1: rect.left - x,
                x2: rect.right - x,
                y1: rect.top - y,
                y2: rect.bottom - y
            });
        });
    };
    setMaterialFromCanvas(canvas) {
        const { width: width, height: height } = canvas;
        const { material: material } = this;
        function mapMatchesCanvas(map) {
            if (!map) return false;
            else return map.width === width && map.height === height;
        }
        if (!mapMatchesCanvas(material.map)) {
            // create new map to match new canvas size
            material.map = new $e97a97f0b0cf48c9$export$f7189e49152d1c13(canvas);
            // scale the geometry to match the new size
            this.scale.set(width / 100, height / 100, 1);
        } else // re-use the old texture
        material.map.image = canvas;
        material.transparent = true;
        material.needsUpdate = true;
    }
    resizeCanvasToElement() {
        let canvas;
        if (!this.canvasContext) {
            canvas = document.createElement("canvas");
            this.canvasContext = canvas.getContext("2d");
        } else canvas = this.canvasContext.canvas;
        const { clientWidth: width, clientHeight: height } = this.HTMLElement;
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    updateTextureFromCanvas = async ()=>{
        const t0 = performance.now();
        const canvas = this.resizeCanvasToElement();
        return await (0, $96577971ed9db16c$export$5473b3d3a2a90179)(this.HTMLElement, this.canvasContext).then(()=>{
            logStats("htmlToCanvas", this.name);
            this.setMaterialFromCanvas(canvas);
            return "updated";
        });
        function logStats(method, name) {
            const elapsed = Math.round(performance.now() - t0);
            console.log("%s: %s  (%d ms)", method, name, elapsed);
        }
    };
    checkUICoordinates(intersectionUv) {
        const mouseX = intersectionUv.x * this.HTMLElement.clientWidth;
        const mouseY = this.HTMLElement.clientHeight - intersectionUv.y * this.HTMLElement.clientHeight;
        // reset values
        this.buttonSelected = false;
        for(let i = 0; i < this.buttonCoordinates.length; i++)if ((0, $0656ff799c64aac2$export$6a645c07cf2dc9cc)(mouseX, this.buttonCoordinates[i].x1, this.buttonCoordinates[i].x2) && (0, $0656ff799c64aac2$export$6a645c07cf2dc9cc)(mouseY, this.buttonCoordinates[i].y1, this.buttonCoordinates[i].y2)) {
            this.activateButton(this.buttonsElements[this.buttonCoordinates[i].index], this.buttonCoordinates[i]);
            return;
        }
        if (!this.buttonSelected && !this.backgroundUpdated) {
            document.activeElement.blur();
            document.body.dispatchEvent((0, $85a5f587c2a7b3b2$export$e6bc4b45455ea7e7));
            this.backgroundUpdated = true;
            this.currentButtonId = null;
        }
    }
    /**
   *
   * @param direction Direction of controller input; 0 = top, 1 = right, 2 = bottom, 3 = left
   */ triggerSelectElementFromDirection = (direction)=>{
        if (!this.currentButtonId) this.currentButtonId = this.buttonCoordinates[0].index;
        // let closest: Nullable<{ coordinates: coordinates; distance: number }> = null;
        let closest = null;
        const elems = this.getAllElementsFromDirection(direction);
        elems.forEach((coordinates)=>{
            const distance = this.elementDistanceFromCurrent(coordinates);
            console.log(distance, this.buttonsElements[coordinates.index]);
            if (!closest || closest.distance > distance) closest = {
                coordinates: coordinates,
                distance: distance
            };
        });
        if (closest === null) return;
        // console.log("[CLOSEST]", closest, this.buttonsElements[closest.coordinates.index]);
        this.activateButton(this.buttonsElements[closest.coordinates.index], closest.coordinates);
    };
    elementDistanceFromCurrent = (coords)=>{
        if (typeof this.currentButtonId !== "number") throw Error("Current Button ID needs to exist");
        const currButtonCoords = this.buttonCoordinates.find((coords)=>coords.index === this.currentButtonId);
        const centreCurrElem = {
            x: currButtonCoords.x1 + (currButtonCoords.x2 - currButtonCoords.x1) / 2,
            y: currButtonCoords.y1 + (currButtonCoords.y2 - currButtonCoords.y1) / 2
        };
        const centreElem = {
            x: coords.x1 + (coords.x2 - coords.x1) / 2,
            y: coords.y1 + (coords.y2 - coords.y1) / 2
        };
        const a = Math.abs(centreCurrElem.x - centreElem.x);
        const b = Math.abs(centreCurrElem.y - centreElem.y);
        return Math.sqrt(a * a + b * b);
    };
    getAllElementsFromDirection = (direction)=>{
        if (typeof this.currentButtonId !== "number") throw Error("Current Button ID needs to exist");
        const currButtonCoord = this.buttonCoordinates.find((coords)=>coords.index === this.currentButtonId);
        if (!currButtonCoord) debugger;
        const fromDirection = [
            (coords)=>coords.y2 < currButtonCoord.y1,
            (coords)=>coords.x1 > currButtonCoord.x2,
            (coords)=>coords.y1 > currButtonCoord.y2,
            (coords)=>coords.x2 < currButtonCoord.x1
        ];
        return this.buttonCoordinates.filter((coords)=>coords.index === currButtonCoord.index ? false : fromDirection[direction](coords));
    };
    triggerClickSelect = ()=>{
        if (typeof this.currentButtonId !== "number") return;
        const elem = this.buttonsElements[this.currentButtonId];
        elem.click();
        elem.dispatchEvent((0, $85a5f587c2a7b3b2$export$957026111206bdf8));
        elem.blur();
    };
    activateButton = (currentButton, buttonCoordinates)=>{
        // check if any button is selected in the array
        this.buttonSelected = true;
        this.backgroundUpdated = false;
        if (this.currentButtonId !== buttonCoordinates.index) {
            this.currentButtonId = buttonCoordinates.index;
            if (!currentButton.classList.contains("hidden") || !currentButton.getAttribute("disabled")) currentButton.focus();
        }
    };
    update() {
        if (this.lerpVector) {
            this.position.lerp(this.lerpVector, (0, $67eb3f7e442cf16e$export$281ad3752a540efe).lerpAlpha);
            if (this.lerpVector.y !== this.originalPosition.y) {
                if (this.material.opacity > 0) this.material.opacity -= 0.02;
            } else if (this.material.opacity < 1.02) this.material.opacity += 0.02;
        }
    }
}





const $183a9bb3ac38c2a3$var$_lut = [];
for(let i = 0; i < 256; i++)$183a9bb3ac38c2a3$var$_lut[i] = (i < 16 ? "0" : "") + i.toString(16);
let $183a9bb3ac38c2a3$var$_seed = 1234567;
const $183a9bb3ac38c2a3$export$460c4029b1a54a2e = Math.PI / 180;
const $183a9bb3ac38c2a3$export$914076c8150813e5 = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $183a9bb3ac38c2a3$export$e73c8bd0f20705a() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $183a9bb3ac38c2a3$var$_lut[d0 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d0 >> 8 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d0 >> 16 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d0 >> 24 & 0xff] + "-" + $183a9bb3ac38c2a3$var$_lut[d1 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d1 >> 8 & 0xff] + "-" + $183a9bb3ac38c2a3$var$_lut[d1 >> 16 & 0x0f | 0x40] + $183a9bb3ac38c2a3$var$_lut[d1 >> 24 & 0xff] + "-" + $183a9bb3ac38c2a3$var$_lut[d2 & 0x3f | 0x80] + $183a9bb3ac38c2a3$var$_lut[d2 >> 8 & 0xff] + "-" + $183a9bb3ac38c2a3$var$_lut[d2 >> 16 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d2 >> 24 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d3 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d3 >> 8 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d3 >> 16 & 0xff] + $183a9bb3ac38c2a3$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
function $183a9bb3ac38c2a3$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidian modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $183a9bb3ac38c2a3$export$3c11354a743b7f4e(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $183a9bb3ac38c2a3$export$61343b3c0ad0a00a(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $183a9bb3ac38c2a3$export$c45b79d581bbb999(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $183a9bb3ac38c2a3$export$3a89f8d6f6bf6c9f(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $183a9bb3ac38c2a3$export$f81c1cb84e35b185(x, y, lambda, dt) {
    return $183a9bb3ac38c2a3$export$3a89f8d6f6bf6c9f(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $183a9bb3ac38c2a3$export$1d919ae830ac5239(x, length = 1) {
    return length - Math.abs($183a9bb3ac38c2a3$export$3c11354a743b7f4e(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $183a9bb3ac38c2a3$export$4053e36566dd3d9a(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $183a9bb3ac38c2a3$export$7509a5c452b9dce8(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $183a9bb3ac38c2a3$export$a85cdcada2f6e6d0(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $183a9bb3ac38c2a3$export$8dceb61b660164cc(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $183a9bb3ac38c2a3$export$f093f4e85c7dea5a(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $183a9bb3ac38c2a3$export$d3abb7a3a61fb0cb(s) {
    if (s !== undefined) $183a9bb3ac38c2a3$var$_seed = s % 2147483647;
    // Park-Miller algorithm
    $183a9bb3ac38c2a3$var$_seed = $183a9bb3ac38c2a3$var$_seed * 16807 % 2147483647;
    return ($183a9bb3ac38c2a3$var$_seed - 1) / 2147483646;
}
function $183a9bb3ac38c2a3$export$e6bfdeff8bfc94f9(degrees) {
    return degrees * $183a9bb3ac38c2a3$export$460c4029b1a54a2e;
}
function $183a9bb3ac38c2a3$export$54390e3b44c4a9cb(radians) {
    return radians * $183a9bb3ac38c2a3$export$914076c8150813e5;
}
function $183a9bb3ac38c2a3$export$b9e43d1765415474(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $183a9bb3ac38c2a3$export$150eaaaf1e7bb6f7(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $183a9bb3ac38c2a3$export$b500f0356efda8ea(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $183a9bb3ac38c2a3$export$ef2201424fe649f7(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}



const $17d66d87d7d900a0$var$htmlElement = document.querySelector("#gui");
const $17d66d87d7d900a0$var$reCentreARButton = $17d66d87d7d900a0$var$htmlElement?.querySelector(".cta");
const $17d66d87d7d900a0$var$toolTip = $17d66d87d7d900a0$var$htmlElement?.querySelector(".tooltip");
class $17d66d87d7d900a0$export$629b893fadd3023c extends (0, $2c672c48f22f9ffc$export$2e2bcd8739ae039) {
    pivot = new (0, $e97a97f0b0cf48c9$export$e4dd07dff30cc924)();
    constructor(isControllerEnabled){
        super("gui", 20, 20, new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)(0, -6.128, -5.142), isControllerEnabled);
        this.rotateX((0, $183a9bb3ac38c2a3$export$e6bfdeff8bfc94f9)(-50));
        this.init();
        this.pivot.add(this);
        this.updateTextureFromCanvas().then(()=>{
            console.log("recentre updated");
            this.visible = true;
        });
        this.refocusListen();
    }
    showToolTip(state) {
        if (state && !$17d66d87d7d900a0$var$toolTip?.classList.contains("hidden")) {
            this.updateTextureFromCanvas().then(()=>{
                console.log("recentre updated");
                this.visible = true;
            });
            $17d66d87d7d900a0$var$toolTip?.classList.add("hidden");
        } else if (!state && $17d66d87d7d900a0$var$toolTip?.classList.contains("hidden")) {
            this.updateTextureFromCanvas();
            $17d66d87d7d900a0$var$toolTip?.classList.remove("hidden");
        }
    }
    refocusListen() {
        $17d66d87d7d900a0$var$reCentreARButton?.addEventListener("click", ()=>{
            $17d66d87d7d900a0$var$htmlElement?.dispatchEvent((0, $85a5f587c2a7b3b2$export$9a8f25c467234dda));
        });
    }
    update = (anchorObject)=>{
        if (!anchorObject) throw Error("Missing anchor oject to get rotation from");
        this.pivot.setRotationFromAxisAngle((0, $0656ff799c64aac2$export$952b2e72a89c71b5), anchorObject.rotation.y);
    };
}


function $fada8102d2a280be$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $fada8102d2a280be$var$urlToolkit = {
    exports: {}
};
(function(module, exports) {
    // see https://tools.ietf.org/html/rfc1808
    (function(root) {
        var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
        var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
        var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
        var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
        var URLToolkit = {
            // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
            // E.g
            // With opts.alwaysNormalize = false (default, spec compliant)
            // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
            // With opts.alwaysNormalize = true (not spec compliant)
            // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
            buildAbsoluteURL: function(baseURL, relativeURL, opts) {
                opts = opts || {};
                // remove any remaining space and CRLF
                baseURL = baseURL.trim();
                relativeURL = relativeURL.trim();
                if (!relativeURL) {
                    // 2a) If the embedded URL is entirely empty, it inherits the
                    // entire base URL (i.e., is set equal to the base URL)
                    // and we are done.
                    if (!opts.alwaysNormalize) return baseURL;
                    var basePartsForNormalise = URLToolkit.parseURL(baseURL);
                    if (!basePartsForNormalise) throw new Error("Error trying to parse base URL.");
                    basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
                    return URLToolkit.buildURLFromParts(basePartsForNormalise);
                }
                var relativeParts = URLToolkit.parseURL(relativeURL);
                if (!relativeParts) throw new Error("Error trying to parse relative URL.");
                if (relativeParts.scheme) {
                    // 2b) If the embedded URL starts with a scheme name, it is
                    // interpreted as an absolute URL and we are done.
                    if (!opts.alwaysNormalize) return relativeURL;
                    relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
                    return URLToolkit.buildURLFromParts(relativeParts);
                }
                var baseParts = URLToolkit.parseURL(baseURL);
                if (!baseParts) throw new Error("Error trying to parse base URL.");
                if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== "/") {
                    // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
                    // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
                    var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
                    baseParts.netLoc = pathParts[1];
                    baseParts.path = pathParts[2];
                }
                if (baseParts.netLoc && !baseParts.path) baseParts.path = "/";
                var builtParts = {
                    // 2c) Otherwise, the embedded URL inherits the scheme of
                    // the base URL.
                    scheme: baseParts.scheme,
                    netLoc: relativeParts.netLoc,
                    path: null,
                    params: relativeParts.params,
                    query: relativeParts.query,
                    fragment: relativeParts.fragment
                };
                if (!relativeParts.netLoc) {
                    // 3) If the embedded URL's <net_loc> is non-empty, we skip to
                    // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
                    // (if any) of the base URL.
                    builtParts.netLoc = baseParts.netLoc;
                    // 4) If the embedded URL path is preceded by a slash "/", the
                    // path is not relative and we skip to Step 7.
                    if (relativeParts.path[0] !== "/") {
                        if (!relativeParts.path) {
                            // 5) If the embedded URL path is empty (and not preceded by a
                            // slash), then the embedded URL inherits the base URL path
                            builtParts.path = baseParts.path;
                            // 5a) if the embedded URL's <params> is non-empty, we skip to
                            // step 7; otherwise, it inherits the <params> of the base
                            // URL (if any) and
                            if (!relativeParts.params) {
                                builtParts.params = baseParts.params;
                                // 5b) if the embedded URL's <query> is non-empty, we skip to
                                // step 7; otherwise, it inherits the <query> of the base
                                // URL (if any) and we skip to step 7.
                                if (!relativeParts.query) builtParts.query = baseParts.query;
                            }
                        } else {
                            // 6) The last segment of the base URL's path (anything
                            // following the rightmost slash "/", or the entire path if no
                            // slash is present) is removed and the embedded URL's path is
                            // appended in its place.
                            var baseURLPath = baseParts.path;
                            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf("/") + 1) + relativeParts.path;
                            builtParts.path = URLToolkit.normalizePath(newPath);
                        }
                    }
                }
                if (builtParts.path === null) builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
                return URLToolkit.buildURLFromParts(builtParts);
            },
            parseURL: function(url) {
                var parts = URL_REGEX.exec(url);
                if (!parts) return null;
                return {
                    scheme: parts[1] || "",
                    netLoc: parts[2] || "",
                    path: parts[3] || "",
                    params: parts[4] || "",
                    query: parts[5] || "",
                    fragment: parts[6] || ""
                };
            },
            normalizePath: function(path) {
                // The following operations are
                // then applied, in order, to the new path:
                // 6a) All occurrences of "./", where "." is a complete path
                // segment, are removed.
                // 6b) If the path ends with "." as a complete path segment,
                // that "." is removed.
                path = path.split("").reverse().join("").replace(SLASH_DOT_REGEX, "");
                // 6c) All occurrences of "<segment>/../", where <segment> is a
                // complete path segment not equal to "..", are removed.
                // Removal of these path segments is performed iteratively,
                // removing the leftmost matching pattern on each iteration,
                // until no matching pattern remains.
                // 6d) If the path ends with "<segment>/..", where <segment> is a
                // complete path segment not equal to "..", that
                // "<segment>/.." is removed.
                while(path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, "")).length);
                return path.split("").reverse().join("");
            },
            buildURLFromParts: function(parts) {
                return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
            }
        };
        module.exports = URLToolkit;
    })();
})($fada8102d2a280be$var$urlToolkit);
var $fada8102d2a280be$var$urlToolkitExports = $fada8102d2a280be$var$urlToolkit.exports;
function $fada8102d2a280be$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fada8102d2a280be$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fada8102d2a280be$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fada8102d2a280be$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fada8102d2a280be$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fada8102d2a280be$var$_defineProperty(obj, key, value) {
    key = $fada8102d2a280be$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fada8102d2a280be$var$_extends() {
    $fada8102d2a280be$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fada8102d2a280be$var$_extends.apply(this, arguments);
}
function $fada8102d2a280be$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $fada8102d2a280be$var$_toPropertyKey(arg) {
    var key = $fada8102d2a280be$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
const $fada8102d2a280be$var$isFiniteNumber = Number.isFinite || function(value) {
    return typeof value === "number" && isFinite(value);
};
let $fada8102d2a280be$var$Events = /*#__PURE__*/ function(Events) {
    Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
    Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
    Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
    Events["MEDIA_DETACHED"] = "hlsMediaDetached";
    Events["BUFFER_RESET"] = "hlsBufferReset";
    Events["BUFFER_CODECS"] = "hlsBufferCodecs";
    Events["BUFFER_CREATED"] = "hlsBufferCreated";
    Events["BUFFER_APPENDING"] = "hlsBufferAppending";
    Events["BUFFER_APPENDED"] = "hlsBufferAppended";
    Events["BUFFER_EOS"] = "hlsBufferEos";
    Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
    Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
    Events["MANIFEST_LOADING"] = "hlsManifestLoading";
    Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
    Events["MANIFEST_PARSED"] = "hlsManifestParsed";
    Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
    Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
    Events["LEVEL_LOADING"] = "hlsLevelLoading";
    Events["LEVEL_LOADED"] = "hlsLevelLoaded";
    Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
    Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
    Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
    Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
    Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
    Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
    Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
    Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
    Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
    Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
    Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
    Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
    Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
    Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
    Events["CUES_PARSED"] = "hlsCuesParsed";
    Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
    Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
    Events["FRAG_LOADING"] = "hlsFragLoading";
    Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
    Events["FRAG_LOADED"] = "hlsFragLoaded";
    Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
    Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
    Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
    Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
    Events["FRAG_PARSED"] = "hlsFragParsed";
    Events["FRAG_BUFFERED"] = "hlsFragBuffered";
    Events["FRAG_CHANGED"] = "hlsFragChanged";
    Events["FPS_DROP"] = "hlsFpsDrop";
    Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
    Events["ERROR"] = "hlsError";
    Events["DESTROYING"] = "hlsDestroying";
    Events["KEY_LOADING"] = "hlsKeyLoading";
    Events["KEY_LOADED"] = "hlsKeyLoaded";
    Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
    Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
    return Events;
}({});
/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */ let $fada8102d2a280be$var$ErrorTypes = /*#__PURE__*/ function(ErrorTypes) {
    ErrorTypes["NETWORK_ERROR"] = "networkError";
    ErrorTypes["MEDIA_ERROR"] = "mediaError";
    ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
    ErrorTypes["MUX_ERROR"] = "muxError";
    ErrorTypes["OTHER_ERROR"] = "otherError";
    return ErrorTypes;
}({});
let $fada8102d2a280be$var$ErrorDetails = /*#__PURE__*/ function(ErrorDetails) {
    ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
    ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
    ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
    ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
    ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
    ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
    ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
    ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
    ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
    ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
    ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
    ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
    ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
    ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
    ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
    ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
    ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
    ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
    ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
    ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
    ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
    ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
    ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
    ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
    ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
    ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
    ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
    ErrorDetails["FRAG_GAP"] = "fragGap";
    ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
    ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
    ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
    ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
    ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
    ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
    ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
    ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
    ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
    ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
    ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
    ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
    ErrorDetails["INTERNAL_ABORTED"] = "aborted";
    ErrorDetails["UNKNOWN"] = "unknown";
    return ErrorDetails;
}({});
const $fada8102d2a280be$var$noop = function noop() {};
const $fada8102d2a280be$var$fakeLogger = {
    trace: $fada8102d2a280be$var$noop,
    debug: $fada8102d2a280be$var$noop,
    log: $fada8102d2a280be$var$noop,
    warn: $fada8102d2a280be$var$noop,
    info: $fada8102d2a280be$var$noop,
    error: $fada8102d2a280be$var$noop
};
let $fada8102d2a280be$var$exportedLogger = $fada8102d2a280be$var$fakeLogger;
// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }
function $fada8102d2a280be$var$consolePrintFn(type) {
    const func = self.console[type];
    if (func) return func.bind(self.console, `[${type}] >`);
    return $fada8102d2a280be$var$noop;
}
function $fada8102d2a280be$var$exportLoggerFunctions(debugConfig, ...functions) {
    functions.forEach(function(type) {
        $fada8102d2a280be$var$exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : $fada8102d2a280be$var$consolePrintFn(type);
    });
}
function $fada8102d2a280be$var$enableLogs(debugConfig, id) {
    // check that console is available
    if (self.console && debugConfig === true || typeof debugConfig === "object") {
        $fada8102d2a280be$var$exportLoggerFunctions(debugConfig, // Remove out from list here to hard-disable a log-level
        // 'trace',
        "debug", "log", "info", "warn", "error");
        // Some browsers don't allow to use bind on console object anyway
        // fallback to default if needed
        try {
            $fada8102d2a280be$var$exportedLogger.log(`Debug logs enabled for "${id}" in hls.js version ${"1.4.6"}`);
        } catch (e) {
            $fada8102d2a280be$var$exportedLogger = $fada8102d2a280be$var$fakeLogger;
        }
    } else $fada8102d2a280be$var$exportedLogger = $fada8102d2a280be$var$fakeLogger;
}
const $fada8102d2a280be$var$logger = $fada8102d2a280be$var$exportedLogger;
const $fada8102d2a280be$var$DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const $fada8102d2a280be$var$ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;
// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class $fada8102d2a280be$var$AttrList {
    constructor(attrs){
        if (typeof attrs === "string") attrs = $fada8102d2a280be$var$AttrList.parseAttrList(attrs);
        for(const attr in attrs)if (attrs.hasOwnProperty(attr)) {
            if (attr.substring(0, 2) === "X-") {
                this.clientAttrs = this.clientAttrs || [];
                this.clientAttrs.push(attr);
            }
            this[attr] = attrs[attr];
        }
    }
    decimalInteger(attrName) {
        const intValue = parseInt(this[attrName], 10);
        if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
        return intValue;
    }
    hexadecimalInteger(attrName) {
        if (this[attrName]) {
            let stringValue = (this[attrName] || "0x").slice(2);
            stringValue = (stringValue.length & 1 ? "0" : "") + stringValue;
            const value = new Uint8Array(stringValue.length / 2);
            for(let i = 0; i < stringValue.length / 2; i++)value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
            return value;
        } else return null;
    }
    hexadecimalIntegerAsNumber(attrName) {
        const intValue = parseInt(this[attrName], 16);
        if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
        return intValue;
    }
    decimalFloatingPoint(attrName) {
        return parseFloat(this[attrName]);
    }
    optionalFloat(attrName, defaultValue) {
        const value = this[attrName];
        return value ? parseFloat(value) : defaultValue;
    }
    enumeratedString(attrName) {
        return this[attrName];
    }
    bool(attrName) {
        return this[attrName] === "YES";
    }
    decimalResolution(attrName) {
        const res = $fada8102d2a280be$var$DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
        if (res === null) return undefined;
        return {
            width: parseInt(res[1], 10),
            height: parseInt(res[2], 10)
        };
    }
    static parseAttrList(input) {
        let match;
        const attrs = {};
        const quote = '"';
        $fada8102d2a280be$var$ATTR_LIST_REGEX.lastIndex = 0;
        while((match = $fada8102d2a280be$var$ATTR_LIST_REGEX.exec(input)) !== null){
            let value = match[2];
            if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) value = value.slice(1, -1);
            const name = match[1].trim();
            attrs[name] = value;
        }
        return attrs;
    }
}
// Avoid exporting const enum so that these values can be inlined
function $fada8102d2a280be$var$isDateRangeCueAttribute(attrName) {
    return attrName !== "ID" && attrName !== "CLASS" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function $fada8102d2a280be$var$isSCTE35Attribute(attrName) {
    return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN";
}
class $fada8102d2a280be$var$DateRange {
    constructor(dateRangeAttr, dateRangeWithSameId){
        this.attr = void 0;
        this._startDate = void 0;
        this._endDate = void 0;
        this._badValueForSameId = void 0;
        if (dateRangeWithSameId) {
            const previousAttr = dateRangeWithSameId.attr;
            for(const key in previousAttr)if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
                $fada8102d2a280be$var$logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
                this._badValueForSameId = key;
                break;
            }
            // Merge DateRange tags with the same ID
            dateRangeAttr = $fada8102d2a280be$var$_extends(new $fada8102d2a280be$var$AttrList({}), previousAttr, dateRangeAttr);
        }
        this.attr = dateRangeAttr;
        this._startDate = new Date(dateRangeAttr["START-DATE"]);
        if ("END-DATE" in this.attr) {
            const endDate = new Date(this.attr["END-DATE"]);
            if ($fada8102d2a280be$var$isFiniteNumber(endDate.getTime())) this._endDate = endDate;
        }
    }
    get id() {
        return this.attr.ID;
    }
    get class() {
        return this.attr.CLASS;
    }
    get startDate() {
        return this._startDate;
    }
    get endDate() {
        if (this._endDate) return this._endDate;
        const duration = this.duration;
        if (duration !== null) return new Date(this._startDate.getTime() + duration * 1000);
        return null;
    }
    get duration() {
        if ("DURATION" in this.attr) {
            const duration = this.attr.decimalFloatingPoint("DURATION");
            if ($fada8102d2a280be$var$isFiniteNumber(duration)) return duration;
        } else if (this._endDate) return (this._endDate.getTime() - this._startDate.getTime()) / 1000;
        return null;
    }
    get plannedDuration() {
        if ("PLANNED-DURATION" in this.attr) return this.attr.decimalFloatingPoint("PLANNED-DURATION");
        return null;
    }
    get endOnNext() {
        return this.attr.bool("END-ON-NEXT");
    }
    get isValid() {
        return !!this.id && !this._badValueForSameId && $fada8102d2a280be$var$isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
    }
}
class $fada8102d2a280be$var$LoadStats {
    constructor(){
        this.aborted = false;
        this.loaded = 0;
        this.retry = 0;
        this.total = 0;
        this.chunkCount = 0;
        this.bwEstimate = 0;
        this.loading = {
            start: 0,
            first: 0,
            end: 0
        };
        this.parsing = {
            start: 0,
            end: 0
        };
        this.buffering = {
            start: 0,
            first: 0,
            end: 0
        };
    }
}
var $fada8102d2a280be$var$ElementaryStreamTypes = {
    AUDIO: "audio",
    VIDEO: "video",
    AUDIOVIDEO: "audiovideo"
};
class $fada8102d2a280be$var$BaseSegment {
    // baseurl is the URL to the playlist
    // relurl is the portion of the URL that comes from inside the playlist.
    // Holds the types of data this fragment supports
    constructor(baseurl){
        this._byteRange = null;
        this._url = null;
        this.baseurl = void 0;
        this.relurl = void 0;
        this.elementaryStreams = {
            [$fada8102d2a280be$var$ElementaryStreamTypes.AUDIO]: null,
            [$fada8102d2a280be$var$ElementaryStreamTypes.VIDEO]: null,
            [$fada8102d2a280be$var$ElementaryStreamTypes.AUDIOVIDEO]: null
        };
        this.baseurl = baseurl;
    }
    // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
    setByteRange(value, previous) {
        const params = value.split("@", 2);
        const byteRange = [];
        if (params.length === 1) byteRange[0] = previous ? previous.byteRangeEndOffset : 0;
        else byteRange[0] = parseInt(params[1]);
        byteRange[1] = parseInt(params[0]) + byteRange[0];
        this._byteRange = byteRange;
    }
    get byteRange() {
        if (!this._byteRange) return [];
        return this._byteRange;
    }
    get byteRangeStartOffset() {
        return this.byteRange[0];
    }
    get byteRangeEndOffset() {
        return this.byteRange[1];
    }
    get url() {
        if (!this._url && this.baseurl && this.relurl) this._url = $fada8102d2a280be$var$urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
            alwaysNormalize: true
        });
        return this._url || "";
    }
    set url(value) {
        this._url = value;
    }
}
/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */ class $fada8102d2a280be$var$Fragment extends $fada8102d2a280be$var$BaseSegment {
    // EXTINF has to be present for a m3u8 to be considered valid
    // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
    // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
    // core difference from the private field _decryptdata is the lack of the initialized IV
    // _decryptdata will set the IV for this segment based on the segment number in the fragment
    // A string representing the fragment type
    // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
    // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
    // The level/track index to which the fragment belongs
    // The continuity counter of the fragment
    // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
    // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
    // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
    // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
    // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
    // Set by `updateFragPTSDTS` in level-helper
    // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
    // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
    // Load/parse timing information
    // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
    // #EXTINF  segment title
    // The Media Initialization Section for this segment
    // Fragment is the last fragment in the media playlist
    // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
    constructor(type, baseurl){
        super(baseurl);
        this._decryptdata = null;
        this.rawProgramDateTime = null;
        this.programDateTime = null;
        this.tagList = [];
        this.duration = 0;
        this.sn = 0;
        this.levelkeys = void 0;
        this.type = void 0;
        this.loader = null;
        this.keyLoader = null;
        this.level = -1;
        this.cc = 0;
        this.startPTS = void 0;
        this.endPTS = void 0;
        this.startDTS = void 0;
        this.endDTS = void 0;
        this.start = 0;
        this.deltaPTS = void 0;
        this.maxStartPTS = void 0;
        this.minEndPTS = void 0;
        this.stats = new $fada8102d2a280be$var$LoadStats();
        this.urlId = 0;
        this.data = void 0;
        this.bitrateTest = false;
        this.title = null;
        this.initSegment = null;
        this.endList = void 0;
        this.gap = void 0;
        this.type = type;
    }
    get decryptdata() {
        const { levelkeys: levelkeys } = this;
        if (!levelkeys && !this._decryptdata) return null;
        if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
            const key = this.levelkeys.identity;
            if (key) this._decryptdata = key.getDecryptData(this.sn);
            else {
                const keyFormats = Object.keys(this.levelkeys);
                if (keyFormats.length === 1) return this._decryptdata = this.levelkeys[keyFormats[0]].getDecryptData(this.sn);
            }
        }
        return this._decryptdata;
    }
    get end() {
        return this.start + this.duration;
    }
    get endProgramDateTime() {
        if (this.programDateTime === null) return null;
        if (!$fada8102d2a280be$var$isFiniteNumber(this.programDateTime)) return null;
        const duration = !$fada8102d2a280be$var$isFiniteNumber(this.duration) ? 0 : this.duration;
        return this.programDateTime + duration * 1000;
    }
    get encrypted() {
        var _this$_decryptdata;
        // At the m3u8-parser level we need to add support for manifest signalled keyformats
        // when we want the fragment to start reporting that it is encrypted.
        // Currently, keyFormat will only be set for identity keys
        if ((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.encrypted) return true;
        else if (this.levelkeys) {
            const keyFormats = Object.keys(this.levelkeys);
            const len = keyFormats.length;
            if (len > 1 || len === 1 && this.levelkeys[keyFormats[0]].encrypted) return true;
        }
        return false;
    }
    setKeyFormat(keyFormat) {
        if (this.levelkeys) {
            const key = this.levelkeys[keyFormat];
            if (key && !this._decryptdata) this._decryptdata = key.getDecryptData(this.sn);
        }
    }
    abortRequests() {
        var _this$loader, _this$keyLoader;
        (_this$loader = this.loader) == null || _this$loader.abort();
        (_this$keyLoader = this.keyLoader) == null || _this$keyLoader.abort();
    }
    setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
        const { elementaryStreams: elementaryStreams } = this;
        const info = elementaryStreams[type];
        if (!info) {
            elementaryStreams[type] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS,
                partial: partial
            };
            return;
        }
        info.startPTS = Math.min(info.startPTS, startPTS);
        info.endPTS = Math.max(info.endPTS, endPTS);
        info.startDTS = Math.min(info.startDTS, startDTS);
        info.endDTS = Math.max(info.endDTS, endDTS);
    }
    clearElementaryStreamInfo() {
        const { elementaryStreams: elementaryStreams } = this;
        elementaryStreams[$fada8102d2a280be$var$ElementaryStreamTypes.AUDIO] = null;
        elementaryStreams[$fada8102d2a280be$var$ElementaryStreamTypes.VIDEO] = null;
        elementaryStreams[$fada8102d2a280be$var$ElementaryStreamTypes.AUDIOVIDEO] = null;
    }
}
/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */ class $fada8102d2a280be$var$Part extends $fada8102d2a280be$var$BaseSegment {
    constructor(partAttrs, frag, baseurl, index, previous){
        super(baseurl);
        this.fragOffset = 0;
        this.duration = 0;
        this.gap = false;
        this.independent = false;
        this.relurl = void 0;
        this.fragment = void 0;
        this.index = void 0;
        this.stats = new $fada8102d2a280be$var$LoadStats();
        this.duration = partAttrs.decimalFloatingPoint("DURATION");
        this.gap = partAttrs.bool("GAP");
        this.independent = partAttrs.bool("INDEPENDENT");
        this.relurl = partAttrs.enumeratedString("URI");
        this.fragment = frag;
        this.index = index;
        const byteRange = partAttrs.enumeratedString("BYTERANGE");
        if (byteRange) this.setByteRange(byteRange, previous);
        if (previous) this.fragOffset = previous.fragOffset + previous.duration;
    }
    get start() {
        return this.fragment.start + this.fragOffset;
    }
    get end() {
        return this.start + this.duration;
    }
    get loaded() {
        const { elementaryStreams: elementaryStreams } = this;
        return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
    }
}
const $fada8102d2a280be$var$DEFAULT_TARGET_DURATION = 10;
/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */ class $fada8102d2a280be$var$LevelDetails {
    // Manifest reload synchronization
    constructor(baseUrl){
        this.PTSKnown = false;
        this.alignedSliding = false;
        this.averagetargetduration = void 0;
        this.endCC = 0;
        this.endSN = 0;
        this.fragments = void 0;
        this.fragmentHint = void 0;
        this.partList = null;
        this.dateRanges = void 0;
        this.live = true;
        this.ageHeader = 0;
        this.advancedDateTime = void 0;
        this.updated = true;
        this.advanced = true;
        this.availabilityDelay = void 0;
        this.misses = 0;
        this.startCC = 0;
        this.startSN = 0;
        this.startTimeOffset = null;
        this.targetduration = 0;
        this.totalduration = 0;
        this.type = null;
        this.url = void 0;
        this.m3u8 = "";
        this.version = null;
        this.canBlockReload = false;
        this.canSkipUntil = 0;
        this.canSkipDateRanges = false;
        this.skippedSegments = 0;
        this.recentlyRemovedDateranges = void 0;
        this.partHoldBack = 0;
        this.holdBack = 0;
        this.partTarget = 0;
        this.preloadHint = void 0;
        this.renditionReports = void 0;
        this.tuneInGoal = 0;
        this.deltaUpdateFailed = void 0;
        this.driftStartTime = 0;
        this.driftEndTime = 0;
        this.driftStart = 0;
        this.driftEnd = 0;
        this.encryptedFragments = void 0;
        this.playlistParsingError = null;
        this.variableList = null;
        this.hasVariableRefs = false;
        this.fragments = [];
        this.encryptedFragments = [];
        this.dateRanges = {};
        this.url = baseUrl;
    }
    reloaded(previous) {
        if (!previous) {
            this.advanced = true;
            this.updated = true;
            return;
        }
        const partSnDiff = this.lastPartSn - previous.lastPartSn;
        const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
        this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff;
        this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
        if (this.updated || this.advanced) this.misses = Math.floor(previous.misses * 0.6);
        else this.misses = previous.misses + 1;
        this.availabilityDelay = previous.availabilityDelay;
    }
    get hasProgramDateTime() {
        if (this.fragments.length) return $fada8102d2a280be$var$isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
        return false;
    }
    get levelTargetDuration() {
        return this.averagetargetduration || this.targetduration || $fada8102d2a280be$var$DEFAULT_TARGET_DURATION;
    }
    get drift() {
        const runTime = this.driftEndTime - this.driftStartTime;
        if (runTime > 0) {
            const runDuration = this.driftEnd - this.driftStart;
            return runDuration * 1000 / runTime;
        }
        return 1;
    }
    get edge() {
        return this.partEnd || this.fragmentEnd;
    }
    get partEnd() {
        var _this$partList;
        if ((_this$partList = this.partList) != null && _this$partList.length) return this.partList[this.partList.length - 1].end;
        return this.fragmentEnd;
    }
    get fragmentEnd() {
        var _this$fragments;
        if ((_this$fragments = this.fragments) != null && _this$fragments.length) return this.fragments[this.fragments.length - 1].end;
        return 0;
    }
    get age() {
        if (this.advancedDateTime) return Math.max(Date.now() - this.advancedDateTime, 0) / 1000;
        return 0;
    }
    get lastPartIndex() {
        var _this$partList2;
        if ((_this$partList2 = this.partList) != null && _this$partList2.length) return this.partList[this.partList.length - 1].index;
        return -1;
    }
    get lastPartSn() {
        var _this$partList3;
        if ((_this$partList3 = this.partList) != null && _this$partList3.length) return this.partList[this.partList.length - 1].fragment.sn;
        return this.endSN;
    }
}
function $fada8102d2a280be$var$base64Decode(base64encodedStr) {
    return Uint8Array.from(atob(base64encodedStr), (c)=>c.charCodeAt(0));
}
function $fada8102d2a280be$var$getKeyIdBytes(str) {
    const keyIdbytes = $fada8102d2a280be$var$strToUtf8array(str).subarray(0, 16);
    const paddedkeyIdbytes = new Uint8Array(16);
    paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
    return paddedkeyIdbytes;
}
function $fada8102d2a280be$var$changeEndianness(keyId) {
    const swap = function swap(array, from, to) {
        const cur = array[from];
        array[from] = array[to];
        array[to] = cur;
    };
    swap(keyId, 0, 3);
    swap(keyId, 1, 2);
    swap(keyId, 4, 5);
    swap(keyId, 6, 7);
}
function $fada8102d2a280be$var$convertDataUriToArrayBytes(uri) {
    // data:[<media type][;attribute=value][;base64],<data>
    const colonsplit = uri.split(":");
    let keydata = null;
    if (colonsplit[0] === "data" && colonsplit.length === 2) {
        const semicolonsplit = colonsplit[1].split(";");
        const commasplit = semicolonsplit[semicolonsplit.length - 1].split(",");
        if (commasplit.length === 2) {
            const isbase64 = commasplit[0] === "base64";
            const data = commasplit[1];
            if (isbase64) {
                semicolonsplit.splice(-1, 1); // remove from processing
                keydata = $fada8102d2a280be$var$base64Decode(data);
            } else keydata = $fada8102d2a280be$var$getKeyIdBytes(data);
        }
    }
    return keydata;
}
function $fada8102d2a280be$var$strToUtf8array(str) {
    return Uint8Array.from(unescape(encodeURIComponent(str)), (c)=>c.charCodeAt(0));
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */ var $fada8102d2a280be$var$KeySystems = {
    CLEARKEY: "org.w3.clearkey",
    FAIRPLAY: "com.apple.fps",
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "com.widevine.alpha"
};
// Playlist #EXT-X-KEY KEYFORMAT values
var $fada8102d2a280be$var$KeySystemFormats = {
    CLEARKEY: "org.w3.clearkey",
    FAIRPLAY: "com.apple.streamingkeydelivery",
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function $fada8102d2a280be$var$keySystemFormatToKeySystemDomain(format) {
    switch(format){
        case $fada8102d2a280be$var$KeySystemFormats.FAIRPLAY:
            return $fada8102d2a280be$var$KeySystems.FAIRPLAY;
        case $fada8102d2a280be$var$KeySystemFormats.PLAYREADY:
            return $fada8102d2a280be$var$KeySystems.PLAYREADY;
        case $fada8102d2a280be$var$KeySystemFormats.WIDEVINE:
            return $fada8102d2a280be$var$KeySystems.WIDEVINE;
        case $fada8102d2a280be$var$KeySystemFormats.CLEARKEY:
            return $fada8102d2a280be$var$KeySystems.CLEARKEY;
    }
}
// System IDs for which we can extract a key ID from "encrypted" event PSSH
var $fada8102d2a280be$var$KeySystemIds = {
    WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function $fada8102d2a280be$var$keySystemIdToKeySystemDomain(systemId) {
    if (systemId === $fada8102d2a280be$var$KeySystemIds.WIDEVINE) return $fada8102d2a280be$var$KeySystems.WIDEVINE;
}
function $fada8102d2a280be$var$keySystemDomainToKeySystemFormat(keySystem) {
    switch(keySystem){
        case $fada8102d2a280be$var$KeySystems.FAIRPLAY:
            return $fada8102d2a280be$var$KeySystemFormats.FAIRPLAY;
        case $fada8102d2a280be$var$KeySystems.PLAYREADY:
            return $fada8102d2a280be$var$KeySystemFormats.PLAYREADY;
        case $fada8102d2a280be$var$KeySystems.WIDEVINE:
            return $fada8102d2a280be$var$KeySystemFormats.WIDEVINE;
        case $fada8102d2a280be$var$KeySystems.CLEARKEY:
            return $fada8102d2a280be$var$KeySystemFormats.CLEARKEY;
    }
}
function $fada8102d2a280be$var$getKeySystemsForConfig(config) {
    const { drmSystems: drmSystems, widevineLicenseUrl: widevineLicenseUrl } = config;
    const keySystemsToAttempt = drmSystems ? [
        $fada8102d2a280be$var$KeySystems.FAIRPLAY,
        $fada8102d2a280be$var$KeySystems.WIDEVINE,
        $fada8102d2a280be$var$KeySystems.PLAYREADY,
        $fada8102d2a280be$var$KeySystems.CLEARKEY
    ].filter((keySystem)=>!!drmSystems[keySystem]) : [];
    if (!keySystemsToAttempt[$fada8102d2a280be$var$KeySystems.WIDEVINE] && widevineLicenseUrl) keySystemsToAttempt.push($fada8102d2a280be$var$KeySystems.WIDEVINE);
    return keySystemsToAttempt;
}
const $fada8102d2a280be$var$requestMediaKeySystemAccess = function() {
    if (typeof self !== "undefined" && self.navigator && self.navigator.requestMediaKeySystemAccess) return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
    else return null;
}();
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */ function $fada8102d2a280be$var$getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
    let initDataTypes;
    switch(keySystem){
        case $fada8102d2a280be$var$KeySystems.FAIRPLAY:
            initDataTypes = [
                "cenc",
                "sinf"
            ];
            break;
        case $fada8102d2a280be$var$KeySystems.WIDEVINE:
        case $fada8102d2a280be$var$KeySystems.PLAYREADY:
            initDataTypes = [
                "cenc"
            ];
            break;
        case $fada8102d2a280be$var$KeySystems.CLEARKEY:
            initDataTypes = [
                "cenc",
                "keyids"
            ];
            break;
        default:
            throw new Error(`Unknown key-system: ${keySystem}`);
    }
    return $fada8102d2a280be$var$createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function $fada8102d2a280be$var$createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
    const baseConfig = {
        initDataTypes: initDataTypes,
        persistentState: drmSystemOptions.persistentState || "not-allowed",
        distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || "not-allowed",
        sessionTypes: drmSystemOptions.sessionTypes || [
            drmSystemOptions.sessionType || "temporary"
        ],
        audioCapabilities: audioCodecs.map((codec)=>({
                contentType: `audio/mp4; codecs="${codec}"`,
                robustness: drmSystemOptions.audioRobustness || "",
                encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
            })),
        videoCapabilities: videoCodecs.map((codec)=>({
                contentType: `video/mp4; codecs="${codec}"`,
                robustness: drmSystemOptions.videoRobustness || "",
                encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
            }))
    };
    return [
        baseConfig
    ];
}
function $fada8102d2a280be$var$sliceUint8(array, start, end) {
    // @ts-expect-error This polyfills IE11 usage of Uint8Array slice.
    // It always exists in the TypeScript definition so fails, but it fails at runtime on IE11.
    return Uint8Array.prototype.slice ? array.slice(start, end) : new Uint8Array(Array.prototype.slice.call(array, start, end));
}
// breaking up those two types in order to clarify what is happening in the decoding path.
/**
 * Returns true if an ID3 header can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */ const $fada8102d2a280be$var$isHeader$2 = (data, offset)=>{
    /*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */ if (offset + 10 <= data.length) {
        // look for 'ID3' identifier
        if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) // check version is within range
        {
            if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
                // check size is within range
                if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
            }
        }
    }
    return false;
};
/**
 * Returns true if an ID3 footer can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */ const $fada8102d2a280be$var$isFooter = (data, offset)=>{
    /*
   * The footer is a copy of the header, but with a different identifier
   */ if (offset + 10 <= data.length) {
        // look for '3DI' identifier
        if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) // check version is within range
        {
            if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
                // check size is within range
                if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
            }
        }
    }
    return false;
};
/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 * @returns the block of data containing any ID3 tags found
 * or *undefined* if no header is found at the starting offset
 */ const $fada8102d2a280be$var$getID3Data = (data, offset)=>{
    const front = offset;
    let length = 0;
    while($fada8102d2a280be$var$isHeader$2(data, offset)){
        // ID3 header is 10 bytes
        length += 10;
        const size = $fada8102d2a280be$var$readSize(data, offset + 6);
        length += size;
        if ($fada8102d2a280be$var$isFooter(data, offset + 10)) // ID3 footer is 10 bytes
        length += 10;
        offset += length;
    }
    if (length > 0) return data.subarray(front, front + length);
    return undefined;
};
const $fada8102d2a280be$var$readSize = (data, offset)=>{
    let size = 0;
    size = (data[offset] & 0x7f) << 21;
    size |= (data[offset + 1] & 0x7f) << 14;
    size |= (data[offset + 2] & 0x7f) << 7;
    size |= data[offset + 3] & 0x7f;
    return size;
};
const $fada8102d2a280be$var$canParse$2 = (data, offset)=>{
    return $fada8102d2a280be$var$isHeader$2(data, offset) && $fada8102d2a280be$var$readSize(data, offset + 6) + 10 <= data.length - offset;
};
/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 * @param data - Block of data containing one or more ID3 tags
 */ const $fada8102d2a280be$var$getTimeStamp = (data)=>{
    const frames = $fada8102d2a280be$var$getID3Frames(data);
    for(let i = 0; i < frames.length; i++){
        const frame = frames[i];
        if ($fada8102d2a280be$var$isTimeStampFrame(frame)) return $fada8102d2a280be$var$readTimeStamp(frame);
    }
    return undefined;
};
/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 */ const $fada8102d2a280be$var$isTimeStampFrame = (frame)=>{
    return frame && frame.key === "PRIV" && frame.info === "com.apple.streaming.transportStreamTimestamp";
};
const $fada8102d2a280be$var$getFrameData = (data)=>{
    /*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */ const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
    const size = $fada8102d2a280be$var$readSize(data, 4);
    // skip frame id, size, and flags
    const offset = 10;
    return {
        type: type,
        size: size,
        data: data.subarray(offset, offset + size)
    };
};
/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 * @param id3Data - The ID3 data containing one or more ID3 tags
 */ const $fada8102d2a280be$var$getID3Frames = (id3Data)=>{
    let offset = 0;
    const frames = [];
    while($fada8102d2a280be$var$isHeader$2(id3Data, offset)){
        const size = $fada8102d2a280be$var$readSize(id3Data, offset + 6);
        // skip past ID3 header
        offset += 10;
        const end = offset + size;
        // loop through frames in the ID3 tag
        while(offset + 8 < end){
            const frameData = $fada8102d2a280be$var$getFrameData(id3Data.subarray(offset));
            const frame = $fada8102d2a280be$var$decodeFrame(frameData);
            if (frame) frames.push(frame);
            // skip frame header and frame data
            offset += frameData.size + 10;
        }
        if ($fada8102d2a280be$var$isFooter(id3Data, offset)) offset += 10;
    }
    return frames;
};
const $fada8102d2a280be$var$decodeFrame = (frame)=>{
    if (frame.type === "PRIV") return $fada8102d2a280be$var$decodePrivFrame(frame);
    else if (frame.type[0] === "W") return $fada8102d2a280be$var$decodeURLFrame(frame);
    return $fada8102d2a280be$var$decodeTextFrame(frame);
};
const $fada8102d2a280be$var$decodePrivFrame = (frame)=>{
    /*
  Format: <text string>\0<binary data>
  */ if (frame.size < 2) return undefined;
    const owner = $fada8102d2a280be$var$utf8ArrayToStr(frame.data, true);
    const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
    return {
        key: frame.type,
        info: owner,
        data: privateData.buffer
    };
};
const $fada8102d2a280be$var$decodeTextFrame = (frame)=>{
    if (frame.size < 2) return undefined;
    if (frame.type === "TXXX") {
        /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */ let index = 1;
        const description = $fada8102d2a280be$var$utf8ArrayToStr(frame.data.subarray(index), true);
        index += description.length + 1;
        const value = $fada8102d2a280be$var$utf8ArrayToStr(frame.data.subarray(index));
        return {
            key: frame.type,
            info: description,
            data: value
        };
    }
    /*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */ const text = $fada8102d2a280be$var$utf8ArrayToStr(frame.data.subarray(1));
    return {
        key: frame.type,
        data: text
    };
};
const $fada8102d2a280be$var$decodeURLFrame = (frame)=>{
    if (frame.type === "WXXX") {
        /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */ if (frame.size < 2) return undefined;
        let index = 1;
        const description = $fada8102d2a280be$var$utf8ArrayToStr(frame.data.subarray(index), true);
        index += description.length + 1;
        const value = $fada8102d2a280be$var$utf8ArrayToStr(frame.data.subarray(index));
        return {
            key: frame.type,
            info: description,
            data: value
        };
    }
    /*
  Format:
  [0-?] = {URL}
  */ const url = $fada8102d2a280be$var$utf8ArrayToStr(frame.data);
    return {
        key: frame.type,
        data: url
    };
};
const $fada8102d2a280be$var$readTimeStamp = (timeStampFrame)=>{
    if (timeStampFrame.data.byteLength === 8) {
        const data = new Uint8Array(timeStampFrame.data);
        // timestamp is 33 bit expressed as a big-endian eight-octet number,
        // with the upper 31 bits set to zero.
        const pts33Bit = data[3] & 0x1;
        let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
        timestamp /= 45;
        if (pts33Bit) timestamp += 47721858.84;
         // 2^32 / 90
        return Math.round(timestamp);
    }
    return undefined;
};
// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */ const $fada8102d2a280be$var$utf8ArrayToStr = (array, exitOnNull = false)=>{
    const decoder = $fada8102d2a280be$var$getTextDecoder();
    if (decoder) {
        const decoded = decoder.decode(array);
        if (exitOnNull) {
            // grab up to the first null
            const idx = decoded.indexOf("\x00");
            return idx !== -1 ? decoded.substring(0, idx) : decoded;
        }
        // remove any null characters
        return decoded.replace(/\0/g, "");
    }
    const len = array.length;
    let c;
    let char2;
    let char3;
    let out = "";
    let i = 0;
    while(i < len){
        c = array[i++];
        if (c === 0x00 && exitOnNull) return out;
        else if (c === 0x00 || c === 0x03) continue;
        switch(c >> 4){
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                out += String.fromCharCode(c);
                break;
            case 12:
            case 13:
                // 110x xxxx   10xx xxxx
                char2 = array[i++];
                out += String.fromCharCode((c & 0x1f) << 6 | char2 & 0x3f);
                break;
            case 14:
                // 1110 xxxx  10xx xxxx  10xx xxxx
                char2 = array[i++];
                char3 = array[i++];
                out += String.fromCharCode((c & 0x0f) << 12 | (char2 & 0x3f) << 6 | (char3 & 0x3f) << 0);
                break;
        }
    }
    return out;
};
let $fada8102d2a280be$var$decoder;
function $fada8102d2a280be$var$getTextDecoder() {
    if (!$fada8102d2a280be$var$decoder && typeof self.TextDecoder !== "undefined") $fada8102d2a280be$var$decoder = new self.TextDecoder("utf-8");
    return $fada8102d2a280be$var$decoder;
}
/**
 *  hex dump helper class
 */ const $fada8102d2a280be$var$Hex = {
    hexDump: function(array) {
        let str = "";
        for(let i = 0; i < array.length; i++){
            let h = array[i].toString(16);
            if (h.length < 2) h = "0" + h;
            str += h;
        }
        return str;
    }
};
const $fada8102d2a280be$var$UINT32_MAX$1 = Math.pow(2, 32) - 1;
const $fada8102d2a280be$var$push = [].push;
// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
const $fada8102d2a280be$var$RemuxerTrackIdConfig = {
    video: 1,
    audio: 2,
    id3: 3,
    text: 4
};
function $fada8102d2a280be$var$bin2str(data) {
    return String.fromCharCode.apply(null, data);
}
function $fada8102d2a280be$var$readUint16(buffer, offset) {
    const val = buffer[offset] << 8 | buffer[offset + 1];
    return val < 0 ? 65536 + val : val;
}
function $fada8102d2a280be$var$readUint32(buffer, offset) {
    const val = $fada8102d2a280be$var$readSint32(buffer, offset);
    return val < 0 ? 4294967296 + val : val;
}
function $fada8102d2a280be$var$readSint32(buffer, offset) {
    return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function $fada8102d2a280be$var$writeUint32(buffer, offset, value) {
    buffer[offset] = value >> 24;
    buffer[offset + 1] = value >> 16 & 0xff;
    buffer[offset + 2] = value >> 8 & 0xff;
    buffer[offset + 3] = value & 0xff;
}
// Find the data for a box specified by its path
function $fada8102d2a280be$var$findBox(data, path) {
    const results = [];
    if (!path.length) // short-circuit the search for empty paths
    return results;
    const end = data.byteLength;
    for(let i = 0; i < end;){
        const size = $fada8102d2a280be$var$readUint32(data, i);
        const type = $fada8102d2a280be$var$bin2str(data.subarray(i + 4, i + 8));
        const endbox = size > 1 ? i + size : end;
        if (type === path[0]) {
            if (path.length === 1) // this is the end of the path and we've found the box we were
            // looking for
            results.push(data.subarray(i + 8, endbox));
            else {
                // recursively search for the next box along the path
                const subresults = $fada8102d2a280be$var$findBox(data.subarray(i + 8, endbox), path.slice(1));
                if (subresults.length) $fada8102d2a280be$var$push.apply(results, subresults);
            }
        }
        i = endbox;
    }
    // we've finished searching all of data
    return results;
}
function $fada8102d2a280be$var$parseSegmentIndex(sidx) {
    const references = [];
    const version = sidx[0];
    // set initial offset, we skip the reference ID (not needed)
    let index = 8;
    const timescale = $fada8102d2a280be$var$readUint32(sidx, index);
    index += 4;
    // TODO: parse earliestPresentationTime and firstOffset
    // usually zero in our case
    const earliestPresentationTime = 0;
    const firstOffset = 0;
    if (version === 0) index += 8;
    else index += 16;
    // skip reserved
    index += 2;
    let startByte = sidx.length + firstOffset;
    const referencesCount = $fada8102d2a280be$var$readUint16(sidx, index);
    index += 2;
    for(let i = 0; i < referencesCount; i++){
        let referenceIndex = index;
        const referenceInfo = $fada8102d2a280be$var$readUint32(sidx, referenceIndex);
        referenceIndex += 4;
        const referenceSize = referenceInfo & 0x7fffffff;
        const referenceType = (referenceInfo & 0x80000000) >>> 31;
        if (referenceType === 1) {
            $fada8102d2a280be$var$logger.warn("SIDX has hierarchical references (not supported)");
            return null;
        }
        const subsegmentDuration = $fada8102d2a280be$var$readUint32(sidx, referenceIndex);
        referenceIndex += 4;
        references.push({
            referenceSize: referenceSize,
            subsegmentDuration: subsegmentDuration,
            // unscaled
            info: {
                duration: subsegmentDuration / timescale,
                start: startByte,
                end: startByte + referenceSize - 1
            }
        });
        startByte += referenceSize;
        // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
        // for |sapDelta|.
        referenceIndex += 4;
        // skip to next ref
        index = referenceIndex;
    }
    return {
        earliestPresentationTime: earliestPresentationTime,
        timescale: timescale,
        version: version,
        referencesCount: referencesCount,
        references: references
    };
}
/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */ function $fada8102d2a280be$var$parseInitSegment(initSegment) {
    const result = [];
    const traks = $fada8102d2a280be$var$findBox(initSegment, [
        "moov",
        "trak"
    ]);
    for(let i = 0; i < traks.length; i++){
        const trak = traks[i];
        const tkhd = $fada8102d2a280be$var$findBox(trak, [
            "tkhd"
        ])[0];
        if (tkhd) {
            let version = tkhd[0];
            let index = version === 0 ? 12 : 20;
            const trackId = $fada8102d2a280be$var$readUint32(tkhd, index);
            const mdhd = $fada8102d2a280be$var$findBox(trak, [
                "mdia",
                "mdhd"
            ])[0];
            if (mdhd) {
                version = mdhd[0];
                index = version === 0 ? 12 : 20;
                const timescale = $fada8102d2a280be$var$readUint32(mdhd, index);
                const hdlr = $fada8102d2a280be$var$findBox(trak, [
                    "mdia",
                    "hdlr"
                ])[0];
                if (hdlr) {
                    const hdlrType = $fada8102d2a280be$var$bin2str(hdlr.subarray(8, 12));
                    const type = {
                        soun: $fada8102d2a280be$var$ElementaryStreamTypes.AUDIO,
                        vide: $fada8102d2a280be$var$ElementaryStreamTypes.VIDEO
                    }[hdlrType];
                    if (type) {
                        // Parse codec details
                        const stsd = $fada8102d2a280be$var$findBox(trak, [
                            "mdia",
                            "minf",
                            "stbl",
                            "stsd"
                        ])[0];
                        let codec;
                        if (stsd) codec = $fada8102d2a280be$var$bin2str(stsd.subarray(12, 16));
                        result[trackId] = {
                            timescale: timescale,
                            type: type
                        };
                        result[type] = {
                            timescale: timescale,
                            id: trackId,
                            codec: codec
                        };
                    }
                }
            }
        }
    }
    const trex = $fada8102d2a280be$var$findBox(initSegment, [
        "moov",
        "mvex",
        "trex"
    ]);
    trex.forEach((trex)=>{
        const trackId = $fada8102d2a280be$var$readUint32(trex, 4);
        const track = result[trackId];
        if (track) track.default = {
            duration: $fada8102d2a280be$var$readUint32(trex, 12),
            flags: $fada8102d2a280be$var$readUint32(trex, 20)
        };
    });
    return result;
}
function $fada8102d2a280be$var$patchEncyptionData(initSegment, decryptdata) {
    if (!initSegment || !decryptdata) return initSegment;
    const keyId = decryptdata.keyId;
    if (keyId && decryptdata.isCommonEncryption) {
        const traks = $fada8102d2a280be$var$findBox(initSegment, [
            "moov",
            "trak"
        ]);
        traks.forEach((trak)=>{
            const stsd = $fada8102d2a280be$var$findBox(trak, [
                "mdia",
                "minf",
                "stbl",
                "stsd"
            ])[0];
            // skip the sample entry count
            const sampleEntries = stsd.subarray(8);
            let encBoxes = $fada8102d2a280be$var$findBox(sampleEntries, [
                "enca"
            ]);
            const isAudio = encBoxes.length > 0;
            if (!isAudio) encBoxes = $fada8102d2a280be$var$findBox(sampleEntries, [
                "encv"
            ]);
            encBoxes.forEach((enc)=>{
                const encBoxChildren = isAudio ? enc.subarray(28) : enc.subarray(78);
                const sinfBoxes = $fada8102d2a280be$var$findBox(encBoxChildren, [
                    "sinf"
                ]);
                sinfBoxes.forEach((sinf)=>{
                    const tenc = $fada8102d2a280be$var$parseSinf(sinf);
                    if (tenc) {
                        // Look for default key id (keyID offset is always 8 within the tenc box):
                        const tencKeyId = tenc.subarray(8, 24);
                        if (!tencKeyId.some((b)=>b !== 0)) {
                            $fada8102d2a280be$var$logger.log(`[eme] Patching keyId in 'enc${isAudio ? "a" : "v"}>sinf>>tenc' box: ${$fada8102d2a280be$var$Hex.hexDump(tencKeyId)} -> ${$fada8102d2a280be$var$Hex.hexDump(keyId)}`);
                            tenc.set(keyId, 8);
                        }
                    }
                });
            });
        });
    }
    return initSegment;
}
function $fada8102d2a280be$var$parseSinf(sinf) {
    const schm = $fada8102d2a280be$var$findBox(sinf, [
        "schm"
    ])[0];
    if (schm) {
        const scheme = $fada8102d2a280be$var$bin2str(schm.subarray(4, 8));
        if (scheme === "cbcs" || scheme === "cenc") return $fada8102d2a280be$var$findBox(sinf, [
            "schi",
            "tenc"
        ])[0];
    }
    $fada8102d2a280be$var$logger.error(`[eme] missing 'schm' box`);
    return null;
}
/**
 * Determine the base media decode start time, in seconds, for an MP4
 * fragment. If multiple fragments are specified, the earliest time is
 * returned.
 *
 * The base media decode time can be parsed from track fragment
 * metadata:
 * ```
 * moof > traf > tfdt.baseMediaDecodeTime
 * ```
 * It requires the timescale value from the mdhd to interpret.
 *
 * @param initData - a hash of track type to timescale values
 * @param fmp4 - the bytes of the mp4 fragment
 * @returns the earliest base media decode start time for the
 * fragment, in seconds
 */ function $fada8102d2a280be$var$getStartDTS(initData, fmp4) {
    // we need info from two children of each track fragment box
    return $fada8102d2a280be$var$findBox(fmp4, [
        "moof",
        "traf"
    ]).reduce((result, traf)=>{
        const tfdt = $fada8102d2a280be$var$findBox(traf, [
            "tfdt"
        ])[0];
        const version = tfdt[0];
        const start = $fada8102d2a280be$var$findBox(traf, [
            "tfhd"
        ]).reduce((result, tfhd)=>{
            // get the track id from the tfhd
            const id = $fada8102d2a280be$var$readUint32(tfhd, 4);
            const track = initData[id];
            if (track) {
                let baseTime = $fada8102d2a280be$var$readUint32(tfdt, 4);
                if (version === 1) {
                    // If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
                    // This prevents large values from being used for initPTS, which can cause playlist sync issues.
                    // https://github.com/video-dev/hls.js/issues/5303
                    if (baseTime === $fada8102d2a280be$var$UINT32_MAX$1) {
                        $fada8102d2a280be$var$logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
                        return result;
                    }
                    baseTime *= $fada8102d2a280be$var$UINT32_MAX$1 + 1;
                    baseTime += $fada8102d2a280be$var$readUint32(tfdt, 8);
                }
                // assume a 90kHz clock if no timescale was specified
                const scale = track.timescale || 90e3;
                // convert base time to seconds
                const startTime = baseTime / scale;
                if (isFinite(startTime) && (result === null || startTime < result)) return startTime;
            }
            return result;
        }, null);
        if (start !== null && isFinite(start) && (result === null || start < result)) return start;
        return result;
    }, null);
}
/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */ function $fada8102d2a280be$var$getDuration(data, initData) {
    let rawDuration = 0;
    let videoDuration = 0;
    let audioDuration = 0;
    const trafs = $fada8102d2a280be$var$findBox(data, [
        "moof",
        "traf"
    ]);
    for(let i = 0; i < trafs.length; i++){
        const traf = trafs[i];
        // There is only one tfhd & trun per traf
        // This is true for CMAF style content, and we should perhaps check the ftyp
        // and only look for a single trun then, but for ISOBMFF we should check
        // for multiple track runs.
        const tfhd = $fada8102d2a280be$var$findBox(traf, [
            "tfhd"
        ])[0];
        // get the track id from the tfhd
        const id = $fada8102d2a280be$var$readUint32(tfhd, 4);
        const track = initData[id];
        if (!track) continue;
        const trackDefault = track.default;
        const tfhdFlags = $fada8102d2a280be$var$readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
        let sampleDuration = trackDefault == null ? void 0 : trackDefault.duration;
        if (tfhdFlags & 0x000008) {
            // 0x000008 indicates the presence of the default_sample_duration field
            if (tfhdFlags & 0x000002) // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
            // If present, the default_sample_duration exists at byte offset 12
            sampleDuration = $fada8102d2a280be$var$readUint32(tfhd, 12);
            else // Otherwise, the duration is at byte offset 8
            sampleDuration = $fada8102d2a280be$var$readUint32(tfhd, 8);
        }
        // assume a 90kHz clock if no timescale was specified
        const timescale = track.timescale || 90e3;
        const truns = $fada8102d2a280be$var$findBox(traf, [
            "trun"
        ]);
        for(let j = 0; j < truns.length; j++){
            rawDuration = $fada8102d2a280be$var$computeRawDurationFromSamples(truns[j]);
            if (!rawDuration && sampleDuration) {
                const sampleCount = $fada8102d2a280be$var$readUint32(truns[j], 4);
                rawDuration = sampleDuration * sampleCount;
            }
            if (track.type === $fada8102d2a280be$var$ElementaryStreamTypes.VIDEO) videoDuration += rawDuration / timescale;
            else if (track.type === $fada8102d2a280be$var$ElementaryStreamTypes.AUDIO) audioDuration += rawDuration / timescale;
        }
    }
    if (videoDuration === 0 && audioDuration === 0) {
        // If duration samples are not available in the traf use sidx subsegment_duration
        let sidxDuration = 0;
        const sidxs = $fada8102d2a280be$var$findBox(data, [
            "sidx"
        ]);
        for(let i = 0; i < sidxs.length; i++){
            const sidx = $fada8102d2a280be$var$parseSegmentIndex(sidxs[i]);
            if (sidx != null && sidx.references) sidxDuration += sidx.references.reduce((dur, ref)=>dur + ref.info.duration || 0, 0);
        }
        return sidxDuration;
    }
    if (videoDuration) return videoDuration;
    return audioDuration;
}
/*
  For Reference:
  aligned(8) class TrackRunBox
           extends FullBox(‘trun’, version, tr_flags) {
     unsigned int(32)  sample_count;
     // the following are optional fields
     signed int(32) data_offset;
     unsigned int(32)  first_sample_flags;
     // all fields in the following array are optional
     {
        unsigned int(32)  sample_duration;
        unsigned int(32)  sample_size;
        unsigned int(32)  sample_flags
        if (version == 0)
           { unsigned int(32)
        else
           { signed int(32)
     }[ sample_count ]
  }
 */ function $fada8102d2a280be$var$computeRawDurationFromSamples(trun) {
    const flags = $fada8102d2a280be$var$readUint32(trun, 0);
    // Flags are at offset 0, non-optional sample_count is at offset 4. Therefore we start 8 bytes in.
    // Each field is an int32, which is 4 bytes
    let offset = 8;
    // data-offset-present flag
    if (flags & 0x000001) offset += 4;
    // first-sample-flags-present flag
    if (flags & 0x000004) offset += 4;
    let duration = 0;
    const sampleCount = $fada8102d2a280be$var$readUint32(trun, 4);
    for(let i = 0; i < sampleCount; i++){
        // sample-duration-present flag
        if (flags & 0x000100) {
            const sampleDuration = $fada8102d2a280be$var$readUint32(trun, offset);
            duration += sampleDuration;
            offset += 4;
        }
        // sample-size-present flag
        if (flags & 0x000200) offset += 4;
        // sample-flags-present flag
        if (flags & 0x000400) offset += 4;
        // sample-composition-time-offsets-present flag
        if (flags & 0x000800) offset += 4;
    }
    return duration;
}
function $fada8102d2a280be$var$offsetStartDTS(initData, fmp4, timeOffset) {
    $fada8102d2a280be$var$findBox(fmp4, [
        "moof",
        "traf"
    ]).forEach((traf)=>{
        $fada8102d2a280be$var$findBox(traf, [
            "tfhd"
        ]).forEach((tfhd)=>{
            // get the track id from the tfhd
            const id = $fada8102d2a280be$var$readUint32(tfhd, 4);
            const track = initData[id];
            if (!track) return;
            // assume a 90kHz clock if no timescale was specified
            const timescale = track.timescale || 90e3;
            // get the base media decode time from the tfdt
            $fada8102d2a280be$var$findBox(traf, [
                "tfdt"
            ]).forEach((tfdt)=>{
                const version = tfdt[0];
                let baseMediaDecodeTime = $fada8102d2a280be$var$readUint32(tfdt, 4);
                if (version === 0) {
                    baseMediaDecodeTime -= timeOffset * timescale;
                    baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                    $fada8102d2a280be$var$writeUint32(tfdt, 4, baseMediaDecodeTime);
                } else {
                    baseMediaDecodeTime *= Math.pow(2, 32);
                    baseMediaDecodeTime += $fada8102d2a280be$var$readUint32(tfdt, 8);
                    baseMediaDecodeTime -= timeOffset * timescale;
                    baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                    const upper = Math.floor(baseMediaDecodeTime / ($fada8102d2a280be$var$UINT32_MAX$1 + 1));
                    const lower = Math.floor(baseMediaDecodeTime % ($fada8102d2a280be$var$UINT32_MAX$1 + 1));
                    $fada8102d2a280be$var$writeUint32(tfdt, 4, upper);
                    $fada8102d2a280be$var$writeUint32(tfdt, 8, lower);
                }
            });
        });
    });
}
// TODO: Check if the last moof+mdat pair is part of the valid range
function $fada8102d2a280be$var$segmentValidRange(data) {
    const segmentedRange = {
        valid: null,
        remainder: null
    };
    const moofs = $fada8102d2a280be$var$findBox(data, [
        "moof"
    ]);
    if (!moofs) return segmentedRange;
    else if (moofs.length < 2) {
        segmentedRange.remainder = data;
        return segmentedRange;
    }
    const last = moofs[moofs.length - 1];
    // Offset by 8 bytes; findBox offsets the start by as much
    segmentedRange.valid = $fada8102d2a280be$var$sliceUint8(data, 0, last.byteOffset - 8);
    segmentedRange.remainder = $fada8102d2a280be$var$sliceUint8(data, last.byteOffset - 8);
    return segmentedRange;
}
function $fada8102d2a280be$var$appendUint8Array(data1, data2) {
    const temp = new Uint8Array(data1.length + data2.length);
    temp.set(data1);
    temp.set(data2, data1.length);
    return temp;
}
function $fada8102d2a280be$var$parseSamples(timeOffset, track) {
    const seiSamples = [];
    const videoData = track.samples;
    const timescale = track.timescale;
    const trackId = track.id;
    let isHEVCFlavor = false;
    const moofs = $fada8102d2a280be$var$findBox(videoData, [
        "moof"
    ]);
    moofs.map((moof)=>{
        const moofOffset = moof.byteOffset - 8;
        const trafs = $fada8102d2a280be$var$findBox(moof, [
            "traf"
        ]);
        trafs.map((traf)=>{
            // get the base media decode time from the tfdt
            const baseTime = $fada8102d2a280be$var$findBox(traf, [
                "tfdt"
            ]).map((tfdt)=>{
                const version = tfdt[0];
                let result = $fada8102d2a280be$var$readUint32(tfdt, 4);
                if (version === 1) {
                    result *= Math.pow(2, 32);
                    result += $fada8102d2a280be$var$readUint32(tfdt, 8);
                }
                return result / timescale;
            })[0];
            if (baseTime !== undefined) timeOffset = baseTime;
            return $fada8102d2a280be$var$findBox(traf, [
                "tfhd"
            ]).map((tfhd)=>{
                const id = $fada8102d2a280be$var$readUint32(tfhd, 4);
                const tfhdFlags = $fada8102d2a280be$var$readUint32(tfhd, 0) & 0xffffff;
                const baseDataOffsetPresent = (tfhdFlags & 0x000001) !== 0;
                const sampleDescriptionIndexPresent = (tfhdFlags & 0x000002) !== 0;
                const defaultSampleDurationPresent = (tfhdFlags & 0x000008) !== 0;
                let defaultSampleDuration = 0;
                const defaultSampleSizePresent = (tfhdFlags & 0x000010) !== 0;
                let defaultSampleSize = 0;
                const defaultSampleFlagsPresent = (tfhdFlags & 0x000020) !== 0;
                let tfhdOffset = 8;
                if (id === trackId) {
                    if (baseDataOffsetPresent) tfhdOffset += 8;
                    if (sampleDescriptionIndexPresent) tfhdOffset += 4;
                    if (defaultSampleDurationPresent) {
                        defaultSampleDuration = $fada8102d2a280be$var$readUint32(tfhd, tfhdOffset);
                        tfhdOffset += 4;
                    }
                    if (defaultSampleSizePresent) {
                        defaultSampleSize = $fada8102d2a280be$var$readUint32(tfhd, tfhdOffset);
                        tfhdOffset += 4;
                    }
                    if (defaultSampleFlagsPresent) tfhdOffset += 4;
                    if (track.type === "video") isHEVCFlavor = $fada8102d2a280be$var$isHEVC(track.codec);
                    $fada8102d2a280be$var$findBox(traf, [
                        "trun"
                    ]).map((trun)=>{
                        const version = trun[0];
                        const flags = $fada8102d2a280be$var$readUint32(trun, 0) & 0xffffff;
                        const dataOffsetPresent = (flags & 0x000001) !== 0;
                        let dataOffset = 0;
                        const firstSampleFlagsPresent = (flags & 0x000004) !== 0;
                        const sampleDurationPresent = (flags & 0x000100) !== 0;
                        let sampleDuration = 0;
                        const sampleSizePresent = (flags & 0x000200) !== 0;
                        let sampleSize = 0;
                        const sampleFlagsPresent = (flags & 0x000400) !== 0;
                        const sampleCompositionOffsetsPresent = (flags & 0x000800) !== 0;
                        let compositionOffset = 0;
                        const sampleCount = $fada8102d2a280be$var$readUint32(trun, 4);
                        let trunOffset = 8; // past version, flags, and sample count
                        if (dataOffsetPresent) {
                            dataOffset = $fada8102d2a280be$var$readUint32(trun, trunOffset);
                            trunOffset += 4;
                        }
                        if (firstSampleFlagsPresent) trunOffset += 4;
                        let sampleOffset = dataOffset + moofOffset;
                        for(let ix = 0; ix < sampleCount; ix++){
                            if (sampleDurationPresent) {
                                sampleDuration = $fada8102d2a280be$var$readUint32(trun, trunOffset);
                                trunOffset += 4;
                            } else sampleDuration = defaultSampleDuration;
                            if (sampleSizePresent) {
                                sampleSize = $fada8102d2a280be$var$readUint32(trun, trunOffset);
                                trunOffset += 4;
                            } else sampleSize = defaultSampleSize;
                            if (sampleFlagsPresent) trunOffset += 4;
                            if (sampleCompositionOffsetsPresent) {
                                if (version === 0) compositionOffset = $fada8102d2a280be$var$readUint32(trun, trunOffset);
                                else compositionOffset = $fada8102d2a280be$var$readSint32(trun, trunOffset);
                                trunOffset += 4;
                            }
                            if (track.type === $fada8102d2a280be$var$ElementaryStreamTypes.VIDEO) {
                                let naluTotalSize = 0;
                                while(naluTotalSize < sampleSize){
                                    const naluSize = $fada8102d2a280be$var$readUint32(videoData, sampleOffset);
                                    sampleOffset += 4;
                                    if ($fada8102d2a280be$var$isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                                        const data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                                        $fada8102d2a280be$var$parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                                    }
                                    sampleOffset += naluSize;
                                    naluTotalSize += naluSize + 4;
                                }
                            }
                            timeOffset += sampleDuration / timescale;
                        }
                    });
                }
            });
        });
    });
    return seiSamples;
}
function $fada8102d2a280be$var$isHEVC(codec) {
    if (!codec) return false;
    const delimit = codec.indexOf(".");
    const baseCodec = delimit < 0 ? codec : codec.substring(0, delimit);
    return baseCodec === "hvc1" || baseCodec === "hev1" || // Dolby Vision
    baseCodec === "dvh1" || baseCodec === "dvhe";
}
function $fada8102d2a280be$var$isSEIMessage(isHEVCFlavor, naluHeader) {
    if (isHEVCFlavor) {
        const naluType = naluHeader >> 1 & 0x3f;
        return naluType === 39 || naluType === 40;
    } else {
        const naluType = naluHeader & 0x1f;
        return naluType === 6;
    }
}
function $fada8102d2a280be$var$parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
    const data = $fada8102d2a280be$var$discardEPB(unescapedData);
    let seiPtr = 0;
    // skip nal header
    seiPtr += headerSize;
    let payloadType = 0;
    let payloadSize = 0;
    let endOfCaptions = false;
    let b = 0;
    while(seiPtr < data.length){
        payloadType = 0;
        do {
            if (seiPtr >= data.length) break;
            b = data[seiPtr++];
            payloadType += b;
        }while (b === 0xff);
        // Parse payload size.
        payloadSize = 0;
        do {
            if (seiPtr >= data.length) break;
            b = data[seiPtr++];
            payloadSize += b;
        }while (b === 0xff);
        const leftOver = data.length - seiPtr;
        if (!endOfCaptions && payloadType === 4 && seiPtr < data.length) {
            endOfCaptions = true;
            const countryCode = data[seiPtr++];
            if (countryCode === 181) {
                const providerCode = $fada8102d2a280be$var$readUint16(data, seiPtr);
                seiPtr += 2;
                if (providerCode === 49) {
                    const userStructure = $fada8102d2a280be$var$readUint32(data, seiPtr);
                    seiPtr += 4;
                    if (userStructure === 0x47413934) {
                        const userDataType = data[seiPtr++];
                        // Raw CEA-608 bytes wrapped in CEA-708 packet
                        if (userDataType === 3) {
                            const firstByte = data[seiPtr++];
                            const totalCCs = 0x1f & firstByte;
                            const enabled = 0x40 & firstByte;
                            const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
                            const byteArray = new Uint8Array(totalBytes);
                            if (enabled) {
                                byteArray[0] = firstByte;
                                for(let i = 1; i < totalBytes; i++)byteArray[i] = data[seiPtr++];
                            }
                            samples.push({
                                type: userDataType,
                                payloadType: payloadType,
                                pts: pts,
                                bytes: byteArray
                            });
                        }
                    }
                }
            }
        } else if (payloadType === 5 && payloadSize < leftOver) {
            endOfCaptions = true;
            if (payloadSize > 16) {
                const uuidStrArray = [];
                for(let i = 0; i < 16; i++){
                    const _b = data[seiPtr++].toString(16);
                    uuidStrArray.push(_b.length == 1 ? "0" + _b : _b);
                    if (i === 3 || i === 5 || i === 7 || i === 9) uuidStrArray.push("-");
                }
                const length = payloadSize - 16;
                const userDataBytes = new Uint8Array(length);
                for(let i = 0; i < length; i++)userDataBytes[i] = data[seiPtr++];
                samples.push({
                    payloadType: payloadType,
                    pts: pts,
                    uuid: uuidStrArray.join(""),
                    userData: $fada8102d2a280be$var$utf8ArrayToStr(userDataBytes),
                    userDataBytes: userDataBytes
                });
            }
        } else if (payloadSize < leftOver) seiPtr += payloadSize;
        else if (payloadSize > leftOver) break;
    }
}
/**
 * remove Emulation Prevention bytes from a RBSP
 */ function $fada8102d2a280be$var$discardEPB(data) {
    const length = data.byteLength;
    const EPBPositions = [];
    let i = 1;
    // Find all `Emulation Prevention Bytes`
    while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
        EPBPositions.push(i + 2);
        i += 2;
    } else i++;
    // If no Emulation Prevention Bytes were found just return the original
    // array
    if (EPBPositions.length === 0) return data;
    // Create a new array to hold the NAL unit data
    const newLength = length - EPBPositions.length;
    const newData = new Uint8Array(newLength);
    let sourceIndex = 0;
    for(i = 0; i < newLength; sourceIndex++, i++){
        if (sourceIndex === EPBPositions[0]) {
            // Skip this byte
            sourceIndex++;
            // Remove this position index
            EPBPositions.shift();
        }
        newData[i] = data[sourceIndex];
    }
    return newData;
}
function $fada8102d2a280be$var$parseEmsg(data) {
    const version = data[0];
    let schemeIdUri = "";
    let value = "";
    let timeScale = 0;
    let presentationTimeDelta = 0;
    let presentationTime = 0;
    let eventDuration = 0;
    let id = 0;
    let offset = 0;
    if (version === 0) {
        while($fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1)) !== "\x00"){
            schemeIdUri += $fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        schemeIdUri += $fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        while($fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1)) !== "\x00"){
            value += $fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        value += $fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        timeScale = $fada8102d2a280be$var$readUint32(data, 12);
        presentationTimeDelta = $fada8102d2a280be$var$readUint32(data, 16);
        eventDuration = $fada8102d2a280be$var$readUint32(data, 20);
        id = $fada8102d2a280be$var$readUint32(data, 24);
        offset = 28;
    } else if (version === 1) {
        offset += 4;
        timeScale = $fada8102d2a280be$var$readUint32(data, offset);
        offset += 4;
        const leftPresentationTime = $fada8102d2a280be$var$readUint32(data, offset);
        offset += 4;
        const rightPresentationTime = $fada8102d2a280be$var$readUint32(data, offset);
        offset += 4;
        presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
        if (!Number.isSafeInteger(presentationTime)) {
            presentationTime = Number.MAX_SAFE_INTEGER;
            $fada8102d2a280be$var$logger.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box");
        }
        eventDuration = $fada8102d2a280be$var$readUint32(data, offset);
        offset += 4;
        id = $fada8102d2a280be$var$readUint32(data, offset);
        offset += 4;
        while($fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1)) !== "\x00"){
            schemeIdUri += $fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        schemeIdUri += $fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        while($fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1)) !== "\x00"){
            value += $fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        value += $fada8102d2a280be$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
    }
    const payload = data.subarray(offset, data.byteLength);
    return {
        schemeIdUri: schemeIdUri,
        value: value,
        timeScale: timeScale,
        presentationTime: presentationTime,
        presentationTimeDelta: presentationTimeDelta,
        eventDuration: eventDuration,
        id: id,
        payload: payload
    };
}
function $fada8102d2a280be$var$mp4Box(type, ...payload) {
    const len = payload.length;
    let size = 8;
    let i = len;
    while(i--)size += payload[i].byteLength;
    const result = new Uint8Array(size);
    result[0] = size >> 24 & 0xff;
    result[1] = size >> 16 & 0xff;
    result[2] = size >> 8 & 0xff;
    result[3] = size & 0xff;
    result.set(type, 4);
    for(i = 0, size = 8; i < len; i++){
        result.set(payload[i], size);
        size += payload[i].byteLength;
    }
    return result;
}
function $fada8102d2a280be$var$mp4pssh(systemId, keyids, data) {
    if (systemId.byteLength !== 16) throw new RangeError("Invalid system id");
    let version;
    let kids;
    if (keyids) {
        version = 1;
        kids = new Uint8Array(keyids.length * 16);
        for(let ix = 0; ix < keyids.length; ix++){
            const k = keyids[ix]; // uint8array
            if (k.byteLength !== 16) throw new RangeError("Invalid key");
            kids.set(k, ix * 16);
        }
    } else {
        version = 0;
        kids = new Uint8Array();
    }
    let kidCount;
    if (version > 0) {
        kidCount = new Uint8Array(4);
        if (keyids.length > 0) new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
    } else kidCount = new Uint8Array();
    const dataSize = new Uint8Array(4);
    if (data && data.byteLength > 0) new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
    return $fada8102d2a280be$var$mp4Box([
        112,
        115,
        115,
        104
    ], new Uint8Array([
        version,
        0x00,
        0x00,
        0x00 // Flags
    ]), systemId, // 16 bytes
    kidCount, kids, dataSize, data || new Uint8Array());
}
function $fada8102d2a280be$var$parsePssh(initData) {
    if (!(initData instanceof ArrayBuffer) || initData.byteLength < 32) return null;
    const result = {
        version: 0,
        systemId: "",
        kids: null,
        data: null
    };
    const view = new DataView(initData);
    const boxSize = view.getUint32(0);
    if (initData.byteLength !== boxSize && boxSize > 44) return null;
    const type = view.getUint32(4);
    if (type !== 0x70737368) return null;
    result.version = view.getUint32(8) >>> 24;
    if (result.version > 1) return null;
    result.systemId = $fada8102d2a280be$var$Hex.hexDump(new Uint8Array(initData, 12, 16));
    const dataSizeOrKidCount = view.getUint32(28);
    if (result.version === 0) {
        if (boxSize - 32 < dataSizeOrKidCount) return null;
        result.data = new Uint8Array(initData, 32, dataSizeOrKidCount);
    } else if (result.version === 1) {
        result.kids = [];
        for(let i = 0; i < dataSizeOrKidCount; i++)result.kids.push(new Uint8Array(initData, 32 + i * 16, 16));
    }
    return result;
}
let $fada8102d2a280be$var$keyUriToKeyIdMap = {};
class $fada8102d2a280be$var$LevelKey {
    static clearKeyUriToKeyIdMap() {
        $fada8102d2a280be$var$keyUriToKeyIdMap = {};
    }
    constructor(method, uri, format, formatversions = [
        1
    ], iv = null){
        this.uri = void 0;
        this.method = void 0;
        this.keyFormat = void 0;
        this.keyFormatVersions = void 0;
        this.encrypted = void 0;
        this.isCommonEncryption = void 0;
        this.iv = null;
        this.key = null;
        this.keyId = null;
        this.pssh = null;
        this.method = method;
        this.uri = uri;
        this.keyFormat = format;
        this.keyFormatVersions = formatversions;
        this.iv = iv;
        this.encrypted = method ? method !== "NONE" : false;
        this.isCommonEncryption = this.encrypted && method !== "AES-128";
    }
    isSupported() {
        // If it's Segment encryption or No encryption, just select that key system
        if (this.method) {
            if (this.method === "AES-128" || this.method === "NONE") return true;
            if (this.keyFormat === "identity") // Maintain support for clear SAMPLE-AES with MPEG-3 TS
            return this.method === "SAMPLE-AES";
            else switch(this.keyFormat){
                case $fada8102d2a280be$var$KeySystemFormats.FAIRPLAY:
                case $fada8102d2a280be$var$KeySystemFormats.WIDEVINE:
                case $fada8102d2a280be$var$KeySystemFormats.PLAYREADY:
                case $fada8102d2a280be$var$KeySystemFormats.CLEARKEY:
                    return [
                        "ISO-23001-7",
                        "SAMPLE-AES",
                        "SAMPLE-AES-CENC",
                        "SAMPLE-AES-CTR"
                    ].indexOf(this.method) !== -1;
            }
        }
        return false;
    }
    getDecryptData(sn) {
        if (!this.encrypted || !this.uri) return null;
        if (this.method === "AES-128" && this.uri && !this.iv) {
            if (typeof sn !== "number") {
                // We are fetching decryption data for a initialization segment
                // If the segment was encrypted with AES-128
                // It must have an IV defined. We cannot substitute the Segment Number in.
                if (this.method === "AES-128" && !this.iv) $fada8102d2a280be$var$logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);
                // Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
                sn = 0;
            }
            const iv = $fada8102d2a280be$var$createInitializationVector(sn);
            const decryptdata = new $fada8102d2a280be$var$LevelKey(this.method, this.uri, "identity", this.keyFormatVersions, iv);
            return decryptdata;
        }
        // Initialize keyId if possible
        const keyBytes = $fada8102d2a280be$var$convertDataUriToArrayBytes(this.uri);
        if (keyBytes) switch(this.keyFormat){
            case $fada8102d2a280be$var$KeySystemFormats.WIDEVINE:
                this.pssh = keyBytes;
                // In case of widevine keyID is embedded in PSSH box. Read Key ID.
                if (keyBytes.length >= 22) this.keyId = keyBytes.subarray(keyBytes.length - 22, keyBytes.length - 6);
                break;
            case $fada8102d2a280be$var$KeySystemFormats.PLAYREADY:
                {
                    const PlayReadyKeySystemUUID = new Uint8Array([
                        0x9a,
                        0x04,
                        0xf0,
                        0x79,
                        0x98,
                        0x40,
                        0x42,
                        0x86,
                        0xab,
                        0x92,
                        0xe6,
                        0x5b,
                        0xe0,
                        0x88,
                        0x5f,
                        0x95
                    ]);
                    this.pssh = $fada8102d2a280be$var$mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
                    const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
                    const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));
                    // Parse Playready WRMHeader XML
                    const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf("<"), keyByteStr.length);
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(xmlKeyBytes, "text/xml");
                    const keyData = xmlDoc.getElementsByTagName("KID")[0];
                    if (keyData) {
                        const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute("VALUE");
                        if (keyId) {
                            const keyIdArray = $fada8102d2a280be$var$base64Decode(keyId).subarray(0, 16);
                            // KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
                            // KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
                            $fada8102d2a280be$var$changeEndianness(keyIdArray);
                            this.keyId = keyIdArray;
                        }
                    }
                    break;
                }
            default:
                {
                    let keydata = keyBytes.subarray(0, 16);
                    if (keydata.length !== 16) {
                        const padded = new Uint8Array(16);
                        padded.set(keydata, 16 - keydata.length);
                        keydata = padded;
                    }
                    this.keyId = keydata;
                    break;
                }
        }
        // Default behavior: assign a new keyId for each uri
        if (!this.keyId || this.keyId.byteLength !== 16) {
            let keyId = $fada8102d2a280be$var$keyUriToKeyIdMap[this.uri];
            if (!keyId) {
                const val = Object.keys($fada8102d2a280be$var$keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
                keyId = new Uint8Array(16);
                const dv = new DataView(keyId.buffer, 12, 4); // Just set the last 4 bytes
                dv.setUint32(0, val);
                $fada8102d2a280be$var$keyUriToKeyIdMap[this.uri] = keyId;
            }
            this.keyId = keyId;
        }
        return this;
    }
}
function $fada8102d2a280be$var$createInitializationVector(segmentNumber) {
    const uint8View = new Uint8Array(16);
    for(let i = 12; i < 16; i++)uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
    return uint8View;
}
const $fada8102d2a280be$var$VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function $fada8102d2a280be$var$hasVariableReferences(str) {
    return $fada8102d2a280be$var$VARIABLE_REPLACEMENT_REGEX.test(str);
}
function $fada8102d2a280be$var$substituteVariablesInAttributes(parsed, attr, attributeNames) {
    if (parsed.variableList !== null || parsed.hasVariableRefs) for(let i = attributeNames.length; i--;){
        const name = attributeNames[i];
        const value = attr[name];
        if (value) attr[name] = $fada8102d2a280be$var$substituteVariables(parsed, value);
    }
}
function $fada8102d2a280be$var$substituteVariables(parsed, value) {
    if (parsed.variableList !== null || parsed.hasVariableRefs) {
        const variableList = parsed.variableList;
        return value.replace($fada8102d2a280be$var$VARIABLE_REPLACEMENT_REGEX, (variableReference)=>{
            const variableName = variableReference.substring(2, variableReference.length - 1);
            const variableValue = variableList == null ? void 0 : variableList[variableName];
            if (variableValue === undefined) {
                parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
                return variableReference;
            }
            return variableValue;
        });
    }
    return value;
}
function $fada8102d2a280be$var$addVariableDefinition(parsed, attr, parentUrl) {
    let variableList = parsed.variableList;
    if (!variableList) parsed.variableList = variableList = {};
    let NAME;
    let VALUE;
    if ("QUERYPARAM" in attr) {
        NAME = attr.QUERYPARAM;
        try {
            const searchParams = new self.URL(parentUrl).searchParams;
            if (searchParams.has(NAME)) VALUE = searchParams.get(NAME);
            else throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
        } catch (error) {
            parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
        }
    } else {
        NAME = attr.NAME;
        VALUE = attr.VALUE;
    }
    if (NAME in variableList) parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
    else variableList[NAME] = VALUE || "";
}
function $fada8102d2a280be$var$importVariableDefinition(parsed, attr, sourceVariableList) {
    const IMPORT = attr.IMPORT;
    if (sourceVariableList && IMPORT in sourceVariableList) {
        let variableList = parsed.variableList;
        if (!variableList) parsed.variableList = variableList = {};
        variableList[IMPORT] = sourceVariableList[IMPORT];
    } else parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
}
/**
 * MediaSource helper
 */ function $fada8102d2a280be$var$getMediaSource() {
    if (typeof self === "undefined") return undefined;
    return self.MediaSource || self.WebKitMediaSource;
}
// from http://mp4ra.org/codecs.html
const $fada8102d2a280be$var$sampleEntryCodesISO = {
    audio: {
        a3ds: true,
        "ac-3": true,
        "ac-4": true,
        alac: true,
        alaw: true,
        dra1: true,
        "dts+": true,
        "dts-": true,
        dtsc: true,
        dtse: true,
        dtsh: true,
        "ec-3": true,
        enca: true,
        g719: true,
        g726: true,
        m4ae: true,
        mha1: true,
        mha2: true,
        mhm1: true,
        mhm2: true,
        mlpa: true,
        mp4a: true,
        "raw ": true,
        Opus: true,
        opus: true,
        // browsers expect this to be lowercase despite MP4RA says 'Opus'
        samr: true,
        sawb: true,
        sawp: true,
        sevc: true,
        sqcp: true,
        ssmv: true,
        twos: true,
        ulaw: true
    },
    video: {
        avc1: true,
        avc2: true,
        avc3: true,
        avc4: true,
        avcp: true,
        av01: true,
        drac: true,
        dva1: true,
        dvav: true,
        dvh1: true,
        dvhe: true,
        encv: true,
        hev1: true,
        hvc1: true,
        mjp2: true,
        mp4v: true,
        mvc1: true,
        mvc2: true,
        mvc3: true,
        mvc4: true,
        resv: true,
        rv60: true,
        s263: true,
        svc1: true,
        svc2: true,
        "vc-1": true,
        vp08: true,
        vp09: true
    },
    text: {
        stpp: true,
        wvtt: true
    }
};
const $fada8102d2a280be$var$MediaSource$2 = $fada8102d2a280be$var$getMediaSource();
function $fada8102d2a280be$var$isCodecType(codec, type) {
    const typeCodes = $fada8102d2a280be$var$sampleEntryCodesISO[type];
    return !!typeCodes && typeCodes[codec.slice(0, 4)] === true;
}
function $fada8102d2a280be$var$isCodecSupportedInMp4(codec, type) {
    var _MediaSource$isTypeSu;
    return (_MediaSource$isTypeSu = $fada8102d2a280be$var$MediaSource$2 == null ? void 0 : $fada8102d2a280be$var$MediaSource$2.isTypeSupported(`${type || "video"}/mp4;codecs="${codec}"`)) != null ? _MediaSource$isTypeSu : false;
}
const $fada8102d2a280be$var$MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
const $fada8102d2a280be$var$MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
const $fada8102d2a280be$var$IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m; // Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)
const $fada8102d2a280be$var$LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
    // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
    /(?!#) *(\S[\S ]*)/.source,
    // segment URI, group 3 => the URI (note newline is not eaten)
    /#EXT-X-BYTERANGE:*(.+)/.source,
    // next segment's byterange, group 4 => range spec (x@y)
    /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
    // next segment's program date/time group 5 => the datetime spec
    /#.*/.source // All other non-segment oriented tags will match with all groups empty
].join("|"), "g");
const $fada8102d2a280be$var$LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([
    /#(EXTM3U)/.source,
    /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,
    /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,
    /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source,
    /(#)([^:]*):(.*)/.source,
    /(#)(.*)(?:.*)\r?\n?/.source
].join("|"));
class $fada8102d2a280be$var$M3U8Parser {
    static findGroup(groups, mediaGroupId) {
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            if (group.id === mediaGroupId) return group;
        }
    }
    static convertAVC1ToAVCOTI(codec) {
        // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
        const avcdata = codec.split(".");
        if (avcdata.length > 2) {
            let result = avcdata.shift() + ".";
            result += parseInt(avcdata.shift()).toString(16);
            result += ("000" + parseInt(avcdata.shift()).toString(16)).slice(-4);
            return result;
        }
        return codec;
    }
    static resolve(url, baseUrl) {
        return $fada8102d2a280be$var$urlToolkitExports.buildAbsoluteURL(baseUrl, url, {
            alwaysNormalize: true
        });
    }
    static isMediaPlaylist(str) {
        return $fada8102d2a280be$var$IS_MEDIA_PLAYLIST.test(str);
    }
    static parseMasterPlaylist(string, baseurl) {
        const hasVariableRefs = $fada8102d2a280be$var$hasVariableReferences(string);
        const parsed = {
            contentSteering: null,
            levels: [],
            playlistParsingError: null,
            sessionData: null,
            sessionKeys: null,
            startTimeOffset: null,
            variableList: null,
            hasVariableRefs: hasVariableRefs
        };
        const levelsWithKnownCodecs = [];
        $fada8102d2a280be$var$MASTER_PLAYLIST_REGEX.lastIndex = 0;
        let result;
        while((result = $fada8102d2a280be$var$MASTER_PLAYLIST_REGEX.exec(string)) != null){
            if (result[1]) {
                var _level$unknownCodecs;
                // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
                const attrs = new $fada8102d2a280be$var$AttrList(result[1]);
                $fada8102d2a280be$var$substituteVariablesInAttributes(parsed, attrs, [
                    "CODECS",
                    "SUPPLEMENTAL-CODECS",
                    "ALLOWED-CPC",
                    "PATHWAY-ID",
                    "STABLE-VARIANT-ID",
                    "AUDIO",
                    "VIDEO",
                    "SUBTITLES",
                    "CLOSED-CAPTIONS",
                    "NAME"
                ]);
                const uri = $fada8102d2a280be$var$substituteVariables(parsed, result[2]);
                const level = {
                    attrs: attrs,
                    bitrate: attrs.decimalInteger("AVERAGE-BANDWIDTH") || attrs.decimalInteger("BANDWIDTH"),
                    name: attrs.NAME,
                    url: $fada8102d2a280be$var$M3U8Parser.resolve(uri, baseurl)
                };
                const resolution = attrs.decimalResolution("RESOLUTION");
                if (resolution) {
                    level.width = resolution.width;
                    level.height = resolution.height;
                }
                $fada8102d2a280be$var$setCodecs((attrs.CODECS || "").split(/[ ,]+/).filter((c)=>c), level);
                if (level.videoCodec && level.videoCodec.indexOf("avc1") !== -1) level.videoCodec = $fada8102d2a280be$var$M3U8Parser.convertAVC1ToAVCOTI(level.videoCodec);
                if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) levelsWithKnownCodecs.push(level);
                parsed.levels.push(level);
            } else if (result[3]) {
                const tag = result[3];
                const attributes = result[4];
                switch(tag){
                    case "SESSION-DATA":
                        {
                            // #EXT-X-SESSION-DATA
                            const sessionAttrs = new $fada8102d2a280be$var$AttrList(attributes);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(parsed, sessionAttrs, [
                                "DATA-ID",
                                "LANGUAGE",
                                "VALUE",
                                "URI"
                            ]);
                            const dataId = sessionAttrs["DATA-ID"];
                            if (dataId) {
                                if (parsed.sessionData === null) parsed.sessionData = {};
                                parsed.sessionData[dataId] = sessionAttrs;
                            }
                            break;
                        }
                    case "SESSION-KEY":
                        {
                            // #EXT-X-SESSION-KEY
                            const sessionKey = $fada8102d2a280be$var$parseKey(attributes, baseurl, parsed);
                            if (sessionKey.encrypted && sessionKey.isSupported()) {
                                if (parsed.sessionKeys === null) parsed.sessionKeys = [];
                                parsed.sessionKeys.push(sessionKey);
                            } else $fada8102d2a280be$var$logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
                            break;
                        }
                    case "DEFINE":
                        // #EXT-X-DEFINE
                        {
                            const variableAttributes = new $fada8102d2a280be$var$AttrList(attributes);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(parsed, variableAttributes, [
                                "NAME",
                                "VALUE",
                                "QUERYPARAM"
                            ]);
                            $fada8102d2a280be$var$addVariableDefinition(parsed, variableAttributes, baseurl);
                        }
                        break;
                    case "CONTENT-STEERING":
                        {
                            // #EXT-X-CONTENT-STEERING
                            const contentSteeringAttributes = new $fada8102d2a280be$var$AttrList(attributes);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(parsed, contentSteeringAttributes, [
                                "SERVER-URI",
                                "PATHWAY-ID"
                            ]);
                            parsed.contentSteering = {
                                uri: $fada8102d2a280be$var$M3U8Parser.resolve(contentSteeringAttributes["SERVER-URI"], baseurl),
                                pathwayId: contentSteeringAttributes["PATHWAY-ID"] || "."
                            };
                            break;
                        }
                    case "START":
                        // #EXT-X-START
                        parsed.startTimeOffset = $fada8102d2a280be$var$parseStartTimeOffset(attributes);
                        break;
                }
            }
        }
        // Filter out levels with unknown codecs if it does not remove all levels
        const stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length;
        parsed.levels = stripUnknownCodecLevels ? levelsWithKnownCodecs : parsed.levels;
        if (parsed.levels.length === 0) parsed.playlistParsingError = new Error("no levels found in manifest");
        return parsed;
    }
    static parseMasterPlaylistMedia(string, baseurl, parsed) {
        let result;
        const results = {};
        const levels = parsed.levels;
        const groupsByType = {
            AUDIO: levels.map((level)=>({
                    id: level.attrs.AUDIO,
                    audioCodec: level.audioCodec
                })),
            SUBTITLES: levels.map((level)=>({
                    id: level.attrs.SUBTITLES,
                    textCodec: level.textCodec
                })),
            "CLOSED-CAPTIONS": []
        };
        let id = 0;
        $fada8102d2a280be$var$MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
        while((result = $fada8102d2a280be$var$MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null){
            const attrs = new $fada8102d2a280be$var$AttrList(result[1]);
            const type = attrs.TYPE;
            if (type) {
                const groups = groupsByType[type];
                const medias = results[type] || [];
                results[type] = medias;
                $fada8102d2a280be$var$substituteVariablesInAttributes(parsed, attrs, [
                    "URI",
                    "GROUP-ID",
                    "LANGUAGE",
                    "ASSOC-LANGUAGE",
                    "STABLE-RENDITION-ID",
                    "NAME",
                    "INSTREAM-ID",
                    "CHARACTERISTICS",
                    "CHANNELS"
                ]);
                const media = {
                    attrs: attrs,
                    bitrate: 0,
                    id: id++,
                    groupId: attrs["GROUP-ID"] || "",
                    instreamId: attrs["INSTREAM-ID"],
                    name: attrs.NAME || attrs.LANGUAGE || "",
                    type: type,
                    default: attrs.bool("DEFAULT"),
                    autoselect: attrs.bool("AUTOSELECT"),
                    forced: attrs.bool("FORCED"),
                    lang: attrs.LANGUAGE,
                    url: attrs.URI ? $fada8102d2a280be$var$M3U8Parser.resolve(attrs.URI, baseurl) : ""
                };
                if (groups != null && groups.length) {
                    // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
                    // If we don't find the track signalled, lets use the first audio groups codec we have
                    // Acting as a best guess
                    const groupCodec = $fada8102d2a280be$var$M3U8Parser.findGroup(groups, media.groupId) || groups[0];
                    $fada8102d2a280be$var$assignCodec(media, groupCodec, "audioCodec");
                    $fada8102d2a280be$var$assignCodec(media, groupCodec, "textCodec");
                }
                medias.push(media);
            }
        }
        return results;
    }
    static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
        const level = new $fada8102d2a280be$var$LevelDetails(baseurl);
        const fragments = level.fragments;
        // The most recent init segment seen (applies to all subsequent segments)
        let currentInitSegment = null;
        let currentSN = 0;
        let currentPart = 0;
        let totalduration = 0;
        let discontinuityCounter = 0;
        let prevFrag = null;
        let frag = new $fada8102d2a280be$var$Fragment(type, baseurl);
        let result;
        let i;
        let levelkeys;
        let firstPdtIndex = -1;
        let createNextFrag = false;
        $fada8102d2a280be$var$LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
        level.m3u8 = string;
        level.hasVariableRefs = $fada8102d2a280be$var$hasVariableReferences(string);
        while((result = $fada8102d2a280be$var$LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null){
            if (createNextFrag) {
                createNextFrag = false;
                frag = new $fada8102d2a280be$var$Fragment(type, baseurl);
                // setup the next fragment for part loading
                frag.start = totalduration;
                frag.sn = currentSN;
                frag.cc = discontinuityCounter;
                frag.level = id;
                if (currentInitSegment) {
                    frag.initSegment = currentInitSegment;
                    frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                    currentInitSegment.rawProgramDateTime = null;
                }
            }
            const duration = result[1];
            if (duration) {
                // INF
                frag.duration = parseFloat(duration);
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                const title = (" " + result[2]).slice(1);
                frag.title = title || null;
                frag.tagList.push(title ? [
                    "INF",
                    duration,
                    title
                ] : [
                    "INF",
                    duration
                ]);
            } else if (result[3]) // url
            {
                if ($fada8102d2a280be$var$isFiniteNumber(frag.duration)) {
                    frag.start = totalduration;
                    if (levelkeys) $fada8102d2a280be$var$setFragLevelKeys(frag, levelkeys, level);
                    frag.sn = currentSN;
                    frag.level = id;
                    frag.cc = discontinuityCounter;
                    frag.urlId = levelUrlId;
                    fragments.push(frag);
                    // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                    const uri = (" " + result[3]).slice(1);
                    frag.relurl = $fada8102d2a280be$var$substituteVariables(level, uri);
                    $fada8102d2a280be$var$assignProgramDateTime(frag, prevFrag);
                    prevFrag = frag;
                    totalduration += frag.duration;
                    currentSN++;
                    currentPart = 0;
                    createNextFrag = true;
                }
            } else if (result[4]) {
                // X-BYTERANGE
                const data = (" " + result[4]).slice(1);
                if (prevFrag) frag.setByteRange(data, prevFrag);
                else frag.setByteRange(data);
            } else if (result[5]) {
                // PROGRAM-DATE-TIME
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                frag.rawProgramDateTime = (" " + result[5]).slice(1);
                frag.tagList.push([
                    "PROGRAM-DATE-TIME",
                    frag.rawProgramDateTime
                ]);
                if (firstPdtIndex === -1) firstPdtIndex = fragments.length;
            } else {
                result = result[0].match($fada8102d2a280be$var$LEVEL_PLAYLIST_REGEX_SLOW);
                if (!result) {
                    $fada8102d2a280be$var$logger.warn("No matches on slow regex match for level playlist!");
                    continue;
                }
                for(i = 1; i < result.length; i++){
                    if (typeof result[i] !== "undefined") break;
                }
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                const tag = (" " + result[i]).slice(1);
                const value1 = (" " + result[i + 1]).slice(1);
                const value2 = result[i + 2] ? (" " + result[i + 2]).slice(1) : "";
                switch(tag){
                    case "PLAYLIST-TYPE":
                        level.type = value1.toUpperCase();
                        break;
                    case "MEDIA-SEQUENCE":
                        currentSN = level.startSN = parseInt(value1);
                        break;
                    case "SKIP":
                        {
                            const skipAttrs = new $fada8102d2a280be$var$AttrList(value1);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(level, skipAttrs, [
                                "RECENTLY-REMOVED-DATERANGES"
                            ]);
                            const skippedSegments = skipAttrs.decimalInteger("SKIPPED-SEGMENTS");
                            if ($fada8102d2a280be$var$isFiniteNumber(skippedSegments)) {
                                level.skippedSegments = skippedSegments;
                                // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                                for(let _i = skippedSegments; _i--;)fragments.unshift(null);
                                currentSN += skippedSegments;
                            }
                            const recentlyRemovedDateranges = skipAttrs.enumeratedString("RECENTLY-REMOVED-DATERANGES");
                            if (recentlyRemovedDateranges) level.recentlyRemovedDateranges = recentlyRemovedDateranges.split("	");
                            break;
                        }
                    case "TARGETDURATION":
                        level.targetduration = Math.max(parseInt(value1), 1);
                        break;
                    case "VERSION":
                        level.version = parseInt(value1);
                        break;
                    case "EXTM3U":
                        break;
                    case "ENDLIST":
                        level.live = false;
                        break;
                    case "#":
                        if (value1 || value2) frag.tagList.push(value2 ? [
                            value1,
                            value2
                        ] : [
                            value1
                        ]);
                        break;
                    case "DISCONTINUITY":
                        discontinuityCounter++;
                        frag.tagList.push([
                            "DIS"
                        ]);
                        break;
                    case "GAP":
                        frag.gap = true;
                        frag.tagList.push([
                            tag
                        ]);
                        break;
                    case "BITRATE":
                        frag.tagList.push([
                            tag,
                            value1
                        ]);
                        break;
                    case "DATERANGE":
                        {
                            const dateRangeAttr = new $fada8102d2a280be$var$AttrList(value1);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(level, dateRangeAttr, [
                                "ID",
                                "CLASS",
                                "START-DATE",
                                "END-DATE",
                                "SCTE35-CMD",
                                "SCTE35-OUT",
                                "SCTE35-IN"
                            ]);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(level, dateRangeAttr, dateRangeAttr.clientAttrs);
                            const dateRange = new $fada8102d2a280be$var$DateRange(dateRangeAttr, level.dateRanges[dateRangeAttr.ID]);
                            if (dateRange.isValid || level.skippedSegments) level.dateRanges[dateRange.id] = dateRange;
                            else $fada8102d2a280be$var$logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
                            // Add to fragment tag list for backwards compatibility (< v1.2.0)
                            frag.tagList.push([
                                "EXT-X-DATERANGE",
                                value1
                            ]);
                            break;
                        }
                    case "DEFINE":
                        {
                            const variableAttributes = new $fada8102d2a280be$var$AttrList(value1);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(level, variableAttributes, [
                                "NAME",
                                "VALUE",
                                "IMPORT",
                                "QUERYPARAM"
                            ]);
                            if ("IMPORT" in variableAttributes) $fada8102d2a280be$var$importVariableDefinition(level, variableAttributes, multivariantVariableList);
                            else $fada8102d2a280be$var$addVariableDefinition(level, variableAttributes, baseurl);
                        }
                        break;
                    case "DISCONTINUITY-SEQUENCE":
                        discontinuityCounter = parseInt(value1);
                        break;
                    case "KEY":
                        {
                            const levelKey = $fada8102d2a280be$var$parseKey(value1, baseurl, level);
                            if (levelKey.isSupported()) {
                                if (levelKey.method === "NONE") {
                                    levelkeys = undefined;
                                    break;
                                }
                                if (!levelkeys) levelkeys = {};
                                if (levelkeys[levelKey.keyFormat]) levelkeys = $fada8102d2a280be$var$_extends({}, levelkeys);
                                levelkeys[levelKey.keyFormat] = levelKey;
                            } else $fada8102d2a280be$var$logger.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${value1}"`);
                            break;
                        }
                    case "START":
                        level.startTimeOffset = $fada8102d2a280be$var$parseStartTimeOffset(value1);
                        break;
                    case "MAP":
                        {
                            const mapAttrs = new $fada8102d2a280be$var$AttrList(value1);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(level, mapAttrs, [
                                "BYTERANGE",
                                "URI"
                            ]);
                            if (frag.duration) {
                                // Initial segment tag is after segment duration tag.
                                //   #EXTINF: 6.0
                                //   #EXT-X-MAP:URI="init.mp4
                                const init = new $fada8102d2a280be$var$Fragment(type, baseurl);
                                $fada8102d2a280be$var$setInitSegment(init, mapAttrs, id, levelkeys);
                                currentInitSegment = init;
                                frag.initSegment = currentInitSegment;
                                if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                            } else {
                                // Initial segment tag is before segment duration tag
                                $fada8102d2a280be$var$setInitSegment(frag, mapAttrs, id, levelkeys);
                                currentInitSegment = frag;
                                createNextFrag = true;
                            }
                            break;
                        }
                    case "SERVER-CONTROL":
                        {
                            const serverControlAttrs = new $fada8102d2a280be$var$AttrList(value1);
                            level.canBlockReload = serverControlAttrs.bool("CAN-BLOCK-RELOAD");
                            level.canSkipUntil = serverControlAttrs.optionalFloat("CAN-SKIP-UNTIL", 0);
                            level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool("CAN-SKIP-DATERANGES");
                            level.partHoldBack = serverControlAttrs.optionalFloat("PART-HOLD-BACK", 0);
                            level.holdBack = serverControlAttrs.optionalFloat("HOLD-BACK", 0);
                            break;
                        }
                    case "PART-INF":
                        {
                            const partInfAttrs = new $fada8102d2a280be$var$AttrList(value1);
                            level.partTarget = partInfAttrs.decimalFloatingPoint("PART-TARGET");
                            break;
                        }
                    case "PART":
                        {
                            let partList = level.partList;
                            if (!partList) partList = level.partList = [];
                            const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
                            const index = currentPart++;
                            const partAttrs = new $fada8102d2a280be$var$AttrList(value1);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(level, partAttrs, [
                                "BYTERANGE",
                                "URI"
                            ]);
                            const part = new $fada8102d2a280be$var$Part(partAttrs, frag, baseurl, index, previousFragmentPart);
                            partList.push(part);
                            frag.duration += part.duration;
                            break;
                        }
                    case "PRELOAD-HINT":
                        {
                            const preloadHintAttrs = new $fada8102d2a280be$var$AttrList(value1);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(level, preloadHintAttrs, [
                                "URI"
                            ]);
                            level.preloadHint = preloadHintAttrs;
                            break;
                        }
                    case "RENDITION-REPORT":
                        {
                            const renditionReportAttrs = new $fada8102d2a280be$var$AttrList(value1);
                            $fada8102d2a280be$var$substituteVariablesInAttributes(level, renditionReportAttrs, [
                                "URI"
                            ]);
                            level.renditionReports = level.renditionReports || [];
                            level.renditionReports.push(renditionReportAttrs);
                            break;
                        }
                    default:
                        $fada8102d2a280be$var$logger.warn(`line parsed but not handled: ${result}`);
                        break;
                }
            }
        }
        if (prevFrag && !prevFrag.relurl) {
            fragments.pop();
            totalduration -= prevFrag.duration;
            if (level.partList) level.fragmentHint = prevFrag;
        } else if (level.partList) {
            $fada8102d2a280be$var$assignProgramDateTime(frag, prevFrag);
            frag.cc = discontinuityCounter;
            level.fragmentHint = frag;
            if (levelkeys) $fada8102d2a280be$var$setFragLevelKeys(frag, levelkeys, level);
        }
        const fragmentLength = fragments.length;
        const firstFragment = fragments[0];
        const lastFragment = fragments[fragmentLength - 1];
        totalduration += level.skippedSegments * level.targetduration;
        if (totalduration > 0 && fragmentLength && lastFragment) {
            level.averagetargetduration = totalduration / fragmentLength;
            const lastSn = lastFragment.sn;
            level.endSN = lastSn !== "initSegment" ? lastSn : 0;
            if (!level.live) lastFragment.endList = true;
            if (firstFragment) level.startCC = firstFragment.cc;
        } else {
            level.endSN = 0;
            level.startCC = 0;
        }
        if (level.fragmentHint) totalduration += level.fragmentHint.duration;
        level.totalduration = totalduration;
        level.endCC = discontinuityCounter;
        /**
     * Backfill any missing PDT values
     * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
     * one or more Media Segment URIs, the client SHOULD extrapolate
     * backward from that tag (using EXTINF durations and/or media
     * timestamps) to associate dates with those segments."
     * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
     * computed.
     */ if (firstPdtIndex > 0) $fada8102d2a280be$var$backfillProgramDateTimes(fragments, firstPdtIndex);
        return level;
    }
}
function $fada8102d2a280be$var$parseKey(keyTagAttributes, baseurl, parsed) {
    var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
    // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
    const keyAttrs = new $fada8102d2a280be$var$AttrList(keyTagAttributes);
    $fada8102d2a280be$var$substituteVariablesInAttributes(parsed, keyAttrs, [
        "KEYFORMAT",
        "KEYFORMATVERSIONS",
        "URI",
        "IV",
        "URI"
    ]);
    const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : "";
    const decrypturi = keyAttrs.URI;
    const decryptiv = keyAttrs.hexadecimalInteger("IV");
    const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
    // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
    const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : "identity";
    if (decrypturi && keyAttrs.IV && !decryptiv) $fada8102d2a280be$var$logger.error(`Invalid IV: ${keyAttrs.IV}`);
    // If decrypturi is a URI with a scheme, then baseurl will be ignored
    // No uri is allowed when METHOD is NONE
    const resolvedUri = decrypturi ? $fada8102d2a280be$var$M3U8Parser.resolve(decrypturi, baseurl) : "";
    const keyFormatVersions = (decryptkeyformatversions ? decryptkeyformatversions : "1").split("/").map(Number).filter(Number.isFinite);
    return new $fada8102d2a280be$var$LevelKey(decryptmethod, resolvedUri, decryptkeyformat, keyFormatVersions, decryptiv);
}
function $fada8102d2a280be$var$parseStartTimeOffset(startAttributes) {
    const startAttrs = new $fada8102d2a280be$var$AttrList(startAttributes);
    const startTimeOffset = startAttrs.decimalFloatingPoint("TIME-OFFSET");
    if ($fada8102d2a280be$var$isFiniteNumber(startTimeOffset)) return startTimeOffset;
    return null;
}
function $fada8102d2a280be$var$setCodecs(codecs, level) {
    [
        "video",
        "audio",
        "text"
    ].forEach((type)=>{
        const filtered = codecs.filter((codec)=>$fada8102d2a280be$var$isCodecType(codec, type));
        if (filtered.length) {
            const preferred = filtered.filter((codec)=>{
                return codec.lastIndexOf("avc1", 0) === 0 || codec.lastIndexOf("mp4a", 0) === 0;
            });
            level[`${type}Codec`] = preferred.length > 0 ? preferred[0] : filtered[0];
            // remove from list
            codecs = codecs.filter((codec)=>filtered.indexOf(codec) === -1);
        }
    });
    level.unknownCodecs = codecs;
}
function $fada8102d2a280be$var$assignCodec(media, groupItem, codecProperty) {
    const codecValue = groupItem[codecProperty];
    if (codecValue) media[codecProperty] = codecValue;
}
function $fada8102d2a280be$var$backfillProgramDateTimes(fragments, firstPdtIndex) {
    let fragPrev = fragments[firstPdtIndex];
    for(let i = firstPdtIndex; i--;){
        const frag = fragments[i];
        // Exit on delta-playlist skipped segments
        if (!frag) return;
        frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
        fragPrev = frag;
    }
}
function $fada8102d2a280be$var$assignProgramDateTime(frag, prevFrag) {
    if (frag.rawProgramDateTime) frag.programDateTime = Date.parse(frag.rawProgramDateTime);
    else if (prevFrag != null && prevFrag.programDateTime) frag.programDateTime = prevFrag.endProgramDateTime;
    if (!$fada8102d2a280be$var$isFiniteNumber(frag.programDateTime)) {
        frag.programDateTime = null;
        frag.rawProgramDateTime = null;
    }
}
function $fada8102d2a280be$var$setInitSegment(frag, mapAttrs, id, levelkeys) {
    frag.relurl = mapAttrs.URI;
    if (mapAttrs.BYTERANGE) frag.setByteRange(mapAttrs.BYTERANGE);
    frag.level = id;
    frag.sn = "initSegment";
    if (levelkeys) frag.levelkeys = levelkeys;
    frag.initSegment = null;
}
function $fada8102d2a280be$var$setFragLevelKeys(frag, levelkeys, level) {
    frag.levelkeys = levelkeys;
    const { encryptedFragments: encryptedFragments } = level;
    if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some((format)=>levelkeys[format].isCommonEncryption)) encryptedFragments.push(frag);
}
var $fada8102d2a280be$var$PlaylistContextType = {
    MANIFEST: "manifest",
    LEVEL: "level",
    AUDIO_TRACK: "audioTrack",
    SUBTITLE_TRACK: "subtitleTrack"
};
var $fada8102d2a280be$var$PlaylistLevelType = {
    MAIN: "main",
    AUDIO: "audio",
    SUBTITLE: "subtitle"
};
function $fada8102d2a280be$var$mapContextToLevelType(context) {
    const { type: type } = context;
    switch(type){
        case $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK:
            return $fada8102d2a280be$var$PlaylistLevelType.AUDIO;
        case $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK:
            return $fada8102d2a280be$var$PlaylistLevelType.SUBTITLE;
        default:
            return $fada8102d2a280be$var$PlaylistLevelType.MAIN;
    }
}
function $fada8102d2a280be$var$getResponseUrl(response, context) {
    let url = response.url;
    // responseURL not supported on some browsers (it is used to detect URL redirection)
    // data-uri mode also not supported (but no need to detect redirection)
    if (url === undefined || url.indexOf("data:") === 0) // fallback to initial URL
    url = context.url;
    return url;
}
class $fada8102d2a280be$var$PlaylistLoader {
    constructor(hls){
        this.hls = void 0;
        this.loaders = Object.create(null);
        this.variableList = null;
        this.hls = hls;
        this.registerListeners();
    }
    startLoad(startPosition) {}
    stopLoad() {
        this.destroyInternalLoaders();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
        hls.on($fada8102d2a280be$var$Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
        hls.off($fada8102d2a280be$var$Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
    }
    /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */ createInternalLoader(context) {
        const config = this.hls.config;
        const PLoader = config.pLoader;
        const Loader = config.loader;
        const InternalLoader = PLoader || Loader;
        const loader = new InternalLoader(config);
        this.loaders[context.type] = loader;
        return loader;
    }
    getInternalLoader(context) {
        return this.loaders[context.type];
    }
    resetInternalLoader(contextType) {
        if (this.loaders[contextType]) delete this.loaders[contextType];
    }
    /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */ destroyInternalLoaders() {
        for(const contextType in this.loaders){
            const loader = this.loaders[contextType];
            if (loader) loader.destroy();
            this.resetInternalLoader(contextType);
        }
    }
    destroy() {
        this.variableList = null;
        this.unregisterListeners();
        this.destroyInternalLoaders();
    }
    onManifestLoading(event, data) {
        const { url: url } = data;
        this.variableList = null;
        this.load({
            id: null,
            level: 0,
            responseType: "text",
            type: $fada8102d2a280be$var$PlaylistContextType.MANIFEST,
            url: url,
            deliveryDirectives: null
        });
    }
    onLevelLoading(event, data) {
        const { id: id, level: level, url: url, deliveryDirectives: deliveryDirectives } = data;
        this.load({
            id: id,
            level: level,
            responseType: "text",
            type: $fada8102d2a280be$var$PlaylistContextType.LEVEL,
            url: url,
            deliveryDirectives: deliveryDirectives
        });
    }
    onAudioTrackLoading(event, data) {
        const { id: id, groupId: groupId, url: url, deliveryDirectives: deliveryDirectives } = data;
        this.load({
            id: id,
            groupId: groupId,
            level: null,
            responseType: "text",
            type: $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK,
            url: url,
            deliveryDirectives: deliveryDirectives
        });
    }
    onSubtitleTrackLoading(event, data) {
        const { id: id, groupId: groupId, url: url, deliveryDirectives: deliveryDirectives } = data;
        this.load({
            id: id,
            groupId: groupId,
            level: null,
            responseType: "text",
            type: $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK,
            url: url,
            deliveryDirectives: deliveryDirectives
        });
    }
    load(context) {
        var _context$deliveryDire;
        const config = this.hls.config;
        // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);
        // Check if a loader for this context already exists
        let loader = this.getInternalLoader(context);
        if (loader) {
            const loaderContext = loader.context;
            if (loaderContext && loaderContext.url === context.url) {
                // same URL can't overlap
                $fada8102d2a280be$var$logger.trace("[playlist-loader]: playlist request ongoing");
                return;
            }
            $fada8102d2a280be$var$logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
            loader.abort();
        }
        // apply different configs for retries depending on
        // context (manifest, level, audio/subs playlist)
        let loadPolicy;
        if (context.type === $fada8102d2a280be$var$PlaylistContextType.MANIFEST) loadPolicy = config.manifestLoadPolicy.default;
        else loadPolicy = $fada8102d2a280be$var$_extends({}, config.playlistLoadPolicy.default, {
            timeoutRetry: null,
            errorRetry: null
        });
        loader = this.createInternalLoader(context);
        // Override level/track timeout for LL-HLS requests
        // (the default of 10000ms is counter productive to blocking playlist reload requests)
        if ((_context$deliveryDire = context.deliveryDirectives) != null && _context$deliveryDire.part) {
            let levelDetails;
            if (context.type === $fada8102d2a280be$var$PlaylistContextType.LEVEL && context.level !== null) levelDetails = this.hls.levels[context.level].details;
            else if (context.type === $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK && context.id !== null) levelDetails = this.hls.audioTracks[context.id].details;
            else if (context.type === $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK && context.id !== null) levelDetails = this.hls.subtitleTracks[context.id].details;
            if (levelDetails) {
                const partTarget = levelDetails.partTarget;
                const targetDuration = levelDetails.targetduration;
                if (partTarget && targetDuration) {
                    const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * 0.8) * 1000;
                    loadPolicy = $fada8102d2a280be$var$_extends({}, loadPolicy, {
                        maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
                        maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
                    });
                }
            }
        }
        const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
        const loaderConfig = {
            loadPolicy: loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
            retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
            maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
        };
        const loaderCallbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                const loader = this.getInternalLoader(context);
                this.resetInternalLoader(context.type);
                const string = response.data;
                // Validate if it is an M3U8 at all
                if (string.indexOf("#EXTM3U") !== 0) {
                    this.handleManifestParsingError(response, context, new Error("no EXTM3U delimiter"), networkDetails || null, stats);
                    return;
                }
                stats.parsing.start = performance.now();
                if ($fada8102d2a280be$var$M3U8Parser.isMediaPlaylist(string)) this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
                else this.handleMasterPlaylist(response, stats, context, networkDetails);
            },
            onError: (response, context, networkDetails, stats)=>{
                this.handleNetworkError(context, networkDetails, false, response, stats);
            },
            onTimeout: (stats, context, networkDetails)=>{
                this.handleNetworkError(context, networkDetails, true, undefined, stats);
            }
        };
        // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);
        loader.load(context, loaderConfig, loaderCallbacks);
    }
    handleMasterPlaylist(response, stats, context, networkDetails) {
        const hls = this.hls;
        const string = response.data;
        const url = $fada8102d2a280be$var$getResponseUrl(response, context);
        const parsedResult = $fada8102d2a280be$var$M3U8Parser.parseMasterPlaylist(string, url);
        if (parsedResult.playlistParsingError) {
            this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
            return;
        }
        const { contentSteering: contentSteering, levels: levels, sessionData: sessionData, sessionKeys: sessionKeys, startTimeOffset: startTimeOffset, variableList: variableList } = parsedResult;
        this.variableList = variableList;
        const { AUDIO: audioTracks = [], SUBTITLES: subtitles, "CLOSED-CAPTIONS": captions } = $fada8102d2a280be$var$M3U8Parser.parseMasterPlaylistMedia(string, url, parsedResult);
        if (audioTracks.length) {
            // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
            const embeddedAudioFound = audioTracks.some((audioTrack)=>!audioTrack.url);
            // if no embedded audio track defined, but audio codec signaled in quality level,
            // we need to signal this main audio track this could happen with playlists with
            // alt audio rendition in which quality levels (main)
            // contains both audio+video. but with mixed audio track not signaled
            if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                $fada8102d2a280be$var$logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one");
                audioTracks.unshift({
                    type: "main",
                    name: "main",
                    groupId: "main",
                    default: false,
                    autoselect: false,
                    forced: false,
                    id: -1,
                    attrs: new $fada8102d2a280be$var$AttrList({}),
                    bitrate: 0,
                    url: ""
                });
            }
        }
        hls.trigger($fada8102d2a280be$var$Events.MANIFEST_LOADED, {
            levels: levels,
            audioTracks: audioTracks,
            subtitles: subtitles,
            captions: captions,
            contentSteering: contentSteering,
            url: url,
            stats: stats,
            networkDetails: networkDetails,
            sessionData: sessionData,
            sessionKeys: sessionKeys,
            startTimeOffset: startTimeOffset,
            variableList: variableList
        });
    }
    handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
        const hls = this.hls;
        const { id: id, level: level, type: type } = context;
        const url = $fada8102d2a280be$var$getResponseUrl(response, context);
        const levelUrlId = $fada8102d2a280be$var$isFiniteNumber(id) ? id : 0;
        const levelId = $fada8102d2a280be$var$isFiniteNumber(level) ? level : levelUrlId;
        const levelType = $fada8102d2a280be$var$mapContextToLevelType(context);
        const levelDetails = $fada8102d2a280be$var$M3U8Parser.parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId, this.variableList);
        // We have done our first request (Manifest-type) and receive
        // not a master playlist but a chunk-list (track/level)
        // We fire the manifest-loaded event anyway with the parsed level-details
        // by creating a single-level structure for it.
        if (type === $fada8102d2a280be$var$PlaylistContextType.MANIFEST) {
            const singleLevel = {
                attrs: new $fada8102d2a280be$var$AttrList({}),
                bitrate: 0,
                details: levelDetails,
                name: "",
                url: url
            };
            hls.trigger($fada8102d2a280be$var$Events.MANIFEST_LOADED, {
                levels: [
                    singleLevel
                ],
                audioTracks: [],
                url: url,
                stats: stats,
                networkDetails: networkDetails,
                sessionData: null,
                sessionKeys: null,
                contentSteering: null,
                startTimeOffset: null,
                variableList: null
            });
        }
        // save parsing time
        stats.parsing.end = performance.now();
        // extend the context with the new levelDetails property
        context.levelDetails = levelDetails;
        this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
    }
    handleManifestParsingError(response, context, error, networkDetails, stats) {
        this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
            type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
            details: $fada8102d2a280be$var$ErrorDetails.MANIFEST_PARSING_ERROR,
            fatal: context.type === $fada8102d2a280be$var$PlaylistContextType.MANIFEST,
            url: response.url,
            err: error,
            error: error,
            reason: error.message,
            response: response,
            context: context,
            networkDetails: networkDetails,
            stats: stats
        });
    }
    handleNetworkError(context, networkDetails, timeout = false, response, stats) {
        let message = `A network ${timeout ? "timeout" : "error" + (response ? " (status " + response.code + ")" : "")} occurred while loading ${context.type}`;
        if (context.type === $fada8102d2a280be$var$PlaylistContextType.LEVEL) message += `: ${context.level} id: ${context.id}`;
        else if (context.type === $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK || context.type === $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK) message += ` id: ${context.id} group-id: "${context.groupId}"`;
        const error = new Error(message);
        $fada8102d2a280be$var$logger.warn(`[playlist-loader]: ${message}`);
        let details = $fada8102d2a280be$var$ErrorDetails.UNKNOWN;
        let fatal = false;
        const loader = this.getInternalLoader(context);
        switch(context.type){
            case $fada8102d2a280be$var$PlaylistContextType.MANIFEST:
                details = timeout ? $fada8102d2a280be$var$ErrorDetails.MANIFEST_LOAD_TIMEOUT : $fada8102d2a280be$var$ErrorDetails.MANIFEST_LOAD_ERROR;
                fatal = true;
                break;
            case $fada8102d2a280be$var$PlaylistContextType.LEVEL:
                details = timeout ? $fada8102d2a280be$var$ErrorDetails.LEVEL_LOAD_TIMEOUT : $fada8102d2a280be$var$ErrorDetails.LEVEL_LOAD_ERROR;
                fatal = false;
                break;
            case $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK:
                details = timeout ? $fada8102d2a280be$var$ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : $fada8102d2a280be$var$ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
                fatal = false;
                break;
            case $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK:
                details = timeout ? $fada8102d2a280be$var$ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : $fada8102d2a280be$var$ErrorDetails.SUBTITLE_LOAD_ERROR;
                fatal = false;
                break;
        }
        if (loader) this.resetInternalLoader(context.type);
        const errorData = {
            type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
            details: details,
            fatal: fatal,
            url: context.url,
            loader: loader,
            context: context,
            error: error,
            networkDetails: networkDetails,
            stats: stats
        };
        if (response) {
            const url = (networkDetails == null ? void 0 : networkDetails.url) || context.url;
            errorData.response = $fada8102d2a280be$var$_objectSpread2({
                url: url,
                data: undefined
            }, response);
        }
        this.hls.trigger($fada8102d2a280be$var$Events.ERROR, errorData);
    }
    handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
        const hls = this.hls;
        const { type: type, level: level, id: id, groupId: groupId, deliveryDirectives: deliveryDirectives } = context;
        const url = $fada8102d2a280be$var$getResponseUrl(response, context);
        const parent = $fada8102d2a280be$var$mapContextToLevelType(context);
        const levelIndex = typeof context.level === "number" && parent === $fada8102d2a280be$var$PlaylistLevelType.MAIN ? level : undefined;
        if (!levelDetails.fragments.length) {
            const _error = new Error("No Segments found in Playlist");
            hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.LEVEL_EMPTY_ERROR,
                fatal: false,
                url: url,
                error: _error,
                reason: _error.message,
                response: response,
                context: context,
                level: levelIndex,
                parent: parent,
                networkDetails: networkDetails,
                stats: stats
            });
            return;
        }
        if (!levelDetails.targetduration) levelDetails.playlistParsingError = new Error("Missing Target Duration");
        const error = levelDetails.playlistParsingError;
        if (error) {
            hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.LEVEL_PARSING_ERROR,
                fatal: false,
                url: url,
                error: error,
                reason: error.message,
                response: response,
                context: context,
                level: levelIndex,
                parent: parent,
                networkDetails: networkDetails,
                stats: stats
            });
            return;
        }
        if (levelDetails.live && loader) {
            if (loader.getCacheAge) levelDetails.ageHeader = loader.getCacheAge() || 0;
            if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) levelDetails.ageHeader = 0;
        }
        switch(type){
            case $fada8102d2a280be$var$PlaylistContextType.MANIFEST:
            case $fada8102d2a280be$var$PlaylistContextType.LEVEL:
                hls.trigger($fada8102d2a280be$var$Events.LEVEL_LOADED, {
                    details: levelDetails,
                    level: levelIndex || 0,
                    id: id || 0,
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives
                });
                break;
            case $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK:
                hls.trigger($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADED, {
                    details: levelDetails,
                    id: id || 0,
                    groupId: groupId || "",
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives
                });
                break;
            case $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK:
                hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_TRACK_LOADED, {
                    details: levelDetails,
                    id: id || 0,
                    groupId: groupId || "",
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives
                });
                break;
        }
    }
}
function $fada8102d2a280be$var$sendAddTrackEvent(track, videoEl) {
    let event;
    try {
        event = new Event("addtrack");
    } catch (err) {
        // for IE11
        event = document.createEvent("Event");
        event.initEvent("addtrack", false, false);
    }
    event.track = track;
    videoEl.dispatchEvent(event);
}
function $fada8102d2a280be$var$addCueToTrack(track, cue) {
    // Sometimes there are cue overlaps on segmented vtts so the same
    // cue can appear more than once in different vtt files.
    // This avoid showing duplicated cues with same timecode and text.
    const mode = track.mode;
    if (mode === "disabled") track.mode = "hidden";
    if (track.cues && !track.cues.getCueById(cue.id)) try {
        track.addCue(cue);
        if (!track.cues.getCueById(cue.id)) throw new Error(`addCue is failed for: ${cue}`);
    } catch (err) {
        $fada8102d2a280be$var$logger.debug(`[texttrack-utils]: ${err}`);
        const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
        textTrackCue.id = cue.id;
        track.addCue(textTrackCue);
    }
    if (mode === "disabled") track.mode = mode;
}
function $fada8102d2a280be$var$clearCurrentCues(track) {
    // When track.mode is disabled, track.cues will be null.
    // To guarantee the removal of cues, we need to temporarily
    // change the mode to hidden
    const mode = track.mode;
    if (mode === "disabled") track.mode = "hidden";
    if (track.cues) for(let i = track.cues.length; i--;)track.removeCue(track.cues[i]);
    if (mode === "disabled") track.mode = mode;
}
function $fada8102d2a280be$var$removeCuesInRange(track, start, end, predicate) {
    const mode = track.mode;
    if (mode === "disabled") track.mode = "hidden";
    if (track.cues && track.cues.length > 0) {
        const cues = $fada8102d2a280be$var$getCuesInRange(track.cues, start, end);
        for(let i = 0; i < cues.length; i++)if (!predicate || predicate(cues[i])) track.removeCue(cues[i]);
    }
    if (mode === "disabled") track.mode = mode;
}
// Find first cue starting after given time.
// Modified version of binary search O(log(n)).
function $fada8102d2a280be$var$getFirstCueIndexAfterTime(cues, time) {
    // If first cue starts after time, start there
    if (time < cues[0].startTime) return 0;
    // If the last cue ends before time there is no overlap
    const len = cues.length - 1;
    if (time > cues[len].endTime) return -1;
    let left = 0;
    let right = len;
    while(left <= right){
        const mid = Math.floor((right + left) / 2);
        if (time < cues[mid].startTime) right = mid - 1;
        else if (time > cues[mid].startTime && left < len) left = mid + 1;
        else // If it's not lower or higher, it must be equal.
        return mid;
    }
    // At this point, left and right have swapped.
    // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
    return cues[left].startTime - time < time - cues[right].startTime ? left : right;
}
function $fada8102d2a280be$var$getCuesInRange(cues, start, end) {
    const cuesFound = [];
    const firstCueInRange = $fada8102d2a280be$var$getFirstCueIndexAfterTime(cues, start);
    if (firstCueInRange > -1) for(let i = firstCueInRange, len = cues.length; i < len; i++){
        const cue = cues[i];
        if (cue.startTime >= start && cue.endTime <= end) cuesFound.push(cue);
        else if (cue.startTime > end) return cuesFound;
    }
    return cuesFound;
}
var $fada8102d2a280be$var$MetadataSchema = {
    audioId3: "org.id3",
    dateRange: "com.apple.quicktime.HLS",
    emsg: "https://aomedia.org/emsg/ID3"
};
const $fada8102d2a280be$var$MIN_CUE_DURATION = 0.25;
function $fada8102d2a280be$var$getCueClass() {
    if (typeof self === "undefined") return undefined;
    // Attempt to recreate Safari functionality by creating
    // WebKitDataCue objects when available and store the decoded
    // ID3 data in the value property of the cue
    return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
}
// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
const $fada8102d2a280be$var$MAX_CUE_ENDTIME = (()=>{
    const Cue = $fada8102d2a280be$var$getCueClass();
    try {
        new Cue(0, Number.POSITIVE_INFINITY, "");
    } catch (e) {
        return Number.MAX_VALUE;
    }
    return Number.POSITIVE_INFINITY;
})();
function $fada8102d2a280be$var$dateRangeDateToTimelineSeconds(date, offset) {
    return date.getTime() / 1000 - offset;
}
function $fada8102d2a280be$var$hexToArrayBuffer(str) {
    return Uint8Array.from(str.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class $fada8102d2a280be$var$ID3TrackController {
    constructor(hls){
        this.hls = void 0;
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
        this.hls = hls;
        this._registerListeners();
    }
    destroy() {
        this._unregisterListeners();
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
        // @ts-ignore
        this.hls = null;
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    // Add ID3 metatadata text track.
    onMediaAttached(event, data) {
        this.media = data.media;
    }
    onMediaDetaching() {
        if (!this.id3Track) return;
        $fada8102d2a280be$var$clearCurrentCues(this.id3Track);
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
    }
    onManifestLoading() {
        this.dateRangeCuesAppended = {};
    }
    createTrack(media) {
        const track = this.getID3Track(media.textTracks);
        track.mode = "hidden";
        return track;
    }
    getID3Track(textTracks) {
        if (!this.media) return;
        for(let i = 0; i < textTracks.length; i++){
            const textTrack = textTracks[i];
            if (textTrack.kind === "metadata" && textTrack.label === "id3") {
                // send 'addtrack' when reusing the textTrack for metadata,
                // same as what we do for captions
                $fada8102d2a280be$var$sendAddTrackEvent(textTrack, this.media);
                return textTrack;
            }
        }
        return this.media.addTextTrack("metadata", "id3");
    }
    onFragParsingMetadata(event, data) {
        if (!this.media) return;
        const { hls: { config: { enableEmsgMetadataCues: enableEmsgMetadataCues, enableID3MetadataCues: enableID3MetadataCues } } } = this;
        if (!enableEmsgMetadataCues && !enableID3MetadataCues) return;
        const { samples: samples } = data;
        // create track dynamically
        if (!this.id3Track) this.id3Track = this.createTrack(this.media);
        const Cue = $fada8102d2a280be$var$getCueClass();
        for(let i = 0; i < samples.length; i++){
            const type = samples[i].type;
            if (type === $fada8102d2a280be$var$MetadataSchema.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) continue;
            const frames = $fada8102d2a280be$var$getID3Frames(samples[i].data);
            if (frames) {
                const startTime = samples[i].pts;
                let endTime = startTime + samples[i].duration;
                if (endTime > $fada8102d2a280be$var$MAX_CUE_ENDTIME) endTime = $fada8102d2a280be$var$MAX_CUE_ENDTIME;
                const timeDiff = endTime - startTime;
                if (timeDiff <= 0) endTime = startTime + $fada8102d2a280be$var$MIN_CUE_DURATION;
                for(let j = 0; j < frames.length; j++){
                    const frame = frames[j];
                    // Safari doesn't put the timestamp frame in the TextTrack
                    if (!$fada8102d2a280be$var$isTimeStampFrame(frame)) {
                        // add a bounds to any unbounded cues
                        this.updateId3CueEnds(startTime, type);
                        const cue = new Cue(startTime, endTime, "");
                        cue.value = frame;
                        if (type) cue.type = type;
                        this.id3Track.addCue(cue);
                    }
                }
            }
        }
    }
    updateId3CueEnds(startTime, type) {
        var _this$id3Track;
        const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
        if (cues) for(let i = cues.length; i--;){
            const cue = cues[i];
            if (cue.type === type && cue.startTime < startTime && cue.endTime === $fada8102d2a280be$var$MAX_CUE_ENDTIME) cue.endTime = startTime;
        }
    }
    onBufferFlushing(event, { startOffset: startOffset, endOffset: endOffset, type: type }) {
        const { id3Track: id3Track, hls: hls } = this;
        if (!hls) return;
        const { config: { enableEmsgMetadataCues: enableEmsgMetadataCues, enableID3MetadataCues: enableID3MetadataCues } } = hls;
        if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
            let predicate;
            if (type === "audio") predicate = (cue)=>cue.type === $fada8102d2a280be$var$MetadataSchema.audioId3 && enableID3MetadataCues;
            else if (type === "video") predicate = (cue)=>cue.type === $fada8102d2a280be$var$MetadataSchema.emsg && enableEmsgMetadataCues;
            else predicate = (cue)=>cue.type === $fada8102d2a280be$var$MetadataSchema.audioId3 && enableID3MetadataCues || cue.type === $fada8102d2a280be$var$MetadataSchema.emsg && enableEmsgMetadataCues;
            $fada8102d2a280be$var$removeCuesInRange(id3Track, startOffset, endOffset, predicate);
        }
    }
    onLevelUpdated(event, { details: details }) {
        if (!this.media || !details.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues) return;
        const { dateRangeCuesAppended: dateRangeCuesAppended, id3Track: id3Track } = this;
        const { dateRanges: dateRanges } = details;
        const ids = Object.keys(dateRanges);
        // Remove cues from track not found in details.dateRanges
        if (id3Track) {
            const idsToRemove = Object.keys(dateRangeCuesAppended).filter((id)=>!ids.includes(id));
            for(let i = idsToRemove.length; i--;){
                const id = idsToRemove[i];
                Object.keys(dateRangeCuesAppended[id].cues).forEach((key)=>{
                    id3Track.removeCue(dateRangeCuesAppended[id].cues[key]);
                });
                delete dateRangeCuesAppended[id];
            }
        }
        // Exit if the playlist does not have Date Ranges or does not have Program Date Time
        const lastFragment = details.fragments[details.fragments.length - 1];
        if (ids.length === 0 || !$fada8102d2a280be$var$isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) return;
        if (!this.id3Track) this.id3Track = this.createTrack(this.media);
        const dateTimeOffset = lastFragment.programDateTime / 1000 - lastFragment.start;
        const Cue = $fada8102d2a280be$var$getCueClass();
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            const dateRange = dateRanges[id];
            const appendedDateRangeCues = dateRangeCuesAppended[id];
            const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
            let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
            const startTime = $fada8102d2a280be$var$dateRangeDateToTimelineSeconds(dateRange.startDate, dateTimeOffset);
            let endTime = $fada8102d2a280be$var$MAX_CUE_ENDTIME;
            const endDate = dateRange.endDate;
            if (endDate) {
                endTime = $fada8102d2a280be$var$dateRangeDateToTimelineSeconds(endDate, dateTimeOffset);
                durationKnown = true;
            } else if (dateRange.endOnNext && !durationKnown) {
                const nextDateRangeWithSameClass = ids.reduce((filterMapArray, id)=>{
                    const candidate = dateRanges[id];
                    if (candidate.class === dateRange.class && candidate.id !== id && candidate.startDate > dateRange.startDate) filterMapArray.push(candidate);
                    return filterMapArray;
                }, []).sort((a, b)=>a.startDate.getTime() - b.startDate.getTime())[0];
                if (nextDateRangeWithSameClass) {
                    endTime = $fada8102d2a280be$var$dateRangeDateToTimelineSeconds(nextDateRangeWithSameClass.startDate, dateTimeOffset);
                    durationKnown = true;
                }
            }
            const attributes = Object.keys(dateRange.attr);
            for(let j = 0; j < attributes.length; j++){
                const key = attributes[j];
                if (!$fada8102d2a280be$var$isDateRangeCueAttribute(key)) continue;
                let cue = cues[key];
                if (cue) {
                    if (durationKnown && !appendedDateRangeCues.durationKnown) cue.endTime = endTime;
                } else {
                    let data = dateRange.attr[key];
                    cue = new Cue(startTime, endTime, "");
                    if ($fada8102d2a280be$var$isSCTE35Attribute(key)) data = $fada8102d2a280be$var$hexToArrayBuffer(data);
                    cue.value = {
                        key: key,
                        data: data
                    };
                    cue.type = $fada8102d2a280be$var$MetadataSchema.dateRange;
                    cue.id = id;
                    this.id3Track.addCue(cue);
                    cues[key] = cue;
                }
            }
            dateRangeCuesAppended[id] = {
                cues: cues,
                dateRange: dateRange,
                durationKnown: durationKnown
            };
        }
    }
}
class $fada8102d2a280be$var$LatencyController {
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = null;
        this.levelDetails = null;
        this.currentTime = 0;
        this.stallCount = 0;
        this._latency = null;
        this.timeupdateHandler = ()=>this.timeupdate();
        this.hls = hls;
        this.config = hls.config;
        this.registerListeners();
    }
    get latency() {
        return this._latency || 0;
    }
    get maxLatency() {
        const { config: config, levelDetails: levelDetails } = this;
        if (config.liveMaxLatencyDuration !== undefined) return config.liveMaxLatencyDuration;
        return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
    }
    get targetLatency() {
        const { levelDetails: levelDetails } = this;
        if (levelDetails === null) return null;
        const { holdBack: holdBack, partHoldBack: partHoldBack, targetduration: targetduration } = levelDetails;
        const { liveSyncDuration: liveSyncDuration, liveSyncDurationCount: liveSyncDurationCount, lowLatencyMode: lowLatencyMode } = this.config;
        const userConfig = this.hls.userConfig;
        let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
        if (userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
        const maxLiveSyncOnStallIncrease = targetduration;
        const liveSyncOnStallIncrease = 1.0;
        return targetLatency + Math.min(this.stallCount * liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
    }
    get liveSyncPosition() {
        const liveEdge = this.estimateLiveEdge();
        const targetLatency = this.targetLatency;
        const levelDetails = this.levelDetails;
        if (liveEdge === null || targetLatency === null || levelDetails === null) return null;
        const edge = levelDetails.edge;
        const syncPosition = liveEdge - targetLatency - this.edgeStalled;
        const min = edge - levelDetails.totalduration;
        const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
        return Math.min(Math.max(min, syncPosition), max);
    }
    get drift() {
        const { levelDetails: levelDetails } = this;
        if (levelDetails === null) return 1;
        return levelDetails.drift;
    }
    get edgeStalled() {
        const { levelDetails: levelDetails } = this;
        if (levelDetails === null) return 0;
        const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
        return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
    }
    get forwardBufferLength() {
        const { media: media, levelDetails: levelDetails } = this;
        if (!media || !levelDetails) return 0;
        const bufferedRanges = media.buffered.length;
        return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetaching();
        this.levelDetails = null;
        // @ts-ignore
        this.hls = this.timeupdateHandler = null;
    }
    registerListeners() {
        this.hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        this.hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.on($fada8102d2a280be$var$Events.LEVEL_UPDATED, this.onLevelUpdated, this);
        this.hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        this.hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        this.hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.off($fada8102d2a280be$var$Events.LEVEL_UPDATED, this.onLevelUpdated, this);
        this.hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    onMediaAttached(event, data) {
        this.media = data.media;
        this.media.addEventListener("timeupdate", this.timeupdateHandler);
    }
    onMediaDetaching() {
        if (this.media) {
            this.media.removeEventListener("timeupdate", this.timeupdateHandler);
            this.media = null;
        }
    }
    onManifestLoading() {
        this.levelDetails = null;
        this._latency = null;
        this.stallCount = 0;
    }
    onLevelUpdated(event, { details: details }) {
        this.levelDetails = details;
        if (details.advanced) this.timeupdate();
        if (!details.live && this.media) this.media.removeEventListener("timeupdate", this.timeupdateHandler);
    }
    onError(event, data) {
        var _this$levelDetails;
        if (data.details !== $fada8102d2a280be$var$ErrorDetails.BUFFER_STALLED_ERROR) return;
        this.stallCount++;
        if ((_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) $fada8102d2a280be$var$logger.warn("[playback-rate-controller]: Stall detected, adjusting target latency");
    }
    timeupdate() {
        const { media: media, levelDetails: levelDetails } = this;
        if (!media || !levelDetails) return;
        this.currentTime = media.currentTime;
        const latency = this.computeLatency();
        if (latency === null) return;
        this._latency = latency;
        // Adapt playbackRate to meet target latency in low-latency mode
        const { lowLatencyMode: lowLatencyMode, maxLiveSyncPlaybackRate: maxLiveSyncPlaybackRate } = this.config;
        if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1) return;
        const targetLatency = this.targetLatency;
        if (targetLatency === null) return;
        const distanceFromTarget = latency - targetLatency;
        // Only adjust playbackRate when within one target duration of targetLatency
        // and more than one second from under-buffering.
        // Playback further than one target duration from target can be considered DVR playback.
        const liveMinLatencyDuration = Math.min(this.maxLatency, targetLatency + levelDetails.targetduration);
        const inLiveRange = distanceFromTarget < liveMinLatencyDuration;
        if (levelDetails.live && inLiveRange && distanceFromTarget > 0.05 && this.forwardBufferLength > 1) {
            const max = Math.min(2, Math.max(1.0, maxLiveSyncPlaybackRate));
            const rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
            media.playbackRate = Math.min(max, Math.max(1, rate));
        } else if (media.playbackRate !== 1 && media.playbackRate !== 0) media.playbackRate = 1;
    }
    estimateLiveEdge() {
        const { levelDetails: levelDetails } = this;
        if (levelDetails === null) return null;
        return levelDetails.edge + levelDetails.age;
    }
    computeLatency() {
        const liveEdge = this.estimateLiveEdge();
        if (liveEdge === null) return null;
        return liveEdge - this.currentTime;
    }
}
const $fada8102d2a280be$var$HdcpLevels = [
    "NONE",
    "TYPE-0",
    "TYPE-1",
    null
];
var $fada8102d2a280be$var$HlsSkip = {
    No: "",
    Yes: "YES",
    v2: "v2"
};
function $fada8102d2a280be$var$getSkipValue(details, msn) {
    const { canSkipUntil: canSkipUntil, canSkipDateRanges: canSkipDateRanges, endSN: endSN } = details;
    const snChangeGoal = msn !== undefined ? msn - endSN : 0;
    if (canSkipUntil && snChangeGoal < canSkipUntil) {
        if (canSkipDateRanges) return $fada8102d2a280be$var$HlsSkip.v2;
        return $fada8102d2a280be$var$HlsSkip.Yes;
    }
    return $fada8102d2a280be$var$HlsSkip.No;
}
class $fada8102d2a280be$var$HlsUrlParameters {
    constructor(msn, part, skip){
        this.msn = void 0;
        this.part = void 0;
        this.skip = void 0;
        this.msn = msn;
        this.part = part;
        this.skip = skip;
    }
    addDirectives(uri) {
        const url = new self.URL(uri);
        if (this.msn !== undefined) url.searchParams.set("_HLS_msn", this.msn.toString());
        if (this.part !== undefined) url.searchParams.set("_HLS_part", this.part.toString());
        if (this.skip) url.searchParams.set("_HLS_skip", this.skip);
        return url.href;
    }
}
class $fada8102d2a280be$var$Level {
    constructor(data){
        this._attrs = void 0;
        this.audioCodec = void 0;
        this.bitrate = void 0;
        this.codecSet = void 0;
        this.height = void 0;
        this.id = void 0;
        this.name = void 0;
        this.videoCodec = void 0;
        this.width = void 0;
        this.unknownCodecs = void 0;
        this.audioGroupIds = void 0;
        this.details = void 0;
        this.fragmentError = 0;
        this.loadError = 0;
        this.loaded = void 0;
        this.realBitrate = 0;
        this.textGroupIds = void 0;
        this.url = void 0;
        this._urlId = 0;
        this.url = [
            data.url
        ];
        this._attrs = [
            data.attrs
        ];
        this.bitrate = data.bitrate;
        if (data.details) this.details = data.details;
        this.id = data.id || 0;
        this.name = data.name;
        this.width = data.width || 0;
        this.height = data.height || 0;
        this.audioCodec = data.audioCodec;
        this.videoCodec = data.videoCodec;
        this.unknownCodecs = data.unknownCodecs;
        this.codecSet = [
            data.videoCodec,
            data.audioCodec
        ].filter((c)=>c).join(",").replace(/\.[^.,]+/g, "");
    }
    get maxBitrate() {
        return Math.max(this.realBitrate, this.bitrate);
    }
    get attrs() {
        return this._attrs[this._urlId];
    }
    get pathwayId() {
        return this.attrs["PATHWAY-ID"] || ".";
    }
    get uri() {
        return this.url[this._urlId] || "";
    }
    get urlId() {
        return this._urlId;
    }
    set urlId(value) {
        const newValue = value % this.url.length;
        if (this._urlId !== newValue) {
            this.fragmentError = 0;
            this.loadError = 0;
            this.details = undefined;
            this._urlId = newValue;
        }
    }
    get audioGroupId() {
        var _this$audioGroupIds;
        return (_this$audioGroupIds = this.audioGroupIds) == null ? void 0 : _this$audioGroupIds[this.urlId];
    }
    get textGroupId() {
        var _this$textGroupIds;
        return (_this$textGroupIds = this.textGroupIds) == null ? void 0 : _this$textGroupIds[this.urlId];
    }
    addFallback(data) {
        this.url.push(data.url);
        this._attrs.push(data.attrs);
    }
}
function $fada8102d2a280be$var$updateFromToPTS(fragFrom, fragTo) {
    const fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if ($fada8102d2a280be$var$isFiniteNumber(fragToPTS)) {
        // update fragment duration.
        // it helps to fix drifts between playlist reported duration and fragment real duration
        let duration = 0;
        let frag;
        if (fragTo.sn > fragFrom.sn) {
            duration = fragToPTS - fragFrom.start;
            frag = fragFrom;
        } else {
            duration = fragFrom.start - fragToPTS;
            frag = fragTo;
        }
        if (frag.duration !== duration) frag.duration = duration;
    // we dont know startPTS[toIdx]
    } else if (fragTo.sn > fragFrom.sn) {
        const contiguous = fragFrom.cc === fragTo.cc;
        // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
        if (contiguous && fragFrom.minEndPTS) fragTo.start = fragFrom.start + (fragFrom.minEndPTS - fragFrom.start);
        else fragTo.start = fragFrom.start + fragFrom.duration;
    } else fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
}
function $fada8102d2a280be$var$updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
    const parsedMediaDuration = endPTS - startPTS;
    if (parsedMediaDuration <= 0) {
        $fada8102d2a280be$var$logger.warn("Fragment should have a positive duration", frag);
        endPTS = startPTS + frag.duration;
        endDTS = startDTS + frag.duration;
    }
    let maxStartPTS = startPTS;
    let minEndPTS = endPTS;
    const fragStartPts = frag.startPTS;
    const fragEndPts = frag.endPTS;
    if ($fada8102d2a280be$var$isFiniteNumber(fragStartPts)) {
        // delta PTS between audio and video
        const deltaPTS = Math.abs(fragStartPts - startPTS);
        if (!$fada8102d2a280be$var$isFiniteNumber(frag.deltaPTS)) frag.deltaPTS = deltaPTS;
        else frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
        maxStartPTS = Math.max(startPTS, fragStartPts);
        startPTS = Math.min(startPTS, fragStartPts);
        startDTS = Math.min(startDTS, frag.startDTS);
        minEndPTS = Math.min(endPTS, fragEndPts);
        endPTS = Math.max(endPTS, fragEndPts);
        endDTS = Math.max(endDTS, frag.endDTS);
    }
    const drift = startPTS - frag.start;
    if (frag.start !== 0) frag.start = startPTS;
    frag.duration = endPTS - frag.start;
    frag.startPTS = startPTS;
    frag.maxStartPTS = maxStartPTS;
    frag.startDTS = startDTS;
    frag.endPTS = endPTS;
    frag.minEndPTS = minEndPTS;
    frag.endDTS = endDTS;
    const sn = frag.sn; // 'initSegment'
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) return 0;
    let i;
    const fragIdx = sn - details.startSN;
    const fragments = details.fragments;
    // update frag reference in fragments array
    // rationale is that fragments array might not contain this frag object.
    // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
    // if we don't update frag, we won't be able to propagate PTS info on the playlist
    // resulting in invalid sliding computation
    fragments[fragIdx] = frag;
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for(i = fragIdx; i > 0; i--)$fada8102d2a280be$var$updateFromToPTS(fragments[i], fragments[i - 1]);
    // adjust fragment PTS/duration from seqnum to last frag
    for(i = fragIdx; i < fragments.length - 1; i++)$fada8102d2a280be$var$updateFromToPTS(fragments[i], fragments[i + 1]);
    if (details.fragmentHint) $fada8102d2a280be$var$updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
    details.PTSKnown = details.alignedSliding = true;
    return drift;
}
function $fada8102d2a280be$var$mergeDetails(oldDetails, newDetails) {
    // Track the last initSegment processed. Initialize it to the last one on the timeline.
    let currentInitSegment = null;
    const oldFragments = oldDetails.fragments;
    for(let i = oldFragments.length - 1; i >= 0; i--){
        const oldInit = oldFragments[i].initSegment;
        if (oldInit) {
            currentInitSegment = oldInit;
            break;
        }
    }
    if (oldDetails.fragmentHint) // prevent PTS and duration from being adjusted on the next hint
    delete oldDetails.fragmentHint.endPTS;
    // check if old/new playlists have fragments in common
    // loop through overlapping SN and update startPTS , cc, and duration if any found
    let ccOffset = 0;
    let PTSFrag;
    $fada8102d2a280be$var$mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag)=>{
        if (oldFrag.relurl) // Do not compare CC if the old fragment has no url. This is a level.fragmentHint used by LL-HLS parts.
        // It maybe be off by 1 if it was created before any parts or discontinuity tags were appended to the end
        // of the playlist.
        ccOffset = oldFrag.cc - newFrag.cc;
        if ($fada8102d2a280be$var$isFiniteNumber(oldFrag.startPTS) && $fada8102d2a280be$var$isFiniteNumber(oldFrag.endPTS)) {
            newFrag.start = newFrag.startPTS = oldFrag.startPTS;
            newFrag.startDTS = oldFrag.startDTS;
            newFrag.maxStartPTS = oldFrag.maxStartPTS;
            newFrag.endPTS = oldFrag.endPTS;
            newFrag.endDTS = oldFrag.endDTS;
            newFrag.minEndPTS = oldFrag.minEndPTS;
            newFrag.duration = oldFrag.endPTS - oldFrag.startPTS;
            if (newFrag.duration) PTSFrag = newFrag;
            // PTS is known when any segment has startPTS and endPTS
            newDetails.PTSKnown = newDetails.alignedSliding = true;
        }
        newFrag.elementaryStreams = oldFrag.elementaryStreams;
        newFrag.loader = oldFrag.loader;
        newFrag.stats = oldFrag.stats;
        newFrag.urlId = oldFrag.urlId;
        if (oldFrag.initSegment) {
            newFrag.initSegment = oldFrag.initSegment;
            currentInitSegment = oldFrag.initSegment;
        }
    });
    if (currentInitSegment) {
        const fragmentsToCheck = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
        fragmentsToCheck.forEach((frag)=>{
            var _currentInitSegment;
            if (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl)) frag.initSegment = currentInitSegment;
        });
    }
    if (newDetails.skippedSegments) {
        newDetails.deltaUpdateFailed = newDetails.fragments.some((frag)=>!frag);
        if (newDetails.deltaUpdateFailed) {
            $fada8102d2a280be$var$logger.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
            for(let i = newDetails.skippedSegments; i--;)newDetails.fragments.shift();
            newDetails.startSN = newDetails.fragments[0].sn;
            newDetails.startCC = newDetails.fragments[0].cc;
        } else if (newDetails.canSkipDateRanges) newDetails.dateRanges = $fada8102d2a280be$var$mergeDateRanges(oldDetails.dateRanges, newDetails.dateRanges, newDetails.recentlyRemovedDateranges);
    }
    const newFragments = newDetails.fragments;
    if (ccOffset) {
        $fada8102d2a280be$var$logger.warn("discontinuity sliding from playlist, take drift into account");
        for(let i = 0; i < newFragments.length; i++)newFragments[i].cc += ccOffset;
    }
    if (newDetails.skippedSegments) newDetails.startCC = newDetails.fragments[0].cc;
    // Merge parts
    $fada8102d2a280be$var$mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart)=>{
        newPart.elementaryStreams = oldPart.elementaryStreams;
        newPart.stats = oldPart.stats;
    });
    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) $fada8102d2a280be$var$updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
    else // ensure that delta is within oldFragments range
    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
    // in that case we also need to adjust start offset of all fragments
    $fada8102d2a280be$var$adjustSliding(oldDetails, newDetails);
    if (newFragments.length) newDetails.totalduration = newDetails.edge - newFragments[0].start;
    newDetails.driftStartTime = oldDetails.driftStartTime;
    newDetails.driftStart = oldDetails.driftStart;
    const advancedDateTime = newDetails.advancedDateTime;
    if (newDetails.advanced && advancedDateTime) {
        const edge = newDetails.edge;
        if (!newDetails.driftStart) {
            newDetails.driftStartTime = advancedDateTime;
            newDetails.driftStart = edge;
        }
        newDetails.driftEndTime = advancedDateTime;
        newDetails.driftEnd = edge;
    } else {
        newDetails.driftEndTime = oldDetails.driftEndTime;
        newDetails.driftEnd = oldDetails.driftEnd;
        newDetails.advancedDateTime = oldDetails.advancedDateTime;
    }
}
function $fada8102d2a280be$var$mergeDateRanges(oldDateRanges, deltaDateRanges, recentlyRemovedDateranges) {
    const dateRanges = $fada8102d2a280be$var$_extends({}, oldDateRanges);
    if (recentlyRemovedDateranges) recentlyRemovedDateranges.forEach((id)=>{
        delete dateRanges[id];
    });
    Object.keys(deltaDateRanges).forEach((id)=>{
        const dateRange = new $fada8102d2a280be$var$DateRange(deltaDateRanges[id].attr, dateRanges[id]);
        if (dateRange.isValid) dateRanges[id] = dateRange;
        else $fada8102d2a280be$var$logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(deltaDateRanges[id].attr)}"`);
    });
    return dateRanges;
}
function $fada8102d2a280be$var$mapPartIntersection(oldParts, newParts, intersectionFn) {
    if (oldParts && newParts) {
        let delta = 0;
        for(let i = 0, len = oldParts.length; i <= len; i++){
            const oldPart = oldParts[i];
            const newPart = newParts[i + delta];
            if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) intersectionFn(oldPart, newPart);
            else delta--;
        }
    }
}
function $fada8102d2a280be$var$mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
    const skippedSegments = newDetails.skippedSegments;
    const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
    const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
    const delta = newDetails.startSN - oldDetails.startSN;
    const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
    const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
    for(let i = start; i <= end; i++){
        const oldFrag = oldFrags[delta + i];
        let newFrag = newFrags[i];
        if (skippedSegments && !newFrag && i < skippedSegments) // Fill in skipped segments in delta playlist
        newFrag = newDetails.fragments[i] = oldFrag;
        if (oldFrag && newFrag) intersectionFn(oldFrag, newFrag);
    }
}
function $fada8102d2a280be$var$adjustSliding(oldDetails, newDetails) {
    const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
    const oldFragments = oldDetails.fragments;
    if (delta < 0 || delta >= oldFragments.length) return;
    $fada8102d2a280be$var$addSliding(newDetails, oldFragments[delta].start);
}
function $fada8102d2a280be$var$addSliding(details, start) {
    if (start) {
        const fragments = details.fragments;
        for(let i = details.skippedSegments; i < fragments.length; i++)fragments[i].start += start;
        if (details.fragmentHint) details.fragmentHint.start += start;
    }
}
function $fada8102d2a280be$var$computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
    let reloadInterval = 1000 * newDetails.targetduration;
    if (newDetails.updated) {
        // Use last segment duration when shorter than target duration and near live edge
        const fragments = newDetails.fragments;
        const liveEdgeMaxTargetDurations = 4;
        if (fragments.length && reloadInterval * liveEdgeMaxTargetDurations > distanceToLiveEdgeMs) {
            const lastSegmentDuration = fragments[fragments.length - 1].duration * 1000;
            if (lastSegmentDuration < reloadInterval) reloadInterval = lastSegmentDuration;
        }
    } else // estimate = 'miss half average';
    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
    // changed then it MUST wait for a period of one-half the target
    // duration before retrying.
    reloadInterval /= 2;
    return Math.round(reloadInterval);
}
function $fada8102d2a280be$var$getFragmentWithSN(level, sn, fragCurrent) {
    if (!(level != null && level.details)) return null;
    const levelDetails = level.details;
    let fragment = levelDetails.fragments[sn - levelDetails.startSN];
    if (fragment) return fragment;
    fragment = levelDetails.fragmentHint;
    if (fragment && fragment.sn === sn) return fragment;
    if (sn < levelDetails.startSN && fragCurrent && fragCurrent.sn === sn) return fragCurrent;
    return null;
}
function $fada8102d2a280be$var$getPartWith(level, sn, partIndex) {
    var _level$details;
    if (!(level != null && level.details)) return null;
    return $fada8102d2a280be$var$findPart((_level$details = level.details) == null ? void 0 : _level$details.partList, sn, partIndex);
}
function $fada8102d2a280be$var$findPart(partList, sn, partIndex) {
    if (partList) for(let i = partList.length; i--;){
        const part = partList[i];
        if (part.index === partIndex && part.fragment.sn === sn) return part;
    }
    return null;
}
function $fada8102d2a280be$var$isTimeoutError(error) {
    switch(error.details){
        case $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_TIMEOUT:
        case $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_TIMEOUT:
        case $fada8102d2a280be$var$ErrorDetails.LEVEL_LOAD_TIMEOUT:
        case $fada8102d2a280be$var$ErrorDetails.MANIFEST_LOAD_TIMEOUT:
            return true;
    }
    return false;
}
function $fada8102d2a280be$var$getRetryConfig(loadPolicy, error) {
    const isTimeout = $fada8102d2a280be$var$isTimeoutError(error);
    return loadPolicy.default[`${isTimeout ? "timeout" : "error"}Retry`];
}
function $fada8102d2a280be$var$getRetryDelay(retryConfig, retryCount) {
    // exponential backoff capped to max retry delay
    const backoffFactor = retryConfig.backoff === "linear" ? 1 : Math.pow(2, retryCount);
    return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function $fada8102d2a280be$var$getLoaderConfigWithoutReties(loderConfig) {
    return $fada8102d2a280be$var$_objectSpread2($fada8102d2a280be$var$_objectSpread2({}, loderConfig), {
        errorRetry: null,
        timeoutRetry: null
    });
}
function $fada8102d2a280be$var$shouldRetry(retryConfig, retryCount, isTimeout, httpStatus) {
    return !!retryConfig && retryCount < retryConfig.maxNumRetry && ($fada8102d2a280be$var$retryForHttpStatus(httpStatus) || !!isTimeout);
}
function $fada8102d2a280be$var$retryForHttpStatus(httpStatus) {
    // Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
    return httpStatus === 0 && navigator.onLine === false || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}
const $fada8102d2a280be$var$BinarySearch = {
    /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */ search: function(list, comparisonFn) {
        let minIndex = 0;
        let maxIndex = list.length - 1;
        let currentIndex = null;
        let currentElement = null;
        while(minIndex <= maxIndex){
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = list[currentIndex];
            const comparisonResult = comparisonFn(currentElement);
            if (comparisonResult > 0) minIndex = currentIndex + 1;
            else if (comparisonResult < 0) maxIndex = currentIndex - 1;
            else return currentElement;
        }
        return null;
    }
};
/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */ function $fada8102d2a280be$var$findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
    if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !$fada8102d2a280be$var$isFiniteNumber(PDTValue)) return null;
    // if less than start
    const startPDT = fragments[0].programDateTime;
    if (PDTValue < (startPDT || 0)) return null;
    const endPDT = fragments[fragments.length - 1].endProgramDateTime;
    if (PDTValue >= (endPDT || 0)) return null;
    maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
    for(let seg = 0; seg < fragments.length; ++seg){
        const frag = fragments[seg];
        if ($fada8102d2a280be$var$pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) return frag;
    }
    return null;
}
/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */ function $fada8102d2a280be$var$findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0) {
    let fragNext = null;
    if (fragPrevious) fragNext = fragments[fragPrevious.sn - fragments[0].sn + 1] || null;
    else if (bufferEnd === 0 && fragments[0].start === 0) fragNext = fragments[0];
    // Prefer the next fragment if it's within tolerance
    if (fragNext && $fada8102d2a280be$var$fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0) return fragNext;
    // We might be seeking past the tolerance so find the best match
    const foundFragment = $fada8102d2a280be$var$BinarySearch.search(fragments, $fada8102d2a280be$var$fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
    if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) return foundFragment;
    // If no match was found return the next fragment after fragPrevious, or null
    return fragNext;
}
/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */ function $fada8102d2a280be$var$fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
    // eagerly accept an accurate match (no tolerance)
    if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) return 0;
    // offset should be within fragment boundary - config.maxFragLookUpTolerance
    // this is to cope with situations like
    // bufferEnd = 9.991
    // frag[Ø] : [0,10]
    // frag[1] : [10,20]
    // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
    //              frag start               frag start+duration
    //                  |-----------------------------|
    //              <--->                         <--->
    //  ...--------><-----------------------------><---------....
    // previous frag         matching fragment         next frag
    //  return -1             return 0                 return 1
    // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
    // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
    const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
    if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
    else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
    return -1;
    return 0;
}
/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */ function $fada8102d2a280be$var$pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
    const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;
    // endProgramDateTime can be null, default to zero
    const endProgramDateTime = candidate.endProgramDateTime || 0;
    return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
function $fada8102d2a280be$var$findFragWithCC(fragments, cc) {
    return $fada8102d2a280be$var$BinarySearch.search(fragments, (candidate)=>{
        if (candidate.cc < cc) return 1;
        else if (candidate.cc > cc) return -1;
        else return 0;
    });
}
const $fada8102d2a280be$var$RENDITION_PENALTY_DURATION_MS = 300000;
var $fada8102d2a280be$var$NetworkErrorAction = {
    DoNothing: 0,
    SendEndCallback: 1,
    SendAlternateToPenaltyBox: 2,
    RemoveAlternatePermanently: 3,
    InsertDiscontinuity: 4,
    RetryRequest: 5
};
var $fada8102d2a280be$var$ErrorActionFlags = {
    None: 0,
    MoveAllAlternatesMatchingHost: 1,
    MoveAllAlternatesMatchingHDCP: 2,
    SwitchToSDR: 4
}; // Reserved for future use
class $fada8102d2a280be$var$ErrorController {
    constructor(hls){
        this.hls = void 0;
        this.playlistError = 0;
        this.penalizedRenditions = {};
        this.log = void 0;
        this.warn = void 0;
        this.error = void 0;
        this.hls = hls;
        this.log = $fada8102d2a280be$var$logger.log.bind($fada8102d2a280be$var$logger, `[info]:`);
        this.warn = $fada8102d2a280be$var$logger.warn.bind($fada8102d2a280be$var$logger, `[warning]:`);
        this.error = $fada8102d2a280be$var$logger.error.bind($fada8102d2a280be$var$logger, `[error]:`);
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onErrorOut, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    destroy() {
        this.unregisterListeners();
        // @ts-ignore
        this.hls = null;
        this.penalizedRenditions = {};
    }
    startLoad(startPosition) {
        this.playlistError = 0;
    }
    stopLoad() {}
    getVariantLevelIndex(frag) {
        return (frag == null ? void 0 : frag.type) === $fada8102d2a280be$var$PlaylistLevelType.MAIN ? frag.level : this.hls.loadLevel;
    }
    onManifestLoading() {
        this.playlistError = 0;
        this.penalizedRenditions = {};
    }
    onLevelUpdated() {
        this.playlistError = 0;
    }
    onError(event, data) {
        var _data$level;
        if (data.fatal) return;
        const hls = this.hls;
        const context = data.context;
        switch(data.details){
            case $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_TIMEOUT:
            case $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_TIMEOUT:
                data.errorAction = this.getFragRetryOrSwitchAction(data);
                return;
            case $fada8102d2a280be$var$ErrorDetails.FRAG_GAP:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_DECRYPT_ERROR:
                // Switch level if possible, otherwise allow retry count to reach max error retries
                data.errorAction = this.getFragRetryOrSwitchAction(data);
                data.errorAction.action = $fada8102d2a280be$var$NetworkErrorAction.SendAlternateToPenaltyBox;
                return;
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_EMPTY_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_PARSING_ERROR:
                {
                    var _data$context, _data$context$levelDe;
                    // Only retry when empty and live
                    const levelIndex = data.parent === $fada8102d2a280be$var$PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
                    if (data.details === $fada8102d2a280be$var$ErrorDetails.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context$levelDe = _data$context.levelDetails) != null && _data$context$levelDe.live)) data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
                    else {
                        // Escalate to fatal if not retrying or switching
                        data.levelRetry = false;
                        data.errorAction = this.getLevelSwitchAction(data, levelIndex);
                    }
                }
                return;
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_LOAD_TIMEOUT:
                if (typeof (context == null ? void 0 : context.level) === "number") data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
                return;
            case $fada8102d2a280be$var$ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
            case $fada8102d2a280be$var$ErrorDetails.SUBTITLE_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:
                if (context) {
                    const level = hls.levels[hls.loadLevel];
                    if (level && (context.type === $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK && context.groupId === level.audioGroupId || context.type === $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK && context.groupId === level.textGroupId)) {
                        // Perform Pathway switch or Redundant failover if possible for fastest recovery
                        // otherwise allow playlist retry count to reach max error retries
                        data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
                        data.errorAction.action = $fada8102d2a280be$var$NetworkErrorAction.SendAlternateToPenaltyBox;
                        data.errorAction.flags = $fada8102d2a280be$var$ErrorActionFlags.MoveAllAlternatesMatchingHost;
                        return;
                    }
                }
                return;
            case $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
                {
                    const level = hls.levels[hls.loadLevel];
                    const restrictedHdcpLevel = level == null ? void 0 : level.attrs["HDCP-LEVEL"];
                    if (restrictedHdcpLevel) data.errorAction = {
                        action: $fada8102d2a280be$var$NetworkErrorAction.SendAlternateToPenaltyBox,
                        flags: $fada8102d2a280be$var$ErrorActionFlags.MoveAllAlternatesMatchingHDCP,
                        hdcpLevel: restrictedHdcpLevel
                    };
                }
                return;
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_ADD_CODEC_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.REMUX_ALLOC_ERROR:
                data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
                return;
            case $fada8102d2a280be$var$ErrorDetails.INTERNAL_EXCEPTION:
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_APPENDING_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_APPEND_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_FULL_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_SWITCH_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_STALLED_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_SEEK_OVER_HOLE:
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_NUDGE_ON_STALL:
                data.errorAction = {
                    action: $fada8102d2a280be$var$NetworkErrorAction.DoNothing,
                    flags: $fada8102d2a280be$var$ErrorActionFlags.None
                };
                return;
        }
        if (data.type === $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR) {
            const levelIndex = this.getVariantLevelIndex(data.frag);
            // Do not retry level. Escalate to fatal if switching levels fails.
            data.levelRetry = false;
            data.errorAction = this.getLevelSwitchAction(data, levelIndex);
            return;
        }
    }
    getPlaylistRetryOrSwitchAction(data, levelIndex) {
        var _data$response;
        const hls = this.hls;
        const retryConfig = $fada8102d2a280be$var$getRetryConfig(hls.config.playlistLoadPolicy, data);
        const retryCount = this.playlistError++;
        const httpStatus = (_data$response = data.response) == null ? void 0 : _data$response.code;
        const retry = $fada8102d2a280be$var$shouldRetry(retryConfig, retryCount, $fada8102d2a280be$var$isTimeoutError(data), httpStatus);
        if (retry) return {
            action: $fada8102d2a280be$var$NetworkErrorAction.RetryRequest,
            flags: $fada8102d2a280be$var$ErrorActionFlags.None,
            retryConfig: retryConfig,
            retryCount: retryCount
        };
        const errorAction = this.getLevelSwitchAction(data, levelIndex);
        if (retryConfig) {
            errorAction.retryConfig = retryConfig;
            errorAction.retryCount = retryCount;
        }
        return errorAction;
    }
    getFragRetryOrSwitchAction(data) {
        const hls = this.hls;
        // Share fragment error count accross media options (main, audio, subs)
        // This allows for level based rendition switching when media option assets fail
        const variantLevelIndex = this.getVariantLevelIndex(data.frag);
        const level = hls.levels[variantLevelIndex];
        const { fragLoadPolicy: fragLoadPolicy, keyLoadPolicy: keyLoadPolicy } = hls.config;
        const retryConfig = $fada8102d2a280be$var$getRetryConfig(data.details.startsWith("key") ? keyLoadPolicy : fragLoadPolicy, data);
        const fragmentErrors = hls.levels.reduce((acc, level)=>acc + level.fragmentError, 0);
        // Switch levels when out of retried or level index out of bounds
        if (level) {
            var _data$response2;
            if (data.details !== $fada8102d2a280be$var$ErrorDetails.FRAG_GAP) level.fragmentError++;
            const httpStatus = (_data$response2 = data.response) == null ? void 0 : _data$response2.code;
            const retry = $fada8102d2a280be$var$shouldRetry(retryConfig, fragmentErrors, $fada8102d2a280be$var$isTimeoutError(data), httpStatus);
            if (retry) return {
                action: $fada8102d2a280be$var$NetworkErrorAction.RetryRequest,
                flags: $fada8102d2a280be$var$ErrorActionFlags.None,
                retryConfig: retryConfig,
                retryCount: fragmentErrors
            };
        }
        // Reach max retry count, or Missing level reference
        // Switch to valid index
        const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
        // Add retry details to allow skipping of FRAG_PARSING_ERROR
        if (retryConfig) {
            errorAction.retryConfig = retryConfig;
            errorAction.retryCount = fragmentErrors;
        }
        return errorAction;
    }
    getLevelSwitchAction(data, levelIndex) {
        const hls = this.hls;
        if (levelIndex === null || levelIndex === undefined) levelIndex = hls.loadLevel;
        const level = this.hls.levels[levelIndex];
        if (level) {
            level.loadError++;
            if (hls.autoLevelEnabled) {
                var _data$frag, _data$context2;
                // Search for next level to retry
                let nextLevel = -1;
                const { levels: levels, loadLevel: loadLevel, minAutoLevel: minAutoLevel, maxAutoLevel: maxAutoLevel } = hls;
                const fragErrorType = (_data$frag = data.frag) == null ? void 0 : _data$frag.type;
                const { type: playlistErrorType, groupId: playlistErrorGroupId } = (_data$context2 = data.context) != null ? _data$context2 : {};
                for(let i = levels.length; i--;){
                    const candidate = (i + loadLevel) % levels.length;
                    if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
                        const levelCandidate = levels[candidate];
                        // Skip level switch if GAP tag is found in next level at same position
                        if (data.details === $fada8102d2a280be$var$ErrorDetails.FRAG_GAP && data.frag) {
                            const levelDetails = levels[candidate].details;
                            if (levelDetails) {
                                const fragCandidate = $fada8102d2a280be$var$findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
                                if (fragCandidate != null && fragCandidate.gap) continue;
                            }
                        } else if (playlistErrorType === $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK && playlistErrorGroupId === levelCandidate.audioGroupId || playlistErrorType === $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK && playlistErrorGroupId === levelCandidate.textGroupId) continue;
                        else if (fragErrorType === $fada8102d2a280be$var$PlaylistLevelType.AUDIO && level.audioGroupId === levelCandidate.audioGroupId || fragErrorType === $fada8102d2a280be$var$PlaylistLevelType.SUBTITLE && level.textGroupId === levelCandidate.textGroupId) continue;
                        nextLevel = candidate;
                        break;
                    }
                }
                if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
                    data.levelRetry = true;
                    this.playlistError = 0;
                    return {
                        action: $fada8102d2a280be$var$NetworkErrorAction.SendAlternateToPenaltyBox,
                        flags: $fada8102d2a280be$var$ErrorActionFlags.None,
                        nextAutoLevel: nextLevel
                    };
                }
            }
        }
        // No levels to switch / Manual level selection / Level not found
        // Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
        return {
            action: $fada8102d2a280be$var$NetworkErrorAction.SendAlternateToPenaltyBox,
            flags: $fada8102d2a280be$var$ErrorActionFlags.MoveAllAlternatesMatchingHost
        };
    }
    onErrorOut(event, data) {
        var _data$errorAction;
        switch((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action){
            case $fada8102d2a280be$var$NetworkErrorAction.DoNothing:
                break;
            case $fada8102d2a280be$var$NetworkErrorAction.SendAlternateToPenaltyBox:
                this.sendAlternateToPenaltyBox(data);
                if (!data.errorAction.resolved && data.details !== $fada8102d2a280be$var$ErrorDetails.FRAG_GAP) data.fatal = true;
                break;
        }
        if (data.fatal) {
            this.hls.stopLoad();
            return;
        }
    }
    sendAlternateToPenaltyBox(data) {
        const hls = this.hls;
        const errorAction = data.errorAction;
        if (!errorAction) return;
        const { flags: flags, hdcpLevel: hdcpLevel, nextAutoLevel: nextAutoLevel } = errorAction;
        switch(flags){
            case $fada8102d2a280be$var$ErrorActionFlags.None:
                this.switchLevel(data, nextAutoLevel);
                break;
            case $fada8102d2a280be$var$ErrorActionFlags.MoveAllAlternatesMatchingHost:
                // Handle Redundant Levels here. Pathway switching is handled by content-steering-controller
                if (!errorAction.resolved) errorAction.resolved = this.redundantFailover(data);
                break;
            case $fada8102d2a280be$var$ErrorActionFlags.MoveAllAlternatesMatchingHDCP:
                if (hdcpLevel) {
                    hls.maxHdcpLevel = $fada8102d2a280be$var$HdcpLevels[$fada8102d2a280be$var$HdcpLevels.indexOf(hdcpLevel) - 1];
                    errorAction.resolved = true;
                }
                this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
                break;
        }
        // If not resolved by previous actions try to switch to next level
        if (!errorAction.resolved) this.switchLevel(data, nextAutoLevel);
    }
    switchLevel(data, levelIndex) {
        if (levelIndex !== undefined && data.errorAction) {
            this.warn(`switching to level ${levelIndex} after ${data.details}`);
            this.hls.nextAutoLevel = levelIndex;
            data.errorAction.resolved = true;
            // Stream controller is responsible for this but won't switch on false start
            this.hls.nextLoadLevel = this.hls.nextAutoLevel;
        }
    }
    redundantFailover(data) {
        const { hls: hls, penalizedRenditions: penalizedRenditions } = this;
        const levelIndex = data.parent === $fada8102d2a280be$var$PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
        const level = hls.levels[levelIndex];
        const redundantLevels = level.url.length;
        const errorUrlId = data.frag ? data.frag.urlId : level.urlId;
        if (level.urlId === errorUrlId && (!data.frag || level.details)) this.penalizeRendition(level, data);
        for(let i = 1; i < redundantLevels; i++){
            const newUrlId = (errorUrlId + i) % redundantLevels;
            const penalizedRendition = penalizedRenditions[newUrlId];
            // Check if rendition is penalized and skip if it is a bad fit for failover
            if (!penalizedRendition || $fada8102d2a280be$var$checkExpired(penalizedRendition, data, penalizedRenditions[errorUrlId])) {
                // delete penalizedRenditions[newUrlId];
                // Update the url id of all levels so that we stay on the same set of variants when level switching
                this.warn(`Switching to Redundant Stream ${newUrlId + 1}/${redundantLevels}: "${level.url[newUrlId]}" after ${data.details}`);
                this.playlistError = 0;
                hls.levels.forEach((lv)=>{
                    lv.urlId = newUrlId;
                });
                hls.nextLoadLevel = levelIndex;
                return true;
            }
        }
        return false;
    }
    penalizeRendition(level, data) {
        const { penalizedRenditions: penalizedRenditions } = this;
        const penalizedRendition = penalizedRenditions[level.urlId] || {
            lastErrorPerfMs: 0,
            errors: [],
            details: undefined
        };
        penalizedRendition.lastErrorPerfMs = performance.now();
        penalizedRendition.errors.push(data);
        penalizedRendition.details = level.details;
        penalizedRenditions[level.urlId] = penalizedRendition;
    }
}
function $fada8102d2a280be$var$checkExpired(penalizedRendition, data, currentPenaltyState) {
    // Expire penalty for switching back to rendition after RENDITION_PENALTY_DURATION_MS
    if (performance.now() - penalizedRendition.lastErrorPerfMs > $fada8102d2a280be$var$RENDITION_PENALTY_DURATION_MS) return true;
    // Expire penalty on GAP tag error if rendition has no GAP at position (does not cover media tracks)
    const lastErrorDetails = penalizedRendition.details;
    if (data.details === $fada8102d2a280be$var$ErrorDetails.FRAG_GAP && lastErrorDetails && data.frag) {
        const position = data.frag.start;
        const candidateFrag = $fada8102d2a280be$var$findFragmentByPTS(null, lastErrorDetails.fragments, position);
        if (candidateFrag && !candidateFrag.gap) return true;
    }
    // Expire penalty if there are more errors in currentLevel than in penalizedRendition
    if (currentPenaltyState && penalizedRendition.errors.length < currentPenaltyState.errors.length) {
        const lastCandidateError = penalizedRendition.errors[penalizedRendition.errors.length - 1];
        if (lastErrorDetails && lastCandidateError.frag && data.frag && Math.abs(lastCandidateError.frag.start - data.frag.start) > lastErrorDetails.targetduration * 3) return true;
    }
    return false;
}
class $fada8102d2a280be$var$BasePlaylistController {
    constructor(hls, logPrefix){
        this.hls = void 0;
        this.timer = -1;
        this.requestScheduled = -1;
        this.canLoad = false;
        this.log = void 0;
        this.warn = void 0;
        this.log = $fada8102d2a280be$var$logger.log.bind($fada8102d2a280be$var$logger, `${logPrefix}:`);
        this.warn = $fada8102d2a280be$var$logger.warn.bind($fada8102d2a280be$var$logger, `${logPrefix}:`);
        this.hls = hls;
    }
    destroy() {
        this.clearTimer();
        // @ts-ignore
        this.hls = this.log = this.warn = null;
    }
    clearTimer() {
        clearTimeout(this.timer);
        this.timer = -1;
    }
    startLoad() {
        this.canLoad = true;
        this.requestScheduled = -1;
        this.loadPlaylist();
    }
    stopLoad() {
        this.canLoad = false;
        this.clearTimer();
    }
    switchParams(playlistUri, previous) {
        const renditionReports = previous == null ? void 0 : previous.renditionReports;
        if (renditionReports) {
            let foundIndex = -1;
            for(let i = 0; i < renditionReports.length; i++){
                const attr = renditionReports[i];
                let uri;
                try {
                    uri = new self.URL(attr.URI, previous.url).href;
                } catch (error) {
                    $fada8102d2a280be$var$logger.warn(`Could not construct new URL for Rendition Report: ${error}`);
                    uri = attr.URI || "";
                }
                // Use exact match. Otherwise, the last partial match, if any, will be used
                // (Playlist URI includes a query string that the Rendition Report does not)
                if (uri === playlistUri) {
                    foundIndex = i;
                    break;
                } else if (uri === playlistUri.substring(0, uri.length)) foundIndex = i;
            }
            if (foundIndex !== -1) {
                const attr = renditionReports[foundIndex];
                const msn = parseInt(attr["LAST-MSN"]) || (previous == null ? void 0 : previous.lastPartSn);
                let part = parseInt(attr["LAST-PART"]) || (previous == null ? void 0 : previous.lastPartIndex);
                if (this.hls.config.lowLatencyMode) {
                    const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
                    if (part >= 0 && currentGoal > previous.partTarget) part += 1;
                }
                return new $fada8102d2a280be$var$HlsUrlParameters(msn, part >= 0 ? part : undefined, $fada8102d2a280be$var$HlsSkip.No);
            }
        }
    }
    loadPlaylist(hlsUrlParameters) {
        if (this.requestScheduled === -1) this.requestScheduled = self.performance.now();
    // Loading is handled by the subclasses
    }
    shouldLoadPlaylist(playlist) {
        return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
    }
    shouldReloadPlaylist(playlist) {
        return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(playlist);
    }
    playlistLoaded(index, data, previousDetails) {
        const { details: details, stats: stats } = data;
        // Set last updated date-time
        const now = self.performance.now();
        const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
        details.advancedDateTime = Date.now() - elapsed;
        // if current playlist is a live playlist, arm a timer to reload it
        if (details.live || previousDetails != null && previousDetails.live) {
            details.reloaded(previousDetails);
            if (previousDetails) this.log(`live playlist ${index} ${details.advanced ? "REFRESHED " + details.lastPartSn + "-" + details.lastPartIndex : "MISSED"}`);
            // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
            if (previousDetails && details.fragments.length > 0) $fada8102d2a280be$var$mergeDetails(previousDetails, details);
            if (!this.canLoad || !details.live) return;
            let deliveryDirectives;
            let msn = undefined;
            let part = undefined;
            if (details.canBlockReload && details.endSN && details.advanced) {
                // Load level with LL-HLS delivery directives
                const lowLatencyMode = this.hls.config.lowLatencyMode;
                const lastPartSn = details.lastPartSn;
                const endSn = details.endSN;
                const lastPartIndex = details.lastPartIndex;
                const hasParts = lastPartIndex !== -1;
                const lastPart = lastPartSn === endSn;
                // When low latency mode is disabled, we'll skip part requests once the last part index is found
                const nextSnStartIndex = lowLatencyMode ? 0 : lastPartIndex;
                if (hasParts) {
                    msn = lastPart ? endSn + 1 : lastPartSn;
                    part = lastPart ? nextSnStartIndex : lastPartIndex + 1;
                } else msn = endSn + 1;
                // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
                // Update directives to obtain the Playlist that has the estimated additional duration of media
                const lastAdvanced = details.age;
                const cdnAge = lastAdvanced + details.ageHeader;
                let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
                if (currentGoal > 0) {
                    if (previousDetails && currentGoal > previousDetails.tuneInGoal) {
                        // If we attempted to get the next or latest playlist update, but currentGoal increased,
                        // then we either can't catchup, or the "age" header cannot be trusted.
                        this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
                        currentGoal = 0;
                    } else {
                        const segments = Math.floor(currentGoal / details.targetduration);
                        msn += segments;
                        if (part !== undefined) {
                            const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
                            part += parts;
                        }
                        this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
                    }
                    details.tuneInGoal = currentGoal;
                }
                deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
                if (lowLatencyMode || !lastPart) {
                    this.loadPlaylist(deliveryDirectives);
                    return;
                }
            } else if (details.canBlockReload) deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
            const bufferInfo = this.hls.mainForwardBufferInfo;
            const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
            const distanceToLiveEdgeMs = (details.edge - position) * 1000;
            const reloadInterval = $fada8102d2a280be$var$computeReloadInterval(details, distanceToLiveEdgeMs);
            if (details.updated && now > this.requestScheduled + reloadInterval) this.requestScheduled = stats.loading.start;
            if (msn !== undefined && details.canBlockReload) this.requestScheduled = stats.loading.first + reloadInterval - (details.partTarget * 1000 || 1000);
            else if (this.requestScheduled === -1 || this.requestScheduled + reloadInterval < now) this.requestScheduled = now;
            else if (this.requestScheduled - now <= 0) this.requestScheduled += reloadInterval;
            let estimatedTimeUntilUpdate = this.requestScheduled - now;
            estimatedTimeUntilUpdate = Math.max(0, estimatedTimeUntilUpdate);
            this.log(`reload live playlist ${index} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
            // this.log(
            //   `live reload ${details.updated ? 'REFRESHED' : 'MISSED'}
            // reload in ${estimatedTimeUntilUpdate / 1000}
            // round trip ${(stats.loading.end - stats.loading.start) / 1000}
            // diff ${
            //   (reloadInterval -
            //     (estimatedTimeUntilUpdate +
            //       stats.loading.end -
            //       stats.loading.start)) /
            //   1000
            // }
            // reload interval ${reloadInterval / 1000}
            // target duration ${details.targetduration}
            // distance to edge ${distanceToLiveEdgeMs / 1000}`
            // );
            this.timer = self.setTimeout(()=>this.loadPlaylist(deliveryDirectives), estimatedTimeUntilUpdate);
        } else this.clearTimer();
    }
    getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
        let skip = $fada8102d2a280be$var$getSkipValue(details, msn);
        if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
            msn = previousDeliveryDirectives.msn;
            part = previousDeliveryDirectives.part;
            skip = $fada8102d2a280be$var$HlsSkip.No;
        }
        return new $fada8102d2a280be$var$HlsUrlParameters(msn, part, skip);
    }
    checkRetry(errorEvent) {
        const errorDetails = errorEvent.details;
        const isTimeout = $fada8102d2a280be$var$isTimeoutError(errorEvent);
        const errorAction = errorEvent.errorAction;
        const { action: action, retryCount: retryCount = 0, retryConfig: retryConfig } = errorAction || {};
        const retry = !!errorAction && !!retryConfig && (action === $fada8102d2a280be$var$NetworkErrorAction.RetryRequest || !errorAction.resolved && action === $fada8102d2a280be$var$NetworkErrorAction.SendAlternateToPenaltyBox);
        if (retry) {
            var _errorEvent$context;
            this.requestScheduled = -1;
            if (retryCount >= retryConfig.maxNumRetry) return false;
            if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
                // The LL-HLS request already timed out so retry immediately
                this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
                this.loadPlaylist();
            } else {
                const delay = $fada8102d2a280be$var$getRetryDelay(retryConfig, retryCount);
                // Schedule level/track reload
                this.timer = self.setTimeout(()=>this.loadPlaylist(), delay);
                this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
            }
            // `levelRetry = true` used to inform other controllers that a retry is happening
            errorEvent.levelRetry = true;
            errorAction.resolved = true;
        }
        return retry;
    }
}
let $fada8102d2a280be$var$chromeOrFirefox;
class $fada8102d2a280be$var$LevelController extends $fada8102d2a280be$var$BasePlaylistController {
    constructor(hls, contentSteeringController){
        super(hls, "[level-controller]");
        this._levels = [];
        this._firstLevel = -1;
        this._startLevel = void 0;
        this.currentLevel = null;
        this.currentLevelIndex = -1;
        this.manualLevelIndex = -1;
        this.steering = void 0;
        this.onParsedComplete = void 0;
        this.steering = contentSteeringController;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($fada8102d2a280be$var$Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($fada8102d2a280be$var$Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    destroy() {
        this._unregisterListeners();
        this.steering = null;
        this.resetLevels();
        super.destroy();
    }
    startLoad() {
        const levels = this._levels;
        // clean up live level details to force reload them, and reset load errors
        levels.forEach((level)=>{
            level.loadError = 0;
            level.fragmentError = 0;
        });
        super.startLoad();
    }
    resetLevels() {
        this._startLevel = undefined;
        this.manualLevelIndex = -1;
        this.currentLevelIndex = -1;
        this.currentLevel = null;
        this._levels = [];
    }
    onManifestLoading(event, data) {
        this.resetLevels();
    }
    onManifestLoaded(event, data) {
        const levels = [];
        const levelSet = {};
        let levelFromSet;
        // regroup redundant levels together
        data.levels.forEach((levelParsed)=>{
            var _levelParsed$audioCod;
            const attributes = levelParsed.attrs;
            // erase audio codec info if browser does not support mp4a.40.34.
            // demuxer will autodetect codec and fallback to mpeg/audio
            if (((_levelParsed$audioCod = levelParsed.audioCodec) == null ? void 0 : _levelParsed$audioCod.indexOf("mp4a.40.34")) !== -1) {
                $fada8102d2a280be$var$chromeOrFirefox || ($fada8102d2a280be$var$chromeOrFirefox = /chrome|firefox/i.test(navigator.userAgent));
                if ($fada8102d2a280be$var$chromeOrFirefox) levelParsed.audioCodec = undefined;
            }
            const { AUDIO: AUDIO, CODECS: CODECS, "FRAME-RATE": FRAMERATE, "PATHWAY-ID": PATHWAY, RESOLUTION: RESOLUTION, SUBTITLES: SUBTITLES } = attributes;
            const contentSteeringPrefix = `${PATHWAY || "."}-`;
            const levelKey = `${contentSteeringPrefix}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}`;
            levelFromSet = levelSet[levelKey];
            if (!levelFromSet) {
                levelFromSet = new $fada8102d2a280be$var$Level(levelParsed);
                levelSet[levelKey] = levelFromSet;
                levels.push(levelFromSet);
            } else levelFromSet.addFallback(levelParsed);
            $fada8102d2a280be$var$addGroupId(levelFromSet, "audio", AUDIO);
            $fada8102d2a280be$var$addGroupId(levelFromSet, "text", SUBTITLES);
        });
        this.filterAndSortMediaOptions(levels, data);
    }
    filterAndSortMediaOptions(unfilteredLevels, data) {
        let audioTracks = [];
        let subtitleTracks = [];
        let resolutionFound = false;
        let videoCodecFound = false;
        let audioCodecFound = false;
        // only keep levels with supported audio/video codecs
        let levels = unfilteredLevels.filter(({ audioCodec: audioCodec, videoCodec: videoCodec, width: width, height: height, unknownCodecs: unknownCodecs })=>{
            resolutionFound || (resolutionFound = !!(width && height));
            videoCodecFound || (videoCodecFound = !!videoCodec);
            audioCodecFound || (audioCodecFound = !!audioCodec);
            return !(unknownCodecs != null && unknownCodecs.length) && (!audioCodec || $fada8102d2a280be$var$isCodecSupportedInMp4(audioCodec, "audio")) && (!videoCodec || $fada8102d2a280be$var$isCodecSupportedInMp4(videoCodec, "video"));
        });
        // remove audio-only level if we also have levels with video codecs or RESOLUTION signalled
        if ((resolutionFound || videoCodecFound) && audioCodecFound) levels = levels.filter(({ videoCodec: videoCodec, width: width, height: height })=>!!videoCodec || !!(width && height));
        if (levels.length === 0) {
            // Dispatch error after MANIFEST_LOADED is done propagating
            Promise.resolve().then(()=>{
                if (this.hls) {
                    const error = new Error("no level with compatible codecs found in manifest");
                    this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                        type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                        fatal: true,
                        url: data.url,
                        error: error,
                        reason: error.message
                    });
                }
            });
            return;
        }
        if (data.audioTracks) {
            audioTracks = data.audioTracks.filter((track)=>!track.audioCodec || $fada8102d2a280be$var$isCodecSupportedInMp4(track.audioCodec, "audio"));
            // Assign ids after filtering as array indices by group-id
            $fada8102d2a280be$var$assignTrackIdsByGroup(audioTracks);
        }
        if (data.subtitles) {
            subtitleTracks = data.subtitles;
            $fada8102d2a280be$var$assignTrackIdsByGroup(subtitleTracks);
        }
        // start bitrate is the first bitrate of the manifest
        const unsortedLevels = levels.slice(0);
        // sort levels from lowest to highest
        levels.sort((a, b)=>{
            if (a.attrs["HDCP-LEVEL"] !== b.attrs["HDCP-LEVEL"]) return (a.attrs["HDCP-LEVEL"] || "") > (b.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
            if (a.bitrate !== b.bitrate) return a.bitrate - b.bitrate;
            if (a.attrs["FRAME-RATE"] !== b.attrs["FRAME-RATE"]) return a.attrs.decimalFloatingPoint("FRAME-RATE") - b.attrs.decimalFloatingPoint("FRAME-RATE");
            if (a.attrs.SCORE !== b.attrs.SCORE) return a.attrs.decimalFloatingPoint("SCORE") - b.attrs.decimalFloatingPoint("SCORE");
            if (resolutionFound && a.height !== b.height) return a.height - b.height;
            return 0;
        });
        let firstLevelInPlaylist = unsortedLevels[0];
        if (this.steering) {
            levels = this.steering.filterParsedLevels(levels);
            if (levels.length !== unsortedLevels.length) {
                for(let i = 0; i < unsortedLevels.length; i++)if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
                    firstLevelInPlaylist = unsortedLevels[i];
                    break;
                }
            }
        }
        this._levels = levels;
        // find index of first level in sorted levels
        for(let i = 0; i < levels.length; i++)if (levels[i] === firstLevelInPlaylist) {
            this._firstLevel = i;
            this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelInPlaylist.bitrate}`);
            break;
        }
        // Audio is only alternate if manifest include a URI along with the audio group tag,
        // and this is not an audio-only stream where levels contain audio-only
        const audioOnly = audioCodecFound && !videoCodecFound;
        const edata = {
            levels: levels,
            audioTracks: audioTracks,
            subtitleTracks: subtitleTracks,
            sessionData: data.sessionData,
            sessionKeys: data.sessionKeys,
            firstLevel: this._firstLevel,
            stats: data.stats,
            audio: audioCodecFound,
            video: videoCodecFound,
            altAudio: !audioOnly && audioTracks.some((t)=>!!t.url)
        };
        this.hls.trigger($fada8102d2a280be$var$Events.MANIFEST_PARSED, edata);
        // Initiate loading after all controllers have received MANIFEST_PARSED
        if (this.hls.config.autoStartLoad || this.hls.forceStartLoad) this.hls.startLoad(this.hls.config.startPosition);
    }
    get levels() {
        if (this._levels.length === 0) return null;
        return this._levels;
    }
    get level() {
        return this.currentLevelIndex;
    }
    set level(newLevel) {
        const levels = this._levels;
        if (levels.length === 0) return;
        // check if level idx is valid
        if (newLevel < 0 || newLevel >= levels.length) {
            // invalid level id given, trigger error
            const error = new Error("invalid level idx");
            const fatal = newLevel < 0;
            this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.OTHER_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.LEVEL_SWITCH_ERROR,
                level: newLevel,
                fatal: fatal,
                error: error,
                reason: error.message
            });
            if (fatal) return;
            newLevel = Math.min(newLevel, levels.length - 1);
        }
        const lastLevelIndex = this.currentLevelIndex;
        const lastLevel = this.currentLevel;
        const lastPathwayId = lastLevel ? lastLevel.attrs["PATHWAY-ID"] : undefined;
        const level = levels[newLevel];
        const pathwayId = level.attrs["PATHWAY-ID"];
        this.currentLevelIndex = newLevel;
        this.currentLevel = level;
        if (lastLevelIndex === newLevel && level.details && lastLevel && lastPathwayId === pathwayId) return;
        this.log(`Switching to level ${newLevel}${pathwayId ? " with Pathway " + pathwayId : ""} from level ${lastLevelIndex}${lastPathwayId ? " with Pathway " + lastPathwayId : ""}`);
        const levelSwitchingData = $fada8102d2a280be$var$_extends({}, level, {
            level: newLevel,
            maxBitrate: level.maxBitrate,
            attrs: level.attrs,
            uri: level.uri,
            urlId: level.urlId
        });
        // @ts-ignore
        delete levelSwitchingData._attrs;
        // @ts-ignore
        delete levelSwitchingData._urlId;
        this.hls.trigger($fada8102d2a280be$var$Events.LEVEL_SWITCHING, levelSwitchingData);
        // check if we need to load playlist for this level
        const levelDetails = level.details;
        if (!levelDetails || levelDetails.live) {
            // level not retrieved yet, or live playlist we need to (re)load it
            const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details);
            this.loadPlaylist(hlsUrlParameters);
        }
    }
    get manualLevel() {
        return this.manualLevelIndex;
    }
    set manualLevel(newLevel) {
        this.manualLevelIndex = newLevel;
        if (this._startLevel === undefined) this._startLevel = newLevel;
        if (newLevel !== -1) this.level = newLevel;
    }
    get firstLevel() {
        return this._firstLevel;
    }
    set firstLevel(newLevel) {
        this._firstLevel = newLevel;
    }
    get startLevel() {
        // hls.startLevel takes precedence over config.startLevel
        // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
        if (this._startLevel === undefined) {
            const configStartLevel = this.hls.config.startLevel;
            if (configStartLevel !== undefined) return configStartLevel;
            else return this._firstLevel;
        } else return this._startLevel;
    }
    set startLevel(newLevel) {
        this._startLevel = newLevel;
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $fada8102d2a280be$var$PlaylistContextType.LEVEL && data.context.level === this.level) this.checkRetry(data);
    }
    // reset errors on the successful load of a fragment
    onFragLoaded(event, { frag: frag }) {
        if (frag !== undefined && frag.type === $fada8102d2a280be$var$PlaylistLevelType.MAIN) {
            const level = this._levels[frag.level];
            if (level !== undefined) level.loadError = 0;
        }
    }
    onLevelLoaded(event, data) {
        var _data$deliveryDirecti2;
        const { level: level, details: details } = data;
        const curLevel = this._levels[level];
        if (!curLevel) {
            var _data$deliveryDirecti;
            this.warn(`Invalid level index ${level}`);
            if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) details.deltaUpdateFailed = true;
            return;
        }
        // only process level loaded events matching with expected level
        if (level === this.currentLevelIndex) {
            // reset level load error counter on successful level loaded only if there is no issues with fragments
            if (curLevel.fragmentError === 0) curLevel.loadError = 0;
            this.playlistLoaded(level, data, curLevel.details);
        } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) // received a delta playlist update that cannot be merged
        details.deltaUpdateFailed = true;
    }
    onAudioTrackSwitched(event, data) {
        const currentLevel = this.currentLevel;
        if (!currentLevel) return;
        const audioGroupId = this.hls.audioTracks[data.id].groupId;
        if (currentLevel.audioGroupIds && currentLevel.audioGroupId !== audioGroupId) {
            let urlId = -1;
            for(let i = 0; i < currentLevel.audioGroupIds.length; i++)if (currentLevel.audioGroupIds[i] === audioGroupId) {
                urlId = i;
                break;
            }
            if (urlId !== -1 && urlId !== currentLevel.urlId) {
                currentLevel.urlId = urlId;
                if (this.canLoad) this.startLoad();
            }
        }
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        const currentLevelIndex = this.currentLevelIndex;
        const currentLevel = this.currentLevel;
        if (currentLevel && this.shouldLoadPlaylist(currentLevel)) {
            const id = currentLevel.urlId;
            let url = currentLevel.uri;
            if (hlsUrlParameters) try {
                url = hlsUrlParameters.addDirectives(url);
            } catch (error) {
                this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
            }
            const pathwayId = currentLevel.attrs["PATHWAY-ID"];
            this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? " at sn " + hlsUrlParameters.msn + " part " + hlsUrlParameters.part : ""} with${pathwayId ? " Pathway " + pathwayId : ""} URI ${id + 1}/${currentLevel.url.length} ${url}`);
            // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
            // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
            this.clearTimer();
            this.hls.trigger($fada8102d2a280be$var$Events.LEVEL_LOADING, {
                url: url,
                level: currentLevelIndex,
                id: id,
                deliveryDirectives: hlsUrlParameters || null
            });
        }
    }
    get nextLoadLevel() {
        if (this.manualLevelIndex !== -1) return this.manualLevelIndex;
        else return this.hls.nextAutoLevel;
    }
    set nextLoadLevel(nextLevel) {
        this.level = nextLevel;
        if (this.manualLevelIndex === -1) this.hls.nextAutoLevel = nextLevel;
    }
    removeLevel(levelIndex, urlId) {
        const filterLevelAndGroupByIdIndex = (url, id)=>id !== urlId;
        const levels = this._levels.filter((level, index)=>{
            if (index !== levelIndex) return true;
            if (level.url.length > 1 && urlId !== undefined) {
                level.url = level.url.filter(filterLevelAndGroupByIdIndex);
                if (level.audioGroupIds) level.audioGroupIds = level.audioGroupIds.filter(filterLevelAndGroupByIdIndex);
                if (level.textGroupIds) level.textGroupIds = level.textGroupIds.filter(filterLevelAndGroupByIdIndex);
                level.urlId = 0;
                return true;
            }
            if (this.steering) this.steering.removeLevel(level);
            return false;
        });
        this.hls.trigger($fada8102d2a280be$var$Events.LEVELS_UPDATED, {
            levels: levels
        });
    }
    onLevelsUpdated(event, { levels: levels }) {
        levels.forEach((level, index)=>{
            const { details: details } = level;
            if (details != null && details.fragments) details.fragments.forEach((fragment)=>{
                fragment.level = index;
            });
        });
        this._levels = levels;
    }
}
function $fada8102d2a280be$var$addGroupId(level, type, id) {
    if (!id) return;
    if (type === "audio") {
        if (!level.audioGroupIds) level.audioGroupIds = [];
        level.audioGroupIds[level.url.length - 1] = id;
    } else if (type === "text") {
        if (!level.textGroupIds) level.textGroupIds = [];
        level.textGroupIds[level.url.length - 1] = id;
    }
}
function $fada8102d2a280be$var$assignTrackIdsByGroup(tracks) {
    const groups = {};
    tracks.forEach((track)=>{
        const groupId = track.groupId || "";
        track.id = groups[groupId] = groups[groupId] || 0;
        groups[groupId]++;
    });
}
var $fada8102d2a280be$var$FragmentState = {
    NOT_LOADED: "NOT_LOADED",
    APPENDING: "APPENDING",
    PARTIAL: "PARTIAL",
    OK: "OK"
};
class $fada8102d2a280be$var$FragmentTracker {
    constructor(hls){
        this.activePartLists = Object.create(null);
        this.endListFragments = Object.create(null);
        this.fragments = Object.create(null);
        this.timeRanges = Object.create(null);
        this.bufferPadding = 0.2;
        this.hls = void 0;
        this.hasGaps = false;
        this.hls = hls;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.BUFFER_APPENDED, this.onBufferAppended, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_LOADED, this.onFragLoaded, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.BUFFER_APPENDED, this.onBufferAppended, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_LOADED, this.onFragLoaded, this);
    }
    destroy() {
        this._unregisterListeners();
        // @ts-ignore
        this.fragments = // @ts-ignore
        this.activePartLists = // @ts-ignore
        this.endListFragments = this.timeRanges = null;
    }
    /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */ getAppendedFrag(position, levelType) {
        const activeParts = this.activePartLists[levelType];
        if (activeParts) for(let i = activeParts.length; i--;){
            const activePart = activeParts[i];
            if (!activePart) break;
            const appendedPTS = activePart.end;
            if (activePart.start <= position && appendedPTS !== null && position <= appendedPTS) return activePart;
        }
        return this.getBufferedFrag(position, levelType);
    }
    /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */ getBufferedFrag(position, levelType) {
        const { fragments: fragments } = this;
        const keys = Object.keys(fragments);
        for(let i = keys.length; i--;){
            const fragmentEntity = fragments[keys[i]];
            if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && fragmentEntity.buffered) {
                const frag = fragmentEntity.body;
                if (frag.start <= position && position <= frag.end) return frag;
            }
        }
        return null;
    }
    /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */ detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart) {
        if (this.timeRanges) this.timeRanges[elementaryStream] = timeRange;
        // Check if any flagged fragments have been unloaded
        // excluding anything newer than appendedPartSn
        const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
        Object.keys(this.fragments).forEach((key)=>{
            const fragmentEntity = this.fragments[key];
            if (!fragmentEntity) return;
            if (appendedPartSn >= fragmentEntity.body.sn) return;
            if (!fragmentEntity.buffered && !fragmentEntity.loaded) {
                if (fragmentEntity.body.type === playlistType) this.removeFragment(fragmentEntity.body);
                return;
            }
            const esData = fragmentEntity.range[elementaryStream];
            if (!esData) return;
            esData.time.some((time)=>{
                const isNotBuffered = !this.isTimeBuffered(time.startPTS, time.endPTS, timeRange);
                if (isNotBuffered) // Unregister partial fragment as it needs to load again to be reused
                this.removeFragment(fragmentEntity.body);
                return isNotBuffered;
            });
        });
    }
    /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */ detectPartialFragments(data) {
        const timeRanges = this.timeRanges;
        const { frag: frag, part: part } = data;
        if (!timeRanges || frag.sn === "initSegment") return;
        const fragKey = $fada8102d2a280be$var$getFragmentKey(frag);
        const fragmentEntity = this.fragments[fragKey];
        if (!fragmentEntity) return;
        const isFragHint = !frag.relurl;
        Object.keys(timeRanges).forEach((elementaryStream)=>{
            const streamInfo = frag.elementaryStreams[elementaryStream];
            if (!streamInfo) return;
            const timeRange = timeRanges[elementaryStream];
            const partial = isFragHint || streamInfo.partial === true;
            fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, part, partial, timeRange);
        });
        fragmentEntity.loaded = null;
        if (Object.keys(fragmentEntity.range).length) {
            fragmentEntity.buffered = true;
            if (fragmentEntity.body.endList) this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
            if (!$fada8102d2a280be$var$isPartial(fragmentEntity)) // Remove older fragment parts from lookup after frag is tracked as buffered
            this.removeParts(frag.sn - 1, frag.type);
        } else // remove fragment if nothing was appended
        this.removeFragment(fragmentEntity.body);
    }
    removeParts(snToKeep, levelType) {
        const activeParts = this.activePartLists[levelType];
        if (!activeParts) return;
        this.activePartLists[levelType] = activeParts.filter((part)=>part.fragment.sn >= snToKeep);
    }
    fragBuffered(frag, force) {
        const fragKey = $fada8102d2a280be$var$getFragmentKey(frag);
        let fragmentEntity = this.fragments[fragKey];
        if (!fragmentEntity && force) {
            fragmentEntity = this.fragments[fragKey] = {
                body: frag,
                appendedPTS: null,
                loaded: null,
                buffered: false,
                range: Object.create(null)
            };
            if (frag.gap) this.hasGaps = true;
        }
        if (fragmentEntity) {
            fragmentEntity.loaded = null;
            fragmentEntity.buffered = true;
        }
    }
    getBufferedTimes(fragment, part, partial, timeRange) {
        const buffered = {
            time: [],
            partial: partial
        };
        const startPTS = fragment.start;
        const endPTS = fragment.end;
        const minEndPTS = fragment.minEndPTS || endPTS;
        const maxStartPTS = fragment.maxStartPTS || startPTS;
        for(let i = 0; i < timeRange.length; i++){
            const startTime = timeRange.start(i) - this.bufferPadding;
            const endTime = timeRange.end(i) + this.bufferPadding;
            if (maxStartPTS >= startTime && minEndPTS <= endTime) {
                // Fragment is entirely contained in buffer
                // No need to check the other timeRange times since it's completely playable
                buffered.time.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
                break;
            } else if (startPTS < endTime && endPTS > startTime) {
                buffered.partial = true;
                // Check for intersection with buffer
                // Get playable sections of the fragment
                buffered.time.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
            } else if (endPTS <= startTime) break;
        }
        return buffered;
    }
    /**
   * Gets the partial fragment for a certain time
   */ getPartialFragment(time) {
        let bestFragment = null;
        let timePadding;
        let startTime;
        let endTime;
        let bestOverlap = 0;
        const { bufferPadding: bufferPadding, fragments: fragments } = this;
        Object.keys(fragments).forEach((key)=>{
            const fragmentEntity = fragments[key];
            if (!fragmentEntity) return;
            if ($fada8102d2a280be$var$isPartial(fragmentEntity)) {
                startTime = fragmentEntity.body.start - bufferPadding;
                endTime = fragmentEntity.body.end + bufferPadding;
                if (time >= startTime && time <= endTime) {
                    // Use the fragment that has the most padding from start and end time
                    timePadding = Math.min(time - startTime, endTime - time);
                    if (bestOverlap <= timePadding) {
                        bestFragment = fragmentEntity.body;
                        bestOverlap = timePadding;
                    }
                }
            }
        });
        return bestFragment;
    }
    isEndListAppended(type) {
        const lastFragmentEntity = this.endListFragments[type];
        return lastFragmentEntity !== undefined && (lastFragmentEntity.buffered || $fada8102d2a280be$var$isPartial(lastFragmentEntity));
    }
    getState(fragment) {
        const fragKey = $fada8102d2a280be$var$getFragmentKey(fragment);
        const fragmentEntity = this.fragments[fragKey];
        if (fragmentEntity) {
            if (!fragmentEntity.buffered) return $fada8102d2a280be$var$FragmentState.APPENDING;
            else if ($fada8102d2a280be$var$isPartial(fragmentEntity)) return $fada8102d2a280be$var$FragmentState.PARTIAL;
            else return $fada8102d2a280be$var$FragmentState.OK;
        }
        return $fada8102d2a280be$var$FragmentState.NOT_LOADED;
    }
    isTimeBuffered(startPTS, endPTS, timeRange) {
        let startTime;
        let endTime;
        for(let i = 0; i < timeRange.length; i++){
            startTime = timeRange.start(i) - this.bufferPadding;
            endTime = timeRange.end(i) + this.bufferPadding;
            if (startPTS >= startTime && endPTS <= endTime) return true;
            if (endPTS <= startTime) // No need to check the rest of the timeRange as it is in order
            return false;
        }
        return false;
    }
    onFragLoaded(event, data) {
        const { frag: frag, part: part } = data;
        // don't track initsegment (for which sn is not a number)
        // don't track frags used for bitrateTest, they're irrelevant.
        if (frag.sn === "initSegment" || frag.bitrateTest) return;
        // Fragment entity `loaded` FragLoadedData is null when loading parts
        const loaded = part ? null : data;
        const fragKey = $fada8102d2a280be$var$getFragmentKey(frag);
        this.fragments[fragKey] = {
            body: frag,
            appendedPTS: null,
            loaded: loaded,
            buffered: false,
            range: Object.create(null)
        };
    }
    onBufferAppended(event, data) {
        const { frag: frag, part: part, timeRanges: timeRanges } = data;
        if (frag.sn === "initSegment") return;
        const playlistType = frag.type;
        if (part) {
            let activeParts = this.activePartLists[playlistType];
            if (!activeParts) this.activePartLists[playlistType] = activeParts = [];
            activeParts.push(part);
        }
        // Store the latest timeRanges loaded in the buffer
        this.timeRanges = timeRanges;
        Object.keys(timeRanges).forEach((elementaryStream)=>{
            const timeRange = timeRanges[elementaryStream];
            this.detectEvictedFragments(elementaryStream, timeRange, playlistType, part);
        });
    }
    onFragBuffered(event, data) {
        this.detectPartialFragments(data);
    }
    hasFragment(fragment) {
        const fragKey = $fada8102d2a280be$var$getFragmentKey(fragment);
        return !!this.fragments[fragKey];
    }
    hasParts(type) {
        var _this$activePartLists;
        return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
    }
    removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
        if (withGapOnly && !this.hasGaps) return;
        Object.keys(this.fragments).forEach((key)=>{
            const fragmentEntity = this.fragments[key];
            if (!fragmentEntity) return;
            const frag = fragmentEntity.body;
            if (frag.type !== playlistType || withGapOnly && !frag.gap) return;
            if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) this.removeFragment(frag);
        });
    }
    removeFragment(fragment) {
        const fragKey = $fada8102d2a280be$var$getFragmentKey(fragment);
        fragment.stats.loaded = 0;
        fragment.clearElementaryStreamInfo();
        const activeParts = this.activePartLists[fragment.type];
        if (activeParts) {
            const snToRemove = fragment.sn;
            this.activePartLists[fragment.type] = activeParts.filter((part)=>part.fragment.sn !== snToRemove);
        }
        delete this.fragments[fragKey];
        if (fragment.endList) delete this.endListFragments[fragment.type];
    }
    removeAllFragments() {
        this.fragments = Object.create(null);
        this.endListFragments = Object.create(null);
        this.activePartLists = Object.create(null);
        this.hasGaps = false;
    }
}
function $fada8102d2a280be$var$isPartial(fragmentEntity) {
    var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
    return fragmentEntity.buffered && (fragmentEntity.body.gap || ((_fragmentEntity$range = fragmentEntity.range.video) == null ? void 0 : _fragmentEntity$range.partial) || ((_fragmentEntity$range2 = fragmentEntity.range.audio) == null ? void 0 : _fragmentEntity$range2.partial) || ((_fragmentEntity$range3 = fragmentEntity.range.audiovideo) == null ? void 0 : _fragmentEntity$range3.partial));
}
function $fada8102d2a280be$var$getFragmentKey(fragment) {
    return `${fragment.type}_${fragment.level}_${fragment.urlId}_${fragment.sn}`;
}
const $fada8102d2a280be$var$MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb
class $fada8102d2a280be$var$FragmentLoader {
    constructor(config){
        this.config = void 0;
        this.loader = null;
        this.partLoadTimeout = -1;
        this.config = config;
    }
    destroy() {
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
    }
    abort() {
        if (this.loader) // Abort the loader for current fragment. Only one may load at any given time
        this.loader.abort();
    }
    load(frag, onProgress) {
        const url = frag.url;
        if (!url) return Promise.reject(new $fada8102d2a280be$var$LoadError({
            type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
            details: $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag: frag,
            error: new Error(`Fragment does not have a ${url ? "part list" : "url"}`),
            networkDetails: null
        }));
        this.abort();
        const config = this.config;
        const FragmentILoader = config.fLoader;
        const DefaultILoader = config.loader;
        return new Promise((resolve, reject)=>{
            if (this.loader) this.loader.destroy();
            if (frag.gap) {
                reject($fada8102d2a280be$var$createGapLoadError(frag));
                return;
            }
            const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
            const loaderContext = $fada8102d2a280be$var$createLoaderContext(frag);
            const loadPolicy = $fada8102d2a280be$var$getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0,
                highWaterMark: frag.sn === "initSegment" ? Infinity : $fada8102d2a280be$var$MIN_CHUNK_SIZE
            };
            // Assign frag stats to the loader's stats reference
            frag.stats = loader.stats;
            loader.load(loaderContext, loaderConfig, {
                onSuccess: (response, stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    let payload = response.data;
                    if (context.resetIV && frag.decryptdata) {
                        frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
                        payload = payload.slice(16);
                    }
                    resolve({
                        frag: frag,
                        part: null,
                        payload: payload,
                        networkDetails: networkDetails
                    });
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(frag, loader);
                    reject(new $fada8102d2a280be$var$LoadError({
                        type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_ERROR,
                        fatal: false,
                        frag: frag,
                        response: $fada8102d2a280be$var$_objectSpread2({
                            url: url,
                            data: undefined
                        }, response),
                        error: new Error(`HTTP Error ${response.code} ${response.text}`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onAbort: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $fada8102d2a280be$var$LoadError({
                        type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.INTERNAL_ABORTED,
                        fatal: false,
                        frag: frag,
                        error: new Error("Aborted"),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $fada8102d2a280be$var$LoadError({
                        type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_TIMEOUT,
                        fatal: false,
                        frag: frag,
                        error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onProgress: (stats, context, data, networkDetails)=>{
                    if (onProgress) onProgress({
                        frag: frag,
                        part: null,
                        payload: data,
                        networkDetails: networkDetails
                    });
                }
            });
        });
    }
    loadPart(frag, part, onProgress) {
        this.abort();
        const config = this.config;
        const FragmentILoader = config.fLoader;
        const DefaultILoader = config.loader;
        return new Promise((resolve, reject)=>{
            if (this.loader) this.loader.destroy();
            if (frag.gap || part.gap) {
                reject($fada8102d2a280be$var$createGapLoadError(frag, part));
                return;
            }
            const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
            const loaderContext = $fada8102d2a280be$var$createLoaderContext(frag, part);
            // Should we define another load policy for parts?
            const loadPolicy = $fada8102d2a280be$var$getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0,
                highWaterMark: $fada8102d2a280be$var$MIN_CHUNK_SIZE
            };
            // Assign part stats to the loader's stats reference
            part.stats = loader.stats;
            loader.load(loaderContext, loaderConfig, {
                onSuccess: (response, stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    this.updateStatsFromPart(frag, part);
                    const partLoadedData = {
                        frag: frag,
                        part: part,
                        payload: response.data,
                        networkDetails: networkDetails
                    };
                    onProgress(partLoadedData);
                    resolve(partLoadedData);
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(frag, loader);
                    reject(new $fada8102d2a280be$var$LoadError({
                        type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_ERROR,
                        fatal: false,
                        frag: frag,
                        part: part,
                        response: $fada8102d2a280be$var$_objectSpread2({
                            url: loaderContext.url,
                            data: undefined
                        }, response),
                        error: new Error(`HTTP Error ${response.code} ${response.text}`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onAbort: (stats, context, networkDetails)=>{
                    frag.stats.aborted = part.stats.aborted;
                    this.resetLoader(frag, loader);
                    reject(new $fada8102d2a280be$var$LoadError({
                        type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.INTERNAL_ABORTED,
                        fatal: false,
                        frag: frag,
                        part: part,
                        error: new Error("Aborted"),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $fada8102d2a280be$var$LoadError({
                        type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_TIMEOUT,
                        fatal: false,
                        frag: frag,
                        part: part,
                        error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                }
            });
        });
    }
    updateStatsFromPart(frag, part) {
        const fragStats = frag.stats;
        const partStats = part.stats;
        const partTotal = partStats.total;
        fragStats.loaded += partStats.loaded;
        if (partTotal) {
            const estTotalParts = Math.round(frag.duration / part.duration);
            const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
            const estRemainingParts = estTotalParts - estLoadedParts;
            const estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
            fragStats.total = fragStats.loaded + estRemainingBytes;
        } else fragStats.total = Math.max(fragStats.loaded, fragStats.total);
        const fragLoading = fragStats.loading;
        const partLoading = partStats.loading;
        if (fragLoading.start) // add to fragment loader latency
        fragLoading.first += partLoading.first - partLoading.start;
        else {
            fragLoading.start = partLoading.start;
            fragLoading.first = partLoading.first;
        }
        fragLoading.end = partLoading.end;
    }
    resetLoader(frag, loader) {
        frag.loader = null;
        if (this.loader === loader) {
            self.clearTimeout(this.partLoadTimeout);
            this.loader = null;
        }
        loader.destroy();
    }
}
function $fada8102d2a280be$var$createLoaderContext(frag, part = null) {
    const segment = part || frag;
    const loaderContext = {
        frag: frag,
        part: part,
        responseType: "arraybuffer",
        url: segment.url,
        headers: {},
        rangeStart: 0,
        rangeEnd: 0
    };
    const start = segment.byteRangeStartOffset;
    const end = segment.byteRangeEndOffset;
    if ($fada8102d2a280be$var$isFiniteNumber(start) && $fada8102d2a280be$var$isFiniteNumber(end)) {
        var _frag$decryptdata;
        let byteRangeStart = start;
        let byteRangeEnd = end;
        if (frag.sn === "initSegment" && ((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method) === "AES-128") {
            // MAP segment encrypted with method 'AES-128', when served with HTTP Range,
            // has the unencrypted size specified in the range.
            // Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
            const fragmentLen = end - start;
            if (fragmentLen % 16) byteRangeEnd = end + (16 - fragmentLen % 16);
            if (start !== 0) {
                loaderContext.resetIV = true;
                byteRangeStart = start - 16;
            }
        }
        loaderContext.rangeStart = byteRangeStart;
        loaderContext.rangeEnd = byteRangeEnd;
    }
    return loaderContext;
}
function $fada8102d2a280be$var$createGapLoadError(frag, part) {
    const error = new Error(`GAP ${frag.gap ? "tag" : "attribute"} found`);
    const errorData = {
        type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
        details: $fada8102d2a280be$var$ErrorDetails.FRAG_GAP,
        fatal: false,
        frag: frag,
        error: error,
        networkDetails: null
    };
    if (part) errorData.part = part;
    (part ? part : frag).stats.aborted = true;
    return new $fada8102d2a280be$var$LoadError(errorData);
}
class $fada8102d2a280be$var$LoadError extends Error {
    constructor(data){
        super(data.error.message);
        this.data = void 0;
        this.data = data;
    }
}
class $fada8102d2a280be$var$KeyLoader {
    constructor(config){
        this.config = void 0;
        this.keyUriToKeyInfo = {};
        this.emeController = null;
        this.config = config;
    }
    abort(type) {
        for(const uri in this.keyUriToKeyInfo){
            const loader = this.keyUriToKeyInfo[uri].loader;
            if (loader) {
                if (type && type !== loader.context.frag.type) return;
                loader.abort();
            }
        }
    }
    detach() {
        for(const uri in this.keyUriToKeyInfo){
            const keyInfo = this.keyUriToKeyInfo[uri];
            // Remove cached EME keys on detach
            if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) delete this.keyUriToKeyInfo[uri];
        }
    }
    destroy() {
        this.detach();
        for(const uri in this.keyUriToKeyInfo){
            const loader = this.keyUriToKeyInfo[uri].loader;
            if (loader) loader.destroy();
        }
        this.keyUriToKeyInfo = {};
    }
    createKeyLoadError(frag, details = $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR, error, networkDetails, response) {
        return new $fada8102d2a280be$var$LoadError({
            type: $fada8102d2a280be$var$ErrorTypes.NETWORK_ERROR,
            details: details,
            fatal: false,
            frag: frag,
            response: response,
            error: error,
            networkDetails: networkDetails
        });
    }
    loadClear(loadingFrag, encryptedFragments) {
        if (this.emeController && this.config.emeEnabled) {
            // access key-system with nearest key on start (loaidng frag is unencrypted)
            const { sn: sn, cc: cc } = loadingFrag;
            for(let i = 0; i < encryptedFragments.length; i++){
                const frag = encryptedFragments[i];
                if (cc <= frag.cc && (sn === "initSegment" || frag.sn === "initSegment" || sn < frag.sn)) {
                    this.emeController.selectKeySystemFormat(frag).then((keySystemFormat)=>{
                        frag.setKeyFormat(keySystemFormat);
                    });
                    break;
                }
            }
        }
    }
    load(frag) {
        if (!frag.decryptdata && frag.encrypted && this.emeController) // Multiple keys, but none selected, resolve in eme-controller
        return this.emeController.selectKeySystemFormat(frag).then((keySystemFormat)=>{
            return this.loadInternal(frag, keySystemFormat);
        });
        return this.loadInternal(frag);
    }
    loadInternal(frag, keySystemFormat) {
        var _keyInfo, _keyInfo2;
        if (keySystemFormat) frag.setKeyFormat(keySystemFormat);
        const decryptdata = frag.decryptdata;
        if (!decryptdata) {
            const error = new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : "Missing decryption data on fragment in onKeyLoading");
            return Promise.reject(this.createKeyLoadError(frag, $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR, error));
        }
        const uri = decryptdata.uri;
        if (!uri) return Promise.reject(this.createKeyLoadError(frag, $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${uri}"`)));
        let keyInfo = this.keyUriToKeyInfo[uri];
        if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
            decryptdata.key = keyInfo.decryptdata.key;
            return Promise.resolve({
                frag: frag,
                keyInfo: keyInfo
            });
        }
        // Return key load promise as long as it does not have a mediakey session with an unusable key status
        if ((_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) {
            var _keyInfo$mediaKeySess;
            switch((_keyInfo$mediaKeySess = keyInfo.mediaKeySessionContext) == null ? void 0 : _keyInfo$mediaKeySess.keyStatus){
                case undefined:
                case "status-pending":
                case "usable":
                case "usable-in-future":
                    return keyInfo.keyLoadPromise.then((keyLoadedData)=>{
                        // Return the correct fragment with updated decryptdata key and loaded keyInfo
                        decryptdata.key = keyLoadedData.keyInfo.decryptdata.key;
                        return {
                            frag: frag,
                            keyInfo: keyInfo
                        };
                    });
            }
        // If we have a key session and status and it is not pending or usable, continue
        // This will go back to the eme-controller for expired keys to get a new keyLoadPromise
        }
        // Load the key or return the loading promise
        keyInfo = this.keyUriToKeyInfo[uri] = {
            decryptdata: decryptdata,
            keyLoadPromise: null,
            loader: null,
            mediaKeySessionContext: null
        };
        switch(decryptdata.method){
            case "ISO-23001-7":
            case "SAMPLE-AES":
            case "SAMPLE-AES-CENC":
            case "SAMPLE-AES-CTR":
                if (decryptdata.keyFormat === "identity") // loadKeyHTTP handles http(s) and data URLs
                return this.loadKeyHTTP(keyInfo, frag);
                return this.loadKeyEME(keyInfo, frag);
            case "AES-128":
                return this.loadKeyHTTP(keyInfo, frag);
            default:
                return Promise.reject(this.createKeyLoadError(frag, $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
        }
    }
    loadKeyEME(keyInfo, frag) {
        const keyLoadedData = {
            frag: frag,
            keyInfo: keyInfo
        };
        if (this.emeController && this.config.emeEnabled) {
            const keySessionContextPromise = this.emeController.loadKey(keyLoadedData);
            if (keySessionContextPromise) return (keyInfo.keyLoadPromise = keySessionContextPromise.then((keySessionContext)=>{
                keyInfo.mediaKeySessionContext = keySessionContext;
                return keyLoadedData;
            })).catch((error)=>{
                // Remove promise for license renewal or retry
                keyInfo.keyLoadPromise = null;
                throw error;
            });
        }
        return Promise.resolve(keyLoadedData);
    }
    loadKeyHTTP(keyInfo, frag) {
        const config = this.config;
        const Loader = config.loader;
        const keyLoader = new Loader(config);
        frag.keyLoader = keyInfo.loader = keyLoader;
        return keyInfo.keyLoadPromise = new Promise((resolve, reject)=>{
            const loaderContext = {
                keyInfo: keyInfo,
                frag: frag,
                responseType: "arraybuffer",
                url: keyInfo.decryptdata.uri
            };
            // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
            // key-loader will trigger an error and rely on stream-controller to handle retry logic.
            // this will also align retry logic with fragment-loader
            const loadPolicy = config.keyLoadPolicy.default;
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0
            };
            const loaderCallbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    const { frag: frag, keyInfo: keyInfo, url: uri } = context;
                    if (!frag.decryptdata || keyInfo !== this.keyUriToKeyInfo[uri]) return reject(this.createKeyLoadError(frag, $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), networkDetails));
                    keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);
                    // detach fragment key loader on load success
                    frag.keyLoader = null;
                    keyInfo.loader = null;
                    resolve({
                        frag: frag,
                        keyInfo: keyInfo
                    });
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR, new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, $fada8102d2a280be$var$_objectSpread2({
                        url: loaderContext.url,
                        data: undefined
                    }, response)));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), networkDetails));
                },
                onAbort: (stats, context, networkDetails)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $fada8102d2a280be$var$ErrorDetails.INTERNAL_ABORTED, new Error("key loading aborted"), networkDetails));
                }
            };
            keyLoader.load(loaderContext, loaderConfig, loaderCallbacks);
        });
    }
    resetLoader(context) {
        const { frag: frag, keyInfo: keyInfo, url: uri } = context;
        const loader = keyInfo.loader;
        if (frag.keyLoader === loader) {
            frag.keyLoader = null;
            keyInfo.loader = null;
        }
        delete this.keyUriToKeyInfo[uri];
        if (loader) loader.destroy();
    }
}
/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */ class $fada8102d2a280be$var$TaskLoop {
    constructor(){
        this._boundTick = void 0;
        this._tickTimer = null;
        this._tickInterval = null;
        this._tickCallCount = 0;
        this._boundTick = this.tick.bind(this);
    }
    destroy() {
        this.onHandlerDestroying();
        this.onHandlerDestroyed();
    }
    onHandlerDestroying() {
        // clear all timers before unregistering from event bus
        this.clearNextTick();
        this.clearInterval();
    }
    onHandlerDestroyed() {}
    hasInterval() {
        return !!this._tickInterval;
    }
    hasNextTick() {
        return !!this._tickTimer;
    }
    /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */ setInterval(millis) {
        if (!this._tickInterval) {
            this._tickCallCount = 0;
            this._tickInterval = self.setInterval(this._boundTick, millis);
            return true;
        }
        return false;
    }
    /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */ clearInterval() {
        if (this._tickInterval) {
            self.clearInterval(this._tickInterval);
            this._tickInterval = null;
            return true;
        }
        return false;
    }
    /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */ clearNextTick() {
        if (this._tickTimer) {
            self.clearTimeout(this._tickTimer);
            this._tickTimer = null;
            return true;
        }
        return false;
    }
    /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */ tick() {
        this._tickCallCount++;
        if (this._tickCallCount === 1) {
            this.doTick();
            // re-entrant call to tick from previous doTick call stack
            // -> schedule a call on the next main loop iteration to process this task processing request
            if (this._tickCallCount > 1) // make sure only one timer exists at any time at max
            this.tickImmediate();
            this._tickCallCount = 0;
        }
    }
    tickImmediate() {
        this.clearNextTick();
        this._tickTimer = self.setTimeout(this._boundTick, 0);
    }
    /**
   * For subclass to implement task logic
   * @abstract
   */ doTick() {}
}
/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */ const $fada8102d2a280be$var$noopBuffered = {
    length: 0,
    start: ()=>0,
    end: ()=>0
};
class $fada8102d2a280be$var$BufferHelper {
    /**
   * Return true if `media`'s buffered include `position`
   */ static isBuffered(media, position) {
        try {
            if (media) {
                const buffered = $fada8102d2a280be$var$BufferHelper.getBuffered(media);
                for(let i = 0; i < buffered.length; i++){
                    if (position >= buffered.start(i) && position <= buffered.end(i)) return true;
                }
            }
        } catch (error) {
        // this is to catch
        // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
        // This SourceBuffer has been removed from the parent media source
        }
        return false;
    }
    static bufferInfo(media, pos, maxHoleDuration) {
        try {
            if (media) {
                const vbuffered = $fada8102d2a280be$var$BufferHelper.getBuffered(media);
                const buffered = [];
                let i;
                for(i = 0; i < vbuffered.length; i++)buffered.push({
                    start: vbuffered.start(i),
                    end: vbuffered.end(i)
                });
                return this.bufferedInfo(buffered, pos, maxHoleDuration);
            }
        } catch (error) {
        // this is to catch
        // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
        // This SourceBuffer has been removed from the parent media source
        }
        return {
            len: 0,
            start: pos,
            end: pos,
            nextStart: undefined
        };
    }
    static bufferedInfo(buffered, pos, maxHoleDuration) {
        pos = Math.max(0, pos);
        // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
        buffered.sort(function(a, b) {
            const diff = a.start - b.start;
            if (diff) return diff;
            else return b.end - a.end;
        });
        let buffered2 = [];
        if (maxHoleDuration) // there might be some small holes between buffer time range
        // consider that holes smaller than maxHoleDuration are irrelevant and build another
        // buffer time range representations that discards those holes
        for(let i = 0; i < buffered.length; i++){
            const buf2len = buffered2.length;
            if (buf2len) {
                const buf2end = buffered2[buf2len - 1].end;
                // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
                if (buffered[i].start - buf2end < maxHoleDuration) // merge overlapping time ranges
                // update lastRange.end only if smaller than item.end
                // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
                // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
                {
                    if (buffered[i].end > buf2end) buffered2[buf2len - 1].end = buffered[i].end;
                } else // big hole
                buffered2.push(buffered[i]);
            } else // first value
            buffered2.push(buffered[i]);
        }
        else buffered2 = buffered;
        let bufferLen = 0;
        // bufferStartNext can possibly be undefined based on the conditional logic below
        let bufferStartNext;
        // bufferStart and bufferEnd are buffer boundaries around current video position
        let bufferStart = pos;
        let bufferEnd = pos;
        for(let i = 0; i < buffered2.length; i++){
            const start = buffered2[i].start;
            const end = buffered2[i].end;
            // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
            if (pos + maxHoleDuration >= start && pos < end) {
                // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
                bufferStart = start;
                bufferEnd = end;
                bufferLen = bufferEnd - pos;
            } else if (pos + maxHoleDuration < start) {
                bufferStartNext = start;
                break;
            }
        }
        return {
            len: bufferLen,
            start: bufferStart || 0,
            end: bufferEnd || 0,
            nextStart: bufferStartNext
        };
    }
    /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */ static getBuffered(media) {
        try {
            return media.buffered;
        } catch (e) {
            $fada8102d2a280be$var$logger.log("failed to get media.buffered", e);
            return $fada8102d2a280be$var$noopBuffered;
        }
    }
}
class $fada8102d2a280be$var$ChunkMetadata {
    constructor(level, sn, id, size = 0, part = -1, partial = false){
        this.level = void 0;
        this.sn = void 0;
        this.part = void 0;
        this.id = void 0;
        this.size = void 0;
        this.partial = void 0;
        this.transmuxing = $fada8102d2a280be$var$getNewPerformanceTiming();
        this.buffering = {
            audio: $fada8102d2a280be$var$getNewPerformanceTiming(),
            video: $fada8102d2a280be$var$getNewPerformanceTiming(),
            audiovideo: $fada8102d2a280be$var$getNewPerformanceTiming()
        };
        this.level = level;
        this.sn = sn;
        this.id = id;
        this.size = size;
        this.part = part;
        this.partial = partial;
    }
}
function $fada8102d2a280be$var$getNewPerformanceTiming() {
    return {
        start: 0,
        executeStart: 0,
        executeEnd: 0,
        end: 0
    };
}
function $fada8102d2a280be$var$findFirstFragWithCC(fragments, cc) {
    let firstFrag = null;
    for(let i = 0, len = fragments.length; i < len; i++){
        const currentFrag = fragments[i];
        if (currentFrag && currentFrag.cc === cc) {
            firstFrag = currentFrag;
            break;
        }
    }
    return firstFrag;
}
function $fada8102d2a280be$var$shouldAlignOnDiscontinuities(lastFrag, lastLevel, details) {
    if (lastLevel.details) {
        if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) return true;
    }
    return false;
}
// Find the first frag in the previous level which matches the CC of the first frag of the new level
function $fada8102d2a280be$var$findDiscontinuousReferenceFrag(prevDetails, curDetails, referenceIndex = 0) {
    const prevFrags = prevDetails.fragments;
    const curFrags = curDetails.fragments;
    if (!curFrags.length || !prevFrags.length) {
        $fada8102d2a280be$var$logger.log("No fragments to align");
        return;
    }
    const prevStartFrag = $fada8102d2a280be$var$findFirstFragWithCC(prevFrags, curFrags[0].cc);
    if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
        $fada8102d2a280be$var$logger.log("No frag in previous level to align on");
        return;
    }
    return prevStartFrag;
}
function $fada8102d2a280be$var$adjustFragmentStart(frag, sliding) {
    if (frag) {
        const start = frag.start + sliding;
        frag.start = frag.startPTS = start;
        frag.endPTS = start + frag.duration;
    }
}
function $fada8102d2a280be$var$adjustSlidingStart(sliding, details) {
    // Update segments
    const fragments = details.fragments;
    for(let i = 0, len = fragments.length; i < len; i++)$fada8102d2a280be$var$adjustFragmentStart(fragments[i], sliding);
    // Update LL-HLS parts at the end of the playlist
    if (details.fragmentHint) $fada8102d2a280be$var$adjustFragmentStart(details.fragmentHint, sliding);
    details.alignedSliding = true;
}
/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */ function $fada8102d2a280be$var$alignStream(lastFrag, lastLevel, details) {
    if (!lastLevel) return;
    $fada8102d2a280be$var$alignDiscontinuities(lastFrag, details, lastLevel);
    if (!details.alignedSliding && lastLevel.details) // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
    // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
    // discontinuity sequence.
    $fada8102d2a280be$var$alignPDT(details, lastLevel.details);
    if (!details.alignedSliding && lastLevel.details && !details.skippedSegments) // Try to align on sn so that we pick a better start fragment.
    // Do not perform this on playlists with delta updates as this is only to align levels on switch
    // and adjustSliding only adjusts fragments after skippedSegments.
    $fada8102d2a280be$var$adjustSliding(lastLevel.details, details);
}
/**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastFrag - The last Fragment which shares the same discontinuity sequence
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */ function $fada8102d2a280be$var$alignDiscontinuities(lastFrag, details, lastLevel) {
    if ($fada8102d2a280be$var$shouldAlignOnDiscontinuities(lastFrag, lastLevel, details)) {
        const referenceFrag = $fada8102d2a280be$var$findDiscontinuousReferenceFrag(lastLevel.details, details);
        if (referenceFrag && $fada8102d2a280be$var$isFiniteNumber(referenceFrag.start)) {
            $fada8102d2a280be$var$logger.log(`Adjusting PTS using last level due to CC increase within current level ${details.url}`);
            $fada8102d2a280be$var$adjustSlidingStart(referenceFrag.start, details);
        }
    }
}
/**
 * Computes the PTS of a new level's fragments using the difference in Program Date Time from the last level.
 * @param details - The details of the new level
 * @param lastDetails - The details of the last loaded level
 */ function $fada8102d2a280be$var$alignPDT(details, lastDetails) {
    // This check protects the unsafe "!" usage below for null program date time access.
    if (!lastDetails.fragments.length || !details.hasProgramDateTime || !lastDetails.hasProgramDateTime) return;
    // if last level sliding is 1000 and its first frag PROGRAM-DATE-TIME is 2017-08-20 1:10:00 AM
    // and if new details first frag PROGRAM DATE-TIME is 2017-08-20 1:10:08 AM
    // then we can deduce that playlist B sliding is 1000+8 = 1008s
    const lastPDT = lastDetails.fragments[0].programDateTime; // hasProgramDateTime check above makes this safe.
    const newPDT = details.fragments[0].programDateTime;
    // date diff is in ms. frag.start is in seconds
    const sliding = (newPDT - lastPDT) / 1000 + lastDetails.fragments[0].start;
    if (sliding && $fada8102d2a280be$var$isFiniteNumber(sliding)) {
        $fada8102d2a280be$var$logger.log(`Adjusting PTS using programDateTime delta ${newPDT - lastPDT}ms, sliding:${sliding.toFixed(3)} ${details.url} `);
        $fada8102d2a280be$var$adjustSlidingStart(sliding, details);
    }
}
/**
 * Ensures appropriate time-alignment between renditions based on PDT. Unlike `alignPDT`, which adjusts
 * the timeline based on the delta between PDTs of the 0th fragment of two playlists/`LevelDetails`,
 * this function assumes the timelines represented in `refDetails` are accurate, including the PDTs,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */ function $fada8102d2a280be$var$alignMediaPlaylistByPDT(details, refDetails) {
    if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) return;
    const fragments = details.fragments;
    const refFragments = refDetails.fragments;
    if (!fragments.length || !refFragments.length) return;
    // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
    // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
    // If a fragment of the same discontinuity was not found use the middle fragment of both.
    const middleFrag = Math.round(refFragments.length / 2) - 1;
    const refFrag = refFragments[middleFrag];
    const frag = $fada8102d2a280be$var$findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.round(fragments.length / 2) - 1];
    const refPDT = refFrag.programDateTime;
    const targetPDT = frag.programDateTime;
    if (refPDT === null || targetPDT === null) return;
    const delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
    $fada8102d2a280be$var$adjustSlidingStart(delta, details);
}
class $fada8102d2a280be$var$AESCrypto {
    constructor(subtle, iv){
        this.subtle = void 0;
        this.aesIV = void 0;
        this.subtle = subtle;
        this.aesIV = iv;
    }
    decrypt(data, key) {
        return this.subtle.decrypt({
            name: "AES-CBC",
            iv: this.aesIV
        }, key, data);
    }
}
class $fada8102d2a280be$var$FastAESKey {
    constructor(subtle, key){
        this.subtle = void 0;
        this.key = void 0;
        this.subtle = subtle;
        this.key = key;
    }
    expandKey() {
        return this.subtle.importKey("raw", this.key, {
            name: "AES-CBC"
        }, false, [
            "encrypt",
            "decrypt"
        ]);
    }
}
// PKCS7
function $fada8102d2a280be$var$removePadding(array) {
    const outputBytes = array.byteLength;
    const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
    if (paddingBytes) return $fada8102d2a280be$var$sliceUint8(array, 0, outputBytes - paddingBytes);
    return array;
}
class $fada8102d2a280be$var$AESDecryptor {
    constructor(){
        this.rcon = [
            0x0,
            0x1,
            0x2,
            0x4,
            0x8,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        this.subMix = [
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256)
        ];
        this.invSubMix = [
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256)
        ];
        this.sBox = new Uint32Array(256);
        this.invSBox = new Uint32Array(256);
        this.key = new Uint32Array(0);
        this.ksRows = 0;
        this.keySize = 0;
        this.keySchedule = void 0;
        this.invKeySchedule = void 0;
        this.initTable();
    }
    // Using view.getUint32() also swaps the byte order.
    uint8ArrayToUint32Array_(arrayBuffer) {
        const view = new DataView(arrayBuffer);
        const newArray = new Uint32Array(4);
        for(let i = 0; i < 4; i++)newArray[i] = view.getUint32(i * 4);
        return newArray;
    }
    initTable() {
        const sBox = this.sBox;
        const invSBox = this.invSBox;
        const subMix = this.subMix;
        const subMix0 = subMix[0];
        const subMix1 = subMix[1];
        const subMix2 = subMix[2];
        const subMix3 = subMix[3];
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        const d = new Uint32Array(256);
        let x = 0;
        let xi = 0;
        let i = 0;
        for(i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
        else d[i] = i << 1 ^ 0x11b;
        for(i = 0; i < 256; i++){
            let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
            sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
            sBox[x] = sx;
            invSBox[sx] = x;
            // Compute multiplication
            const x2 = d[x];
            const x4 = d[x2];
            const x8 = d[x4];
            // Compute sub/invSub bytes, mix columns tables
            let t = d[sx] * 0x101 ^ sx * 0x1010100;
            subMix0[x] = t << 24 | t >>> 8;
            subMix1[x] = t << 16 | t >>> 16;
            subMix2[x] = t << 8 | t >>> 24;
            subMix3[x] = t;
            // Compute inv sub bytes, inv mix columns tables
            t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            invSubMix0[sx] = t << 24 | t >>> 8;
            invSubMix1[sx] = t << 16 | t >>> 16;
            invSubMix2[sx] = t << 8 | t >>> 24;
            invSubMix3[sx] = t;
            // Compute next counter
            if (!x) x = xi = 1;
            else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
    }
    expandKey(keyBuffer) {
        // convert keyBuffer to Uint32Array
        const key = this.uint8ArrayToUint32Array_(keyBuffer);
        let sameKey = true;
        let offset = 0;
        while(offset < key.length && sameKey){
            sameKey = key[offset] === this.key[offset];
            offset++;
        }
        if (sameKey) return;
        this.key = key;
        const keySize = this.keySize = key.length;
        if (keySize !== 4 && keySize !== 6 && keySize !== 8) throw new Error("Invalid aes key size=" + keySize);
        const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
        let ksRow;
        let invKsRow;
        const keySchedule = this.keySchedule = new Uint32Array(ksRows);
        const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
        const sbox = this.sBox;
        const rcon = this.rcon;
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        let prev;
        let t;
        for(ksRow = 0; ksRow < ksRows; ksRow++){
            if (ksRow < keySize) {
                prev = keySchedule[ksRow] = key[ksRow];
                continue;
            }
            t = prev;
            if (ksRow % keySize === 0) {
                // Rot word
                t = t << 8 | t >>> 24;
                // Sub word
                t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
                // Mix Rcon
                t ^= rcon[ksRow / keySize | 0] << 24;
            } else if (keySize > 6 && ksRow % keySize === 4) // Sub word
            t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
            keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
        }
        for(invKsRow = 0; invKsRow < ksRows; invKsRow++){
            ksRow = ksRows - invKsRow;
            if (invKsRow & 3) t = keySchedule[ksRow];
            else t = keySchedule[ksRow - 4];
            if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
            else invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
            invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
        }
    }
    // Adding this as a method greatly improves performance.
    networkToHostOrderSwap(word) {
        return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    }
    decrypt(inputArrayBuffer, offset, aesIV) {
        const nRounds = this.keySize + 6;
        const invKeySchedule = this.invKeySchedule;
        const invSBOX = this.invSBox;
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        const initVector = this.uint8ArrayToUint32Array_(aesIV);
        let initVector0 = initVector[0];
        let initVector1 = initVector[1];
        let initVector2 = initVector[2];
        let initVector3 = initVector[3];
        const inputInt32 = new Int32Array(inputArrayBuffer);
        const outputInt32 = new Int32Array(inputInt32.length);
        let t0, t1, t2, t3;
        let s0, s1, s2, s3;
        let inputWords0, inputWords1, inputWords2, inputWords3;
        let ksRow, i;
        const swapWord = this.networkToHostOrderSwap;
        while(offset < inputInt32.length){
            inputWords0 = swapWord(inputInt32[offset]);
            inputWords1 = swapWord(inputInt32[offset + 1]);
            inputWords2 = swapWord(inputInt32[offset + 2]);
            inputWords3 = swapWord(inputInt32[offset + 3]);
            s0 = inputWords0 ^ invKeySchedule[0];
            s1 = inputWords3 ^ invKeySchedule[1];
            s2 = inputWords2 ^ invKeySchedule[2];
            s3 = inputWords1 ^ invKeySchedule[3];
            ksRow = 4;
            // Iterate through the rounds of decryption
            for(i = 1; i < nRounds; i++){
                t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
                t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
                t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
                t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
                // Update state
                s0 = t0;
                s1 = t1;
                s2 = t2;
                s3 = t3;
                ksRow = ksRow + 4;
            }
            // Shift rows, sub bytes, add round key
            t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
            t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
            t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
            t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
            // Write
            outputInt32[offset] = swapWord(t0 ^ initVector0);
            outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
            outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
            outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
            // reset initVector to last 4 unsigned int
            initVector0 = inputWords0;
            initVector1 = inputWords1;
            initVector2 = inputWords2;
            initVector3 = inputWords3;
            offset = offset + 4;
        }
        return outputInt32.buffer;
    }
}
const $fada8102d2a280be$var$CHUNK_SIZE = 16; // 16 bytes, 128 bits
class $fada8102d2a280be$var$Decrypter {
    constructor(config, { removePKCS7Padding: removePKCS7Padding = true } = {}){
        this.logEnabled = true;
        this.removePKCS7Padding = void 0;
        this.subtle = null;
        this.softwareDecrypter = null;
        this.key = null;
        this.fastAesKey = null;
        this.remainderData = null;
        this.currentIV = null;
        this.currentResult = null;
        this.useSoftware = void 0;
        this.useSoftware = config.enableSoftwareAES;
        this.removePKCS7Padding = removePKCS7Padding;
        // built in decryptor expects PKCS7 padding
        if (removePKCS7Padding) try {
            const browserCrypto = self.crypto;
            if (browserCrypto) this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        } catch (e) {
        /* no-op */ }
        if (this.subtle === null) this.useSoftware = true;
    }
    destroy() {
        this.subtle = null;
        this.softwareDecrypter = null;
        this.key = null;
        this.fastAesKey = null;
        this.remainderData = null;
        this.currentIV = null;
        this.currentResult = null;
    }
    isSync() {
        return this.useSoftware;
    }
    flush() {
        const { currentResult: currentResult, remainderData: remainderData } = this;
        if (!currentResult || remainderData) {
            this.reset();
            return null;
        }
        const data = new Uint8Array(currentResult);
        this.reset();
        if (this.removePKCS7Padding) return $fada8102d2a280be$var$removePadding(data);
        return data;
    }
    reset() {
        this.currentResult = null;
        this.currentIV = null;
        this.remainderData = null;
        if (this.softwareDecrypter) this.softwareDecrypter = null;
    }
    decrypt(data, key, iv) {
        if (this.useSoftware) return new Promise((resolve, reject)=>{
            this.softwareDecrypt(new Uint8Array(data), key, iv);
            const decryptResult = this.flush();
            if (decryptResult) resolve(decryptResult.buffer);
            else reject(new Error("[softwareDecrypt] Failed to decrypt data"));
        });
        return this.webCryptoDecrypt(new Uint8Array(data), key, iv);
    }
    // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
    // data is handled in the flush() call
    softwareDecrypt(data, key, iv) {
        const { currentIV: currentIV, currentResult: currentResult, remainderData: remainderData } = this;
        this.logOnce("JS AES decrypt");
        // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
        // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
        // the end on flush(), but by that time we have already received all bytes for the segment.
        // Progressive decryption does not work with WebCrypto
        if (remainderData) {
            data = $fada8102d2a280be$var$appendUint8Array(remainderData, data);
            this.remainderData = null;
        }
        // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
        const currentChunk = this.getValidChunk(data);
        if (!currentChunk.length) return null;
        if (currentIV) iv = currentIV;
        let softwareDecrypter = this.softwareDecrypter;
        if (!softwareDecrypter) softwareDecrypter = this.softwareDecrypter = new $fada8102d2a280be$var$AESDecryptor();
        softwareDecrypter.expandKey(key);
        const result = currentResult;
        this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
        this.currentIV = $fada8102d2a280be$var$sliceUint8(currentChunk, -16).buffer;
        if (!result) return null;
        return result;
    }
    webCryptoDecrypt(data, key, iv) {
        const subtle = this.subtle;
        if (this.key !== key || !this.fastAesKey) {
            this.key = key;
            this.fastAesKey = new $fada8102d2a280be$var$FastAESKey(subtle, key);
        }
        return this.fastAesKey.expandKey().then((aesKey)=>{
            // decrypt using web crypto
            if (!subtle) return Promise.reject(new Error("web crypto not initialized"));
            this.logOnce("WebCrypto AES decrypt");
            const crypto = new $fada8102d2a280be$var$AESCrypto(subtle, new Uint8Array(iv));
            return crypto.decrypt(data.buffer, aesKey);
        }).catch((err)=>{
            $fada8102d2a280be$var$logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
            return this.onWebCryptoError(data, key, iv);
        });
    }
    onWebCryptoError(data, key, iv) {
        this.useSoftware = true;
        this.logEnabled = true;
        this.softwareDecrypt(data, key, iv);
        const decryptResult = this.flush();
        if (decryptResult) return decryptResult.buffer;
        throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
    }
    getValidChunk(data) {
        let currentChunk = data;
        const splitPoint = data.length - data.length % $fada8102d2a280be$var$CHUNK_SIZE;
        if (splitPoint !== data.length) {
            currentChunk = $fada8102d2a280be$var$sliceUint8(data, 0, splitPoint);
            this.remainderData = $fada8102d2a280be$var$sliceUint8(data, splitPoint);
        }
        return currentChunk;
    }
    logOnce(msg) {
        if (!this.logEnabled) return;
        $fada8102d2a280be$var$logger.log(`[decrypter]: ${msg}`);
        this.logEnabled = false;
    }
}
/**
 *  TimeRanges to string helper
 */ const $fada8102d2a280be$var$TimeRanges = {
    toString: function(r) {
        let log = "";
        const len = r.length;
        for(let i = 0; i < len; i++)log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
        return log;
    }
};
const $fada8102d2a280be$var$State = {
    STOPPED: "STOPPED",
    IDLE: "IDLE",
    KEY_LOADING: "KEY_LOADING",
    FRAG_LOADING: "FRAG_LOADING",
    FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
    WAITING_TRACK: "WAITING_TRACK",
    PARSING: "PARSING",
    PARSED: "PARSED",
    ENDED: "ENDED",
    ERROR: "ERROR",
    WAITING_INIT_PTS: "WAITING_INIT_PTS",
    WAITING_LEVEL: "WAITING_LEVEL"
};
class $fada8102d2a280be$var$BaseStreamController extends $fada8102d2a280be$var$TaskLoop {
    constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType){
        super();
        this.hls = void 0;
        this.fragPrevious = null;
        this.fragCurrent = null;
        this.fragmentTracker = void 0;
        this.transmuxer = null;
        this._state = $fada8102d2a280be$var$State.STOPPED;
        this.playlistType = void 0;
        this.media = null;
        this.mediaBuffer = null;
        this.config = void 0;
        this.bitrateTest = false;
        this.lastCurrentTime = 0;
        this.nextLoadPosition = 0;
        this.startPosition = 0;
        this.startTimeOffset = null;
        this.loadedmetadata = false;
        this.retryDate = 0;
        this.levels = null;
        this.fragmentLoader = void 0;
        this.keyLoader = void 0;
        this.levelLastLoaded = null;
        this.startFragRequested = false;
        this.decrypter = void 0;
        this.initPTS = [];
        this.onvseeking = null;
        this.onvended = null;
        this.logPrefix = "";
        this.log = void 0;
        this.warn = void 0;
        this.playlistType = playlistType;
        this.logPrefix = logPrefix;
        this.log = $fada8102d2a280be$var$logger.log.bind($fada8102d2a280be$var$logger, `${logPrefix}:`);
        this.warn = $fada8102d2a280be$var$logger.warn.bind($fada8102d2a280be$var$logger, `${logPrefix}:`);
        this.hls = hls;
        this.fragmentLoader = new $fada8102d2a280be$var$FragmentLoader(hls.config);
        this.keyLoader = keyLoader;
        this.fragmentTracker = fragmentTracker;
        this.config = hls.config;
        this.decrypter = new $fada8102d2a280be$var$Decrypter(hls.config);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    }
    doTick() {
        this.onTickEnd();
    }
    onTickEnd() {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    startLoad(startPosition) {}
    stopLoad() {
        this.fragmentLoader.abort();
        this.keyLoader.abort(this.playlistType);
        const frag = this.fragCurrent;
        if (frag != null && frag.loader) {
            frag.abortRequests();
            this.fragmentTracker.removeFragment(frag);
        }
        this.resetTransmuxer();
        this.fragCurrent = null;
        this.fragPrevious = null;
        this.clearInterval();
        this.clearNextTick();
        this.state = $fada8102d2a280be$var$State.STOPPED;
    }
    _streamEnded(bufferInfo, levelDetails) {
        // If playlist is live, there is another buffered range after the current range, nothing buffered, media is detached,
        // of nothing loading/loaded return false
        if (levelDetails.live || bufferInfo.nextStart || !bufferInfo.end || !this.media) return false;
        const partList = levelDetails.partList;
        // Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
        // check instead if the last part is buffered.
        if (partList != null && partList.length) {
            const lastPart = partList[partList.length - 1];
            // Checking the midpoint of the part for potential margin of error and related issues.
            // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
            // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
            // part mismatches for independent audio and video playlists/segments.
            const lastPartBuffered = $fada8102d2a280be$var$BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
            return lastPartBuffered;
        }
        const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
        return this.fragmentTracker.isEndListAppended(playlistType);
    }
    getLevelDetails() {
        if (this.levels && this.levelLastLoaded !== null) {
            var _this$levels$this$lev;
            return (_this$levels$this$lev = this.levels[this.levelLastLoaded]) == null ? void 0 : _this$levels$this$lev.details;
        }
    }
    onMediaAttached(event, data) {
        const media = this.media = this.mediaBuffer = data.media;
        this.onvseeking = this.onMediaSeeking.bind(this);
        this.onvended = this.onMediaEnded.bind(this);
        media.addEventListener("seeking", this.onvseeking);
        media.addEventListener("ended", this.onvended);
        const config = this.config;
        if (this.levels && config.autoStartLoad && this.state === $fada8102d2a280be$var$State.STOPPED) this.startLoad(config.startPosition);
    }
    onMediaDetaching() {
        const media = this.media;
        if (media != null && media.ended) {
            this.log("MSE detaching and video ended, reset startPosition");
            this.startPosition = this.lastCurrentTime = 0;
        }
        // remove video listeners
        if (media && this.onvseeking && this.onvended) {
            media.removeEventListener("seeking", this.onvseeking);
            media.removeEventListener("ended", this.onvended);
            this.onvseeking = this.onvended = null;
        }
        if (this.keyLoader) this.keyLoader.detach();
        this.media = this.mediaBuffer = null;
        this.loadedmetadata = false;
        this.fragmentTracker.removeAllFragments();
        this.stopLoad();
    }
    onMediaSeeking() {
        const { config: config, fragCurrent: fragCurrent, media: media, mediaBuffer: mediaBuffer, state: state } = this;
        const currentTime = media ? media.currentTime : 0;
        const bufferInfo = $fada8102d2a280be$var$BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
        this.log(`media seeking to ${$fada8102d2a280be$var$isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}`);
        if (this.state === $fada8102d2a280be$var$State.ENDED) this.resetLoadingState();
        else if (fragCurrent) {
            // Seeking while frag load is in progress
            const tolerance = config.maxFragLookUpTolerance;
            const fragStartOffset = fragCurrent.start - tolerance;
            const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
            // if seeking out of buffered range or into new one
            if (!bufferInfo.len || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
                const pastFragment = currentTime > fragEndOffset;
                // if the seek position is outside the current fragment range
                if (currentTime < fragStartOffset || pastFragment) {
                    if (pastFragment && fragCurrent.loader) {
                        this.log("seeking outside of buffer while fragment load in progress, cancel fragment load");
                        fragCurrent.abortRequests();
                        this.resetLoadingState();
                    }
                    this.fragPrevious = null;
                }
            }
        }
        if (media) {
            // Remove gap fragments
            this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);
            this.lastCurrentTime = currentTime;
        }
        // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
        if (!this.loadedmetadata && !bufferInfo.len) this.nextLoadPosition = this.startPosition = currentTime;
        // Async tick to speed up processing
        this.tickImmediate();
    }
    onMediaEnded() {
        // reset startPosition and lastCurrentTime to restart playback @ stream beginning
        this.startPosition = this.lastCurrentTime = 0;
    }
    onManifestLoaded(event, data) {
        this.startTimeOffset = data.startTimeOffset;
        this.initPTS = [];
    }
    onHandlerDestroying() {
        this.stopLoad();
        super.onHandlerDestroying();
    }
    onHandlerDestroyed() {
        this.state = $fada8102d2a280be$var$State.STOPPED;
        if (this.fragmentLoader) this.fragmentLoader.destroy();
        if (this.keyLoader) this.keyLoader.destroy();
        if (this.decrypter) this.decrypter.destroy();
        this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
        super.onHandlerDestroyed();
    }
    loadFragment(frag, level, targetBufferTime) {
        this._loadFragForPlayback(frag, level, targetBufferTime);
    }
    _loadFragForPlayback(frag, level, targetBufferTime) {
        const progressCallback = (data)=>{
            if (this.fragContextChanged(frag)) {
                this.warn(`Fragment ${frag.sn}${data.part ? " p: " + data.part.index : ""} of level ${frag.level} was dropped during download.`);
                this.fragmentTracker.removeFragment(frag);
                return;
            }
            frag.stats.chunkCount++;
            this._handleFragmentLoadProgress(data);
        };
        this._doFragLoad(frag, level, targetBufferTime, progressCallback).then((data)=>{
            if (!data) // if we're here we probably needed to backtrack or are waiting for more parts
            return;
            const state = this.state;
            if (this.fragContextChanged(frag)) {
                if (state === $fada8102d2a280be$var$State.FRAG_LOADING || !this.fragCurrent && state === $fada8102d2a280be$var$State.PARSING) {
                    this.fragmentTracker.removeFragment(frag);
                    this.state = $fada8102d2a280be$var$State.IDLE;
                }
                return;
            }
            if ("payload" in data) {
                this.log(`Loaded fragment ${frag.sn} of level ${frag.level}`);
                this.hls.trigger($fada8102d2a280be$var$Events.FRAG_LOADED, data);
            }
            // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
            this._handleFragmentLoadComplete(data);
        }).catch((reason)=>{
            if (this.state === $fada8102d2a280be$var$State.STOPPED || this.state === $fada8102d2a280be$var$State.ERROR) return;
            this.warn(reason);
            this.resetFragmentLoading(frag);
        });
    }
    clearTrackerIfNeeded(frag) {
        var _this$mediaBuffer;
        const { fragmentTracker: fragmentTracker } = this;
        const fragState = fragmentTracker.getState(frag);
        if (fragState === $fada8102d2a280be$var$FragmentState.APPENDING) {
            // Lower the buffer size and try again
            const playlistType = frag.type;
            const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
            const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
            if (this.reduceMaxBufferLength(minForwardBufferLength)) fragmentTracker.removeFragment(frag);
        } else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) // Stop gap for bad tracker / buffer flush behavior
        fragmentTracker.removeAllFragments();
        else if (fragmentTracker.hasParts(frag.type)) {
            // In low latency mode, remove fragments for which only some parts were buffered
            fragmentTracker.detectPartialFragments({
                frag: frag,
                part: null,
                stats: frag.stats,
                id: frag.type
            });
            if (fragmentTracker.getState(frag) === $fada8102d2a280be$var$FragmentState.PARTIAL) fragmentTracker.removeFragment(frag);
        }
    }
    flushMainBuffer(startOffset, endOffset, type = null) {
        if (!(startOffset - endOffset)) return;
        // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
        // passing a null type flushes both buffers
        const flushScope = {
            startOffset: startOffset,
            endOffset: endOffset,
            type: type
        };
        this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_FLUSHING, flushScope);
    }
    _loadInitSegment(frag, level) {
        this._doFragLoad(frag, level).then((data)=>{
            if (!data || this.fragContextChanged(frag) || !this.levels) throw new Error("init load aborted");
            return data;
        }).then((data)=>{
            const { hls: hls } = this;
            const { payload: payload } = data;
            const decryptData = frag.decryptdata;
            // check to see if the payload needs to be decrypted
            if (payload && payload.byteLength > 0 && decryptData && decryptData.key && decryptData.iv && decryptData.method === "AES-128") {
                const startTime = self.performance.now();
                // decrypt init segment data
                return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch((err)=>{
                    hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                        type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.FRAG_DECRYPT_ERROR,
                        fatal: false,
                        error: err,
                        reason: err.message,
                        frag: frag
                    });
                    throw err;
                }).then((decryptedData)=>{
                    const endTime = self.performance.now();
                    hls.trigger($fada8102d2a280be$var$Events.FRAG_DECRYPTED, {
                        frag: frag,
                        payload: decryptedData,
                        stats: {
                            tstart: startTime,
                            tdecrypt: endTime
                        }
                    });
                    data.payload = decryptedData;
                    return data;
                });
            }
            return data;
        }).then((data)=>{
            const { fragCurrent: fragCurrent, hls: hls, levels: levels } = this;
            if (!levels) throw new Error("init load aborted, missing levels");
            const stats = frag.stats;
            this.state = $fada8102d2a280be$var$State.IDLE;
            level.fragmentError = 0;
            frag.data = new Uint8Array(data.payload);
            stats.parsing.start = stats.buffering.start = self.performance.now();
            stats.parsing.end = stats.buffering.end = self.performance.now();
            // Silence FRAG_BUFFERED event if fragCurrent is null
            if (data.frag === fragCurrent) hls.trigger($fada8102d2a280be$var$Events.FRAG_BUFFERED, {
                stats: stats,
                frag: fragCurrent,
                part: null,
                id: frag.type
            });
            this.tick();
        }).catch((reason)=>{
            if (this.state === $fada8102d2a280be$var$State.STOPPED || this.state === $fada8102d2a280be$var$State.ERROR) return;
            this.warn(reason);
            this.resetFragmentLoading(frag);
        });
    }
    fragContextChanged(frag) {
        const { fragCurrent: fragCurrent } = this;
        return !frag || !fragCurrent || frag.level !== fragCurrent.level || frag.sn !== fragCurrent.sn || frag.urlId !== fragCurrent.urlId;
    }
    fragBufferedComplete(frag, part) {
        var _frag$startPTS, _frag$endPTS, _this$fragCurrent, _this$fragPrevious;
        const media = this.mediaBuffer ? this.mediaBuffer : this.media;
        this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? " part: " + part.index : ""} of ${this.playlistType === $fada8102d2a280be$var$PlaylistLevelType.MAIN ? "level" : "track"} ${frag.level} (frag:[${((_frag$startPTS = frag.startPTS) != null ? _frag$startPTS : NaN).toFixed(3)}-${((_frag$endPTS = frag.endPTS) != null ? _frag$endPTS : NaN).toFixed(3)}] > buffer:${media ? $fada8102d2a280be$var$TimeRanges.toString($fada8102d2a280be$var$BufferHelper.getBuffered(media)) : "(detached)"})`);
        this.state = $fada8102d2a280be$var$State.IDLE;
        if (!media) return;
        if (!this.loadedmetadata && frag.type == $fada8102d2a280be$var$PlaylistLevelType.MAIN && media.buffered.length && ((_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.sn) === ((_this$fragPrevious = this.fragPrevious) == null ? void 0 : _this$fragPrevious.sn)) {
            this.loadedmetadata = true;
            this.seekToStartPos();
        }
        this.tick();
    }
    seekToStartPos() {}
    _handleFragmentLoadComplete(fragLoadedEndData) {
        const { transmuxer: transmuxer } = this;
        if (!transmuxer) return;
        const { frag: frag, part: part, partsLoaded: partsLoaded } = fragLoadedEndData;
        // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
        const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some((fragLoaded)=>!fragLoaded);
        const chunkMeta = new $fada8102d2a280be$var$ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
        transmuxer.flush(chunkMeta);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _handleFragmentLoadProgress(frag) {}
    _doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
        var _frag$decryptdata;
        const details = level == null ? void 0 : level.details;
        if (!this.levels || !details) throw new Error(`frag load aborted, missing level${details ? "" : " detail"}s`);
        let keyLoadingPromise = null;
        if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
            this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.logPrefix === "[stream-controller]" ? "level" : "track"} ${frag.level}`);
            this.state = $fada8102d2a280be$var$State.KEY_LOADING;
            this.fragCurrent = frag;
            keyLoadingPromise = this.keyLoader.load(frag).then((keyLoadedData)=>{
                if (!this.fragContextChanged(keyLoadedData.frag)) {
                    this.hls.trigger($fada8102d2a280be$var$Events.KEY_LOADED, keyLoadedData);
                    if (this.state === $fada8102d2a280be$var$State.KEY_LOADING) this.state = $fada8102d2a280be$var$State.IDLE;
                    return keyLoadedData;
                }
            });
            this.hls.trigger($fada8102d2a280be$var$Events.KEY_LOADING, {
                frag: frag
            });
            if (this.fragCurrent === null) keyLoadingPromise = Promise.reject(new Error(`frag load aborted, context changed in KEY_LOADING`));
        } else if (!frag.encrypted && details.encryptedFragments.length) this.keyLoader.loadClear(frag, details.encryptedFragments);
        targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
        if (this.config.lowLatencyMode && frag.sn !== "initSegment") {
            const partList = details.partList;
            if (partList && progressCallback) {
                if (targetBufferTime > frag.end && details.fragmentHint) frag = details.fragmentHint;
                const partIndex = this.getNextPart(partList, frag, targetBufferTime);
                if (partIndex > -1) {
                    const part = partList[partIndex];
                    this.log(`Loading part sn: ${frag.sn} p: ${part.index} cc: ${frag.cc} of playlist [${details.startSN}-${details.endSN}] parts [0-${partIndex}-${partList.length - 1}] ${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
                    this.nextLoadPosition = part.start + part.duration;
                    this.state = $fada8102d2a280be$var$State.FRAG_LOADING;
                    let _result;
                    if (keyLoadingPromise) _result = keyLoadingPromise.then((keyLoadedData)=>{
                        if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) return null;
                        return this.doFragPartsLoad(frag, part, level, progressCallback);
                    }).catch((error)=>this.handleFragLoadError(error));
                    else _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch((error)=>this.handleFragLoadError(error));
                    this.hls.trigger($fada8102d2a280be$var$Events.FRAG_LOADING, {
                        frag: frag,
                        part: part,
                        targetBufferTime: targetBufferTime
                    });
                    if (this.fragCurrent === null) return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
                    return _result;
                } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) // Fragment hint has no parts
                return Promise.resolve(null);
            }
        }
        this.log(`Loading fragment ${frag.sn} cc: ${frag.cc} ${details ? "of [" + details.startSN + "-" + details.endSN + "] " : ""}${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
        // Don't update nextLoadPosition for fragments which are not buffered
        if ($fada8102d2a280be$var$isFiniteNumber(frag.sn) && !this.bitrateTest) this.nextLoadPosition = frag.start + frag.duration;
        this.state = $fada8102d2a280be$var$State.FRAG_LOADING;
        // Load key before streaming fragment data
        const dataOnProgress = this.config.progressive;
        let result;
        if (dataOnProgress && keyLoadingPromise) result = keyLoadingPromise.then((keyLoadedData)=>{
            if (!keyLoadedData || this.fragContextChanged(keyLoadedData == null ? void 0 : keyLoadedData.frag)) return null;
            return this.fragmentLoader.load(frag, progressCallback);
        }).catch((error)=>this.handleFragLoadError(error));
        else // load unencrypted fragment data with progress event,
        // or handle fragment result after key and fragment are finished loading
        result = Promise.all([
            this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : undefined),
            keyLoadingPromise
        ]).then(([fragLoadedData])=>{
            if (!dataOnProgress && fragLoadedData && progressCallback) progressCallback(fragLoadedData);
            return fragLoadedData;
        }).catch((error)=>this.handleFragLoadError(error));
        this.hls.trigger($fada8102d2a280be$var$Events.FRAG_LOADING, {
            frag: frag,
            targetBufferTime: targetBufferTime
        });
        if (this.fragCurrent === null) return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING`));
        return result;
    }
    doFragPartsLoad(frag, fromPart, level, progressCallback) {
        return new Promise((resolve, reject)=>{
            var _level$details;
            const partsLoaded = [];
            const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
            const loadPart = (part)=>{
                this.fragmentLoader.loadPart(frag, part, progressCallback).then((partLoadedData)=>{
                    partsLoaded[part.index] = partLoadedData;
                    const loadedPart = partLoadedData.part;
                    this.hls.trigger($fada8102d2a280be$var$Events.FRAG_LOADED, partLoadedData);
                    const nextPart = $fada8102d2a280be$var$getPartWith(level, frag.sn, part.index + 1) || $fada8102d2a280be$var$findPart(initialPartList, frag.sn, part.index + 1);
                    if (nextPart) loadPart(nextPart);
                    else return resolve({
                        frag: frag,
                        part: loadedPart,
                        partsLoaded: partsLoaded
                    });
                }).catch(reject);
            };
            loadPart(fromPart);
        });
    }
    handleFragLoadError(error) {
        if ("data" in error) {
            const data = error.data;
            if (error.data && data.details === $fada8102d2a280be$var$ErrorDetails.INTERNAL_ABORTED) this.handleFragLoadAborted(data.frag, data.part);
            else this.hls.trigger($fada8102d2a280be$var$Events.ERROR, data);
        } else this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
            type: $fada8102d2a280be$var$ErrorTypes.OTHER_ERROR,
            details: $fada8102d2a280be$var$ErrorDetails.INTERNAL_EXCEPTION,
            err: error,
            error: error,
            fatal: true
        });
        return null;
    }
    _handleTransmuxerFlush(chunkMeta) {
        const context = this.getCurrentContext(chunkMeta);
        if (!context || this.state !== $fada8102d2a280be$var$State.PARSING) {
            if (!this.fragCurrent && this.state !== $fada8102d2a280be$var$State.STOPPED && this.state !== $fada8102d2a280be$var$State.ERROR) this.state = $fada8102d2a280be$var$State.IDLE;
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const now = self.performance.now();
        frag.stats.parsing.end = now;
        if (part) part.stats.parsing.end = now;
        this.updateLevelTiming(frag, part, level, chunkMeta.partial);
    }
    getCurrentContext(chunkMeta) {
        const { levels: levels, fragCurrent: fragCurrent } = this;
        const { level: levelIndex, sn: sn, part: partIndex } = chunkMeta;
        if (!(levels != null && levels[levelIndex])) {
            this.warn(`Levels object was unset while buffering fragment ${sn} of level ${levelIndex}. The current chunk will not be buffered.`);
            return null;
        }
        const level = levels[levelIndex];
        const part = partIndex > -1 ? $fada8102d2a280be$var$getPartWith(level, sn, partIndex) : null;
        const frag = part ? part.fragment : $fada8102d2a280be$var$getFragmentWithSN(level, sn, fragCurrent);
        if (!frag) return null;
        if (fragCurrent && fragCurrent !== frag) frag.stats = fragCurrent.stats;
        return {
            frag: frag,
            part: part,
            level: level
        };
    }
    bufferFragmentData(data, frag, part, chunkMeta) {
        var _buffer;
        if (!data || this.state !== $fada8102d2a280be$var$State.PARSING) return;
        const { data1: data1, data2: data2 } = data;
        let buffer = data1;
        if (data1 && data2) // Combine the moof + mdat so that we buffer with a single append
        buffer = $fada8102d2a280be$var$appendUint8Array(data1, data2);
        if (!((_buffer = buffer) != null && _buffer.length)) return;
        const segment = {
            type: data.type,
            frag: frag,
            part: part,
            chunkMeta: chunkMeta,
            parent: frag.type,
            data: buffer
        };
        this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_APPENDING, segment);
        if (data.dropped && data.independent && !part) // Clear buffer so that we reload previous segments sequentially if required
        this.flushBufferGap(frag);
    }
    flushBufferGap(frag) {
        const media = this.media;
        if (!media) return;
        // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
        if (!$fada8102d2a280be$var$BufferHelper.isBuffered(media, media.currentTime)) {
            this.flushMainBuffer(0, frag.start);
            return;
        }
        // Remove back-buffer without interrupting playback to allow back tracking
        const currentTime = media.currentTime;
        const bufferInfo = $fada8102d2a280be$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const fragDuration = frag.duration;
        const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
        const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
        if (frag.start - start > segmentFraction) this.flushMainBuffer(start, frag.start);
    }
    getFwdBufferInfo(bufferable, type) {
        const pos = this.getLoadPosition();
        if (!$fada8102d2a280be$var$isFiniteNumber(pos)) return null;
        return this.getFwdBufferInfoAtPos(bufferable, pos, type);
    }
    getFwdBufferInfoAtPos(bufferable, pos, type) {
        const { config: { maxBufferHole: maxBufferHole } } = this;
        const bufferInfo = $fada8102d2a280be$var$BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
        // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
        if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
            const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
            if (bufferedFragAtPos && bufferInfo.nextStart < bufferedFragAtPos.end) return $fada8102d2a280be$var$BufferHelper.bufferInfo(bufferable, pos, Math.max(bufferInfo.nextStart, maxBufferHole));
        }
        return bufferInfo;
    }
    getMaxBufferLength(levelBitrate) {
        const { config: config } = this;
        let maxBufLen;
        if (levelBitrate) maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
        else maxBufLen = config.maxBufferLength;
        return Math.min(maxBufLen, config.maxMaxBufferLength);
    }
    reduceMaxBufferLength(threshold) {
        const config = this.config;
        const minLength = threshold || config.maxBufferLength;
        if (config.maxMaxBufferLength >= minLength) {
            // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
            config.maxMaxBufferLength /= 2;
            this.warn(`Reduce max buffer length to ${config.maxMaxBufferLength}s`);
            return true;
        }
        return false;
    }
    getAppendedFrag(position, playlistType = $fada8102d2a280be$var$PlaylistLevelType.MAIN) {
        const fragOrPart = this.fragmentTracker.getAppendedFrag(position, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
        if (fragOrPart && "fragment" in fragOrPart) return fragOrPart.fragment;
        return fragOrPart;
    }
    getNextFragment(pos, levelDetails) {
        const fragments = levelDetails.fragments;
        const fragLen = fragments.length;
        if (!fragLen) return null;
        // find fragment index, contiguous with end of buffer position
        const { config: config } = this;
        const start = fragments[0].start;
        let frag;
        if (levelDetails.live) {
            const initialLiveManifestSize = config.initialLiveManifestSize;
            if (fragLen < initialLiveManifestSize) {
                this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
                return null;
            }
            // The real fragment start times for a live stream are only known after the PTS range for that level is known.
            // In order to discover the range, we load the best matching fragment for that level and demux it.
            // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
            // we get the fragment matching that start time
            if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1) {
                frag = this.getInitialLiveFragment(levelDetails, fragments);
                this.startPosition = frag ? this.hls.liveSyncPosition || frag.start : pos;
            }
        } else if (pos <= start) // VoD playlist: if loadPosition before start of playlist, load first fragment
        frag = fragments[0];
        // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
        if (!frag) {
            const end = config.lowLatencyMode ? levelDetails.partEnd : levelDetails.fragmentEnd;
            frag = this.getFragmentAtPosition(pos, end, levelDetails);
        }
        return this.mapToInitFragWhenRequired(frag);
    }
    isLoopLoading(frag, targetBufferTime) {
        const trackerState = this.fragmentTracker.getState(frag);
        return (trackerState === $fada8102d2a280be$var$FragmentState.OK || trackerState === $fada8102d2a280be$var$FragmentState.PARTIAL && !!frag.gap) && this.nextLoadPosition > targetBufferTime;
    }
    getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
        const gapStart = frag.gap;
        const nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
        if (nextFragment === null) return nextFragment;
        frag = nextFragment;
        if (gapStart && frag && !frag.gap && bufferInfo.nextStart) {
            // Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
            const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType);
            if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
                // Returning here might result in not finding an audio and video candiate to skip to
                this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${frag.sn}`);
                return null;
            }
        }
        return frag;
    }
    mapToInitFragWhenRequired(frag) {
        // If an initSegment is present, it must be buffered first
        if (frag != null && frag.initSegment && !(frag != null && frag.initSegment.data) && !this.bitrateTest) return frag.initSegment;
        return frag;
    }
    getNextPart(partList, frag, targetBufferTime) {
        let nextPart = -1;
        let contiguous = false;
        let independentAttrOmitted = true;
        for(let i = 0, len = partList.length; i < len; i++){
            const part = partList[i];
            independentAttrOmitted = independentAttrOmitted && !part.independent;
            if (nextPart > -1 && targetBufferTime < part.start) break;
            const loaded = part.loaded;
            if (loaded) nextPart = -1;
            else if ((contiguous || part.independent || independentAttrOmitted) && part.fragment === frag) nextPart = i;
            contiguous = loaded;
        }
        return nextPart;
    }
    loadedEndOfParts(partList, targetBufferTime) {
        const lastPart = partList[partList.length - 1];
        return lastPart && targetBufferTime > lastPart.start && lastPart.loaded;
    }
    /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */ getInitialLiveFragment(levelDetails, fragments) {
        const fragPrevious = this.fragPrevious;
        let frag = null;
        if (fragPrevious) {
            if (levelDetails.hasProgramDateTime) {
                // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
                this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
                frag = $fada8102d2a280be$var$findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
            }
            if (!frag) {
                // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
                const targetSN = fragPrevious.sn + 1;
                if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
                    const fragNext = fragments[targetSN - levelDetails.startSN];
                    // Ensure that we're staying within the continuity range, since PTS resets upon a new range
                    if (fragPrevious.cc === fragNext.cc) {
                        frag = fragNext;
                        this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
                    }
                }
                // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
                // will have the wrong start times
                if (!frag) {
                    frag = $fada8102d2a280be$var$findFragWithCC(fragments, fragPrevious.cc);
                    if (frag) this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
                }
            }
        } else {
            // Find a new start fragment when fragPrevious is null
            const liveStart = this.hls.liveSyncPosition;
            if (liveStart !== null) frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
        }
        return frag;
    }
    /*
  This method finds the best matching fragment given the provided position.
   */ getFragmentAtPosition(bufferEnd, end, levelDetails) {
        const { config: config } = this;
        let { fragPrevious: fragPrevious } = this;
        let { fragments: fragments, endSN: endSN } = levelDetails;
        const { fragmentHint: fragmentHint } = levelDetails;
        const tolerance = config.maxFragLookUpTolerance;
        const partList = levelDetails.partList;
        const loadingParts = !!(config.lowLatencyMode && partList != null && partList.length && fragmentHint);
        if (loadingParts && fragmentHint && !this.bitrateTest) {
            // Include incomplete fragment with parts at end
            fragments = fragments.concat(fragmentHint);
            endSN = fragmentHint.sn;
        }
        let frag;
        if (bufferEnd < end) {
            const lookupTolerance = bufferEnd > end - tolerance ? 0 : tolerance;
            // Remove the tolerance if it would put the bufferEnd past the actual end of stream
            // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
            frag = $fada8102d2a280be$var$findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
        } else // reach end of playlist
        frag = fragments[fragments.length - 1];
        if (frag) {
            const curSNIdx = frag.sn - levelDetails.startSN;
            // Move fragPrevious forward to support forcing the next fragment to load
            // when the buffer catches up to a previously buffered range.
            const fragState = this.fragmentTracker.getState(frag);
            if (fragState === $fada8102d2a280be$var$FragmentState.OK || fragState === $fada8102d2a280be$var$FragmentState.PARTIAL && frag.gap) fragPrevious = frag;
            if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn)) {
                // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
                // non-uniform fragment durations
                const sameLevel = fragPrevious && frag.level === fragPrevious.level;
                if (sameLevel) {
                    const nextFrag = fragments[curSNIdx + 1];
                    if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== $fada8102d2a280be$var$FragmentState.OK) frag = nextFrag;
                    else frag = null;
                }
            }
        }
        return frag;
    }
    synchronizeToLiveEdge(levelDetails) {
        const { config: config, media: media } = this;
        if (!media) return;
        const liveSyncPosition = this.hls.liveSyncPosition;
        const currentTime = media.currentTime;
        const start = levelDetails.fragments[0].start;
        const end = levelDetails.edge;
        const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
        // Continue if we can seek forward to sync position or if current time is outside of sliding window
        if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
            // Continue if buffer is starving or if current time is behind max latency
            const maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
            if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
                if (!this.loadedmetadata) this.nextLoadPosition = liveSyncPosition;
                // Only seek if ready and there is not a significant forward buffer available for playback
                if (media.readyState) {
                    this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
                    media.currentTime = liveSyncPosition;
                }
            }
        }
    }
    alignPlaylists(details, previousDetails) {
        const { levels: levels, levelLastLoaded: levelLastLoaded, fragPrevious: fragPrevious } = this;
        const lastLevel = levelLastLoaded !== null ? levels[levelLastLoaded] : null;
        // FIXME: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
        //  this could all go in level-helper mergeDetails()
        const length = details.fragments.length;
        if (!length) {
            this.warn(`No fragments in live playlist`);
            return 0;
        }
        const slidingStart = details.fragments[0].start;
        const firstLevelLoad = !previousDetails;
        const aligned = details.alignedSliding && $fada8102d2a280be$var$isFiniteNumber(slidingStart);
        if (firstLevelLoad || !aligned && !slidingStart) {
            $fada8102d2a280be$var$alignStream(fragPrevious, lastLevel, details);
            const alignedSlidingStart = details.fragments[0].start;
            this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : "na"}->${details.startSN} prev-sn: ${fragPrevious ? fragPrevious.sn : "na"} fragments: ${length}`);
            return alignedSlidingStart;
        }
        return slidingStart;
    }
    waitForCdnTuneIn(details) {
        // Wait for Low-Latency CDN Tune-in to get an updated playlist
        const advancePartLimit = 3;
        return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
    }
    setStartPosition(details, sliding) {
        // compute start position if set to -1. use it straight away if value is defined
        let startPosition = this.startPosition;
        if (startPosition < sliding) startPosition = -1;
        if (startPosition === -1 || this.lastCurrentTime === -1) {
            // Use Playlist EXT-X-START:TIME-OFFSET when set
            // Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
            const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
            const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
            if (startTimeOffset !== null && $fada8102d2a280be$var$isFiniteNumber(startTimeOffset)) {
                startPosition = sliding + startTimeOffset;
                if (startTimeOffset < 0) startPosition += details.totalduration;
                startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
                this.log(`Start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? "multivariant" : "media"} playlist, adjust startPosition to ${startPosition}`);
                this.startPosition = startPosition;
            } else if (details.live) // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
            // not been specified via the config or an as an argument to startLoad (#3736).
            startPosition = this.hls.liveSyncPosition || sliding;
            else this.startPosition = startPosition = 0;
            this.lastCurrentTime = startPosition;
        }
        this.nextLoadPosition = startPosition;
    }
    getLoadPosition() {
        const { media: media } = this;
        // if we have not yet loaded any fragment, start loading from start position
        let pos = 0;
        if (this.loadedmetadata && media) pos = media.currentTime;
        else if (this.nextLoadPosition) pos = this.nextLoadPosition;
        return pos;
    }
    handleFragLoadAborted(frag, part) {
        if (this.transmuxer && frag.sn !== "initSegment" && frag.stats.aborted) {
            this.warn(`Fragment ${frag.sn}${part ? " part " + part.index : ""} of level ${frag.level} was aborted`);
            this.resetFragmentLoading(frag);
        }
    }
    resetFragmentLoading(frag) {
        if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== $fada8102d2a280be$var$State.FRAG_LOADING_WAITING_RETRY) this.state = $fada8102d2a280be$var$State.IDLE;
    }
    onFragmentOrKeyLoadError(filterType, data) {
        if (data.chunkMeta && !data.frag) {
            const context = this.getCurrentContext(data.chunkMeta);
            if (context) data.frag = context.frag;
        }
        const frag = data.frag;
        // Handle frag error related to caller's filterType
        if (!frag || frag.type !== filterType || !this.levels) return;
        if (this.fragContextChanged(frag)) {
            var _this$fragCurrent2;
            this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent2 = this.fragCurrent) == null ? void 0 : _this$fragCurrent2.url}`);
            return;
        }
        const gapTagEncountered = data.details === $fada8102d2a280be$var$ErrorDetails.FRAG_GAP;
        if (gapTagEncountered) this.fragmentTracker.fragBuffered(frag, true);
        // keep retrying until the limit will be reached
        const errorAction = data.errorAction;
        const { action: action, retryCount: retryCount = 0, retryConfig: retryConfig } = errorAction || {};
        if (errorAction && action === $fada8102d2a280be$var$NetworkErrorAction.RetryRequest && retryConfig) {
            if (!this.loadedmetadata) {
                this.startFragRequested = false;
                this.nextLoadPosition = this.startPosition;
            }
            const delay = $fada8102d2a280be$var$getRetryDelay(retryConfig, retryCount);
            this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
            errorAction.resolved = true;
            this.retryDate = self.performance.now() + delay;
            this.state = $fada8102d2a280be$var$State.FRAG_LOADING_WAITING_RETRY;
        } else if (retryConfig && errorAction) {
            this.resetFragmentErrors(filterType);
            if (retryCount < retryConfig.maxNumRetry) // Network retry is skipped when level switch is preferred
            {
                if (!gapTagEncountered) errorAction.resolved = true;
            } else $fada8102d2a280be$var$logger.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
        } else this.state = $fada8102d2a280be$var$State.ERROR;
        // Perform next async tick sooner to speed up error action resolution
        this.tickImmediate();
    }
    reduceLengthAndFlushBuffer(data) {
        // if in appending state
        if (this.state === $fada8102d2a280be$var$State.PARSING || this.state === $fada8102d2a280be$var$State.PARSED) {
            const playlistType = data.parent;
            const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
            // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
            // reduce max buf len if current position is buffered
            const buffered = bufferedInfo && bufferedInfo.len > 0.5;
            if (buffered) this.reduceMaxBufferLength(bufferedInfo.len);
            const flushBuffer = !buffered;
            if (flushBuffer) // current position is not buffered, but browser is still complaining about buffer full error
            // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
            // in that case flush the whole audio buffer to recover
            this.warn(`Buffer full error while media.currentTime is not buffered, flush ${playlistType} buffer`);
            if (data.frag) {
                this.fragmentTracker.removeFragment(data.frag);
                this.nextLoadPosition = data.frag.start;
            }
            this.resetLoadingState();
            return flushBuffer;
        }
        return false;
    }
    resetFragmentErrors(filterType) {
        if (filterType === $fada8102d2a280be$var$PlaylistLevelType.AUDIO) // Reset current fragment since audio track audio is essential and may not have a fail-over track
        this.fragCurrent = null;
        // Fragment errors that result in a level switch or redundant fail-over
        // should reset the stream controller state to idle
        if (!this.loadedmetadata) this.startFragRequested = false;
        if (this.state !== $fada8102d2a280be$var$State.STOPPED) this.state = $fada8102d2a280be$var$State.IDLE;
    }
    afterBufferFlushed(media, bufferType, playlistType) {
        if (!media) return;
        // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
        // (so that we will check against video.buffered ranges in case of alt audio track)
        const bufferedTimeRanges = $fada8102d2a280be$var$BufferHelper.getBuffered(media);
        this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
        if (this.state === $fada8102d2a280be$var$State.ENDED) this.resetLoadingState();
    }
    resetLoadingState() {
        this.log("Reset loading state");
        this.fragCurrent = null;
        this.fragPrevious = null;
        this.state = $fada8102d2a280be$var$State.IDLE;
    }
    resetStartWhenNotLoaded(level) {
        // if loadedmetadata is not set, it means that first frag request failed
        // in that case, reset startFragRequested flag
        if (!this.loadedmetadata) {
            this.startFragRequested = false;
            const details = this.levels ? this.levels[level].details : null;
            if (details != null && details.live) {
                // Update the start position and return to IDLE to recover live start
                this.startPosition = -1;
                this.setStartPosition(details, 0);
                this.resetLoadingState();
            } else this.nextLoadPosition = this.startPosition;
        }
    }
    resetWhenMissingContext(chunkMeta) {
        this.warn(`The loading context changed while buffering fragment ${chunkMeta.sn} of level ${chunkMeta.level}. This chunk will not be buffered.`);
        this.removeUnbufferedFrags();
        this.resetStartWhenNotLoaded(chunkMeta.level);
        this.resetLoadingState();
    }
    removeUnbufferedFrags(start = 0) {
        this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
    }
    updateLevelTiming(frag, part, level, partial) {
        var _this$transmuxer;
        const details = level.details;
        if (!details) {
            this.warn("level.details undefined");
            return;
        }
        const parsed = Object.keys(frag.elementaryStreams).reduce((result, type)=>{
            const info = frag.elementaryStreams[type];
            if (info) {
                const parsedDuration = info.endPTS - info.startPTS;
                if (parsedDuration <= 0) {
                    // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
                    // The new transmuxer will be configured with a time offset matching the next fragment start,
                    // preventing the timeline from shifting.
                    this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
                    return result || false;
                }
                const drift = partial ? 0 : $fada8102d2a280be$var$updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS);
                this.hls.trigger($fada8102d2a280be$var$Events.LEVEL_PTS_UPDATED, {
                    details: details,
                    level: level,
                    drift: drift,
                    type: type,
                    frag: frag,
                    start: info.startPTS,
                    end: info.endPTS
                });
                return true;
            }
            return result;
        }, false);
        if (parsed) level.fragmentError = 0;
        else if (((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null) {
            const error = new Error(`Found no media in fragment ${frag.sn} of level ${level.id} resetting transmuxer to fallback to playlist timing`);
            this.warn(error.message);
            this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR,
                fatal: false,
                error: error,
                frag: frag,
                reason: `Found no media in msn ${frag.sn} of level "${level.url}"`
            });
            if (!this.hls) return;
            this.resetTransmuxer();
        // For this error fallthrough. Marking parsed will allow advancing to next fragment.
        }
        this.state = $fada8102d2a280be$var$State.PARSED;
        this.hls.trigger($fada8102d2a280be$var$Events.FRAG_PARSED, {
            frag: frag,
            part: part
        });
    }
    resetTransmuxer() {
        if (this.transmuxer) {
            this.transmuxer.destroy();
            this.transmuxer = null;
        }
    }
    recoverWorkerError(data) {
        if (data.event === "demuxerWorker") {
            this.resetTransmuxer();
            this.resetLoadingState();
        }
    }
    set state(nextState) {
        const previousState = this._state;
        if (previousState !== nextState) {
            this._state = nextState;
            this.log(`${previousState}->${nextState}`);
        }
    }
    get state() {
        return this._state;
    }
}
function $fada8102d2a280be$var$getSourceBuffer() {
    return self.SourceBuffer || self.WebKitSourceBuffer;
}
/**
 * @ignore
 */ function $fada8102d2a280be$var$isSupported() {
    const mediaSource = $fada8102d2a280be$var$getMediaSource();
    if (!mediaSource) return false;
    const sourceBuffer = $fada8102d2a280be$var$getSourceBuffer();
    const isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === "function" && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
    // if SourceBuffer is exposed ensure its API is valid
    // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
    const sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === "function" && typeof sourceBuffer.prototype.remove === "function";
    return !!isTypeSupported && !!sourceBufferValidAPI;
}
/**
 * @ignore
 */ function $fada8102d2a280be$var$changeTypeSupported() {
    var _sourceBuffer$prototy;
    const sourceBuffer = $fada8102d2a280be$var$getSourceBuffer();
    return typeof (sourceBuffer == null ? void 0 : (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === "function";
}
// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
function $fada8102d2a280be$var$hasUMDWorker() {
    return typeof __HLS_WORKER_BUNDLE__ === "function";
}
function $fada8102d2a280be$var$injectWorker() {
    const blob = new self.Blob([
        `var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`
    ], {
        type: "text/javascript"
    });
    const objectURL = self.URL.createObjectURL(blob);
    const worker = new self.Worker(objectURL);
    return {
        worker: worker,
        objectURL: objectURL
    };
}
function $fada8102d2a280be$var$loadWorker(path) {
    const scriptURL = new self.URL(path, self.location.href).href;
    const worker = new self.Worker(scriptURL);
    return {
        worker: worker,
        scriptURL: scriptURL
    };
}
function $fada8102d2a280be$var$dummyTrack(type = "", inputTimeScale = 90000) {
    return {
        type: type,
        id: -1,
        pid: -1,
        inputTimeScale: inputTimeScale,
        sequenceNumber: -1,
        samples: [],
        dropped: 0
    };
}
class $fada8102d2a280be$var$BaseAudioDemuxer {
    constructor(){
        this._audioTrack = void 0;
        this._id3Track = void 0;
        this.frameIndex = 0;
        this.cachedData = null;
        this.basePTS = null;
        this.initPTS = null;
        this.lastPTS = null;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        this._id3Track = {
            type: "id3",
            id: 3,
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            dropped: 0
        };
    }
    resetTimeStamp(deaultTimestamp) {
        this.initPTS = deaultTimestamp;
        this.resetContiguity();
    }
    resetContiguity() {
        this.basePTS = null;
        this.lastPTS = null;
        this.frameIndex = 0;
    }
    canParse(data, offset) {
        return false;
    }
    appendFrame(track, data, offset) {}
    // feed incoming data to the front of the parsing pipeline
    demux(data, timeOffset) {
        if (this.cachedData) {
            data = $fada8102d2a280be$var$appendUint8Array(this.cachedData, data);
            this.cachedData = null;
        }
        let id3Data = $fada8102d2a280be$var$getID3Data(data, 0);
        let offset = id3Data ? id3Data.length : 0;
        let lastDataIndex;
        const track = this._audioTrack;
        const id3Track = this._id3Track;
        const timestamp = id3Data ? $fada8102d2a280be$var$getTimeStamp(id3Data) : undefined;
        const length = data.length;
        if (this.basePTS === null || this.frameIndex === 0 && $fada8102d2a280be$var$isFiniteNumber(timestamp)) {
            this.basePTS = $fada8102d2a280be$var$initPTSFn(timestamp, timeOffset, this.initPTS);
            this.lastPTS = this.basePTS;
        }
        if (this.lastPTS === null) this.lastPTS = this.basePTS;
        // more expressive than alternative: id3Data?.length
        if (id3Data && id3Data.length > 0) id3Track.samples.push({
            pts: this.lastPTS,
            dts: this.lastPTS,
            data: id3Data,
            type: $fada8102d2a280be$var$MetadataSchema.audioId3,
            duration: Number.POSITIVE_INFINITY
        });
        while(offset < length){
            if (this.canParse(data, offset)) {
                const frame = this.appendFrame(track, data, offset);
                if (frame) {
                    this.frameIndex++;
                    this.lastPTS = frame.sample.pts;
                    offset += frame.length;
                    lastDataIndex = offset;
                } else offset = length;
            } else if ($fada8102d2a280be$var$canParse$2(data, offset)) {
                // after a ID3.canParse, a call to ID3.getID3Data *should* always returns some data
                id3Data = $fada8102d2a280be$var$getID3Data(data, offset);
                id3Track.samples.push({
                    pts: this.lastPTS,
                    dts: this.lastPTS,
                    data: id3Data,
                    type: $fada8102d2a280be$var$MetadataSchema.audioId3,
                    duration: Number.POSITIVE_INFINITY
                });
                offset += id3Data.length;
                lastDataIndex = offset;
            } else offset++;
            if (offset === length && lastDataIndex !== length) {
                const partialData = $fada8102d2a280be$var$sliceUint8(data, lastDataIndex);
                if (this.cachedData) this.cachedData = $fada8102d2a280be$var$appendUint8Array(this.cachedData, partialData);
                else this.cachedData = partialData;
            }
        }
        return {
            audioTrack: track,
            videoTrack: $fada8102d2a280be$var$dummyTrack(),
            id3Track: id3Track,
            textTrack: $fada8102d2a280be$var$dummyTrack()
        };
    }
    demuxSampleAes(data, keyData, timeOffset) {
        return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
    }
    flush(timeOffset) {
        // Parse cache in case of remaining frames.
        const cachedData = this.cachedData;
        if (cachedData) {
            this.cachedData = null;
            this.demux(cachedData, 0);
        }
        return {
            audioTrack: this._audioTrack,
            videoTrack: $fada8102d2a280be$var$dummyTrack(),
            id3Track: this._id3Track,
            textTrack: $fada8102d2a280be$var$dummyTrack()
        };
    }
    destroy() {}
}
/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */ const $fada8102d2a280be$var$initPTSFn = (timestamp, timeOffset, initPTS)=>{
    if ($fada8102d2a280be$var$isFiniteNumber(timestamp)) return timestamp * 90;
    const init90kHz = initPTS ? initPTS.baseTime * 90000 / initPTS.timescale : 0;
    return timeOffset * 90000 + init90kHz;
};
/**
 * ADTS parser helper
 * @link https://wiki.multimedia.cx/index.php?title=ADTS
 */ function $fada8102d2a280be$var$getAudioConfig(observer, data, offset, audioCodec) {
    let adtsObjectType;
    let adtsExtensionSamplingIndex;
    let adtsChannelConfig;
    let config;
    const userAgent = navigator.userAgent.toLowerCase();
    const manifestCodec = audioCodec;
    const adtsSamplingRates = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    // byte 2
    adtsObjectType = ((data[offset + 2] & 0xc0) >>> 6) + 1;
    const adtsSamplingIndex = (data[offset + 2] & 0x3c) >>> 2;
    if (adtsSamplingIndex > adtsSamplingRates.length - 1) {
        observer.trigger($fada8102d2a280be$var$Events.ERROR, {
            type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
            details: $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR,
            fatal: true,
            reason: `invalid ADTS sampling index:${adtsSamplingIndex}`
        });
        return;
    }
    adtsChannelConfig = (data[offset + 2] & 0x01) << 2;
    // byte 3
    adtsChannelConfig |= (data[offset + 3] & 0xc0) >>> 6;
    $fada8102d2a280be$var$logger.log(`manifest codec:${audioCodec}, ADTS type:${adtsObjectType}, samplingIndex:${adtsSamplingIndex}`);
    // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
    if (/firefox/i.test(userAgent)) {
        if (adtsSamplingIndex >= 6) {
            adtsObjectType = 5;
            config = new Array(4);
            // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
            // there is a factor 2 between frame sample rate and output sample rate
            // multiply frequency by 2 (see table below, equivalent to substract 3)
            adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
        } else {
            adtsObjectType = 2;
            config = new Array(2);
            adtsExtensionSamplingIndex = adtsSamplingIndex;
        }
    } else if (userAgent.indexOf("android") !== -1) {
        adtsObjectType = 2;
        config = new Array(2);
        adtsExtensionSamplingIndex = adtsSamplingIndex;
    } else {
        /*  for other browsers (Chrome/Vivaldi/Opera ...)
        always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
    */ adtsObjectType = 5;
        config = new Array(4);
        // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
        if (audioCodec && (audioCodec.indexOf("mp4a.40.29") !== -1 || audioCodec.indexOf("mp4a.40.5") !== -1) || !audioCodec && adtsSamplingIndex >= 6) // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
        // there is a factor 2 between frame sample rate and output sample rate
        // multiply frequency by 2 (see table below, equivalent to substract 3)
        adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
        else {
            // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
            // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
            if (audioCodec && audioCodec.indexOf("mp4a.40.2") !== -1 && (adtsSamplingIndex >= 6 && adtsChannelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChannelConfig === 1) {
                adtsObjectType = 2;
                config = new Array(2);
            }
            adtsExtensionSamplingIndex = adtsSamplingIndex;
        }
    }
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */ // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    config[0] = adtsObjectType << 3;
    // samplingFrequencyIndex
    config[0] |= (adtsSamplingIndex & 0x0e) >> 1;
    config[1] |= (adtsSamplingIndex & 0x01) << 7;
    // channelConfiguration
    config[1] |= adtsChannelConfig << 3;
    if (adtsObjectType === 5) {
        // adtsExtensionSamplingIndex
        config[1] |= (adtsExtensionSamplingIndex & 0x0e) >> 1;
        config[2] = (adtsExtensionSamplingIndex & 0x01) << 7;
        // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
        //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
        config[2] |= 8;
        config[3] = 0;
    }
    return {
        config: config,
        samplerate: adtsSamplingRates[adtsSamplingIndex],
        channelCount: adtsChannelConfig,
        codec: "mp4a.40." + adtsObjectType,
        manifestCodec: manifestCodec
    };
}
function $fada8102d2a280be$var$isHeaderPattern$1(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
function $fada8102d2a280be$var$getHeaderLength(data, offset) {
    return data[offset + 1] & 0x01 ? 7 : 9;
}
function $fada8102d2a280be$var$getFullFrameLength(data, offset) {
    return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xe0) >>> 5;
}
function $fada8102d2a280be$var$canGetFrameLength(data, offset) {
    return offset + 5 < data.length;
}
function $fada8102d2a280be$var$isHeader$1(data, offset) {
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    return offset + 1 < data.length && $fada8102d2a280be$var$isHeaderPattern$1(data, offset);
}
function $fada8102d2a280be$var$canParse$1(data, offset) {
    return $fada8102d2a280be$var$canGetFrameLength(data, offset) && $fada8102d2a280be$var$isHeaderPattern$1(data, offset) && $fada8102d2a280be$var$getFullFrameLength(data, offset) <= data.length - offset;
}
function $fada8102d2a280be$var$probe$1(data, offset) {
    // same as isHeader but we also check that ADTS frame follows last ADTS frame
    // or end of data is reached
    if ($fada8102d2a280be$var$isHeader$1(data, offset)) {
        // ADTS header Length
        const headerLength = $fada8102d2a280be$var$getHeaderLength(data, offset);
        if (offset + headerLength >= data.length) return false;
        // ADTS frame Length
        const frameLength = $fada8102d2a280be$var$getFullFrameLength(data, offset);
        if (frameLength <= headerLength) return false;
        const newOffset = offset + frameLength;
        return newOffset === data.length || $fada8102d2a280be$var$isHeader$1(data, newOffset);
    }
    return false;
}
function $fada8102d2a280be$var$initTrackConfig(track, observer, data, offset, audioCodec) {
    if (!track.samplerate) {
        const config = $fada8102d2a280be$var$getAudioConfig(observer, data, offset, audioCodec);
        if (!config) return;
        track.config = config.config;
        track.samplerate = config.samplerate;
        track.channelCount = config.channelCount;
        track.codec = config.codec;
        track.manifestCodec = config.manifestCodec;
        $fada8102d2a280be$var$logger.log(`parsed codec:${track.codec}, rate:${config.samplerate}, channels:${config.channelCount}`);
    }
}
function $fada8102d2a280be$var$getFrameDuration(samplerate) {
    return 92160000 / samplerate;
}
function $fada8102d2a280be$var$parseFrameHeader(data, offset) {
    // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
    const headerLength = $fada8102d2a280be$var$getHeaderLength(data, offset);
    if (offset + headerLength <= data.length) {
        // retrieve frame size
        const frameLength = $fada8102d2a280be$var$getFullFrameLength(data, offset) - headerLength;
        if (frameLength > 0) // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
        return {
            headerLength: headerLength,
            frameLength: frameLength
        };
    }
}
function $fada8102d2a280be$var$appendFrame$1(track, data, offset, pts, frameIndex) {
    const frameDuration = $fada8102d2a280be$var$getFrameDuration(track.samplerate);
    const stamp = pts + frameIndex * frameDuration;
    const header = $fada8102d2a280be$var$parseFrameHeader(data, offset);
    let unit;
    if (header) {
        const { frameLength: frameLength, headerLength: headerLength } = header;
        const _length = headerLength + frameLength;
        const missing = Math.max(0, offset + _length - data.length);
        // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
        if (missing) {
            unit = new Uint8Array(_length - headerLength);
            unit.set(data.subarray(offset + headerLength, data.length), 0);
        } else unit = data.subarray(offset + headerLength, offset + _length);
        const _sample = {
            unit: unit,
            pts: stamp
        };
        if (!missing) track.samples.push(_sample);
        return {
            sample: _sample,
            length: _length,
            missing: missing
        };
    }
    // overflow incomplete header
    const length = data.length - offset;
    unit = new Uint8Array(length);
    unit.set(data.subarray(offset, data.length), 0);
    const sample = {
        unit: unit,
        pts: stamp
    };
    return {
        sample: sample,
        length: length,
        missing: -1
    };
}
/**
 * AAC demuxer
 */ class $fada8102d2a280be$var$AACDemuxer extends $fada8102d2a280be$var$BaseAudioDemuxer {
    constructor(observer, config){
        super();
        this.observer = void 0;
        this.config = void 0;
        this.observer = observer;
        this.config = config;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: "audio/adts",
            type: "audio",
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: "aac",
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
    static probe(data) {
        if (!data) return false;
        // Check for the ADTS sync word
        // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
        // Layer bits (position 14 and 15) in header should be always 0 for ADTS
        // More info https://wiki.multimedia.cx/index.php?title=ADTS
        const id3Data = $fada8102d2a280be$var$getID3Data(data, 0) || [];
        let offset = id3Data.length;
        for(let length = data.length; offset < length; offset++)if ($fada8102d2a280be$var$probe$1(data, offset)) {
            $fada8102d2a280be$var$logger.log("ADTS sync word found !");
            return true;
        }
        return false;
    }
    canParse(data, offset) {
        return $fada8102d2a280be$var$canParse$1(data, offset);
    }
    appendFrame(track, data, offset) {
        $fada8102d2a280be$var$initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
        const frame = $fada8102d2a280be$var$appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
        if (frame && frame.missing === 0) return frame;
    }
}
const $fada8102d2a280be$var$emsgSchemePattern = /\/emsg[-/]ID3/i;
class $fada8102d2a280be$var$MP4Demuxer {
    constructor(observer, config){
        this.remainderData = null;
        this.timeOffset = 0;
        this.config = void 0;
        this.videoTrack = void 0;
        this.audioTrack = void 0;
        this.id3Track = void 0;
        this.txtTrack = void 0;
        this.config = config;
    }
    resetTimeStamp() {}
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        const videoTrack = this.videoTrack = $fada8102d2a280be$var$dummyTrack("video", 1);
        const audioTrack = this.audioTrack = $fada8102d2a280be$var$dummyTrack("audio", 1);
        const captionTrack = this.txtTrack = $fada8102d2a280be$var$dummyTrack("text", 1);
        this.id3Track = $fada8102d2a280be$var$dummyTrack("id3", 1);
        this.timeOffset = 0;
        if (!(initSegment != null && initSegment.byteLength)) return;
        const initData = $fada8102d2a280be$var$parseInitSegment(initSegment);
        if (initData.video) {
            const { id: id, timescale: timescale, codec: codec } = initData.video;
            videoTrack.id = id;
            videoTrack.timescale = captionTrack.timescale = timescale;
            videoTrack.codec = codec;
        }
        if (initData.audio) {
            const { id: id, timescale: timescale, codec: codec } = initData.audio;
            audioTrack.id = id;
            audioTrack.timescale = timescale;
            audioTrack.codec = codec;
        }
        captionTrack.id = $fada8102d2a280be$var$RemuxerTrackIdConfig.text;
        videoTrack.sampleDuration = 0;
        videoTrack.duration = audioTrack.duration = trackDuration;
    }
    resetContiguity() {
        this.remainderData = null;
    }
    static probe(data) {
        // ensure we find a moof box in the first 16 kB
        data = data.length > 16384 ? data.subarray(0, 16384) : data;
        return $fada8102d2a280be$var$findBox(data, [
            "moof"
        ]).length > 0;
    }
    demux(data, timeOffset) {
        this.timeOffset = timeOffset;
        // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
        let videoSamples = data;
        const videoTrack = this.videoTrack;
        const textTrack = this.txtTrack;
        if (this.config.progressive) {
            // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
            // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
            // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
            if (this.remainderData) videoSamples = $fada8102d2a280be$var$appendUint8Array(this.remainderData, data);
            const segmentedData = $fada8102d2a280be$var$segmentValidRange(videoSamples);
            this.remainderData = segmentedData.remainder;
            videoTrack.samples = segmentedData.valid || new Uint8Array();
        } else videoTrack.samples = videoSamples;
        const id3Track = this.extractID3Track(videoTrack, timeOffset);
        textTrack.samples = $fada8102d2a280be$var$parseSamples(timeOffset, videoTrack);
        return {
            videoTrack: videoTrack,
            audioTrack: this.audioTrack,
            id3Track: id3Track,
            textTrack: this.txtTrack
        };
    }
    flush() {
        const timeOffset = this.timeOffset;
        const videoTrack = this.videoTrack;
        const textTrack = this.txtTrack;
        videoTrack.samples = this.remainderData || new Uint8Array();
        this.remainderData = null;
        const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
        textTrack.samples = $fada8102d2a280be$var$parseSamples(timeOffset, videoTrack);
        return {
            videoTrack: videoTrack,
            audioTrack: $fada8102d2a280be$var$dummyTrack(),
            id3Track: id3Track,
            textTrack: $fada8102d2a280be$var$dummyTrack()
        };
    }
    extractID3Track(videoTrack, timeOffset) {
        const id3Track = this.id3Track;
        if (videoTrack.samples.length) {
            const emsgs = $fada8102d2a280be$var$findBox(videoTrack.samples, [
                "emsg"
            ]);
            if (emsgs) emsgs.forEach((data)=>{
                const emsgInfo = $fada8102d2a280be$var$parseEmsg(data);
                if ($fada8102d2a280be$var$emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
                    const pts = $fada8102d2a280be$var$isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
                    let duration = emsgInfo.eventDuration === 0xffffffff ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
                    // Safari takes anything <= 0.001 seconds and maps it to Infinity
                    if (duration <= 0.001) duration = Number.POSITIVE_INFINITY;
                    const payload = emsgInfo.payload;
                    id3Track.samples.push({
                        data: payload,
                        len: payload.byteLength,
                        dts: pts,
                        pts: pts,
                        type: $fada8102d2a280be$var$MetadataSchema.emsg,
                        duration: duration
                    });
                }
            });
        }
        return id3Track;
    }
    demuxSampleAes(data, keyData, timeOffset) {
        return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
    }
    destroy() {}
}
/**
 *  MPEG parser helper
 */ let $fada8102d2a280be$var$chromeVersion$1 = null;
const $fada8102d2a280be$var$BitratesMap = [
    32,
    64,
    96,
    128,
    160,
    192,
    224,
    256,
    288,
    320,
    352,
    384,
    416,
    448,
    32,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    256,
    320,
    384,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    256,
    320,
    32,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    144,
    160,
    176,
    192,
    224,
    256,
    8,
    16,
    24,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    144,
    160
];
const $fada8102d2a280be$var$SamplingRateMap = [
    44100,
    48000,
    32000,
    22050,
    24000,
    16000,
    11025,
    12000,
    8000
];
const $fada8102d2a280be$var$SamplesCoefficients = [
    // MPEG 2.5
    [
        0,
        // Reserved
        72,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ],
    // Reserved
    [
        0,
        // Reserved
        0,
        // Layer3
        0,
        // Layer2
        0 // Layer1
    ],
    // MPEG 2
    [
        0,
        // Reserved
        72,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ],
    // MPEG 1
    [
        0,
        // Reserved
        144,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ]
];
const $fada8102d2a280be$var$BytesInSlot = [
    0,
    // Reserved
    1,
    // Layer3
    1,
    // Layer2
    4 // Layer1
];
function $fada8102d2a280be$var$appendFrame(track, data, offset, pts, frameIndex) {
    // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
    if (offset + 24 > data.length) return;
    const header = $fada8102d2a280be$var$parseHeader(data, offset);
    if (header && offset + header.frameLength <= data.length) {
        const frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
        const stamp = pts + frameIndex * frameDuration;
        const sample = {
            unit: data.subarray(offset, offset + header.frameLength),
            pts: stamp,
            dts: stamp
        };
        track.config = [];
        track.channelCount = header.channelCount;
        track.samplerate = header.sampleRate;
        track.samples.push(sample);
        return {
            sample: sample,
            length: header.frameLength,
            missing: 0
        };
    }
}
function $fada8102d2a280be$var$parseHeader(data, offset) {
    const mpegVersion = data[offset + 1] >> 3 & 3;
    const mpegLayer = data[offset + 1] >> 1 & 3;
    const bitRateIndex = data[offset + 2] >> 4 & 15;
    const sampleRateIndex = data[offset + 2] >> 2 & 3;
    if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
        const paddingBit = data[offset + 2] >> 1 & 1;
        const channelMode = data[offset + 3] >> 6;
        const columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
        const bitRate = $fada8102d2a280be$var$BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
        const columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
        const sampleRate = $fada8102d2a280be$var$SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
        const channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
        const sampleCoefficient = $fada8102d2a280be$var$SamplesCoefficients[mpegVersion][mpegLayer];
        const bytesInSlot = $fada8102d2a280be$var$BytesInSlot[mpegLayer];
        const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
        const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
        if ($fada8102d2a280be$var$chromeVersion$1 === null) {
            const userAgent = navigator.userAgent || "";
            const result = userAgent.match(/Chrome\/(\d+)/i);
            $fada8102d2a280be$var$chromeVersion$1 = result ? parseInt(result[1]) : 0;
        }
        const needChromeFix = !!$fada8102d2a280be$var$chromeVersion$1 && $fada8102d2a280be$var$chromeVersion$1 <= 87;
        if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
        data[offset + 3] = data[offset + 3] | 0x80;
        return {
            sampleRate: sampleRate,
            channelCount: channelCount,
            frameLength: frameLength,
            samplesPerFrame: samplesPerFrame
        };
    }
}
function $fada8102d2a280be$var$isHeaderPattern(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
}
function $fada8102d2a280be$var$isHeader(data, offset) {
    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
    // More info http://www.mp3-tech.org/programmer/frame_header.html
    return offset + 1 < data.length && $fada8102d2a280be$var$isHeaderPattern(data, offset);
}
function $fada8102d2a280be$var$canParse(data, offset) {
    const headerSize = 4;
    return $fada8102d2a280be$var$isHeaderPattern(data, offset) && headerSize <= data.length - offset;
}
function $fada8102d2a280be$var$probe(data, offset) {
    // same as isHeader but we also check that MPEG frame follows last MPEG frame
    // or end of data is reached
    if (offset + 1 < data.length && $fada8102d2a280be$var$isHeaderPattern(data, offset)) {
        // MPEG header Length
        const headerLength = 4;
        // MPEG frame Length
        const header = $fada8102d2a280be$var$parseHeader(data, offset);
        let frameLength = headerLength;
        if (header != null && header.frameLength) frameLength = header.frameLength;
        const newOffset = offset + frameLength;
        return newOffset === data.length || $fada8102d2a280be$var$isHeader(data, newOffset);
    }
    return false;
}
/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */ class $fada8102d2a280be$var$ExpGolomb {
    constructor(data){
        this.data = void 0;
        this.bytesAvailable = void 0;
        this.word = void 0;
        this.bitsAvailable = void 0;
        this.data = data;
        // the number of bytes left to examine in this.data
        this.bytesAvailable = data.byteLength;
        // the current word being examined
        this.word = 0; // :uint
        // the number of bits left to examine in the current word
        this.bitsAvailable = 0; // :uint
    }
    // ():void
    loadWord() {
        const data = this.data;
        const bytesAvailable = this.bytesAvailable;
        const position = data.byteLength - bytesAvailable;
        const workingBytes = new Uint8Array(4);
        const availableBytes = Math.min(4, bytesAvailable);
        if (availableBytes === 0) throw new Error("no bytes available");
        workingBytes.set(data.subarray(position, position + availableBytes));
        this.word = new DataView(workingBytes.buffer).getUint32(0);
        // track the amount of this.data that has been processed
        this.bitsAvailable = availableBytes * 8;
        this.bytesAvailable -= availableBytes;
    }
    // (count:int):void
    skipBits(count) {
        let skipBytes; // :int
        count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
        if (this.bitsAvailable > count) {
            this.word <<= count;
            this.bitsAvailable -= count;
        } else {
            count -= this.bitsAvailable;
            skipBytes = count >> 3;
            count -= skipBytes << 3;
            this.bytesAvailable -= skipBytes;
            this.loadWord();
            this.word <<= count;
            this.bitsAvailable -= count;
        }
    }
    // (size:int):uint
    readBits(size) {
        let bits = Math.min(this.bitsAvailable, size); // :uint
        const valu = this.word >>> 32 - bits; // :uint
        if (size > 32) $fada8102d2a280be$var$logger.error("Cannot read more than 32 bits at a time");
        this.bitsAvailable -= bits;
        if (this.bitsAvailable > 0) this.word <<= bits;
        else if (this.bytesAvailable > 0) this.loadWord();
        else throw new Error("no bits available");
        bits = size - bits;
        if (bits > 0 && this.bitsAvailable) return valu << bits | this.readBits(bits);
        else return valu;
    }
    // ():uint
    skipLZ() {
        let leadingZeroCount; // :uint
        for(leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount)if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
            // the first bit of working word is 1
            this.word <<= leadingZeroCount;
            this.bitsAvailable -= leadingZeroCount;
            return leadingZeroCount;
        }
        // we exhausted word and still have not found a 1
        this.loadWord();
        return leadingZeroCount + this.skipLZ();
    }
    // ():void
    skipUEG() {
        this.skipBits(1 + this.skipLZ());
    }
    // ():void
    skipEG() {
        this.skipBits(1 + this.skipLZ());
    }
    // ():uint
    readUEG() {
        const clz = this.skipLZ(); // :uint
        return this.readBits(clz + 1) - 1;
    }
    // ():int
    readEG() {
        const valu = this.readUEG(); // :int
        if (0x01 & valu) // the number is odd if the low order bit is set
        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
        else return -1 * (valu >>> 1); // divide by two then make it negative
    }
    // Some convenience functions
    // :Boolean
    readBoolean() {
        return this.readBits(1) === 1;
    }
    // ():int
    readUByte() {
        return this.readBits(8);
    }
    // ():int
    readUShort() {
        return this.readBits(16);
    }
    // ():int
    readUInt() {
        return this.readBits(32);
    }
    /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */ skipScalingList(count) {
        let lastScale = 8;
        let nextScale = 8;
        let deltaScale;
        for(let j = 0; j < count; j++){
            if (nextScale !== 0) {
                deltaScale = this.readEG();
                nextScale = (lastScale + deltaScale + 256) % 256;
            }
            lastScale = nextScale === 0 ? lastScale : nextScale;
        }
    }
    /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */ readSPS() {
        let frameCropLeftOffset = 0;
        let frameCropRightOffset = 0;
        let frameCropTopOffset = 0;
        let frameCropBottomOffset = 0;
        let numRefFramesInPicOrderCntCycle;
        let scalingListCount;
        let i;
        const readUByte = this.readUByte.bind(this);
        const readBits = this.readBits.bind(this);
        const readUEG = this.readUEG.bind(this);
        const readBoolean = this.readBoolean.bind(this);
        const skipBits = this.skipBits.bind(this);
        const skipEG = this.skipEG.bind(this);
        const skipUEG = this.skipUEG.bind(this);
        const skipScalingList = this.skipScalingList.bind(this);
        readUByte();
        const profileIdc = readUByte(); // profile_idc
        readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
        skipBits(3); // reserved_zero_3bits u(3),
        readUByte(); // level_idc u(8)
        skipUEG(); // seq_parameter_set_id
        // some profiles have more optional data we don't need
        if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
            const chromaFormatIdc = readUEG();
            if (chromaFormatIdc === 3) skipBits(1);
             // separate_colour_plane_flag
            skipUEG(); // bit_depth_luma_minus8
            skipUEG(); // bit_depth_chroma_minus8
            skipBits(1); // qpprime_y_zero_transform_bypass_flag
            if (readBoolean()) {
                // seq_scaling_matrix_present_flag
                scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                for(i = 0; i < scalingListCount; i++)if (readBoolean()) {
                    // seq_scaling_list_present_flag[ i ]
                    if (i < 6) skipScalingList(16);
                    else skipScalingList(64);
                }
            }
        }
        skipUEG(); // log2_max_frame_num_minus4
        const picOrderCntType = readUEG();
        if (picOrderCntType === 0) readUEG(); // log2_max_pic_order_cnt_lsb_minus4
        else if (picOrderCntType === 1) {
            skipBits(1); // delta_pic_order_always_zero_flag
            skipEG(); // offset_for_non_ref_pic
            skipEG(); // offset_for_top_to_bottom_field
            numRefFramesInPicOrderCntCycle = readUEG();
            for(i = 0; i < numRefFramesInPicOrderCntCycle; i++)skipEG();
             // offset_for_ref_frame[ i ]
        }
        skipUEG(); // max_num_ref_frames
        skipBits(1); // gaps_in_frame_num_value_allowed_flag
        const picWidthInMbsMinus1 = readUEG();
        const picHeightInMapUnitsMinus1 = readUEG();
        const frameMbsOnlyFlag = readBits(1);
        if (frameMbsOnlyFlag === 0) skipBits(1);
         // mb_adaptive_frame_field_flag
        skipBits(1); // direct_8x8_inference_flag
        if (readBoolean()) {
            // frame_cropping_flag
            frameCropLeftOffset = readUEG();
            frameCropRightOffset = readUEG();
            frameCropTopOffset = readUEG();
            frameCropBottomOffset = readUEG();
        }
        let pixelRatio = [
            1,
            1
        ];
        if (readBoolean()) // vui_parameters_present_flag
        {
            if (readBoolean()) {
                // aspect_ratio_info_present_flag
                const aspectRatioIdc = readUByte();
                switch(aspectRatioIdc){
                    case 1:
                        pixelRatio = [
                            1,
                            1
                        ];
                        break;
                    case 2:
                        pixelRatio = [
                            12,
                            11
                        ];
                        break;
                    case 3:
                        pixelRatio = [
                            10,
                            11
                        ];
                        break;
                    case 4:
                        pixelRatio = [
                            16,
                            11
                        ];
                        break;
                    case 5:
                        pixelRatio = [
                            40,
                            33
                        ];
                        break;
                    case 6:
                        pixelRatio = [
                            24,
                            11
                        ];
                        break;
                    case 7:
                        pixelRatio = [
                            20,
                            11
                        ];
                        break;
                    case 8:
                        pixelRatio = [
                            32,
                            11
                        ];
                        break;
                    case 9:
                        pixelRatio = [
                            80,
                            33
                        ];
                        break;
                    case 10:
                        pixelRatio = [
                            18,
                            11
                        ];
                        break;
                    case 11:
                        pixelRatio = [
                            15,
                            11
                        ];
                        break;
                    case 12:
                        pixelRatio = [
                            64,
                            33
                        ];
                        break;
                    case 13:
                        pixelRatio = [
                            160,
                            99
                        ];
                        break;
                    case 14:
                        pixelRatio = [
                            4,
                            3
                        ];
                        break;
                    case 15:
                        pixelRatio = [
                            3,
                            2
                        ];
                        break;
                    case 16:
                        pixelRatio = [
                            2,
                            1
                        ];
                        break;
                    case 255:
                        pixelRatio = [
                            readUByte() << 8 | readUByte(),
                            readUByte() << 8 | readUByte()
                        ];
                        break;
                }
            }
        }
        return {
            width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
            height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
            pixelRatio: pixelRatio
        };
    }
    readSliceType() {
        // skip NALu type
        this.readUByte();
        // discard first_mb_in_slice
        this.readUEG();
        // return slice_type
        return this.readUEG();
    }
}
/**
 * SAMPLE-AES decrypter
 */ class $fada8102d2a280be$var$SampleAesDecrypter {
    constructor(observer, config, keyData){
        this.keyData = void 0;
        this.decrypter = void 0;
        this.keyData = keyData;
        this.decrypter = new $fada8102d2a280be$var$Decrypter(config, {
            removePKCS7Padding: false
        });
    }
    decryptBuffer(encryptedData) {
        return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer);
    }
    // AAC - encrypt all full 16 bytes blocks starting from offset 16
    decryptAacSample(samples, sampleIndex, callback) {
        const curUnit = samples[sampleIndex].unit;
        if (curUnit.length <= 16) // No encrypted portion in this sample (first 16 bytes is not
        // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
        return;
        const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
        const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
        this.decryptBuffer(encryptedBuffer).then((decryptedBuffer)=>{
            const decryptedData = new Uint8Array(decryptedBuffer);
            curUnit.set(decryptedData, 16);
            if (!this.decrypter.isSync()) this.decryptAacSamples(samples, sampleIndex + 1, callback);
        });
    }
    decryptAacSamples(samples, sampleIndex, callback) {
        for(;; sampleIndex++){
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            if (samples[sampleIndex].unit.length < 32) continue;
            this.decryptAacSample(samples, sampleIndex, callback);
            if (!this.decrypter.isSync()) return;
        }
    }
    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
    getAvcEncryptedData(decodedData) {
        const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
        const encryptedData = new Int8Array(encryptedDataLen);
        let outputPos = 0;
        for(let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16)encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
        return encryptedData;
    }
    getAvcDecryptedUnit(decodedData, decryptedData) {
        const uint8DecryptedData = new Uint8Array(decryptedData);
        let inputPos = 0;
        for(let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16)decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
        return decodedData;
    }
    decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
        const decodedData = $fada8102d2a280be$var$discardEPB(curUnit.data);
        const encryptedData = this.getAvcEncryptedData(decodedData);
        this.decryptBuffer(encryptedData.buffer).then((decryptedBuffer)=>{
            curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
            if (!this.decrypter.isSync()) this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
        });
    }
    decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
        if (samples instanceof Uint8Array) throw new Error("Cannot decrypt samples of type Uint8Array");
        for(;; sampleIndex++, unitIndex = 0){
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            const curUnits = samples[sampleIndex].units;
            for(;; unitIndex++){
                if (unitIndex >= curUnits.length) break;
                const curUnit = curUnits[unitIndex];
                if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) continue;
                this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
                if (!this.decrypter.isSync()) return;
            }
        }
    }
}
const $fada8102d2a280be$var$PACKET_LENGTH = 188;
class $fada8102d2a280be$var$TSDemuxer {
    constructor(observer, config, typeSupported){
        this.observer = void 0;
        this.config = void 0;
        this.typeSupported = void 0;
        this.sampleAes = null;
        this.pmtParsed = false;
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this._duration = 0;
        this._pmtId = -1;
        this._avcTrack = void 0;
        this._audioTrack = void 0;
        this._id3Track = void 0;
        this._txtTrack = void 0;
        this.aacOverFlow = null;
        this.avcSample = null;
        this.remainderData = null;
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
    }
    static probe(data) {
        const syncOffset = $fada8102d2a280be$var$TSDemuxer.syncOffset(data);
        if (syncOffset > 0) $fada8102d2a280be$var$logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
        return syncOffset !== -1;
    }
    static syncOffset(data) {
        const length = data.length;
        let scanwindow = Math.min($fada8102d2a280be$var$PACKET_LENGTH * 5, data.length - $fada8102d2a280be$var$PACKET_LENGTH) + 1;
        let i = 0;
        while(i < scanwindow){
            // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
            let foundPat = false;
            let packetStart = -1;
            let tsPackets = 0;
            for(let j = i; j < length; j += $fada8102d2a280be$var$PACKET_LENGTH){
                if (data[j] === 0x47) {
                    tsPackets++;
                    if (packetStart === -1) {
                        packetStart = j;
                        // First sync word found at offset, increase scan length (#5251)
                        if (packetStart !== 0) scanwindow = Math.min(packetStart + $fada8102d2a280be$var$PACKET_LENGTH * 99, data.length - $fada8102d2a280be$var$PACKET_LENGTH) + 1;
                    }
                    if (!foundPat) foundPat = $fada8102d2a280be$var$parsePID(data, j) === 0;
                    // Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
                    if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + $fada8102d2a280be$var$PACKET_LENGTH > scanwindow)) return packetStart;
                } else if (tsPackets) // Exit if sync word found, but does not contain contiguous packets (#5501)
                return -1;
                else break;
            }
            i++;
        }
        return -1;
    }
    /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */ static createTrack(type, duration) {
        return {
            container: type === "video" || type === "audio" ? "video/mp2t" : undefined,
            type: type,
            id: $fada8102d2a280be$var$RemuxerTrackIdConfig[type],
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            dropped: 0,
            duration: type === "audio" ? duration : undefined
        };
    }
    /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */ resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        this.pmtParsed = false;
        this._pmtId = -1;
        this._avcTrack = $fada8102d2a280be$var$TSDemuxer.createTrack("video");
        this._audioTrack = $fada8102d2a280be$var$TSDemuxer.createTrack("audio", trackDuration);
        this._id3Track = $fada8102d2a280be$var$TSDemuxer.createTrack("id3");
        this._txtTrack = $fada8102d2a280be$var$TSDemuxer.createTrack("text");
        this._audioTrack.segmentCodec = "aac";
        // flush any partial content
        this.aacOverFlow = null;
        this.avcSample = null;
        this.remainderData = null;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this._duration = trackDuration;
    }
    resetTimeStamp() {}
    resetContiguity() {
        const { _audioTrack: _audioTrack, _avcTrack: _avcTrack, _id3Track: _id3Track } = this;
        if (_audioTrack) _audioTrack.pesData = null;
        if (_avcTrack) _avcTrack.pesData = null;
        if (_id3Track) _id3Track.pesData = null;
        this.aacOverFlow = null;
        this.avcSample = null;
        this.remainderData = null;
    }
    demux(data, timeOffset, isSampleAes = false, flush = false) {
        if (!isSampleAes) this.sampleAes = null;
        let pes;
        const videoTrack = this._avcTrack;
        const audioTrack = this._audioTrack;
        const id3Track = this._id3Track;
        const textTrack = this._txtTrack;
        let avcId = videoTrack.pid;
        let avcData = videoTrack.pesData;
        let audioId = audioTrack.pid;
        let id3Id = id3Track.pid;
        let audioData = audioTrack.pesData;
        let id3Data = id3Track.pesData;
        let unknownPID = null;
        let pmtParsed = this.pmtParsed;
        let pmtId = this._pmtId;
        let len = data.length;
        if (this.remainderData) {
            data = $fada8102d2a280be$var$appendUint8Array(this.remainderData, data);
            len = data.length;
            this.remainderData = null;
        }
        if (len < $fada8102d2a280be$var$PACKET_LENGTH && !flush) {
            this.remainderData = data;
            return {
                audioTrack: audioTrack,
                videoTrack: videoTrack,
                id3Track: id3Track,
                textTrack: textTrack
            };
        }
        const syncOffset = Math.max(0, $fada8102d2a280be$var$TSDemuxer.syncOffset(data));
        len -= (len - syncOffset) % $fada8102d2a280be$var$PACKET_LENGTH;
        if (len < data.byteLength && !flush) this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
        // loop through TS packets
        let tsPacketErrors = 0;
        for(let start = syncOffset; start < len; start += $fada8102d2a280be$var$PACKET_LENGTH)if (data[start] === 0x47) {
            const stt = !!(data[start + 1] & 0x40);
            const pid = $fada8102d2a280be$var$parsePID(data, start);
            const atf = (data[start + 3] & 0x30) >> 4;
            // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
            let offset;
            if (atf > 1) {
                offset = start + 5 + data[start + 4];
                // continue if there is only adaptation field
                if (offset === start + $fada8102d2a280be$var$PACKET_LENGTH) continue;
            } else offset = start + 4;
            switch(pid){
                case avcId:
                    if (stt) {
                        if (avcData && (pes = $fada8102d2a280be$var$parsePES(avcData))) this.parseAVCPES(videoTrack, textTrack, pes, false);
                        avcData = {
                            data: [],
                            size: 0
                        };
                    }
                    if (avcData) {
                        avcData.data.push(data.subarray(offset, start + $fada8102d2a280be$var$PACKET_LENGTH));
                        avcData.size += start + $fada8102d2a280be$var$PACKET_LENGTH - offset;
                    }
                    break;
                case audioId:
                    if (stt) {
                        if (audioData && (pes = $fada8102d2a280be$var$parsePES(audioData))) switch(audioTrack.segmentCodec){
                            case "aac":
                                this.parseAACPES(audioTrack, pes);
                                break;
                            case "mp3":
                                this.parseMPEGPES(audioTrack, pes);
                                break;
                        }
                        audioData = {
                            data: [],
                            size: 0
                        };
                    }
                    if (audioData) {
                        audioData.data.push(data.subarray(offset, start + $fada8102d2a280be$var$PACKET_LENGTH));
                        audioData.size += start + $fada8102d2a280be$var$PACKET_LENGTH - offset;
                    }
                    break;
                case id3Id:
                    if (stt) {
                        if (id3Data && (pes = $fada8102d2a280be$var$parsePES(id3Data))) this.parseID3PES(id3Track, pes);
                        id3Data = {
                            data: [],
                            size: 0
                        };
                    }
                    if (id3Data) {
                        id3Data.data.push(data.subarray(offset, start + $fada8102d2a280be$var$PACKET_LENGTH));
                        id3Data.size += start + $fada8102d2a280be$var$PACKET_LENGTH - offset;
                    }
                    break;
                case 0:
                    if (stt) offset += data[offset] + 1;
                    pmtId = this._pmtId = $fada8102d2a280be$var$parsePAT(data, offset);
                    break;
                case pmtId:
                    {
                        if (stt) offset += data[offset] + 1;
                        const parsedPIDs = $fada8102d2a280be$var$parsePMT(data, offset, this.typeSupported, isSampleAes);
                        // only update track id if track PID found while parsing PMT
                        // this is to avoid resetting the PID to -1 in case
                        // track PID transiently disappears from the stream
                        // this could happen in case of transient missing audio samples for example
                        // NOTE this is only the PID of the track as found in TS,
                        // but we are not using this for MP4 track IDs.
                        avcId = parsedPIDs.avc;
                        if (avcId > 0) videoTrack.pid = avcId;
                        audioId = parsedPIDs.audio;
                        if (audioId > 0) {
                            audioTrack.pid = audioId;
                            audioTrack.segmentCodec = parsedPIDs.segmentCodec;
                        }
                        id3Id = parsedPIDs.id3;
                        if (id3Id > 0) id3Track.pid = id3Id;
                        if (unknownPID !== null && !pmtParsed) {
                            $fada8102d2a280be$var$logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
                            unknownPID = null;
                            // we set it to -188, the += 188 in the for loop will reset start to 0
                            start = syncOffset - 188;
                        }
                        pmtParsed = this.pmtParsed = true;
                        break;
                    }
                case 0x11:
                case 0x1fff:
                    break;
                default:
                    unknownPID = pid;
                    break;
            }
        } else tsPacketErrors++;
        if (tsPacketErrors > 0) {
            const error = new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`);
            this.observer.emit($fada8102d2a280be$var$Events.ERROR, $fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR,
                fatal: false,
                error: error,
                reason: error.message
            });
        }
        videoTrack.pesData = avcData;
        audioTrack.pesData = audioData;
        id3Track.pesData = id3Data;
        const demuxResult = {
            audioTrack: audioTrack,
            videoTrack: videoTrack,
            id3Track: id3Track,
            textTrack: textTrack
        };
        if (flush) this.extractRemainingSamples(demuxResult);
        return demuxResult;
    }
    flush() {
        const { remainderData: remainderData } = this;
        this.remainderData = null;
        let result;
        if (remainderData) result = this.demux(remainderData, -1, false, true);
        else result = {
            videoTrack: this._avcTrack,
            audioTrack: this._audioTrack,
            id3Track: this._id3Track,
            textTrack: this._txtTrack
        };
        this.extractRemainingSamples(result);
        if (this.sampleAes) return this.decrypt(result, this.sampleAes);
        return result;
    }
    extractRemainingSamples(demuxResult) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = demuxResult;
        const avcData = videoTrack.pesData;
        const audioData = audioTrack.pesData;
        const id3Data = id3Track.pesData;
        // try to parse last PES packets
        let pes;
        if (avcData && (pes = $fada8102d2a280be$var$parsePES(avcData))) {
            this.parseAVCPES(videoTrack, textTrack, pes, true);
            videoTrack.pesData = null;
        } else // either avcData null or PES truncated, keep it for next frag parsing
        videoTrack.pesData = avcData;
        if (audioData && (pes = $fada8102d2a280be$var$parsePES(audioData))) {
            switch(audioTrack.segmentCodec){
                case "aac":
                    this.parseAACPES(audioTrack, pes);
                    break;
                case "mp3":
                    this.parseMPEGPES(audioTrack, pes);
                    break;
            }
            audioTrack.pesData = null;
        } else {
            if (audioData != null && audioData.size) $fada8102d2a280be$var$logger.log("last AAC PES packet truncated,might overlap between fragments");
            // either audioData null or PES truncated, keep it for next frag parsing
            audioTrack.pesData = audioData;
        }
        if (id3Data && (pes = $fada8102d2a280be$var$parsePES(id3Data))) {
            this.parseID3PES(id3Track, pes);
            id3Track.pesData = null;
        } else // either id3Data null or PES truncated, keep it for next frag parsing
        id3Track.pesData = id3Data;
    }
    demuxSampleAes(data, keyData, timeOffset) {
        const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
        const sampleAes = this.sampleAes = new $fada8102d2a280be$var$SampleAesDecrypter(this.observer, this.config, keyData);
        return this.decrypt(demuxResult, sampleAes);
    }
    decrypt(demuxResult, sampleAes) {
        return new Promise((resolve)=>{
            const { audioTrack: audioTrack, videoTrack: videoTrack } = demuxResult;
            if (audioTrack.samples && audioTrack.segmentCodec === "aac") sampleAes.decryptAacSamples(audioTrack.samples, 0, ()=>{
                if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, ()=>{
                    resolve(demuxResult);
                });
                else resolve(demuxResult);
            });
            else if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, ()=>{
                resolve(demuxResult);
            });
        });
    }
    destroy() {
        this._duration = 0;
    }
    parseAVCPES(track, textTrack, pes, last) {
        const units = this.parseAVCNALu(track, pes.data);
        let avcSample = this.avcSample;
        let push;
        let spsfound = false;
        // free pes.data to save up some memory
        pes.data = null;
        // if new NAL units found and last sample still there, let's push ...
        // this helps parsing streams with missing AUD (only do this if AUD never found)
        if (avcSample && units.length && !track.audFound) {
            $fada8102d2a280be$var$pushAccessUnit(avcSample, track);
            avcSample = this.avcSample = $fada8102d2a280be$var$createAVCSample(false, pes.pts, pes.dts, "");
        }
        units.forEach((unit)=>{
            switch(unit.type){
                // NDR
                case 1:
                    {
                        push = true;
                        if (!avcSample) avcSample = this.avcSample = $fada8102d2a280be$var$createAVCSample(true, pes.pts, pes.dts, "");
                        avcSample.frame = true;
                        const data = unit.data;
                        // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
                        if (spsfound && data.length > 4) {
                            // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
                            const sliceType = new $fada8102d2a280be$var$ExpGolomb(data).readSliceType();
                            // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
                            // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
                            // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
                            // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
                            // if (sliceType === 2 || sliceType === 7) {
                            if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) avcSample.key = true;
                        }
                        break;
                    // IDR
                    }
                case 5:
                    push = true;
                    // handle PES not starting with AUD
                    if (!avcSample) avcSample = this.avcSample = $fada8102d2a280be$var$createAVCSample(true, pes.pts, pes.dts, "");
                    avcSample.key = true;
                    avcSample.frame = true;
                    break;
                // SEI
                case 6:
                    push = true;
                    $fada8102d2a280be$var$parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
                    break;
                case 7:
                    push = true;
                    spsfound = true;
                    if (!track.sps) {
                        const sps = unit.data;
                        const expGolombDecoder = new $fada8102d2a280be$var$ExpGolomb(sps);
                        const config = expGolombDecoder.readSPS();
                        track.width = config.width;
                        track.height = config.height;
                        track.pixelRatio = config.pixelRatio;
                        track.sps = [
                            sps
                        ];
                        track.duration = this._duration;
                        const codecarray = sps.subarray(1, 4);
                        let codecstring = "avc1.";
                        for(let i = 0; i < 3; i++){
                            let h = codecarray[i].toString(16);
                            if (h.length < 2) h = "0" + h;
                            codecstring += h;
                        }
                        track.codec = codecstring;
                    }
                    break;
                // PPS
                case 8:
                    push = true;
                    if (!track.pps) track.pps = [
                        unit.data
                    ];
                    break;
                // AUD
                case 9:
                    push = false;
                    track.audFound = true;
                    if (avcSample) $fada8102d2a280be$var$pushAccessUnit(avcSample, track);
                    avcSample = this.avcSample = $fada8102d2a280be$var$createAVCSample(false, pes.pts, pes.dts, "");
                    break;
                // Filler Data
                case 12:
                    push = true;
                    break;
                default:
                    push = false;
                    if (avcSample) avcSample.debug += "unknown NAL " + unit.type + " ";
                    break;
            }
            if (avcSample && push) {
                const units = avcSample.units;
                units.push(unit);
            }
        });
        // if last PES packet, push samples
        if (last && avcSample) {
            $fada8102d2a280be$var$pushAccessUnit(avcSample, track);
            this.avcSample = null;
        }
    }
    getLastNalUnit(samples) {
        var _avcSample;
        let avcSample = this.avcSample;
        let lastUnit;
        // try to fallback to previous sample if current one is empty
        if (!avcSample || avcSample.units.length === 0) avcSample = samples[samples.length - 1];
        if ((_avcSample = avcSample) != null && _avcSample.units) {
            const units = avcSample.units;
            lastUnit = units[units.length - 1];
        }
        return lastUnit;
    }
    parseAVCNALu(track, array) {
        const len = array.byteLength;
        let state = track.naluState || 0;
        const lastState = state;
        const units = [];
        let i = 0;
        let value;
        let overflow;
        let unitType;
        let lastUnitStart = -1;
        let lastUnitType = 0;
        // logger.log('PES:' + Hex.hexDump(array));
        if (state === -1) {
            // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
            lastUnitStart = 0;
            // NALu type is value read from offset 0
            lastUnitType = array[0] & 0x1f;
            state = 0;
            i = 1;
        }
        while(i < len){
            value = array[i++];
            // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
            if (!state) {
                state = value ? 0 : 1;
                continue;
            }
            if (state === 1) {
                state = value ? 0 : 2;
                continue;
            }
            // here we have state either equal to 2 or 3
            if (!value) state = 3;
            else if (value === 1) {
                if (lastUnitStart >= 0) {
                    const unit = {
                        data: array.subarray(lastUnitStart, i - state - 1),
                        type: lastUnitType
                    };
                    // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
                    units.push(unit);
                } else {
                    // lastUnitStart is undefined => this is the first start code found in this PES packet
                    // first check if start code delimiter is overlapping between 2 PES packets,
                    // ie it started in last packet (lastState not zero)
                    // and ended at the beginning of this PES packet (i <= 4 - lastState)
                    const lastUnit = this.getLastNalUnit(track.samples);
                    if (lastUnit) {
                        if (lastState && i <= 4 - lastState) // start delimiter overlapping between PES packets
                        // strip start delimiter bytes from the end of last NAL unit
                        // check if lastUnit had a state different from zero
                        {
                            if (lastUnit.state) // strip last bytes
                            lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                        }
                        // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
                        overflow = i - state - 1;
                        if (overflow > 0) {
                            // logger.log('first NALU found with overflow:' + overflow);
                            const tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
                            tmp.set(lastUnit.data, 0);
                            tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
                            lastUnit.data = tmp;
                            lastUnit.state = 0;
                        }
                    }
                }
                // check if we can read unit type
                if (i < len) {
                    unitType = array[i] & 0x1f;
                    // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
                    lastUnitStart = i;
                    lastUnitType = unitType;
                    state = 0;
                } else // not enough byte to read unit type. let's read it on next PES parsing
                state = -1;
            } else state = 0;
        }
        if (lastUnitStart >= 0 && state >= 0) {
            const unit = {
                data: array.subarray(lastUnitStart, len),
                type: lastUnitType,
                state: state
            };
            units.push(unit);
        // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
        }
        // no NALu found
        if (units.length === 0) {
            // append pes.data to previous NAL unit
            const lastUnit = this.getLastNalUnit(track.samples);
            if (lastUnit) {
                const tmp = new Uint8Array(lastUnit.data.byteLength + array.byteLength);
                tmp.set(lastUnit.data, 0);
                tmp.set(array, lastUnit.data.byteLength);
                lastUnit.data = tmp;
            }
        }
        track.naluState = state;
        return units;
    }
    parseAACPES(track, pes) {
        let startOffset = 0;
        const aacOverFlow = this.aacOverFlow;
        let data = pes.data;
        if (aacOverFlow) {
            this.aacOverFlow = null;
            const frameMissingBytes = aacOverFlow.missing;
            const sampleLength = aacOverFlow.sample.unit.byteLength;
            // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
            if (frameMissingBytes === -1) {
                const tmp = new Uint8Array(sampleLength + data.byteLength);
                tmp.set(aacOverFlow.sample.unit, 0);
                tmp.set(data, sampleLength);
                data = tmp;
            } else {
                const frameOverflowBytes = sampleLength - frameMissingBytes;
                aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
                track.samples.push(aacOverFlow.sample);
                startOffset = aacOverFlow.missing;
            }
        }
        // look for ADTS header (0xFFFx)
        let offset;
        let len;
        for(offset = startOffset, len = data.length; offset < len - 1; offset++){
            if ($fada8102d2a280be$var$isHeader$1(data, offset)) break;
        }
        // if ADTS header does not start straight from the beginning of the PES payload, raise an error
        if (offset !== startOffset) {
            let reason;
            const recoverable = offset < len - 1;
            if (recoverable) reason = `AAC PES did not start with ADTS header,offset:${offset}`;
            else reason = "No ADTS header found in AAC PES";
            const error = new Error(reason);
            $fada8102d2a280be$var$logger.warn(`parsing error: ${reason}`);
            this.observer.emit($fada8102d2a280be$var$Events.ERROR, $fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR,
                fatal: false,
                levelRetry: recoverable,
                error: error,
                reason: reason
            });
            if (!recoverable) return;
        }
        $fada8102d2a280be$var$initTrackConfig(track, this.observer, data, offset, this.audioCodec);
        let pts;
        if (pes.pts !== undefined) pts = pes.pts;
        else if (aacOverFlow) {
            // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
            // first sample PTS should be equal to last sample PTS + frameDuration
            const frameDuration = $fada8102d2a280be$var$getFrameDuration(track.samplerate);
            pts = aacOverFlow.sample.pts + frameDuration;
        } else {
            $fada8102d2a280be$var$logger.warn("[tsdemuxer]: AAC PES unknown PTS");
            return;
        }
        // scan for aac samples
        let frameIndex = 0;
        let frame;
        while(offset < len){
            frame = $fada8102d2a280be$var$appendFrame$1(track, data, offset, pts, frameIndex);
            offset += frame.length;
            if (!frame.missing) {
                frameIndex++;
                for(; offset < len - 1; offset++){
                    if ($fada8102d2a280be$var$isHeader$1(data, offset)) break;
                }
            } else {
                this.aacOverFlow = frame;
                break;
            }
        }
    }
    parseMPEGPES(track, pes) {
        const data = pes.data;
        const length = data.length;
        let frameIndex = 0;
        let offset = 0;
        const pts = pes.pts;
        if (pts === undefined) {
            $fada8102d2a280be$var$logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
            return;
        }
        while(offset < length)if ($fada8102d2a280be$var$isHeader(data, offset)) {
            const frame = $fada8102d2a280be$var$appendFrame(track, data, offset, pts, frameIndex);
            if (frame) {
                offset += frame.length;
                frameIndex++;
            } else break;
        } else // nothing found, keep looking
        offset++;
    }
    parseID3PES(id3Track, pes) {
        if (pes.pts === undefined) {
            $fada8102d2a280be$var$logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
            return;
        }
        const id3Sample = $fada8102d2a280be$var$_extends({}, pes, {
            type: this._avcTrack ? $fada8102d2a280be$var$MetadataSchema.emsg : $fada8102d2a280be$var$MetadataSchema.audioId3,
            duration: Number.POSITIVE_INFINITY
        });
        id3Track.samples.push(id3Sample);
    }
}
function $fada8102d2a280be$var$createAVCSample(key, pts, dts, debug) {
    return {
        key: key,
        frame: false,
        pts: pts,
        dts: dts,
        units: [],
        debug: debug,
        length: 0
    };
}
function $fada8102d2a280be$var$parsePID(data, offset) {
    // pid is a 13-bit field starting at the last bit of TS[1]
    return ((data[offset + 1] & 0x1f) << 8) + data[offset + 2];
}
function $fada8102d2a280be$var$parsePAT(data, offset) {
    // skip the PSI header and parse the first PMT entry
    return (data[offset + 10] & 0x1f) << 8 | data[offset + 11];
}
function $fada8102d2a280be$var$parsePMT(data, offset, typeSupported, isSampleAes) {
    const result = {
        audio: -1,
        avc: -1,
        id3: -1,
        segmentCodec: "aac"
    };
    const sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
    const tableEnd = offset + 3 + sectionLength - 4;
    // to determine where the table is, we have to figure out how
    // long the program info descriptors are
    const programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
    // advance the offset to the first entry in the mapping table
    offset += 12 + programInfoLength;
    while(offset < tableEnd){
        const pid = $fada8102d2a280be$var$parsePID(data, offset);
        switch(data[offset]){
            case 0xcf:
                // SAMPLE-AES AAC
                if (!isSampleAes) {
                    $fada8102d2a280be$var$logger.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
                    break;
                }
            /* falls through */ case 0x0f:
                // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                // logger.log('AAC PID:'  + pid);
                if (result.audio === -1) result.audio = pid;
                break;
            // Packetized metadata (ID3)
            case 0x15:
                // logger.log('ID3 PID:'  + pid);
                if (result.id3 === -1) result.id3 = pid;
                break;
            case 0xdb:
                // SAMPLE-AES AVC
                if (!isSampleAes) {
                    $fada8102d2a280be$var$logger.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");
                    break;
                }
            /* falls through */ case 0x1b:
                // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                // logger.log('AVC PID:'  + pid);
                if (result.avc === -1) result.avc = pid;
                break;
            // ISO/IEC 11172-3 (MPEG-1 audio)
            // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
            case 0x03:
            case 0x04:
                // logger.log('MPEG PID:'  + pid);
                if (typeSupported.mpeg !== true && typeSupported.mp3 !== true) $fada8102d2a280be$var$logger.log("MPEG audio found, not supported in this browser");
                else if (result.audio === -1) {
                    result.audio = pid;
                    result.segmentCodec = "mp3";
                }
                break;
            case 0x24:
                $fada8102d2a280be$var$logger.warn("Unsupported HEVC stream type found");
                break;
        }
        // move to the next table entry
        // skip past the elementary stream descriptors, if present
        offset += ((data[offset + 3] & 0x0f) << 8 | data[offset + 4]) + 5;
    }
    return result;
}
function $fada8102d2a280be$var$parsePES(stream) {
    let i = 0;
    let frag;
    let pesLen;
    let pesHdrLen;
    let pesPts;
    let pesDts;
    const data = stream.data;
    // safety check
    if (!stream || stream.size === 0) return null;
    // we might need up to 19 bytes to read PES header
    // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
    // usually only one merge is needed (and this is rare ...)
    while(data[0].length < 19 && data.length > 1){
        const newData = new Uint8Array(data[0].length + data[1].length);
        newData.set(data[0]);
        newData.set(data[1], data[0].length);
        data[0] = newData;
        data.splice(1, 1);
    }
    // retrieve PTS/DTS from first fragment
    frag = data[0];
    const pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
    if (pesPrefix === 1) {
        pesLen = (frag[4] << 8) + frag[5];
        // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
        // minus 6 : PES header size
        if (pesLen && pesLen > stream.size - 6) return null;
        const pesFlags = frag[7];
        if (pesFlags & 0xc0) {
            /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */ pesPts = (frag[9] & 0x0e) * 536870912 + // 1 << 29
            (frag[10] & 0xff) * 4194304 + // 1 << 22
            (frag[11] & 0xfe) * 16384 + // 1 << 14
            (frag[12] & 0xff) * 128 + // 1 << 7
            (frag[13] & 0xfe) / 2;
            if (pesFlags & 0x40) {
                pesDts = (frag[14] & 0x0e) * 536870912 + // 1 << 29
                (frag[15] & 0xff) * 4194304 + // 1 << 22
                (frag[16] & 0xfe) * 16384 + // 1 << 14
                (frag[17] & 0xff) * 128 + // 1 << 7
                (frag[18] & 0xfe) / 2;
                if (pesPts - pesDts > 5400000) {
                    $fada8102d2a280be$var$logger.warn(`${Math.round((pesPts - pesDts) / 90000)}s delta between PTS and DTS, align them`);
                    pesPts = pesDts;
                }
            } else pesDts = pesPts;
        }
        pesHdrLen = frag[8];
        // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
        let payloadStartOffset = pesHdrLen + 9;
        if (stream.size <= payloadStartOffset) return null;
        stream.size -= payloadStartOffset;
        // reassemble PES packet
        const pesData = new Uint8Array(stream.size);
        for(let j = 0, dataLen = data.length; j < dataLen; j++){
            frag = data[j];
            let len = frag.byteLength;
            if (payloadStartOffset) {
                if (payloadStartOffset > len) {
                    // trim full frag if PES header bigger than frag
                    payloadStartOffset -= len;
                    continue;
                } else {
                    // trim partial frag if PES header smaller than frag
                    frag = frag.subarray(payloadStartOffset);
                    len -= payloadStartOffset;
                    payloadStartOffset = 0;
                }
            }
            pesData.set(frag, i);
            i += len;
        }
        if (pesLen) // payload size : remove PES header + PES extension
        pesLen -= pesHdrLen + 3;
        return {
            data: pesData,
            pts: pesPts,
            dts: pesDts,
            len: pesLen
        };
    }
    return null;
}
function $fada8102d2a280be$var$pushAccessUnit(avcSample, avcTrack) {
    if (avcSample.units.length && avcSample.frame) {
        // if sample does not have PTS/DTS, patch with last sample PTS/DTS
        if (avcSample.pts === undefined) {
            const samples = avcTrack.samples;
            const nbSamples = samples.length;
            if (nbSamples) {
                const lastSample = samples[nbSamples - 1];
                avcSample.pts = lastSample.pts;
                avcSample.dts = lastSample.dts;
            } else {
                // dropping samples, no timestamp found
                avcTrack.dropped++;
                return;
            }
        }
        avcTrack.samples.push(avcSample);
    }
    if (avcSample.debug.length) $fada8102d2a280be$var$logger.log(avcSample.pts + "/" + avcSample.dts + ":" + avcSample.debug);
}
/**
 * MP3 demuxer
 */ class $fada8102d2a280be$var$MP3Demuxer extends $fada8102d2a280be$var$BaseAudioDemuxer {
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: "audio/mpeg",
            type: "audio",
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: "mp3",
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    static probe(data) {
        if (!data) return false;
        // check if data contains ID3 timestamp and MPEG sync word
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        const id3Data = $fada8102d2a280be$var$getID3Data(data, 0) || [];
        let offset = id3Data.length;
        for(let length = data.length; offset < length; offset++)if ($fada8102d2a280be$var$probe(data, offset)) {
            $fada8102d2a280be$var$logger.log("MPEG Audio sync word found !");
            return true;
        }
        return false;
    }
    canParse(data, offset) {
        return $fada8102d2a280be$var$canParse(data, offset);
    }
    appendFrame(track, data, offset) {
        if (this.basePTS === null) return;
        return $fada8102d2a280be$var$appendFrame(track, data, offset, this.basePTS, this.frameIndex);
    }
}
/**
 *  AAC helper
 */ class $fada8102d2a280be$var$AAC {
    static getSilentFrame(codec, channelCount) {
        switch(codec){
            case "mp4a.40.2":
                if (channelCount === 1) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x23,
                    0x80
                ]);
                else if (channelCount === 2) return new Uint8Array([
                    0x21,
                    0x00,
                    0x49,
                    0x90,
                    0x02,
                    0x19,
                    0x00,
                    0x23,
                    0x80
                ]);
                else if (channelCount === 3) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x8e
                ]);
                else if (channelCount === 4) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x80,
                    0x2c,
                    0x80,
                    0x08,
                    0x02,
                    0x38
                ]);
                else if (channelCount === 5) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x82,
                    0x30,
                    0x04,
                    0x99,
                    0x00,
                    0x21,
                    0x90,
                    0x02,
                    0x38
                ]);
                else if (channelCount === 6) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x82,
                    0x30,
                    0x04,
                    0x99,
                    0x00,
                    0x21,
                    0x90,
                    0x02,
                    0x00,
                    0xb2,
                    0x00,
                    0x20,
                    0x08,
                    0xe0
                ]);
                break;
            // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
            default:
                if (channelCount === 1) // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x4e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x1c,
                    0x6,
                    0xf1,
                    0xc1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                else if (channelCount === 2) // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x5e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x0,
                    0x95,
                    0x0,
                    0x6,
                    0xf1,
                    0xa1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                else if (channelCount === 3) // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x5e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x0,
                    0x95,
                    0x0,
                    0x6,
                    0xf1,
                    0xa1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                break;
        }
        return undefined;
    }
}
/**
 * Generate MP4 Box
 */ const $fada8102d2a280be$var$UINT32_MAX = Math.pow(2, 32) - 1;
class $fada8102d2a280be$var$MP4 {
    static init() {
        $fada8102d2a280be$var$MP4.types = {
            avc1: [],
            // codingname
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            ".mp3": [],
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: [],
            smhd: []
        };
        let i;
        for(i in $fada8102d2a280be$var$MP4.types)if ($fada8102d2a280be$var$MP4.types.hasOwnProperty(i)) $fada8102d2a280be$var$MP4.types[i] = [
            i.charCodeAt(0),
            i.charCodeAt(1),
            i.charCodeAt(2),
            i.charCodeAt(3)
        ];
        const videoHdlr = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x76,
            0x69,
            0x64,
            0x65,
            // handler_type: 'vide'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x56,
            0x69,
            0x64,
            0x65,
            0x6f,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'VideoHandler'
        ]);
        const audioHdlr = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x73,
            0x6f,
            0x75,
            0x6e,
            // handler_type: 'soun'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x53,
            0x6f,
            0x75,
            0x6e,
            0x64,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'SoundHandler'
        ]);
        $fada8102d2a280be$var$MP4.HDLR_TYPES = {
            video: videoHdlr,
            audio: audioHdlr
        };
        const dref = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // entry_count
            0x00,
            0x00,
            0x00,
            0x0c,
            // entry_size
            0x75,
            0x72,
            0x6c,
            0x20,
            // 'url' type
            0x00,
            // version 0
            0x00,
            0x00,
            0x01 // entry_flags
        ]);
        const stco = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00 // entry_count
        ]);
        $fada8102d2a280be$var$MP4.STTS = $fada8102d2a280be$var$MP4.STSC = $fada8102d2a280be$var$MP4.STCO = stco;
        $fada8102d2a280be$var$MP4.STSZ = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // sample_size
            0x00,
            0x00,
            0x00,
            0x00 // sample_count
        ]);
        $fada8102d2a280be$var$MP4.VMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x01,
            // flags
            0x00,
            0x00,
            // graphicsmode
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00 // opcolor
        ]);
        $fada8102d2a280be$var$MP4.SMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            // balance
            0x00,
            0x00 // reserved
        ]);
        $fada8102d2a280be$var$MP4.STSD = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01
        ]); // entry_count
        const majorBrand = new Uint8Array([
            105,
            115,
            111,
            109
        ]); // isom
        const avc1Brand = new Uint8Array([
            97,
            118,
            99,
            49
        ]); // avc1
        const minorVersion = new Uint8Array([
            0,
            0,
            0,
            1
        ]);
        $fada8102d2a280be$var$MP4.FTYP = $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
        $fada8102d2a280be$var$MP4.DINF = $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.dinf, $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.dref, dref));
    }
    static box(type, ...payload) {
        let size = 8;
        let i = payload.length;
        const len = i;
        // calculate the total size we need to allocate
        while(i--)size += payload[i].byteLength;
        const result = new Uint8Array(size);
        result[0] = size >> 24 & 0xff;
        result[1] = size >> 16 & 0xff;
        result[2] = size >> 8 & 0xff;
        result[3] = size & 0xff;
        result.set(type, 4);
        // copy the payload into the result
        for(i = 0, size = 8; i < len; i++){
            // copy payload[i] array @ offset size
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    }
    static hdlr(type) {
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.hdlr, $fada8102d2a280be$var$MP4.HDLR_TYPES[type]);
    }
    static mdat(data) {
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.mdat, data);
    }
    static mdhd(timescale, duration) {
        duration *= timescale;
        const upperWordDuration = Math.floor(duration / ($fada8102d2a280be$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($fada8102d2a280be$var$UINT32_MAX + 1));
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.mdhd, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            timescale >> 24 & 0xff,
            timescale >> 16 & 0xff,
            timescale >> 8 & 0xff,
            timescale & 0xff,
            // timescale
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x55,
            0xc4,
            // 'und' language (undetermined)
            0x00,
            0x00
        ]));
    }
    static mdia(track) {
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.mdia, $fada8102d2a280be$var$MP4.mdhd(track.timescale, track.duration), $fada8102d2a280be$var$MP4.hdlr(track.type), $fada8102d2a280be$var$MP4.minf(track));
    }
    static mfhd(sequenceNumber) {
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.mfhd, new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00,
            // flags
            sequenceNumber >> 24,
            sequenceNumber >> 16 & 0xff,
            sequenceNumber >> 8 & 0xff,
            sequenceNumber & 0xff // sequence_number
        ]));
    }
    static minf(track) {
        if (track.type === "audio") return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.minf, $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.smhd, $fada8102d2a280be$var$MP4.SMHD), $fada8102d2a280be$var$MP4.DINF, $fada8102d2a280be$var$MP4.stbl(track));
        else return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.minf, $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.vmhd, $fada8102d2a280be$var$MP4.VMHD), $fada8102d2a280be$var$MP4.DINF, $fada8102d2a280be$var$MP4.stbl(track));
    }
    static moof(sn, baseMediaDecodeTime, track) {
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.moof, $fada8102d2a280be$var$MP4.mfhd(sn), $fada8102d2a280be$var$MP4.traf(track, baseMediaDecodeTime));
    }
    static moov(tracks) {
        let i = tracks.length;
        const boxes = [];
        while(i--)boxes[i] = $fada8102d2a280be$var$MP4.trak(tracks[i]);
        return $fada8102d2a280be$var$MP4.box.apply(null, [
            $fada8102d2a280be$var$MP4.types.moov,
            $fada8102d2a280be$var$MP4.mvhd(tracks[0].timescale, tracks[0].duration)
        ].concat(boxes).concat($fada8102d2a280be$var$MP4.mvex(tracks)));
    }
    static mvex(tracks) {
        let i = tracks.length;
        const boxes = [];
        while(i--)boxes[i] = $fada8102d2a280be$var$MP4.trex(tracks[i]);
        return $fada8102d2a280be$var$MP4.box.apply(null, [
            $fada8102d2a280be$var$MP4.types.mvex,
            ...boxes
        ]);
    }
    static mvhd(timescale, duration) {
        duration *= timescale;
        const upperWordDuration = Math.floor(duration / ($fada8102d2a280be$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($fada8102d2a280be$var$UINT32_MAX + 1));
        const bytes = new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            timescale >> 24 & 0xff,
            timescale >> 16 & 0xff,
            timescale >> 8 & 0xff,
            timescale & 0xff,
            // timescale
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x00,
            0x01,
            0x00,
            0x00,
            // 1.0 rate
            0x01,
            0x00,
            // 1.0 volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0xff,
            0xff,
            0xff,
            0xff // next_track_ID
        ]);
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.mvhd, bytes);
    }
    static sdtp(track) {
        const samples = track.samples || [];
        const bytes = new Uint8Array(4 + samples.length);
        let i;
        let flags;
        // leave the full box header (4 bytes) all zero
        // write the sample table
        for(i = 0; i < samples.length; i++){
            flags = samples[i].flags;
            bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
        }
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.sdtp, bytes);
    }
    static stbl(track) {
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.stbl, $fada8102d2a280be$var$MP4.stsd(track), $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.stts, $fada8102d2a280be$var$MP4.STTS), $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.stsc, $fada8102d2a280be$var$MP4.STSC), $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.stsz, $fada8102d2a280be$var$MP4.STSZ), $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.stco, $fada8102d2a280be$var$MP4.STCO));
    }
    static avc1(track) {
        let sps = [];
        let pps = [];
        let i;
        let data;
        let len;
        // assemble the SPSs
        for(i = 0; i < track.sps.length; i++){
            data = track.sps[i];
            len = data.byteLength;
            sps.push(len >>> 8 & 0xff);
            sps.push(len & 0xff);
            // SPS
            sps = sps.concat(Array.prototype.slice.call(data));
        }
        // assemble the PPSs
        for(i = 0; i < track.pps.length; i++){
            data = track.pps[i];
            len = data.byteLength;
            pps.push(len >>> 8 & 0xff);
            pps.push(len & 0xff);
            pps = pps.concat(Array.prototype.slice.call(data));
        }
        const avcc = $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.avcC, new Uint8Array([
            0x01,
            // version
            sps[3],
            // profile
            sps[4],
            // profile compat
            sps[5],
            // level
            255,
            // lengthSizeMinusOne, hard-coded to 4 bytes
            0xe0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
        ].concat(sps).concat([
            track.pps.length // numOfPictureParameterSets
        ]).concat(pps))); // "PPS"
        const width = track.width;
        const height = track.height;
        const hSpacing = track.pixelRatio[0];
        const vSpacing = track.pixelRatio[1];
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.avc1, new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            // pre_defined
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            width >> 8 & 0xff,
            width & 0xff,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            // height
            0x00,
            0x48,
            0x00,
            0x00,
            // horizresolution
            0x00,
            0x48,
            0x00,
            0x00,
            // vertresolution
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // frame_count
            0x12,
            0x64,
            0x61,
            0x69,
            0x6c,
            // dailymotion/hls.js
            0x79,
            0x6d,
            0x6f,
            0x74,
            0x69,
            0x6f,
            0x6e,
            0x2f,
            0x68,
            0x6c,
            0x73,
            0x2e,
            0x6a,
            0x73,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // compressorname
            0x00,
            0x18,
            // depth = 24
            0x11,
            0x11
        ]), // pre_defined = -1
        avcc, $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.btrt, new Uint8Array([
            0x00,
            0x1c,
            0x9c,
            0x80,
            // bufferSizeDB
            0x00,
            0x2d,
            0xc6,
            0xc0,
            // maxBitrate
            0x00,
            0x2d,
            0xc6,
            0xc0
        ])), // avgBitrate
        $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.pasp, new Uint8Array([
            hSpacing >> 24,
            // hSpacing
            hSpacing >> 16 & 0xff,
            hSpacing >> 8 & 0xff,
            hSpacing & 0xff,
            vSpacing >> 24,
            // vSpacing
            vSpacing >> 16 & 0xff,
            vSpacing >> 8 & 0xff,
            vSpacing & 0xff
        ])));
    }
    static esds(track) {
        const configlen = track.config.length;
        return new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x03,
            // descriptor_type
            0x17 + configlen,
            // length
            0x00,
            0x01,
            // es_id
            0x00,
            // stream_priority
            0x04,
            // descriptor_type
            0x0f + configlen,
            // length
            0x40,
            // codec : mpeg4_audio
            0x15,
            // stream_type
            0x00,
            0x00,
            0x00,
            // buffer_size
            0x00,
            0x00,
            0x00,
            0x00,
            // maxBitrate
            0x00,
            0x00,
            0x00,
            0x00,
            // avgBitrate
            0x05 // descriptor_type
        ].concat([
            configlen
        ]).concat(track.config).concat([
            0x06,
            0x01,
            0x02
        ])); // GASpecificConfig)); // length + audio config descriptor
    }
    static mp4a(track) {
        const samplerate = track.samplerate;
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.mp4a, new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            track.channelCount,
            // channelcount
            0x00,
            0x10,
            // sampleSize:16bits
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved2
            samplerate >> 8 & 0xff,
            samplerate & 0xff,
            //
            0x00,
            0x00
        ]), $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.esds, $fada8102d2a280be$var$MP4.esds(track)));
    }
    static mp3(track) {
        const samplerate = track.samplerate;
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types[".mp3"], new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            track.channelCount,
            // channelcount
            0x00,
            0x10,
            // sampleSize:16bits
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved2
            samplerate >> 8 & 0xff,
            samplerate & 0xff,
            //
            0x00,
            0x00
        ]));
    }
    static stsd(track) {
        if (track.type === "audio") {
            if (track.segmentCodec === "mp3" && track.codec === "mp3") return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.stsd, $fada8102d2a280be$var$MP4.STSD, $fada8102d2a280be$var$MP4.mp3(track));
            return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.stsd, $fada8102d2a280be$var$MP4.STSD, $fada8102d2a280be$var$MP4.mp4a(track));
        } else return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.stsd, $fada8102d2a280be$var$MP4.STSD, $fada8102d2a280be$var$MP4.avc1(track));
    }
    static tkhd(track) {
        const id = track.id;
        const duration = track.duration * track.timescale;
        const width = track.width;
        const height = track.height;
        const upperWordDuration = Math.floor(duration / ($fada8102d2a280be$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($fada8102d2a280be$var$UINT32_MAX + 1));
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.tkhd, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x07,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            id >> 24 & 0xff,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            // layer
            0x00,
            0x00,
            // alternate_group
            0x00,
            0x00,
            // non-audio track volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            width >> 8 & 0xff,
            width & 0xff,
            0x00,
            0x00,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            0x00,
            0x00 // height
        ]));
    }
    static traf(track, baseMediaDecodeTime) {
        const sampleDependencyTable = $fada8102d2a280be$var$MP4.sdtp(track);
        const id = track.id;
        const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / ($fada8102d2a280be$var$UINT32_MAX + 1));
        const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % ($fada8102d2a280be$var$UINT32_MAX + 1));
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.traf, $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.tfhd, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            id >> 24,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff // track_ID
        ])), $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.tfdt, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            upperWordBaseMediaDecodeTime >> 24,
            upperWordBaseMediaDecodeTime >> 16 & 0xff,
            upperWordBaseMediaDecodeTime >> 8 & 0xff,
            upperWordBaseMediaDecodeTime & 0xff,
            lowerWordBaseMediaDecodeTime >> 24,
            lowerWordBaseMediaDecodeTime >> 16 & 0xff,
            lowerWordBaseMediaDecodeTime >> 8 & 0xff,
            lowerWordBaseMediaDecodeTime & 0xff
        ])), $fada8102d2a280be$var$MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
        20 + // tfdt
        8 + // traf header
        16 + // mfhd
        8 + // moof header
        8), // mdat header
        sampleDependencyTable);
    }
    /**
   * Generate a track box.
   * @param track a track definition
   */ static trak(track) {
        track.duration = track.duration || 0xffffffff;
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.trak, $fada8102d2a280be$var$MP4.tkhd(track), $fada8102d2a280be$var$MP4.mdia(track));
    }
    static trex(track) {
        const id = track.id;
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.trex, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            id >> 24,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // default_sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x01,
            0x00,
            0x01 // default_sample_flags
        ]));
    }
    static trun(track, offset) {
        const samples = track.samples || [];
        const len = samples.length;
        const arraylen = 12 + 16 * len;
        const array = new Uint8Array(arraylen);
        let i;
        let sample;
        let duration;
        let size;
        let flags;
        let cts;
        offset += 8 + arraylen;
        array.set([
            track.type === "video" ? 0x01 : 0x00,
            // version 1 for video with signed-int sample_composition_time_offset
            0x00,
            0x0f,
            0x01,
            // flags
            len >>> 24 & 0xff,
            len >>> 16 & 0xff,
            len >>> 8 & 0xff,
            len & 0xff,
            // sample_count
            offset >>> 24 & 0xff,
            offset >>> 16 & 0xff,
            offset >>> 8 & 0xff,
            offset & 0xff // data_offset
        ], 0);
        for(i = 0; i < len; i++){
            sample = samples[i];
            duration = sample.duration;
            size = sample.size;
            flags = sample.flags;
            cts = sample.cts;
            array.set([
                duration >>> 24 & 0xff,
                duration >>> 16 & 0xff,
                duration >>> 8 & 0xff,
                duration & 0xff,
                // sample_duration
                size >>> 24 & 0xff,
                size >>> 16 & 0xff,
                size >>> 8 & 0xff,
                size & 0xff,
                // sample_size
                flags.isLeading << 2 | flags.dependsOn,
                flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync,
                flags.degradPrio & 61440,
                flags.degradPrio & 0x0f,
                // sample_flags
                cts >>> 24 & 0xff,
                cts >>> 16 & 0xff,
                cts >>> 8 & 0xff,
                cts & 0xff // sample_composition_time_offset
            ], 12 + 16 * i);
        }
        return $fada8102d2a280be$var$MP4.box($fada8102d2a280be$var$MP4.types.trun, array);
    }
    static initSegment(tracks) {
        if (!$fada8102d2a280be$var$MP4.types) $fada8102d2a280be$var$MP4.init();
        const movie = $fada8102d2a280be$var$MP4.moov(tracks);
        const result = new Uint8Array($fada8102d2a280be$var$MP4.FTYP.byteLength + movie.byteLength);
        result.set($fada8102d2a280be$var$MP4.FTYP);
        result.set(movie, $fada8102d2a280be$var$MP4.FTYP.byteLength);
        return result;
    }
}
$fada8102d2a280be$var$MP4.types = void 0;
$fada8102d2a280be$var$MP4.HDLR_TYPES = void 0;
$fada8102d2a280be$var$MP4.STTS = void 0;
$fada8102d2a280be$var$MP4.STSC = void 0;
$fada8102d2a280be$var$MP4.STCO = void 0;
$fada8102d2a280be$var$MP4.STSZ = void 0;
$fada8102d2a280be$var$MP4.VMHD = void 0;
$fada8102d2a280be$var$MP4.SMHD = void 0;
$fada8102d2a280be$var$MP4.STSD = void 0;
$fada8102d2a280be$var$MP4.FTYP = void 0;
$fada8102d2a280be$var$MP4.DINF = void 0;
const $fada8102d2a280be$var$MPEG_TS_CLOCK_FREQ_HZ = 90000;
function $fada8102d2a280be$var$toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
    const result = baseTime * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
    return round ? Math.round(result) : result;
}
function $fada8102d2a280be$var$toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
    return $fada8102d2a280be$var$toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function $fada8102d2a280be$var$toMsFromMpegTsClock(baseTime, round = false) {
    return $fada8102d2a280be$var$toTimescaleFromBase(baseTime, 1000, 1 / $fada8102d2a280be$var$MPEG_TS_CLOCK_FREQ_HZ, round);
}
function $fada8102d2a280be$var$toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
    return $fada8102d2a280be$var$toTimescaleFromBase(baseTime, $fada8102d2a280be$var$MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}
const $fada8102d2a280be$var$MAX_SILENT_FRAME_DURATION = 10000; // 10 seconds
const $fada8102d2a280be$var$AAC_SAMPLES_PER_FRAME = 1024;
const $fada8102d2a280be$var$MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
let $fada8102d2a280be$var$chromeVersion = null;
let $fada8102d2a280be$var$safariWebkitVersion = null;
class $fada8102d2a280be$var$MP4Remuxer {
    constructor(observer, config, typeSupported, vendor = ""){
        this.observer = void 0;
        this.config = void 0;
        this.typeSupported = void 0;
        this.ISGenerated = false;
        this._initPTS = null;
        this._initDTS = null;
        this.nextAvcDts = null;
        this.nextAudioPts = null;
        this.videoSampleDuration = null;
        this.isAudioContiguous = false;
        this.isVideoContiguous = false;
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.ISGenerated = false;
        if ($fada8102d2a280be$var$chromeVersion === null) {
            const userAgent = navigator.userAgent || "";
            const result = userAgent.match(/Chrome\/(\d+)/i);
            $fada8102d2a280be$var$chromeVersion = result ? parseInt(result[1]) : 0;
        }
        if ($fada8102d2a280be$var$safariWebkitVersion === null) {
            const result = navigator.userAgent.match(/Safari\/(\d+)/i);
            $fada8102d2a280be$var$safariWebkitVersion = result ? parseInt(result[1]) : 0;
        }
    }
    destroy() {}
    resetTimeStamp(defaultTimeStamp) {
        $fada8102d2a280be$var$logger.log("[mp4-remuxer]: initPTS & initDTS reset");
        this._initPTS = this._initDTS = defaultTimeStamp;
    }
    resetNextTimestamp() {
        $fada8102d2a280be$var$logger.log("[mp4-remuxer]: reset next timestamp");
        this.isVideoContiguous = false;
        this.isAudioContiguous = false;
    }
    resetInitSegment() {
        $fada8102d2a280be$var$logger.log("[mp4-remuxer]: ISGenerated flag reset");
        this.ISGenerated = false;
    }
    getVideoStartPts(videoSamples) {
        let rolloverDetected = false;
        const startPTS = videoSamples.reduce((minPTS, sample)=>{
            const delta = sample.pts - minPTS;
            if (delta < -4294967296) {
                // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
                rolloverDetected = true;
                return $fada8102d2a280be$var$normalizePts(minPTS, sample.pts);
            } else if (delta > 0) return minPTS;
            else return sample.pts;
        }, videoSamples[0].pts);
        if (rolloverDetected) $fada8102d2a280be$var$logger.debug("PTS rollover detected");
        return startPTS;
    }
    remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
        let video;
        let audio;
        let initSegment;
        let text;
        let id3;
        let independent;
        let audioTimeOffset = timeOffset;
        let videoTimeOffset = timeOffset;
        // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
        // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
        // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
        // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
        // then we can remux one track without waiting for the other.
        const hasAudio = audioTrack.pid > -1;
        const hasVideo = videoTrack.pid > -1;
        const length = videoTrack.samples.length;
        const enoughAudioSamples = audioTrack.samples.length > 0;
        const enoughVideoSamples = flush && length > 0 || length > 1;
        const canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush;
        if (canRemuxAvc) {
            if (!this.ISGenerated) initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
            const isVideoContiguous = this.isVideoContiguous;
            let firstKeyFrameIndex = -1;
            let firstKeyFramePTS;
            if (enoughVideoSamples) {
                firstKeyFrameIndex = $fada8102d2a280be$var$findKeyframeIndex(videoTrack.samples);
                if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
                    independent = true;
                    if (firstKeyFrameIndex > 0) {
                        $fada8102d2a280be$var$logger.warn(`[mp4-remuxer]: Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
                        const startPTS = this.getVideoStartPts(videoTrack.samples);
                        videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
                        videoTrack.dropped += firstKeyFrameIndex;
                        videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
                        firstKeyFramePTS = videoTimeOffset;
                    } else if (firstKeyFrameIndex === -1) {
                        $fada8102d2a280be$var$logger.warn(`[mp4-remuxer]: No keyframe found out of ${length} video samples`);
                        independent = false;
                    }
                }
            }
            if (this.ISGenerated) {
                if (enoughAudioSamples && enoughVideoSamples) {
                    // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
                    // if first audio DTS is not aligned with first video DTS then we need to take that into account
                    // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
                    // drift between audio and video streams
                    const startPTS = this.getVideoStartPts(videoTrack.samples);
                    const tsDelta = $fada8102d2a280be$var$normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS;
                    const audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
                    audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
                    videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
                }
                // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
                if (enoughAudioSamples) {
                    // if initSegment was generated without audio samples, regenerate it again
                    if (!audioTrack.samplerate) {
                        $fada8102d2a280be$var$logger.warn("[mp4-remuxer]: regenerate InitSegment as audio detected");
                        initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
                    }
                    audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === $fada8102d2a280be$var$PlaylistLevelType.AUDIO ? videoTimeOffset : undefined);
                    if (enoughVideoSamples) {
                        const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
                        // if initSegment was generated without video samples, regenerate it again
                        if (!videoTrack.inputTimeScale) {
                            $fada8102d2a280be$var$logger.warn("[mp4-remuxer]: regenerate InitSegment as video detected");
                            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
                        }
                        video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
                    }
                } else if (enoughVideoSamples) video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
                if (video) {
                    video.firstKeyFrame = firstKeyFrameIndex;
                    video.independent = firstKeyFrameIndex !== -1;
                    video.firstKeyFramePTS = firstKeyFramePTS;
                }
            }
        }
        // Allow ID3 and text to remux, even if more audio/video samples are required
        if (this.ISGenerated && this._initPTS && this._initDTS) {
            if (id3Track.samples.length) id3 = $fada8102d2a280be$var$flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
            if (textTrack.samples.length) text = $fada8102d2a280be$var$flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
        }
        return {
            audio: audio,
            video: video,
            initSegment: initSegment,
            independent: independent,
            text: text,
            id3: id3
        };
    }
    generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
        const audioSamples = audioTrack.samples;
        const videoSamples = videoTrack.samples;
        const typeSupported = this.typeSupported;
        const tracks = {};
        const _initPTS = this._initPTS;
        let computePTSDTS = !_initPTS || accurateTimeOffset;
        let container = "audio/mp4";
        let initPTS;
        let initDTS;
        let timescale;
        if (computePTSDTS) initPTS = initDTS = Infinity;
        if (audioTrack.config && audioSamples.length) {
            // let's use audio sampling rate as MP4 time scale.
            // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
            // using audio sampling rate here helps having an integer MP4 frame duration
            // this avoids potential rounding issue and AV sync issue
            audioTrack.timescale = audioTrack.samplerate;
            switch(audioTrack.segmentCodec){
                case "mp3":
                    if (typeSupported.mpeg) {
                        // Chrome and Safari
                        container = "audio/mpeg";
                        audioTrack.codec = "";
                    } else if (typeSupported.mp3) // Firefox
                    audioTrack.codec = "mp3";
                    break;
            }
            tracks.audio = {
                id: "audio",
                container: container,
                codec: audioTrack.codec,
                initSegment: audioTrack.segmentCodec === "mp3" && typeSupported.mpeg ? new Uint8Array(0) : $fada8102d2a280be$var$MP4.initSegment([
                    audioTrack
                ]),
                metadata: {
                    channelCount: audioTrack.channelCount
                }
            };
            if (computePTSDTS) {
                timescale = audioTrack.inputTimeScale;
                if (!_initPTS || timescale !== _initPTS.timescale) // remember first PTS of this demuxing context. for audio, PTS = DTS
                initPTS = initDTS = audioSamples[0].pts - Math.round(timescale * timeOffset);
                else computePTSDTS = false;
            }
        }
        if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
            // let's use input time scale as MP4 video timescale
            // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
            videoTrack.timescale = videoTrack.inputTimeScale;
            tracks.video = {
                id: "main",
                container: "video/mp4",
                codec: videoTrack.codec,
                initSegment: $fada8102d2a280be$var$MP4.initSegment([
                    videoTrack
                ]),
                metadata: {
                    width: videoTrack.width,
                    height: videoTrack.height
                }
            };
            if (computePTSDTS) {
                timescale = videoTrack.inputTimeScale;
                if (!_initPTS || timescale !== _initPTS.timescale) {
                    const startPTS = this.getVideoStartPts(videoSamples);
                    const startOffset = Math.round(timescale * timeOffset);
                    initDTS = Math.min(initDTS, $fada8102d2a280be$var$normalizePts(videoSamples[0].dts, startPTS) - startOffset);
                    initPTS = Math.min(initPTS, startPTS - startOffset);
                } else computePTSDTS = false;
            }
        }
        if (Object.keys(tracks).length) {
            this.ISGenerated = true;
            if (computePTSDTS) {
                this._initPTS = {
                    baseTime: initPTS,
                    timescale: timescale
                };
                this._initDTS = {
                    baseTime: initDTS,
                    timescale: timescale
                };
            } else initPTS = timescale = undefined;
            return {
                tracks: tracks,
                initPTS: initPTS,
                timescale: timescale
            };
        }
    }
    remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
        const timeScale = track.inputTimeScale;
        const inputSamples = track.samples;
        const outputSamples = [];
        const nbSamples = inputSamples.length;
        const initPTS = this._initPTS;
        let nextAvcDts = this.nextAvcDts;
        let offset = 8;
        let mp4SampleDuration = this.videoSampleDuration;
        let firstDTS;
        let lastDTS;
        let minPTS = Number.POSITIVE_INFINITY;
        let maxPTS = Number.NEGATIVE_INFINITY;
        let sortSamples = false;
        // if parsed fragment is contiguous with last one, let's use last DTS value as reference
        if (!contiguous || nextAvcDts === null) {
            const pts = timeOffset * timeScale;
            const cts = inputSamples[0].pts - $fada8102d2a280be$var$normalizePts(inputSamples[0].dts, inputSamples[0].pts);
            // if not contiguous, let's use target timeOffset
            nextAvcDts = pts - cts;
        }
        // PTS is coded on 33bits, and can loop from -2^32 to 2^32
        // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
        const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
        for(let i = 0; i < nbSamples; i++){
            const sample = inputSamples[i];
            sample.pts = $fada8102d2a280be$var$normalizePts(sample.pts - initTime, nextAvcDts);
            sample.dts = $fada8102d2a280be$var$normalizePts(sample.dts - initTime, nextAvcDts);
            if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) sortSamples = true;
        }
        // sort video samples by DTS then PTS then demux id order
        if (sortSamples) inputSamples.sort(function(a, b) {
            const deltadts = a.dts - b.dts;
            const deltapts = a.pts - b.pts;
            return deltadts || deltapts;
        });
        // Get first/last DTS
        firstDTS = inputSamples[0].dts;
        lastDTS = inputSamples[inputSamples.length - 1].dts;
        // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
        // set this constant duration as being the avg delta between consecutive DTS.
        const inputDuration = lastDTS - firstDTS;
        const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;
        // if fragment are contiguous, detect hole/overlapping between fragments
        if (contiguous) {
            // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
            const delta = firstDTS - nextAvcDts;
            const foundHole = delta > averageSampleDuration;
            const foundOverlap = delta < -1;
            if (foundHole || foundOverlap) {
                if (foundHole) $fada8102d2a280be$var$logger.warn(`AVC: ${$fada8102d2a280be$var$toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected, filling it`);
                else $fada8102d2a280be$var$logger.warn(`AVC: ${$fada8102d2a280be$var$toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected`);
                if (!foundOverlap || nextAvcDts >= inputSamples[0].pts) {
                    firstDTS = nextAvcDts;
                    const firstPTS = inputSamples[0].pts - delta;
                    inputSamples[0].dts = firstDTS;
                    inputSamples[0].pts = firstPTS;
                    $fada8102d2a280be$var$logger.log(`Video: First PTS/DTS adjusted: ${$fada8102d2a280be$var$toMsFromMpegTsClock(firstPTS, true)}/${$fada8102d2a280be$var$toMsFromMpegTsClock(firstDTS, true)}, delta: ${$fada8102d2a280be$var$toMsFromMpegTsClock(delta, true)} ms`);
                }
            }
        }
        firstDTS = Math.max(0, firstDTS);
        let nbNalu = 0;
        let naluLen = 0;
        for(let i = 0; i < nbSamples; i++){
            // compute total/avc sample length and nb of NAL units
            const sample = inputSamples[i];
            const units = sample.units;
            const nbUnits = units.length;
            let sampleLen = 0;
            for(let j = 0; j < nbUnits; j++)sampleLen += units[j].data.length;
            naluLen += sampleLen;
            nbNalu += nbUnits;
            sample.length = sampleLen;
            // ensure sample monotonic DTS
            sample.dts = Math.max(sample.dts, firstDTS);
            minPTS = Math.min(sample.pts, minPTS);
            maxPTS = Math.max(sample.pts, maxPTS);
        }
        lastDTS = inputSamples[nbSamples - 1].dts;
        /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */ const mdatSize = naluLen + 4 * nbNalu + 8;
        let mdat;
        try {
            mdat = new Uint8Array(mdatSize);
        } catch (err) {
            this.observer.emit($fada8102d2a280be$var$Events.ERROR, $fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.MUX_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.REMUX_ALLOC_ERROR,
                fatal: false,
                error: err,
                bytes: mdatSize,
                reason: `fail allocating video mdat ${mdatSize}`
            });
            return;
        }
        const view = new DataView(mdat.buffer);
        view.setUint32(0, mdatSize);
        mdat.set($fada8102d2a280be$var$MP4.types.mdat, 4);
        let stretchedLastFrame = false;
        let minDtsDelta = Number.POSITIVE_INFINITY;
        let minPtsDelta = Number.POSITIVE_INFINITY;
        let maxDtsDelta = Number.NEGATIVE_INFINITY;
        let maxPtsDelta = Number.NEGATIVE_INFINITY;
        for(let i = 0; i < nbSamples; i++){
            const avcSample = inputSamples[i];
            const avcSampleUnits = avcSample.units;
            let mp4SampleLength = 0;
            // convert NALU bitstream to MP4 format (prepend NALU with size field)
            for(let j = 0, nbUnits = avcSampleUnits.length; j < nbUnits; j++){
                const unit = avcSampleUnits[j];
                const unitData = unit.data;
                const unitDataLen = unit.data.byteLength;
                view.setUint32(offset, unitDataLen);
                offset += 4;
                mdat.set(unitData, offset);
                offset += unitDataLen;
                mp4SampleLength += 4 + unitDataLen;
            }
            // expected sample duration is the Decoding Timestamp diff of consecutive samples
            let ptsDelta;
            if (i < nbSamples - 1) {
                mp4SampleDuration = inputSamples[i + 1].dts - avcSample.dts;
                ptsDelta = inputSamples[i + 1].pts - avcSample.pts;
            } else {
                const config = this.config;
                const lastFrameDuration = i > 0 ? avcSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
                ptsDelta = i > 0 ? avcSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
                if (config.stretchShortVideoTrack && this.nextAudioPts !== null) {
                    // In some cases, a segment's audio track duration may exceed the video track duration.
                    // Since we've already remuxed audio, and we know how long the audio track is, we look to
                    // see if the delta to the next segment is longer than maxBufferHole.
                    // If so, playback would potentially get stuck, so we artificially inflate
                    // the duration of the last frame to minimize any potential gap between segments.
                    const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
                    const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
                    if (deltaToFrameEnd > gapTolerance) {
                        // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                        // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                        mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                        if (mp4SampleDuration < 0) mp4SampleDuration = lastFrameDuration;
                        else stretchedLastFrame = true;
                        $fada8102d2a280be$var$logger.log(`[mp4-remuxer]: It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
                    } else mp4SampleDuration = lastFrameDuration;
                } else mp4SampleDuration = lastFrameDuration;
            }
            const compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
            minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
            maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
            minPtsDelta = Math.min(minPtsDelta, ptsDelta);
            maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
            outputSamples.push(new $fada8102d2a280be$var$Mp4Sample(avcSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
        }
        if (outputSamples.length) {
            if ($fada8102d2a280be$var$chromeVersion) {
                if ($fada8102d2a280be$var$chromeVersion < 70) {
                    // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
                    // https://code.google.com/p/chromium/issues/detail?id=229412
                    const flags = outputSamples[0].flags;
                    flags.dependsOn = 2;
                    flags.isNonSync = 0;
                }
            } else if ($fada8102d2a280be$var$safariWebkitVersion) // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
            // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
            {
                if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
                    $fada8102d2a280be$var$logger.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
                    let dts = firstDTS;
                    for(let i = 0, len = outputSamples.length; i < len; i++){
                        const nextDts = dts + outputSamples[i].duration;
                        const pts = dts + outputSamples[i].cts;
                        if (i < len - 1) {
                            const nextPts = nextDts + outputSamples[i + 1].cts;
                            outputSamples[i].duration = nextPts - pts;
                        } else outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
                        outputSamples[i].cts = 0;
                        dts = nextDts;
                    }
                }
            }
        }
        // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
        mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
        this.nextAvcDts = nextAvcDts = lastDTS + mp4SampleDuration;
        this.videoSampleDuration = mp4SampleDuration;
        this.isVideoContiguous = true;
        const moof = $fada8102d2a280be$var$MP4.moof(track.sequenceNumber++, firstDTS, $fada8102d2a280be$var$_extends({}, track, {
            samples: outputSamples
        }));
        const type = "video";
        const data = {
            data1: moof,
            data2: mdat,
            startPTS: minPTS / timeScale,
            endPTS: (maxPTS + mp4SampleDuration) / timeScale,
            startDTS: firstDTS / timeScale,
            endDTS: nextAvcDts / timeScale,
            type: type,
            hasAudio: false,
            hasVideo: true,
            nb: outputSamples.length,
            dropped: track.dropped
        };
        track.samples = [];
        track.dropped = 0;
        return data;
    }
    remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
        const inputTimeScale = track.inputTimeScale;
        const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
        const scaleFactor = inputTimeScale / mp4timeScale;
        const mp4SampleDuration = track.segmentCodec === "aac" ? $fada8102d2a280be$var$AAC_SAMPLES_PER_FRAME : $fada8102d2a280be$var$MPEG_AUDIO_SAMPLE_PER_FRAME;
        const inputSampleDuration = mp4SampleDuration * scaleFactor;
        const initPTS = this._initPTS;
        const rawMPEG = track.segmentCodec === "mp3" && this.typeSupported.mpeg;
        const outputSamples = [];
        const alignedWithVideo = videoTimeOffset !== undefined;
        let inputSamples = track.samples;
        let offset = rawMPEG ? 0 : 8;
        let nextAudioPts = this.nextAudioPts || -1;
        // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);
        // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
        // for sake of clarity:
        // consecutive fragments are frags with
        //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
        //  - less than 20 audio frames distance
        // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
        // this helps ensuring audio continuity
        // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
        const timeOffsetMpegTS = timeOffset * inputTimeScale;
        const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
        this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioPts > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - nextAudioPts) < 9000 || Math.abs($fada8102d2a280be$var$normalizePts(inputSamples[0].pts - initTime, timeOffsetMpegTS) - nextAudioPts) < 20 * inputSampleDuration);
        // compute normalized PTS
        inputSamples.forEach(function(sample) {
            sample.pts = $fada8102d2a280be$var$normalizePts(sample.pts - initTime, timeOffsetMpegTS);
        });
        if (!contiguous || nextAudioPts < 0) {
            // filter out sample with negative PTS that are not playable anyway
            // if we don't remove these negative samples, they will shift all audio samples forward.
            // leading to audio overlap between current / next fragment
            inputSamples = inputSamples.filter((sample)=>sample.pts >= 0);
            // in case all samples have negative PTS, and have been filtered out, return now
            if (!inputSamples.length) return;
            if (videoTimeOffset === 0) // Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
            nextAudioPts = 0;
            else if (accurateTimeOffset && !alignedWithVideo) // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
            nextAudioPts = Math.max(0, timeOffsetMpegTS);
            else // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
            nextAudioPts = inputSamples[0].pts;
        }
        // If the audio track is missing samples, the frames seem to get "left-shifted" within the
        // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
        // In an effort to prevent this from happening, we inject frames here where there are gaps.
        // When possible, we inject a silent frame; when that's not possible, we duplicate the last
        // frame.
        if (track.segmentCodec === "aac") {
            const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
            for(let i = 0, nextPts = nextAudioPts; i < inputSamples.length; i++){
                // First, let's see how far off this frame is from where we expect it to be
                const sample = inputSamples[i];
                const pts = sample.pts;
                const delta = pts - nextPts;
                const duration = Math.abs(1000 * delta / inputTimeScale);
                // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
                if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
                    if (i === 0) {
                        $fada8102d2a280be$var$logger.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1000 * delta / inputTimeScale)} ms.`);
                        this.nextAudioPts = nextAudioPts = nextPts = pts;
                    }
                } else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < $fada8102d2a280be$var$MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
                    let missing = Math.round(delta / inputSampleDuration);
                    // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
                    // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
                    nextPts = pts - missing * inputSampleDuration;
                    if (nextPts < 0) {
                        missing--;
                        nextPts += inputSampleDuration;
                    }
                    if (i === 0) this.nextAudioPts = nextAudioPts = nextPts;
                    $fada8102d2a280be$var$logger.warn(`[mp4-remuxer]: Injecting ${missing} audio frame @ ${(nextPts / inputTimeScale).toFixed(3)}s due to ${Math.round(1000 * delta / inputTimeScale)} ms gap.`);
                    for(let j = 0; j < missing; j++){
                        const newStamp = Math.max(nextPts, 0);
                        let fillFrame = $fada8102d2a280be$var$AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                        if (!fillFrame) {
                            $fada8102d2a280be$var$logger.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.");
                            fillFrame = sample.unit.subarray();
                        }
                        inputSamples.splice(i, 0, {
                            unit: fillFrame,
                            pts: newStamp
                        });
                        nextPts += inputSampleDuration;
                        i++;
                    }
                }
                sample.pts = nextPts;
                nextPts += inputSampleDuration;
            }
        }
        let firstPTS = null;
        let lastPTS = null;
        let mdat;
        let mdatSize = 0;
        let sampleLength = inputSamples.length;
        while(sampleLength--)mdatSize += inputSamples[sampleLength].unit.byteLength;
        for(let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++){
            const audioSample = inputSamples[j];
            const unit = audioSample.unit;
            let pts = audioSample.pts;
            if (lastPTS !== null) {
                // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
                // the previous sample
                const prevSample = outputSamples[j - 1];
                prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
            } else {
                if (contiguous && track.segmentCodec === "aac") // set PTS/DTS to expected PTS/DTS
                pts = nextAudioPts;
                // remember first PTS of our audioSamples
                firstPTS = pts;
                if (mdatSize > 0) {
                    /* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */ mdatSize += offset;
                    try {
                        mdat = new Uint8Array(mdatSize);
                    } catch (err) {
                        this.observer.emit($fada8102d2a280be$var$Events.ERROR, $fada8102d2a280be$var$Events.ERROR, {
                            type: $fada8102d2a280be$var$ErrorTypes.MUX_ERROR,
                            details: $fada8102d2a280be$var$ErrorDetails.REMUX_ALLOC_ERROR,
                            fatal: false,
                            error: err,
                            bytes: mdatSize,
                            reason: `fail allocating audio mdat ${mdatSize}`
                        });
                        return;
                    }
                    if (!rawMPEG) {
                        const view = new DataView(mdat.buffer);
                        view.setUint32(0, mdatSize);
                        mdat.set($fada8102d2a280be$var$MP4.types.mdat, 4);
                    }
                } else // no audio samples
                return;
            }
            mdat.set(unit, offset);
            const unitLen = unit.byteLength;
            offset += unitLen;
            // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
            // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
            // becomes the PTS diff with the previous sample
            outputSamples.push(new $fada8102d2a280be$var$Mp4Sample(true, mp4SampleDuration, unitLen, 0));
            lastPTS = pts;
        }
        // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
        const nbSamples = outputSamples.length;
        if (!nbSamples) return;
        // The next audio sample PTS should be equal to last sample PTS + duration
        const lastSample = outputSamples[outputSamples.length - 1];
        this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSample.duration;
        // Set the track samples from inputSamples to outputSamples before remuxing
        const moof = rawMPEG ? new Uint8Array(0) : $fada8102d2a280be$var$MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, $fada8102d2a280be$var$_extends({}, track, {
            samples: outputSamples
        }));
        // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
        track.samples = [];
        const start = firstPTS / inputTimeScale;
        const end = nextAudioPts / inputTimeScale;
        const type = "audio";
        const audioData = {
            data1: moof,
            data2: mdat,
            startPTS: start,
            endPTS: end,
            startDTS: start,
            endDTS: end,
            type: type,
            hasAudio: true,
            hasVideo: false,
            nb: nbSamples
        };
        this.isAudioContiguous = true;
        return audioData;
    }
    remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
        const inputTimeScale = track.inputTimeScale;
        const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
        const scaleFactor = inputTimeScale / mp4timeScale;
        const nextAudioPts = this.nextAudioPts;
        // sync with video's timestamp
        const initDTS = this._initDTS;
        const init90kHz = initDTS.baseTime * 90000 / initDTS.timescale;
        const startDTS = (nextAudioPts !== null ? nextAudioPts : videoData.startDTS * inputTimeScale) + init90kHz;
        const endDTS = videoData.endDTS * inputTimeScale + init90kHz;
        // one sample's duration value
        const frameDuration = scaleFactor * $fada8102d2a280be$var$AAC_SAMPLES_PER_FRAME;
        // samples count of this segment's duration
        const nbSamples = Math.ceil((endDTS - startDTS) / frameDuration);
        // silent frame
        const silentFrame = $fada8102d2a280be$var$AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
        $fada8102d2a280be$var$logger.warn("[mp4-remuxer]: remux empty Audio");
        // Can't remux if we can't generate a silent frame...
        if (!silentFrame) {
            $fada8102d2a280be$var$logger.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
            return;
        }
        const samples = [];
        for(let i = 0; i < nbSamples; i++){
            const stamp = startDTS + i * frameDuration;
            samples.push({
                unit: silentFrame,
                pts: stamp,
                dts: stamp
            });
        }
        track.samples = samples;
        return this.remuxAudio(track, timeOffset, contiguous, false);
    }
}
function $fada8102d2a280be$var$normalizePts(value, reference) {
    let offset;
    if (reference === null) return value;
    if (reference < value) // - 2^33
    offset = -8589934592;
    else // + 2^33
    offset = 8589934592;
    /* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */ while(Math.abs(value - reference) > 4294967296)value += offset;
    return value;
}
function $fada8102d2a280be$var$findKeyframeIndex(samples) {
    for(let i = 0; i < samples.length; i++){
        if (samples[i].key) return i;
    }
    return -1;
}
function $fada8102d2a280be$var$flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
    const length = track.samples.length;
    if (!length) return;
    const inputTimeScale = track.inputTimeScale;
    for(let index = 0; index < length; index++){
        const sample = track.samples[index];
        // setting id3 pts, dts to relative time
        // using this._initPTS and this._initDTS to calculate relative time
        sample.pts = $fada8102d2a280be$var$normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
        sample.dts = $fada8102d2a280be$var$normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    }
    const samples = track.samples;
    track.samples = [];
    return {
        samples: samples
    };
}
function $fada8102d2a280be$var$flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
    const length = track.samples.length;
    if (!length) return;
    const inputTimeScale = track.inputTimeScale;
    for(let index = 0; index < length; index++){
        const sample = track.samples[index];
        // setting text pts, dts to relative time
        // using this._initPTS and this._initDTS to calculate relative time
        sample.pts = $fada8102d2a280be$var$normalizePts(sample.pts - initPTS.baseTime * 90000 / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    }
    track.samples.sort((a, b)=>a.pts - b.pts);
    const samples = track.samples;
    track.samples = [];
    return {
        samples: samples
    };
}
class $fada8102d2a280be$var$Mp4Sample {
    constructor(isKeyframe, duration, size, cts){
        this.size = void 0;
        this.duration = void 0;
        this.cts = void 0;
        this.flags = void 0;
        this.duration = duration;
        this.size = size;
        this.cts = cts;
        this.flags = new $fada8102d2a280be$var$Mp4SampleFlags(isKeyframe);
    }
}
class $fada8102d2a280be$var$Mp4SampleFlags {
    constructor(isKeyframe){
        this.isLeading = 0;
        this.isDependedOn = 0;
        this.hasRedundancy = 0;
        this.degradPrio = 0;
        this.dependsOn = 1;
        this.isNonSync = 1;
        this.dependsOn = isKeyframe ? 2 : 1;
        this.isNonSync = isKeyframe ? 0 : 1;
    }
}
class $fada8102d2a280be$var$PassThroughRemuxer {
    constructor(){
        this.emitInitSegment = false;
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this.initData = void 0;
        this.initPTS = null;
        this.initTracks = void 0;
        this.lastEndTime = null;
    }
    destroy() {}
    resetTimeStamp(defaultInitPTS) {
        this.initPTS = defaultInitPTS;
        this.lastEndTime = null;
    }
    resetNextTimestamp() {
        this.lastEndTime = null;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this.generateInitSegment($fada8102d2a280be$var$patchEncyptionData(initSegment, decryptdata));
        this.emitInitSegment = true;
    }
    generateInitSegment(initSegment) {
        let { audioCodec: audioCodec, videoCodec: videoCodec } = this;
        if (!(initSegment != null && initSegment.byteLength)) {
            this.initTracks = undefined;
            this.initData = undefined;
            return;
        }
        const initData = this.initData = $fada8102d2a280be$var$parseInitSegment(initSegment);
        // Get codec from initSegment or fallback to default
        if (!audioCodec) audioCodec = $fada8102d2a280be$var$getParsedTrackCodec(initData.audio, $fada8102d2a280be$var$ElementaryStreamTypes.AUDIO);
        if (!videoCodec) videoCodec = $fada8102d2a280be$var$getParsedTrackCodec(initData.video, $fada8102d2a280be$var$ElementaryStreamTypes.VIDEO);
        const tracks = {};
        if (initData.audio && initData.video) tracks.audiovideo = {
            container: "video/mp4",
            codec: audioCodec + "," + videoCodec,
            initSegment: initSegment,
            id: "main"
        };
        else if (initData.audio) tracks.audio = {
            container: "audio/mp4",
            codec: audioCodec,
            initSegment: initSegment,
            id: "audio"
        };
        else if (initData.video) tracks.video = {
            container: "video/mp4",
            codec: videoCodec,
            initSegment: initSegment,
            id: "main"
        };
        else $fada8102d2a280be$var$logger.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.");
        this.initTracks = tracks;
    }
    remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
        var _initData, _initData2;
        let { initPTS: initPTS, lastEndTime: lastEndTime } = this;
        const result = {
            audio: undefined,
            video: undefined,
            text: textTrack,
            id3: id3Track,
            initSegment: undefined
        };
        // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
        // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
        // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
        if (!$fada8102d2a280be$var$isFiniteNumber(lastEndTime)) lastEndTime = this.lastEndTime = timeOffset || 0;
        // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
        // audio or video (or both); adding it to video was an arbitrary choice.
        const data = videoTrack.samples;
        if (!(data != null && data.length)) return result;
        const initSegment = {
            initPTS: undefined,
            timescale: 1
        };
        let initData = this.initData;
        if (!((_initData = initData) != null && _initData.length)) {
            this.generateInitSegment(data);
            initData = this.initData;
        }
        if (!((_initData2 = initData) != null && _initData2.length)) {
            // We can't remux if the initSegment could not be generated
            $fada8102d2a280be$var$logger.warn("[passthrough-remuxer.ts]: Failed to generate initSegment.");
            return result;
        }
        if (this.emitInitSegment) {
            initSegment.tracks = this.initTracks;
            this.emitInitSegment = false;
        }
        const duration = $fada8102d2a280be$var$getDuration(data, initData);
        const startDTS = $fada8102d2a280be$var$getStartDTS(initData, data);
        const decodeTime = startDTS === null ? timeOffset : startDTS;
        if ($fada8102d2a280be$var$isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || initSegment.timescale !== initPTS.timescale && accurateTimeOffset) {
            initSegment.initPTS = decodeTime - timeOffset;
            if (initPTS && initPTS.timescale === 1) $fada8102d2a280be$var$logger.warn(`Adjusting initPTS by ${initSegment.initPTS - initPTS.baseTime}`);
            this.initPTS = initPTS = {
                baseTime: initSegment.initPTS,
                timescale: 1
            };
        }
        const startTime = audioTrack ? decodeTime - initPTS.baseTime / initPTS.timescale : lastEndTime;
        const endTime = startTime + duration;
        $fada8102d2a280be$var$offsetStartDTS(initData, data, initPTS.baseTime / initPTS.timescale);
        if (duration > 0) this.lastEndTime = endTime;
        else {
            $fada8102d2a280be$var$logger.warn("Duration parsed from mp4 should be greater than zero");
            this.resetNextTimestamp();
        }
        const hasAudio = !!initData.audio;
        const hasVideo = !!initData.video;
        let type = "";
        if (hasAudio) type += "audio";
        if (hasVideo) type += "video";
        const track = {
            data1: data,
            startPTS: startTime,
            startDTS: startTime,
            endPTS: endTime,
            endDTS: endTime,
            type: type,
            hasAudio: hasAudio,
            hasVideo: hasVideo,
            nb: 1,
            dropped: 0
        };
        result.audio = track.type === "audio" ? track : undefined;
        result.video = track.type !== "audio" ? track : undefined;
        result.initSegment = initSegment;
        result.id3 = $fada8102d2a280be$var$flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
        if (textTrack.samples.length) result.text = $fada8102d2a280be$var$flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
        return result;
    }
}
function $fada8102d2a280be$var$isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
    if (initPTS === null) return true;
    // InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
    const minDuration = Math.max(duration, 1);
    const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
    return Math.abs(startTime - timeOffset) > minDuration;
}
function $fada8102d2a280be$var$getParsedTrackCodec(track, type) {
    const parsedCodec = track == null ? void 0 : track.codec;
    if (parsedCodec && parsedCodec.length > 4) return parsedCodec;
    // Since mp4-tools cannot parse full codec string (see 'TODO: Parse codec details'... in mp4-tools)
    // Provide defaults based on codec type
    // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
    if (parsedCodec === "hvc1" || parsedCodec === "hev1") return "hvc1.1.6.L120.90";
    if (parsedCodec === "av01") return "av01.0.04M.08";
    if (parsedCodec === "avc1" || type === $fada8102d2a280be$var$ElementaryStreamTypes.VIDEO) return "avc1.42e01e";
    return "mp4a.40.5";
}
let $fada8102d2a280be$var$now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
    $fada8102d2a280be$var$now = self.performance.now.bind(self.performance);
} catch (err) {
    $fada8102d2a280be$var$logger.debug("Unable to use Performance API on this environment");
    $fada8102d2a280be$var$now = typeof self !== "undefined" && self.Date.now;
}
const $fada8102d2a280be$var$muxConfig = [
    {
        demux: $fada8102d2a280be$var$MP4Demuxer,
        remux: $fada8102d2a280be$var$PassThroughRemuxer
    },
    {
        demux: $fada8102d2a280be$var$TSDemuxer,
        remux: $fada8102d2a280be$var$MP4Remuxer
    },
    {
        demux: $fada8102d2a280be$var$AACDemuxer,
        remux: $fada8102d2a280be$var$MP4Remuxer
    },
    {
        demux: $fada8102d2a280be$var$MP3Demuxer,
        remux: $fada8102d2a280be$var$MP4Remuxer
    }
];
class $fada8102d2a280be$var$Transmuxer {
    constructor(observer, typeSupported, config, vendor, id){
        this.async = false;
        this.observer = void 0;
        this.typeSupported = void 0;
        this.config = void 0;
        this.vendor = void 0;
        this.id = void 0;
        this.demuxer = void 0;
        this.remuxer = void 0;
        this.decrypter = void 0;
        this.probe = void 0;
        this.decryptionPromise = null;
        this.transmuxConfig = void 0;
        this.currentTransmuxState = void 0;
        this.observer = observer;
        this.typeSupported = typeSupported;
        this.config = config;
        this.vendor = vendor;
        this.id = id;
    }
    configure(transmuxConfig) {
        this.transmuxConfig = transmuxConfig;
        if (this.decrypter) this.decrypter.reset();
    }
    push(data, decryptdata, chunkMeta, state) {
        const stats = chunkMeta.transmuxing;
        stats.executeStart = $fada8102d2a280be$var$now();
        let uintData = new Uint8Array(data);
        const { currentTransmuxState: currentTransmuxState, transmuxConfig: transmuxConfig } = this;
        if (state) this.currentTransmuxState = state;
        const { contiguous: contiguous, discontinuity: discontinuity, trackSwitch: trackSwitch, accurateTimeOffset: accurateTimeOffset, timeOffset: timeOffset, initSegmentChange: initSegmentChange } = state || currentTransmuxState;
        const { audioCodec: audioCodec, videoCodec: videoCodec, defaultInitPts: defaultInitPts, duration: duration, initSegmentData: initSegmentData } = transmuxConfig;
        const keyData = $fada8102d2a280be$var$getEncryptionType(uintData, decryptdata);
        if (keyData && keyData.method === "AES-128") {
            const decrypter = this.getDecrypter();
            // Software decryption is synchronous; webCrypto is not
            if (decrypter.isSync()) {
                // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
                // data is handled in the flush() call
                let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer);
                // For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
                const loadingParts = chunkMeta.part > -1;
                if (loadingParts) decryptedData = decrypter.flush();
                if (!decryptedData) {
                    stats.executeEnd = $fada8102d2a280be$var$now();
                    return $fada8102d2a280be$var$emptyResult(chunkMeta);
                }
                uintData = new Uint8Array(decryptedData);
            } else {
                this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer).then((decryptedData)=>{
                    // Calling push here is important; if flush() is called while this is still resolving, this ensures that
                    // the decrypted data has been transmuxed
                    const result = this.push(decryptedData, null, chunkMeta);
                    this.decryptionPromise = null;
                    return result;
                });
                return this.decryptionPromise;
            }
        }
        const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
        if (resetMuxers) {
            const error = this.configureTransmuxer(uintData);
            if (error) {
                $fada8102d2a280be$var$logger.warn(`[transmuxer] ${error.message}`);
                this.observer.emit($fada8102d2a280be$var$Events.ERROR, $fada8102d2a280be$var$Events.ERROR, {
                    type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                    details: $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: false,
                    error: error,
                    reason: error.message
                });
                stats.executeEnd = $fada8102d2a280be$var$now();
                return $fada8102d2a280be$var$emptyResult(chunkMeta);
            }
        }
        if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
        if (discontinuity || initSegmentChange || resetMuxers) this.resetInitialTimestamp(defaultInitPts);
        if (!contiguous) this.resetContiguity();
        const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
        const currentState = this.currentTransmuxState;
        currentState.contiguous = true;
        currentState.discontinuity = false;
        currentState.trackSwitch = false;
        stats.executeEnd = $fada8102d2a280be$var$now();
        return result;
    }
    // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
    flush(chunkMeta) {
        const stats = chunkMeta.transmuxing;
        stats.executeStart = $fada8102d2a280be$var$now();
        const { decrypter: decrypter, currentTransmuxState: currentTransmuxState, decryptionPromise: decryptionPromise } = this;
        if (decryptionPromise) // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
        // only flushing is required for async decryption
        return decryptionPromise.then(()=>{
            return this.flush(chunkMeta);
        });
        const transmuxResults = [];
        const { timeOffset: timeOffset } = currentTransmuxState;
        if (decrypter) {
            // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
            // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
            // or for progressive downloads with small segments)
            const decryptedData = decrypter.flush();
            if (decryptedData) // Push always returns a TransmuxerResult if decryptdata is null
            transmuxResults.push(this.push(decryptedData, null, chunkMeta));
        }
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) {
            // If probing failed, then Hls.js has been given content its not able to handle
            stats.executeEnd = $fada8102d2a280be$var$now();
            return [
                $fada8102d2a280be$var$emptyResult(chunkMeta)
            ];
        }
        const demuxResultOrPromise = demuxer.flush(timeOffset);
        if ($fada8102d2a280be$var$isPromise(demuxResultOrPromise)) // Decrypt final SAMPLE-AES samples
        return demuxResultOrPromise.then((demuxResult)=>{
            this.flushRemux(transmuxResults, demuxResult, chunkMeta);
            return transmuxResults;
        });
        this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
        return transmuxResults;
    }
    flushRemux(transmuxResults, demuxResult, chunkMeta) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = demuxResult;
        const { accurateTimeOffset: accurateTimeOffset, timeOffset: timeOffset } = this.currentTransmuxState;
        $fada8102d2a280be$var$logger.log(`[transmuxer.ts]: Flushed fragment ${chunkMeta.sn}${chunkMeta.part > -1 ? " p: " + chunkMeta.part : ""} of level ${chunkMeta.level}`);
        const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
        transmuxResults.push({
            remuxResult: remuxResult,
            chunkMeta: chunkMeta
        });
        chunkMeta.transmuxing.executeEnd = $fada8102d2a280be$var$now();
    }
    resetInitialTimestamp(defaultInitPts) {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetTimeStamp(defaultInitPts);
        remuxer.resetTimeStamp(defaultInitPts);
    }
    resetContiguity() {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetContiguity();
        remuxer.resetNextTimestamp();
    }
    resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
        remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
    }
    destroy() {
        if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = undefined;
        }
        if (this.remuxer) {
            this.remuxer.destroy();
            this.remuxer = undefined;
        }
    }
    transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
        let result;
        if (keyData && keyData.method === "SAMPLE-AES") result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
        else result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
        return result;
    }
    transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
        const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id);
        return {
            remuxResult: remuxResult,
            chunkMeta: chunkMeta
        };
    }
    transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
        return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then((demuxResult)=>{
            const remuxResult = this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id);
            return {
                remuxResult: remuxResult,
                chunkMeta: chunkMeta
            };
        });
    }
    configureTransmuxer(data) {
        const { config: config, observer: observer, typeSupported: typeSupported, vendor: vendor } = this;
        // probe for content type
        let mux;
        for(let i = 0, len = $fada8102d2a280be$var$muxConfig.length; i < len; i++)if ($fada8102d2a280be$var$muxConfig[i].demux.probe(data)) {
            mux = $fada8102d2a280be$var$muxConfig[i];
            break;
        }
        if (!mux) return new Error("Failed to find demuxer by probing fragment data");
        // so let's check that current remuxer and demuxer are still valid
        const demuxer = this.demuxer;
        const remuxer = this.remuxer;
        const Remuxer = mux.remux;
        const Demuxer = mux.demux;
        if (!remuxer || !(remuxer instanceof Remuxer)) this.remuxer = new Remuxer(observer, config, typeSupported, vendor);
        if (!demuxer || !(demuxer instanceof Demuxer)) {
            this.demuxer = new Demuxer(observer, config, typeSupported);
            this.probe = Demuxer.probe;
        }
    }
    needsProbing(discontinuity, trackSwitch) {
        // in case of continuity change, or track switch
        // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
        return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
    }
    getDecrypter() {
        let decrypter = this.decrypter;
        if (!decrypter) decrypter = this.decrypter = new $fada8102d2a280be$var$Decrypter(this.config);
        return decrypter;
    }
}
function $fada8102d2a280be$var$getEncryptionType(data, decryptData) {
    let encryptionType = null;
    if (data.byteLength > 0 && decryptData != null && decryptData.key != null && decryptData.iv !== null && decryptData.method != null) encryptionType = decryptData;
    return encryptionType;
}
const $fada8102d2a280be$var$emptyResult = (chunkMeta)=>({
        remuxResult: {},
        chunkMeta: chunkMeta
    });
function $fada8102d2a280be$var$isPromise(p) {
    return "then" in p && p.then instanceof Function;
}
class $fada8102d2a280be$var$TransmuxConfig {
    constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts){
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this.initSegmentData = void 0;
        this.duration = void 0;
        this.defaultInitPts = void 0;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this.initSegmentData = initSegmentData;
        this.duration = duration;
        this.defaultInitPts = defaultInitPts || null;
    }
}
class $fada8102d2a280be$var$TransmuxState {
    constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange){
        this.discontinuity = void 0;
        this.contiguous = void 0;
        this.accurateTimeOffset = void 0;
        this.trackSwitch = void 0;
        this.timeOffset = void 0;
        this.initSegmentChange = void 0;
        this.discontinuity = discontinuity;
        this.contiguous = contiguous;
        this.accurateTimeOffset = accurateTimeOffset;
        this.trackSwitch = trackSwitch;
        this.timeOffset = timeOffset;
        this.initSegmentChange = initSegmentChange;
    }
}
var $fada8102d2a280be$var$eventemitter3 = {
    exports: {}
};
(function(module) {
    var has = Object.prototype.hasOwnProperty, prefix = "~";
    /**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */ function Events() {}
    //
    // We try to not inherit from `Object.prototype`. In some engines creating an
    // instance in this way is faster than calling `Object.create(null)` directly.
    // If `Object.create(null)` is not supported we prefix the event names with a
    // character to make sure that the built-in object properties are not
    // overridden or used as an attack vector.
    //
    if (Object.create) {
        Events.prototype = Object.create(null);
        //
        // This hack is needed because the `__proto__` property is still inherited in
        // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
        //
        if (!new Events().__proto__) prefix = false;
    }
    /**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */ function EE(fn, context, once) {
        this.fn = fn;
        this.context = context;
        this.once = once || false;
    }
    /**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */ function addListener(emitter, event, fn, context, once) {
        if (typeof fn !== "function") throw new TypeError("The listener must be a function");
        var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
        if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
        else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
        else emitter._events[evt] = [
            emitter._events[evt],
            listener
        ];
        return emitter;
    }
    /**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */ function clearEvent(emitter, evt) {
        if (--emitter._eventsCount === 0) emitter._events = new Events();
        else delete emitter._events[evt];
    }
    /**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */ function EventEmitter() {
        this._events = new Events();
        this._eventsCount = 0;
    }
    /**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */ EventEmitter.prototype.eventNames = function eventNames() {
        var names = [], events, name;
        if (this._eventsCount === 0) return names;
        for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
        if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
        return names;
    };
    /**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */ EventEmitter.prototype.listeners = function listeners(event) {
        var evt = prefix ? prefix + event : event, handlers = this._events[evt];
        if (!handlers) return [];
        if (handlers.fn) return [
            handlers.fn
        ];
        for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
        return ee;
    };
    /**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
        var evt = prefix ? prefix + event : event, listeners = this._events[evt];
        if (!listeners) return 0;
        if (listeners.fn) return 1;
        return listeners.length;
    };
    /**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return false;
        var listeners = this._events[evt], len = arguments.length, args, i;
        if (listeners.fn) {
            if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
            switch(len){
                case 1:
                    return listeners.fn.call(listeners.context), true;
                case 2:
                    return listeners.fn.call(listeners.context, a1), true;
                case 3:
                    return listeners.fn.call(listeners.context, a1, a2), true;
                case 4:
                    return listeners.fn.call(listeners.context, a1, a2, a3), true;
                case 5:
                    return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                case 6:
                    return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
            }
            for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
            listeners.fn.apply(listeners.context, args);
        } else {
            var length = listeners.length, j;
            for(i = 0; i < length; i++){
                if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                switch(len){
                    case 1:
                        listeners[i].fn.call(listeners[i].context);
                        break;
                    case 2:
                        listeners[i].fn.call(listeners[i].context, a1);
                        break;
                    case 3:
                        listeners[i].fn.call(listeners[i].context, a1, a2);
                        break;
                    case 4:
                        listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                        break;
                    default:
                        if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                        listeners[i].fn.apply(listeners[i].context, args);
                }
            }
        }
        return true;
    };
    /**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */ EventEmitter.prototype.on = function on(event, fn, context) {
        return addListener(this, event, fn, context, false);
    };
    /**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */ EventEmitter.prototype.once = function once(event, fn, context) {
        return addListener(this, event, fn, context, true);
    };
    /**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return this;
        if (!fn) {
            clearEvent(this, evt);
            return this;
        }
        var listeners = this._events[evt];
        if (listeners.fn) {
            if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
        } else {
            for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
            //
            // Reset the array, or remove it completely if we have no more listeners.
            //
            if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
            else clearEvent(this, evt);
        }
        return this;
    };
    /**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;
        if (event) {
            evt = prefix ? prefix + event : event;
            if (this._events[evt]) clearEvent(this, evt);
        } else {
            this._events = new Events();
            this._eventsCount = 0;
        }
        return this;
    };
    //
    // Alias methods names because people roll like that.
    //
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    //
    // Expose the prefix.
    //
    EventEmitter.prefixed = prefix;
    //
    // Allow `EventEmitter` to be imported as module namespace.
    //
    EventEmitter.EventEmitter = EventEmitter;
    module.exports = EventEmitter;
})($fada8102d2a280be$var$eventemitter3);
var $fada8102d2a280be$var$eventemitter3Exports = $fada8102d2a280be$var$eventemitter3.exports;
var $fada8102d2a280be$var$EventEmitter = /*@__PURE__*/ $fada8102d2a280be$var$getDefaultExportFromCjs($fada8102d2a280be$var$eventemitter3Exports);
const $fada8102d2a280be$var$MediaSource$1 = $fada8102d2a280be$var$getMediaSource() || {
    isTypeSupported: ()=>false
};
class $fada8102d2a280be$var$TransmuxerInterface {
    constructor(hls, id, onTransmuxComplete, onFlush){
        this.error = null;
        this.hls = void 0;
        this.id = void 0;
        this.observer = void 0;
        this.frag = null;
        this.part = null;
        this.useWorker = void 0;
        this.workerContext = null;
        this.onwmsg = void 0;
        this.transmuxer = null;
        this.onTransmuxComplete = void 0;
        this.onFlush = void 0;
        const config = hls.config;
        this.hls = hls;
        this.id = id;
        this.useWorker = !!config.enableWorker;
        this.onTransmuxComplete = onTransmuxComplete;
        this.onFlush = onFlush;
        const forwardMessage = (ev, data)=>{
            data = data || {};
            data.frag = this.frag;
            data.id = this.id;
            if (ev === $fada8102d2a280be$var$Events.ERROR) this.error = data.error;
            this.hls.trigger(ev, data);
        };
        // forward events to main thread
        this.observer = new $fada8102d2a280be$var$EventEmitter();
        this.observer.on($fada8102d2a280be$var$Events.FRAG_DECRYPTED, forwardMessage);
        this.observer.on($fada8102d2a280be$var$Events.ERROR, forwardMessage);
        const typeSupported = {
            mp4: $fada8102d2a280be$var$MediaSource$1.isTypeSupported("video/mp4"),
            mpeg: $fada8102d2a280be$var$MediaSource$1.isTypeSupported("audio/mpeg"),
            mp3: $fada8102d2a280be$var$MediaSource$1.isTypeSupported('audio/mp4; codecs="mp3"')
        };
        // navigator.vendor is not always available in Web Worker
        // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
        const vendor = navigator.vendor;
        if (this.useWorker && typeof Worker !== "undefined") {
            const canCreateWorker = config.workerPath || $fada8102d2a280be$var$hasUMDWorker();
            if (canCreateWorker) {
                try {
                    if (config.workerPath) {
                        $fada8102d2a280be$var$logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
                        this.workerContext = $fada8102d2a280be$var$loadWorker(config.workerPath);
                    } else {
                        $fada8102d2a280be$var$logger.log(`injecting Web Worker for "${id}"`);
                        this.workerContext = $fada8102d2a280be$var$injectWorker();
                    }
                    this.onwmsg = (ev)=>this.onWorkerMessage(ev);
                    const { worker: worker } = this.workerContext;
                    worker.addEventListener("message", this.onwmsg);
                    worker.onerror = (event)=>{
                        const error = new Error(`${event.message}  (${event.filename}:${event.lineno})`);
                        config.enableWorker = false;
                        $fada8102d2a280be$var$logger.warn(`Error in "${id}" Web Worker, fallback to inline`);
                        this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                            type: $fada8102d2a280be$var$ErrorTypes.OTHER_ERROR,
                            details: $fada8102d2a280be$var$ErrorDetails.INTERNAL_EXCEPTION,
                            fatal: false,
                            event: "demuxerWorker",
                            error: error
                        });
                    };
                    worker.postMessage({
                        cmd: "init",
                        typeSupported: typeSupported,
                        vendor: vendor,
                        id: id,
                        config: JSON.stringify(config)
                    });
                } catch (err) {
                    $fada8102d2a280be$var$logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
                    this.resetWorker();
                    this.error = null;
                    this.transmuxer = new $fada8102d2a280be$var$Transmuxer(this.observer, typeSupported, config, vendor, id);
                }
                return;
            }
        }
        this.transmuxer = new $fada8102d2a280be$var$Transmuxer(this.observer, typeSupported, config, vendor, id);
    }
    resetWorker() {
        if (this.workerContext) {
            const { worker: worker, objectURL: objectURL } = this.workerContext;
            if (objectURL) // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
            self.URL.revokeObjectURL(objectURL);
            worker.removeEventListener("message", this.onwmsg);
            worker.onerror = null;
            worker.terminate();
            this.workerContext = null;
        }
    }
    destroy() {
        if (this.workerContext) {
            this.resetWorker();
            this.onwmsg = undefined;
        } else {
            const transmuxer = this.transmuxer;
            if (transmuxer) {
                transmuxer.destroy();
                this.transmuxer = null;
            }
        }
        const observer = this.observer;
        if (observer) observer.removeAllListeners();
        this.frag = null;
        // @ts-ignore
        this.observer = null;
        // @ts-ignore
        this.hls = null;
    }
    push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
        var _frag$initSegment, _lastFrag$initSegment;
        chunkMeta.transmuxing.start = self.performance.now();
        const { transmuxer: transmuxer } = this;
        const timeOffset = part ? part.start : frag.start;
        // TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
        const decryptdata = frag.decryptdata;
        const lastFrag = this.frag;
        const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
        const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
        const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
        const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
        const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
        const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
        const now = self.performance.now();
        if (trackSwitch || snDiff || frag.stats.parsing.start === 0) frag.stats.parsing.start = now;
        if (part && (partDiff || !contiguous)) part.stats.parsing.start = now;
        const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
        const state = new $fada8102d2a280be$var$TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
        if (!contiguous || discontinuity || initSegmentChange) {
            $fada8102d2a280be$var$logger.log(`[transmuxer-interface, ${frag.type}]: Starting new transmux session for sn: ${chunkMeta.sn} p: ${chunkMeta.part} level: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
            const config = new $fada8102d2a280be$var$TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
            this.configureTransmuxer(config);
        }
        this.frag = frag;
        this.part = part;
        // Frags with sn of 'initSegment' are not transmuxed
        if (this.workerContext) // post fragment payload as transferable objects for ArrayBuffer (no copy)
        this.workerContext.worker.postMessage({
            cmd: "demux",
            data: data,
            decryptdata: decryptdata,
            chunkMeta: chunkMeta,
            state: state
        }, data instanceof ArrayBuffer ? [
            data
        ] : []);
        else if (transmuxer) {
            const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
            if ($fada8102d2a280be$var$isPromise(transmuxResult)) {
                transmuxer.async = true;
                transmuxResult.then((data)=>{
                    this.handleTransmuxComplete(data);
                }).catch((error)=>{
                    this.transmuxerError(error, chunkMeta, "transmuxer-interface push error");
                });
            } else {
                transmuxer.async = false;
                this.handleTransmuxComplete(transmuxResult);
            }
        }
    }
    flush(chunkMeta) {
        chunkMeta.transmuxing.start = self.performance.now();
        const { transmuxer: transmuxer } = this;
        if (this.workerContext) this.workerContext.worker.postMessage({
            cmd: "flush",
            chunkMeta: chunkMeta
        });
        else if (transmuxer) {
            let transmuxResult = transmuxer.flush(chunkMeta);
            const asyncFlush = $fada8102d2a280be$var$isPromise(transmuxResult);
            if (asyncFlush || transmuxer.async) {
                if (!$fada8102d2a280be$var$isPromise(transmuxResult)) transmuxResult = Promise.resolve(transmuxResult);
                transmuxResult.then((data)=>{
                    this.handleFlushResult(data, chunkMeta);
                }).catch((error)=>{
                    this.transmuxerError(error, chunkMeta, "transmuxer-interface flush error");
                });
            } else this.handleFlushResult(transmuxResult, chunkMeta);
        }
    }
    transmuxerError(error, chunkMeta, reason) {
        if (!this.hls) return;
        this.error = error;
        this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
            type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
            details: $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR,
            chunkMeta: chunkMeta,
            fatal: false,
            error: error,
            err: error,
            reason: reason
        });
    }
    handleFlushResult(results, chunkMeta) {
        results.forEach((result)=>{
            this.handleTransmuxComplete(result);
        });
        this.onFlush(chunkMeta);
    }
    onWorkerMessage(ev) {
        const data = ev.data;
        const hls = this.hls;
        switch(data.event){
            case "init":
                {
                    var _this$workerContext;
                    const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
                    if (objectURL) // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
                    self.URL.revokeObjectURL(objectURL);
                    break;
                }
            case "transmuxComplete":
                this.handleTransmuxComplete(data.data);
                break;
            case "flush":
                this.onFlush(data.data);
                break;
            // pass logs from the worker thread to the main logger
            case "workerLog":
                if ($fada8102d2a280be$var$logger[data.data.logType]) $fada8102d2a280be$var$logger[data.data.logType](data.data.message);
                break;
            default:
                data.data = data.data || {};
                data.data.frag = this.frag;
                data.data.id = this.id;
                hls.trigger(data.event, data.data);
                break;
        }
    }
    configureTransmuxer(config) {
        const { transmuxer: transmuxer } = this;
        if (this.workerContext) this.workerContext.worker.postMessage({
            cmd: "configure",
            config: config
        });
        else if (transmuxer) transmuxer.configure(config);
    }
    handleTransmuxComplete(result) {
        result.chunkMeta.transmuxing.end = self.performance.now();
        this.onTransmuxComplete(result);
    }
}
const $fada8102d2a280be$var$STALL_MINIMUM_DURATION_MS = 250;
const $fada8102d2a280be$var$MAX_START_GAP_JUMP = 2.0;
const $fada8102d2a280be$var$SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
const $fada8102d2a280be$var$SKIP_BUFFER_RANGE_START = 0.05;
class $fada8102d2a280be$var$GapController {
    constructor(config, media, fragmentTracker, hls){
        this.config = void 0;
        this.media = null;
        this.fragmentTracker = void 0;
        this.hls = void 0;
        this.nudgeRetry = 0;
        this.stallReported = false;
        this.stalled = null;
        this.moved = false;
        this.seeking = false;
        this.config = config;
        this.media = media;
        this.fragmentTracker = fragmentTracker;
        this.hls = hls;
    }
    destroy() {
        this.media = null;
        // @ts-ignore
        this.hls = this.fragmentTracker = null;
    }
    /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */ poll(lastCurrentTime, activeFrag) {
        const { config: config, media: media, stalled: stalled } = this;
        if (media === null) return;
        const { currentTime: currentTime, seeking: seeking } = media;
        const seeked = this.seeking && !seeking;
        const beginSeek = !this.seeking && seeking;
        this.seeking = seeking;
        // The playhead is moving, no-op
        if (currentTime !== lastCurrentTime) {
            this.moved = true;
            if (stalled !== null) {
                // The playhead is now moving, but was previously stalled
                if (this.stallReported) {
                    const _stalledDuration = self.performance.now() - stalled;
                    $fada8102d2a280be$var$logger.warn(`playback not stuck anymore @${currentTime}, after ${Math.round(_stalledDuration)}ms`);
                    this.stallReported = false;
                }
                this.stalled = null;
                this.nudgeRetry = 0;
            }
            return;
        }
        // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
        if (beginSeek || seeked) {
            this.stalled = null;
            return;
        }
        // The playhead should not be moving
        if (media.paused && !seeking || media.ended || media.playbackRate === 0 || !$fada8102d2a280be$var$BufferHelper.getBuffered(media).length) return;
        const bufferInfo = $fada8102d2a280be$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const isBuffered = bufferInfo.len > 0;
        const nextStart = bufferInfo.nextStart || 0;
        // There is no playable buffer (seeked, waiting for buffer)
        if (!isBuffered && !nextStart) return;
        if (seeking) {
            // Waiting for seeking in a buffered range to complete
            const hasEnoughBuffer = bufferInfo.len > $fada8102d2a280be$var$MAX_START_GAP_JUMP;
            // Next buffered range is too far ahead to jump to while still seeking
            const noBufferGap = !nextStart || activeFrag && activeFrag.start <= currentTime || nextStart - currentTime > $fada8102d2a280be$var$MAX_START_GAP_JUMP && !this.fragmentTracker.getPartialFragment(currentTime);
            if (hasEnoughBuffer || noBufferGap) return;
            // Reset moved state when seeking to a point in or before a gap
            this.moved = false;
        }
        // Skip start gaps if we haven't played, but the last poll detected the start of a stall
        // The addition poll gives the browser a chance to jump the gap for us
        if (!this.moved && this.stalled !== null) {
            var _level$details;
            // Jump start gaps within jump threshold
            const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;
            // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
            // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
            // that begins over 1 target duration after the video start position.
            const level = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null;
            const isLive = level == null ? void 0 : (_level$details = level.details) == null ? void 0 : _level$details.live;
            const maxStartGapJump = isLive ? level.details.targetduration * 2 : $fada8102d2a280be$var$MAX_START_GAP_JUMP;
            const partialOrGap = this.fragmentTracker.getPartialFragment(currentTime);
            if (startJump > 0 && (startJump <= maxStartGapJump || partialOrGap)) {
                this._trySkipBufferHole(partialOrGap);
                return;
            }
        }
        // Start tracking stall time
        const tnow = self.performance.now();
        if (stalled === null) {
            this.stalled = tnow;
            return;
        }
        const stalledDuration = tnow - stalled;
        if (!seeking && stalledDuration >= $fada8102d2a280be$var$STALL_MINIMUM_DURATION_MS) {
            // Report stalling after trying to fix
            this._reportStall(bufferInfo);
            if (!this.media) return;
        }
        const bufferedWithHoles = $fada8102d2a280be$var$BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
        this._tryFixBufferStall(bufferedWithHoles, stalledDuration);
    }
    /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */ _tryFixBufferStall(bufferInfo, stalledDurationMs) {
        const { config: config, fragmentTracker: fragmentTracker, media: media } = this;
        if (media === null) return;
        const currentTime = media.currentTime;
        const partial = fragmentTracker.getPartialFragment(currentTime);
        if (partial) {
            // Try to skip over the buffer hole caused by a partial fragment
            // This method isn't limited by the size of the gap between buffered ranges
            const targetTime = this._trySkipBufferHole(partial);
            // we return here in this case, meaning
            // the branch below only executes when we haven't seeked to a new position
            if (targetTime || !this.media) return;
        }
        // if we haven't had to skip over a buffer hole of a partial fragment
        // we may just have to "nudge" the playlist as the browser decoding/rendering engine
        // needs to cross some sort of threshold covering all source-buffers content
        // to start playing properly.
        if ((bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && bufferInfo.nextStart - currentTime < config.maxBufferHole) && stalledDurationMs > config.highBufferWatchdogPeriod * 1000) {
            $fada8102d2a280be$var$logger.warn("Trying to nudge playhead over buffer-hole");
            // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
            // We only try to jump the hole if it's under the configured size
            // Reset stalled so to rearm watchdog timer
            this.stalled = null;
            this._tryNudgeBuffer();
        }
    }
    /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */ _reportStall(bufferInfo) {
        const { hls: hls, media: media, stallReported: stallReported } = this;
        if (!stallReported && media) {
            // Report stalled error once
            this.stallReported = true;
            const error = new Error(`Playback stalling at @${media.currentTime} due to low buffer (${JSON.stringify(bufferInfo)})`);
            $fada8102d2a280be$var$logger.warn(error.message);
            hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.BUFFER_STALLED_ERROR,
                fatal: false,
                error: error,
                buffer: bufferInfo.len
            });
        }
    }
    /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */ _trySkipBufferHole(partial) {
        const { config: config, hls: hls, media: media } = this;
        if (media === null) return 0;
        // Check if currentTime is between unbuffered regions of partial fragments
        const currentTime = media.currentTime;
        const bufferInfo = $fada8102d2a280be$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
        if (startTime) {
            const bufferStarved = bufferInfo.len <= config.maxBufferHole;
            const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
            const gapLength = startTime - currentTime;
            if (gapLength > 0 && (bufferStarved || waiting)) {
                // Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
                if (gapLength > config.maxBufferHole) {
                    const { fragmentTracker: fragmentTracker } = this;
                    let startGap = false;
                    if (currentTime === 0) {
                        const startFrag = fragmentTracker.getAppendedFrag(0, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
                        if (startFrag && startTime < startFrag.end) startGap = true;
                    }
                    if (!startGap) {
                        const startProvisioned = partial || fragmentTracker.getAppendedFrag(currentTime, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
                        if (startProvisioned) {
                            let moreToLoad = false;
                            let pos = startProvisioned.end;
                            while(pos < startTime){
                                const provisioned = fragmentTracker.getPartialFragment(pos);
                                if (provisioned) pos += provisioned.duration;
                                else {
                                    moreToLoad = true;
                                    break;
                                }
                            }
                            if (moreToLoad) return 0;
                        }
                    }
                }
                const targetTime = Math.max(startTime + $fada8102d2a280be$var$SKIP_BUFFER_RANGE_START, currentTime + $fada8102d2a280be$var$SKIP_BUFFER_HOLE_STEP_SECONDS);
                $fada8102d2a280be$var$logger.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
                this.moved = true;
                this.stalled = null;
                media.currentTime = targetTime;
                if (partial && !partial.gap) {
                    const error = new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
                    hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                        type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                        fatal: false,
                        error: error,
                        reason: error.message,
                        frag: partial
                    });
                }
                return targetTime;
            }
        }
        return 0;
    }
    /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */ _tryNudgeBuffer() {
        const { config: config, hls: hls, media: media, nudgeRetry: nudgeRetry } = this;
        if (media === null) return;
        const currentTime = media.currentTime;
        this.nudgeRetry++;
        if (nudgeRetry < config.nudgeMaxRetry) {
            const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
            // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
            const error = new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
            $fada8102d2a280be$var$logger.warn(error.message);
            media.currentTime = targetTime;
            hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.BUFFER_NUDGE_ON_STALL,
                error: error,
                fatal: false
            });
        } else {
            const error = new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
            $fada8102d2a280be$var$logger.error(error.message);
            hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.BUFFER_STALLED_ERROR,
                error: error,
                fatal: true
            });
        }
    }
}
const $fada8102d2a280be$var$TICK_INTERVAL$2 = 100; // how often to tick in ms
class $fada8102d2a280be$var$StreamController extends $fada8102d2a280be$var$BaseStreamController {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, "[stream-controller]", $fada8102d2a280be$var$PlaylistLevelType.MAIN);
        this.audioCodecSwap = false;
        this.gapController = null;
        this.level = -1;
        this._forceStartLoad = false;
        this.altAudio = false;
        this.audioOnly = false;
        this.fragPlaying = null;
        this.onvplaying = null;
        this.onvseeked = null;
        this.fragLastKbps = 0;
        this.couldBacktrack = false;
        this.backtrackFragment = null;
        this.audioCodecSwitch = false;
        this.videoBuffer = null;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
        hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
        hls.on($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_CREATED, this.onBufferCreated, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on($fada8102d2a280be$var$Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
        hls.off($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_CREATED, this.onBufferCreated, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off($fada8102d2a280be$var$Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    onHandlerDestroying() {
        this._unregisterListeners();
        this.onMediaDetaching();
    }
    startLoad(startPosition) {
        if (this.levels) {
            const { lastCurrentTime: lastCurrentTime, hls: hls } = this;
            this.stopLoad();
            this.setInterval($fada8102d2a280be$var$TICK_INTERVAL$2);
            this.level = -1;
            if (!this.startFragRequested) {
                // determine load level
                let startLevel = hls.startLevel;
                if (startLevel === -1) {
                    if (hls.config.testBandwidth && this.levels.length > 1) {
                        // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
                        startLevel = 0;
                        this.bitrateTest = true;
                    } else startLevel = hls.nextAutoLevel;
                }
                // set new level to playlist loader : this will trigger start level load
                // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
                this.level = hls.nextLoadLevel = startLevel;
                this.loadedmetadata = false;
            }
            // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
            if (lastCurrentTime > 0 && startPosition === -1) {
                this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
                startPosition = lastCurrentTime;
            }
            this.state = $fada8102d2a280be$var$State.IDLE;
            this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
            this.tick();
        } else {
            this._forceStartLoad = true;
            this.state = $fada8102d2a280be$var$State.STOPPED;
        }
    }
    stopLoad() {
        this._forceStartLoad = false;
        super.stopLoad();
    }
    doTick() {
        switch(this.state){
            case $fada8102d2a280be$var$State.WAITING_LEVEL:
                {
                    var _levels$level;
                    const { levels: levels, level: level } = this;
                    const details = levels == null ? void 0 : (_levels$level = levels[level]) == null ? void 0 : _levels$level.details;
                    if (details && (!details.live || this.levelLastLoaded === this.level)) {
                        if (this.waitForCdnTuneIn(details)) break;
                        this.state = $fada8102d2a280be$var$State.IDLE;
                        break;
                    } else if (this.hls.nextLoadLevel !== this.level) {
                        this.state = $fada8102d2a280be$var$State.IDLE;
                        break;
                    }
                    break;
                }
            case $fada8102d2a280be$var$State.FRAG_LOADING_WAITING_RETRY:
                {
                    var _this$media;
                    const now = self.performance.now();
                    const retryDate = this.retryDate;
                    // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                    if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
                        this.resetStartWhenNotLoaded(this.level);
                        this.state = $fada8102d2a280be$var$State.IDLE;
                    }
                }
                break;
        }
        if (this.state === $fada8102d2a280be$var$State.IDLE) this.doTickIdle();
        this.onTickEnd();
    }
    onTickEnd() {
        super.onTickEnd();
        this.checkBuffer();
        this.checkFragmentChanged();
    }
    doTickIdle() {
        const { hls: hls, levelLastLoaded: levelLastLoaded, levels: levels, media: media } = this;
        const { config: config, nextLoadLevel: level } = hls;
        // if start level not parsed yet OR
        // if video not attached AND start fragment already requested OR start frag prefetch not enabled
        // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
        if (levelLastLoaded === null || !media && (this.startFragRequested || !config.startFragPrefetch)) return;
        // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
        if (this.altAudio && this.audioOnly) return;
        if (!(levels != null && levels[level])) return;
        const levelInfo = levels[level];
        // if buffer length is less than maxBufLen try to load a new fragment
        const bufferInfo = this.getMainFwdBufferInfo();
        if (bufferInfo === null) return;
        const lastDetails = this.getLevelDetails();
        if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
            const data = {};
            if (this.altAudio) data.type = "video";
            this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_EOS, data);
            this.state = $fada8102d2a280be$var$State.ENDED;
            return;
        }
        // set next load level : this will trigger a playlist load if needed
        if (hls.loadLevel !== level && hls.manualLevel === -1) this.log(`Adapting to level ${level} from level ${this.level}`);
        this.level = hls.nextLoadLevel = level;
        const levelDetails = levelInfo.details;
        // if level info not retrieved yet, switch state and wait for level retrieval
        // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
        // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
        if (!levelDetails || this.state === $fada8102d2a280be$var$State.WAITING_LEVEL || levelDetails.live && this.levelLastLoaded !== level) {
            this.level = level;
            this.state = $fada8102d2a280be$var$State.WAITING_LEVEL;
            return;
        }
        const bufferLen = bufferInfo.len;
        // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
        const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);
        // Stay idle if we are still with buffer margins
        if (bufferLen >= maxBufLen) return;
        if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) this.backtrackFragment = null;
        const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
        let frag = this.getNextFragment(targetBufferTime, levelDetails);
        // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
        if (this.couldBacktrack && !this.fragPrevious && frag && frag.sn !== "initSegment" && this.fragmentTracker.getState(frag) !== $fada8102d2a280be$var$FragmentState.OK) {
            var _this$backtrackFragme;
            const backtrackSn = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
            const fragIdx = backtrackSn - levelDetails.startSN;
            const backtrackFrag = levelDetails.fragments[fragIdx - 1];
            if (backtrackFrag && frag.cc === backtrackFrag.cc) {
                frag = backtrackFrag;
                this.fragmentTracker.removeFragment(backtrackFrag);
            }
        } else if (this.backtrackFragment && bufferInfo.len) this.backtrackFragment = null;
        // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
        if (frag && this.isLoopLoading(frag, targetBufferTime)) {
            const gapStart = frag.gap;
            if (!gapStart) {
                // Cleanup the fragment tracker before trying to find the next unbuffered fragment
                const type = this.audioOnly && !this.altAudio ? $fada8102d2a280be$var$ElementaryStreamTypes.AUDIO : $fada8102d2a280be$var$ElementaryStreamTypes.VIDEO;
                const mediaBuffer = (type === $fada8102d2a280be$var$ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                if (mediaBuffer) this.afterBufferFlushed(mediaBuffer, type, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
            }
            frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, $fada8102d2a280be$var$PlaylistLevelType.MAIN, maxBufLen);
        }
        if (!frag) return;
        if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) frag = frag.initSegment;
        this.loadFragment(frag, levelInfo, targetBufferTime);
    }
    loadFragment(frag, level, targetBufferTime) {
        // Check if fragment is not loaded
        const fragState = this.fragmentTracker.getState(frag);
        this.fragCurrent = frag;
        if (fragState === $fada8102d2a280be$var$FragmentState.NOT_LOADED || fragState === $fada8102d2a280be$var$FragmentState.PARTIAL) {
            if (frag.sn === "initSegment") this._loadInitSegment(frag, level);
            else if (this.bitrateTest) {
                this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
                this._loadBitrateTestFrag(frag, level);
            } else {
                this.startFragRequested = true;
                super.loadFragment(frag, level, targetBufferTime);
            }
        } else this.clearTrackerIfNeeded(frag);
    }
    getBufferedFrag(position) {
        return this.fragmentTracker.getBufferedFrag(position, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
    }
    followingBufferedFrag(frag) {
        if (frag) // try to get range of next fragment (500ms after this range)
        return this.getBufferedFrag(frag.end + 0.5);
        return null;
    }
    /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */ immediateLevelSwitch() {
        this.abortCurrentFrag();
        this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    }
    /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */ nextLevelSwitch() {
        const { levels: levels, media: media } = this;
        // ensure that media is defined and that metadata are available (to retrieve currentTime)
        if (media != null && media.readyState) {
            let fetchdelay;
            const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
            if (fragPlayingCurrent && fragPlayingCurrent.start > 1) // flush buffer preceding current fragment (flush until current fragment start offset)
            // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
            this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
            const levelDetails = this.getLevelDetails();
            if (levelDetails != null && levelDetails.live) {
                const bufferInfo = this.getMainFwdBufferInfo();
                // Do not flush in live stream with low buffer
                if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) return;
            }
            if (!media.paused && levels) {
                // add a safety delay of 1s
                const nextLevelId = this.hls.nextLoadLevel;
                const nextLevel = levels[nextLevelId];
                const fragLastKbps = this.fragLastKbps;
                if (fragLastKbps && this.fragCurrent) fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
                else fetchdelay = 0;
            } else fetchdelay = 0;
            // this.log('fetchdelay:'+fetchdelay);
            // find buffer range that will be reached once new fragment will be fetched
            const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
            if (bufferedFrag) {
                // we can flush buffer range following this one without stalling playback
                const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
                if (nextBufferedFrag) {
                    // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
                    this.abortCurrentFrag();
                    // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
                    const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
                    const fragDuration = nextBufferedFrag.duration;
                    const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * 0.5), fragDuration * 0.75));
                    this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
                }
            }
        }
    }
    abortCurrentFrag() {
        const fragCurrent = this.fragCurrent;
        this.fragCurrent = null;
        this.backtrackFragment = null;
        if (fragCurrent) {
            fragCurrent.abortRequests();
            this.fragmentTracker.removeFragment(fragCurrent);
        }
        switch(this.state){
            case $fada8102d2a280be$var$State.KEY_LOADING:
            case $fada8102d2a280be$var$State.FRAG_LOADING:
            case $fada8102d2a280be$var$State.FRAG_LOADING_WAITING_RETRY:
            case $fada8102d2a280be$var$State.PARSING:
            case $fada8102d2a280be$var$State.PARSED:
                this.state = $fada8102d2a280be$var$State.IDLE;
                break;
        }
        this.nextLoadPosition = this.getLoadPosition();
    }
    flushMainBuffer(startOffset, endOffset) {
        super.flushMainBuffer(startOffset, endOffset, this.altAudio ? "video" : null);
    }
    onMediaAttached(event, data) {
        super.onMediaAttached(event, data);
        const media = data.media;
        this.onvplaying = this.onMediaPlaying.bind(this);
        this.onvseeked = this.onMediaSeeked.bind(this);
        media.addEventListener("playing", this.onvplaying);
        media.addEventListener("seeked", this.onvseeked);
        this.gapController = new $fada8102d2a280be$var$GapController(this.config, media, this.fragmentTracker, this.hls);
    }
    onMediaDetaching() {
        const { media: media } = this;
        if (media && this.onvplaying && this.onvseeked) {
            media.removeEventListener("playing", this.onvplaying);
            media.removeEventListener("seeked", this.onvseeked);
            this.onvplaying = this.onvseeked = null;
            this.videoBuffer = null;
        }
        this.fragPlaying = null;
        if (this.gapController) {
            this.gapController.destroy();
            this.gapController = null;
        }
        super.onMediaDetaching();
    }
    onMediaPlaying() {
        // tick to speed up FRAG_CHANGED triggering
        this.tick();
    }
    onMediaSeeked() {
        const media = this.media;
        const currentTime = media ? media.currentTime : null;
        if ($fada8102d2a280be$var$isFiniteNumber(currentTime)) this.log(`Media seeked to ${currentTime.toFixed(3)}`);
        // If seeked was issued before buffer was appended do not tick immediately
        const bufferInfo = this.getMainFwdBufferInfo();
        if (bufferInfo === null || bufferInfo.len === 0) {
            this.warn(`Main forward buffer length on "seeked" event ${bufferInfo ? bufferInfo.len : "empty"})`);
            return;
        }
        // tick to speed up FRAG_CHANGED triggering
        this.tick();
    }
    onManifestLoading() {
        // reset buffer on manifest loading
        this.log("Trigger BUFFER_RESET");
        this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_RESET, undefined);
        this.fragmentTracker.removeAllFragments();
        this.couldBacktrack = false;
        this.startPosition = this.lastCurrentTime = 0;
        this.levels = this.fragPlaying = this.backtrackFragment = null;
        this.altAudio = this.audioOnly = false;
    }
    onManifestParsed(event, data) {
        let aac = false;
        let heaac = false;
        let codec;
        data.levels.forEach((level)=>{
            // detect if we have different kind of audio codecs used amongst playlists
            codec = level.audioCodec;
            if (codec) {
                if (codec.indexOf("mp4a.40.2") !== -1) aac = true;
                if (codec.indexOf("mp4a.40.5") !== -1) heaac = true;
            }
        });
        this.audioCodecSwitch = aac && heaac && !$fada8102d2a280be$var$changeTypeSupported();
        if (this.audioCodecSwitch) this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC");
        this.levels = data.levels;
        this.startFragRequested = false;
    }
    onLevelLoading(event, data) {
        const { levels: levels } = this;
        if (!levels || this.state !== $fada8102d2a280be$var$State.IDLE) return;
        const level = levels[data.level];
        if (!level.details || level.details.live && this.levelLastLoaded !== data.level || this.waitForCdnTuneIn(level.details)) this.state = $fada8102d2a280be$var$State.WAITING_LEVEL;
    }
    onLevelLoaded(event, data) {
        var _curLevel$details;
        const { levels: levels } = this;
        const newLevelId = data.level;
        const newDetails = data.details;
        const duration = newDetails.totalduration;
        if (!levels) {
            this.warn(`Levels were reset while loading level ${newLevelId}`);
            return;
        }
        this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ""}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
        const curLevel = levels[newLevelId];
        const fragCurrent = this.fragCurrent;
        if (fragCurrent && (this.state === $fada8102d2a280be$var$State.FRAG_LOADING || this.state === $fada8102d2a280be$var$State.FRAG_LOADING_WAITING_RETRY)) {
            if ((fragCurrent.level !== data.level || fragCurrent.urlId !== curLevel.urlId) && fragCurrent.loader) this.abortCurrentFrag();
        }
        let sliding = 0;
        if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
            if (!newDetails.fragments[0]) newDetails.deltaUpdateFailed = true;
            if (newDetails.deltaUpdateFailed) return;
            sliding = this.alignPlaylists(newDetails, curLevel.details);
        }
        // override level info
        curLevel.details = newDetails;
        this.levelLastLoaded = newLevelId;
        this.hls.trigger($fada8102d2a280be$var$Events.LEVEL_UPDATED, {
            details: newDetails,
            level: newLevelId
        });
        // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
        if (this.state === $fada8102d2a280be$var$State.WAITING_LEVEL) {
            if (this.waitForCdnTuneIn(newDetails)) // Wait for Low-Latency CDN Tune-in
            return;
            this.state = $fada8102d2a280be$var$State.IDLE;
        }
        if (!this.startFragRequested) this.setStartPosition(newDetails, sliding);
        else if (newDetails.live) this.synchronizeToLiveEdge(newDetails);
        // trigger handler right now
        this.tick();
    }
    _handleFragmentLoadProgress(data) {
        var _frag$initSegment;
        const { frag: frag, part: part, payload: payload } = data;
        const { levels: levels } = this;
        if (!levels) {
            this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
            return;
        }
        const currentLevel = levels[frag.level];
        const details = currentLevel.details;
        if (!details) {
            this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        const videoCodec = currentLevel.videoCodec;
        // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
        const accurateTimeOffset = details.PTSKnown || !details.live;
        const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
        const audioCodec = this._getAudioCodec(currentLevel);
        // transmux the MPEG-TS data to ISO-BMFF segments
        // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
        const transmuxer = this.transmuxer = this.transmuxer || new $fada8102d2a280be$var$TransmuxerInterface(this.hls, $fada8102d2a280be$var$PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
        const partIndex = part ? part.index : -1;
        const partial = partIndex !== -1;
        const chunkMeta = new $fada8102d2a280be$var$ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
        const initPTS = this.initPTS[frag.cc];
        transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
    }
    onAudioTrackSwitching(event, data) {
        // if any URL found on new audio track, it is an alternate audio track
        const fromAltAudio = this.altAudio;
        const altAudio = !!data.url;
        // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
        // don't do anything if we switch to alt audio: audio stream controller is handling it.
        // we will just have to change buffer scheduling on audioTrackSwitched
        if (!altAudio) {
            if (this.mediaBuffer !== this.media) {
                this.log("Switching on main audio, use media.buffered to schedule main fragment loading");
                this.mediaBuffer = this.media;
                const fragCurrent = this.fragCurrent;
                // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
                if (fragCurrent) {
                    this.log("Switching to main audio track, cancel main fragment load");
                    fragCurrent.abortRequests();
                    this.fragmentTracker.removeFragment(fragCurrent);
                }
                // destroy transmuxer to force init segment generation (following audio switch)
                this.resetTransmuxer();
                // switch to IDLE state to load new fragment
                this.resetLoadingState();
            } else if (this.audioOnly) // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
            this.resetTransmuxer();
            const hls = this.hls;
            // If switching from alt to main audio, flush all audio and trigger track switched
            if (fromAltAudio) {
                hls.trigger($fada8102d2a280be$var$Events.BUFFER_FLUSHING, {
                    startOffset: 0,
                    endOffset: Number.POSITIVE_INFINITY,
                    type: null
                });
                this.fragmentTracker.removeAllFragments();
            }
            hls.trigger($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHED, data);
        }
    }
    onAudioTrackSwitched(event, data) {
        const trackId = data.id;
        const altAudio = !!this.hls.audioTracks[trackId].url;
        if (altAudio) {
            const videoBuffer = this.videoBuffer;
            // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
            if (videoBuffer && this.mediaBuffer !== videoBuffer) {
                this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading");
                this.mediaBuffer = videoBuffer;
            }
        }
        this.altAudio = altAudio;
        this.tick();
    }
    onBufferCreated(event, data) {
        const tracks = data.tracks;
        let mediaTrack;
        let name;
        let alternate = false;
        for(const type in tracks){
            const track = tracks[type];
            if (track.id === "main") {
                name = type;
                mediaTrack = track;
                // keep video source buffer reference
                if (type === "video") {
                    const videoTrack = tracks[type];
                    if (videoTrack) this.videoBuffer = videoTrack.buffer;
                }
            } else alternate = true;
        }
        if (alternate && mediaTrack) {
            this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
            this.mediaBuffer = mediaTrack.buffer;
        } else this.mediaBuffer = this.media;
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        if (frag && frag.type !== $fada8102d2a280be$var$PlaylistLevelType.MAIN) return;
        if (this.fragContextChanged(frag)) {
            // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
            // Avoid setting state back to IDLE, since that will interfere with a level switch
            this.warn(`Fragment ${frag.sn}${part ? " p: " + part.index : ""} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
            if (this.state === $fada8102d2a280be$var$State.PARSED) this.state = $fada8102d2a280be$var$State.IDLE;
            return;
        }
        const stats = part ? part.stats : frag.stats;
        this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
        if (frag.sn !== "initSegment") this.fragPrevious = frag;
        this.fragBufferedComplete(frag, part);
    }
    onError(event, data) {
        var _data$context;
        if (data.fatal) {
            this.state = $fada8102d2a280be$var$State.ERROR;
            return;
        }
        switch(data.details){
            case $fada8102d2a280be$var$ErrorDetails.FRAG_GAP:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_DECRYPT_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_TIMEOUT:
            case $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError($fada8102d2a280be$var$PlaylistLevelType.MAIN, data);
                break;
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_LOAD_TIMEOUT:
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_PARSING_ERROR:
                // in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
                if (!data.levelRetry && this.state === $fada8102d2a280be$var$State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === $fada8102d2a280be$var$PlaylistContextType.LEVEL) this.state = $fada8102d2a280be$var$State.IDLE;
                break;
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_FULL_ERROR:
                if (!data.parent || data.parent !== "main") return;
                if (this.reduceLengthAndFlushBuffer(data)) this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                break;
            case $fada8102d2a280be$var$ErrorDetails.INTERNAL_EXCEPTION:
                this.recoverWorkerError(data);
                break;
        }
    }
    // Checks the health of the buffer and attempts to resolve playback stalls.
    checkBuffer() {
        const { media: media, gapController: gapController } = this;
        if (!media || !gapController || !media.readyState) // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
        return;
        if (this.loadedmetadata || !$fada8102d2a280be$var$BufferHelper.getBuffered(media).length) {
            // Resolve gaps using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
            const activeFrag = this.state !== $fada8102d2a280be$var$State.IDLE ? this.fragCurrent : null;
            gapController.poll(this.lastCurrentTime, activeFrag);
        }
        this.lastCurrentTime = media.currentTime;
    }
    onFragLoadEmergencyAborted() {
        this.state = $fada8102d2a280be$var$State.IDLE;
        // if loadedmetadata is not set, it means that we are emergency switch down on first frag
        // in that case, reset startFragRequested flag
        if (!this.loadedmetadata) {
            this.startFragRequested = false;
            this.nextLoadPosition = this.startPosition;
        }
        this.tickImmediate();
    }
    onBufferFlushed(event, { type: type }) {
        if (type !== $fada8102d2a280be$var$ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
            const mediaBuffer = (type === $fada8102d2a280be$var$ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
            this.afterBufferFlushed(mediaBuffer, type, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
        }
    }
    onLevelsUpdated(event, data) {
        this.levels = data.levels;
    }
    swapAudioCodec() {
        this.audioCodecSwap = !this.audioCodecSwap;
    }
    /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */ seekToStartPos() {
        const { media: media } = this;
        if (!media) return;
        const currentTime = media.currentTime;
        let startPosition = this.startPosition;
        // only adjust currentTime if different from startPosition or if startPosition not buffered
        // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
        if (startPosition >= 0 && currentTime < startPosition) {
            if (media.seeking) {
                this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
                return;
            }
            const buffered = $fada8102d2a280be$var$BufferHelper.getBuffered(media);
            const bufferStart = buffered.length ? buffered.start(0) : 0;
            const delta = bufferStart - startPosition;
            if (delta > 0 && (delta < this.config.maxBufferHole || delta < this.config.maxFragLookUpTolerance)) {
                this.log(`adjusting start position by ${delta} to match buffer start`);
                startPosition += delta;
                this.startPosition = startPosition;
            }
            this.log(`seek to target start position ${startPosition} from current time ${currentTime}`);
            media.currentTime = startPosition;
        }
    }
    _getAudioCodec(currentLevel) {
        let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
        if (this.audioCodecSwap && audioCodec) {
            this.log("Swapping audio codec");
            if (audioCodec.indexOf("mp4a.40.5") !== -1) audioCodec = "mp4a.40.2";
            else audioCodec = "mp4a.40.5";
        }
        return audioCodec;
    }
    _loadBitrateTestFrag(frag, level) {
        frag.bitrateTest = true;
        this._doFragLoad(frag, level).then((data)=>{
            const { hls: hls } = this;
            if (!data || this.fragContextChanged(frag)) return;
            level.fragmentError = 0;
            this.state = $fada8102d2a280be$var$State.IDLE;
            this.startFragRequested = false;
            this.bitrateTest = false;
            const stats = frag.stats;
            // Bitrate tests fragments are neither parsed nor buffered
            stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
            hls.trigger($fada8102d2a280be$var$Events.FRAG_LOADED, data);
            frag.bitrateTest = false;
        });
    }
    _handleTransmuxComplete(transmuxResult) {
        var _id3$samples;
        const id = "main";
        const { hls: hls } = this;
        const { remuxResult: remuxResult, chunkMeta: chunkMeta } = transmuxResult;
        const context = this.getCurrentContext(chunkMeta);
        if (!context) {
            this.resetWhenMissingContext(chunkMeta);
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const { video: video, text: text, id3: id3, initSegment: initSegment } = remuxResult;
        const { details: details } = level;
        // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
        const audio = this.altAudio ? undefined : remuxResult.audio;
        // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
        // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
        if (this.fragContextChanged(frag)) {
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        this.state = $fada8102d2a280be$var$State.PARSING;
        if (initSegment) {
            if (initSegment != null && initSegment.tracks) {
                const mapFragment = frag.initSegment || frag;
                this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
                hls.trigger($fada8102d2a280be$var$Events.FRAG_PARSING_INIT_SEGMENT, {
                    frag: mapFragment,
                    id: id,
                    tracks: initSegment.tracks
                });
            }
            // This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
            const initPTS = initSegment.initPTS;
            const timescale = initSegment.timescale;
            if ($fada8102d2a280be$var$isFiniteNumber(initPTS)) {
                this.initPTS[frag.cc] = {
                    baseTime: initPTS,
                    timescale: timescale
                };
                hls.trigger($fada8102d2a280be$var$Events.INIT_PTS_FOUND, {
                    frag: frag,
                    id: id,
                    initPTS: initPTS,
                    timescale: timescale
                });
            }
        }
        // Avoid buffering if backtracking this fragment
        if (video && remuxResult.independent !== false) {
            if (details) {
                const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = video;
                if (part) part.elementaryStreams[video.type] = {
                    startPTS: startPTS,
                    endPTS: endPTS,
                    startDTS: startDTS,
                    endDTS: endDTS
                };
                else {
                    if (video.firstKeyFrame && video.independent && chunkMeta.id === 1) this.couldBacktrack = true;
                    if (video.dropped && video.independent) {
                        // Backtrack if dropped frames create a gap after currentTime
                        const bufferInfo = this.getMainFwdBufferInfo();
                        const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
                        const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
                        if (targetBufferTime < startTime - this.config.maxBufferHole) {
                            this.backtrack(frag);
                            return;
                        }
                        // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
                        frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
                    }
                }
                frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
                if (this.backtrackFragment) this.backtrackFragment = frag;
                this.bufferFragmentData(video, frag, part, chunkMeta);
            }
        } else if (remuxResult.independent === false) {
            this.backtrack(frag);
            return;
        }
        if (audio) {
            const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = audio;
            if (part) part.elementaryStreams[$fada8102d2a280be$var$ElementaryStreamTypes.AUDIO] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS
            };
            frag.setElementaryStreamInfo($fada8102d2a280be$var$ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
            this.bufferFragmentData(audio, frag, part, chunkMeta);
        }
        if (details && id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
            const emittedID3 = {
                id: id,
                frag: frag,
                details: details,
                samples: id3.samples
            };
            hls.trigger($fada8102d2a280be$var$Events.FRAG_PARSING_METADATA, emittedID3);
        }
        if (details && text) {
            const emittedText = {
                id: id,
                frag: frag,
                details: details,
                samples: text.samples
            };
            hls.trigger($fada8102d2a280be$var$Events.FRAG_PARSING_USERDATA, emittedText);
        }
    }
    _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
        if (this.state !== $fada8102d2a280be$var$State.PARSING) return;
        this.audioOnly = !!tracks.audio && !tracks.video;
        // if audio track is expected to come from audio stream controller, discard any coming from main
        if (this.altAudio && !this.audioOnly) delete tracks.audio;
        // include levelCodec in audio and video tracks
        const { audio: audio, video: video, audiovideo: audiovideo } = tracks;
        if (audio) {
            let audioCodec = currentLevel.audioCodec;
            const ua = navigator.userAgent.toLowerCase();
            if (this.audioCodecSwitch) {
                if (audioCodec) {
                    if (audioCodec.indexOf("mp4a.40.5") !== -1) audioCodec = "mp4a.40.2";
                    else audioCodec = "mp4a.40.5";
                }
                // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
                // force HE-AAC, as it seems that most browsers prefers it.
                // don't force HE-AAC if mono stream, or in Firefox
                if (audio.metadata.channelCount !== 1 && ua.indexOf("firefox") === -1) audioCodec = "mp4a.40.5";
            }
            // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
            if (ua.indexOf("android") !== -1 && audio.container !== "audio/mpeg") {
                // Exclude mpeg audio
                audioCodec = "mp4a.40.2";
                this.log(`Android: force audio codec to ${audioCodec}`);
            }
            if (currentLevel.audioCodec && currentLevel.audioCodec !== audioCodec) this.log(`Swapping manifest audio codec "${currentLevel.audioCodec}" for "${audioCodec}"`);
            audio.levelCodec = audioCodec;
            audio.id = "main";
            this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ""}/${currentLevel.audioCodec || ""}/${audio.codec}]`);
        }
        if (video) {
            video.levelCodec = currentLevel.videoCodec;
            video.id = "main";
            this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ""}/${video.codec}]`);
        }
        if (audiovideo) this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.attrs.CODECS || ""}/${audiovideo.codec}]`);
        this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_CODECS, tracks);
        // loop through tracks that are going to be provided to bufferController
        Object.keys(tracks).forEach((trackName)=>{
            const track = tracks[trackName];
            const initSegment = track.initSegment;
            if (initSegment != null && initSegment.byteLength) this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_APPENDING, {
                type: trackName,
                data: initSegment,
                frag: frag,
                part: null,
                chunkMeta: chunkMeta,
                parent: frag.type
            });
        });
        // trigger handler right now
        this.tick();
    }
    getMainFwdBufferInfo() {
        return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
    }
    backtrack(frag) {
        this.couldBacktrack = true;
        // Causes findFragments to backtrack through fragments to find the keyframe
        this.backtrackFragment = frag;
        this.resetTransmuxer();
        this.flushBufferGap(frag);
        this.fragmentTracker.removeFragment(frag);
        this.fragPrevious = null;
        this.nextLoadPosition = frag.start;
        this.state = $fada8102d2a280be$var$State.IDLE;
    }
    checkFragmentChanged() {
        const video = this.media;
        let fragPlayingCurrent = null;
        if (video && video.readyState > 1 && video.seeking === false) {
            const currentTime = video.currentTime;
            /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */ if ($fada8102d2a280be$var$BufferHelper.isBuffered(video, currentTime)) fragPlayingCurrent = this.getAppendedFrag(currentTime);
            else if ($fada8102d2a280be$var$BufferHelper.isBuffered(video, currentTime + 0.1)) /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */ fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
            if (fragPlayingCurrent) {
                this.backtrackFragment = null;
                const fragPlaying = this.fragPlaying;
                const fragCurrentLevel = fragPlayingCurrent.level;
                if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel || fragPlayingCurrent.urlId !== fragPlaying.urlId) {
                    this.fragPlaying = fragPlayingCurrent;
                    this.hls.trigger($fada8102d2a280be$var$Events.FRAG_CHANGED, {
                        frag: fragPlayingCurrent
                    });
                    if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) this.hls.trigger($fada8102d2a280be$var$Events.LEVEL_SWITCHED, {
                        level: fragCurrentLevel
                    });
                }
            }
        }
    }
    get nextLevel() {
        const frag = this.nextBufferedFrag;
        if (frag) return frag.level;
        return -1;
    }
    get currentFrag() {
        const media = this.media;
        if (media) return this.fragPlaying || this.getAppendedFrag(media.currentTime);
        return null;
    }
    get currentProgramDateTime() {
        const media = this.media;
        if (media) {
            const currentTime = media.currentTime;
            const frag = this.currentFrag;
            if (frag && $fada8102d2a280be$var$isFiniteNumber(currentTime) && $fada8102d2a280be$var$isFiniteNumber(frag.programDateTime)) {
                const epocMs = frag.programDateTime + (currentTime - frag.start) * 1000;
                return new Date(epocMs);
            }
        }
        return null;
    }
    get currentLevel() {
        const frag = this.currentFrag;
        if (frag) return frag.level;
        return -1;
    }
    get nextBufferedFrag() {
        const frag = this.currentFrag;
        if (frag) return this.followingBufferedFrag(frag);
        return null;
    }
    get forceStartLoad() {
        return this._forceStartLoad;
    }
}
/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */ class $fada8102d2a280be$var$EWMA {
    //  About half of the estimated value will be from the last |halfLife| samples by weight.
    constructor(halfLife, estimate = 0, weight = 0){
        this.halfLife = void 0;
        this.alpha_ = void 0;
        this.estimate_ = void 0;
        this.totalWeight_ = void 0;
        this.halfLife = halfLife;
        // Larger values of alpha expire historical data more slowly.
        this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
        this.estimate_ = estimate;
        this.totalWeight_ = weight;
    }
    sample(weight, value) {
        const adjAlpha = Math.pow(this.alpha_, weight);
        this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
        this.totalWeight_ += weight;
    }
    getTotalWeight() {
        return this.totalWeight_;
    }
    getEstimate() {
        if (this.alpha_) {
            const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
            if (zeroFactor) return this.estimate_ / zeroFactor;
        }
        return this.estimate_;
    }
}
/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */ class $fada8102d2a280be$var$EwmaBandWidthEstimator {
    constructor(slow, fast, defaultEstimate, defaultTTFB = 100){
        this.defaultEstimate_ = void 0;
        this.minWeight_ = void 0;
        this.minDelayMs_ = void 0;
        this.slow_ = void 0;
        this.fast_ = void 0;
        this.defaultTTFB_ = void 0;
        this.ttfb_ = void 0;
        this.defaultEstimate_ = defaultEstimate;
        this.minWeight_ = 0.001;
        this.minDelayMs_ = 50;
        this.slow_ = new $fada8102d2a280be$var$EWMA(slow);
        this.fast_ = new $fada8102d2a280be$var$EWMA(fast);
        this.defaultTTFB_ = defaultTTFB;
        this.ttfb_ = new $fada8102d2a280be$var$EWMA(slow);
    }
    update(slow, fast) {
        const { slow_: slow_, fast_: fast_, ttfb_: ttfb_ } = this;
        if (slow_.halfLife !== slow) this.slow_ = new $fada8102d2a280be$var$EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
        if (fast_.halfLife !== fast) this.fast_ = new $fada8102d2a280be$var$EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
        if (ttfb_.halfLife !== slow) this.ttfb_ = new $fada8102d2a280be$var$EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
    }
    sample(durationMs, numBytes) {
        durationMs = Math.max(durationMs, this.minDelayMs_);
        const numBits = 8 * numBytes;
        // weight is duration in seconds
        const durationS = durationMs / 1000;
        // value is bandwidth in bits/s
        const bandwidthInBps = numBits / durationS;
        this.fast_.sample(durationS, bandwidthInBps);
        this.slow_.sample(durationS, bandwidthInBps);
    }
    sampleTTFB(ttfb) {
        // weight is frequency curve applied to TTFB in seconds
        // (longer times have less weight with expected input under 1 second)
        const seconds = ttfb / 1000;
        const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
        this.ttfb_.sample(weight, Math.max(ttfb, 5));
    }
    canEstimate() {
        return this.fast_.getTotalWeight() >= this.minWeight_;
    }
    getEstimate() {
        if (this.canEstimate()) // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
        // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
        // Take the minimum of these two estimates.  This should have the effect of
        // adapting down quickly, but up more slowly.
        return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
        else return this.defaultEstimate_;
    }
    getEstimateTTFB() {
        if (this.ttfb_.getTotalWeight() >= this.minWeight_) return this.ttfb_.getEstimate();
        else return this.defaultTTFB_;
    }
    destroy() {}
}
class $fada8102d2a280be$var$AbrController {
    constructor(hls){
        this.hls = void 0;
        this.lastLevelLoadSec = 0;
        this.lastLoadedFragLevel = 0;
        this._nextAutoLevel = -1;
        this.timer = -1;
        this.onCheck = this._abandonRulesCheck.bind(this);
        this.fragCurrent = null;
        this.partCurrent = null;
        this.bitrateTestDelay = 0;
        this.bwEstimator = void 0;
        this.hls = hls;
        const config = hls.config;
        this.bwEstimator = new $fada8102d2a280be$var$EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
        this.registerListeners();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.FRAG_LOADING, this.onFragLoading, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.FRAG_LOADING, this.onFragLoading, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
    }
    destroy() {
        this.unregisterListeners();
        this.clearTimer();
        // @ts-ignore
        this.hls = this.onCheck = null;
        this.fragCurrent = this.partCurrent = null;
    }
    onFragLoading(event, data) {
        var _data$part;
        const frag = data.frag;
        if (this.ignoreFragment(frag)) return;
        this.fragCurrent = frag;
        this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
        this.clearTimer();
        this.timer = self.setInterval(this.onCheck, 100);
    }
    onLevelSwitching(event, data) {
        this.clearTimer();
    }
    getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
        const fragLoadSec = timeToFirstByteSec + fragSizeBits / bandwidth;
        const playlistLoadSec = isSwitch ? this.lastLevelLoadSec : 0;
        return fragLoadSec + playlistLoadSec;
    }
    onLevelLoaded(event, data) {
        const config = this.hls.config;
        const { total: total, bwEstimate: bwEstimate } = data.stats;
        // Total is the bytelength and bwEstimate in bits/sec
        if ($fada8102d2a280be$var$isFiniteNumber(total) && $fada8102d2a280be$var$isFiniteNumber(bwEstimate)) this.lastLevelLoadSec = 8 * total / bwEstimate;
        if (data.details.live) this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
        else this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
    }
    /*
      This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
      quickly enough to prevent underbuffering
    */ _abandonRulesCheck() {
        const { fragCurrent: frag, partCurrent: part, hls: hls } = this;
        const { autoLevelEnabled: autoLevelEnabled, media: media } = hls;
        if (!frag || !media) return;
        const now = performance.now();
        const stats = part ? part.stats : frag.stats;
        const duration = part ? part.duration : frag.duration;
        const timeLoading = now - stats.loading.start;
        // If frag loading is aborted, complete, or from lowest level, stop timer and return
        if (stats.aborted || stats.loaded && stats.loaded === stats.total || frag.level === 0) {
            this.clearTimer();
            // reset forced auto level value so that next level will be selected
            this._nextAutoLevel = -1;
            return;
        }
        // This check only runs if we're in ABR mode and actually playing
        if (!autoLevelEnabled || media.paused || !media.playbackRate || !media.readyState) return;
        const bufferInfo = hls.mainForwardBufferInfo;
        if (bufferInfo === null) return;
        const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
        const playbackRate = Math.abs(media.playbackRate);
        // To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
        if (timeLoading <= Math.max(ttfbEstimate, 1000 * (duration / (playbackRate * 2)))) return;
        // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
        const bufferStarvationDelay = bufferInfo.len / playbackRate;
        // Only downswitch if less than 2 fragment lengths are buffered
        if (bufferStarvationDelay >= 2 * duration / playbackRate) return;
        const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
        const loadedFirstByte = stats.loaded && ttfb > -1;
        const bwEstimate = this.bwEstimator.getEstimate();
        const { levels: levels, minAutoLevel: minAutoLevel } = hls;
        const level = levels[frag.level];
        const expectedLen = stats.total || Math.max(stats.loaded, Math.round(duration * level.maxBitrate / 8));
        let timeStreaming = timeLoading - ttfb;
        if (timeStreaming < 1 && loadedFirstByte) timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
        const loadRate = loadedFirstByte ? stats.loaded * 1000 / timeStreaming : 0;
        // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
        const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbEstimate / 1000;
        // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
        if (fragLoadedDelay <= bufferStarvationDelay) return;
        const bwe = loadRate ? loadRate * 8 : bwEstimate;
        let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
        let nextLoadLevel;
        // Iterate through lower level and try to find the largest one that avoids rebuffering
        for(nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--){
            // compute time to load next fragment at lower level
            // 8 = bits per byte (bps/Bps)
            const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
            fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbEstimate / 1000, bwe, duration * levelNextBitrate, !levels[nextLoadLevel].details);
            if (fragLevelNextLoadedDelay < bufferStarvationDelay) break;
        }
        // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
        // to load the current one
        if (fragLevelNextLoadedDelay >= fragLoadedDelay) return;
        // if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
        if (fragLevelNextLoadedDelay > duration * 10) return;
        hls.nextLoadLevel = nextLoadLevel;
        if (loadedFirstByte) // If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
        this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
        else // If there has been no loading progress, sample TTFB
        this.bwEstimator.sampleTTFB(timeLoading);
        this.clearTimer();
        $fada8102d2a280be$var$logger.warn(`[abr] Fragment ${frag.sn}${part ? " part " + part.index : ""} of level ${frag.level} is loading too slowly;
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb}
      Current BW estimate: ${$fada8102d2a280be$var$isFiniteNumber(bwEstimate) ? (bwEstimate / 1024).toFixed(3) : "Unknown"} Kb/s
      New BW estimate: ${(this.bwEstimator.getEstimate() / 1024).toFixed(3)} Kb/s
      Aborting and switching to level ${nextLoadLevel}`);
        if (frag.loader) {
            this.fragCurrent = this.partCurrent = null;
            frag.abortRequests();
        }
        hls.trigger($fada8102d2a280be$var$Events.FRAG_LOAD_EMERGENCY_ABORTED, {
            frag: frag,
            part: part,
            stats: stats
        });
    }
    onFragLoaded(event, { frag: frag, part: part }) {
        const stats = part ? part.stats : frag.stats;
        if (frag.type === $fada8102d2a280be$var$PlaylistLevelType.MAIN) this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
        if (this.ignoreFragment(frag)) return;
        // stop monitoring bw once frag loaded
        this.clearTimer();
        // store level id after successful fragment load
        this.lastLoadedFragLevel = frag.level;
        // reset forced auto level value so that next level will be selected
        this._nextAutoLevel = -1;
        // compute level average bitrate
        if (this.hls.config.abrMaxWithRealBitrate) {
            const duration = part ? part.duration : frag.duration;
            const level = this.hls.levels[frag.level];
            const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
            const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
            level.loaded = {
                bytes: loadedBytes,
                duration: loadedDuration
            };
            level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
        }
        if (frag.bitrateTest) {
            const fragBufferedData = {
                stats: stats,
                frag: frag,
                part: part,
                id: frag.type
            };
            this.onFragBuffered($fada8102d2a280be$var$Events.FRAG_BUFFERED, fragBufferedData);
            frag.bitrateTest = false;
        }
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
        if (stats.aborted) return;
        if (this.ignoreFragment(frag)) return;
        // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
        // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
        // is used. If we used buffering in that case, our BW estimate sample will be very large.
        const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
        this.bwEstimator.sample(processingMs, stats.loaded);
        stats.bwEstimate = this.bwEstimator.getEstimate();
        if (frag.bitrateTest) this.bitrateTestDelay = processingMs / 1000;
        else this.bitrateTestDelay = 0;
    }
    ignoreFragment(frag) {
        // Only count non-alt-audio frags which were actually buffered in our BW calculations
        return frag.type !== $fada8102d2a280be$var$PlaylistLevelType.MAIN || frag.sn === "initSegment";
    }
    clearTimer() {
        self.clearInterval(this.timer);
    }
    // return next auto level
    get nextAutoLevel() {
        const forcedAutoLevel = this._nextAutoLevel;
        const bwEstimator = this.bwEstimator;
        // in case next auto level has been forced, and bw not available or not reliable, return forced value
        if (forcedAutoLevel !== -1 && !bwEstimator.canEstimate()) return forcedAutoLevel;
        // compute next level using ABR logic
        let nextABRAutoLevel = this.getNextABRAutoLevel();
        // use forced auto level when ABR selected level has errored
        if (forcedAutoLevel !== -1) {
            const levels = this.hls.levels;
            if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) return forcedAutoLevel;
        }
        // if forced auto level has been defined, use it to cap ABR computed quality level
        if (forcedAutoLevel !== -1) nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
        return nextABRAutoLevel;
    }
    getNextABRAutoLevel() {
        const { fragCurrent: fragCurrent, partCurrent: partCurrent, hls: hls } = this;
        const { maxAutoLevel: maxAutoLevel, config: config, minAutoLevel: minAutoLevel, media: media } = hls;
        const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
        // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
        // if we're playing back at the normal rate.
        const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1.0;
        const avgbw = this.bwEstimator ? this.bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate;
        // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
        const bufferInfo = hls.mainForwardBufferInfo;
        const bufferStarvationDelay = (bufferInfo ? bufferInfo.len : 0) / playbackRate;
        // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
        let bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor);
        if (bestLevel >= 0) return bestLevel;
        $fada8102d2a280be$var$logger.trace(`[abr] ${bufferStarvationDelay ? "rebuffering expected" : "buffer is empty"}, finding optimal quality level`);
        // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
        // if no matching level found, logic will return 0
        let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
        let bwFactor = config.abrBandWidthFactor;
        let bwUpFactor = config.abrBandWidthUpFactor;
        if (!bufferStarvationDelay) {
            // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
            const bitrateTestDelay = this.bitrateTestDelay;
            if (bitrateTestDelay) {
                // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
                // max video loading delay used in  automatic start level selection :
                // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
                // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
                // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
                const maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
                maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
                $fada8102d2a280be$var$logger.trace(`[abr] bitrate test took ${Math.round(1000 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1000 * maxStarvationDelay)} ms`);
                // don't use conservative factor on bitrate test
                bwFactor = bwUpFactor = 1;
            }
        }
        bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor);
        return Math.max(bestLevel, 0);
    }
    findBestLevel(currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor) {
        var _level$details;
        const { fragCurrent: fragCurrent, partCurrent: partCurrent, lastLoadedFragLevel: currentLevel } = this;
        const { levels: levels } = this.hls;
        const level = levels[currentLevel];
        const live = !!(level != null && (_level$details = level.details) != null && _level$details.live);
        const currentCodecSet = level == null ? void 0 : level.codecSet;
        const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
        const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1000;
        let levelSkippedMin = minAutoLevel;
        let levelSkippedMax = -1;
        for(let i = maxAutoLevel; i >= minAutoLevel; i--){
            const levelInfo = levels[i];
            if (!levelInfo || currentCodecSet && levelInfo.codecSet !== currentCodecSet) {
                if (levelInfo) {
                    levelSkippedMin = Math.min(i, levelSkippedMin);
                    levelSkippedMax = Math.max(i, levelSkippedMax);
                }
                continue;
            }
            if (levelSkippedMax !== -1) $fada8102d2a280be$var$logger.trace(`[abr] Skipped level(s) ${levelSkippedMin}-${levelSkippedMax} with CODECS:"${levels[levelSkippedMax].attrs.CODECS}"; not compatible with "${level.attrs.CODECS}"`);
            const levelDetails = levelInfo.details;
            const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
            let adjustedbw;
            // follow algorithm captured from stagefright :
            // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
            // Pick the highest bandwidth stream below or equal to estimated bandwidth.
            // consider only 80% of the available bandwidth, but if we are switching up,
            // be even more conservative (70%) to avoid overestimating and immediately
            // switching back.
            if (i <= currentLevel) adjustedbw = bwFactor * currentBw;
            else adjustedbw = bwUpFactor * currentBw;
            const bitrate = levels[i].maxBitrate;
            const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === undefined);
            $fada8102d2a280be$var$logger.trace(`[abr] level:${i} adjustedbw-bitrate:${Math.round(adjustedbw - bitrate)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)}`);
            // if adjusted bw is greater than level bitrate AND
            if (adjustedbw > bitrate && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
            // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
            // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
            (fetchDuration === 0 || !$fada8102d2a280be$var$isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration)) // as we are looping from highest to lowest, this will return the best achievable quality level
            return i;
        }
        // not enough time budget even with quality level 0 ... rebuffering might happen
        return -1;
    }
    set nextAutoLevel(nextLevel) {
        this._nextAutoLevel = nextLevel;
    }
}
class $fada8102d2a280be$var$ChunkCache {
    constructor(){
        this.chunks = [];
        this.dataLength = 0;
    }
    push(chunk) {
        this.chunks.push(chunk);
        this.dataLength += chunk.length;
    }
    flush() {
        const { chunks: chunks, dataLength: dataLength } = this;
        let result;
        if (!chunks.length) return new Uint8Array(0);
        else if (chunks.length === 1) result = chunks[0];
        else result = $fada8102d2a280be$var$concatUint8Arrays(chunks, dataLength);
        this.reset();
        return result;
    }
    reset() {
        this.chunks.length = 0;
        this.dataLength = 0;
    }
}
function $fada8102d2a280be$var$concatUint8Arrays(chunks, dataLength) {
    const result = new Uint8Array(dataLength);
    let offset = 0;
    for(let i = 0; i < chunks.length; i++){
        const chunk = chunks[i];
        result.set(chunk, offset);
        offset += chunk.length;
    }
    return result;
}
const $fada8102d2a280be$var$TICK_INTERVAL$1 = 100; // how often to tick in ms
class $fada8102d2a280be$var$AudioStreamController extends $fada8102d2a280be$var$BaseStreamController {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, "[audio-stream-controller]", $fada8102d2a280be$var$PlaylistLevelType.AUDIO);
        this.videoBuffer = null;
        this.videoTrackCC = -1;
        this.waitingVideoCC = -1;
        this.bufferedTrack = null;
        this.switchingTrack = null;
        this.trackId = -1;
        this.waitingData = null;
        this.mainDetails = null;
        this.bufferFlushed = false;
        this.cachedTrackLoadedData = null;
        this._registerListeners();
    }
    onHandlerDestroying() {
        this._unregisterListeners();
        this.mainDetails = null;
        this.bufferedTrack = null;
        this.switchingTrack = null;
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($fada8102d2a280be$var$Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
        hls.on($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_RESET, this.onBufferReset, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_CREATED, this.onBufferCreated, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on($fada8102d2a280be$var$Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($fada8102d2a280be$var$Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
        hls.off($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_RESET, this.onBufferReset, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_CREATED, this.onBufferCreated, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off($fada8102d2a280be$var$Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
    onInitPtsFound(event, { frag: frag, id: id, initPTS: initPTS, timescale: timescale }) {
        // Always update the new INIT PTS
        // Can change due level switch
        if (id === "main") {
            const cc = frag.cc;
            this.initPTS[frag.cc] = {
                baseTime: initPTS,
                timescale: timescale
            };
            this.log(`InitPTS for cc: ${cc} found from main: ${initPTS}`);
            this.videoTrackCC = cc;
            // If we are waiting, tick immediately to unblock audio fragment transmuxing
            if (this.state === $fada8102d2a280be$var$State.WAITING_INIT_PTS) this.tick();
        }
    }
    startLoad(startPosition) {
        if (!this.levels) {
            this.startPosition = startPosition;
            this.state = $fada8102d2a280be$var$State.STOPPED;
            return;
        }
        const lastCurrentTime = this.lastCurrentTime;
        this.stopLoad();
        this.setInterval($fada8102d2a280be$var$TICK_INTERVAL$1);
        if (lastCurrentTime > 0 && startPosition === -1) {
            this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
            startPosition = lastCurrentTime;
            this.state = $fada8102d2a280be$var$State.IDLE;
        } else {
            this.loadedmetadata = false;
            this.state = $fada8102d2a280be$var$State.WAITING_TRACK;
        }
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
        this.tick();
    }
    doTick() {
        switch(this.state){
            case $fada8102d2a280be$var$State.IDLE:
                this.doTickIdle();
                break;
            case $fada8102d2a280be$var$State.WAITING_TRACK:
                {
                    var _levels$trackId;
                    const { levels: levels, trackId: trackId } = this;
                    const details = levels == null ? void 0 : (_levels$trackId = levels[trackId]) == null ? void 0 : _levels$trackId.details;
                    if (details) {
                        if (this.waitForCdnTuneIn(details)) break;
                        this.state = $fada8102d2a280be$var$State.WAITING_INIT_PTS;
                    }
                    break;
                }
            case $fada8102d2a280be$var$State.FRAG_LOADING_WAITING_RETRY:
                {
                    var _this$media;
                    const now = performance.now();
                    const retryDate = this.retryDate;
                    // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                    if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
                        this.log("RetryDate reached, switch back to IDLE state");
                        this.resetStartWhenNotLoaded(this.trackId);
                        this.state = $fada8102d2a280be$var$State.IDLE;
                    }
                    break;
                }
            case $fada8102d2a280be$var$State.WAITING_INIT_PTS:
                {
                    // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
                    const waitingData = this.waitingData;
                    if (waitingData) {
                        const { frag: frag, part: part, cache: cache, complete: complete } = waitingData;
                        if (this.initPTS[frag.cc] !== undefined) {
                            this.waitingData = null;
                            this.waitingVideoCC = -1;
                            this.state = $fada8102d2a280be$var$State.FRAG_LOADING;
                            const payload = cache.flush();
                            const data = {
                                frag: frag,
                                part: part,
                                payload: payload,
                                networkDetails: null
                            };
                            this._handleFragmentLoadProgress(data);
                            if (complete) super._handleFragmentLoadComplete(data);
                        } else if (this.videoTrackCC !== this.waitingVideoCC) {
                            // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
                            this.log(`Waiting fragment cc (${frag.cc}) cancelled because video is at cc ${this.videoTrackCC}`);
                            this.clearWaitingFragment();
                        } else {
                            // Drop waiting fragment if an earlier fragment is needed
                            const pos = this.getLoadPosition();
                            const bufferInfo = $fada8102d2a280be$var$BufferHelper.bufferInfo(this.mediaBuffer, pos, this.config.maxBufferHole);
                            const waitingFragmentAtPosition = $fada8102d2a280be$var$fragmentWithinToleranceTest(bufferInfo.end, this.config.maxFragLookUpTolerance, frag);
                            if (waitingFragmentAtPosition < 0) {
                                this.log(`Waiting fragment cc (${frag.cc}) @ ${frag.start} cancelled because another fragment at ${bufferInfo.end} is needed`);
                                this.clearWaitingFragment();
                            }
                        }
                    } else this.state = $fada8102d2a280be$var$State.IDLE;
                }
        }
        this.onTickEnd();
    }
    clearWaitingFragment() {
        const waitingData = this.waitingData;
        if (waitingData) {
            this.fragmentTracker.removeFragment(waitingData.frag);
            this.waitingData = null;
            this.waitingVideoCC = -1;
            this.state = $fada8102d2a280be$var$State.IDLE;
        }
    }
    resetLoadingState() {
        this.clearWaitingFragment();
        super.resetLoadingState();
    }
    onTickEnd() {
        const { media: media } = this;
        if (!(media != null && media.readyState)) // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
        return;
        this.lastCurrentTime = media.currentTime;
    }
    doTickIdle() {
        const { hls: hls, levels: levels, media: media, trackId: trackId } = this;
        const config = hls.config;
        if (!(levels != null && levels[trackId])) return;
        // if video not attached AND
        // start fragment already requested OR start frag prefetch not enabled
        // exit loop
        // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
        if (!media && (this.startFragRequested || !config.startFragPrefetch)) return;
        const levelInfo = levels[trackId];
        const trackDetails = levelInfo.details;
        if (!trackDetails || trackDetails.live && this.levelLastLoaded !== trackId || this.waitForCdnTuneIn(trackDetails)) {
            this.state = $fada8102d2a280be$var$State.WAITING_TRACK;
            return;
        }
        const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
        if (this.bufferFlushed && bufferable) {
            this.bufferFlushed = false;
            this.afterBufferFlushed(bufferable, $fada8102d2a280be$var$ElementaryStreamTypes.AUDIO, $fada8102d2a280be$var$PlaylistLevelType.AUDIO);
        }
        const bufferInfo = this.getFwdBufferInfo(bufferable, $fada8102d2a280be$var$PlaylistLevelType.AUDIO);
        if (bufferInfo === null) return;
        const { bufferedTrack: bufferedTrack, switchingTrack: switchingTrack } = this;
        if (!switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
            hls.trigger($fada8102d2a280be$var$Events.BUFFER_EOS, {
                type: "audio"
            });
            this.state = $fada8102d2a280be$var$State.ENDED;
            return;
        }
        const mainBufferInfo = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
        const bufferLen = bufferInfo.len;
        const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len);
        // if buffer length is less than maxBufLen try to load a new fragment
        if (bufferLen >= maxBufLen && !switchingTrack) return;
        const fragments = trackDetails.fragments;
        const start = fragments[0].start;
        let targetBufferTime = bufferInfo.end;
        if (switchingTrack && media) {
            const pos = this.getLoadPosition();
            if (bufferedTrack && switchingTrack.attrs !== bufferedTrack.attrs) targetBufferTime = pos;
            // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
            if (trackDetails.PTSKnown && pos < start) // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
            {
                if (bufferInfo.end > start || bufferInfo.nextStart) {
                    this.log("Alt audio track ahead of main track, seek to start of alt audio track");
                    media.currentTime = start + 0.05;
                }
            }
        }
        let frag = this.getNextFragment(targetBufferTime, trackDetails);
        let atGap = false;
        // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
        if (frag && this.isLoopLoading(frag, targetBufferTime)) {
            atGap = !!frag.gap;
            frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, $fada8102d2a280be$var$PlaylistLevelType.MAIN, maxBufLen);
        }
        if (!frag) {
            this.bufferFlushed = true;
            return;
        }
        // Buffer audio up to one target duration ahead of main buffer
        const atBufferSyncLimit = mainBufferInfo && frag.start > mainBufferInfo.end + trackDetails.targetduration;
        if (atBufferSyncLimit || // Or wait for main buffer after buffing some audio
        !(mainBufferInfo != null && mainBufferInfo.len) && bufferInfo.len) {
            // Check fragment-tracker for main fragments since GAP segments do not show up in bufferInfo
            const mainFrag = this.getAppendedFrag(frag.start, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
            if (mainFrag === null) return;
            // Bridge gaps in main buffer
            atGap || (atGap = !!mainFrag.gap || !!atBufferSyncLimit && mainBufferInfo.len === 0);
            if (atBufferSyncLimit && !atGap || atGap && bufferInfo.nextStart && bufferInfo.nextStart < mainFrag.end) return;
        }
        this.loadFragment(frag, levelInfo, targetBufferTime);
    }
    getMaxBufferLength(mainBufferLength) {
        const maxConfigBuffer = super.getMaxBufferLength();
        if (!mainBufferLength) return maxConfigBuffer;
        return Math.min(Math.max(maxConfigBuffer, mainBufferLength), this.config.maxMaxBufferLength);
    }
    onMediaDetaching() {
        this.videoBuffer = null;
        super.onMediaDetaching();
    }
    onAudioTracksUpdated(event, { audioTracks: audioTracks }) {
        this.resetTransmuxer();
        this.levels = audioTracks.map((mediaPlaylist)=>new $fada8102d2a280be$var$Level(mediaPlaylist));
    }
    onAudioTrackSwitching(event, data) {
        // if any URL found on new audio track, it is an alternate audio track
        const altAudio = !!data.url;
        this.trackId = data.id;
        const { fragCurrent: fragCurrent } = this;
        if (fragCurrent) {
            fragCurrent.abortRequests();
            this.removeUnbufferedFrags(fragCurrent.start);
        }
        this.resetLoadingState();
        // destroy useless transmuxer when switching audio to main
        if (!altAudio) this.resetTransmuxer();
        else // switching to audio track, start timer if not already started
        this.setInterval($fada8102d2a280be$var$TICK_INTERVAL$1);
        // should we switch tracks ?
        if (altAudio) {
            this.switchingTrack = data;
            // main audio track are handled by stream-controller, just do something if switching to alt audio track
            this.state = $fada8102d2a280be$var$State.IDLE;
        } else {
            this.switchingTrack = null;
            this.bufferedTrack = data;
            this.state = $fada8102d2a280be$var$State.STOPPED;
        }
        this.tick();
    }
    onManifestLoading() {
        this.fragmentTracker.removeAllFragments();
        this.startPosition = this.lastCurrentTime = 0;
        this.bufferFlushed = false;
        this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null;
        this.startFragRequested = false;
        this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
    }
    onLevelLoaded(event, data) {
        this.mainDetails = data.details;
        if (this.cachedTrackLoadedData !== null) {
            this.hls.trigger($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData);
            this.cachedTrackLoadedData = null;
        }
    }
    onAudioTrackLoaded(event, data) {
        var _track$details;
        if (this.mainDetails == null) {
            this.cachedTrackLoadedData = data;
            return;
        }
        const { levels: levels } = this;
        const { details: newDetails, id: trackId } = data;
        if (!levels) {
            this.warn(`Audio tracks were reset while loading level ${trackId}`);
            return;
        }
        this.log(`Track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ""},duration:${newDetails.totalduration}`);
        const track = levels[trackId];
        let sliding = 0;
        if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
            const mainDetails = this.mainDetails;
            if (!newDetails.fragments[0]) newDetails.deltaUpdateFailed = true;
            if (newDetails.deltaUpdateFailed || !mainDetails) return;
            if (!track.details && newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
                // Make sure our audio rendition is aligned with the "main" rendition, using
                // pdt as our reference times.
                $fada8102d2a280be$var$alignMediaPlaylistByPDT(newDetails, mainDetails);
                sliding = newDetails.fragments[0].start;
            } else sliding = this.alignPlaylists(newDetails, track.details);
        }
        track.details = newDetails;
        this.levelLastLoaded = trackId;
        // compute start position if we are aligned with the main playlist
        if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) this.setStartPosition(track.details, sliding);
        // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
        if (this.state === $fada8102d2a280be$var$State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) this.state = $fada8102d2a280be$var$State.IDLE;
        // trigger handler right now
        this.tick();
    }
    _handleFragmentLoadProgress(data) {
        var _frag$initSegment;
        const { frag: frag, part: part, payload: payload } = data;
        const { config: config, trackId: trackId, levels: levels } = this;
        if (!levels) {
            this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
            return;
        }
        const track = levels[trackId];
        if (!track) {
            this.warn("Audio track is undefined on fragment load progress");
            return;
        }
        const details = track.details;
        if (!details) {
            this.warn("Audio track details undefined on fragment load progress");
            this.removeUnbufferedFrags(frag.start);
            return;
        }
        const audioCodec = config.defaultAudioCodec || track.audioCodec || "mp4a.40.2";
        let transmuxer = this.transmuxer;
        if (!transmuxer) transmuxer = this.transmuxer = new $fada8102d2a280be$var$TransmuxerInterface(this.hls, $fada8102d2a280be$var$PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
        // Check if we have video initPTS
        // If not we need to wait for it
        const initPTS = this.initPTS[frag.cc];
        const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
        if (initPTS !== undefined) {
            // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
            // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
            const accurateTimeOffset = false; // details.PTSKnown || !details.live;
            const partIndex = part ? part.index : -1;
            const partial = partIndex !== -1;
            const chunkMeta = new $fada8102d2a280be$var$ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
            transmuxer.push(payload, initSegmentData, audioCodec, "", frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
        } else {
            this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
            const { cache: cache } = this.waitingData = this.waitingData || {
                frag: frag,
                part: part,
                cache: new $fada8102d2a280be$var$ChunkCache(),
                complete: false
            };
            cache.push(new Uint8Array(payload));
            this.waitingVideoCC = this.videoTrackCC;
            this.state = $fada8102d2a280be$var$State.WAITING_INIT_PTS;
        }
    }
    _handleFragmentLoadComplete(fragLoadedData) {
        if (this.waitingData) {
            this.waitingData.complete = true;
            return;
        }
        super._handleFragmentLoadComplete(fragLoadedData);
    }
    onBufferReset() {
        // reset reference to sourcebuffers
        this.mediaBuffer = this.videoBuffer = null;
        this.loadedmetadata = false;
    }
    onBufferCreated(event, data) {
        const audioTrack = data.tracks.audio;
        if (audioTrack) this.mediaBuffer = audioTrack.buffer || null;
        if (data.tracks.video) this.videoBuffer = data.tracks.video.buffer || null;
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        if (frag.type !== $fada8102d2a280be$var$PlaylistLevelType.AUDIO) {
            if (!this.loadedmetadata && frag.type === $fada8102d2a280be$var$PlaylistLevelType.MAIN) {
                const bufferable = this.videoBuffer || this.media;
                if (bufferable) {
                    const bufferedTimeRanges = $fada8102d2a280be$var$BufferHelper.getBuffered(bufferable);
                    if (bufferedTimeRanges.length) this.loadedmetadata = true;
                }
            }
            return;
        }
        if (this.fragContextChanged(frag)) {
            // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
            // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
            this.warn(`Fragment ${frag.sn}${part ? " p: " + part.index : ""} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
            return;
        }
        if (frag.sn !== "initSegment") {
            this.fragPrevious = frag;
            const track = this.switchingTrack;
            if (track) {
                this.bufferedTrack = track;
                this.switchingTrack = null;
                this.hls.trigger($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHED, $fada8102d2a280be$var$_objectSpread2({}, track));
            }
        }
        this.fragBufferedComplete(frag, part);
    }
    onError(event, data) {
        var _data$context;
        if (data.fatal) {
            this.state = $fada8102d2a280be$var$State.ERROR;
            return;
        }
        switch(data.details){
            case $fada8102d2a280be$var$ErrorDetails.FRAG_GAP:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_PARSING_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_DECRYPT_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.FRAG_LOAD_TIMEOUT:
            case $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError($fada8102d2a280be$var$PlaylistLevelType.AUDIO, data);
                break;
            case $fada8102d2a280be$var$ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
            case $fada8102d2a280be$var$ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
            case $fada8102d2a280be$var$ErrorDetails.LEVEL_PARSING_ERROR:
                // in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
                if (!data.levelRetry && this.state === $fada8102d2a280be$var$State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK) this.state = $fada8102d2a280be$var$State.IDLE;
                break;
            case $fada8102d2a280be$var$ErrorDetails.BUFFER_FULL_ERROR:
                if (!data.parent || data.parent !== "audio") return;
                if (this.reduceLengthAndFlushBuffer(data)) {
                    this.bufferedTrack = null;
                    super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio");
                }
                break;
            case $fada8102d2a280be$var$ErrorDetails.INTERNAL_EXCEPTION:
                this.recoverWorkerError(data);
                break;
        }
    }
    onBufferFlushed(event, { type: type }) {
        if (type === $fada8102d2a280be$var$ElementaryStreamTypes.AUDIO) {
            this.bufferFlushed = true;
            if (this.state === $fada8102d2a280be$var$State.ENDED) this.state = $fada8102d2a280be$var$State.IDLE;
        }
    }
    _handleTransmuxComplete(transmuxResult) {
        var _id3$samples;
        const id = "audio";
        const { hls: hls } = this;
        const { remuxResult: remuxResult, chunkMeta: chunkMeta } = transmuxResult;
        const context = this.getCurrentContext(chunkMeta);
        if (!context) {
            this.resetWhenMissingContext(chunkMeta);
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const { details: details } = level;
        const { audio: audio, text: text, id3: id3, initSegment: initSegment } = remuxResult;
        // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
        // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
        if (this.fragContextChanged(frag) || !details) {
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        this.state = $fada8102d2a280be$var$State.PARSING;
        if (this.switchingTrack && audio) this.completeAudioSwitch(this.switchingTrack);
        if (initSegment != null && initSegment.tracks) {
            const mapFragment = frag.initSegment || frag;
            this._bufferInitSegment(initSegment.tracks, mapFragment, chunkMeta);
            hls.trigger($fada8102d2a280be$var$Events.FRAG_PARSING_INIT_SEGMENT, {
                frag: mapFragment,
                id: id,
                tracks: initSegment.tracks
            });
        // Only flush audio from old audio tracks when PTS is known on new audio track
        }
        if (audio) {
            const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = audio;
            if (part) part.elementaryStreams[$fada8102d2a280be$var$ElementaryStreamTypes.AUDIO] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS
            };
            frag.setElementaryStreamInfo($fada8102d2a280be$var$ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
            this.bufferFragmentData(audio, frag, part, chunkMeta);
        }
        if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
            const emittedID3 = $fada8102d2a280be$var$_extends({
                id: id,
                frag: frag,
                details: details
            }, id3);
            hls.trigger($fada8102d2a280be$var$Events.FRAG_PARSING_METADATA, emittedID3);
        }
        if (text) {
            const emittedText = $fada8102d2a280be$var$_extends({
                id: id,
                frag: frag,
                details: details
            }, text);
            hls.trigger($fada8102d2a280be$var$Events.FRAG_PARSING_USERDATA, emittedText);
        }
    }
    _bufferInitSegment(tracks, frag, chunkMeta) {
        if (this.state !== $fada8102d2a280be$var$State.PARSING) return;
        // delete any video track found on audio transmuxer
        if (tracks.video) delete tracks.video;
        // include levelCodec in audio and video tracks
        const track = tracks.audio;
        if (!track) return;
        track.levelCodec = track.codec;
        track.id = "audio";
        this.log(`Init audio buffer, container:${track.container}, codecs[parsed]=[${track.codec}]`);
        this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_CODECS, tracks);
        const initSegment = track.initSegment;
        if (initSegment != null && initSegment.byteLength) {
            const segment = {
                type: "audio",
                frag: frag,
                part: null,
                chunkMeta: chunkMeta,
                parent: frag.type,
                data: initSegment
            };
            this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_APPENDING, segment);
        }
        // trigger handler right now
        this.tick();
    }
    loadFragment(frag, track, targetBufferTime) {
        // only load if fragment is not loaded or if in audio switch
        const fragState = this.fragmentTracker.getState(frag);
        this.fragCurrent = frag;
        // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
        if (this.switchingTrack || fragState === $fada8102d2a280be$var$FragmentState.NOT_LOADED || fragState === $fada8102d2a280be$var$FragmentState.PARTIAL) {
            var _track$details2;
            if (frag.sn === "initSegment") this._loadInitSegment(frag, track);
            else if ((_track$details2 = track.details) != null && _track$details2.live && !this.initPTS[frag.cc]) {
                this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
                this.state = $fada8102d2a280be$var$State.WAITING_INIT_PTS;
            } else {
                this.startFragRequested = true;
                super.loadFragment(frag, track, targetBufferTime);
            }
        } else this.clearTrackerIfNeeded(frag);
    }
    completeAudioSwitch(switchingTrack) {
        const { hls: hls, media: media, bufferedTrack: bufferedTrack } = this;
        const bufferedAttributes = bufferedTrack == null ? void 0 : bufferedTrack.attrs;
        const switchAttributes = switchingTrack.attrs;
        if (media && bufferedAttributes && (bufferedAttributes.CHANNELS !== switchAttributes.CHANNELS || bufferedAttributes.NAME !== switchAttributes.NAME || bufferedAttributes.LANGUAGE !== switchAttributes.LANGUAGE)) {
            this.log("Switching audio track : flushing all audio");
            super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio");
        }
        this.bufferedTrack = switchingTrack;
        this.switchingTrack = null;
        hls.trigger($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHED, $fada8102d2a280be$var$_objectSpread2({}, switchingTrack));
    }
}
class $fada8102d2a280be$var$AudioTrackController extends $fada8102d2a280be$var$BasePlaylistController {
    constructor(hls){
        super(hls, "[audio-track-controller]");
        this.tracks = [];
        this.groupId = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
        this.registerListeners();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    destroy() {
        this.unregisterListeners();
        this.tracks.length = 0;
        this.tracksInGroup.length = 0;
        this.currentTrack = null;
        super.destroy();
    }
    onManifestLoading() {
        this.tracks = [];
        this.groupId = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
    }
    onManifestParsed(event, data) {
        this.tracks = data.audioTracks || [];
    }
    onAudioTrackLoaded(event, data) {
        const { id: id, groupId: groupId, details: details } = data;
        const trackInActiveGroup = this.tracksInGroup[id];
        if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
            this.warn(`Track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup.groupId}`);
            return;
        }
        const curDetails = trackInActiveGroup.details;
        trackInActiveGroup.details = data.details;
        this.log(`audio-track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
        if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
    }
    onLevelLoading(event, data) {
        this.switchLevel(data.level);
    }
    onLevelSwitching(event, data) {
        this.switchLevel(data.level);
    }
    switchLevel(levelIndex) {
        const levelInfo = this.hls.levels[levelIndex];
        if (!(levelInfo != null && levelInfo.audioGroupIds)) return;
        const audioGroupId = levelInfo.audioGroupIds[levelInfo.urlId];
        if (this.groupId !== audioGroupId) {
            this.groupId = audioGroupId || null;
            const audioTracks = this.tracks.filter((track)=>!audioGroupId || track.groupId === audioGroupId);
            // Disable selectDefaultTrack if there are no default tracks
            if (this.selectDefaultTrack && !audioTracks.some((track)=>track.default)) this.selectDefaultTrack = false;
            this.tracksInGroup = audioTracks;
            const audioTracksUpdated = {
                audioTracks: audioTracks
            };
            this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group:${audioGroupId}`);
            this.hls.trigger($fada8102d2a280be$var$Events.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
            this.selectInitialTrack();
        } else if (this.shouldReloadPlaylist(this.currentTrack)) // Retry playlist loading if no playlist is or has been loaded yet
        this.setAudioTrack(this.trackId);
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $fada8102d2a280be$var$PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && data.context.groupId === this.groupId) {
            this.requestScheduled = -1;
            this.checkRetry(data);
        }
    }
    get audioTracks() {
        return this.tracksInGroup;
    }
    get audioTrack() {
        return this.trackId;
    }
    set audioTrack(newId) {
        // If audio track is selected from API then don't choose from the manifest default track
        this.selectDefaultTrack = false;
        this.setAudioTrack(newId);
    }
    setAudioTrack(newId) {
        const tracks = this.tracksInGroup;
        // check if level idx is valid
        if (newId < 0 || newId >= tracks.length) {
            this.warn("Invalid id passed to audio-track controller");
            return;
        }
        // stopping live reloading timer if any
        this.clearTimer();
        const lastTrack = this.currentTrack;
        tracks[this.trackId];
        const track = tracks[newId];
        const { groupId: groupId, name: name } = track;
        this.log(`Switching to audio-track ${newId} "${name}" lang:${track.lang} group:${groupId}`);
        this.trackId = newId;
        this.currentTrack = track;
        this.selectDefaultTrack = false;
        this.hls.trigger($fada8102d2a280be$var$Events.AUDIO_TRACK_SWITCHING, $fada8102d2a280be$var$_objectSpread2({}, track));
        // Do not reload track unless live
        if (track.details && !track.details.live) return;
        const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details);
        this.loadPlaylist(hlsUrlParameters);
    }
    selectInitialTrack() {
        const audioTracks = this.tracksInGroup;
        const trackId = this.findTrackId(this.currentTrack) | this.findTrackId(null);
        if (trackId !== -1) this.setAudioTrack(trackId);
        else {
            const error = new Error(`No track found for running audio group-ID: ${this.groupId} track count: ${audioTracks.length}`);
            this.warn(error.message);
            this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                fatal: true,
                error: error
            });
        }
    }
    findTrackId(currentTrack) {
        const audioTracks = this.tracksInGroup;
        for(let i = 0; i < audioTracks.length; i++){
            const track = audioTracks[i];
            if (!this.selectDefaultTrack || track.default) {
                if (!currentTrack || currentTrack.attrs["STABLE-RENDITION-ID"] !== undefined && currentTrack.attrs["STABLE-RENDITION-ID"] === track.attrs["STABLE-RENDITION-ID"]) return track.id;
                if (currentTrack.name === track.name && currentTrack.lang === track.lang) return track.id;
            }
        }
        return -1;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        const audioTrack = this.tracksInGroup[this.trackId];
        if (this.shouldLoadPlaylist(audioTrack)) {
            const id = audioTrack.id;
            const groupId = audioTrack.groupId;
            let url = audioTrack.url;
            if (hlsUrlParameters) try {
                url = hlsUrlParameters.addDirectives(url);
            } catch (error) {
                this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
            }
            // track not retrieved yet, or live playlist we need to (re)load it
            this.log(`loading audio-track playlist ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}`);
            this.clearTimer();
            this.hls.trigger($fada8102d2a280be$var$Events.AUDIO_TRACK_LOADING, {
                url: url,
                id: id,
                groupId: groupId,
                deliveryDirectives: hlsUrlParameters || null
            });
        }
    }
}
function $fada8102d2a280be$var$subtitleOptionsIdentical(trackList1, trackList2) {
    if (trackList1.length !== trackList2.length) return false;
    for(let i = 0; i < trackList1.length; i++){
        if (!$fada8102d2a280be$var$subtitleAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) return false;
    }
    return true;
}
function $fada8102d2a280be$var$subtitleAttributesIdentical(attrs1, attrs2) {
    // Media options with the same rendition ID must be bit identical
    const stableRenditionId = attrs1["STABLE-RENDITION-ID"];
    if (stableRenditionId) return stableRenditionId === attrs2["STABLE-RENDITION-ID"];
    // When rendition ID is not present, compare attributes
    return ![
        "LANGUAGE",
        "NAME",
        "CHARACTERISTICS",
        "AUTOSELECT",
        "DEFAULT",
        "FORCED"
    ].some((subtitleAttribute)=>attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}
const $fada8102d2a280be$var$TICK_INTERVAL = 500; // how often to tick in ms
class $fada8102d2a280be$var$SubtitleStreamController extends $fada8102d2a280be$var$BaseStreamController {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, "[subtitle-stream-controller]", $fada8102d2a280be$var$PlaylistLevelType.SUBTITLE);
        this.levels = [];
        this.currentTrackId = -1;
        this.tracksBuffered = [];
        this.mainDetails = null;
        this._registerListeners();
    }
    onHandlerDestroying() {
        this._unregisterListeners();
        this.mainDetails = null;
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
        hls.on($fada8102d2a280be$var$Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.on($fada8102d2a280be$var$Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.on($fada8102d2a280be$var$Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.on($fada8102d2a280be$var$Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
        hls.off($fada8102d2a280be$var$Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.off($fada8102d2a280be$var$Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.off($fada8102d2a280be$var$Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.off($fada8102d2a280be$var$Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    startLoad(startPosition) {
        this.stopLoad();
        this.state = $fada8102d2a280be$var$State.IDLE;
        this.setInterval($fada8102d2a280be$var$TICK_INTERVAL);
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
        this.tick();
    }
    onManifestLoading() {
        this.mainDetails = null;
        this.fragmentTracker.removeAllFragments();
    }
    onMediaDetaching() {
        this.tracksBuffered = [];
        super.onMediaDetaching();
    }
    onLevelLoaded(event, data) {
        this.mainDetails = data.details;
    }
    onSubtitleFragProcessed(event, data) {
        const { frag: frag, success: success } = data;
        this.fragPrevious = frag;
        this.state = $fada8102d2a280be$var$State.IDLE;
        if (!success) return;
        const buffered = this.tracksBuffered[this.currentTrackId];
        if (!buffered) return;
        // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
        // so we can re-use the logic used to detect how much has been buffered
        let timeRange;
        const fragStart = frag.start;
        for(let i = 0; i < buffered.length; i++)if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
            timeRange = buffered[i];
            break;
        }
        const fragEnd = frag.start + frag.duration;
        if (timeRange) timeRange.end = fragEnd;
        else {
            timeRange = {
                start: fragStart,
                end: fragEnd
            };
            buffered.push(timeRange);
        }
        this.fragmentTracker.fragBuffered(frag);
    }
    onBufferFlushing(event, data) {
        const { startOffset: startOffset, endOffset: endOffset } = data;
        if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
            const { currentTrackId: currentTrackId, levels: levels } = this;
            if (!levels.length || !levels[currentTrackId] || !levels[currentTrackId].details) return;
            const trackDetails = levels[currentTrackId].details;
            const targetDuration = trackDetails.targetduration;
            const endOffsetSubtitles = endOffset - targetDuration;
            if (endOffsetSubtitles <= 0) return;
            data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
            this.tracksBuffered.forEach((buffered)=>{
                for(let i = 0; i < buffered.length;){
                    if (buffered[i].end <= endOffsetSubtitles) {
                        buffered.shift();
                        continue;
                    } else if (buffered[i].start < endOffsetSubtitles) buffered[i].start = endOffsetSubtitles;
                    else break;
                    i++;
                }
            });
            this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, $fada8102d2a280be$var$PlaylistLevelType.SUBTITLE);
        }
    }
    onFragBuffered(event, data) {
        if (!this.loadedmetadata && data.frag.type === $fada8102d2a280be$var$PlaylistLevelType.MAIN) {
            var _this$media;
            if ((_this$media = this.media) != null && _this$media.buffered.length) this.loadedmetadata = true;
        }
    }
    // If something goes wrong, proceed to next frag, if we were processing one.
    onError(event, data) {
        const frag = data.frag;
        if ((frag == null ? void 0 : frag.type) === $fada8102d2a280be$var$PlaylistLevelType.SUBTITLE) {
            if (this.fragCurrent) this.fragCurrent.abortRequests();
            if (this.state !== $fada8102d2a280be$var$State.STOPPED) this.state = $fada8102d2a280be$var$State.IDLE;
        }
    }
    // Got all new subtitle levels.
    onSubtitleTracksUpdated(event, { subtitleTracks: subtitleTracks }) {
        if ($fada8102d2a280be$var$subtitleOptionsIdentical(this.levels, subtitleTracks)) {
            this.levels = subtitleTracks.map((mediaPlaylist)=>new $fada8102d2a280be$var$Level(mediaPlaylist));
            return;
        }
        this.tracksBuffered = [];
        this.levels = subtitleTracks.map((mediaPlaylist)=>{
            const level = new $fada8102d2a280be$var$Level(mediaPlaylist);
            this.tracksBuffered[level.id] = [];
            return level;
        });
        this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, $fada8102d2a280be$var$PlaylistLevelType.SUBTITLE);
        this.fragPrevious = null;
        this.mediaBuffer = null;
    }
    onSubtitleTrackSwitch(event, data) {
        this.currentTrackId = data.id;
        if (!this.levels.length || this.currentTrackId === -1) {
            this.clearInterval();
            return;
        }
        // Check if track has the necessary details to load fragments
        const currentTrack = this.levels[this.currentTrackId];
        if (currentTrack != null && currentTrack.details) this.mediaBuffer = this.mediaBufferTimeRanges;
        else this.mediaBuffer = null;
        if (currentTrack) this.setInterval($fada8102d2a280be$var$TICK_INTERVAL);
    }
    // Got a new set of subtitle fragments.
    onSubtitleTrackLoaded(event, data) {
        var _track$details;
        const { details: newDetails, id: trackId } = data;
        const { currentTrackId: currentTrackId, levels: levels } = this;
        if (!levels.length) return;
        const track = levels[currentTrackId];
        if (trackId >= levels.length || trackId !== currentTrackId || !track) return;
        this.mediaBuffer = this.mediaBufferTimeRanges;
        let sliding = 0;
        if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
            const mainDetails = this.mainDetails;
            if (newDetails.deltaUpdateFailed || !mainDetails) return;
            const mainSlidingStartFragment = mainDetails.fragments[0];
            if (!track.details) {
                if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
                    $fada8102d2a280be$var$alignMediaPlaylistByPDT(newDetails, mainDetails);
                    sliding = newDetails.fragments[0].start;
                } else if (mainSlidingStartFragment) {
                    // line up live playlist with main so that fragments in range are loaded
                    sliding = mainSlidingStartFragment.start;
                    $fada8102d2a280be$var$addSliding(newDetails, sliding);
                }
            } else {
                sliding = this.alignPlaylists(newDetails, track.details);
                if (sliding === 0 && mainSlidingStartFragment) {
                    // realign with main when there is no overlap with last refresh
                    sliding = mainSlidingStartFragment.start;
                    $fada8102d2a280be$var$addSliding(newDetails, sliding);
                }
            }
        }
        track.details = newDetails;
        this.levelLastLoaded = trackId;
        if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) this.setStartPosition(track.details, sliding);
        // trigger handler right now
        this.tick();
        // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
        if (newDetails.live && !this.fragCurrent && this.media && this.state === $fada8102d2a280be$var$State.IDLE) {
            const foundFrag = $fada8102d2a280be$var$findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0);
            if (!foundFrag) {
                this.warn("Subtitle playlist not aligned with playback");
                track.details = undefined;
            }
        }
    }
    _handleFragmentLoadComplete(fragLoadedData) {
        const { frag: frag, payload: payload } = fragLoadedData;
        const decryptData = frag.decryptdata;
        const hls = this.hls;
        if (this.fragContextChanged(frag)) return;
        // check to see if the payload needs to be decrypted
        if (payload && payload.byteLength > 0 && decryptData && decryptData.key && decryptData.iv && decryptData.method === "AES-128") {
            const startTime = performance.now();
            // decrypt the subtitles
            this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch((err)=>{
                hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                    type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                    details: $fada8102d2a280be$var$ErrorDetails.FRAG_DECRYPT_ERROR,
                    fatal: false,
                    error: err,
                    reason: err.message,
                    frag: frag
                });
                throw err;
            }).then((decryptedData)=>{
                const endTime = performance.now();
                hls.trigger($fada8102d2a280be$var$Events.FRAG_DECRYPTED, {
                    frag: frag,
                    payload: decryptedData,
                    stats: {
                        tstart: startTime,
                        tdecrypt: endTime
                    }
                });
            }).catch((err)=>{
                this.warn(`${err.name}: ${err.message}`);
                this.state = $fada8102d2a280be$var$State.IDLE;
            });
        }
    }
    doTick() {
        if (!this.media) {
            this.state = $fada8102d2a280be$var$State.IDLE;
            return;
        }
        if (this.state === $fada8102d2a280be$var$State.IDLE) {
            const { currentTrackId: currentTrackId, levels: levels } = this;
            const track = levels[currentTrackId];
            if (!levels.length || !track || !track.details) return;
            // Expand range of subs loaded by one target-duration in either direction to make up for misaligned playlists
            const trackDetails = track.details;
            const targetDuration = trackDetails.targetduration;
            const { config: config } = this;
            const currentTime = this.getLoadPosition();
            const bufferedInfo = $fada8102d2a280be$var$BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime - targetDuration, config.maxBufferHole);
            const { end: targetBufferTime, len: bufferLen } = bufferedInfo;
            const mainBufferInfo = this.getFwdBufferInfo(this.media, $fada8102d2a280be$var$PlaylistLevelType.MAIN);
            const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len) + targetDuration;
            if (bufferLen > maxBufLen) return;
            const fragments = trackDetails.fragments;
            const fragLen = fragments.length;
            const end = trackDetails.edge;
            let foundFrag = null;
            const fragPrevious = this.fragPrevious;
            if (targetBufferTime < end) {
                const { maxFragLookUpTolerance: maxFragLookUpTolerance } = config;
                foundFrag = $fada8102d2a280be$var$findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), maxFragLookUpTolerance);
                if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) foundFrag = fragments[0];
            } else foundFrag = fragments[fragLen - 1];
            if (!foundFrag) return;
            foundFrag = this.mapToInitFragWhenRequired(foundFrag);
            if (this.fragmentTracker.getState(foundFrag) === $fada8102d2a280be$var$FragmentState.NOT_LOADED) // only load if fragment is not loaded
            this.loadFragment(foundFrag, track, targetBufferTime);
        }
    }
    getMaxBufferLength(mainBufferLength) {
        const maxConfigBuffer = super.getMaxBufferLength();
        if (!mainBufferLength) return maxConfigBuffer;
        return Math.max(maxConfigBuffer, mainBufferLength);
    }
    loadFragment(frag, level, targetBufferTime) {
        this.fragCurrent = frag;
        if (frag.sn === "initSegment") this._loadInitSegment(frag, level);
        else {
            this.startFragRequested = true;
            super.loadFragment(frag, level, targetBufferTime);
        }
    }
    get mediaBufferTimeRanges() {
        return new $fada8102d2a280be$var$BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
    }
}
class $fada8102d2a280be$var$BufferableInstance {
    constructor(timeranges){
        this.buffered = void 0;
        const getRange = (name, index, length)=>{
            index = index >>> 0;
            if (index > length - 1) throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
            return timeranges[index][name];
        };
        this.buffered = {
            get length () {
                return timeranges.length;
            },
            end (index) {
                return getRange("end", index, timeranges.length);
            },
            start (index) {
                return getRange("start", index, timeranges.length);
            }
        };
    }
}
class $fada8102d2a280be$var$SubtitleTrackController extends $fada8102d2a280be$var$BasePlaylistController {
    constructor(hls){
        super(hls, "[subtitle-track-controller]");
        this.media = null;
        this.tracks = [];
        this.groupId = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.selectDefaultTrack = true;
        this.queuedDefaultTrack = -1;
        this.trackChangeListener = ()=>this.onTextTracksChanged();
        this.asyncPollTrackChange = ()=>this.pollTrackChange(0);
        this.useTextTrackPolling = false;
        this.subtitlePollingInterval = -1;
        this._subtitleDisplay = true;
        this.registerListeners();
    }
    destroy() {
        this.unregisterListeners();
        this.tracks.length = 0;
        this.tracksInGroup.length = 0;
        this.trackChangeListener = this.asyncPollTrackChange = null;
        super.destroy();
    }
    get subtitleDisplay() {
        return this._subtitleDisplay;
    }
    set subtitleDisplay(value) {
        this._subtitleDisplay = value;
        if (this.trackId > -1) this.toggleTrackModes(this.trackId);
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($fada8102d2a280be$var$Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($fada8102d2a280be$var$Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    // Listen for subtitle track change, then extract the current track ID.
    onMediaAttached(event, data) {
        this.media = data.media;
        if (!this.media) return;
        if (this.queuedDefaultTrack > -1) {
            this.subtitleTrack = this.queuedDefaultTrack;
            this.queuedDefaultTrack = -1;
        }
        this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks);
        if (this.useTextTrackPolling) this.pollTrackChange(500);
        else this.media.textTracks.addEventListener("change", this.asyncPollTrackChange);
    }
    pollTrackChange(timeout) {
        self.clearInterval(this.subtitlePollingInterval);
        this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, timeout);
    }
    onMediaDetaching() {
        if (!this.media) return;
        self.clearInterval(this.subtitlePollingInterval);
        if (!this.useTextTrackPolling) this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange);
        if (this.trackId > -1) this.queuedDefaultTrack = this.trackId;
        const textTracks = $fada8102d2a280be$var$filterSubtitleTracks(this.media.textTracks);
        // Clear loaded cues on media detachment from tracks
        textTracks.forEach((track)=>{
            $fada8102d2a280be$var$clearCurrentCues(track);
        });
        // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
        this.subtitleTrack = -1;
        this.media = null;
    }
    onManifestLoading() {
        this.tracks = [];
        this.groupId = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.selectDefaultTrack = true;
    }
    // Fired whenever a new manifest is loaded.
    onManifestParsed(event, data) {
        this.tracks = data.subtitleTracks;
    }
    onSubtitleTrackLoaded(event, data) {
        const { id: id, details: details } = data;
        const { trackId: trackId } = this;
        const currentTrack = this.tracksInGroup[trackId];
        if (!currentTrack) {
            this.warn(`Invalid subtitle track id ${id}`);
            return;
        }
        const curDetails = currentTrack.details;
        currentTrack.details = data.details;
        this.log(`subtitle track ${id} loaded [${details.startSN}-${details.endSN}]`);
        if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
    }
    onLevelLoading(event, data) {
        this.switchLevel(data.level);
    }
    onLevelSwitching(event, data) {
        this.switchLevel(data.level);
    }
    switchLevel(levelIndex) {
        const levelInfo = this.hls.levels[levelIndex];
        if (!(levelInfo != null && levelInfo.textGroupIds)) return;
        const textGroupId = levelInfo.textGroupIds[levelInfo.urlId];
        const lastTrack = this.tracksInGroup ? this.tracksInGroup[this.trackId] : undefined;
        if (this.groupId !== textGroupId) {
            const subtitleTracks = this.tracks.filter((track)=>!textGroupId || track.groupId === textGroupId);
            this.tracksInGroup = subtitleTracks;
            const initialTrackId = this.findTrackId(lastTrack == null ? void 0 : lastTrack.name) || this.findTrackId();
            this.groupId = textGroupId || null;
            const subtitleTracksUpdated = {
                subtitleTracks: subtitleTracks
            };
            this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${textGroupId}" group-id`);
            this.hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
            if (initialTrackId !== -1) this.setSubtitleTrack(initialTrackId, lastTrack);
        } else if (this.shouldReloadPlaylist(lastTrack)) // Retry playlist loading if no playlist is or has been loaded yet
        this.setSubtitleTrack(this.trackId, lastTrack);
    }
    findTrackId(name) {
        const textTracks = this.tracksInGroup;
        for(let i = 0; i < textTracks.length; i++){
            const track = textTracks[i];
            if (!this.selectDefaultTrack || track.default) {
                if (!name || name === track.name) return track.id;
            }
        }
        return -1;
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $fada8102d2a280be$var$PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && data.context.groupId === this.groupId) this.checkRetry(data);
    }
    /** get alternate subtitle tracks list from playlist **/ get subtitleTracks() {
        return this.tracksInGroup;
    }
    /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/ get subtitleTrack() {
        return this.trackId;
    }
    set subtitleTrack(newId) {
        this.selectDefaultTrack = false;
        const lastTrack = this.tracksInGroup ? this.tracksInGroup[this.trackId] : undefined;
        this.setSubtitleTrack(newId, lastTrack);
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        const currentTrack = this.tracksInGroup[this.trackId];
        if (this.shouldLoadPlaylist(currentTrack)) {
            const id = currentTrack.id;
            const groupId = currentTrack.groupId;
            let url = currentTrack.url;
            if (hlsUrlParameters) try {
                url = hlsUrlParameters.addDirectives(url);
            } catch (error) {
                this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
            }
            this.log(`Loading subtitle playlist for id ${id}`);
            this.hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_TRACK_LOADING, {
                url: url,
                id: id,
                groupId: groupId,
                deliveryDirectives: hlsUrlParameters || null
            });
        }
    }
    /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */ toggleTrackModes(newId) {
        const { media: media, trackId: trackId } = this;
        if (!media) return;
        const textTracks = $fada8102d2a280be$var$filterSubtitleTracks(media.textTracks);
        const groupTracks = textTracks.filter((track)=>track.groupId === this.groupId);
        if (newId === -1) [].slice.call(textTracks).forEach((track)=>{
            track.mode = "disabled";
        });
        else {
            const oldTrack = groupTracks[trackId];
            if (oldTrack) oldTrack.mode = "disabled";
        }
        const nextTrack = groupTracks[newId];
        if (nextTrack) nextTrack.mode = this.subtitleDisplay ? "showing" : "hidden";
    }
    /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */ setSubtitleTrack(newId, lastTrack) {
        var _tracks$newId;
        const tracks = this.tracksInGroup;
        // setting this.subtitleTrack will trigger internal logic
        // if media has not been attached yet, it will fail
        // we keep a reference to the default track id
        // and we'll set subtitleTrack when onMediaAttached is triggered
        if (!this.media) {
            this.queuedDefaultTrack = newId;
            return;
        }
        if (this.trackId !== newId) this.toggleTrackModes(newId);
        // exit if track id as already set or invalid
        if (this.trackId === newId && (newId === -1 || (_tracks$newId = tracks[newId]) != null && _tracks$newId.details) || newId < -1 || newId >= tracks.length) return;
        // stopping live reloading timer if any
        this.clearTimer();
        const track = tracks[newId];
        this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ""));
        this.trackId = newId;
        if (track) {
            const { id: id, groupId: groupId = "", name: name, type: type, url: url } = track;
            this.hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_TRACK_SWITCH, {
                id: id,
                groupId: groupId,
                name: name,
                type: type,
                url: url
            });
            const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details);
            this.loadPlaylist(hlsUrlParameters);
        } else // switch to -1
        this.hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_TRACK_SWITCH, {
            id: newId
        });
    }
    onTextTracksChanged() {
        if (!this.useTextTrackPolling) self.clearInterval(this.subtitlePollingInterval);
        // Media is undefined when switching streams via loadSource()
        if (!this.media || !this.hls.config.renderTextTracksNatively) return;
        let trackId = -1;
        const tracks = $fada8102d2a280be$var$filterSubtitleTracks(this.media.textTracks);
        for(let id = 0; id < tracks.length; id++){
            if (tracks[id].mode === "hidden") // Do not break in case there is a following track with showing.
            trackId = id;
            else if (tracks[id].mode === "showing") {
                trackId = id;
                break;
            }
        }
        // Setting current subtitleTrack will invoke code.
        if (this.subtitleTrack !== trackId) this.subtitleTrack = trackId;
    }
}
function $fada8102d2a280be$var$filterSubtitleTracks(textTrackList) {
    const tracks = [];
    for(let i = 0; i < textTrackList.length; i++){
        const track = textTrackList[i];
        // Edge adds a track without a label; we don't want to use it
        if ((track.kind === "subtitles" || track.kind === "captions") && track.label) tracks.push(textTrackList[i]);
    }
    return tracks;
}
class $fada8102d2a280be$var$BufferOperationQueue {
    constructor(sourceBufferReference){
        this.buffers = void 0;
        this.queues = {
            video: [],
            audio: [],
            audiovideo: []
        };
        this.buffers = sourceBufferReference;
    }
    append(operation, type) {
        const queue = this.queues[type];
        queue.push(operation);
        if (queue.length === 1 && this.buffers[type]) this.executeNext(type);
    }
    insertAbort(operation, type) {
        const queue = this.queues[type];
        queue.unshift(operation);
        this.executeNext(type);
    }
    appendBlocker(type) {
        let execute;
        const promise = new Promise((resolve)=>{
            execute = resolve;
        });
        const operation = {
            execute: execute,
            onStart: ()=>{},
            onComplete: ()=>{},
            onError: ()=>{}
        };
        this.append(operation, type);
        return promise;
    }
    executeNext(type) {
        const { buffers: buffers, queues: queues } = this;
        const sb = buffers[type];
        const queue = queues[type];
        if (queue.length) {
            const operation = queue[0];
            try {
                // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
                // which do not end with this event must call _onSBUpdateEnd manually
                operation.execute();
            } catch (e) {
                $fada8102d2a280be$var$logger.warn("[buffer-operation-queue]: Unhandled exception executing the current operation");
                operation.onError(e);
                // Only shift the current operation off, otherwise the updateend handler will do this for us
                if (!(sb != null && sb.updating)) {
                    queue.shift();
                    this.executeNext(type);
                }
            }
        }
    }
    shiftAndExecuteNext(type) {
        this.queues[type].shift();
        this.executeNext(type);
    }
    current(type) {
        return this.queues[type][0];
    }
}
const $fada8102d2a280be$var$MediaSource = $fada8102d2a280be$var$getMediaSource();
const $fada8102d2a280be$var$VIDEO_CODEC_PROFILE_REPACE = /([ha]vc.)(?:\.[^.,]+)+/;
class $fada8102d2a280be$var$BufferController {
    // The level details used to determine duration, target-duration and live
    // cache the self generated object url to detect hijack of video tag
    // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
    // References to event listeners for each SourceBuffer, so that they can be referenced for event removal
    // The number of BUFFER_CODEC events received before any sourceBuffers are created
    // The total number of BUFFER_CODEC events received
    // A reference to the attached media element
    // A reference to the active media source
    // Last MP3 audio chunk appended
    // counters
    constructor(hls){
        this.details = null;
        this._objectUrl = null;
        this.operationQueue = void 0;
        this.listeners = void 0;
        this.hls = void 0;
        this.bufferCodecEventsExpected = 0;
        this._bufferCodecEventsTotal = 0;
        this.media = null;
        this.mediaSource = null;
        this.lastMpegAudioChunk = null;
        this.appendError = 0;
        this.tracks = {};
        this.pendingTracks = {};
        this.sourceBuffer = void 0;
        // Keep as arrow functions so that we can directly reference these functions directly as event listeners
        this._onMediaSourceOpen = ()=>{
            const { media: media, mediaSource: mediaSource } = this;
            $fada8102d2a280be$var$logger.log("[buffer-controller]: Media source opened");
            if (media) {
                media.removeEventListener("emptied", this._onMediaEmptied);
                this.updateMediaElementDuration();
                this.hls.trigger($fada8102d2a280be$var$Events.MEDIA_ATTACHED, {
                    media: media
                });
            }
            if (mediaSource) // once received, don't listen anymore to sourceopen event
            mediaSource.removeEventListener("sourceopen", this._onMediaSourceOpen);
            this.checkPendingTracks();
        };
        this._onMediaSourceClose = ()=>{
            $fada8102d2a280be$var$logger.log("[buffer-controller]: Media source closed");
        };
        this._onMediaSourceEnded = ()=>{
            $fada8102d2a280be$var$logger.log("[buffer-controller]: Media source ended");
        };
        this._onMediaEmptied = ()=>{
            const { media: media, _objectUrl: _objectUrl } = this;
            if (media && media.src !== _objectUrl) $fada8102d2a280be$var$logger.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${media.src})`);
        };
        this.hls = hls;
        this._initSourceBuffer();
        this.registerListeners();
    }
    hasSourceTypes() {
        return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
    }
    destroy() {
        this.unregisterListeners();
        this.details = null;
        this.lastMpegAudioChunk = null;
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_RESET, this.onBufferReset, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_APPENDING, this.onBufferAppending, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_EOS, this.onBufferEos, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on($fada8102d2a280be$var$Events.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_PARSED, this.onFragParsed, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_CHANGED, this.onFragChanged, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_RESET, this.onBufferReset, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_APPENDING, this.onBufferAppending, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_EOS, this.onBufferEos, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off($fada8102d2a280be$var$Events.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_PARSED, this.onFragParsed, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_CHANGED, this.onFragChanged, this);
    }
    _initSourceBuffer() {
        this.sourceBuffer = {};
        this.operationQueue = new $fada8102d2a280be$var$BufferOperationQueue(this.sourceBuffer);
        this.listeners = {
            audio: [],
            video: [],
            audiovideo: []
        };
        this.lastMpegAudioChunk = null;
    }
    onManifestLoading() {
        this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0;
        this.details = null;
    }
    onManifestParsed(event, data) {
        // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
        // sourcebuffers will be created all at once when the expected nb of tracks will be reached
        // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
        // it will contain the expected nb of source buffers, no need to compute it
        let codecEvents = 2;
        if (data.audio && !data.video || !data.altAudio || false) codecEvents = 1;
        this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = codecEvents;
        $fada8102d2a280be$var$logger.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
    }
    onMediaAttaching(event, data) {
        const media = this.media = data.media;
        if (media && $fada8102d2a280be$var$MediaSource) {
            const ms = this.mediaSource = new $fada8102d2a280be$var$MediaSource();
            // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
            ms.addEventListener("sourceopen", this._onMediaSourceOpen);
            ms.addEventListener("sourceended", this._onMediaSourceEnded);
            ms.addEventListener("sourceclose", this._onMediaSourceClose);
            // link video and media Source
            media.src = self.URL.createObjectURL(ms);
            // cache the locally generated object url
            this._objectUrl = media.src;
            media.addEventListener("emptied", this._onMediaEmptied);
        }
    }
    onMediaDetaching() {
        const { media: media, mediaSource: mediaSource, _objectUrl: _objectUrl } = this;
        if (mediaSource) {
            $fada8102d2a280be$var$logger.log("[buffer-controller]: media source detaching");
            if (mediaSource.readyState === "open") try {
                // endOfStream could trigger exception if any sourcebuffer is in updating state
                // we don't really care about checking sourcebuffer state here,
                // as we are anyway detaching the MediaSource
                // let's just avoid this exception to propagate
                mediaSource.endOfStream();
            } catch (err) {
                $fada8102d2a280be$var$logger.warn(`[buffer-controller]: onMediaDetaching: ${err.message} while calling endOfStream`);
            }
            // Clean up the SourceBuffers by invoking onBufferReset
            this.onBufferReset();
            mediaSource.removeEventListener("sourceopen", this._onMediaSourceOpen);
            mediaSource.removeEventListener("sourceended", this._onMediaSourceEnded);
            mediaSource.removeEventListener("sourceclose", this._onMediaSourceClose);
            // Detach properly the MediaSource from the HTMLMediaElement as
            // suggested in https://github.com/w3c/media-source/issues/53.
            if (media) {
                media.removeEventListener("emptied", this._onMediaEmptied);
                if (_objectUrl) self.URL.revokeObjectURL(_objectUrl);
                // clean up video tag src only if it's our own url. some external libraries might
                // hijack the video tag and change its 'src' without destroying the Hls instance first
                if (media.src === _objectUrl) {
                    media.removeAttribute("src");
                    media.load();
                } else $fada8102d2a280be$var$logger.warn("[buffer-controller]: media.src was changed by a third party - skip cleanup");
            }
            this.mediaSource = null;
            this.media = null;
            this._objectUrl = null;
            this.bufferCodecEventsExpected = this._bufferCodecEventsTotal;
            this.pendingTracks = {};
            this.tracks = {};
        }
        this.hls.trigger($fada8102d2a280be$var$Events.MEDIA_DETACHED, undefined);
    }
    onBufferReset() {
        this.getSourceBufferTypes().forEach((type)=>{
            const sb = this.sourceBuffer[type];
            try {
                if (sb) {
                    this.removeBufferListeners(type);
                    if (this.mediaSource) this.mediaSource.removeSourceBuffer(sb);
                    // Synchronously remove the SB from the map before the next call in order to prevent an async function from
                    // accessing it
                    this.sourceBuffer[type] = undefined;
                }
            } catch (err) {
                $fada8102d2a280be$var$logger.warn(`[buffer-controller]: Failed to reset the ${type} buffer`, err);
            }
        });
        this._initSourceBuffer();
    }
    onBufferCodecs(event, data) {
        const sourceBufferCount = this.getSourceBufferTypes().length;
        Object.keys(data).forEach((trackName)=>{
            if (sourceBufferCount) {
                // check if SourceBuffer codec needs to change
                const track = this.tracks[trackName];
                if (track && typeof track.buffer.changeType === "function") {
                    const { id: id, codec: codec, levelCodec: levelCodec, container: container, metadata: metadata } = data[trackName];
                    const currentCodec = (track.levelCodec || track.codec).replace($fada8102d2a280be$var$VIDEO_CODEC_PROFILE_REPACE, "$1");
                    const nextCodec = (levelCodec || codec).replace($fada8102d2a280be$var$VIDEO_CODEC_PROFILE_REPACE, "$1");
                    if (currentCodec !== nextCodec) {
                        const mimeType = `${container};codecs=${levelCodec || codec}`;
                        this.appendChangeType(trackName, mimeType);
                        $fada8102d2a280be$var$logger.log(`[buffer-controller]: switching codec ${currentCodec} to ${nextCodec}`);
                        this.tracks[trackName] = {
                            buffer: track.buffer,
                            codec: codec,
                            container: container,
                            levelCodec: levelCodec,
                            metadata: metadata,
                            id: id
                        };
                    }
                }
            } else // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
            this.pendingTracks[trackName] = data[trackName];
        });
        // if sourcebuffers already created, do nothing ...
        if (sourceBufferCount) return;
        this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0);
        if (this.mediaSource && this.mediaSource.readyState === "open") this.checkPendingTracks();
    }
    appendChangeType(type, mimeType) {
        const { operationQueue: operationQueue } = this;
        const operation = {
            execute: ()=>{
                const sb = this.sourceBuffer[type];
                if (sb) {
                    $fada8102d2a280be$var$logger.log(`[buffer-controller]: changing ${type} sourceBuffer type to ${mimeType}`);
                    sb.changeType(mimeType);
                }
                operationQueue.shiftAndExecuteNext(type);
            },
            onStart: ()=>{},
            onComplete: ()=>{},
            onError: (e)=>{
                $fada8102d2a280be$var$logger.warn(`[buffer-controller]: Failed to change ${type} SourceBuffer type`, e);
            }
        };
        operationQueue.append(operation, type);
    }
    onBufferAppending(event, eventData) {
        const { hls: hls, operationQueue: operationQueue, tracks: tracks } = this;
        const { data: data, type: type, frag: frag, part: part, chunkMeta: chunkMeta } = eventData;
        const chunkStats = chunkMeta.buffering[type];
        const bufferAppendingStart = self.performance.now();
        chunkStats.start = bufferAppendingStart;
        const fragBuffering = frag.stats.buffering;
        const partBuffering = part ? part.stats.buffering : null;
        if (fragBuffering.start === 0) fragBuffering.start = bufferAppendingStart;
        if (partBuffering && partBuffering.start === 0) partBuffering.start = bufferAppendingStart;
        // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
        // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
        // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
        // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
        // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
        const audioTrack = tracks.audio;
        let checkTimestampOffset = false;
        if (type === "audio" && (audioTrack == null ? void 0 : audioTrack.container) === "audio/mpeg") {
            checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
            this.lastMpegAudioChunk = chunkMeta;
        }
        const fragStart = frag.start;
        const operation = {
            execute: ()=>{
                chunkStats.executeStart = self.performance.now();
                if (checkTimestampOffset) {
                    const sb = this.sourceBuffer[type];
                    if (sb) {
                        const delta = fragStart - sb.timestampOffset;
                        if (Math.abs(delta) >= 0.1) {
                            $fada8102d2a280be$var$logger.log(`[buffer-controller]: Updating audio SourceBuffer timestampOffset to ${fragStart} (delta: ${delta}) sn: ${frag.sn})`);
                            sb.timestampOffset = fragStart;
                        }
                    }
                }
                this.appendExecutor(data, type);
            },
            onStart: ()=>{
            // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
            },
            onComplete: ()=>{
                // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
                const end = self.performance.now();
                chunkStats.executeEnd = chunkStats.end = end;
                if (fragBuffering.first === 0) fragBuffering.first = end;
                if (partBuffering && partBuffering.first === 0) partBuffering.first = end;
                const { sourceBuffer: sourceBuffer } = this;
                const timeRanges = {};
                for(const type in sourceBuffer)timeRanges[type] = $fada8102d2a280be$var$BufferHelper.getBuffered(sourceBuffer[type]);
                this.appendError = 0;
                this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_APPENDED, {
                    type: type,
                    frag: frag,
                    part: part,
                    chunkMeta: chunkMeta,
                    parent: frag.type,
                    timeRanges: timeRanges
                });
            },
            onError: (err)=>{
                // in case any error occured while appending, put back segment in segments table
                $fada8102d2a280be$var$logger.error(`[buffer-controller]: Error encountered while trying to append to the ${type} SourceBuffer`, err);
                const event = {
                    type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                    parent: frag.type,
                    details: $fada8102d2a280be$var$ErrorDetails.BUFFER_APPEND_ERROR,
                    frag: frag,
                    part: part,
                    chunkMeta: chunkMeta,
                    error: err,
                    err: err,
                    fatal: false
                };
                if (err.code === DOMException.QUOTA_EXCEEDED_ERR) // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
                // let's stop appending any segments, and report BUFFER_FULL_ERROR error
                event.details = $fada8102d2a280be$var$ErrorDetails.BUFFER_FULL_ERROR;
                else {
                    this.appendError++;
                    event.details = $fada8102d2a280be$var$ErrorDetails.BUFFER_APPEND_ERROR;
                    /* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */ if (this.appendError > hls.config.appendErrorMaxRetry) {
                        $fada8102d2a280be$var$logger.error(`[buffer-controller]: Failed ${hls.config.appendErrorMaxRetry} times to append segment in sourceBuffer`);
                        event.fatal = true;
                    }
                }
                hls.trigger($fada8102d2a280be$var$Events.ERROR, event);
            }
        };
        operationQueue.append(operation, type);
    }
    onBufferFlushing(event, data) {
        const { operationQueue: operationQueue } = this;
        const flushOperation = (type)=>({
                execute: this.removeExecutor.bind(this, type, data.startOffset, data.endOffset),
                onStart: ()=>{
                // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
                },
                onComplete: ()=>{
                    // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
                    this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_FLUSHED, {
                        type: type
                    });
                },
                onError: (e)=>{
                    $fada8102d2a280be$var$logger.warn(`[buffer-controller]: Failed to remove from ${type} SourceBuffer`, e);
                }
            });
        if (data.type) operationQueue.append(flushOperation(data.type), data.type);
        else this.getSourceBufferTypes().forEach((type)=>{
            operationQueue.append(flushOperation(type), type);
        });
    }
    onFragParsed(event, data) {
        const { frag: frag, part: part } = data;
        const buffersAppendedTo = [];
        const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
        if (elementaryStreams[$fada8102d2a280be$var$ElementaryStreamTypes.AUDIOVIDEO]) buffersAppendedTo.push("audiovideo");
        else {
            if (elementaryStreams[$fada8102d2a280be$var$ElementaryStreamTypes.AUDIO]) buffersAppendedTo.push("audio");
            if (elementaryStreams[$fada8102d2a280be$var$ElementaryStreamTypes.VIDEO]) buffersAppendedTo.push("video");
        }
        const onUnblocked = ()=>{
            const now = self.performance.now();
            frag.stats.buffering.end = now;
            if (part) part.stats.buffering.end = now;
            const stats = part ? part.stats : frag.stats;
            this.hls.trigger($fada8102d2a280be$var$Events.FRAG_BUFFERED, {
                frag: frag,
                part: part,
                stats: stats,
                id: frag.type
            });
        };
        if (buffersAppendedTo.length === 0) $fada8102d2a280be$var$logger.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
        this.blockBuffers(onUnblocked, buffersAppendedTo);
    }
    onFragChanged(event, data) {
        this.flushBackBuffer();
    }
    // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
    // an undefined data.type will mark all buffers as EOS.
    onBufferEos(event, data) {
        const ended = this.getSourceBufferTypes().reduce((acc, type)=>{
            const sb = this.sourceBuffer[type];
            if (sb && (!data.type || data.type === type)) {
                sb.ending = true;
                if (!sb.ended) {
                    sb.ended = true;
                    $fada8102d2a280be$var$logger.log(`[buffer-controller]: ${type} sourceBuffer now EOS`);
                }
            }
            return acc && !!(!sb || sb.ended);
        }, true);
        if (ended) {
            $fada8102d2a280be$var$logger.log(`[buffer-controller]: Queueing mediaSource.endOfStream()`);
            this.blockBuffers(()=>{
                this.getSourceBufferTypes().forEach((type)=>{
                    const sb = this.sourceBuffer[type];
                    if (sb) sb.ending = false;
                });
                const { mediaSource: mediaSource } = this;
                if (!mediaSource || mediaSource.readyState !== "open") {
                    if (mediaSource) $fada8102d2a280be$var$logger.info(`[buffer-controller]: Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
                    return;
                }
                $fada8102d2a280be$var$logger.log(`[buffer-controller]: Calling mediaSource.endOfStream()`);
                // Allow this to throw and be caught by the enqueueing function
                mediaSource.endOfStream();
            });
        }
    }
    onLevelUpdated(event, { details: details }) {
        if (!details.fragments.length) return;
        this.details = details;
        if (this.getSourceBufferTypes().length) this.blockBuffers(this.updateMediaElementDuration.bind(this));
        else this.updateMediaElementDuration();
    }
    flushBackBuffer() {
        const { hls: hls, details: details, media: media, sourceBuffer: sourceBuffer } = this;
        if (!media || details === null) return;
        const sourceBufferTypes = this.getSourceBufferTypes();
        if (!sourceBufferTypes.length) return;
        // Support for deprecated liveBackBufferLength
        const backBufferLength = details.live && hls.config.liveBackBufferLength !== null ? hls.config.liveBackBufferLength : hls.config.backBufferLength;
        if (!$fada8102d2a280be$var$isFiniteNumber(backBufferLength) || backBufferLength < 0) return;
        const currentTime = media.currentTime;
        const targetDuration = details.levelTargetDuration;
        const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
        const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
        sourceBufferTypes.forEach((type)=>{
            const sb = sourceBuffer[type];
            if (sb) {
                const buffered = $fada8102d2a280be$var$BufferHelper.getBuffered(sb);
                // when target buffer start exceeds actual buffer start
                if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
                    hls.trigger($fada8102d2a280be$var$Events.BACK_BUFFER_REACHED, {
                        bufferEnd: targetBackBufferPosition
                    });
                    // Support for deprecated event:
                    if (details.live) hls.trigger($fada8102d2a280be$var$Events.LIVE_BACK_BUFFER_REACHED, {
                        bufferEnd: targetBackBufferPosition
                    });
                    else if (sb.ended && buffered.end(buffered.length - 1) - currentTime < targetDuration * 2) {
                        $fada8102d2a280be$var$logger.info(`[buffer-controller]: Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
                        return;
                    }
                    hls.trigger($fada8102d2a280be$var$Events.BUFFER_FLUSHING, {
                        startOffset: 0,
                        endOffset: targetBackBufferPosition,
                        type: type
                    });
                }
            }
        });
    }
    /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */ updateMediaElementDuration() {
        if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open") return;
        const { details: details, hls: hls, media: media, mediaSource: mediaSource } = this;
        const levelDuration = details.fragments[0].start + details.totalduration;
        const mediaDuration = media.duration;
        const msDuration = $fada8102d2a280be$var$isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0;
        if (details.live && hls.config.liveDurationInfinity) {
            // Override duration to Infinity
            $fada8102d2a280be$var$logger.log("[buffer-controller]: Media Source duration is set to Infinity");
            mediaSource.duration = Infinity;
            this.updateSeekableRange(details);
        } else if (levelDuration > msDuration && levelDuration > mediaDuration || !$fada8102d2a280be$var$isFiniteNumber(mediaDuration)) {
            // levelDuration was the last value we set.
            // not using mediaSource.duration as the browser may tweak this value
            // only update Media Source duration if its value increase, this is to avoid
            // flushing already buffered portion when switching between quality level
            $fada8102d2a280be$var$logger.log(`[buffer-controller]: Updating Media Source duration to ${levelDuration.toFixed(3)}`);
            mediaSource.duration = levelDuration;
        }
    }
    updateSeekableRange(levelDetails) {
        const mediaSource = this.mediaSource;
        const fragments = levelDetails.fragments;
        const len = fragments.length;
        if (len && levelDetails.live && mediaSource != null && mediaSource.setLiveSeekableRange) {
            const start = Math.max(0, fragments[0].start);
            const end = Math.max(start, start + levelDetails.totalduration);
            mediaSource.setLiveSeekableRange(start, end);
        }
    }
    checkPendingTracks() {
        const { bufferCodecEventsExpected: bufferCodecEventsExpected, operationQueue: operationQueue, pendingTracks: pendingTracks } = this;
        // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
        // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
        // data has been appended to existing ones.
        // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
        const pendingTracksCount = Object.keys(pendingTracks).length;
        if (pendingTracksCount && !bufferCodecEventsExpected || pendingTracksCount === 2) {
            // ok, let's create them now !
            this.createSourceBuffers(pendingTracks);
            this.pendingTracks = {};
            // append any pending segments now !
            const buffers = this.getSourceBufferTypes();
            if (buffers.length) {
                this.hls.trigger($fada8102d2a280be$var$Events.BUFFER_CREATED, {
                    tracks: this.tracks
                });
                buffers.forEach((type)=>{
                    operationQueue.executeNext(type);
                });
            } else {
                const error = new Error("could not create source buffer for media codec(s)");
                this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                    type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                    details: $fada8102d2a280be$var$ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                    fatal: true,
                    error: error,
                    reason: error.message
                });
            }
        }
    }
    createSourceBuffers(tracks) {
        const { sourceBuffer: sourceBuffer, mediaSource: mediaSource } = this;
        if (!mediaSource) throw Error("createSourceBuffers called when mediaSource was null");
        for(const trackName in tracks)if (!sourceBuffer[trackName]) {
            const track = tracks[trackName];
            if (!track) throw Error(`source buffer exists for track ${trackName}, however track does not`);
            // use levelCodec as first priority
            const codec = track.levelCodec || track.codec;
            const mimeType = `${track.container};codecs=${codec}`;
            $fada8102d2a280be$var$logger.log(`[buffer-controller]: creating sourceBuffer(${mimeType})`);
            try {
                const sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
                const sbName = trackName;
                this.addBufferListener(sbName, "updatestart", this._onSBUpdateStart);
                this.addBufferListener(sbName, "updateend", this._onSBUpdateEnd);
                this.addBufferListener(sbName, "error", this._onSBUpdateError);
                this.tracks[trackName] = {
                    buffer: sb,
                    codec: codec,
                    container: track.container,
                    levelCodec: track.levelCodec,
                    metadata: track.metadata,
                    id: track.id
                };
            } catch (err) {
                $fada8102d2a280be$var$logger.error(`[buffer-controller]: error while trying to add sourceBuffer: ${err.message}`);
                this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
                    type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
                    details: $fada8102d2a280be$var$ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                    fatal: false,
                    error: err,
                    mimeType: mimeType
                });
            }
        }
    }
    _onSBUpdateStart(type) {
        const { operationQueue: operationQueue } = this;
        const operation = operationQueue.current(type);
        operation.onStart();
    }
    _onSBUpdateEnd(type) {
        const { operationQueue: operationQueue } = this;
        const operation = operationQueue.current(type);
        operation.onComplete();
        operationQueue.shiftAndExecuteNext(type);
    }
    _onSBUpdateError(type, event) {
        const error = new Error(`${type} SourceBuffer error`);
        $fada8102d2a280be$var$logger.error(`[buffer-controller]: ${error}`, event);
        // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
        // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
        this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
            type: $fada8102d2a280be$var$ErrorTypes.MEDIA_ERROR,
            details: $fada8102d2a280be$var$ErrorDetails.BUFFER_APPENDING_ERROR,
            error: error,
            fatal: false
        });
        // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
        const operation = this.operationQueue.current(type);
        if (operation) operation.onError(event);
    }
    // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
    removeExecutor(type, startOffset, endOffset) {
        const { media: media, mediaSource: mediaSource, operationQueue: operationQueue, sourceBuffer: sourceBuffer } = this;
        const sb = sourceBuffer[type];
        if (!media || !mediaSource || !sb) {
            $fada8102d2a280be$var$logger.warn(`[buffer-controller]: Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
            operationQueue.shiftAndExecuteNext(type);
            return;
        }
        const mediaDuration = $fada8102d2a280be$var$isFiniteNumber(media.duration) ? media.duration : Infinity;
        const msDuration = $fada8102d2a280be$var$isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
        const removeStart = Math.max(0, startOffset);
        const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
        if (removeEnd > removeStart && !sb.ending) {
            sb.ended = false;
            $fada8102d2a280be$var$logger.log(`[buffer-controller]: Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
            sb.remove(removeStart, removeEnd);
        } else // Cycle the queue
        operationQueue.shiftAndExecuteNext(type);
    }
    // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
    appendExecutor(data, type) {
        const { operationQueue: operationQueue, sourceBuffer: sourceBuffer } = this;
        const sb = sourceBuffer[type];
        if (!sb) {
            $fada8102d2a280be$var$logger.warn(`[buffer-controller]: Attempting to append to the ${type} SourceBuffer, but it does not exist`);
            operationQueue.shiftAndExecuteNext(type);
            return;
        }
        sb.ended = false;
        sb.appendBuffer(data);
    }
    // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
    // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
    // upon completion, since we already do it here
    blockBuffers(onUnblocked, buffers = this.getSourceBufferTypes()) {
        if (!buffers.length) {
            $fada8102d2a280be$var$logger.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist");
            Promise.resolve().then(onUnblocked);
            return;
        }
        const { operationQueue: operationQueue } = this;
        // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
        const blockingOperations = buffers.map((type)=>operationQueue.appendBlocker(type));
        Promise.all(blockingOperations).then(()=>{
            // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
            onUnblocked();
            buffers.forEach((type)=>{
                const sb = this.sourceBuffer[type];
                // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
                // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
                // While this is a workaround, it's probably useful to have around
                if (!(sb != null && sb.updating)) operationQueue.shiftAndExecuteNext(type);
            });
        });
    }
    getSourceBufferTypes() {
        return Object.keys(this.sourceBuffer);
    }
    addBufferListener(type, event, fn) {
        const buffer = this.sourceBuffer[type];
        if (!buffer) return;
        const listener = fn.bind(this, type);
        this.listeners[type].push({
            event: event,
            listener: listener
        });
        buffer.addEventListener(event, listener);
    }
    removeBufferListeners(type) {
        const buffer = this.sourceBuffer[type];
        if (!buffer) return;
        this.listeners[type].forEach((l)=>{
            buffer.removeEventListener(l.event, l.listener);
        });
    }
}
/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */ /**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */ const $fada8102d2a280be$var$specialCea608CharsCodes = {
    0x2a: 0xe1,
    // lowercase a, acute accent
    0x5c: 0xe9,
    // lowercase e, acute accent
    0x5e: 0xed,
    // lowercase i, acute accent
    0x5f: 0xf3,
    // lowercase o, acute accent
    0x60: 0xfa,
    // lowercase u, acute accent
    0x7b: 0xe7,
    // lowercase c with cedilla
    0x7c: 0xf7,
    // division symbol
    0x7d: 0xd1,
    // uppercase N tilde
    0x7e: 0xf1,
    // lowercase n tilde
    0x7f: 0x2588,
    // Full block
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae,
    // Registered symbol (R)
    0x81: 0xb0,
    // degree sign
    0x82: 0xbd,
    // 1/2 symbol
    0x83: 0xbf,
    // Inverted (open) question mark
    0x84: 0x2122,
    // Trademark symbol (TM)
    0x85: 0xa2,
    // Cents symbol
    0x86: 0xa3,
    // Pounds sterling
    0x87: 0x266a,
    // Music 8'th note
    0x88: 0xe0,
    // lowercase a, grave accent
    0x89: 0x20,
    // transparent space (regular)
    0x8a: 0xe8,
    // lowercase e, grave accent
    0x8b: 0xe2,
    // lowercase a, circumflex accent
    0x8c: 0xea,
    // lowercase e, circumflex accent
    0x8d: 0xee,
    // lowercase i, circumflex accent
    0x8e: 0xf4,
    // lowercase o, circumflex accent
    0x8f: 0xfb,
    // lowercase u, circumflex accent
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1,
    // capital letter A with acute
    0x91: 0xc9,
    // capital letter E with acute
    0x92: 0xd3,
    // capital letter O with acute
    0x93: 0xda,
    // capital letter U with acute
    0x94: 0xdc,
    // capital letter U with diaresis
    0x95: 0xfc,
    // lowercase letter U with diaeresis
    0x96: 0x2018,
    // opening single quote
    0x97: 0xa1,
    // inverted exclamation mark
    0x98: 0x2a,
    // asterisk
    0x99: 0x2019,
    // closing single quote
    0x9a: 0x2501,
    // box drawings heavy horizontal
    0x9b: 0xa9,
    // copyright sign
    0x9c: 0x2120,
    // Service mark
    0x9d: 0x2022,
    // (round) bullet
    0x9e: 0x201c,
    // Left double quotation mark
    0x9f: 0x201d,
    // Right double quotation mark
    0xa0: 0xc0,
    // uppercase A, grave accent
    0xa1: 0xc2,
    // uppercase A, circumflex
    0xa2: 0xc7,
    // uppercase C with cedilla
    0xa3: 0xc8,
    // uppercase E, grave accent
    0xa4: 0xca,
    // uppercase E, circumflex
    0xa5: 0xcb,
    // capital letter E with diaresis
    0xa6: 0xeb,
    // lowercase letter e with diaresis
    0xa7: 0xce,
    // uppercase I, circumflex
    0xa8: 0xcf,
    // uppercase I, with diaresis
    0xa9: 0xef,
    // lowercase i, with diaresis
    0xaa: 0xd4,
    // uppercase O, circumflex
    0xab: 0xd9,
    // uppercase U, grave accent
    0xac: 0xf9,
    // lowercase u, grave accent
    0xad: 0xdb,
    // uppercase U, circumflex
    0xae: 0xab,
    // left-pointing double angle quotation mark
    0xaf: 0xbb,
    // right-pointing double angle quotation mark
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3,
    // Uppercase A, tilde
    0xb1: 0xe3,
    // Lowercase a, tilde
    0xb2: 0xcd,
    // Uppercase I, acute accent
    0xb3: 0xcc,
    // Uppercase I, grave accent
    0xb4: 0xec,
    // Lowercase i, grave accent
    0xb5: 0xd2,
    // Uppercase O, grave accent
    0xb6: 0xf2,
    // Lowercase o, grave accent
    0xb7: 0xd5,
    // Uppercase O, tilde
    0xb8: 0xf5,
    // Lowercase o, tilde
    0xb9: 0x7b,
    // Open curly brace
    0xba: 0x7d,
    // Closing curly brace
    0xbb: 0x5c,
    // Backslash
    0xbc: 0x5e,
    // Caret
    0xbd: 0x5f,
    // Underscore
    0xbe: 0x7c,
    // Pipe (vertical line)
    0xbf: 0x223c,
    // Tilde operator
    0xc0: 0xc4,
    // Uppercase A, umlaut
    0xc1: 0xe4,
    // Lowercase A, umlaut
    0xc2: 0xd6,
    // Uppercase O, umlaut
    0xc3: 0xf6,
    // Lowercase o, umlaut
    0xc4: 0xdf,
    // Esszett (sharp S)
    0xc5: 0xa5,
    // Yen symbol
    0xc6: 0xa4,
    // Generic currency sign
    0xc7: 0x2503,
    // Box drawings heavy vertical
    0xc8: 0xc5,
    // Uppercase A, ring
    0xc9: 0xe5,
    // Lowercase A, ring
    0xca: 0xd8,
    // Uppercase O, stroke
    0xcb: 0xf8,
    // Lowercase o, strok
    0xcc: 0x250f,
    // Box drawings heavy down and right
    0xcd: 0x2513,
    // Box drawings heavy down and left
    0xce: 0x2517,
    // Box drawings heavy up and right
    0xcf: 0x251b // Box drawings heavy up and left
};
/**
 * Utils
 */ const $fada8102d2a280be$var$getCharForByte = function getCharForByte(byte) {
    let charCode = byte;
    if ($fada8102d2a280be$var$specialCea608CharsCodes.hasOwnProperty(byte)) charCode = $fada8102d2a280be$var$specialCea608CharsCodes[byte];
    return String.fromCharCode(charCode);
};
const $fada8102d2a280be$var$NR_ROWS = 15;
const $fada8102d2a280be$var$NR_COLS = 100;
// Tables to look up row from PAC data
const $fada8102d2a280be$var$rowsLowCh1 = {
    0x11: 1,
    0x12: 3,
    0x15: 5,
    0x16: 7,
    0x17: 9,
    0x10: 11,
    0x13: 12,
    0x14: 14
};
const $fada8102d2a280be$var$rowsHighCh1 = {
    0x11: 2,
    0x12: 4,
    0x15: 6,
    0x16: 8,
    0x17: 10,
    0x13: 13,
    0x14: 15
};
const $fada8102d2a280be$var$rowsLowCh2 = {
    0x19: 1,
    0x1a: 3,
    0x1d: 5,
    0x1e: 7,
    0x1f: 9,
    0x18: 11,
    0x1b: 12,
    0x1c: 14
};
const $fada8102d2a280be$var$rowsHighCh2 = {
    0x19: 2,
    0x1a: 4,
    0x1d: 6,
    0x1e: 8,
    0x1f: 10,
    0x1b: 13,
    0x1c: 15
};
const $fada8102d2a280be$var$backgroundColors = [
    "white",
    "green",
    "blue",
    "cyan",
    "red",
    "yellow",
    "magenta",
    "black",
    "transparent"
];
class $fada8102d2a280be$var$CaptionsLogger {
    constructor(){
        this.time = null;
        this.verboseLevel = 0;
    }
    log(severity, msg) {
        if (this.verboseLevel >= severity) {
            const m = typeof msg === "function" ? msg() : msg;
            $fada8102d2a280be$var$logger.log(`${this.time} [${severity}] ${m}`);
        }
    }
}
const $fada8102d2a280be$var$numArrayToHexArray = function numArrayToHexArray(numArray) {
    const hexArray = [];
    for(let j = 0; j < numArray.length; j++)hexArray.push(numArray[j].toString(16));
    return hexArray;
};
class $fada8102d2a280be$var$PenState {
    constructor(foreground, underline, italics, background, flash){
        this.foreground = void 0;
        this.underline = void 0;
        this.italics = void 0;
        this.background = void 0;
        this.flash = void 0;
        this.foreground = foreground || "white";
        this.underline = underline || false;
        this.italics = italics || false;
        this.background = background || "black";
        this.flash = flash || false;
    }
    reset() {
        this.foreground = "white";
        this.underline = false;
        this.italics = false;
        this.background = "black";
        this.flash = false;
    }
    setStyles(styles) {
        const attribs = [
            "foreground",
            "underline",
            "italics",
            "background",
            "flash"
        ];
        for(let i = 0; i < attribs.length; i++){
            const style = attribs[i];
            if (styles.hasOwnProperty(style)) this[style] = styles[style];
        }
    }
    isDefault() {
        return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
    }
    equals(other) {
        return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
    }
    copy(newPenState) {
        this.foreground = newPenState.foreground;
        this.underline = newPenState.underline;
        this.italics = newPenState.italics;
        this.background = newPenState.background;
        this.flash = newPenState.flash;
    }
    toString() {
        return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
    }
}
/**
 * Unicode character with styling and background.
 * @constructor
 */ class $fada8102d2a280be$var$StyledUnicodeChar {
    constructor(uchar, foreground, underline, italics, background, flash){
        this.uchar = void 0;
        this.penState = void 0;
        this.uchar = uchar || " "; // unicode character
        this.penState = new $fada8102d2a280be$var$PenState(foreground, underline, italics, background, flash);
    }
    reset() {
        this.uchar = " ";
        this.penState.reset();
    }
    setChar(uchar, newPenState) {
        this.uchar = uchar;
        this.penState.copy(newPenState);
    }
    setPenState(newPenState) {
        this.penState.copy(newPenState);
    }
    equals(other) {
        return this.uchar === other.uchar && this.penState.equals(other.penState);
    }
    copy(newChar) {
        this.uchar = newChar.uchar;
        this.penState.copy(newChar.penState);
    }
    isEmpty() {
        return this.uchar === " " && this.penState.isDefault();
    }
}
/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */ class $fada8102d2a280be$var$Row {
    constructor(logger){
        this.chars = void 0;
        this.pos = void 0;
        this.currPenState = void 0;
        this.cueStartTime = void 0;
        this.logger = void 0;
        this.chars = [];
        for(let i = 0; i < $fada8102d2a280be$var$NR_COLS; i++)this.chars.push(new $fada8102d2a280be$var$StyledUnicodeChar());
        this.logger = logger;
        this.pos = 0;
        this.currPenState = new $fada8102d2a280be$var$PenState();
    }
    equals(other) {
        let equal = true;
        for(let i = 0; i < $fada8102d2a280be$var$NR_COLS; i++)if (!this.chars[i].equals(other.chars[i])) {
            equal = false;
            break;
        }
        return equal;
    }
    copy(other) {
        for(let i = 0; i < $fada8102d2a280be$var$NR_COLS; i++)this.chars[i].copy(other.chars[i]);
    }
    isEmpty() {
        let empty = true;
        for(let i = 0; i < $fada8102d2a280be$var$NR_COLS; i++)if (!this.chars[i].isEmpty()) {
            empty = false;
            break;
        }
        return empty;
    }
    /**
   *  Set the cursor to a valid column.
   */ setCursor(absPos) {
        if (this.pos !== absPos) this.pos = absPos;
        if (this.pos < 0) {
            this.logger.log(3, "Negative cursor position " + this.pos);
            this.pos = 0;
        } else if (this.pos > $fada8102d2a280be$var$NR_COLS) {
            this.logger.log(3, "Too large cursor position " + this.pos);
            this.pos = $fada8102d2a280be$var$NR_COLS;
        }
    }
    /**
   * Move the cursor relative to current position.
   */ moveCursor(relPos) {
        const newPos = this.pos + relPos;
        if (relPos > 1) for(let i = this.pos + 1; i < newPos + 1; i++)this.chars[i].setPenState(this.currPenState);
        this.setCursor(newPos);
    }
    /**
   * Backspace, move one step back and clear character.
   */ backSpace() {
        this.moveCursor(-1);
        this.chars[this.pos].setChar(" ", this.currPenState);
    }
    insertChar(byte) {
        if (byte >= 0x90) // Extended char
        this.backSpace();
        const char = $fada8102d2a280be$var$getCharForByte(byte);
        if (this.pos >= $fada8102d2a280be$var$NR_COLS) {
            this.logger.log(0, ()=>"Cannot insert " + byte.toString(16) + " (" + char + ") at position " + this.pos + ". Skipping it!");
            return;
        }
        this.chars[this.pos].setChar(char, this.currPenState);
        this.moveCursor(1);
    }
    clearFromPos(startPos) {
        let i;
        for(i = startPos; i < $fada8102d2a280be$var$NR_COLS; i++)this.chars[i].reset();
    }
    clear() {
        this.clearFromPos(0);
        this.pos = 0;
        this.currPenState.reset();
    }
    clearToEndOfRow() {
        this.clearFromPos(this.pos);
    }
    getTextString() {
        const chars = [];
        let empty = true;
        for(let i = 0; i < $fada8102d2a280be$var$NR_COLS; i++){
            const char = this.chars[i].uchar;
            if (char !== " ") empty = false;
            chars.push(char);
        }
        if (empty) return "";
        else return chars.join("");
    }
    setPenStyles(styles) {
        this.currPenState.setStyles(styles);
        const currChar = this.chars[this.pos];
        currChar.setPenState(this.currPenState);
    }
}
/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */ class $fada8102d2a280be$var$CaptionScreen {
    constructor(logger){
        this.rows = void 0;
        this.currRow = void 0;
        this.nrRollUpRows = void 0;
        this.lastOutputScreen = void 0;
        this.logger = void 0;
        this.rows = [];
        for(let i = 0; i < $fada8102d2a280be$var$NR_ROWS; i++)this.rows.push(new $fada8102d2a280be$var$Row(logger));
         // Note that we use zero-based numbering (0-14)
        this.logger = logger;
        this.currRow = $fada8102d2a280be$var$NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.lastOutputScreen = null;
        this.reset();
    }
    reset() {
        for(let i = 0; i < $fada8102d2a280be$var$NR_ROWS; i++)this.rows[i].clear();
        this.currRow = $fada8102d2a280be$var$NR_ROWS - 1;
    }
    equals(other) {
        let equal = true;
        for(let i = 0; i < $fada8102d2a280be$var$NR_ROWS; i++)if (!this.rows[i].equals(other.rows[i])) {
            equal = false;
            break;
        }
        return equal;
    }
    copy(other) {
        for(let i = 0; i < $fada8102d2a280be$var$NR_ROWS; i++)this.rows[i].copy(other.rows[i]);
    }
    isEmpty() {
        let empty = true;
        for(let i = 0; i < $fada8102d2a280be$var$NR_ROWS; i++)if (!this.rows[i].isEmpty()) {
            empty = false;
            break;
        }
        return empty;
    }
    backSpace() {
        const row = this.rows[this.currRow];
        row.backSpace();
    }
    clearToEndOfRow() {
        const row = this.rows[this.currRow];
        row.clearToEndOfRow();
    }
    /**
   * Insert a character (without styling) in the current row.
   */ insertChar(char) {
        const row = this.rows[this.currRow];
        row.insertChar(char);
    }
    setPen(styles) {
        const row = this.rows[this.currRow];
        row.setPenStyles(styles);
    }
    moveCursor(relPos) {
        const row = this.rows[this.currRow];
        row.moveCursor(relPos);
    }
    setCursor(absPos) {
        this.logger.log(2, "setCursor: " + absPos);
        const row = this.rows[this.currRow];
        row.setCursor(absPos);
    }
    setPAC(pacData) {
        this.logger.log(2, ()=>"pacData = " + JSON.stringify(pacData));
        let newRow = pacData.row - 1;
        if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) newRow = this.nrRollUpRows - 1;
        // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
        if (this.nrRollUpRows && this.currRow !== newRow) {
            // clear all rows first
            for(let i = 0; i < $fada8102d2a280be$var$NR_ROWS; i++)this.rows[i].clear();
            // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
            // topRowIndex - the start of rows to copy (inclusive index)
            const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
            // We only copy if the last position was already shown.
            // We use the cueStartTime value to check this.
            const lastOutputScreen = this.lastOutputScreen;
            if (lastOutputScreen) {
                const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                const time = this.logger.time;
                if (prevLineTime && time !== null && prevLineTime < time) for(let i = 0; i < this.nrRollUpRows; i++)this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
            }
        }
        this.currRow = newRow;
        const row = this.rows[this.currRow];
        if (pacData.indent !== null) {
            const indent = pacData.indent;
            const prevPos = Math.max(indent - 1, 0);
            row.setCursor(pacData.indent);
            pacData.color = row.chars[prevPos].penState.foreground;
        }
        const styles = {
            foreground: pacData.color,
            underline: pacData.underline,
            italics: pacData.italics,
            background: "black",
            flash: false
        };
        this.setPen(styles);
    }
    /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */ setBkgData(bkgData) {
        this.logger.log(2, ()=>"bkgData = " + JSON.stringify(bkgData));
        this.backSpace();
        this.setPen(bkgData);
        this.insertChar(0x20); // Space
    }
    setRollUpRows(nrRows) {
        this.nrRollUpRows = nrRows;
    }
    rollUp() {
        if (this.nrRollUpRows === null) {
            this.logger.log(3, "roll_up but nrRollUpRows not set yet");
            return; // Not properly setup
        }
        this.logger.log(1, ()=>this.getDisplayText());
        const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
        const topRow = this.rows.splice(topRowIndex, 1)[0];
        topRow.clear();
        this.rows.splice(this.currRow, 0, topRow);
        this.logger.log(2, "Rolling up");
    // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
    }
    /**
   * Get all non-empty rows with as unicode text.
   */ getDisplayText(asOneRow) {
        asOneRow = asOneRow || false;
        const displayText = [];
        let text = "";
        let rowNr = -1;
        for(let i = 0; i < $fada8102d2a280be$var$NR_ROWS; i++){
            const rowText = this.rows[i].getTextString();
            if (rowText) {
                rowNr = i + 1;
                if (asOneRow) displayText.push("Row " + rowNr + ": '" + rowText + "'");
                else displayText.push(rowText.trim());
            }
        }
        if (displayText.length > 0) {
            if (asOneRow) text = "[" + displayText.join(" | ") + "]";
            else text = displayText.join("\n");
        }
        return text;
    }
    getTextAndFormat() {
        return this.rows;
    }
}
// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
class $fada8102d2a280be$var$Cea608Channel {
    constructor(channelNumber, outputFilter, logger){
        this.chNr = void 0;
        this.outputFilter = void 0;
        this.mode = void 0;
        this.verbose = void 0;
        this.displayedMemory = void 0;
        this.nonDisplayedMemory = void 0;
        this.lastOutputScreen = void 0;
        this.currRollUpRow = void 0;
        this.writeScreen = void 0;
        this.cueStartTime = void 0;
        this.logger = void 0;
        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new $fada8102d2a280be$var$CaptionScreen(logger);
        this.nonDisplayedMemory = new $fada8102d2a280be$var$CaptionScreen(logger);
        this.lastOutputScreen = new $fada8102d2a280be$var$CaptionScreen(logger);
        this.currRollUpRow = this.displayedMemory.rows[$fada8102d2a280be$var$NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
        this.logger = logger;
    }
    reset() {
        this.mode = null;
        this.displayedMemory.reset();
        this.nonDisplayedMemory.reset();
        this.lastOutputScreen.reset();
        this.outputFilter.reset();
        this.currRollUpRow = this.displayedMemory.rows[$fada8102d2a280be$var$NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null;
    }
    getHandler() {
        return this.outputFilter;
    }
    setHandler(newHandler) {
        this.outputFilter = newHandler;
    }
    setPAC(pacData) {
        this.writeScreen.setPAC(pacData);
    }
    setBkgData(bkgData) {
        this.writeScreen.setBkgData(bkgData);
    }
    setMode(newMode) {
        if (newMode === this.mode) return;
        this.mode = newMode;
        this.logger.log(2, ()=>"MODE=" + newMode);
        if (this.mode === "MODE_POP-ON") this.writeScreen = this.nonDisplayedMemory;
        else {
            this.writeScreen = this.displayedMemory;
            this.writeScreen.reset();
        }
        if (this.mode !== "MODE_ROLL-UP") {
            this.displayedMemory.nrRollUpRows = null;
            this.nonDisplayedMemory.nrRollUpRows = null;
        }
        this.mode = newMode;
    }
    insertChars(chars) {
        for(let i = 0; i < chars.length; i++)this.writeScreen.insertChar(chars[i]);
        const screen = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
        this.logger.log(2, ()=>screen + ": " + this.writeScreen.getDisplayText(true));
        if (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") {
            this.logger.log(1, ()=>"DISPLAYED: " + this.displayedMemory.getDisplayText(true));
            this.outputDataUpdate();
        }
    }
    ccRCL() {
        // Resume Caption Loading (switch mode to Pop On)
        this.logger.log(2, "RCL - Resume Caption Loading");
        this.setMode("MODE_POP-ON");
    }
    ccBS() {
        // BackSpace
        this.logger.log(2, "BS - BackSpace");
        if (this.mode === "MODE_TEXT") return;
        this.writeScreen.backSpace();
        if (this.writeScreen === this.displayedMemory) this.outputDataUpdate();
    }
    ccAOF() {
    // Reserved (formerly Alarm Off)
    }
    ccAON() {
    // Reserved (formerly Alarm On)
    }
    ccDER() {
        // Delete to End of Row
        this.logger.log(2, "DER- Delete to End of Row");
        this.writeScreen.clearToEndOfRow();
        this.outputDataUpdate();
    }
    ccRU(nrRows) {
        // Roll-Up Captions-2,3,or 4 Rows
        this.logger.log(2, "RU(" + nrRows + ") - Roll Up");
        this.writeScreen = this.displayedMemory;
        this.setMode("MODE_ROLL-UP");
        this.writeScreen.setRollUpRows(nrRows);
    }
    ccFON() {
        // Flash On
        this.logger.log(2, "FON - Flash On");
        this.writeScreen.setPen({
            flash: true
        });
    }
    ccRDC() {
        // Resume Direct Captioning (switch mode to PaintOn)
        this.logger.log(2, "RDC - Resume Direct Captioning");
        this.setMode("MODE_PAINT-ON");
    }
    ccTR() {
        // Text Restart in text mode (not supported, however)
        this.logger.log(2, "TR");
        this.setMode("MODE_TEXT");
    }
    ccRTD() {
        // Resume Text Display in Text mode (not supported, however)
        this.logger.log(2, "RTD");
        this.setMode("MODE_TEXT");
    }
    ccEDM() {
        // Erase Displayed Memory
        this.logger.log(2, "EDM - Erase Displayed Memory");
        this.displayedMemory.reset();
        this.outputDataUpdate(true);
    }
    ccCR() {
        // Carriage Return
        this.logger.log(2, "CR - Carriage Return");
        this.writeScreen.rollUp();
        this.outputDataUpdate(true);
    }
    ccENM() {
        // Erase Non-Displayed Memory
        this.logger.log(2, "ENM - Erase Non-displayed Memory");
        this.nonDisplayedMemory.reset();
    }
    ccEOC() {
        // End of Caption (Flip Memories)
        this.logger.log(2, "EOC - End Of Caption");
        if (this.mode === "MODE_POP-ON") {
            const tmp = this.displayedMemory;
            this.displayedMemory = this.nonDisplayedMemory;
            this.nonDisplayedMemory = tmp;
            this.writeScreen = this.nonDisplayedMemory;
            this.logger.log(1, ()=>"DISP: " + this.displayedMemory.getDisplayText());
        }
        this.outputDataUpdate(true);
    }
    ccTO(nrCols) {
        // Tab Offset 1,2, or 3 columns
        this.logger.log(2, "TO(" + nrCols + ") - Tab Offset");
        this.writeScreen.moveCursor(nrCols);
    }
    ccMIDROW(secondByte) {
        // Parse MIDROW command
        const styles = {
            flash: false
        };
        styles.underline = secondByte % 2 === 1;
        styles.italics = secondByte >= 0x2e;
        if (!styles.italics) {
            const colorIndex = Math.floor(secondByte / 2) - 0x10;
            const colors = [
                "white",
                "green",
                "blue",
                "cyan",
                "red",
                "yellow",
                "magenta"
            ];
            styles.foreground = colors[colorIndex];
        } else styles.foreground = "white";
        this.logger.log(2, "MIDROW: " + JSON.stringify(styles));
        this.writeScreen.setPen(styles);
    }
    outputDataUpdate(dispatch = false) {
        const time = this.logger.time;
        if (time === null) return;
        if (this.outputFilter) {
            if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) // Start of a new cue
            this.cueStartTime = time;
            else if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                this.outputFilter.newCue(this.cueStartTime, time, this.lastOutputScreen);
                if (dispatch && this.outputFilter.dispatchCue) this.outputFilter.dispatchCue();
                this.cueStartTime = this.displayedMemory.isEmpty() ? null : time;
            }
            this.lastOutputScreen.copy(this.displayedMemory);
        }
    }
    cueSplitAtTime(t) {
        if (this.outputFilter) {
            if (!this.displayedMemory.isEmpty()) {
                if (this.outputFilter.newCue) this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                this.cueStartTime = t;
            }
        }
    }
}
// Will be 1 or 2 when parsing captions
class $fada8102d2a280be$var$Cea608Parser {
    constructor(field, out1, out2){
        this.channels = void 0;
        this.currentChannel = 0;
        this.cmdHistory = void 0;
        this.logger = void 0;
        const logger = new $fada8102d2a280be$var$CaptionsLogger();
        this.channels = [
            null,
            new $fada8102d2a280be$var$Cea608Channel(field, out1, logger),
            new $fada8102d2a280be$var$Cea608Channel(field + 1, out2, logger)
        ];
        this.cmdHistory = $fada8102d2a280be$var$createCmdHistory();
        this.logger = logger;
    }
    getHandler(channel) {
        return this.channels[channel].getHandler();
    }
    setHandler(channel, newHandler) {
        this.channels[channel].setHandler(newHandler);
    }
    /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */ addData(time, byteList) {
        let cmdFound;
        let a;
        let b;
        let charsFound = false;
        this.logger.time = time;
        for(let i = 0; i < byteList.length; i += 2){
            a = byteList[i] & 0x7f;
            b = byteList[i + 1] & 0x7f;
            if (a === 0 && b === 0) continue;
            else this.logger.log(3, "[" + $fada8102d2a280be$var$numArrayToHexArray([
                byteList[i],
                byteList[i + 1]
            ]) + "] -> (" + $fada8102d2a280be$var$numArrayToHexArray([
                a,
                b
            ]) + ")");
            cmdFound = this.parseCmd(a, b);
            if (!cmdFound) cmdFound = this.parseMidrow(a, b);
            if (!cmdFound) cmdFound = this.parsePAC(a, b);
            if (!cmdFound) cmdFound = this.parseBackgroundAttributes(a, b);
            if (!cmdFound) {
                charsFound = this.parseChars(a, b);
                if (charsFound) {
                    const currChNr = this.currentChannel;
                    if (currChNr && currChNr > 0) {
                        const channel = this.channels[currChNr];
                        channel.insertChars(charsFound);
                    } else this.logger.log(2, "No channel found yet. TEXT-MODE?");
                }
            }
            if (!cmdFound && !charsFound) this.logger.log(2, "Couldn't parse cleaned data " + $fada8102d2a280be$var$numArrayToHexArray([
                a,
                b
            ]) + " orig: " + $fada8102d2a280be$var$numArrayToHexArray([
                byteList[i],
                byteList[i + 1]
            ]));
        }
    }
    /**
   * Parse Command.
   * @returns True if a command was found
   */ parseCmd(a, b) {
        const { cmdHistory: cmdHistory } = this;
        const cond1 = (a === 0x14 || a === 0x1c || a === 0x15 || a === 0x1d) && b >= 0x20 && b <= 0x2f;
        const cond2 = (a === 0x17 || a === 0x1f) && b >= 0x21 && b <= 0x23;
        if (!(cond1 || cond2)) return false;
        if ($fada8102d2a280be$var$hasCmdRepeated(a, b, cmdHistory)) {
            $fada8102d2a280be$var$setLastCmd(null, null, cmdHistory);
            this.logger.log(3, "Repeated command (" + $fada8102d2a280be$var$numArrayToHexArray([
                a,
                b
            ]) + ") is dropped");
            return true;
        }
        const chNr = a === 0x14 || a === 0x15 || a === 0x17 ? 1 : 2;
        const channel = this.channels[chNr];
        if (a === 0x14 || a === 0x15 || a === 0x1c || a === 0x1d) {
            if (b === 0x20) channel.ccRCL();
            else if (b === 0x21) channel.ccBS();
            else if (b === 0x22) channel.ccAOF();
            else if (b === 0x23) channel.ccAON();
            else if (b === 0x24) channel.ccDER();
            else if (b === 0x25) channel.ccRU(2);
            else if (b === 0x26) channel.ccRU(3);
            else if (b === 0x27) channel.ccRU(4);
            else if (b === 0x28) channel.ccFON();
            else if (b === 0x29) channel.ccRDC();
            else if (b === 0x2a) channel.ccTR();
            else if (b === 0x2b) channel.ccRTD();
            else if (b === 0x2c) channel.ccEDM();
            else if (b === 0x2d) channel.ccCR();
            else if (b === 0x2e) channel.ccENM();
            else if (b === 0x2f) channel.ccEOC();
        } else // a == 0x17 || a == 0x1F
        channel.ccTO(b - 0x20);
        $fada8102d2a280be$var$setLastCmd(a, b, cmdHistory);
        this.currentChannel = chNr;
        return true;
    }
    /**
   * Parse midrow styling command
   */ parseMidrow(a, b) {
        let chNr = 0;
        if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
            if (a === 0x11) chNr = 1;
            else chNr = 2;
            if (chNr !== this.currentChannel) {
                this.logger.log(0, "Mismatch channel in midrow parsing");
                return false;
            }
            const channel = this.channels[chNr];
            if (!channel) return false;
            channel.ccMIDROW(b);
            this.logger.log(3, "MIDROW (" + $fada8102d2a280be$var$numArrayToHexArray([
                a,
                b
            ]) + ")");
            return true;
        }
        return false;
    }
    /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */ parsePAC(a, b) {
        let row;
        const cmdHistory = this.cmdHistory;
        const case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1f) && b >= 0x40 && b <= 0x7f;
        const case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5f;
        if (!(case1 || case2)) return false;
        if ($fada8102d2a280be$var$hasCmdRepeated(a, b, cmdHistory)) {
            $fada8102d2a280be$var$setLastCmd(null, null, cmdHistory);
            return true; // Repeated commands are dropped (once)
        }
        const chNr = a <= 0x17 ? 1 : 2;
        if (b >= 0x40 && b <= 0x5f) row = chNr === 1 ? $fada8102d2a280be$var$rowsLowCh1[a] : $fada8102d2a280be$var$rowsLowCh2[a];
        else // 0x60 <= b <= 0x7F
        row = chNr === 1 ? $fada8102d2a280be$var$rowsHighCh1[a] : $fada8102d2a280be$var$rowsHighCh2[a];
        const channel = this.channels[chNr];
        if (!channel) return false;
        channel.setPAC(this.interpretPAC(row, b));
        $fada8102d2a280be$var$setLastCmd(a, b, cmdHistory);
        this.currentChannel = chNr;
        return true;
    }
    /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */ interpretPAC(row, byte) {
        let pacIndex;
        const pacData = {
            color: null,
            italics: false,
            indent: null,
            underline: false,
            row: row
        };
        if (byte > 0x5f) pacIndex = byte - 0x60;
        else pacIndex = byte - 0x40;
        pacData.underline = (pacIndex & 1) === 1;
        if (pacIndex <= 0xd) pacData.color = [
            "white",
            "green",
            "blue",
            "cyan",
            "red",
            "yellow",
            "magenta",
            "white"
        ][Math.floor(pacIndex / 2)];
        else if (pacIndex <= 0xf) {
            pacData.italics = true;
            pacData.color = "white";
        } else pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
        return pacData; // Note that row has zero offset. The spec uses 1.
    }
    /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */ parseChars(a, b) {
        let channelNr;
        let charCodes = null;
        let charCode1 = null;
        if (a >= 0x19) {
            channelNr = 2;
            charCode1 = a - 8;
        } else {
            channelNr = 1;
            charCode1 = a;
        }
        if (charCode1 >= 0x11 && charCode1 <= 0x13) {
            // Special character
            let oneCode;
            if (charCode1 === 0x11) oneCode = b + 0x50;
            else if (charCode1 === 0x12) oneCode = b + 0x70;
            else oneCode = b + 0x90;
            this.logger.log(2, "Special char '" + $fada8102d2a280be$var$getCharForByte(oneCode) + "' in channel " + channelNr);
            charCodes = [
                oneCode
            ];
        } else if (a >= 0x20 && a <= 0x7f) charCodes = b === 0 ? [
            a
        ] : [
            a,
            b
        ];
        if (charCodes) {
            const hexCodes = $fada8102d2a280be$var$numArrayToHexArray(charCodes);
            this.logger.log(3, "Char codes =  " + hexCodes.join(","));
            $fada8102d2a280be$var$setLastCmd(a, b, this.cmdHistory);
        }
        return charCodes;
    }
    /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */ parseBackgroundAttributes(a, b) {
        const case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
        const case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
        if (!(case1 || case2)) return false;
        let index;
        const bkgData = {};
        if (a === 0x10 || a === 0x18) {
            index = Math.floor((b - 0x20) / 2);
            bkgData.background = $fada8102d2a280be$var$backgroundColors[index];
            if (b % 2 === 1) bkgData.background = bkgData.background + "_semi";
        } else if (b === 0x2d) bkgData.background = "transparent";
        else {
            bkgData.foreground = "black";
            if (b === 0x2f) bkgData.underline = true;
        }
        const chNr = a <= 0x17 ? 1 : 2;
        const channel = this.channels[chNr];
        channel.setBkgData(bkgData);
        $fada8102d2a280be$var$setLastCmd(a, b, this.cmdHistory);
        return true;
    }
    /**
   * Reset state of parser and its channels.
   */ reset() {
        for(let i = 0; i < Object.keys(this.channels).length; i++){
            const channel = this.channels[i];
            if (channel) channel.reset();
        }
        this.cmdHistory = $fada8102d2a280be$var$createCmdHistory();
    }
    /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */ cueSplitAtTime(t) {
        for(let i = 0; i < this.channels.length; i++){
            const channel = this.channels[i];
            if (channel) channel.cueSplitAtTime(t);
        }
    }
}
function $fada8102d2a280be$var$setLastCmd(a, b, cmdHistory) {
    cmdHistory.a = a;
    cmdHistory.b = b;
}
function $fada8102d2a280be$var$hasCmdRepeated(a, b, cmdHistory) {
    return cmdHistory.a === a && cmdHistory.b === b;
}
function $fada8102d2a280be$var$createCmdHistory() {
    return {
        a: null,
        b: null
    };
}
class $fada8102d2a280be$var$OutputFilter {
    constructor(timelineController, trackName){
        this.timelineController = void 0;
        this.cueRanges = [];
        this.trackName = void 0;
        this.startTime = null;
        this.endTime = null;
        this.screen = null;
        this.timelineController = timelineController;
        this.trackName = trackName;
    }
    dispatchCue() {
        if (this.startTime === null) return;
        this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
        this.startTime = null;
    }
    newCue(startTime, endTime, screen) {
        if (this.startTime === null || this.startTime > startTime) this.startTime = startTime;
        this.endTime = endTime;
        this.screen = screen;
        this.timelineController.createCaptionsTrack(this.trackName);
    }
    reset() {
        this.cueRanges = [];
        this.startTime = null;
    }
}
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fada8102d2a280be$var$VTTCue = function() {
    if (typeof self !== "undefined" && self.VTTCue) return self.VTTCue;
    const AllowedDirections = [
        "",
        "lr",
        "rl"
    ];
    const AllowedAlignments = [
        "start",
        "middle",
        "end",
        "left",
        "right"
    ];
    function isAllowedValue(allowed, value) {
        if (typeof value !== "string") return false;
        // necessary for assuring the generic conforms to the Array interface
        if (!Array.isArray(allowed)) return false;
        // reset the type so that the next narrowing works well
        const lcValue = value.toLowerCase();
        // use the allow list to narrow the type to a specific subset of strings
        if (~allowed.indexOf(lcValue)) return lcValue;
        return false;
    }
    function findDirectionSetting(value) {
        return isAllowedValue(AllowedDirections, value);
    }
    function findAlignSetting(value) {
        return isAllowedValue(AllowedAlignments, value);
    }
    function extend(obj, ...rest) {
        let i = 1;
        for(; i < arguments.length; i++){
            const cobj = arguments[i];
            for(const p in cobj)obj[p] = cobj[p];
        }
        return obj;
    }
    function VTTCue(startTime, endTime, text) {
        const cue = this;
        const baseObj = {
            enumerable: true
        };
        /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */ // Lets us know when the VTTCue's data has changed in such a way that we need
        // to recompute its display state. This lets us compute its display state
        // lazily.
        cue.hasBeenReset = false;
        /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */ let _id = "";
        let _pauseOnExit = false;
        let _startTime = startTime;
        let _endTime = endTime;
        let _text = text;
        let _region = null;
        let _vertical = "";
        let _snapToLines = true;
        let _line = "auto";
        let _lineAlign = "start";
        let _position = 50;
        let _positionAlign = "middle";
        let _size = 50;
        let _align = "middle";
        Object.defineProperty(cue, "id", extend({}, baseObj, {
            get: function() {
                return _id;
            },
            set: function(value) {
                _id = "" + value;
            }
        }));
        Object.defineProperty(cue, "pauseOnExit", extend({}, baseObj, {
            get: function() {
                return _pauseOnExit;
            },
            set: function(value) {
                _pauseOnExit = !!value;
            }
        }));
        Object.defineProperty(cue, "startTime", extend({}, baseObj, {
            get: function() {
                return _startTime;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("Start time must be set to a number.");
                _startTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "endTime", extend({}, baseObj, {
            get: function() {
                return _endTime;
            },
            set: function(value) {
                if (typeof value !== "number") throw new TypeError("End time must be set to a number.");
                _endTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "text", extend({}, baseObj, {
            get: function() {
                return _text;
            },
            set: function(value) {
                _text = "" + value;
                this.hasBeenReset = true;
            }
        }));
        // todo: implement VTTRegion polyfill?
        Object.defineProperty(cue, "region", extend({}, baseObj, {
            get: function() {
                return _region;
            },
            set: function(value) {
                _region = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "vertical", extend({}, baseObj, {
            get: function() {
                return _vertical;
            },
            set: function(value) {
                const setting = findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) throw new SyntaxError("An invalid or illegal string was specified.");
                _vertical = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "snapToLines", extend({}, baseObj, {
            get: function() {
                return _snapToLines;
            },
            set: function(value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "line", extend({}, baseObj, {
            get: function() {
                return _line;
            },
            set: function(value) {
                if (typeof value !== "number" && value !== "auto") throw new SyntaxError("An invalid number or illegal string was specified.");
                _line = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "lineAlign", extend({}, baseObj, {
            get: function() {
                return _lineAlign;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError("An invalid or illegal string was specified.");
                _lineAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "position", extend({}, baseObj, {
            get: function() {
                return _position;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error("Position must be between 0 and 100.");
                _position = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "positionAlign", extend({}, baseObj, {
            get: function() {
                return _positionAlign;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError("An invalid or illegal string was specified.");
                _positionAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "size", extend({}, baseObj, {
            get: function() {
                return _size;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error("Size must be between 0 and 100.");
                _size = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, "align", extend({}, baseObj, {
            get: function() {
                return _align;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError("An invalid or illegal string was specified.");
                _align = setting;
                this.hasBeenReset = true;
            }
        }));
        /**
     * Other <track> spec defined properties
     */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
        cue.displayState = undefined;
    }
    /**
   * VTTCue methods
   */ VTTCue.prototype.getCueAsHTML = function() {
        // Assume WebVTT.convertCueToDOMTree is on the global.
        const WebVTT = self.WebVTT;
        return WebVTT.convertCueToDOMTree(self, this.text);
    };
    // this is a polyfill hack
    return VTTCue;
}();
/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */ class $fada8102d2a280be$var$StringDecoder {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    decode(data, options) {
        if (!data) return "";
        if (typeof data !== "string") throw new Error("Error - expected string data.");
        return decodeURIComponent(encodeURIComponent(data));
    }
}
// Try to parse input as a time stamp.
function $fada8102d2a280be$var$parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
    }
    const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
    if (!m) return null;
    if (parseFloat(m[2]) > 59) // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[2], m[3], 0, m[4]);
    // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3], m[4]);
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
class $fada8102d2a280be$var$Settings {
    constructor(){
        this.values = Object.create(null);
    }
    // Only accept the first assignment to any key.
    set(k, v) {
        if (!this.get(k) && v !== "") this.values[k] = v;
    }
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get(k, dflt, defaultKey) {
        if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
        return this.has(k) ? this.values[k] : dflt;
    }
    // Check whether we have a value for a key.
    has(k) {
        return k in this.values;
    }
    // Accept a setting if its one of the given alternatives.
    alt(k, v, a) {
        for(let n = 0; n < a.length; ++n)if (v === a[n]) {
            this.set(k, v);
            break;
        }
    }
    // Accept a setting if its a valid (signed) integer.
    integer(k, v) {
        if (/^-?\d+$/.test(v)) // integer
        this.set(k, parseInt(v, 10));
    }
    // Accept a setting if its a valid percentage.
    percent(k, v) {
        if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
            const percent = parseFloat(v);
            if (percent >= 0 && percent <= 100) {
                this.set(k, percent);
                return true;
            }
        }
        return false;
    }
}
// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function $fada8102d2a280be$var$parseOptions(input, callback, keyValueDelim, groupDelim) {
    const groups = groupDelim ? input.split(groupDelim) : [
        input
    ];
    for(const i in groups){
        if (typeof groups[i] !== "string") continue;
        const kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) continue;
        const k = kv[0];
        const v = kv[1];
        callback(k, v);
    }
}
const $fada8102d2a280be$var$defaults = new $fada8102d2a280be$var$VTTCue(0, 0, "");
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
const $fada8102d2a280be$var$center = $fada8102d2a280be$var$defaults.align === "middle" ? "middle" : "center";
function $fada8102d2a280be$var$parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    const oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        const ts = $fada8102d2a280be$var$parseTimeStamp(input);
        if (ts === null) throw new Error("Malformed timestamp: " + oInput);
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, "");
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        const settings = new $fada8102d2a280be$var$Settings();
        $fada8102d2a280be$var$parseOptions(input, function(k, v) {
            let vals;
            switch(k){
                case "region":
                    // Find the last region we parsed with the same region id.
                    for(let i = regionList.length - 1; i >= 0; i--)if (regionList[i].id === v) {
                        settings.set(k, regionList[i].region);
                        break;
                    }
                    break;
                case "vertical":
                    settings.alt(k, v, [
                        "rl",
                        "lr"
                    ]);
                    break;
                case "line":
                    vals = v.split(",");
                    settings.integer(k, vals[0]);
                    if (settings.percent(k, vals[0])) settings.set("snapToLines", false);
                    settings.alt(k, vals[0], [
                        "auto"
                    ]);
                    if (vals.length === 2) settings.alt("lineAlign", vals[1], [
                        "start",
                        $fada8102d2a280be$var$center,
                        "end"
                    ]);
                    break;
                case "position":
                    vals = v.split(",");
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) settings.alt("positionAlign", vals[1], [
                        "start",
                        $fada8102d2a280be$var$center,
                        "end",
                        "line-left",
                        "line-right",
                        "auto"
                    ]);
                    break;
                case "size":
                    settings.percent(k, v);
                    break;
                case "align":
                    settings.alt(k, v, [
                        "start",
                        $fada8102d2a280be$var$center,
                        "end",
                        "left",
                        "right"
                    ]);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get("region", null);
        cue.vertical = settings.get("vertical", "");
        let line = settings.get("line", "auto");
        if (line === "auto" && $fada8102d2a280be$var$defaults.line === -1) // set numeric line number for Safari
        line = -1;
        cue.line = line;
        cue.lineAlign = settings.get("lineAlign", "start");
        cue.snapToLines = settings.get("snapToLines", true);
        cue.size = settings.get("size", 100);
        cue.align = settings.get("align", $fada8102d2a280be$var$center);
        let position = settings.get("position", "auto");
        if (position === "auto" && $fada8102d2a280be$var$defaults.position === 50) // set numeric position for Safari
        position = cue.align === "start" || cue.align === "left" ? 0 : cue.align === "end" || cue.align === "right" ? 100 : 50;
        cue.position = position;
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, "");
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.slice(0, 3) !== "-->") // (3) next characters must match '-->'
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
    input = input.slice(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
function $fada8102d2a280be$var$fixLineBreaks(input) {
    return input.replace(/<br(?: \/)?>/gi, "\n");
}
class $fada8102d2a280be$var$VTTParser {
    constructor(){
        this.state = "INITIAL";
        this.buffer = "";
        this.decoder = new $fada8102d2a280be$var$StringDecoder();
        this.regionList = [];
        this.cue = null;
        this.oncue = void 0;
        this.onparsingerror = void 0;
        this.onflush = void 0;
    }
    parse(data) {
        const _this = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) // Try to decode the data that we received.
        _this.buffer += _this.decoder.decode(data, {
            stream: true
        });
        function collectNextLine() {
            let buffer = _this.buffer;
            let pos = 0;
            buffer = $fada8102d2a280be$var$fixLineBreaks(buffer);
            while(pos < buffer.length && buffer[pos] !== "\r" && buffer[pos] !== "\n")++pos;
            const line = buffer.slice(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === "\r") ++pos;
            if (buffer[pos] === "\n") ++pos;
            _this.buffer = buffer.slice(pos);
            return line;
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            $fada8102d2a280be$var$parseOptions(input, function(k, v) {
            // switch (k) {
            // case 'region':
            // 3.3 WebVTT region metadata header syntax
            // console.log('parse region', v);
            // parseRegion(v);
            // break;
            // }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            let line = "";
            if (_this.state === "INITIAL") {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(_this.buffer)) return this;
                line = collectNextLine();
                // strip of UTF-8 BOM if any
                // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
                const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                if (!(m != null && m[0])) throw new Error("Malformed WebVTT signature.");
                _this.state = "HEADER";
            }
            let alreadyCollectedLine = false;
            while(_this.buffer){
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(_this.buffer)) return this;
                if (!alreadyCollectedLine) line = collectNextLine();
                else alreadyCollectedLine = false;
                switch(_this.state){
                    case "HEADER":
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) parseHeader(line);
                        else if (!line) // An empty line terminates the header and starts the body (cues).
                        _this.state = "ID";
                        continue;
                    case "NOTE":
                        // Ignore NOTE blocks.
                        if (!line) _this.state = "ID";
                        continue;
                    case "ID":
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            _this.state = "NOTE";
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) continue;
                        _this.cue = new $fada8102d2a280be$var$VTTCue(0, 0, "");
                        _this.state = "CUE";
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf("-->") === -1) {
                            _this.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /* falls through */ case "CUE":
                        // 40 - Collect cue timings and settings.
                        if (!_this.cue) {
                            _this.state = "BADCUE";
                            continue;
                        }
                        try {
                            $fada8102d2a280be$var$parseCue(line, _this.cue, _this.regionList);
                        } catch (e) {
                            // In case of an error ignore rest of the cue.
                            _this.cue = null;
                            _this.state = "BADCUE";
                            continue;
                        }
                        _this.state = "CUETEXT";
                        continue;
                    case "CUETEXT":
                        {
                            const hasSubstring = line.indexOf("-->") !== -1;
                            // 34 - If we have an empty line then report the cue.
                            // 35 - If we have the special substring '-->' then report the cue,
                            // but do not collect the line as we need to process the current
                            // one as a new cue.
                            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                                // We are done parsing self cue.
                                if (_this.oncue && _this.cue) _this.oncue(_this.cue);
                                _this.cue = null;
                                _this.state = "ID";
                                continue;
                            }
                            if (_this.cue === null) continue;
                            if (_this.cue.text) _this.cue.text += "\n";
                            _this.cue.text += line;
                        }
                        continue;
                    case "BADCUE":
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) _this.state = "ID";
                }
            }
        } catch (e) {
            // If we are currently parsing a cue, report what we have.
            if (_this.state === "CUETEXT" && _this.cue && _this.oncue) _this.oncue(_this.cue);
            _this.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            _this.state = _this.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
        }
        return this;
    }
    flush() {
        const _this = this;
        try {
            // Finish decoding the stream.
            // _this.buffer += _this.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (_this.cue || _this.state === "HEADER") {
                _this.buffer += "\n\n";
                _this.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (_this.state === "INITIAL" || _this.state === "BADWEBVTT") throw new Error("Malformed WebVTT signature.");
        } catch (e) {
            if (_this.onparsingerror) _this.onparsingerror(e);
        }
        if (_this.onflush) _this.onflush();
        return this;
    }
}
const $fada8102d2a280be$var$LINEBREAKS = /\r\n|\n\r|\n|\r/g;
// String.prototype.startsWith is not supported in IE11
const $fada8102d2a280be$var$startsWith = function startsWith(inputString, searchString, position = 0) {
    return inputString.slice(position, position + searchString.length) === searchString;
};
const $fada8102d2a280be$var$cueString2millis = function cueString2millis(timeString) {
    let ts = parseInt(timeString.slice(-3));
    const secs = parseInt(timeString.slice(-6, -4));
    const mins = parseInt(timeString.slice(-9, -7));
    const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(":"))) : 0;
    if (!$fada8102d2a280be$var$isFiniteNumber(ts) || !$fada8102d2a280be$var$isFiniteNumber(secs) || !$fada8102d2a280be$var$isFiniteNumber(mins) || !$fada8102d2a280be$var$isFiniteNumber(hours)) throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
    ts += 1000 * secs;
    ts += 60000 * mins;
    ts += 3600000 * hours;
    return ts;
};
// From https://github.com/darkskyapp/string-hash
const $fada8102d2a280be$var$hash = function hash(text) {
    let _hash = 5381;
    let i = text.length;
    while(i)_hash = _hash * 33 ^ text.charCodeAt(--i);
    return (_hash >>> 0).toString();
};
// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function $fada8102d2a280be$var$generateCueId(startTime, endTime, text) {
    return $fada8102d2a280be$var$hash(startTime.toString()) + $fada8102d2a280be$var$hash(endTime.toString()) + $fada8102d2a280be$var$hash(text);
}
const $fada8102d2a280be$var$calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
    let currCC = vttCCs[cc];
    let prevCC = vttCCs[currCC.prevCC];
    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || !prevCC.new && currCC.new) {
        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
        currCC.new = false;
        return;
    }
    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while((_prevCC = prevCC) != null && _prevCC.new){
        var _prevCC;
        vttCCs.ccOffset += currCC.start - prevCC.start;
        currCC.new = false;
        currCC = prevCC;
        prevCC = vttCCs[currCC.prevCC];
    }
    vttCCs.presentationOffset = presentationTime;
};
function $fada8102d2a280be$var$parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
    const parser = new $fada8102d2a280be$var$VTTParser();
    // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
    // Uint8Array.prototype.reduce is not implemented in IE11
    const vttLines = $fada8102d2a280be$var$utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace($fada8102d2a280be$var$LINEBREAKS, "\n").split("\n");
    const cues = [];
    const init90kHz = $fada8102d2a280be$var$toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale);
    let cueTime = "00:00.000";
    let timestampMapMPEGTS = 0;
    let timestampMapLOCAL = 0;
    let parsingError;
    let inHeader = true;
    parser.oncue = function(cue) {
        // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
        const currCC = vttCCs[cc];
        let cueOffset = vttCCs.ccOffset;
        // Calculate subtitle PTS offset
        const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 90000;
        // Update offsets for new discontinuities
        if (currCC != null && currCC.new) {
            if (timestampMapLOCAL !== undefined) // When local time is provided, offset = discontinuity start time - local time
            cueOffset = vttCCs.ccOffset = currCC.start;
            else $fada8102d2a280be$var$calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
        }
        if (webVttMpegTsMapOffset) // If we have MPEGTS, offset = presentation time + discontinuity offset
        cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
        const duration = cue.endTime - cue.startTime;
        const startTime = $fada8102d2a280be$var$normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
        cue.startTime = Math.max(startTime, 0);
        cue.endTime = Math.max(startTime + duration, 0);
        //trim trailing webvtt block whitespaces
        const text = cue.text.trim();
        // Fix encoding of special characters
        cue.text = decodeURIComponent(encodeURIComponent(text));
        // If the cue was not assigned an id from the VTT file (line above the content), create one.
        if (!cue.id) cue.id = $fada8102d2a280be$var$generateCueId(cue.startTime, cue.endTime, text);
        if (cue.endTime > 0) cues.push(cue);
    };
    parser.onparsingerror = function(error) {
        parsingError = error;
    };
    parser.onflush = function() {
        if (parsingError) {
            errorCallBack(parsingError);
            return;
        }
        callBack(cues);
    };
    // Go through contents line by line.
    vttLines.forEach((line)=>{
        if (inHeader) {
            // Look for X-TIMESTAMP-MAP in header.
            if ($fada8102d2a280be$var$startsWith(line, "X-TIMESTAMP-MAP=")) {
                // Once found, no more are allowed anyway, so stop searching.
                inHeader = false;
                // Extract LOCAL and MPEGTS.
                line.slice(16).split(",").forEach((timestamp)=>{
                    if ($fada8102d2a280be$var$startsWith(timestamp, "LOCAL:")) cueTime = timestamp.slice(6);
                    else if ($fada8102d2a280be$var$startsWith(timestamp, "MPEGTS:")) timestampMapMPEGTS = parseInt(timestamp.slice(7));
                });
                try {
                    // Convert cue time to seconds
                    timestampMapLOCAL = $fada8102d2a280be$var$cueString2millis(cueTime) / 1000;
                } catch (error) {
                    parsingError = error;
                }
                // Return without parsing X-TIMESTAMP-MAP line.
                return;
            } else if (line === "") inHeader = false;
        }
        // Parse line by default.
        parser.parse(line + "\n");
    });
    parser.flush();
}
const $fada8102d2a280be$var$IMSC1_CODEC = "stpp.ttml.im1t";
// Time format: h:m:s:frames(.subframes)
const $fada8102d2a280be$var$HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;
// Time format: hours, minutes, seconds, milliseconds, frames, ticks
const $fada8102d2a280be$var$TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
const $fada8102d2a280be$var$textAlignToLineAlign = {
    left: "start",
    center: "center",
    right: "end",
    start: "start",
    end: "end"
};
function $fada8102d2a280be$var$parseIMSC1(payload, initPTS, callBack, errorCallBack) {
    const results = $fada8102d2a280be$var$findBox(new Uint8Array(payload), [
        "mdat"
    ]);
    if (results.length === 0) {
        errorCallBack(new Error("Could not parse IMSC1 mdat"));
        return;
    }
    const ttmlList = results.map((mdat)=>$fada8102d2a280be$var$utf8ArrayToStr(mdat));
    const syncTime = $fada8102d2a280be$var$toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
    try {
        ttmlList.forEach((ttml)=>callBack($fada8102d2a280be$var$parseTTML(ttml, syncTime)));
    } catch (error) {
        errorCallBack(error);
    }
}
function $fada8102d2a280be$var$parseTTML(ttml, syncTime) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(ttml, "text/xml");
    const tt = xmlDoc.getElementsByTagName("tt")[0];
    if (!tt) throw new Error("Invalid ttml");
    const defaultRateInfo = {
        frameRate: 30,
        subFrameRate: 1,
        frameRateMultiplier: 0,
        tickRate: 0
    };
    const rateInfo = Object.keys(defaultRateInfo).reduce((result, key)=>{
        result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
        return result;
    }, {});
    const trim = tt.getAttribute("xml:space") !== "preserve";
    const styleElements = $fada8102d2a280be$var$collectionToDictionary($fada8102d2a280be$var$getElementCollection(tt, "styling", "style"));
    const regionElements = $fada8102d2a280be$var$collectionToDictionary($fada8102d2a280be$var$getElementCollection(tt, "layout", "region"));
    const cueElements = $fada8102d2a280be$var$getElementCollection(tt, "body", "[begin]");
    return [].map.call(cueElements, (cueElement)=>{
        const cueText = $fada8102d2a280be$var$getTextContent(cueElement, trim);
        if (!cueText || !cueElement.hasAttribute("begin")) return null;
        const startTime = $fada8102d2a280be$var$parseTtmlTime(cueElement.getAttribute("begin"), rateInfo);
        const duration = $fada8102d2a280be$var$parseTtmlTime(cueElement.getAttribute("dur"), rateInfo);
        let endTime = $fada8102d2a280be$var$parseTtmlTime(cueElement.getAttribute("end"), rateInfo);
        if (startTime === null) throw $fada8102d2a280be$var$timestampParsingError(cueElement);
        if (endTime === null) {
            if (duration === null) throw $fada8102d2a280be$var$timestampParsingError(cueElement);
            endTime = startTime + duration;
        }
        const cue = new $fada8102d2a280be$var$VTTCue(startTime - syncTime, endTime - syncTime, cueText);
        cue.id = $fada8102d2a280be$var$generateCueId(cue.startTime, cue.endTime, cue.text);
        const region = regionElements[cueElement.getAttribute("region")];
        const style = styleElements[cueElement.getAttribute("style")];
        // Apply styles to cue
        const styles = $fada8102d2a280be$var$getTtmlStyles(region, style, styleElements);
        const { textAlign: textAlign } = styles;
        if (textAlign) {
            // cue.positionAlign not settable in FF~2016
            const lineAlign = $fada8102d2a280be$var$textAlignToLineAlign[textAlign];
            if (lineAlign) cue.lineAlign = lineAlign;
            cue.align = textAlign;
        }
        $fada8102d2a280be$var$_extends(cue, styles);
        return cue;
    }).filter((cue)=>cue !== null);
}
function $fada8102d2a280be$var$getElementCollection(fromElement, parentName, childName) {
    const parent = fromElement.getElementsByTagName(parentName)[0];
    if (parent) return [].slice.call(parent.querySelectorAll(childName));
    return [];
}
function $fada8102d2a280be$var$collectionToDictionary(elementsWithId) {
    return elementsWithId.reduce((dict, element)=>{
        const id = element.getAttribute("xml:id");
        if (id) dict[id] = element;
        return dict;
    }, {});
}
function $fada8102d2a280be$var$getTextContent(element, trim) {
    return [].slice.call(element.childNodes).reduce((str, node, i)=>{
        var _node$childNodes;
        if (node.nodeName === "br" && i) return str + "\n";
        if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) return $fada8102d2a280be$var$getTextContent(node, trim);
        else if (trim) return str + node.textContent.trim().replace(/\s+/g, " ");
        return str + node.textContent;
    }, "");
}
function $fada8102d2a280be$var$getTtmlStyles(region, style, styleElements) {
    const ttsNs = "http://www.w3.org/ns/ttml#styling";
    let regionStyle = null;
    const styleAttributes = [
        "displayAlign",
        "textAlign",
        "color",
        "backgroundColor",
        "fontSize",
        "fontFamily"
    ];
    const regionStyleName = region != null && region.hasAttribute("style") ? region.getAttribute("style") : null;
    if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) regionStyle = styleElements[regionStyleName];
    return styleAttributes.reduce((styles, name)=>{
        const value = $fada8102d2a280be$var$getAttributeNS(style, ttsNs, name) || $fada8102d2a280be$var$getAttributeNS(region, ttsNs, name) || $fada8102d2a280be$var$getAttributeNS(regionStyle, ttsNs, name);
        if (value) styles[name] = value;
        return styles;
    }, {});
}
function $fada8102d2a280be$var$getAttributeNS(element, ns, name) {
    if (!element) return null;
    return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function $fada8102d2a280be$var$timestampParsingError(node) {
    return new Error(`Could not parse ttml timestamp ${node}`);
}
function $fada8102d2a280be$var$parseTtmlTime(timeAttributeValue, rateInfo) {
    if (!timeAttributeValue) return null;
    let seconds = $fada8102d2a280be$var$parseTimeStamp(timeAttributeValue);
    if (seconds === null) {
        if ($fada8102d2a280be$var$HMSF_REGEX.test(timeAttributeValue)) seconds = $fada8102d2a280be$var$parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
        else if ($fada8102d2a280be$var$TIME_UNIT_REGEX.test(timeAttributeValue)) seconds = $fada8102d2a280be$var$parseTimeUnits(timeAttributeValue, rateInfo);
    }
    return seconds;
}
function $fada8102d2a280be$var$parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
    const m = $fada8102d2a280be$var$HMSF_REGEX.exec(timeAttributeValue);
    const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
    return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function $fada8102d2a280be$var$parseTimeUnits(timeAttributeValue, rateInfo) {
    const m = $fada8102d2a280be$var$TIME_UNIT_REGEX.exec(timeAttributeValue);
    const value = Number(m[1]);
    const unit = m[2];
    switch(unit){
        case "h":
            return value * 3600;
        case "m":
            return value * 60;
        case "ms":
            return value * 1000;
        case "f":
            return value / rateInfo.frameRate;
        case "t":
            return value / rateInfo.tickRate;
    }
    return value;
}
class $fada8102d2a280be$var$TimelineController {
    constructor(hls){
        this.hls = void 0;
        this.media = null;
        this.config = void 0;
        this.enabled = true;
        this.Cues = void 0;
        this.textTracks = [];
        this.tracks = [];
        this.initPTS = [];
        this.unparsedVttFrags = [];
        this.captionsTracks = {};
        this.nonNativeCaptionsTracks = {};
        this.cea608Parser1 = void 0;
        this.cea608Parser2 = void 0;
        this.lastSn = -1;
        this.lastPartIndex = -1;
        this.prevCC = -1;
        this.vttCCs = $fada8102d2a280be$var$newVTTCCs();
        this.captionsProperties = void 0;
        this.hls = hls;
        this.config = hls.config;
        this.Cues = hls.config.cueHandler;
        this.captionsProperties = {
            textTrack1: {
                label: this.config.captionsTextTrack1Label,
                languageCode: this.config.captionsTextTrack1LanguageCode
            },
            textTrack2: {
                label: this.config.captionsTextTrack2Label,
                languageCode: this.config.captionsTextTrack2LanguageCode
            },
            textTrack3: {
                label: this.config.captionsTextTrack3Label,
                languageCode: this.config.captionsTextTrack3LanguageCode
            },
            textTrack4: {
                label: this.config.captionsTextTrack4Label,
                languageCode: this.config.captionsTextTrack4LanguageCode
            }
        };
        if (this.config.enableCEA708Captions) {
            const channel1 = new $fada8102d2a280be$var$OutputFilter(this, "textTrack1");
            const channel2 = new $fada8102d2a280be$var$OutputFilter(this, "textTrack2");
            const channel3 = new $fada8102d2a280be$var$OutputFilter(this, "textTrack3");
            const channel4 = new $fada8102d2a280be$var$OutputFilter(this, "textTrack4");
            this.cea608Parser1 = new $fada8102d2a280be$var$Cea608Parser(1, channel1, channel2);
            this.cea608Parser2 = new $fada8102d2a280be$var$Cea608Parser(3, channel3, channel4);
        }
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($fada8102d2a280be$var$Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_LOADING, this.onFragLoading, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
        hls.on($fada8102d2a280be$var$Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
        hls.on($fada8102d2a280be$var$Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.on($fada8102d2a280be$var$Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    }
    destroy() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($fada8102d2a280be$var$Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_LOADING, this.onFragLoading, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_LOADED, this.onFragLoaded, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
        hls.off($fada8102d2a280be$var$Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
        hls.off($fada8102d2a280be$var$Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.off($fada8102d2a280be$var$Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
        // @ts-ignore
        this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null;
    }
    addCues(trackName, startTime, endTime, screen, cueRanges) {
        // skip cues which overlap more than 50% with previously parsed time ranges
        let merged = false;
        for(let i = cueRanges.length; i--;){
            const cueRange = cueRanges[i];
            const overlap = $fada8102d2a280be$var$intersection(cueRange[0], cueRange[1], startTime, endTime);
            if (overlap >= 0) {
                cueRange[0] = Math.min(cueRange[0], startTime);
                cueRange[1] = Math.max(cueRange[1], endTime);
                merged = true;
                if (overlap / (endTime - startTime) > 0.5) return;
            }
        }
        if (!merged) cueRanges.push([
            startTime,
            endTime
        ]);
        if (this.config.renderTextTracksNatively) {
            const track = this.captionsTracks[trackName];
            this.Cues.newCue(track, startTime, endTime, screen);
        } else {
            const cues = this.Cues.newCue(null, startTime, endTime, screen);
            this.hls.trigger($fada8102d2a280be$var$Events.CUES_PARSED, {
                type: "captions",
                cues: cues,
                track: trackName
            });
        }
    }
    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
    onInitPtsFound(event, { frag: frag, id: id, initPTS: initPTS, timescale: timescale }) {
        const { unparsedVttFrags: unparsedVttFrags } = this;
        if (id === "main") this.initPTS[frag.cc] = {
            baseTime: initPTS,
            timescale: timescale
        };
        // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
        // Parse any unparsed fragments upon receiving the initial PTS.
        if (unparsedVttFrags.length) {
            this.unparsedVttFrags = [];
            unparsedVttFrags.forEach((frag)=>{
                this.onFragLoaded($fada8102d2a280be$var$Events.FRAG_LOADED, frag);
            });
        }
    }
    getExistingTrack(trackName) {
        const { media: media } = this;
        if (media) for(let i = 0; i < media.textTracks.length; i++){
            const textTrack = media.textTracks[i];
            if (textTrack[trackName]) return textTrack;
        }
        return null;
    }
    createCaptionsTrack(trackName) {
        if (this.config.renderTextTracksNatively) this.createNativeTrack(trackName);
        else this.createNonNativeTrack(trackName);
    }
    createNativeTrack(trackName) {
        if (this.captionsTracks[trackName]) return;
        const { captionsProperties: captionsProperties, captionsTracks: captionsTracks, media: media } = this;
        const { label: label, languageCode: languageCode } = captionsProperties[trackName];
        // Enable reuse of existing text track.
        const existingTrack = this.getExistingTrack(trackName);
        if (!existingTrack) {
            const textTrack = this.createTextTrack("captions", label, languageCode);
            if (textTrack) {
                // Set a special property on the track so we know it's managed by Hls.js
                textTrack[trackName] = true;
                captionsTracks[trackName] = textTrack;
            }
        } else {
            captionsTracks[trackName] = existingTrack;
            $fada8102d2a280be$var$clearCurrentCues(captionsTracks[trackName]);
            $fada8102d2a280be$var$sendAddTrackEvent(captionsTracks[trackName], media);
        }
    }
    createNonNativeTrack(trackName) {
        if (this.nonNativeCaptionsTracks[trackName]) return;
        // Create a list of a single track for the provider to consume
        const trackProperties = this.captionsProperties[trackName];
        if (!trackProperties) return;
        const label = trackProperties.label;
        const track = {
            _id: trackName,
            label: label,
            kind: "captions",
            default: trackProperties.media ? !!trackProperties.media.default : false,
            closedCaptions: trackProperties.media
        };
        this.nonNativeCaptionsTracks[trackName] = track;
        this.hls.trigger($fada8102d2a280be$var$Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
            tracks: [
                track
            ]
        });
    }
    createTextTrack(kind, label, lang) {
        const media = this.media;
        if (!media) return;
        return media.addTextTrack(kind, label, lang);
    }
    onMediaAttaching(event, data) {
        this.media = data.media;
        this._cleanTracks();
    }
    onMediaDetaching() {
        const { captionsTracks: captionsTracks } = this;
        Object.keys(captionsTracks).forEach((trackName)=>{
            $fada8102d2a280be$var$clearCurrentCues(captionsTracks[trackName]);
            delete captionsTracks[trackName];
        });
        this.nonNativeCaptionsTracks = {};
    }
    onManifestLoading() {
        this.lastSn = -1; // Detect discontinuity in fragment parsing
        this.lastPartIndex = -1;
        this.prevCC = -1;
        this.vttCCs = $fada8102d2a280be$var$newVTTCCs(); // Detect discontinuity in subtitle manifests
        this._cleanTracks();
        this.tracks = [];
        this.captionsTracks = {};
        this.nonNativeCaptionsTracks = {};
        this.textTracks = [];
        this.unparsedVttFrags = this.unparsedVttFrags || [];
        this.initPTS = [];
        if (this.cea608Parser1 && this.cea608Parser2) {
            this.cea608Parser1.reset();
            this.cea608Parser2.reset();
        }
    }
    _cleanTracks() {
        // clear outdated subtitles
        const { media: media } = this;
        if (!media) return;
        const textTracks = media.textTracks;
        if (textTracks) for(let i = 0; i < textTracks.length; i++)$fada8102d2a280be$var$clearCurrentCues(textTracks[i]);
    }
    onSubtitleTracksUpdated(event, data) {
        const tracks = data.subtitleTracks || [];
        const hasIMSC1 = tracks.some((track)=>track.textCodec === $fada8102d2a280be$var$IMSC1_CODEC);
        if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
            const listIsIdentical = $fada8102d2a280be$var$subtitleOptionsIdentical(this.tracks, tracks);
            if (listIsIdentical) {
                this.tracks = tracks;
                return;
            }
            this.textTracks = [];
            this.tracks = tracks;
            if (this.config.renderTextTracksNatively) {
                const inUseTracks = this.media ? this.media.textTracks : null;
                this.tracks.forEach((track, index)=>{
                    let textTrack;
                    if (inUseTracks && index < inUseTracks.length) {
                        let inUseTrack = null;
                        for(let i = 0; i < inUseTracks.length; i++)if ($fada8102d2a280be$var$canReuseVttTextTrack(inUseTracks[i], track)) {
                            inUseTrack = inUseTracks[i];
                            break;
                        }
                        // Reuse tracks with the same label, but do not reuse 608/708 tracks
                        if (inUseTrack) textTrack = inUseTrack;
                    }
                    if (textTrack) $fada8102d2a280be$var$clearCurrentCues(textTrack);
                    else {
                        const textTrackKind = this._captionsOrSubtitlesFromCharacteristics(track);
                        textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
                        if (textTrack) textTrack.mode = "disabled";
                    }
                    if (textTrack) {
                        textTrack.groupId = track.groupId;
                        this.textTracks.push(textTrack);
                    }
                });
            } else if (this.tracks.length) {
                // Create a list of tracks for the provider to consume
                const tracksList = this.tracks.map((track)=>{
                    return {
                        label: track.name,
                        kind: track.type.toLowerCase(),
                        default: track.default,
                        subtitleTrack: track
                    };
                });
                this.hls.trigger($fada8102d2a280be$var$Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                    tracks: tracksList
                });
            }
        }
    }
    _captionsOrSubtitlesFromCharacteristics(track) {
        if (track.attrs.CHARACTERISTICS) {
            const transcribesSpokenDialog = /transcribes-spoken-dialog/gi.test(track.attrs.CHARACTERISTICS);
            const describesMusicAndSound = /describes-music-and-sound/gi.test(track.attrs.CHARACTERISTICS);
            if (transcribesSpokenDialog && describesMusicAndSound) return "captions";
        }
        return "subtitles";
    }
    onManifestLoaded(event, data) {
        if (this.config.enableCEA708Captions && data.captions) data.captions.forEach((captionsTrack)=>{
            const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
            if (!instreamIdMatch) return;
            const trackName = `textTrack${instreamIdMatch[1]}`;
            const trackProperties = this.captionsProperties[trackName];
            if (!trackProperties) return;
            trackProperties.label = captionsTrack.name;
            if (captionsTrack.lang) // optional attribute
            trackProperties.languageCode = captionsTrack.lang;
            trackProperties.media = captionsTrack;
        });
    }
    closedCaptionsForLevel(frag) {
        const level = this.hls.levels[frag.level];
        return level == null ? void 0 : level.attrs["CLOSED-CAPTIONS"];
    }
    onFragLoading(event, data) {
        const { cea608Parser1: cea608Parser1, cea608Parser2: cea608Parser2, lastSn: lastSn, lastPartIndex: lastPartIndex } = this;
        if (!this.enabled || !(cea608Parser1 && cea608Parser2)) return;
        // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
        if (data.frag.type === $fada8102d2a280be$var$PlaylistLevelType.MAIN) {
            var _data$part$index, _data$part;
            const sn = data.frag.sn;
            const partIndex = (_data$part$index = data == null ? void 0 : (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
            if (!(sn === lastSn + 1 || sn === lastSn && partIndex === lastPartIndex + 1)) {
                cea608Parser1.reset();
                cea608Parser2.reset();
            }
            this.lastSn = sn;
            this.lastPartIndex = partIndex;
        }
    }
    onFragLoaded(event, data) {
        const { frag: frag, payload: payload } = data;
        const { initPTS: initPTS, unparsedVttFrags: unparsedVttFrags } = this;
        if (frag.type === $fada8102d2a280be$var$PlaylistLevelType.SUBTITLE) {
            // If fragment is subtitle type, parse as WebVTT.
            if (payload.byteLength) {
                // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
                if (!initPTS[frag.cc]) {
                    unparsedVttFrags.push(data);
                    if (initPTS.length) // finish unsuccessfully, otherwise the subtitle-stream-controller could be blocked from loading new frags.
                    this.hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_FRAG_PROCESSED, {
                        success: false,
                        frag: frag,
                        error: new Error("Missing initial subtitle PTS")
                    });
                    return;
                }
                const decryptData = frag.decryptdata;
                // fragment after decryption has a stats object
                const decrypted = "stats" in data;
                // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
                if (decryptData == null || !decryptData.encrypted || decrypted) {
                    const trackPlaylistMedia = this.tracks[frag.level];
                    const vttCCs = this.vttCCs;
                    if (!vttCCs[frag.cc]) {
                        vttCCs[frag.cc] = {
                            start: frag.start,
                            prevCC: this.prevCC,
                            new: true
                        };
                        this.prevCC = frag.cc;
                    }
                    if (trackPlaylistMedia && trackPlaylistMedia.textCodec === $fada8102d2a280be$var$IMSC1_CODEC) this._parseIMSC1(frag, payload);
                    else this._parseVTTs(frag, payload, vttCCs);
                }
            } else // In case there is no payload, finish unsuccessfully.
            this.hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: new Error("Empty subtitle payload")
            });
        }
    }
    _parseIMSC1(frag, payload) {
        const hls = this.hls;
        $fada8102d2a280be$var$parseIMSC1(payload, this.initPTS[frag.cc], (cues)=>{
            this._appendCues(cues, frag.level);
            hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_FRAG_PROCESSED, {
                success: true,
                frag: frag
            });
        }, (error)=>{
            $fada8102d2a280be$var$logger.log(`Failed to parse IMSC1: ${error}`);
            hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: error
            });
        });
    }
    _parseVTTs(frag, payload, vttCCs) {
        var _frag$initSegment;
        const hls = this.hls;
        // Parse the WebVTT file contents.
        const payloadWebVTT = (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? $fada8102d2a280be$var$appendUint8Array(frag.initSegment.data, new Uint8Array(payload)) : payload;
        $fada8102d2a280be$var$parseWebVTT(payloadWebVTT, this.initPTS[frag.cc], vttCCs, frag.cc, frag.start, (cues)=>{
            this._appendCues(cues, frag.level);
            hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_FRAG_PROCESSED, {
                success: true,
                frag: frag
            });
        }, (error)=>{
            this._fallbackToIMSC1(frag, payload);
            // Something went wrong while parsing. Trigger event with success false.
            $fada8102d2a280be$var$logger.log(`Failed to parse VTT cue: ${error}`);
            hls.trigger($fada8102d2a280be$var$Events.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: error
            });
        });
    }
    _fallbackToIMSC1(frag, payload) {
        // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
        const trackPlaylistMedia = this.tracks[frag.level];
        if (!trackPlaylistMedia.textCodec) $fada8102d2a280be$var$parseIMSC1(payload, this.initPTS[frag.cc], ()=>{
            trackPlaylistMedia.textCodec = $fada8102d2a280be$var$IMSC1_CODEC;
            this._parseIMSC1(frag, payload);
        }, ()=>{
            trackPlaylistMedia.textCodec = "wvtt";
        });
    }
    _appendCues(cues, fragLevel) {
        const hls = this.hls;
        if (this.config.renderTextTracksNatively) {
            const textTrack = this.textTracks[fragLevel];
            // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
            // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
            // and trying to access getCueById method of cues will throw an exception
            // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
            if (!textTrack || textTrack.mode === "disabled") return;
            cues.forEach((cue)=>$fada8102d2a280be$var$addCueToTrack(textTrack, cue));
        } else {
            const currentTrack = this.tracks[fragLevel];
            if (!currentTrack) return;
            const track = currentTrack.default ? "default" : "subtitles" + fragLevel;
            hls.trigger($fada8102d2a280be$var$Events.CUES_PARSED, {
                type: "subtitles",
                cues: cues,
                track: track
            });
        }
    }
    onFragDecrypted(event, data) {
        const { frag: frag } = data;
        if (frag.type === $fada8102d2a280be$var$PlaylistLevelType.SUBTITLE) {
            if (!this.initPTS[frag.cc]) {
                this.unparsedVttFrags.push(data);
                return;
            }
            this.onFragLoaded($fada8102d2a280be$var$Events.FRAG_LOADED, data);
        }
    }
    onSubtitleTracksCleared() {
        this.tracks = [];
        this.captionsTracks = {};
    }
    onFragParsingUserdata(event, data) {
        const { cea608Parser1: cea608Parser1, cea608Parser2: cea608Parser2 } = this;
        if (!this.enabled || !(cea608Parser1 && cea608Parser2)) return;
        const { frag: frag, samples: samples } = data;
        if (frag.type === $fada8102d2a280be$var$PlaylistLevelType.MAIN && this.closedCaptionsForLevel(frag) === "NONE") return;
        // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
        // It will create the proper timestamps based on the PTS value
        for(let i = 0; i < samples.length; i++){
            const ccBytes = samples[i].bytes;
            if (ccBytes) {
                const ccdatas = this.extractCea608Data(ccBytes);
                cea608Parser1.addData(samples[i].pts, ccdatas[0]);
                cea608Parser2.addData(samples[i].pts, ccdatas[1]);
            }
        }
    }
    onBufferFlushing(event, { startOffset: startOffset, endOffset: endOffset, endOffsetSubtitles: endOffsetSubtitles, type: type }) {
        const { media: media } = this;
        if (!media || media.currentTime < endOffset) return;
        // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
        // Forward cues are never removed because we can loose streamed 608 content from recent fragments
        if (!type || type === "video") {
            const { captionsTracks: captionsTracks } = this;
            Object.keys(captionsTracks).forEach((trackName)=>$fada8102d2a280be$var$removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
        }
        if (this.config.renderTextTracksNatively) // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
        {
            if (startOffset === 0 && endOffsetSubtitles !== undefined) {
                const { textTracks: textTracks } = this;
                Object.keys(textTracks).forEach((trackName)=>$fada8102d2a280be$var$removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
            }
        }
    }
    extractCea608Data(byteArray) {
        const actualCCBytes = [
            [],
            []
        ];
        const count = byteArray[0] & 0x1f;
        let position = 2;
        for(let j = 0; j < count; j++){
            const tmpByte = byteArray[position++];
            const ccbyte1 = 0x7f & byteArray[position++];
            const ccbyte2 = 0x7f & byteArray[position++];
            if (ccbyte1 === 0 && ccbyte2 === 0) continue;
            const ccValid = (0x04 & tmpByte) !== 0; // Support all four channels
            if (ccValid) {
                const ccType = 0x03 & tmpByte;
                if (0x00 /* CEA608 field1*/  === ccType || 0x01 /* CEA608 field2*/  === ccType) {
                    // Exclude CEA708 CC data.
                    actualCCBytes[ccType].push(ccbyte1);
                    actualCCBytes[ccType].push(ccbyte2);
                }
            }
        }
        return actualCCBytes;
    }
}
function $fada8102d2a280be$var$canReuseVttTextTrack(inUseTrack, manifestTrack) {
    return !!inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
}
function $fada8102d2a280be$var$intersection(x1, x2, y1, y2) {
    return Math.min(x2, y2) - Math.max(x1, y1);
}
function $fada8102d2a280be$var$newVTTCCs() {
    return {
        ccOffset: 0,
        presentationOffset: 0,
        0: {
            start: 0,
            prevCC: -1,
            new: true
        }
    };
}
/*
 * cap stream level to media size dimension controller
 */ class $fada8102d2a280be$var$CapLevelController {
    constructor(hls){
        this.hls = void 0;
        this.autoLevelCapping = void 0;
        this.firstLevel = void 0;
        this.media = void 0;
        this.restrictedLevels = void 0;
        this.timer = void 0;
        this.clientRect = void 0;
        this.streamController = void 0;
        this.hls = hls;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.firstLevel = -1;
        this.media = null;
        this.restrictedLevels = [];
        this.timer = undefined;
        this.clientRect = null;
        this.registerListeners();
    }
    setStreamController(streamController) {
        this.streamController = streamController;
    }
    destroy() {
        this.unregisterListener();
        if (this.hls.config.capLevelToPlayerSize) this.stopCapping();
        this.media = null;
        this.clientRect = null;
        // @ts-ignore
        this.hls = this.streamController = null;
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($fada8102d2a280be$var$Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    unregisterListener() {
        const { hls: hls } = this;
        hls.off($fada8102d2a280be$var$Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    onFpsDropLevelCapping(event, data) {
        // Don't add a restricted level more than once
        const level = this.hls.levels[data.droppedLevel];
        if (this.isLevelAllowed(level)) this.restrictedLevels.push({
            bitrate: level.bitrate,
            height: level.height,
            width: level.width
        });
    }
    onMediaAttaching(event, data) {
        this.media = data.media instanceof HTMLVideoElement ? data.media : null;
        this.clientRect = null;
    }
    onManifestParsed(event, data) {
        const hls = this.hls;
        this.restrictedLevels = [];
        this.firstLevel = data.firstLevel;
        if (hls.config.capLevelToPlayerSize && data.video) // Start capping immediately if the manifest has signaled video codecs
        this.startCapping();
    }
    // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
    // to the first level
    onBufferCodecs(event, data) {
        const hls = this.hls;
        if (hls.config.capLevelToPlayerSize && data.video) // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
        this.startCapping();
    }
    onMediaDetaching() {
        this.stopCapping();
    }
    detectPlayerSize() {
        if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
            const levels = this.hls.levels;
            if (levels.length) {
                const hls = this.hls;
                hls.autoLevelCapping = this.getMaxLevel(levels.length - 1);
                if (hls.autoLevelCapping > this.autoLevelCapping && this.streamController) // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
                // usually happen when the user go to the fullscreen mode.
                this.streamController.nextLevelSwitch();
                this.autoLevelCapping = hls.autoLevelCapping;
            }
        }
    }
    /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */ getMaxLevel(capLevelIndex) {
        const levels = this.hls.levels;
        if (!levels.length) return -1;
        const validLevels = levels.filter((level, index)=>this.isLevelAllowed(level) && index <= capLevelIndex);
        this.clientRect = null;
        return $fada8102d2a280be$var$CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
    }
    startCapping() {
        if (this.timer) // Don't reset capping if started twice; this can happen if the manifest signals a video codec
        return;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.hls.firstLevel = this.getMaxLevel(this.firstLevel);
        self.clearInterval(this.timer);
        this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
    }
    stopCapping() {
        this.restrictedLevels = [];
        this.firstLevel = -1;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) {
            self.clearInterval(this.timer);
            this.timer = undefined;
        }
    }
    getDimensions() {
        if (this.clientRect) return this.clientRect;
        const media = this.media;
        const boundsRect = {
            width: 0,
            height: 0
        };
        if (media) {
            const clientRect = media.getBoundingClientRect();
            boundsRect.width = clientRect.width;
            boundsRect.height = clientRect.height;
            if (!boundsRect.width && !boundsRect.height) {
                // When the media element has no width or height (equivalent to not being in the DOM),
                // then use its width and height attributes (media.width, media.height)
                boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
                boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
            }
        }
        this.clientRect = boundsRect;
        return boundsRect;
    }
    get mediaWidth() {
        return this.getDimensions().width * this.contentScaleFactor;
    }
    get mediaHeight() {
        return this.getDimensions().height * this.contentScaleFactor;
    }
    get contentScaleFactor() {
        let pixelRatio = 1;
        if (!this.hls.config.ignoreDevicePixelRatio) try {
            pixelRatio = self.devicePixelRatio;
        } catch (e) {
        /* no-op */ }
        return pixelRatio;
    }
    isLevelAllowed(level) {
        const restrictedLevels = this.restrictedLevels;
        return !restrictedLevels.some((restrictedLevel)=>{
            return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
        });
    }
    static getMaxLevelByMediaSize(levels, width, height) {
        if (!(levels != null && levels.length)) return -1;
        // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
        // to determine whether we've chosen the greatest bandwidth for the media's dimensions
        const atGreatestBandwidth = (curLevel, nextLevel)=>{
            if (!nextLevel) return true;
            return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
        };
        // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
        // the max level
        let maxLevelIndex = levels.length - 1;
        for(let i = 0; i < levels.length; i += 1){
            const level = levels[i];
            if ((level.width >= width || level.height >= height) && atGreatestBandwidth(level, levels[i + 1])) {
                maxLevelIndex = i;
                break;
            }
        }
        return maxLevelIndex;
    }
}
class $fada8102d2a280be$var$FPSController {
    // stream controller must be provided as a dependency!
    constructor(hls){
        this.hls = void 0;
        this.isVideoPlaybackQualityAvailable = false;
        this.timer = void 0;
        this.media = null;
        this.lastTime = void 0;
        this.lastDroppedFrames = 0;
        this.lastDecodedFrames = 0;
        this.streamController = void 0;
        this.hls = hls;
        this.registerListeners();
    }
    setStreamController(streamController) {
        this.streamController = streamController;
    }
    registerListeners() {
        this.hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    }
    unregisterListeners() {
        this.hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    }
    destroy() {
        if (this.timer) clearInterval(this.timer);
        this.unregisterListeners();
        this.isVideoPlaybackQualityAvailable = false;
        this.media = null;
    }
    onMediaAttaching(event, data) {
        const config = this.hls.config;
        if (config.capLevelOnFPSDrop) {
            const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
            this.media = media;
            if (media && typeof media.getVideoPlaybackQuality === "function") this.isVideoPlaybackQualityAvailable = true;
            self.clearInterval(this.timer);
            this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
        }
    }
    checkFPS(video, decodedFrames, droppedFrames) {
        const currentTime = performance.now();
        if (decodedFrames) {
            if (this.lastTime) {
                const currentPeriod = currentTime - this.lastTime;
                const currentDropped = droppedFrames - this.lastDroppedFrames;
                const currentDecoded = decodedFrames - this.lastDecodedFrames;
                const droppedFPS = 1000 * currentDropped / currentPeriod;
                const hls = this.hls;
                hls.trigger($fada8102d2a280be$var$Events.FPS_DROP, {
                    currentDropped: currentDropped,
                    currentDecoded: currentDecoded,
                    totalDroppedFrames: droppedFrames
                });
                if (droppedFPS > 0) // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
                {
                    if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
                        let currentLevel = hls.currentLevel;
                        $fada8102d2a280be$var$logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + currentLevel);
                        if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                            currentLevel = currentLevel - 1;
                            hls.trigger($fada8102d2a280be$var$Events.FPS_DROP_LEVEL_CAPPING, {
                                level: currentLevel,
                                droppedLevel: hls.currentLevel
                            });
                            hls.autoLevelCapping = currentLevel;
                            this.streamController.nextLevelSwitch();
                        }
                    }
                }
            }
            this.lastTime = currentTime;
            this.lastDroppedFrames = droppedFrames;
            this.lastDecodedFrames = decodedFrames;
        }
    }
    checkFPSInterval() {
        const video = this.media;
        if (video) {
            if (this.isVideoPlaybackQualityAvailable) {
                const videoPlaybackQuality = video.getVideoPlaybackQuality();
                this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
            } else // HTMLVideoElement doesn't include the webkit types
            this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
        }
    }
}
const $fada8102d2a280be$var$LOGGER_PREFIX = "[eme]";
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */ class $fada8102d2a280be$var$EMEController {
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = null;
        this.keyFormatPromise = null;
        this.keySystemAccessPromises = {};
        this._requestLicenseFailureCount = 0;
        this.mediaKeySessions = [];
        this.keyIdToKeySessionPromise = {};
        this.setMediaKeysQueue = $fada8102d2a280be$var$EMEController.CDMCleanupPromise ? [
            $fada8102d2a280be$var$EMEController.CDMCleanupPromise
        ] : [];
        this.onMediaEncrypted = this._onMediaEncrypted.bind(this);
        this.onWaitingForKey = this._onWaitingForKey.bind(this);
        this.debug = $fada8102d2a280be$var$logger.debug.bind($fada8102d2a280be$var$logger, $fada8102d2a280be$var$LOGGER_PREFIX);
        this.log = $fada8102d2a280be$var$logger.log.bind($fada8102d2a280be$var$logger, $fada8102d2a280be$var$LOGGER_PREFIX);
        this.warn = $fada8102d2a280be$var$logger.warn.bind($fada8102d2a280be$var$logger, $fada8102d2a280be$var$LOGGER_PREFIX);
        this.error = $fada8102d2a280be$var$logger.error.bind($fada8102d2a280be$var$logger, $fada8102d2a280be$var$LOGGER_PREFIX);
        this.hls = hls;
        this.config = hls.config;
        this.registerListeners();
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetached();
        // Remove any references that could be held in config options or callbacks
        const config = this.config;
        config.requestMediaKeySystemAccessFunc = null;
        config.licenseXhrSetup = config.licenseResponseCallback = undefined;
        config.drmSystems = config.drmSystemOptions = {};
        // @ts-ignore
        this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null;
        // @ts-ignore
        this.config = null;
    }
    registerListeners() {
        this.hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHED, this.onMediaDetached, this);
        this.hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    }
    unregisterListeners() {
        this.hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHED, this.onMediaDetached, this);
        this.hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    }
    getLicenseServerUrl(keySystem) {
        const { drmSystems: drmSystems, widevineLicenseUrl: widevineLicenseUrl } = this.config;
        const keySystemConfiguration = drmSystems[keySystem];
        if (keySystemConfiguration) return keySystemConfiguration.licenseUrl;
        // For backward compatibility
        if (keySystem === $fada8102d2a280be$var$KeySystems.WIDEVINE && widevineLicenseUrl) return widevineLicenseUrl;
        throw new Error(`no license server URL configured for key-system "${keySystem}"`);
    }
    getServerCertificateUrl(keySystem) {
        const { drmSystems: drmSystems } = this.config;
        const keySystemConfiguration = drmSystems[keySystem];
        if (keySystemConfiguration) return keySystemConfiguration.serverCertificateUrl;
        else this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
    }
    attemptKeySystemAccess(keySystemsToAttempt) {
        const levels = this.hls.levels;
        const uniqueCodec = (value, i, a)=>!!value && a.indexOf(value) === i;
        const audioCodecs = levels.map((level)=>level.audioCodec).filter(uniqueCodec);
        const videoCodecs = levels.map((level)=>level.videoCodec).filter(uniqueCodec);
        if (audioCodecs.length + videoCodecs.length === 0) videoCodecs.push("avc1.42e01e");
        return new Promise((resolve, reject)=>{
            const attempt = (keySystems)=>{
                const keySystem = keySystems.shift();
                this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then((mediaKeys)=>resolve({
                        keySystem: keySystem,
                        mediaKeys: mediaKeys
                    })).catch((error)=>{
                    if (keySystems.length) attempt(keySystems);
                    else if (error instanceof $fada8102d2a280be$var$EMEKeyError) reject(error);
                    else reject(new $fada8102d2a280be$var$EMEKeyError({
                        type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                        error: error,
                        fatal: true
                    }, error.message));
                });
            };
            attempt(keySystemsToAttempt);
        });
    }
    requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
        const { requestMediaKeySystemAccessFunc: requestMediaKeySystemAccessFunc } = this.config;
        if (!(typeof requestMediaKeySystemAccessFunc === "function")) {
            let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
            if ($fada8102d2a280be$var$requestMediaKeySystemAccess === null && self.location.protocol === "http:") errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
            return Promise.reject(new Error(errMessage));
        }
        return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
    }
    getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
        // This can throw, but is caught in event handler callpath
        const mediaKeySystemConfigs = $fada8102d2a280be$var$getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions);
        const keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
        let keySystemAccess = keySystemAccessPromises == null ? void 0 : keySystemAccessPromises.keySystemAccess;
        if (!keySystemAccess) {
            this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${JSON.stringify(mediaKeySystemConfigs)}`);
            keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
            const _keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = {
                keySystemAccess: keySystemAccess
            };
            keySystemAccess.catch((error)=>{
                this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
            });
            return keySystemAccess.then((mediaKeySystemAccess)=>{
                this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
                const certificateRequest = this.fetchServerCertificate(keySystem);
                this.log(`Create media-keys for "${keySystem}"`);
                _keySystemAccessPromises.mediaKeys = mediaKeySystemAccess.createMediaKeys().then((mediaKeys)=>{
                    this.log(`Media-keys created for "${keySystem}"`);
                    return certificateRequest.then((certificate)=>{
                        if (certificate) return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
                        return mediaKeys;
                    });
                });
                _keySystemAccessPromises.mediaKeys.catch((error)=>{
                    this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
                });
                return _keySystemAccessPromises.mediaKeys;
            });
        }
        return keySystemAccess.then(()=>keySystemAccessPromises.mediaKeys);
    }
    createMediaKeySessionContext({ decryptdata: decryptdata, keySystem: keySystem, mediaKeys: mediaKeys }) {
        this.log(`Creating key-system session "${keySystem}" keyId: ${$fada8102d2a280be$var$Hex.hexDump(decryptdata.keyId || [])}`);
        const mediaKeysSession = mediaKeys.createSession();
        const mediaKeySessionContext = {
            decryptdata: decryptdata,
            keySystem: keySystem,
            mediaKeys: mediaKeys,
            mediaKeysSession: mediaKeysSession,
            keyStatus: "status-pending"
        };
        this.mediaKeySessions.push(mediaKeySessionContext);
        return mediaKeySessionContext;
    }
    renewKeySession(mediaKeySessionContext) {
        const decryptdata = mediaKeySessionContext.decryptdata;
        if (decryptdata.pssh) {
            const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
            const keyId = this.getKeyIdString(decryptdata);
            const scheme = "cenc";
            this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, "expired");
        } else this.warn(`Could not renew expired session. Missing pssh initData.`);
        this.removeSession(mediaKeySessionContext);
    }
    getKeyIdString(decryptdata) {
        if (!decryptdata) throw new Error("Could not read keyId of undefined decryptdata");
        if (decryptdata.keyId === null) throw new Error("keyId is null");
        return $fada8102d2a280be$var$Hex.hexDump(decryptdata.keyId);
    }
    updateKeySession(mediaKeySessionContext, data) {
        var _mediaKeySessionConte;
        const keySession = mediaKeySessionContext.mediaKeysSession;
        this.log(`Updating key-session "${keySession.sessionId}" for keyID ${$fada8102d2a280be$var$Hex.hexDump(((_mediaKeySessionConte = mediaKeySessionContext.decryptdata) == null ? void 0 : _mediaKeySessionConte.keyId) || [])}
      } (data length: ${data ? data.byteLength : data})`);
        return keySession.update(data);
    }
    selectKeySystemFormat(frag) {
        const keyFormats = Object.keys(frag.levelkeys || {});
        if (!this.keyFormatPromise) {
            this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(", ")}`);
            this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
        }
        return this.keyFormatPromise;
    }
    getKeyFormatPromise(keyFormats) {
        return new Promise((resolve, reject)=>{
            const keySystemsInConfig = $fada8102d2a280be$var$getKeySystemsForConfig(this.config);
            const keySystemsToAttempt = keyFormats.map($fada8102d2a280be$var$keySystemFormatToKeySystemDomain).filter((value)=>!!value && keySystemsInConfig.indexOf(value) !== -1);
            return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({ keySystem: keySystem })=>{
                const keySystemFormat = $fada8102d2a280be$var$keySystemDomainToKeySystemFormat(keySystem);
                if (keySystemFormat) resolve(keySystemFormat);
                else reject(new Error(`Unable to find format for key-system "${keySystem}"`));
            }).catch(reject);
        });
    }
    loadKey(data) {
        const decryptdata = data.keyInfo.decryptdata;
        const keyId = this.getKeyIdString(decryptdata);
        const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
        this.log(`Starting session for key ${keyDetails}`);
        let keySessionContextPromise = this.keyIdToKeySessionPromise[keyId];
        if (!keySessionContextPromise) {
            keySessionContextPromise = this.keyIdToKeySessionPromise[keyId] = this.getKeySystemForKeyPromise(decryptdata).then(({ keySystem: keySystem, mediaKeys: mediaKeys })=>{
                this.throwIfDestroyed();
                this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
                return this.attemptSetMediaKeys(keySystem, mediaKeys).then(()=>{
                    this.throwIfDestroyed();
                    const keySessionContext = this.createMediaKeySessionContext({
                        keySystem: keySystem,
                        mediaKeys: mediaKeys,
                        decryptdata: decryptdata
                    });
                    const scheme = "cenc";
                    return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, "playlist-key");
                });
            });
            keySessionContextPromise.catch((error)=>this.handleError(error));
        }
        return keySessionContextPromise;
    }
    throwIfDestroyed(message = "Invalid state") {
        if (!this.hls) throw new Error("invalid state");
    }
    handleError(error) {
        if (!this.hls) return;
        this.error(error.message);
        if (error instanceof $fada8102d2a280be$var$EMEKeyError) this.hls.trigger($fada8102d2a280be$var$Events.ERROR, error.data);
        else this.hls.trigger($fada8102d2a280be$var$Events.ERROR, {
            type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
            details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_NO_KEYS,
            error: error,
            fatal: true
        });
    }
    getKeySystemForKeyPromise(decryptdata) {
        const keyId = this.getKeyIdString(decryptdata);
        const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
        if (!mediaKeySessionContext) {
            const keySystem = $fada8102d2a280be$var$keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
            const keySystemsToAttempt = keySystem ? [
                keySystem
            ] : $fada8102d2a280be$var$getKeySystemsForConfig(this.config);
            return this.attemptKeySystemAccess(keySystemsToAttempt);
        }
        return mediaKeySessionContext;
    }
    getKeySystemSelectionPromise(keySystemsToAttempt) {
        if (!keySystemsToAttempt.length) keySystemsToAttempt = $fada8102d2a280be$var$getKeySystemsForConfig(this.config);
        if (keySystemsToAttempt.length === 0) throw new $fada8102d2a280be$var$EMEKeyError({
            type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
            details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
            fatal: true
        }, `Missing key-system license configuration options ${JSON.stringify({
            drmSystems: this.config.drmSystems
        })}`);
        return this.attemptKeySystemAccess(keySystemsToAttempt);
    }
    _onMediaEncrypted(event) {
        const { initDataType: initDataType, initData: initData } = event;
        this.debug(`"${event.type}" event: init data type: "${initDataType}"`);
        // Ignore event when initData is null
        if (initData === null) return;
        let keyId;
        let keySystemDomain;
        if (initDataType === "sinf" && this.config.drmSystems[$fada8102d2a280be$var$KeySystems.FAIRPLAY]) {
            // Match sinf keyId to playlist skd://keyId=
            const json = $fada8102d2a280be$var$bin2str(new Uint8Array(initData));
            try {
                const sinf = $fada8102d2a280be$var$base64Decode(JSON.parse(json).sinf);
                const tenc = $fada8102d2a280be$var$parseSinf(new Uint8Array(sinf));
                if (!tenc) return;
                keyId = tenc.subarray(8, 24);
                keySystemDomain = $fada8102d2a280be$var$KeySystems.FAIRPLAY;
            } catch (error) {
                this.warn('Failed to parse sinf "encrypted" event message initData');
                return;
            }
        } else {
            // Support clear-lead key-session creation (otherwise depend on playlist keys)
            const psshInfo = $fada8102d2a280be$var$parsePssh(initData);
            if (psshInfo === null) return;
            if (psshInfo.version === 0 && psshInfo.systemId === $fada8102d2a280be$var$KeySystemIds.WIDEVINE && psshInfo.data) keyId = psshInfo.data.subarray(8, 24);
            keySystemDomain = $fada8102d2a280be$var$keySystemIdToKeySystemDomain(psshInfo.systemId);
        }
        if (!keySystemDomain || !keyId) return;
        const keyIdHex = $fada8102d2a280be$var$Hex.hexDump(keyId);
        const { keyIdToKeySessionPromise: keyIdToKeySessionPromise, mediaKeySessions: mediaKeySessions } = this;
        let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
        for(let i = 0; i < mediaKeySessions.length; i++){
            // Match playlist key
            const keyContext = mediaKeySessions[i];
            const decryptdata = keyContext.decryptdata;
            if (decryptdata.pssh || !decryptdata.keyId) continue;
            const oldKeyIdHex = $fada8102d2a280be$var$Hex.hexDump(decryptdata.keyId);
            if (keyIdHex === oldKeyIdHex || decryptdata.uri.replace(/-/g, "").indexOf(keyIdHex) !== -1) {
                keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
                delete keyIdToKeySessionPromise[oldKeyIdHex];
                decryptdata.pssh = new Uint8Array(initData);
                decryptdata.keyId = keyId;
                keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(()=>{
                    return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, "encrypted-event-key-match");
                });
                break;
            }
        }
        if (!keySessionContextPromise) // Clear-lead key (not encountered in playlist)
        keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = this.getKeySystemSelectionPromise([
            keySystemDomain
        ]).then(({ keySystem: keySystem, mediaKeys: mediaKeys })=>{
            var _keySystemToKeySystem;
            this.throwIfDestroyed();
            const decryptdata = new $fada8102d2a280be$var$LevelKey("ISO-23001-7", keyIdHex, (_keySystemToKeySystem = $fada8102d2a280be$var$keySystemDomainToKeySystemFormat(keySystem)) != null ? _keySystemToKeySystem : "");
            decryptdata.pssh = new Uint8Array(initData);
            decryptdata.keyId = keyId;
            return this.attemptSetMediaKeys(keySystem, mediaKeys).then(()=>{
                this.throwIfDestroyed();
                const keySessionContext = this.createMediaKeySessionContext({
                    decryptdata: decryptdata,
                    keySystem: keySystem,
                    mediaKeys: mediaKeys
                });
                return this.generateRequestWithPreferredKeySession(keySessionContext, initDataType, initData, "encrypted-event-no-match");
            });
        });
        keySessionContextPromise.catch((error)=>this.handleError(error));
    }
    _onWaitingForKey(event) {
        this.log(`"${event.type}" event`);
    }
    attemptSetMediaKeys(keySystem, mediaKeys) {
        const queue = this.setMediaKeysQueue.slice();
        this.log(`Setting media-keys for "${keySystem}"`);
        // Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
        // can be queued for execution for multiple key sessions.
        const setMediaKeysPromise = Promise.all(queue).then(()=>{
            if (!this.media) throw new Error("Attempted to set mediaKeys without media element attached");
            return this.media.setMediaKeys(mediaKeys);
        });
        this.setMediaKeysQueue.push(setMediaKeysPromise);
        return setMediaKeysPromise.then(()=>{
            this.log(`Media-keys set for "${keySystem}"`);
            queue.push(setMediaKeysPromise);
            this.setMediaKeysQueue = this.setMediaKeysQueue.filter((p)=>queue.indexOf(p) === -1);
        });
    }
    generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
        var _this$config$drmSyste, _this$config$drmSyste2;
        const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null ? void 0 : (_this$config$drmSyste2 = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste2.generateRequest;
        if (generateRequestFilter) try {
            const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
            if (!mappedInitData) throw new Error("Invalid response from configured generateRequest filter");
            initDataType = mappedInitData.initDataType;
            initData = context.decryptdata.pssh = mappedInitData.initData ? new Uint8Array(mappedInitData.initData) : null;
        } catch (error) {
            var _this$hls;
            this.warn(error.message);
            if ((_this$hls = this.hls) != null && _this$hls.config.debug) throw error;
        }
        if (initData === null) {
            this.log(`Skipping key-session request for "${reason}" (no initData)`);
            return Promise.resolve(context);
        }
        const keyId = this.getKeyIdString(context.decryptdata);
        this.log(`Generating key-session request for "${reason}": ${keyId} (init data type: ${initDataType} length: ${initData ? initData.byteLength : null})`);
        const licenseStatus = new $fada8102d2a280be$var$EventEmitter();
        context.mediaKeysSession.onmessage = (event)=>{
            const keySession = context.mediaKeysSession;
            if (!keySession) {
                licenseStatus.emit("error", new Error("invalid state"));
                return;
            }
            const { messageType: messageType, message: message } = event;
            this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
            if (messageType === "license-request" || messageType === "license-renewal") this.renewLicense(context, message).catch((error)=>{
                this.handleError(error);
                licenseStatus.emit("error", error);
            });
            else if (messageType === "license-release") {
                if (context.keySystem === $fada8102d2a280be$var$KeySystems.FAIRPLAY) {
                    this.updateKeySession(context, $fada8102d2a280be$var$strToUtf8array("acknowledged"));
                    this.removeSession(context);
                }
            } else this.warn(`unhandled media key message type "${messageType}"`);
        };
        context.mediaKeysSession.onkeystatuseschange = (event)=>{
            const keySession = context.mediaKeysSession;
            if (!keySession) {
                licenseStatus.emit("error", new Error("invalid state"));
                return;
            }
            this.onKeyStatusChange(context);
            const keyStatus = context.keyStatus;
            licenseStatus.emit("keyStatus", keyStatus);
            if (keyStatus === "expired") {
                this.warn(`${context.keySystem} expired for key ${keyId}`);
                this.renewKeySession(context);
            }
        };
        const keyUsablePromise = new Promise((resolve, reject)=>{
            licenseStatus.on("error", reject);
            licenseStatus.on("keyStatus", (keyStatus)=>{
                if (keyStatus.startsWith("usable")) resolve();
                else if (keyStatus === "output-restricted") reject(new $fada8102d2a280be$var$EMEKeyError({
                    type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                    details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
                    fatal: false
                }, "HDCP level output restricted"));
                else if (keyStatus === "internal-error") reject(new $fada8102d2a280be$var$EMEKeyError({
                    type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                    details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
                    fatal: true
                }, `key status changed to "${keyStatus}"`));
                else if (keyStatus === "expired") reject(new Error("key expired while generating request"));
                else this.warn(`unhandled key status change "${keyStatus}"`);
            });
        });
        return context.mediaKeysSession.generateRequest(initDataType, initData).then(()=>{
            var _context$mediaKeysSes;
            this.log(`Request generated for key-session "${(_context$mediaKeysSes = context.mediaKeysSession) == null ? void 0 : _context$mediaKeysSes.sessionId}" keyId: ${keyId}`);
        }).catch((error)=>{
            throw new $fada8102d2a280be$var$EMEKeyError({
                type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_NO_SESSION,
                error: error,
                fatal: false
            }, `Error generating key-session request: ${error}`);
        }).then(()=>keyUsablePromise).catch((error)=>{
            licenseStatus.removeAllListeners();
            this.removeSession(context);
            throw error;
        }).then(()=>{
            licenseStatus.removeAllListeners();
            return context;
        });
    }
    onKeyStatusChange(mediaKeySessionContext) {
        mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status1, keyId)=>{
            this.log(`key status change "${status1}" for keyStatuses keyId: ${$fada8102d2a280be$var$Hex.hexDump("buffer" in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId))} session keyId: ${$fada8102d2a280be$var$Hex.hexDump(new Uint8Array(mediaKeySessionContext.decryptdata.keyId || []))} uri: ${mediaKeySessionContext.decryptdata.uri}`);
            mediaKeySessionContext.keyStatus = status1;
        });
    }
    fetchServerCertificate(keySystem) {
        const config = this.config;
        const Loader = config.loader;
        const certLoader = new Loader(config);
        const url = this.getServerCertificateUrl(keySystem);
        if (!url) return Promise.resolve();
        this.log(`Fetching serverCertificate for "${keySystem}"`);
        return new Promise((resolve, reject)=>{
            const loaderContext = {
                responseType: "arraybuffer",
                url: url
            };
            const loadPolicy = config.certLoadPolicy.default;
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0
            };
            const loaderCallbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    resolve(response.data);
                },
                onError: (response, contex, networkDetails, stats)=>{
                    reject(new $fada8102d2a280be$var$EMEKeyError({
                        type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                        fatal: true,
                        networkDetails: networkDetails,
                        response: $fada8102d2a280be$var$_objectSpread2({
                            url: loaderContext.url,
                            data: undefined
                        }, response)
                    }, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    reject(new $fada8102d2a280be$var$EMEKeyError({
                        type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                        details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                        fatal: true,
                        networkDetails: networkDetails,
                        response: {
                            url: loaderContext.url,
                            data: undefined
                        }
                    }, `"${keySystem}" certificate request timed out (${url})`));
                },
                onAbort: (stats, context, networkDetails)=>{
                    reject(new Error("aborted"));
                }
            };
            certLoader.load(loaderContext, loaderConfig, loaderCallbacks);
        });
    }
    setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
        return new Promise((resolve, reject)=>{
            mediaKeys.setServerCertificate(cert).then((success)=>{
                this.log(`setServerCertificate ${success ? "success" : "not supported by CDM"} (${cert == null ? void 0 : cert.byteLength}) on "${keySystem}"`);
                resolve(mediaKeys);
            }).catch((error)=>{
                reject(new $fada8102d2a280be$var$EMEKeyError({
                    type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                    details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
                    error: error,
                    fatal: true
                }, error.message));
            });
        });
    }
    renewLicense(context, keyMessage) {
        return this.requestLicense(context, new Uint8Array(keyMessage)).then((data)=>{
            return this.updateKeySession(context, new Uint8Array(data)).catch((error)=>{
                throw new $fada8102d2a280be$var$EMEKeyError({
                    type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                    details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
                    error: error,
                    fatal: true
                }, error.message);
            });
        });
    }
    setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
        const licenseXhrSetup = this.config.licenseXhrSetup;
        if (!licenseXhrSetup) {
            xhr.open("POST", url, true);
            return Promise.resolve({
                xhr: xhr,
                licenseChallenge: licenseChallenge
            });
        }
        return Promise.resolve().then(()=>{
            if (!keysListItem.decryptdata) throw new Error("Key removed");
            return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
        }).catch((error)=>{
            if (!keysListItem.decryptdata) // Key session removed. Cancel license request.
            throw error;
            // let's try to open before running setup
            xhr.open("POST", url, true);
            return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
        }).then((licenseXhrSetupResult)=>{
            // if licenseXhrSetup did not yet call open, let's do it now
            if (!xhr.readyState) xhr.open("POST", url, true);
            const finalLicenseChallenge = licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge;
            return {
                xhr: xhr,
                licenseChallenge: finalLicenseChallenge
            };
        });
    }
    requestLicense(keySessionContext, licenseChallenge) {
        const keyLoadPolicy = this.config.keyLoadPolicy.default;
        return new Promise((resolve, reject)=>{
            const url = this.getLicenseServerUrl(keySessionContext.keySystem);
            this.log(`Sending license request to URL: ${url}`);
            const xhr = new XMLHttpRequest();
            xhr.responseType = "arraybuffer";
            xhr.onreadystatechange = ()=>{
                if (!this.hls || !keySessionContext.mediaKeysSession) return reject(new Error("invalid state"));
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        this._requestLicenseFailureCount = 0;
                        let data = xhr.response;
                        this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
                        const licenseResponseCallback = this.config.licenseResponseCallback;
                        if (licenseResponseCallback) try {
                            data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
                        } catch (error) {
                            this.error(error);
                        }
                        resolve(data);
                    } else {
                        const retryConfig = keyLoadPolicy.errorRetry;
                        const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
                        this._requestLicenseFailureCount++;
                        if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) reject(new $fada8102d2a280be$var$EMEKeyError({
                            type: $fada8102d2a280be$var$ErrorTypes.KEY_SYSTEM_ERROR,
                            details: $fada8102d2a280be$var$ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                            fatal: true,
                            networkDetails: xhr,
                            response: {
                                url: url,
                                data: undefined,
                                code: xhr.status,
                                text: xhr.statusText
                            }
                        }, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
                        else {
                            const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
                            this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
                            this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
                        }
                    }
                }
            };
            if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) keySessionContext.licenseXhr.abort();
            keySessionContext.licenseXhr = xhr;
            this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({ xhr: xhr, licenseChallenge: licenseChallenge })=>{
                xhr.send(licenseChallenge);
            });
        });
    }
    onMediaAttached(event, data) {
        if (!this.config.emeEnabled) return;
        const media = data.media;
        // keep reference of media
        this.media = media;
        media.addEventListener("encrypted", this.onMediaEncrypted);
        media.addEventListener("waitingforkey", this.onWaitingForKey);
    }
    onMediaDetached() {
        const media = this.media;
        const mediaKeysList = this.mediaKeySessions;
        if (media) {
            media.removeEventListener("encrypted", this.onMediaEncrypted);
            media.removeEventListener("waitingforkey", this.onWaitingForKey);
            this.media = null;
        }
        this._requestLicenseFailureCount = 0;
        this.setMediaKeysQueue = [];
        this.mediaKeySessions = [];
        this.keyIdToKeySessionPromise = {};
        $fada8102d2a280be$var$LevelKey.clearKeyUriToKeyIdMap();
        // Close all sessions and remove media keys from the video element.
        const keySessionCount = mediaKeysList.length;
        $fada8102d2a280be$var$EMEController.CDMCleanupPromise = Promise.all(mediaKeysList.map((mediaKeySessionContext)=>this.removeSession(mediaKeySessionContext)).concat(media == null ? void 0 : media.setMediaKeys(null).catch((error)=>{
            this.log(`Could not clear media keys: ${error}. media.src: ${media == null ? void 0 : media.src}`);
        }))).then(()=>{
            if (keySessionCount) {
                this.log("finished closing key sessions and clearing media keys");
                mediaKeysList.length = 0;
            }
        }).catch((error)=>{
            this.log(`Could not close sessions and clear media keys: ${error}. media.src: ${media == null ? void 0 : media.src}`);
        });
    }
    onManifestLoading() {
        this.keyFormatPromise = null;
    }
    onManifestLoaded(event, { sessionKeys: sessionKeys }) {
        if (!sessionKeys || !this.config.emeEnabled) return;
        if (!this.keyFormatPromise) {
            const keyFormats = sessionKeys.reduce((formats, sessionKey)=>{
                if (formats.indexOf(sessionKey.keyFormat) === -1) formats.push(sessionKey.keyFormat);
                return formats;
            }, []);
            this.log(`Selecting key-system from session-keys ${keyFormats.join(", ")}`);
            this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
        }
    }
    removeSession(mediaKeySessionContext) {
        const { mediaKeysSession: mediaKeysSession, licenseXhr: licenseXhr } = mediaKeySessionContext;
        if (mediaKeysSession) {
            this.log(`Remove licenses and keys and close session ${mediaKeysSession.sessionId}`);
            mediaKeysSession.onmessage = null;
            mediaKeysSession.onkeystatuseschange = null;
            if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) licenseXhr.abort();
            mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = undefined;
            const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
            if (index > -1) this.mediaKeySessions.splice(index, 1);
            return mediaKeysSession.remove().catch((error)=>{
                this.log(`Could not remove session: ${error}`);
            }).then(()=>{
                return mediaKeysSession.close();
            }).catch((error)=>{
                this.log(`Could not close session: ${error}`);
            });
        }
    }
}
$fada8102d2a280be$var$EMEController.CDMCleanupPromise = void 0;
class $fada8102d2a280be$var$EMEKeyError extends Error {
    constructor(data, message){
        super(message);
        this.data = void 0;
        data.error || (data.error = new Error(message));
        this.data = data;
        data.err = data.error;
    }
}
/**
 * CMCD spec version
 */ const $fada8102d2a280be$var$CMCDVersion = 1;
/**
 * CMCD Object Type
 */ var $fada8102d2a280be$var$CMCDObjectType = {
    MANIFEST: "m",
    AUDIO: "a",
    VIDEO: "v",
    MUXED: "av",
    INIT: "i",
    CAPTION: "c",
    TIMED_TEXT: "tt",
    KEY: "k",
    OTHER: "o"
};
/**
 * CMCD Streaming Format
 */ const $fada8102d2a280be$var$CMCDStreamingFormatHLS = "h";
/**
 * CMCD Streaming Type
 */ /**
 * CMCD Headers
 */ /**
 * CMCD
 */ /**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */ class $fada8102d2a280be$var$CMCDController {
    // eslint-disable-line no-restricted-globals
    // eslint-disable-line no-restricted-globals
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = void 0;
        this.sid = void 0;
        this.cid = void 0;
        this.useHeaders = false;
        this.initialized = false;
        this.starved = false;
        this.buffering = true;
        this.audioBuffer = void 0;
        this.videoBuffer = void 0;
        this.onWaiting = ()=>{
            if (this.initialized) this.starved = true;
            this.buffering = true;
        };
        this.onPlaying = ()=>{
            if (!this.initialized) this.initialized = true;
            this.buffering = false;
        };
        /**
     * Apply CMCD data to a manifest request.
     */ this.applyPlaylistData = (context)=>{
            try {
                this.apply(context, {
                    ot: $fada8102d2a280be$var$CMCDObjectType.MANIFEST,
                    su: !this.initialized
                });
            } catch (error) {
                $fada8102d2a280be$var$logger.warn("Could not generate manifest CMCD data.", error);
            }
        };
        /**
     * Apply CMCD data to a segment request
     */ this.applyFragmentData = (context)=>{
            try {
                const fragment = context.frag;
                const level = this.hls.levels[fragment.level];
                const ot = this.getObjectType(fragment);
                const data = {
                    d: fragment.duration * 1000,
                    ot: ot
                };
                if (ot === $fada8102d2a280be$var$CMCDObjectType.VIDEO || ot === $fada8102d2a280be$var$CMCDObjectType.AUDIO || ot == $fada8102d2a280be$var$CMCDObjectType.MUXED) {
                    data.br = level.bitrate / 1000;
                    data.tb = this.getTopBandwidth(ot) / 1000;
                    data.bl = this.getBufferLength(ot);
                }
                this.apply(context, data);
            } catch (error) {
                $fada8102d2a280be$var$logger.warn("Could not generate segment CMCD data.", error);
            }
        };
        this.hls = hls;
        const config = this.config = hls.config;
        const { cmcd: cmcd } = config;
        if (cmcd != null) {
            config.pLoader = this.createPlaylistLoader();
            config.fLoader = this.createFragmentLoader();
            this.sid = cmcd.sessionId || $fada8102d2a280be$var$CMCDController.uuid();
            this.cid = cmcd.contentId;
            this.useHeaders = cmcd.useHeaders === true;
            this.registerListeners();
        }
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($fada8102d2a280be$var$Events.MEDIA_DETACHED, this.onMediaDetached, this);
        hls.on($fada8102d2a280be$var$Events.BUFFER_CREATED, this.onBufferCreated, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        hls.off($fada8102d2a280be$var$Events.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($fada8102d2a280be$var$Events.MEDIA_DETACHED, this.onMediaDetached, this);
        hls.off($fada8102d2a280be$var$Events.BUFFER_CREATED, this.onBufferCreated, this);
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetached();
        // @ts-ignore
        this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
    }
    onMediaAttached(event, data) {
        this.media = data.media;
        this.media.addEventListener("waiting", this.onWaiting);
        this.media.addEventListener("playing", this.onPlaying);
    }
    onMediaDetached() {
        if (!this.media) return;
        this.media.removeEventListener("waiting", this.onWaiting);
        this.media.removeEventListener("playing", this.onPlaying);
        // @ts-ignore
        this.media = null;
    }
    onBufferCreated(event, data) {
        var _data$tracks$audio, _data$tracks$video;
        this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
        this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
    }
    /**
   * Create baseline CMCD data
   */ createData() {
        var _this$media;
        return {
            v: $fada8102d2a280be$var$CMCDVersion,
            sf: $fada8102d2a280be$var$CMCDStreamingFormatHLS,
            sid: this.sid,
            cid: this.cid,
            pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
            mtp: this.hls.bandwidthEstimate / 1000
        };
    }
    /**
   * Apply CMCD data to a request.
   */ apply(context, data = {}) {
        // apply baseline data
        $fada8102d2a280be$var$_extends(data, this.createData());
        const isVideo = data.ot === $fada8102d2a280be$var$CMCDObjectType.INIT || data.ot === $fada8102d2a280be$var$CMCDObjectType.VIDEO || data.ot === $fada8102d2a280be$var$CMCDObjectType.MUXED;
        if (this.starved && isVideo) {
            data.bs = true;
            data.su = true;
            this.starved = false;
        }
        if (data.su == null) data.su = this.buffering;
        // TODO: Implement rtp, nrr, nor, dl
        if (this.useHeaders) {
            const headers = $fada8102d2a280be$var$CMCDController.toHeaders(data);
            if (!Object.keys(headers).length) return;
            if (!context.headers) context.headers = {};
            $fada8102d2a280be$var$_extends(context.headers, headers);
        } else {
            const query = $fada8102d2a280be$var$CMCDController.toQuery(data);
            if (!query) return;
            context.url = $fada8102d2a280be$var$CMCDController.appendQueryToUri(context.url, query);
        }
    }
    /**
   * The CMCD object type.
   */ getObjectType(fragment) {
        const { type: type } = fragment;
        if (type === "subtitle") return $fada8102d2a280be$var$CMCDObjectType.TIMED_TEXT;
        if (fragment.sn === "initSegment") return $fada8102d2a280be$var$CMCDObjectType.INIT;
        if (type === "audio") return $fada8102d2a280be$var$CMCDObjectType.AUDIO;
        if (type === "main") {
            if (!this.hls.audioTracks.length) return $fada8102d2a280be$var$CMCDObjectType.MUXED;
            return $fada8102d2a280be$var$CMCDObjectType.VIDEO;
        }
        return undefined;
    }
    /**
   * Get the highest bitrate.
   */ getTopBandwidth(type) {
        let bitrate = 0;
        let levels;
        const hls = this.hls;
        if (type === $fada8102d2a280be$var$CMCDObjectType.AUDIO) levels = hls.audioTracks;
        else {
            const max = hls.maxAutoLevel;
            const len = max > -1 ? max + 1 : hls.levels.length;
            levels = hls.levels.slice(0, len);
        }
        for (const level of levels)if (level.bitrate > bitrate) bitrate = level.bitrate;
        return bitrate > 0 ? bitrate : NaN;
    }
    /**
   * Get the buffer length for a media type in milliseconds
   */ getBufferLength(type) {
        const media = this.hls.media;
        const buffer = type === $fada8102d2a280be$var$CMCDObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
        if (!buffer || !media) return NaN;
        const info = $fada8102d2a280be$var$BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole);
        return info.len * 1000;
    }
    /**
   * Create a playlist loader
   */ createPlaylistLoader() {
        const { pLoader: pLoader } = this.config;
        const apply = this.applyPlaylistData;
        const Ctor = pLoader || this.config.loader;
        return class CmcdPlaylistLoader {
            constructor(config){
                this.loader = void 0;
                this.loader = new Ctor(config);
            }
            get stats() {
                return this.loader.stats;
            }
            get context() {
                return this.loader.context;
            }
            destroy() {
                this.loader.destroy();
            }
            abort() {
                this.loader.abort();
            }
            load(context, config, callbacks) {
                apply(context);
                this.loader.load(context, config, callbacks);
            }
        };
    }
    /**
   * Create a playlist loader
   */ createFragmentLoader() {
        const { fLoader: fLoader } = this.config;
        const apply = this.applyFragmentData;
        const Ctor = fLoader || this.config.loader;
        return class CmcdFragmentLoader {
            constructor(config){
                this.loader = void 0;
                this.loader = new Ctor(config);
            }
            get stats() {
                return this.loader.stats;
            }
            get context() {
                return this.loader.context;
            }
            destroy() {
                this.loader.destroy();
            }
            abort() {
                this.loader.abort();
            }
            load(context, config, callbacks) {
                apply(context);
                this.loader.load(context, config, callbacks);
            }
        };
    }
    /**
   * Generate a random v4 UUI
   *
   * @returns {string}
   */ static uuid() {
        const url = URL.createObjectURL(new Blob());
        const uuid = url.toString();
        URL.revokeObjectURL(url);
        return uuid.slice(uuid.lastIndexOf("/") + 1);
    }
    /**
   * Serialize a CMCD data object according to the rules defined in the
   * section 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */ static serialize(data) {
        const results = [];
        const isValid = (value)=>!Number.isNaN(value) && value != null && value !== "" && value !== false;
        const toRounded = (value)=>Math.round(value);
        const toHundred = (value)=>toRounded(value / 100) * 100;
        const toUrlSafe = (value)=>encodeURIComponent(value);
        const formatters = {
            br: toRounded,
            d: toRounded,
            bl: toHundred,
            dl: toHundred,
            mtp: toHundred,
            nor: toUrlSafe,
            rtp: toHundred,
            tb: toRounded
        };
        const keys = Object.keys(data || {}).sort();
        for (const key of keys){
            let value = data[key];
            // ignore invalid values
            if (!isValid(value)) continue;
            // Version should only be reported if not equal to 1.
            if (key === "v" && value === 1) continue;
            // Playback rate should only be sent if not equal to 1.
            if (key == "pr" && value === 1) continue;
            // Certain values require special formatting
            const formatter = formatters[key];
            if (formatter) value = formatter(value);
            // Serialize the key/value pair
            const type = typeof value;
            let result;
            if (key === "ot" || key === "sf" || key === "st") result = `${key}=${value}`;
            else if (type === "boolean") result = key;
            else if (type === "number") result = `${key}=${value}`;
            else result = `${key}=${JSON.stringify(value)}`;
            results.push(result);
        }
        return results.join(",");
    }
    /**
   * Convert a CMCD data object to request headers according to the rules
   * defined in the section 2.1 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */ static toHeaders(data) {
        const keys = Object.keys(data);
        const headers = {};
        const headerNames = [
            "Object",
            "Request",
            "Session",
            "Status"
        ];
        const headerGroups = [
            {},
            {},
            {},
            {}
        ];
        const headerMap = {
            br: 0,
            d: 0,
            ot: 0,
            tb: 0,
            bl: 1,
            dl: 1,
            mtp: 1,
            nor: 1,
            nrr: 1,
            su: 1,
            cid: 2,
            pr: 2,
            sf: 2,
            sid: 2,
            st: 2,
            v: 2,
            bs: 3,
            rtp: 3
        };
        for (const key of keys){
            // Unmapped fields are mapped to the Request header
            const index = headerMap[key] != null ? headerMap[key] : 1;
            headerGroups[index][key] = data[key];
        }
        for(let i = 0; i < headerGroups.length; i++){
            const value = $fada8102d2a280be$var$CMCDController.serialize(headerGroups[i]);
            if (value) headers[`CMCD-${headerNames[i]}`] = value;
        }
        return headers;
    }
    /**
   * Convert a CMCD data object to query args according to the rules
   * defined in the section 2.2 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */ static toQuery(data) {
        return `CMCD=${encodeURIComponent($fada8102d2a280be$var$CMCDController.serialize(data))}`;
    }
    /**
   * Append query args to a uri.
   */ static appendQueryToUri(uri, query) {
        if (!query) return uri;
        const separator = uri.includes("?") ? "&" : "?";
        return `${uri}${separator}${query}`;
    }
}
const $fada8102d2a280be$var$PATHWAY_PENALTY_DURATION_MS = 300000;
class $fada8102d2a280be$var$ContentSteeringController {
    constructor(hls){
        this.hls = void 0;
        this.log = void 0;
        this.loader = null;
        this.uri = null;
        this.pathwayId = ".";
        this.pathwayPriority = null;
        this.timeToLoad = 300;
        this.reloadTimer = -1;
        this.updated = 0;
        this.started = false;
        this.enabled = true;
        this.levels = null;
        this.audioTracks = null;
        this.subtitleTracks = null;
        this.penalizedPathways = {};
        this.hls = hls;
        this.log = $fada8102d2a280be$var$logger.log.bind($fada8102d2a280be$var$logger, `[content-steering]:`);
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($fada8102d2a280be$var$Events.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($fada8102d2a280be$var$Events.ERROR, this.onError, this);
    }
    startLoad() {
        this.started = true;
        self.clearTimeout(this.reloadTimer);
        if (this.enabled && this.uri) {
            if (this.updated) {
                const ttl = Math.max(this.timeToLoad * 1000 - (performance.now() - this.updated), 0);
                this.scheduleRefresh(this.uri, ttl);
            } else this.loadSteeringManifest(this.uri);
        }
    }
    stopLoad() {
        this.started = false;
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
        self.clearTimeout(this.reloadTimer);
    }
    destroy() {
        this.unregisterListeners();
        this.stopLoad();
        // @ts-ignore
        this.hls = null;
        this.levels = this.audioTracks = this.subtitleTracks = null;
    }
    removeLevel(levelToRemove) {
        const levels = this.levels;
        if (levels) this.levels = levels.filter((level)=>level !== levelToRemove);
    }
    onManifestLoading() {
        this.stopLoad();
        this.enabled = true;
        this.timeToLoad = 300;
        this.updated = 0;
        this.uri = null;
        this.pathwayId = ".";
        this.levels = this.audioTracks = this.subtitleTracks = null;
    }
    onManifestLoaded(event, data) {
        const { contentSteering: contentSteering } = data;
        if (contentSteering === null) return;
        this.pathwayId = contentSteering.pathwayId;
        this.uri = contentSteering.uri;
        if (this.started) this.startLoad();
    }
    onManifestParsed(event, data) {
        this.audioTracks = data.audioTracks;
        this.subtitleTracks = data.subtitleTracks;
    }
    onError(event, data) {
        const { errorAction: errorAction } = data;
        if ((errorAction == null ? void 0 : errorAction.action) === $fada8102d2a280be$var$NetworkErrorAction.SendAlternateToPenaltyBox && errorAction.flags === $fada8102d2a280be$var$ErrorActionFlags.MoveAllAlternatesMatchingHost) {
            let pathwayPriority = this.pathwayPriority;
            const pathwayId = this.pathwayId;
            if (!this.penalizedPathways[pathwayId]) this.penalizedPathways[pathwayId] = performance.now();
            if (!pathwayPriority && this.levels) // If PATHWAY-PRIORITY was not provided, list pathways for error handling
            pathwayPriority = this.levels.reduce((pathways, level)=>{
                if (pathways.indexOf(level.pathwayId) === -1) pathways.push(level.pathwayId);
                return pathways;
            }, []);
            if (pathwayPriority && pathwayPriority.length > 1) {
                this.updatePathwayPriority(pathwayPriority);
                errorAction.resolved = this.pathwayId !== pathwayId;
            }
        }
    }
    filterParsedLevels(levels) {
        // Filter levels to only include those that are in the initial pathway
        this.levels = levels;
        let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
        if (pathwayLevels.length === 0) {
            const pathwayId = levels[0].pathwayId;
            this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
            pathwayLevels = this.getLevelsForPathway(pathwayId);
            this.pathwayId = pathwayId;
        }
        if (pathwayLevels.length !== levels.length) {
            this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
            return pathwayLevels;
        }
        return levels;
    }
    getLevelsForPathway(pathwayId) {
        if (this.levels === null) return [];
        return this.levels.filter((level)=>pathwayId === level.pathwayId);
    }
    updatePathwayPriority(pathwayPriority) {
        this.pathwayPriority = pathwayPriority;
        let levels;
        // Evaluate if we should remove the pathway from the penalized list
        const penalizedPathways = this.penalizedPathways;
        const now = performance.now();
        Object.keys(penalizedPathways).forEach((pathwayId)=>{
            if (now - penalizedPathways[pathwayId] > $fada8102d2a280be$var$PATHWAY_PENALTY_DURATION_MS) delete penalizedPathways[pathwayId];
        });
        for(let i = 0; i < pathwayPriority.length; i++){
            const pathwayId = pathwayPriority[i];
            if (penalizedPathways[pathwayId]) continue;
            if (pathwayId === this.pathwayId) return;
            const selectedIndex = this.hls.nextLoadLevel;
            const selectedLevel = this.hls.levels[selectedIndex];
            levels = this.getLevelsForPathway(pathwayId);
            if (levels.length > 0) {
                this.log(`Setting Pathway to "${pathwayId}"`);
                this.pathwayId = pathwayId;
                this.hls.trigger($fada8102d2a280be$var$Events.LEVELS_UPDATED, {
                    levels: levels
                });
                // Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
                const levelAfterChange = this.hls.levels[selectedIndex];
                if (selectedLevel && levelAfterChange && this.levels) {
                    if (levelAfterChange.attrs["STABLE-VARIANT-ID"] !== selectedLevel.attrs["STABLE-VARIANT-ID"] && levelAfterChange.bitrate !== selectedLevel.bitrate) this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
                    this.hls.nextLoadLevel = selectedIndex;
                }
                break;
            }
        }
    }
    clonePathways(pathwayClones) {
        const levels = this.levels;
        if (!levels) return;
        const audioGroupCloneMap = {};
        const subtitleGroupCloneMap = {};
        pathwayClones.forEach((pathwayClone)=>{
            const { ID: cloneId, "BASE-ID": baseId, "URI-REPLACEMENT": uriReplacement } = pathwayClone;
            if (levels.some((level)=>level.pathwayId === cloneId)) return;
            const clonedVariants = this.getLevelsForPathway(baseId).map((baseLevel)=>{
                const levelParsed = $fada8102d2a280be$var$_extends({}, baseLevel);
                levelParsed.details = undefined;
                levelParsed.url = $fada8102d2a280be$var$performUriReplacement(baseLevel.uri, baseLevel.attrs["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", uriReplacement);
                const attributes = new $fada8102d2a280be$var$AttrList(baseLevel.attrs);
                attributes["PATHWAY-ID"] = cloneId;
                const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
                const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
                if (clonedAudioGroupId) {
                    audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
                    attributes.AUDIO = clonedAudioGroupId;
                }
                if (clonedSubtitleGroupId) {
                    subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
                    attributes.SUBTITLES = clonedSubtitleGroupId;
                }
                levelParsed.attrs = attributes;
                const clonedLevel = new $fada8102d2a280be$var$Level(levelParsed);
                $fada8102d2a280be$var$addGroupId(clonedLevel, "audio", clonedAudioGroupId);
                $fada8102d2a280be$var$addGroupId(clonedLevel, "text", clonedSubtitleGroupId);
                return clonedLevel;
            });
            levels.push(...clonedVariants);
            $fada8102d2a280be$var$cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
            $fada8102d2a280be$var$cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
        });
    }
    loadSteeringManifest(uri) {
        const config = this.hls.config;
        const Loader = config.loader;
        if (this.loader) this.loader.destroy();
        this.loader = new Loader(config);
        let url;
        try {
            url = new self.URL(uri);
        } catch (error) {
            this.enabled = false;
            this.log(`Failed to parse Steering Manifest URI: ${uri}`);
            return;
        }
        if (url.protocol !== "data:") {
            const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
            url.searchParams.set("_HLS_pathway", this.pathwayId);
            url.searchParams.set("_HLS_throughput", "" + throughput);
        }
        const context = {
            responseType: "json",
            url: url.href
        };
        const loadPolicy = config.steeringManifestLoadPolicy.default;
        const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
        const loaderConfig = {
            loadPolicy: loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
            retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
            maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
        };
        const callbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                this.log(`Loaded steering manifest: "${url}"`);
                const steeringData = response.data;
                if (steeringData.VERSION !== 1) {
                    this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
                    return;
                }
                this.updated = performance.now();
                this.timeToLoad = steeringData.TTL;
                const { "RELOAD-URI": reloadUri, "PATHWAY-CLONES": pathwayClones, "PATHWAY-PRIORITY": pathwayPriority } = steeringData;
                if (reloadUri) try {
                    this.uri = new self.URL(reloadUri, url).href;
                } catch (error) {
                    this.enabled = false;
                    this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
                    return;
                }
                this.scheduleRefresh(this.uri || context.url);
                if (pathwayClones) this.clonePathways(pathwayClones);
                if (pathwayPriority) this.updatePathwayPriority(pathwayPriority);
            },
            onError: (error, context, networkDetails, stats)=>{
                this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
                this.stopLoad();
                if (error.code === 410) {
                    this.enabled = false;
                    this.log(`Steering manifest ${context.url} no longer available`);
                    return;
                }
                let ttl = this.timeToLoad * 1000;
                if (error.code === 429) {
                    const loader = this.loader;
                    if (typeof (loader == null ? void 0 : loader.getResponseHeader) === "function") {
                        const retryAfter = loader.getResponseHeader("Retry-After");
                        if (retryAfter) ttl = parseFloat(retryAfter) * 1000;
                    }
                    this.log(`Steering manifest ${context.url} rate limited`);
                    return;
                }
                this.scheduleRefresh(this.uri || context.url, ttl);
            },
            onTimeout: (stats, context, networkDetails)=>{
                this.log(`Timeout loading steering manifest (${context.url})`);
                this.scheduleRefresh(this.uri || context.url);
            }
        };
        this.log(`Requesting steering manifest: ${url}`);
        this.loader.load(context, loaderConfig, callbacks);
    }
    scheduleRefresh(uri, ttlMs = this.timeToLoad * 1000) {
        self.clearTimeout(this.reloadTimer);
        this.reloadTimer = self.setTimeout(()=>{
            this.loadSteeringManifest(uri);
        }, ttlMs);
    }
}
function $fada8102d2a280be$var$cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
    if (!tracks) return;
    Object.keys(groupCloneMap).forEach((audioGroupId)=>{
        const clonedTracks = tracks.filter((track)=>track.groupId === audioGroupId).map((track)=>{
            const clonedTrack = $fada8102d2a280be$var$_extends({}, track);
            clonedTrack.details = undefined;
            clonedTrack.attrs = new $fada8102d2a280be$var$AttrList(clonedTrack.attrs);
            clonedTrack.url = clonedTrack.attrs.URI = $fada8102d2a280be$var$performUriReplacement(track.url, track.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", uriReplacement);
            clonedTrack.groupId = clonedTrack.attrs["GROUP-ID"] = groupCloneMap[audioGroupId];
            clonedTrack.attrs["PATHWAY-ID"] = cloneId;
            return clonedTrack;
        });
        tracks.push(...clonedTracks);
    });
}
function $fada8102d2a280be$var$performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
    const { HOST: host, PARAMS: params, [perOptionKey]: perOptionUris } = uriReplacement;
    let perVariantUri;
    if (stableId) {
        perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
        if (perVariantUri) uri = perVariantUri;
    }
    const url = new self.URL(uri);
    if (host && !perVariantUri) url.host = host;
    if (params) Object.keys(params).sort().forEach((key)=>{
        if (key) url.searchParams.set(key, params[key]);
    });
    return url.href;
}
const $fada8102d2a280be$var$AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class $fada8102d2a280be$var$XhrLoader {
    constructor(config){
        this.xhrSetup = void 0;
        this.requestTimeout = void 0;
        this.retryTimeout = void 0;
        this.retryDelay = void 0;
        this.config = null;
        this.callbacks = null;
        this.context = void 0;
        this.loader = null;
        this.stats = void 0;
        this.xhrSetup = config ? config.xhrSetup || null : null;
        this.stats = new $fada8102d2a280be$var$LoadStats();
        this.retryDelay = 0;
    }
    destroy() {
        this.callbacks = null;
        this.abortInternal();
        this.loader = null;
        this.config = null;
    }
    abortInternal() {
        const loader = this.loader;
        self.clearTimeout(this.requestTimeout);
        self.clearTimeout(this.retryTimeout);
        if (loader) {
            loader.onreadystatechange = null;
            loader.onprogress = null;
            if (loader.readyState !== 4) {
                this.stats.aborted = true;
                loader.abort();
            }
        }
    }
    abort() {
        var _this$callbacks;
        this.abortInternal();
        if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.loader);
    }
    load(context, config, callbacks) {
        if (this.stats.loading.start) throw new Error("Loader can only be used once.");
        this.stats.loading.start = self.performance.now();
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.loadInternal();
    }
    loadInternal() {
        const { config: config, context: context } = this;
        if (!config) return;
        const xhr = this.loader = new self.XMLHttpRequest();
        const stats = this.stats;
        stats.loading.first = 0;
        stats.loaded = 0;
        const xhrSetup = this.xhrSetup;
        if (xhrSetup) Promise.resolve().then(()=>{
            if (this.stats.aborted) return;
            return xhrSetup(xhr, context.url);
        }).catch((error)=>{
            xhr.open("GET", context.url, true);
            return xhrSetup(xhr, context.url);
        }).then(()=>{
            if (this.stats.aborted) return;
            this.openAndSendXhr(xhr, context, config);
        }).catch((error)=>{
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            this.callbacks.onError({
                code: xhr.status,
                text: error.message
            }, context, xhr, stats);
            return;
        });
        else this.openAndSendXhr(xhr, context, config);
    }
    openAndSendXhr(xhr, context, config) {
        if (!xhr.readyState) xhr.open("GET", context.url, true);
        const headers = this.context.headers;
        const { maxTimeToFirstByteMs: maxTimeToFirstByteMs, maxLoadTimeMs: maxLoadTimeMs } = config.loadPolicy;
        if (headers) for(const header in headers)xhr.setRequestHeader(header, headers[header]);
        if (context.rangeEnd) xhr.setRequestHeader("Range", "bytes=" + context.rangeStart + "-" + (context.rangeEnd - 1));
        xhr.onreadystatechange = this.readystatechange.bind(this);
        xhr.onprogress = this.loadprogress.bind(this);
        xhr.responseType = context.responseType;
        // setup timeout before we perform request
        self.clearTimeout(this.requestTimeout);
        config.timeout = maxTimeToFirstByteMs && $fada8102d2a280be$var$isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
        this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
        xhr.send();
    }
    readystatechange() {
        const { context: context, loader: xhr, stats: stats } = this;
        if (!context || !xhr) return;
        const readyState = xhr.readyState;
        const config = this.config;
        // don't proceed if xhr has been aborted
        if (stats.aborted) return;
        // >= HEADERS_RECEIVED
        if (readyState >= 2) {
            if (stats.loading.first === 0) {
                stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
                // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
                if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
                    self.clearTimeout(this.requestTimeout);
                    config.timeout = config.loadPolicy.maxLoadTimeMs;
                    this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
                }
            }
            if (readyState === 4) {
                self.clearTimeout(this.requestTimeout);
                xhr.onreadystatechange = null;
                xhr.onprogress = null;
                const status1 = xhr.status;
                // http status between 200 to 299 are all successful
                const useResponse = xhr.responseType !== "text";
                if (status1 >= 200 && status1 < 300 && (useResponse && xhr.response || xhr.responseText !== null)) {
                    stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
                    const data = useResponse ? xhr.response : xhr.responseText;
                    const len = xhr.responseType === "arraybuffer" ? data.byteLength : data.length;
                    stats.loaded = stats.total = len;
                    stats.bwEstimate = stats.total * 8000 / (stats.loading.end - stats.loading.first);
                    if (!this.callbacks) return;
                    const onProgress = this.callbacks.onProgress;
                    if (onProgress) onProgress(stats, context, data, xhr);
                    if (!this.callbacks) return;
                    const response = {
                        url: xhr.responseURL,
                        data: data,
                        code: status1
                    };
                    this.callbacks.onSuccess(response, stats, context, xhr);
                } else {
                    const retryConfig = config.loadPolicy.errorRetry;
                    const retryCount = stats.retry;
                    // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
                    if ($fada8102d2a280be$var$shouldRetry(retryConfig, retryCount, false, status1)) this.retry(retryConfig);
                    else {
                        $fada8102d2a280be$var$logger.error(`${status1} while loading ${context.url}`);
                        this.callbacks.onError({
                            code: status1,
                            text: xhr.statusText
                        }, context, xhr, stats);
                    }
                }
            }
        }
    }
    loadtimeout() {
        var _this$config;
        const retryConfig = (_this$config = this.config) == null ? void 0 : _this$config.loadPolicy.timeoutRetry;
        const retryCount = this.stats.retry;
        if ($fada8102d2a280be$var$shouldRetry(retryConfig, retryCount, true)) this.retry(retryConfig);
        else {
            $fada8102d2a280be$var$logger.warn(`timeout while loading ${this.context.url}`);
            const callbacks = this.callbacks;
            if (callbacks) {
                this.abortInternal();
                callbacks.onTimeout(this.stats, this.context, this.loader);
            }
        }
    }
    retry(retryConfig) {
        const { context: context, stats: stats } = this;
        this.retryDelay = $fada8102d2a280be$var$getRetryDelay(retryConfig, stats.retry);
        stats.retry++;
        $fada8102d2a280be$var$logger.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
        // abort and reset internal state
        this.abortInternal();
        this.loader = null;
        // schedule retry
        self.clearTimeout(this.retryTimeout);
        this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
    }
    loadprogress(event) {
        const stats = this.stats;
        stats.loaded = event.loaded;
        if (event.lengthComputable) stats.total = event.total;
    }
    getCacheAge() {
        let result = null;
        if (this.loader && $fada8102d2a280be$var$AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
            const ageHeader = this.loader.getResponseHeader("age");
            result = ageHeader ? parseFloat(ageHeader) : null;
        }
        return result;
    }
    getResponseHeader(name) {
        if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders())) return this.loader.getResponseHeader(name);
        return null;
    }
}
function $fada8102d2a280be$var$fetchSupported() {
    if (// @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request) try {
        new self.ReadableStream({}); // eslint-disable-line no-new
        return true;
    } catch (e) {
    /* noop */ }
    return false;
}
const $fada8102d2a280be$var$BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class $fada8102d2a280be$var$FetchLoader {
    constructor(config /* HlsConfig */ ){
        this.fetchSetup = void 0;
        this.requestTimeout = void 0;
        this.request = void 0;
        this.response = void 0;
        this.controller = void 0;
        this.context = void 0;
        this.config = null;
        this.callbacks = null;
        this.stats = void 0;
        this.loader = null;
        this.fetchSetup = config.fetchSetup || $fada8102d2a280be$var$getRequest;
        this.controller = new self.AbortController();
        this.stats = new $fada8102d2a280be$var$LoadStats();
    }
    destroy() {
        this.loader = this.callbacks = null;
        this.abortInternal();
    }
    abortInternal() {
        const response = this.response;
        if (!(response != null && response.ok)) {
            this.stats.aborted = true;
            this.controller.abort();
        }
    }
    abort() {
        var _this$callbacks;
        this.abortInternal();
        if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.response);
    }
    load(context, config, callbacks) {
        const stats = this.stats;
        if (stats.loading.start) throw new Error("Loader can only be used once.");
        stats.loading.start = self.performance.now();
        const initParams = $fada8102d2a280be$var$getRequestParameters(context, this.controller.signal);
        const onProgress = callbacks.onProgress;
        const isArrayBuffer = context.responseType === "arraybuffer";
        const LENGTH = isArrayBuffer ? "byteLength" : "length";
        const { maxTimeToFirstByteMs: maxTimeToFirstByteMs, maxLoadTimeMs: maxLoadTimeMs } = config.loadPolicy;
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.request = this.fetchSetup(context, initParams);
        self.clearTimeout(this.requestTimeout);
        config.timeout = maxTimeToFirstByteMs && $fada8102d2a280be$var$isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
        this.requestTimeout = self.setTimeout(()=>{
            this.abortInternal();
            callbacks.onTimeout(stats, context, this.response);
        }, config.timeout);
        self.fetch(this.request).then((response)=>{
            this.response = this.loader = response;
            const first = Math.max(self.performance.now(), stats.loading.start);
            self.clearTimeout(this.requestTimeout);
            config.timeout = maxLoadTimeMs;
            this.requestTimeout = self.setTimeout(()=>{
                this.abortInternal();
                callbacks.onTimeout(stats, context, this.response);
            }, maxLoadTimeMs - (first - stats.loading.start));
            if (!response.ok) {
                const { status: status1, statusText: statusText } = response;
                throw new $fada8102d2a280be$var$FetchError(statusText || "fetch, bad network response", status1, response);
            }
            stats.loading.first = first;
            stats.total = $fada8102d2a280be$var$getContentLength(response.headers) || stats.total;
            if (onProgress && $fada8102d2a280be$var$isFiniteNumber(config.highWaterMark)) return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
            if (isArrayBuffer) return response.arrayBuffer();
            if (context.responseType === "json") return response.json();
            return response.text();
        }).then((responseData)=>{
            const { response: response } = this;
            self.clearTimeout(this.requestTimeout);
            stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
            const total = responseData[LENGTH];
            if (total) stats.loaded = stats.total = total;
            const loaderResponse = {
                url: response.url,
                data: responseData,
                code: response.status
            };
            if (onProgress && !$fada8102d2a280be$var$isFiniteNumber(config.highWaterMark)) onProgress(stats, context, responseData, response);
            callbacks.onSuccess(loaderResponse, stats, context, response);
        }).catch((error)=>{
            self.clearTimeout(this.requestTimeout);
            if (stats.aborted) return;
            // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
            // when destroying, 'error' itself can be undefined
            const code = !error ? 0 : error.code || 0;
            const text = !error ? null : error.message;
            callbacks.onError({
                code: code,
                text: text
            }, context, error ? error.details : null, stats);
        });
    }
    getCacheAge() {
        let result = null;
        if (this.response) {
            const ageHeader = this.response.headers.get("age");
            result = ageHeader ? parseFloat(ageHeader) : null;
        }
        return result;
    }
    getResponseHeader(name) {
        return this.response ? this.response.headers.get(name) : null;
    }
    loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
        const chunkCache = new $fada8102d2a280be$var$ChunkCache();
        const reader = response.body.getReader();
        const pump = ()=>{
            return reader.read().then((data)=>{
                if (data.done) {
                    if (chunkCache.dataLength) onProgress(stats, context, chunkCache.flush(), response);
                    return Promise.resolve(new ArrayBuffer(0));
                }
                const chunk = data.value;
                const len = chunk.length;
                stats.loaded += len;
                if (len < highWaterMark || chunkCache.dataLength) {
                    // The current chunk is too small to to be emitted or the cache already has data
                    // Push it to the cache
                    chunkCache.push(chunk);
                    if (chunkCache.dataLength >= highWaterMark) // flush in order to join the typed arrays
                    onProgress(stats, context, chunkCache.flush(), response);
                } else // If there's nothing cached already, and the chache is large enough
                // just emit the progress event
                onProgress(stats, context, chunk, response);
                return pump();
            }).catch(()=>{
                /* aborted */ return Promise.reject();
            });
        };
        return pump();
    }
}
function $fada8102d2a280be$var$getRequestParameters(context, signal) {
    const initParams = {
        method: "GET",
        mode: "cors",
        credentials: "same-origin",
        signal: signal,
        headers: new self.Headers($fada8102d2a280be$var$_extends({}, context.headers))
    };
    if (context.rangeEnd) initParams.headers.set("Range", "bytes=" + context.rangeStart + "-" + String(context.rangeEnd - 1));
    return initParams;
}
function $fada8102d2a280be$var$getByteRangeLength(byteRangeHeader) {
    const result = $fada8102d2a280be$var$BYTERANGE.exec(byteRangeHeader);
    if (result) return parseInt(result[2]) - parseInt(result[1]) + 1;
}
function $fada8102d2a280be$var$getContentLength(headers) {
    const contentRange = headers.get("Content-Range");
    if (contentRange) {
        const byteRangeLength = $fada8102d2a280be$var$getByteRangeLength(contentRange);
        if ($fada8102d2a280be$var$isFiniteNumber(byteRangeLength)) return byteRangeLength;
    }
    const contentLength = headers.get("Content-Length");
    if (contentLength) return parseInt(contentLength);
}
function $fada8102d2a280be$var$getRequest(context, initParams) {
    return new self.Request(context.url, initParams);
}
class $fada8102d2a280be$var$FetchError extends Error {
    constructor(message, code, details){
        super(message);
        this.code = void 0;
        this.details = void 0;
        this.code = code;
        this.details = details;
    }
}
const $fada8102d2a280be$var$WHITESPACE_CHAR = /\s/;
const $fada8102d2a280be$var$Cues = {
    newCue (track, startTime, endTime, captionScreen) {
        const result = [];
        let row;
        // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
        let cue;
        let indenting;
        let indent;
        let text;
        const Cue = self.VTTCue || self.TextTrackCue;
        for(let r = 0; r < captionScreen.rows.length; r++){
            row = captionScreen.rows[r];
            indenting = true;
            indent = 0;
            text = "";
            if (!row.isEmpty()) {
                var _track$cues;
                for(let c = 0; c < row.chars.length; c++)if ($fada8102d2a280be$var$WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) indent++;
                else {
                    text += row.chars[c].uchar;
                    indenting = false;
                }
                // To be used for cleaning-up orphaned roll-up captions
                row.cueStartTime = startTime;
                // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                if (startTime === endTime) endTime += 0.0001;
                if (indent >= 16) indent--;
                else indent++;
                const cueText = $fada8102d2a280be$var$fixLineBreaks(text.trim());
                const id = $fada8102d2a280be$var$generateCueId(startTime, endTime, cueText);
                // If this cue already exists in the track do not push it
                if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
                    cue = new Cue(startTime, endTime, cueText);
                    cue.id = id;
                    cue.line = r + 1;
                    cue.align = "left";
                    // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
                    // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
                    // Firefox throws an exception and captions break with out of bounds 0-100 values
                    cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
                    result.push(cue);
                }
            }
        }
        if (track && result.length) {
            // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
            result.sort((cueA, cueB)=>{
                if (cueA.line === "auto" || cueB.line === "auto") return 0;
                if (cueA.line > 8 && cueB.line > 8) return cueB.line - cueA.line;
                return cueA.line - cueB.line;
            });
            result.forEach((cue)=>$fada8102d2a280be$var$addCueToTrack(track, cue));
        }
        return result;
    }
};
/**
 * @deprecated use fragLoadPolicy.default
 */ /**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */ const $fada8102d2a280be$var$defaultLoadPolicy = {
    maxTimeToFirstByteMs: 8000,
    maxLoadTimeMs: 20000,
    timeoutRetry: null,
    errorRetry: null
};
/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */ const $fada8102d2a280be$var$hlsDefaultConfig = $fada8102d2a280be$var$_objectSpread2($fada8102d2a280be$var$_objectSpread2({
    autoStartLoad: true,
    // used by stream-controller
    startPosition: -1,
    // used by stream-controller
    defaultAudioCodec: undefined,
    // used by stream-controller
    debug: false,
    // used by logger
    capLevelOnFPSDrop: false,
    // used by fps-controller
    capLevelToPlayerSize: false,
    // used by cap-level-controller
    ignoreDevicePixelRatio: false,
    // used by cap-level-controller
    initialLiveManifestSize: 1,
    // used by stream-controller
    maxBufferLength: 30,
    // used by stream-controller
    backBufferLength: Infinity,
    // used by buffer-controller
    maxBufferSize: 60000000,
    // used by stream-controller
    maxBufferHole: 0.1,
    // used by stream-controller
    highBufferWatchdogPeriod: 2,
    // used by stream-controller
    nudgeOffset: 0.1,
    // used by stream-controller
    nudgeMaxRetry: 3,
    // used by stream-controller
    maxFragLookUpTolerance: 0.25,
    // used by stream-controller
    liveSyncDurationCount: 3,
    // used by latency-controller
    liveMaxLatencyDurationCount: Infinity,
    // used by latency-controller
    liveSyncDuration: undefined,
    // used by latency-controller
    liveMaxLatencyDuration: undefined,
    // used by latency-controller
    maxLiveSyncPlaybackRate: 1,
    // used by latency-controller
    liveDurationInfinity: false,
    // used by buffer-controller
    /**
   * @deprecated use backBufferLength
   */ liveBackBufferLength: null,
    // used by buffer-controller
    maxMaxBufferLength: 600,
    // used by stream-controller
    enableWorker: true,
    // used by transmuxer
    workerPath: null,
    // used by transmuxer
    enableSoftwareAES: true,
    // used by decrypter
    startLevel: undefined,
    // used by level-controller
    startFragPrefetch: false,
    // used by stream-controller
    fpsDroppedMonitoringPeriod: 5000,
    // used by fps-controller
    fpsDroppedMonitoringThreshold: 0.2,
    // used by fps-controller
    appendErrorMaxRetry: 3,
    // used by buffer-controller
    loader: $fada8102d2a280be$var$XhrLoader,
    // loader: FetchLoader,
    fLoader: undefined,
    // used by fragment-loader
    pLoader: undefined,
    // used by playlist-loader
    xhrSetup: undefined,
    // used by xhr-loader
    licenseXhrSetup: undefined,
    // used by eme-controller
    licenseResponseCallback: undefined,
    // used by eme-controller
    abrController: $fada8102d2a280be$var$AbrController,
    bufferController: $fada8102d2a280be$var$BufferController,
    capLevelController: $fada8102d2a280be$var$CapLevelController,
    errorController: $fada8102d2a280be$var$ErrorController,
    fpsController: $fada8102d2a280be$var$FPSController,
    stretchShortVideoTrack: false,
    // used by mp4-remuxer
    maxAudioFramesDrift: 1,
    // used by mp4-remuxer
    forceKeyFrameOnDiscontinuity: true,
    // used by ts-demuxer
    abrEwmaFastLive: 3,
    // used by abr-controller
    abrEwmaSlowLive: 9,
    // used by abr-controller
    abrEwmaFastVoD: 3,
    // used by abr-controller
    abrEwmaSlowVoD: 9,
    // used by abr-controller
    abrEwmaDefaultEstimate: 5e5,
    // 500 kbps  // used by abr-controller
    abrBandWidthFactor: 0.95,
    // used by abr-controller
    abrBandWidthUpFactor: 0.7,
    // used by abr-controller
    abrMaxWithRealBitrate: false,
    // used by abr-controller
    maxStarvationDelay: 4,
    // used by abr-controller
    maxLoadingDelay: 4,
    // used by abr-controller
    minAutoBitrate: 0,
    // used by hls
    emeEnabled: false,
    // used by eme-controller
    widevineLicenseUrl: undefined,
    // used by eme-controller
    drmSystems: {},
    // used by eme-controller
    drmSystemOptions: {},
    // used by eme-controller
    requestMediaKeySystemAccessFunc: $fada8102d2a280be$var$requestMediaKeySystemAccess,
    // used by eme-controller
    testBandwidth: true,
    progressive: false,
    lowLatencyMode: true,
    cmcd: undefined,
    enableDateRangeMetadataCues: true,
    enableEmsgMetadataCues: true,
    enableID3MetadataCues: true,
    certLoadPolicy: {
        default: $fada8102d2a280be$var$defaultLoadPolicy
    },
    keyLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 8000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 20000,
                backoff: "linear"
            },
            errorRetry: {
                maxNumRetry: 8,
                retryDelayMs: 1000,
                maxRetryDelayMs: 20000,
                backoff: "linear"
            }
        }
    },
    manifestLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: Infinity,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    playlistLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 2,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    fragLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 120000,
            timeoutRetry: {
                maxNumRetry: 4,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 6,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    steeringManifestLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    // These default settings are deprecated in favor of the above policies
    // and are maintained for backwards compatibility
    manifestLoadingTimeOut: 10000,
    manifestLoadingMaxRetry: 1,
    manifestLoadingRetryDelay: 1000,
    manifestLoadingMaxRetryTimeout: 64000,
    levelLoadingTimeOut: 10000,
    levelLoadingMaxRetry: 4,
    levelLoadingRetryDelay: 1000,
    levelLoadingMaxRetryTimeout: 64000,
    fragLoadingTimeOut: 20000,
    fragLoadingMaxRetry: 6,
    fragLoadingRetryDelay: 1000,
    fragLoadingMaxRetryTimeout: 64000
}, $fada8102d2a280be$var$timelineConfig()), {}, {
    subtitleStreamController: $fada8102d2a280be$var$SubtitleStreamController,
    subtitleTrackController: $fada8102d2a280be$var$SubtitleTrackController,
    timelineController: $fada8102d2a280be$var$TimelineController,
    audioStreamController: $fada8102d2a280be$var$AudioStreamController,
    audioTrackController: $fada8102d2a280be$var$AudioTrackController,
    emeController: $fada8102d2a280be$var$EMEController,
    cmcdController: $fada8102d2a280be$var$CMCDController,
    contentSteeringController: $fada8102d2a280be$var$ContentSteeringController
});
function $fada8102d2a280be$var$timelineConfig() {
    return {
        cueHandler: $fada8102d2a280be$var$Cues,
        // used by timeline-controller
        enableWebVTT: true,
        // used by timeline-controller
        enableIMSC1: true,
        // used by timeline-controller
        enableCEA708Captions: true,
        // used by timeline-controller
        captionsTextTrack1Label: "English",
        // used by timeline-controller
        captionsTextTrack1LanguageCode: "en",
        // used by timeline-controller
        captionsTextTrack2Label: "Spanish",
        // used by timeline-controller
        captionsTextTrack2LanguageCode: "es",
        // used by timeline-controller
        captionsTextTrack3Label: "Unknown CC",
        // used by timeline-controller
        captionsTextTrack3LanguageCode: "",
        // used by timeline-controller
        captionsTextTrack4Label: "Unknown CC",
        // used by timeline-controller
        captionsTextTrack4LanguageCode: "",
        // used by timeline-controller
        renderTextTracksNatively: true
    };
}
/**
 * @ignore
 */ function $fada8102d2a280be$var$mergeConfig(defaultConfig, userConfig) {
    if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
    if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
    if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
    const defaultsCopy = $fada8102d2a280be$var$deepCpy(defaultConfig);
    // Backwards compatibility with deprecated config values
    const deprecatedSettingTypes = [
        "manifest",
        "level",
        "frag"
    ];
    const deprecatedSettings = [
        "TimeOut",
        "MaxRetry",
        "RetryDelay",
        "MaxRetryTimeout"
    ];
    deprecatedSettingTypes.forEach((type)=>{
        const policyName = `${type === "level" ? "playlist" : type}LoadPolicy`;
        const policyNotSet = userConfig[policyName] === undefined;
        const report = [];
        deprecatedSettings.forEach((setting)=>{
            const deprecatedSetting = `${type}Loading${setting}`;
            const value = userConfig[deprecatedSetting];
            if (value !== undefined && policyNotSet) {
                report.push(deprecatedSetting);
                const settings = defaultsCopy[policyName].default;
                userConfig[policyName] = {
                    default: settings
                };
                switch(setting){
                    case "TimeOut":
                        settings.maxLoadTimeMs = value;
                        settings.maxTimeToFirstByteMs = value;
                        break;
                    case "MaxRetry":
                        settings.errorRetry.maxNumRetry = value;
                        settings.timeoutRetry.maxNumRetry = value;
                        break;
                    case "RetryDelay":
                        settings.errorRetry.retryDelayMs = value;
                        settings.timeoutRetry.retryDelayMs = value;
                        break;
                    case "MaxRetryTimeout":
                        settings.errorRetry.maxRetryDelayMs = value;
                        settings.timeoutRetry.maxRetryDelayMs = value;
                        break;
                }
            }
        });
        if (report.length) $fada8102d2a280be$var$logger.warn(`hls.js config: "${report.join('", "')}" setting(s) are deprecated, use "${policyName}": ${JSON.stringify(userConfig[policyName])}`);
    });
    return $fada8102d2a280be$var$_objectSpread2($fada8102d2a280be$var$_objectSpread2({}, defaultsCopy), userConfig);
}
function $fada8102d2a280be$var$deepCpy(obj) {
    if (obj && typeof obj === "object") {
        if (Array.isArray(obj)) return obj.map($fada8102d2a280be$var$deepCpy);
        return Object.keys(obj).reduce((result, key)=>{
            result[key] = $fada8102d2a280be$var$deepCpy(obj[key]);
            return result;
        }, {});
    }
    return obj;
}
/**
 * @ignore
 */ function $fada8102d2a280be$var$enableStreamingMode(config) {
    const currentLoader = config.loader;
    if (currentLoader !== $fada8102d2a280be$var$FetchLoader && currentLoader !== $fada8102d2a280be$var$XhrLoader) {
        // If a developer has configured their own loader, respect that choice
        $fada8102d2a280be$var$logger.log("[config]: Custom loader detected, cannot enable progressive streaming");
        config.progressive = false;
    } else {
        const canStreamProgressively = $fada8102d2a280be$var$fetchSupported();
        if (canStreamProgressively) {
            config.loader = $fada8102d2a280be$var$FetchLoader;
            config.progressive = true;
            config.enableSoftwareAES = true;
            $fada8102d2a280be$var$logger.log("[config]: Progressive streaming enabled, using FetchLoader");
        }
    }
}
/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */ class $fada8102d2a280be$export$2e2bcd8739ae039 {
    /**
   * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
   */ /**
   * The configuration object provided on player instantiation.
   */ /**
   * Get the video-dev/hls.js package version.
   */ static get version() {
        return "1.4.6";
    }
    /**
   * Check if the required MediaSource Extensions are available.
   */ static isSupported() {
        return $fada8102d2a280be$var$isSupported();
    }
    static get Events() {
        return $fada8102d2a280be$var$Events;
    }
    static get ErrorTypes() {
        return $fada8102d2a280be$var$ErrorTypes;
    }
    static get ErrorDetails() {
        return $fada8102d2a280be$var$ErrorDetails;
    }
    /**
   * Get the default configuration applied to new instances.
   */ static get DefaultConfig() {
        if (!$fada8102d2a280be$export$2e2bcd8739ae039.defaultConfig) return $fada8102d2a280be$var$hlsDefaultConfig;
        return $fada8102d2a280be$export$2e2bcd8739ae039.defaultConfig;
    }
    /**
   * Replace the default configuration applied to new instances.
   */ static set DefaultConfig(defaultConfig) {
        $fada8102d2a280be$export$2e2bcd8739ae039.defaultConfig = defaultConfig;
    }
    /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */ constructor(userConfig = {}){
        this.config = void 0;
        this.userConfig = void 0;
        this.coreComponents = void 0;
        this.networkControllers = void 0;
        this._emitter = new $fada8102d2a280be$var$EventEmitter();
        this._autoLevelCapping = void 0;
        this._maxHdcpLevel = null;
        this.abrController = void 0;
        this.bufferController = void 0;
        this.capLevelController = void 0;
        this.latencyController = void 0;
        this.levelController = void 0;
        this.streamController = void 0;
        this.audioTrackController = void 0;
        this.subtitleTrackController = void 0;
        this.emeController = void 0;
        this.cmcdController = void 0;
        this._media = null;
        this.url = null;
        $fada8102d2a280be$var$enableLogs(userConfig.debug || false, "Hls instance");
        const config = this.config = $fada8102d2a280be$var$mergeConfig($fada8102d2a280be$export$2e2bcd8739ae039.DefaultConfig, userConfig);
        this.userConfig = userConfig;
        this._autoLevelCapping = -1;
        if (config.progressive) $fada8102d2a280be$var$enableStreamingMode(config);
        // core controllers and network loaders
        const { abrController: ConfigAbrController, bufferController: ConfigBufferController, capLevelController: ConfigCapLevelController, errorController: ConfigErrorController, fpsController: ConfigFpsController } = config;
        const errorController = new ConfigErrorController(this);
        const abrController = this.abrController = new ConfigAbrController(this);
        const bufferController = this.bufferController = new ConfigBufferController(this);
        const capLevelController = this.capLevelController = new ConfigCapLevelController(this);
        const fpsController = new ConfigFpsController(this);
        const playListLoader = new $fada8102d2a280be$var$PlaylistLoader(this);
        const id3TrackController = new $fada8102d2a280be$var$ID3TrackController(this);
        const ConfigContentSteeringController = config.contentSteeringController;
        // ConentSteeringController is defined before LevelController to receive Multivariant Playlist events first
        const contentSteering = ConfigContentSteeringController ? new ConfigContentSteeringController(this) : null;
        const levelController = this.levelController = new $fada8102d2a280be$var$LevelController(this, contentSteering);
        // FragmentTracker must be defined before StreamController because the order of event handling is important
        const fragmentTracker = new $fada8102d2a280be$var$FragmentTracker(this);
        const keyLoader = new $fada8102d2a280be$var$KeyLoader(this.config);
        const streamController = this.streamController = new $fada8102d2a280be$var$StreamController(this, fragmentTracker, keyLoader);
        // Cap level controller uses streamController to flush the buffer
        capLevelController.setStreamController(streamController);
        // fpsController uses streamController to switch when frames are being dropped
        fpsController.setStreamController(streamController);
        const networkControllers = [
            playListLoader,
            levelController,
            streamController
        ];
        if (contentSteering) networkControllers.splice(1, 0, contentSteering);
        this.networkControllers = networkControllers;
        const coreComponents = [
            abrController,
            bufferController,
            capLevelController,
            fpsController,
            id3TrackController,
            fragmentTracker
        ];
        this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
        const AudioStreamControllerClass = config.audioStreamController;
        if (AudioStreamControllerClass) networkControllers.push(new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
        // subtitleTrackController must be defined before subtitleStreamController because the order of event handling is important
        this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
        const SubtitleStreamControllerClass = config.subtitleStreamController;
        if (SubtitleStreamControllerClass) networkControllers.push(new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
        this.createController(config.timelineController, coreComponents);
        keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
        this.cmcdController = this.createController(config.cmcdController, coreComponents);
        this.latencyController = this.createController($fada8102d2a280be$var$LatencyController, coreComponents);
        this.coreComponents = coreComponents;
        // Error controller handles errors before and after all other controllers
        // This listener will be invoked after all other controllers error listeners
        networkControllers.push(errorController);
        const onErrorOut = errorController.onErrorOut;
        if (typeof onErrorOut === "function") this.on($fada8102d2a280be$var$Events.ERROR, onErrorOut, errorController);
    }
    createController(ControllerClass, components) {
        if (ControllerClass) {
            const controllerInstance = new ControllerClass(this);
            if (components) components.push(controllerInstance);
            return controllerInstance;
        }
        return null;
    }
    // Delegate the EventEmitter through the public API of Hls.js
    on(event, listener, context = this) {
        this._emitter.on(event, listener, context);
    }
    once(event, listener, context = this) {
        this._emitter.once(event, listener, context);
    }
    removeAllListeners(event) {
        this._emitter.removeAllListeners(event);
    }
    off(event, listener, context = this, once) {
        this._emitter.off(event, listener, context, once);
    }
    listeners(event) {
        return this._emitter.listeners(event);
    }
    emit(event, name, eventObject) {
        return this._emitter.emit(event, name, eventObject);
    }
    trigger(event, eventObject) {
        if (this.config.debug) return this.emit(event, event, eventObject);
        else try {
            return this.emit(event, event, eventObject);
        } catch (e) {
            $fada8102d2a280be$var$logger.error("An internal error happened while handling event " + event + '. Error message: "' + e.message + '". Here is a stacktrace:', e);
            this.trigger($fada8102d2a280be$var$Events.ERROR, {
                type: $fada8102d2a280be$var$ErrorTypes.OTHER_ERROR,
                details: $fada8102d2a280be$var$ErrorDetails.INTERNAL_EXCEPTION,
                fatal: false,
                event: event,
                error: e
            });
        }
        return false;
    }
    listenerCount(event) {
        return this._emitter.listenerCount(event);
    }
    /**
   * Dispose of the instance
   */ destroy() {
        $fada8102d2a280be$var$logger.log("destroy");
        this.trigger($fada8102d2a280be$var$Events.DESTROYING, undefined);
        this.detachMedia();
        this.removeAllListeners();
        this._autoLevelCapping = -1;
        this.url = null;
        this.networkControllers.forEach((component)=>component.destroy());
        this.networkControllers.length = 0;
        this.coreComponents.forEach((component)=>component.destroy());
        this.coreComponents.length = 0;
        // Remove any references that could be held in config options or callbacks
        const config = this.config;
        config.xhrSetup = config.fetchSetup = undefined;
        // @ts-ignore
        this.userConfig = null;
    }
    /**
   * Attaches Hls.js to a media element
   */ attachMedia(media) {
        $fada8102d2a280be$var$logger.log("attachMedia");
        this._media = media;
        this.trigger($fada8102d2a280be$var$Events.MEDIA_ATTACHING, {
            media: media
        });
    }
    /**
   * Detach Hls.js from the media
   */ detachMedia() {
        $fada8102d2a280be$var$logger.log("detachMedia");
        this.trigger($fada8102d2a280be$var$Events.MEDIA_DETACHING, undefined);
        this._media = null;
    }
    /**
   * Set the source URL. Can be relative or absolute.
   */ loadSource(url) {
        this.stopLoad();
        const media = this.media;
        const loadedSource = this.url;
        const loadingSource = this.url = $fada8102d2a280be$var$urlToolkitExports.buildAbsoluteURL(self.location.href, url, {
            alwaysNormalize: true
        });
        $fada8102d2a280be$var$logger.log(`loadSource:${loadingSource}`);
        if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
            this.detachMedia();
            this.attachMedia(media);
        }
        // when attaching to a source URL, trigger a playlist load
        this.trigger($fada8102d2a280be$var$Events.MANIFEST_LOADING, {
            url: url
        });
    }
    /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */ startLoad(startPosition = -1) {
        $fada8102d2a280be$var$logger.log(`startLoad(${startPosition})`);
        this.networkControllers.forEach((controller)=>{
            controller.startLoad(startPosition);
        });
    }
    /**
   * Stop loading of any stream data.
   */ stopLoad() {
        $fada8102d2a280be$var$logger.log("stopLoad");
        this.networkControllers.forEach((controller)=>{
            controller.stopLoad();
        });
    }
    /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */ swapAudioCodec() {
        $fada8102d2a280be$var$logger.log("swapAudioCodec");
        this.streamController.swapAudioCodec();
    }
    /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */ recoverMediaError() {
        $fada8102d2a280be$var$logger.log("recoverMediaError");
        const media = this._media;
        this.detachMedia();
        if (media) this.attachMedia(media);
    }
    removeLevel(levelIndex, urlId = 0) {
        this.levelController.removeLevel(levelIndex, urlId);
    }
    /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, BANDWIDTH, SCORE, and RESOLUTION (height)
   */ get levels() {
        const levels = this.levelController.levels;
        return levels ? levels : [];
    }
    /**
   * Index of quality level (variant) currently played
   */ get currentLevel() {
        return this.streamController.currentLevel;
    }
    /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */ set currentLevel(newLevel) {
        $fada8102d2a280be$var$logger.log(`set currentLevel:${newLevel}`);
        this.loadLevel = newLevel;
        this.abrController.clearTimer();
        this.streamController.immediateLevelSwitch();
    }
    /**
   * Index of next quality level loaded as scheduled by stream controller.
   */ get nextLevel() {
        return this.streamController.nextLevel;
    }
    /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */ set nextLevel(newLevel) {
        $fada8102d2a280be$var$logger.log(`set nextLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
        this.streamController.nextLevelSwitch();
    }
    /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */ get loadLevel() {
        return this.levelController.level;
    }
    /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */ set loadLevel(newLevel) {
        $fada8102d2a280be$var$logger.log(`set loadLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
    }
    /**
   * get next quality level loaded
   */ get nextLoadLevel() {
        return this.levelController.nextLoadLevel;
    }
    /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */ set nextLoadLevel(level) {
        this.levelController.nextLoadLevel = level;
    }
    /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */ get firstLevel() {
        return Math.max(this.levelController.firstLevel, this.minAutoLevel);
    }
    /**
   * Sets "first-level", see getter.
   */ set firstLevel(newLevel) {
        $fada8102d2a280be$var$logger.log(`set firstLevel:${newLevel}`);
        this.levelController.firstLevel = newLevel;
    }
    /**
   * Return start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */ get startLevel() {
        return this.levelController.startLevel;
    }
    /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */ set startLevel(newLevel) {
        $fada8102d2a280be$var$logger.log(`set startLevel:${newLevel}`);
        // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
        if (newLevel !== -1) newLevel = Math.max(newLevel, this.minAutoLevel);
        this.levelController.startLevel = newLevel;
    }
    /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */ get capLevelToPlayerSize() {
        return this.config.capLevelToPlayerSize;
    }
    /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */ set capLevelToPlayerSize(shouldStartCapping) {
        const newCapLevelToPlayerSize = !!shouldStartCapping;
        if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
            if (newCapLevelToPlayerSize) this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
            else {
                this.capLevelController.stopCapping();
                this.autoLevelCapping = -1;
                this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
            }
            this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
        }
    }
    /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */ get autoLevelCapping() {
        return this._autoLevelCapping;
    }
    /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */ get bandwidthEstimate() {
        const { bwEstimator: bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.getEstimate();
    }
    /**
   * get time to first byte estimate
   * @type {number}
   */ get ttfbEstimate() {
        const { bwEstimator: bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.getEstimateTTFB();
    }
    /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */ set autoLevelCapping(newLevel) {
        if (this._autoLevelCapping !== newLevel) {
            $fada8102d2a280be$var$logger.log(`set autoLevelCapping:${newLevel}`);
            this._autoLevelCapping = newLevel;
        }
    }
    get maxHdcpLevel() {
        return this._maxHdcpLevel;
    }
    set maxHdcpLevel(value) {
        if ($fada8102d2a280be$var$HdcpLevels.indexOf(value) > -1) this._maxHdcpLevel = value;
    }
    /**
   * True when automatic level selection enabled
   */ get autoLevelEnabled() {
        return this.levelController.manualLevel === -1;
    }
    /**
   * Level set manually (if any)
   */ get manualLevel() {
        return this.levelController.manualLevel;
    }
    /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */ get minAutoLevel() {
        const { levels: levels, config: { minAutoBitrate: minAutoBitrate } } = this;
        if (!levels) return 0;
        const len = levels.length;
        for(let i = 0; i < len; i++){
            if (levels[i].maxBitrate >= minAutoBitrate) return i;
        }
        return 0;
    }
    /**
   * max level selectable in auto mode according to autoLevelCapping
   */ get maxAutoLevel() {
        const { levels: levels, autoLevelCapping: autoLevelCapping, maxHdcpLevel: maxHdcpLevel } = this;
        let maxAutoLevel;
        if (autoLevelCapping === -1 && levels && levels.length) maxAutoLevel = levels.length - 1;
        else maxAutoLevel = autoLevelCapping;
        if (maxHdcpLevel) for(let i = maxAutoLevel; i--;){
            const hdcpLevel = levels[i].attrs["HDCP-LEVEL"];
            if (hdcpLevel && hdcpLevel <= maxHdcpLevel) return i;
        }
        return maxAutoLevel;
    }
    /**
   * next automatically selected quality level
   */ get nextAutoLevel() {
        // ensure next auto level is between  min and max auto level
        return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
    }
    /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */ set nextAutoLevel(nextLevel) {
        this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, nextLevel);
    }
    /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */ get playingDate() {
        return this.streamController.currentProgramDateTime;
    }
    get mainForwardBufferInfo() {
        return this.streamController.getMainFwdBufferInfo();
    }
    /**
   * Get the list of selectable audio tracks
   */ get audioTracks() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTracks : [];
    }
    /**
   * index of the selected audio track (index in audio track lists)
   */ get audioTrack() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTrack : -1;
    }
    /**
   * selects an audio track, based on its index in audio track lists
   */ set audioTrack(audioTrackId) {
        const audioTrackController = this.audioTrackController;
        if (audioTrackController) audioTrackController.audioTrack = audioTrackId;
    }
    /**
   * get alternate subtitle tracks list from playlist
   */ get subtitleTracks() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
    }
    /**
   * index of the selected subtitle track (index in subtitle track lists)
   */ get subtitleTrack() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
    }
    get media() {
        return this._media;
    }
    /**
   * select an subtitle track, based on its index in subtitle track lists
   */ set subtitleTrack(subtitleTrackId) {
        const subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleTrack = subtitleTrackId;
    }
    /**
   * Whether subtitle display is enabled or not
   */ get subtitleDisplay() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
    }
    /**
   * Enable/disable subtitle display rendering
   */ set subtitleDisplay(value) {
        const subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleDisplay = value;
    }
    /**
   * get mode for Low-Latency HLS loading
   */ get lowLatencyMode() {
        return this.config.lowLatencyMode;
    }
    /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */ set lowLatencyMode(mode) {
        this.config.lowLatencyMode = mode;
    }
    /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */ get liveSyncPosition() {
        return this.latencyController.liveSyncPosition;
    }
    /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */ get latency() {
        return this.latencyController.latency;
    }
    /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */ get maxLatency() {
        return this.latencyController.maxLatency;
    }
    /**
   * target distance from the edge as calculated by the latency controller
   */ get targetLatency() {
        return this.latencyController.targetLatency;
    }
    /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */ get drift() {
        return this.latencyController.drift;
    }
    /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */ get forceStartLoad() {
        return this.streamController.forceStartLoad;
    }
}
$fada8102d2a280be$export$2e2bcd8739ae039.defaultConfig = void 0;




// skip the camera rotation at start
const $1277f5d9c8b9f6ae$var$videoStartTime = 3.0;
function $1277f5d9c8b9f6ae$var$parseTime(s) {
    const bits = s.split(":");
    if (bits.length === 2) return 60 * parseFloat(bits[0]) + parseFloat(bits[1]);
    else return parseFloat(bits[0]);
}
class $1277f5d9c8b9f6ae$var$ConditionDecisionList {
    cds = [];
    constructor(args){
        args.forEach((arg)=>{
            this.cds.push({
                timeRange: [
                    $1277f5d9c8b9f6ae$var$parseTime(arg.in),
                    $1277f5d9c8b9f6ae$var$parseTime(arg.out)
                ],
                condition: arg.condition,
                severity: arg.severity
            });
        });
    }
    findIndex(time) {
        return this.cds.findIndex((cd)=>{
            const [t0, t1] = cd.timeRange;
            return t0 <= time && time < t1;
        });
    }
    fireEvent(index) {
        if (index < 0) (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        else {
            const { condition: condition, severity: severity } = this.cds[index];
            (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(condition, severity);
        }
    }
}
const $1277f5d9c8b9f6ae$var$conditionDecisionList = new $1277f5d9c8b9f6ae$var$ConditionDecisionList([
    {
        in: "0:41.2",
        out: "0:55.2",
        condition: "armd",
        severity: 4
    },
    {
        in: "2:35.1",
        out: "02:54",
        condition: "diabetic-retinopathy",
        severity: 4
    },
    {
        in: "5:29.0",
        out: "5:53.0",
        condition: "armd",
        severity: 4
    },
    {
        in: "8:01.1",
        out: "8:22.1",
        condition: "cataracts",
        severity: 4
    },
    {
        in: "9:59.2",
        out: "10:23",
        condition: "armd",
        severity: 4
    }
]);
class $1277f5d9c8b9f6ae$export$412a273e62ec80f9 {
    videoElement;
    texture;
    conditionDecisionIndex = -1;
    constructor(source, _perspectiveCamera){
        this.videoElement = document.createElement("video");
        this.videoElement.setAttribute("playsinline", "playsinline");
        this.videoElement.style.visibility = "hidden";
        this.videoElement.playsInline = true;
        this.videoElement.setAttribute("type", "video/mp4");
        this.videoElement.setAttribute("crossorigin", "anonymous");
        this.videoElement.width = 1920;
        this.videoElement.height = 1080;
        // HLS
        if ((0, $fada8102d2a280be$export$2e2bcd8739ae039).isSupported()) {
            const hls = new (0, $fada8102d2a280be$export$2e2bcd8739ae039)();
            hls.loadSource(source);
            hls.attachMedia(this.videoElement);
        } else if (this.videoElement.canPlayType("application/vnd.apple.mpegurl")) this.videoElement.src = source;
        else throw Error("No video stream supported");
        this.texture = new $e97a97f0b0cf48c9$export$6e09d1edf8d5a25c(this.videoElement, $e97a97f0b0cf48c9$export$d64030b316d3b087);
        this.texture.magFilter = $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
        this.texture.minFilter = $e97a97f0b0cf48c9$export$8a72f490b25c56c8;
        this.texture.needsUpdate = true;
        this.eventListener();
    }
    play() {
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        this.conditionDecisionIndex = -1;
        this.videoElement.currentTime = $1277f5d9c8b9f6ae$var$videoStartTime;
        this.videoElement.play();
    }
    close() {
        this.videoElement.pause();
    }
    get playing() {
        return !(this.videoElement.paused || this.videoElement.ended);
    }
    eyeconditions() {
        const { currentTime: currentTime } = this.videoElement;
        const index = $1277f5d9c8b9f6ae$var$conditionDecisionList.findIndex(currentTime);
        if (index !== this.conditionDecisionIndex) {
            console.log("360 video: conditionDecisionIndex=%d", index);
            this.conditionDecisionIndex = index;
            $1277f5d9c8b9f6ae$var$conditionDecisionList.fireEvent(index);
        }
    }
    update() {
        this.eyeconditions();
    }
    eventListener() {
        console.log("eventlistener");
        document.addEventListener("rnib:360-video", (e)=>{
            console.log("360 video event");
            if (e.detail.state === true) this.play();
            else this.close();
        });
        let wet = false;
        function toggleExampleCondition() {
            if (wet) {
                (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
                wet = false;
            } else {
                (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("glaucoma", 3);
                wet = true;
            }
        }
        const clamp = (x, a, b)=>x < a ? a : x > b ? b : x;
        let eyeSep = 0;
        function adjustEyeSep(dir) {
            const step = 0.5;
            const limits = [
                0.0,
                6.5
            ];
            eyeSep = clamp(eyeSep + step * dir, ...limits);
            (0, $85a5f587c2a7b3b2$export$997607796c4801b3)(eyeSep);
            console.log("eyeSep:", eyeSep.toFixed(1));
        }
        const createElement = (tag, ...props)=>{
            const el = Object.assign(document.createElement(tag), ...props);
            if (typeof props.style === "string") el.style.cssText = props.style;
            return el;
        };
        const box = createElement("div", {
            style: `position: absolute; top: 0; right: 0; margin: 5px; display: flex; flex-flow: row; gap: 10px; background: rgba(0 0 0 / 25%); border-radius: 5px; padding: 5px 10px;`
        });
        const label = createElement("div", {
            style: `color: white; font: 20px system-ui;`,
            innerText: "eyeSep = 0.0"
        });
        const slider = createElement("input", {
            type: "range",
            min: -65,
            max: 65,
            oninput (e) {
                eyeSep = parseInt(e.target.value) * 0.1, (0, $85a5f587c2a7b3b2$export$997607796c4801b3)(eyeSep);
                label.innerText = "eyeSep = " + eyeSep.toFixed(1);
            }
        });
        box.append(label, slider);
        document.body.append(box);
        document.addEventListener("keydown", (e)=>{
            switch(e.code){
                case "Digit1":
                    toggleExampleCondition();
                    break;
                case "BracketLeft":
                    adjustEyeSep(-1);
                    break;
                case "BracketRight":
                    adjustEyeSep(1);
                    break;
                case "KeyF":
                    document.dispatchEvent(new CustomEvent("rnib:flipCameras"));
                    break;
                default:
                    return;
            }
            e.stopPropagation();
            e.preventDefault();
        });
    }
}




class $eb9f3dd2f8f9af2b$export$2e2bcd8739ae039 extends $e97a97f0b0cf48c9$export$e4dd07dff30cc924 {
    arcGeometry;
    arcGhostGeometry;
    sphereGeometry;
    sphereMaterial;
    arcMaterial;
    arcGhostMaterial;
    arcMesh;
    arcGhostMesh;
    sphereMesh;
    sphere;
    focusing = false;
    arc;
    reticleTimerOffset;
    // private camera: THREE.Camera;
    clock;
    offsetTime;
    outlineMesh;
    outlineMaterial;
    constructor(clock){
        super();
        this.sphereMaterial = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            color: "#0074FF"
        });
        this.arcMaterial = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            color: "#FFFFFF"
        });
        this.arcGhostMaterial = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            color: "#808080",
            opacity: 0.3
        });
        this.arc = 2 * Math.PI;
        this.outlineMaterial = new $e97a97f0b0cf48c9$export$55cbcc9b622fe1f5({
            color: 0xffffff,
            side: $e97a97f0b0cf48c9$export$d9f0486e75b5ace,
            visible: true
        });
        this.arcGeometry = new $e97a97f0b0cf48c9$export$19d55f905fa4f2cb(0.4, 0.0001, 5, 20, this.arc);
        this.arcGhostGeometry = new $e97a97f0b0cf48c9$export$19d55f905fa4f2cb(0.4, 0.05, 3, 20);
        this.sphereGeometry = new $e97a97f0b0cf48c9$export$d5d06a966fec4192(0.05, 5, 5);
        this.arcMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5(this.arcGeometry, this.arcMaterial);
        this.arcGhostMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5(this.arcGhostGeometry, this.arcGhostMaterial);
        this.sphereMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5(this.sphereGeometry, this.sphereMaterial);
        this.arcMesh.rotation.set(0, Math.PI, Math.PI / 2);
        this.outlineMesh = new $e97a97f0b0cf48c9$export$e176487c05830cc5(this.sphereGeometry, this.outlineMaterial);
        this.outlineMesh.scale.multiplyScalar(1.3);
        // this.camera = camera;
        this.sphere = new $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4();
        this.sphere.add(this.sphereMesh, this.outlineMesh);
        this.offsetTime = 0;
        this.clock = clock;
        this.reticleTimerOffset = 0;
        this.add(this.arcMesh);
        this.add(this.arcGhostMesh);
        this.add(this.sphere);
        // this.mesh.scale.set(0.1, 0.1, 0.1);
        this.init();
    }
    defaultPointer() {
        this.focusing = false;
    }
    loadingAnimation() {
        this.focusing = true;
    }
    setPosition(intersectingPoint) {
        let { x: x, y: y, z: z } = intersectingPoint;
        this.sphere.position.set(x, y, z + this.reticleTimerOffset);
        this.arcMesh.position.set(x, y, z + this.reticleTimerOffset);
        this.arcGhostMesh.position.set(x, y, z + this.reticleTimerOffset);
    }
    rotateSprite() {
        // const vtr = new THREE.Vector3(this.mesh.position.x, this.mesh.position.y, this.mesh.position.z);
        // const quatCopy = vtr.quaternion.copy(this.camera.quaternion);
        const elapsedTime = this.clock.getElapsedTime();
        const time = elapsedTime - this.offsetTime;
        // this.mesh.applyQuaternion(this.camera.quaternion);
        // console.log(params.focusDelay, time, this.focusing);
        if (!this.arcMesh || !this.sphereMesh) return;
        if (this.focusing && this.arc < 2 * Math.PI && time > (0, $67eb3f7e442cf16e$export$281ad3752a540efe).focusDelay / 1000) {
            const adjustedTime = time - (0, $67eb3f7e442cf16e$export$281ad3752a540efe).focusDelay / 1000;
            //this.arc += (Math.PI/90);
            this.arc = 2 * Math.PI * adjustedTime / ((0, $67eb3f7e442cf16e$export$281ad3752a540efe).focusTime / 1000);
            this.arcGeometry.dispose();
            this.arcGeometry = new $e97a97f0b0cf48c9$export$19d55f905fa4f2cb(0.4, 0.06, 3, 20, this.arc);
            this.arcMesh.geometry = this.arcGeometry;
            this.arcMesh.rotation.z = Math.PI * 0.5;
            this.reticleTimerOffset = 0.5;
            if (!this.arcMesh.visible && !this.arcGhostMesh.visible) {
                this.arcMesh.visible = true;
                this.arcGhostMesh.visible = true;
            }
        } else if (this.arc > 0.01) {
            if (this.arcMesh.visible && this.arcGhostMesh.visible) {
                this.arcMesh.visible = false;
                this.arcGhostMesh.visible = false;
            }
            this.arc = 0;
            this.reticleTimerOffset = 0;
        }
        if (this.arc > 2 * Math.PI) this.focusing = false;
        if (this.focusing === false) this.offsetTime = this.clock.getElapsedTime();
    }
    init() {
        document.addEventListener("rnib:focuson", ()=>{
            this.loadingAnimation();
        });
        document.addEventListener("rnib:focusout", ()=>this.defaultPointer());
        document.addEventListener("rnib:click", ()=>this.defaultPointer());
    }
}



class $4a6c6ddd13690e16$export$2e2bcd8739ae039 extends (0, $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4) {
    reticle;
    raycaster = new (0, $e97a97f0b0cf48c9$export$8b7aaceff00bd2f)();
    originVector = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)();
    directionVector = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)();
    constructor(clock){
        super();
        this.reticle = new (0, $eb9f3dd2f8f9af2b$export$2e2bcd8739ae039)(clock);
        this.reticle.position.z = -5.95;
        this.add(this.reticle);
    }
    objectInterceptor = (objects)=>{
        // calculate objects intersecting the picking ray
        // // update the picking ray with the camera and pointer position
        this.getWorldDirection(this.directionVector);
        this.raycaster.set(this.originVector, this.directionVector.negate());
        return this.raycaster.intersectObjects(objects);
    };
    update = (objects)=>{
        // this.reticle?.arcMesh.lookAt(this.perspectiveCamera.position);
        // this.reticle?.arcGhostMesh.lookAt(this.perspectiveCamera.position);
        this.reticle?.rotateSprite();
        return this.objectInterceptor(objects);
    };
}


var $6941faeb257230e7$exports = {};
$6941faeb257230e7$exports = JSON.parse('{"task-mode":{"scenes":[{"name":"Explore and experience different parts of the country","tagName":"planning","script":[{"type":"text","copy":"Scenario 1: Explore and experience different parts of the country","screenTime":5500},{"type":"text","copy":"This task requires that you have access to a computer,</br> tablet or additional smartphone.","screenTime":6500},{"type":"text","copy":"Planning is an important part of any journey.","screenTime":3500},{"type":"text","copy":"But if you are blind or partially sighted, this can</br>often be complicated before you have even left the door.","screenTime":6000},{"type":"text","copy":"Let’s try it out.","screenTime":2000},{"type":"text","copy":"Do you have your computer, tablet or additional smartphone ready?","screenTime":4000},{"type":"text","copy":"Now open a journey app such as google or apple maps","screenTime":4000},{"type":"input","copy":"Let us know when you are ready to continue","screenTime":2400},{"type":"text","copy":"Looking at the screen, it is simple to begin planning a journey, right?","screenTime":4000},{"type":"random","copy":"Now try and plan a journey by putting in a place or postcode","screenTime":4500},{"type":"input2","copy":"Understanding the directions and information is difficult, isn’t it?","screenTime":4000},{"type":"text","copy":"Did you know? 98% of the top 1 million websites’ homepages</br>have accessibility errors preventing tasks to be complete","screenTime":9000},{"type":"text","copy":"Many blind and partially sighted people are not able to make the journeys</br>they want to, limiting the ability to work and participate in society.","screenTime":9000},{"type":"text","copy":"40% need support during every trip, and 80% need</br>support on a journey that’s unfamiliar to them.","screenTime":7500},{"type":"text","copy":"Over half (61%) of people with sight loss find</br>it difficult to navigate public transport facilities","screenTime":7000},{"type":"text","copy":"25% of blind and partially sighted people feel</br>they are not getting out independently enough","screenTime":8000},{"type":"end","copy":"Would you like to know more about this eye condition?","screenTime":3000}]},{"name":"Happily go shopping for the things I want","tagName":"shopping","script":[{"type":"text","copy":"Scenario 2: Happily go shopping for the things I want","screenTime":5000},{"type":"text","copy":"This task requires that you have access to packaged products</br>which have ingredients or instructions written on them.","screenTime":7500},{"type":"text","copy":"Shopping should be an easy and enjoyable experience","screenTime":3500},{"type":"text","copy":"But it can be tricky if you are blind or partially sighted.","screenTime":4000},{"type":"text","copy":"Have you got your packaged product?","screenTime":3000},{"type":"input","copy":"Let us know when you are ready to continue","screenTime":2500},{"type":"random","copy":"Looking at the product through the phone\'s screen,</br>you can easily tell what it is you\'re holding right?","screenTime":5500},{"type":"input2","copy":"Reading the information is difficult, isn’t it?","screenTime":4000},{"type":"text","copy":"Did you know? 9 out of 10, that\'s (90%) blind and partially sighted</br>people find it difficult or impossible to read packing information","screenTime":10000},{"type":"text","copy":"People living with sight loss for less than 5 years</br>are less likely to be able to go out shopping alone","screenTime":6000},{"type":"text","copy":"People living with sight loss since birth or childhood are more likely</br>to be able to go shopping by themselves (Source VI lives report 2022)","screenTime":11900},{"type":"end","copy":"Would you like to know more about this eye condition?","screenTime":3000}]},{"name":"Keep on top of everything I want done around</br>the home, in the way that I want it.","tagName":"home","script":[{"type":"text","copy":"Scenario 3: Keep on top of everything I want</br>done around the home, in the way that I want it","screenTime":9500},{"type":"text","copy":"This task requires that you have access to a</br>letter or a nearby appliance such as a washing machine.","screenTime":6500},{"type":"text","copy":"Being independent and managing things</br>at home we should be able to do","screenTime":4000},{"type":"text","copy":"But if you are blind or partially sighted</br>this can be harder than you think.","screenTime":4500},{"type":"text","copy":"Have you got a letter to hand or</br>are you near an appliance?","screenTime":3500},{"type":"input","copy":"Let us know when you are ready to continue","screenTime":2500},{"type":"text","copy":"Looking at the letter or text on the appliance menu</br>or appliance settings through your phone’s screen,","screenTime":5500},{"type":"text","copy":"you can easily tell what it is you\'re</br>holding/access this information, right?","screenTime":5500},{"type":"random","copy":"Try reading the information now","screenTime":3000},{"type":"input2","copy":"Accessing information within a letter or changing settings</br>on an appliance becomes more difficult, doesn’t it?","screenTime":7000},{"type":"text","copy":"Did you know? Around half of blind and partially sighted</br>people said that they needed some help around the home.","screenTime":6000},{"type":"text","copy":"People with less sight and people with additional disabilities</br>were more likely to require support around the home.","screenTime":7000},{"type":"text","copy":"The most common areas of support were around</br>cleaning and preparing meals. (Source: My Voice 2015)","screenTime":7000},{"type":"text","copy":"Less than 20% of people living with sight loss</br>can manage everyday household tasks independently","screenTime":7500},{"type":"text","copy":"Two thirds of people said managing household tasks positively</br>impacted their mental health (source VI lives report 2022)","screenTime":16000},{"type":"end","copy":"Would you like to know more about this eye condition?","screenTime":3000}]},{"name":"Navigate spaces","tagName":"spaces","script":[{"type":"text","copy":"Scenario 4: Navigate spaces","screenTime":4500},{"type":"text","copy":"This task requires that you are in a safe indoor location,</br>such as your home or an office environment.","screenTime":6500},{"type":"text","copy":"Being able to safely and independently go from A to B","screenTime":5000},{"type":"text","copy":"But if you are blind or partially sighted understanding of your surroundings</br>and how to get to where you want to go can be harder than you think.","screenTime":9000},{"type":"text","copy":"Are you in a safe environment, think about a new location you</br>would like to move to, such as a toilet or entrance/exit","screenTime":7500},{"type":"input","copy":"Let us know when you are ready to continue","screenTime":2500},{"type":"text","copy":"Looking around you can see it’s safe to proceed, right?","screenTime":4000},{"type":"random","copy":"Safely move towards your new location","screenTime":4000},{"type":"input2","copy":"Moving through the environment can be</br>unsettling and sometimes a scary experience.","screenTime":4500},{"type":"text","copy":"Did you know? Many blind and partially sighted people are not able to make the</br>journeys they want to, limiting the ability to work and participate in society.","screenTime":10500},{"type":"text","copy":"2 in 5 that\'s 40% need support during every trip, and 4 in 5 that\'s</br>80% need support on a journey that’s unfamiliar to them","screenTime":10000},{"type":"text","copy":"Over half of people with sight loss find it</br>difficult to navigate public transport facilities","screenTime":6000},{"type":"text","copy":"98% of the top 1 million websites’</br>homepages have accessibility errors","screenTime":6500},{"type":"text","copy":"28% of people with site loss said they use</br>technology for navigation and getting around outside","screenTime":7000},{"type":"text","copy":"61% said they did not do this either because they</br>did not know how to or didn’t have the technology","screenTime":7000},{"type":"text","copy":"7% said technology didn’t make a difference</br>to navigating (source VI lives report 2022)","screenTime":12000},{"type":"end","copy":"Would you like to know more</br>about this eye condition?","screenTime":3000}]}]}}');


var $a3048f9fc66af22b$exports = {};
$a3048f9fc66af22b$exports = JSON.parse('{"eye-conditions":[{"tagName":"20/20 Vision","name":"none","id":0,"desc":"","scaleType":"sliding","hidden":false},{"tagName":"Age Related Macular degeneration - wet","name":"armd-wet","id":1,"desc":"Age-related macular degeneration (AMD) affects a tiny part of the retina at the back of your eye, called the macula.  Although this condition doesn’t cause total loss of vision, it  can cause issues with central, detailed vision. AMD is the leading cause of sight loss for over 65s.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/age-related-macular-degeneration-amd/"},{"tagName":"Age Related Macular degeneration - dry","name":"armd-dry","id":2,"desc":"Age-related macular degeneration (AMD) affects a tiny part of the retina at the back of your eye, called the macula.  Although this condition doesn’t cause total loss of vision, it  can cause issues with central, detailed vision.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/age-related-macular-degeneration-amd/"},{"tagName":"Retinitis pigmentosa","name":"retinitis-pigmentosa","id":3,"desc":"Retinitis Pigmentosa (RP) denotes a group of progressive eye diseases that affect the retina.Over time, people with RP will gradually lose their peripheral vision causing a tunnel vision effect.  As time progresses RP will also affect central vision.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/retinitis-pigmentosa/"},{"tagName":"Glaucoma","name":"glaucoma","id":4,"desc":"Glaucoma is a common eye condition where the optic nerve, which connects the eye to the brain, becomes damaged usually due to high pressure within the eye. Initially affecting peripheral vision, it eventually progresses to central vision and can result in total loss of vision.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/glaucoma/"},{"tagName":"Diabetic retinopathy","name":"diabetic-retinopathy","id":5,"desc":"Diabetic retinopathy is an eye condition that can cause vision loss and blindness in people who have diabetes. It affects blood vessels in the retina and can affect peripheral vision as it progresses.  It is the second most common cause of sight loss for working age people.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/retinitis-pigmentosa/"},{"tagName":"Hemianopia","name":"hemianopia","id":6,"desc":"Hemianopia is most commonly caused by stroke.The most common form of this is a loss of half of one\'s visual field in both eyes, although strokes can cause differing loss of vision as well as difficulty in visual processing.","scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/stroke-related-eye-conditions/"},{"tagName":"Cataracts","name":"cataracts","desc":"Cataracts occur when the lens inside your eye becomes cloudy. Naturally it is crystal clear but as you get older it becomes less clear and often becomes slightly brown in colour. This results in blurring, haze/ scattered light and dazzle in bright light.  It is very common as we get older but can be treated with surgery for the majority of cases.","id":7,"scaleType":"sliding","hidden":false,"url":"https://www.rnib.org.uk/your-eyes/eye-conditions-az/cataracts/"},{"tagName":"Colour Blindness","name":"color-blindness","id":8,"desc":"Colour vision deficiency - can be inhertied (most common) or acquired (caused by another condition/medication). Inherited CVD - most common is red/green deficiency, does not get better/worse with age. Most forms do not affect eye\'s ability to see detail. Usually colour blindness is inherited and not progressive. Some people acquire colour vision loss due to medication or eye conditions. People with macular conditions often have acquired loss of colour vision. ","scaleType":"options","hidden":false,"options":[{"name":"Deuteranopia","tagName":"deuteranopia","desc":"Deuteranopia is colour blindness resulting from insensitivity to green light, causing confusion of greens, reds, and yellows."},{"name":"Protanopia","tagName":"protanopia","desc":"Protanopia is colour blindness resulting from insensitivity to red light, causing confusion of greens, reds, and yellows. It is hereditary, and is the most common form of colour blindness"},{"name":"Tritanopia","tagName":"tritanopia","desc":"Tritanopia is a rare form of colour blindness resulting from insensitivity to blue light, causing confusion of greens and blues."},{"name":"Monochromacy (Achromatopsia)","tagName":"achromatopsia","desc":"Monochromacy is a lack of all colour detecting cells in the eye."}]}]}');




const $5f85fdb964ce4b6d$var$main = (0, $3c5424715410c340$export$9302a2cd748aaf61)("#main");
const $5f85fdb964ce4b6d$var$toolTip = $5f85fdb964ce4b6d$var$main?.querySelector("#tooltip-main-button");
const $5f85fdb964ce4b6d$var$rnibInformationInner = $5f85fdb964ce4b6d$var$main?.querySelector(".rnib-expanded-info span");
const $5f85fdb964ce4b6d$var$taskModeYesButton = $5f85fdb964ce4b6d$var$main?.querySelector("#task-mode__yes-button");
const $5f85fdb964ce4b6d$var$taskModeNoButton = $5f85fdb964ce4b6d$var$main?.querySelector("#task-mode__no-button");
const $5f85fdb964ce4b6d$var$taskModeContinueButton = $5f85fdb964ce4b6d$var$main?.querySelector("#task-mode__continue-button");
const $5f85fdb964ce4b6d$var$taskModeSubtitles = $5f85fdb964ce4b6d$var$main?.querySelector(".task-mode__subtitles");
const $5f85fdb964ce4b6d$var$soundButton = $5f85fdb964ce4b6d$var$main?.querySelector("#task-mode__sound-button");
class $5f85fdb964ce4b6d$export$2e2bcd8739ae039 {
    voiceovers = [
        [],
        [],
        [],
        []
    ];
    taskData;
    eyeConditionsData;
    // private taskModeSubtitles: HTMLDivElement;
    // public textLabel: CSS2DObject;
    currentTask;
    currentTaskNum;
    scriptIndex = 0;
    readScriptTimeout = undefined;
    gamepadObject;
    isInputPressed;
    taskActive;
    voiceoverNum;
    constructor(gamepadObject){
        this.currentTaskNum = 0;
        this.voiceoverNum = 0;
        for(let i = 0; i < 4; i++)for(let n = 0; n < 4; n++){
            let voiceover = document.querySelector("#voiceover" + i + "_" + n);
            voiceover.load();
            this.voiceovers[i].push(voiceover);
        }
        // this.textLabel = new CSS2DObject(taskModeSubtitles);
        // this.scene.add(this.textLabel);
        // this.textLabel.layers.set(0);
        this.gamepadObject = gamepadObject;
        this.isInputPressed = false;
        this.taskData = (0, (/*@__PURE__*/$parcel$interopDefault($6941faeb257230e7$exports)))["task-mode"];
        this.eyeConditionsData = (0, (/*@__PURE__*/$parcel$interopDefault($a3048f9fc66af22b$exports)))["eye-conditions"];
        this.taskActive = false;
        //if (!taskModeSubtitles) return;
        // textLabel.position.set(-1.6, -0.7, -3);
        document.addEventListener("rnib:task-mode", (e)=>{
            const task = e.detail.task;
            const state = e.detail.state;
            if (state) {
                if (task) {
                    if (!this.taskActive) this.startTask(task);
                }
            } else this.closeTask();
        });
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState == "visible") {
                console.log("tab is active");
                this.resumeTask();
            } else {
                console.log("tab is inactive");
                this.pauseTask();
            }
        });
        this.gamepadObject && this.gamepadObject.addEventListener("button0", this.triggerGamepadInput);
        $5f85fdb964ce4b6d$var$taskModeNoButton?.addEventListener("click", ()=>{
            this.closeTask();
        });
        $5f85fdb964ce4b6d$var$taskModeContinueButton?.addEventListener("click", ()=>{
            console.log("continue pressed");
            this.isInputPressed = true;
        });
        function setSoundButtonHTML(state) {
            $5f85fdb964ce4b6d$var$soundButton.innerHTML = `
          Sound ${state.toUpperCase()}
          <div class="button-icon" data-icon="sound-${state.toLowerCase()}">
        `;
        }
        $5f85fdb964ce4b6d$var$soundButton?.addEventListener("click", ()=>{
            if ($5f85fdb964ce4b6d$var$soundButton.classList.contains("soundOff")) {
                setSoundButtonHTML("on");
                $5f85fdb964ce4b6d$var$soundButton.classList.remove("soundOff");
                this.voiceovers.forEach((voiceover)=>{
                    voiceover.forEach((vo)=>{
                        vo.muted = false;
                    });
                });
            } else {
                setSoundButtonHTML("off");
                $5f85fdb964ce4b6d$var$soundButton.classList.add("soundOff");
                this.voiceovers.forEach((voiceover)=>{
                    voiceover.forEach((vo)=>{
                        vo.muted = true;
                    });
                });
            }
        });
    }
    // private updateText(copy: string) {
    //   if (taskModeSubtitles) {
    //     console.log('updateText' + copy)
    //     taskModeSubtitles.innerHTML = copy;
    //   }
    // }
    triggerGamepadInput = ()=>{
        this.isInputPressed = true;
    };
    checkTaskInput() {
        if (this.isInputPressed && this.currentTask) {
            console.log("input pressed");
            this.readScript(this.currentTask);
            this.isInputPressed = false;
        }
    }
    readScript(task, _customText) {
        this.voiceovers[this.currentTaskNum][this.voiceoverNum]?.play();
        // if (!customText) {
        //   this.updateText(task.script[this.scriptIndex].copy);
        // } else {
        //   this.updateText(customText);
        // }
        if ($5f85fdb964ce4b6d$var$taskModeSubtitles != null) $5f85fdb964ce4b6d$var$taskModeSubtitles.innerHTML = task.script[this.scriptIndex].copy;
        (0, $85a5f587c2a7b3b2$export$cfd85ebbb456058b)();
        if (task.script[this.scriptIndex].type) {
            let givenEyeCondition;
            switch(task.script[this.scriptIndex].type){
                case "text":
                    this.readScriptTimeout = setTimeout(()=>{
                        if (this.currentTask) this.readScript(this.currentTask);
                    }, task.script[this.scriptIndex].screenTime);
                    break;
                case "input":
                    this.readScriptTimeout = setTimeout(()=>{
                        // if (this.currentTask) {
                        //   this.voiceovers[this.currentTaskNum]?.pause();
                        // }
                        this.voiceoverNum++;
                        (0, $85a5f587c2a7b3b2$export$c0498f458a5d334d)();
                    //toolTip?.dispatchEvent(clickEvent);
                    }, task.script[this.scriptIndex].screenTime);
                    break;
                case "input2":
                    this.readScriptTimeout = setTimeout(()=>{
                        // if (this.currentTask) {
                        //   this.voiceovers[this.currentTaskNum][this.voiceoverNum]?.pause();
                        // }
                        this.voiceoverNum++;
                        (0, $85a5f587c2a7b3b2$export$b1c1607a32cb819b)();
                        console.log("SHOW tooltip - input2 - (eye condition)");
                        $5f85fdb964ce4b6d$var$toolTip?.classList.remove("hidden");
                    //toolTip?.dispatchEvent(clickEvent);
                    }, task.script[this.scriptIndex].screenTime);
                    break;
                case "random":
                    if ($5f85fdb964ce4b6d$var$toolTip) {
                        $5f85fdb964ce4b6d$var$toolTip.classList.remove("expanded-info");
                        console.log("random tooltip unhidden");
                        $5f85fdb964ce4b6d$var$toolTip?.classList.remove("hidden");
                    }
                    // random, excluding the color blindess and 20/20 vision
                    const random = Math.floor(Math.random() * (this.eyeConditionsData.length - 2)) + 1;
                    (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(this.eyeConditionsData[random].name, 4);
                    givenEyeCondition = (0, (/*@__PURE__*/$parcel$interopDefault($a3048f9fc66af22b$exports)))["eye-conditions"].find((eyecondition)=>eyecondition.name === this.eyeConditionsData[random].name);
                    if (givenEyeCondition && givenEyeCondition.url) $5f85fdb964ce4b6d$var$taskModeYesButton?.setAttribute("data-href", givenEyeCondition.url);
                    if ($5f85fdb964ce4b6d$var$toolTip && $5f85fdb964ce4b6d$var$rnibInformationInner && givenEyeCondition) {
                        $5f85fdb964ce4b6d$var$toolTip.innerHTML = givenEyeCondition?.tagName;
                        $5f85fdb964ce4b6d$var$rnibInformationInner.innerHTML = givenEyeCondition?.desc;
                    }
                    this.readScriptTimeout = setTimeout(()=>{
                        if (this.currentTask) {
                            this.voiceoverNum++;
                            this.readScript(this.currentTask);
                        }
                    }, task.script[this.scriptIndex].screenTime + 10000);
                    break;
                case "end":
                    this.readScriptTimeout = setTimeout(()=>{
                        (0, $85a5f587c2a7b3b2$export$68d5264cfe134b94)();
                    }, task.script[this.scriptIndex].screenTime);
                    break;
            }
        } else if (this.scriptIndex === task.script[this.scriptIndex].type.length) (0, $85a5f587c2a7b3b2$export$68d5264cfe134b94)();
        this.scriptIndex++;
    }
    closeTask() {
        console.log("close task");
        this.voiceovers.forEach((voiceover)=>{
            voiceover.forEach((vo)=>{
                vo.pause();
                vo.currentTime = 0;
            });
        });
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        this.scriptIndex = 0;
        this.currentTask = null;
        this.voiceoverNum = 0;
        $5f85fdb964ce4b6d$var$taskModeSubtitles?.classList.remove("active");
        clearTimeout(this.readScriptTimeout);
        this.taskActive = false;
    }
    pauseTask() {
        console.log("pause task");
        this.voiceovers.forEach((voiceover)=>{
            voiceover.forEach((vo)=>{
                vo.pause();
                vo.currentTime = 0;
            });
        });
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        this.scriptIndex = 0;
        clearTimeout(this.readScriptTimeout);
        this.taskActive = false;
        this.voiceoverNum = 0;
    }
    resumeTask() {
        // console.log('resume task')
        if (this.currentTask != null) {
            //   console.log('resume task')
            //   this.readScript(this.currentTask)
            this.startTask(this.currentTask.name);
            (0, $85a5f587c2a7b3b2$export$9e72f2b7858f2dd7)();
        }
    }
    startTask(taskName) {
        this.voiceoverNum = 0;
        this.taskActive = true;
        $5f85fdb964ce4b6d$var$taskModeSubtitles?.classList.add("active");
        const tasks = this.taskData.scenes;
        $5f85fdb964ce4b6d$var$toolTip?.classList.add("unclickable");
        $5f85fdb964ce4b6d$var$toolTip?.classList.add("taskMode");
        //const foundTask = tasks.find(task => task.tagName === taskName);
        tasks.forEach((task, i)=>{
            if (task.tagName == taskName) {
                this.currentTask = task;
                this.currentTaskNum = i;
            }
        });
        if (this.currentTask != null) {
            this.scriptIndex = 0;
            this.readScript(this.currentTask);
        }
    }
}






class $6a9ecdef11b6cf6d$export$2e2bcd8739ae039 extends $e97a97f0b0cf48c9$export$38af1803e3442a7f {
    perspectiveCamera;
    clock;
    gamepadObject;
    controllerDetected;
    taskMode;
    tutorial;
    homepage;
    main;
    severityScale;
    externalSite;
    reCentreAR;
    pivot;
    meshUIArr = [];
    pointer;
    orientation;
    currentIntersected = null;
    constructor(perspectiveCamera, orientation, gamepadObject){
        super();
        this.gamepadObject = gamepadObject;
        this.perspectiveCamera = perspectiveCamera;
        this.clock = new $e97a97f0b0cf48c9$export$9735c82c4bae3302();
        this.orientation = orientation;
        this.pivot = new $e97a97f0b0cf48c9$export$eb2fcfdbd7ba97d4();
        this.add(this.perspectiveCamera);
        this.gamepadObject?.addEventListener("direction", (ev)=>{
            const mappings = {
                up: 0,
                right: 1,
                down: 2,
                left: 3
            };
            this.triggerTabActionInCurrentScreen(mappings[ev.detail]);
        });
        this.gamepadObject?.addEventListener("select", this.triggerTabActionUserSelect);
    }
    addPointer = ()=>{
        this.pointer = new (0, $4a6c6ddd13690e16$export$2e2bcd8739ae039)(this.clock);
        this.perspectiveCamera.add(this.pointer);
    };
    triggerTabActionInCurrentScreen = (direction)=>{
        const currScreen = this.meshUIArr.find((child)=>child.visible && !(child instanceof (0, $17d66d87d7d900a0$export$629b893fadd3023c)));
        currScreen?.triggerSelectElementFromDirection(direction);
    };
    triggerTabActionUserSelect = ()=>{
        const currScreen = this.meshUIArr.find((child)=>child.visible && !(child instanceof (0, $17d66d87d7d900a0$export$629b893fadd3023c)));
        currScreen?.triggerClickSelect();
    };
    navigateToMesh = (meshName)=>{
        (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            meshName
        ]);
    };
    checkIfIntersectingActiveUI = (intersections)=>{
        if (intersections.length > 0) {
            this.currentIntersected = intersections.find((i)=>i.object.visible) ?? null;
            this.currentIntersected?.object?.checkUICoordinates(this.currentIntersected.uv);
        } else if (this.currentIntersected) this.currentIntersected = null;
    };
    showInitialMesh(controllerDetected) {
        this.controllerDetected = controllerDetected;
        this.clock.start();
        // Only show controller for Gaze Control, else skip to main UI
        if (this.controllerDetected) {
            this.navigateToMesh("homepage");
            (0, $3c5424715410c340$export$9302a2cd748aaf61)(".select-eye-condition").focus();
        } else {
            if (this.orientation === "landscape") this.addPointer();
            this.navigateToMesh("tutorial");
        // findDomElement<"span">(".tutorial__look-down span").focus();
        }
    }
    showInitialElement() {
        // Homepage HTML Element
        (0, $3c5424715410c340$export$9302a2cd748aaf61)("#homepage").classList.add("active");
    }
    async init(headsetMode, isControllerEnabled) {
        if (!headsetMode) return;
        // Tutorial = CanvasTexture
        this.tutorial = new (0, $2c672c48f22f9ffc$export$2e2bcd8739ae039)("tutorial", 5, 20, new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, -6), isControllerEnabled);
        this.tutorial.init();
        // this.tutorial.planeCurve(1);
        this.meshUIArr.push(this.tutorial);
        this.pivot.add(this.tutorial);
        // Re-Centre AR - CanvasTexture
        this.reCentreAR = new (0, $17d66d87d7d900a0$export$629b893fadd3023c)(isControllerEnabled);
        this.add(this.reCentreAR.pivot);
        this.meshUIArr.push(this.reCentreAR);
        // Main UI - CanvasTexture
        this.homepage = new (0, $2c672c48f22f9ffc$export$2e2bcd8739ae039)("homepage", 20, 20, new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, -6), isControllerEnabled);
        this.homepage.init();
        // this.homepage.planeCurve(2);
        this.meshUIArr.push(this.homepage);
        // Main UI - CanvasTexture
        this.main = new (0, $2c672c48f22f9ffc$export$2e2bcd8739ae039)("main", 20, 20, new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, -0.5, -6), isControllerEnabled);
        this.main.init();
        // this.main.planeCurve(2);
        this.meshUIArr.push(this.main);
        //Severity Scale - CanvasTexture
        this.severityScale = new (0, $2c672c48f22f9ffc$export$2e2bcd8739ae039)("severity-scale-container", 20, 20, new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, -3.856, -4.596), isControllerEnabled);
        this.severityScale.init();
        // this.severityScale.planeCurve(0.2);
        this.severityScale.rotateX((0, $183a9bb3ac38c2a3$export$e6bfdeff8bfc94f9)(-40));
        this.meshUIArr.push(this.severityScale);
        // External Site - CanvasTexture
        this.externalSite = new (0, $2c672c48f22f9ffc$export$2e2bcd8739ae039)("external-site", 20, 20, new $e97a97f0b0cf48c9$export$64b5c384219d3699(0, 0, -6), isControllerEnabled);
        this.externalSite.init();
        // this.externalSite.planeCurve(1);
        this.meshUIArr.push(this.externalSite);
        // 360 Video
        this.panoramicVideo = new (0, $1277f5d9c8b9f6ae$export$412a273e62ec80f9)("https://rnib-hls-video.s3.eu-west-1.amazonaws.com/manifest.m3u8", this.perspectiveCamera);
        // Task Mode
        this.taskMode = new (0, $5f85fdb964ce4b6d$export$2e2bcd8739ae039)(this.gamepadObject);
        // scene is a THREE.Scene (see three.js)
        //this.add( this.tutorial.mesh);
        this.pivot.add(this.homepage);
        this.pivot.add(this.main);
        this.pivot.add(this.severityScale);
        this.pivot.add(this.externalSite);
        // this.pivot.add(this.taskMode.textLabel);
        this.add(this.pivot);
    }
    rotatePivotToCamera = ()=>{
        this.pivot.setRotationFromAxisAngle((0, $0656ff799c64aac2$export$952b2e72a89c71b5), this.perspectiveCamera.rotation.y);
    };
    update() {
        if (this.main && this.panoramicVideo.playing) {
            this.panoramicVideo.update();
            // move the main UI down a bit to avoid obscuring the talent
            this.main.position.y = -2;
        } else if (this.main) this.main.position.y = 0;
        this.taskMode?.checkTaskInput();
        if (this.pointer) this.checkIfIntersectingActiveUI(this.pointer?.update(this.meshUIArr));
        this.reCentreAR?.update(this.perspectiveCamera);
        this.meshUIArr.forEach((MeshUIObj)=>MeshUIObj.name !== "gui" && MeshUIObj.update());
    }
}


var $e5f0f1097dd57307$exports = {};


$e5f0f1097dd57307$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("hq0mX");


var $04168e4d5ffd2a64$exports = {};


$04168e4d5ffd2a64$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("femmd");


var $1d8a1c3487daf5fd$exports = {};


$1d8a1c3487daf5fd$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("bbV0l");


var $c94cc553a579baf0$exports = {};


$c94cc553a579baf0$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("5Swzl");


var $cd1755e3d04b4a28$exports = {};


$cd1755e3d04b4a28$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("kD5ss");


var $ad29447270e37f38$exports = {};


$ad29447270e37f38$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("99VnP");


var $5500a09f9e77020c$exports = {};


$5500a09f9e77020c$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("f3Yyz");


var $95af900963ed40b3$exports = {};


$95af900963ed40b3$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("anoQy");


var $db1dfd30520d067e$exports = {};


$db1dfd30520d067e$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("3aUHn");


var $f09b878702cc2e8a$exports = {};


$f09b878702cc2e8a$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("wadZo");


var $5fdb46be2454b38f$exports = {};


$5fdb46be2454b38f$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("9vMEj");


var $0a5ba3c58b80dcf5$exports = {};


$0a5ba3c58b80dcf5$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("7nwIx");


var $9152256d9e0778de$exports = {};


$9152256d9e0778de$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("6ob2k");


var $89bdafeeac0d157a$exports = {};


$89bdafeeac0d157a$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("3nQMt");


var $bf76880046a7d1b0$exports = {};


$bf76880046a7d1b0$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("goKD6");


var $9622c0bcd520036f$exports = {};


$9622c0bcd520036f$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("kzspj");


var $6c40f5f02b8337d6$exports = {};


$6c40f5f02b8337d6$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("c706f");


var $a94b2dd862e0be04$exports = {};


$a94b2dd862e0be04$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("jMzmp");


var $2ea84fdbd3aded2c$export$2e2bcd8739ae039 = {
    textures: {
        bluenoise: (/*@__PURE__*/$parcel$interopDefault($1d8a1c3487daf5fd$exports)),
        camouflage1: (/*@__PURE__*/$parcel$interopDefault($c94cc553a579baf0$exports)),
        camouflage2: (/*@__PURE__*/$parcel$interopDefault($cd1755e3d04b4a28$exports)),
        camouflage3: (/*@__PURE__*/$parcel$interopDefault($ad29447270e37f38$exports)),
        camouflage4: (/*@__PURE__*/$parcel$interopDefault($5500a09f9e77020c$exports)),
        camouflage5: (/*@__PURE__*/$parcel$interopDefault($95af900963ed40b3$exports)),
        tunnel1: (/*@__PURE__*/$parcel$interopDefault($db1dfd30520d067e$exports)),
        tunnel2: (/*@__PURE__*/$parcel$interopDefault($f09b878702cc2e8a$exports)),
        tunnel3: (/*@__PURE__*/$parcel$interopDefault($5fdb46be2454b38f$exports)),
        tunnel4: (/*@__PURE__*/$parcel$interopDefault($0a5ba3c58b80dcf5$exports)),
        tunnel5: (/*@__PURE__*/$parcel$interopDefault($9152256d9e0778de$exports)),
        glaucoma1: (/*@__PURE__*/$parcel$interopDefault($89bdafeeac0d157a$exports)),
        glaucoma2: (/*@__PURE__*/$parcel$interopDefault($bf76880046a7d1b0$exports)),
        glaucoma3: (/*@__PURE__*/$parcel$interopDefault($9622c0bcd520036f$exports)),
        glaucoma4: (/*@__PURE__*/$parcel$interopDefault($6c40f5f02b8337d6$exports)),
        glaucoma5: (/*@__PURE__*/$parcel$interopDefault($a94b2dd862e0be04$exports)),
        macula: (/*@__PURE__*/$parcel$interopDefault($e5f0f1097dd57307$exports)),
        cataracts: (/*@__PURE__*/$parcel$interopDefault($04168e4d5ffd2a64$exports))
    }
};



var $711555eabecedb8b$var$__defProp = Object.defineProperty;
var $711555eabecedb8b$var$__defNormalProp = (obj, key, value)=>key in obj ? $711555eabecedb8b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $711555eabecedb8b$var$__publicField = (obj, key, value)=>{
    $711555eabecedb8b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $711555eabecedb8b$var$pro = [
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0.856167,
    0.182038,
    -0.038205,
    0.029342,
    0.955115,
    0.015544,
    -0.00288,
    -0.001563,
    1.004443,
    0.734766,
    0.334872,
    -0.069637,
    0.05184,
    0.919198,
    0.028963,
    -0.004928,
    -0.004209,
    1.009137,
    0.630323,
    0.465641,
    -0.095964,
    0.069181,
    0.890046,
    0.040773,
    -0.006308,
    -0.007724,
    1.014032,
    0.539009,
    0.579343,
    -0.118352,
    0.082546,
    0.866121,
    0.051332,
    -0.007136,
    -0.011959,
    1.019095,
    0.458064,
    0.679578,
    -0.137642,
    0.092785,
    0.846313,
    0.060902,
    -0.007494,
    -0.016807,
    1.024301,
    0.38545,
    0.769005,
    -0.154455,
    0.100526,
    0.829802,
    0.069673,
    -0.007442,
    -0.02219,
    1.029632,
    0.319627,
    0.849633,
    -0.169261,
    0.106241,
    0.815969,
    0.07779,
    -0.007025,
    -0.028051,
    1.035076,
    0.259411,
    0.923008,
    -0.18242,
    0.110296,
    0.80434,
    0.085364,
    -0.006276,
    -0.034346,
    1.040622,
    0.203876,
    0.990338,
    -0.194214,
    0.112975,
    0.794542,
    0.092483,
    -0.005222,
    -0.041043,
    1.046265,
    0.152286,
    1.052583,
    -0.204868,
    0.114503,
    0.786281,
    0.099216,
    -0.003882,
    -0.048116,
    1.051998
];
const $711555eabecedb8b$var$deu = [
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0.866435,
    0.177704,
    -0.044139,
    0.049567,
    0.939063,
    0.01137,
    -0.003453,
    7233e-6,
    0.99622,
    0.760729,
    0.319078,
    -0.079807,
    0.090568,
    0.889315,
    0.020117,
    -0.006027,
    0.013325,
    0.992702,
    0.675425,
    0.43385,
    -0.109275,
    0.125303,
    0.847755,
    0.026942,
    -0.00795,
    0.018572,
    0.989378,
    0.605511,
    0.52856,
    -0.134071,
    0.155318,
    0.812366,
    0.032316,
    -0.009376,
    0.023176,
    0.9862,
    0.547494,
    0.607765,
    -0.155259,
    0.181692,
    0.781742,
    0.036566,
    -0.01041,
    0.027275,
    0.983136,
    0.498864,
    0.674741,
    -0.173604,
    0.205199,
    0.754872,
    0.039929,
    -0.011131,
    0.030969,
    0.980162,
    0.457771,
    0.731899,
    -0.18967,
    0.226409,
    0.731012,
    0.042579,
    -0.011595,
    0.034333,
    0.977261,
    0.422823,
    0.781057,
    -0.203881,
    0.245752,
    0.709602,
    0.044646,
    -0.011843,
    0.037423,
    0.974421,
    0.392952,
    0.82361,
    -0.216562,
    0.263559,
    0.69021,
    0.046232,
    -0.01191,
    0.040281,
    0.97163,
    0.367322,
    0.860646,
    -0.227968,
    0.280085,
    0.672501,
    0.047413,
    -0.01182,
    0.04294,
    0.968881
];
const $711555eabecedb8b$var$tri = [
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0.92667,
    0.092514,
    -0.019184,
    0.021191,
    0.964503,
    0.014306,
    8437e-6,
    0.054813,
    0.93675,
    0.89572,
    0.13333,
    -0.02905,
    0.029997,
    0.9454,
    0.024603,
    0.013027,
    0.104707,
    0.882266,
    0.905871,
    0.127791,
    -0.033662,
    0.026856,
    0.941251,
    0.031893,
    0.01341,
    0.148296,
    0.838294,
    0.948035,
    0.08949,
    -0.037526,
    0.014364,
    0.946792,
    0.038844,
    0.010853,
    0.193991,
    0.795156,
    1.017277,
    0.027029,
    -0.044306,
    -0.006113,
    0.958479,
    0.047634,
    6379e-6,
    0.248708,
    0.744913,
    1.104996,
    -0.046633,
    -0.058363,
    -0.032137,
    0.971635,
    0.060503,
    1336e-6,
    0.317922,
    0.680742,
    1.193214,
    -0.109812,
    -0.083402,
    -0.058496,
    0.97941,
    0.079086,
    -0.002346,
    0.403492,
    0.598854,
    1.257728,
    -0.139648,
    -0.118081,
    -0.078003,
    0.975409,
    0.102594,
    -0.003316,
    0.501214,
    0.502102,
    1.278864,
    -0.125333,
    -0.153531,
    -0.084748,
    0.957674,
    0.127074,
    -0.000989,
    0.601151,
    0.399838,
    1.255528,
    -0.076749,
    -0.178779,
    -0.078411,
    0.930809,
    0.147602,
    4733e-6,
    0.691367,
    0.3039
];
const $711555eabecedb8b$var$machado = {
    pro: $711555eabecedb8b$var$pro,
    deu: $711555eabecedb8b$var$deu,
    tri: $711555eabecedb8b$var$tri
};
let $711555eabecedb8b$var$hotShaderMaterials = [];
window.__on_glsl_hmr_update = function(source2) {
    console.log("XXX");
    for (let mat of $711555eabecedb8b$var$hotShaderMaterials){
        console.log(mat.name);
        if (mat.name == source2.id) {
            mat.vertexShader = $711555eabecedb8b$var$getStageSource(source2, "vertex");
            mat.fragmentShader = $711555eabecedb8b$var$getStageSource(source2, "fragment");
            mat.needsUpdate = true;
            console.log("HMR:", mat.name);
        }
    }
};
function $711555eabecedb8b$var$getStageSource(source2, stage) {
    let section = source2.sections.find((s)=>s.stage == stage);
    return section ? section.text : null;
}
class $711555eabecedb8b$var$HotShaderMaterial extends $e97a97f0b0cf48c9$export$21c421a2e1df9d22 {
    constructor({ source: source2, ...parameters }){
        super({
            ...parameters,
            name: source2.id,
            vertexShader: $711555eabecedb8b$var$getStageSource(source2, "vertex"),
            fragmentShader: $711555eabecedb8b$var$getStageSource(source2, "fragment")
        });
        $711555eabecedb8b$var$hotShaderMaterials.push(this);
    }
}
const $711555eabecedb8b$var$lerp = (a, b, u)=>a + u * (b - a);
const $711555eabecedb8b$var$smoothstep = (a, b, x)=>{
    const u = (x - a) / (b - a);
    return u < 0 ? 0 : u > 1 ? 1 : u * u * (3 - 2 * u);
};
function $711555eabecedb8b$var$range(...args) {
    let lo, hi, step;
    if (args.length === 1) {
        lo = 0;
        hi = args[0];
        step = 1;
    } else if (args.length === 2) {
        lo = args[0];
        hi = args[1];
        step = 1;
    } else if (args.length === 3) {
        lo = args[0];
        hi = args[1];
        step = args[2];
    }
    const out = [];
    if (lo < hi && step > 0 || lo > hi && step < 0) for(let i = lo; step < 0 ? i > hi : i < hi; i += step)out.push(i);
    return out;
}
let $711555eabecedb8b$var$source$8 = {
    "id": "src/shaders/three/cvd.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 23,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\nvarying vec3 vDir;\nuniform mat3 uMatTexCamera;\nuniform mat4 uMatViewProjInv;\nuniform bool uIsPanoramic;\n\nvoid main() {\n    // vertex position\n    vec4 P = vec4(position.xy, 0.0, 1.0);\n    gl_Position = P;\n\n    if (uIsPanoramic) {\n        // view direction in worldspace\n        P.z = 1.0;\n        vDir = (uMatViewProjInv * P).xyz;\n    } else {\n        // transformed texture coord\n        vCoord = (uMatTexCamera * vec3(uv, 1.0)).xy;\n    }\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "varying vec3 vDir;",
                "uniform mat3 uMatTexCamera;",
                "uniform mat4 uMatViewProjInv;",
                "uniform bool uIsPanoramic;",
                "",
                "void main() {",
                "    // vertex position",
                "    vec4 P = vec4(position.xy, 0.0, 1.0);",
                "    gl_Position = P;",
                "",
                "    if (uIsPanoramic) {",
                "        // view direction in worldspace",
                "        P.z = 1.0;",
                "        vDir = (uMatViewProjInv * P).xyz;",
                "    } else {",
                "        // transformed texture coord",
                "        vCoord = (uMatTexCamera * vec3(uv, 1.0)).xy;",
                "    }",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 26,
            "count": 80,
            "text": "precision highp float;\nvarying vec2 vCoord;\nvarying vec3 vDir;\nuniform sampler2D uTexCamera;\nuniform mat3 uMatCVD;\nuniform bool uIsPanoramic;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\n#define PI 3.1415926535897932384626433832795\n#define PI_HALF 0.5*PI\n\nfloat fastAcos(float x) {\n    float res = -0.156583 * abs(x) + PI_HALF;\n    res *= sqrt(1.0 - abs(x));\n    return x >= 0.0 ? res : PI - res;\n}\n\nvec2 directionToUV(vec3 dir) {\n    return vec2(\n        0.5 * (atan(dir.z, dir.x)/PI + 1.0),\n        1.0 - (fastAcos(dir.y)/PI));\n}\n\nuniform float uMix;\n\nvoid mixOutput(vec3 C) {\n    gl_FragColor = vec4(C, uMix);\n}\n\n\nvoid main() {\n    vec2 uv;\n\n    if (uIsPanoramic) {\n        vec3 dir = normalize(vDir);\n        uv = directionToUV(dir);\n    } else {\n        uv = vCoord;\n        if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {\n            discard;\n        }\n    }\n\n    vec3 C = texture2D(uTexCamera, uv).rgb;\n    C = linearFromSRGB(C);\n    C *= uMatCVD;\n    C = sRGBFromLinear(C);\n\n    mixOutput(C);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "varying vec3 vDir;",
                "uniform sampler2D uTexCamera;",
                "uniform mat3 uMatCVD;",
                "uniform bool uIsPanoramic;",
                "",
                "float linearFromSRGB(float s) {",
                "    if (s < 0.04045) {",
                "        return s / 12.92;",
                "    } else {",
                "        return pow((s + 0.055) / 1.055, 2.4);",
                "    }",
                "}",
                "",
                "float sRGBFromLinear(float l) {",
                "    if (l < 0.0031308) {",
                "        return l * 12.92;",
                "    } else {",
                "        return 1.055 * pow(l, 1.0/2.4) - 0.055;",
                "    }",
                "}",
                "",
                "vec3 linearFromSRGB(vec3 sRGB) {",
                "    return vec3(",
                "        linearFromSRGB(sRGB[0]),",
                "        linearFromSRGB(sRGB[1]),",
                "        linearFromSRGB(sRGB[2]));",
                "}",
                "",
                "vec3 sRGBFromLinear(vec3 linear) {",
                "    return vec3(",
                "        sRGBFromLinear(linear[0]),",
                "        sRGBFromLinear(linear[1]),",
                "        sRGBFromLinear(linear[2]));",
                "}",
                "",
                "#define PI 3.1415926535897932384626433832795",
                "#define PI_HALF 0.5*PI",
                "",
                "float fastAcos(float x) {",
                "    float res = -0.156583 * abs(x) + PI_HALF;",
                "    res *= sqrt(1.0 - abs(x));",
                "    return x >= 0.0 ? res : PI - res;",
                "}",
                "",
                "vec2 directionToUV(vec3 dir) {",
                "    return vec2(",
                "        0.5 * (atan(dir.z, dir.x)/PI + 1.0),",
                "        1.0 - (fastAcos(dir.y)/PI));",
                "}",
                "",
                "uniform float uMix;",
                "",
                "void mixOutput(vec3 C) {",
                "    gl_FragColor = vec4(C, uMix);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv;",
                "",
                "    if (uIsPanoramic) {",
                "        vec3 dir = normalize(vDir);",
                "        uv = directionToUV(dir);",
                "    } else {",
                "        uv = vCoord;",
                "        if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {",
                "            discard;",
                "        }",
                "    }",
                "",
                "    vec3 C = texture2D(uTexCamera, uv).rgb;",
                "    C = linearFromSRGB(C);",
                "    C *= uMatCVD;",
                "    C = sRGBFromLinear(C);",
                "",
                "    mixOutput(C);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$7 = {
    "id": "src/shaders/three/blur.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 21,
            "text": "attribute vec3 position;\nattribute vec2 uv;\n\nvarying vec2 vCoord0;\nvarying vec4 vCoord1, vCoord2;\n\nuniform vec2 uSampleDelta;\n\nvoid main() {\n    const float o1 = 1.38462, o2 = 3.22702;\n    vCoord0 = uv;\n    vCoord1 = vec4(\n        uv - o1 * uSampleDelta,\n        uv + o1 * uSampleDelta);\n    vCoord2 = vec4(\n        uv - o2 * uSampleDelta,\n        uv + o2 * uSampleDelta);\n    //gl_Position = vec4(2.*(position - .5), 0., 1.);\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "",
                "varying vec2 vCoord0;",
                "varying vec4 vCoord1, vCoord2;",
                "",
                "uniform vec2 uSampleDelta;",
                "",
                "void main() {",
                "    const float o1 = 1.38462, o2 = 3.22702;",
                "    vCoord0 = uv;",
                "    vCoord1 = vec4(",
                "        uv - o1 * uSampleDelta,",
                "        uv + o1 * uSampleDelta);",
                "    vCoord2 = vec4(",
                "        uv - o2 * uSampleDelta,",
                "        uv + o2 * uSampleDelta);",
                "    //gl_Position = vec4(2.*(position - .5), 0., 1.);",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 24,
            "count": 33,
            "text": "precision highp float;\nvarying vec2 vCoord0;\nvarying vec4 vCoord1, vCoord2;\nuniform sampler2D uTexSource;\nuniform vec2 uNoiseShift;\n\nfloat random(vec3 c) {\n    float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));\n    return fract(512.0*j + 0.123);\n}\n\nfloat rand(vec2 n) { \n    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);\n}\n\nvoid main() {\n    const float w0 = 0.22702, w1 = 0.31622, w2 = 0.07027;\n    gl_FragColor = (\n        w0 * texture2D(uTexSource, vCoord0) +\n        w1 * (\n            texture2D(uTexSource, vCoord1.xy) +\n            texture2D(uTexSource, vCoord1.zw)) +\n        w2 * (\n            texture2D(uTexSource, vCoord2.xy) +\n            texture2D(uTexSource, vCoord2.zw)));\n\n#ifdef USE_NOISE\n    vec2 uv = gl_FragCoord.xy + uNoiseShift;\n    float n = 0.020 * (rand(uv) - 0.5);\n    gl_FragColor.rgb += vec3(n);\n#endif\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord0;",
                "varying vec4 vCoord1, vCoord2;",
                "uniform sampler2D uTexSource;",
                "uniform vec2 uNoiseShift;",
                "",
                "float random(vec3 c) {",
                "    float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));",
                "    return fract(512.0*j + 0.123);",
                "}",
                "",
                "float rand(vec2 n) { ",
                "    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);",
                "}",
                "",
                "void main() {",
                "    const float w0 = 0.22702, w1 = 0.31622, w2 = 0.07027;",
                "    gl_FragColor = (",
                "        w0 * texture2D(uTexSource, vCoord0) +",
                "        w1 * (",
                "            texture2D(uTexSource, vCoord1.xy) +",
                "            texture2D(uTexSource, vCoord1.zw)) +",
                "        w2 * (",
                "            texture2D(uTexSource, vCoord2.xy) +",
                "            texture2D(uTexSource, vCoord2.zw)));",
                "",
                "#ifdef USE_NOISE",
                "    vec2 uv = gl_FragCoord.xy + uNoiseShift;",
                "    float n = 0.020 * (rand(uv) - 0.5);",
                "    gl_FragColor.rgb += vec3(n);",
                "#endif",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$6 = {
    "id": "src/shaders/three/armd.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 88,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform mat3 uMatCVD;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\nuniform float uMix;\n\nvoid mixOutput(vec3 C) {\n    gl_FragColor = vec4(C, uMix);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    // scale around center by severity (splodge larger as severity -> 1)\n    vec2 Suv = mix(3.0, 1.5, uSeverity) * (uv - 0.5) + 0.5;\n    vec4 S = sampleSplodge(Suv);\n\n    // caclc distortion\n    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);\n    float x = clamp(3.0 * S.r, 0.0, 1.0);\n\n    // sample and blur by severity\n    vec3 C0 = mix(\n        texture2D(uTexSource0, uv + Duv).rgb,\n        texture2D(uTexSource2, uv + Duv).rgb,\n        uSeverity);\n\n    // blur again\n    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;\n    vec3 C = mix(C0, C1, x);\n\n    // blend to grey\n    float grey = mix(0.5, 0.0, uSeverity * uSeverity);\n    C = mix(C, vec3(grey), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));\n\n    // apply CVD\n    C = sRGBFromLinear(uMatCVD * linearFromSRGB(C));\n\n    mixOutput(C);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform mat3 uMatCVD;",
                "",
                "float linearFromSRGB(float s) {",
                "    if (s < 0.04045) {",
                "        return s / 12.92;",
                "    } else {",
                "        return pow((s + 0.055) / 1.055, 2.4);",
                "    }",
                "}",
                "",
                "float sRGBFromLinear(float l) {",
                "    if (l < 0.0031308) {",
                "        return l * 12.92;",
                "    } else {",
                "        return 1.055 * pow(l, 1.0/2.4) - 0.055;",
                "    }",
                "}",
                "",
                "vec3 linearFromSRGB(vec3 sRGB) {",
                "    return vec3(",
                "        linearFromSRGB(sRGB[0]),",
                "        linearFromSRGB(sRGB[1]),",
                "        linearFromSRGB(sRGB[2]));",
                "}",
                "",
                "vec3 sRGBFromLinear(vec3 linear) {",
                "    return vec3(",
                "        sRGBFromLinear(linear[0]),",
                "        sRGBFromLinear(linear[1]),",
                "        sRGBFromLinear(linear[2]));",
                "}",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "uniform float uMix;",
                "",
                "void mixOutput(vec3 C) {",
                "    gl_FragColor = vec4(C, uMix);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "",
                "    // scale around center by severity (splodge larger as severity -> 1)",
                "    vec2 Suv = mix(3.0, 1.5, uSeverity) * (uv - 0.5) + 0.5;",
                "    vec4 S = sampleSplodge(Suv);",
                "",
                "    // caclc distortion",
                "    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);",
                "    float x = clamp(3.0 * S.r, 0.0, 1.0);",
                "",
                "    // sample and blur by severity",
                "    vec3 C0 = mix(",
                "        texture2D(uTexSource0, uv + Duv).rgb,",
                "        texture2D(uTexSource2, uv + Duv).rgb,",
                "        uSeverity);",
                "",
                "    // blur again",
                "    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;",
                "    vec3 C = mix(C0, C1, x);",
                "",
                "    // blend to grey",
                "    float grey = mix(0.5, 0.0, uSeverity * uSeverity);",
                "    C = mix(C, vec3(grey), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));",
                "",
                "    // apply CVD",
                "    C = sRGBFromLinear(uMatCVD * linearFromSRGB(C));",
                "",
                "    mixOutput(C);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$5 = {
    "id": "src/shaders/three/hemianopia.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 46,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\n\nuniform sampler2D uTexNoise;\n\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\n\nuniform float uMix;\n\nvoid mixOutput(vec3 C) {\n    gl_FragColor = vec4(C, uMix);\n}\n\n\nfloat blend(float x, float m, float h) {\n    return smoothstep(m - h, m + h, x);\n}\n\nfloat rand(vec2 n) { \n    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);\n}\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    vec3 C;\n\n    {\n        float h = 0.1;\n        float m = 0.55;\n        float x = blend(vCoord.x, m, h);\n        vec3 gray = vec3(0.0);\n        C = mix(C0, gray, blend(vCoord.x, 0.5, 0.010));\n    }\n\n    mixOutput(C);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "",
                "uniform sampler2D uTexNoise;",
                "",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "",
                "uniform float uMix;",
                "",
                "void mixOutput(vec3 C) {",
                "    gl_FragColor = vec4(C, uMix);",
                "}",
                "",
                "",
                "float blend(float x, float m, float h) {",
                "    return smoothstep(m - h, m + h, x);",
                "}",
                "",
                "float rand(vec2 n) { ",
                "    return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);",
                "}",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "    vec3 C;",
                "",
                "    {",
                "        float h = 0.1;",
                "        float m = 0.55;",
                "        float x = blend(vCoord.x, m, h);",
                "        vec3 gray = vec3(0.0);",
                "        C = mix(C0, gray, blend(vCoord.x, 0.5, 0.010));",
                "    }",
                "",
                "    mixOutput(C);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$4 = {
    "id": "src/shaders/three/cataracts.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 73,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\nuniform float uMix;\n\nvoid mixOutput(vec3 C) {\n    gl_FragColor = vec4(C, uMix);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    vec3 C1 = texture2D(uTexSource5, uv).rgb;\n    vec3 C;\n\n    {\n        float aspect = uResolution[0] / uResolution[1];\n        float scale = 0.8;\n        uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;\n\n        vec2 d = vec2(1.0) / 512.0;\n\n        vec4 S = sampleSplodge(uv);\n\n        float x = S.r;\n\n        float blur = 1.0;\n        float glare = x;\n        float darken = 1.0;\n\n        x = clamp(2.0 * x * x, 0.9*uSeverity, 1.0);\n        //gl_FragColor = vec4(x); return;\n        C = mix(C0, C1, blur * x);\n        C *= mix(1.0, 0.8, darken * x);\n\n        // distort\n        float distort = 0.4 * uSeverity;\n        vec2 G = 0.2 * (S.gb - 0.5);\n        uv = vCoord + distort * G;\n        C = mix(\n            texture2D(uTexSource1, uv).rgb,\n            texture2D(uTexSource5, uv).rgb,\n            blur * x);\n\n        C += glare * mix(0.1, 1.0, x) * texture2D(uTexSource5, uv).rgb;\n\n        float decontrast = 0.9 * uSeverity;\n        C = mix(C, 1.2 * vec3(0.5, 0.45, 0.35), decontrast * x);\n        C = mix(C, vec3(0.55, 0.50, 0.48), 0.05);\n    }\n\n    mixOutput(C);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "uniform float uMix;",
                "",
                "void mixOutput(vec3 C) {",
                "    gl_FragColor = vec4(C, uMix);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "    vec3 C1 = texture2D(uTexSource5, uv).rgb;",
                "    vec3 C;",
                "",
                "    {",
                "        float aspect = uResolution[0] / uResolution[1];",
                "        float scale = 0.8;",
                "        uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;",
                "",
                "        vec2 d = vec2(1.0) / 512.0;",
                "",
                "        vec4 S = sampleSplodge(uv);",
                "",
                "        float x = S.r;",
                "",
                "        float blur = 1.0;",
                "        float glare = x;",
                "        float darken = 1.0;",
                "",
                "        x = clamp(2.0 * x * x, 0.9*uSeverity, 1.0);",
                "        //gl_FragColor = vec4(x); return;",
                "        C = mix(C0, C1, blur * x);",
                "        C *= mix(1.0, 0.8, darken * x);",
                "",
                "        // distort",
                "        float distort = 0.4 * uSeverity;",
                "        vec2 G = 0.2 * (S.gb - 0.5);",
                "        uv = vCoord + distort * G;",
                "        C = mix(",
                "            texture2D(uTexSource1, uv).rgb,",
                "            texture2D(uTexSource5, uv).rgb,",
                "            blur * x);",
                "",
                "        C += glare * mix(0.1, 1.0, x) * texture2D(uTexSource5, uv).rgb;",
                "",
                "        float decontrast = 0.9 * uSeverity;",
                "        C = mix(C, 1.2 * vec3(0.5, 0.45, 0.35), decontrast * x);",
                "        C = mix(C, vec3(0.55, 0.50, 0.48), 0.05);",
                "    }",
                "",
                "    mixOutput(C);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$3 = {
    "id": "src/shaders/three/glaucoma.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 65,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\nuniform float uMix;\n\nvoid mixOutput(vec3 C) {\n    gl_FragColor = vec4(C, uMix);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec4 S;\n\n    {\n        vec2 uv2 = uv;\n        if (uEye == 1)\n            uv2.x = 1.0 - uv2.x;\n        S = sampleSplodge(uv2);\n    }\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n\n    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);\n    vec3 C1 = texture2D(uTexSource5, uv2).rgb;\n    vec3 C;\n\n    C1 = mix(C1, vec3(0.45), mix(0.15, 0.80, uSeverity));\n\n    {\n        //float aspect = uResolution[0] / uResolution[1];\n        //float scale = 0.8;\n        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;\n        //vec2 d = vec2(1.0) / 512.0;\n        //vec4 S = texture2D(uTexSplodge, uv);\n        float scale = 2.2;\n        float x = min(1.0, S.r * scale);\n\n        vec2 d = uv - 0.5;\n        //x = max(x, uSeverity * length(d));\n        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));\n        C = mix(C0, C1, x);\n    }\n\n    mixOutput(C);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "uniform int uEye;",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "uniform float uMix;",
                "",
                "void mixOutput(vec3 C) {",
                "    gl_FragColor = vec4(C, uMix);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "    vec4 S;",
                "",
                "    {",
                "        vec2 uv2 = uv;",
                "        if (uEye == 1)",
                "            uv2.x = 1.0 - uv2.x;",
                "        S = sampleSplodge(uv2);",
                "    }",
                "",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "",
                "    vec2 uv2 = uv + 0.5 * (S.gb - 0.5);",
                "    vec3 C1 = texture2D(uTexSource5, uv2).rgb;",
                "    vec3 C;",
                "",
                "    C1 = mix(C1, vec3(0.45), mix(0.15, 0.80, uSeverity));",
                "",
                "    {",
                "        //float aspect = uResolution[0] / uResolution[1];",
                "        //float scale = 0.8;",
                "        //uv = (uv - 0.5) * scale * vec2(aspect, 1.0) + 0.5;",
                "        //vec2 d = vec2(1.0) / 512.0;",
                "        //vec4 S = texture2D(uTexSplodge, uv);",
                "        float scale = 2.2;",
                "        float x = min(1.0, S.r * scale);",
                "",
                "        vec2 d = uv - 0.5;",
                "        //x = max(x, uSeverity * length(d));",
                "        x = min(1.0, max(x, uSeverity * 3.0 * dot(d, d)));",
                "        C = mix(C0, C1, x);",
                "    }",
                "",
                "    mixOutput(C);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$2 = {
    "id": "src/shaders/three/achromatopsia.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 106,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nuniform float uMix;\n\nvoid mixOutput(vec3 C) {\n    gl_FragColor = vec4(C, uMix);\n}\n\n\nvec3 scotopic(vec3 C) {\n    C = linearFromSRGB(C);\n\n    // convert to XYZ\n    vec3 XYZ = vec3(\n        0.5149 * C[0] + 0.3244 * C[1] + 0.1607 * C[2],\n        0.2654 * C[0] + 0.6704 * C[1] + 0.0642 * C[2],\n        0.0248 * C[0] + 0.1248 * C[1] + 0.8504 * C[2]);\n\n    // scotopic luminance (Larson et al)\n    float Ls = XYZ[1] * (\n        1.33 * (1.0 + (XYZ[1] + XYZ[2]) / XYZ[0]) - 1.68);\n\n    // regular luminance\n    //Ls = dot(C, vec3(0.2126, 0.7152, 0.0722));\n\n    vec3 blue = mix(vec3(1), vec3(.62, .6, 1.0), 0.5);\n    //C = Ls * 0.5 * vec3(1.0 - blue, 1.0 - blue, 1.0);\n    C = blue * vec3(Ls);\n    //C = mix(C0, C, 0.0);\n    C = sRGBFromLinear(C);\n    return C;\n}\n\nvoid main() {\n    vec2 uv = vCoord;\n\n    {\n        // nystagmus\n        float u = fract(3.0 * uTime);\n        float x = u < 0.8 ?\n            smoothstep(0.0, 0.9, u) : \n            smoothstep(1.0, 0.9, u);\n        //uv.x += 0.01 * sin(30.0 * uTime);\n        float travel = 0.03 * smoothstep(0.7, 1.0, uSeverity);\n        vec2 d = travel * normalize(vec2(1.0, 0.1));\n        //uv += d * mix(-1.0, 1.0, x);\n    }\n\n    vec3 Cblur = texture2D(uTexSource4, uv).rgb;\n    vec3 Csharp = texture2D(uTexSource3, uv).rgb;\n\n    Cblur = scotopic(Cblur);\n    Csharp = scotopic(Csharp);\n\n    vec3 diff = Csharp - Cblur;\n\n    //float gamma = mix(1.25, 1.1, smoothstep(0.9, 1.0, uSeverity));\n    float gamma = 1.25;\n    vec3 C = sign(diff) * pow(abs(diff), vec3(1.0/gamma));\n    C = Cblur + C;\n\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    C = mix(C0, C, smoothstep(0.0, 0.5, uSeverity));\n\n    mixOutput(C);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "",
                "float linearFromSRGB(float s) {",
                "    if (s < 0.04045) {",
                "        return s / 12.92;",
                "    } else {",
                "        return pow((s + 0.055) / 1.055, 2.4);",
                "    }",
                "}",
                "",
                "float sRGBFromLinear(float l) {",
                "    if (l < 0.0031308) {",
                "        return l * 12.92;",
                "    } else {",
                "        return 1.055 * pow(l, 1.0/2.4) - 0.055;",
                "    }",
                "}",
                "",
                "vec3 linearFromSRGB(vec3 sRGB) {",
                "    return vec3(",
                "        linearFromSRGB(sRGB[0]),",
                "        linearFromSRGB(sRGB[1]),",
                "        linearFromSRGB(sRGB[2]));",
                "}",
                "",
                "vec3 sRGBFromLinear(vec3 linear) {",
                "    return vec3(",
                "        sRGBFromLinear(linear[0]),",
                "        sRGBFromLinear(linear[1]),",
                "        sRGBFromLinear(linear[2]));",
                "}",
                "",
                "uniform float uMix;",
                "",
                "void mixOutput(vec3 C) {",
                "    gl_FragColor = vec4(C, uMix);",
                "}",
                "",
                "",
                "vec3 scotopic(vec3 C) {",
                "    C = linearFromSRGB(C);",
                "",
                "    // convert to XYZ",
                "    vec3 XYZ = vec3(",
                "        0.5149 * C[0] + 0.3244 * C[1] + 0.1607 * C[2],",
                "        0.2654 * C[0] + 0.6704 * C[1] + 0.0642 * C[2],",
                "        0.0248 * C[0] + 0.1248 * C[1] + 0.8504 * C[2]);",
                "",
                "    // scotopic luminance (Larson et al)",
                "    float Ls = XYZ[1] * (",
                "        1.33 * (1.0 + (XYZ[1] + XYZ[2]) / XYZ[0]) - 1.68);",
                "",
                "    // regular luminance",
                "    //Ls = dot(C, vec3(0.2126, 0.7152, 0.0722));",
                "",
                "    vec3 blue = mix(vec3(1), vec3(.62, .6, 1.0), 0.5);",
                "    //C = Ls * 0.5 * vec3(1.0 - blue, 1.0 - blue, 1.0);",
                "    C = blue * vec3(Ls);",
                "    //C = mix(C0, C, 0.0);",
                "    C = sRGBFromLinear(C);",
                "    return C;",
                "}",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "",
                "    {",
                "        // nystagmus",
                "        float u = fract(3.0 * uTime);",
                "        float x = u < 0.8 ?",
                "            smoothstep(0.0, 0.9, u) : ",
                "            smoothstep(1.0, 0.9, u);",
                "        //uv.x += 0.01 * sin(30.0 * uTime);",
                "        float travel = 0.03 * smoothstep(0.7, 1.0, uSeverity);",
                "        vec2 d = travel * normalize(vec2(1.0, 0.1));",
                "        //uv += d * mix(-1.0, 1.0, x);",
                "    }",
                "",
                "    vec3 Cblur = texture2D(uTexSource4, uv).rgb;",
                "    vec3 Csharp = texture2D(uTexSource3, uv).rgb;",
                "",
                "    Cblur = scotopic(Cblur);",
                "    Csharp = scotopic(Csharp);",
                "",
                "    vec3 diff = Csharp - Cblur;",
                "",
                "    //float gamma = mix(1.25, 1.1, smoothstep(0.9, 1.0, uSeverity));",
                "    float gamma = 1.25;",
                "    vec3 C = sign(diff) * pow(abs(diff), vec3(1.0/gamma));",
                "    C = Cblur + C;",
                "",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "    C = mix(C0, C, smoothstep(0.0, 0.5, uSeverity));",
                "",
                "    mixOutput(C);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source$1 = {
    "id": "src/shaders/three/retinitis_pigmentosa.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 43,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\nuniform float uMix;\n\nvoid mixOutput(vec3 C) {\n    gl_FragColor = vec4(C, uMix);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec4 S = sampleSplodge(uv);\n    vec3 C0 = texture2D(uTexSource0, uv).rgb;\n    vec3 C1 = texture2D(uTexSource5, uv).rgb;\n\n    vec3 C = C0;\n    float x = 1.0 - S.g;\n\n    C = mix(C0, C1, 1.0 - S.r);\n    C = mix(C, vec3(0.0), 1.0 - S.g);\n\n    mixOutput(C);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "uniform int uEye;",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "uniform float uMix;",
                "",
                "void mixOutput(vec3 C) {",
                "    gl_FragColor = vec4(C, uMix);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "    vec4 S = sampleSplodge(uv);",
                "    vec3 C0 = texture2D(uTexSource0, uv).rgb;",
                "    vec3 C1 = texture2D(uTexSource5, uv).rgb;",
                "",
                "    vec3 C = C0;",
                "    float x = 1.0 - S.g;",
                "",
                "    C = mix(C0, C1, 1.0 - S.r);",
                "    C = mix(C, vec3(0.0), 1.0 - S.g);",
                "",
                "    mixOutput(C);",
                "}",
                ""
            ]
        }
    ]
};
let $711555eabecedb8b$var$source = {
    "id": "src/shaders/three/diabetic_retinopathy.glsl",
    "sections": [
        {
            "stage": "vertex",
            "start": 2,
            "count": 9,
            "text": "attribute vec3 position;\nattribute vec2 uv;\nvarying vec2 vCoord;\n\nvoid main() {\n    vCoord = uv;\n    gl_Position = vec4(position, 1.0);\n}\n",
            "lines": [
                "attribute vec3 position;",
                "attribute vec2 uv;",
                "varying vec2 vCoord;",
                "",
                "void main() {",
                "    vCoord = uv;",
                "    gl_Position = vec4(position, 1.0);",
                "}",
                ""
            ]
        },
        {
            "stage": "fragment",
            "start": 12,
            "count": 85,
            "text": "precision highp float;\nvarying vec2 vCoord;\nuniform sampler2D uTexSource0;\nuniform sampler2D uTexSource1;\nuniform sampler2D uTexSource2;\nuniform sampler2D uTexSource3;\nuniform sampler2D uTexSource4;\nuniform sampler2D uTexSource5;\nuniform float uTime;\nuniform float uSeverity;\nuniform vec2 uResolution;\nuniform int uEye;\n\nuniform mat3 uMatCVD;\n\nfloat linearFromSRGB(float s) {\n    if (s < 0.04045) {\n        return s / 12.92;\n    } else {\n        return pow((s + 0.055) / 1.055, 2.4);\n    }\n}\n\nfloat sRGBFromLinear(float l) {\n    if (l < 0.0031308) {\n        return l * 12.92;\n    } else {\n        return 1.055 * pow(l, 1.0/2.4) - 0.055;\n    }\n}\n\nvec3 linearFromSRGB(vec3 sRGB) {\n    return vec3(\n        linearFromSRGB(sRGB[0]),\n        linearFromSRGB(sRGB[1]),\n        linearFromSRGB(sRGB[2]));\n}\n\nvec3 sRGBFromLinear(vec3 linear) {\n    return vec3(\n        sRGBFromLinear(linear[0]),\n        sRGBFromLinear(linear[1]),\n        sRGBFromLinear(linear[2]));\n}\n\nuniform sampler2D uTexSplodge;\nuniform mat3 uMatSplodge;\n\nvec4 sampleSplodge(vec2 uv) {\n    uv = (uMatSplodge * vec3(uv, 1.0)).xy;\n    return texture2D(uTexSplodge, uv);\n}\n\nuniform float uMix;\n\nvoid mixOutput(vec3 C) {\n    gl_FragColor = vec4(C, uMix);\n}\n\n\nvoid main() {\n    vec2 uv = vCoord;\n    vec4 S = sampleSplodge(uv);\n\n    // calc distortion\n    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);\n    float x = clamp(S.r, 0.0, 1.0);\n\n    // sample and blur by severity\n    vec3 C0 = mix(\n        texture2D(uTexSource0, uv + Duv).rgb,\n        texture2D(uTexSource2, uv + Duv).rgb,\n        uSeverity);\n\n    // blur again\n    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;\n    vec3 C = mix(C0, C1, x);\n\n    // blend to grey\n    float g = 1.0 - max(0.95*S.r, max(S.g, S.b));\n    C = mix(C, vec3(g), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));\n\n    mixOutput(C);\n}\n",
            "lines": [
                "precision highp float;",
                "varying vec2 vCoord;",
                "uniform sampler2D uTexSource0;",
                "uniform sampler2D uTexSource1;",
                "uniform sampler2D uTexSource2;",
                "uniform sampler2D uTexSource3;",
                "uniform sampler2D uTexSource4;",
                "uniform sampler2D uTexSource5;",
                "uniform float uTime;",
                "uniform float uSeverity;",
                "uniform vec2 uResolution;",
                "uniform int uEye;",
                "",
                "uniform mat3 uMatCVD;",
                "",
                "float linearFromSRGB(float s) {",
                "    if (s < 0.04045) {",
                "        return s / 12.92;",
                "    } else {",
                "        return pow((s + 0.055) / 1.055, 2.4);",
                "    }",
                "}",
                "",
                "float sRGBFromLinear(float l) {",
                "    if (l < 0.0031308) {",
                "        return l * 12.92;",
                "    } else {",
                "        return 1.055 * pow(l, 1.0/2.4) - 0.055;",
                "    }",
                "}",
                "",
                "vec3 linearFromSRGB(vec3 sRGB) {",
                "    return vec3(",
                "        linearFromSRGB(sRGB[0]),",
                "        linearFromSRGB(sRGB[1]),",
                "        linearFromSRGB(sRGB[2]));",
                "}",
                "",
                "vec3 sRGBFromLinear(vec3 linear) {",
                "    return vec3(",
                "        sRGBFromLinear(linear[0]),",
                "        sRGBFromLinear(linear[1]),",
                "        sRGBFromLinear(linear[2]));",
                "}",
                "",
                "uniform sampler2D uTexSplodge;",
                "uniform mat3 uMatSplodge;",
                "",
                "vec4 sampleSplodge(vec2 uv) {",
                "    uv = (uMatSplodge * vec3(uv, 1.0)).xy;",
                "    return texture2D(uTexSplodge, uv);",
                "}",
                "",
                "uniform float uMix;",
                "",
                "void mixOutput(vec3 C) {",
                "    gl_FragColor = vec4(C, uMix);",
                "}",
                "",
                "",
                "void main() {",
                "    vec2 uv = vCoord;",
                "    vec4 S = sampleSplodge(uv);",
                "",
                "    // calc distortion",
                "    vec2 Duv = uSeverity * 0.2 * (S.gb - 0.5);",
                "    float x = clamp(S.r, 0.0, 1.0);",
                "",
                "    // sample and blur by severity",
                "    vec3 C0 = mix(",
                "        texture2D(uTexSource0, uv + Duv).rgb,",
                "        texture2D(uTexSource2, uv + Duv).rgb,",
                "        uSeverity);",
                "",
                "    // blur again",
                "    vec3 C1 = texture2D(uTexSource5, uv - Duv).rgb;",
                "    vec3 C = mix(C0, C1, x);",
                "",
                "    // blend to grey",
                "    float g = 1.0 - max(0.95*S.r, max(S.g, S.b));",
                "    C = mix(C, vec3(g), mix(0.20*uSeverity, mix(0.1, 0.9, uSeverity), x));",
                "",
                "    mixOutput(C);",
                "}",
                ""
            ]
        }
    ]
};
class $711555eabecedb8b$var$MyTextureLoader extends $e97a97f0b0cf48c9$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        let texture = new $e97a97f0b0cf48c9$export$5431306cf43de24a();
        let loader = new $e97a97f0b0cf48c9$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let callback = (image)=>{
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad) onLoad({
                texture: texture,
                image: image
            });
        };
        loader.load(url, callback, onProgress, onError);
        return texture;
    }
}
function $711555eabecedb8b$var$getCvdMatrix(out, type, amount) {
    if (type == "none") {
        out.identity();
        return;
    }
    let numKeys = 11;
    let u = amount * (numKeys - 1);
    let i0 = Math.floor(u);
    let i1 = Math.min(numKeys - 1, i0 + 1);
    let uu = u - i0;
    let name = type.substr(0, 3);
    let src = $711555eabecedb8b$var$machado[name];
    let sp0 = 9 * i0;
    let sp1 = 9 * i1;
    let matCVD = out.elements;
    for(let i = 0; i < 9; ++i)matCVD[i] = $711555eabecedb8b$var$lerp(src[sp0 + i], src[sp1 + i], uu);
}
function $711555eabecedb8b$var$createFullScreenQuad(material) {
    return new $e97a97f0b0cf48c9$export$e176487c05830cc5(new $e97a97f0b0cf48c9$export$e789a11a194ca4e0(2, 2), material);
}
function $711555eabecedb8b$var$createTarget(w, h) {
    return new $e97a97f0b0cf48c9$export$3c052beb2e51e23f(w, h, {
        depthBuffer: false
    });
}
function $711555eabecedb8b$export$2e2bcd8739ae039({ assets: assets }) {
    let rtBase = $711555eabecedb8b$var$createTarget();
    let rtComps = [
        $711555eabecedb8b$var$createTarget(),
        $711555eabecedb8b$var$createTarget()
    ];
    let textureLoader = new $711555eabecedb8b$var$MyTextureLoader();
    let loadTexture = (name, options)=>{
        let url = assets.textures[name];
        let texture = textureLoader.load(url, ({ texture: texture2, image: image })=>{
            texture2.aspect = image.width / image.height;
        }, void 0, (err)=>{
            console.warn('EyewareEffects: error loading: "%s"', url);
        });
        if (options && options.repeat) texture.wrapS = texture.wrapT = $e97a97f0b0cf48c9$export$533346c8e8dac0f5;
        return texture;
    };
    let textures = {
        macula: loadTexture("macula"),
        cataracts: loadTexture("cataracts"),
        glaucoma: $711555eabecedb8b$var$range(5).map((i)=>loadTexture(`glaucoma${i + 1}`)),
        tunnel: $711555eabecedb8b$var$range(5).map((i)=>loadTexture(`tunnel${i + 1}`)),
        camouflage: $711555eabecedb8b$var$range(5).map((i)=>loadTexture(`camouflage${i + 1}`)),
        noise: loadTexture("bluenoise", {
            repeat: true
        })
    };
    function createConditionMaterial({ source: source2, uniforms: uniforms }) {
        return new $711555eabecedb8b$var$HotShaderMaterial({
            source: source2,
            uniforms: {
                uTexSource0: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uTexSource1: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uTexSource2: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uTexSource3: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uTexSource4: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uTexSource5: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uTexSplodge: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uTime: {
                    value: 0
                },
                uSeverity: {
                    value: 0
                },
                uResolution: {
                    value: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()
                },
                uEye: {
                    value: 0
                },
                uMatCVD: {
                    value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
                },
                uMatSplodge: {
                    value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
                },
                uMix: {
                    value: 0
                },
                ...uniforms
            }
        });
    }
    let materials = {
        cvd: new $711555eabecedb8b$var$HotShaderMaterial({
            source: $711555eabecedb8b$var$source$8,
            uniforms: {
                uTexCamera: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uMatTexCamera: {
                    value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
                },
                uMatViewProjInv: {
                    value: new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5()
                },
                uMatCVD: {
                    value: new $e97a97f0b0cf48c9$export$8ff26dafa08918()
                },
                uIsPanoramic: {
                    value: false
                },
                uMix: {
                    value: 0
                }
            }
        }),
        blur: new $711555eabecedb8b$var$HotShaderMaterial({
            source: $711555eabecedb8b$var$source$7,
            uniforms: {
                uTexSource: {
                    value: new $e97a97f0b0cf48c9$export$5431306cf43de24a()
                },
                uSampleDelta: {
                    value: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()
                },
                uNoiseShift: {
                    value: new $e97a97f0b0cf48c9$export$c977b3e384af9ae1()
                }
            },
            defines: {
            }
        }),
        armd: createConditionMaterial({
            source: $711555eabecedb8b$var$source$6
        }),
        cataracts: createConditionMaterial({
            source: $711555eabecedb8b$var$source$4
        }),
        glaucoma: createConditionMaterial({
            source: $711555eabecedb8b$var$source$3
        }),
        "diabetic-retinopathy": createConditionMaterial({
            source: $711555eabecedb8b$var$source
        }),
        "retinitis-pigmentosa": createConditionMaterial({
            source: $711555eabecedb8b$var$source$1
        }),
        hemianopia: createConditionMaterial({
            source: $711555eabecedb8b$var$source$5
        }),
        achromatopsia: createConditionMaterial({
            source: $711555eabecedb8b$var$source$2
        })
    };
    let quadMesh = $711555eabecedb8b$var$createFullScreenQuad();
    let quadCamera = new $e97a97f0b0cf48c9$export$9ebf355ee4ed261b(-1, 1, 1, -1, 0, 1);
    new $e97a97f0b0cf48c9$export$2ae72fc923e5eb5();
    function renderQuad(renderer, material) {
        quadMesh.material = material;
        renderer.render(quadMesh, quadCamera);
    }
    function Level(index) {
        this.index = index;
        this.targets = [
            $711555eabecedb8b$var$createTarget(),
            $711555eabecedb8b$var$createTarget()
        ];
    }
    let numLevels = 5;
    let levels = $711555eabecedb8b$var$range(numLevels).map((index)=>new Level(index));
    new $e97a97f0b0cf48c9$export$c977b3e384af9ae1();
    let time0;
    let targetAspect = 1;
    function reallocTargets(renderer, mode) {
        let { drawingBufferWidth: width, drawingBufferHeight: height } = renderer.getContext();
        if (mode == "stereo") width >>= 1;
        targetAspect = width / height;
        if (rtBase && rtBase.width === width && rtBase.height === height) return;
        console.log("realloc[%d]: %dx%d", 0, width, height);
        rtBase.setSize(width, height);
        rtComps[0].setSize(width, height);
        if (mode === "stereo") rtComps[1].setSize(width, height);
        const baseShift = 1;
        levels.forEach((level, i)=>{
            let shift = baseShift + i;
            let w = width >> shift;
            let h = height >> shift;
            level.targets.forEach((target)=>target.setSize(w, h));
            console.log("realloc[%d]: %dx%d", 1 + i, w, h);
        });
    }
    function getBlurTexture(index) {
        if (index === 0) return rtBase.texture;
        else return levels[index - 1].targets[1].texture;
    }
    function getCameraViewProjectionInverse(out, camera) {
        out.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        out.invert();
        return out;
    }
    function renderBlur(renderer, sourceTexture, camera) {
        let writeTarget, readTarget;
        {
            let { cvd: material } = materials;
            material.uniforms.uTexCamera.value = sourceTexture;
            if (sourceTexture.mapping === $e97a97f0b0cf48c9$export$d64030b316d3b087) {
                getCameraViewProjectionInverse(material.uniforms.uMatViewProjInv.value, camera);
                material.uniforms.uIsPanoramic.value = true;
            } else {
                material.uniforms.uMatTexCamera.value.copy(sourceTexture.matrix);
                material.uniforms.uIsPanoramic.value = false;
            }
            material.uniforms.uMatCVD.value.identity();
            material.uniforms.uMix.value = 1;
            material.uniformsNeedUpdate = true;
            renderer.setRenderTarget(rtBase);
            renderQuad(renderer, material);
            writeTarget = levels[0].targets[1];
            renderer.setRenderTarget(writeTarget);
            renderQuad(renderer, material);
        }
        {
            let { blur: material } = materials;
            readTarget = writeTarget;
            for(let i = 0; i < numLevels; ++i){
                let level = levels[i];
                for(let j = 0; j < 2; ++j){
                    let horz = j === 0 ? 1 : 0;
                    let vert = 1 - horz;
                    material.uniforms.uSampleDelta.value.set(horz / (readTarget.width - 1), vert / (readTarget.height - 1));
                    material.uniforms.uNoiseShift.value.set(Math.random(), Math.random());
                    material.uniforms.uTexSource.value = readTarget.texture;
                    material.uniformsNeedUpdate = true;
                    writeTarget = level.targets[j];
                    renderer.setRenderTarget(writeTarget);
                    renderQuad(renderer, material);
                    readTarget = writeTarget;
                }
            }
        }
    }
    function timeNow() {
        return performance.now() * 1e-3;
    }
    function updateTime() {
        if (time0 === void 0) time0 = timeNow();
        return timeNow() - time0;
    }
    let validConditions = [
        "none",
        "protanopia",
        "deuteranopia",
        "tritanopia",
        "achromatopsia",
        "hemianopia",
        "cataracts",
        "glaucoma",
        "retinitis-pigmentosa",
        "armd",
        "diabetic-retinopathy"
    ];
    function renderCondition(renderer, eye, condition, severity, time, mix) {
        let material;
        if (condition == "protanopia" || condition == "deuteranopia" || condition == "tritanopia" || condition == "none") {
            material = materials.cvd;
            if (condition == "none") material.uniforms.uMatCVD.value.identity();
            else $711555eabecedb8b$var$getCvdMatrix(material.uniforms.uMatCVD.value, condition, severity / 5);
            material.uniforms.uTexCamera.value = getBlurTexture(0);
            material.uniforms.uMatTexCamera.value.identity();
            material.uniforms.uIsPanoramic.value = false;
            material.uniforms.uMix.value = mix;
            material.uniformsNeedUpdate = true;
        } else {
            material = materials[condition];
            material.uniforms.uMatCVD.value.identity();
            material.uniforms.uEye.value = eye;
            let splodge;
            if (condition == "cataracts") splodge = textures.cataracts;
            else if (condition == "glaucoma") splodge = textures.glaucoma[severity - 1];
            else if (condition == "retinitis-pigmentosa") splodge = textures.tunnel[severity - 1];
            else if (condition == "armd") {
                splodge = textures.macula;
                $711555eabecedb8b$var$getCvdMatrix(material.uniforms.uMatCVD.value, "tritanopia", 0.5 * severity / 5);
            } else if (condition == "diabetic-retinopathy") {
                splodge = textures.camouflage[severity - 1];
                $711555eabecedb8b$var$getCvdMatrix(material.uniforms.uMatCVD.value, "tritanopia", 0.5 * severity / 5);
            }
            if (splodge) {
                material.uniforms.uTexSplodge.value = splodge;
                let e = material.uniforms.uMatSplodge.value.elements;
                let sourceAspect = splodge.aspect ?? 1;
                let vScale = sourceAspect / targetAspect;
                e[4] = vScale;
                e[7] = 0.5 * (1 - vScale);
            }
            for(let i = 0; i < 6; ++i){
                let name = `uTexSource${i}`;
                material.uniforms[name].value = getBlurTexture(i);
            }
            const rtComp = rtComps[eye];
            material.uniforms.uTime.value = time;
            material.uniforms.uSeverity.value = severity / 5;
            material.uniforms.uResolution.value.set(rtComp.width, rtComp.height);
            material.uniforms.uMix.value = mix;
        }
        material.forceSinglePass = true;
        material.depthWrite = false;
        material.toneMapped = false;
        material.blending = $e97a97f0b0cf48c9$export$777d8f9551c2216b;
        renderQuad(renderer, material);
    }
    class EffectSetting {
        constructor(){
            $711555eabecedb8b$var$__publicField(this, "time", 0);
            $711555eabecedb8b$var$__publicField(this, "condition", "none");
            $711555eabecedb8b$var$__publicField(this, "severity", 1);
        }
    }
    class EffectTransition {
        constructor(){
            $711555eabecedb8b$var$__publicField(this, "duration", 1);
            $711555eabecedb8b$var$__publicField(this, "prev", new EffectSetting());
            $711555eabecedb8b$var$__publicField(this, "next", new EffectSetting());
            $711555eabecedb8b$var$__publicField(this, "mix", 0);
        }
        update(time, condition, severity) {
            const { prev: prev, next: next, duration: duration } = this;
            if (condition !== next.condition || severity !== next.severity) {
                prev.time = time;
                prev.condition = next.condition;
                prev.severity = next.severity;
                next.time = time + duration;
                next.condition = condition;
                next.severity = severity;
            }
            {
                const delta = next.time - prev.time;
                const u = delta > 0 ? (time - prev.time) / delta : 1;
                this.mix = $711555eabecedb8b$var$smoothstep(0, 1, u);
            }
        }
    }
    const transition = new EffectTransition();
    function renderConditionTransition(renderer, eye, time) {
        const rtComp = rtComps[eye];
        renderer.setRenderTarget(rtComp);
        const { autoClear: autoClear } = renderer;
        renderer.autoClear = false;
        renderer.clear(true, true, true);
        const { prev: prev, next: next, mix: mix } = transition;
        if (mix < 1) {
            const { condition: condition, severity: severity } = prev;
            renderCondition(renderer, eye, condition, severity, time, 1 - mix);
        }
        if (mix > 0) {
            const { condition: condition, severity: severity } = next;
            renderCondition(renderer, eye, condition, severity, time, mix);
        }
        renderer.autoClear = autoClear;
        renderer.setRenderTarget(null);
    }
    function render({ renderer: renderer, cameras: cameras, mode: mode = "mono", sourceTexture: // either backgroundTexture or pano texture
    sourceTexture, condition: //camera,
    condition = "none", severity: severity = 5 }) {
        const time = updateTime();
        transition.update(time, condition, severity);
        reallocTargets(renderer, mode);
        if (!validConditions.includes(condition)) {
            console.warn('EyewareEffects: bad condition "%s"', condition);
            return;
        }
        severity = Math.floor(severity);
        if (severity < 1 || severity > 5) {
            console.warn('EyewareEffects: bad severity "%d"', severity);
            return;
        }
        const numEyes = mode === "stereo" ? 2 : 1;
        for(let eye = 0; eye < numEyes; ++eye){
            renderBlur(renderer, sourceTexture, cameras[eye]);
            renderConditionTransition(renderer, eye, time);
        }
    }
    return Object.assign(new.target ? this : {}, {
        render: render,
        get textureLeft () {
            return rtComps[0].texture;
        },
        get textureRight () {
            return rtComps[1].texture;
        }
    });
}



var $ecc8e5ffb363d4f0$exports = {};
/**
 * A type-safe event handling class that multiple functions to be registered to be called when events are emitted.
 */ class $3f699d1d92b0530c$export$d61e24a684f9e51 {
    constructor(){
        this._funcs = [];
    }
    /**
     * Bind new handler function.
     * @param f - The callback function to be bound.
     */ bind(f) {
        this._funcs.push(f);
    }
    /**
     * Unbind an existing handler function.
     * @param f - The callback function to be unbound.
     */ unbind(f) {
        const indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    /**
     * Emit an event, calling the bound handler functions.
     */ emit() {
        for(let i = 0, total = this._funcs.length; i < total; i++)this._funcs[i]();
    }
}
class $3f699d1d92b0530c$export$3371bf92c01fb88b {
    constructor(){
        this._funcs = [];
    }
    /**
     * Bind new handler function.
     * @param f - The callback function to be bound.
    */ bind(f) {
        this._funcs.push(f);
    }
    /**
     * Unbind an existing function.
     * @param f - The callback function to be unbound.
     */ unbind(f) {
        const indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    /**
     * Emit an event.
     *
     * @param a - The argument to pass to handler functions.
     */ emit(a) {
        for(let i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a);
    }
}


var $6516b0b5f2779a72$exports = {};

$parcel$export($6516b0b5f2779a72$exports, "z", function () { return $6516b0b5f2779a72$export$df995fae86a55f06; });
var $97b6f9b149f90503$exports = {};

$parcel$export($97b6f9b149f90503$exports, "initialize", function () { return $97b6f9b149f90503$export$2a47f398eeff8b01; });
var $adda256f81190c7f$export$53baafd5596ae7a8;
(function(barcode_format_t) {
    barcode_format_t[barcode_format_t["UNKNOWN"] = 131072] = "UNKNOWN";
    barcode_format_t[barcode_format_t["AZTEC"] = 1] = "AZTEC";
    barcode_format_t[barcode_format_t["CODABAR"] = 2] = "CODABAR";
    barcode_format_t[barcode_format_t["CODE_39"] = 4] = "CODE_39";
    barcode_format_t[barcode_format_t["CODE_93"] = 8] = "CODE_93";
    barcode_format_t[barcode_format_t["CODE_128"] = 16] = "CODE_128";
    barcode_format_t[barcode_format_t["DATA_MATRIX"] = 32] = "DATA_MATRIX";
    barcode_format_t[barcode_format_t["EAN_8"] = 64] = "EAN_8";
    barcode_format_t[barcode_format_t["EAN_13"] = 128] = "EAN_13";
    barcode_format_t[barcode_format_t["ITF"] = 256] = "ITF";
    barcode_format_t[barcode_format_t["MAXICODE"] = 512] = "MAXICODE";
    barcode_format_t[barcode_format_t["PDF_417"] = 1024] = "PDF_417";
    barcode_format_t[barcode_format_t["QR_CODE"] = 2048] = "QR_CODE";
    barcode_format_t[barcode_format_t["RSS_14"] = 4096] = "RSS_14";
    barcode_format_t[barcode_format_t["RSS_EXPANDED"] = 8192] = "RSS_EXPANDED";
    barcode_format_t[barcode_format_t["UPC_A"] = 16384] = "UPC_A";
    barcode_format_t[barcode_format_t["UPC_E"] = 32768] = "UPC_E";
    barcode_format_t[barcode_format_t["UPC_EAN_EXTENSION"] = 65536] = "UPC_EAN_EXTENSION";
    barcode_format_t[barcode_format_t["ALL"] = 131071] = "ALL";
})($adda256f81190c7f$export$53baafd5596ae7a8 || ($adda256f81190c7f$export$53baafd5596ae7a8 = {}));
var $adda256f81190c7f$export$1f0a57b556284af4;
(function(face_landmark_name_t) {
    face_landmark_name_t[face_landmark_name_t["EYE_LEFT"] = 0] = "EYE_LEFT";
    face_landmark_name_t[face_landmark_name_t["EYE_RIGHT"] = 1] = "EYE_RIGHT";
    face_landmark_name_t[face_landmark_name_t["EAR_LEFT"] = 2] = "EAR_LEFT";
    face_landmark_name_t[face_landmark_name_t["EAR_RIGHT"] = 3] = "EAR_RIGHT";
    face_landmark_name_t[face_landmark_name_t["NOSE_BRIDGE"] = 4] = "NOSE_BRIDGE";
    face_landmark_name_t[face_landmark_name_t["NOSE_TIP"] = 5] = "NOSE_TIP";
    face_landmark_name_t[face_landmark_name_t["NOSE_BASE"] = 6] = "NOSE_BASE";
    face_landmark_name_t[face_landmark_name_t["LIP_TOP"] = 7] = "LIP_TOP";
    face_landmark_name_t[face_landmark_name_t["LIP_BOTTOM"] = 8] = "LIP_BOTTOM";
    face_landmark_name_t[face_landmark_name_t["MOUTH_CENTER"] = 9] = "MOUTH_CENTER";
    face_landmark_name_t[face_landmark_name_t["CHIN"] = 10] = "CHIN";
    face_landmark_name_t[face_landmark_name_t["EYEBROW_LEFT"] = 11] = "EYEBROW_LEFT";
    face_landmark_name_t[face_landmark_name_t["EYEBROW_RIGHT"] = 12] = "EYEBROW_RIGHT";
})($adda256f81190c7f$export$1f0a57b556284af4 || ($adda256f81190c7f$export$1f0a57b556284af4 = {}));
var $adda256f81190c7f$export$51221aec55e6c7e6;
(function(instant_world_tracker_transform_orientation_t) {
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["WORLD"] = 3] = "WORLD";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["MINUS_Z_AWAY_FROM_USER"] = 4] = "MINUS_Z_AWAY_FROM_USER";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["MINUS_Z_HEADING"] = 5] = "MINUS_Z_HEADING";
    instant_world_tracker_transform_orientation_t[instant_world_tracker_transform_orientation_t["UNCHANGED"] = 6] = "UNCHANGED";
})($adda256f81190c7f$export$51221aec55e6c7e6 || ($adda256f81190c7f$export$51221aec55e6c7e6 = {}));
var $adda256f81190c7f$export$3c7fce2c49a05698;
(function(log_level_t) {
    log_level_t[log_level_t["LOG_LEVEL_NONE"] = 0] = "LOG_LEVEL_NONE";
    log_level_t[log_level_t["LOG_LEVEL_ERROR"] = 1] = "LOG_LEVEL_ERROR";
    log_level_t[log_level_t["LOG_LEVEL_WARNING"] = 2] = "LOG_LEVEL_WARNING";
    log_level_t[log_level_t["LOG_LEVEL_VERBOSE"] = 3] = "LOG_LEVEL_VERBOSE";
})($adda256f81190c7f$export$3c7fce2c49a05698 || ($adda256f81190c7f$export$3c7fce2c49a05698 = {}));
var $adda256f81190c7f$export$75bacc79ae92a32d;
(function(frame_pixel_format_t) {
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I420"] = 0] = "FRAME_PIXEL_FORMAT_I420";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I420A"] = 1] = "FRAME_PIXEL_FORMAT_I420A";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I422"] = 2] = "FRAME_PIXEL_FORMAT_I422";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_I444"] = 3] = "FRAME_PIXEL_FORMAT_I444";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_NV12"] = 4] = "FRAME_PIXEL_FORMAT_NV12";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_RGBA"] = 5] = "FRAME_PIXEL_FORMAT_RGBA";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_BGRA"] = 6] = "FRAME_PIXEL_FORMAT_BGRA";
    frame_pixel_format_t[frame_pixel_format_t["FRAME_PIXEL_FORMAT_Y"] = 7] = "FRAME_PIXEL_FORMAT_Y";
})($adda256f81190c7f$export$75bacc79ae92a32d || ($adda256f81190c7f$export$75bacc79ae92a32d = {}));
var $adda256f81190c7f$export$7f44ab26face7b78;
(function(image_target_type_t) {
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_PLANAR"] = 0] = "IMAGE_TRACKER_TYPE_PLANAR";
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_CYLINDRICAL"] = 1] = "IMAGE_TRACKER_TYPE_CYLINDRICAL";
    image_target_type_t[image_target_type_t["IMAGE_TRACKER_TYPE_CONICAL"] = 2] = "IMAGE_TRACKER_TYPE_CONICAL";
})($adda256f81190c7f$export$7f44ab26face7b78 || ($adda256f81190c7f$export$7f44ab26face7b78 = {}));




class $84dc69a8fd0718f1$export$74925a4979a99f62 {
    constructor(_messageSender){
        this._messageSender = _messageSender;
        this._freeBufferPool = [];
        this._buffer = new ArrayBuffer(16);
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 1;
        this._startOffset = -1;
        this._timeoutSet = false;
        this._appender = {
            int: (i)=>this.int(i),
            bool: (i)=>this.int(i ? 1 : 0),
            float: (i)=>this.float(i),
            string: (i)=>this.string(i),
            dataWithLength: (i)=>this.arrayBuffer(i),
            type: (i)=>this.int(i),
            matrix4x4: (i)=>this.float32ArrayBuffer(i),
            matrix3x3: (i)=>this.float32ArrayBuffer(i),
            identityCoefficients: (i)=>this.float32ArrayBuffer(i),
            expressionCoefficients: (i)=>this.float32ArrayBuffer(i),
            cameraModel: (i)=>this.float32ArrayBuffer(i),
            timestamp: (i)=>this.double(i),
            barcodeFormat: (i)=>this.int(i),
            faceLandmarkName: (i)=>this.int(i),
            instantTrackerTransformOrientation: (i)=>this.int(i),
            logLevel: (i)=>this.int(i)
        };
        this._freeBufferPool.push(new ArrayBuffer(16));
        this._freeBufferPool.push(new ArrayBuffer(16));
    }
    bufferReturn(ab) {
        this._freeBufferPool.push(ab);
    }
    // public copySerializedData(): ArrayBuffer {
    //     let data = this._buffer.slice(0, this._offset * Int32Array.BYTES_PER_ELEMENT);
    //     this._offset = 0;
    //     this._startOffset = -1;
    //     return data;
    // }
    _ensureArrayBuffer(incremental) {
        let requirement = (this._offset + incremental + 8) * 4;
        if (this._buffer && this._buffer.byteLength >= requirement) return;
        let newBuffer = undefined;
        // for (let i = 0; i < this._freeBufferPool.length; i++) {
        //     if (this._freeBufferPool[i].byteLength > requirement) {
        //         newBuffer = this._freeBufferPool[i];
        //         this._freeBufferPool.splice(i, 1);
        //         break;
        //     }
        // }
        if (!newBuffer) {
            let nextPow2 = requirement;
            nextPow2--;
            nextPow2 |= nextPow2 >> 1;
            nextPow2 |= nextPow2 >> 2;
            nextPow2 |= nextPow2 >> 4;
            nextPow2 |= nextPow2 >> 8;
            nextPow2 |= nextPow2 >> 16;
            nextPow2++;
            newBuffer = new ArrayBuffer(nextPow2);
        }
        let oldView = this._buffer ? this._i32View : undefined;
        this._buffer = newBuffer;
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        if (oldView) this._i32View.set(oldView.subarray(0, this._offset));
    // this._offset = 1; // First int is whole length
    // this._startOffset = -1;
    }
    sendMessage(messageId, cb) {
        this._ensureArrayBuffer(4);
        this._startOffset = this._offset;
        this._i32View[this._offset + 1] = messageId;
        this._offset += 2;
        cb(this._appender);
        this._i32View[this._startOffset] = this._offset - this._startOffset;
        this._startOffset = -1;
        this._sendOneTime();
    }
    _sendOneTime() {
        if (this._timeoutSet === false) {
            this._timeoutSet = true;
            setTimeout(()=>{
                this._timeoutSet = false;
                this._send();
            }, 0);
        }
    }
    _send() {
        // Continue filling the current buffer unless have a new buffer to fill
        if (this._freeBufferPool.length === 0) {
            this._sendOneTime();
            return;
        }
        this._i32View[0] = this._offset;
        this._messageSender(this._buffer);
        this._buffer = undefined;
        this._buffer = this._freeBufferPool.pop();
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u8cView = new Uint8ClampedArray(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 1;
        this._startOffset = -1;
    }
    int(arg) {
        this._ensureArrayBuffer(1);
        this._i32View[this._offset] = arg;
        this._offset++;
    }
    double(arg) {
        this._ensureArrayBuffer(2);
        if (this._offset % 2 === 1) this._offset++;
        this._f64View[this._offset / 2] = arg;
        this._offset += 2;
    }
    float(arg) {
        this._ensureArrayBuffer(1);
        this._f32View[this._offset] = arg;
        this._offset++;
    }
    int32Array(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._i32View[this._offset + i] = args[i];
        this._offset += args.length;
    }
    float32Array(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._f32View[this._offset + i] = args[i];
        this._offset += args.length;
    }
    booleanArray(args) {
        this._ensureArrayBuffer(args.length);
        for(let i = 0; i < args.length; ++i)this._i32View[this._offset + i] = args[i] ? 1 : 0;
        this._offset += args.length;
    }
    uint8ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.byteLength;
        this._offset++;
        this._u8View.set(data, this._offset * 4);
        // Update the int32 offset
        this._offset += data.byteLength >> 2;
        if ((data.byteLength & 3) !== 0) this._offset++;
    }
    arrayBuffer(data) {
        let view = new Uint8Array(data);
        this.uint8ArrayBuffer(view);
    }
    uint8ClampedArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.byteLength;
        this._offset++;
        this._u8cView.set(data, this._offset * 4);
        // Update the int32 offset
        this._offset += data.byteLength >> 2;
        if ((data.byteLength & 3) !== 0) this._offset++;
    }
    float32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._f32View.set(data, this._offset);
        this._offset += data.length;
    }
    uint16ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        let u16Offset = this._offset * 2;
        this._u16View.set(data, u16Offset);
        // Update the int32 offset
        this._offset += data.length >> 1;
        if ((data.length & 1) !== 0) this._offset++;
    }
    int32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._i32View.set(data, this._offset);
        this._offset += data.length;
    }
    uint32ArrayBuffer(data) {
        this._ensureArrayBuffer(data.byteLength / 4);
        this._i32View[this._offset] = data.length;
        this._offset++;
        this._u32View.set(data, this._offset);
        this._offset += data.length;
    }
    string(data) {
        let encoder = new TextEncoder();
        let res = encoder.encode(data);
        this._ensureArrayBuffer(res.byteLength / 4);
        this._i32View[this._offset] = res.byteLength;
        this._offset++;
        this._u8View.set(res, this._offset * 4);
        // Update the int32 offset
        this._offset += res.byteLength >> 2;
        if ((res.byteLength & 3) !== 0) this._offset++;
    }
}


class $be020f3ced0b41c0$export$16c5ab9fb870b6bb {
    constructor(){
        this._buffer = new ArrayBuffer(0);
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 0;
        this._length = 0;
        this._startOffset = -1;
        this._processor = {
            int: ()=>this._i32View[this._startOffset++],
            bool: ()=>this._i32View[this._startOffset++] === 1,
            type: ()=>this._i32View[this._startOffset++],
            float: ()=>this._f32View[this._startOffset++],
            timestamp: ()=>{
                if (this._startOffset % 2 === 1) this._startOffset++;
                let ret = this._f64View[this._startOffset / 2];
                this._startOffset += 2;
                return ret;
            },
            string: ()=>{
                let len = this._i32View[this._startOffset++];
                let decoder = new TextDecoder();
                let res = decoder.decode(new Uint8Array(this._buffer, this._startOffset * 4, len));
                this._startOffset += len >> 2;
                if ((len & 3) !== 0) this._startOffset++;
                return res;
            },
            dataWithLength: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Uint8Array(len);
                ret.set(this._u8View.subarray(this._startOffset * 4, this._startOffset * 4 + len));
                this._startOffset += ret.byteLength >> 2;
                if ((ret.byteLength & 3) !== 0) this._startOffset++;
                return ret.buffer;
            },
            matrix4x4: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 16));
                this._startOffset += len;
                return ret;
            },
            matrix3x3: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 9));
                this._startOffset += len;
                return ret;
            },
            identityCoefficients: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 50));
                this._startOffset += len;
                return ret;
            },
            expressionCoefficients: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 29));
                this._startOffset += len;
                return ret;
            },
            cameraModel: ()=>{
                let len = this._i32View[this._startOffset++];
                let ret = new Float32Array(len);
                ret.set(this._f32View.subarray(this._startOffset, this._startOffset + 6));
                this._startOffset += len;
                return ret;
            },
            barcodeFormat: ()=>this._i32View[this._startOffset++],
            faceLandmarkName: ()=>this._i32View[this._startOffset++],
            instantTrackerTransformOrientation: ()=>this._i32View[this._startOffset++],
            logLevel: ()=>this._i32View[this._startOffset++]
        };
    }
    setData(data) {
        this._buffer = data;
        this._i32View = new Int32Array(this._buffer);
        this._f32View = new Float32Array(this._buffer);
        this._f64View = new Float64Array(this._buffer);
        this._u8View = new Uint8Array(this._buffer);
        this._u16View = new Uint16Array(this._buffer);
        this._u32View = new Uint32Array(this._buffer);
        this._offset = 0;
        this._length = 0;
        if (data.byteLength >= 4) {
            this._offset = 1;
            this._length = this._i32View[0];
        }
        this._startOffset = -1;
    }
    hasMessage() {
        return this._offset + 1 < this._length;
    }
    forMessages(cb) {
        while(this.hasMessage()){
            let len = this._i32View[this._offset];
            let messageId = this._i32View[this._offset + 1];
            this._startOffset = this._offset + 2;
            this._offset += len;
            cb(messageId, this._processor);
        }
    }
}


class $07fd930278135cf3$export$ada9decabe1e7aa7 {
    constructor(_messageSender){
        this._messageSender = _messageSender;
        this._globalState = {
            log_level: 1
        };
        this.serializer = new (0, $84dc69a8fd0718f1$export$74925a4979a99f62)((ab)=>{
            this._messageSender(ab);
        });
        this.deserializer = new (0, $be020f3ced0b41c0$export$16c5ab9fb870b6bb)();
        this._latestId = 1;
        this._pipeline_state_by_instance = new Map();
        this._camera_source_state_by_instance = new Map();
        this._sequence_source_state_by_instance = new Map();
        this._image_tracker_state_by_instance = new Map();
        this._face_tracker_state_by_instance = new Map();
        this._face_mesh_state_by_instance = new Map();
        this._face_landmark_state_by_instance = new Map();
        this._barcode_finder_state_by_instance = new Map();
        this._instant_world_tracker_state_by_instance = new Map();
        this.impl = {
            log_level: ()=>{
                return this._globalState.log_level;
            },
            log_level_set: (level)=>{
                this.serializer.sendMessage(34, (m)=>{
                    m.logLevel(level);
                });
            },
            analytics_project_id_set: (id, uid)=>{
                this.serializer.sendMessage(31, (m)=>{
                    m.string(id);
                    m.string(uid);
                });
            },
            // #### pipeline ####
            pipeline_create: ()=>{
                let newId = this._latestId++;
                let s = {
                    current_frame_user_data: 0,
                    camera_model: new Float32Array([
                        300,
                        300,
                        160,
                        120,
                        0,
                        0
                    ]),
                    camera_pose: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    camera_frame_camera_attitude: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    camera_frame_device_attitude: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]),
                    frame_number: 0
                };
                this._pipeline_state_by_instance.set(newId, s);
                this.serializer.sendMessage(27, (m)=>{
                    m.type(newId);
                });
                return newId;
            },
            pipeline_destroy: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._pipeline_state_by_instance.delete(o);
                this.serializer.sendMessage(28, (m)=>{
                    m.type(o);
                });
            },
            pipeline_frame_update: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(9, (m)=>{
                    m.type(o);
                });
            },
            pipeline_frame_number: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.frame_number;
            },
            pipeline_camera_model: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_model;
            },
            pipeline_camera_frame_user_data: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.current_frame_user_data;
            },
            pipeline_camera_frame_submit: (o, data, width, height, user_data, camera_to_device_transform, camera_model, user_facing)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(8, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                    m.int(width);
                    m.int(height);
                    m.int(user_data);
                    m.matrix4x4(camera_to_device_transform);
                    m.cameraModel(camera_model);
                    m.bool(user_facing);
                });
            },
            pipeline_camera_frame_submit_raw_pointer: (o, data, dataLength, format, width, height, user_data, camera_to_device_transform, rotation, camera_model, user_facing)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
            },
            pipeline_camera_frame_camera_attitude: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_frame_camera_attitude;
            },
            pipeline_camera_frame_device_attitude: (o)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.camera_frame_device_attitude;
            },
            pipeline_motion_accelerometer_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(10, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_rotation_rate_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(11, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_attitude_submit: (o, time, x, y, z)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(12, (m)=>{
                    m.type(o);
                    m.timestamp(time);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                });
            },
            pipeline_motion_attitude_matrix_submit: (o, mat)=>{
                let s = this._pipeline_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(13, (m)=>{
                    m.type(o);
                    m.matrix4x4(mat);
                });
            },
            // #### camera_source ####
            camera_source_create: (pipeline, device_id)=>{
                let newId = this._latestId++;
                let s = {};
                this._camera_source_state_by_instance.set(newId, s);
                this.serializer.sendMessage(29, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                    m.string(device_id);
                });
                return newId;
            },
            camera_source_destroy: (o)=>{
                let s = this._camera_source_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._camera_source_state_by_instance.delete(o);
                this.serializer.sendMessage(30, (m)=>{
                    m.type(o);
                });
            },
            // #### sequence_source ####
            sequence_source_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {};
                this._sequence_source_state_by_instance.set(newId, s);
                this.serializer.sendMessage(35, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            sequence_source_destroy: (o)=>{
                let s = this._sequence_source_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._sequence_source_state_by_instance.delete(o);
                this.serializer.sendMessage(36, (m)=>{
                    m.type(o);
                });
            },
            // #### image_tracker ####
            image_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    target_loaded_version: -1,
                    anchor_count: 0,
                    anchor_id: [],
                    anchor_pose: []
                };
                this._image_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(2, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            image_tracker_destroy: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._image_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(14, (m)=>{
                    m.type(o);
                });
            },
            image_tracker_target_load_from_memory: (o, data)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(4, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                });
            },
            image_tracker_target_loaded_version: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.target_loaded_version;
            },
            image_tracker_enabled: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            image_tracker_enabled_set: (o, enabled)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(3, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            image_tracker_anchor_count: (o)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_count;
            },
            image_tracker_anchor_id: (o, indx)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_id[indx];
            },
            image_tracker_anchor_pose_raw: (o, indx)=>{
                let s = this._image_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_pose[indx];
            },
            // #### face_tracker ####
            face_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    model_loaded: -1,
                    max_faces: 1,
                    anchor_count: 0,
                    anchor_id: [],
                    anchor_pose: [],
                    anchor_identity_coefficients: [],
                    anchor_expression_coefficients: []
                };
                this._face_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(20, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            face_tracker_destroy: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(21, (m)=>{
                    m.type(o);
                });
            },
            face_tracker_model_load_from_memory: (o, data)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(22, (m)=>{
                    m.type(o);
                    m.dataWithLength(data);
                });
            },
            face_tracker_model_loaded_version: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.model_loaded;
            },
            face_tracker_enabled_set: (o, enabled)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(23, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            face_tracker_enabled: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            face_tracker_max_faces_set: (o, num)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(24, (m)=>{
                    m.type(o);
                    m.int(num);
                });
            },
            face_tracker_max_faces: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.max_faces;
            },
            face_tracker_anchor_count: (o)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_count;
            },
            face_tracker_anchor_id: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_id[indx];
            },
            face_tracker_anchor_pose_raw: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_pose[indx];
            },
            face_tracker_anchor_identity_coefficients: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_identity_coefficients[indx];
            },
            face_tracker_anchor_expression_coefficients: (o, indx)=>{
                let s = this._face_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.anchor_expression_coefficients[indx];
            },
            // #### face_mesh ####
            face_mesh_create: ()=>{
                let newId = this._latestId++;
                let s = {};
                this._face_mesh_state_by_instance.set(newId, s);
                this.serializer.sendMessage(25, (m)=>{
                    m.type(newId);
                });
                return newId;
            },
            face_mesh_destroy: (o)=>{
                let s = this._face_mesh_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_mesh_state_by_instance.delete(o);
                this.serializer.sendMessage(26, (m)=>{
                    m.type(o);
                });
            },
            // #### face_landmark ####
            face_landmark_create: (landmark)=>{
                let newId = this._latestId++;
                let s = {};
                this._face_landmark_state_by_instance.set(newId, s);
                this.serializer.sendMessage(32, (m)=>{
                    m.type(newId);
                    m.faceLandmarkName(landmark);
                });
                return newId;
            },
            face_landmark_destroy: (o)=>{
                let s = this._face_landmark_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._face_landmark_state_by_instance.delete(o);
                this.serializer.sendMessage(33, (m)=>{
                    m.type(o);
                });
            },
            // #### barcode_finder ####
            barcode_finder_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    number_found: 0,
                    found_text: [],
                    found_format: [],
                    formats: 131071
                };
                this._barcode_finder_state_by_instance.set(newId, s);
                this.serializer.sendMessage(16, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            barcode_finder_destroy: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._barcode_finder_state_by_instance.delete(o);
                this.serializer.sendMessage(17, (m)=>{
                    m.type(o);
                });
            },
            barcode_finder_enabled_set: (o, enabled)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(18, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            barcode_finder_enabled: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            barcode_finder_found_number: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.number_found;
            },
            barcode_finder_found_text: (o, indx)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.found_text[indx];
            },
            barcode_finder_found_format: (o, indx)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.found_format[indx];
            },
            barcode_finder_formats: (o)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.formats;
            },
            barcode_finder_formats_set: (o, f)=>{
                let s = this._barcode_finder_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(19, (m)=>{
                    m.type(o);
                    m.barcodeFormat(f);
                });
            },
            // #### instant_world_tracker ####
            instant_world_tracker_create: (pipeline)=>{
                let newId = this._latestId++;
                let s = {
                    enabled: true,
                    pose: new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ])
                };
                this._instant_world_tracker_state_by_instance.set(newId, s);
                this.serializer.sendMessage(5, (m)=>{
                    m.type(newId);
                    m.type(pipeline);
                });
                return newId;
            },
            instant_world_tracker_destroy: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this._instant_world_tracker_state_by_instance.delete(o);
                this.serializer.sendMessage(15, (m)=>{
                    m.type(o);
                });
            },
            instant_world_tracker_enabled_set: (o, enabled)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(6, (m)=>{
                    m.type(o);
                    m.bool(enabled);
                });
            },
            instant_world_tracker_enabled: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.enabled;
            },
            instant_world_tracker_anchor_pose_raw: (o)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                return s.pose;
            },
            instant_world_tracker_anchor_pose_set_from_camera_offset_raw: (o, x, y, z, orientation)=>{
                let s = this._instant_world_tracker_state_by_instance.get(o);
                if (!s) throw new Error("This object has been destroyed");
                this.serializer.sendMessage(7, (m)=>{
                    m.type(o);
                    m.float(x);
                    m.float(y);
                    m.float(z);
                    m.instantTrackerTransformOrientation(orientation);
                });
            }
        };
    }
    processMessages(a) {
        this.deserializer.setData(a);
        this.deserializer.forMessages((messageId, msg)=>{
            switch(messageId){
                case 7:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.frame_number = msg.int();
                        break;
                    }
                case 6:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_model = msg.cameraModel();
                        break;
                    }
                case 5:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.current_frame_user_data = msg.int();
                        break;
                    }
                case 11:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_frame_camera_attitude = msg.matrix4x4();
                        break;
                    }
                case 12:
                    {
                        let handle = msg.type();
                        let inst = this._pipeline_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.camera_frame_device_attitude = msg.matrix4x4();
                        break;
                    }
                case 19:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.target_loaded_version = msg.int();
                        break;
                    }
                case 1:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.anchor_count = msg.int();
                        break;
                    }
                case 2:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_id[indx] = msg.string();
                        break;
                    }
                case 3:
                    {
                        let handle = msg.type();
                        let inst = this._image_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_pose[indx] = msg.matrix4x4();
                        break;
                    }
                case 18:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.model_loaded = msg.int();
                        break;
                    }
                case 13:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.anchor_count = msg.int();
                        break;
                    }
                case 14:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_id[indx] = msg.string();
                        break;
                    }
                case 15:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_pose[indx] = msg.matrix4x4();
                        break;
                    }
                case 16:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_identity_coefficients[indx] = msg.identityCoefficients();
                        break;
                    }
                case 17:
                    {
                        let handle = msg.type();
                        let inst = this._face_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.anchor_expression_coefficients[indx] = msg.expressionCoefficients();
                        break;
                    }
                case 8:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.number_found = msg.int();
                        break;
                    }
                case 9:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.found_text[indx] = msg.string();
                        break;
                    }
                case 10:
                    {
                        let handle = msg.type();
                        let inst = this._barcode_finder_state_by_instance.get(handle);
                        if (!inst) return;
                        let indx = msg.int();
                        inst.found_format[indx] = msg.barcodeFormat();
                        break;
                    }
                case 4:
                    {
                        let handle = msg.type();
                        let inst = this._instant_world_tracker_state_by_instance.get(handle);
                        if (!inst) return;
                        inst.pose = msg.matrix4x4();
                        break;
                    }
            }
        });
    }
}


function $2855ef2b305ce725$export$9b5304f4eb007cf0(gl, type, src) {
    let ret = gl.createShader(type);
    if (!ret) throw new Error("Unable to create shader");
    gl.shaderSource(ret, src);
    gl.compileShader(ret);
    let msg = gl.getShaderInfoLog(ret);
    if (msg && msg.trim().length > 0) throw new Error("Shader compile error: " + msg);
    return ret;
}
function $2855ef2b305ce725$export$d879afae78b531a5(gl, prog) {
    gl.linkProgram(prog);
    let msg = gl.getProgramInfoLog(prog);
    if (msg && msg.trim().length > 0) throw new Error("Unable to link: " + msg);
}


let $d580c9e8b84c13cf$var$shader;
let $d580c9e8b84c13cf$var$vbo;
let $d580c9e8b84c13cf$var$uvbo;
let $d580c9e8b84c13cf$var$texturesByUrl = {};
function $d580c9e8b84c13cf$export$5998daa18e8ce5b0() {
    $d580c9e8b84c13cf$var$shader = undefined;
    $d580c9e8b84c13cf$var$vbo = undefined;
    $d580c9e8b84c13cf$var$uvbo = undefined;
    $d580c9e8b84c13cf$var$texturesByUrl = {};
}
function $d580c9e8b84c13cf$var$generate(gl) {
    if ($d580c9e8b84c13cf$var$vbo) return $d580c9e8b84c13cf$var$vbo;
    $d580c9e8b84c13cf$var$vbo = gl.createBuffer();
    if (!$d580c9e8b84c13cf$var$vbo) throw new Error("Unable to create buffer object");
    let coords = [
        -0.5,
        0.125,
        0,
        -0.5,
        -0.125,
        0,
        0.5,
        0.125,
        0,
        0.5,
        -0.125,
        0
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, $d580c9e8b84c13cf$var$vbo);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(coords), gl.STATIC_DRAW);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return $d580c9e8b84c13cf$var$vbo;
}
function $d580c9e8b84c13cf$var$generateUVBO(gl) {
    if ($d580c9e8b84c13cf$var$uvbo) return $d580c9e8b84c13cf$var$uvbo;
    $d580c9e8b84c13cf$var$uvbo = gl.createBuffer();
    if (!$d580c9e8b84c13cf$var$uvbo) throw new Error("Unable to create buffer object");
    let coords = [
        0,
        1,
        0,
        0,
        1,
        1,
        1,
        0
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, $d580c9e8b84c13cf$var$uvbo);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(coords), gl.STATIC_DRAW);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return $d580c9e8b84c13cf$var$uvbo;
}
function $d580c9e8b84c13cf$export$4807f772bfdbc71f(gl, projectionMatrix, cameraMatrix, targetMatrix, textureUrl) {
    let shader = $d580c9e8b84c13cf$var$getShader(gl);
    let v = $d580c9e8b84c13cf$var$generate(gl);
    let uvbo = $d580c9e8b84c13cf$var$generateUVBO(gl);
    gl.disable(gl.DEPTH_TEST);
    gl.useProgram(shader.prog);
    gl.uniformMatrix4fv(shader.unif_proj, false, projectionMatrix);
    gl.uniformMatrix4fv(shader.unif_camera, false, cameraMatrix);
    gl.uniformMatrix4fv(shader.unif_matrix, false, targetMatrix);
    gl.bindBuffer(gl.ARRAY_BUFFER, v);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, $d580c9e8b84c13cf$var$loadTexture(gl, textureUrl));
    gl.uniform1i(shader.unif_skinSampler, 0);
    gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
    gl.enableVertexAttribArray(shader.attr_position);
    gl.bindBuffer(gl.ARRAY_BUFFER, uvbo);
    gl.vertexAttribPointer(shader.attr_textureCoord, 2, gl.FLOAT, false, 8, 0);
    gl.enableVertexAttribArray(shader.attr_textureCoord);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    gl.disableVertexAttribArray(shader.attr_position);
    gl.disableVertexAttribArray(shader.attr_textureCoord);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
}
function $d580c9e8b84c13cf$var$generateLocalMatrix() {
    let position = [
        0,
        0,
        -5
    ];
    return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        position[0],
        position[1],
        position[2],
        1
    ]);
}
let $d580c9e8b84c13cf$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 projMatrix;
uniform mat4 cameraMatrix;
uniform mat4 modelViewMatrix;
attribute vec4 position;
attribute vec2 textureCoord;

varying highp vec2 vTextureCoord;

void main()
{
    gl_Position = projMatrix * cameraMatrix * modelViewMatrix * position;
    vTextureCoord = textureCoord;
}`;
let $d580c9e8b84c13cf$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
uniform sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2D(skinSampler, vTextureCoord);
}`;
function $d580c9e8b84c13cf$var$getShader(gl) {
    if ($d580c9e8b84c13cf$var$shader) return $d580c9e8b84c13cf$var$shader;
    let prog = gl.createProgram();
    if (!prog) throw new Error("Unable to create program");
    let vertexShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $d580c9e8b84c13cf$var$vertexShaderSrc);
    let fragmentShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $d580c9e8b84c13cf$var$fragmentShaderSrc);
    gl.attachShader(prog, vertexShader);
    gl.attachShader(prog, fragmentShader);
    (0, $2855ef2b305ce725$export$d879afae78b531a5)(gl, prog);
    let unif_proj = gl.getUniformLocation(prog, "projMatrix");
    if (!unif_proj) throw new Error("Unable to get uniform location projMatrix");
    let unif_matrix = gl.getUniformLocation(prog, "modelViewMatrix");
    if (!unif_matrix) throw new Error("Unable to get uniform location modelViewMatrix");
    let unif_camera = gl.getUniformLocation(prog, "cameraMatrix");
    if (!unif_camera) throw new Error("Unable to get uniform location cameraMatrix");
    let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
    if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
    $d580c9e8b84c13cf$var$shader = {
        prog: prog,
        unif_matrix: unif_matrix,
        unif_proj: unif_proj,
        unif_camera: unif_camera,
        unif_skinSampler: unif_skinSampler,
        attr_position: gl.getAttribLocation(prog, "position"),
        attr_textureCoord: gl.getAttribLocation(prog, "textureCoord")
    };
    return $d580c9e8b84c13cf$var$shader;
}
function $d580c9e8b84c13cf$var$loadTexture(gl, url) {
    if ($d580c9e8b84c13cf$var$texturesByUrl[url]) return $d580c9e8b84c13cf$var$texturesByUrl[url];
    let texture = gl.createTexture();
    if (!texture) throw new Error("Unable to create texture");
    $d580c9e8b84c13cf$var$texturesByUrl[url] = texture;
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // Because images have to be download over the internet
    // they might take a moment until they are ready.
    // Until then put a single pixel in the texture so we can
    // use it immediately. When the image has finished downloading
    // we'll update the texture with the contents of the image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 1;
    const height = 1;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const pixel = new Uint8Array([
        0,
        0,
        255,
        255
    ]); // opaque blue
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);
    const image = new Image();
    image.onload = function() {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    };
    image.src = url;
    return texture;
}




var $gG43b = parcelRequire("gG43b");
var $2a24a564c6953dcf$export$59a354bcfe78fe8;
(function(EmbeddedVideoImplementation) {
    EmbeddedVideoImplementation[EmbeddedVideoImplementation["OBJECT_URL"] = 0] = "OBJECT_URL";
    EmbeddedVideoImplementation[EmbeddedVideoImplementation["SRC_OBJECT"] = 1] = "SRC_OBJECT";
})($2a24a564c6953dcf$export$59a354bcfe78fe8 || ($2a24a564c6953dcf$export$59a354bcfe78fe8 = {}));
let $2a24a564c6953dcf$export$4882ae973e0491e = {
    deviceMotionMutliplier: -1,
    blacklisted: false,
    showGyroPermissionsWarningIfNecessary: false,
    showSafariPermissionsResetIfNecessary: false,
    requestHighFrameRate: false,
    videoWidth: 640,
    videoHeight: 480,
    dataWidth: 320,
    dataHeight: 240,
    videoElementInDOM: false,
    preferMediaStreamTrackProcessorCamera: false,
    preferImageBitmapCamera: false,
    ios164CameraSelection: false,
    forceWindowOrientation: false
};
if (typeof window !== "undefined") {
    window["zeeProfile"] = $2a24a564c6953dcf$export$4882ae973e0491e;
    if (window.location.href.indexOf("_mstppipeline") >= 0) {
        console.log("Configuring for MSTP camera pipeline (if supported)");
        $2a24a564c6953dcf$export$4882ae973e0491e.preferMediaStreamTrackProcessorCamera = true;
    }
    if (window.location.href.indexOf("_imagebitmappipeline") >= 0) {
        console.log("Configuring for ImageBitmap camera pipeline (if supported)");
        $2a24a564c6953dcf$export$4882ae973e0491e.preferImageBitmapCamera = true;
    }
}
let $2a24a564c6953dcf$var$agent = new $gG43b.UAParser();
let $2a24a564c6953dcf$var$os = ($2a24a564c6953dcf$var$agent.getOS().name || "unknown").toLowerCase();
let $2a24a564c6953dcf$var$engine = ($2a24a564c6953dcf$var$agent.getEngine().name || "unknown").toLowerCase();
if ($2a24a564c6953dcf$var$engine === "webkit" && $2a24a564c6953dcf$var$os !== "ios") {
    $2a24a564c6953dcf$export$4882ae973e0491e.deviceMotionMutliplier = 1.0;
    if (typeof window !== "undefined" && window.orientation !== undefined) // iPad
    $2a24a564c6953dcf$var$iDevice("15.0");
}
if ($2a24a564c6953dcf$var$engine === "webkit" && $2a24a564c6953dcf$var$os === "ios") {
    $2a24a564c6953dcf$export$4882ae973e0491e.deviceMotionMutliplier = 1.0;
    const version = $2a24a564c6953dcf$var$agent.getOS().version || "15.0";
    $2a24a564c6953dcf$var$iDevice(version);
}
function $2a24a564c6953dcf$var$iDevice(version) {
    $2a24a564c6953dcf$export$4882ae973e0491e.forceWindowOrientation = true;
    let versionParts = version.split(".");
    if (versionParts.length >= 2) {
        const majorVersion = parseInt(versionParts[0]);
        const minorVersion = parseInt(versionParts[1]);
        if (majorVersion < 11 || majorVersion === 11 && minorVersion < 3) $2a24a564c6953dcf$export$4882ae973e0491e.blacklisted = true;
        if (majorVersion < 12 || majorVersion === 12 && minorVersion < 2) $2a24a564c6953dcf$export$4882ae973e0491e.videoElementInDOM = true;
        if (majorVersion === 12 && minorVersion >= 2 || majorVersion >= 13) $2a24a564c6953dcf$export$4882ae973e0491e.showGyroPermissionsWarningIfNecessary = true;
        if (majorVersion >= 13) $2a24a564c6953dcf$export$4882ae973e0491e.showSafariPermissionsResetIfNecessary = true;
        if ((majorVersion >= 12 && minorVersion > 1 || majorVersion >= 13) && navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().frameRate) {
            $2a24a564c6953dcf$export$4882ae973e0491e.requestHighFrameRate = true;
            if (majorVersion < 14) {
                // Avoid bug where iOS letterboxes 16:9 into 4:3 for high fps
                // Doesn't seem needed with newer versions of iOS, tested on 14.8.1 and 15.2
                $2a24a564c6953dcf$export$4882ae973e0491e.videoHeight = 360;
                $2a24a564c6953dcf$export$4882ae973e0491e.dataHeight = 180;
            }
        }
        if (majorVersion === 16 && minorVersion >= 4 || majorVersion > 16) $2a24a564c6953dcf$export$4882ae973e0491e.ios164CameraSelection = true;
    }
}


function $b64a7e1fb5f394c7$export$ca7f1c5c0280e0bf(params, screenWidth, screenHeight, near = 0.01, far = 100.0) {
    let cam_x = params[2] * 2;
    let cam_y = params[3] * 2;
    let projection = (0, $2edf3b5f20103352$exports).create();
    (0, $2edf3b5f20103352$exports).frustum(projection, near * (-0.5 - params[2]) / params[0], near * (cam_x - 0.5 - params[2]) / params[0], near * (cam_y - 0.5 - params[3]) / params[1], near * (-0.5 - params[3]) / params[1], near, far);
    // Flip camera y axis (before any other transformations) - converts from
    // the y axis downwards of the  tracking camera models to the y axis upwards
    // of rendering coordinate systems
    projection[4] *= -1;
    projection[5] *= -1;
    projection[6] *= -1;
    projection[7] *= -1;
    let mult = (0, $2edf3b5f20103352$exports).create();
    (0, $2edf3b5f20103352$exports).fromScaling(mult, [
        0.5 * cam_x,
        0.5 * cam_y,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, mult, projection);
    // If it's user facing or not doesn't matter here as long as we apply the same-but-opposite
    // rotation at the end of the function
    (0, $2edf3b5f20103352$exports).fromRotation(mult, $b64a7e1fb5f394c7$export$83fad53f837eba8e(false) * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, mult, projection);
    let vec = (0, $7aaf532207b60e73$exports).create();
    vec[0] = cam_x;
    vec[1] = cam_y;
    vec[2] = 0;
    (0, $7aaf532207b60e73$exports).transformMat4(vec, vec, mult);
    let absWidth = Math.abs(vec[0]);
    let absHeight = Math.abs(vec[1]);
    let scaleFactor = 1;
    if (absWidth / screenWidth > absHeight / screenHeight) scaleFactor = screenHeight / absHeight;
    else scaleFactor = screenWidth / absWidth;
    (0, $2edf3b5f20103352$exports).fromScaling(mult, [
        scaleFactor,
        scaleFactor,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, mult, projection);
    (0, $2edf3b5f20103352$exports).fromScaling(mult, [
        2 / screenWidth,
        2 / screenHeight,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, mult, projection);
    (0, $2edf3b5f20103352$exports).fromRotation(mult, $b64a7e1fb5f394c7$export$83fad53f837eba8e(false) * Math.PI / -180, [
        0,
        0,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(projection, projection, mult);
    return projection;
}
function $b64a7e1fb5f394c7$export$83fad53f837eba8e(isUserFacing) {
    if (window.screen.orientation && !(0, $2a24a564c6953dcf$export$4882ae973e0491e).forceWindowOrientation) switch(window.screen.orientation.type){
        case "portrait-primary":
            return isUserFacing ? 90 : 270;
        case "landscape-secondary":
            return 180;
        case "portrait-secondary":
            return isUserFacing ? 270 : 90;
        default:
            return 0;
    }
    else if (window.orientation !== undefined) switch(window.orientation){
        case 0:
            return isUserFacing ? 90 : 270;
        case 90:
            return 0;
        case 180:
            return isUserFacing ? 270 : 90;
        case -90:
            return 180;
    }
    return 0;
}



var $ef3859a96b6c3dd7$exports = {};

$parcel$export($ef3859a96b6c3dd7$exports, "messageManager", function () { return $ef3859a96b6c3dd7$export$40ec70640330196f; });
$parcel$export($ef3859a96b6c3dd7$exports, "launchWorker", function () { return $ef3859a96b6c3dd7$export$11afba88bcfa2040; });
class $c5055f0ec6e6358b$export$d61e24a684f9e51 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit() {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i]();
    }
}
class $c5055f0ec6e6358b$export$3371bf92c01fb88b {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a);
    }
}
class $c5055f0ec6e6358b$export$2432f79a777b511d {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b);
    }
}
class $c5055f0ec6e6358b$export$82c217a001e88885 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b, c) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b, c);
    }
}
class $c5055f0ec6e6358b$export$88bac6eca2b85ca9 {
    constructor(){
        this._funcs = [];
    }
    bind(f) {
        this._funcs.push(f);
    }
    unbind(f) {
        let indx = this._funcs.indexOf(f);
        if (indx > -1) this._funcs.splice(indx, 1);
    }
    emit(a, b, c, d, e) {
        for(var i = 0, total = this._funcs.length; i < total; i++)this._funcs[i](a, b, c, d, e);
    }
}


class $e13a517ef2f54098$export$7401c2b3ceaa2a5d {
    constructor(){
        this.onOutgoingMessage = new (0, $c5055f0ec6e6358b$export$d61e24a684f9e51)();
        this.onIncomingMessage = new (0, $c5055f0ec6e6358b$export$3371bf92c01fb88b)();
        this._outgoingMessages = [];
    }
    postIncomingMessage(msg) {
        this.onIncomingMessage.emit(msg);
    }
    postOutgoingMessage(msg, trans) {
        this._outgoingMessages.push({
            msg: msg,
            transferables: trans
        });
        this.onOutgoingMessage.emit();
    }
    getOutgoingMessages() {
        let ret = this._outgoingMessages;
        this._outgoingMessages = [];
        return ret;
    }
}


var $ef3859a96b6c3dd7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $ef3859a96b6c3dd7$export$40ec70640330196f = new (0, $e13a517ef2f54098$export$7401c2b3ceaa2a5d)();
var $a0cc0005b26fc7f9$exports = {};


var $1XyTv = parcelRequire("1XyTv");

let $a0cc0005b26fc7f9$var$url = $1XyTv.getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("8IdKL");
$a0cc0005b26fc7f9$exports = $e7768240e195dd6f$exports($a0cc0005b26fc7f9$var$url, $1XyTv.getOrigin($a0cc0005b26fc7f9$var$url), false);


var $023e38d02084faf2$exports = {};


$023e38d02084faf2$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("16oX0");


function $ef3859a96b6c3dd7$export$11afba88bcfa2040(worker) {
    return $ef3859a96b6c3dd7$var$__awaiter(this, void 0, void 0, function*() {
        if (!worker) worker = new Worker($a0cc0005b26fc7f9$exports);
        worker.postMessage({
            t: "wasm",
            url: new URL($023e38d02084faf2$exports).toString()
        });
        yield $ef3859a96b6c3dd7$var$waitForLoad(worker);
        function sendOutgoing() {
            let msgs = $ef3859a96b6c3dd7$export$40ec70640330196f.getOutgoingMessages();
            for (let msg of msgs)worker.postMessage(msg.msg, msg.transferables);
        }
        $ef3859a96b6c3dd7$export$40ec70640330196f.onOutgoingMessage.bind(sendOutgoing);
        sendOutgoing();
        worker.addEventListener("message", (evt)=>{
            $ef3859a96b6c3dd7$export$40ec70640330196f.postIncomingMessage(evt.data);
        });
    });
}
function $ef3859a96b6c3dd7$var$waitForLoad(w) {
    return new Promise((resolve)=>{
        let listener = (msg)=>{
            if (msg.data === "loaded") {
                w.removeEventListener("message", listener);
                resolve();
            }
        };
        w.addEventListener("message", listener);
    });
}


var $a38163fdf9bac037$exports = {};

$parcel$export($a38163fdf9bac037$exports, "permissionGrantedCamera", function () { return $a38163fdf9bac037$export$4bb09993846e9acf; });
$parcel$export($a38163fdf9bac037$exports, "permissionGrantedMotion", function () { return $a38163fdf9bac037$export$8ef5e97655361f65; });
$parcel$export($a38163fdf9bac037$exports, "permissionDeniedCamera", function () { return $a38163fdf9bac037$export$5867d9a17b50afa0; });
$parcel$export($a38163fdf9bac037$exports, "permissionDeniedMotion", function () { return $a38163fdf9bac037$export$fb47f4fbe41dd949; });
$parcel$export($a38163fdf9bac037$exports, "permissionDeniedAny", function () { return $a38163fdf9bac037$export$79205252f7c81bd7; });
$parcel$export($a38163fdf9bac037$exports, "permissionGrantedAll", function () { return $a38163fdf9bac037$export$672567c1c7f186ec; });
$parcel$export($a38163fdf9bac037$exports, "permissionRequestAll", function () { return $a38163fdf9bac037$export$4366b797ee910129; });
$parcel$export($a38163fdf9bac037$exports, "permissionRequestMotion", function () { return $a38163fdf9bac037$export$b90d6478d97704f1; });
$parcel$export($a38163fdf9bac037$exports, "permissionRequestCamera", function () { return $a38163fdf9bac037$export$5115e68f403cb5d9; });
$parcel$export($a38163fdf9bac037$exports, "permissionRequestUI", function () { return $a38163fdf9bac037$export$447cf121adb7b558; });
$parcel$export($a38163fdf9bac037$exports, "permissionDeniedUI", function () { return $a38163fdf9bac037$export$2e339b4d51173824; });

var $gG43b = parcelRequire("gG43b");
var $6c682cfa63642dd1$export$caa3e053e76e6c08;
(function(STRINGS) {
    STRINGS[STRINGS["PermissionTitle"] = 0] = "PermissionTitle";
    STRINGS[STRINGS["PermissionDescription"] = 1] = "PermissionDescription";
    STRINGS[STRINGS["PermissionButton"] = 2] = "PermissionButton";
})($6c682cfa63642dd1$export$caa3e053e76e6c08 || ($6c682cfa63642dd1$export$caa3e053e76e6c08 = {}));
function $6c682cfa63642dd1$var$parseLanguage(inp) {
    const [lang, locale] = inp.toLowerCase().split("-");
    return [
        lang,
        locale || ""
    ];
}
const [$6c682cfa63642dd1$var$lang, $6c682cfa63642dd1$var$locale] = $6c682cfa63642dd1$var$parseLanguage(navigator.language);
function $6c682cfa63642dd1$export$72451b88a72ad9c2(str) {
    switch($6c682cfa63642dd1$var$lang){
        case "es":
            switch(str){
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionTitle:
                    return "Ya casi...";
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionDescription:
                    return "Para brindar esta experiencia de realidad aumentada, necesitamos acceso a la c\xe1mara y los sensores de movimiento de su dispositivo.";
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionButton:
                    return "Permitir acceso";
            }
            break;
        case "de":
            switch(str){
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionTitle:
                    return "Fast am Ziel..";
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionDescription:
                    return "Um dir dieses Augmented Reality Erlebnis zu liefern, brauchen wir Zugriff auf die Kamera und Bewegungssensoren deines Ger\xe4tes.";
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionButton:
                    return "Gew\xe4hre Zugriff";
            }
            break;
        case "pt":
            switch(str){
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionTitle:
                    return "Est\xe1 quase!";
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionDescription:
                    return "Esta experi\xeancia de realidade aumentada precisa de acesso \xe0 c\xe2mera e aos sensores de movimento deste dispositivo.";
                case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionButton:
                    return "Permitir acesso";
            }
            break;
    }
    switch(str){
        case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionTitle:
            return "Almost there...";
        case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionDescription:
            return "In order to provide this augmented reality experience, we need access to your device's camera and motion sensors.";
        case $6c682cfa63642dd1$export$caa3e053e76e6c08.PermissionButton:
            return "Grant Access";
    }
    return "";
}


var $a38163fdf9bac037$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $a38163fdf9bac037$var$parser = new (0, $gG43b.UAParser)();
let $a38163fdf9bac037$var$_permissionGrantedCamera = false;
let $a38163fdf9bac037$var$_permissionGrantedMotion = false;
let $a38163fdf9bac037$var$_permissionDeniedCamera = false;
let $a38163fdf9bac037$var$_permissionDeniedMotion = false;
if (!window.DeviceOrientationEvent || !window.DeviceOrientationEvent.requestPermission) $a38163fdf9bac037$var$_permissionGrantedMotion = true;
function $a38163fdf9bac037$var$checkForCameraPermission() {
    return $a38163fdf9bac037$var$__awaiter(this, void 0, void 0, function*() {
        if (navigator.permissions && navigator.permissions.query) try {
            let res = yield navigator.permissions.query({
                name: "camera"
            });
            $a38163fdf9bac037$var$_permissionDeniedCamera = res.state === "denied";
            $a38163fdf9bac037$var$_permissionGrantedCamera = res.state === "granted";
        } catch (ex) {}
    });
}
$a38163fdf9bac037$var$checkForCameraPermission();
function $a38163fdf9bac037$export$4bb09993846e9acf() {
    return $a38163fdf9bac037$var$_permissionGrantedCamera;
}
function $a38163fdf9bac037$export$8ef5e97655361f65() {
    return $a38163fdf9bac037$var$_permissionGrantedMotion;
}
function $a38163fdf9bac037$export$5867d9a17b50afa0() {
    return $a38163fdf9bac037$var$_permissionDeniedCamera;
}
function $a38163fdf9bac037$export$fb47f4fbe41dd949() {
    return $a38163fdf9bac037$var$_permissionDeniedMotion;
}
function $a38163fdf9bac037$export$79205252f7c81bd7() {
    return $a38163fdf9bac037$var$_permissionDeniedCamera || $a38163fdf9bac037$var$_permissionDeniedMotion;
}
function $a38163fdf9bac037$export$672567c1c7f186ec() {
    return $a38163fdf9bac037$var$_permissionGrantedCamera && $a38163fdf9bac037$var$_permissionGrantedMotion;
}
function $a38163fdf9bac037$export$4366b797ee910129() {
    return $a38163fdf9bac037$var$__awaiter(this, void 0, void 0, function*() {
        yield $a38163fdf9bac037$export$b90d6478d97704f1();
        yield $a38163fdf9bac037$export$5115e68f403cb5d9();
    });
}
function $a38163fdf9bac037$export$5115e68f403cb5d9() {
    return $a38163fdf9bac037$var$__awaiter(this, void 0, void 0, function*() {
        try {
            let res = yield navigator.mediaDevices.getUserMedia({
                video: true
            });
            let tracks = res.getTracks();
            tracks.forEach((t)=>t.stop());
            $a38163fdf9bac037$var$_permissionGrantedCamera = true;
            $a38163fdf9bac037$var$_permissionDeniedCamera = false;
        } catch (err) {
            $a38163fdf9bac037$var$_permissionGrantedCamera = false;
            $a38163fdf9bac037$var$_permissionDeniedCamera = true;
        }
    });
}
function $a38163fdf9bac037$export$b90d6478d97704f1() {
    return $a38163fdf9bac037$var$__awaiter(this, void 0, void 0, function*() {
        if (window.DeviceOrientationEvent && window.DeviceOrientationEvent.requestPermission) {
            let permissionResult = yield window.DeviceOrientationEvent.requestPermission();
            if (permissionResult !== "granted") {
                $a38163fdf9bac037$var$_permissionGrantedMotion = false;
                $a38163fdf9bac037$var$_permissionDeniedMotion = true;
                return false;
            }
        }
        // No motion permissions or granted
        $a38163fdf9bac037$var$_permissionGrantedMotion = true;
        $a38163fdf9bac037$var$_permissionDeniedMotion = false;
    });
}
function $a38163fdf9bac037$export$447cf121adb7b558() {
    return $a38163fdf9bac037$var$__awaiter(this, void 0, void 0, function*() {
        yield $a38163fdf9bac037$var$checkForCameraPermission();
        if ($a38163fdf9bac037$export$672567c1c7f186ec()) return true;
        let div = document.createElement("div");
        div.classList.add("zappar-permission-request");
        div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            max-width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">${(0, $6c682cfa63642dd1$export$72451b88a72ad9c2)((0, $6c682cfa63642dd1$export$caa3e053e76e6c08).PermissionTitle)}</div>
        <div class="zappar-text">${(0, $6c682cfa63642dd1$export$72451b88a72ad9c2)((0, $6c682cfa63642dd1$export$caa3e053e76e6c08).PermissionDescription)}</div>
        <button id="zappar-permission-request-button">${(0, $6c682cfa63642dd1$export$72451b88a72ad9c2)((0, $6c682cfa63642dd1$export$caa3e053e76e6c08).PermissionButton)}</button>
    </div>
`;
        document.body.append(div);
        let button = div.querySelector("#zappar-permission-request-button");
        return yield new Promise((resolve)=>{
            button === null || button === void 0 || button.addEventListener("click", ()=>$a38163fdf9bac037$var$__awaiter(this, void 0, void 0, function*() {
                    yield $a38163fdf9bac037$export$4366b797ee910129();
                    div.remove();
                    while(true){
                        yield $a38163fdf9bac037$var$nextFrame();
                        if ($a38163fdf9bac037$export$79205252f7c81bd7()) {
                            resolve(false);
                            return;
                        }
                        if ($a38163fdf9bac037$export$672567c1c7f186ec()) {
                            resolve(true);
                            return;
                        }
                    }
                }));
        });
    });
}
function $a38163fdf9bac037$var$nextFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}
function $a38163fdf9bac037$export$2e339b4d51173824() {
    switch($a38163fdf9bac037$var$parser.getBrowser().name){
        case "Chrome":
            $a38163fdf9bac037$var$permissionDeniedUIChrome();
            break;
        default:
            $a38163fdf9bac037$var$permissionDeniedUIIOS();
            break;
    }
}
function $a38163fdf9bac037$var$permissionDeniedUIIOS() {
    let div = document.createElement("div");
    div.classList.add("zappar-permission-request");
    div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            max-width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">Permission is Needed</div>
        <div class="zappar-text">Permission to access your device's camera and motion sensors is necessary for this experience. Please reload the page to try again.</div>
        <button id="zappar-permission-reload-button">Reload</button>
    </div>
`;
    document.body.append(div);
    let button = div.querySelector("#zappar-permission-reload-button");
    button === null || button === void 0 || button.addEventListener("click", ()=>window.location.reload());
}
function $a38163fdf9bac037$var$permissionDeniedUIChrome() {
    let div = document.createElement("div");
    div.classList.add("zappar-permission-request");
    div.innerHTML = `
    <style>
        .zappar-permission-request {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.9);
            font-family: sans-serif;
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .zappar-inner {
            width: 400px;
            text-align: center;
        }
        .zappar-title {
            font-size: 20px;
        }
        .zappar-text {
            font-size: 14px;
            padding: 15px;
        }
        .zappar-inner > button {
            background: none;
            outline: none;
            border: 2px solid white;
            border-radius: 10px;
            color: white;
            padding: 10px 40px;
            text-transform: uppercase;
        }
    </style>
    <div class="zappar-inner">
        <div class="zappar-title">Permission is Needed</div>
        <div class="zappar-text">Permission to access your device's camera and motion sensors is necessary for this experience.<br/><br/>To grant access, please tap the ! button in the address bar of your browser, then "Site settings", and finally "Clear and reset". You can then reload the page to try again.</div>
        <button id="zappar-permission-reload-button">Reload</button>
    </div>
`;
    document.body.append(div);
    let button = div.querySelector("#zappar-permission-reload-button");
    button === null || button === void 0 || button.addEventListener("click", ()=>window.location.reload());
}




let $46062ba68c57c43e$var$logLevel = (0, $adda256f81190c7f$export$3c7fce2c49a05698).LOG_LEVEL_ERROR;
function $46062ba68c57c43e$export$c622e99c0ce7b1c9(l) {
    $46062ba68c57c43e$var$logLevel = l;
}
function $46062ba68c57c43e$export$454156e929b28fe7(...args) {
    if ($46062ba68c57c43e$var$logLevel >= (0, $adda256f81190c7f$export$3c7fce2c49a05698).LOG_LEVEL_VERBOSE) console.log("[Zappar] INFO", ...args);
}
function $46062ba68c57c43e$export$497c45d0bfe56de1(...args) {
    if ($46062ba68c57c43e$var$logLevel >= (0, $adda256f81190c7f$export$3c7fce2c49a05698).LOG_LEVEL_ERROR) console.error("[Zappar] ERROR", ...args);
}
function $46062ba68c57c43e$export$79a36c979e81230e(...args) {
    if ($46062ba68c57c43e$var$logLevel >= (0, $adda256f81190c7f$export$3c7fce2c49a05698).LOG_LEVEL_VERBOSE) console.log("[Zappar] WARN", ...args);
}


let $db4b46ac65f12ff1$var$latestFaceMesh = 1;
let $db4b46ac65f12ff1$var$faceMeshById = new Map();
function $db4b46ac65f12ff1$export$3a09cf4ac8b68494() {
    let ret = $db4b46ac65f12ff1$var$latestFaceMesh++;
    $db4b46ac65f12ff1$var$faceMeshById.set(ret, new $db4b46ac65f12ff1$export$1238420da3a0b20c());
    (0, $46062ba68c57c43e$export$454156e929b28fe7)("face_mesh_t initialized");
    return ret;
}
function $db4b46ac65f12ff1$export$eed3c787ca5a1447(m) {
    $db4b46ac65f12ff1$var$faceMeshById.delete(m);
}
function $db4b46ac65f12ff1$export$139ac0d2bb1e45ec(m) {
    return $db4b46ac65f12ff1$var$faceMeshById.get(m);
}
class $db4b46ac65f12ff1$export$1238420da3a0b20c {
    constructor(){
        this.render_mean_ = new Float32Array();
        this.render_identity_ = new Float32Array(50);
        this.render_expression_ = new Float32Array(29);
        this.render_uvs_ = new Float32Array();
        this.render_indices_ = new Uint16Array();
        this.vertices_ = new Float32Array();
        this.normals_ = new Float32Array();
        this.normalsCalculated_ = false;
        this.modelVersion_ = -1;
        this.mirrored_ = false;
    }
    loadFromMemory(ab, fillMouth, fillEyeL, fillEyeR, fillNeck) {
        let offset = 0;
        let uint16View = new Uint16Array(ab);
        let intView = new Int32Array(ab);
        let floatView = new Float32Array(ab);
        let readMatrix = ()=>{
            let nr = intView[offset++];
            let nc = intView[offset++];
            let size = nr * nc;
            let ret = floatView.subarray(offset, offset + size);
            offset += size;
            return ret;
        };
        let readShortVector = ()=>{
            let size = intView[offset++];
            let ret = uint16View.subarray(offset * 2, offset * 2 + size);
            offset += size / 2;
            return ret;
        };
        this.render_mean_ = readMatrix();
        this.render_identity_ = readMatrix();
        this.render_expression_ = readMatrix();
        this.render_uvs_ = readMatrix();
        let baseIndices = readShortVector();
        let mouthIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let leftEyeIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let rightEyeIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        let neckIndices = offset < intView.length ? readShortVector() : new Uint16Array();
        if (!fillMouth && !fillEyeL && !fillEyeR && !fillNeck) this.render_indices_ = baseIndices;
        else {
            let sizeRequired = baseIndices.length;
            if (fillMouth) sizeRequired += mouthIndices.length;
            if (fillEyeL) sizeRequired += leftEyeIndices.length;
            if (fillEyeR) sizeRequired += rightEyeIndices.length;
            if (fillNeck) sizeRequired += neckIndices.length;
            this.render_indices_ = new Uint16Array(sizeRequired);
            this.render_indices_.set(baseIndices, 0);
            let indx = baseIndices.length;
            if (fillMouth) {
                this.render_indices_.set(mouthIndices, indx);
                indx += mouthIndices.length;
            }
            if (fillEyeL) {
                this.render_indices_.set(leftEyeIndices, indx);
                indx += leftEyeIndices.length;
            }
            if (fillEyeR) {
                this.render_indices_.set(rightEyeIndices, indx);
                indx += rightEyeIndices.length;
            }
            if (fillNeck) {
                this.render_indices_.set(neckIndices, indx);
                indx += neckIndices.length;
            }
        }
        this.vertices_ = new Float32Array(this.render_mean_);
        this.normals_ = new Float32Array(this.vertices_.length);
        this.modelVersion_++;
    }
    getVertices() {
        return this.vertices_;
    }
    getUVs() {
        return this.render_uvs_;
    }
    getIndices() {
        if (this.mirrored_) {
            if (!this.render_indices_reversed) {
                this.render_indices_reversed = new Uint16Array(this.render_indices_.length);
                for(let i = 0; i < this.render_indices_.length; i += 3){
                    this.render_indices_reversed[i] = this.render_indices_[i + 2];
                    this.render_indices_reversed[i + 1] = this.render_indices_[i + 1];
                    this.render_indices_reversed[i + 2] = this.render_indices_[i];
                }
            }
            return this.render_indices_reversed;
        }
        return this.render_indices_;
    }
    getNormals() {
        if (!this.normalsCalculated_) this.calculateNormals();
        return this.normals_;
    }
    getModelVersion() {
        return this.modelVersion_;
    }
    getLandmarkDataForVertex(v) {
        let mean = [
            this.render_mean_[v * 3],
            this.render_mean_[v * 3 + 1],
            this.render_mean_[v * 3 + 2]
        ];
        let identity = [];
        for(let i = 0; i < 50; i++)identity.push(this.render_identity_[v * 150 + i]), identity.push(this.render_identity_[(v * 3 + 1) * 50 + i]), identity.push(this.render_identity_[(v * 3 + 2) * 50 + i]);
        let expression = [];
        for(let i = 0; i < 29; i++)expression.push(this.render_expression_[v * 87 + i]), expression.push(this.render_expression_[(v * 3 + 1) * 29 + i]), expression.push(this.render_expression_[(v * 3 + 2) * 29 + i]);
        return {
            mean: mean,
            identity: identity,
            expression: expression
        };
    }
    update(identity, expression, mirrored) {
        if (this.render_mean_.length === 0) return;
        if (this.render_identity_.length === 0) return;
        if (this.render_expression_.length === 0) return;
        this.mirrored_ = mirrored;
        this.vertices_.set(this.render_mean_);
        for(let i = 0; i < identity.length; i++)for(let j = 0; j < this.vertices_.length; j++)this.vertices_[j] += identity[i] * this.render_identity_[j * identity.length + i];
        for(let i = 0; i < expression.length; i++)for(let j = 0; j < this.vertices_.length; j++)this.vertices_[j] += expression[i] * this.render_expression_[j * expression.length + i];
        if (mirrored) for(let j = 0; j < this.vertices_.length; j += 3)this.vertices_[j] *= -1;
        this.normalsCalculated_ = false;
    }
    calculateNormals() {
        let indices = this.getIndices();
        let vertices = this.vertices_;
        let faceNormals = new Float32Array(indices.length);
        if (!vertices) return;
        let size = indices.length;
        let normals = this.normals_;
        let v = new Float32Array([
            0,
            0,
            0
        ]);
        let w = new Float32Array([
            0,
            0,
            0
        ]);
        let out = new Float32Array([
            0,
            0,
            0
        ]);
        for(let i = 0; i < size; i += 3){
            let vertexStart0 = indices[i] * 3;
            let vertexStart1 = indices[i + 1] * 3;
            let vertexStart2 = indices[i + 2] * 3;
            v[0] = vertices[vertexStart1] - vertices[vertexStart0];
            v[1] = vertices[vertexStart1 + 1] - vertices[vertexStart0 + 1];
            v[2] = vertices[vertexStart1 + 2] - vertices[vertexStart0 + 2];
            w[0] = vertices[vertexStart2] - vertices[vertexStart0];
            w[1] = vertices[vertexStart2 + 1] - vertices[vertexStart0 + 1];
            w[2] = vertices[vertexStart2 + 2] - vertices[vertexStart0 + 2];
            (0, $7aaf532207b60e73$exports).cross(out, v, w);
            let length = (0, $7aaf532207b60e73$exports).length(out);
            faceNormals[i] = out[0] / length;
            faceNormals[i + 1] = out[1] / length;
            faceNormals[i + 2] = out[2] / length;
        }
        normals.fill(0);
        for(let i = 0; i < size; i += 3){
            let vertexStart0 = indices[i] * 3;
            let vertexStart1 = indices[i + 1] * 3;
            let vertexStart2 = indices[i + 2] * 3;
            normals[vertexStart0] += faceNormals[i];
            normals[vertexStart0 + 1] += faceNormals[i + 1];
            normals[vertexStart0 + 2] += faceNormals[i + 2];
            normals[vertexStart1] += faceNormals[i];
            normals[vertexStart1 + 1] += faceNormals[i + 1];
            normals[vertexStart1 + 2] += faceNormals[i + 2];
            normals[vertexStart2] += faceNormals[i];
            normals[vertexStart2 + 1] += faceNormals[i + 1];
            normals[vertexStart2 + 2] += faceNormals[i + 2];
        }
        let numberNormals = normals.length / 3;
        for(let i = 0; i < numberNormals; i++){
            let indx = i * 3;
            v[0] = normals[indx];
            v[1] = normals[indx + 1];
            v[2] = normals[indx + 2];
            (0, $7aaf532207b60e73$exports).normalize(w, v);
            normals[indx] = w[0];
            normals[indx + 1] = w[1];
            normals[indx + 2] = w[2];
        }
        this.normalsCalculated_ = true;
    }
}





let $59c5678f95fa53ad$var$identity = (0, $2edf3b5f20103352$exports).create();
class $59c5678f95fa53ad$export$65ee3277a9a1612d {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        this._vbo = undefined;
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._shader = undefined;
    }
    _generate(gl, i) {
        if (this._vbo) return this._vbo;
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        let vboData = new Float32Array([
            -1,
            -1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            1,
            1,
            -1,
            0,
            1,
            0,
            1,
            -1,
            0,
            1,
            0,
            -1,
            1,
            0,
            0,
            1,
            1,
            1,
            0,
            1,
            1
        ]);
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vboData), gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    drawCameraFrame(screenWidth, screenHeight, i, mirror) {
        if (!i.texture) return;
        let gl = this._gl;
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.BLEND);
        let shader = this._getCameraShader(gl);
        let vbo = this._generate(gl, i);
        gl.activeTexture(gl.TEXTURE0);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_skinTexTransform, false, $59c5678f95fa53ad$export$3da067886124f338(i.dataWidth, i.dataHeight, screenWidth, screenHeight, i.uvTransform || $59c5678f95fa53ad$var$identity, mirror));
        gl.uniform1i(shader.unif_skinSampler, 0);
        gl.bindTexture(gl.TEXTURE_2D, i.texture);
        gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 20, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.vertexAttribPointer(shader.attr_texCoord, 2, gl.FLOAT, false, 20, 12);
        gl.enableVertexAttribArray(shader.attr_texCoord);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_texCoord);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.useProgram(null);
    }
    _getCameraShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $59c5678f95fa53ad$var$vertexShaderSrc);
        let fragmentShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $59c5678f95fa53ad$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $2855ef2b305ce725$export$d879afae78b531a5)(gl, prog);
        let unif_skinTexTransform = gl.getUniformLocation(prog, "skinTexTransform");
        if (!unif_skinTexTransform) throw new Error("Unable to get uniform location skinTexTransform");
        let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
        if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
        this._shader = {
            prog: prog,
            unif_skinTexTransform: unif_skinTexTransform,
            unif_skinSampler: unif_skinSampler,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_texCoord: gl.getAttribLocation(prog, "texCoord")
        };
        return this._shader;
    }
}
let $59c5678f95fa53ad$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

attribute vec4 position;
attribute vec4 texCoord;
varying vec4 skinTexVarying;
uniform mat4 skinTexTransform;

void main()
{
    gl_Position = position;
    skinTexVarying = skinTexTransform * texCoord;
}`;
let $59c5678f95fa53ad$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying vec4 skinTexVarying;
uniform lowp sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2DProj(skinSampler, skinTexVarying);
}`;
function $59c5678f95fa53ad$var$cameraRotationForScreenOrientation() {
    if (window.screen.orientation && !(0, $2a24a564c6953dcf$export$4882ae973e0491e).forceWindowOrientation) switch(window.screen.orientation.type){
        case "portrait-primary":
            return 270;
        case "landscape-secondary":
            return 180;
        case "portrait-secondary":
            return 90;
        default:
            return 0;
    }
    else if (window.orientation !== undefined) switch(window.orientation){
        case 0:
            return 270;
        case 90:
            return 0;
        case 180:
            return 90;
        case -90:
            return 180;
    }
    return 0;
}
function $59c5678f95fa53ad$export$3da067886124f338(frameWidth, frameHeight, screenWidth, screenHeight, uvMatrix, mirror) {
    let ret = (0, $2edf3b5f20103352$exports).create();
    let trans = (0, $2edf3b5f20103352$exports).create();
    // Translate to centre UV coords
    (0, $2edf3b5f20103352$exports).fromTranslation(trans, [
        -0.5,
        -0.5,
        0
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    if (mirror) {
        (0, $2edf3b5f20103352$exports).fromScaling(trans, [
            -1,
            1,
            1
        ]);
        (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    }
    // Apply rotation back into ZCV's landscape space
    (0, $2edf3b5f20103352$exports).fromRotation(trans, -1 * $59c5678f95fa53ad$var$cameraRotationForScreenOrientation() * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    // Get our screenWidth and screenHeight into that same space
    let vec = (0, $7aaf532207b60e73$exports).create();
    vec[0] = screenWidth;
    vec[1] = screenHeight;
    vec[2] = 0;
    (0, $7aaf532207b60e73$exports).transformMat4(vec, vec, trans);
    let absScreenX = Math.abs(vec[0]);
    let absScreenY = Math.abs(vec[1]);
    // Apply a flip since the texture is upside-down
    (0, $2edf3b5f20103352$exports).fromScaling(trans, [
        1,
        -1,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    // Apply cropping
    let screenAspect = absScreenX / absScreenY;
    let frameAspect = frameWidth / frameHeight;
    if (screenAspect > frameAspect) (0, $2edf3b5f20103352$exports).fromScaling(trans, [
        1,
        frameAspect / screenAspect,
        1
    ]);
    else (0, $2edf3b5f20103352$exports).fromScaling(trans, [
        screenAspect / frameAspect,
        1,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    // Translate back to UV coords
    (0, $2edf3b5f20103352$exports).fromTranslation(trans, [
        0.5,
        0.5,
        0
    ]);
    (0, $2edf3b5f20103352$exports).multiply(ret, trans, ret);
    // Apply the camera frame's UV matrix
    (0, $2edf3b5f20103352$exports).multiply(ret, uvMatrix, ret);
    return ret;
}





class $256ab20f08c41d94$export$884fb66b30975d12 {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._normalbo) this._gl.deleteBuffer(this._normalbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._normalbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateNormalBO(face, gl) {
        if (!this._normalbo) this._normalbo = gl.createBuffer();
        if (!this._normalbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._normalbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._normalbo;
    }
    drawFace(matrix, o) {
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(o.getVertices(), gl);
        let n = this._generateNormalBO(o.getNormals(), gl);
        let i = this._generateIBO(o.getIndices(), gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, n);
        gl.vertexAttribPointer(shader.attr_normal, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_normal);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, o.getIndices().length, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_normal);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $256ab20f08c41d94$var$vertexShaderSrc);
        let fragmentShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $256ab20f08c41d94$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $2855ef2b305ce725$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location mattrix");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_normal: gl.getAttribLocation(prog, "normal")
        };
        return this._shader;
    }
}
let $256ab20f08c41d94$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
attribute vec4 position;
attribute vec3 normal;
varying highp vec3 vnormal;

void main()
{
    gl_Position = matrix * position;
    vnormal = normal;
}`;
let $256ab20f08c41d94$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying vec4 skinTexVarying;
varying highp vec3 vnormal;
uniform lowp sampler2D skinSampler;

void main()
{
    vec3 normal2 = 0.5 * vnormal + 0.5;
    gl_FragColor = vec4(normal2.x , normal2.y, normal2.z, 1.0);
}`;



class $0da80bb9be0ee5cd$export$626d5c7c1d8c587c {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._uvbo) this._gl.deleteBuffer(this._uvbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._uvbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateUVBO(face, gl) {
        if (!this._uvbo) this._uvbo = gl.createBuffer();
        if (!this._uvbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._uvbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STREAM_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._uvbo;
    }
    drawFace(matrix, vertices, uvMatrix, uvs, indices, texture) {
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(vertices, gl);
        let u = this._generateUVBO(uvs, gl);
        let i = this._generateIBO(indices, gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        // gl.enable(gl.BLEND);
        // gl.blendFunc(gl.ONE, gl.ONE);
        // gl.blendEquation(gl.FUNC_SUBTRACT);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.uniformMatrix4fv(shader.unif_uvmatrix, false, uvMatrix);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.uniform1i(shader.unif_sampler, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, u);
        gl.vertexAttribPointer(shader.attr_uv, 3, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(shader.attr_uv);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, 6912, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_uv);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $0da80bb9be0ee5cd$var$vertexShaderSrc);
        let fragmentShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $0da80bb9be0ee5cd$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $2855ef2b305ce725$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location matrix");
        let unif_uvmatrix = gl.getUniformLocation(prog, "uvmatrix");
        if (!unif_uvmatrix) throw new Error("Unable to get uniform location matrix");
        let unif_sampler = gl.getUniformLocation(prog, "uSampler");
        if (!unif_sampler) throw new Error("Unable to get uniform location sampler");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            unif_sampler: unif_sampler,
            unif_uvmatrix: unif_uvmatrix,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_uv: gl.getAttribLocation(prog, "uv"),
            attr_texturecoord: gl.getAttribLocation(prog, "aTextureCoord")
        };
        return this._shader;
    }
}
let $0da80bb9be0ee5cd$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
uniform mat4 uvmatrix;
attribute vec4 position;
attribute vec3 normal;
attribute vec3 uv;

// varying highp vec3 vnormal;

varying highp vec2 vTextureCoord;
varying highp float vAlpha;

void main()
{
    gl_Position = matrix * position;
    vec4 ret = uvmatrix * vec4(uv.x, uv.y, uv.z, 1.0);
    ret.x /= ret.w * 2.0;
    ret.y /= ret.w * 2.0;
    ret.x += 0.5;
    ret.y += 0.0;
    vAlpha = 1.0;
    vTextureCoord = ret.xy;
}`;
let $0da80bb9be0ee5cd$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
varying highp vec3 vnormal;
varying highp float vAlpha;
uniform lowp sampler2D uSampler;

void main()
{
    // vec3 normal2 = 0.5 * vnormal + 0.5;
    vec4 p = texture2D(uSampler, vTextureCoord);
    p.a = vAlpha;
    gl_FragColor = p; // vec4(normal2.x , normal2.y, normal2.z, 1.0);
}`;






var $64e6deea2842fcd8$export$b970cf2e1a7b7c7b;
(function(SequenceRecorderPacketType) {
    SequenceRecorderPacketType[SequenceRecorderPacketType["CAMERA_FRAME"] = 0] = "CAMERA_FRAME";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ACCELEROMETER"] = 1] = "ACCELEROMETER";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ROTATION_RATE"] = 2] = "ROTATION_RATE";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ATTITUDE"] = 3] = "ATTITUDE";
    SequenceRecorderPacketType[SequenceRecorderPacketType["ATTITUDE_MATRIX"] = 4] = "ATTITUDE_MATRIX";
})($64e6deea2842fcd8$export$b970cf2e1a7b7c7b || ($64e6deea2842fcd8$export$b970cf2e1a7b7c7b = {}));
class $64e6deea2842fcd8$export$a9d7f366c6e802ee {
    constructor(estimatedFrames){
        this._insertionByte = 0;
        this._numberPackets = 0;
        this._started = false;
        this._hasLoggedUnsuppored = false;
        this._data = new ArrayBuffer(this._estimatedSize(estimatedFrames, 320, 240));
        this._dataView = new DataView(this._data);
        this._dataUint8 = new Uint8Array(this._data);
        this._dataFloat32 = new Float32Array(this._data);
    }
    _estimatedSize(frames, cameraFrameWidth, cameraFrameHeight) {
        return $64e6deea2842fcd8$export$a9d7f366c6e802ee.headerSizeBytes + ($64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType + $64e6deea2842fcd8$export$a9d7f366c6e802ee.cameraPacketSizeBytes + cameraFrameWidth * cameraFrameHeight) * frames;
    }
    start() {
        this._started = true;
        this._insertionByte = 0;
        this._numberPackets = 0;
        this._growArrayBuffer($64e6deea2842fcd8$export$a9d7f366c6e802ee.headerSizeBytes);
        let enc = new TextEncoder();
        let headerData = enc.encode("UAR1");
        this._dataUint8.set(headerData);
        this._dataView.setUint32(4, 0, true);
        this._insertionByte += 8;
    }
    stop() {
        this._started = false;
        let trimmed = this._data.slice(0, this._insertionByte);
        this._data = trimmed;
        this._dataUint8 = new Uint8Array(this._data);
        this._dataFloat32 = new Float32Array(this._data);
        this._dataView = new DataView(this._data);
    }
    data() {
        return this._dataUint8;
    }
    appendCameraFrame(c) {
        if (!this._started) return;
        if (!c.data) {
            if (this._hasLoggedUnsuppored) return;
            this._hasLoggedUnsuppored = true;
            (0, $46062ba68c57c43e$export$497c45d0bfe56de1)("Unable to record frames from this camera source");
            return;
        }
        if (c.data.byteLength !== c.dataWidth * c.dataHeight) {
            (0, $46062ba68c57c43e$export$497c45d0bfe56de1)("Unable to record frame to sequence: greyscale array doesn't match dimensions");
            return;
        }
        let increment = $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType + $64e6deea2842fcd8$export$a9d7f366c6e802ee.cameraPacketSizeBytes + c.dataWidth * c.dataHeight;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.CAMERA_FRAME, true);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType;
        this._dataView.setUint32(this._insertionByte, c.dataWidth, true);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraFrameWidth;
        this._dataView.setUint32(this._insertionByte, c.dataHeight, true);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraFrameHeight;
        this._dataFloat32.set(c.cameraToDevice, this._insertionByte / 4);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraToDeviceTransform;
        this._dataFloat32.set(c.cameraModel, this._insertionByte / 4);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraModel;
        this._dataView.setUint32(this._insertionByte, c.userFacing ? 1 : 0, true);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbFlags;
        this._dataUint8.set(new Uint8Array(c.data), this._insertionByte);
        this._insertionByte += c.data.byteLength;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    appendAccelerometer(t, x, y, z) {
        this._appendTimestampedVec3($64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ACCELEROMETER, t, x, y, z);
    }
    appendRotationRate(t, x, y, z) {
        this._appendTimestampedVec3($64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ROTATION_RATE, t, x, y, z);
    }
    appendAttitude(t, x, y, z) {
        this._appendTimestampedVec3($64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ATTITUDE, t, x, y, z);
    }
    _appendTimestampedVec3(type, t, x, y, z) {
        if (!this._started) return;
        let increment = $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType + $64e6deea2842fcd8$export$a9d7f366c6e802ee.accelerometerPacketSizeBytes;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, type, true);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType;
        this._dataView.setUint32(this._insertionByte, t, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, x, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, y, true);
        this._insertionByte += 4;
        this._dataView.setFloat32(this._insertionByte, z, true);
        this._insertionByte += 4;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    appendAttitudeMatrix(m) {
        if (!this._started) return;
        let increment = $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType + $64e6deea2842fcd8$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
        this._growArrayBuffer(increment);
        this._dataView.setUint32(this._insertionByte, $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX, true);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType;
        this._dataFloat32.set(m, this._insertionByte / 4);
        this._insertionByte += $64e6deea2842fcd8$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
        this._numberPackets++;
        this._dataView.setUint32(4, this._numberPackets, true);
    }
    _growArrayBuffer(requiredIncrement) {
        while(this._insertionByte + requiredIncrement > this._data.byteLength){
            let newSize = Math.max(this._data.byteLength * 2, this._estimatedSize(50, 320, 240));
            let newData = new ArrayBuffer(newSize);
            let newDataUint8 = new Uint8Array(newData);
            newDataUint8.set(this._dataUint8);
            this._data = newData;
            this._dataUint8 = newDataUint8;
            this._dataFloat32 = new Float32Array(this._data);
            this._dataView = new DataView(this._data);
        }
    }
}
// Header (8 bytes): "UAR1" + number of frames (uint32)
$64e6deea2842fcd8$export$a9d7f366c6e802ee.headerSizeBytes = 8;
// Per-frame packet byte sizes
$64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType = 4;
// Camera frames
$64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraFrameWidth = 4;
$64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraFrameHeight = 4;
$64e6deea2842fcd8$export$a9d7f366c6e802ee.psbFlags = 4;
$64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraToDeviceTransform = 64;
$64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraModel = 24;
$64e6deea2842fcd8$export$a9d7f366c6e802ee.cameraPacketSizeBytes = $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraFrameWidth + $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraFrameHeight + $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraToDeviceTransform + $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraModel + $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbFlags;
// Accelerometer
$64e6deea2842fcd8$export$a9d7f366c6e802ee.accelerometerPacketSizeBytes = 16; // t, x, y, z
// Rotation rate
$64e6deea2842fcd8$export$a9d7f366c6e802ee.rotationRatePacketSizeBytes = 16; // t, x, y, z
// Attitude
$64e6deea2842fcd8$export$a9d7f366c6e802ee.attitudePacketSizeBytes = 16; // t, x, y, z
// Attitude matrix
$64e6deea2842fcd8$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes = 64;
class $64e6deea2842fcd8$export$20801e67610bf5d8 {
    constructor(_data){
        this._data = _data;
        this.dataByPacket = new Map();
        this.dataByCameraFrame = new Map();
        this.numberPackets = 0;
        this.numberCameraFrames = 0;
        this.numberAccelerometerPackets = 0;
        this.numberRotationRatePackets = 0;
        this.numberAttitudePackets = 0;
        this.numberAttitudeMatrixPackets = 0;
        let dec = new TextDecoder();
        let txt = "";
        try {
            txt = dec.decode(this._data.slice(0, 4));
        } catch (err) {
            throw new Error("Unable to decode header - perhaps this isn't a sequence file?");
        }
        if (txt !== "UAR1") throw new Error(`Invalid - perhaps this isn't a sequence file: ${txt}`);
        let readPoint = 0;
        let dataView = new DataView(this._data);
        this.numberPackets = dataView.getUint32(4, true);
        readPoint += $64e6deea2842fcd8$export$a9d7f366c6e802ee.headerSizeBytes;
        for(let i = 0; i < this.numberPackets; i++){
            let type = dataView.getUint32(readPoint, true);
            readPoint += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbPacketType;
            switch(type){
                case $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.CAMERA_FRAME:
                    {
                        let width = dataView.getUint32(readPoint, true);
                        readPoint += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraFrameWidth;
                        let height = dataView.getUint32(readPoint, true);
                        readPoint += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraFrameHeight;
                        let cameraToDevice = new Float32Array(this._data, readPoint, $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraToDeviceTransform / 4);
                        readPoint += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraToDeviceTransform;
                        let cameraModel = new Float32Array(this._data, readPoint, $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraModel / 4);
                        readPoint += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbCameraModel;
                        let flags = dataView.getUint32(readPoint, true);
                        readPoint += $64e6deea2842fcd8$export$a9d7f366c6e802ee.psbFlags;
                        let userFacing = flags === 1;
                        let greyscale = new Uint8Array(this._data, readPoint, width * height);
                        readPoint += width * height;
                        let d = {
                            type: $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.CAMERA_FRAME,
                            width: width,
                            height: height,
                            cameraToDevice: cameraToDevice,
                            cameraModel: cameraModel,
                            userFacing: userFacing,
                            greyscale: greyscale
                        };
                        this.dataByPacket.set(i, d);
                        this.dataByCameraFrame.set(this.numberCameraFrames, d);
                        this.numberCameraFrames++;
                        break;
                    }
                case $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ACCELEROMETER:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ACCELEROMETER,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberAccelerometerPackets++;
                        break;
                    }
                case $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ROTATION_RATE:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ROTATION_RATE,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberRotationRatePackets++;
                        break;
                    }
                case $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ATTITUDE:
                    {
                        let t = dataView.getUint32(readPoint, true);
                        readPoint += 4;
                        let x = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let y = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        let z = dataView.getFloat32(readPoint, true);
                        readPoint += 4;
                        this.dataByPacket.set(i, {
                            type: $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ATTITUDE,
                            t: t,
                            x: x,
                            y: y,
                            z: z
                        });
                        this.numberAttitudePackets++;
                        break;
                    }
                case $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX:
                    {
                        let attitude = new Float32Array(this._data, readPoint, $64e6deea2842fcd8$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes / 4);
                        readPoint += $64e6deea2842fcd8$export$a9d7f366c6e802ee.attitudeMatrixPacketSizeBytes;
                        this.dataByPacket.set(i, {
                            type: $64e6deea2842fcd8$export$b970cf2e1a7b7c7b.ATTITUDE_MATRIX,
                            attitude: attitude
                        });
                        this.numberAttitudeMatrixPackets++;
                        break;
                    }
            }
        }
    }
}


var $9cbab9aac84784d2$exports = {};

$parcel$export($9cbab9aac84784d2$exports, "CameraSource", function () { return $9cbab9aac84784d2$export$9a93ce53f488cb2e; });

class $566bb64a761777a5$export$1d2df86270c81ecb {
}






const $d1fafd02223a2bd8$var$managers = new Map();
class $d1fafd02223a2bd8$export$6d8a7545b2cb2a7e {
    constructor(_gl){
        this._gl = _gl;
        this._viewports = [];
        this._underlyingViewport = this._gl.viewport;
        this._viewports.push(this._gl.getParameter(this._gl.VIEWPORT));
        this._gl.viewport = (x, y, width, height)=>{
            this._viewports[this._viewports.length - 1] = [
                x,
                y,
                width,
                height
            ];
            this._underlyingViewport.call(this._gl, x, y, width, height);
        };
    }
    static get(gl) {
        let existing = $d1fafd02223a2bd8$var$managers.get(gl);
        if (!existing) {
            existing = new $d1fafd02223a2bd8$export$6d8a7545b2cb2a7e(gl);
            $d1fafd02223a2bd8$var$managers.set(gl, existing);
        }
        return existing;
    }
    push() {
        this._viewports.push(this._viewports[this._viewports.length - 1]);
    }
    pop() {
        const current = this._viewports.pop();
        const prev = this._viewports[this._viewports.length - 1];
        if (!current || current[0] !== prev[0] || current[1] !== prev[1] || current[2] !== prev[2] || current[3] !== prev[3]) this._underlyingViewport.call(this._gl, prev[0], prev[1], prev[2], prev[3]);
    }
}




class $2cc2e1ec34bc3b5d$export$f9b0f8dc7af3bf20 {
    constructor(_gl){
        this._gl = _gl;
        this._isPaused = true;
        this._hadFrames = false;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._isUploadFrame = true;
        this._computedTransformRotation = -1;
        this._computedFrontCameraRotation = false;
        this._cameraUvTransform = (0, $2edf3b5f20103352$exports).create();
        this._framebufferWidth = 0;
        this._framebufferHeight = 0;
        this._framebufferId = null;
        this._renderTexture = null;
        this._isWebGL2 = false;
        this._isWebGL2 = _gl.getParameter(_gl.VERSION).indexOf("WebGL 2") >= 0;
        if (!this._isWebGL2) this._instancedArraysExtension = this._gl.getExtension("ANGLE_instanced_arrays");
    }
    resetGLContext() {
        this._framebufferId = null;
        this._renderTexture = null;
        this._vertexBuffer = undefined;
        this._indexBuffer = undefined;
        this._greyscaleShader = undefined;
    }
    destroy() {
        this.resetGLContext();
    }
    uploadFrame(texture, img, rotation, fc) {
        let gl = this._gl;
        const glStateManager = (0, $d1fafd02223a2bd8$export$6d8a7545b2cb2a7e).get(gl);
        glStateManager.push();
        const reenableScissorTest = gl.isEnabled(gl.SCISSOR_TEST);
        const reenableDepthTest = gl.isEnabled(gl.DEPTH_TEST);
        const reenableBlend = gl.isEnabled(gl.BLEND);
        const reenableCullFace = gl.isEnabled(gl.CULL_FACE);
        const reenableStencilTest = gl.isEnabled(gl.STENCIL_TEST);
        const previousActiveTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
        const previousUnpackFlip = gl.getParameter(gl.UNPACK_FLIP_Y_WEBGL);
        const previousProgram = gl.getParameter(gl.CURRENT_PROGRAM);
        gl.activeTexture(gl.TEXTURE0);
        const previousBoundTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
        const previousBoundFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
        const previousBoundArrayBuffer = gl.getParameter(gl.ARRAY_BUFFER_BINDING);
        const previousBoundElementArrayBuffer = gl.getParameter(gl.ELEMENT_ARRAY_BUFFER_BINDING);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.STENCIL_TEST);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const level = 0;
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, img);
        let videoWidth = 0;
        let videoHeight = 0;
        if (typeof HTMLVideoElement !== "undefined" && img instanceof HTMLVideoElement) {
            videoWidth = img.videoWidth;
            videoHeight = img.videoHeight;
        } else {
            videoWidth = img.width;
            videoHeight = img.height;
        }
        if (videoHeight > videoWidth) videoHeight = [
            videoWidth,
            videoWidth = videoHeight
        ][0];
        this._updateTransforms(rotation, fc);
        let framebuffer = this._getFramebuffer(gl, (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth / 4, (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataHeight);
        let vbo = this._getVertexBuffer(gl);
        let ibo = this._getIndexBuffer(gl);
        let shader = this._getGreyscaleShader(gl);
        const previousVertexAttribSize = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_SIZE);
        const previousVertexAttribType = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_TYPE);
        const previousVertexAttribNormalized = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_NORMALIZED);
        const previousVertexAttribStride = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_STRIDE);
        const previousVertexAttribOffset = gl.getVertexAttribOffset(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_POINTER);
        const previousVertexAttribEnabled = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
        const previousVertexAttribBufferBinding = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING);
        const previousTextureAttribSize = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_SIZE);
        const previousTextureAttribType = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_TYPE);
        const previousTextureAttribNormalized = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_NORMALIZED);
        const previousTextureAttribStride = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_STRIDE);
        const previousTextureAttribOffset = gl.getVertexAttribOffset(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_POINTER);
        const previousTextureAttribBufferBinding = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING);
        const previousTextureAttribEnabled = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
        let previousVertexAttribDivisor = 0;
        let previousTextureAttribDivisor = 0;
        if (this._isWebGL2) {
            previousVertexAttribDivisor = gl.getVertexAttrib(shader.aVertexPositionLoc, gl.VERTEX_ATTRIB_ARRAY_DIVISOR);
            previousTextureAttribDivisor = gl.getVertexAttrib(shader.aTextureCoordLoc, gl.VERTEX_ATTRIB_ARRAY_DIVISOR);
            gl.vertexAttribDivisor(shader.aVertexPositionLoc, 0);
            gl.vertexAttribDivisor(shader.aTextureCoordLoc, 0);
        } else if (this._instancedArraysExtension) {
            previousVertexAttribDivisor = gl.getVertexAttrib(shader.aVertexPositionLoc, this._instancedArraysExtension.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
            previousTextureAttribDivisor = gl.getVertexAttrib(shader.aTextureCoordLoc, this._instancedArraysExtension.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aVertexPositionLoc, 0);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aTextureCoordLoc, 0);
        }
        // Rendering to the greyscale conversion buffer - bind the framebuffer
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.viewport(0, 0, this._framebufferWidth, this._framebufferHeight);
        // We'll be replacing all the content - clear is a good hint for this on mobile
        gl.clear(gl.COLOR_BUFFER_BIT);
        // Set up bindings for vertex attributes
        gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
        gl.vertexAttribPointer(shader.aVertexPositionLoc, 2, gl.FLOAT, false, 16, 0);
        gl.enableVertexAttribArray(shader.aVertexPositionLoc);
        gl.vertexAttribPointer(shader.aTextureCoordLoc, 2, gl.FLOAT, false, 16, 8);
        gl.enableVertexAttribArray(shader.aTextureCoordLoc);
        // Bind the index buffer
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ibo);
        // Tell WebGL to use our program when drawing
        gl.useProgram(shader.program);
        // Specify greyscale width for the correct offsets, and the uv transform
        gl.uniform1f(shader.uTexWidthLoc, (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth);
        gl.uniformMatrix4fv(shader.uUvTransformLoc, false, this._cameraUvTransform);
        gl.activeTexture(gl.TEXTURE0);
        // Bind the texture to texture unit 0
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // Tell the shader we bound the texture to texture unit 0
        gl.uniform1i(shader.uSamplerLoc, 0);
        // Do the drawing...
        gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousVertexAttribBufferBinding);
        gl.vertexAttribPointer(shader.aVertexPositionLoc, previousVertexAttribSize, previousVertexAttribType, previousVertexAttribNormalized, previousVertexAttribStride, previousVertexAttribOffset);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousTextureAttribBufferBinding);
        gl.vertexAttribPointer(shader.aTextureCoordLoc, previousTextureAttribSize, previousTextureAttribType, previousTextureAttribNormalized, previousTextureAttribStride, previousTextureAttribOffset);
        gl.bindBuffer(gl.ARRAY_BUFFER, previousBoundArrayBuffer);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, previousBoundElementArrayBuffer);
        if (!previousVertexAttribEnabled) gl.disableVertexAttribArray(shader.aVertexPositionLoc);
        if (!previousTextureAttribEnabled) gl.disableVertexAttribArray(shader.aTextureCoordLoc);
        if (this._isWebGL2) {
            gl.vertexAttribDivisor(shader.aVertexPositionLoc, previousVertexAttribDivisor);
            gl.vertexAttribDivisor(shader.aTextureCoordLoc, previousTextureAttribDivisor);
        } else if (this._instancedArraysExtension) {
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aVertexPositionLoc, previousVertexAttribDivisor);
            this._instancedArraysExtension.vertexAttribDivisorANGLE(shader.aTextureCoordLoc, previousTextureAttribDivisor);
        }
        gl.bindFramebuffer(gl.FRAMEBUFFER, previousBoundFramebuffer);
        gl.useProgram(previousProgram);
        gl.bindTexture(gl.TEXTURE_2D, previousBoundTexture);
        gl.activeTexture(previousActiveTexture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, previousUnpackFlip);
        glStateManager.pop();
        if (reenableBlend) gl.enable(gl.BLEND);
        if (reenableCullFace) gl.enable(gl.CULL_FACE);
        if (reenableDepthTest) gl.enable(gl.DEPTH_TEST);
        if (reenableScissorTest) gl.enable(gl.SCISSOR_TEST);
        if (reenableStencilTest) gl.enable(gl.STENCIL_TEST);
    }
    readFrame(texture, pixels) {
        let gl = this._gl;
        let pixelsView = new Uint8Array(pixels);
        const previousBoundFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
        let framebuffer = this._getFramebuffer(gl, (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth / 4, (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataHeight);
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.readPixels(0, 0, this._framebufferWidth, this._framebufferHeight, gl.RGBA, gl.UNSIGNED_BYTE, pixelsView);
        gl.bindFramebuffer(gl.FRAMEBUFFER, previousBoundFramebuffer);
        return {
            uvTransform: this._cameraUvTransform,
            data: pixels,
            texture: texture,
            dataWidth: (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth,
            dataHeight: (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataHeight,
            userFacing: this._computedFrontCameraRotation
        };
    }
    _updateTransforms(rot, fc) {
        if (rot == this._computedTransformRotation && fc == this._computedFrontCameraRotation) return;
        this._computedTransformRotation = rot;
        this._computedFrontCameraRotation = fc;
        this._cameraUvTransform = this._getCameraUvTransform();
    }
    _getCameraUvTransform() {
        switch(this._computedTransformRotation){
            case 270:
                return new Float32Array([
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    1
                ]);
            case 180:
                return new Float32Array([
                    -1,
                    0,
                    0,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1
                ]);
            case 90:
                return new Float32Array([
                    0,
                    -1,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    1,
                    0,
                    1
                ]);
        }
        return new Float32Array([
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    _getFramebuffer(gl, fbWidth, fbHeight) {
        if (this._framebufferWidth === fbWidth && this._framebufferHeight === fbHeight && this._framebufferId) return this._framebufferId;
        if (this._framebufferId) {
            gl.deleteFramebuffer(this._framebufferId);
            this._framebufferId = null;
        }
        if (this._renderTexture) {
            gl.deleteTexture(this._renderTexture);
            this._renderTexture = null;
        }
        this._framebufferId = gl.createFramebuffer();
        if (!this._framebufferId) throw new Error("Unable to create framebuffer");
        gl.bindFramebuffer(gl.FRAMEBUFFER, this._framebufferId);
        this._renderTexture = gl.createTexture();
        if (!this._renderTexture) throw new Error("Unable to create render texture");
        gl.activeTexture(gl.TEXTURE0);
        const previousBoundTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
        gl.bindTexture(gl.TEXTURE_2D, this._renderTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, fbWidth, fbHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameterf(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this._renderTexture, 0);
        let fbStatus = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
        if (fbStatus !== gl.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer not complete: " + fbStatus.toString());
        this._framebufferWidth = fbWidth;
        this._framebufferHeight = fbHeight;
        gl.bindTexture(gl.TEXTURE_2D, previousBoundTexture);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        return this._framebufferId;
    }
    _getVertexBuffer(gl) {
        if (this._vertexBuffer) return this._vertexBuffer;
        this._vertexBuffer = gl.createBuffer();
        if (!this._vertexBuffer) throw new Error("Unable to create vertex buffer");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vertexBuffer);
        let buffer = new Float32Array([
            -1,
            -1,
            0.0,
            0.0,
            -1,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            -1,
            1.0,
            0.0
        ]);
        gl.bufferData(gl.ARRAY_BUFFER, buffer, gl.STATIC_DRAW);
        return this._vertexBuffer;
    }
    _getIndexBuffer(gl) {
        if (this._indexBuffer) return this._indexBuffer;
        this._indexBuffer = gl.createBuffer();
        if (!this._indexBuffer) throw new Error("Unable to create index buffer");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._indexBuffer);
        let buffer = new Uint16Array([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, buffer, gl.STATIC_DRAW);
        return this._indexBuffer;
    }
    _getGreyscaleShader(gl) {
        if (this._greyscaleShader) return this._greyscaleShader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $2cc2e1ec34bc3b5d$var$greyscaleVsSource);
        let fragmentShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $2cc2e1ec34bc3b5d$var$greyscaleFsSource);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $2855ef2b305ce725$export$d879afae78b531a5)(gl, prog);
        let uTexWidthLoc = gl.getUniformLocation(prog, "uTexWidth");
        if (!uTexWidthLoc) throw new Error("Unable to get uniform location uTexWidth");
        let uUvTransformLoc = gl.getUniformLocation(prog, "uUvTransform");
        if (!uUvTransformLoc) throw new Error("Unable to get uniform location uUvTransform");
        let uSamplerLoc = gl.getUniformLocation(prog, "uSampler");
        if (!uSamplerLoc) throw new Error("Unable to get uniform location uSampler");
        this._greyscaleShader = {
            program: prog,
            aVertexPositionLoc: gl.getAttribLocation(prog, "aVertexPosition"),
            aTextureCoordLoc: gl.getAttribLocation(prog, "aTextureCoord"),
            uTexWidthLoc: uTexWidthLoc,
            uUvTransformLoc: uUvTransformLoc,
            uSamplerLoc: uSamplerLoc
        };
        return this._greyscaleShader;
    }
}
let $2cc2e1ec34bc3b5d$var$greyscaleVsSource = `
    attribute vec4 aVertexPosition;
    attribute vec2 aTextureCoord;

    varying highp vec2 vTextureCoord1;
    varying highp vec2 vTextureCoord2;
    varying highp vec2 vTextureCoord3;
    varying highp vec2 vTextureCoord4;

    uniform float uTexWidth;
	uniform mat4 uUvTransform;

    void main(void) {
      highp vec2 offset1 = vec2(1.5 / uTexWidth, 0);
      highp vec2 offset2 = vec2(0.5 / uTexWidth, 0);

      gl_Position = aVertexPosition;
      vTextureCoord1 = (uUvTransform * vec4(aTextureCoord - offset1, 0, 1)).xy;
      vTextureCoord2 = (uUvTransform * vec4(aTextureCoord - offset2, 0, 1)).xy;
      vTextureCoord3 = (uUvTransform * vec4(aTextureCoord + offset2, 0, 1)).xy;
      vTextureCoord4 = (uUvTransform * vec4(aTextureCoord + offset1, 0, 1)).xy;
    }
`;
// Fragment shader program
let $2cc2e1ec34bc3b5d$var$greyscaleFsSource = `
  varying highp vec2 vTextureCoord1;
  varying highp vec2 vTextureCoord2;
  varying highp vec2 vTextureCoord3;
  varying highp vec2 vTextureCoord4;

  uniform sampler2D uSampler;

  const lowp vec3 colorWeights = vec3(77.0 / 256.0, 150.0 / 256.0, 29.0 / 256.0);

  void main(void) {
    lowp vec4 outpx;

    outpx.r = dot(colorWeights, texture2D(uSampler, vTextureCoord1).xyz);
    outpx.g = dot(colorWeights, texture2D(uSampler, vTextureCoord2).xyz);
    outpx.b = dot(colorWeights, texture2D(uSampler, vTextureCoord3).xyz);
    outpx.a = dot(colorWeights, texture2D(uSampler, vTextureCoord4).xyz);

    gl_FragColor = outpx;
  }
`;


let $2be767d2fbd2d81c$var$latest = 1;
let $2be767d2fbd2d81c$var$byId = new Map();
class $2be767d2fbd2d81c$export$bbfb48c500076b66 extends (0, $566bb64a761777a5$export$1d2df86270c81ecb) {
    constructor(_video, _pipeline){
        super();
        this._video = _video;
        this._pipeline = _pipeline;
        this._isPaused = true;
        this._hadFrames = false;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._isUploadFrame = true;
        this._cameraToDeviceTransform = (0, $2edf3b5f20103352$exports).create();
        this._cameraToDeviceTransformUserFacing = (0, $2edf3b5f20103352$exports).create();
        this._cameraModel = new Float32Array([
            300,
            300,
            160,
            120,
            0,
            0
        ]);
        (0, $2edf3b5f20103352$exports).fromScaling(this._cameraToDeviceTransformUserFacing, [
            -1,
            1,
            -1
        ]);
        let video = this._video;
        if (this._video instanceof HTMLVideoElement) video.addEventListener("loadedmetadata", ()=>{
            this._hadFrames = true;
        });
        else this._hadFrames = true;
        this._resetGLContext = this._resetGLContext.bind(this);
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p) p.onGLContextReset.bind(this._resetGLContext);
    }
    static createVideoElementSource(p, element) {
        let ret = $2be767d2fbd2d81c$var$latest++;
        $2be767d2fbd2d81c$var$byId.set(ret, new $2be767d2fbd2d81c$export$bbfb48c500076b66(element, p));
        (0, $46062ba68c57c43e$export$454156e929b28fe7)("html_element_source_t initialized");
        return ret;
    }
    static getVideoElementSource(m) {
        return $2be767d2fbd2d81c$var$byId.get(m);
    }
    _resetGLContext() {
        var _a, _b;
        this._currentVideoTexture = undefined;
        (_b = (_a = this._imageProcessor) === null || _a === void 0 ? void 0 : _a.resetGLContext) === null || _b === void 0 || _b.call(_a);
    }
    destroy() {
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p) p.onGLContextReset.unbind(this._resetGLContext);
        this.pause();
        this._resetGLContext();
    }
    pause() {
        this._isPaused = true;
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
    }
    start() {
        var _a;
        if (this._isPaused) {
            this._isUploadFrame = true;
            if (this._video instanceof HTMLVideoElement) this._hadFrames = false;
        }
        this._isPaused = false;
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
    }
    getFrame(currentlyProcessing) {
        let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let gl = pipeline.glContext;
        if (!gl) return;
        if (this._isPaused) return;
        if (!this._hadFrames) return;
        try {
            let info = this._processFrame(gl, this._cameraToScreenRotation, currentlyProcessing);
            if (info) {
                let token = pipeline.registerToken(info);
                pipeline.sendDataToWorker(info.data || new ArrayBuffer(0), token, info.dataWidth, info.dataHeight, info.userFacing, info.cameraToDevice, info.cameraModel);
            }
        } catch (ex) {
            console.log("Unable to process frame");
        }
        return;
    }
    _processFrame(gl, rotation, currentlyProcessing) {
        let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return undefined;
        if (!this._imageProcessor) this._imageProcessor = new (0, $2cc2e1ec34bc3b5d$export$f9b0f8dc7af3bf20)(gl);
        if (this._isUploadFrame) {
            if (!this._currentVideoTexture) this._currentVideoTexture = pipeline.getVideoTexture();
            if (!this._currentVideoTexture) return undefined;
            this._imageProcessor.uploadFrame(this._currentVideoTexture, this._video, rotation, this._isUserFacing);
            this._isUploadFrame = !this._isUploadFrame;
            return undefined;
        }
        if (currentlyProcessing || !this._currentVideoTexture) return undefined;
        this._isUploadFrame = !this._isUploadFrame;
        let greySize = (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth * (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataHeight;
        let pixels = pipeline.cameraPixelArrays.pop();
        while(pixels){
            if (pixels.byteLength === greySize) break;
            pixels = pipeline.cameraPixelArrays.pop();
        }
        if (!pixels) pixels = new ArrayBuffer(greySize);
        let tex = this._currentVideoTexture;
        this._currentVideoTexture = undefined;
        let focalLength = 300.0 * (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth / 320.0;
        this._cameraModel[0] = focalLength;
        this._cameraModel[1] = focalLength;
        this._cameraModel[2] = (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth * 0.5;
        this._cameraModel[3] = (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataHeight * 0.5;
        return Object.assign(Object.assign({}, this._imageProcessor.readFrame(tex, pixels)), {
            cameraModel: this._cameraModel,
            cameraSource: this,
            cameraToDevice: this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform
        });
    }
    uploadGL() {
    // No-op as already uploaded
    }
}







var $9cbab9aac84784d2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $9cbab9aac84784d2$var$_videoSingleton = document.createElement("video");
$9cbab9aac84784d2$var$_videoSingleton.setAttribute("playsinline", "");
$9cbab9aac84784d2$var$_videoSingleton.setAttribute("webkit-playsinline", "");
if ((0, $2a24a564c6953dcf$export$4882ae973e0491e).videoElementInDOM) {
    $9cbab9aac84784d2$var$_videoSingleton.style.width = "0px";
    $9cbab9aac84784d2$var$_videoSingleton.style.height = "0px";
    document.body.appendChild($9cbab9aac84784d2$var$_videoSingleton);
}
class $9cbab9aac84784d2$export$9a93ce53f488cb2e extends (0, $2be767d2fbd2d81c$export$bbfb48c500076b66) {
    constructor(_impl, pipeline, _deviceId){
        super($9cbab9aac84784d2$var$_videoSingleton, pipeline);
        this._impl = _impl;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
    }
    destroy() {
        (0, $72f2c4e7422e6f6a$export$55d101622faac174)(this._impl);
        super.destroy();
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        super.pause();
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        super.start();
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $9cbab9aac84784d2$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $9cbab9aac84784d2$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID && this._deviceId !== $9cbab9aac84784d2$export$9a93ce53f488cb2e.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else {
                facingMode = this._deviceId === $9cbab9aac84784d2$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID ? "environment" : "user";
                if ((0, $2a24a564c6953dcf$export$4882ae973e0491e).ios164CameraSelection) {
                    if (!this._explicitEnvironmentCameraId || !this._explicitUserCameraId) {
                        const stream = yield navigator.mediaDevices.getUserMedia({
                            audio: false,
                            video: {
                                facingMode: facingMode
                            }
                        });
                        let tracks = stream.getTracks();
                        tracks.forEach((t)=>t.stop());
                        let devices = yield navigator.mediaDevices.enumerateDevices();
                        devices = devices.filter((val)=>val.kind === "videoinput");
                        if (devices.length >= 2) {
                            this._explicitUserCameraId = devices[0].deviceId;
                            this._explicitEnvironmentCameraId = devices[1].deviceId;
                        }
                    }
                    deviceId = facingMode === "environment" ? this._explicitEnvironmentCameraId : this._explicitUserCameraId;
                }
            }
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $2a24a564c6953dcf$export$4882ae973e0491e).videoWidth,
                    height: (0, $2a24a564c6953dcf$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $2a24a564c6953dcf$export$4882ae973e0491e).requestHighFrameRate ? 60 : undefined,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $46062ba68c57c43e$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(allowRead) {
        this._cameraToScreenRotation = (0, $b64a7e1fb5f394c7$export$83fad53f837eba8e)(false);
        super.getFrame(allowRead);
    }
    _getUserMedia() {
        return $9cbab9aac84784d2$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $9cbab9aac84784d2$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                }
                if (!(this._video instanceof HTMLVideoElement)) return;
                this._video.src = "";
                this._video.loop = false;
                this._video.muted = true;
                this._video.srcObject = this._currentStream;
                this._video.play();
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        this._deviceOrientationListener = (ev)=>{
            let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        };
        window.addEventListener("deviceorientation", this._deviceOrientationListener);
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
        if (this._deviceOrientationListener) window.removeEventListener("deviceorientation", this._deviceOrientationListener);
    }
}
$9cbab9aac84784d2$export$9a93ce53f488cb2e.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$9cbab9aac84784d2$export$9a93ce53f488cb2e.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";


var $c94bef5acaf29dfb$exports = {};

$parcel$export($c94bef5acaf29dfb$exports, "ImageBitmapCameraSource", function () { return $c94bef5acaf29dfb$export$26291a750254acd7; });







var $c94bef5acaf29dfb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $c94bef5acaf29dfb$export$26291a750254acd7 extends (0, $566bb64a761777a5$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline, _deviceId){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._isPaused = true;
        this._isUserFacing = false;
        this._hadFrames = false;
        this._canvas = new OffscreenCanvas(640, 480);
        this._context = this._canvas.getContext("2d");
        this._lastFrameTime = -1;
        this._video = document.createElement("video");
        this._cameraToDeviceTransform = (0, $2edf3b5f20103352$exports).create();
        this._cameraToDeviceTransformUserFacing = (0, $2edf3b5f20103352$exports).create();
        this._cameraModel = new Float32Array([
            300,
            300,
            160,
            120,
            0,
            0
        ]);
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
        (0, $46062ba68c57c43e$export$454156e929b28fe7)("Using ImageBitmap camera source");
        (0, $2edf3b5f20103352$exports).fromScaling(this._cameraToDeviceTransformUserFacing, [
            -1,
            1,
            -1
        ]);
        this._video.muted = true;
        this._video.setAttribute("playsinline", "");
        this._video.setAttribute("webkit-playsinline", "");
        if ((0, $2a24a564c6953dcf$export$4882ae973e0491e).videoElementInDOM) {
            this._video.style.width = "0px";
            this._video.style.height = "0px";
            document.body.appendChild(this._video);
        }
        this._video.addEventListener("loadedmetadata", ()=>{
            this._hadFrames = true;
        });
    }
    destroy() {
        this.pause();
        (0, $72f2c4e7422e6f6a$export$55d101622faac174)(this._impl);
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        this._isPaused = true;
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        var _a;
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
        this._isPaused = false;
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $c94bef5acaf29dfb$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $c94bef5acaf29dfb$export$26291a750254acd7.DEFAULT_DEVICE_ID && this._deviceId !== $c94bef5acaf29dfb$export$26291a750254acd7.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else facingMode = this._deviceId === $c94bef5acaf29dfb$export$26291a750254acd7.DEFAULT_DEVICE_ID ? "environment" : "user";
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $2a24a564c6953dcf$export$4882ae973e0491e).videoWidth,
                    height: (0, $2a24a564c6953dcf$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $2a24a564c6953dcf$export$4882ae973e0491e).requestHighFrameRate ? 60 : undefined,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $46062ba68c57c43e$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(currentlyProcessing) {
        var _a, _b;
        if (!this._context) return;
        if (!this._hadFrames) return;
        if (currentlyProcessing) return;
        let currentTime = performance.now();
        if (currentTime < this._lastFrameTime + 25) return;
        this._lastFrameTime = currentTime;
        if (this._canvas.width !== this._video.videoWidth) this._canvas.width = this._video.videoWidth;
        if (this._canvas.height !== this._video.videoHeight) this._canvas.height = this._video.videoHeight;
        this._context.drawImage(this._video, 0, 0);
        const imageBitmap = this._canvas.transferToImageBitmap();
        let rotation = (0, $b64a7e1fb5f394c7$export$83fad53f837eba8e)(false);
        let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let focalLength = 300.0 * (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth / 320.0;
        this._cameraModel[0] = focalLength;
        this._cameraModel[1] = focalLength;
        this._cameraModel[2] = (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataWidth * 0.5;
        this._cameraModel[3] = (0, $2a24a564c6953dcf$export$4882ae973e0491e).dataHeight * 0.5;
        let token = pipeline.registerToken({
            dataWidth: this._canvas.width,
            dataHeight: this._canvas.height,
            texture: undefined,
            userFacing: this._isUserFacing,
            cameraSource: this,
            cameraModel: this._cameraModel.slice(),
            cameraToDevice: this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform
        });
        (_b = (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline)) === null || _a === void 0 ? void 0 : _a.sendImageBitmapToWorker) === null || _b === void 0 || _b.call(_a, imageBitmap, rotation, this._isUserFacing, token, this._cameraModel, this._isUserFacing ? this._cameraToDeviceTransformUserFacing : this._cameraToDeviceTransform);
        return;
    }
    _getUserMedia() {
        return $c94bef5acaf29dfb$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $c94bef5acaf29dfb$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                }
                this._video.src = "";
                this._video.loop = false;
                this._video.muted = true;
                this._video.srcObject = this._currentStream;
                this._video.play();
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        window.addEventListener("deviceorientation", (ev)=>{
            let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        });
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
    }
    uploadGL(info) {
        const pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        const gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!info || info.texture || !info.frame || !pipeline || !gl) return;
        let texture = pipeline.getVideoTexture();
        if (!texture) return;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, info.frame);
        gl.bindTexture(gl.TEXTURE_2D, null);
        info.texture = texture;
        info.frame.close();
        delete info.frame;
    }
}
$c94bef5acaf29dfb$export$26291a750254acd7.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$c94bef5acaf29dfb$export$26291a750254acd7.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";



var $733554013f7e60fd$exports = {};

$parcel$export($733554013f7e60fd$exports, "MSTPCameraSource", function () { return $733554013f7e60fd$export$e29bc47e63d4ca88; });






var $733554013f7e60fd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $733554013f7e60fd$export$e29bc47e63d4ca88 extends (0, $566bb64a761777a5$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline, _deviceId){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._deviceId = _deviceId;
        this._currentStream = null;
        this._activeDeviceId = null;
        this._isPaused = true;
        this._isUserFacing = false;
        this._cameraToScreenRotation = 0;
        this._hasStartedOrientation = false;
        this._deviceMotionListener = (ev)=>{
            let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.accelerationIncludingGravity !== null && ev.accelerationIncludingGravity.x !== null && ev.accelerationIncludingGravity.y !== null && ev.accelerationIncludingGravity.z !== null) pipeline.motionAccelerometerSubmit(timeStamp, ev.accelerationIncludingGravity.x * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.y * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier, ev.accelerationIncludingGravity.z * (0, $2a24a564c6953dcf$export$4882ae973e0491e).deviceMotionMutliplier);
            if (ev.rotationRate !== null && ev.rotationRate.alpha !== null && ev.rotationRate.beta !== null && ev.rotationRate.gamma !== null && !this._hasStartedOrientation) {
                ev.timeStamp;
                pipeline.motionRotationRateSubmit(timeStamp, ev.rotationRate.alpha * Math.PI / -180, ev.rotationRate.beta * Math.PI / -180, ev.rotationRate.gamma * Math.PI / -180);
            } else if (!this._hasStartedOrientation) this._startDeviceOrientation();
        };
        (0, $46062ba68c57c43e$export$454156e929b28fe7)("Using MSTP camera source");
    }
    destroy() {
        this.pause();
        (0, $72f2c4e7422e6f6a$export$55d101622faac174)(this._impl);
    }
    _stop() {
        if (!this._currentStream) return;
        let tracks = this._currentStream.getTracks();
        tracks.forEach((t)=>t.stop());
        this._currentStream = null;
    }
    pause() {
        this._isPaused = true;
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
        this._stopDeviceMotion();
        this._syncCamera();
    }
    start() {
        var _a;
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
        this._isPaused = false;
        this._startDeviceMotion();
        this._syncCamera();
    }
    _getConstraints() {
        return $733554013f7e60fd$var$__awaiter(this, void 0, void 0, function*() {
            let deviceId;
            let facingMode;
            if (this._deviceId !== $733554013f7e60fd$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID && this._deviceId !== $733554013f7e60fd$export$e29bc47e63d4ca88.USER_DEFAULT_DEVICE_ID) // Custom device
            deviceId = this._deviceId;
            else facingMode = this._deviceId === $733554013f7e60fd$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID ? "environment" : "user";
            let constraints = {
                audio: false,
                video: {
                    facingMode: facingMode,
                    width: (0, $2a24a564c6953dcf$export$4882ae973e0491e).videoWidth,
                    height: (0, $2a24a564c6953dcf$export$4882ae973e0491e).videoHeight,
                    frameRate: (0, $2a24a564c6953dcf$export$4882ae973e0491e).requestHighFrameRate ? 60 : 30,
                    deviceId: deviceId
                }
            };
            if (deviceId) return constraints;
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return constraints;
            let devices = yield navigator.mediaDevices.enumerateDevices();
            let hasHadCapabilities = false;
            devices = devices.filter((val)=>{
                // Remove non-video devices
                if (val.kind !== "videoinput") return false;
                // If the media info object contains capabilities, use it to filter to the correct facing cameras
                if (val.getCapabilities) {
                    hasHadCapabilities = true;
                    let capabilities = val.getCapabilities();
                    if (capabilities && capabilities.facingMode && capabilities.facingMode.indexOf(facingMode === "user" ? "user" : "environment") < 0) return false;
                }
                return true;
            });
            // If none of the devices had capability info, or we have no devices left, fall back to the standard constraints
            if (!hasHadCapabilities || devices.length === 0) return constraints;
            if (typeof constraints.video === "object") {
                (0, $46062ba68c57c43e$export$454156e929b28fe7)("choosing device ID", devices[devices.length - 1].deviceId);
                constraints.video.deviceId = devices[devices.length - 1].deviceId;
            }
            return constraints;
        });
    }
    getFrame(allowRead) {
        var _a, _b;
        let rotation = (0, $b64a7e1fb5f394c7$export$83fad53f837eba8e)(false);
        if (rotation != this._cameraToScreenRotation) {
            (_b = (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline)) === null || _a === void 0 ? void 0 : _a.sendCameraToScreenRotationToWorker) === null || _b === void 0 || _b.call(_a, rotation);
            this._cameraToScreenRotation = rotation;
        }
        return;
    }
    _getUserMedia() {
        return $733554013f7e60fd$var$__awaiter(this, void 0, void 0, function*() {
            let constraints = yield this._getConstraints();
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return yield navigator.mediaDevices.getUserMedia(constraints);
            return yield new Promise((resolve, reject)=>{
                navigator.getUserMedia(constraints, resolve, reject);
            });
        });
    }
    _syncCamera() {
        return $733554013f7e60fd$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentStream && this._isPaused) {
                this._stop();
                return;
            }
            if (this._currentStream && this._activeDeviceId !== this._deviceId) this._stop();
            if (!this._isPaused) {
                this._activeDeviceId = this._deviceId;
                this._currentStream = yield this._getUserMedia();
                if (this._isPaused) {
                    yield this._syncCamera();
                    return;
                }
                this._isUserFacing = false;
                if (this._currentStream) {
                    let videoTracks = this._currentStream.getVideoTracks();
                    if (videoTracks.length > 0) {
                        this._isUserFacing = videoTracks[0].getSettings().facingMode === "user";
                        let processor = new MediaStreamTrackProcessor({
                            track: videoTracks[0]
                        });
                        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
                        if (p) p.sendCameraStreamToWorker(this._impl, processor.readable, this._isUserFacing);
                    }
                }
            }
        });
    }
    _startDeviceOrientation() {
        if (this._hasStartedOrientation) return;
        this._hasStartedOrientation = true;
        window.addEventListener("deviceorientation", (ev)=>{
            let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
            if (!pipeline) return;
            let timeStamp = ev.timeStamp !== undefined && ev.timeStamp !== null ? ev.timeStamp : performance.now();
            if (ev.alpha === null || ev.beta === null || ev.gamma === null) return;
            pipeline.motionAttitudeSubmit(timeStamp, ev.alpha, ev.beta, ev.gamma);
        });
    }
    _startDeviceMotion() {
        window.addEventListener("devicemotion", this._deviceMotionListener, false);
    }
    _stopDeviceMotion() {
        window.removeEventListener("devicemotion", this._deviceMotionListener);
    }
    uploadGL(info) {
        const pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        const gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!info || info.texture || !info.frame || !pipeline || !gl) return;
        let texture = pipeline.getVideoTexture();
        if (!texture) return;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, info.frame);
        gl.bindTexture(gl.TEXTURE_2D, null);
        info.texture = texture;
        info.frame.close();
        delete info.frame;
    }
}
$733554013f7e60fd$export$e29bc47e63d4ca88.USER_DEFAULT_DEVICE_ID = "Simulated User Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";
$733554013f7e60fd$export$e29bc47e63d4ca88.DEFAULT_DEVICE_ID = "Simulated Default Device ID: a908df7f-5661-4d20-b227-a1c15d2fdb4b";



let $72f2c4e7422e6f6a$var$latest = 1;
let $72f2c4e7422e6f6a$var$byId = new Map();
function $72f2c4e7422e6f6a$export$1c7b58c7f8b1da4() {
    return $72f2c4e7422e6f6a$var$latest++;
}
function $72f2c4e7422e6f6a$export$9c2853b8b7906172(id, c) {
    $72f2c4e7422e6f6a$var$byId.set(id, c);
}
function $72f2c4e7422e6f6a$export$cf42922f9ae76ed1(id) {
    return $72f2c4e7422e6f6a$var$byId.get(id);
}
function $72f2c4e7422e6f6a$export$55d101622faac174(id) {
    $72f2c4e7422e6f6a$var$byId.delete(id);
}
function $72f2c4e7422e6f6a$export$3612a413b5e57058(p, deviceId) {
    let ret = $72f2c4e7422e6f6a$export$1c7b58c7f8b1da4();
    if ((0, $2a24a564c6953dcf$export$4882ae973e0491e).preferMediaStreamTrackProcessorCamera && "MediaStreamTrackProcessor" in window && "MediaStreamTrackGenerator" in window) $72f2c4e7422e6f6a$export$9c2853b8b7906172(ret, new (0, $733554013f7e60fd$exports.MSTPCameraSource)(ret, p, deviceId));
    else if ((0, $2a24a564c6953dcf$export$4882ae973e0491e).preferImageBitmapCamera && typeof OffscreenCanvas !== "undefined") $72f2c4e7422e6f6a$export$9c2853b8b7906172(ret, new (0, $c94bef5acaf29dfb$exports.ImageBitmapCameraSource)(ret, p, deviceId));
    else $72f2c4e7422e6f6a$export$9c2853b8b7906172(ret, new (0, $9cbab9aac84784d2$exports.CameraSource)(ret, p, deviceId));
    (0, $46062ba68c57c43e$export$454156e929b28fe7)("camera_source_t initialized");
    return ret;
}



class $40b48b669fd67b34$export$2a06d804567c3ad8 {
    constructor(_gl){
        this._gl = _gl;
    }
    dispose() {
        if (this._vbo) this._gl.deleteBuffer(this._vbo);
        if (this._uvbo) this._gl.deleteBuffer(this._uvbo);
        if (this._ibo) this._gl.deleteBuffer(this._ibo);
        if (this._shader) this._gl.deleteProgram(this._shader.prog);
        this._vbo = undefined;
        this._uvbo = undefined;
        this._ibo = undefined;
        this._shader = undefined;
    }
    _generateIBO(indices, gl) {
        if (this._ibo && this._lastIndices === indices) return this._ibo;
        this._lastIndices = indices;
        if (!this._ibo) this._ibo = gl.createBuffer();
        if (!this._ibo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this._ibo;
    }
    _generateVBO(face, gl) {
        if (!this._vbo) this._vbo = gl.createBuffer();
        if (!this._vbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._vbo;
    }
    _generateUVBO(face, gl) {
        if (!this._uvbo) this._uvbo = gl.createBuffer();
        if (!this._uvbo) throw new Error("Unable to create buffer object");
        gl.bindBuffer(gl.ARRAY_BUFFER, this._uvbo);
        gl.bufferData(gl.ARRAY_BUFFER, face, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return this._uvbo;
    }
    draw(matrix, tracker, indx) {
        var _a;
        const o = tracker.getPreviewMesh(indx);
        const image = (_a = tracker.getTargetInfo(indx).preview) === null || _a === void 0 ? void 0 : _a.image;
        if (!o || !image) return;
        if (!image.complete) return;
        let gl = this._gl;
        let shader = this._getShader(gl);
        let v = this._generateVBO(o.vertices, gl);
        let n = this._generateUVBO(o.uvs, gl);
        let i = this._generateIBO(o.indices, gl);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        gl.useProgram(shader.prog);
        gl.uniformMatrix4fv(shader.unif_matrix, false, matrix);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, $40b48b669fd67b34$var$loadTexture(gl, image));
        gl.uniform1i(shader.unif_skinSampler, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, v);
        gl.vertexAttribPointer(shader.attr_position, 3, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(shader.attr_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, n);
        gl.vertexAttribPointer(shader.attr_textureCoord, 2, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(shader.attr_textureCoord);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, i);
        gl.drawElements(gl.TRIANGLES, o.indices.length, gl.UNSIGNED_SHORT, 0);
        gl.disableVertexAttribArray(shader.attr_position);
        gl.disableVertexAttribArray(shader.attr_textureCoord);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    _getShader(gl) {
        if (this._shader) return this._shader;
        let prog = gl.createProgram();
        if (!prog) throw new Error("Unable to create program");
        let vertexShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, $40b48b669fd67b34$var$vertexShaderSrc);
        let fragmentShader = (0, $2855ef2b305ce725$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, $40b48b669fd67b34$var$fragmentShaderSrc);
        gl.attachShader(prog, vertexShader);
        gl.attachShader(prog, fragmentShader);
        (0, $2855ef2b305ce725$export$d879afae78b531a5)(gl, prog);
        let unif_matrix = gl.getUniformLocation(prog, "matrix");
        if (!unif_matrix) throw new Error("Unable to get uniform location mattrix");
        let unif_skinSampler = gl.getUniformLocation(prog, "skinSampler");
        if (!unif_skinSampler) throw new Error("Unable to get uniform location skinSampler");
        this._shader = {
            prog: prog,
            unif_matrix: unif_matrix,
            unif_skinSampler: unif_skinSampler,
            attr_position: gl.getAttribLocation(prog, "position"),
            attr_textureCoord: gl.getAttribLocation(prog, "textureCoord")
        };
        return this._shader;
    }
}
const $40b48b669fd67b34$var$texturesByElement = new Map();
function $40b48b669fd67b34$var$loadTexture(gl, elm) {
    let existing = $40b48b669fd67b34$var$texturesByElement.get(elm);
    if (existing) return existing;
    existing = gl.createTexture() || undefined;
    if (!existing) throw new Error("Unable to create texture");
    $40b48b669fd67b34$var$texturesByElement.set(elm, existing);
    gl.bindTexture(gl.TEXTURE_2D, existing);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    // Because images have to be download over the internet
    // they might take a moment until they are ready.
    // Until then put a single pixel in the texture so we can
    // use it immediately. When the image has finished downloading
    // we'll update the texture with the contents of the image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, elm);
    elm.addEventListener("load", ()=>{
        if (!existing) return;
        gl.bindTexture(gl.TEXTURE_2D, existing);
        const level = 0;
        const internalFormat = gl.RGBA;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, elm);
    });
    return existing;
}
let $40b48b669fd67b34$var$vertexShaderSrc = `
#ifndef GL_ES
#define highp
#define mediump
#define lowp
#endif

uniform mat4 matrix;
attribute vec4 position;
attribute vec2 textureCoord;

varying highp vec2 vTextureCoord;

void main()
{
    gl_Position = matrix * position;
    vTextureCoord = textureCoord;
}`;
let $40b48b669fd67b34$var$fragmentShaderSrc = `
#define highp mediump
#ifdef GL_ES
    // define default precision for float, vec, mat.
    precision highp float;
#else
#define highp
#define mediump
#define lowp
#endif

varying highp vec2 vTextureCoord;
uniform sampler2D skinSampler;

void main()
{
    gl_FragColor = texture2D(skinSampler, vTextureCoord);
}`;


let $24725864d261e6a0$var$byId = new Map();
let $24725864d261e6a0$var$identity = (0, $2edf3b5f20103352$exports).create();
class $24725864d261e6a0$export$abd47b564b6c9ce2 {
    constructor(_client, _impl, _mgr){
        this._client = _client;
        this._impl = _impl;
        this._mgr = _mgr;
        this.pendingMessages = [];
        this.cameraTokens = new Map();
        this.nextCameraToken = 1;
        this.tokensInFlight = 0;
        this.videoTextures = [];
        this.cameraPixelArrays = [];
        this._sequenceRecordDeviceAttitudeMatrices = true;
        this._sequenceRecorderFirstCameraToken = 0;
        this.onGLContextReset = new (0, $c5055f0ec6e6358b$export$d61e24a684f9e51)();
    }
    static create(client, mgr) {
        let ret = client.pipeline_create();
        $24725864d261e6a0$var$byId.set(ret, new $24725864d261e6a0$export$abd47b564b6c9ce2(client, ret, mgr));
        return ret;
    }
    static get(p) {
        return $24725864d261e6a0$var$byId.get(p);
    }
    frameUpdate(client) {
        for (let msg of this.pendingMessages){
            client.processMessages(msg);
            this._mgr.postOutgoingMessage({
                t: "buf",
                p: this._impl,
                d: msg
            }, [
                msg
            ]);
        }
        this.pendingMessages = [];
        this.cleanOldFrames();
    }
    cleanOldFrames() {
        var _a, _b;
        let currentToken = this._client.pipeline_camera_frame_user_data(this._impl);
        if (!currentToken) return;
        for (let t of this.cameraTokens)if (t[0] < currentToken) {
            if (t[1].texture) this.videoTextures.push(t[1].texture);
            (_b = (_a = t[1].frame) === null || _a === void 0 ? void 0 : _a.close) === null || _b === void 0 || _b.call(_a);
            this.cameraTokens.delete(t[0]);
        }
    }
    cameraTokenReturn(msg) {
        if (this._sequenceRecorder && this._sequenceRecordDeviceAttitudeMatrices && msg.token >= this._sequenceRecorderFirstCameraToken) {
            let info = this.cameraTokens.get(msg.token);
            if (info) {
                if (msg.att) this._sequenceRecorder.appendAttitudeMatrix(msg.att);
                info.data = msg.d;
                this._sequenceRecorder.appendCameraFrame(info);
            }
        }
        this.cameraPixelArrays.push(msg.d);
        this.tokensInFlight--;
    }
    sequenceRecordStart(expectedFrames) {
        if (!this._sequenceRecorder) this._sequenceRecorder = new (0, $64e6deea2842fcd8$export$a9d7f366c6e802ee)(expectedFrames);
        this._sequenceRecorder.start();
        this._sequenceRecorderFirstCameraToken = this.nextCameraToken;
    }
    sequenceRecordStop() {
        var _a;
        (_a = this._sequenceRecorder) === null || _a === void 0 || _a.stop();
    }
    sequenceRecordData() {
        var _a;
        return ((_a = this._sequenceRecorder) === null || _a === void 0 ? void 0 : _a.data()) || new Uint8Array(0);
    }
    sequenceRecordClear() {
        delete this._sequenceRecorder;
    }
    sequenceRecordDeviceAttitudeMatrices(v) {
        this._sequenceRecordDeviceAttitudeMatrices = v;
    }
    getVideoTexture() {
        return this.videoTextures.pop();
    }
    destroy() {
        this._client.pipeline_destroy(this._impl);
        $24725864d261e6a0$var$byId.delete(this._impl);
    }
    getCurrentCameraInfo() {
        let currentToken = this._client.pipeline_camera_frame_user_data(this._impl);
        if (!currentToken) return undefined;
        return this.cameraTokens.get(currentToken);
    }
    cameraFrameDrawGL(screenWidth, screenHeight, mirror) {
        if (!this.glContext) return;
        let token = this.getCurrentCameraInfo();
        if (!token) return;
        if (!this._cameraDraw) this._cameraDraw = new (0, $59c5678f95fa53ad$export$65ee3277a9a1612d)(this.glContext);
        this._cameraDraw.drawCameraFrame(screenWidth, screenHeight, token, mirror === true);
    }
    glContextLost() {
        if (this._cameraDraw) this._cameraDraw.dispose();
        if (this._faceDraw) this._faceDraw.dispose();
        if (this._imageTargetPreviewDraw) this._imageTargetPreviewDraw.dispose();
        if (this._faceProjectDraw) this._faceProjectDraw.dispose();
        delete this._cameraDraw;
        delete this._faceDraw;
        delete this._imageTargetPreviewDraw;
        delete this._faceProjectDraw;
        (0, $d580c9e8b84c13cf$export$5998daa18e8ce5b0)();
        this.onGLContextReset.emit();
        for (let tex of this.videoTextures)if (this.glContext) this.glContext.deleteTexture(tex);
        this.videoTextures = [];
        for (let info of this.cameraTokens){
            if (this.glContext && info[1].texture) this.glContext.deleteTexture(info[1].texture);
            info[1].texture = undefined;
        }
        this.glContext = undefined;
    }
    glContextSet(gl, texturePool) {
        this.glContextLost();
        this.glContext = gl;
        texturePool = texturePool || [];
        for(let i = 0; i < 4; i++){
            let tex = texturePool[i] || gl.createTexture();
            if (tex) {
                gl.bindTexture(gl.TEXTURE_2D, tex);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                this.videoTextures.push(tex);
            }
        }
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    drawFace(projectionMatrix, cameraMatrix, targetMatrix, o) {
        if (!this.glContext) return;
        if (!this._faceDraw) this._faceDraw = new (0, $256ab20f08c41d94$export$884fb66b30975d12)(this.glContext);
        let mat = (0, $2edf3b5f20103352$exports).create();
        (0, $2edf3b5f20103352$exports).multiply(mat, projectionMatrix, cameraMatrix);
        (0, $2edf3b5f20103352$exports).multiply(mat, mat, targetMatrix);
        this._faceDraw.drawFace(mat, o);
    }
    drawImageTargetPreview(projectionMatrix, cameraMatrix, targetMatrix, indx, o) {
        if (!this.glContext) return;
        if (!this._imageTargetPreviewDraw) this._imageTargetPreviewDraw = new (0, $40b48b669fd67b34$export$2a06d804567c3ad8)(this.glContext);
        let mat = (0, $2edf3b5f20103352$exports).create();
        (0, $2edf3b5f20103352$exports).multiply(mat, projectionMatrix, cameraMatrix);
        (0, $2edf3b5f20103352$exports).multiply(mat, mat, targetMatrix);
        this._imageTargetPreviewDraw.draw(mat, o, indx);
    }
    drawFaceProject(matrix, vertices, uvMatrix, uvs, indices, texture) {
        if (!this.glContext) return;
        if (!this._faceProjectDraw) this._faceProjectDraw = new (0, $0da80bb9be0ee5cd$export$626d5c7c1d8c587c)(this.glContext);
        this._faceProjectDraw.drawFace(matrix, vertices, uvMatrix, uvs, indices, texture);
    }
    cameraFrameTexture() {
        var _a;
        return (_a = this.getCurrentCameraInfo()) === null || _a === void 0 ? void 0 : _a.texture;
    }
    cameraFrameTextureMatrix(sw, sh, mirror) {
        let info = this.getCurrentCameraInfo();
        if (!info) return (0, $2edf3b5f20103352$exports).create();
        return (0, $59c5678f95fa53ad$export$3da067886124f338)(info.dataWidth, info.dataHeight, sw, sh, info.uvTransform || $24725864d261e6a0$var$identity, mirror);
    }
    cameraFrameUserFacing() {
        var _a;
        return ((_a = this.getCurrentCameraInfo()) === null || _a === void 0 ? void 0 : _a.userFacing) || false;
    }
    cameraPoseWithAttitude(mirror) {
        let res = $24725864d261e6a0$export$9e7b3df2d144a412(this.getCurrentCameraInfo(), this._client.pipeline_camera_frame_camera_attitude(this._impl));
        if (mirror) {
            let scale = (0, $2edf3b5f20103352$exports).create();
            (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                -1,
                1,
                1
            ]);
            (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
            (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
        }
        (0, $2edf3b5f20103352$exports).invert(res, res);
        return res;
    }
    videoFrameFromWorker(msg) {
        let tokenId = this.nextCameraToken++;
        const cameraSource = (0, $72f2c4e7422e6f6a$export$cf42922f9ae76ed1)(msg.source);
        if (!cameraSource) return;
        this.cameraTokens.set(tokenId, {
            dataWidth: msg.w,
            dataHeight: msg.h,
            texture: undefined,
            frame: msg.d,
            userFacing: msg.userFacing,
            uvTransform: msg.uvTransform,
            cameraModel: msg.cameraModel,
            cameraToDevice: msg.cameraToDevice,
            cameraSource: cameraSource
        });
        this.cleanOldFrames();
    }
    imageBitmapFromWorker(msg) {
        let data = this.cameraTokens.get(msg.tokenId);
        if (!data) return;
        data.dataWidth = msg.dataWidth;
        data.dataHeight = msg.dataHeight;
        data.frame = msg.frame;
        data.userFacing = msg.userFacing;
        data.uvTransform = msg.uvTransform;
        this.tokensInFlight--;
        this.cleanOldFrames();
    }
    uploadGL() {
        var _a, _b;
        let info = this.getCurrentCameraInfo();
        (_b = (_a = info === null || info === void 0 ? void 0 : info.cameraSource) === null || _a === void 0 ? void 0 : _a.uploadGL) === null || _b === void 0 || _b.call(_a, info);
    }
    registerToken(info) {
        let tokenId = this.nextCameraToken++;
        this.cameraTokens.set(tokenId, info);
        this.tokensInFlight++;
        return tokenId;
    }
    processGL() {
        if (!this.glContext) {
            (0, $46062ba68c57c43e$export$497c45d0bfe56de1)("no GL context for camera frames - please call pipeline_gl_context_set");
            return;
        }
        if (!this.currentCameraSource) return;
        if (this.tokensInFlight > 0) {
            this.currentCameraSource.getFrame(true);
            return;
        }
        this.currentCameraSource.getFrame(false);
    }
    motionAccelerometerSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendAccelerometer(timestamp, x, y, z);
        this._client.pipeline_motion_accelerometer_submit(this._impl, timestamp, x, y, z);
    }
    motionRotationRateSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendRotationRate(timestamp, x, y, z);
        this._client.pipeline_motion_rotation_rate_submit(this._impl, timestamp, x, y, z);
    }
    motionAttitudeSubmit(timestamp, x, y, z) {
        var _a;
        if (!this._sequenceRecordDeviceAttitudeMatrices) (_a = this._sequenceRecorder) === null || _a === void 0 || _a.appendAttitude(timestamp, x, y, z);
        this._client.pipeline_motion_attitude_submit(this._impl, timestamp, x, y, z);
    }
    motionAttitudeMatrix(m) {
        // This doesn't need to be added to the sequence since that's done on frame update instead
        this._client.pipeline_motion_attitude_matrix_submit(this._impl, m);
    }
    sendCameraStreamToWorker(source, stream, userFacing) {
        let msg = {
            t: "streamC2S",
            p: this._impl,
            s: stream,
            userFacing: userFacing,
            source: source
        };
        this._mgr.postOutgoingMessage(msg, [
            msg.s
        ]);
    }
    sendCameraToScreenRotationToWorker(rot) {
        let msg = {
            p: this._impl,
            t: "cameraToScreenC2S",
            r: rot
        };
        this._mgr.postOutgoingMessage(msg, []);
    }
    sendImageBitmapToWorker(img, rot, userFacing, tokenId, cameraModel, cameraToDevice) {
        let msg = {
            p: this._impl,
            t: "imageBitmapC2S",
            i: img,
            r: rot,
            tokenId: tokenId,
            userFacing: userFacing,
            cameraModel: cameraModel,
            cameraToDevice: cameraToDevice
        };
        this._mgr.postOutgoingMessage(msg, [
            img
        ]);
    }
    sendDataToWorker(data, token, width, height, userFacing, cameraToDevice, cameraModel) {
        let msg = {
            d: data,
            p: this._impl,
            width: width,
            height: height,
            token: token,
            userFacing: userFacing,
            c2d: cameraToDevice,
            cm: cameraModel,
            t: "cameraFrameC2S"
        };
        this._mgr.postOutgoingMessage(msg, [
            data
        ]);
    }
}
function $24725864d261e6a0$export$9e7b3df2d144a412(info, inp) {
    let userFacing = false;
    userFacing = info ? info.userFacing : false;
    let mult = (0, $2edf3b5f20103352$exports).create();
    (0, $2edf3b5f20103352$exports).fromRotation(mult, (0, $b64a7e1fb5f394c7$export$83fad53f837eba8e)(userFacing) * Math.PI / 180.0, [
        0,
        0,
        1
    ]);
    (0, $2edf3b5f20103352$exports).multiply(mult, mult, inp);
    return mult;
}





const $017c644280618cdd$export$bc05bfbdf8a2824 = {
    0: [
        {
            mean: [
                0.235,
                0.2344,
                0.7305
            ],
            identity: [
                0.008,
                0.0087,
                0.0024,
                -0.0026,
                0.0006,
                -0.0022,
                0.0005,
                0.0033,
                0.0026,
                0.0017,
                -0.0055,
                -0.0008,
                0.0011,
                0.0059,
                0,
                0.0002,
                0.001,
                -0.001,
                -0.0044,
                -0.0011,
                -0.0001,
                0.0024,
                0.0019,
                -0.0009,
                0.0004,
                -0.0015,
                0,
                0.0038,
                0.0013,
                0.0003,
                0.002,
                -0.0021,
                0.0018,
                0.0023,
                0.0011,
                0.0012,
                -0.0011,
                -0.0017,
                0.0009,
                -0.0012,
                -0.0008,
                0.0007,
                -0.0017,
                0.0029,
                -0.0029,
                0.0008,
                -0.0027,
                0.0008,
                -0.0017,
                0.0004,
                0.0009,
                -0.001,
                -0.0003,
                0.0008,
                -0.0016,
                -0.0003,
                -0.0007,
                0.0016,
                -0.0009,
                0.0021,
                -0.0005,
                0.0011,
                -0.0024,
                -0.0001,
                0.0006,
                0.0001,
                -0.0026,
                -0.0004,
                -0.0003,
                -0.0009,
                0.0005,
                0.0003,
                -0.0008,
                -0.001,
                -0.0004,
                -0.0008,
                0.0022,
                -0.0014,
                -0.0001,
                -0.0023,
                0,
                -0.0018,
                0.0007,
                -0.0036,
                0.0017,
                0.0017,
                -0.0018,
                -0.0002,
                -0.0004,
                -0.0009,
                -0.0008,
                0.0003,
                0.0012,
                0.0009,
                -0.0004,
                -0.0016,
                0.0005,
                -0.0013,
                0.0011,
                0.0023,
                0.0029,
                0.0024,
                0.0017,
                -0.0027,
                -0.0004,
                -0.001,
                -0.0018,
                -0.0015,
                -0.001,
                0.001,
                -0.0013,
                -0.0001,
                -0.0002,
                0.0007,
                0.0003,
                0.0003,
                -0.0016,
                0.0009,
                -0.0021,
                0.0004,
                0.0014,
                0.002,
                -0.0007,
                -0.0004,
                0.0002,
                -0.0004,
                -0.0006,
                -0.0009,
                0.0015,
                0.0004,
                -0.0004,
                0.0005,
                -0.0015,
                0.0009,
                0.0003,
                0.0003,
                -0.0002,
                -0.0008,
                -0.0009,
                0.0023,
                0.0004,
                0.0001,
                -0.0004,
                -0.0001,
                0.0007,
                0.0002,
                0.001,
                0.0001,
                -0.0029,
                -0.0005
            ],
            expression: [
                0,
                0.0003,
                0.0052,
                -0.0007,
                -0.0051,
                -0.0103,
                0,
                0.0019,
                0.0027,
                -0.0054,
                0.0135,
                0.035,
                -0.0005,
                -0.0006,
                0.0025,
                -0.0045,
                -0.0557,
                -0.003,
                -0.0191,
                -0.1199,
                0.0548,
                -0.0036,
                -0.0682,
                -0.0167,
                0.0002,
                -0.0085,
                -0.0085,
                0.0044,
                0.0041,
                -0.0568,
                0.0044,
                0.179,
                0.0065,
                -0.0017,
                -0.1006,
                0.0036,
                -0.0267,
                -0.3279,
                0.0301,
                -0.0011,
                -0.0173,
                -0.001,
                0.0046,
                0.2808,
                0.0207,
                0.0162,
                0.238,
                -0.0225,
                0.0017,
                0.1041,
                0.0203,
                0.0005,
                0.0161,
                0.0031,
                -0.0436,
                0.6504,
                0.0873,
                -0.0099,
                0.1039,
                0.0048,
                -0.0254,
                0.2534,
                -0.0042,
                0.003,
                -0.0106,
                -0.0153,
                -0.0118,
                0.0252,
                0.0009,
                -0.0071,
                0.0099,
                0.007,
                -0.0724,
                0.0461,
                -0.0235,
                0.0833,
                0.004,
                0.0141,
                -0.0219,
                0.0132,
                -0.0042,
                -0.0179,
                0.0045,
                -0.0215,
                0.3638,
                0.0054,
                -0.0445
            ]
        },
        {
            mean: [
                0.2358,
                0.1466,
                0.7183
            ],
            identity: [
                0.0077,
                0.0093,
                0.0001,
                -0.0022,
                0,
                -0.0041,
                0.0005,
                0.0022,
                0.0028,
                0.0018,
                -0.0038,
                -0.0013,
                0.001,
                0.0044,
                -0.0002,
                0,
                0.0017,
                -0.0016,
                -0.0043,
                -0.0002,
                -0.0001,
                0.0023,
                0.0009,
                0.0005,
                -0.0007,
                -0.0004,
                -0.0017,
                0.003,
                0.0007,
                0.0006,
                0.0011,
                -0.0018,
                0.0005,
                0.0018,
                -0.0008,
                0.0004,
                -0.0023,
                -0.0006,
                -0.0003,
                -0.0015,
                -0.0014,
                -0.0001,
                -0.0018,
                0.0027,
                -0.0026,
                0.0003,
                -0.0031,
                0.0011,
                -0.0026,
                -0.0011,
                0.0012,
                -0.0013,
                -0.0002,
                0.0007,
                -0.0021,
                0.0021,
                0.0004,
                0.0012,
                -0.001,
                0.002,
                -0.0003,
                0.0002,
                -0.0026,
                -0.0003,
                0.001,
                0.0001,
                -0.0018,
                -0.001,
                0.0009,
                -0.0011,
                0.001,
                0.0004,
                -0.0008,
                -0.0007,
                -0.001,
                -0.0003,
                0.0007,
                -0.0005,
                -0.0006,
                -0.0019,
                -0.0005,
                -0.002,
                0.0007,
                -0.0027,
                0.0014,
                0.0013,
                0.0006,
                -0.0005,
                -0.0003,
                -0.0003,
                -0.001,
                0,
                0.0019,
                0.0001,
                0.0006,
                -0.0012,
                0.0004,
                -0.0009,
                0.0004,
                0.0025,
                0.0003,
                0.0024,
                0.0017,
                -0.0009,
                -0.0015,
                -0.0015,
                -0.001,
                -0.0023,
                -0.001,
                -0.0005,
                -0.0004,
                0.0008,
                0.0009,
                0.0007,
                0.0002,
                0.0007,
                -0.0009,
                0.0009,
                -0.0013,
                0.0001,
                0.0009,
                0.0002,
                0.0006,
                -0.0006,
                -0.0008,
                -0.0004,
                -0.0007,
                0.0008,
                0.0019,
                0.0003,
                0.0015,
                0.0002,
                -0.0015,
                -0.0003,
                0,
                0.0006,
                0.0003,
                0.0006,
                -0.0006,
                0.0002,
                0.0005,
                -0.0004,
                0.0012,
                -0.0004,
                0.0002,
                -0.0008,
                0.0006,
                -0.0004,
                0.0002,
                -0.0021
            ],
            expression: [
                -0.0034,
                0.0054,
                0.0069,
                0.004,
                0.0006,
                -0.0104,
                -0.0003,
                0.0036,
                0.0025,
                0.0065,
                0.0296,
                0.0208,
                -0.0009,
                0.0154,
                0.0029,
                -0.0167,
                0.0124,
                0.004,
                -0.0102,
                0.0351,
                0.028,
                -0.019,
                0.0146,
                -0.0035,
                -0.0023,
                -0.0069,
                -0.0051,
                -0.01,
                0.0262,
                -0.028,
                0.0112,
                0.082,
                0.023,
                -0.0019,
                -0.066,
                -0.0104,
                -0.0408,
                0.0164,
                0.0075,
                -0.0074,
                0.0367,
                0.0041,
                0.0517,
                -0.0207,
                0.0045,
                0.0291,
                -0.0672,
                -0.0129,
                0.0345,
                -0.1558,
                -0.0106,
                0.0037,
                -0.0437,
                -0.0021,
                0.0854,
                -0.1121,
                0.0187,
                0.0041,
                0.0072,
                0.0011,
                0.0193,
                -0.0143,
                -0.0119,
                0.005,
                -0.02,
                -0.0122,
                -0.008,
                0.0527,
                0.0036,
                -0.006,
                0.0222,
                0.007,
                -0.0429,
                0.046,
                -0.0046,
                0.0226,
                -0.0059,
                0.0202,
                -0.0173,
                0.0087,
                0,
                -0.0067,
                -0.0095,
                -0.0153,
                0.1506,
                -0.0017,
                0.0021
            ]
        }
    ],
    1: [
        {
            mean: [
                -0.2271,
                0.2323,
                0.7319
            ],
            identity: [
                -0.0084,
                0.0097,
                0.0018,
                0.0041,
                0.0002,
                -0.002,
                -0.0012,
                0.0036,
                0.0019,
                -0.0009,
                -0.0063,
                -0.001,
                -0.0003,
                0.0053,
                0.0006,
                0.0001,
                0.0005,
                -0.0015,
                0.0044,
                -0.0025,
                -0.0015,
                -0.002,
                0.0016,
                -0.0006,
                0.0002,
                -0.0013,
                0,
                -0.0022,
                0.0002,
                0.0002,
                -0.0025,
                -0.0014,
                0.0015,
                0.0008,
                0.0002,
                0.0012,
                0.0006,
                -0.0006,
                0.0017,
                0,
                0.0003,
                -0.0001,
                0.0024,
                0.0025,
                -0.0029,
                -0.0015,
                -0.0015,
                0.0001,
                0.0031,
                -0.0016,
                0.0007,
                0.0019,
                0.0006,
                0.002,
                0.0009,
                0.001,
                -0.0014,
                -0.002,
                -0.0015,
                0.0029,
                0.0001,
                0.0005,
                -0.0023,
                0.0008,
                -0.0011,
                0.0019,
                0.0017,
                -0.0003,
                -0.0011,
                -0.0003,
                0.0011,
                -0.0008,
                0.0019,
                -0.0022,
                0.0001,
                0.0015,
                0.0017,
                -0.0008,
                -0.0011,
                -0.0022,
                0.0003,
                0.0022,
                0.0006,
                -0.003,
                -0.0002,
                0,
                -0.0017,
                -0.0002,
                0,
                0.0001,
                0.0004,
                0.0012,
                0.0019,
                -0.0014,
                0.0004,
                -0.0017,
                -0.0012,
                -0.0011,
                0.0021,
                -0.0029,
                0.0026,
                0.0018,
                -0.0023,
                -0.0029,
                0.0001,
                0.0014,
                -0.0019,
                -0.0004,
                -0.0004,
                0.0023,
                -0.0016,
                0,
                -0.0009,
                0.0014,
                -0.0015,
                0.0015,
                -0.0016,
                -0.0011,
                -0.0022,
                0.0001,
                -0.0018,
                0.0027,
                -0.0013,
                0.0004,
                -0.0001,
                -0.0005,
                0.0011,
                -0.0002,
                0.0015,
                0.0005,
                -0.0009,
                -0.0001,
                0.0029,
                0.0006,
                0,
                -0.0003,
                0.0007,
                -0.0008,
                -0.0005,
                0.0025,
                0.0003,
                0.0002,
                -0.0008,
                -0.0001,
                0.0003,
                0,
                0.0014,
                0.0002,
                -0.0024,
                0.0001
            ],
            expression: [
                -0.0025,
                -0.0009,
                0.006,
                0.004,
                -0.0027,
                -0.0113,
                -0.0008,
                0.001,
                0.0031,
                -0.0016,
                0.0144,
                0.0382,
                -0.0003,
                -0.0005,
                0.0035,
                -0.0044,
                -0.0511,
                -0.0014,
                -0.0007,
                -0.1007,
                0.0582,
                -0.0006,
                -0.0606,
                -0.0165,
                0.0005,
                -0.0087,
                -0.0093,
                0.0036,
                0.0057,
                -0.0576,
                -0.0039,
                0.1488,
                0.0127,
                0.0016,
                -0.0666,
                -0.0009,
                -0.0153,
                0.3162,
                -0.0445,
                -0.0021,
                0.0023,
                0.0043,
                -0.0033,
                0.2382,
                0.0063,
                -0.0217,
                0.167,
                -0.039,
                0.0097,
                -0.1144,
                -0.0189,
                -0.0145,
                0.6831,
                0.0632,
                -0.0012,
                -0.1959,
                -0.0133,
                0.0004,
                0.1108,
                -0.0003,
                0.0062,
                0.2593,
                -0.0161,
                -0.0018,
                -0.0051,
                -0.012,
                0.0162,
                0.016,
                -0.0022,
                -0.0052,
                -0.0201,
                0.0101,
                0.0115,
                0.0365,
                -0.024,
                -0.0059,
                0.0188,
                -0.0336,
                0.0352,
                0.0224,
                -0.0229,
                0.0146,
                0.0086,
                -0.0273,
                -0.0032,
                0.0103,
                -0.0112
            ]
        },
        {
            mean: [
                -0.2288,
                0.1541,
                0.7202
            ],
            identity: [
                -0.0082,
                0.0101,
                0.0002,
                0.0036,
                -0.0007,
                -0.0037,
                -0.0008,
                0.0024,
                0.0022,
                -0.0013,
                -0.0045,
                -0.0013,
                -0.0006,
                0.0045,
                -0.0004,
                0.0004,
                0.0012,
                -0.0014,
                0.0042,
                -0.001,
                -0.0007,
                -0.0019,
                0.0003,
                -0.0002,
                0.0012,
                -0.0004,
                -0.0012,
                -0.0018,
                -0.0004,
                -0.0001,
                -0.0014,
                -0.0012,
                0.0001,
                0.0001,
                -0.0017,
                0.001,
                0.0015,
                -0.0001,
                0.0006,
                0.0001,
                0,
                -0.0006,
                0.0028,
                0.0021,
                -0.0025,
                -0.002,
                -0.0015,
                0.0007,
                0.0028,
                -0.0023,
                0.0009,
                0.0013,
                0.0001,
                0.0016,
                0.0012,
                0.0032,
                -0.0006,
                -0.0013,
                -0.0011,
                0.0021,
                0.0003,
                -0.0005,
                -0.0024,
                0.0004,
                -0.0004,
                0.0014,
                0.0015,
                -0.0008,
                -0.0003,
                0.0003,
                0.0017,
                -0.0006,
                0.002,
                -0.0018,
                -0.0003,
                0.0009,
                0.0001,
                0.0002,
                -0.0006,
                -0.0015,
                -0.0004,
                0.0022,
                0.0007,
                -0.0023,
                0,
                -0.0002,
                -0.0002,
                -0.0003,
                -0.0001,
                0.0006,
                -0.0002,
                0.0006,
                0.0022,
                -0.0003,
                0.0013,
                -0.0014,
                -0.0005,
                -0.0003,
                0.0013,
                -0.0027,
                0.0006,
                0.0025,
                -0.0023,
                -0.0008,
                -0.0013,
                0.0017,
                -0.0009,
                -0.0019,
                0.0001,
                0.0008,
                -0.0007,
                -0.0004,
                0,
                0.001,
                -0.001,
                0.0019,
                -0.0008,
                -0.0015,
                -0.0006,
                -0.0002,
                -0.0011,
                0.0008,
                0.0001,
                0.0009,
                -0.0008,
                -0.0004,
                0.0006,
                0.0007,
                0.0021,
                -0.0004,
                0.0007,
                -0.0005,
                0.0021,
                -0.0007,
                -0.0004,
                -0.0009,
                0.0008,
                0.0003,
                0.0001,
                0.0003,
                0.0001,
                0.0009,
                0.001,
                -0.0005,
                0.0005,
                -0.001,
                0.001,
                0.0004,
                -0.0005,
                -0.0012
            ],
            expression: [
                0.0008,
                0.0037,
                0.0078,
                -0.0004,
                0.0005,
                -0.012,
                -0.0002,
                -0.0046,
                0.0033,
                -0.0089,
                0.0295,
                0.0221,
                -0.0024,
                -0.0084,
                0.0013,
                0.0057,
                0.0125,
                0.0049,
                -0.0036,
                0.0373,
                0.0285,
                0.0115,
                0.0135,
                -0.0035,
                0.0048,
                0.0108,
                -0.0033,
                0.0106,
                0.0281,
                -0.0301,
                -0.0082,
                0.0803,
                0.0244,
                -0.0007,
                -0.0725,
                -0.0105,
                -0.0247,
                -0.0036,
                -0.0143,
                -0.0045,
                -0.029,
                0.0002,
                -0.0303,
                0.0093,
                -0.0021,
                -0.0196,
                -0.0754,
                -0.0211,
                0.0326,
                0.1246,
                0.006,
                -0.0804,
                -0.1499,
                0.0109,
                0.0182,
                -0.0029,
                -0.0014,
                -0.0035,
                0.0072,
                -0.0008,
                -0.0152,
                -0.0108,
                -0.0166,
                -0.0073,
                -0.0144,
                -0.0095,
                0.0101,
                0.047,
                -0.0018,
                -0.004,
                -0.0189,
                0.0027,
                0.0104,
                0.0298,
                -0.0042,
                -0.0096,
                0.0191,
                -0.0217,
                0.0228,
                0.0226,
                -0.0105,
                0.0047,
                -0.0048,
                -0.0172,
                0.0061,
                -0.0043,
                -0.0016
            ]
        }
    ],
    2: {
        mean: [
            0.5396,
            0.2028,
            0.2496
        ],
        identity: [
            0.0204,
            0.0146,
            -0.0182,
            -0.0052,
            0.0158,
            -0.0038,
            -0.0025,
            -0.0108,
            -0.006,
            0.0085,
            -0.0044,
            0.0029,
            0.0042,
            0.001,
            0.0095,
            0.0015,
            -0.0034,
            -0.0064,
            -0.0057,
            0.0007,
            0.0026,
            0.0007,
            0.0037,
            -0.0006,
            0.0037,
            0.0026,
            0.0024,
            0.0005,
            -0.0019,
            -0.0013,
            0.003,
            -0.0028,
            0.0018,
            -0.0009,
            0.002,
            -0.0047,
            0.004,
            -0.003,
            0.0031,
            -0.0027,
            -0.0026,
            -0.0017,
            0.0016,
            0.0014,
            -0.0004,
            0.0021,
            -0.002,
            0,
            0.0017,
            0.0007,
            -0.0004,
            -0.0007,
            -0.0018,
            -0.0009,
            0.0002,
            -0.0012,
            0.0001,
            -0.0005,
            -0.0011,
            0.0004,
            0.0002,
            0.0011,
            0.0001,
            0.0008,
            0.0017,
            -0.0013,
            0.0025,
            0.0017,
            0.001,
            0.0002,
            0.0003,
            0.0005,
            -0.0004,
            -0.0001,
            -0.0005,
            0.0007,
            -0.0022,
            -0.0029,
            0.0006,
            -0.0008,
            -0.0006,
            0.0006,
            -0.0005,
            0.0005,
            0.0013,
            0.0003,
            -0.0005,
            -0.003,
            0.0007,
            0.0002,
            0.0016,
            -0.0004,
            0,
            0,
            0.0004,
            0.0001,
            0.0014,
            0.0012,
            0.0001,
            0.0004,
            -0.0001,
            0.0008,
            0.0009,
            0.0004,
            -0.0004,
            0.0009,
            -0.0002,
            0.001,
            0.0009,
            0.0004,
            0.0001,
            0.0007,
            0.0007,
            0.001,
            -0.0017,
            -0.0008,
            0.0002,
            0.0017,
            -0.0003,
            -0.0001,
            0.0004,
            0.0005,
            0.0007,
            0.0005,
            -0.0001,
            -0.0006,
            -0.0001,
            0.0001,
            -0.0003,
            -0.0007,
            -0.0002,
            -0.0005,
            0,
            -0.0003,
            0.0003,
            0.0008,
            -0.0002,
            -0.0003,
            0.0005,
            0.0001,
            -0.0007,
            -0.001,
            -0.0002,
            0.0003,
            0.0004,
            -0.0001,
            0.0007,
            0,
            0.0004,
            0.0004
        ],
        expression: [
            0.0001,
            -0.0004,
            0.0001,
            0,
            0.0005,
            0.0002,
            0,
            0,
            0.0003,
            -0.0002,
            0.0003,
            0.0005,
            -0.0001,
            0.0002,
            0.0008,
            0.0001,
            -0.0002,
            -0.0005,
            -0.0003,
            0.0006,
            0.0005,
            0,
            0.0001,
            0.0002,
            0.0001,
            -0.0001,
            -0.0006,
            -0.0002,
            0.0005,
            0,
            -0.0004,
            0.0004,
            0.0016,
            0.0004,
            -0.0004,
            -0.0015,
            0,
            0.0001,
            0.0001,
            -0.0003,
            0.0003,
            0.0019,
            -0.0002,
            0.0007,
            0.0004,
            0.0004,
            -0.0008,
            -0.0015,
            0.0013,
            -0.0016,
            -0.0069,
            0.0004,
            -0.0006,
            -0.0019,
            0,
            -0.0001,
            0.0005,
            -0.0003,
            0.0002,
            0.0014,
            -0.0003,
            0.0006,
            0.0011,
            0.0004,
            -0.0003,
            -0.0032,
            -0.0006,
            0.0008,
            0.0025,
            -0.0003,
            0.0003,
            0.0015,
            -0.0001,
            0.0001,
            0.0003,
            -0.0001,
            0,
            0,
            -0.0003,
            0.0004,
            0.0019,
            0.0001,
            0,
            -0.0008,
            -0.0001,
            0.0001,
            0.0005
        ]
    },
    3: {
        mean: [
            -0.5464,
            0.2141,
            0.26
        ],
        identity: [
            -0.0207,
            0.0172,
            -0.0176,
            0.0068,
            0.0148,
            -0.0051,
            0.0042,
            -0.0101,
            -0.0058,
            -0.0087,
            -0.0059,
            0.0045,
            -0.0056,
            0.0017,
            0.0097,
            -0.0048,
            -0.004,
            -0.0044,
            0.0019,
            0.0002,
            0.0041,
            -0.0052,
            0.0041,
            0.0002,
            -0.0027,
            0.0006,
            0.002,
            -0.0027,
            -0.0033,
            -0.0006,
            -0.004,
            0.0009,
            -0.0012,
            -0.0001,
            -0.0026,
            0.0021,
            -0.003,
            -0.0025,
            0.0052,
            0.0025,
            0.0022,
            -0.0001,
            -0.0008,
            0.0013,
            0.001,
            0.0004,
            0.0018,
            0.0014,
            0.0006,
            -0.0005,
            -0.0015,
            -0.0039,
            0.0014,
            -0.0001,
            0.0008,
            -0.0002,
            0.0006,
            -0.0005,
            -0.0038,
            -0.0012,
            -0.0018,
            -0.0003,
            0.001,
            0.0009,
            0.0012,
            0.0024,
            -0.0024,
            -0.0007,
            -0.0016,
            -0.0016,
            0.0003,
            -0.001,
            -0.0014,
            -0.0014,
            0.001,
            -0.0003,
            -0.0007,
            -0.0012,
            0.0003,
            0.0006,
            0.0003,
            -0.0005,
            0.0003,
            0.0012,
            0.0006,
            -0.0008,
            0.0004,
            0.0004,
            0.0008,
            -0.0002,
            -0.0014,
            0.0003,
            0,
            0.0023,
            -0.0003,
            -0.0012,
            -0.0013,
            0.0011,
            -0.0002,
            -0.0014,
            -0.0001,
            0.0014,
            0,
            0.0003,
            0.0003,
            -0.0008,
            -0.0005,
            -0.0007,
            -0.0007,
            -0.0002,
            0.0003,
            0.0005,
            0.0002,
            -0.0001,
            0.0011,
            -0.0014,
            0.0001,
            -0.0015,
            -0.0001,
            -0.0003,
            0,
            -0.001,
            -0.0001,
            -0.0008,
            0.0008,
            -0.0008,
            -0.0002,
            -0.0011,
            -0.0003,
            -0.0004,
            0.0001,
            -0.0002,
            0.0003,
            -0.0007,
            0,
            0.0003,
            0.0001,
            -0.0008,
            0.0005,
            0.0001,
            0.0004,
            0.0014,
            -0.0006,
            -0.001,
            -0.0003,
            -0.0002,
            0.0001,
            -0.0001,
            -0.0001,
            0.0007
        ],
        expression: [
            -0.0003,
            -0.0001,
            0.0006,
            0.0004,
            0,
            -0.0007,
            0,
            -0.0003,
            -0.0002,
            -0.0004,
            0.0012,
            0.0008,
            0.0001,
            -0.0005,
            -0.0007,
            -0.0004,
            0,
            0.0001,
            -0.0004,
            0.0017,
            0.0007,
            0,
            0.0001,
            0.0003,
            0,
            0.0004,
            0.0004,
            0.0005,
            0.0001,
            -0.001,
            -0.0007,
            0.0022,
            0.0026,
            0.0005,
            -0.0024,
            -0.0023,
            0,
            0.0001,
            0.0003,
            0,
            -0.0013,
            -0.0015,
            0.0006,
            0.0014,
            0.0008,
            -0.0002,
            -0.0025,
            -0.0023,
            -0.0003,
            0.0049,
            0.006,
            -0.0002,
            -0.0007,
            -0.0002,
            0,
            -0.0019,
            -0.0018,
            -0.0002,
            0.0017,
            0.0017,
            0.0003,
            0.0015,
            0.0007,
            0.0001,
            -0.0023,
            -0.0036,
            0.0002,
            0.0023,
            0.0017,
            0,
            -0.0005,
            -0.0003,
            -0.0003,
            0.0004,
            0.0002,
            -0.0001,
            -0.0003,
            -0.0005,
            0.0001,
            0.0018,
            0.0025,
            0.0001,
            -0.0006,
            -0.0011,
            0,
            0.0001,
            0.0001
        ]
    },
    4: {
        mean: [
            0.0018,
            0.1864,
            0.853
        ],
        identity: [
            -0.0011,
            0.0134,
            0.0085,
            0.0009,
            -0.0025,
            -0.0007,
            -0.0003,
            0.0033,
            0.0004,
            -0.0005,
            -0.0047,
            -0.002,
            0.0007,
            0.0026,
            -0.0069,
            -0.0001,
            0.0036,
            0.0072,
            0.0005,
            -0.0008,
            -0.0047,
            0.0004,
            -0.0008,
            -0.001,
            0,
            0.0002,
            -0.0036,
            -0.0002,
            -0.001,
            -0.0048,
            -0.0001,
            0.0018,
            0.0044,
            -0.0007,
            -0.0002,
            0.0043,
            0.0003,
            0.002,
            -0.0031,
            0,
            -0.0007,
            0.0013,
            0,
            0.0037,
            0.0033,
            -0.0016,
            -0.0012,
            0.002,
            -0.0001,
            -0.0027,
            0.0051,
            0.0005,
            0.0008,
            0.0007,
            -0.0017,
            0.0054,
            0.0023,
            -0.0003,
            0.0032,
            0.0001,
            0,
            0.0007,
            -0.0005,
            -0.0011,
            0.0002,
            0.0008,
            0,
            -0.0033,
            -0.0008,
            -0.0007,
            0.0007,
            0.0033,
            0.0005,
            -0.0003,
            0.0029,
            -0.0001,
            -0.0024,
            -0.0011,
            -0.002,
            -0.0015,
            -0.0019,
            0.0002,
            0.0007,
            0.0031,
            0.0006,
            0.0012,
            0,
            0,
            -0.0021,
            0,
            -0.0009,
            -0.0011,
            -0.0011,
            -0.0002,
            0.0015,
            0.001,
            0.0013,
            0.0008,
            0.001,
            -0.0003,
            0.0009,
            0.0027,
            -0.0002,
            -0.0011,
            -0.0011,
            0.0006,
            0.0007,
            0.0002,
            0.0001,
            -0.0005,
            -0.0022,
            0.0011,
            -0.0014,
            0.0009,
            0.0003,
            0.0002,
            0,
            -0.0006,
            -0.0004,
            -0.0011,
            -0.0007,
            0.001,
            -0.0012,
            0.0006,
            -0.0012,
            -0.0015,
            0.0003,
            -0.0009,
            -0.0013,
            -0.0013,
            0.0007,
            0.001,
            -0.0011,
            -0.0013,
            0.0015,
            0.0004,
            0.0001,
            0.0004,
            -0.0001,
            -0.0016,
            -0.0016,
            0.0009,
            -0.0007,
            -0.0024,
            0.0005,
            -0.0001,
            -0.0017,
            -0.0002,
            0.0003,
            -0.0009
        ],
        expression: [
            -0.0017,
            0.0019,
            0.0097,
            0.003,
            -0.0103,
            -0.0093,
            0.0009,
            0.0006,
            0.0023,
            -0.0017,
            -0.0204,
            0.0376,
            0.0033,
            -0.0034,
            0.0033,
            -0.0026,
            -0.0322,
            0.0396,
            -0.0032,
            -0.0947,
            0.0942,
            -0.0007,
            -0.0175,
            0.0266,
            -0.001,
            -0.0006,
            0.0016,
            0.0025,
            0.0157,
            -0.0142,
            -0.0022,
            0.037,
            0.015,
            0.0021,
            -0.0102,
            -0.0107,
            0.0036,
            0.0055,
            -0.0051,
            0.0021,
            0.0003,
            -0.0003,
            0.0004,
            -0.0177,
            0.0074,
            -0.0006,
            -0.0357,
            0.0149,
            -0.0066,
            0.0009,
            0.0013,
            -0.0031,
            0.0016,
            0.0095,
            0.002,
            0.0052,
            0.0035,
            -0.0003,
            0.0053,
            -0.0082,
            0.002,
            0.0022,
            -0.0071,
            -0.0011,
            0.0005,
            0.0055,
            0.0011,
            0.0003,
            -0.0126,
            -0.0004,
            0.0003,
            -0.0023,
            -0.0015,
            0.0059,
            0.0063,
            -0.0042,
            -0.0023,
            0.0055,
            0.0019,
            0.0017,
            -0.0075,
            0.0006,
            -0.0008,
            0.0018,
            0.0012,
            0.0012,
            -0.0005
        ]
    },
    5: {
        mean: [
            -0.002,
            -0.0469,
            1.0039
        ],
        identity: [
            -0.0017,
            0.0018,
            0.0156,
            0.0006,
            -0.0038,
            0.0005,
            0.0004,
            0.0013,
            0.002,
            -0.0004,
            -0.0015,
            -0.0051,
            0.0005,
            -0.0007,
            -0.0055,
            -0.0001,
            -0.0009,
            0.008,
            -0.0002,
            0.0036,
            -0.0053,
            0.0004,
            -0.0026,
            -0.0016,
            0.0007,
            0.0009,
            -0.009,
            -0.0003,
            0.0007,
            -0.0084,
            0.0015,
            0.0021,
            0.0032,
            -0.0015,
            0.0018,
            0.0046,
            -0.0003,
            -0.0004,
            -0.0001,
            0.0008,
            -0.0044,
            -0.0007,
            -0.0008,
            0.0007,
            0.0048,
            -0.0024,
            -0.0003,
            0.0024,
            0.0002,
            -0.0051,
            0.0058,
            -0.0006,
            0.0028,
            0.0018,
            -0.0021,
            0.0035,
            0.0057,
            0.0011,
            0.0065,
            0,
            -0.0002,
            0.0011,
            0.003,
            -0.0027,
            0.0008,
            0.0007,
            0.0003,
            -0.0039,
            -0.002,
            -0.0002,
            -0.0015,
            0.0034,
            0.0012,
            -0.0025,
            0.0024,
            -0.0002,
            0.0004,
            -0.0042,
            -0.0024,
            -0.001,
            -0.0023,
            0.0016,
            -0.0007,
            0.0039,
            0.0001,
            -0.0005,
            0.0018,
            0.0003,
            -0.0002,
            -0.0009,
            -0.0015,
            0.0003,
            -0.0007,
            -0.0001,
            -0.0002,
            0.0023,
            0.0032,
            0.002,
            -0.0013,
            0.0013,
            -0.0038,
            0.0045,
            0.0001,
            -0.0031,
            0.0001,
            0.0019,
            -0.0001,
            0.0016,
            0.0013,
            0,
            -0.002,
            0.0023,
            0.0002,
            0.0011,
            0.0018,
            -0.0024,
            0.0006,
            -0.0017,
            0.002,
            -0.0008,
            -0.0021,
            0.0007,
            0.0011,
            0.0008,
            0.0004,
            -0.001,
            0.0012,
            0.0002,
            -0.0006,
            -0.0027,
            -0.0005,
            0.001,
            -0.0009,
            0.0001,
            -0.0001,
            0.0008,
            -0.0011,
            0.0022,
            -0.001,
            -0.0005,
            -0.0011,
            0.0016,
            -0.0015,
            0.0008,
            -0.0003,
            0.0009,
            0.0013,
            -0.0007,
            -0.0007,
            -0.0002
        ],
        expression: [
            -0.0018,
            -0.0168,
            0.0088,
            0.0389,
            0.1026,
            0.0414,
            0.2201,
            -0.0262,
            -0.0016,
            -0.0017,
            0.0612,
            -0.0298,
            -0.0323,
            0.0093,
            0.0013,
            -0.005,
            0.2207,
            0.1315,
            -0.0004,
            0.0858,
            -0.0303,
            -0.0133,
            0.015,
            -0.008,
            0.1454,
            0.0114,
            0.0177,
            -0.0077,
            0.1022,
            0.0356,
            -0.0023,
            0.1088,
            0.0232,
            0.003,
            -0.0706,
            0.0347,
            -0.0001,
            0.004,
            -0.0011,
            0.0397,
            -0.0096,
            -0.0033,
            0.0029,
            -0.01,
            -0.0083,
            -0.0006,
            -0.0135,
            0.0016,
            -0.0087,
            -0.0019,
            0.0022,
            -0.004,
            -0.0087,
            0.0105,
            0.0008,
            -0.005,
            0.0069,
            0.0028,
            0.0409,
            -0.0391,
            0.003,
            0.0103,
            0.0051,
            0.0026,
            0.0776,
            -0.0083,
            -0.0062,
            -0.0567,
            0.0268,
            0.0175,
            0.0017,
            0.0156,
            -0.0043,
            0.0299,
            -0.0395,
            -0.0015,
            0.0051,
            -0.0148,
            0.0125,
            0.0035,
            0.0603,
            0.0109,
            -0.0645,
            -0.0257,
            0.002,
            0.0006,
            -0.0008
        ]
    },
    6: {
        mean: [
            -0.0006,
            -0.1542,
            0.8789
        ],
        identity: [
            -0.0007,
            -0.0032,
            0.01,
            0,
            -0.0027,
            0.0031,
            0.0006,
            0.0005,
            -0.0006,
            -0.0003,
            0.0013,
            -0.0049,
            -0.0002,
            -0.002,
            -0.0046,
            0.0008,
            -0.0011,
            0.0054,
            0.0002,
            0.0043,
            -0.0027,
            0.0003,
            -0.0022,
            -0.0019,
            0.0008,
            0.0032,
            -0.0069,
            0,
            0.0004,
            -0.0071,
            0.0016,
            0.0027,
            0.0039,
            -0.0017,
            0.0009,
            0.0031,
            -0.0001,
            -0.0005,
            -0.0004,
            0.0007,
            -0.0026,
            -0.0012,
            -0.0005,
            0.0006,
            0.0002,
            -0.0014,
            -0.0013,
            0.0019,
            -0.0002,
            -0.0053,
            0.0031,
            -0.0006,
            0.0016,
            0.0023,
            -0.0013,
            0.0021,
            0.0029,
            0.0008,
            0.0052,
            0,
            0.0004,
            0,
            0.0037,
            -0.0026,
            0.0003,
            0.002,
            -0.0002,
            -0.0024,
            0.0004,
            -0.0004,
            -0.0012,
            0.0008,
            0.0007,
            -0.0023,
            0.0005,
            0,
            0.0014,
            -0.0022,
            -0.0016,
            0,
            -0.0012,
            0.0008,
            -0.0007,
            0.0014,
            -0.0006,
            -0.0012,
            -0.0003,
            0.0002,
            0.0012,
            -0.0003,
            -0.002,
            -0.0001,
            0.0001,
            -0.0002,
            -0.0016,
            0.0009,
            0.002,
            0.0019,
            0,
            0.0006,
            -0.0022,
            0.0016,
            0.0001,
            -0.0017,
            -0.0013,
            0.001,
            0.0009,
            -0.0001,
            0.0011,
            0.0003,
            -0.0007,
            0.0014,
            0.0008,
            0.0013,
            0.0011,
            -0.002,
            0,
            -0.0015,
            0.0014,
            0.001,
            -0.0015,
            0.0007,
            0.0003,
            0.001,
            -0.0001,
            0.0012,
            0.0007,
            0.0006,
            -0.0004,
            -0.0013,
            -0.0012,
            -0.0009,
            -0.0011,
            0.0002,
            -0.0005,
            0.0005,
            0.0004,
            0.0002,
            0.0001,
            0,
            0.0005,
            0.0005,
            -0.0014,
            0.0015,
            -0.0009,
            0.0005,
            0.0014,
            -0.0008,
            -0.0008,
            0.0012
        ],
        expression: [
            0.0008,
            0.0481,
            0.1653,
            0.0784,
            0.1008,
            -0.3992,
            0.5088,
            -0.02,
            0.0542,
            0.001,
            0.3723,
            -0.0151,
            -0.0986,
            0.0283,
            -0.0033,
            -0.0121,
            0.2634,
            0.1202,
            0.0036,
            -0.0529,
            -0.0245,
            -0.0297,
            -0.1085,
            0.0495,
            0.3264,
            0.0083,
            0.0004,
            -0.0314,
            0.1459,
            -0.1142,
            -0.003,
            0.0001,
            0.1154,
            -0.0035,
            -0.0285,
            -0.0184,
            -0.0001,
            0.0012,
            0.0035,
            0.079,
            -0.0103,
            0.0043,
            0.011,
            -0.004,
            -0.0774,
            -0.0047,
            -0.023,
            0.0284,
            -0.0048,
            -0.001,
            0.0149,
            -0.0039,
            0.0046,
            0.0528,
            -0.0006,
            0.0063,
            0.0376,
            0.0096,
            0.0558,
            -0.0295,
            0,
            -0.0311,
            -0.0634,
            0.0062,
            0.0176,
            -0.0154,
            -0.0109,
            -0.1149,
            0.0192,
            0.0326,
            0.0121,
            0.0237,
            0.0034,
            0.0262,
            -0.0778,
            0.0014,
            -0.0045,
            -0.0203,
            0.0077,
            0.0588,
            0.0575,
            0.008,
            -0.0557,
            -0.0095,
            0.0032,
            0.0054,
            -0.0042
        ]
    },
    7: {
        mean: [
            0.0038,
            -0.2927,
            0.833
        ],
        identity: [
            0.0006,
            -0.0109,
            0.0073,
            -0.0006,
            -0.0044,
            0.0017,
            -0.0001,
            -0.0022,
            -0.0006,
            -0.0003,
            0.0065,
            -0.0014,
            -0.0006,
            -0.0051,
            -0.0046,
            0.0003,
            -0.0029,
            0.003,
            0.0002,
            0.0038,
            -0.0006,
            0,
            -0.0012,
            0.0006,
            -0.0004,
            0.0053,
            -0.0075,
            -0.0002,
            -0.0007,
            -0.0063,
            0.0014,
            0.0026,
            0.0019,
            -0.0022,
            0.0018,
            0.0028,
            -0.0001,
            -0.0012,
            0.0011,
            0.0009,
            0.0019,
            -0.0019,
            -0.0001,
            0.0012,
            -0.0022,
            -0.0003,
            -0.0012,
            0.0004,
            -0.0008,
            0.0003,
            -0.0003,
            0,
            0.0017,
            0.0021,
            -0.0004,
            0.0012,
            0.0022,
            -0.0003,
            0.0026,
            -0.0003,
            0.0004,
            -0.0026,
            0.0032,
            -0.0019,
            0.0003,
            0.0015,
            0.0001,
            -0.0015,
            0.0013,
            -0.0001,
            0.0001,
            -0.0029,
            0,
            -0.0002,
            -0.0028,
            -0.0007,
            0.0019,
            -0.0003,
            -0.0002,
            0.0012,
            0.0009,
            0.0004,
            -0.001,
            -0.002,
            -0.0016,
            0.0011,
            -0.0001,
            0.0003,
            0.0021,
            0.0002,
            -0.0014,
            -0.0009,
            -0.0001,
            0,
            -0.0002,
            -0.001,
            0.0015,
            0.0018,
            0.0001,
            0.0007,
            0.0008,
            0.0017,
            0.001,
            -0.0009,
            0.0001,
            0.0004,
            0.0023,
            -0.0001,
            0.0012,
            0.0001,
            -0.0008,
            0.0002,
            0.0018,
            0.0006,
            0.0003,
            0.0001,
            0.0012,
            -0.0003,
            0.002,
            -0.0006,
            0,
            -0.0001,
            -0.0022,
            0.0004,
            0.0005,
            0.0011,
            0.0002,
            -0.0013,
            -0.0023,
            0.0006,
            0.0006,
            -0.0005,
            -0.0005,
            0.0009,
            0.0002,
            0.0002,
            0.0011,
            -0.0003,
            0.0011,
            0.0015,
            0.0011,
            0.0003,
            0.0002,
            0.0008,
            -0.0004,
            -0.0008,
            0.0003,
            0,
            0.0012,
            -0.0001
        ],
        expression: [
            0.026,
            0.1107,
            0.3257,
            0.1917,
            0.3206,
            -1.1348,
            1.0791,
            -0.035,
            0.1549,
            -0.0103,
            0.6953,
            0.0001,
            -0.3262,
            0.068,
            0.0219,
            -0.0044,
            0.3643,
            0.2178,
            0.0168,
            -0.2478,
            -0.1321,
            -0.0414,
            -0.3782,
            -0.0617,
            0.5088,
            -0.0031,
            -0.0311,
            -0.0497,
            0.0948,
            -0.385,
            0.0148,
            -0.2224,
            -0.1415,
            -0.0074,
            0.0863,
            -0.203,
            0.0003,
            -0.0081,
            0.0057,
            0.1164,
            -0.0039,
            0.0015,
            -0.0024,
            0.0505,
            0.1532,
            0.0039,
            -0.0148,
            -0.0753,
            0.0163,
            0.0058,
            -0.0339,
            0.0036,
            0.0252,
            -0.0569,
            -0.0041,
            0.0163,
            -0.0361,
            0.0035,
            -0.018,
            0.1266,
            0,
            -0.0163,
            -0.0046,
            0.0133,
            -0.1656,
            0.2134,
            0.0191,
            0.0057,
            0.0734,
            0.0681,
            0.0039,
            -0.0144,
            0.029,
            -0.074,
            -0.046,
            0.0122,
            0.0072,
            -0.0162,
            -0.0349,
            -0.1234,
            0.0212,
            -0.0355,
            0.0535,
            0.1218,
            0.0043,
            -0.024,
            0.0016
        ]
    },
    8: {
        mean: [
            -0.0018,
            -0.3037,
            0.8491
        ],
        identity: [
            0.0002,
            -0.0112,
            0.0077,
            -0.0004,
            -0.0044,
            0.0024,
            0.0001,
            -0.0021,
            -0.0004,
            -0.0004,
            0.0066,
            -0.002,
            -0.0004,
            -0.0052,
            -0.0044,
            0.0003,
            -0.0032,
            0.0039,
            0.0004,
            0.0042,
            -0.0003,
            0.0002,
            -0.0012,
            -0.0002,
            -0.0002,
            0.0052,
            -0.0083,
            -0.0001,
            -0.0008,
            -0.0056,
            0.0017,
            0.0024,
            0.0019,
            -0.0023,
            0.002,
            0.0027,
            -0.0002,
            -0.0013,
            0.002,
            0.0009,
            0.0017,
            -0.0028,
            -0.0002,
            0.0012,
            -0.0026,
            0,
            -0.0016,
            0.0002,
            -0.0005,
            0.0003,
            -0.001,
            -0.0001,
            0.0016,
            0.0016,
            -0.0003,
            0.0012,
            0.0012,
            -0.0003,
            0.0027,
            -0.0003,
            0.0003,
            -0.0026,
            0.0037,
            -0.0017,
            0.0001,
            0.0016,
            0.0001,
            -0.0015,
            0.0024,
            0.0001,
            0.0002,
            -0.0039,
            0,
            -0.0003,
            -0.0033,
            -0.0006,
            0.0017,
            -0.0004,
            -0.0004,
            0.0012,
            0.0018,
            0.0002,
            -0.0012,
            -0.002,
            -0.0017,
            0.0013,
            -0.001,
            0.0003,
            0.0021,
            0.0004,
            -0.0012,
            -0.0006,
            -0.0002,
            0,
            -0.0004,
            -0.0009,
            0.0016,
            0.0017,
            0.0004,
            0.0007,
            0.0007,
            0.001,
            0.0009,
            -0.0008,
            0.0005,
            0.0005,
            0.0023,
            0.001,
            0.0013,
            0.0002,
            -0.0004,
            0.0002,
            0.0017,
            0.0008,
            0.0003,
            -0.0001,
            0.0009,
            -0.0004,
            0.0019,
            -0.0005,
            0.0003,
            0,
            -0.0025,
            0.0003,
            0.0003,
            0.0011,
            0.0001,
            -0.0015,
            -0.001,
            0.0007,
            0.0007,
            -0.0007,
            -0.0007,
            0.0008,
            0,
            0.0001,
            0.0013,
            -0.0004,
            0.0012,
            0.0014,
            0.0017,
            0.0004,
            0.0002,
            0.0003,
            -0.0003,
            -0.0009,
            0.0001,
            0,
            0.001,
            -0.0004
        ],
        expression: [
            -0.0092,
            2.8809,
            1.416,
            0.2018,
            1.1982,
            -0.9351,
            1.4492,
            -0.1902,
            0.1749,
            0.0305,
            -0.167,
            -0.1572,
            -0.7354,
            -0.0492,
            0.0115,
            0.0608,
            0.2971,
            0.1179,
            0.0046,
            -0.0997,
            -0.0041,
            -0.0104,
            0.3379,
            -0.1854,
            0.009,
            0.0366,
            -0.0583,
            0.0269,
            -0.0029,
            -0.4175,
            -0.0008,
            0.1794,
            0.0752,
            -0.0135,
            0.1158,
            0.1234,
            0.0005,
            0.003,
            -0.0032,
            0.1034,
            -0.0504,
            -0.0055,
            -0.0076,
            -0.0772,
            0.224,
            0.0047,
            0.0229,
            -0.1044,
            0.0162,
            -0.0161,
            -0.0241,
            -0.0083,
            -0.1388,
            -0.0434,
            -0.0125,
            -0.0997,
            -0.0327,
            -0.0111,
            0.1576,
            -0.3911,
            0.0199,
            0.2522,
            0.142,
            0.0059,
            -0.0721,
            -0.0045,
            0.031,
            -0.1136,
            -0.1685,
            0.0641,
            0.0142,
            0.0312,
            0.0426,
            -0.1366,
            0.1011,
            0.0101,
            -0.0157,
            0.0018,
            -0.0103,
            -0.0344,
            0.0907,
            0.0016,
            0.1168,
            -0.0806,
            0.0104,
            -0.0057,
            0.0111
        ]
    },
    9: [
        {
            mean: [
                0.0038,
                -0.2927,
                0.833
            ],
            identity: [
                0.0006,
                -0.0109,
                0.0073,
                -0.0006,
                -0.0044,
                0.0017,
                -0.0001,
                -0.0022,
                -0.0006,
                -0.0003,
                0.0065,
                -0.0014,
                -0.0006,
                -0.0051,
                -0.0046,
                0.0003,
                -0.0029,
                0.003,
                0.0002,
                0.0038,
                -0.0006,
                0,
                -0.0012,
                0.0006,
                -0.0004,
                0.0053,
                -0.0075,
                -0.0002,
                -0.0007,
                -0.0063,
                0.0014,
                0.0026,
                0.0019,
                -0.0022,
                0.0018,
                0.0028,
                -0.0001,
                -0.0012,
                0.0011,
                0.0009,
                0.0019,
                -0.0019,
                -0.0001,
                0.0012,
                -0.0022,
                -0.0003,
                -0.0012,
                0.0004,
                -0.0008,
                0.0003,
                -0.0003,
                0,
                0.0017,
                0.0021,
                -0.0004,
                0.0012,
                0.0022,
                -0.0003,
                0.0026,
                -0.0003,
                0.0004,
                -0.0026,
                0.0032,
                -0.0019,
                0.0003,
                0.0015,
                0.0001,
                -0.0015,
                0.0013,
                -0.0001,
                0.0001,
                -0.0029,
                0,
                -0.0002,
                -0.0028,
                -0.0007,
                0.0019,
                -0.0003,
                -0.0002,
                0.0012,
                0.0009,
                0.0004,
                -0.001,
                -0.002,
                -0.0016,
                0.0011,
                -0.0001,
                0.0003,
                0.0021,
                0.0002,
                -0.0014,
                -0.0009,
                -0.0001,
                0,
                -0.0002,
                -0.001,
                0.0015,
                0.0018,
                0.0001,
                0.0007,
                0.0008,
                0.0017,
                0.001,
                -0.0009,
                0.0001,
                0.0004,
                0.0023,
                -0.0001,
                0.0012,
                0.0001,
                -0.0008,
                0.0002,
                0.0018,
                0.0006,
                0.0003,
                0.0001,
                0.0012,
                -0.0003,
                0.002,
                -0.0006,
                0,
                -0.0001,
                -0.0022,
                0.0004,
                0.0005,
                0.0011,
                0.0002,
                -0.0013,
                -0.0023,
                0.0006,
                0.0006,
                -0.0005,
                -0.0005,
                0.0009,
                0.0002,
                0.0002,
                0.0011,
                -0.0003,
                0.0011,
                0.0015,
                0.0011,
                0.0003,
                0.0002,
                0.0008,
                -0.0004,
                -0.0008,
                0.0003,
                0,
                0.0012,
                -0.0001
            ],
            expression: [
                0.026,
                0.1107,
                0.3257,
                0.1917,
                0.3206,
                -1.1348,
                1.0791,
                -0.035,
                0.1549,
                -0.0103,
                0.6953,
                0.0001,
                -0.3262,
                0.068,
                0.0219,
                -0.0044,
                0.3643,
                0.2178,
                0.0168,
                -0.2478,
                -0.1321,
                -0.0414,
                -0.3782,
                -0.0617,
                0.5088,
                -0.0031,
                -0.0311,
                -0.0497,
                0.0948,
                -0.385,
                0.0148,
                -0.2224,
                -0.1415,
                -0.0074,
                0.0863,
                -0.203,
                0.0003,
                -0.0081,
                0.0057,
                0.1164,
                -0.0039,
                0.0015,
                -0.0024,
                0.0505,
                0.1532,
                0.0039,
                -0.0148,
                -0.0753,
                0.0163,
                0.0058,
                -0.0339,
                0.0036,
                0.0252,
                -0.0569,
                -0.0041,
                0.0163,
                -0.0361,
                0.0035,
                -0.018,
                0.1266,
                0,
                -0.0163,
                -0.0046,
                0.0133,
                -0.1656,
                0.2134,
                0.0191,
                0.0057,
                0.0734,
                0.0681,
                0.0039,
                -0.0144,
                0.029,
                -0.074,
                -0.046,
                0.0122,
                0.0072,
                -0.0162,
                -0.0349,
                -0.1234,
                0.0212,
                -0.0355,
                0.0535,
                0.1218,
                0.0043,
                -0.024,
                0.0016
            ]
        },
        {
            mean: [
                -0.0018,
                -0.3037,
                0.8491
            ],
            identity: [
                0.0002,
                -0.0112,
                0.0077,
                -0.0004,
                -0.0044,
                0.0024,
                0.0001,
                -0.0021,
                -0.0004,
                -0.0004,
                0.0066,
                -0.002,
                -0.0004,
                -0.0052,
                -0.0044,
                0.0003,
                -0.0032,
                0.0039,
                0.0004,
                0.0042,
                -0.0003,
                0.0002,
                -0.0012,
                -0.0002,
                -0.0002,
                0.0052,
                -0.0083,
                -0.0001,
                -0.0008,
                -0.0056,
                0.0017,
                0.0024,
                0.0019,
                -0.0023,
                0.002,
                0.0027,
                -0.0002,
                -0.0013,
                0.002,
                0.0009,
                0.0017,
                -0.0028,
                -0.0002,
                0.0012,
                -0.0026,
                0,
                -0.0016,
                0.0002,
                -0.0005,
                0.0003,
                -0.001,
                -0.0001,
                0.0016,
                0.0016,
                -0.0003,
                0.0012,
                0.0012,
                -0.0003,
                0.0027,
                -0.0003,
                0.0003,
                -0.0026,
                0.0037,
                -0.0017,
                0.0001,
                0.0016,
                0.0001,
                -0.0015,
                0.0024,
                0.0001,
                0.0002,
                -0.0039,
                0,
                -0.0003,
                -0.0033,
                -0.0006,
                0.0017,
                -0.0004,
                -0.0004,
                0.0012,
                0.0018,
                0.0002,
                -0.0012,
                -0.002,
                -0.0017,
                0.0013,
                -0.001,
                0.0003,
                0.0021,
                0.0004,
                -0.0012,
                -0.0006,
                -0.0002,
                0,
                -0.0004,
                -0.0009,
                0.0016,
                0.0017,
                0.0004,
                0.0007,
                0.0007,
                0.001,
                0.0009,
                -0.0008,
                0.0005,
                0.0005,
                0.0023,
                0.001,
                0.0013,
                0.0002,
                -0.0004,
                0.0002,
                0.0017,
                0.0008,
                0.0003,
                -0.0001,
                0.0009,
                -0.0004,
                0.0019,
                -0.0005,
                0.0003,
                0,
                -0.0025,
                0.0003,
                0.0003,
                0.0011,
                0.0001,
                -0.0015,
                -0.001,
                0.0007,
                0.0007,
                -0.0007,
                -0.0007,
                0.0008,
                0,
                0.0001,
                0.0013,
                -0.0004,
                0.0012,
                0.0014,
                0.0017,
                0.0004,
                0.0002,
                0.0003,
                -0.0003,
                -0.0009,
                0.0001,
                0,
                0.001,
                -0.0004
            ],
            expression: [
                -0.0092,
                2.8809,
                1.416,
                0.2018,
                1.1982,
                -0.9351,
                1.4492,
                -0.1902,
                0.1749,
                0.0305,
                -0.167,
                -0.1572,
                -0.7354,
                -0.0492,
                0.0115,
                0.0608,
                0.2971,
                0.1179,
                0.0046,
                -0.0997,
                -0.0041,
                -0.0104,
                0.3379,
                -0.1854,
                0.009,
                0.0366,
                -0.0583,
                0.0269,
                -0.0029,
                -0.4175,
                -0.0008,
                0.1794,
                0.0752,
                -0.0135,
                0.1158,
                0.1234,
                0.0005,
                0.003,
                -0.0032,
                0.1034,
                -0.0504,
                -0.0055,
                -0.0076,
                -0.0772,
                0.224,
                0.0047,
                0.0229,
                -0.1044,
                0.0162,
                -0.0161,
                -0.0241,
                -0.0083,
                -0.1388,
                -0.0434,
                -0.0125,
                -0.0997,
                -0.0327,
                -0.0111,
                0.1576,
                -0.3911,
                0.0199,
                0.2522,
                0.142,
                0.0059,
                -0.0721,
                -0.0045,
                0.031,
                -0.1136,
                -0.1685,
                0.0641,
                0.0142,
                0.0312,
                0.0426,
                -0.1366,
                0.1011,
                0.0101,
                -0.0157,
                0.0018,
                -0.0103,
                -0.0344,
                0.0907,
                0.0016,
                0.1168,
                -0.0806,
                0.0104,
                -0.0057,
                0.0111
            ]
        }
    ],
    10: {
        mean: [
            -0.007,
            -0.6338,
            0.7695
        ],
        identity: [
            0.0001,
            -0.0296,
            0.0089,
            -0.0006,
            -0.0073,
            -0.0065,
            -0.0001,
            -0.0029,
            -0.0031,
            -0.0002,
            0.0128,
            0.0065,
            0,
            -0.0116,
            -0.014,
            -0.0001,
            -0.0037,
            -0.0052,
            -0.0005,
            0.0028,
            0.003,
            -0.0004,
            0.0041,
            0.0015,
            0.0006,
            0.0088,
            -0.0076,
            -0.0011,
            -0.0015,
            -0.0073,
            0.0007,
            -0.0011,
            0.0019,
            -0.0011,
            -0.0005,
            0.0031,
            -0.0001,
            -0.0018,
            0.0009,
            0.0018,
            0.0038,
            0.0068,
            -0.0004,
            -0.0001,
            0.0061,
            0.0024,
            0.0024,
            -0.0066,
            -0.0006,
            0.0051,
            0.0014,
            0.002,
            0.005,
            -0.0035,
            0.0001,
            -0.0034,
            -0.004,
            -0.0007,
            0.001,
            -0.0008,
            0.0001,
            -0.0005,
            -0.0021,
            0.0002,
            0.0045,
            -0.0043,
            -0.0012,
            -0.0024,
            -0.0014,
            0.0006,
            0.0034,
            0.0027,
            -0.0008,
            -0.0053,
            0.0014,
            0.0001,
            0.0013,
            -0.0018,
            0.0006,
            -0.0015,
            0.0029,
            -0.0002,
            -0.0035,
            0.0001,
            -0.002,
            0.0012,
            0.0048,
            0.0011,
            0.0001,
            -0.0002,
            -0.0003,
            -0.0012,
            0.0033,
            0.0006,
            0.002,
            -0.0033,
            0.0004,
            0.0028,
            0.0002,
            0.0008,
            -0.0001,
            -0.0018,
            0.0008,
            0.0017,
            0.0001,
            0.0009,
            0.0008,
            0.0003,
            0.0019,
            -0.001,
            0.001,
            -0.0007,
            -0.0013,
            0,
            0.0001,
            0.0032,
            -0.0001,
            0.0001,
            0.0011,
            -0.0004,
            0.0005,
            -0.0007,
            0.0018,
            -0.0003,
            0.0002,
            0.0007,
            0.0008,
            -0.0014,
            0.0007,
            0.0015,
            -0.0006,
            -0.0001,
            -0.0004,
            0.0019,
            -0.0009,
            -0.0006,
            -0.0006,
            -0.0012,
            0.0002,
            -0.0012,
            -0.0008,
            0.0004,
            0.0006,
            -0.0011,
            0.0003,
            0.0009,
            -0.0004,
            0.0006,
            -0.0007,
            -0.0004
        ],
        expression: [
            -0.0603,
            2.0527,
            1.9014,
            0.1025,
            0.6143,
            0.3804,
            0.7881,
            -0.1023,
            -0.0764,
            0.0454,
            -0.2487,
            -0.5073,
            -0.6704,
            -0.031,
            -0.0181,
            0.0466,
            0.0651,
            -0.0726,
            -0.0033,
            -0.0022,
            0.2944,
            0.0101,
            0.1669,
            -0.5225,
            -0.4685,
            0.0236,
            0.0079,
            0.011,
            0.2173,
            0.4529,
            0.0121,
            -0.2104,
            -0.0673,
            0.0225,
            -0.4023,
            0.0317,
            -0.0009,
            0.0076,
            -0.0032,
            0.0333,
            0.0523,
            0.0129,
            -0.001,
            -0.0319,
            -0.0139,
            0.0015,
            -0.0044,
            0.0247,
            -0.0005,
            0.0161,
            0.0061,
            0.0074,
            0.0776,
            -0.0176,
            0.007,
            0.055,
            -0.017,
            0.0052,
            -0.1819,
            0.0294,
            -0.0161,
            -0.0337,
            0.0226,
            -0.008,
            -0.0297,
            0.1967,
            -0.0095,
            0.0383,
            0.2039,
            0.0434,
            0.0271,
            -0.0064,
            -0.0037,
            -0.0294,
            -0.024,
            0.0024,
            -0.0137,
            -0.0209,
            -0.0031,
            0.0628,
            0.1003,
            -0.0126,
            -0.056,
            -0.0097,
            -0.0012,
            -0.0041,
            0.0162
        ]
    },
    11: {
        mean: [
            0.2505,
            0.3833,
            0.7793
        ],
        identity: [
            0.0098,
            0.012,
            0.0077,
            -0.0006,
            -0.0003,
            0,
            0.0001,
            0.0082,
            -0.0007,
            0.0019,
            -0.0036,
            -0.0012,
            0.0002,
            0.0119,
            -0.0039,
            0.001,
            0.0001,
            0.0031,
            -0.0036,
            -0.0059,
            -0.0007,
            0.0026,
            0.0028,
            -0.0011,
            0.0009,
            -0.0032,
            0.0008,
            0.0029,
            0.0043,
            0.0003,
            0.0025,
            -0.0009,
            0.0047,
            0.0016,
            0.0022,
            0.0018,
            -0.001,
            0.0025,
            -0.003,
            -0.001,
            0.0033,
            0.0034,
            0.0004,
            -0.0052,
            0.0024,
            -0.0002,
            0.001,
            -0.0014,
            -0.0006,
            0.0038,
            -0.0015,
            -0.0006,
            -0.001,
            -0.0011,
            -0.0004,
            -0.001,
            0.0004,
            -0.0007,
            0.0036,
            -0.0008,
            -0.0002,
            -0.0019,
            0.0005,
            0.0003,
            -0.0006,
            -0.0024,
            -0.0017,
            -0.0014,
            0.0006,
            -0.0004,
            -0.0031,
            -0.0013,
            -0.0006,
            0.0042,
            0.0002,
            -0.0002,
            -0.002,
            -0.0003,
            0.0008,
            0.0018,
            -0.0005,
            -0.0006,
            -0.0002,
            -0.0006,
            0.0025,
            0.0019,
            0.001,
            0.0008,
            -0.0015,
            -0.0012,
            -0.0001,
            -0.0006,
            -0.0004,
            0.0023,
            -0.001,
            0.0006,
            -0.0002,
            -0.001,
            0,
            -0.0009,
            -0.002,
            -0.0011,
            0.0001,
            0,
            -0.0001,
            0.0005,
            0.0006,
            0.0009,
            -0.0006,
            0.0005,
            0.0008,
            -0.0001,
            -0.0002,
            -0.0017,
            -0.0006,
            -0.0004,
            0.0004,
            -0.0006,
            0.0012,
            0.0004,
            0.0003,
            -0.0007,
            0.0003,
            -0.0002,
            0.0006,
            0.0001,
            0.0005,
            -0.0019,
            -0.0006,
            0.0004,
            0.0007,
            -0.0001,
            0.0001,
            0.0005,
            0.001,
            -0.0006,
            -0.002,
            -0.0007,
            -0.0005,
            0.0005,
            0.0003,
            0.0007,
            0.0014,
            0,
            0.0005,
            -0.0005,
            -0.0002,
            0.0003,
            -0.0006,
            -0.0001
        ],
        expression: [
            -0.0009,
            -0.0003,
            0.0032,
            -0.003,
            -0.0034,
            -0.0031,
            0.0014,
            0,
            0.0004,
            -0.0139,
            -0.0764,
            0.0275,
            -0.002,
            -0.0089,
            0.0031,
            -0.0503,
            -0.0771,
            0.038,
            -0.1323,
            -0.3523,
            0.1368,
            -0.0474,
            -0.0564,
            0.0296,
            -0.0045,
            0.007,
            -0.0013,
            0.0153,
            0.1259,
            -0.0464,
            0.0866,
            0.2175,
            -0.0786,
            -0.0413,
            -0.1248,
            0.0448,
            -0.1777,
            -0.4607,
            0.1782,
            -0.0005,
            -0.005,
            0.0016,
            0.0629,
            0.1506,
            -0.0624,
            0.0545,
            0.2576,
            -0.0864,
            -0.0231,
            -0.0552,
            0.0244,
            -0.0136,
            -0.0359,
            0.0169,
            -0.1158,
            -0.2996,
            0.1214,
            -0.0235,
            -0.0354,
            0.0165,
            -0.0745,
            -0.1079,
            0.0475,
            -0.0116,
            -0.0039,
            0.0012,
            0.0013,
            -0.0108,
            -0.0008,
            0.0044,
            -0.0027,
            -0.0001,
            -0.0694,
            0.0363,
            0.0071,
            0.1462,
            -0.136,
            0.0047,
            0.009,
            -0.0177,
            0.0038,
            -0.0271,
            0.0118,
            0.0011,
            -0.0399,
            -0.0111,
            0.0123
        ]
    },
    12: {
        mean: [
            -0.2981,
            0.3828,
            0.7563
        ],
        identity: [
            -0.0116,
            0.014,
            0.0054,
            0.0018,
            0.0005,
            0,
            -0.0004,
            0.0068,
            -0.0013,
            -0.0019,
            -0.0048,
            -0.0005,
            0.0005,
            0.0108,
            -0.0036,
            -0.0029,
            -0.0018,
            0.0029,
            0.0043,
            -0.0077,
            0.0006,
            -0.0017,
            0.002,
            -0.0011,
            -0.0014,
            -0.0035,
            0.0015,
            -0.0024,
            0.0011,
            0.0004,
            -0.0048,
            0.0002,
            0.0029,
            -0.0001,
            -0.0001,
            0.003,
            0.0019,
            0.0035,
            -0.0016,
            -0.0004,
            0.0039,
            0.0019,
            0.0001,
            -0.0064,
            0.004,
            0.0003,
            0.002,
            -0.0021,
            0.0017,
            0.0011,
            -0.001,
            0.0026,
            0.0025,
            -0.0005,
            0.0002,
            -0.0003,
            -0.0005,
            -0.0007,
            0.0009,
            -0.0004,
            -0.001,
            -0.0022,
            0.001,
            0.0009,
            -0.0014,
            0.0007,
            0.0011,
            -0.001,
            -0.0005,
            -0.0008,
            -0.0017,
            -0.0021,
            0.0009,
            0.0036,
            0.0005,
            0.0004,
            -0.0031,
            0.0006,
            -0.0015,
            0.0027,
            0.0002,
            0.0001,
            -0.0011,
            0.0002,
            -0.0011,
            -0.0018,
            0.0004,
            -0.0013,
            -0.0002,
            0.0007,
            0.0009,
            -0.0003,
            0.001,
            -0.0021,
            0.0008,
            0.0006,
            -0.0009,
            0.0004,
            -0.0007,
            0.0008,
            -0.002,
            -0.0013,
            0,
            0.0007,
            -0.0012,
            -0.0001,
            0.0014,
            0.0014,
            -0.0001,
            0.0013,
            0.0006,
            0.0006,
            -0.0014,
            -0.0015,
            -0.0009,
            0.0001,
            0.0001,
            0.0009,
            0.0007,
            0,
            0.0001,
            -0.001,
            -0.0004,
            0,
            -0.0005,
            0.0001,
            -0.0003,
            0.0004,
            -0.0005,
            -0.0001,
            -0.0011,
            0.0002,
            0,
            0.0001,
            0.0008,
            0.0008,
            0,
            -0.0007,
            -0.0008,
            0,
            0.0002,
            -0.0001,
            0.001,
            0.0003,
            0.0004,
            -0.0002,
            0,
            0.0005,
            0.0018,
            -0.0001
        ],
        expression: [
            0,
            -0.0004,
            0.0028,
            0.0036,
            -0.0008,
            -0.0026,
            -0.0015,
            -0.0008,
            0.0003,
            0.0075,
            -0.0608,
            0.025,
            0.0019,
            -0.0076,
            0.0033,
            0.0379,
            -0.0437,
            0.0335,
            0.0964,
            -0.2452,
            0.1233,
            0.0368,
            -0.0251,
            0.0253,
            0.0033,
            0.0097,
            -0.0021,
            -0.0095,
            0.1171,
            -0.0475,
            -0.064,
            0.1548,
            -0.0718,
            0.0228,
            -0.0831,
            0.0343,
            -0.1924,
            0.6206,
            -0.2771,
            0.0021,
            -0.0143,
            0.0056,
            -0.0705,
            0.2522,
            -0.1116,
            -0.0692,
            0.4229,
            -0.1592,
            -0.0093,
            0.05,
            -0.0185,
            0.0948,
            -0.3196,
            0.1437,
            -0.0184,
            0.0194,
            -0.0131,
            0.0205,
            -0.0353,
            0.0201,
            0.0676,
            -0.135,
            0.0672,
            0.0137,
            -0.0311,
            0.0118,
            0.0003,
            -0.0077,
            -0.0002,
            -0.0151,
            0.0004,
            -0.0058,
            0.029,
            -0.0139,
            0.0163,
            0.1324,
            0.1819,
            -0.0039,
            0.0406,
            0.0501,
            0.0017,
            0.0331,
            0.0161,
            0.0062,
            -0.0235,
            -0.0446,
            0.0047
        ]
    }
};



let $e5235e83cd175b07$var$latestFaceLandmark = 1;
let $e5235e83cd175b07$var$faceLandmarkById = new Map();
function $e5235e83cd175b07$export$36e720c0ee0eafff(n) {
    let ret = $e5235e83cd175b07$var$latestFaceLandmark++;
    $e5235e83cd175b07$var$faceLandmarkById.set(ret, new $e5235e83cd175b07$export$8da7a4c55ed49539(n));
    (0, $46062ba68c57c43e$export$454156e929b28fe7)("face_landmark_t initialized");
    return ret;
}
function $e5235e83cd175b07$export$4a91c83b2945af9c(m) {
    $e5235e83cd175b07$var$faceLandmarkById.delete(m);
}
function $e5235e83cd175b07$export$2cdf232f18b0ea25(m) {
    return $e5235e83cd175b07$var$faceLandmarkById.get(m);
}
class $e5235e83cd175b07$export$8da7a4c55ed49539 {
    constructor(_name){
        this._name = _name;
        this.anchor_pose = (0, $2edf3b5f20103352$exports).create();
    }
    _getVertex(identity, expression, data) {
        let vert = data.mean.slice();
        for(let i = 0; i < 50; i++){
            vert[0] += identity[i] * data.identity[i * 3 + 0];
            vert[1] += identity[i] * data.identity[i * 3 + 1];
            vert[2] += identity[i] * data.identity[i * 3 + 2];
        }
        for(let i = 0; i < 29; i++){
            vert[0] += expression[i] * data.expression[i * 3 + 0];
            vert[1] += expression[i] * data.expression[i * 3 + 1];
            vert[2] += expression[i] * data.expression[i * 3 + 2];
        }
        return vert;
    }
    update(identity, expression, mirrored) {
        let vert;
        let data = (0, $017c644280618cdd$export$bc05bfbdf8a2824)[this._name.toString()];
        if (!data) return;
        if (Array.isArray(data)) {
            vert = this._getVertex(identity, expression, data[0]);
            let b = this._getVertex(identity, expression, data[1]);
            vert[0] = 0.5 * (vert[0] + b[0]);
            vert[1] = 0.5 * (vert[1] + b[1]);
            vert[2] = 0.5 * (vert[2] + b[2]);
        } else vert = this._getVertex(identity, expression, data);
        if (mirrored) vert[0] *= -1;
        (0, $2edf3b5f20103352$exports).fromTranslation(this.anchor_pose, vert);
    }
}


function $0a2942d639f1b4d7$var$getUnsupportedMessage() {
    let ret = document.createElement("div");
    let idealBrowser = "a recent web browser";
    if (navigator.userAgent.match(/Android/i)) {
        idealBrowser = "Chrome for Android";
        window.location.href = "googlechrome://navigate?url=" + encodeURI(window.location.href);
        setTimeout(()=>{
            window.location.href = "samsunginternet://open?url=" + encodeURI(window.location.href);
        }, 2000);
    } else if (navigator.userAgent.match(/iPhone|iPod|iPad/i)) {
        idealBrowser = "Safari";
        ret.classList.add("zee-launcher-browser-safari");
    }
    ret.classList.add("zee-launcher-unsupported");
    ret.innerHTML = `
            <style>.zee-launcher-unsupported {
               display: flex;
               flex-direction: column;
               height: 100%;
               justify-content: center;
               position: absolute;
               width: 100%;
               height: 100%;
               top: 0;
               left: 0;
               align-items: center;
               }
               .zee-launcher-browser-logo {
               background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 210 211' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(-82 -146)' fill-rule='nonzero' stroke='%23ffffff' stroke-width='2'%3E%3Cg transform='translate(83 146.5)'%3E%3Cpath d='m55.146 88.785l-32.039-49.472c19.962-24.947 49.904-38.684 80.517-38.81 17.739-0.12642 35.855 4.4246 52.336 13.99 18.2 10.619 32.039 25.874 40.846 43.404l-86.095-4.5511c-24.365-1.4327-47.556 12.347-55.565 35.439zm13.797 16.224c0 19.468 15.684 35.229 35.059 35.229 19.374 0 35.059-15.76 35.059-35.229 0-19.468-15.684-35.229-35.059-35.229-19.374 0-35.059 15.718-35.059 35.229zm132.06-37.588l-58.585 3.034c15.894 18.668 16.145 45.595 2.7678 66.243l-47.01 72.648c19.5 1.0535 39.588-3.2447 57.788-13.864 45.039-26.126 63.282-80.908 45.039-128.06zm-144.93 57.647l-39.126-77.326c-10.694 16.434-16.942 36.156-16.942 57.267 0 52.253 38.078 95.53 87.856 103.2l26.713-52.59c-24.155 4.5511-47.472-8.765-58.501-30.551z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
               width: 211px;
               height: 211px;
               margin-bottom: 25%;
               margin-top: -60px;
               background-repeat: no-repeat;
               }
               .zee-launcher-browser-safari .zee-launcher-browser-logo {
               background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 211 211' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(-82 -146)' fill-rule='nonzero' stroke='%23ffffff' stroke-width='2'%3E%3Cpath d='m180 251.86c0-4.0385 2.9377-7.855 7.2552-7.855 3.9614 0 7.7448 2.8402 7.7448 7.145 0 4.0385-2.8487 7.855-7.1662 7.855-4.0059 0-7.8338-2.9734-7.8338-7.145zm112-0.35503c0 57.728-46.772 104.5-104.5 104.5s-104.5-46.772-104.5-104.5 46.772-104.5 104.5-104.5 104.5 46.772 104.5 104.5zm-12-1c0-51.649-41.851-93.5-93.5-93.5s-93.5 41.851-93.5 93.5 41.851 93.5 93.5 93.5 93.5-41.851 93.5-93.5zm-30.624 40.983c0 1.5095 5.4495 4.2768 6.8328 5.1154-11.486 17.401-29.26 29.938-49.423 34.928l-1.8444-7.757c-0.12576-1.0482-0.79646-1.174-1.7606-1.174-0.79646 0-1.2576 1.174-1.1737 1.7611l1.8444 7.8828c-5.5753 1.174-11.234 1.7611-16.935 1.7611-15.217 0-30.182-4.2768-43.177-12.202 0.71263-1.174 5.1141-7.5474 5.1141-8.4698 0-0.79666-0.71263-1.5095-1.5091-1.5095-1.6348 0-5.1141 6.9603-6.1621 8.344-17.522-11.615-30.182-29.602-35.044-50.148l8.0066-1.761c0.92222-0.25158 1.1737-0.92246 1.1737-1.7611 0-0.79667-1.1737-1.2579-1.8444-1.174l-7.8389 1.803c-1.048-5.3251-1.6348-10.692-1.6348-16.143 0-15.556 4.4015-30.86 12.66-43.984 1.1737 0.71281 6.749 4.5284 7.6712 4.5284 0.79646 0 1.5091-0.58702 1.5091-1.3837 0-1.6353-6.1621-4.7381-7.5455-5.7024 11.821-17.275 29.805-29.728 50.219-34.34l1.7606 7.757c0.25152 0.92246 0.92222 1.174 1.7606 1.174 0.83838 0 1.2576-1.174 1.1737-1.8449l-1.7606-7.6732c5.1141-0.92246 10.312-1.5095 15.552-1.5095 15.552 0 30.727 4.4026 43.973 12.663-0.79646 1.174-4.5273 6.6249-4.5273 7.5474 0 0.79667 0.58687 1.5095 1.3833 1.5095 1.6348 0 4.7369-6.0379 5.5753-7.4216 17.187 11.615 29.469 29.351 34.248 49.561l-6.4975 1.3837c-1.048 0.25158-1.1737 0.92246-1.1737 1.8449 0 0.79667 1.1737 1.2579 1.7606 1.174l6.6232-1.5095c1.048 5.3251 1.6348 10.776 1.6348 16.227 0 15.221-4.1919 30.189-12.073 43.062-1.1737-0.58702-6.0364-4.0672-6.9586-4.0672-0.8803 0-1.5929 0.71281-1.5929 1.5095zm-14.876-98.483c-5.2178 4.88-53.863 49.48-55.228 51.8l-38.772 64.2c5.0974-4.76 53.863-49.6 55.108-51.72l38.892-64.28z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
               }
               .zee-launcher-unsupported-message {
               text-align: center;
               width: 250px;
               font-family: sans-serif;
               color: #ffffff;
               }
               .zee-launcher-unsupported-message-copy {
               border: 1px solid #ffffff;
               border-radius: 5px;
               margin-top: 10px;
               }
               #zee-launcher-unsupported-message-input {
               border: none;
               padding: 10px;
               border-radius: 0px;
               border-right: 1px solid #344B60;
               height: 40px;
               color: #ffffff;
               background-color: black;
               box-sizing: border-box;
               width: calc(100% - 65px);
               margin-left: 5px;
               }
               #zee-launcher-unsupported-message-button {
               background: none;
               border: none;
               outline: none;
               text-transform: uppercase;
               color: #ffffff;
               height: 40px;
               display: inline-block;
               width: 59px;
               }
               .zee-launcher-unsupported-message-before-copy {
               height: 100px;
               display: flex;
               flex-direction: column;
               justify-content: center;
               margin-top: 20px;
               }
               .zee-launcher-unsupported-message-copied .zee-launcher-unsupported-message-before-copy {
               display: none;
               }
               .zee-launcher-unsupported-message-after-copy {
               display: none;
               }
               .zee-launcher-unsupported-message-copied .zee-launcher-unsupported-message-after-copy {
               height: 100px;
               display: flex;
               flex-direction: column;
               justify-content: center;
               margin-top: 20px;
               }
            </style>
            <div class="zee-launcher-browser-logo"></div>
            <div class="zee-launcher-unsupported-message">Open with ${idealBrowser} to access this content.</div>
            <div class="zee-launcher-unsupported-message-before-copy">
               <div class="zee-launcher-unsupported-message ">Tap below to copy the address for easy pasting into ${idealBrowser}.</div>
               <div class="zee-launcher-unsupported-message-copy"><input id="zee-launcher-unsupported-message-input" type="text/"><button id="zee-launcher-unsupported-message-button">Copy</button></div>
            </div>
            <div class="zee-launcher-unsupported-message zee-launcher-unsupported-message-after-copy">COPIED! Now paste into ${idealBrowser}'s address bar to experience the content.</div>
    `;
    let inpElm = ret.querySelector("#zee-launcher-unsupported-message-input") || document.createElement("input");
    inpElm.value = window.location.href;
    let btnElm = ret.querySelector("#zee-launcher-unsupported-message-button") || document.createElement("button");
    let onCopyPressed = ()=>{
        if (navigator.userAgent.match(/iPhone|iPod|iPad/i)) {
            let r = document.createRange();
            r.selectNodeContents(inpElm);
            let sel = window.getSelection();
            if (!sel) return;
            sel.removeAllRanges();
            sel.addRange(r);
            inpElm.setSelectionRange(0, 999999999);
        } else inpElm.select();
        document.execCommand("copy");
        inpElm.blur();
        ret.classList.toggle("zee-launcher-unsupported-message-copied", true);
    };
    btnElm.addEventListener("click", onCopyPressed);
    inpElm.addEventListener("click", onCopyPressed);
    return ret;
}
const $0a2942d639f1b4d7$var$incompatibleUI = ()=>{
    const zapparCompatibility = document.createElement("div");
    zapparCompatibility.append($0a2942d639f1b4d7$var$getUnsupportedMessage());
    Object.assign(zapparCompatibility.style, {
        position: "fixed",
        width: "100%",
        height: "100%",
        top: "0px",
        left: "0px",
        zIndex: 1001,
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        fontFamily: "sans-serif",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    });
    zapparCompatibility.classList.add("zee_launcher_compatibility");
    document.body.append(zapparCompatibility);
};
function $0a2942d639f1b4d7$var$isSupportedBrowser() {
    if (typeof Promise !== "function") return false;
    if (typeof WebAssembly !== "object") return false;
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices || !navigator.mediaDevices.getUserMedia) return false;
    return true;
}
var $0a2942d639f1b4d7$export$2e2bcd8739ae039 = {
    incompatible: ()=>!$0a2942d639f1b4d7$var$isSupportedBrowser(),
    incompatible_ui: $0a2942d639f1b4d7$var$incompatibleUI
};








let $72e5942e3d068a06$var$latest = 1;
let $72e5942e3d068a06$var$byId = new Map();
class $72e5942e3d068a06$export$9035336025e5be06 extends (0, $566bb64a761777a5$export$1d2df86270c81ecb) {
    constructor(_impl, _pipeline){
        super();
        this._impl = _impl;
        this._pipeline = _pipeline;
        this._packetNumber = 0;
        this._motionUpdatesQueued = 0;
        this._motionUpdatesSent = 0;
        this._minFrameGapMs = 0;
        this._lastUpdateTime = 0;
    }
    static create(p) {
        let ret = $72e5942e3d068a06$var$latest++;
        $72e5942e3d068a06$var$byId.set(ret, new $72e5942e3d068a06$export$9035336025e5be06(ret, p));
        (0, $46062ba68c57c43e$export$454156e929b28fe7)("sequence_source_source_t initialized");
        return ret;
    }
    static get(m) {
        return $72e5942e3d068a06$var$byId.get(m);
    }
    loadFromMemory(data) {
        try {
            this._decoder = new (0, $64e6deea2842fcd8$export$20801e67610bf5d8)(data);
            this._packetNumber = 0;
            this._lastUpdateTime = 0;
        } catch (err) {
            (0, $46062ba68c57c43e$export$497c45d0bfe56de1)("Unable to decode sequence:", err);
        }
    }
    maxPlaybackFpsSet(fps) {
        if (fps <= 0) {
            this._minFrameGapMs = 0;
            return;
        }
        this._minFrameGapMs = 1000.0 / fps;
    }
    setTime(t) {
        if (t < 0) delete this._time;
        else this._time = t;
    }
    getFrame(currentlyProcessing) {
        var _a;
        let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        if (!this._decoder) return;
        this._submitMotionUpdates(pipeline);
        if (this._motionUpdatesQueued > this._motionUpdatesSent) return;
        if (currentlyProcessing) return;
        let curTime = (_a = this._time) !== null && _a !== void 0 ? _a : performance.now();
        if (curTime < this._lastUpdateTime + this._minFrameGapMs) return;
        if (this._packetNumber >= this._decoder.numberPackets) return;
        let packet = this._decoder.dataByPacket.get(this._packetNumber);
        if (packet.type != (0, $64e6deea2842fcd8$export$b970cf2e1a7b7c7b).CAMERA_FRAME) return;
        this._packetNumber++;
        let pixels = pipeline.cameraPixelArrays.pop();
        while(pixels){
            if (pixels.byteLength === packet.greyscale.byteLength) break;
            pixels = pipeline.cameraPixelArrays.pop();
        }
        if (!pixels) pixels = new ArrayBuffer(packet.greyscale.byteLength);
        new Uint8Array(pixels).set(packet.greyscale);
        this._lastUpdateTime = curTime;
        let info = {
            data: pixels,
            cameraSourceData: packet.greyscale,
            cameraModel: packet.cameraModel,
            cameraToDevice: packet.cameraToDevice,
            dataWidth: packet.width,
            dataHeight: packet.height,
            texture: undefined,
            userFacing: packet.userFacing,
            uvTransform: (0, $2edf3b5f20103352$exports).create(),
            cameraSource: this
        };
        // We can queue the motion updates for the follwing frame immediately
        // as this camera frame will be sent immediately, but the next motion
        // updates will be one frame later
        this._submitMotionUpdates(pipeline);
        const token = pipeline.registerToken(info);
        pipeline.sendDataToWorker(info.data || new ArrayBuffer(0), token, info.dataWidth, info.dataHeight, info.userFacing, info.cameraToDevice, info.cameraModel);
    }
    destroy() {
        $72e5942e3d068a06$var$byId.delete(this._impl);
        this.pause();
    }
    start() {
        var _a;
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource !== this) {
            (_a = p.currentCameraSource) === null || _a === void 0 || _a.pause();
            p.currentCameraSource = this;
        }
    }
    pause() {
        let p = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (p && p.currentCameraSource === this) p.currentCameraSource = undefined;
    }
    uploadGL(info) {
        let pipeline = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(this._pipeline);
        if (!pipeline) return;
        let gl = pipeline === null || pipeline === void 0 ? void 0 : pipeline.glContext;
        if (!gl) return;
        if (!info.texture) info.texture = pipeline.getVideoTexture();
        if (!info.texture) return;
        if (!info.cameraSourceData) return;
        gl.bindTexture(gl.TEXTURE_2D, info.texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, info.dataWidth, info.dataHeight, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, new Uint8Array(info.cameraSourceData));
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    _submitMotionUpdates(pipeline) {
        let pendingMotionUpdate = false;
        while(this._packetNumber < this._decoder.numberPackets){
            let packet = this._decoder.dataByPacket.get(this._packetNumber);
            if (packet.type == (0, $64e6deea2842fcd8$export$b970cf2e1a7b7c7b).CAMERA_FRAME) break;
            switch(packet.type){
                case (0, $64e6deea2842fcd8$export$b970cf2e1a7b7c7b).ACCELEROMETER:
                    pipeline.motionAccelerometerSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $64e6deea2842fcd8$export$b970cf2e1a7b7c7b).ROTATION_RATE:
                    pipeline.motionRotationRateSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $64e6deea2842fcd8$export$b970cf2e1a7b7c7b).ATTITUDE:
                    pipeline.motionAttitudeSubmit(packet.t, packet.x, packet.y, packet.z);
                    pendingMotionUpdate = true;
                    break;
                case (0, $64e6deea2842fcd8$export$b970cf2e1a7b7c7b).ATTITUDE_MATRIX:
                    pipeline.motionAttitudeMatrix(packet.attitude);
                    pendingMotionUpdate = true;
                    break;
            }
            this._packetNumber++;
        }
        // If we've submitted motion updates, add a setTimeout to reflect when
        // the message serializer will actually have sent them over to the worker
        if (pendingMotionUpdate) {
            this._motionUpdatesQueued++;
            setTimeout(()=>{
                this._motionUpdatesSent++;
            }, 0);
        }
        return;
    }
}



const $8bda6e055faa194a$export$4cf8838f9102a661 = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="250" height="80.408" viewBox="0 0 250 80.408"><defs><filter id="a" x="0" y="1.182" width="250" height="79.226" filterUnits="userSpaceOnUse"><feOffset dy="3" input="SourceAlpha"/><feGaussianBlur stdDeviation="3" result="b"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="c" x="6.929" y="0" width="111.975" height="40.988" filterUnits="userSpaceOnUse"><feOffset dy="3" input="SourceAlpha"/><feGaussianBlur stdDeviation="3" result="d"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-26.873 -414.029)"><g transform="translate(44 423.332)"><g transform="translate(0 0.635)" style="isolation:isolate"><g transform="translate(0 0)"><g transform="matrix(1, 0, 0, 1, -17.13, -9.94)" filter="url(#a)"><path d="M55.766,44.97V11.8h8.272v2.6h.089a8.258,8.258,0,0,1,7.046-3.357,11.4,11.4,0,0,1,8.5,3.686,12.667,12.667,0,0,1,3.278,8.622,12.509,12.509,0,0,1-3.25,8.57,11.353,11.353,0,0,1-8.429,3.6,9.533,9.533,0,0,1-7.229-2.95V43.378l-8.269,1.594h0Zm8-21.671a4.958,4.958,0,0,0,5.319,5.15A4.957,4.957,0,0,0,74.4,23.3a5.321,5.321,0,0,0-10.638,0ZM16.105,18.412H2.752V11.038H30.9L14.887,37.16H38.22L0,44.534ZM131.469,38.45a.761.761,0,0,1-.484-.166.582.582,0,0,1-.228-.419l-.553-3.586a12.243,12.243,0,0,1-1.782-.721l-2.789,2.084a.718.718,0,0,1-.5.176.688.688,0,0,1-.495-.214,25.864,25.864,0,0,1-3.264-3.274.754.754,0,0,1,.018-.9c.2-.277.543-.713,1.01-1.3.483-.6.832-1.05,1.068-1.374a9.614,9.614,0,0,1-.811-1.929l-3.62-.527a.631.631,0,0,1-.416-.243.728.728,0,0,1-.159-.458V21.283a.743.743,0,0,1,.159-.448.6.6,0,0,1,.376-.253l3.68-.546a9.511,9.511,0,0,1,.772-1.792c-.523-.733-1.235-1.638-2.117-2.69a.731.731,0,0,1-.2-.467.82.82,0,0,1,.178-.449,19.577,19.577,0,0,1,1.949-2.095c.953-.924,1.582-1.393,1.87-1.393a.861.861,0,0,1,.515.195l2.729,2.084a11.551,11.551,0,0,1,1.8-.741,31.446,31.446,0,0,1,.573-3.623.666.666,0,0,1,.712-.546h4.392a.757.757,0,0,1,.485.166.58.58,0,0,1,.228.419l.553,3.584a12.576,12.576,0,0,1,1.782.722l2.809-2.085a.641.641,0,0,1,.475-.176.776.776,0,0,1,.5.195,27.035,27.035,0,0,1,3.264,3.313.625.625,0,0,1,.139.429.742.742,0,0,1-.159.447c-.2.271-.525.7-1.008,1.3-.467.581-.827,1.043-1.069,1.373a11.8,11.8,0,0,1,.812,1.91l3.62.545a.626.626,0,0,1,.416.244.736.736,0,0,1,.158.457v4.325a.755.755,0,0,1-.158.449.6.6,0,0,1-.4.253l-3.66.545a12.692,12.692,0,0,1-.772,1.774c.465.653,1.177,1.559,2.117,2.688a.751.751,0,0,1,.2.488.648.648,0,0,1-.178.448,19.638,19.638,0,0,1-1.958,2.1c-.947.918-1.573,1.384-1.861,1.384a.976.976,0,0,1-.515-.176l-2.731-2.1a11.361,11.361,0,0,1-1.8.741,31.849,31.849,0,0,1-.573,3.625.668.668,0,0,1-.713.546Zm-1.385-18.491a4.935,4.935,0,0,0,0,7.053,5.12,5.12,0,0,0,7.163,0,4.931,4.931,0,0,0,0-7.053,5.117,5.117,0,0,0-7.163,0Zm69.969,14.868a18.523,18.523,0,0,1-4.932-2.073l1.705-6.1A13.441,13.441,0,0,0,200.779,29a12.14,12.14,0,0,0,4.344.818,4.644,4.644,0,0,0,2.351-.482,1.538,1.538,0,0,0,.806-1.4q0-1.5-3.25-2.242-1.061-.246-1.705-.425a12.335,12.335,0,0,1-5.358-2.589,5.5,5.5,0,0,1-1.671-4.157,6.323,6.323,0,0,1,2.547-5.267,10.993,10.993,0,0,1,6.9-1.972,21.351,21.351,0,0,1,4.552.5,25.439,25.439,0,0,1,4.736,1.557l-1.705,5.491a14.244,14.244,0,0,0-3.319-1.636,10.6,10.6,0,0,0-3.364-.561,4.227,4.227,0,0,0-2.121.426,1.357,1.357,0,0,0-.714,1.232q0,1.211,3.227,2.04.737.2,1.106.291,4.264,1.187,5.935,2.79a5.728,5.728,0,0,1,1.67,4.337A6.781,6.781,0,0,1,213,33.37a11.48,11.48,0,0,1-7.259,2.14A22.577,22.577,0,0,1,200.053,34.827ZM30.568,31.834a12.566,12.566,0,0,1-3.292-8.59,12.567,12.567,0,0,1,3.247-8.568,11.3,11.3,0,0,1,8.423-3.638,9.519,9.519,0,0,1,7.217,3V11.8h8.264V34.735H46.163V32.186h-.09c-1.32,2.071-3.951,3.308-7.038,3.308A11.412,11.412,0,0,1,30.568,31.834Zm5.245-8.545a4.95,4.95,0,0,0,5.312,5.141,4.95,4.95,0,0,0,5.312-5.141A5.023,5.023,0,0,0,41.125,18.1,5.023,5.023,0,0,0,35.813,23.289Zm69.2,11.554-3.527-10.452q-.282-.892-.505-1.8t-.412-1.8a30.821,30.821,0,0,1-.917,3.454l-.047.16L96.1,34.842H90.176l-9.925-23.1h8.632l3.552,10.223q.4,1.12.634,1.955t.377,1.635a23.558,23.558,0,0,1,.917-3.179q.093-.274.141-.411l3.528-10.223h5.056l3.5,10.2.07.183a20.724,20.724,0,0,1,.988,3.43q.141-.732.364-1.532t.647-2.058l3.574-10.223h8.678l-9.971,23.1Zm80.154-.092-8.587-9.841v9.841h-7.888V1.5L176.583,0V22.28l8.272-9.665h9.96L184.584,23.266l11.156,11.485Zm-35.09,0V11.782h8.272v3.761h.091a8.131,8.131,0,0,1,7.546-4.074h1.593V19.3a6.8,6.8,0,0,0-3.5-.761c-4.593,0-5.728,3-5.728,6.941v9.268Z" transform="translate(17.13 15.31)"/></g><g transform="matrix(1, 0, 0, 1, -17.13, -9.94)" filter="url(#c)"><path d="M3.576-12.852v-4.3H6.628a2.867,2.867,0,0,1,1.945.55A2.034,2.034,0,0,1,9.188-15a2.06,2.06,0,0,1-.615,1.608,2.784,2.784,0,0,1-1.945.542ZM2.017-18.464V-6.748H3.576v-4.792H7.153a3.569,3.569,0,0,0,2.683-.9A3.478,3.478,0,0,0,10.747-15a3.45,3.45,0,0,0-.911-2.552,3.638,3.638,0,0,0-2.683-.911Zm11.421,7.483a4.221,4.221,0,0,1,.205-1.37,2.957,2.957,0,0,1,.566-1.009,2.411,2.411,0,0,1,.845-.624A2.515,2.515,0,0,1,16.08-14.2a2.515,2.515,0,0,1,1.026.213,2.411,2.411,0,0,1,.845.624,2.957,2.957,0,0,1,.566,1.009,4.221,4.221,0,0,1,.205,1.37,4.221,4.221,0,0,1-.205,1.37,2.867,2.867,0,0,1-.566,1,2.457,2.457,0,0,1-.845.615,2.515,2.515,0,0,1-1.026.213,2.515,2.515,0,0,1-1.026-.213,2.457,2.457,0,0,1-.845-.615,2.867,2.867,0,0,1-.566-1A4.221,4.221,0,0,1,13.438-10.981Zm-1.477,0a5.573,5.573,0,0,0,.263,1.739,3.97,3.97,0,0,0,.788,1.4,3.623,3.623,0,0,0,1.3.935,4.4,4.4,0,0,0,1.772.336A4.381,4.381,0,0,0,17.86-6.9a3.641,3.641,0,0,0,1.288-.935,3.97,3.97,0,0,0,.788-1.4,5.573,5.573,0,0,0,.263-1.739,5.65,5.65,0,0,0-.263-1.748,3.96,3.96,0,0,0-.788-1.411,3.729,3.729,0,0,0-1.288-.944,4.29,4.29,0,0,0-1.78-.345,4.3,4.3,0,0,0-1.772.345,3.71,3.71,0,0,0-1.3.944,3.96,3.96,0,0,0-.788,1.411A5.65,5.65,0,0,0,11.961-10.981Zm18.28,4.234,2.708-8.484H31.5L29.6-8.29h-.033L27.8-15.231H26.27L24.564-8.29h-.033l-1.92-6.941H21.068l2.724,8.484H25.3l1.707-6.744h.033l1.723,6.744ZM40.169-11.8H35.3a2.905,2.905,0,0,1,.213-.927A2.473,2.473,0,0,1,36-13.492a2.255,2.255,0,0,1,.747-.517,2.429,2.429,0,0,1,.976-.189,2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,40.169-11.8Zm1.346,2.363H40.136a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.105,5.105,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,41.515-9.439Zm1.526-5.793v8.484h1.395v-3.774a5.8,5.8,0,0,1,.164-1.452,2.784,2.784,0,0,1,.525-1.075,2.251,2.251,0,0,1,.952-.673,3.945,3.945,0,0,1,1.428-.23v-1.477a3.135,3.135,0,0,0-1.871.459,3.779,3.779,0,0,0-1.247,1.526h-.033v-1.789ZM54.15-11.8H49.276a2.905,2.905,0,0,1,.213-.927,2.473,2.473,0,0,1,.492-.763,2.255,2.255,0,0,1,.747-.517A2.429,2.429,0,0,1,51.7-14.2a2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,54.15-11.8ZM55.5-9.439H54.117a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.1,5.1,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,55.5-9.439Zm2.593-1.477a5.581,5.581,0,0,1,.131-1.214,3.212,3.212,0,0,1,.427-1.05,2.221,2.221,0,0,1,.788-.738,2.4,2.4,0,0,1,1.2-.279,2.589,2.589,0,0,1,1.231.271,2.389,2.389,0,0,1,.829.714,2.985,2.985,0,0,1,.468,1.026,4.889,4.889,0,0,1,.148,1.206,4.919,4.919,0,0,1-.139,1.165,3.053,3.053,0,0,1-.451,1.026,2.4,2.4,0,0,1-.8.73,2.4,2.4,0,0,1-1.2.279,2.491,2.491,0,0,1-1.173-.263,2.332,2.332,0,0,1-.82-.706,3.122,3.122,0,0,1-.476-1.009A4.338,4.338,0,0,1,58.088-10.916Zm6.564,4.168V-18.464H63.257V-14.1h-.033a2.247,2.247,0,0,0-.566-.632,3.216,3.216,0,0,0-.714-.41,3.583,3.583,0,0,0-.755-.222,4.132,4.132,0,0,0-.706-.066,3.861,3.861,0,0,0-1.7.353,3.487,3.487,0,0,0-1.214.952,4.018,4.018,0,0,0-.722,1.4,5.985,5.985,0,0,0-.238,1.707,5.8,5.8,0,0,0,.246,1.707,4.218,4.218,0,0,0,.73,1.411,3.529,3.529,0,0,0,1.214.968,3.827,3.827,0,0,0,1.715.361,4.135,4.135,0,0,0,1.625-.312A2.053,2.053,0,0,0,63.224-7.9h.033v1.149Zm6.761-11.716V-6.748h1.395V-7.88h.033a2.247,2.247,0,0,0,.566.632,2.982,2.982,0,0,0,.714.4,3.874,3.874,0,0,0,.763.213,4.193,4.193,0,0,0,.7.066,3.94,3.94,0,0,0,1.7-.345,3.4,3.4,0,0,0,1.214-.944,4.018,4.018,0,0,0,.722-1.4,5.985,5.985,0,0,0,.238-1.707,5.8,5.8,0,0,0-.246-1.707,4.312,4.312,0,0,0-.73-1.419,3.488,3.488,0,0,0-1.214-.976,3.827,3.827,0,0,0-1.715-.361,4.043,4.043,0,0,0-1.625.32,2.088,2.088,0,0,0-1.083,1.026h-.033v-4.381Zm6.564,7.4a5.581,5.581,0,0,1-.131,1.214,3.212,3.212,0,0,1-.427,1.05,2.243,2.243,0,0,1-.779.738,2.385,2.385,0,0,1-1.206.279A2.589,2.589,0,0,1,74.2-8.052a2.389,2.389,0,0,1-.829-.714,2.985,2.985,0,0,1-.468-1.026A4.889,4.889,0,0,1,72.758-11a4.919,4.919,0,0,1,.139-1.165,3.053,3.053,0,0,1,.451-1.026,2.4,2.4,0,0,1,.8-.73,2.4,2.4,0,0,1,1.2-.279,2.491,2.491,0,0,1,1.173.263,2.332,2.332,0,0,1,.82.706,3.122,3.122,0,0,1,.476,1.009A4.338,4.338,0,0,1,77.976-11.063Zm6.449,5.448a8.871,8.871,0,0,1-.484,1.05,2.871,2.871,0,0,1-.525.7,1.782,1.782,0,0,1-.64.394,2.462,2.462,0,0,1-.812.123,3.721,3.721,0,0,1-.492-.033A2.324,2.324,0,0,1,81-3.5v-1.28a2.342,2.342,0,0,0,.418.139,1.765,1.765,0,0,0,.4.057,1.2,1.2,0,0,0,.714-.205,1.255,1.255,0,0,0,.435-.583L83.539-6.8l-3.364-8.434h1.575L84.228-8.29h.033l2.379-6.941h1.477Z" transform="translate(17.85 28.4)"/></g></g></g><g transform="translate(0 0)"><g transform="translate(0 5.371)"><path d="M11.76,24.456A11.41,11.41,0,0,1,3.292,20.8,12.564,12.564,0,0,1,0,12.206,12.569,12.569,0,0,1,3.246,3.638,11.307,11.307,0,0,1,11.67,0a9.519,9.519,0,0,1,7.217,3V.759h8.264V23.7H18.887V21.148H18.8C17.478,23.219,14.846,24.456,11.76,24.456ZM13.849,7.064A5.023,5.023,0,0,0,8.537,12.25a4.95,4.95,0,0,0,5.312,5.141A4.95,4.95,0,0,0,19.16,12.25,5.023,5.023,0,0,0,13.849,7.064Z" transform="translate(27.277 11.038)" fill="#fff"/><path d="M0,33.931V.758H8.271v2.6H8.36A8.258,8.258,0,0,1,15.406,0,11.4,11.4,0,0,1,23.9,3.686a12.665,12.665,0,0,1,3.278,8.622,12.508,12.508,0,0,1-3.25,8.57,11.351,11.351,0,0,1-8.429,3.6,9.535,9.535,0,0,1-7.229-2.95V32.337L0,33.931ZM13.317,7.07A5.028,5.028,0,0,0,8,12.259a4.957,4.957,0,0,0,5.319,5.15,4.957,4.957,0,0,0,5.319-5.15A5.028,5.028,0,0,0,13.317,7.07Z" transform="translate(55.766 11.041)" fill="#fff"/><path d="M22.836,0l3.5,10.2.07.183a20.748,20.748,0,0,1,.988,3.43q.141-.731.364-1.532t.647-2.058L31.985,0h8.678L30.691,23.1H24.764L21.237,12.647q-.282-.891-.505-1.8t-.412-1.8A30.927,30.927,0,0,1,19.4,12.51l-.047.16L15.851,23.1H9.925L0,0H8.631l3.552,10.223q.4,1.121.635,1.955t.377,1.635a23.522,23.522,0,0,1,.917-3.179q.093-.274.141-.411L17.78,0h5.056" transform="translate(80.251 11.743)" fill="#fff"/><path d="M0,34.75V1.5L7.888,0V22.28l8.272-9.665H26.12L15.889,23.266,27.045,34.75H16.475L7.888,24.91v9.84H0" transform="translate(168.695 0)" fill="#fff"/><path d="M0,21.47l1.705-6.1a13.453,13.453,0,0,0,3.952,2.342A12.145,12.145,0,0,0,10,18.534a4.643,4.643,0,0,0,2.351-.482,1.539,1.539,0,0,0,.807-1.4q0-1.5-3.25-2.241-1.06-.246-1.705-.426A12.325,12.325,0,0,1,2.846,11.4,5.5,5.5,0,0,1,1.176,7.239,6.324,6.324,0,0,1,3.722,1.972,11,11,0,0,1,10.624,0a21.365,21.365,0,0,1,4.551.5,25.45,25.45,0,0,1,4.736,1.558l-1.706,5.49a14.24,14.24,0,0,0-3.319-1.636,10.6,10.6,0,0,0-3.364-.56A4.22,4.22,0,0,0,9.4,5.782a1.356,1.356,0,0,0-.714,1.233q0,1.211,3.227,2.04.737.2,1.106.291,4.264,1.188,5.935,2.79a5.728,5.728,0,0,1,1.671,4.337,6.782,6.782,0,0,1-2.743,5.614,11.478,11.478,0,0,1-7.259,2.14,22.565,22.565,0,0,1-5.693-.683A18.517,18.517,0,0,1,0,21.47" transform="translate(195.121 11.284)" fill="#fff"/><path d="M8.273,4.075h.091A8.13,8.13,0,0,1,15.909,0H17.5V7.834A6.8,6.8,0,0,0,14,7.074c-4.593,0-5.728,3-5.728,6.941v9.268H0V.313H8.273V4.075" transform="translate(150.08 11.469)" fill="#fff"/><path d="M17.392,29.929H13a.76.76,0,0,1-.485-.166.579.579,0,0,1-.227-.419l-.553-3.586a12.3,12.3,0,0,1-1.781-.721L7.163,27.123a.719.719,0,0,1-.495.176.687.687,0,0,1-.495-.214A25.873,25.873,0,0,1,2.91,23.81a.753.753,0,0,1,.019-.9c.2-.277.542-.713,1.009-1.3.483-.6.832-1.05,1.068-1.374a9.591,9.591,0,0,1-.811-1.929l-3.62-.526a.63.63,0,0,1-.416-.243A.729.729,0,0,1,0,17.089V12.762a.746.746,0,0,1,.159-.448.6.6,0,0,1,.376-.253l3.68-.546a9.5,9.5,0,0,1,.772-1.792C4.464,8.991,3.752,8.085,2.87,7.034a.732.732,0,0,1-.2-.468.82.82,0,0,1,.179-.449A19.622,19.622,0,0,1,4.8,4.023C5.751,3.1,6.38,2.631,6.668,2.631a.859.859,0,0,1,.515.194L9.913,4.91a11.536,11.536,0,0,1,1.8-.741A31.372,31.372,0,0,1,12.287.546.665.665,0,0,1,13,0h4.392a.755.755,0,0,1,.485.166.581.581,0,0,1,.229.419l.553,3.584a12.543,12.543,0,0,1,1.781.722L23.25,2.807a.641.641,0,0,1,.475-.176.775.775,0,0,1,.495.194,27.092,27.092,0,0,1,3.264,3.313.625.625,0,0,1,.139.429.745.745,0,0,1-.159.448c-.2.271-.525.695-1.008,1.3-.467.581-.827,1.043-1.069,1.373a11.784,11.784,0,0,1,.812,1.91l3.62.545a.625.625,0,0,1,.416.244.736.736,0,0,1,.157.458v4.325a.754.754,0,0,1-.157.449.606.606,0,0,1-.4.253l-3.66.545a12.628,12.628,0,0,1-.772,1.774c.465.654,1.177,1.559,2.117,2.688a.752.752,0,0,1,.2.488.648.648,0,0,1-.177.448,19.641,19.641,0,0,1-1.959,2.1c-.947.918-1.573,1.384-1.86,1.384a.978.978,0,0,1-.515-.176l-2.731-2.1a11.429,11.429,0,0,1-1.8.741,32.016,32.016,0,0,1-.573,3.624A.668.668,0,0,1,17.392,29.929ZM15.2,9.976a4.938,4.938,0,0,0-3.582,1.463,4.935,4.935,0,0,0,0,7.053,5.12,5.12,0,0,0,7.163,0,4.932,4.932,0,0,0,0-7.053A4.938,4.938,0,0,0,15.2,9.976Z" transform="translate(118.47 8.521)" fill="#fff"/><path d="M0,33.5,16.106,7.374H2.752V0H30.9L14.887,26.122H38.22L0,33.5" transform="translate(0 11.038)" fill="#fff"/></g><path d="M3.576-12.852v-4.3H6.628a2.867,2.867,0,0,1,1.945.55A2.034,2.034,0,0,1,9.188-15a2.06,2.06,0,0,1-.615,1.608,2.784,2.784,0,0,1-1.945.542ZM2.017-18.464V-6.748H3.576v-4.792H7.153a3.569,3.569,0,0,0,2.683-.9A3.478,3.478,0,0,0,10.747-15a3.45,3.45,0,0,0-.911-2.552,3.638,3.638,0,0,0-2.683-.911Zm11.421,7.483a4.221,4.221,0,0,1,.205-1.37,2.957,2.957,0,0,1,.566-1.009,2.411,2.411,0,0,1,.845-.624A2.515,2.515,0,0,1,16.08-14.2a2.515,2.515,0,0,1,1.026.213,2.411,2.411,0,0,1,.845.624,2.957,2.957,0,0,1,.566,1.009,4.221,4.221,0,0,1,.205,1.37,4.221,4.221,0,0,1-.205,1.37,2.867,2.867,0,0,1-.566,1,2.457,2.457,0,0,1-.845.615,2.515,2.515,0,0,1-1.026.213,2.515,2.515,0,0,1-1.026-.213,2.457,2.457,0,0,1-.845-.615,2.867,2.867,0,0,1-.566-1A4.221,4.221,0,0,1,13.438-10.981Zm-1.477,0a5.573,5.573,0,0,0,.263,1.739,3.97,3.97,0,0,0,.788,1.4,3.623,3.623,0,0,0,1.3.935,4.4,4.4,0,0,0,1.772.336A4.381,4.381,0,0,0,17.86-6.9a3.641,3.641,0,0,0,1.288-.935,3.97,3.97,0,0,0,.788-1.4,5.573,5.573,0,0,0,.263-1.739,5.65,5.65,0,0,0-.263-1.748,3.96,3.96,0,0,0-.788-1.411,3.729,3.729,0,0,0-1.288-.944,4.29,4.29,0,0,0-1.78-.345,4.3,4.3,0,0,0-1.772.345,3.71,3.71,0,0,0-1.3.944,3.96,3.96,0,0,0-.788,1.411A5.65,5.65,0,0,0,11.961-10.981Zm18.28,4.234,2.708-8.484H31.5L29.6-8.29h-.033L27.8-15.231H26.27L24.564-8.29h-.033l-1.92-6.941H21.068l2.724,8.484H25.3l1.707-6.744h.033l1.723,6.744ZM40.169-11.8H35.3a2.905,2.905,0,0,1,.213-.927A2.473,2.473,0,0,1,36-13.492a2.255,2.255,0,0,1,.747-.517,2.429,2.429,0,0,1,.976-.189,2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,40.169-11.8Zm1.346,2.363H40.136a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.105,5.105,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,41.515-9.439Zm1.526-5.793v8.484h1.395v-3.774a5.8,5.8,0,0,1,.164-1.452,2.784,2.784,0,0,1,.525-1.075,2.251,2.251,0,0,1,.952-.673,3.945,3.945,0,0,1,1.428-.23v-1.477a3.135,3.135,0,0,0-1.871.459,3.779,3.779,0,0,0-1.247,1.526h-.033v-1.789ZM54.15-11.8H49.276a2.905,2.905,0,0,1,.213-.927,2.473,2.473,0,0,1,.492-.763,2.255,2.255,0,0,1,.747-.517A2.429,2.429,0,0,1,51.7-14.2a2.386,2.386,0,0,1,.96.189,2.415,2.415,0,0,1,.755.509,2.391,2.391,0,0,1,.509.763A2.854,2.854,0,0,1,54.15-11.8ZM55.5-9.439H54.117a1.983,1.983,0,0,1-.747,1.247,2.414,2.414,0,0,1-1.452.41,2.889,2.889,0,0,1-1.2-.23,2.348,2.348,0,0,1-.837-.615,2.4,2.4,0,0,1-.476-.886,3.367,3.367,0,0,1-.131-1.058h6.35a6.754,6.754,0,0,0-.139-1.625,4.7,4.7,0,0,0-.624-1.575,3.716,3.716,0,0,0-1.2-1.19,3.48,3.48,0,0,0-1.879-.468,3.858,3.858,0,0,0-1.6.328,3.76,3.76,0,0,0-1.264.919,4.236,4.236,0,0,0-.829,1.395,5.1,5.1,0,0,0-.3,1.772,6.8,6.8,0,0,0,.287,1.789,3.9,3.9,0,0,0,.763,1.411,3.478,3.478,0,0,0,1.255.919,4.358,4.358,0,0,0,1.764.328,3.851,3.851,0,0,0,2.4-.722A3.39,3.39,0,0,0,55.5-9.439Zm2.593-1.477a5.581,5.581,0,0,1,.131-1.214,3.212,3.212,0,0,1,.427-1.05,2.221,2.221,0,0,1,.788-.738,2.4,2.4,0,0,1,1.2-.279,2.589,2.589,0,0,1,1.231.271,2.389,2.389,0,0,1,.829.714,2.985,2.985,0,0,1,.468,1.026,4.889,4.889,0,0,1,.148,1.206,4.919,4.919,0,0,1-.139,1.165,3.053,3.053,0,0,1-.451,1.026,2.4,2.4,0,0,1-.8.73,2.4,2.4,0,0,1-1.2.279,2.491,2.491,0,0,1-1.173-.263,2.332,2.332,0,0,1-.82-.706,3.122,3.122,0,0,1-.476-1.009A4.338,4.338,0,0,1,58.088-10.916Zm6.564,4.168V-18.464H63.257V-14.1h-.033a2.247,2.247,0,0,0-.566-.632,3.216,3.216,0,0,0-.714-.41,3.583,3.583,0,0,0-.755-.222,4.132,4.132,0,0,0-.706-.066,3.861,3.861,0,0,0-1.7.353,3.487,3.487,0,0,0-1.214.952,4.018,4.018,0,0,0-.722,1.4,5.985,5.985,0,0,0-.238,1.707,5.8,5.8,0,0,0,.246,1.707,4.218,4.218,0,0,0,.73,1.411,3.529,3.529,0,0,0,1.214.968,3.827,3.827,0,0,0,1.715.361,4.135,4.135,0,0,0,1.625-.312A2.053,2.053,0,0,0,63.224-7.9h.033v1.149Zm6.761-11.716V-6.748h1.395V-7.88h.033a2.247,2.247,0,0,0,.566.632,2.982,2.982,0,0,0,.714.4,3.874,3.874,0,0,0,.763.213,4.193,4.193,0,0,0,.7.066,3.94,3.94,0,0,0,1.7-.345,3.4,3.4,0,0,0,1.214-.944,4.018,4.018,0,0,0,.722-1.4,5.985,5.985,0,0,0,.238-1.707,5.8,5.8,0,0,0-.246-1.707,4.312,4.312,0,0,0-.73-1.419,3.488,3.488,0,0,0-1.214-.976,3.827,3.827,0,0,0-1.715-.361,4.043,4.043,0,0,0-1.625.32,2.088,2.088,0,0,0-1.083,1.026h-.033v-4.381Zm6.564,7.4a5.581,5.581,0,0,1-.131,1.214,3.212,3.212,0,0,1-.427,1.05,2.243,2.243,0,0,1-.779.738,2.385,2.385,0,0,1-1.206.279A2.589,2.589,0,0,1,74.2-8.052a2.389,2.389,0,0,1-.829-.714,2.985,2.985,0,0,1-.468-1.026A4.889,4.889,0,0,1,72.758-11a4.919,4.919,0,0,1,.139-1.165,3.053,3.053,0,0,1,.451-1.026,2.4,2.4,0,0,1,.8-.73,2.4,2.4,0,0,1,1.2-.279,2.491,2.491,0,0,1,1.173.263,2.332,2.332,0,0,1,.82.706,3.122,3.122,0,0,1,.476,1.009A4.338,4.338,0,0,1,77.976-11.063Zm6.449,5.448a8.871,8.871,0,0,1-.484,1.05,2.871,2.871,0,0,1-.525.7,1.782,1.782,0,0,1-.64.394,2.462,2.462,0,0,1-.812.123,3.721,3.721,0,0,1-.492-.033A2.324,2.324,0,0,1,81-3.5v-1.28a2.342,2.342,0,0,0,.418.139,1.765,1.765,0,0,0,.4.057,1.2,1.2,0,0,0,.714-.205,1.255,1.255,0,0,0,.435-.583L83.539-6.8l-3.364-8.434h1.575L84.228-8.29h.033l2.379-6.941h1.477Z" transform="translate(0.722 18.464)" fill="#fff"/></g></g></g></svg>`;





function $a2fd95e6c3869809$export$ccd5084c909b35f5(info) {
    switch(info.type){
        case (0, $adda256f81190c7f$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR:
            return $a2fd95e6c3869809$var$planar(info);
        case (0, $adda256f81190c7f$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CYLINDRICAL:
            return $a2fd95e6c3869809$var$cylindrical(info);
        case (0, $adda256f81190c7f$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CONICAL:
            return $a2fd95e6c3869809$var$conical(info);
    }
    return $a2fd95e6c3869809$var$defaultMesh();
}
function $a2fd95e6c3869809$var$planar(info) {
    const aspectRatio = info.trainedWidth / info.trainedHeight;
    if (isNaN(aspectRatio)) return $a2fd95e6c3869809$var$defaultMesh();
    const scaling = info.physicalScaleFactor > 0 ? info.physicalScaleFactor : 1;
    const vertices = new Float32Array([
        -1 * aspectRatio * scaling,
        -1 * scaling,
        0,
        -1 * aspectRatio * scaling,
        scaling,
        0,
        aspectRatio * scaling,
        scaling,
        0,
        aspectRatio * scaling,
        -1 * scaling,
        0
    ]);
    const indices = new Uint16Array([
        0,
        2,
        1,
        0,
        3,
        2
    ]);
    const uvs = new Float32Array([
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0
    ]);
    const normals = new Float32Array([
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1
    ]);
    return {
        vertices: vertices,
        indices: indices,
        uvs: uvs,
        normals: normals
    };
}
function $a2fd95e6c3869809$var$defaultMesh() {
    return {
        indices: new Uint16Array(0),
        vertices: new Float32Array(0),
        normals: new Float32Array(0),
        uvs: new Float32Array(0)
    };
}
function $a2fd95e6c3869809$var$cylindrical(info) {
    const wrap_amount = 2 * info.trainedWidth / (info.trainedHeight * info.topRadius);
    return $a2fd95e6c3869809$var$generalConical(info, 2, false, 0, 0, 0, (0, $15341bfe28675a89$exports).create(), info.trainedWidth / info.trainedHeight, wrap_amount, info.physicalScaleFactor);
}
function $a2fd95e6c3869809$var$conical(info) {
    const radius_diff = info.topRadius - info.bottomRadius;
    // Prevents divide by zero errors.
    if (radius_diff === 0) {
        console.warn("Conical target has matching radii, using cylindrical preview mesh with a defined image size instead.");
        return $a2fd95e6c3869809$var$cylindrical(info);
    }
    const height_3d = Math.sqrt(info.sideLength * info.sideLength - radius_diff * radius_diff);
    const flip = info.bottomRadius > info.topRadius;
    let aspect_ratio = info.trainedWidth / info.trainedHeight;
    if (isNaN(aspect_ratio)) aspect_ratio = 1;
    const cone = !(info.bottomRadius > 0) || !(info.topRadius > 0);
    const wide = info.sideLength < 2 * Math.abs(info.topRadius - info.bottomRadius);
    const top_corner = (0, $15341bfe28675a89$exports).create();
    const bottom_corner = (0, $15341bfe28675a89$exports).create();
    const rotation_center = (0, $15341bfe28675a89$exports).create();
    if (cone) {
        if (wide) {
            if (flip) {
                rotation_center[1] = aspect_ratio - 1;
                const omega = Math.acos((2 - aspect_ratio) / aspect_ratio);
                top_corner[0] = aspect_ratio * Math.sin(omega);
                top_corner[1] = aspect_ratio - 1 + aspect_ratio * Math.cos(omega);
                (0, $15341bfe28675a89$exports).copy(bottom_corner, rotation_center);
            } else {
                rotation_center[1] = 1.0 - aspect_ratio;
                const omega = Math.PI + Math.acos((2 - aspect_ratio) / aspect_ratio);
                top_corner[0] = aspect_ratio * Math.sin(omega);
                top_corner[1] = 1 - aspect_ratio + aspect_ratio * Math.cos(omega);
                (0, $15341bfe28675a89$exports).copy(bottom_corner, rotation_center);
            }
        } else if (flip) {
            rotation_center[1] = 1;
            (0, $15341bfe28675a89$exports).copy(bottom_corner, rotation_center);
            top_corner[0] = aspect_ratio;
            top_corner[1] = 1 - Math.sqrt(4 - Math.pow(aspect_ratio, 2));
        } else {
            rotation_center[1] = -1;
            (0, $15341bfe28675a89$exports).copy(bottom_corner, rotation_center);
            top_corner[0] = -aspect_ratio;
            top_corner[1] = Math.sqrt(4 - Math.pow(aspect_ratio, 2)) - 1;
        }
    } else if (wide) {
        if (flip) {
            rotation_center[1] = aspect_ratio - 1;
            const omega = Math.acos((2 - aspect_ratio) / aspect_ratio);
            top_corner[0] = aspect_ratio * Math.sin(omega);
            top_corner[1] = aspect_ratio - 1 + aspect_ratio * Math.cos(omega);
            bottom_corner[0] = (aspect_ratio - info.sideLength) * Math.sin(omega);
            bottom_corner[1] = aspect_ratio - 1 + (aspect_ratio - info.sideLength) * Math.cos(omega);
        } else {
            rotation_center[1] = 1.0 - aspect_ratio;
            const omega = Math.PI + Math.acos((2 - aspect_ratio) / aspect_ratio);
            top_corner[0] = aspect_ratio * Math.sin(omega);
            top_corner[1] = 1 - aspect_ratio + aspect_ratio * Math.cos(omega);
            bottom_corner[0] = (aspect_ratio - info.sideLength) * Math.sin(omega);
            bottom_corner[1] = 1 - aspect_ratio + (aspect_ratio - info.sideLength) * Math.cos(omega);
        }
    } else {
        const radius_ratio = flip ? info.topRadius / info.bottomRadius : info.bottomRadius / info.topRadius;
        if (flip) {
            bottom_corner[0] = radius_ratio * aspect_ratio;
            bottom_corner[1] = 1;
            top_corner[0] = aspect_ratio;
            top_corner[1] = 1 - Math.sqrt(info.sideLength * info.sideLength - (bottom_corner[0] - top_corner[0]) * (bottom_corner[0] - top_corner[0]));
            rotation_center[1] = top_corner[1] + top_corner[0] / (top_corner[0] - bottom_corner[0]) * (bottom_corner[1] - top_corner[1]);
        } else {
            bottom_corner[0] = -radius_ratio * aspect_ratio;
            bottom_corner[1] = -1;
            top_corner[0] = -aspect_ratio;
            top_corner[1] = Math.sqrt(info.sideLength * info.sideLength - (bottom_corner[0] - top_corner[0]) * (bottom_corner[0] - top_corner[0])) - 1;
            rotation_center[1] = top_corner[1] - -top_corner[0] / (bottom_corner[0] - top_corner[0]) * (top_corner[1] - bottom_corner[1]);
        }
    }
    const top_from_center = (0, $15341bfe28675a89$exports).create();
    (0, $15341bfe28675a89$exports).subtract(top_from_center, top_corner, rotation_center);
    const bottom_from_center = (0, $15341bfe28675a89$exports).create();
    (0, $15341bfe28675a89$exports).subtract(bottom_from_center, bottom_corner, rotation_center);
    const top_2d_radius = (0, $15341bfe28675a89$exports).length(top_from_center);
    const bottom_2d_radius = (0, $15341bfe28675a89$exports).length(bottom_from_center);
    let max_angle = 2 * Math.abs(Math.atan(top_from_center[0] / top_from_center[1]));
    if (wide) max_angle = 2 * Math.PI - max_angle;
    let theta_3d = top_2d_radius * max_angle / info.topRadius;
    let theta = Math.abs(Math.atan(top_from_center[0] / top_from_center[1]));
    if (wide) theta = Math.PI - theta;
    return $a2fd95e6c3869809$var$generalConical(info, height_3d, flip, theta, bottom_2d_radius, top_2d_radius, rotation_center, aspect_ratio, theta_3d, info.physicalScaleFactor);
}
function $a2fd95e6c3869809$var$generalConical(info, height_3d, flip, theta, bottom_2d_radius, top_2d_radius, rotation_center, aspect_ratio, wrap_amount, psf) {
    if (isNaN(aspect_ratio)) aspect_ratio = 1;
    const vertices = [];
    const uvs = [];
    const physical_scale = psf > 0 ? psf : 1;
    const scale_factor = physical_scale * 2.0 / height_3d;
    const subdivisons = 64;
    for(let s = 0; s <= subdivisons; ++s){
        const angle = s * wrap_amount / subdivisons + (2 * Math.PI - wrap_amount) / 2;
        const bx = info.bottomRadius * Math.sin(angle) * scale_factor;
        const bz = info.bottomRadius * Math.cos(angle) * scale_factor;
        const tx = info.topRadius * Math.sin(angle) * scale_factor;
        const tz = info.topRadius * Math.cos(angle) * scale_factor;
        const btm = -1 * physical_scale;
        const top = physical_scale;
        if (flip) {
            vertices.push(bx, btm, bz);
            vertices.push(tx, top, tz);
        } else {
            vertices.push(tx, top, -tz);
            vertices.push(bx, btm, -bz);
        }
    }
    for(let s = 0; s <= subdivisons; ++s)if (info.type == (0, $adda256f81190c7f$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_CYLINDRICAL) {
        const offset = 1 - s / subdivisons;
        uvs.push(offset, 1);
        uvs.push(offset, 0);
    } else {
        let angle_2d = -(s / subdivisons - 0.5) * 2 * theta;
        if (flip) {
            angle_2d = -angle_2d + theta;
            if (angle_2d > theta) angle_2d = -theta + (angle_2d - theta);
        }
        const direction = (0, $15341bfe28675a89$exports).create();
        direction[0] = Math.sin(angle_2d);
        direction[1] = Math.cos(angle_2d);
        if (flip) direction[1] *= -1;
        const bottom_px = (0, $15341bfe28675a89$exports).create();
        (0, $15341bfe28675a89$exports).copy(bottom_px, direction);
        (0, $15341bfe28675a89$exports).scale(bottom_px, bottom_px, bottom_2d_radius);
        (0, $15341bfe28675a89$exports).add(bottom_px, rotation_center, bottom_px);
        const top_px = (0, $15341bfe28675a89$exports).create();
        (0, $15341bfe28675a89$exports).copy(top_px, direction);
        (0, $15341bfe28675a89$exports).scale(top_px, top_px, top_2d_radius);
        (0, $15341bfe28675a89$exports).add(top_px, rotation_center, top_px);
        uvs.push((top_px[0] + aspect_ratio) / (2 * aspect_ratio), 1 - (-top_px[1] + 1) / 2);
        uvs.push((bottom_px[0] + aspect_ratio) / (2 * aspect_ratio), 1 - (-bottom_px[1] + 1) / 2);
    }
    const indices = [];
    for(let i = 0; i < subdivisons; ++i){
        const bi = i * 2;
        indices.push(bi + 1, bi + 2, bi + 3);
        indices.push(bi + 0, bi + 2, bi + 1);
    }
    return {
        vertices: new Float32Array(vertices),
        indices: new Uint16Array(indices),
        normals: new Float32Array(0),
        uvs: new Float32Array(uvs)
    };
}


const $8f4c0480efdbc341$var$decoder = new TextDecoder();
class $8f4c0480efdbc341$export$55f75071f06461bb {
    constructor(_data, _paddingBytes = false){
        this._data = _data;
        this._paddingBytes = _paddingBytes;
        this.truncatedChunks = false;
        this._view = new DataView(this._data);
        this.root = this._parse();
    }
    _parse() {
        const header = $8f4c0480efdbc341$var$decoder.decode(this._data.slice(0, 4));
        if (header !== "RIFF") throw new Error("Not a valid ZPT file");
        return this._parseChunk(0);
    }
    _parseChunk(offset) {
        const ident = $8f4c0480efdbc341$var$decoder.decode(this._data.slice(offset, offset + 4));
        const length = this._view.getUint32(offset + 4, true);
        const data = new Uint8Array(this._data, offset + 8, length);
        if (data.byteLength !== length) this.truncatedChunks = true;
        let subchunks;
        let subident;
        if (ident === "RIFF" || ident === "LIST") {
            subident = $8f4c0480efdbc341$var$decoder.decode(this._data.slice(offset + 8, offset + 12));
            subchunks = [];
            let currentOffset = 4;
            while(currentOffset < data.byteLength - 1){
                const subchunk = this._parseChunk(offset + 8 + currentOffset);
                subchunks.push(subchunk);
                currentOffset += subchunk.data.byteLength + 8;
                if (this._paddingBytes && subchunk.data.byteLength & 0x1) currentOffset++;
            }
        }
        return {
            ident: ident,
            data: data,
            subident: subident,
            subchunks: subchunks
        };
    }
    find(str, inChunk = this.root) {
        if (inChunk.ident === str) return inChunk;
        if (!inChunk.subchunks) return;
        for (let c of inChunk.subchunks){
            const found = this.find(str, c);
            if (found) return found;
        }
    }
    has(str) {
        return this.find(str) !== undefined;
    }
}


let $3093aba598d2b043$var$byId = new Map();
const $3093aba598d2b043$var$decoder = new TextDecoder();
class $3093aba598d2b043$export$333222788f3dd075 {
    constructor(_client, _impl){
        this._client = _client;
        this._impl = _impl;
        this._targets = [];
    }
    static create(pipeline, client) {
        let ret = client.image_tracker_create(pipeline);
        $3093aba598d2b043$var$byId.set(ret, new $3093aba598d2b043$export$333222788f3dd075(client, ret));
        return ret;
    }
    static get(p) {
        return $3093aba598d2b043$var$byId.get(p);
    }
    destroy() {
        this._client.image_tracker_destroy(this._impl);
        $3093aba598d2b043$var$byId.delete(this._impl);
    }
    loadFromMemory(data) {
        this._targets.push({
            data: data
        });
        this._client.image_tracker_target_load_from_memory(this._impl, data);
    }
    targetCount() {
        return this._targets.length;
    }
    getTargetInfo(i) {
        let current = this._targets[i];
        if (current && current.info) return current.info;
        current.info = {
            topRadius: -1,
            bottomRadius: -1,
            sideLength: -1,
            physicalScaleFactor: -1,
            trainedWidth: 0,
            trainedHeight: 0,
            type: (0, $adda256f81190c7f$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR
        };
        try {
            const reader = new (0, $8f4c0480efdbc341$export$55f75071f06461bb)(current.data, false);
            const imgChunk = reader.find("IMG ");
            if (imgChunk) {
                let mimeType = "image/png";
                const mimeTypeChunk = reader.find("IMGM");
                if (mimeTypeChunk) mimeType = $3093aba598d2b043$var$decoder.decode(mimeTypeChunk.data);
                current.info.preview = {
                    mimeType: mimeType,
                    compressed: imgChunk.data
                };
            }
            const odleChunk = reader.find("ODLE");
            if (odleChunk) {
                const odle = $3093aba598d2b043$var$decoder.decode(odleChunk.data);
                this._parseOdle(odle, current.info);
            }
        } catch (err) {}
        return current.info;
    }
    _parseOdle(data, info) {
        let currentOffset = 0;
        let version = "0";
        [version, currentOffset] = $3093aba598d2b043$var$readLine(currentOffset, data);
        if (version === "1") return this._parseOdleV1(data, currentOffset, info);
        else if (version === "3") return this._parseOdleV3(data, currentOffset, info);
    }
    _parseOdleV1(data, currentOffset, info) {
        let treeOrFlat = "0";
        [treeOrFlat, currentOffset] = $3093aba598d2b043$var$readLine(currentOffset, data);
        if (treeOrFlat !== "0" && treeOrFlat !== "1") return;
        let emptyLine = "";
        [emptyLine, currentOffset] = $3093aba598d2b043$var$readLine(currentOffset, data);
        if (emptyLine.length !== 0) return;
        let infoLine = "";
        [infoLine, currentOffset] = $3093aba598d2b043$var$readLine(currentOffset, data);
        const infoLineParts = infoLine.split(" ");
        if (infoLineParts.length < 5) return;
        info.trainedWidth = parseInt(infoLineParts[3].replace("[", ""));
        info.trainedHeight = parseInt(infoLineParts[4].replace("]", ""));
    }
    _parseOdleV3(data, currentOffset, info) {
        let treeOrFlat = "0";
        [treeOrFlat, currentOffset] = $3093aba598d2b043$var$readLine(currentOffset, data);
        if (treeOrFlat !== "0" && treeOrFlat !== "1") return;
        let numberTargets = "0";
        [numberTargets, currentOffset] = $3093aba598d2b043$var$readLine(currentOffset, data);
        const parsedTargets = parseInt(numberTargets);
        if (isNaN(parsedTargets) || parsedTargets < 1) return;
        let emptyLine = "";
        [emptyLine, currentOffset] = $3093aba598d2b043$var$readLine(currentOffset, data);
        if (emptyLine.length !== 0) return;
        let infoLine = "";
        [infoLine, currentOffset] = $3093aba598d2b043$var$readLine(currentOffset, data);
        const infoLineParts = infoLine.split(" ");
        if (infoLineParts.length < 6) return;
        const targetType = parseInt(infoLineParts[0]);
        if (targetType === 0 || targetType === 1 || targetType === 2) info.type = targetType;
        info.trainedWidth = parseInt(infoLineParts[4].replace("[", ""));
        info.trainedHeight = parseInt(infoLineParts[5].replace("]", ""));
        if (infoLineParts.length >= 7) {
            info.physicalScaleFactor = parseFloat(infoLineParts[6]);
            if (isNaN(info.physicalScaleFactor)) info.physicalScaleFactor = -1;
        }
        if (infoLineParts.length >= 8) {
            info.topRadius = parseFloat(infoLineParts[7]);
            if (isNaN(info.topRadius)) info.topRadius = -1;
            info.bottomRadius = info.topRadius;
        }
        if (infoLineParts.length >= 9) {
            info.bottomRadius = parseFloat(infoLineParts[8]);
            if (isNaN(info.bottomRadius)) info.bottomRadius = -1;
        }
        if (infoLineParts.length >= 10) {
            info.sideLength = parseFloat(infoLineParts[9]);
            if (isNaN(info.sideLength)) info.sideLength = -1;
        }
    }
    getDecodedPreview(i) {
        const info = this.getTargetInfo(i);
        if (!info.preview) return undefined;
        if (!info.preview.image) {
            const blob = new Blob([
                info.preview.compressed
            ], {
                type: info.preview.mimeType
            });
            info.preview.image = new Image();
            info.preview.image.src = URL.createObjectURL(blob);
        }
        return info.preview.image;
    }
    getPreviewMesh(i) {
        const info = this.getTargetInfo(i);
        if (!info.previewMesh) info.previewMesh = (0, $a2fd95e6c3869809$export$ccd5084c909b35f5)(info);
        return info.previewMesh;
    }
}
function $3093aba598d2b043$var$readLine(offset, str) {
    let indx = str.indexOf("\n", offset);
    return [
        str.substring(offset, indx >= 0 ? indx : undefined).replace("\r", ""),
        indx + 1
    ];
}


var $97b6f9b149f90503$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $97b6f9b149f90503$var$client;
var $08d0c52730ce8b0c$exports = {};


$08d0c52730ce8b0c$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("fvGib");



var $cfa72f92b6cc7212$exports = {};


$cfa72f92b6cc7212$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("7epEH");


function $97b6f9b149f90503$export$2a47f398eeff8b01(opts) {
    if ($97b6f9b149f90503$var$client) return $97b6f9b149f90503$var$client;
    let loaded = false;
    (0, $ef3859a96b6c3dd7$exports.launchWorker)(opts === null || opts === void 0 ? void 0 : opts.worker).then(()=>{
        (0, $46062ba68c57c43e$export$454156e929b28fe7)("Fully loaded");
        loaded = true;
    });
    let c = new (0, $07fd930278135cf3$export$ada9decabe1e7aa7)((ab)=>{
        (0, $ef3859a96b6c3dd7$exports.messageManager).postOutgoingMessage({
            t: "zappar",
            d: ab
        }, [
            ab
        ]);
    });
    const uid = $97b6f9b149f90503$var$getUID();
    let hasPersistedUID = false;
    if (window.location.hostname.toLowerCase().indexOf(".zappar.io") > 0 || window.location.hostname.toLowerCase().indexOf(".webar.run") > 0 || window.location.hostname.toLowerCase().indexOf(".arweb.app") > 0) {
        let pathParts = window.location.pathname.split("/");
        if (pathParts.length > 1 && pathParts[1].length > 0) c.impl.analytics_project_id_set(".wiz" + pathParts[1], uid);
    }
    (0, $ef3859a96b6c3dd7$exports.messageManager).onIncomingMessage.bind((msg)=>{
        var _a, _b, _c, _d, _e, _f, _g;
        switch(msg.t){
            case "zappar":
                (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(msg.p)) === null || _a === void 0 || _a.pendingMessages.push(msg.d);
                break;
            case "buf":
                c.serializer.bufferReturn(msg.d);
                break;
            case "cameraFrameRecycleS2C":
                {
                    let msgt = msg;
                    (_c = (_b = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(msgt.p)) === null || _b === void 0 ? void 0 : _b.cameraTokenReturn) === null || _c === void 0 || _c.call(_b, msg);
                    break;
                }
            case "videoFrameS2C":
                {
                    let msgt = msg;
                    (_e = (_d = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(msgt.p)) === null || _d === void 0 ? void 0 : _d.videoFrameFromWorker) === null || _e === void 0 || _e.call(_d, msgt);
                    break;
                }
            case "imageBitmapS2C":
                {
                    let msgt = msg;
                    (_g = (_f = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(msgt.p)) === null || _f === void 0 ? void 0 : _f.imageBitmapFromWorker) === null || _g === void 0 || _g.call(_f, msgt);
                    break;
                }
            case "licerr":
                {
                    let div = document.createElement("div");
                    div.innerHTML = "Visit <a href='https://docs.zap.works/universal-ar/licensing/' style='color: white;'>our licensing page</a> to find out about hosting on your own domain.";
                    div.style.position = "absolute";
                    div.style.bottom = "20px";
                    div.style.width = "80%";
                    div.style.backgroundColor = "black";
                    div.style.color = "white";
                    div.style.borderRadius = "10px";
                    div.style.padding = "10px";
                    div.style.fontFamily = "sans-serif";
                    div.style.textAlign = "center";
                    div.style.left = "10%";
                    div.style.zIndex = Number.MAX_SAFE_INTEGER.toString();
                    let span = document.createElement("span");
                    span.innerText = " (30)";
                    div.append(span);
                    let indx = 30;
                    setInterval(function() {
                        indx--;
                        if (indx >= 0) span.innerText = " (" + indx.toString() + ")";
                    }, 1000);
                    document.body.append(div);
                }
            case "gfx":
                {
                    let div = document.createElement("div");
                    div.innerHTML = (0, $8bda6e055faa194a$export$4cf8838f9102a661);
                    div.style.position = "absolute";
                    div.style.bottom = "20px";
                    div.style.width = "250px";
                    div.style.left = "50%";
                    div.style.marginLeft = "-125px";
                    div.style.zIndex = Number.MAX_SAFE_INTEGER.toString();
                    div.style.opacity = "0";
                    div.style.transition = "opacity 0.5s";
                    document.body.append(div);
                    setTimeout(function() {
                        div.style.opacity = "1";
                    }, 500);
                    setTimeout(function() {
                        div.style.opacity = "0";
                    }, 3000);
                    setTimeout(function() {
                        div.remove();
                    }, 4000);
                }
        }
    });
    $97b6f9b149f90503$var$client = Object.assign(Object.assign({}, c.impl), {
        loaded: ()=>loaded,
        camera_default_device_id: (userFacing)=>userFacing ? (0, $9cbab9aac84784d2$exports.CameraSource).USER_DEFAULT_DEVICE_ID : (0, $9cbab9aac84784d2$exports.CameraSource).DEFAULT_DEVICE_ID,
        camera_source_create: (p, deviceId)=>(0, $72f2c4e7422e6f6a$export$3612a413b5e57058)(p, deviceId),
        camera_source_destroy: (cam)=>{
            var _a;
            return (_a = (0, $72f2c4e7422e6f6a$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        camera_source_pause: (cam)=>{
            var _a;
            return (_a = (0, $72f2c4e7422e6f6a$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        camera_source_start: (cam)=>{
            var _a;
            return (_a = (0, $72f2c4e7422e6f6a$export$cf42922f9ae76ed1)(cam)) === null || _a === void 0 ? void 0 : _a.start();
        },
        camera_count: ()=>2,
        camera_id: (indx)=>indx === 0 ? (0, $9cbab9aac84784d2$exports.CameraSource).DEFAULT_DEVICE_ID : (0, $9cbab9aac84784d2$exports.CameraSource).USER_DEFAULT_DEVICE_ID,
        camera_name: (indx)=>indx === 0 ? "Rear-facing Camera" : "User-facing Camera",
        camera_user_facing: (indx)=>indx !== 0,
        pipeline_create: ()=>(0, $24725864d261e6a0$export$abd47b564b6c9ce2).create(c.impl, (0, $ef3859a96b6c3dd7$exports.messageManager)),
        pipeline_frame_update: (p)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.frameUpdate(c);
        },
        pipeline_camera_frame_draw_gl: (pipeline, screenWidth, screenHeight, mirror)=>{
            var _a;
            (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(pipeline)) === null || _a === void 0 || _a.cameraFrameDrawGL(screenWidth, screenHeight, mirror);
        },
        draw_plane: (gl, projectionMatrix, cameraMatrix, targetMatrix, texture)=>{
            (0, $d580c9e8b84c13cf$export$4807f772bfdbc71f)(gl, projectionMatrix, cameraMatrix, targetMatrix, texture);
        },
        pipeline_draw_face: (p, projectionMatrix, cameraMatrix, targetMatrix, o)=>{
            var _a;
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call draw_face on a destroyed zappar_face_mesh_t");
                return new Uint16Array();
            }
            (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawFace(projectionMatrix, cameraMatrix, targetMatrix, obj);
        },
        pipeline_draw_face_project: (p, matrix, vertices, uvMatrix, uvs, indices, texture)=>{
            var _a;
            (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawFaceProject(matrix, vertices, uvMatrix, uvs, indices, texture);
        },
        pipeline_draw_image_target_preview: (p, projectionMatrix, cameraMatrix, targetMatrix, o, indx)=>{
            var _a;
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("image tracker not found");
                return;
            }
            (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 || _a.drawImageTargetPreview(projectionMatrix, cameraMatrix, targetMatrix, indx, obj);
        },
        projection_matrix_from_camera_model: (0, $b64a7e1fb5f394c7$export$ca7f1c5c0280e0bf),
        projection_matrix_from_camera_model_ext: (0, $b64a7e1fb5f394c7$export$ca7f1c5c0280e0bf),
        pipeline_process_gl: (p)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.processGL();
        },
        pipeline_gl_context_set: (p, gl, texturePool)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.glContextSet(gl, texturePool);
        },
        pipeline_gl_context_lost: (p)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.glContextLost();
        },
        pipeline_camera_frame_upload_gl: (p)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.uploadGL();
        },
        pipeline_camera_frame_texture_gl: (p)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameTexture();
        },
        pipeline_camera_frame_texture_matrix: (p, sw, sh, mirror)=>{
            var _a;
            return ((_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameTextureMatrix(sw, sh, mirror)) || (0, $2edf3b5f20103352$exports).create();
        },
        pipeline_camera_frame_user_facing: (p)=>{
            var _a;
            return ((_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraFrameUserFacing()) || false;
        },
        pipeline_camera_pose_default: ()=>(0, $2edf3b5f20103352$exports).create(),
        pipeline_camera_pose_with_attitude: (p, mirror)=>{
            var _a;
            return ((_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.cameraPoseWithAttitude(mirror)) || (0, $2edf3b5f20103352$exports).create();
        },
        pipeline_camera_pose_with_origin: (p, o)=>{
            let res = (0, $2edf3b5f20103352$exports).create();
            (0, $2edf3b5f20103352$exports).invert(res, o);
            return res;
        },
        pipeline_sequence_record_clear: (p)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordClear();
        },
        pipeline_sequence_record_start: (p, expectedFrames)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordStart(expectedFrames);
        },
        pipeline_sequence_record_stop: (p)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordStop();
        },
        pipeline_sequence_record_device_attitude_matrices_set: (p, v)=>{
            var _a;
            return (_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordDeviceAttitudeMatrices(v);
        },
        pipeline_sequence_record_data: (p)=>{
            var _a;
            return ((_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordData()) || new Uint8Array(0);
        },
        pipeline_sequence_record_data_size: (p)=>{
            var _a;
            return ((_a = (0, $24725864d261e6a0$export$abd47b564b6c9ce2).get(p)) === null || _a === void 0 ? void 0 : _a.sequenceRecordData().byteLength) || 0;
        },
        instant_world_tracker_anchor_pose_camera_relative: (o, mirror)=>{
            let res = (0, $24725864d261e6a0$export$9e7b3df2d144a412)(undefined, c.impl.instant_world_tracker_anchor_pose_raw(o));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            return res;
        },
        instant_world_tracker_anchor_pose: (o, cameraPose, mirror)=>{
            let res = (0, $24725864d261e6a0$export$9e7b3df2d144a412)(undefined, c.impl.instant_world_tracker_anchor_pose_raw(o));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            (0, $2edf3b5f20103352$exports).multiply(res, cameraPose, res);
            return res;
        },
        instant_world_tracker_anchor_pose_set_from_camera_offset: (o, x, y, z, orientation)=>{
            // TODO - add an _ext function if we need to support mirrored cameras with an extra param
            // if(mirror) {
            //     x *= -1;
            // }
            // TODO - can we access the appropriate pipeline here to call pipeline_camera_frame_user_facing(p)?
            let userFacing = false;
            let rotation = (0, $b64a7e1fb5f394c7$export$83fad53f837eba8e)(userFacing) * Math.PI / 180.0;
            let rotationMat = (0, $2edf3b5f20103352$exports).create();
            (0, $2edf3b5f20103352$exports).fromRotation(rotationMat, -rotation, [
                0,
                0,
                1
            ]);
            let rawVec = (0, $7aaf532207b60e73$exports).create();
            (0, $7aaf532207b60e73$exports).transformMat4(rawVec, [
                x,
                y,
                z
            ], rotationMat);
            c.impl.instant_world_tracker_anchor_pose_set_from_camera_offset_raw(o, rawVec[0], rawVec[1], rawVec[2], orientation);
        },
        image_tracker_create: (pipeline)=>(0, $3093aba598d2b043$export$333222788f3dd075).create(pipeline, c.impl),
        image_tracker_destroy: (t)=>{
            var _a;
            return (_a = (0, $3093aba598d2b043$export$333222788f3dd075).get(t)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        image_tracker_target_type: (t, i)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_type on a destroyed zappar_image_tracker_t");
                return (0, $adda256f81190c7f$export$7f44ab26face7b78).IMAGE_TRACKER_TYPE_PLANAR;
            }
            return obj.getTargetInfo(i).type;
        },
        image_tracker_target_count: (t)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_count on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.targetCount();
        },
        image_tracker_target_load_from_memory: (t, data)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_load_from_memory on a destroyed zappar_image_tracker_t");
                return 0;
            }
            obj.loadFromMemory(data);
        },
        image_tracker_target_preview_compressed: (t, i)=>{
            var _a;
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed on a destroyed zappar_image_tracker_t");
                return new Uint8Array(0);
            }
            return ((_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.compressed) || new Uint8Array(0);
        },
        image_tracker_target_preview_compressed_mimetype: (t, i)=>{
            var _a;
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed_mimetype on a destroyed zappar_image_tracker_t");
                return "";
            }
            return ((_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.mimeType) || "";
        },
        image_tracker_target_preview_compressed_size: (t, i)=>{
            var _a, _b;
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_compressed_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return ((_b = (_a = obj.getTargetInfo(i).preview) === null || _a === void 0 ? void 0 : _a.compressed) === null || _b === void 0 ? void 0 : _b.byteLength) || 0;
        },
        image_tracker_target_physical_scale_factor: (t, i)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_physical_scale_factor on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).physicalScaleFactor;
        },
        image_tracker_target_radius_top: (t, i)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_radius_top on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).topRadius;
        },
        image_tracker_target_radius_bottom: (t, i)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_radius_bottom on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).bottomRadius;
        },
        image_tracker_target_side_length: (t, i)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_side_length on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getTargetInfo(i).sideLength;
        },
        image_tracker_target_image: (t, i)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(t);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_image on a destroyed zappar_image_tracker_t");
                return new Image();
            }
            return obj.getDecodedPreview(i);
        },
        image_tracker_anchor_pose_camera_relative: (o, indx, mirror)=>{
            let res = (0, $24725864d261e6a0$export$9e7b3df2d144a412)(undefined, c.impl.image_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            return res;
        },
        image_tracker_anchor_pose: (o, indx, cameraPose, mirror)=>{
            let res = (0, $24725864d261e6a0$export$9e7b3df2d144a412)(undefined, c.impl.image_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            (0, $2edf3b5f20103352$exports).multiply(res, cameraPose, res);
            return res;
        },
        image_tracker_target_preview_mesh_indices: (o, indx)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_indices on a destroyed zappar_image_tracker_t");
                return new Uint16Array();
            }
            return obj.getPreviewMesh(indx).indices;
        },
        image_tracker_target_preview_mesh_vertices: (o, indx)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_vertices on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).vertices;
        },
        image_tracker_target_preview_mesh_uvs: (o, indx)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_uvs on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).uvs;
        },
        image_tracker_target_preview_mesh_normals: (o, indx)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_normals on a destroyed zappar_image_tracker_t");
                return new Float32Array();
            }
            return obj.getPreviewMesh(indx).normals;
        },
        image_tracker_target_preview_mesh_indices_size: (o, indx)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_indices_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).indices.length;
        },
        image_tracker_target_preview_mesh_vertices_size: (o, indx)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_vertices_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).vertices.length;
        },
        image_tracker_target_preview_mesh_uvs_size: (o, indx)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_uvs_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).uvs.length;
        },
        image_tracker_target_preview_mesh_normals_size: (o, indx)=>{
            let obj = (0, $3093aba598d2b043$export$333222788f3dd075).get(o);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call image_tracker_target_preview_mesh_normals_size on a destroyed zappar_image_tracker_t");
                return 0;
            }
            return obj.getPreviewMesh(indx).normals.length;
        },
        face_tracker_anchor_pose_camera_relative: (o, indx, mirror)=>{
            let res = (0, $24725864d261e6a0$export$9e7b3df2d144a412)(undefined, c.impl.face_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            return res;
        },
        face_tracker_anchor_pose: (o, indx, cameraPose, mirror)=>{
            let res = (0, $24725864d261e6a0$export$9e7b3df2d144a412)(undefined, c.impl.face_tracker_anchor_pose_raw(o, indx));
            if (mirror) {
                let scale = (0, $2edf3b5f20103352$exports).create();
                (0, $2edf3b5f20103352$exports).fromScaling(scale, [
                    -1,
                    1,
                    1
                ]);
                (0, $2edf3b5f20103352$exports).multiply(res, scale, res);
                (0, $2edf3b5f20103352$exports).multiply(res, res, scale);
            }
            (0, $2edf3b5f20103352$exports).multiply(res, cameraPose, res);
            return res;
        },
        face_tracker_model_load_default: (o)=>$97b6f9b149f90503$var$__awaiter(this, void 0, void 0, function*() {
                yield $97b6f9b149f90503$var$loadDefaultFaceModel(o);
            }),
        face_mesh_create: ()=>{
            return (0, $db4b46ac65f12ff1$export$3a09cf4ac8b68494)();
        },
        face_mesh_destroy: (m)=>{
            (0, $db4b46ac65f12ff1$export$eed3c787ca5a1447)(m);
        },
        face_mesh_indices: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_indices on a destroyed zappar_face_mesh_t");
                return new Uint16Array();
            }
            return obj.getIndices();
        },
        face_mesh_indices_size: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_indices_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getIndices().length;
        },
        face_mesh_uvs: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_uvs on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getUVs();
        },
        face_mesh_uvs_size: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_uvs_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getUVs().length;
        },
        face_mesh_vertices: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_vertices on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getVertices();
        },
        face_mesh_vertices_size: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_vertices_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getVertices().length;
        },
        face_mesh_normals: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_normals on a destroyed zappar_face_mesh_t");
                return new Float32Array();
            }
            return obj.getNormals();
        },
        face_mesh_normals_size: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_normals_size on a destroyed zappar_face_mesh_t");
                return 0;
            }
            return obj.getNormals().length;
        },
        face_mesh_load_from_memory: (m, ab, fillMouth, fillEyeL, fillEyeR, fillNeck)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_load_from_memory on a destroyed zappar_face_mesh_t");
                return;
            }
            obj.loadFromMemory(ab, fillMouth, fillEyeL, fillEyeR, fillNeck);
        },
        face_mesh_update: (m, identity, expression, mirrored)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_update on a destroyed zappar_face_mesh_t");
                return;
            }
            obj.update(identity, expression, mirrored);
        },
        face_mesh_load_default: (m)=>$97b6f9b149f90503$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_load_default on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($08d0c52730ce8b0c$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), false, false, false, false);
            }),
        face_mesh_load_default_face: (m, fillMouth, fillEyeL, fillEyeR)=>$97b6f9b149f90503$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_load_default_face on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($08d0c52730ce8b0c$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), fillMouth, fillEyeL, fillEyeR, false);
            }),
        face_mesh_load_default_full_head_simplified: (m, fillMouth, fillEyeL, fillEyeR, fillNeck)=>$97b6f9b149f90503$var$__awaiter(this, void 0, void 0, function*() {
                let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
                if (!obj) {
                    (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_load_default_full_head_simplified on a destroyed zappar_face_mesh_t");
                    return;
                }
                let url = new URL($cfa72f92b6cc7212$exports);
                let req = yield fetch(url.toString());
                obj.loadFromMemory((yield req.arrayBuffer()), fillMouth, fillEyeL, fillEyeR, fillNeck);
            }),
        face_mesh_loaded_version: (m)=>{
            let obj = (0, $db4b46ac65f12ff1$export$139ac0d2bb1e45ec)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_mesh_load_default on a destroyed zappar_face_mesh_t");
                return -1;
            }
            return obj.getModelVersion();
        },
        face_landmark_create: (n)=>{
            return (0, $e5235e83cd175b07$export$36e720c0ee0eafff)(n);
        },
        face_landmark_destroy: (m)=>{
            (0, $e5235e83cd175b07$export$4a91c83b2945af9c)(m);
        },
        face_landmark_update: (m, identity, expression, mirrored)=>{
            let obj = (0, $e5235e83cd175b07$export$2cdf232f18b0ea25)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_landmark_update on a destroyed zappar_face_landmark_t");
                return;
            }
            obj.update(identity, expression, mirrored);
        },
        face_landmark_anchor_pose: (m)=>{
            let obj = (0, $e5235e83cd175b07$export$2cdf232f18b0ea25)(m);
            if (!obj) {
                (0, $46062ba68c57c43e$export$79a36c979e81230e)("attempting to call face_landmark_anchor_pose on a destroyed zappar_face_landmark_t");
                return (0, $2edf3b5f20103352$exports).create();
            }
            return obj.anchor_pose;
        },
        html_element_source_create: (pipeline, elm)=>(0, $2be767d2fbd2d81c$export$bbfb48c500076b66).createVideoElementSource(pipeline, elm),
        html_element_source_start: (o)=>{
            var _a;
            return (_a = (0, $2be767d2fbd2d81c$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.start();
        },
        html_element_source_pause: (o)=>{
            var _a;
            return (_a = (0, $2be767d2fbd2d81c$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        html_element_source_destroy: (o)=>{
            var _a;
            return (_a = (0, $2be767d2fbd2d81c$export$bbfb48c500076b66).getVideoElementSource(o)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        sequence_source_create: (p)=>(0, $72e5942e3d068a06$export$9035336025e5be06).create(p),
        sequence_source_load_from_memory: (o, data)=>{
            var _a;
            return (_a = (0, $72e5942e3d068a06$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.loadFromMemory(data);
        },
        sequence_source_pause: (o)=>{
            var _a;
            return (_a = (0, $72e5942e3d068a06$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.pause();
        },
        sequence_source_start: (o)=>{
            var _a;
            return (_a = (0, $72e5942e3d068a06$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.start();
        },
        sequence_source_max_playback_fps_set: (o, fps)=>{
            var _a;
            return (_a = (0, $72e5942e3d068a06$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.maxPlaybackFpsSet(fps);
        },
        sequence_source_time_set: (o, t)=>{
            var _a;
            return (_a = (0, $72e5942e3d068a06$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.setTime(t);
        },
        sequence_source_destroy: (o)=>{
            var _a;
            return (_a = (0, $72e5942e3d068a06$export$9035336025e5be06).get(o)) === null || _a === void 0 ? void 0 : _a.destroy();
        },
        permission_granted_all: (0, $a38163fdf9bac037$exports.permissionGrantedAll),
        permission_granted_camera: (0, $a38163fdf9bac037$exports.permissionGrantedCamera),
        permission_granted_motion: (0, $a38163fdf9bac037$exports.permissionGrantedMotion),
        permission_denied_any: (0, $a38163fdf9bac037$exports.permissionDeniedAny),
        permission_denied_camera: (0, $a38163fdf9bac037$exports.permissionDeniedCamera),
        permission_denied_motion: (0, $a38163fdf9bac037$exports.permissionDeniedMotion),
        permission_request_motion: (0, $a38163fdf9bac037$exports.permissionRequestMotion),
        permission_request_camera: (0, $a38163fdf9bac037$exports.permissionRequestCamera),
        permission_request_all: (0, $a38163fdf9bac037$exports.permissionRequestAll),
        permission_request_ui: (0, $a38163fdf9bac037$exports.permissionRequestUI),
        permission_request_ui_promise: (0, $a38163fdf9bac037$exports.permissionRequestUI),
        permission_denied_ui: (0, $a38163fdf9bac037$exports.permissionDeniedUI),
        browser_incompatible: (0, $0a2942d639f1b4d7$export$2e2bcd8739ae039).incompatible,
        browser_incompatible_ui: (0, $0a2942d639f1b4d7$export$2e2bcd8739ae039).incompatible_ui,
        log_level_set: (l)=>{
            (0, $46062ba68c57c43e$export$c622e99c0ce7b1c9)(l);
            c.impl.log_level_set(l);
        },
        cookies_permitted: (p)=>{
            if (p) {
                if (!hasPersistedUID) {
                    $97b6f9b149f90503$var$persistUID(uid);
                    hasPersistedUID = true;
                }
            } else $97b6f9b149f90503$var$deleteUID();
        }
    });
    return $97b6f9b149f90503$var$client;
}
var $18cf34ede5cdd23b$exports = {};


$18cf34ede5cdd23b$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("3L11X");


function $97b6f9b149f90503$var$loadDefaultFaceModel(o) {
    return $97b6f9b149f90503$var$__awaiter(this, void 0, void 0, function*() {
        let url = new URL($18cf34ede5cdd23b$exports);
        let data = yield fetch(url.toString());
        let ab = yield data.arrayBuffer();
        $97b6f9b149f90503$var$client === null || $97b6f9b149f90503$var$client === void 0 || $97b6f9b149f90503$var$client.face_tracker_model_load_from_memory(o, ab);
    });
}
function $97b6f9b149f90503$var$getUID() {
    let uid = window.localStorage.getItem("z_uar_lid");
    if (uid === null) {
        const destination = new Uint8Array(8);
        window.crypto.getRandomValues(destination);
        uid = "";
        for(let i = 0; i < destination.byteLength; i++){
            const part = destination[i].toString(16);
            if (part.length === 1) uid += "0" + part;
            else if (part.length === 2) uid += part;
        }
    }
    return uid;
}
function $97b6f9b149f90503$var$persistUID(u) {
    window.localStorage.setItem("z_uar_lid", u);
}
function $97b6f9b149f90503$var$deleteUID() {
    window.localStorage.removeItem("z_uar_lid");
}


const $579e15a231e05c81$export$a4ad2735b021c132 = "2.1.5";



function $44af4e948948a9a2$export$2a47f398eeff8b01(opts) {
    console.log(`Zappar CV v${(0, $579e15a231e05c81$export$a4ad2735b021c132)}`);
    return (0, $97b6f9b149f90503$exports.initialize)(opts);
}



/**
  * SDK version.
*/ const $e7a2e8ef94eba5d5$export$a4ad2735b021c132 = "2.2.3";


var $6516b0b5f2779a72$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $6516b0b5f2779a72$var$_z;
let $6516b0b5f2779a72$var$_options;
function $6516b0b5f2779a72$export$add91eafeaeab287(opts) {
    if ($6516b0b5f2779a72$var$_z) console.warn("setOptions called after Zappar JS initialization");
    $6516b0b5f2779a72$var$_options = opts;
}
function $6516b0b5f2779a72$export$df995fae86a55f06() {
    if (!$6516b0b5f2779a72$var$_z) {
        console.log(`Zappar JS v${(0, $e7a2e8ef94eba5d5$export$a4ad2735b021c132)}`);
        $6516b0b5f2779a72$var$_z = (0, $44af4e948948a9a2$export$2a47f398eeff8b01)($6516b0b5f2779a72$var$_options);
    }
    return $6516b0b5f2779a72$var$_z;
}
function $6516b0b5f2779a72$export$5e22cf87be86f6fa(userFacing) {
    return $6516b0b5f2779a72$export$df995fae86a55f06().camera_default_device_id(userFacing || false);
}
function $6516b0b5f2779a72$export$6897c284b6f9f4dc(m) {
    const ret = (0, $2edf3b5f20103352$exports).create();
    (0, $2edf3b5f20103352$exports).invert(ret, m);
    return ret;
}
function $6516b0b5f2779a72$export$790b3b94a8142dee(model, renderWidth, renderHeight, zNear = 0.1, zFar = 100) {
    return $6516b0b5f2779a72$export$df995fae86a55f06().projection_matrix_from_camera_model_ext(model, renderWidth, renderHeight, zNear, zFar);
}
function $6516b0b5f2779a72$export$4807f772bfdbc71f(gl, projectionMatrix, cameraMatrix, targetMatrix, texture) {
    $6516b0b5f2779a72$export$df995fae86a55f06().draw_plane(gl, projectionMatrix, cameraMatrix, targetMatrix, texture);
}
function $6516b0b5f2779a72$export$45d46abc43ff1aac() {
    return $6516b0b5f2779a72$export$df995fae86a55f06().browser_incompatible();
}
function $6516b0b5f2779a72$export$5485d7c8ccfb3ed0() {
    $6516b0b5f2779a72$export$df995fae86a55f06().browser_incompatible_ui();
}
function $6516b0b5f2779a72$export$b40fc69c4a2927a1() {
    return $6516b0b5f2779a72$export$df995fae86a55f06().loaded();
}
function $6516b0b5f2779a72$export$6b6393bedfd195a0() {
    return $6516b0b5f2779a72$var$__awaiter(this, void 0, void 0, function*() {
        while(true){
            if ($6516b0b5f2779a72$export$b40fc69c4a2927a1()) return;
            yield $6516b0b5f2779a72$var$delay(50);
        }
    });
}
function $6516b0b5f2779a72$var$delay(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $6516b0b5f2779a72$export$e482865cd6c8f403(c) {
    $6516b0b5f2779a72$export$df995fae86a55f06().cookies_permitted(c);
}


var $ecc8e5ffb363d4f0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $ecc8e5ffb363d4f0$export$333222788f3dd075 {
    /**
     * Constructs a new ImageTracker
     * @param _pipeline - The pipeline that this tracker will operate within.
     * @param targetFile - The .zpt target file from the source image you'd like to track.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
    */ constructor(_pipeline, targetFile){
        this._pipeline = _pipeline;
        /**
        * Emitted when an anchor becomes visible in a camera frame.
        */ this.onVisible = new (0, $3f699d1d92b0530c$export$3371bf92c01fb88b)();
        /**
        * Emitted when an anchor goes from being visible in the previous camera frame, to not being visible in the current frame.
        */ this.onNotVisible = new (0, $3f699d1d92b0530c$export$3371bf92c01fb88b)();
        /**
        * Emitted when a new anchor is created by the tracker.
        */ this.onNewAnchor = new (0, $3f699d1d92b0530c$export$3371bf92c01fb88b)();
        /**
        * The set of currently visible anchors.
        */ this.visible = new Set();
        /**
        * A map of the available image anchors by their respective IDs.
        */ this.anchors = new Map();
        this._visibleLastFrame = new Set();
        this._frameUpdate = ()=>{
            const newAnchors = new Set();
            // Swap the visible and visibleLastFrame so we can avoid a set allocation
            const swap = this.visible;
            this.visible = this._visibleLastFrame;
            this._visibleLastFrame = swap;
            this.visible.clear();
            const num = this._z.image_tracker_anchor_count(this._impl);
            for(let i = 0; i < num; i++){
                const id = this._z.image_tracker_anchor_id(this._impl, i);
                let anchor = this.anchors.get(id);
                let isNew = false; // TODO: declared but never used?
                if (!anchor) {
                    anchor = {
                        onVisible: new (0, $3f699d1d92b0530c$export$d61e24a684f9e51)(),
                        onNotVisible: new (0, $3f699d1d92b0530c$export$d61e24a684f9e51)(),
                        id: id,
                        poseCameraRelative: (mirror)=>this._z.image_tracker_anchor_pose_camera_relative(this._impl, i, mirror === true),
                        pose: (cameraPose, mirror)=>this._z.image_tracker_anchor_pose(this._impl, i, cameraPose, mirror === true),
                        visible: true
                    };
                    isNew = true;
                    this.anchors.set(id, anchor);
                    newAnchors.add(anchor);
                }
                anchor.visible = true;
                this.visible.add(anchor);
            }
            // Events
            for (const anchor of newAnchors)this.onNewAnchor.emit(anchor);
            for (const anchor of this.visible)if (!this._visibleLastFrame.has(anchor)) {
                this.onVisible.emit(anchor);
                anchor.onVisible.emit();
            } else this._visibleLastFrame.delete(anchor);
            for (const anchor of this._visibleLastFrame){
                anchor.visible = false;
                this.onNotVisible.emit(anchor);
                anchor.onNotVisible.emit();
            }
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.image_tracker_create(this._pipeline._getImpl());
        if (targetFile) this.loadTarget(targetFile);
    }
    /**
     * Destroys the image tracker.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this.anchors.clear();
        this.visible.clear();
        this._z.image_tracker_destroy(this._impl);
    }
    /**
     * Loads a target file.
     * @param src - A URL to, or an ArrayBuffer of, the target file from the source image you'd like to track.
     * @see https://docs.zap.works/universal-ar/zapworks-cli/
     * @returns A promise that's resolved once the file is downloaded. It may still take a few frames for the tracker to fully initialize and detect images.
    */ loadTarget(src) {
        return $ecc8e5ffb363d4f0$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._targets = undefined;
            this._z.image_tracker_target_load_from_memory(this._impl, src);
        });
    }
    /**
     * Gets/sets the enabled state of the image tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.image_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.image_tracker_enabled_set(this._impl, e);
    }
    /**
     * An array of information for each of the target images loaded by this tracker.
     */ get targets() {
        if (!this._targets) {
            this._targets = [];
            const count = this._z.image_tracker_target_count(this._impl);
            for(let i = 0; i < count; i++)this._targets.push(new $ecc8e5ffb363d4f0$export$90139717fc3176c2(this._z, this._impl, i));
        }
        return this._targets;
    }
}
class $ecc8e5ffb363d4f0$export$90139717fc3176c2 {
    constructor(_z, _impl, _indx){
        this._z = _z;
        this._impl = _impl;
        this._indx = _indx;
        this.physicalScaleFactor = this._z.image_tracker_target_physical_scale_factor(this._impl, this._indx);
        if (this.physicalScaleFactor < 0) this.physicalScaleFactor = undefined;
        this.topRadius = this._z.image_tracker_target_radius_top(this._impl, this._indx);
        if (this.topRadius < 0) this.topRadius = undefined;
        this.bottomRadius = this._z.image_tracker_target_radius_bottom(this._impl, this._indx);
        if (this.bottomRadius < 0) this.bottomRadius = undefined;
        this.sideLength = this._z.image_tracker_target_side_length(this._impl, this._indx);
        if (this.sideLength < 0) this.sideLength = undefined;
    }
    /**
     * An <img> element containing the embedded preview image, or `undefined` if the target file does not contain one.
     */ get image() {
        if (this._image === undefined) this._image = this._z.image_tracker_target_image(this._impl, this._indx) || null;
        return this._image || undefined;
    }
    /**
     * An object containing a mesh that represents this image target.
     */ get preview() {
        if (this._preview === undefined) this._preview = new $ecc8e5ffb363d4f0$export$ae476155e1d7e629(this._z, this._impl, this._indx);
        return this._preview;
    }
}
class $ecc8e5ffb363d4f0$export$ae476155e1d7e629 {
    constructor(_z, _impl, _indx){
        this._z = _z;
        this._impl = _impl;
        this._indx = _indx;
        this.vertices = this._z.image_tracker_target_preview_mesh_vertices(this._impl, this._indx);
        this.indices = this._z.image_tracker_target_preview_mesh_indices(this._impl, this._indx);
        this.uvs = this._z.image_tracker_target_preview_mesh_uvs(this._impl, this._indx);
    }
}




class $f0f00fc87402cf53$export$230d52b81bfab97f {
    /**
     * Constructs a new InstantWorldTracker.
     * @param _pipeline - The pipeline that this tracker will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * The instant world tracking anchor.
        */ this.anchor = {
            poseCameraRelative: (mirror)=>this._anchorPoseCameraRelative(mirror),
            pose: (cameraPose, mirror)=>this._anchorPose(cameraPose, mirror)
        };
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.instant_world_tracker_create(this._pipeline._getImpl());
    }
    /**
     * Destroys the instant tracker.
     */ destroy() {
        this._z.instant_world_tracker_destroy(this._impl);
    }
    _anchorPoseCameraRelative(mirror) {
        return this._z.instant_world_tracker_anchor_pose_camera_relative(this._impl, mirror === true);
    }
    _anchorPose(cameraPose, mirror) {
        return this._z.instant_world_tracker_anchor_pose(this._impl, cameraPose, mirror === true);
    }
    /**
     * Gets/sets the enabled state of the instant world tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.instant_world_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.instant_world_tracker_enabled_set(this._impl, e);
    }
    /**
     * Sets the point in the user's environment that the anchor tracks from.
     *
     * The parameters passed in to this function correspond to the X, Y and Z coordinates (in camera space) of the point to track. Choosing a position with X and Y coordinates of zero, and a negative Z coordinate, will select a point on a surface directly in front of the center of the screen.
     *
     * @param orientation -  The orientation of the point in space.
     */ setAnchorPoseFromCameraOffset(x, y, z, orientation) {
        this._z.instant_world_tracker_anchor_pose_set_from_camera_offset(this._impl, x, y, z, orientation || (0, $adda256f81190c7f$export$51221aec55e6c7e6).MINUS_Z_AWAY_FROM_USER);
    }
}





class $9d1b307252755ae9$export$441c3cbad541da1b {
    /**
     * Constructs a new BarcodeFinder.
     * @param _pipeline - The pipeline that this BarcodeFinder will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * Emitted when a barcode becomes visible in a camera frame.
        */ this.onDetection = new (0, $3f699d1d92b0530c$export$3371bf92c01fb88b)();
        this._lastDetected = [];
        this._found = [];
        this._formats = [];
        this._frameUpdate = ()=>{
            this._found = [];
            const num = this._z.barcode_finder_found_number(this._impl);
            for(let i = 0; i < num; i++)this._found.push({
                text: this._z.barcode_finder_found_text(this._impl, i),
                format: this._z.barcode_finder_found_format(this._impl, i)
            });
            if (this._found.length === 0) return;
            outerloop: for (const entry of this._found){
                for (const previous of this._lastDetected){
                    if (previous.text === entry.text) continue outerloop;
                }
                this.onDetection.emit(entry);
            }
            this._lastDetected = this._found;
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.barcode_finder_create(this._pipeline._getImpl());
        this._formats.push.apply(this._formats, [
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).AZTEC,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).CODABAR,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).CODE_39,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).CODE_93,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).CODE_128,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).DATA_MATRIX,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).EAN_8,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).EAN_13,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).ITF,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).MAXICODE,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).PDF_417,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).QR_CODE,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).RSS_14,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).RSS_EXPANDED,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).UPC_A,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).UPC_E,
            (0, $adda256f81190c7f$export$53baafd5596ae7a8).UPC_EAN_EXTENSION
        ]);
    }
    /**
     * Destroys the barcode finder.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this._found = [];
        this._lastDetected = [];
        this._z.barcode_finder_destroy(this._impl);
    }
    /**
      * Returns an array of discovered barcodes
      */ get found() {
        return this._found;
    }
    /**
     * Gets/sets the enabled state of the barcode finder.
     * Disable when not in use to save computational resources during frame processing.
    */ get enabled() {
        return this._z.barcode_finder_enabled(this._impl);
    }
    set enabled(e) {
        this._z.barcode_finder_enabled_set(this._impl, e);
    }
    /**
      * Gets/sets the barcode formats to scan for.
      */ get formats() {
        return this._formats;
    }
    set formats(f) {
        this._formats = f.slice();
        let underlying = 0;
        for (const format of this._formats)underlying |= format;
        this._z.barcode_finder_formats_set(this._impl, underlying);
    }
}


var $3bdfa48f8d7f2a8b$exports = {};


var $3bdfa48f8d7f2a8b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $3bdfa48f8d7f2a8b$export$bb2337bd021e3bce {
    /**
     * Constructs a new FaceTracker
     * @param _pipeline - The pipeline that this tracker will operate within.
    */ constructor(_pipeline){
        this._pipeline = _pipeline;
        /**
        * Emitted when an anchor becomes visible in a camera frame.
        */ this.onVisible = new (0, $3f699d1d92b0530c$export$3371bf92c01fb88b)();
        /**
        * Emitted when an anchor goes from being visible in the previous camera frame, to not being visible in the current frame.
        */ this.onNotVisible = new (0, $3f699d1d92b0530c$export$3371bf92c01fb88b)();
        /**
        * Emitted when a new anchor is created by the tracker.
        */ this.onNewAnchor = new (0, $3f699d1d92b0530c$export$3371bf92c01fb88b)();
        /**
         * The set of currently visible anchors.
         */ this.visible = new Set();
        /**
        * A map of the available anchors by their respective IDs.
        */ this.anchors = new Map();
        this._visibleLastFrame = new Set();
        this._frameUpdate = ()=>{
            const newAnchors = new Set();
            // Swap the visible and visibleLastFrame so we can avoid a set allocation
            const swap = this.visible;
            this.visible = this._visibleLastFrame;
            this._visibleLastFrame = swap;
            this.visible.clear();
            const num = this._z.face_tracker_anchor_count(this._impl);
            for(let i = 0; i < num; i++){
                const id = this._z.face_tracker_anchor_id(this._impl, i);
                let anchor = this.anchors.get(id);
                let isNew = false;
                if (!anchor) {
                    anchor = {
                        onVisible: new (0, $3f699d1d92b0530c$export$d61e24a684f9e51)(),
                        onNotVisible: new (0, $3f699d1d92b0530c$export$d61e24a684f9e51)(),
                        indx: 0,
                        id: id,
                        poseCameraRelative: (mirror)=>this._z.face_tracker_anchor_pose_camera_relative(this._impl, anchor.indx, mirror === true),
                        pose: (cameraPose, mirror)=>this._z.face_tracker_anchor_pose(this._impl, anchor.indx, cameraPose, mirror === true),
                        identity: new Float32Array(50),
                        expression: new Float32Array(29),
                        visible: true
                    };
                    isNew = true;
                    this.anchors.set(id, anchor);
                    newAnchors.add(anchor);
                }
                anchor.indx = i;
                anchor.visible = true;
                anchor.identity = this._z.face_tracker_anchor_identity_coefficients(this._impl, i);
                anchor.expression = this._z.face_tracker_anchor_expression_coefficients(this._impl, i);
                this.visible.add(anchor);
            }
            // Events
            for (const anchor of newAnchors)this.onNewAnchor.emit(anchor);
            for (const anchor of this.visible)if (!this._visibleLastFrame.has(anchor)) {
                this.onVisible.emit(anchor);
                anchor.onVisible.emit();
            } else this._visibleLastFrame.delete(anchor);
            for (const anchor of this._visibleLastFrame){
                anchor.visible = false;
                this.onNotVisible.emit(anchor);
                anchor.onNotVisible.emit();
            }
        };
        this._pipeline._onFrameUpdateInternal.bind(this._frameUpdate);
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.face_tracker_create(this._pipeline._getImpl());
    }
    /**
      * Destroys the face tracker.
     */ destroy() {
        this._pipeline._onFrameUpdateInternal.unbind(this._frameUpdate);
        this.anchors.clear();
        this.visible.clear();
        this._z.face_tracker_destroy(this._impl);
    }
    /**
     * Loads face tracking model data.
     * @param src - A URL to, or ArrayBuffer of, model data.
     * @returns A promise that's resolved once the model is loaded. It may still take a few frames for the tracker to fully initialize and detect faces.
    */ loadModel(src) {
        return $3bdfa48f8d7f2a8b$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.face_tracker_model_load_from_memory(this._impl, src);
        });
    }
    /**
     * Loads the default face tracking model.
     * @returns A promise that's resolved once the model is loaded. It may still take a few frames for the tracker to fully initialize and detect faces.
    */ loadDefaultModel() {
        return $3bdfa48f8d7f2a8b$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_tracker_model_load_default(this._impl);
        });
    }
    /**
     * Gets/sets the enabled state of the face tracker.
     * Disable when not in use to save computational resources during frame processing.
     */ get enabled() {
        return this._z.face_tracker_enabled(this._impl);
    }
    set enabled(e) {
        this._z.face_tracker_enabled_set(this._impl, e);
    }
    /**
     * Gets/sets the maximum number of faces to track.
     *
     * By default only one face is tracked in any given frame. Increasing this number may reduce runtime performance.
     */ get maxFaces() {
        return this._z.face_tracker_max_faces(this._impl);
    }
    set maxFaces(m) {
        this._z.face_tracker_max_faces_set(this._impl, m);
    }
}


var $c5b9e7eefd1e1479$exports = {};

var $c5b9e7eefd1e1479$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $c5b9e7eefd1e1479$export$1238420da3a0b20c {
    /**
     * Constructs a new FaceMesh.
     * @see https://docs.zap.works/universal-ar/javascript/face-tracking/
    */ constructor(){
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.face_mesh_create();
    }
    /**
     * Destroys the face mesh.
     */ destroy() {
        this._z.face_mesh_destroy(this._impl);
    }
    /**
     * Loads the data for a face mesh.
     * @param src - A URL or ArrayBuffer of the source mesh data.
     * @param fillMouth - If true, fills this face feature with polygons.
     * @param fillEyeLeft - If true, fills this face feature with polygons.
     * @param fillEyeRight - If true, fills this face feature with polygons.
     * @param fillNeck - If true, fills this face feature with polygons.
     * @returns A promise that's resolved once the data is loaded.
     */ load(src, fillMouth, fillEyeLeft, fillEyeRight, fillNeck) {
        return $c5b9e7eefd1e1479$var$__awaiter(this, void 0, void 0, function*() {
            if (!src) {
                this.loadDefault();
                return;
            } else if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.face_mesh_load_from_memory(this._impl, src, fillMouth || false, fillEyeLeft || false, fillEyeRight || false, fillNeck || false);
        });
    }
    /**
      * Loads the default face mesh data.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefault() {
        return $c5b9e7eefd1e1479$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default(this._impl);
        });
    }
    /**
      * Loads the default face mesh.
      * @param fillMouth - If true, fills this face feature with polygons.
      * @param fillEyeLeft - If true, fills this face feature with polygons.
      * @param fillEyeRight - If true, fills this face feature with polygons.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefaultFace(fillMouth, fillEyeLeft, fillEyeRight) {
        return $c5b9e7eefd1e1479$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default_face(this._impl, fillMouth || false, fillEyeLeft || false, fillEyeRight || false);
        });
    }
    /**
      * The full head simplified mesh covers the whole of the user's head, including some neck.
      * It's ideal for drawing into the depth buffer in order to mask out the back of 3D models placed on the user's head.
      * @param fillMouth - If true, fills this face feature with polygons.
      * @param fillEyeLeft - If true, fills this face feature with polygons.
      * @param fillEyeRight - If true, fills this face feature with polygons.
      * @param fillNeck - If true, fills this face feature with polygons.
      * @returns A promise that's resolved once the data is loaded.
      */ loadDefaultFullHeadSimplified(fillMouth, fillEyeLeft, fillEyeRight, fillNeck) {
        return $c5b9e7eefd1e1479$var$__awaiter(this, void 0, void 0, function*() {
            yield this._z.face_mesh_load_default_full_head_simplified(this._impl, fillMouth || false, fillEyeLeft || false, fillEyeRight || false, fillNeck || false);
        });
    }
    /**
      * Update the face mesh directly from a [[FaceAnchor]].
      * @param f - The face anchor.
      * @param mirror - Pass `true` to mirror the location in the X-axis.
      */ updateFromFaceAnchor(f, mirror) {
        this._z.face_mesh_update(this._impl, f.identity, f.expression, mirror || false);
    }
    /**
      * Updates the face mesh directly from a identity and expression coefficients.
      * @param identity - The identity coefficients.
      * @param expression - The expression coefficients.
      * @param mirror - Pass `true` to mirror the location in the X-axis.
     */ updateFromIdentityExpression(identity, expression, mirror) {
        this._z.face_mesh_update(this._impl, identity, expression, mirror || false);
    }
    /**
     *
     * @returns The vertices of the mesh.
     */ get vertices() {
        return this._z.face_mesh_vertices(this._impl);
    }
    /**
     * @returns The indices of the mesh.
     */ get indices() {
        return this._z.face_mesh_indices(this._impl);
    }
    /**
     * @returns The UVs of the mesh.
     */ get uvs() {
        return this._z.face_mesh_uvs(this._impl);
    }
    /**
     * @returns The normals of the mesh.
     */ get normals() {
        return this._z.face_mesh_normals(this._impl);
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
}



class $22c20654024c91c0$export$9a93ce53f488cb2e {
    /**
     * Constructs a new CameraSource.
     * @param _pipeline - The pipeline that this tracker will operate within.
     * @param deviceId - The camera device ID which will be used as the source.
     * @see https://docs.zap.works/universal-ar/javascript/pipelines-and-camera-processing/
    */ constructor(pipeline, deviceId){
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.camera_source_create(pipeline._getImpl(), deviceId);
    }
    /**
    * Destroys the camera source.
    */ destroy() {
        this._z.camera_source_destroy(this._impl);
    }
    /**
    * Starts the camera source.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.camera_source_start(this._impl);
    }
    /**
    * Pauses the camera source.
    */ pause() {
        this._z.camera_source_pause(this._impl);
    }
}



class $8348e8e4d59acdf5$export$bbfb48c500076b66 {
    /**
     * Constructs a new HTMLElementSource.
     * @param pipeline - The pipeline that this tracker will operate within.
     * @param element -  The HTML source element.
    */ constructor(pipeline, element){
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.html_element_source_create(pipeline._getImpl(), element);
    }
    /**
    * Destroys the source.
    */ destroy() {
        this._z.html_element_source_destroy(this._impl);
    }
    /**
    * Starts the source sending frames into the pipeline.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.html_element_source_start(this._impl);
    }
    /**
    * Pauses the source.
    */ pause() {
        this._z.html_element_source_pause(this._impl);
    }
}


var $206f3951d59dd4fd$exports = {};

var $206f3951d59dd4fd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $206f3951d59dd4fd$export$9035336025e5be06 {
    /**
     * Constructs a new SequenceSource.
     * @param _pipeline - The pipeline that this source will operate within.
    */ constructor(pipeline){
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.sequence_source_create(pipeline._getImpl());
    }
    /**
    * Destroys the sequence source.
    */ destroy() {
        this._z.sequence_source_destroy(this._impl);
    }
    /**
    * Starts the sequence source.
    *
    * Starting a given source pauses any other sources within the same pipeline.
    */ start() {
        this._z.sequence_source_start(this._impl);
    }
    /**
    * Pauses the sequence source.
    */ pause() {
        this._z.sequence_source_pause(this._impl);
    }
    /**
     * Loads sequence data.
     * @param src - A URL to, or an ArrayBuffer of, the sequence data you'd like to play back.
     * @returns A promise that's resolved once the data is downloaded.
    */ load(src) {
        return $206f3951d59dd4fd$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof src === "string") src = yield (yield fetch(src)).arrayBuffer();
            this._z.sequence_source_load_from_memory(this._impl, src);
        });
    }
    /**
     * Manually set the current time for the sequence.
     * @param t The time in ms, or `undefined` to use the system time.
     */ setTime(t) {
        this._z.sequence_source_time_set(this._impl, t !== null && t !== void 0 ? t : -1);
    }
}




class $fb35afdb3ba6cec9$export$abd47b564b6c9ce2 {
    /**
     * Constructs a new Pipeline.
    */ constructor(){
        /**
         * Emitted when the frame is updated.
        */ this.onFrameUpdate = new (0, $3f699d1d92b0530c$export$d61e24a684f9e51)();
        /**
         * @ignore
        */ this._onFrameUpdateInternal = new (0, $3f699d1d92b0530c$export$d61e24a684f9e51)();
        this._lastFrameNumber = -1;
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.pipeline_create();
    }
    /**
     * Destroys the pipeline.
     */ destroy() {
        this._z.pipeline_destroy(this._impl);
    }
    /**
     * Updates the pipeline and trackers to expose tracking data from the most recently processed camera frame.
     */ frameUpdate() {
        this._z.pipeline_frame_update(this._impl);
        const frameNumber = this._z.pipeline_frame_number(this._impl);
        if (frameNumber !== this._lastFrameNumber) {
            this._lastFrameNumber = frameNumber;
            this._onFrameUpdateInternal.emit();
            this.onFrameUpdate.emit();
        }
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
    /**
     * Sets the WebGL context used for the processing and upload of camera textures.
     * @param gl - The WebGL context.
    */ glContextSet(gl) {
        this._z.pipeline_gl_context_set(this._impl, gl);
    }
    /**
     * Informs the pipeline that the GL context is lost and should not be used.
    */ glContextLost() {
        this._z.pipeline_gl_context_lost(this._impl);
    }
    /**
     * Returns the most recent camera frame texture.
    */ cameraFrameTextureGL() {
        return this._z.pipeline_camera_frame_texture_gl(this._impl);
    }
    /**
     * Returns a matrix that you can use to transform the UV coordinates of the following full-screen quad in order to render the camera texture:
     *
     * Vertex 0: `-1, -1, 0`
     *
     * UV 0: `0, 0`
     *
     * Vertex 1: `-1, 1, 0`
     *
     * UV 1: `0, 1`
     *
     * Vertex 2: `1, -1, 0`
     *
     * UV 1: `1, 0`
     *
     * Vertex 3: `1, 1, 0`
     *
     * UV 1: `1, 1`
     *
     * @param renderWidth - The width of the canvas.
     * @param renderHeight - The height of the canvas.
     * @param mirror - Pass `true` to mirror the camera image in the X-axis.
     * @returns A 4x4 column-major transformation matrix.
    */ cameraFrameTextureMatrix(renderWidth, renderHeight, mirror) {
        return this._z.pipeline_camera_frame_texture_matrix(this._impl, renderWidth, renderHeight, mirror === true);
    }
    /**
    * Draw the camera to the screen as a full screen quad.
    *
    * Please note this function modifies some GL state during its operation so you may need to reset the following GL state if you use it:
    * - The currently bound texture 2D is set to `null` (e.g. `gl.bindTexture(gl.TEXTURE_2D, null)`)
    * - The currently bound array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ARRAY_BUFFER, null);`)
    * - The currently bound program is set to `null` (e.g. `gl.useProgram(null)`)
    * - The currently active texture is set to `gl.TEXTURE0` (e.g. `gl.activeTexture(gl.TEXTURE0)`)
    * - These features are disabled: `gl.SCISSOR_TEST`, `gl.DEPTH_TEST`, `gl.BLEND`, `gl.CULL_FACE`
    * @param renderWidth - The width of the canvas.
    * @param renderHeight - The height of the canvas.
    * @param mirror - Pass `true` to mirror the camera image in the X-axis.
   */ cameraFrameDrawGL(renderWidth, renderHeight, mirror) {
        this._z.pipeline_camera_frame_draw_gl(this._impl, renderWidth, renderHeight, mirror);
    }
    /**
     * Uploads the current camera frame to a WebGL texture.
    */ cameraFrameUploadGL() {
        this._z.pipeline_camera_frame_upload_gl(this._impl);
    }
    /**
     * Prepares camera frames for processing.
     *
     * Call this function on your pipeline once an animation frame (e.g. during your `requestAnimationFrame` function) in order to process incoming camera frames.
     *
     * Please note this function modifies some GL state during its operation so you may need to reset the following GL state if you use it:
     * - The currently bound framebuffer is set to `null` (e.g. `gl.bindFramebuffer(gl.FRAMEBUFFER, null)`)
     * - The currently bound texture 2D is set to `null` (e.g. `gl.bindTexture(gl.TEXTURE_2D, null)`)
     * - The currently bound array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ARRAY_BUFFER, null);`)
     * - The currently bound element array buffer is set to `null` (e.g. `gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null)`)
     * - The currently bound program is set to `null` (e.g. `gl.useProgram(null)`)
     * - The currently active texture is set to `gl.TEXTURE0` (e.g. `gl.activeTexture(gl.TEXTURE0)`)
     * - These features are disabled: `gl.SCISSOR_TEST`, `gl.DEPTH_TEST`, `gl.BLEND`, `gl.CULL_FACE`
     * - The pixel store flip-Y mode is disabled (e.g. `gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false)`)
     * - The viewport is changed (e.g. `gl.viewport(...)`)
     * - The clear color is changed (e.g. `gl.clearColor(...)`)
    */ processGL() {
        this._z.pipeline_process_gl(this._impl);
    }
    /**
     * Returns the camera model (i.e. the intrinsic camera parameters) for the current frame.
    */ cameraModel() {
        return this._z.pipeline_camera_model(this._impl);
    }
    /**
     * Returns a transformation where the camera sits, stationary, at the origin of world space, and points down the negative Z axis.
     *
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     *
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseDefault() {
        return this._z.pipeline_camera_pose_default(this._impl);
    }
    /**
     * Returns a transformation where the camera sits at the origin of world space, but rotates as the user rotates the physical device.
     *
     * When the Zappar library initializes, the negative Z axis of world space points forward in front of the user.
     *
     * In this mode, tracked anchors move in world space as the user moves the device or tracked objects in the real world.
     *
     * @param mirror -  Pass `true` to mirror the location in the X-axis.
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseWithAttitude(mirror) {
        return this._z.pipeline_camera_pose_with_attitude(this._impl, mirror || false);
    }
    /**
     * Returns a transformation with the (camera-relative) origin specified by the supplied parameter.
     *
     * This is used with the `poseCameraRelative(...) : Float32Array` functions provided by the various anchor types to allow a given anchor (e.g. a tracked image or face) to be the origin of world space.
     *
     * In this case the camera moves and rotates in world space around the anchor at the origin.
     *
     * @param o - The origin matrix.
     * @returns A 4x4 column-major transformation matrix
    */ cameraPoseWithOrigin(o) {
        return this._z.pipeline_camera_pose_with_origin(this._impl, o);
    }
    /**
      * Returns true if the current camera frame came from a user-facing camera
     */ cameraFrameUserFacing() {
        return this._z.pipeline_camera_frame_user_facing(this._impl);
    }
    /**
      * @ignore
     */ drawFace(projectionMatrix, cameraMatrix, targetMatrix, m) {
        this._z.pipeline_draw_face(this._impl, projectionMatrix, cameraMatrix, targetMatrix, m._getImpl());
    }
    /**
      * Returns the number of the current frame.
     */ frameNumber() {
        return this._z.pipeline_frame_number(this._impl);
    }
    /**
     * Start recording camera and motion data into memory. This data can then used with SequenceSource to replay the sequence.
     *
     * @param expectedFrames - The number of camera frames you expect to capture. If supplied, memory will be pre-allocated to improve performance
     */ sequenceRecordStart(expectedFrames) {
        if (expectedFrames === undefined) expectedFrames = 150; // 5 second default
        this._z.pipeline_sequence_record_start(this._impl, expectedFrames);
    }
    /**
     * Stop recording camera and motion data.
     */ sequenceRecordStop() {
        this._z.pipeline_sequence_record_stop(this._impl);
    }
    /**
     * Remove any camera and motion data currently stored in memory.
     */ sequenceRecordClear() {
        this._z.pipeline_sequence_record_clear(this._impl);
    }
    /**
     * Get the data captured by sequence recording.
     *
     * @returns A Uint8Array of packed camera and motion data
     */ sequenceRecordData() {
        return this._z.pipeline_sequence_record_data(this._impl);
    }
}





class $f10df6f1136f2c1d$export$8da7a4c55ed49539 {
    /**
     * Constructs a new FaceLanmdmark.
     * @param _name - The name of the landmark to track.
     * @see https://docs.zap.works/universal-ar/javascript/face-tracking/
    */ constructor(_name){
        this._name = _name;
        /**
         * The most recent pose of this landmark, relative to the [[FaceAnchor]] used to update it.
         * A 4x4 column-major transformation matrix.
         */ this.pose = (0, $2edf3b5f20103352$exports).create();
        this._z = (0, $6516b0b5f2779a72$exports.z)();
        this._impl = this._z.face_landmark_create(this._name);
    }
    /**
     * Destroys the face landmark.
     */ destroy() {
        this._z.face_landmark_destroy(this._impl);
    }
    /**
     * Updates pose directly from the expression and identity in a [[FaceAnchor]].
     * @param f - The anchor to derive the expression and identity from.
     * @param mirror - Pass `true` to mirror the location in the X-axis.
    */ updateFromFaceAnchor(f, mirror) {
        this._z.face_landmark_update(this._impl, f.identity, f.expression, mirror || false);
        this.pose = this._z.face_landmark_anchor_pose(this._impl);
    }
    /**
     * Updates pose directly from identity and expression coefficients.
     * @param identity  - The identity coefficients.
     * @param expression - The expression coefficients.
     * @param mirror - Pass `true` to mirror the location in the X-axis.
    */ updateFromIdentityExpression(identity, expression, mirror) {
        this._z.face_landmark_update(this._impl, identity, expression, mirror || false);
        this.pose = this._z.face_landmark_anchor_pose(this._impl);
    }
    /**
     * @ignore
    */ _getImpl() {
        return this._impl;
    }
}


var $36c07df706919483$exports = {};

$parcel$export($36c07df706919483$exports, "Permission", function () { return $36c07df706919483$export$a461eaf23bef603e; });
$parcel$export($36c07df706919483$exports, "permissionRequest", function () { return $36c07df706919483$export$d303ff031c4d4b58; });

var $36c07df706919483$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $36c07df706919483$export$a461eaf23bef603e;
(function(Permission) {
    /**
    * Permission to access camera images.
    */ Permission[Permission["CAMERA"] = 0] = "CAMERA";
    /**
     * Permission to access device motion data (e.g. accelerometer and gyro). Some tracking algorithms require this data to operate.
     */ Permission[Permission["MOTION"] = 1] = "MOTION";
})($36c07df706919483$export$a461eaf23bef603e || ($36c07df706919483$export$a461eaf23bef603e = {}));
function $36c07df706919483$export$f568f2f64377aed0(onlyPermsission) {
    switch(onlyPermsission){
        case $36c07df706919483$export$a461eaf23bef603e.CAMERA:
            return (0, $6516b0b5f2779a72$exports.z)().permission_granted_camera();
        case $36c07df706919483$export$a461eaf23bef603e.MOTION:
            return (0, $6516b0b5f2779a72$exports.z)().permission_granted_motion();
        default:
            return (0, $6516b0b5f2779a72$exports.z)().permission_granted_all();
    }
}
function $36c07df706919483$export$a188bf2e0d7eb5c7(onlyPermission) {
    switch(onlyPermission){
        case $36c07df706919483$export$a461eaf23bef603e.CAMERA:
            return (0, $6516b0b5f2779a72$exports.z)().permission_denied_camera();
        case $36c07df706919483$export$a461eaf23bef603e.MOTION:
            return (0, $6516b0b5f2779a72$exports.z)().permission_denied_motion();
        default:
            return (0, $6516b0b5f2779a72$exports.z)().permission_denied_any();
    }
}
function $36c07df706919483$export$d303ff031c4d4b58(onlyPermission) {
    switch(onlyPermission){
        case $36c07df706919483$export$a461eaf23bef603e.CAMERA:
            (0, $6516b0b5f2779a72$exports.z)().permission_request_camera();
            break;
        case $36c07df706919483$export$a461eaf23bef603e.MOTION:
            (0, $6516b0b5f2779a72$exports.z)().permission_request_motion();
            break;
        default:
            (0, $6516b0b5f2779a72$exports.z)().permission_request_all();
            break;
    }
    // eslint-disable-next-line no-async-promise-executor
    return new Promise((resolve)=>$36c07df706919483$var$__awaiter(this, void 0, void 0, function*() {
            // eslint-disable-next-line no-constant-condition
            while(true){
                yield $36c07df706919483$var$_nextFrame();
                switch(onlyPermission){
                    case $36c07df706919483$export$a461eaf23bef603e.CAMERA:
                        if ((0, $6516b0b5f2779a72$exports.z)().permission_granted_camera()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $6516b0b5f2779a72$exports.z)().permission_denied_camera()) {
                            resolve(false);
                            return;
                        }
                        break;
                    case $36c07df706919483$export$a461eaf23bef603e.MOTION:
                        if ((0, $6516b0b5f2779a72$exports.z)().permission_granted_motion()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $6516b0b5f2779a72$exports.z)().permission_denied_motion()) {
                            resolve(false);
                            return;
                        }
                        break;
                    default:
                        if ((0, $6516b0b5f2779a72$exports.z)().permission_granted_camera() && (0, $6516b0b5f2779a72$exports.z)().permission_granted_motion()) {
                            resolve(true);
                            return;
                        }
                        if ((0, $6516b0b5f2779a72$exports.z)().permission_denied_camera() || (0, $6516b0b5f2779a72$exports.z)().permission_denied_motion()) {
                            resolve(false);
                            return;
                        }
                        break;
                }
            }
        }));
}
function $36c07df706919483$export$447cf121adb7b558() {
    return $36c07df706919483$var$__awaiter(this, void 0, void 0, function*() {
        return yield (0, $6516b0b5f2779a72$exports.z)().permission_request_ui_promise();
    });
}
function $36c07df706919483$export$2e339b4d51173824() {
    return (0, $6516b0b5f2779a72$exports.z)().permission_denied_ui();
}
function $36c07df706919483$var$_nextFrame() {
    return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
}




function $38a791cbccdee115$export$b564441c22aac826() {
    return (0, $6516b0b5f2779a72$exports.z)().log_level();
}
function $38a791cbccdee115$export$c622e99c0ce7b1c9(l) {
    (0, $6516b0b5f2779a72$exports.z)().log_level_set(l);
}






const $a14c8e8022a4675a$var$hasPermissionAccess = async (permissionType)=>{
    return (0, $1865e185f0ff5554$exports.permissionGranted)(permissionType);
};
const $a14c8e8022a4675a$var$promptForPermissionAccess = (permissionType)=>{
    return (0, $36c07df706919483$exports.permissionRequest)(permissionType);
};
const $a14c8e8022a4675a$export$8b4008aa4959c02a = async ()=>{
    try {
        if (!await $a14c8e8022a4675a$var$hasPermissionAccess((0, $36c07df706919483$exports.Permission).MOTION)) await $a14c8e8022a4675a$var$promptForPermissionAccess((0, $36c07df706919483$exports.Permission).MOTION);
        await $a14c8e8022a4675a$var$promptForPermissionAccess((0, $36c07df706919483$exports.Permission).CAMERA);
    } catch (error) {
        throw error;
    }
};




class $c097b7e9ec8fb26d$export$f02761adf21def8a {
    stereo;
    size;
    renderer;
    cameraFocus = 6;
    constructor(renderer){
        this.stereo = new (0, $e97a97f0b0cf48c9$export$bc7f73a1065bee0c)();
        this.renderer = renderer;
        this.stereo.aspect = 0.5;
        this.stereo.cameraL.focus = this.cameraFocus;
        this.stereo.cameraR.focus = this.cameraFocus;
        this.stereo.eyeSep = 3;
        this.size = new (0, $e97a97f0b0cf48c9$export$c977b3e384af9ae1)();
        console.warn("Auto update in render needs check if types are correct");
    }
    setEyeSeparation = (eyeSep)=>{
        this.stereo.eyeSep = eyeSep;
    };
    setSize = (width, height)=>{
        this.renderer.setSize(width, height);
    };
    render = (scene, camera, textureLeft, textureRight)=>{
        if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
        if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
        camera.updateWorldMatrix(false, true);
        this.stereo.update(camera);
        this.renderer.getSize(this.size);
        if (this.renderer.autoClear) this.renderer.clear();
        this.renderer.setScissorTest(true);
        this.renderer.setScissor(0, 0, this.size.width / 2, this.size.height);
        this.renderer.setViewport(0, 0, this.size.width / 2, this.size.height);
        scene.background = textureLeft;
        this.renderer.render(scene, this.stereo.cameraL);
        this.renderer.setScissor(this.size.width / 2, 0, this.size.width / 2, this.size.height);
        this.renderer.setViewport(this.size.width / 2, 0, this.size.width / 2, this.size.height);
        scene.background = textureRight;
        this.renderer.render(scene, this.stereo.cameraR);
        this.renderer.setScissorTest(false);
    };
}


class $5efca1fa0818cea8$export$2e2bcd8739ae039 extends (0, $e97a97f0b0cf48c9$export$f6cc00ef28d7cf97) {
    sizeVector = new (0, $e97a97f0b0cf48c9$export$c977b3e384af9ae1)();
    currentPixelRatio = Math.min(window.devicePixelRatio, 2);
    constructor({ orientation: orientation, stereoMode: stereoMode }){
        super({
            powerPreference: "high-performance",
            preserveDrawingBuffer: true
        });
        this.isLandscape = orientation === "landscape";
        this.isStereoMode = stereoMode;
        this.stereoEffect = new (0, $c097b7e9ec8fb26d$export$f02761adf21def8a)(this);
        document.body.appendChild(this.domElement);
        this.stereoEffect.setSize(window.innerWidth, window.innerHeight);
        this.setPixelRatio(this.currentPixelRatio);
        this.setSize(window.innerWidth, window.innerHeight);
        this.setupListeners();
    }
    setupListeners = ()=>{
        window.addEventListener("resize", ()=>{
            this.setSize(window.innerWidth, window.innerHeight);
            this.stereoEffect.setSize(window.innerWidth, window.innerHeight);
            this.setPixelRatio(this.currentPixelRatio);
        });
        document.addEventListener("rnib:eye-sep", (e)=>{
            const eyeSep = e.detail.eyeSep;
            if (eyeSep) this.stereoEffect.setEyeSeparation(eyeSep);
        });
    };
    setStereoMode = (val)=>this.isStereoMode = val;
    renderLandscape = (scene, camera, textureLeft, textureRight)=>{
        this.stereoEffect.render(scene, camera, textureLeft, textureRight);
    };
    renderPortrait = (scene, backgroundTexture, camera)=>{
        scene.background = backgroundTexture;
        this.render(scene, camera);
    };
    mainRender = (scene, camera, textureLeft, textureRight)=>{
        if (this.isStereoMode && this.isLandscape) this.renderLandscape(scene, camera, textureLeft, textureRight);
        else this.renderPortrait(scene, textureLeft, camera);
    };
}




class $4e9b6a9d6616cf6a$export$936f75e6792bf2dc extends (0, $e97a97f0b0cf48c9$export$e4dd07dff30cc924) {
    constructor(element = document.createElement("div")){
        super();
        this.element = element;
        this.element.style.position = "absolute";
        this.element.style.userSelect = "none";
        this.element.setAttribute("draggable", false);
        this.addEventListener("removed", function() {
            this.traverse(function(object) {
                if (object.element instanceof Element && object.element.parentNode !== null) object.element.parentNode.removeChild(object.element);
            });
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.element = source.element.cloneNode(true);
        return this;
    }
}
$4e9b6a9d6616cf6a$export$936f75e6792bf2dc.prototype.isCSS2DObject = true;
//
const $4e9b6a9d6616cf6a$var$_vector = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)();
const $4e9b6a9d6616cf6a$var$_viewMatrix = new (0, $e97a97f0b0cf48c9$export$2ae72fc923e5eb5)();
const $4e9b6a9d6616cf6a$var$_viewProjectionMatrix = new (0, $e97a97f0b0cf48c9$export$2ae72fc923e5eb5)();
const $4e9b6a9d6616cf6a$var$_a = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)();
const $4e9b6a9d6616cf6a$var$_b = new (0, $e97a97f0b0cf48c9$export$64b5c384219d3699)();
class $4e9b6a9d6616cf6a$export$508520281a983506 {
    constructor(parameters = {}){
        const _this = this;
        let _width, _height;
        let _widthHalf, _heightHalf;
        const cache = {
            objects: new WeakMap()
        };
        const domElement = parameters.element !== undefined ? parameters.element : document.createElement("div");
        domElement.style.overflow = "hidden";
        this.domElement = domElement;
        this.getSize = function() {
            return {
                width: _width,
                height: _height
            };
        };
        this.render = function(scene, camera) {
            if (scene.autoUpdate === true) scene.updateMatrixWorld();
            if (camera.parent === null) camera.updateMatrixWorld();
            $4e9b6a9d6616cf6a$var$_viewMatrix.copy(camera.matrixWorldInverse);
            $4e9b6a9d6616cf6a$var$_viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, $4e9b6a9d6616cf6a$var$_viewMatrix);
            renderObject(scene, scene, camera);
            zOrder(scene);
        };
        this.setSize = function(width, height) {
            _width = width;
            _height = height;
            _widthHalf = _width / 2;
            _heightHalf = _height / 2;
            domElement.style.width = width + "px";
            domElement.style.height = height + "px";
        };
        function renderObject(object, scene, camera) {
            if (object.isCSS2DObject) {
                const visible = object.visible && $4e9b6a9d6616cf6a$var$_vector.z >= -1 && $4e9b6a9d6616cf6a$var$_vector.z <= 1 && object.layers.test(camera.layers);
                object.element.style.display = visible ? "" : "none";
                if (visible) {
                    object.onBeforeRender(_this, scene, camera);
                    $4e9b6a9d6616cf6a$var$_vector.setFromMatrixPosition(object.matrixWorld);
                    $4e9b6a9d6616cf6a$var$_vector.applyMatrix4($4e9b6a9d6616cf6a$var$_viewProjectionMatrix);
                    const element = object.element;
                    if (/apple/i.test(navigator.vendor)) // https://github.com/mrdoob/three.js/issues/21415
                    element.style.transform = "translate(-50%,-50%) translate(" + Math.round($4e9b6a9d6616cf6a$var$_vector.x * _widthHalf + _widthHalf) + "px," + Math.round(-$4e9b6a9d6616cf6a$var$_vector.y * _heightHalf + _heightHalf) + "px)";
                    else element.style.transform = "translate(-50%,-50%) translate(" + ($4e9b6a9d6616cf6a$var$_vector.x * _widthHalf + _widthHalf) + "px," + (-$4e9b6a9d6616cf6a$var$_vector.y * _heightHalf + _heightHalf) + "px)";
                    const objectData = {
                        distanceToCameraSquared: getDistanceToSquared(camera, object)
                    };
                    cache.objects.set(object, objectData);
                    if (element.parentNode !== domElement) domElement.appendChild(element);
                    object.onAfterRender(_this, scene, camera);
                }
            }
            for(let i = 0, l = object.children.length; i < l; i++)renderObject(object.children[i], scene, camera);
        }
        function getDistanceToSquared(object1, object2) {
            $4e9b6a9d6616cf6a$var$_a.setFromMatrixPosition(object1.matrixWorld);
            $4e9b6a9d6616cf6a$var$_b.setFromMatrixPosition(object2.matrixWorld);
            return $4e9b6a9d6616cf6a$var$_a.distanceToSquared($4e9b6a9d6616cf6a$var$_b);
        }
        function filterAndFlatten(scene) {
            const result = [];
            scene.traverse(function(object) {
                if (object.isCSS2DObject) result.push(object);
            });
            return result;
        }
        function zOrder(scene) {
            const sorted = filterAndFlatten(scene).sort(function(a, b) {
                const distanceA = cache.objects.get(a).distanceToCameraSquared;
                const distanceB = cache.objects.get(b).distanceToCameraSquared;
                return distanceA - distanceB;
            });
            const zMax = sorted.length;
            for(let i = 0, l = sorted.length; i < l; i++)sorted[i].element.style.zIndex = zMax - i;
        }
    }
}


class $7aadf7bdb48c1ed9$export$2e2bcd8739ae039 extends (0, $4e9b6a9d6616cf6a$export$508520281a983506) {
    isStereoMode;
    stereoRenderer;
    constructor({ stereoMode: stereoMode }){
        super();
        this.stereoRenderer = new (0, $4e9b6a9d6616cf6a$export$508520281a983506)();
        this.isStereoMode = stereoMode;
        if (!this.isStereoMode) {
            this.setSize(window.innerWidth / 2, window.innerHeight);
            this.domElement.style.position = "absolute";
            this.domElement.style.top = "0px";
            this.domElement.style.left = "0";
            this.domElement.style.pointerEvents = "none";
            document.body.appendChild(this.domElement);
            this.stereoRenderer.setSize(window.innerWidth / 2, window.innerHeight);
            this.stereoRenderer.domElement.style.position = "absolute";
            this.stereoRenderer.domElement.style.top = "0px";
            this.stereoRenderer.domElement.style.left = "50%";
            this.stereoRenderer.domElement.style.bottom = "0";
            this.stereoRenderer.domElement.style.pointerEvents = "none";
            document.body.appendChild(this.stereoRenderer.domElement);
        } else {
            this.setSize(window.innerWidth, window.innerHeight);
            this.domElement.style.position = "absolute";
            this.domElement.style.top = "0px";
            this.domElement.style.left = "0";
            this.domElement.style.pointerEvents = "none";
            document.body.appendChild(this.domElement);
            console.log("stereo");
        }
        this.listeners();
    }
    listeners() {
        window.addEventListener("resize", ()=>{
            this.stereoRenderer.setSize(window.innerWidth / 2, window.innerHeight);
            this.setSize(window.innerWidth / 2, window.innerHeight);
        });
    }
    renderLandscape = (scene, stereo)=>{
        this.render(scene, stereo.cameraL);
        if (this.domElement.lastElementChild) {
            this.stereoRenderer.domElement.firstElementChild?.remove();
            const clone = this.domElement.lastElementChild.cloneNode(true);
            this.stereoRenderer.domElement.appendChild(clone);
        }
    //this.stereoRenderer.render(scene, stereo.cameraR);
    };
    renderPortrait = (scene, camera)=>{
        // TODO: create stereo view for
        this.render(scene, camera);
    };
    mainRender = (scene, camera, stereo)=>{
        if (!this.isStereoMode) this.renderLandscape(scene, stereo);
        else this.renderPortrait(scene, camera);
    };
}


const $8d0b21abaa4a342c$var$isOrientationControls = (controls)=>controls instanceof (0, $5a73931fb849d1b7$export$2e2bcd8739ae039);
class $8d0b21abaa4a342c$export$2e2bcd8739ae039 {
    gamepadObject;
    orientation;
    deviceType = (0, $0656ff799c64aac2$export$f395e2d3d05d3c6a)();
    renderer;
    captionCSSRenderer;
    scene;
    camera;
    zapparCamera;
    zapparCameraPlaying = false;
    controls;
    isDeviceOrientationControls;
    eyeConditionType;
    severityLevel;
    eyewareEffects;
    stats;
    stereoMode = false;
    firstTick = false;
    useController = false;
    hasTouchScreen = false;
    constructor(gamepadObject, orientation){
        this.gamepadObject = gamepadObject;
        this.orientation = orientation;
        if ("maxTouchPoints" in navigator) this.hasTouchScreen = navigator.maxTouchPoints > 0;
        this.stats = new (0, (/*@__PURE__*/$parcel$interopDefault($bb352d88731e6f32$exports)))();
        this.eyeConditionType = "none";
        this.severityLevel = 1;
        this.camera = new $e97a97f0b0cf48c9$export$74e4ae24825f68d7(75, window.innerWidth / window.innerHeight, 0.1, 1000);
        this.camera.position.z = 0;
        this.renderer = new (0, $5efca1fa0818cea8$export$2e2bcd8739ae039)({
            orientation: this.orientation,
            stereoMode: this.stereoMode
        });
        this.captionCSSRenderer = new (0, $7aadf7bdb48c1ed9$export$2e2bcd8739ae039)({
            stereoMode: this.stereoMode
        });
        this.scene = new (0, $6a9ecdef11b6cf6d$export$2e2bcd8739ae039)(this.camera, this.orientation, this.gamepadObject);
        if (this.hasTouchScreen) this.controls = new (0, $5a73931fb849d1b7$export$2e2bcd8739ae039)({
            camera: this.camera,
            isAndroid: this.deviceType === "Android"
        });
        else {
            this.controls = new (0, $746a181503264f5a$export$e08ee79bd6cc99de)(this.camera, this.renderer.domElement);
            this.scene.add(this.controls.getObject());
        }
        this.isDeviceOrientationControls = $8d0b21abaa4a342c$var$isOrientationControls(this.controls);
        // The Zappar library needs the WebGL context to process camera images
        // Use this function to set your context
        $e9c3a419a4122d1f$export$efb561eaedf42055(this.renderer.getContext());
        // Create a camera and set the scene background to the camera's backgroundTexture
        this.zapparCamera = new $1ec2e62baebbadc2$export$79f141de891a5fed();
        this.zapparCamera.backgroundTexture.encoding = $e97a97f0b0cf48c9$export$f32388edbb32674;
        this.eyewareEffects = new (0, $711555eabecedb8b$export$2e2bcd8739ae039)({
            assets: (0, $2ea84fdbd3aded2c$export$2e2bcd8739ae039)
        });
        if (this.orientation === "landscape") document.querySelector(".ui")?.classList.add("headset-mode");
        this.eventListeners();
    }
    getPermissions() {
        if ($8d0b21abaa4a342c$var$isOrientationControls(this.controls)) this.controls.connect();
        (0, $a14c8e8022a4675a$export$8b4008aa4959c02a)().then(()=>{
            this.zapparCamera.start();
            this.zapparCameraPlaying = true;
            //Temporary fix to Android black screen bug
            setTimeout(()=>{
                this.zapparCamera.start();
                setTimeout(()=>{
                    this.zapparCamera.start();
                }, 500);
            }, 500);
        });
    }
    onFirstTick = ()=>{
        this.scene.rotatePivotToCamera();
        this.firstTick = true;
    };
    get isPlayingPanoramicVideo() {
        return this.scene.panoramicVideo.playing;
    }
    get isRenderingStereo() {
        // Renderer uses orientation as well as stereoMode, so we duplicate logic here
        return this.stereoMode && this.orientation === "landscape";
    }
    getZapparCameraTextureMatrix(out) {
        const { renderer: renderer, zapparCamera: zapparCamera } = this;
        const { drawingBufferWidth: w, drawingBufferHeight: h } = renderer.getContext();
        const s = this.isRenderingStereo ? 1 : 0;
        const m = zapparCamera.pipeline.cameraFrameTextureMatrix(w >> s, h, false);
        out.identity();
        out.elements[0] = m[0]; // x scale
        out.elements[4] = m[5]; // y scale
        out.elements[6] = m[12]; // x translate
        out.elements[7] = m[13]; // y translate
        return out;
    }
    setZapparCameraPlaying(playing) {
        if (this.zapparCameraPlaying === playing) // already good
        return;
        if (playing) {
            // restart the camera source
            console.log("zapparCamera: restarting");
            this.zapparCamera.start();
            this.zapparCameraPlaying = true;
        } else {
            // pause the camera source
            console.log("zapparCamera: pausing");
            //@ts-ignore
            this.zapparCamera.pause();
            this.zapparCameraPlaying = false;
        }
    }
    updateZapparCamera() {
        if (this.isPlayingPanoramicVideo) // playing 360 video: pause the zappar camera
        this.setZapparCameraPlaying(false);
        else {
            // AR view: ensure camera started and update the frame
            this.setZapparCameraPlaying(true);
            this.zapparCamera.updateFrame(this.renderer);
        }
    }
    flipCameras = true;
    getEyeCameras() {
        // ensure scene camera matrices are up to date
        const { camera: camera } = this;
        camera.updateWorldMatrix(true, true);
        if (this.isRenderingStereo) {
            // update the stereo camera generator and return each eye
            const { stereo: stereo } = this.renderer.stereoEffect;
            if (this.flipCameras) {
                stereo.update(camera);
                return [
                    stereo.cameraR,
                    stereo.cameraL
                ];
            } else {
                // is this the same??
                stereo.eyeSep = -stereo.eyeSep;
                stereo.update(camera);
                stereo.eyeSep = -stereo.eyeSep;
                return [
                    stereo.cameraL,
                    stereo.cameraR
                ];
            }
        } else // return the main camera only for mono
        return [
            camera
        ];
    }
    getEyewareEffectsSourceTexture() {
        if (!this.isPlayingPanoramicVideo) {
            // source texture is the zappar camera feed
            const texture = this.zapparCamera.backgroundTexture;
            this.getZapparCameraTextureMatrix(texture.matrix);
            return texture;
        } else {
            // source texture is the 360 video
            const texture = this.scene.panoramicVideo.texture;
            texture.matrix.identity();
            return texture;
        }
    }
    animate = ()=>{
        this.stats.begin();
        this.scene.update();
        this.isDeviceOrientationControls && this.controls.update();
        this.updateZapparCamera();
        this.camera.updateWorldMatrix(true, true);
        // render effects passes
        this.eyewareEffects.render({
            renderer: this.renderer,
            cameras: this.getEyeCameras(),
            mode: this.isRenderingStereo ? "stereo" : "mono",
            sourceTexture: this.getEyewareEffectsSourceTexture(),
            condition: this.eyeConditionType,
            severity: this.severityLevel
        });
        this.firstTick || this.onFirstTick();
        this.renderer.mainRender(this.scene, this.camera, this.eyewareEffects.textureLeft, this.eyewareEffects.textureRight);
        this.captionCSSRenderer.mainRender(this.scene, this.camera, this.renderer.stereoEffect.stereo);
        this.stats.end();
        // Ask the browser to call this function again next frame
        requestAnimationFrame(this.animate);
    };
    startScene(orientation, isStereoMode, useController) {
        this.stereoMode = isStereoMode;
        this.orientation = orientation;
        this.useController = useController;
        this.renderer.setStereoMode(this.stereoMode);
        this.stats.showPanel(0);
        const thisParent = document.querySelector(".stats_modal_container");
        thisParent?.appendChild(this.stats.dom);
        if (this.orientation === "landscape") this.scene.init(true, useController).then(()=>{
            this.scene.showInitialMesh(this.useController);
            if (!this.isDeviceOrientationControls) window.addEventListener("click", ()=>this.controls.lock(), {
                once: false
            });
            document.body.scrollTo({
                behavior: "auto",
                top: 0,
                left: 0
            });
        });
        else this.scene.init(false, useController).then(()=>{
            this.scene.showInitialElement();
        });
        // Ask the browser to call this function again next frame
        requestAnimationFrame(this.animate);
    }
    eventListeners() {
        document.addEventListener("rnib:refocus", this.scene.rotatePivotToCamera);
        document.addEventListener("rnib:condition", (e)=>{
            let condition = e.detail.condition;
            if (condition.startsWith("armd-")) condition = "armd";
            this.eyeConditionType = condition;
            this.severityLevel = e.detail.severity;
        });
        document.addEventListener("rnib:flipCameras", ()=>{
            this.flipCameras = !this.flipCameras;
            console.log("flipCameras: %o", this.flipCameras);
        });
    }
}



class $c21c4f14562bd7cb$var$JoyCon {
    side;
    platform;
    patchedEvent = null;
    constructor(controllerId, platform){
        this.side = this.determineSide(controllerId);
        this.platform = platform;
        this.side === "left" && this.isAndroid() && this.patchLeftJoyconAndroid();
    }
    determineSide = (controllerId)=>{
        switch(true){
            case controllerId.includes("Left") || controllerId.includes("(L)"):
                return "left";
            case controllerId.includes("Right") || controllerId.includes("(R)"):
                return "right";
            default:
                throw Error("Not a valid Joycon");
        }
    };
    isIOS = ()=>this.platform === "iOS";
    isAndroid = ()=>this.platform === "Android";
    patchLeftJoyconAndroid = ()=>{
        window.addEventListener("keydown", (evt)=>{
            if (evt.code === "" && evt.key === "Unidentified") this.patchedEvent = "select";
        });
    };
    parseIOSButtonsInputs = (buttonIndex)=>{
        const options = {
            left: [
                "right",
                "left",
                "up",
                "down"
            ],
            right: [
                "left",
                "right",
                "down",
                "up"
            ]
        };
        return options[this.side][buttonIndex - 12] ?? "";
    };
    parseControllerInputs = (controllerStates)=>{
        const [buttons, axes] = controllerStates;
        let direction = "";
        if (axes[0] > 0.8 || axes[2] > 0.8) direction = "right";
        else if (axes[0] < -0.8 || axes[2] < -0.8) direction = "left";
        else if (axes[1] > 0.8 || axes[3] > 0.8) direction = "down";
        else if (axes[1] < -0.8 || axes[3] < -0.8) direction = "up";
        if (direction.length) return direction;
        buttons.length && buttons.forEach((button)=>{
            if (button.index <= 7) direction = "select";
            if (!direction.length && this.isIOS()) direction = this.parseIOSButtonsInputs(button.index);
        });
        if (this.isAndroid() && this.patchedEvent) {
            direction = this.patchedEvent;
            this.patchedEvent = null;
        }
        return direction;
    };
}
class $c21c4f14562bd7cb$export$2e2bcd8739ae039 extends EventTarget {
    controllers = [];
    mobileOs = (0, $0656ff799c64aac2$export$f395e2d3d05d3c6a)();
    connectedController = null;
    currentActiveStates = null;
    scanInterval = null;
    isConnected = false;
    lastDispatchedEvent = {
        eventName: null,
        timeoutRef: null
    };
    addGamepad = (gamepad)=>{
        this.controllers[gamepad.index] = gamepad;
        this.connectedController = gamepad;
        this.isConnected = true;
        this.scanInterval && clearInterval(this.scanInterval);
        this.scanInterval = null;
        this.connectedJoycon = new $c21c4f14562bd7cb$var$JoyCon(this.connectedController.id, this.mobileOs);
    };
    getCurrentGamepad = ()=>navigator.getGamepads()[0];
    disconnectHandler = (event)=>{
        const gamepad = event.gamepad;
        this.removeGamepad(gamepad);
        this.startDeviceScan();
    };
    connectHandler = (event)=>{
        const gamepad = event.gamepad;
        this.addGamepad(gamepad);
        requestAnimationFrame(this.updateStatus);
    };
    removeGamepad = (gamepad)=>{
        delete this.controllers[gamepad.index];
        this.isConnected = false;
    };
    // Need now to refactor how we detect buttons and axes
    // Currently no way to easily detect which button has been pressed
    getActiveStates = (gamepad)=>{
        return [
            gamepad.buttons.reduce((prev, curr, i)=>{
                if (curr.pressed) {
                    curr.index = i;
                    prev.push(curr);
                }
                return prev;
            }, []),
            gamepad.axes
        ];
    };
    dispatchThrottledEvent = (eventName)=>{
        if (this.lastDispatchedEvent.eventName === eventName) return;
        if (this.lastDispatchedEvent.timeoutRef) clearTimeout(this.lastDispatchedEvent.timeoutRef);
        this.lastDispatchedEvent.eventName = eventName;
        this.lastDispatchedEvent.timeoutRef = setTimeout(()=>{
            this.lastDispatchedEvent.eventName = this.lastDispatchedEvent.timeoutRef = null;
        }, 1000);
        eventName === "select" ? this.dispatchEvent(new CustomEvent(eventName, {
            bubbles: true
        })) : this.dispatchEvent(new CustomEvent("direction", {
            bubbles: true,
            detail: eventName
        }));
    };
    dispatchEvents = ()=>{
        if (!this.currentActiveStates) return;
        const input = this.connectedJoycon.parseControllerInputs(this.currentActiveStates);
        input.length && this.dispatchThrottledEvent(input);
    };
    updateStatus = ()=>{
        this.connectedController = this.getCurrentGamepad();
        if (!this.connectedController) return;
        this.currentActiveStates = this.getActiveStates(this.connectedController);
        this.dispatchEvents();
        requestAnimationFrame(this.updateStatus);
    };
    // controllers will only be visible after gamepadconnected is triggered
    scanGamepads = ()=>{
        navigator.getGamepads() //
        .forEach((gamepad)=>{
            if (gamepad) this.addGamepad(gamepad);
        });
    };
    startDeviceScan = ()=>{
        this.scanInterval = setInterval(this.scanGamepads, 500);
    };
    init = (connectCallback, disconnectCallback)=>{
        window.addEventListener("IOScontrollerInput", console.log);
        window.addEventListener("gamepadconnected", (e)=>{
            this.connectHandler(e);
            connectCallback && connectCallback();
        });
        window.addEventListener("gamepaddisconnected", (e)=>{
            this.disconnectHandler(e);
            disconnectCallback && disconnectCallback();
        });
    };
}







const $d6688360c12ddbaa$var$inGameUI = document.querySelector(".ui");
const $d6688360c12ddbaa$var$parentElement = $d6688360c12ddbaa$var$inGameUI?.querySelector("#external-site");
const $d6688360c12ddbaa$var$homepageElement = $d6688360c12ddbaa$var$inGameUI?.querySelector("#homepage");
const $d6688360c12ddbaa$var$backButton = $d6688360c12ddbaa$var$parentElement?.querySelector("#external-site-back-button");
const $d6688360c12ddbaa$var$confirmButton = $d6688360c12ddbaa$var$parentElement?.querySelector("#external-site-confirm-button");
let $d6688360c12ddbaa$var$currentLink;
function $d6688360c12ddbaa$export$73d19272c3eff27(link) {
    $d6688360c12ddbaa$var$currentLink = link;
}
const $d6688360c12ddbaa$var$ExternalLink = (0, $3c5424715410c340$export$d2de3aaeafa91619)((orientation)=>{
    $d6688360c12ddbaa$var$confirmButton?.addEventListener("click", ()=>{
        //console.log('WINDOW OPEN ' + currentLink)
        window.open($d6688360c12ddbaa$var$currentLink);
    });
    $d6688360c12ddbaa$var$backButton?.addEventListener("click", ()=>{
        if (orientation === "portrait") {
            $d6688360c12ddbaa$var$parentElement?.classList.remove("active");
            $d6688360c12ddbaa$var$homepageElement?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "homepage"
        ]);
    });
});
var $d6688360c12ddbaa$export$2e2bcd8739ae039 = $d6688360c12ddbaa$var$ExternalLink;



const $4862ecea332fa5ed$var$inGameUI = document.querySelector(".ui");
const $4862ecea332fa5ed$var$homepageElement = $4862ecea332fa5ed$var$inGameUI?.querySelector("#homepage");
const $4862ecea332fa5ed$var$main = $4862ecea332fa5ed$var$inGameUI?.querySelector("#main");
const $4862ecea332fa5ed$var$eyeConditionsContainer = $4862ecea332fa5ed$var$main?.querySelector(".eye-conditions-container");
const $4862ecea332fa5ed$var$taskModeGrid = $4862ecea332fa5ed$var$main?.querySelector(".task-mode-grid");
const $4862ecea332fa5ed$var$selectEyeConditionButton = $4862ecea332fa5ed$var$homepageElement?.querySelector(".select-eye-condition");
const $4862ecea332fa5ed$var$findOutMoreButton = $4862ecea332fa5ed$var$homepageElement?.querySelector("#find-out-more-button");
const $4862ecea332fa5ed$var$surveyButton = $4862ecea332fa5ed$var$homepageElement?.querySelector(".survey");
const $4862ecea332fa5ed$var$videoButton = $4862ecea332fa5ed$var$homepageElement?.querySelector(".three-sixty-video");
const $4862ecea332fa5ed$var$taskModeButton = $4862ecea332fa5ed$var$homepageElement?.querySelector(".task-mode");
const $4862ecea332fa5ed$var$donateButton = $4862ecea332fa5ed$var$homepageElement?.querySelector("#donate-button");
const $4862ecea332fa5ed$var$toolTip = $4862ecea332fa5ed$var$main?.querySelector("#tooltip-main-button");
const $4862ecea332fa5ed$var$homeButton = $4862ecea332fa5ed$var$main?.querySelector("#main-ui-home-button");
const $4862ecea332fa5ed$var$replayButton = $4862ecea332fa5ed$var$main?.querySelector("#main-ui-replay-button");
// const scenarioButton = main?.querySelector("#main-ui-scenario-button");
const $4862ecea332fa5ed$var$closeButton = $4862ecea332fa5ed$var$main?.querySelector("#main-ui-close-button");
const $4862ecea332fa5ed$var$soundButton = $4862ecea332fa5ed$var$main?.querySelector("#task-mode__sound-button");
const $4862ecea332fa5ed$var$mainUIEyeConditionButton = $4862ecea332fa5ed$var$main?.querySelector("#main-ui-eye-condition-button");
const $4862ecea332fa5ed$var$externalSite = $4862ecea332fa5ed$var$inGameUI?.querySelector("#external-site");
const $4862ecea332fa5ed$var$severityScaleContainer = $4862ecea332fa5ed$var$main?.querySelector(".severity-scale-container");
const $4862ecea332fa5ed$var$findOutMoreIcon = `<svg width="38px" height="34px" viewBox="0 0 38 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<title>Group 9</title>
<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Free-control-mode-headset-1-Copy-13" transform="translate(-515.000000, -303.000000)">
        <g id="Group-9" transform="translate(517.000000, 305.000000)">
            <path d="M20.8719268,2.791741 C26.4461025,7.22025399 27.3851672,15.3419555 22.969414,20.9322384 C18.5536608,26.5225213 10.4551825,27.4642995 4.88118443,23.0357865 C-0.692991306,18.6072735 -1.63205599,10.4853939 2.78369721,4.89528912 C7.19945042,-0.694993778 15.297751,-1.63677199 20.8719268,2.791741 Z" id="Stroke-1" stroke="#FEFEFE" stroke-width="3.14928" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M19.1647544,4.95298573 C23.5487141,8.43597976 24.2872484,14.8235767 20.8142898,19.2200261 C17.3415089,23.6166537 10.9723164,24.3573221 6.58835678,20.8745062 C2.20439714,17.3915121 1.46586282,11.0039152 4.93864375,6.60728766 C8.41160229,2.2106601 14.7807948,1.4699917 19.1647544,4.95298573" id="Fill-3" fill="#FEFEFE"></path>
            <line x1="31.1952619" y1="27.4674881" x2="22.9694317" y2="20.9322206" id="Stroke-5" stroke="#FEFEFE" stroke-width="3.14928" stroke-linecap="round" stroke-linejoin="round"></line>
            <path d="M35.7276744,29.0901183 L33.8074496,31.5210711 C33.3754834,32.067933 32.5831309,32.1602049 32.037667,31.7268123 L25.6151892,26.6242519 C25.0697253,26.1910375 24.977897,25.3963954 25.4098632,24.8495335 L27.3300879,22.4185807 C27.7622318,21.8715406 28.5545842,21.7794469 29.0998705,22.2126613 L35.5225259,27.3152218 C36.0678122,27.7486143 36.1596406,28.5432564 35.7276744,29.0901183" id="Fill-7" fill="#FEFEFE"></path>
        </g>
    </g>
</g>
</svg>`;
const $4862ecea332fa5ed$export$74ba1212fd768fa5 = (0, $3c5424715410c340$export$d2de3aaeafa91619)((orientation)=>{
    $4862ecea332fa5ed$var$selectEyeConditionButton?.addEventListener("click", ()=>{
        $4862ecea332fa5ed$var$main?.classList.remove("space-between");
        $4862ecea332fa5ed$var$eyeConditionsContainer?.classList.remove("hidden");
        $4862ecea332fa5ed$var$taskModeGrid?.classList.add("hidden");
        $4862ecea332fa5ed$var$replayButton?.classList.add("hidden");
        $4862ecea332fa5ed$var$homeButton?.classList.remove("hidden");
        $4862ecea332fa5ed$var$closeButton?.classList.add("hidden");
        if (orientation === "portrait") {
            $4862ecea332fa5ed$var$homepageElement?.classList.remove("active");
            $4862ecea332fa5ed$var$main?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "main"
        ]);
    });
    if ($4862ecea332fa5ed$var$findOutMoreButton) {
        if (orientation === "portrait") $4862ecea332fa5ed$var$findOutMoreButton.innerHTML = `Find out more`;
        else $4862ecea332fa5ed$var$findOutMoreButton.innerHTML = `Find out more ${$4862ecea332fa5ed$var$findOutMoreIcon}`;
    }
    $4862ecea332fa5ed$var$findOutMoreButton?.addEventListener("click", ()=>{
        (0, $d6688360c12ddbaa$export$73d19272c3eff27)("https://www.rnib.org.uk/about-us/");
        if (orientation === "portrait") {
            $4862ecea332fa5ed$var$homepageElement?.classList.remove("active");
            $4862ecea332fa5ed$var$externalSite?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "external-site"
        ]);
    });
    $4862ecea332fa5ed$var$videoButton?.addEventListener("click", ()=>{
        $4862ecea332fa5ed$var$toolTip?.classList.add("hidden");
        $4862ecea332fa5ed$var$main?.classList.add("space-between");
        $4862ecea332fa5ed$var$eyeConditionsContainer?.classList.add("hidden");
        $4862ecea332fa5ed$var$mainUIEyeConditionButton?.classList.add("hidden");
        $4862ecea332fa5ed$var$taskModeGrid?.classList.add("hidden");
        $4862ecea332fa5ed$var$closeButton?.classList.add("hidden");
        $4862ecea332fa5ed$var$homeButton?.classList.remove("hidden");
        $4862ecea332fa5ed$var$replayButton?.classList.remove("hidden");
        (0, $85a5f587c2a7b3b2$export$187686429c539d6)(true);
        if (orientation === "portrait") {
            $4862ecea332fa5ed$var$homepageElement?.classList.remove("active");
            $4862ecea332fa5ed$var$main?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "main"
        ]);
    });
    if (!$4862ecea332fa5ed$var$surveyButton) return;
    $4862ecea332fa5ed$var$surveyButton?.addEventListener("click", ()=>{
        (0, $d6688360c12ddbaa$export$73d19272c3eff27)("https://www.surveymonkey.com/r/?sm=gYvln%2Bx%2FddP82dwc%2BGnifg%3D%3D");
        if (orientation === "portrait") {
            $4862ecea332fa5ed$var$homepageElement?.classList.remove("active");
            $4862ecea332fa5ed$var$externalSite?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "external-site"
        ]);
    });
    $4862ecea332fa5ed$var$taskModeButton?.addEventListener("click", ()=>{
        if ($4862ecea332fa5ed$var$toolTip) $4862ecea332fa5ed$var$toolTip.innerHTML = "Choose your scenario";
        $4862ecea332fa5ed$var$main?.classList.add("space-between");
        $4862ecea332fa5ed$var$severityScaleContainer?.classList.add("hidden");
        $4862ecea332fa5ed$var$eyeConditionsContainer?.classList.add("hidden");
        $4862ecea332fa5ed$var$closeButton?.classList.add("hidden");
        $4862ecea332fa5ed$var$replayButton?.classList.add("hidden");
        $4862ecea332fa5ed$var$taskModeGrid?.classList.remove("hidden");
        $4862ecea332fa5ed$var$homeButton?.classList.remove("hidden");
        $4862ecea332fa5ed$var$soundButton?.classList.add("hidden");
        if (orientation === "portrait") {
            $4862ecea332fa5ed$var$homepageElement?.classList.remove("active");
            $4862ecea332fa5ed$var$main?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "main"
        ]);
    });
    $4862ecea332fa5ed$var$donateButton?.addEventListener("click", ()=>{
        (0, $d6688360c12ddbaa$export$73d19272c3eff27)("https://www.rnib.org.uk/get-involved/donate/");
        if (orientation === "portrait") {
            $4862ecea332fa5ed$var$homepageElement?.classList.remove("active");
            $4862ecea332fa5ed$var$externalSite?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "external-site"
        ]);
    });
});
var $4862ecea332fa5ed$export$2e2bcd8739ae039 = $4862ecea332fa5ed$export$74ba1212fd768fa5;






const $55e0309f06c0860d$var$eyeConditions = (0, (/*@__PURE__*/$parcel$interopDefault($a3048f9fc66af22b$exports)))["eye-conditions"];
const $55e0309f06c0860d$var$inGameUI = document.querySelector(".ui");
const $55e0309f06c0860d$var$homepageElement = $55e0309f06c0860d$var$inGameUI?.querySelector("#homepage");
const $55e0309f06c0860d$var$main = $55e0309f06c0860d$var$inGameUI?.querySelector("#main");
// const homeTopButtonContainer = main?.querySelector(".home__top-button-container");
const $55e0309f06c0860d$var$eyeConditionsContainer = $55e0309f06c0860d$var$main?.querySelector(".eye-conditions-container");
const $55e0309f06c0860d$var$severityScaleContainer = $55e0309f06c0860d$var$inGameUI?.querySelector("#severity-scale-container");
const $55e0309f06c0860d$var$severityScaleHeader = $55e0309f06c0860d$var$inGameUI?.querySelector(".severity-scale__header");
const $55e0309f06c0860d$var$severityScaleFooter = $55e0309f06c0860d$var$inGameUI?.querySelector(".severity-scale__footer");
const $55e0309f06c0860d$var$colorBlindnessGrid = $55e0309f06c0860d$var$inGameUI?.querySelector(".color-blindness-grid");
const $55e0309f06c0860d$var$severityScale = $55e0309f06c0860d$var$inGameUI?.querySelector(".severity-scale");
const $55e0309f06c0860d$var$severityScaleButtons = $55e0309f06c0860d$var$severityScale?.querySelectorAll("button");
const $55e0309f06c0860d$var$eyeConditionsGrid = $55e0309f06c0860d$var$main?.querySelector(".eye-conditions-grid");
const $55e0309f06c0860d$var$taskModeGrid = $55e0309f06c0860d$var$main?.querySelector(".task-mode-grid");
const $55e0309f06c0860d$var$taskModeButtons = $55e0309f06c0860d$var$taskModeGrid?.querySelectorAll("button");
const $55e0309f06c0860d$var$toolTip = $55e0309f06c0860d$var$main?.querySelector("#tooltip-main-button");
const $55e0309f06c0860d$var$toolTipExpandButton = $55e0309f06c0860d$var$main?.querySelector("#tooltip-expand-button");
const $55e0309f06c0860d$var$rnibInformation = $55e0309f06c0860d$var$main?.querySelector(".rnib-expanded-info");
const $55e0309f06c0860d$var$rnibInformationInner = $55e0309f06c0860d$var$main?.querySelector("span");
const $55e0309f06c0860d$var$homeButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-home-button");
const $55e0309f06c0860d$var$closeButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-close-button");
const $55e0309f06c0860d$var$replayButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-replay-button");
const $55e0309f06c0860d$var$collapseButton = $55e0309f06c0860d$var$main?.querySelector("#tooltip-collapse-button");
const $55e0309f06c0860d$var$soundButton = $55e0309f06c0860d$var$main?.querySelector("#task-mode__sound-button");
const $55e0309f06c0860d$var$eyeConditionButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-eye-condition-button");
const $55e0309f06c0860d$var$scenarioButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-scenario-button");
const $55e0309f06c0860d$var$donateButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-donate-button");
const $55e0309f06c0860d$var$findOutMoreButton = $55e0309f06c0860d$var$main?.querySelector("#main-ui-find-out-more-button");
const $55e0309f06c0860d$var$externalSite = $55e0309f06c0860d$var$inGameUI?.querySelector("#external-site");
const $55e0309f06c0860d$var$prevButton = $55e0309f06c0860d$var$main?.querySelector(".navigation--arrow.left");
const $55e0309f06c0860d$var$nextButton = $55e0309f06c0860d$var$main?.querySelector(".navigation--arrow.right");
const $55e0309f06c0860d$var$taskModeYesButton = $55e0309f06c0860d$var$main?.querySelector("#task-mode__yes-button");
const $55e0309f06c0860d$var$taskModeNoButton = $55e0309f06c0860d$var$main?.querySelector("#task-mode__no-button");
const $55e0309f06c0860d$var$taskModeContinueButton = $55e0309f06c0860d$var$main?.querySelector("#task-mode__continue-button");
let $55e0309f06c0860d$var$buttonPages = [];
let $55e0309f06c0860d$var$currentPage = 0;
let $55e0309f06c0860d$var$togglingTip = false;
/* Functions */ const $55e0309f06c0860d$var$clearButtonContainer = ()=>{
    $55e0309f06c0860d$var$homeButton?.classList.add("hidden");
    $55e0309f06c0860d$var$closeButton?.classList.add("hidden");
    $55e0309f06c0860d$var$eyeConditionButton?.classList.add("hidden");
    $55e0309f06c0860d$var$scenarioButton?.classList.add("hidden");
    $55e0309f06c0860d$var$soundButton?.classList.add("hidden");
    $55e0309f06c0860d$var$replayButton?.classList.add("hidden");
    $55e0309f06c0860d$var$findOutMoreButton?.classList.add("hidden");
    $55e0309f06c0860d$var$taskModeYesButton?.classList.add("hidden");
    $55e0309f06c0860d$var$taskModeNoButton?.classList.add("hidden");
    $55e0309f06c0860d$var$taskModeContinueButton?.classList.add("hidden");
    $55e0309f06c0860d$var$donateButton?.classList.add("hidden");
};
function $55e0309f06c0860d$var$handleEyeConditionButtonClick(e) {
    const eyeConditionType = (e?.target).dataset?.type;
    if (!eyeConditionType || !$55e0309f06c0860d$var$toolTip) return;
    $55e0309f06c0860d$var$eyeConditionButton?.classList.remove("hidden");
    $55e0309f06c0860d$var$closeButton?.classList.add("hidden");
    if (eyeConditionType === "color-blindness") {
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        $55e0309f06c0860d$var$eyeConditionsContainer?.classList.add("hidden");
        $55e0309f06c0860d$var$colorBlindnessGrid?.classList.remove("hidden");
        $55e0309f06c0860d$var$severityScale?.classList.add("hidden");
        $55e0309f06c0860d$var$severityScaleHeader?.classList.add("hidden");
        $55e0309f06c0860d$var$severityScaleFooter?.classList.add("hidden");
        $55e0309f06c0860d$var$severityScale.removeAttribute("data-eye-condition");
        $55e0309f06c0860d$var$severityScaleContainer?.classList.remove("hidden");
        $55e0309f06c0860d$var$toolTip?.classList.add("unclickable");
        $55e0309f06c0860d$var$toolTip?.classList.add("hidden");
        $55e0309f06c0860d$var$toolTip.innerHTML = "Color Blindness";
        (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "main",
            "severity-scale-container"
        ]);
    } else if (eyeConditionType === "none" || eyeConditionType === "hemianopia") {
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(eyeConditionType, 3);
        $55e0309f06c0860d$var$eyeConditionsContainer?.classList.add("hidden");
        $55e0309f06c0860d$var$colorBlindnessGrid?.classList.add("hidden");
        $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
        $55e0309f06c0860d$var$main?.classList.add("space-between");
        if (eyeConditionType === "none") {
            $55e0309f06c0860d$var$toolTip.innerHTML = "20/20 Vision";
            $55e0309f06c0860d$var$toolTip.classList.add("unclickable");
        } else $55e0309f06c0860d$var$toolTip?.classList.remove("unclickable");
    } else {
        $55e0309f06c0860d$var$severityScaleButtons?.forEach((severityScaleButton, index)=>{
            if (index == 2) severityScaleButton.classList.add("selected");
            else severityScaleButton.classList.remove("selected");
        });
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(eyeConditionType, 3);
        $55e0309f06c0860d$var$eyeConditionsContainer?.classList.add("hidden");
        $55e0309f06c0860d$var$colorBlindnessGrid?.classList.add("hidden");
        $55e0309f06c0860d$var$severityScale?.classList.remove("hidden");
        $55e0309f06c0860d$var$severityScaleContainer?.classList.remove("hidden");
        $55e0309f06c0860d$var$severityScaleHeader?.classList.remove("hidden");
        $55e0309f06c0860d$var$severityScaleFooter?.classList.remove("hidden");
        $55e0309f06c0860d$var$severityScale.setAttribute("data-eye-condition", eyeConditionType);
        $55e0309f06c0860d$var$toolTip?.classList.add("hidden");
        $55e0309f06c0860d$var$toolTip?.classList.remove("unclickable");
        (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "main",
            "severity-scale-container"
        ]);
    }
    $55e0309f06c0860d$var$toolTip?.classList.remove("expanded-info");
    $55e0309f06c0860d$var$rnibInformation?.classList.add("hidden");
    $55e0309f06c0860d$var$toolTip.classList.remove("hidden");
}
function $55e0309f06c0860d$var$generateEyeConditionButtons() {
    $55e0309f06c0860d$var$eyeConditions.forEach((eyeCondition, index)=>{
        const buttonElement = document.createElement("button");
        buttonElement.setAttribute("data-type", eyeCondition.name);
        buttonElement.setAttribute("data-id", `${index}`);
        buttonElement.classList.add("cta");
        index;
        buttonElement.innerHTML = eyeCondition.tagName;
        buttonElement.addEventListener("click", $55e0309f06c0860d$var$handleEyeConditionButtonClick);
        $55e0309f06c0860d$var$eyeConditionsGrid.appendChild(buttonElement);
    });
    const colorBlindnessList = $55e0309f06c0860d$var$eyeConditions.find((object)=>object.tagName === "Colour Blindness");
    const colorBlindnessOptions = colorBlindnessList?.options;
    if (colorBlindnessOptions) colorBlindnessOptions.forEach((option, index)=>{
        const buttonElement = document.createElement("button");
        buttonElement.setAttribute("data-type", option.tagName);
        buttonElement.setAttribute("data-info", option.desc);
        buttonElement.setAttribute("data-id", `${index}`);
        buttonElement.classList.add("cta");
        buttonElement.innerHTML = option.tagName;
        buttonElement.addEventListener("click", ()=>{
            if ($55e0309f06c0860d$var$toolTip && $55e0309f06c0860d$var$rnibInformationInner) {
                $55e0309f06c0860d$var$resetTooltip();
                //SeverityScale?.classList.add("ar-mode");
                $55e0309f06c0860d$var$toolTip.classList.remove("unclickable");
                $55e0309f06c0860d$var$toolTip.innerHTML = option.name;
                console.log("option name " + option.name);
                $55e0309f06c0860d$var$rnibInformationInner.innerHTML = option.desc;
                $55e0309f06c0860d$var$toolTip.classList.remove("hidden");
            }
            $55e0309f06c0860d$var$main?.classList.add("space-between");
            $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
            (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(option.tagName, 5);
        });
        $55e0309f06c0860d$var$colorBlindnessGrid?.appendChild(buttonElement);
    });
    const pagesLength = Math.ceil($55e0309f06c0860d$var$eyeConditions.length / 6);
    if (pagesLength < 2) return $55e0309f06c0860d$var$eyeConditionsGrid;
    // Pagination
    for(let j = 0; j < pagesLength; j++){
        const page = document.createElement("div");
        page.className = "eye-conditions-grid-page";
        page.style.display = j ? "none" : "grid";
        for(let i = 0; i < 6; i++)if ($55e0309f06c0860d$var$eyeConditionsGrid.children[0]) page.appendChild($55e0309f06c0860d$var$eyeConditionsGrid.children[0]);
        $55e0309f06c0860d$var$buttonPages.push(page);
    }
    $55e0309f06c0860d$var$buttonPages.forEach((page)=>{
        $55e0309f06c0860d$var$eyeConditionsGrid.appendChild(page);
    });
    return $55e0309f06c0860d$var$eyeConditionsGrid;
}
const $55e0309f06c0860d$var$resetTooltip = ()=>{
    if (!$55e0309f06c0860d$var$toolTip || !$55e0309f06c0860d$var$rnibInformation || !$55e0309f06c0860d$var$rnibInformationInner) return;
    // Reset Tooltip
    $55e0309f06c0860d$var$toolTip.classList.add("unclickable");
    $55e0309f06c0860d$var$toolTip.innerHTML = "Select arrows for more eye conditions";
    $55e0309f06c0860d$var$rnibInformation.classList.add("hidden");
    $55e0309f06c0860d$var$rnibInformationInner.innerHTML = "";
    $55e0309f06c0860d$var$main?.classList.remove("space-between");
};
const $55e0309f06c0860d$export$861edd1ccea2f746 = (0, $3c5424715410c340$export$d2de3aaeafa91619)((orientation)=>{
    $55e0309f06c0860d$var$generateEyeConditionButtons();
    $55e0309f06c0860d$var$severityScaleButtons?.forEach((severityScaleButton)=>{
        severityScaleButton?.addEventListener("click", ()=>{
            const eyeConditionData = $55e0309f06c0860d$var$severityScale?.dataset.eyeCondition;
            const severityLevelData = Number(severityScaleButton.dataset.severity);
            if (!eyeConditionData || !severityLevelData) return;
            $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
            $55e0309f06c0860d$var$main?.classList.add("space-between");
            (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)(eyeConditionData, severityLevelData);
            //SeverityScale?.classList.add("ar-mode");
            $55e0309f06c0860d$var$severityScaleHeader?.focus();
            $55e0309f06c0860d$var$toolTip?.classList.remove("hidden");
            $55e0309f06c0860d$var$severityScaleButtons?.forEach((severityScaleButton, index)=>{
                severityScaleButton.classList.remove("selected");
                if (index == severityLevelData - 1) severityScaleButton.classList.add("selected");
            });
        });
    });
    if ($55e0309f06c0860d$var$inGameUI && $55e0309f06c0860d$var$prevButton && $55e0309f06c0860d$var$nextButton) {
        orientation;
        setTimeout(()=>document.querySelectorAll(".eye-conditions-grid > div").forEach((page)=>{
                if (orientation === "landscape") $55e0309f06c0860d$var$eyeConditionsGrid.style.maxWidth = "775px";
                else page.style.width = `${$55e0309f06c0860d$var$inGameUI?.clientWidth - 80}px`;
            }), 300);
    }
    window.addEventListener("resize", ()=>{
        if ($55e0309f06c0860d$var$inGameUI && $55e0309f06c0860d$var$prevButton && $55e0309f06c0860d$var$nextButton) setTimeout(()=>$55e0309f06c0860d$var$buttonPages.forEach((page)=>{
                if (orientation === "landscape") $55e0309f06c0860d$var$eyeConditionsGrid.style.maxWidth = "775px";
                else page.style.width = `${$55e0309f06c0860d$var$inGameUI?.clientWidth - 80}px`;
            }), 300);
    });
    $55e0309f06c0860d$var$taskModeButtons.forEach((taskModeButton)=>{
        console.log("task mode button");
        const scene = taskModeButton.dataset.scene;
        taskModeButton.addEventListener("click", ()=>{
            if (!scene) return;
            $55e0309f06c0860d$var$clearButtonContainer();
            $55e0309f06c0860d$var$taskModeGrid?.classList.add("hidden");
            $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
            $55e0309f06c0860d$var$scenarioButton?.classList.remove("hidden");
            $55e0309f06c0860d$var$soundButton?.classList.remove("hidden");
            $55e0309f06c0860d$var$main?.classList.add("space-between");
            if ($55e0309f06c0860d$var$toolTip) $55e0309f06c0860d$var$toolTip.innerHTML = "please turn on your audio for voiceover";
            setTimeout(()=>{
                $55e0309f06c0860d$var$toolTip?.classList.add("hidden");
                (0, $85a5f587c2a7b3b2$export$cfd85ebbb456058b)();
            }, 5000);
            (0, $85a5f587c2a7b3b2$export$549798acdf125a64)(scene, true);
        });
    });
    $55e0309f06c0860d$var$scenarioButton?.addEventListener("click", ()=>{
        $55e0309f06c0860d$var$clearButtonContainer();
        $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$scenarioButton.classList.add("hidden");
        $55e0309f06c0860d$var$soundButton?.classList.add("hidden");
        $55e0309f06c0860d$var$taskModeGrid?.classList.remove("hidden");
        if ($55e0309f06c0860d$var$toolTip) {
            $55e0309f06c0860d$var$toolTip.classList.add("unclickable");
            $55e0309f06c0860d$var$toolTip.classList.remove("hidden");
            $55e0309f06c0860d$var$toolTip.innerHTML = "Choose your scenario";
            $55e0309f06c0860d$var$toolTip?.classList.remove("expanded-info");
        }
        $55e0309f06c0860d$var$rnibInformation?.classList.add("hidden");
        (0, $85a5f587c2a7b3b2$export$3fe8048cbcec8a76)();
    });
    $55e0309f06c0860d$var$homeButton?.addEventListener("click", ()=>{
        //toolTip?.classList.remove("hidden");
        $55e0309f06c0860d$var$toolTip?.classList.add("unclickable");
        $55e0309f06c0860d$var$toolTip?.classList.remove("expanded-info");
        $55e0309f06c0860d$var$rnibInformation?.classList.add("hidden");
        $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
        //eyeConditionsContainer?.classList.remove("hidden");
        $55e0309f06c0860d$var$clearButtonContainer();
        //homeButton?.classList.remove("hidden");
        //closeButton?.classList.remove("hidden");
        (0, $85a5f587c2a7b3b2$export$3fe8048cbcec8a76)();
        $55e0309f06c0860d$var$resetTooltip();
        (0, $85a5f587c2a7b3b2$export$187686429c539d6)(false);
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        if (orientation === "portrait") {
            $55e0309f06c0860d$var$homepageElement?.classList.add("active");
            $55e0309f06c0860d$var$main?.classList.remove("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "homepage"
        ]);
    });
    $55e0309f06c0860d$var$closeButton?.addEventListener("click", ()=>{
        $55e0309f06c0860d$var$clearButtonContainer();
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$eyeConditionButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$toolTip?.classList.remove("hidden");
        $55e0309f06c0860d$var$eyeConditionsContainer?.classList.add("hidden");
        $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
    });
    function adjustCurrentPage(delta) {
        const numPages = $55e0309f06c0860d$var$buttonPages.length;
        const nextPage = Math.max(0, Math.min(numPages - 1, $55e0309f06c0860d$var$currentPage + delta));
        if (nextPage === $55e0309f06c0860d$var$currentPage) return;
        console.log("adjustCurrentPage: delta=%d  current=%d  next=%d", delta, $55e0309f06c0860d$var$currentPage, nextPage);
        $55e0309f06c0860d$var$currentPage = nextPage;
        $55e0309f06c0860d$var$buttonPages.forEach((page, index)=>{
            const visible = index === $55e0309f06c0860d$var$currentPage;
            console.log(" - page %d: %o", index, visible);
            page.style.display = visible ? "grid" : "none";
        });
    }
    $55e0309f06c0860d$var$prevButton?.addEventListener("click", ()=>adjustCurrentPage(-1));
    $55e0309f06c0860d$var$nextButton?.addEventListener("click", ()=>adjustCurrentPage(1));
    $55e0309f06c0860d$var$eyeConditionButton?.addEventListener("click", ()=>{
        if (orientation === "landscape") (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "main"
        ]);
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
        $55e0309f06c0860d$var$clearButtonContainer();
        $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$eyeConditionsContainer?.classList.remove("hidden");
        $55e0309f06c0860d$var$severityScaleContainer?.classList.add("hidden");
        $55e0309f06c0860d$var$resetTooltip();
    });
    $55e0309f06c0860d$var$replayButton?.addEventListener("click", ()=>{
        (0, $85a5f587c2a7b3b2$export$187686429c539d6)(true);
    });
    $55e0309f06c0860d$var$collapseButton?.addEventListener("click", ()=>{
        $55e0309f06c0860d$var$toolTip?.classList.remove("expanded-info");
        $55e0309f06c0860d$var$rnibInformation?.classList.add("hidden");
        if (!$55e0309f06c0860d$var$main.classList.contains("space-between")) $55e0309f06c0860d$var$severityScaleContainer?.classList.remove("hidden");
    });
    $55e0309f06c0860d$var$toolTip?.addEventListener("click", ()=>{
        toggleTooltip();
    });
    $55e0309f06c0860d$var$toolTipExpandButton?.addEventListener("click", ()=>{
        toggleTooltip();
    });
    const toggleTooltip = ()=>{
        if ($55e0309f06c0860d$var$togglingTip) return;
        $55e0309f06c0860d$var$togglingTip = true;
        setTimeout(()=>{
            $55e0309f06c0860d$var$togglingTip = false;
        }, 1000);
        if (!$55e0309f06c0860d$var$rnibInformation || !$55e0309f06c0860d$var$toolTip) return;
        if (!$55e0309f06c0860d$var$toolTip.classList.contains("unclickable")) {
            if ($55e0309f06c0860d$var$toolTip.classList.contains("expanded-info")) {
                $55e0309f06c0860d$var$toolTip.classList.remove("expanded-info");
                $55e0309f06c0860d$var$rnibInformation.classList.add("hidden");
            // severityScaleContainer?.classList.remove("hidden");
            } else {
                $55e0309f06c0860d$var$toolTip.classList.add("expanded-info");
                $55e0309f06c0860d$var$rnibInformation.classList.remove("hidden");
            // severityScaleContainer?.classList.add("hidden");
            }
        }
    };
    $55e0309f06c0860d$var$taskModeContinueButton?.addEventListener("click", ()=>{
        $55e0309f06c0860d$var$taskModeContinueButton?.classList.add("hidden");
        $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$scenarioButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$soundButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$main.classList.remove("end");
        $55e0309f06c0860d$var$main?.classList.add("space-between");
        $55e0309f06c0860d$var$toolTip?.classList.remove("expanded-info");
        $55e0309f06c0860d$var$rnibInformation?.classList.add("hidden");
        $55e0309f06c0860d$var$toolTip?.classList.add("hidden");
        (0, $85a5f587c2a7b3b2$export$c5c93d23325f795e)("none", 1);
    });
    $55e0309f06c0860d$var$taskModeYesButton?.addEventListener("click", ()=>{
        const anchorButton = document.createElement("a");
        const currentLink = $55e0309f06c0860d$var$taskModeYesButton.getAttribute("data-href");
        if (currentLink) {
            anchorButton.href = currentLink;
            anchorButton.setAttribute("target", "_blank");
            anchorButton.click();
        }
    });
    $55e0309f06c0860d$var$taskModeNoButton?.addEventListener("click", ()=>{
        $55e0309f06c0860d$var$clearButtonContainer();
        $55e0309f06c0860d$var$toolTip?.classList.add("hidden");
        $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$scenarioButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$donateButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$findOutMoreButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$soundButton?.classList.add("hidden");
    });
    $55e0309f06c0860d$var$findOutMoreButton?.addEventListener("click", ()=>{
        (0, $d6688360c12ddbaa$export$73d19272c3eff27)("https://www.rnib.org.uk/about-us/");
        if (orientation === "portrait") {
            $55e0309f06c0860d$var$homepageElement?.classList.remove("active");
            $55e0309f06c0860d$var$externalSite?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "external-site"
        ]);
    });
    $55e0309f06c0860d$var$donateButton?.addEventListener("click", ()=>{
        (0, $d6688360c12ddbaa$export$73d19272c3eff27)("https://www.rnib.org.uk/get-involved/donate/");
        if (orientation === "portrait") {
            $55e0309f06c0860d$var$homepageElement?.classList.remove("active");
            $55e0309f06c0860d$var$externalSite?.classList.add("active");
        } else (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "external-site"
        ]);
    });
    document.addEventListener("rnib:condition", (e)=>{
        const currenteyecondition = e.detail.condition;
        console.log("console " + JSON.stringify(e.detail));
        if (!currenteyecondition || currenteyecondition === "none") return;
        const givenEyeCondition = (0, (/*@__PURE__*/$parcel$interopDefault($a3048f9fc66af22b$exports)))["eye-conditions"].find((eyeconditiondata)=>eyeconditiondata.name === currenteyecondition);
        if ($55e0309f06c0860d$var$rnibInformationInner && $55e0309f06c0860d$var$toolTip && givenEyeCondition) {
            $55e0309f06c0860d$var$toolTip.innerHTML = givenEyeCondition.tagName;
            console.log("givenEyeCondition name " + givenEyeCondition.tagName);
            $55e0309f06c0860d$var$rnibInformationInner.innerHTML = givenEyeCondition.desc;
            $55e0309f06c0860d$var$toolTip.dispatchEvent((0, $85a5f587c2a7b3b2$export$957026111206bdf8));
        }
    });
    document.addEventListener("rnib:end-task", ()=>{
        if (!$55e0309f06c0860d$var$toolTip) return;
        console.log("end task");
        $55e0309f06c0860d$var$homeButton?.classList.add("hidden");
        $55e0309f06c0860d$var$scenarioButton?.classList.add("hidden");
        $55e0309f06c0860d$var$soundButton?.classList.add("hidden");
        $55e0309f06c0860d$var$taskModeYesButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$taskModeNoButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$taskModeNoButton?.dispatchEvent((0, $85a5f587c2a7b3b2$export$957026111206bdf8));
    });
    document.addEventListener("rnib:reset-task", ()=>{
        if (!$55e0309f06c0860d$var$toolTip) return;
        $55e0309f06c0860d$var$clearButtonContainer();
        $55e0309f06c0860d$var$taskModeGrid?.classList.add("hidden");
        $55e0309f06c0860d$var$homeButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$scenarioButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$soundButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$main?.classList.add("space-between");
        if ($55e0309f06c0860d$var$toolTip) $55e0309f06c0860d$var$toolTip.innerHTML = "please turn on your audio for voiceover";
        setTimeout(()=>{
            $55e0309f06c0860d$var$toolTip?.classList.add("hidden");
            $55e0309f06c0860d$var$toolTip?.dispatchEvent((0, $85a5f587c2a7b3b2$export$957026111206bdf8));
        }, 5000);
    });
    document.addEventListener("rnib:continue-task", ()=>{
        if (!$55e0309f06c0860d$var$toolTip) return;
        $55e0309f06c0860d$var$clearButtonContainer();
        $55e0309f06c0860d$var$taskModeContinueButton?.classList.remove("hidden");
        // main?.classList.remove("space-between");
        $55e0309f06c0860d$var$taskModeContinueButton?.dispatchEvent((0, $85a5f587c2a7b3b2$export$957026111206bdf8));
    });
    document.addEventListener("rnib:continue-task2", ()=>{
        if (!$55e0309f06c0860d$var$toolTip) return;
        $55e0309f06c0860d$var$clearButtonContainer();
        $55e0309f06c0860d$var$taskModeContinueButton?.classList.remove("hidden");
        $55e0309f06c0860d$var$taskModeContinueButton?.dispatchEvent((0, $85a5f587c2a7b3b2$export$957026111206bdf8));
    });
});
var $55e0309f06c0860d$export$2e2bcd8739ae039 = $55e0309f06c0860d$export$861edd1ccea2f746;





const $6efd1e38f2037a04$var$inGameUI = document.querySelector(".ui");
const $6efd1e38f2037a04$var$tutorial = $6efd1e38f2037a04$var$inGameUI?.querySelector("#tutorial");
const $6efd1e38f2037a04$var$gazeControlTooltip = $6efd1e38f2037a04$var$tutorial?.querySelector("#gaze-control-tooltip");
const $6efd1e38f2037a04$var$lookHereButton = $6efd1e38f2037a04$var$tutorial?.querySelector("#look-here-button");
const $6efd1e38f2037a04$var$eyeSeperationContainer = $6efd1e38f2037a04$var$tutorial?.querySelector(".eye-seperation-container");
const $6efd1e38f2037a04$var$eyeSeperationValue = $6efd1e38f2037a04$var$tutorial?.querySelector("#eye-seperation-value");
const $6efd1e38f2037a04$var$eyeSeperationProgress = $6efd1e38f2037a04$var$tutorial?.querySelector("#eye-seperation-progress");
const $6efd1e38f2037a04$var$minusButton = $6efd1e38f2037a04$var$tutorial?.querySelector("#eye-seperation-minus-button");
const $6efd1e38f2037a04$var$plusButton = $6efd1e38f2037a04$var$tutorial?.querySelector("#eye-seperation-plus-button");
const $6efd1e38f2037a04$var$continueButton = $6efd1e38f2037a04$var$tutorial?.querySelector("#eye-seperation-continue-button");
const $6efd1e38f2037a04$var$Tutorial = (0, $3c5424715410c340$export$d2de3aaeafa91619)(()=>{
    let eyeSeperation = 3.5;
    const eyeSeperationTotal = 7;
    function setEyeSeperationValue() {
        if (!$6efd1e38f2037a04$var$eyeSeperationValue || !$6efd1e38f2037a04$var$eyeSeperationProgress) throw Error("Missing elements");
        const percentage = `${eyeSeperation / eyeSeperationTotal * 100}%`;
        $6efd1e38f2037a04$var$eyeSeperationProgress.style.width = percentage;
        $6efd1e38f2037a04$var$eyeSeperationValue.style.left = percentage;
        $6efd1e38f2037a04$var$eyeSeperationValue.innerHTML = eyeSeperation.toFixed(1);
        (0, $85a5f587c2a7b3b2$export$997607796c4801b3)(eyeSeperation);
    }
    setEyeSeperationValue();
    // some helper functions to manage elements styled by "hidden"'class
    function setHidden(elements, hidden) {
        elements.forEach((element)=>element.classList.toggle("hidden", hidden));
    }
    const show = (...args)=>setHidden(args, false);
    const hide = (...args)=>setHidden(args, true);
    function advanceToEyeSeparation() {
        hide($6efd1e38f2037a04$var$lookHereButton, $6efd1e38f2037a04$var$gazeControlTooltip);
        show($6efd1e38f2037a04$var$eyeSeperationContainer);
    }
    function advanceToHomepage() {
        (0, $85a5f587c2a7b3b2$export$5102595c4507afe8)([
            "homepage"
        ]);
    }
    const clamp = (x, a, b)=>x < a ? a : x > b ? b : x;
    // XXX seperation is wrong spelling, but continuing here for consistency
    function adjustEyeSeperation(step) {
        const delta = 0.5 * step;
        eyeSeperation = clamp(eyeSeperation + delta, 0.5, 6);
        setEyeSeperationValue();
    }
    $6efd1e38f2037a04$var$plusButton.addEventListener("click", ()=>adjustEyeSeperation(1));
    $6efd1e38f2037a04$var$minusButton.addEventListener("click", ()=>adjustEyeSeperation(-1));
    $6efd1e38f2037a04$var$lookHereButton.addEventListener("click", ()=>advanceToEyeSeparation());
    $6efd1e38f2037a04$var$continueButton.addEventListener("click", ()=>advanceToHomepage());
});
var $6efd1e38f2037a04$export$2e2bcd8739ae039 = $6efd1e38f2037a04$var$Tutorial;


const $d67e54a143b94815$export$a07db8fd30206876 = (orientation)=>{
    (0, $4862ecea332fa5ed$export$2e2bcd8739ae039)(orientation);
    (0, $55e0309f06c0860d$export$2e2bcd8739ae039)(orientation);
    (0, $6efd1e38f2037a04$export$2e2bcd8739ae039)();
    (0, $d6688360c12ddbaa$export$2e2bcd8739ae039)(orientation);
};


var $c0e04a75b73fb40f$exports = {};


$c0e04a75b73fb40f$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("2ngYy");


var $d58a1de09ee004b9$exports = {};


$d58a1de09ee004b9$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("jNFIT");


var $da765e2bce96d69b$exports = {};


$da765e2bce96d69b$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("j8jtG");


var $ccfc7ef33c34b391$exports = {};


$ccfc7ef33c34b391$exports = (parcelRequire("1XyTv")).getBundleURL("eEdY6") + (parcelRequire("hqnuF")).resolve("5qwlj");


const $bac94032f53427ab$var$introductionPage = (0, $3c5424715410c340$export$9302a2cd748aaf61)(".introduction");
const $bac94032f53427ab$var$heading = (0, $3c5424715410c340$export$9302a2cd748aaf61)(".introduction__body--heading", $bac94032f53427ab$var$introductionPage);
const $bac94032f53427ab$var$subheading = (0, $3c5424715410c340$export$9302a2cd748aaf61)(".introduction__body--subheading", $bac94032f53427ab$var$introductionPage);
const $bac94032f53427ab$var$currentImage = (0, $3c5424715410c340$export$9302a2cd748aaf61)("img", $bac94032f53427ab$var$introductionPage);
const $bac94032f53427ab$var$inGameUI = (0, $3c5424715410c340$export$9302a2cd748aaf61)(".ui");
const $bac94032f53427ab$var$continueButton = (0, $3c5424715410c340$export$9302a2cd748aaf61)("#continue-button", $bac94032f53427ab$var$introductionPage);
const $bac94032f53427ab$var$yesButton = (0, $3c5424715410c340$export$9302a2cd748aaf61)("#yes-controller-button", $bac94032f53427ab$var$introductionPage);
const $bac94032f53427ab$var$noButton = (0, $3c5424715410c340$export$9302a2cd748aaf61)("#no-controller-button", $bac94032f53427ab$var$introductionPage);
const $bac94032f53427ab$var$skipHeadsetButton = (0, $3c5424715410c340$export$9302a2cd748aaf61)("#skip-headset-button", $bac94032f53427ab$var$introductionPage);
const $bac94032f53427ab$var$splashScreen = document.querySelector("#splash_screen");
const $bac94032f53427ab$export$bf2b2765adb35ebb = ()=>{
    $bac94032f53427ab$var$currentImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($da765e2bce96d69b$exports)));
    $bac94032f53427ab$var$currentImage.alt = "Screenshot of pop-up for camera permissions";
    $bac94032f53427ab$var$heading.innerHTML = "PLEASE ALLOW <br>CAMERA PERMISSIONS";
    $bac94032f53427ab$var$subheading.innerHTML = `We'll need this to place the AR experience in your environment.`;
    return $bac94032f53427ab$var$interfaceObj;
};
const $bac94032f53427ab$export$913a195b7ece9615 = ()=>{
    $bac94032f53427ab$var$currentImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($c0e04a75b73fb40f$exports)));
    $bac94032f53427ab$var$currentImage.alt = "Person using handheld Virtual reality controllers";
    $bac94032f53427ab$var$heading.innerHTML = "No Controller detected";
    $bac94032f53427ab$var$subheading.innerHTML = `Pair your controller if you have one.<br><br> Press any button
        to detect your controller or continue using Gaze Control.`;
    return $bac94032f53427ab$var$interfaceObj;
};
const $bac94032f53427ab$export$2dece70e0b4455a1 = ()=>{
    $bac94032f53427ab$var$heading.innerHTML = "Controller detected";
    $bac94032f53427ab$var$subheading.innerHTML = `Would you like to use it in this experience?`;
    $bac94032f53427ab$var$currentImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($c0e04a75b73fb40f$exports)));
    $bac94032f53427ab$var$currentImage.alt = "Person using handheld Virtual reality controllers";
    $bac94032f53427ab$var$continueButton.classList.add("hidden");
    $bac94032f53427ab$var$yesButton.classList.remove("hidden");
    $bac94032f53427ab$var$noButton.classList.remove("hidden");
    return $bac94032f53427ab$var$interfaceObj;
};
const $bac94032f53427ab$export$cce87169fe440def = ()=>{
    $bac94032f53427ab$var$heading.innerHTML = "";
    $bac94032f53427ab$var$subheading.innerHTML = `<br/><br/>Remember to be alert at all times.<br>
        Stay aware of your surroundings.`;
    $bac94032f53427ab$var$currentImage.style.transform = "none";
    $bac94032f53427ab$var$currentImage.style.marginRight = "1rem";
    $bac94032f53427ab$var$currentImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($ccfc7ef33c34b391$exports)));
    $bac94032f53427ab$var$currentImage.alt = "Illustrated warning of a virtual reality user tripping over household objects";
    $bac94032f53427ab$var$yesButton.classList.add("hidden");
    $bac94032f53427ab$var$noButton.classList.add("hidden");
    $bac94032f53427ab$var$continueButton.classList.remove("hidden");
    return $bac94032f53427ab$var$interfaceObj;
};
const $bac94032f53427ab$export$78b717454490e955 = ()=>{
    $bac94032f53427ab$var$heading.innerHTML = "";
    $bac94032f53427ab$var$subheading.innerHTML = `<br/><br/>Please place your device into headset for the 
          full immersive experience.`;
    $bac94032f53427ab$var$currentImage.style.transform = "none";
    $bac94032f53427ab$var$currentImage.style.marginLeft = "2rem";
    $bac94032f53427ab$var$currentImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($d58a1de09ee004b9$exports)));
    $bac94032f53427ab$var$currentImage.alt = "Person putting a smartphone into the RNIB Headset, on a tabletop";
    $bac94032f53427ab$var$yesButton.classList.add("hidden");
    $bac94032f53427ab$var$noButton.classList.add("hidden");
    $bac94032f53427ab$var$skipHeadsetButton?.classList.remove("hidden");
    $bac94032f53427ab$var$continueButton.classList.remove("hidden");
    return $bac94032f53427ab$var$interfaceObj;
};
const $bac94032f53427ab$export$35caa5113888fa7b = ()=>{
    $bac94032f53427ab$var$introductionPage?.classList.add("hidden");
    document.body.removeAttribute("style");
    $bac94032f53427ab$var$inGameUI?.classList.remove("hidden");
    (0, $d67e54a143b94815$export$a07db8fd30206876)((0, $3c5424715410c340$export$2333ffce05e999c1)());
    return $bac94032f53427ab$var$interfaceObj;
};
const $bac94032f53427ab$var$interfaceObj = {
    addContinueButtonCallback: (cb)=>{
        $bac94032f53427ab$var$continueButton.addEventListener("click", cb);
        return $bac94032f53427ab$var$interfaceObj;
    },
    addYesButtonCallback: (cb)=>{
        $bac94032f53427ab$var$yesButton.addEventListener("click", cb);
        return $bac94032f53427ab$var$interfaceObj;
    },
    addNoButtonCallback: (cb)=>{
        $bac94032f53427ab$var$noButton.addEventListener("click", cb);
        return $bac94032f53427ab$var$interfaceObj;
    },
    addSkipHeadsetButtonCallback: (cb)=>{
        $bac94032f53427ab$var$skipHeadsetButton.addEventListener("click", cb);
        return $bac94032f53427ab$var$interfaceObj;
    }
};
function $bac94032f53427ab$export$87d55977bc4d38d4() {
    $bac94032f53427ab$var$inGameUI?.classList.add("hidden");
    document.body.style.padding = "var(--sat) var(--sar) var(--sab) var(--sal)";
    (0, $d67e54a143b94815$export$a07db8fd30206876)((0, $3c5424715410c340$export$2333ffce05e999c1)());
    $bac94032f53427ab$var$setupSplashPageTimeout();
    return $bac94032f53427ab$var$interfaceObj;
}
const $bac94032f53427ab$var$setupSplashPageTimeout = ()=>{
    setTimeout(()=>{
        if (!$bac94032f53427ab$var$splashScreen) return;
        $bac94032f53427ab$var$splashScreen?.classList.add("hidden");
        $bac94032f53427ab$var$splashScreen?.setAttribute("aria-hidden", "true");
    }, 500);
};





let $2d081a1fa49e40a2$var$isStereoMode = true;
let $2d081a1fa49e40a2$var$controllerEnabled = false;
let $2d081a1fa49e40a2$var$currentState = "DEFAULT";
function $2d081a1fa49e40a2$var$navigateToPage(nextState, experience) {
    $2d081a1fa49e40a2$var$currentState = nextState;
    switch($2d081a1fa49e40a2$var$currentState){
        case "CAMERA_PERMISSIONS":
            (0, $bac94032f53427ab$export$bf2b2765adb35ebb)();
            break;
        case "NO_CONTROLLER_DETECTED":
            (0, $bac94032f53427ab$export$913a195b7ece9615)();
            break;
        case "CONTROLLER_DETECTED":
            (0, $bac94032f53427ab$export$2dece70e0b4455a1)();
            break;
        case "VR_WARNING":
            $2d081a1fa49e40a2$var$currentState = (0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[4];
            (0, $bac94032f53427ab$export$cce87169fe440def)();
            break;
        case "PLACE_YOUR_HEADSET":
            (0, $bac94032f53427ab$export$78b717454490e955)();
            break;
        case "WEBGL":
            (0, $bac94032f53427ab$export$35caa5113888fa7b)();
            experience.startScene((0, $3c5424715410c340$export$2333ffce05e999c1)(), $2d081a1fa49e40a2$var$isStereoMode, $2d081a1fa49e40a2$var$controllerEnabled);
            break;
    }
}
const $2d081a1fa49e40a2$var$continueButtonCallback = (experience, gamepadObject)=>()=>{
        switch($2d081a1fa49e40a2$var$currentState){
            case "DEFAULT":
                $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[1], experience);
                break;
            case "CAMERA_PERMISSIONS":
                experience.getPermissions();
                if (gamepadObject.isConnected) $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[3], experience);
                else $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[2], experience);
                break;
            case "NO_CONTROLLER_DETECTED":
                if ((0, $3c5424715410c340$export$2333ffce05e999c1)() === "landscape") $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[4], experience);
                else $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[6], experience);
                break;
            case "VR_WARNING":
                $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[5], experience);
                break;
            case "PLACE_YOUR_HEADSET":
                $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[6], experience);
                break;
        }
    };
const $2d081a1fa49e40a2$var$skipHeadsetButtonCallback = (experience)=>()=>{
        $2d081a1fa49e40a2$var$isStereoMode = false;
        if ($2d081a1fa49e40a2$var$currentState === "PLACE_YOUR_HEADSET") $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[6], experience);
    };
const $2d081a1fa49e40a2$var$yesNoCallback = (experience)=>(ev)=>{
        $2d081a1fa49e40a2$var$controllerEnabled = ev.currentTarget?.id.includes("yes");
        $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[4], experience);
    };
const $2d081a1fa49e40a2$var$onGamepadConnect = (experience)=>{
    return ()=>{
        if ($2d081a1fa49e40a2$var$currentState === "NO_CONTROLLER_DETECTED" || $2d081a1fa49e40a2$var$currentState === "VR_WARNING") $2d081a1fa49e40a2$var$navigateToPage((0, $a7bbb4392bc1ea56$export$b782dad1d219cf26)[3], experience);
    };
};
function $2d081a1fa49e40a2$var$init() {
    const gamepadObject = new (0, $c21c4f14562bd7cb$export$2e2bcd8739ae039)();
    const experience = new (0, $8d0b21abaa4a342c$export$2e2bcd8739ae039)(gamepadObject, (0, $3c5424715410c340$export$2333ffce05e999c1)());
    gamepadObject.init($2d081a1fa49e40a2$var$onGamepadConnect(experience));
    (0, $bac94032f53427ab$export$87d55977bc4d38d4)().addContinueButtonCallback($2d081a1fa49e40a2$var$continueButtonCallback(experience, gamepadObject)).addYesButtonCallback($2d081a1fa49e40a2$var$yesNoCallback(experience)).addNoButtonCallback($2d081a1fa49e40a2$var$yesNoCallback(experience)).addSkipHeadsetButtonCallback($2d081a1fa49e40a2$var$skipHeadsetButtonCallback(experience));
}
$2d081a1fa49e40a2$var$init();

})();
//# sourceMappingURL=index.f6b449f5.js.map
